import React, { createElement as createElement$1, useRef, useEffect, useState, useLayoutEffect, forwardRef, isValidElement, useCallback, useMemo, useDebugValue, Children, cloneElement, createContext, memo, useImperativeHandle, useContext, Fragment as Fragment$2, Component, createRef, PureComponent } from 'react';
import ReactDOM, { findDOMNode, createPortal } from 'react-dom';
import styled, { css as css$1, keyframes } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var toPrimitive = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var toPropertyKey = createCommonjsModule(function (module) {
var _typeof = _typeof_1["default"];

function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _defineProperty = /*@__PURE__*/getDefaultExportFromCjs(defineProperty);

var samsungBlue = {
	lightest: "#ECEEF7",
	lighter: "#D0D4EC",
	light: "#727EC6",
	"default": "#1428A0",
	dark: "#0F1E78",
	darker: "#0A1450"
};
var skyBlue = {
	lighter: "#CCE4F4",
	light: "#66ADDE",
	"default": "#0077C8",
	dark: "#005996",
	darker: "#003B64"
};
var seaBlue = {
	lighter: "#CCF0F9",
	light: "#66D1EE",
	"default": "#00B3E3",
	dark: "#0086AA",
	darker: "#005971"
};
var teal = {
	lighter: "#CCF3F0",
	light: "#66DBD1",
	"default": "#00C3B2",
	dark: "#009285",
	darker: "#006159"
};
var clover = {
	lighter: "#DAEBCC",
	light: "#90C366",
	"default": "#469B00",
	dark: "#347400",
	darker: "#234D00"
};
var sprout = {
	lighter: "#F5F8CC",
	light: "#E2EB66",
	"default": "#CEDE00",
	dark: "#9AA600",
	darker: "#676F00"
};
var daffodil = {
	lighter: "#FEFBDA",
	light: "#FBF290",
	"default": "#F8E946",
	dark: "#BAAF34",
	darker: "#7C7423"
};
var saffron = {
	lighter: "#FFF0DA",
	light: "#FFD390",
	"default": "#FFB546",
	dark: "#BF8834",
	darker: "#805A23"
};
var pepper = {
	lighter: "#FDE1D3",
	light: "#F8A67C",
	"default": "#F36A25",
	dark: "#B64F1C",
	darker: "#793512"
};
var coral = {
	lightest: "#F8F8F8",
	lighter: "#FAD2CF",
	light: "#F17770",
	"default": "#E81C11",
	dark: "#AE150D",
	darker: "#740E08"
};
var hibiscus = {
	lighter: "#F7D7F0",
	light: "#E888D1",
	"default": "#D939B2",
	dark: "#A32B85",
	darker: "#6C1C59"
};
var plum = {
	lighter: "#E9E0F5",
	light: "#BEA1E0",
	"default": "#9363CC",
	dark: "#6E4A99",
	darker: "#493166"
};
var neutrals = {
	black: "#000000",
	darkerGrey: "#333333",
	darkGrey: "#777777",
	grey: "#CCCCCC",
	lightGrey: "#F2F2F2",
	white: "#FFFFFF"
};
var samsungColors = {
	samsungBlue: samsungBlue,
	skyBlue: skyBlue,
	seaBlue: seaBlue,
	teal: teal,
	clover: clover,
	sprout: sprout,
	daffodil: daffodil,
	saffron: saffron,
	pepper: pepper,
	coral: coral,
	hibiscus: hibiscus,
	plum: plum,
	neutrals: neutrals
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const legacy = {
  borderColorFocus: samsungColors.skyBlue.light,
  samsungBlue: samsungColors.skyBlue.light,
  borderColor: '#ddd',
  boxBgColor: '#f5f5f5',
  divider: '#e5e5e5',
  headBgColor: '#f8f8f8',
  rowBgColor: '#f7f7f7',
  rowBgHovered: '#fff2f0',
  tableBorder: '#ccc',
  blue: samsungColors.skyBlue.default,
  baseColor: '#e6e6fa',
  purple: '#4c3e98',
  lightBlue: '#dffcff',
  lightRed: '#f2dede',
  red: '#f00',
  darkRed: '#b94a48',
  lightGreen: '#dff0d8',
  darkGreen: '#469b00',
  lightOrange: '#fcf8e3',
  // TODO: Consolidate these greys into only four types of grey,
  // similar to what we have in 'samsung-colors.json'
  black: samsungColors.neutrals.black,
  grayDarker: '#222',
  grayDark: '#333',
  gray: '#555',
  grayLight: '#999',
  grayLight2: '#bbb',
  grayLight3: '#ddd',
  grayLighter: '#eee',
  grayLighter1: '#f5f5f5',
  grayLighter2: '#f8f8f8',
  white: samsungColors.neutrals.white,
  // ====== Overwritten for Samsung =======
  primary: '#02b5d0',
  info: '#02b5d0',
  pending: '#f9ff40',
  success: '#4bce4b',
  warning: '#f0ad4e',
  help: '#02b5d0',
  default: '#333',
  enqueued: '#555',
  legacyPrimary: '#02b5d0',
  legacyPrimaryHover: '#02899d',
  legacyPrimaryHoverBorder: '#017384',
  legacyPrimaryColorDisabled: '#FFFFFF',
  legacyPrimaryBackgroundColorDisabled: '#7AD0E1',
  legacyPrimaryBorderColorDisabled: '#7AD0E1',
  linkDefault: '#02b5d0',
  linkHover: '#02b5d0',
  linkActive: '#017384',
  danger: samsungColors.coral.default,
  dangerHover: samsungColors.coral.dark,
  dangerFocusBorder: samsungColors.coral.darker,
  dangerDisabled: samsungColors.coral.light,
  dangerActiveShadow: samsungColors.coral.lighter,
  progressBar: '#02b5d0',
  legacySecondaryButtonColor: '#333',
  legacySecondaryButtonBorderColor: '#ccc',
  legacySecondaryButtonHover: '#ebebeb',
  bar: '#02b5d0',
  barHover: '#02899d'
};
const samsung = _objectSpread(_objectSpread({}, legacy), {}, {
  lightBlue: samsungColors.samsungBlue.lighter,
  legacyPrimary: samsungColors.samsungBlue.default,
  legacyPrimaryHover: samsungColors.samsungBlue.darker,
  legacyPrimaryHoverBorder: samsungColors.samsungBlue.darker,
  legacyPrimaryColorDisabled: samsungColors.neutrals.darkGrey,
  legacyPrimaryBackgroundColorDisabled: samsungColors.neutrals.lightGrey,
  legacyPrimaryBorderColorDisabled: samsungColors.neutrals.lightGrey,
  linkDefault: samsungColors.skyBlue.default,
  linkHover: samsungColors.skyBlue.default,
  linkActive: samsungColors.seaBlue.default,
  primary: samsungColors.samsungBlue.default,
  info: samsungColors.samsungBlue.default,
  pending: samsungColors.daffodil.default,
  success: samsungColors.clover.default,
  warning: samsungColors.saffron.default,
  help: samsungColors.samsungBlue.default,
  default: samsungColors.neutrals.darkGrey,
  enqueued: samsungColors.neutrals.grey,
  blue: samsungColors.skyBlue.default,
  lightRed: samsungColors.coral.lighter,
  red: samsungColors.coral.default,
  darkRed: samsungColors.coral.dark,
  lightGreen: samsungColors.clover.lighter,
  darkGreen: samsungColors.clover.darker,
  lightOrange: samsungColors.saffron.lighter,
  progressBar: samsungColors.skyBlue.default,
  legacySecondaryButtonColor: samsungColors.samsungBlue.default,
  legacySecondaryButtonBorderColor: samsungColors.samsungBlue.default,
  legacySecondaryButtonHover: samsungColors.samsungBlue.lighter,
  bar: samsungColors.skyBlue.default,
  barHover: samsungColors.skyBlue.dark
});

/**
 * Legacy
 * Copypasta of the theme file in Trader
 */
const zIndex = {
  /* for specific element of a component that needs to stand out from everything in the component |
  z-index between 1 and 99, starts at 1. */
  components: 1,
  // for overlay inside elements and components | z-index between 100 and 199, starts at 100.
  overlay: 100,
  /* for secondary navigation (side navbar's submenu, page's sidenav) |
  z-index between 200 and 299, starts at 200. */
  secondaryNav: 200,
  // for header | z-index between 300 and 399, starts at 300.
  header: 300,
  // for footer (action footer) | z-index between 300 and 399, starts at 300.
  footer: 300,
  // for primary navigation (navbar and side navbar) | z-index between 400 and 499, starts at 400.
  primaryNav: 400,
  /* for anything that should appear on top of almost everything that is not modal or notification |
  z-index between 500 and 599, starts at 500. */
  fullScreenFeature: 500,
  // for special feature | z-index between 600 and 699, starts at 600.
  specialCase: 600,
  // for modals and dialog window | z-index between 700 and 799, starts at 700.
  modal: 700,
  // for dropdown menus | z-index between 800 and 899, starts at 800.
  dropdown: 800,
  // for notification (alerts) | z-index between 900 and 999, starts at 900.
  notification: 900,
  // Rule them all king modal
  kingpin: 1000
};
const fontFamilies = {
  asap: 'asap, Helvetica, sans-serif',
  entypo: 'entypo',
  helvetica: 'Helvetica Neue, Helvetica, sans-serif',
  mono: 'Menlo, Monaco, Consolas, Courier New, monospace',
  montserrat: 'Monserrat, Helvetica, sans-serif',
  roboto: 'Roboto Slab, serif'
};
function severityToColor(severity) {
  switch (severity) {
    case 'success':
      return legacy.success;
    case 'warning':
      return legacy.warning;
    case 'danger':
      return legacy.danger;
    case 'info':
      return legacy.info;
    case 'pending':
      return legacy.pending;
    case 'primary':
      return legacy.primary;
    case 'default':
      return legacy.grayLight;
    default:
      return legacy.primary;
  }
}

var robotoRegularWoff = "data:font/woff;base64,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";

var robotoRegularWoff2 = "data:font/woff2;base64,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";

var samsungOne400Woff = "data:font/woff;base64,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";

var samsungOne400Woff2 = "data:font/woff2;base64,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";

var samsungOne700Woff = "data:font/woff;base64,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";

var samsungOne700Woff2 = "data:font/woff2;base64,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";

var samsungOne800Woff = "data:font/woff;base64,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";

var samsungOne800Woff2 = "data:font/woff2;base64,d09GMgABAAAAAiRQABIAAAAHD2AAAiPiAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP0ZGVE0cGoFSG4fxVByeNAZgAJBuCIFcCZoWEQgKkZFIjv5mC8gEAAE2AiQDx2gEIAWPJweBqVoMgTxbwmDWCvzjs9/uedGDBb384a8tZCppoagkomFz67cfgY6RyaYoZwuA+r8V50DJIV4+EIG1s+kYogsGQItUtT/OAnFj270PS7SK9BSX/XGkgO2us/////////////////////////9xy+L5arO7/h/rvd/9/szs7M6OsDv7hzm4F2EJsMgVCSwoKgEBEwwENKfIlcQISVSMYszlGQ9iFIwQNZhIjNEcRohCCBKFEgpjdAYVUzQppJAUi9LEJFndTWjUjWgRFc0x3JQxMapW5nFCEkwoZm83ZFJ3bl+0uOikhkzkNkXMHKZVV81IJfX6jCpy6xEvydxvgcFwUXdGZkZx6bLl06qpQpYAVjCs1CFGCSCUahXh6lndVCFAUvfWNO4o1q4Td3d3BylCMttq3Jlb/5UNGzcpMzMzZfOQhCQks27u3bkBbJmKW+PMNpnZ7u6+Q9lXIQlJvVyFlN/8POjW3ri+S+/c6r5p06ZSSn4NBdmFYvYAiXfvWNizUfdk7933rFsnw33u7i7u7u59Zc0mCiGgEDzjvnt5nxqXKNX9O/T+r++tB31ADqLmnuKBQg5l2q0qOYx26PEom6gaMRSKciQ+2CjkG4e/ea+7N5NKlqy0u4Mf3dBfnlZZajbkIZdv3Q9dHjikjh2Pe7rNbfLt3WID3MPEzK33oJ7niZPNseHOncqOwmPM3s3tpG6tXybtyh4G8RHIRbVzHO7kd777ve/vUmY/MDNlP4QkJCGZ26PLTsn+bORjNXJ6OJRROHCmiIAsGIQUUlORcDaGSD0aRBWlOCsxUEo5d3CfEGwPyzqzs4cPLV2feRthk5nvpB7ocZjOt1qtloxJqmEz6+j57FuyT2Q+8ZhsVuH4XK/ebE5MtVOOc/ghHDNMlmVZqh9Br70ft4mOtMYbjUZDtqSfoGZEZ9sBRSGiELGvHidoyc7dY1G8dsrsjxjaeId3Op22WtnGneytGrgLrqq5hduOuergT9Ge00+cPn1amZmZqSQJUQjJ3C5cRD/b9/MzB88pMzMznRIkIZn5F09CEhy4cOypY2eOi7u7u+uyhCQkc3v6EqqqZ6qqUmZmZjolSEIyt18++xzoxRi7+5SZmZkyM7MZXVwuULCQ9flfQRJUVfVCVVXi7u7uuiwhCcncTv36N6AXH44np5SZmZkyMzPThRcohJDbbzNVqvzd7wcDA147L2btr3lpzagNPHuR/eUMr0BS9w8/eupUt6EWLza7/R4wNgbJ3F59DZKgXl/XrXeVmZkZSAmSuf3hdUiCmZk1b1RzyszMDKQEycxnc6ouV91uVYGU/5tvQRKSur5+fTE3Nyfu7u51EEtI5nblj5AEo9GrcThUZmZmwCMkc3v7T5AEw+E7w+FQmZnZGVCWkMzt3auQBJPzcTCYVmZmZiA6JDNfew+SkNSDwWD7n4dLxd3d3UFZQjK3969DEkyOtt5YulSZmZmBlCCZ218+gCQYjUa7RyNlZmYGUoJkfh/m0VT1+tWP6gOU4LvMfinfwWBw/a+DAUr538yp35/r96eQ57fhQ0hCEpKq3W63zcbF3d3dUQi5ffw3SEJST0xM/H1iQpmZmaGUcjvxOCQhqfv9/ie3NiszMzOUUuY38p2enp5esmQGpfzf/gckIaknJycnl00qMzMzlFLmT89BEpKQVJMLCwvbbFb8gLu7ozLk9s9bkISkXrFixf5iuTIzM0MeMl18ST67oC/8K5wXU58pyueqaabik4U8LVNS6PKpOuOlLwqTouAzz8lR/YXJzRv/lo9RlKijpiZYrTpiEp+Fp8TyuHJR9TT1ZVSk83g5SjKWr9+E1Qtg0Su19AEqsvxH3kLE74Q3a+SqPqKpexJUACbEK1FPiJ9g5v/eevEq6BT/K9Enr8FbrYBv5XxjrUyAdrwuUd8nafoamL1WwLKZw/ZsX8pH0GFIEQVhzUzt0Rvk/U9L9fpa9XluJf4on6PbQVp4b+y6msmtZH7T8jxoftloNBqyWMraDs1cD9fAYnyd8GaouZev4P+jvSnU/q4amRmIIsaNvcsXgQgcRJT0dBzm5eQsyzBqXrsvol3Xm3IXD9meSl6lRYtdvEU+m93k6+cvZIy0KqmBwb77mGLwcsDP7e+9BWMbCzZgbGPQg4GwARa0DBg1kRYLKQtQEcGkRUREP/pNxPx+LOwiU7JNJFrm/78/fdvn0gNg6dmSSZaJr7+/g84QVCGos/pZ0026amj1GYBt6gxEwARtVEBQUDAwEhQMxAIDUTERAW1CRDExkKmzem7GonXl5iq/uZBVfO77sr7tG9T3+8U73XN39wcAX8j4VBSwEQQ2LFyUiiIbF2fI4t7D8//s9/x+rrXffahVayQaFc8MokvDGylTVTKheCIU8W9ytsHS1YRqxHabw4pKQGPBYLItti3183zf6wZgboYCI3NRbCyKNasoxoKRI1JEQEXMvDfqVtz+27cPrF/9fYb3b39ttTTzSukIQ1/aMbnf735VGBZiIFUIhVC42/bMHJO/d6r6R+pHOm9rtsytQFCMOjn/RERndyJI+/b2nkkZ5kxL6XP+lyCoBvnICadUyYb+qcH9Y26fIhBqUgIe8nf3vfOrloQuBcFMkARTg5kpipSBxbjXFpx8AiACDvOC/8lEM0maatrtqg+wT+IJPklH4cuc597nh18kknU8wISicN459lu/PFuL21Yti+zMynLdM7uz7u7eGTlLiB0C3wAmQLCCC0CF/N6pZsj/LJ08OwgcExW1MKyv3HsnwagdW0NTIY/oAbmARk84u4n9HhfiYn0q/nUa6oDmoXHERLcwAMNOYW1ySan09DQajQaCO2H+dkgeRVEURRHlz1/fttebpF8hwRAMwmuMhHtz9ZWlpEq0IyQTSBEyZXLRp+nnmQU+At5ue7z0q62uBjA4QBgIVi1bd9/u7X4T0hCiRniMiQolUCjeScqH8giVlULd35jv7DOWbGnk+Pr2vCxbBraFFzppWQlghcVsTzWiGzErbSVFXPlHHySfO045o/hC10YmlIFkIBmoE1Mb5C+PQUkbxjAPMhSAAPwX9zw7Z/fe/Q+bmmk8oAxSiKKAAqDAHs9/fw/s1znn7vOuZUlGzSSUUAIJhIE2SZNQQJ+/2CuAf+dcqSaTyWQSDsJh7vsDzccTob4EuyiKoge7Cs8PEjvBpXRJk1LpqfQ0Go1WDBJucK5RFE3TNE1RtAfc/CmllFJKA9jr80Pd8B2BeqknK8EmSJIk2bfbg8QNzj2Koih5mqZpXR24TRolRVEURd1DlMI78cTxUZcoiqJoLYDP768mLJqgAMAg/K+uPfA3/YUoipKNokTPhIv9/0dRFEVRFEVRFEVRFEVRFEXR0Wg0Go1Go9FolEJucG5RFEXRNE3TdBLo+6O4ueFnpAjOMZGlmI8csSguMOL2O4SYCL2B/nPNN/9KoGt9ok5GF9huK4QGovF3e/EdiEa+JE7zu9LGDgW47W9ewB67sIq2MRoBb4aHXBQtWFdgM5RERSItRYFsLvTBQB5MJpPJZLptLeI+fM4DswgDJpPJZDKZNi3o4MA9iqJTNIpOpyg2t/QYDoPM/743tTrnXPPe+z8T8DQAnZHUIiWVAZnFDkAZmhiQv4NFjUFjXDLBkZKfpYhRccwSkRtwuehl7Rdj5YrW3zxJ9ooCgVUoBQGoS30SGx4oANBpyVoIka2avHlbRPeXJHDiAjy0Zk/5MCIoAobUSe3+wUn5cEnMzO7lsrXwhDr7XqTRzEiGxI6zpOX4Ex1yl+5YRdMdDOVWVW1AKiEJMSPmQAgWrBqxoWd8Rf299/nd6173Hll5H79pLvgNMsRjfB+3sFk0zYye94Rt/YVo57IZPoMMMsggg9RdBvAvf/je5LyXm09dVipIwQtaLOjYTGNRWUOQOwArzdO2tkDgof12Yi0rK20qmThEZ9CsDLdNlR0XVarw4/QJ6GhhAcJFvJqSZr0ae9sLRTbzARRl3UFKRT2TyssRnBLwsC8FcSIlXOPGAD5r3X86lBZ2lFP/Z5Pbbt9N5lAbsalgy0ABtuMUVtrj/Z/LEKKmpnAhZJasDxtjVxrSsA8MABC6wYlFURRFLdFsmx9783i3J5NMMskkSZIkSdvS/X9148KRhGtyBTcuruCuq3fLx/91yeRukkkmmWQyV2Yyk5nsXfn5/yaZZJJJJmdyJmdyUOzcN/WXQQYZZJBBBhlkkEEKIqLHyOrsTFNXppHbNd/alMJHfD6Ygm1LQUJUkGYDAcd0/LPSbcqSjR8A/f+fzuq+VxLM3FsPOifTKbhDDC+UVIAkC1tuNAw9zZ6VTf3A2T/7F7KdITt0ICQbt1M+65IEjW1S9zLOZ463k6H6sWd8NBrSrLzLVbADDyczxQHCnBhArfP9TVvVXP9xrqdPepPe5J5MXyGd03nQBVQ0aglJrWILLPQKtSwsumUh+RvzF4Ij2ef/m7szk5nMZCaTJElK52LhNGLCgqqd28LPwVOzEEVRFEVFTRIdWZUCBFTtXHZ+JQpuoiiKoiiqbHJayImqK2R67KWno9InTZ5Go9FotLrRqaEqHZ7DLEoWJYui0+myU+BOLIqiKApuvQSfv3Mb7ctoNLjXSRRFUVCyA4eXvYxGo1EnURRFZdPVXfH8VNGVbq6ngckkDEwm02Dw9PT0SlKCYm6ht7EwFsQgBjGIQQxyDyL8YxAb6EnKiwfcvFJKKaXY7FjjpBZELYii38HT7+A7CGqKi9aOecHTw+4nD7soiqIoCjbgQPiCi8IK+6vFyxIrK8ZNVQ9cB82gGa1JMzqdTqfTwdhWryaTyWQaHJiWhINPH5xxBoKe4DYajZYmXQqn0+l0eqHFlaSn2c5tNBqNRsFf1EsvvWSNyXpbGAtjYSyIQQxyzx3CH8IfBrEcH4vtrT5LQTYXejeZTMJAGJienp5ecHxFaWrLA/agC5K6hyhp9zAajUaru74aTASHHLAmHawtbevThVwlkyQ2k9hMkiTp6e/0uO+u6IqI6OqKGDFixFoQMXJUp7LW+opjVQ/cRqPRaHTpU7j09BT+6UKvkiRJkmBsJhjlyqEmJ+y3vQS/KIqiKCqWy/U1cGEHrO4F3+dMwIGN5hMc+QT3Kl6zXC/pkZ0++j2o3QJFzSmUjUu0AhIWuK0lvHb2vvz/7dH2zYoSPM2Eh68gdrJY1sDvPA9NvhU1RZ2umizul015qmrUdJCeQGABMggw2P4pTUi3Oe/ptvDFz+WHHLoiqVq3yZvDnYMKVyJvftPEERERTe6Q2h7054kFEqJytmQMHdnh/79N+0rfracaV9nqOZI9oJlZsBZby15MATHcdLP37quy6tVTfVkqu7ukapI9INnfpwVNsj8YG/zJw7wAINv9wfIHwwAAZBsRx9luhEGWb7R5ukmyPNTPmBZmB5/HGSRCfuGwMuHeWa7rD0JFtlHIqmt8nW+VrVOqPPS/t/9l6VUkSRE3Ek0WDqzr8x53rXr/koteVEN2Ib0mROFmsnQEYcaYUSOMmfmvueoaeoxeUbmNHC5NP1ZP6+8+l9PHOlJIQlKQTkiaxjq0bSVYSIChYKQM5pckk1RV8DF6dpeWMcYK3TRs9wstOuIGY/Q69JjY/bKih+vN5LY8/3ZP6jubvGRHrIPFBfv5Tb9yLxQGi8XBNa5RgQuK/V/TzPaG/1aB60RHdq7ddDSIS6NMh1Q1pyGheebfvTQrOaemEfjx50MgNrwRTaVQly6qajC8tK6ks3PTV24q/72pVmk3QGpIaQ211kZnfJBA5iJjs6T7/f/6d//XDZBoAAQbRhyQ1A5JaUYiZfz27wZnfzegK4BaA3GdpHPUnJu1Tpr1NgkviKwN74Lw6pLosg2C/PwvNbX+s7O6GXXQMdQOqWlJqnNIRe2iPnzg83vn3WpraQeGQz4p1w6LPRwBHOkUitZd66JsSDq35h/8vZbYOrL4pH4aGC1awIZCz19b+TN3jV7K23RcSmPelAZpFJT/vy9ntX3vhwJCAvtIJgfhnMA14azJWcNeCkmks8dh26th3kn33fdv6L8fP+BHhAQREuAICWwJjFMDkBLI//0fIX5ECFdIgBtP1djpqsLuCUMNlN2DTYCoMlM18nBOjt3zbhjX2M4aZvc4bTa9zuxVLda96t2+/X+nftH4Z3tjcCrexshE0vObRHZy9mRaQdsJ0dV7cmTZ+dMr21oARwvg0sPco7ZwxPq01Kos7vFVpZrLStmMteOhfpWz/VI1Vf9jFOuyEu+yk2uaSVP7c1yOQl2HikVF4gTCIxTliQU2V01zSWetTYM1N03C1/Jn+X5hzsFfXM/1ViE0QgFP0LJfdpepRy7IEovRWP3pVuyQlyxDCAqEO4uQB1Etf6+RzyE02mLUXW6GIeRQPoVd7lVhozBYJDYHhcaGpFw2DoTFG4RCKPWN+1c6+z7tntnR2AcYISZZz0g+giC8JHs7aqvf2l7vEYJGI11pZb9jyCC6+0ApUOWYRRgHCP//7fVn8/7OoVeFA+NyhYuTdV4WzDuUUjTCMtQZSlNZKCQaiZAwGJwu44LBIDjgoLDR8O9MMt5XkZeSHEQQZhCDEcH4vIfuZN//91Ivup8ZsMggg4h0pZRQQsmWUEIochD39/HbsCf3jUv+bo/bXgNIEAk2lSDBBgkSJIjY6zOEYmct7mFEzslMnB0Twz9HCKHU78T+36Rf85et+rZ6rqsqqioiIiJvj4hjxLhU1WBWzwkMEStQL2NONP/srv3DgH/OtiGYIIQQhwmEs0ykfbxTr71SnNKMMYsRZhDC15dAOZXKrIo0uUocy2GEMUKE/nnfWfU5Tz5PtqZxNvMRhTFGCCOMIkRhmiKnMIdTIFyKIv2QpYvJUMreoYQMJnQqJpgizHEI0dN+MfYvmPpls8iFCXI8PNaS3IEZ8CKCE0KMEkFAe5yvvvrtq4ROw9o/zqVTuVGIJ+QyZ2XzAIdQFiSSqVscqv++6e7wp9YfDtibeL3Zu3tbqk2ppgkkkPpIgvj/9f/H5v9YNp+FNii85FXp+RNMrpv31+x/oqCd2o73vE5n66YYEBQUJCBLgCwr6Oc7Ys7/jmhKf6VjEhEQUFCJ2EEEZnensPcX3+27wIB353+iSDuG2LQT77ZKAofM1f8FBbb59l75ra6UUHUVQegSSCLJDBz+1PoTwcmmf23pLhIYlxgXEjcwmCaBpJmBe+WwqfZEsqHdUlPwwFgWc3oN+ZtnueuDIdBIMTnrkSJttxKA6uCNXx3vXq+60g+LPDryOr0HgnK44NlUox6EpLsnWSqUIz0DMWXXMC1oOKpwkl4m88Lhp3BIiR0TZ/AwQ+aKyB2i7PJhDBc6jFtV+2if49M/mVTuT5PrL9b7A/+U9Df617L+27PZOTx4ch976ZRvp/z44/xl2jqIYOzVuX98sOQBtgb02ZqL0MXvcvcByvaPxEQB72yM1nDXBsU8hEXuddQA8xfFPh/NYsDL4kCvGt29ZfSod068Y3GrGJ/qitnuiegoYP55yAaNj1JRCgQBkisAiL/q6pQHjBwE5GFGEItI4pXABGd7oiMPAQLhiUps4pMmy1m5UAjgJrvx+Bw1HEPFyntvbJ053+f87ou+w2x07C9dTiY5Bhe5Y73qSO3kP5uA4AX2w53MLtjkR4ju8Wj0mk+i9/0QffVfXX//uoK9FdTwZnPcH8SYE3wvLOidLZk01UmpaFQFn0khMvd6GejT/sx4pL9g/+41w7LJMN18DBmWWzplVtzqqbPyggZs9YUO1JqLGIS1FjUoa29k4tbZtmmzUQiHYOPQD90maT4cm6bltNj8yrfcFkL4v93Yku0A/LswuWgAVgCOCMDRAccFnBhwSsDpAWcFnBtwQcDFAZcFXBlwTcD1ATcF3BpwR8DdAfcFPBjwSMDjAU8FPBvwQsDLAa8FvBnwTsD7AR8FfBrwRcDXAd8F/BjwS8DvAX918W8Xh1xKAOoDaGSgMYHGB5oUaGqgGYFmB5oXaGGgJYGWB1oVaG2gDamh/+Hj/bf9Q4Uo8A8Q25Z9x9NXZow72c+1RvXL/Rq7OwKyPxctD90WYaiw2IqpssLWk7DyQo60ysIGbtWd+xqsvoRUayrr/Wqz9U/YVpuYpO2DO3g7HuKh2fkwDtteh3uC9jsRci6mXOaSrcB3mTrWXu4awB+flsjv9e8QOIJHpoiFR4eA0DJWVpGQ8hEoSLgI0faJlyrDKWfluC5Pvqde+6hIhTrNOvX7ZtRULQwO0QZkBMaGIww3XvyRhKNjYOHII1BKolqDVh16DZs0Y6vd9lty0nnLNO567JnXPvpeHPgPC0sraxtbO3sHRydnF1c3dw9PL28fX0CYUMaFVNrk+U+Sq/984PcKf+rP84p8V7CLA0AJ3Q9WSRsauNfWmBZKp6/ZePItNy3nMCLr10dMTXs7etg50K2Cl3om834h65lb3NrEeJhMA+d4QUr6aA0rsTLILhS7s1y36JyWtnQ8a/2fTR5mj4F6Alh2o8tesBzAdhQZVgSszfcVRIU54pgF0JbdCrcdj1WVTq+gsaZgQKCkLDQqZtT0BCfuYnfXZTottLi7m8gwv8St2P4deYrlqHK0p+wB5Veb8pp6wIhCJ9tGActCh0UkqJAkYLgiYdHFytO/Rb+Z4I311WdSE5lHmZvy4Q4RYdJ5HewPoiKVXqGoNk07GFbSPl2HdERWVWmliAxulHXPZ4ukrKkjmvjxekPVSW0KnvpWD4iOGJCqDhVEeTVMILORTt6hnIIq4qmVpHUx23jl8dztPy2GKgnJQ0+QGa0kHRrFFJt1XZdaFTgP+tJq+L0OEdIWAcfdUgdFX6Xkes/qMOwC2VVmd8LpZtla5SeWQwlgHAjGWzBhjo+lFLGcECsJYYELS9rlE8KGaoU0KybEKuqV0q0MCkc4nPDhTAwJKVwowpUU7vjwIIZ0Va4eS3lDET748H1TbKB/p9q7runENHlI++9mO9PqpX2xb8rN6LDcfRroPyVydKrjRkg13v+OPYrqZrfBZLE5XB4QBIZAYbA4qmqD6mYAvPkfI4swSdGG62FjgBZwFvCXovBWpYjUFtITlqq9Xu7Xp0lKhzTrscyIxIqam2XStaRSdQorFNYmWwOYZf9dDbKayBiFdN2xBXmJHJejEIsmL5SjRNJ5qVgKqewUTtWfEUVO5ERJlARWYhhJ/J/n2j2arXan2ysUjsQTiCQy1eSBaEWM4RWPDB7XeMYv6xOcrYlKTA4kUZpM2c7LddMdDz331mclqjRo1W3QD2MwA4sIFiEitCiHC5FTNaJedmbXt4fkUYH974mPfDzEomTBJdtXk8DtJ01xUeSQr09Ee2WElE8rFffb1kku6iDwN52lqQwzCtMyxpTjJQvCwkLb6lYqrmKl7teq1INrlHpSVbj5X3p3OWkTXInCCk9AswAAwAEAAO/hjDNAs29W6j/fmU3/zenJo/wf50zU3B0HCx5kilh4dAgILWNlFQkpH4GChIsQbZ/4mfrEZTjlrBzXZ95Dfp7itY+KVKhLMzr1+2b0cYpNxv9HSbUx9yLKg3kvggoKMdx48UcSjo6BhSOPQCmJag1adeg1bNKMrXbbb8lJ5y3TuOuxZ1776Hv9frKJWgLVEWdGJmMarkkzNWY0u3nnwlTnxJ2XAFMe642Xyo+1izcFbewn90jgmW0bal01XY0JEHC2cOM0pljZeMakYbkmrGuNN1vxV7OxDmA3uh/sWLKv8Jyq6l9KvecMgHs3Q2oAbiQIocmBbwRGwkx5NZoArOsCocO2Yj4fb1xRvUuWQXHyoMqxkSrHR6qcGKlyEtVtwBEq3YCZSsxE5hwLllFgDcjakPUhG1FsDtkSsk1bsh3bo9mxNS4urnQASAFYIxc/AAJaABsElBKklK0A7DCfnbKIkcWJKZ2Xk7lAudFiue8RAs8nvPQ234PAFzQK0aiAUolANQI1UGoRqINSj0AjAk0ItCDQhkAHAl0I9CDQC6UPgX4oAwgMQhlCYBjKCAJztPaJfw8uRdsuKAYkJiglSMqgVCCxQKlC0qeUYJFGRSgL0LKkkoeRNZUCjDxASS+QvMrKbd9yQK0FVOA6O4dVrGqLIG0FtQ1SNKViKBUHaj9GB6gcB5UAKYmkVEiZkM6BOg/pBqQ7oO5CugfqPqSHoB5BegzqCaTneL2C9BrUG0gFoAohlUOqhFQHqh5SA6hGSN2U6gU1BGkE0m9Io4j+AI0hGgeaQDQJNIVoGmiGLJkxjQIyFpRWAGQKUKYCbxpoOmQmxkpUU7OUnIaXDpD1IOuv3bNB496T2tS0bO7zrZoHbd2C2y6t4e0uvD0h+2K8bh2kr/21EdBBkDeDDsE7HPLWtZXJTk1M9+u64rAXNYIoJodbtKouEEXkKPZcEYhickQJil1gxEARi4qDa8nDM1HJQJFCtUvQcfRCGZnTWdUEFCNQfIfiJxSTeExdWPvP/LWSYexuboqJEiiDChCDFGQghxqohXpoRAt2iz2YFwvYK/ZhvziAZY6rK/P66aTmmPUYtr9RL9sq6mf7Bw2y/YuG2V6g7+gnGmP4BBYgDK3g5EAIQhGanAlLruQheZKXRCRvyYd8JT/ylwIoUAqiYCmESBKZQklhiEKionBSBIokRSEWS6ncBazKtJgZGCszYuf6OJkZt4Ig5SLuWnIsq59w9D/JIgYuKiyQ5IBEXCQFT0mVLIsFiIukhaazKu2Spkvq3/bMapWWB1oP0kakINBmpGC0UKTtoGhWYlAM3i2kPLQ7rLYt8l7NeXfDVj0R6FlyQDkyOSMkgAvGDbMOsR7YgtgKbENsB3YgIoCdiN2oaBYxIgbYi4gFDqIOsdSi4lnqEccQxxGZQBZwFnEOuITIAS6jclmmETeBO6i7wIPV5cMN9QTEU+AF4iXwCvEaeId4v8iS2KqDg69rOTfn6dxemNlXl79bnvunzfK9n8evhRXAAC53AXLbh5O+d/88/HHpcZ+wTD70n2ddMH/5Hv21x/LvvIM/Efgz8I/If0K9F+d9/0ViabG5j/21NCIqJm72GbUGkNMZAGesC6KBu5obc8DDuCtPV27DVNpqeKM4FbCko0oGWDLBkgWWUwk7yQQaFZo5owe1/VpyuIOeFZVIeNn63clAqB8FPEWTyWuWL4xszAqvTkY3fm6/Rmx3Ap6Ej4a2w4rcsn5zYACulDqdZWvBykwFeLkdcGNlv9WlyvPs0J7bW41nq0VdKzgluKGKzdItV8luJUoxeeehjZY3g5F/R4doQfM1DTGNx1sXQsWkW9YkRAnns7YNR1N9x31CCoZVRFZDnMVyNsd5Si6neMRaz9X5TAaYPEXJi0hhU5RwQtlCcwly2YYvkVTXTX1DpLIfrh1g7cLWHoiGBUkUHBOegWbGsqBYIkaGFThWLGyH0O+mNnF6c1dTpL+vwmqc5WznudwjtGf/l4vL3tjGN7HJ7djuHdrhe/8u3/ewW5SBOvESNKwKVKErZGdTqd3RfVchD4HB/OBvajj9mOvWQQoGiJK3AIjOBSc2lfJbJ1efDzam7jnB4jOa9ZlvhVvO8XGL1MZ9uOetqEfNn42C49ZEapWVg2P97W9XNV8olj7dpHAUqh7V3duK2h5qJU6uKT/UVyAvskTgad/ROGtazc8E21oNy5rhCjlKu1JCrgYqGFYmtBVPHxhLblFsMj6kO28sYl04ZMJOTd5sMd0PfP/87eOMXnGGaC5iuE7gJpbbhpgPGU/Khyly/AXOCZlYMimNmZymTIny6t5vQs5Q49u/J0I+m+HbFzIm58tgcm6z94F7uAmMMJjfCJfr8Lkeyr343NfonjBC4FT3EAB39wz8TGTVsR8gdonYj9/NVrSrzK0orrQuRKkEHjLZocxV+na+FVkC9SlXhp6rdNxQLWPLjJvdUnmrQHWuCUtN7kZjBkybFV3ck3NhsErfoOmb1H2Llfs20ndYqdfbyMys0JuwSm/R9jZ979D1Q5p+RN27rNx7SO+zUj9uI58/XeEIS9YeBfproj0q/dHojk5zDNpjUh+L9th010x9HOS4rX2avq9Sl5fu7iMH72z8oQbr52D5vIyrBRS1kFSLGJ7XiLWExfNWm3cKaiuqZnNGsR1M+Pzcmpbu+U67M1zkOje5LYosyLgweW7tbYqyrUequ7TBDGU4IxnNWCYy2ehzkhzO9TyN5UPLzzX34UNq+8HfZLf+xHHUrxXYnPjDlrxtm18Q9z0oQZTnQtPNlJ57Psxvs+dH1q7gvfgkAESOInOKzhh768ouZVw+/5te58oiy+BufRCG5H/OvTAUmUgya0nvVlom5aJwOo+RYCLyoy8rDxdLD38Du6TyCRPBA78drYEd79BWtafXK/6owKpZlJysaMEItFwb5J2YIN3rC2zVbCrQnEoWP7tgw5POe6tMgep9Zwdw8Qh0kLQS8Vwgob57TEOzjEl4b3I7dt5vy3wKeAHtv4XLNc9bMVUmRhG5S24Hwb+42KCV1+GST1La7beE8bEP1VO4x5mVa/bcJPlhXBzj/ltLxjZyOOIEcpsn7fUxSHddlnAfCJDQkomKYRmhjvdU8k2Nz4nlE9rWHFP9mtieFMwVl30cJg0L2iot0IGZ4VHJzbsibmkmk3KegXHAErE6DSyxgKXSzIBYnQYWYlIxiuaIpGL8seWROwyXdLYsXWafs5YDe/7gGa7r4PqK5XMJqm+w9S3dc5XmeQ6sH1qiAHoqVBayqQnPTHnesKifNwfFAuK7c5DLuEs79LS9V1KXvJpyjyPKNMoFbadXhxLa+iyeLx95DJNWuy2R3BWp7Cg5+lFks1lTR+aIZya1lFwDzJJJqI4maZKDU1NBip4iqShi8IwkDJYJ1jI6mksBW1QsmO2iWkZHcymQQx7Kv6H5r1mK4So028Fw+8lwRXaczYea4S5puXk3QyiCOZEr8pOCk+fg6XrOtfK2PAkuHjqVZ3cOV2dENG7rdlk0B0WsHbBsHR3FDsDC2cpJU1CwLUuVf2Skemdt3q5qP9j/6kEyEwYAJ6xYUK9dhUupeFCJUpYrc7qr/g/q3sw7kyMs10rfvY2+3dsbPxfvtcm7vLM7ZH9adR+OWBGF2eULjaud/LtUYUIa0n0LO0h35Rjb/76jxv6H0Y/zMRGh/o8n4xWLsqqbtuuHLC/Kqm7abq+qm9RGl0sfYsqltp7dGQ5GPi4WTyTTmBw+bQZMMRSsOVBy54NAobF4IplKozMACMEIkqIJEx+PRmcwWewur5ldR87NdW49mXz6U4oancHk4ent6y/Kqu5wutx+qrc/ipO02mj3aqbSYdIyX+haVd3U3NLa1h539fR1dHZ19/T29XcFLJjzQiptrPOAxKKNdR6QciGVNtYBEouaozGQiCQa40IqbSwgsShtrPOAMKGMC6k0ILGoM0UIGk8mkxWFVNpY5wPjQiptrOspbcjCsXhAYlFzCljRur4oq7ppuz7ElEvdtF0fYpoXZVU3bRdiyqW2LhsTCpFCy/KirOqmDTHlUtVN2/UhipM0y4uyqkNMudSuVWc40/buH40n09WN7b01p6aHky3nF3ZdtXrT5i1bt20f79qzb8fOXbv37N23f7ceg/DBBQseImRoMOHABydIimZYjkdQNMuLsqrpBkCECam0WPDBgwYdBkxYsOPC27T9OK/7eb9/GZtumB7P9/cfc+3Hed0jFoAjSIpmWI4PMJwgKZphuTylDVk4Fg9ILGpOBwo2O3sLSytrG1s7e0Bi0cY6D0i5kEob6wCJRc3REODyMZwgKZphAYlFaWOdB4QJZVxIpQGJRZ0RsVKeYVq243p+oemGadmO6/Wtferm9fzI6tn7PlDx+fl7eHp5+/j6+UdWzz73/cjax1z73BdZPXuvJ7DQ1ZfJFUqVWqONrJ61z30/Ui619THXjqyefae/uvedzFF733yj1vlnMmruuSCWXmG87fTtRoN9Oly1hg5DvURH1FN7Z1S2XB07mKb+8HU1/EReI1H+wlYr61hlFosMF8AG2OC9y/yo66iol+kYKBW23YJwd1J289VxOnFhMek4gIO9zDWWdvxszn6+bjo1May5sMnKGuqnGV5kuPjLzC7nNBQvk43F/4Nw8so6idD+qb42X9NpkPgt8zLRQ9xac1oo5dTXWn56hakhDgiYQ3fLGiSCWNVnPlcHt5nByc3Aep1J+DbT8xT0GeIHHQP+MH0xpsNrY4rClM1kx0kn5dFKaSAPW0hK9yaj44TzhHMRAquRuUqpc3jNuNvbeCx7GG96Q4HSpCwD4cpt/+jmELOCSruHr4QJxXvLxuLnYvCjFj7tXP99rB+X6mfO3e8UTNmNSsm7xD+WLnse/ul08gdL42V6sBN5TpiJ+lJTJJYVJ4AnDK+b+Zu597H+PTfLLng60l4pU054JYnxSuJ6Y4qiu96TfYRO996EzCzn8uFX5I7Cq6osPOmEeSE+mqzaH8twUsJBIgkbBvzTdRWRndS6Mborq8ug+MHKi99zLzV7SRx1UAEmVI4yRx+gsgWVTyEvmA15X9DIQNTPhgF1bVZd6EPAOtGIKTlCk/r24lfeV30HM0zqkxA7IdrlXDkP5RhG/BC9XnA0jmDS/ndjOFfhJUy6Ikx9dRBf7AmRAk8LZ2UY6DDs4q4uASvlGwXkUtaEG/GpG7mxUVn+tsMRW5K4d2wY4pgFbCf1sp7Zt4vlqgewlQP9IgyF5EAQc14EGws+ncNaDDYqY75utSOJyQbeFAi9iqsipLaJcXJSB+q4oSfNV1uuOptpdZRf0IZGkfGdRUIFSsPvTOZoK4tX0evNhG/jR1fQXn9slo0DMS5SKx6FOOGqqT3j9DSWngfzrzEaJpXyFd4bNeMZKLEQm0V3gpEJv3Mlnz54o/6knoAKZV2uBKvIYDOTmnf1nk3VQmU9jboR8uLYWLBibv4TfVlUWmF4LN4GQHblIqGWjh3KpbXi1Ykdfl0Ahb/5g9K7lTUDGKp6mx2/mc2XSXaJr41aDLN5VOjsnR7zLKxY5Fj3f3pyitM+wEekwv6008iFc2fa/ZmzXY/jejsrRe/Htq3LfLrfndXn+8/59kWG7boDwBPgm8qsfYcI6QdUGD9hcvG7U9v86XqSsI/yRd0vlvRZmbwvKxV9W6vsrz79e2URcHA19nnk0RbGgt5gstidLk9L/fx+ZD0AilWqB4NG2NQq2CIgo2GKAz4RCZ36fhqpOoyVq9orGynfSgA4A0dw9BmjjugqGv2kAQAAAADAMY5BowEAAjgCAAAAAAAAAACg0QDgKxplttr+1cf4I/E+XkdU/6XfQKTu0x2qPj9VNMNqw+LnE6QqY1lXD0arm05Ms/SlLv1wtHm2LuY2nN5A+vZz8GSac+en/lN0fuKRy4S1qoE52JCYvOFDlGVD13w35I1ckIEt5X40SLZz7rkvawLSrMXae1n6pdtvZgwtv/06X+X2DvJDNN/4nqfyIiGWB5FO8Dmh2avRZZ9JMbaFQMUYcbD/IyLg1W22DqbfcxyaX8ktRvYjWgALCk8L0k/Mg4JlTkTstX50eOEZMsL9T+F5zggoEhBd4RgnMVkgJC0wznqTJja/P1sf7leRGEhTF89tpYMygPrBW2qoMxIyPIADHfTmTddIyKu9Y59Ft7e08HBXlWZt6QCqgaSC7vI3CMSaQEotpyxhpp7xUYASwRM4wxYoHnpeuhwmPr+vRyhANK6RWXuwT/T98KT1ArQZwiOEoWUVclqRO14oI0RV0odc7ndtvd2UEXmGWavbva/DYW4aRo7HmIXdgClL+F3+A495mxoclycX7hJ4Uv+VJA50feAp/Yeo1g4LrSniN4Q699ClEIna8bi9LXeqvBtLP1rkMSpPLeFZyjeSb5GFnax3pWVLeiR/K/kHVabL8ywRdK8p9VHx1Sweq7NS1TDOfVLQHODobDiLVYAI+qAP+sAE/YED87vhda0gEFUqzsIs1Pa/2HpWBMnYMiu4cuNOuteA4ucEYKudYpxw3gUXXZIj1335HnjokedeeuW1N956r0KlajVq1anXqEmLNh269OjVp9+AQUOGjTzOoy6zUTEwKVGmgkWVBykv3nz5WStMuC222iZOvASpMp1z3g133HXPfQ898tiT/VzqWiSv8UaBQuUq1anXoFGvISN+G/XHmHETJk2ZLtlolMKmgrpNCB0qOLjU8KjToEmHHn2mLFmxZjNdBDVdbBg167HBRkE2J+SswDbba8eaKOwS46DD4iVIlKzJiO9+7kmpxw/MW/C3ZGsjEGmn3fbYK85+Bx2WIMkRDz3y2BNPPfO8Xgww1KjTpE0XnwFD3Z8egAgTyrhAxUBBgoUgIQsVhoIqXIRIUXLk+uiTz/X/oEufEUtW7DiJliYdR5YcufIVEm9JBhQ/h932WHjZp6UuF7WiIQMHn4BQoSLFyohJSFVqt1aHLoOGjHF3ZI4bbrrrgYceeeKpF1565bV33itRqs5XzVq0atehT78Bg4YMG/HN7xod4smxZcfeKg7EfPnxF2CtOPvsd8BBhxwWL0GiZCnuuOue+/I98KSefQdFfGcTf8PxGpF6TH7aV87SV7io2dz6llve2nM5CP6/7YVpjKghlrBmk7Q9R5HumAzHd+YmilCibM81lD4EjFgIFC1mnh7WTbfk+bg//5POokRt2d2TH7kGOdhlNsmhhDERNRM5KSqBIzINeRSZmeTEwIbK2Krc1kC4Og269eo3WMOvwMoIHgERGQWNIiZlLOw5Pzj4QFlHdLTEjr1VHARnRyev7q4nB8e5evjW8ObL39rsxsEcxmV3UkE1Ls1gbqllllthJQuWrFjP8IFbZDnplH9cluvKmTPbJtH7JBvlNQuFlb5VUo94b/e2OJxyh+cDZLnBvvQ/owTJaLHoW1mNsiEDV0bvGaPcT3bHMuPW2N7MxZf9pPVtjo7J1HJCbavG1qQ6Ddm9Zy/6DRrejE3DT4BA65dDs+84PHESnInKpCXlfeqAI2zODjnn/ObCGBddWt9sTH3QEUmtSDvYW8VBsLy4259cUgMNfeVu7kFv9ykPhsMux529WQxP4pR/dnRz8wqba9O87oab2dstfX4XHCEB5Il5DynlPIGFfGMoif7o8GbbD51DYxweJCgTlUlLyvvUIUf4xbqIBxyPChp6cK9i9gP1LBgLH2IxEHZ0LjOv+S1oXfvE38Oj83yNp904YaSP8anPfenr+LXnNa1tXevHf9+VScQsSOfCWMSiFrOpq+O63nV2sZ8DXBDX9nqBC13kEpe6zOXx2R+mD6fhKP2mix48N14JEdum/RWjjeB+Chw5zTdQlMfDoVcPayk2uftvU70hoY+AJZhixgpWYoEl+69p+/+NJdS09Byc/AJCUpY4Kt0xGY474Yab/vPcS6+89sZb731RoFCREmUq1KjTZAFZmBgGwZF4IBhJszg8gUgikytsdofT5ROGRKGxJDKdxebJ1RqDyWxxujy9vEEYQTGckPQoTtthur1IitFNy4mSvG6HlTABmkkkQ0GFYlAsSkIVy6xSWVUtu9yqlVf1alSzWtWuTvVqUEHNalnr2tSukY1qdOmNLaPMpjSjnOaU14IKWjLFUz6SkU3V1E7d1E/DNI1y2mbtdEzn3JymaZ626ZnBGZqR+Tbf58eMzeRMzfz8ncWRxS0TJf0gV6o1RrPV7hOITKUz2Vy+wWSxOVxuHl4QAoXBEUgUGkMilckVSpVao9UbTRZMTD+Pm8vDy6dvfvEjGI7Gk7X1jc2t7Z3dvQaHhqelZ2RmZefk5hUW9X+a1W3nKQcQJBQY9wTFsHhuDwSKQOIJLIFQpDaZLXY/sjhCuVKl1uj0RpOtH/KNz3K8pGq6YVqO64dxkhZV0w3Tcd3uj+cnGEFxkuYkRdNtL4i6+Xx+TXKCaedFWdVN2xFjTLNhnOZl3fbjvB8QghGlKKu6abt++AKBwuAIJAqNweLwBA6XxxcIRWKFymT2s3a9+thn3Uc4w18DrL/66V9v7AEQr+9LX16fZqEVnhYKZRIm13+zRo8vlHEk8l5TfmaPRFQVnt9UvDrY8+nmBBDrtTtUJiiFNQ2dYI68KZBY6rNqHSKyRecGOtk5Mr6becxVJkLZ8Mx99mRYMrUKE56iwQfqfdHOttBwtrPZByrPmRN2yHrIQq51k2TOuHIwDthtMR02awYXfpHhMxE6CtOARhRWWl0FlnjhMyy44fywe2eceaqXYFRW/+9h4yS189P7MthBTL8EF29jCS78AgsyZ8j+WAc8ffp7BMuLROZxhMnoIQKuKD43HX5TDD4scEhqkGbf+pct9fpzdz0QNEgOGs4hyzWH5S1u6u2AFY0dEOvZstCqMkFSd7krAVeYmGaZmY6zwXkKD0BGq3AwXvZPOX5aeriA3nsB18yapGKYTppIyy7JHTCjGVlkyYdV59ckJGNj7QIGER+wrtiN7EE6sTf4BMpypqfgKMUfmbQ1rhYx1+64bCvzUJR8SBtXUUvK4Wd6lYFjwAgeySB3pi34wTbGBiIbipbg4FPShKazi3x7LIIx04lszFnfhAxm+EPd1qHdTpUmZtJsdlQN9fq8im23Oyopid2lGl3qLbt7Ka+r+Jqg8rM5ztgOJ6UkEnYcDZhfXPTTI3PRUiqdCC0F+/hsvK0vpfe99G7CKPbLKQORSNQG388i7Wb+leWD0czW2/jqyGplfTMpCnh/49cmp8w6nUjvg6QunHRNcY9BcsQxU2p+qYoX1dQqG/kDBqTcSDZ43dfD9LrbZ7JOL+eXSx8d9r4+CAv5vQ0p5kIm91hRLlNzFQspCoeI/7vkvf0/XkAUmOqiY5bmDCq+a3CJaCa8xlzD7xKNWf8X44p88mYZyLYIL14x0Xm1I3YkesXEV8QI169zkN/dKd3yYeHv4P4ipyFDBkeUWF3HGpi1KNaGrINZl2Y9hvVbywZsiGMjmY15NmmJTdkMx+aYLQS2xGwlsrXENgq2rXwK0kt2QMWOanbSsNdaONBB2pORLpyEnnPUXIC5FHMtxx032kH6813upbnPgxwPgXm4nI8U/Jl5zJMyT6HmacwzrfCK17W8USImhXThfQifucGVXwLyFczXMN+g+RbNd2i+R/MDmh+x/ITlZyy/YPkVx284fsfxey1/YPzR4U+MPzv8hfFXh78x/mHwT4d/Gfzb4T+c/w8KmRMGwcAhOHKI3JW8EZxIMxQQBbQqTbgeYcIEE0zKXkaLHVFconhEaZCkRZIOSXotSU1RRDGFjJElXJmmRU3zoueyYuaKYpcFSllRK6BWSKOIXvGqlJQkpSVNWclKAVGJkuRClktpl9I5YQPqvLpMVWvCyRvR1pwHNSx/zahQYafUOog+Gv04bfwVr+Bq4cyo4JBx2o6gHYjtREXR29UaSyqKKbQXWXGw9pG1n9pRGsfoXfA2NqY+mSBOuo6blqrZ1lYur47bq2qd1jUuZP1TvVYb4XR2cXWGKnjErZF1iazLZF0h6xpZNxAPoXWnWaXqyVb5tZMPDgke8SxYz+h9ltbzFxov1OJSl2D1FvEqQe9x+ty0ZBU84pvQqkCrCqdqWt/Dqba1wlVwSPCItxDVTFQrWe1kdbbkX0UxrD6IX+A0iNMwWSOI39H4Pb0/Na1jRQQjghHBiOC8/Bf0ibE7mQCN2aSsKYzX0MvE000eoEwE2eQGLWhFjnacFbUYv1dPbdeTgXRDFiasjWmHgrM5/XCas7NCQo+MAtHObyh5yEw+rcfR7oPyRDc+ZAKwNzXlaIWMdTCcQ2inFfKW1mla08+wy91W3o7+OVsJ6cpOJR3rdsWmYmKdSlnBGZORr2qxyyvhn9fsXthZx/8zacDVAa3nc6mDq2sJmz7VuuFozVwX7Z1UrFt7X+Ha4Lp51gPXx7MBbP/CDb9p5GG4sZWfzkC8PzngAAgtgaUlwpXwRVuVCEXblRSdotNVpRTKV6bIlBJLVtqqilS1lEKqTqpBqklZs4pWGZWMWqZDpkumW6ZHR7ZMn44ztCB8OotP5/HpIpRyoJQLpatQuo5Lt3ApD5fu4NI9XMpvzgoLDgkOCQ4JviMdqI+E9CoklwjpDZIrxPSemD4S02diKiClIlIqIaUyUqpoSR6LIooo7hTds4/k1Bw5tZJTOzl1klM3ZeqlTP2UaZAyDVOmX1T5Zcs7r7bWR3Z+jyd/sPMnT/5i52+eZgGVMUAKQmceOmugs9ZVf//6Vnqhs/5Vm//6Vkbh8hLaknDZpLVe2YdmYWFhYWFhYWFhYWGKj1SFnF1Xpnt0KY0hPWNKr1jSJ7byQ13XIj3xpC++CmjkmAWPNIIyX6PrM7h8l67H6HriTcEZr5PPMXKewfI8My9gWWaMAmCjIEBuHggFm2BLgisnaDy0kgdSIYKikEAsCiAUSgPjbfeEUgEXVUzhIAd6EwOlxas4e2u9p5w2ke7h6f+CZRWJeWW9nO2T1vPFya0iU5bkTmCslat19nP3DE7MrJmsnJ9zCgpp7YXMWUjEUUWsmbcWc9gI0CVQDrXL3F3Fuo53k93srzzNlTGZbWa3tYjjy/zaevDXmMP2DusFrZds+mBy+BXjOIXHaot4McsDmZRmDcELSmLwZfJnWtum7RYxlAm3CbcZFwKEbfJbRDAiGDFUgioKKqPa1WjBRQ3uocAdfxm3wdp3kJxwsM21zzUhMR6NhGRISUiFWpjSG724iIihAY0RMTSM7GLbdlxEcMw1JzkqT7N4xdS4q3NxkYb2Xcu574wYOlwbOcUHuE/AF1ghWjFQglQKlGEqX3WuychqDEcTtx42+HJz6zWUMXj934A4kUCCc8OBc9JJyrPj1S9/5norvc9tsjj37fLAtzJ37vfGtz7FH/Fu+3z3B5hEN/GkterRHd+fpR53/9gZzab7dn/2bUOom/mra8up++nrs8/tbwG/+02Heatqf6S3grej34n/x5tfF9Z4f0rQNYBO+juwhHXSeEJl5zMZOGrpG93vnIu1oZureycLcx2RR27extbjj8k7dAOQNGQyaVmhfZAKoXRRReqZHlwt6K3t0omBdeP1fXVmOczTrYgVRHYU7/QtfcUPZTbXa9H/BoXlMvz4UUf89rr+8k3wOERnYEbcnS05SK5xDTNtUVFXcP3hHdz0wH5Qg6QssOSoOIis+burmWGy2zZwVzKZurDT05vU2QjmvM/Y1+bcE4In96Oq43chFgHOFO8N+SUhYu4MfOAE09IFM4AKjyB1gg9X6OXEjTLXJZkTBpFVg4Gjs8VM67oJBd20ONknqMtDvKYSkuydnAso10OC63keweiu21wCWSBfncUxofqnfjcAD7yVQE5mTBrP4RprTxUH2YG0JFwGYMUgBEgcmRdKJWYEBGAjcP6QJQvXHvjwu1IVJ3xiQ2AogJXXQR6MRVfKBCb0J9l8wnVi9SY9ILqbmtAySkSapfAAoRC1OJ0IE/ExXHCAK6DtyuAOYFXNCNuyRYYHGGcYxMUzWOUvK/XAjpvJuefy/p1onUIFXw0WdGEzQ94s88O6trwts9DUCSisZaPdYDEvrcTsFCJgT5va2SXW1X/oy6fWYHNOSsqDkyQQgUH8WUutGPY94eOpmVHq5FqiMQEjyID5Y8wK6PkODCZ/UlNuTJzg3WgTUJTMPP7cbXs/O/oralivX1W5EYKoT8vEft1Ff8KiGMpRkcsBxTQUGEI75EhEfFgI/nUEgPClzbwbeOHmQCmoCtbPgVUxoNsMUXBPcn/2U2Fv67GjQcP06sWYLxPtutPvD3ww4/kakSwZFwZ8DG2vigog6FpR9/o0QhxA1wszx763z3qQlmcFRi62tTyn6qT/lM3zNEsXu9LufSzMFIWs8hDJwPTggnKLGNVBB1E/VckRsTwxUU8oAPAlkw0fiIhfficK/6UZ4i0hnuRs3KUg8an6ezRpWwpsIx4Iv9Dqa3Fq7VPatx8Qcp6i4vjoPdjV2F93DAldOBe/tgd4OUD6QN8ol6h/egpTwAsULDucG7FbkjaOUIX00g88DEjnNwhDc3791KcIaIhN83ukZHZtUQobWzv77jeWYlpvXkANZHBfoR1dPs1gRjg0gXNBZAoZ/p/fL/c/ku7BxXK8IEqyomq6YVq26/lBiHH8RsZpXnAObtr4mDAsxwuiJCuqphumeSEWNUdW2P+HP8T4xtFY2HGAEIygGI6CcA+OSqMzmCw2h8vtAYLAEBgcgYc4zECWc0WZ4nFOmbDIqMPlARyLCwsVPJLs9Kbnf7U7nG7uHhiJS7IaizmS2pQuSdV0w3K8AC/ZbF7WbT+M07ysG5S587vdHy9E4CeXzAmSrKiabuAooRcgKTLrHbuomrbrh2lBmFDGMRU3OMvVTS5uZKw6wBVrnAFZaU6qahraUofia+MqzVp6RmbW26yXX1BYVFxaXllV3ehSc1htTbHfIFKuuGwbtSBDsdJwiwRyYX9yCkdcatlx4/ddMinMp0RdVKN3bzD0mJPZySJV6Q9cncFksTlc7p7eQDAUjkRj8QRinJwEwrzrD6VypVqrNxhNZovVZnc4AZmLtjg8gUgiU6iGDce86CrjAmQfPfHrrJy8gqKSsorKquqa2rr6hsam5pbWtvaOzq7unsCg4JDQsPCIqJi4hKSUtIysnLwCtOb0P1dU1dRBNhLpc7iX5ggBA8BtJluw4eAew248rd1gv40bPZwuEXEOBD5YAshZnsJgcUQSGUJc4PJuC9JBAnGq7jOjZlBH2km/YiyhDjdWqLTITmwy5+y536jhxonIaIBHisXlVMZXt+NpuSxX1sk22SfHNju3tnd0duvRq3dAYNCohwuIKAQplQ42s7Jz0J6t55V1Tc0tbR2dXd179hb2cembNtaMi09ISU1LbxC6Af9ZuFPLH7lyaODmgAKdeOlHPIrhBEnRDMvxgijJiqrphmnZjuv5QRjFSeqJ2YCie3yc5mXd9uO8bvfH8/UGyGLu2NEbtkgiU6g0OoPJYsNIyyVSmVyhFwanfgKT9nTqhpM6xx8yfL0+8ne/w2gnLVUbpI+GLARmKwBU92Iadrd2geXGVlVXZWrofTakrSRruu3Zm27MTavNinukdpZsirl5I7upV0ddHdO9yrCU+aZqf/Abn63W0TXaS5s0PesG1mXTESL7yVkkYir0iAGDmKIR7cgXry+bFezY20u+XgyOdPG+/31Dr5CwmZG8DYycCAaMGiPWFJ9pHw8Onum1t/Y1a8C3dvRt7mHKtzwdPNpIr/I8oHfKNQKdy7M2Og9dqGFzdBG6xOTSkk/mCsgbw1bMm9Qae98G9tOyP3CQxQPAkcAxZ+Wp9+pJ4+ypS/zNlwDOEbkAvbKm93zMTxF8g0XtXUee9RmrUAUCgUDUSf4QPB8xPub5hPEpnk8zPoN+BD4PfAH9CnwJ/Q58Ffg68E3g28B3ge8DPwR+hP4AfoL+An6G/gF+gf4H/EvDv9PUQroICAiTn7UT5ppMJtMUDSwkBQui4SDtFJdYSFoMQqxKFdXfHyV31VtjLFhBoFtjdFssQC1C0R9fCr+yIvfvRqWtClvQasQ9SMYgxjXuHptWf7lCbYx38XjARLZfY8tcu0+Jq8DA0+E904xogztMduDN8P6HeQvv/5h5eG83O1uO6StAQMCgtPPYEsACRBr4cXg/YX5pRrTBgUXwFmOW4C1tVsXKUQAIGFjWNMWehiSz2DaPBY/DZLfXt/D+HCyVBQgICAgzumCRlC1jGBjgg1niWcvsBm6AymaJ0IAgqo8wbLUtZ93he22wjWcBoAqAE+O4Uz9rLhNjkcb9pq7ihlsrWnCOSruGtFRAwLlM/oa5pQXqVzER00mz07e0EzOrurOuYoMvZwGCZnIpDCPOBpkN8azbymsI388SCKqbwIGvWwPbTLtdb0ksu5lsPW0ragUG+0Nro1qBWKaub05mnK3/NKtrDXYR2/Xn+ATBojf7d2XlHz5hzVgWVYxtAQAAAABMJKWh7W0BAgICHv3UZDKZTOCRVEdKDZJaUuqQ1JPSgKSxJTzdciHFpQqqoAqqoKpVUaU1w353zPs9w/7QZlfdY5br7660+vr+eaQsUPdvrBgQiwWqOBCKX+UsOZwcAo5AHic/M4OEIyHjyBRwCig4CiqOilYT9JpSrBlGoZiFUao55VpQqSVWrajWGrs2OLXNZ9fsFwAAAAACAgICAgICAgICAoKoiqqoiioGkG0of816/tlg8S8UIOHXe5urjUdBXU7stcmv5KOjTR/1c5MLO/MVXmMRDFA4vA2zgSfXfBfs0+EcL25g1pgG+3S9KVc318EAD78te8MorYBX4UJx4nYY/KgTF2Ox3MmF3ZV/koD1yRQLvTBVUCFMYzKsxVivT7dGEyXfG0kIND1zKmGDPzwDT49PCt9Ufmn80wVkWJspMIuY1VsxACsCAgZaja56PcS+GGDQVaPt4V1Vd63AWmiNqYJ6JrOurmo7mXpDolUM0bGJz5lO3TG8xCIU0mMqggAIOPF5fkMLrLE+BhiMtTRmbOnYdgR2dNs7063R/XiMoUv4Ty1j12E38J+vDQdDViWb+LQ1tGEyAJi1T4Ztm+zw/u1XNzY/LQJqnkz8r8kDESjgHrMnhFyjtEZmrdHVSKvRVU0JqgqGfVxrZQBgU/fE9ezfvQ2eVvfT6qpE1M+NKIZk1i/ztU/qowNv7Pz+b5L833+9U0Dr+LbEdAM/9xM+l0ypju53wddw/TPpOGCkirNVAZ4plXElnCtV9En05bPg1njyyhLpiDfC131q5O+xbFJDKU1A3rDKwPz+xPdWcpmF1hlo2nQzyjcy1+iM32D+mfeAHZTLP1QLZ5nKGZFS0GMWUVlDjX7bMbeKYI5x/M2XQ+6RdF/FVwDUp21MBsHqgG/3ArvfV//BCjpgn3iEneYup7iZhQKVb0erysWNzpOxLeQNvCHTli7nRA0b7DRGcdFd5UAjbzWBeLAqnlt++iduSxld6lmC+HfFUKJv8Xc24mwr/4TQ94s15SNIlcIRShXxVKfD+41kqsfdnGQGlAFlEp3T4yLdpS9BA2eSRqWTZz92bvWOgp72BqSp3hd+nMnR5jTb5nCEzLr40nCsIVRdynynZ8Qa+JRvZVodot3kkoGFtk8mjpzI71Szyk35Thh3e6d2wr+nYSG3Rs186CeglRmaBT7OR4IXEDE+pNnOHle2Kzk3lh0JINEqZsqHTR/ILuQOWg4IHAnQEDjoGCdrISRwt+3IXTmRqQs7PUX/b64Bt/Kyb/BrR/ITlhK/X5sdnRbD5ZClBGCK92ScS9ioerpzxDkQTEsXzEAqPEZDzFqPRWCKDWWuSzUIbvWWDSfVWIiOt0+LmZ7WTSjoxtl8QZWiFNDEa7rWVGrWzblkVK6joctDi4VgdNftMQUcKcPlA6A6E2Z1Y7ah0loh5WTG/JIhN8/E01zLOjoXWtLnf7MO6uKR3Y46LL1QKjEjXACZDaw3AeAFzOoCwLirdHFykNgEhs+tgmwaxG64wxDz+jGhP8nmE64TqzdNbWBpJiYUauE6CAf/1m8rSyC+QWNC7S+FX+hMsU0s3cq5TLdibhxAF/w0hodwFBdXxSqHsylhnhZZzLrLexatC1zULvtDkwCtzoA5To5ZszQucWvZJjnjEmAQyNvo6wpwN1iYO0TNTk0W+TQeWt14sa7+S18+1bY256SkPDhPAsw7x38drVYMxjUfOruD6QmwWGj9vSDz8zoUQt8UT7gRsT5wlo/a/im4IcGdef0IeWyQ6RAh4YbTVAn7mArfgv1nVWEf/XzQ1qjB9cv+wM0XanFk154ICo6QOA79/9izzv3Av6KANDv79lDWA26pZWBVGrD8a0qvTyOG7K6fl9Z89ij+6fHshPn07GIxvVZie0QvpKzybA9KPXl0QSmFpg4Cqn7lKqFBlyomusAwHBx3q20GEDF8+Z0ofHDNvow7CYWdEY0TBaGfqr9fmrRtUVgYDrSEqW0jfcJi7RM7zykaYhGi67wJjlvJyvigZRCGkPy5gO0eXj4I1zH0jXJC//QUpga80IO1w6Oxuw5v6zGr4I6/iXSCBdCWoRP+z3EwrCAwmHTaf+FWMih7yJ+8+uP3e+nnF0B6KXCqRESIhfXNVYmkXtRh2Wf9fYFo2i55KsL/6bf737I/4uThubzhrnjuxZf91urqlx/Zu0zs3bXSmIuuFQfgBXfMNe65hVlp6T6xLEr8/Dfi13/iEfb7JkV/7r3fN8y5crGvDYJ1S2VvdZZrKufqf4671sUMiZWv1tFS33CVBtpX2TnnrFV0ltOOLP9H/3sqgLGpG0KFIxRjx9pNCaSrFWxtAtw2HQMFq25oyfzBA1JpnNdr6FyzaQJfe3O2ZvuqEwQg2lnguDs3eqvkQjJlxmoGcpAz1ZU1a+yNkHn4UHaVBtzvAS6UrbCwWgeA3K/C2+/eyu9Mq/KF0K7NGyYNSnV70IhCgVYlhZXoP/GfUtiMNLxp5z4fSonAWXUEGaLbftnYNa231QQd/Y/LktTHQINsxIzgK3d/p3ICwNCPLiHyWbQFWT5RgGT1yPSy6gbX2NvHXb9aKc/o7i57v3hi9Nsv8/+jMWqgiXNX9gmefQn7CewPHEA5WMchbeTQ+5UjgaMkjpY5hnFswaCjRNcL19CCZ31Kea4VXvA14c0U31fe8g00KxVfTnE5dWQNTwghDyiCyCbIwsdmx9u/jpI5ld+m8vfngv/+vxNAFAVWLCglACcReMkrk4JQk65pqYLIQVINSXUkNZHVRZaPrAFMQ5hLYJoAigDNAJcCLgdcCWiJojWKjgS98G6iM4joZjaGnqgU1y54d2PuIRgLPEAx5XuyaR/hv6NeBMwB5gKvAq8D/2s6u+LvKyK/1+y72W59WNMJ3YV0d/Xc0JARm45kC8k2YAewi2wP5gDq0Ka3oSPO2ZR2zL/A4ACPwgk0yBZDk2bKKDshJvsud+Chi5fRGrs4GEwZw63lttHg0THxPyOOaLxox2yI+Fk6vmCWTwA6tkMGYzcAP/YDwqwaWBrxIIxoR0eiZaWNEHoIN6xKGjarV33uNYrN7oVlA+GnTMSRJ7KFGZ1dWpbZwF7OyO5tQ9iflj22SLrH4fcfNtu4/Y3B7gX207Aty3v/vH2FksPuZq/hI0zcX6Pb36vOo4t2azzSTrRMsRGi7J3DHvRQNR9+F5CgwATTEBF2yym/ijzP84QQQkbAWEdDcwzNcTQn0JxEc4mYy8RcIeYaMTfQ/IfmfzS30dxFcx/NAzTvSPlAyidSvpBSSE4xOaXklJNT2bLP7oazu8nsbiw7lqaBtIC0gXSAdIH0UNLXyqayspVVlIrJ1oFsncbOkrkNyq9MmRqZb43lghXM5O01z6x5Y02BNdXVlFZTV01RlRJCCCGEZ0bqMlA3UA/Q1aBrQL1BfUH9KV1L6TpKN1C6qUUMPegNZ06f+Hz2lOyhu9fPCae0E5k7f7vV9+pMWj7ZjQJQCiS1Di+G3MVW+DJ8atfg3WgDLvemltl6NNrjSMQ4V27udD7c/GgCaAJpNjIEMQQzhJKEv6WA46aNdSCaQzTxNGk0GWRZuJNrOZ+aUJUdcIbqApCLu0pxHbhLkY973BwQ96yHe0HDV1wM6+OwfYYUYCo6kVB4pYRxPIhDcNPBQNcthPLcXXZQ34Xl53p5+deNGRxFMb4OcqK3mgY3s+rz2X60psPwHqLIAuUUUH6X9HvjAN6jv984+NSjjwbf/KRnspC90v10vy4aF6/W6NaksZtv1t6vx2amwOBWfHXknIlnaeuGa9yZJHOscaDqUuYCoIHd1uRzgZYFAMLEoSa3NNjyTc211ABKNZWCmcPvmWoe3uhKXbdSFhZqXGyRLhPbSqLQKW6NL2xlbpo1OB1n4ET7a0uqmbJ5ZbuSSy1k7CNk24ScfWPoG7KGcJAxTfLbWzooBx6LAwd7sc2rGQDKHJ1sUiWP5bNPFWsxehGDoH0gOOtkjPWI+Fm84QvguyYCFlVPrfdCMC29wiMIFR5LAVnrsWgozCg3ClyNW71lW1AkJOXbVTHTqm5CQTfO5h2qFKUAEq/pWlOpWSfnmlG4LnsKZEnVeQSju24kyJqC8wGojsqHOyaggaEkIjmFMVLO+lh5CsdZffM0BbZti4yB2lFWzUopKjtvUBRM/ffZQbGgYHUBXsZdIfAP+VDp3nwKZx9UMCqFb5Z8/ZjQn2TzCdeJ1ZuUbX6twIRUhauv0+udBEMTnS3L/gdezMhMcbwc5oWA0Dg1eBXDa/COW4qtchhMCWFaZBFkl/csWhfsonbZH5hRKJdxJk+OWbM0SFw/20yBQSG1UYW1oBss5tweYp+YLIp3I1VWl1hX/6Uvn2pbG3Pr/51ASSTAvHP8WblWDFNP+HhlYJc6ubmoR8AOMmDaZv3bQHR7pGd61XON+it4oSRwTv8rAU4nHRqvAi0Bqw870LYJ6KuaAhTw11yDHKUt0+0WNBWPzyA8S93UwxdVYc/8NYPr5cDnYPU8tw++ExQF57dsj9579mAoZP578FOKy6O+e4pT1v20f4EWo+6SI+391EqFHkQgOLA+A+x13LdiR/a/5waTHj2ddS0zu2H5wFKT5Z/696+ZD8yedLFemW3xwlCSVZ7tjVJPepUthV0dBFT9ylVCw5C6RAWVglONgTMeXhB5MipReImSvyIi4BWUEY2XFIR+qv7eNOk9LpFi8YHMLxV5LYYq1uOVemZOQ9DXY+m8tZXsPlFNpkUIS38ufm1NoC5U4TpM3yh3YBPpKVKKl/n7WK79nFBfQYTGtgrIzVUD+q/ssoqviXOv8xROvf/QYqnsNIr/PRGSGlX+Q4pmWI6XZEU1TMt2XM8PitsfWV6UVd20XT9szxe8PwdhkuVFWdVN2/XDOM3Luu3HD38tVpjZIBQmNlxwxY2gGDZXKJbKlWqt3mi22p0+cSS+QChRGoxmm8vnFJAP8fgjm7brh0lWVM31fItplhdt1w/jtKzH+dvYPjp33kLzmTSW8kLJEG5uCS5o6wwVwcWX1uITyAeuiA6PPuEGzmVWO9Z4/qWXX3n73U8kRTjNqPvu+x94wA10S/ezCriisG8vikAKYHF4T8ToONPM4Z9TKi2ib0ilzeE6cR79qNXLinjyPd08vHwEQWAIFAbH4vAEIolModLo3D29hZFoLJ5IptKZbC5fKJbKlWqZEYXZKih9D3suanOYsu93t1AklkhlsnPzC4tLy/uNjo1PTE415sy5er+/2/K2/T0pM8/TYkAeT8hYnDS1sy1+4vIEIuMmyzDMqVHOdoFJ6R41svIKikrKWtq6uvfsW2RsXLrl2skZufmFxVW1Y/FNN7a2d+vRKxQRlZWTe/1eZ0GipLSuvrFpyM25klW5MsrK+PVur+PakQkUwp1Xvfo1r31dOOXETaP73/4A0am/tmVr8uIsblMqSHQzNCrs/7hRjrFMz3tbAz8YycaHYg8zQ3Hn7bNIcyU4w/XfE6gUFLtWw9M1/mdfxSXw2VY8ybTgNN8lxE8v02L8UTfMUGS3zCv0VD8Q+BD8PbT3RaO2IjLdYLp5ufe0MS7xsAx7rWGdsmhTDfUysXOXMqfLJvtjrW2cf+/ozTf78mAA0VjsCd/c/16saX5/HAZglo16sabn/YMZAKcBAGZ9TdP4+qb/ZrGm4/+x17/Eqt3oG1rRH1v860IfevrupJn06nHVAaKybJ4e4I4VwTSycm3dzrR5k03PPEso3552SOtRPdpBbz3v8c65pBgbMxGmKFqy6VLaMqTlaCuQVqJZoFoWCvcF5ji2QPaVV18pj+kLr3thgbb+6HF8nzl6oRhuGOXLTHxPrMn6L9AXbJE3KSOKeu9wv1eRXYldmV2FQyVQDdQ41AJ1DvVAg8tG4KvLJqAFaHXZBrTXZUylM9IV6070pNkrhz6g/6wkUwDri0OAOBQQvuMyLqc0atSYMRMmcirQZtDmkBfQZNSOmdG7SZIkIQiKEk4Z3iQdx3Es6+EaXHnCAH/CADYAYEP/3Q0iPjAMSuBOAFAm7O1kMftduN269bqNGwNhQAilbqe3nUhgE8ZqkYB7VgywYQANCgD0z7kLKx+Yh7rqlH2/WwFJwNXYzoD2PcAATwzgCgBCKFebEHQ34PnAFA71/pIPZABXS9sXD1sn+m91tTNK185yURnbmYkBQihXmwkDOi0SMBRtZkrnyTUzBEEQ9q1xGQMsS5ut9D4LA66RNafiAftkVJ7K0mY/ZaciAQsDlELUzqigcH8kTxjPwykBwH2rpb17P+kSKKSinVnpXXmW+1uzb4WpRG3uOIjafV67kAGEUfnZl4Zt2aZs7OT+VGWnovwK8TuH+7bwWFCCBVU4MFH6dRaZ4KZSnkFFRqJMxJlJspBmVZmNLLuqHOQ5VedSkxtF7mrzUJen+rw05EuNATQF3L5Vfyo5mySZZnZq2SRJkiRJCIKgdLJTyCZJx3Ecx7KsR7m75nnKME+b5CljPG2GZ6IF84UK7l6cYIIE8xCCefDAPOI1WKICDQkUHtBgQCEBDQMUBtAAQKH/DP0T7s+gvyRnZyPnZ2cLVN6aCsWNhmFYFiGMOU6r1en0eoPBaHR0dHLKl6/GdhqoPCAEQRAEQRAEQdj3AAY8koAnDHA1swl9+roxPbmRnR5Y5zhCrsfSfv773mmJt7W2B7GgHxjcbGCsLIZl2FkSK1EbL4cTjKCB0wpXQIIoP5ugjcelBTer+0WOEr2xHbKLcBHHmaI6LFcbzl2xQRhhbiExkBzEvi2CBaN04bbnpnu38nZuV3vnaw5a2mTDD25cN6JN+zh0tEpxPRThZaK2M8doLLfxF2aQbiQ+Bk+MYMumynBjRj3q9s4nURbkzx8fP1zhGl5eXl4QSRKCoEQLw9v2tAOCmjC2HdJ2GtupaydRGDghdMitLwYmStemgebuigYa2wyosKTtS4eaCkKp24y6YHGFUAMVogRuks7O18Te5vliDLfKWO5qhqShucPG+KuwYWVhhqV0U7mqQFh04Rm0cFW6ueM1BQHDkLm5+7y2IWYYGjdBpwUb2tcvI5XDzZ+Rho6R1OGOoUp4kTiVDQcuaqE6GrNh1MLpOfdI6ukMpZRRQSNfaaKZFlppP6MivMtzdnq9iliD7QP30Dpd7l4++axAkRKlyjWZ49ARsmEBTncTiiZSN1qoKo/UwOeyo3PDJm/vKC+1SzSIEpHQK+kh/NmhH5wdOlIF0oU4+BIBNR8R9ShSDgMnTMpR2tfgE84ipWOiysxLNXrZw2pfqGB5Tw73DzgQVGAIp1keLq4/YEAyfYqzRlmqw/rXkGDRjEPN9csJVhx27nxQwWdrnE6hf4qmkrRySEZ9UrQAEkROOTEhIQkh8SDZgCAIIhmg43KnPAiCSNANwyiSmMr0ZhhTsW6W5X4ttdQSpNzjLwrQQSTlZb9f73J/Q3MDzfCmAr1s9msJnn13NS8pX46DzwgiEQfBsspfD3EquA/uXXyn3ak2iMTaiOK+JuXoJTVBEATN2WS6Udmv93xb++xY0FTU1CQUiWS6bTSbNf16exOgSmruZaRBvml0byBUPZkDqbOk9sndRrMDaEhmPnTWCEPILOjr2mgyo6BRq5dfY52lfE09eg1S6mQ6jU6gU+ekOV1OlFPk5DgtTk9BEERyaRiGUcQ5lZhFolOhWYQ6lZtFrlPRWUQ7SlWGXme6sxi9zoBnSdrMeCpMy869llrWeU+l6v/ws0hNTxPTlDQZTUMT0NQz3QRBEARBEARBEGwGRRWdzayo0rMZF1WANhOjasDOJn1lqGW3+64eu6fp2i+mvdMzvWVXT5enVhx64i4kTUaNkWvde2QY2rjJq3udcdxJt6TI95W6ZzMq3tO5F04oXwKSEBguNFvvN/W/Z9tTvlfZtu0CtIVm2bzXe4pRQuXYLMWUliXavdyutaz2GqCf3/mxEokjCCJlhF007xUISi21UEJB61ASTCKRPkqwyMkqHJEyCoJIFkGwTM7qRVK4HZzPFoLym4Bk8pf2ZdVeaeWreNKzBxwI9QzhNCX500vBV13nuuBbT3l8idsIY2vGANpi3rPW9z/+/X8rs4A+aW1r7+jsr3/8a/T+z+W7tZ3+v9j/XRj+2u8hqJ2E5x7HL0Hz/y0O+CICfaCEOJKFBXBQdAwxWP9tADwRVuAeFdjVgPFMsZmKMVTMILNv3HyhyQIbRW6OyG0OMS9krJmyPAyIJTNC7SbMlyFmG1ZORqOwDzYcXC3anqIoCgA9+Qwm0mx/LLRZUCg8ZQo7WQqeJoU0Hx9g8oaAqJg4e1OasQMAGDvNiG6B8qUCBLfT+S2+vHjdMuJL6RYEH2AlNmaKtcwqF4dHoYOS2iRVSU4xMS1GK9BplCXK9W/XMLmg4/9UZ/+n3axfvwAKgUShMVgcHoXGwMTCxsHFwwekXEiljXWAxKLmCDQPx9P5cr3dX127fuPmrdt37t67D2JR88hqUE5vgQCLsqqbtuu1St3udHX39Pb1K23IwrF4QGJRc0IFUAwmi83h8vgMJovN4fLw8vEDUi6k0sY6QGJRc4QZ0DAt23E9X0iljWU7rucLqbSxbMf1fEBiUWdSVvbD49Pzy+vbu1eP59dv3nr7nXffe3/tUzev50dWz973kKRTKFVqjVanVyhVao1WR1dPP7L2Mdc+90VWz96LylukjWar3en2+kVZ1U2r3en2+kVZ1U2r3en2+iGmXGrXQgU4jNO8rNtusVytN9tpZ3dvX2lDFo7FAxKLmhOZiwGJoNAYLA7yAUcgUWgMFodHoTEwsbBxcHETPgBCMIKkaMLEeZPZane6vT6NVm80W+1Ot9dvtTs6u7p7io+vvyirusPpcitV9sfn1/fP79+/Hz9//f7z9+uff//7f+1TN6/nR1bP3nfGAkACEGFCGRcVl5SSkZUjV558AFGcICmaYTkAESaUccgoAAKIMKGMRyBRaEwsbBxcPHwAwQiK4QRJ0QAiTCjH8EMpgYIoyYqq6VRCVmu0tHV09fSVNmThWDwgsag5oQIoBBKFxmBxeAQShcZgcXDx8AEpF1JpYx0gsag5mqBBABEmlPEUjc5gstgcLo8PCBPKuJBKAxKLOtMMAQIgBCMohkMgUWgMFsLBxcNX2pCFY/GAxKLmlKgAiiApmmE5nqIZTBabw+XxASkXUmljHSCxqDkCnVRIpY11vmWzO5wut8fr84coTtIsL8qqDjHlUrtWkYIADoFEoTFYHD4AgyOQKDQGi4untCELx+IBiUXNceg8M4NSqKhpaOlIfSGnoKSipqGlo6eipkGTFm06dOlW9AFEmJBKi+WeRKbSmWwuD4PFE8lUOpPN5VPpjMys7JzAw8sfc+3Hed1fnop4DCaLzeHy+AkancFksTlcXr6qblIbXS59iCmX2jqPPT5z9vzzkmrJVDqTzeVT6YzMrOyc3Lz8ENO8KKu6absQUy61NYX/TA5ABpPF5nB5fIKkaIbF5nB5fIKkaIbF5nB5fEBiUWd8iqIUQIQJZRwFmGZYbA6Xx6/qJrXR5dKHmHKprWcZS0RNSKWNdd7U3NLKxtaOXXv2hVR1w7Rsx/WEVNpY56ljiCyk0sY6n8FksTm5uHl4+fiFJCuqphumZQuptLGe40dKWnQKpUqt0er0BZlcoVSpNVpdvet+1jvfPv+Ya5/7vk7NVERWiCmX2npoeGRUTGycuPHih5jmRVnVTduFmHKprcuGiDTElEttvUKpUmtqaevo6umHKE7SLC/Kqg4x5VK7ppQ1NmuYlu24ns9lbLfHy9vH189/td5M27Gbl/0wTvOybvvcoKRjMFlsDpfHZzBZbA6Xh5ePP7L2Mdc+90VWz97rCXp7EEZxkmb5VFp6RmZWdk5uXv6Y5mXd9uO87jHXPvd7N0PZBEnRDMvxGEwWm8OleHj5+Nc+dfN6fmT17H0nqpk9w7Rsx/V8y3Y4XW6P1+cfc92P87qf9xtz7XPfty8GtLG6NTO3sLSyvrULGXRhBHPIwcEWTpDgCT+QgGDAQYAEB5xwwwv/cDydb2xube8RNDYEIyiVweZhExVqRBRcoseAV6ywxglnXHDFDXdkvPDBj4OTi5uHl4+fo1o4pFZvNNucHj+1aUBTMlTQmg5U0p0+JEiRJkueImWq1KjTECRFM0zLNu6RmH3Mtc99v8Ppcnt6efv4+vmPaV7WbT/O6x5z7XO/55R1fh+EUZykWS4V4nQmKzsnNy//9f5c3/O7n/9xXvfzfv/9mZrZG3Ptc99vbe/s6unt07df/zHX/Tiv+3m/Mdc+9337i8zn9evm7uHp5f3rlzPu8ojnnLPjLZ848ZN/LBnZsOPAiQ8++eaX/+P5ev/4/Pr+p2rtKE7SaqPdk6Yo0YIishQvQa5SSS2TzLLIKpvswnLJI19HZ1d3T29ff1dBAAVILGquUKrUGq2Orp6+IErlCqVKrdHqAIlFzRFoEJBY1LxCqVJrtLR1dPX0FUqVWqOlraOrpw9ILOpMpEaAg2AEpTLYPNu0ymqLVuzSehvs1Va2ZmJmYWVjh7l4+Dg4ubh5ePn4Oaod16/VG802p8fv2m7gps64wq3dwZXu7j4KlVqrN5qtNrtDkBTNMC3bKHQdWT173+F0uT1e3j6+fv4Op8vt8fL28fXzj6yefbccASCACBPKOAaTxeYAF3l8/BTNIBY4THgAESaUcQQWGCine6FYKleqa2rr6mvUrFW7Tl1111NvffWDcrpzDAhILGoegUShMVjYOLh4+AgkCo3BwsbBxcMHJBZ1phyFRAZhFCdplsvIzMrOCbkxL1/+VDoTZUMuTvJBGMVJmuUxRebCACIEChoGFg7Ex4odJ2544AXBCH4QUNCw8IjIqGjoGAAQBIZAotAIVtTqlSpXrV6zdt16tdRWR111r2eh3vWpb/1LFpYpV6FSHXXWXW/9hcWl5TVq1qpdqAABiUXNKZQqtUYr6ejq6SuUKrVGq6Orpw9ILGpOylyaUMZgYePg4qH8XLnz5I0Pviia4Y+CipqWnpGZlY2dg0Ci0BhMFpvhhKYrKauqa2rr6mnRpkOX7noKeuujr/6SQhk5BSUdOnXr1S8US+UamlraQpUdWT17z+F0uT1ey8fXz9/hdLk9Xh9fP//I6tn7hgVQgMSi5lA4EoXB4uDi4UPhSBQaCxsHFw8fkFjUHL02dWT17H0Gk8XmcHHz8PLxM5gsNoeLm4eXjz+yevbdciTKQiptrPMcTpfbI171+flbtqNc8bTxhVTaWOfVInXbTdt1dOnWo1eftn+vvffZt370q9Xu9K9Fq9Zt23fs3LVb9x4NTS1tHZ1d3Z2e8XwnZ1d3T29fPy/efPjy3U/Db3/89d/SaGPn4OTDp2+//o1mq93D08vb/5w7lS6Kk7TaaPdiM6qoI0aJy+hjiNdYxbqpuaW1rT3u6unr6Ozq7unt6+/qft7/dn88356ff2qnQZomk4q0TodUpnv6LFbr7f54vt7uj2FatuO87vN2BAQkFjWvUKrUGi1tHV09fYVSpdZoaevo6ukDEos647MAAYlFzRmm5XJ7vD7b8RvH9fF8/fj15x+QWNScLjKPh3GamDJtxqw54/xZZ59zbvOY12g8md+IUaPHjp84eeq06TMGhkbGJianpiezkOVJyanpmdm5eVmy5ciVe55B3vnkm39kMCYuISlHztx58wfD0XhGZlZ2Pkel1UVZ1U3b9To6u7p7Sm/t69e/1e5U3dKrm35RVnXTdn3tlpV0kdWz91Q6k8Xh8vDy8VPpTBabi5uHl48/snr2Xg+pI6tn7zucLrfHy9vH18/f4XS5PV7ePr5+/pHVs+/6rOzI6tl7QRil0plsLk7yIUlzstw8efPlj6yeve+XKOkiq2fvHU6X2+P18fXzN0yr3eF0uT1eX2T17L0uzSAqiJKsqJpeECVZUak1Wp0eCBgEHAIaBhYOHnxBlGRF1WmCBYAAIkwo4wBEFM2wHCY8EDAoOAQkHLjw4AOIMKGMI6MAkABEmFDGAUSY0AzL8aLiklLSsmTLkStPPoAIE8o45B0BAYlFzSuUKrVGS1tHV09foVSpNVraOrp6+oDEos74LCFRQZRkRdV0giip1BqtTlb0QlF1NF09evXpF0RJVlRNl3oBYqCc7tCGAUzBQAFrOEAJd/iAAAUaLHiIkKFCgw4DlNOV7u94AAKIMKGMBxBhQtEMy/FIyCjoGNg4uHj48AOIMKEcA5YoC6m0sc4TUlm243ra+EjIqOgYmHjw4sMvpNLGOq+OElETUmljnRdSaWM7ruebmltaWduybceuPftCKm2s89R3pI6snr3vcLrcHi9vH18/f4fT5fZ4efv4+vlHVs++67MAEECECWUcgIiiGZbDhAdCOYzLw8vHDyDChDKOvEQABUgsai4hKSUtIytHrjz5AqGouISklLSMrBwgsag5Ag0CEouaRyBRaAwWNg4uHj4CiUJjsLBxcPHwAYlFnclXxuaGadmO6/kM03K5PV6f7fiN4/p4vn78+vNvmJbtuJ5vfZGYQQlFMyyHPq6444k3fOALhcbgDwUq1GjRY8SMFRt2HAARJqTSYrmf5nU/7/ejhTY66KI7PQn0pg996U+SkAw5CpTooJNueumPufbjvO5ihUQGYRQnaZYLwiiVzmRzcZIPSZqT5ebJmy9/EEZxkmZ5zHsVkRViyqW2HmLKpW7arg8Nj4yKjhU7Ttx48UNMudTWZa8JCEgsap7BZLE5XNw8vHz8DCaLzeHi5uHl4wckFnXmRRWlIaZcautCTFXdtF0uvZCwqLiEpBy58uSHmHKprWdbFkABEouaQ+FIFAaLg4uHD4UjUWgsbBxcPHxAYlFzdElCZBBGcZJm+SCM4iSVzmRzeSVlFXUNbR1dPX36gzCKkzSXxWeVVhdlVTdt1yvKqtXudHt10y9N29P19unbr39RVnXTdn3tS5R0kdWz9xaWVtY2tnbs2rNvMJqaW1haWdvY2kVWz97r0qxUF2VVN23XL8qqblrtTrfXNzI2MbewtrG1s2e/KKu6aXtdUc37mGuf+74x13U/77fPb2Rsam5haceuPftjrn3u+/tKBYAEIMKEMg4gwoRmWI5nMFlsDhc3Dy8fP4AIE8o45AldR1bP3lcoVWqNlraOrp6+QqlSa7S0dXT19COrZ98tRxKU052Gppa2jtCVevr0q9QaSSt0sqIH5XQ/WCJqQiptrPNCKm1sx/V8h9Pl9nh5+/j6+QuptLHOU4fUkdWz9x1Ol9vj5e3j6+fvcLrcHi9vH18//8jq2Xc3KkBAYlFzBEnRDIs4XB6fICmaYTlcHh+QWNScVqqIrBBTLrX1EFMuddN2faPZane6unt6+/pDTLnU1mWl2Zgdxmle1m0/jNO8rNab7W6flJySnpGdk5uXL/8wTvOy7rb5rLHZYZzmZd12wzit1pvtbl72Y1l3tt09e/ftH8ZpXtZtn3uPZvbGXPvc98dc+9zP+/2j45NT07Nmz5k7b/6Ya5/7vr00O/fHed3P+/2P87qf1/vz/f2LikvKK6prauvq1T/O637e3/eNKjuyevaeYVq24yqP1+c3TMt2XI/X54+snr1vVEkXWT17T6UzWRwuDy8fP5XOZLG5uHl4+fgjq2fv9dQMkMFksTlcHp8gKZphsTlcHp8gKZphsTlcHh9AhAnlGBULAAFEmFDGAYgommE5THiKZhALHCY8EofLw8vHj4wCQAIQYUIZBxBhQjMsxyOQKDQGCxsHFw8fACEYQTEcMiZpiCmX2voQUy5V3bRdb2BoZGxiam5lY8++haWVtY2tnX2BABBAhAllHICIohmWw4QvKi4tr6isU7defQARJpRx5KASURNSaWOdF1JpYzuu5zOYLDaHi5uHl4+fICmaYTmeekInDTHlUlsfYsqlqpu26wMCg4JDQsOjYuLFDwRD4Ug0LlakJjiECVUN29OkaEgsecFVpeaJZ1545Y13Zr744Y8HHnnmlXc++cVfp33u3/bjvJ3Pv31w2iyuH5bvP0UUVXSxxZdYcqmllV5GoUxlKVs5yqO8y28KDQISi5oHJBaljXU+ITEpOSU1PSsnX/5EMpXOZPNyOipRFlJpY50npLJsx/W08ZuaW9s7Ovv07ddfSKWNdV59nhgDEkGhMVgc5AOOQKLQGCwOj0JjYGJh4+DiJnwAhGAESdGECU1XUlZV19TW1ZORlVdUVlXX1NbVV1XXqFmrdp1Cj179QrFUrqGppa2KZWxumJbtuJ7PMC2X2+P12Y7f5fZYXuOzHb91Pr5+/Przbz0qIivElEttPcSUS920Xa9QqtQaLW0dXT19QZRkRdV02RgQkFjUPCCxKG2s8w2NTc0tre1dPf36d3R2dff09vULFKUhplxq60JMVd20XS790PDo+MTknLnz5oeYcqmtZw0LDJTTHZTTs/cPj0+fv3j56vWbt+/eePOtt9959733vTbbx1z73PePufa57uf9/oXFpeWV1fWtnX37Nza3tnd29/avQiGRQRjFSZrlgjBKpTPZXJzkU+lMlA25OMnHlJObJ2++/DHz1LWNdQ4XNw8vH+tv7BycXNw8vHz8XNw8ePLizYcv344/g8liczhdbscLWZ6UnJqemZ2bFxMbn5icmp6ZnZufmp4xc9bsOUOevPmD4Wg8IzMrO39U8z7m2ue+b8x13c/77fMvLa+ub2zu2btv/5hrn/v+/gHN7I259rnvj7n2uZ/3+x1Ol9vj5e3j6+dvmJbtuJ5vP6G3j7n2ue8fc+1z3c/7/QeHR8cnp+dXN/fuH46n8+V6d7sKPYAAIkwo4wBEFM2wHCY8RTOIBQ4THonD5eHl40caFgASgAgTyjiACBOaYTkeQBQnSIpmWI7BZLE5XB4fuSZJQ0y51NaHmHKp6qbtegCEYATFKYbHJ0iKZliOr1KNzQ7jNC/rthvGabXebHfzsl+tN9N27OZlP9fO7p69+/bPNSwRNSGVNtZ5IZU2tuN6vpCqbpiW7biew+lye7w+v3ptto+59rnvH3Ptc93P+/0CoUgskcpVGj19hVKl1mh1+quUKAuptLHOE1JZtuN62viW7ShXPG18NY/Xx9fPXx0FBsrpDsrp2fsXL1+9fvPW2++8+977D49Pzy+vb+/8dThAZWFwBBKFzuKS0WXEnBzHlhOJJz8kiMERSByc3Lz8xIUrN+48+fDnlTa3JCuq1eH22VSpRcWl3uDVytrJ2cXVzV328vFzcHR2dff05dezOTRiNl8s15qdfu0GTTMVrTtUdu+TSKWz+WK5Wqs3oqmlraNH736lE5qgnO5BOdWz9w8ePnr85OnzV2/ee//h8en55fXdWxWK0hBTLrV1Iaaqbtoul76qm9RGl0uf1en29Pb1Zw0rIivElEttPcSUS920XR9imhdlVTdt12i22p1ur59dExCQWNQ8ILEobazzBqPJbLHaXR4/f4fT5fZ4fX7uvg/VZ6u/6h/OEsg0Joc3YFxIpY11PaUNWTgWL+Ri4nMlWUWWDc9JHaQTpPbU8UErjaIQgX9SJPGO8DfRNkN0M3v8q6cWr4P5IR6u67vhB5dgm0cP9m/WvXN9xG3ka4fOjp1wbSw2W7Ib0ssOdZm/fK3RsQkrGzEUpyXycMFOgJ4G4RWwCTFbXbMkAOpPB/MhjXREqEeZXmm4UJiFCKbqMz0UggquqZVppTYe6KD9aE61S5AApU5f7GY994csQuUQd0+z3Fv5k7il0hBOYI8sPfXh/VH8EGOyVn55+OHHgIzwKUkA1O9PvpcQD6ASRyN7fyDiJNuS5ZFchmZzdzu1u5Uyc4/vTot3MjwM6J/0LUz198GrblTerKSpUT1oT8bGgoNwzDTjBUtOGOzkcD+W+I/elbPYzNv27kiEvlzRvbDoNKfzgrCefHyYc0QXQAmrNSFEsiBDpMuFY+GrOkflInTangglRTkIHSFU1qRPH0rwZ9PJOwKFGl1+JeJ0NgAfCSOJoipp3Cqg+PO4ECi/WodzAmpFfYVvBPjj0yNzB50/+JBXskUVnb2SJYuSD5Ffq+NfyAXKL7r0fGTGoE8DfuEr769QCYQoiuFvI4ekNIUknO55R/gZ+XUpA0byPC1mQeh0XnZdyotZdaBcyBHCaTjttQlbSoPOdxskSZH2JYTwke9g8JlyU0ynFsEz9QV1GVyHPAEKce1OulPTf2eabL5CCOj6OjN7KledIu7+ngD3d6DyHUu+g7HxKd/X5fs8HakCRMsGDlf59/EFPZnVJiS08y/hBLqLnNDp1oQwTCDnLtJ6oRHKf0b3Ca4SU/iCYKZIBSm2mbd3WotlMrgTviaH+x8tIV579KtwVu0LjUn2cPDf7Lt6PydKlTUVeTk/HvkG3aRwF9vS5QC8Xx2OSpF3s3iqo6f+DeP/3j/DbNjuT2qpJDLP1VltJ8XMdGNxufHqLOJZbpztx5lvF/+GmVqIxk/KTAR6d0re8bXI7vIrVWsp7Fpn6VoitNN95tzq8yRBda3TpA3lMw2Y1O5P91OybPVmyMkiT4tYiws6fnEsCKh8OONRTqMb46BtTRKuiDwly9f62QCQQwOcWDrBlrkuBsPB6Uvby0je+MrXZRn9FJO6Qnh0LCaBhi2cLgGXXlg627F8t4H7u8wAdSWjy8cjZMBIvieWGDBIf0akbc2YxZpimvx08u7iBURIf8ZX7CCN4wFtgy4e/fzoISsoqTTe5vHDPJt18wd/TpIZV94JvZlm1atZmZxn667oEvP6SyCEJxvf0clVr4uRiPo6II/mlimXCS6O0nRoqNK7gwrYgGYd/0GcZDNAovTIRzm5KpVBDHL5oTseUQbX6SayMG5hIlvn98jVUxwgspnvTEa94RSeCsuv4wwkhK/LFxn6ld+eztNdEh8xc//aslXEXIz6pBezCi8EnKQ7cWWxZJXhsj/hu5vpEYfCI0ZtVu6lvABc9cM4GS0oC5tlFMst7mKUcyXWKjgzBW6qBbPXKjT5m9SGObjd/Xcb1XWgnUYbWfiAN2LzauPC+OSIwccynOGkk5FhjTYUc4AMGYvhdjUTHMzgcATkrCx2GiwxMFw2A5/xM4Guxud8EfGOvwmZ8eq73FbzUjS7rKYY1nHKis3ZLlAEEPvzjkER19dmhwJDFCHuoDLX1JgfweUwk0uT1hHRaOa4P2x2mpSZ15Muxn13WDDOQ2GjEmPOPpZnRsyCPlhBvpvZ1iZv0GKznV6L18Fjsfx3yWiZIJQxvSH+VEtQwh6xGfNLupjnxxKzsxF7cVjViKKdMIsRs8RJbahjotbQ0fHYYa2snhArsuYwa/PeH+ZHIkZp5aXL8pxg9mrWPtLZp3bQcdgx1tdZbM6GXwdKwi0hRrT6G2Iu4196Y5ioT/L+0wCVkvoF1VMwkw190RvC1hkFDtFof/JZ0CGryTELWNJvuGBHpKfRffMEGxw1ioFLQD+jLtOtD8ZymYUZYj5PVeg6jc6Pzt/NqSpjibsM3rZdb7/DyRSTFCH1z7HfaOAAErg7oupA60HYUrk1xPMn0KbZKiTYB3x+EG4Ntae3eIMkmr6uK4CmBcObD+gjvR6EA+m2hliNFP9m4aD7lc8PwmMw1AMtG+LLpJ2wvy5uO5Bv8EqAuruzGfOP+sYDeoitXHWc9ndeEbY9RPUO2JFWv3L3E40LiBGND9vzRgoNaKqg6yiSPT00XTiEdK+2A7qlpzzCsqTrmD51E8vNCxcO0ykPNoy/JND9EIaZ62jQ6lnDaJTAYT3vfOKP3a9pDHf7/Mn3/ScMxjksj/S3nQ+8PKJjgMBxNIPkuAf5juFOVDKVmEg4N2SSmN4fgVsR+Uafg7nuBE/adc/zroy/88LWv3dhPPYHNnVbD9+7iHRe2Pr3OeJ6NzdJnBe2PgfEhdi6cU7vNlBbajbv7iKBEZCbEZpNV/N/0az9Ha7qHnzVthX+0HM2SA9xkN7bu20sKX78kMd7ccjzGB2RC0hMLVjkBFydIqiECkBHKirZzsUEL4t5gZ+93vN6EFoQeE71Dy1WMc17DmIUHww4OSqGb7wGBYEhjHX5c78vlbm1oy9miYxmSLfVRr7+J9PG4a3WFeR8MJdCrifSH8Jc2b4eOpqt/zPcy6i5TSn/Z1qUcMYp06GQD8SSuuj4jftV2Om57VavpWROoBaScEWTHgr8UHqSkmU398Y+9Qc4B5d5Q5pSbco5mGdO+Ga1/bLad45FwT+k2sLb2lzHn4XTKi/o3WgfhgVb/OX7/vnd55LlgjK4z+DTFR8RAxfUixnybvlSECaPZoB++NauZsF2d9XQSVDPmM7DDcxeSw4YBfjJcTCGEdLwyOX8NtPhnPYytWaMqgqPAn6ox9SP4BGh1OlADo9e9tSiKK1Mk4s2nNmsJ8BgPtu/y8+Ctx6X5E4H8ytzx2iGuCTfcKBmR8LpsPVWDLW8Yde8md+dcwovUzECqB3BUSjL8v2lT2prsBf7J1dpSoNQQKiRHLsY7m51PoAu3YytdLjqNbBGbFw47S8NJ7X4FRXvka2nlp0mfndJLcYtlQny5QwrxWoMNCRXVnIq7uO/8amkfICTtuGy7SV+6HK146JLi82nzLhM9qeeWkhN/lrotCYAnQd6x2J051CqRqWjUmBlU4KVLTSCzN2RE5JwakZGf81nsGTK6ByU96UZbyvvutTM+OnTmgB/mxqCuqovbf4/wXioVygf0GDtSVEbi+Ek1HkBmoUuO9aL2CD+w1XPizRAQ7KOTiOF//KUfKkmJPqx//8EhC8d/7CzNpsjSJocZsl1g2tuecYzL7wVlPfKhKfCV3vSrFN8uv1wxC9/IZtMY7kemyz3JoFx1BLnRBmIS6INxj0MQ/FKoh/xSbKf8U+qX1mbNL+zPplGkaDkGENCkm8cCQ/fJLI9RaaRyJSaRXZHZB6JSaW/yMHURws5Nlujh9zL4WDyPsfim0/pyYr0ZyBr82+Gsi4vM5v1+T9/E1EtNCORNUCpyJ6aVTkHalN2EmpXbhJrX/UkFV39pNS1hjlaQi2SXnJdM9DYxmVDE5qQ6SaWlZmyy86WZjc7W5tbbraVV152Vtii7GpJSzLfspZloRWtiGa8NyuzMvZlVdbF/tyUW+IIxYjj+OylPs5PKutiZUP3GqQLLG5T1u6zFHULDTR0KwOMdNsFVU4+vrRqzb/vQs3mk/u/Nue7e1zz+aGe1r78aAdH5md7OCG/29es/OkA5+X/DnMBQLltLgQkF+kSIHI7XYGh3B6LMbHUUkxd4zrM3OUuLNztHizd536sPeFJbL3N24B7h3dj76M+N1q++CrHyNde/Qh94zWOWRN7L97PwPL7AvRtTPdzxneI9PAwYi7VEqCjCKMrKKEMsMQ7taYfPJ6G0jO0QJvoRJw6keROpLkL2Xu5/esPrP/prunp3JTHNybxG5P0jUn+xlT4xqR8Y1K/frQ2apt8GBEDJx+j7vkYLjzGznO52T1h8MpjPXIXvPn42LYF3ntybQ6BW09D3vudvBk+e36GRMA3RH+iv2n/dCFaFEAhbcyevtsbiVg9/RQahdg/Uy3m7WehWbirwH7ijiz0CvTz7eMGlgdl2FXhuUrtefdHcZ6fO9hiarKxK6WGJgq9QaAxxzI8qlnpyUypNTO3sDSKEqlopKesxK72dahjH+3+uHzWC97w9sdf+MYPfvEH/wtURWhVW7DCFKXYJSoVdX1PCNsU7C0aU13os5WGM299dfss+IUVKS9+Am0UvGuIwN2i7PVpGX5mjWOd3oE6v4LiJchWabs7S/a9dDh//jmlSp2vWtN/t68MLS3a19hy3waKDLcMWviFzZ9iOVkjumnjRwSWKJQpTsVEIeRBi/rTw/q7ftYvr6n/+cOwbbVHnzYrhumc93eRlgA1jFyhT9fGt8d5e/v0O0mS05VD747bKwLJhyolLwjyvZKhm3YaP6jdIzfM67bvhnldXtfzGxyGxIzfHR9/jB6ncGwGmUVn8kQ+Zc68deYD97zs2S/6Tj+yw7mT7qJNxmssBQkD8WrFZE9ntVyy2oqGlhFbJggx/X5BcUkpi+Wrnd+UntLy1H6dVThx/71GGWOCKebEqLUn5jcKCwsBain67GFfMuxqPF7drZ4Z4hU+eeDxRDwVz+mbNgXRdmEJEBDVZsCEDGfkyvPYW0VqfNWu17BfJpgTihAQCsIMmyM22TeCgxKRQRcoImRFuni1tQXKyr3UZbyP+o13UR1cbqTQz1bYFGz+moR7yspPalP23dNWpTZn/z1jdWoLpRZZk9pKmcXWprZRbol1qe1UWGp9ageVltnQupMqy20MWltsJpF7qE2w6xKvUm07NO7YkXHfZtVv7ULNI1Fm1vQT7Qap3aJEHsiuRB70Xq7mE2Lydxlw2JRDu3Khj/32aUmdZlbYTU3OxCyZRcRRAw5wQQ14oK40BCYA6gmKZ0j6/ZtDTXSetqNgiPGgy+6/EjoGFg7OcqrSvmSlVVZbY6111ttgYxCUQSFCyx7P/oktoamojVePMKFhBgQaCsIIEbwVPXz2vB2+upkyy+ajWHVW14HLBamiTqBTbq6zYwj4GrT03PVUo1nYwH1c02un602knbZxMXTQSQ8DDPKN7/np6gzx+zXMCN3Rn2uklU5cp4h/0ePgXCnYDlWqLPSgPe3p5GoKk2DI8BtRy/LRWEkVtX1nz882zfsjyRlVqkzKyMFEg3BjdsjzHgK2hGkeyrCRgwYLDfQRsgK79ZsL1YvPLz1qxbOHS/JuTnFfolKQVC1BQg9EwUMppm5DxcNexEDwPFT8/XlEP5FUEQI197iLvZVO1FepWakFqBdQVEgFJoQH3kpzcYOQAJiYW0EfiQECGnP4+rstw48LmIqwDnBYD1UhwtKFXxvrRhE0p3pDBlNb5JvlBphwi8Xpc+Jdh5vKhbQ/+XoLiVrhV8qsh4u/ACr8sG0+JHE0ThB372smjK2KOEu9lJcneCmZXLULNp+qeHb+g5+M7pjXqTntxPwdHoQ4BaIP4xn5D38Cp/mcjtNORpF0dlLW1RdCWTeJjgzFy7aKOUtfTrOHKIEvxV5Yi4KHXMkUvS84M5sylUeCqo9MVag7XUk3Ka8VxtC6vec9KlMj5EF+fMRTWV3VyhLN750y5qp9xbM4PXCyixbX8NUQl5+ee70Lz5TpWzCFU4d/o3hEwQzvnEwDV5uzy8R0ryLg0ESfZUg4zLMDjsJB8IUsUAbL/+KIZqyilOFh8ph/p0dR7FXBQa11DSDwPrroZw0NYCej/Y+YhQBprPC4AMhpAvCkqQkwMUqPZQ/TkzTo65fmyuaNQl49GIj/PsE6UcD5EuHhAhh5FFAjfsIIp4zjm7baz9+/bNA36ZO8XSzMnM27Tbtzna8ZBIhCHBBnlmg5lm8lVm4V1tS6s45tT+9QZCGPkKc2b4u2Yht2Yg/tgx1kh7na3v/wBC/wDp/CCHeY8ctrsilNyFf9f8/B+1fdclU7utGRsJ9+82vxaPHykP0f/P8BYAgooIYGVyecSI5v0FKdP3wBtY30zfqCBo2dzaubtsAA3V9csAzLs+IrrrZO0ZOvLtPQL/wYz/EWH/uevCSBaVDWfRHw/3tX/UXuNj9981oMOTHwf4Eg8276fY65nXz3zdfXP/0fmyZEhFRoC1Hrf6xlt8UMC6xtphlWNM1yX56+mAl++OKdiTcvLiS04seHBzcu7KgRYowKzL+/7uqgnWaNavVGrz/Xng7P5sfKW0tUyGDIF+z5UvNZi8+WMyQSqfKyqdleQvhoDucKcbeOX1Gd11H5R6HqSdMIPE2gmNiBurh4xCLEljexOFRL2klvejhm62njPLLM7mjHxHpt3Jv7uA/WBn9MboDtbWQjz9rEH56L/68mbL6O/yw58ex589zZnO8JF3vAr96L93sZ2de+Nqqf/RyjtUnok8joQhhTVoylp2ccoxnNuMY0lvFMaDITmMKUJjOt6UxhRjOayqxmNbX5zGcaK1jBtFZyjOmc7LTY8mpS/3iEbRXFdkYyku2NYlQ7GMMYdjKWsexsHOPaxYQmtJvpTGd3c5rTHpa2tD1tbGN72dwWsff15JOhlX1fTHHxDvu51W32d6e7HOh+DzjYwx5xqCc96XDPetYRF89jqxwpmOrL/Ik4aky3IrkSTrGujeK0Mf3G5EHEOW2Gj/uMi8Y911e+gNaN36+Sb2MC73nfc/5p44Vx3U3kQ3jT4/FEq2X8GKJbtQL8Ryaib6gPjWQkE5vBRJq2+x7tj+LvVp1RyC+3eaePMwtv4l/Qk88CoMTuBI6uD/OdKrCqr7uJkB4S9GxTa4fpK5/SEkr7vNEV1frllZCSkVNQUlGLG3NjJubrzWwix5wsLKJFVKuMwoz7fybOyXHd/27Jc8dtd933QL6HHnnisaeeeeGVl157642PPvjk8ylVsRKSOtKqQ/aL0bUIHdC5Mq2Qe1aswa0quVJGt7BKqhhiSdRtAnC9947YIr2iYFdlFanHopNa4ZY45lKswnrLdtVu2I1bsWt19WyLTODC2JzyTr9Pl0+T54IJZNwRh091p6ZTv3SnHPWPrOJSZReWIXD2xJSYRjP7Gm2vk13fKfFOd0M7fSePDxK7rDyQxjpq3LVTv+SyG7J+An0xkr2cFSavK1jso1yOi+zH4iYRRrX8NsvS6p6dKBY1yWsfHR+OzKf7+bkJ+5BtvmR0kI3LNi2UUVQTM2exbEMSOEf7IAKZM6/k6fTtceUQxJ99r8Dbf/B//5bq7ZPn+RPX72GF9GdPhvjfDCPUc5kZa4m/Ey/STSAouIpEjsWqIiMW4K8S+dO0jj9e+nlPdfaWHHrw2VuxJv0N/N3ed6DVrNr1qdfvisxZiguuhb3DStrW3XKRX6uwQvolfogtw8Edya690i7JZRBU6wKS+0CIo7MMLStyogcF4kK0kNrzlMlRqdbGWiUVFQXFqnossqwciNjbjGkdZwFl0ZfIT/YkEJJb77/XPW/7I0Xe92HPxAP1olZNQR/6Tpo/lt02x9NK0lAxgaFElGMIR9oc+M1EsmpFqkkF5amiQXSz1tH8nwjVOTdFHTT1Q5dfmMnJmEK9u21xJ9Z0M2RsCQVyye2jQIjG07LEAqs8GjzZxl5ZjRBTDoqZ7vxnxxHNcb4BmLUgLg6m9eRM+Ku3RqzettjCY2adV34Tuy3ns8pBV3T1RpS/g+S0iDvwB/DYPBBwVSEcR+CfCHValnd6FZC+cPxTIq1Cvj3yWTSdXq2PtfLDiQ5X3/dvD59zxvY02T5mRvBy7AR+Aql0DFwHM8rgsvsC3hGkWwE5JjcDN0DxHaZfoLJwsnKlf5MxNMI4i7dqpauRHvDMDHqai/bWzECSjiTicaJIr08ACdfy2OuRZ5AcejrJ0U6UhUMglb+ji3UWeHXpixwPNviv4umKVkyZkRQVM2ZakFxjpNA4KTVBKk2SWlOk0QzSaibpNGvPHgXzKqri7ZHfD9ekb+9g3fH7DR155O+rH3TsRv5/R/dc49vH1jiD3shMzIJZMjOzw+wyK2bNYqKVQ6KxUePo7MCoQCt7avXokpGHbjq/YcH13j2t7nHFO4IRBuxJ3JKLYf9UaUZubPHp4XTL41OWMev9XR0cnaDSX9PKKfGor95Zyy3OWYHVkytOJX1J5L8A4PGZbOXTmA/s/XJONBg72yRetNU9dsH6QvO6qUs2S1hZu/bSK2YWbq+hVhGx9InHXqdfRnEbEX5mLqqXJjddRsnO3pZnX5PIGcKCwMJYPj0tFcu0SUCTrs+PclNDLWeB4mA3WW/5RcS4VO/7n2yzuTR+I2826qLopimkJWdThqBzFYoyRDJ+y/gMTGEh5IqLockUdcQVPhL5m1GgzxRZhrhlHmeZGsjwYi3cMqCQknqSlUEDTYnIyRKtgsyjIXTA9v5enIy14+qjfIuBh0xd5rQpzVb6kbuQJs0dABSC4cr3ZDYQRPdS/MnXaMSag3i27mkS/gWFKPP6xs41l2rTaCSZ3Lr88MmQxzcZrv+Jw3V023yktACCFn/hUH7PHKhHo3XexKwoHPn0Ww/M3mB9Wt/cf+Lnkteu7Mp3JW88jZvGtd7MdM12FoVqbqTxEiJ3y2Lm1mt18w1MsCVx+X2ZTUGO6Um04B+L0WVhBBCf9jeyZaxz1K32z3jt4rrAwPsgssa6lRJHIQZsfuhn3l2dEMbumdzM+el4Prr84zKD0jO82NxPyt7Vy/j0cyHvBTWGtCxRqr6V9mud2B+lrPmsnAgtUgqymiTXCZDXJIW4SENRk5Q6AcqatRX/FIoTVKmk1gVQp5JGtwCaVNLqAmhT3U57kNS6mLm9FFPoa5JBXGTA0iTDToCRphr3CRJ0AugUEnQG6BzQBaBLQFdg/9pZ0Z7a7OQYXWQLpmsDLjKIOU7Sg05cHerpEH+nKhGCSCGMVO1S8QF7+4McdMhRR54eHYNzZHCJDKLI4Gqn5KZD7jryAR2HZ+TwihzekcPHTslXh/x0DvlTpqKli96pOpLhUJP3XjjdPXQLFr+UbLjJBFHu6PbgHQRGDTB8bXDTC8DXVwKM+z1glHczkA+eA8O82032TOgmY0D88egKqIuJZVonwQcDLWYnwLPogSIVGnwaBJlcUuIUIjQWmPcHTUYIbtbNuXvss7Qe+n8vH9N5xfMSEjyKtHntEiyYGXfGEU98PvNnPbFD5W2hOFjMOx4qM8bODkKuOe5SdDuso2uW+YQPTMknCigDjSlzcozUaYFQ2YUULA/3YsdOrvzU7CEuDehFBPKU3lORvJbi35SyNYeakKOEGrBu56J4pVQpk9t4RSzku7VrSQEpGRfChMbHmfWerLglGdFO5phLEpRCrtOw2542MSlKkiYzcSQ1c64AYsIKyiJCzS1FQHvHKBJPCgR5VsoScgWq4r4cTtRPjuNNLpYdtXPYws+6AE0wA42YAcQgl8Vh9FhLN4YaxuJEX+2cNI6E0tbypjTIKEmIxYMkxrsemRKS7I0pcCCxNchB2CQ/z6kV7bCltVKkAUKTERGIMxmXFUVmDr/MPA+IkkL1fEQiJEs6oGziDdfY6IMYsFTCiKWQupfkerYHMMx42ryiCtGlJRsIkB1zAIAYlsY9igPoEeiI+yjxiIaFBleMF4/xfL0sQFuPWbCDQsWeJvpCcaTM05fVb0ehaIrS6aLhxMeBNftZ9yrtsmwZsS6gNbS2fK9P5ZsApQmg6rvD0ABaXm5e6jSAvqVQGTFpb9skYl8mlhWWXqy6S0rclcV+mmfLCzYFFm9VBX1njFifW+pOXFA3dPna61KbFvKcyurJ++ddEUamiF1GmXTZA2rc2PKDxlYQavW+RGVSdbgm0CAhzbx7SrzyUaTgn+dUsMlUELelmqwMvGk6oNx+30q/kMrXBrRcGUdmC3tdzIMd8KeKKcSAhU8NrKx0aS1aHnHGaREKjDVYyqzumj8HvhMqwXgmulRdj3tU+cuiRdV40IvDafBDQQyN0iArOTB/tEZsQt7I4SlO3pN+ZnlEfzgZ0AWBHSkHvTP3NTEFm0TSicpEzSWGIabRtPEz45WWUOkUUYLijEbedwBRs/t3HGTZgjvGKBUYIxNxxW9TF0WKCfwCasHRQ4MkbeWlSSLMK6kQT5rCnELmcQkD2mOAppBC9xoHiYj+pLOAZn5VnYm+tUDCOCtxQhRKAM0r5xYzlJhJgiOZaQ0OldWxOlNX1AHqoOqS+8FgGAAwMRkBFEPxDGWoQQsUgGIS4cTJEpDYopzApB/ZfgCZAdqMxaW6DAwpyHwkBUu44j4qFyvgFmaSmhBDCRI/muqbDbbA8VA1ZFoKAVAClMHH5tZaMHPbjBNSYW8+V8QZHMEM7WVjGbRi8Mjll73+/W97Hd9MmzFtJVFCgibmdD0tmgHGHt58LKGIRBlCK7dQnlfeuhsewMjv2/HO/oyYx2k+bgOaZlFn3OwROMk9JHm9MPtj2Pt12+95Hob7fXk/6vLqPGWCmRdufWvqjAxqiYA6N3AABjvedouZyRQuoenSsi6564qGxj2IVRelVe3Oy9p59tyrY+iknBybQzG+eWbtDTOBACkBygio44T0OHFdYjiDXf7SnFvzzy/tMbKmqrC7NFnKsj2tGmoIuLlE7uCd2979qTn3EkaRfNiaaLqHEgaZBze5mHZh+3uYH7gHI/MmTn6//6QxP8OS/Sc/HN9doXwc1u7zRX9aV4+m6WXoB5GuKyIRYysPjJ/TNq02jpPuRWK0cbblRL7d5gR0Iv34xu7u5nuo6xjcl3AFZ/vw9UPAz0/mYlRdX/1S2dDdW4nRwgr5xrZoRsGATsWPMe1LVTv4+EIhUFWd0ALwIBl9K67pLiAqA1Y885YgQiFDUqsUc68jKlgsos58MKJoLAd4Iab9kj2Ll3NZL8VA5e4e9caeoP3YWb+1k2B59jfNdl5wcNmtVl1xp9vd/92tiJHu+mFgHspchhHniDee6Oc55xEV8uDE7QxZLKr71/xvJGrCQB/5aJwvQc0x4E2ISITh3TRPIpvydSMfRA/7NA0DLHtI9MvrYtGSTuU5BoGamKCCJsKcnFe9q1UQZ3NVnX3wnF6BHxmK17VcTDawr/AFsbOx73e58rTRxqntJU9dxCCCF5/hET58trD79Qln+/vHxxJQ4x+Ms8goW7OFLVxfwn3+dmyh/v443cen1nCFg3/9uhj9dRyvzsrDb7jGvFgPRHKUhjjzp70622aGpvk57ZPUtIjPs91hfeN9/qd8IXZPZNbf6zI+2araol9vttndKiLH3rc2ndF31tlwu/H4PWlnU44hjBoCNITezBBFkAL/4B+w1UEEpsxPLfHEF4bHSAukOUDEgQxNJBPeHMotcYQb9Vyg+Q4gv05MaSEIMNYKlUEdumP4AqfUmCtDRxp8wCUJHsQtojwU4eh8IOfSzgIzD8uN8+28sKpjmxzydtJUVRVlhw9g5ANnmaoqyk7cY0U/2JabzFlUNYrCTMyzc4e0VJw+0ateOF4FvChZZfFB4tUxdIoIbLVilf90HJ1KSVJHkOHiGFTtOSPFedqv3aL/gdAJ2YaAW7unGYsVNczjKyA/yM3KvAa3D1EKwhBBRN4Xn7Ucy9w/Wex9Z6/xurT5MH16V0fkDrmKcw6pBPqca0ELe/mtES5NUxz9mGX7t3rSen5UPGZp64mpWw1eKSHIKIdcUcEa79cCVVeC9wpH6t7/UxIhGSIJJJCsNK8kO807rTsFt5PdnWYUuOtU26mUWxFrndPqWivz5i3tnCTdNlyMsIoI0NopaLCiOk1G7kaVXLGI+MLD0wJuzNHQD9y9bbtu2qcuzLIzN3OTppSAFCZ1KfTzPJnqrDsXICat8WedQ6vKLT+O3EXheI+06tRdOsjNqsJNbnXk8oQ9lD4JS+BSTQueyHXdiUHkvjxf6ilv8KE2cZtS8t64bp3yzM6ttajS/zvWQKVFSrTgmazvKStxTeGD7df4g/eI4u3+NNXr61azS86/OuceXnVQt6tl97LgVk3OLY1f69KCnKdp3/3QTkP8mjC2mk2Lfty9NylhkiO85KMVLeHSM8zlqF13u336lAs4eYJTfTw2XfQ81yUMn2susn32CnSWb2tcY43crmvqppGIyB+Gdtrq8ygijzBvx1iH4Zb6Uq63yuSq+5ErWprm/u3L/F7CZFDKtLPCB4mUJpFPJkNzYFA5g/341Vb4aU94UoFOTTPqQ+WjCG8NN1U/iPSthPywt81Fp2FSHAdWjJYmw2QpAuvPY+3CLtK2RDQPmajahxj1wJUoE1RR8LKUuztqVNeKlB9XPG53bX4xUZFyuQ9XTb0TuBv3/60u6J735BL9jZ0IYb1XZXnA99u/lOiG+NyOUE+W97fPs7xJZx/NESbHXFCt+DyqRapiDcS4CLmwhyDLA8O6tun4TqS0F0fFkgg5mD5C/JjgIVDD65IAJZpJF6Mukk9egCjpkkkB2d5e0qR1U5DpIW4zRpDWZWZGLkhbcNuI6p51WG4hvqmpCcQJApjRUvx5D/FdDNvADtkjHd89rGvpERODtOGl1x7avlidoAWYhQeUIVnDqSXDc/sKhhKwkRnP6Qc61gHS+3Vn0Q5TPqBLlUXcMOm+RzShpHbE7FOaZF+uQEAGhEpAcrTh+Rmi1YBJXQH24H+OTcswrTiHu3Xr7GEwAYvYAQxKbeJgM3fXeQ4axbgeTbEsUjk3xwHEeTaTZrDWw2tGx43MW20mQJaDels8Rhwtpy61rM7pvpyQ/aSJw+uabvXlfhL2I4xvKs+FpTpps3SjPDhzOhHMCfpR/86+AdrR8e6wtLDf3Ook7eqaNq/1SF+ySWDqqa0DXY4TSrr1iAAb9FZjtFlcMmEUb7T4OAaqhz/vP1wDBu1nOV2Eqk8csjVkamAUont2XAuNGLpJ9LYHsD9YitsSI1SE4bBzGfcoHxQKLqeLgFYijkM+SYHSMmoJKd3CwhKlpurRIJ3i2cKpHOxg5zcIECKzBY5xu4IPOJg4GYrPEGPIUgG0bI7fMhdWhAKY7qkmTRAdpUCViZmE45e55CzGONgJz2uNHAzXCyH3olxSjC22LMdGJhu75YIOxAAWyvTfuuBqUjUj2DsFBnbiCg1hmFClaV+D9drRjM4I+PPdbh1OKyyXsYMBuByZSPeQQnyCOZDOLsRiKop4wL0hPNv9XwShJbphUoacUMoBZGEKueVgs4TNBJREAgR2roBYJS33cmxGQWQRUqglKgG2x0gBojuGbBx9hhEWng4nmW/2FuLPCgHmEs9B4r6SDJ2XU/eIMp9X2PByamLx262TVT/rukJc54+bwCCRdgmcKG3oYLOd6F1VAPLhExwmA83y8YrX95uCbIy1nawW+bx9oSW7uW5IhnCEGXdXzD5J9eBZPvwq09NMUGEmWw3eSp9+REaoQno8AJoylNXGSUG2VSqw4Lmr2lTi2SvRjkQKjdsAhKrD9q/uxnYAsUgW1kQWScyG3DDsfLN75XBlstA3qc7a4XjG7DaQCXBojUVbGjNsXxOdfj5Tuy+2QVX0i6hq53JaevQ3vH3f9V5Bsmxbdq9mTNoKttSnYfcNrPtNOlcR24bkarOBZaH1W3tWlI+H1IOAksyXUchZThPjMN/6ohzSeH9KzZxGLR/OZkGAzR4etRFVH1/zGRWf9t3gzQR4iSqp98fugn+NySDOXqMOEZxfk2mYzIrHWjpAIBrgbxkei3WPOAK0Zse2zZpYfwe1D+uT25vCNTgb/SBy13cv0OjDgo5VqU9SRB1/5IyZoMpfcEYt9IeoUi+lWi7WmWBYpPM/OUd93UD/kyWWMcEJsFMcmc3+EBiTNum/XhnNKdQIaGGl76gKUPfciY4Yx8aRrJHNiAMC0ytpe0ACbGa6txBfXeqI3/W0fOGsko5bF/FvGlK5RkYMgcQU7pFIP8Oqw8ujAoM48N6OqROooXpV7YWFByjix8Q/ZpSsJ9GKklqLpCPgafGnM1NLdbLEkn2HeFm3gdeOM3kzvQeeVxzml/MeeyyoSj+HpTLkgTMj6wp7ipaOHcsXVU9TSq1IpL03HjJDUPibfT6K+tSbH4HZRTGr1FZHaTLvq6h13/FTH2SlBPo5VLU6ABr1dqPXgc1QYjKfP749bTmjPjDDaR/vMKceqR9WXMDyc2b5lTjHX/vqtpJOlRxm83UKoEc88slvc4BaMjX0zQpgBRCPvBZYoG8pAgTruy+UVuqcm4u1QX8SGW9DaqwYHls8yMKDfgJlledCo+mXfvqTni+m2Fq6lpKNnjJeR2aevr7+Fk31Pbqd2I7Dfn6nZBvplSoZiB6pMaI3YYyHIqWv1qUXboBSKthUhAZyPQjhQJc7G2mml8jaBjs0pG4Kg8pQX5RzeKlyZDI5Yez+jizm3CSOdysOKxO2ZqhEOsmnKygehb46NVwoo9zckEzxQzWTmdCHDWkFZkF60Sh5ina/ecD9BvXwIpPUnmTYOHjy3OIjM4uPWyIaNF2q9Ts2JDvvk6+rD4Llpyh4/VWgyBT7PZuJQnYW9QxCnv1PQ2Fh7bKW36hpp1DHkG8oJNzejX1HDoAQ33JRhjCU9ZtqOgicp+Wzl5JBwf3+KgCKCE0MU3QQiXlpXWUXj5Tf/QmQyBTgvigaSP1KGUfD1f79CihWGLJy7udVjYuNcey6JgCtjmTebuEGfgtUxt32/EsgjpZU4TBcSCtT2tpnDqXlfQYxthY39OqejMkfNwjqDubhCCUBHexhg5D4Y9K2ZdpZpWH2heopj1EFC33Yyfj1SgG2CtMRZcCQpsXIvB2kAJqVFTao/VQ6L7V68e8npnuiOaDXKiI1psJJpA09P0gghLrdzFdQ9i/9qGkjk1SUlGA2SS8f6A7G872PLOLlOuBCErRWkmZ5LIoMIYgFtsR+p1Tnlh6bIxiQa5gHuMwVzeD4GtLDVt/v8gTYf1FIQKyS1480HP8I5JFWLTut0YoD7rMyyO9ifesS6AUqwxWhUNvnXsspNPqpgAATejvOpNXZv7pk0kfqD5IY3MJoZNy50BZFQ5X7mNy2K4vXjxbwuCNgQHyLRrB5H5AUASaWQIdPas3OnmBjTSOH49+nAZFfOB/n1Up6qBoRRuI1Y6OUdyjFvmg6YGs0/tLxCVNePPkEiZcUHuCihR0cvmYjAdMEGCmIqT+oJESWBYmNMNSEAodjQk7BmYyFhyREsC4B7QX1g+yHlK+uWLZOyqbxS4USaa4S5EZ4rUBXEKdeMHPV0n1IO8vgzQw/8xSB3Wz6ZMF472UC6NOzx4QShFAZvOgzf5Y8kldhQeBSgTJER50I8+1M24nKbCYckhlXhaIAN+MSRl0aq3Um+aJiE4jo4OkdtAhMWJpPBu6xJTBiMwV23ifuIDjc7DP7Xp0s98YxSlAOWmkTFQ4wGn7KNiurjAGj9bI1dFzAOSqPHcc3oypz/RCojo8N4XETgl0XIt+brutaqz91qfVl2Fi45gvHtl7olps2sWmM1wm3hxXGzWRYi4oQCxgNuMYiTonFGLYFL5hd9VddKrILw7IsLN3qeCkq29AHO2ICp8PCV4AIOxipc4q9laEFkybytc33ijw1Tob+AXdm6w+/VnNBC7MeQBDjfLAYFH6nGBOfTlCRwSGz02T2UYyMcLrXvnF6iBphw0ySUo8hXOzlYC4G9kfnRNOkN2uhXjpMdIz3xP+EIGY9W5BB4szCybGCKxpEDG0Jy41ZxFsEdDLmppcwVb9t9h0/06EInBqLu2uWGEx/Vv/aI8PP7Vn+sobRLB9sJQXkTUvQgnatQ3a1x3CwZiuy67U66gcR4cJt8LEhhkzwi3zFSo3n8jRmBIiL7fWHSXVuMQdWetcpbn6JC7MoMqiqftwkXvm4Mk53dptBhTCQS3ndT2a6bHr9qC+7aTOsrth1XFOTWWcKMWcgMGJ4acj41QH0L1O5wAjXepgyz5edYZ0z9QlbgV/okRi7XUAedqeZIrMG21dRAdlwItqyD4LUpWjBrqN73rjfYztAEIWGFuInbXjmrnBQb2RcsdgTCAtA9qevaENXZ4jMcLuc6GWDftqBQIL5FND03oXMPzPiNNeaLApakC10kgn+Vj6vB8Y4oj9DvatGqNPlfJncPNA9miRFOFsRJ6pSoMYWSLwFij+zcKIIUnFCSWFJ68EH6aDPwzYTv6TlXYhUgA6cvLJ7PqCENZuv9CocuDe5nwWyx3vJ7zvq/GzcJQhM5dcH/AA5KoW/c8hwfZugGGZemyXBhmZKAcpiFQ4stxvfTTmCuU1K801UhvLP4oHcgH65bykANCOFEFPgqVBq8pycO47ZYAmEzrzCtPSbZaTpJfW66pKP0kxoBr3dn5WEBo2KDTo8Vg6JpZIanDhGAXmkpjgf55jrzR3BbLb1L5bN2XKoe5/Hi/CKE2BZdkMMjXkIEsjClZGmn3T3VEu0a6mnTwD+HRJWtbtFx8wBcgJsBGfBb+DNJ+smsKkecloWGKTJZj3klQ7YcVk7h1bJiXj3qBaId44EhxNwwtjwsMXhr6j0fEZnn3WaLz5FFJ4szeBD6ItvCAErlu+Y8cCzP/5hqIaTb5phlybxMxYF2kkn8mMt3HjvA27j87tU7E6dNcGjVeccFps1P5Dke2b/cws0B2agp9y4ViqreWZwXW06d/VV0LxvTAUmhPBmsOtgzJR1I2Ld1IpJmcjUeTvW6r1zIAIMwwGs7vZ/CsNhqmqRRMy+NyfdSGB4wmzPzs589aXcyQ7kDKfghWKQGKgrX1IlcRlaq8+wqh1q7hH9hEn/0K5VfAMCzUwCoTE4uQ01awkZ8WcLgjoLHXQRO9o8acgpwrDRDml5KbqmRHNU417GkNyTkEOaM6itV8+Mu74Jx/JX18Cxfa8i20SnleRjg6ZnTwDbeOwFhCS50pGcQzcjRfWrG8K0pAYw9DrZLWdqwTaPUfpTndRfDjwKbTm6whTb60t62/c2b5Tt8rhRT1mTOGimFeI83K/5kAaMKmDAQRJmlqZaRzxgo8Iux4xXT4gWSXtRRoXiwvXUy7clrhy+T5D/HYUR+tSJy1Y9S4wQolAeWKuXz1AydViqsu3O1UoCdxIIY1mW6UcJygLlaNWbM9dhqwslienuI5wKiJlmRqTopUKPJ+dKsrzOiBX23XjOkWG+bT6XJkWGospUoFYUO0O3pRpZplGiFOcDWwjHANUZ20mT92gnEoO0U/YFKTYlxTBOtywVVXR0IhVl215yt3syPU8UimN9dq0WuKkVaeqays05B1nDSa6m3auJgwolvBazm+wPzdYIUZ+S7PyyzHSM+/yE6Tjwzs9gbqsBNsiIyZrAUpTWurGhMysSux+VX4wLGyelufa93aaCBQFz6zfGw8TWSbyisT9QQ43vzRkE786rXN3t3/mvdMXPSNWISas1CwUzUCzEIIEuZTtan4jrc19iAohVCJvOS+7fcN13YKrLrvCkVJt3sqzvhY1uyrDtVc9QD77x1tYmKV63SYgGoe1miqahiP1JCxmmeaRvW0Bwr7xZxHIBehWXlH5jzy2lm0KrOviggllIrKq02Mu92TmofZHUYnYgLtcg5EoHI26UrOGSVjsuVgfHsBzBcXzNvwS0gsrNpOXbBUjrmug7fm3mrOWPflNAnMQtlDvfDxjPC2l8meUpfJHsUk8FtpLmWPa7AhlY98CWe1sB0OGEew0x//yddf667jkiBFWn+gixZ1vZRhdZMDksazxjjZ0eE9hSWzStWm0m52cZHN0MSkOq6mxNnA4IOxYfEqbU+TnSgPEISfoZLU8M1MNjRdFhBwqRwFIDf8cvaTbUQuwtQ4QvOn4CWdViky2goy27MVifmgXHBWb1Y/MS8az9xbB9dSX1JkBUC2Y+lfLXhtsY3ggY36hWH/VL3zcSMcmmy8tRdsH1wP5uSQQSm6jAbXPu5U4b0AHjvUeV0R8gsIIpSJFuJzAy8F77Bc/AFqjoGnZmnvLNQFFScaspw+AdlXhZQNUrFUiI7kptVId5WniLS2BPuRy4jmaXkrDAtafN+M5KRP+kfnNzCuDXinTLlood9L28JH9MytWQR/eAnsD5m9PlduRYlqJts3ufYRFPR52+R5aDpP8dlHHqw9l2Kx+kcDyi5Zo9/uhDoOD2er12cesNqX6GUjKjsL8RIeos88kruONapgtqimSAAUcSzbQQ209e5qJijwxaAoKK7xiBgEIXw7UEZGrhpoJQ+9Y9dA/yuPs+EOBMHX8/hovzTDO5TKmsZKSTa+dBPMruN1D+FavMy/qtVZDtX8KLvr223xcfQtWpRZazpvhoYysM7o2mJhW7gjfHRL/qs771vElG98gFmI/CtBo0xGwrwT0t5GjBnxew4V4HOkVWn/Ro89Yy5OWiu67dDdbwvIJaqk8+/h5GeA/qVsmXcopLlwm9bCNIWMfUtVwjQVBnIYIoLmZGTpDf4DPQZ6Puzq+gE2biBSVc6r/e0rrcc+dG38q+m6MqW7e5UDB6X/LLZ8WhZdqOK5/EmLNVSaXglKJPZtjuw6TDhKu2/9dqZNOMcG9JM7jVHiIvNarmcnLur6AGwAq+Hlm0PuFxNBxhmSOnWu6cjqPaObykeULnuAIsdFneNeFwxCh7Oyy1a+mGk9z6IoDyDY8A1d/2HAI+VzHCoENSX/SEOgOP6uiTfntl2ecPdWkU0yN5tU9qmHTDgF515ktXWa1LrYjOsO+vaWFoIP7A7NR3/TEM3SDZUTRlyHcq0VsFXiG+u7czHX2Z8M6e9hamJRpdw62kGjG/sDfCz8F7/GJaRcYeDOF0y/HPDTE9FHVUdPGD7P3olKhMxr8fhgS/kMXAZgRfNsvsTwC97bWPhW2PSpFSLp64YU43ub8pwD47NyVT9UcG4yzsrbna0QoJnzoE+Zy5zNc8BRzZtNnUm5NUrsQfvdQ+qJ9dVbpoh35o5eu6Hduk31g6S+4X7CifF3d/WAfhw+iQi9Ga5MRHEnERUPGpLoodgYyG65PlIeUISlaIIJMuifd0lAB95dQgrSosPiP5aCOUqD9KcdDkfbfWvdfqN6Pgb+bPHS2DUAP+WWUyZ/X+d0ylqq6fQ/hHRbqxnOnWp9A4jJh6szZMJt5c+sd/ezVcVUkSLMW8FMF/YZS9BBrxtRxkC3/dt6Cw4efg/4DBfuF7P5KK+lzLL43+SpkvSvdR77WzaZOC/ULYDbxyNG5AfqmTq9QP3AEH0X1EJGdHVnLhx5PyQ1PX6fWE+UDWkn6lHMk30UAiBtgv5T7lAVhYutFYN4yIq2qA2DqqtSYlBgO6DWDPVJxmJ6gSr7iwV8i4Il1Mi1UyUXWpiuilyCXxqQvJAZXBTTTjW3KE0VJrIrBCMaVk1vhslCV/3FiaD3mTvZm+v2PwSmu694/fhOCNjwO4d9Nmon8JXQHRpvZx38Yv5O8YJtLPekpvNOBwPUHp0RY9oA2zEWpaxYerZu6DVgB8igDPdpD1VbbZcPC6m2W3yiqhztf9jFU0lUfaMtE68LTSgV2eA2832JgOu3l4iLAjbD1r3b9p3E2DLW8lGOQ7Dh1m29XotOOgZgt3q+vuFuxKpOt6MXsPK3gCmtwR+uZ0uUyG+SCUDjHqIEKOMG2+SECldVf5nlP1f5qXIAvgam5kDcEpflguPqV3Zaqg9Rdxsv1BrwhW5HWbQwO5DzrJRzNhdXtVK+/wNGEKpELrWWiNDL31oX6eiico+cr7V2oty62RIHzf9ZG2CXxWL1uoa9ntRgFH6z4/RezBVTeG853rtTJeD6vuNWYA2e4bExZLOl8OB87v5efOKRBBjzEfhFc8hN60LpuwN+AoMoW6dr/d5BVGtLL7BwQaKJt7TGZ4/uWmQ/iUY+GjGAT10L62/5IOkXH7Xki9r1zLvmujnGtC1ck5fWj2qVQJT+K0MGsslK74IbX/IA6vqo95f3PBmsbn7LOREst82jydDlJAKKP1+Q5RUncBJFrI/krFO6B9D8SLv44eDAfiQQx8mvgw2l8Yrf1ptDxfqzvozS6DsmYLlwdEDUfc7JdZt2OGFD5cbtovUDzOabjAcOX9fkHzNcFLz3e5sDkM7Zdj4499w85nO9SCOtKfV7qxp3jV9mmFrT97iP7fSrQr27da3rHCyZI0SF3cVHVv75d+e5J2SMhE50gl5Lh7cH5vgn6yABrPFZ4WEu/Bu1706YiHgOtYj8DmxgCdewxiXT9xPQ6INpHSkRbaR+zFU3a6Uul38g0l+YLNQnOVDNCQLope9Etq74HVoNC5MVbduSG8Xnq+wPc0NhRGdPFW+qR0f5hn24Z5EoXudbB+qOjqDaVWkV3O7YgPl/WU5BpZd7tGCUaXdb5eOSHo5MTyriv3v2N8WX/VX+9TDfIIBq1szaZaJ5pWZRswgOlQpLVj36G2VTqL05/66gTMT882eX5FzndX/T/iFDjBUPF2lPDr8JbmsBvYTDqYdzIC0xHoTwhlafTDJQzxHnrxBinCciUo6b9FIHf8y4qdpNYzMik48lVrsaUF33GV8/KX/x2NJl9oeAu88zy/660Zb/4gXvLe+9JPo2MfgWHO79Yvbist1+J1uKOh+CIB6M8zWAr5+kQHy6BE1O7t4ri06OpB1w84DIvYyeE6yOgtk8mmwG/Oq46pcfzIQ4mzx/S4+EF99pSExTq7VCn4dE2lKfOM+KdvRSIBDJ4SxwnfFmE5m1/RvIjpThSBUjSjirY6MGs5vxJ3U6WO5+Z0tx89sowL5Jp9Bbcj66zS2fX3ZAb9GHsBUI/h9ZMvMlJ20GMR1Y1G21pMdwCfdXdj06WwGcshysNFUHn7v8JQ5wWtuI/Jk4V3IMLpq9WouBhlWLaBRINOB0++ozqMsoZHAOZcjfENKMGbbCIB2Z+uiJt8Uw33zgecf85cFJ2Kv2V++MIflPUNsQziWvZHpGRcyK+AtixSJIQKqM2qEd6LsZeysquH4fkJ2KcwjmT8MkjUqZ7LOBjuJk/M5IVDHw7Reu/FWTcJqap2c77aHTXUctMsNeas6t6oKwJ0IzJRCo9RIUoF4xdPa//Y9VPX2lGo6p03X6oyCZWwuGB5fmoNDSJ/1j2K630eBXDi+inaRW4k7JNqr6PisVoq3vx4JkRhFZIrVGcX4jNwA9HMSrl+TgRL3tUdmOBxBMlieLQJ1R5Doo0Nv8KX7ARV/zPUhFR2FX5zZ1aS3VJuZFopNrTIzPapZw+XWW0N29MJA2tQQzRWH6aDf2XBYmrXexGHQeIFDlH/5XdPJ257db0WVXQBW2uO8KM4KFZKFB4jYELkd53H+o4YvcxhtfLY3GHtyhxesRn9nMofJvkziTsbZMeRRy6VFHiaKkdrvHwVN8zPkUVTFj/0OLX0XIITBOueR9ZvDU2vJLVW2aWij3u+aWfPIinUtfSzP66PkWEFNzWhn7shZDO5JJuJenlC9y5BJnwiZZ2rj7zQcAkwFQoEw4wXRsD6SYpsOHGVMF2yvERp2RXZwuEJ1Q6clZd1bU8hcGfncPMg87mA/KllsMafaVDLH9UvDuVBFtAbVsqOdJb0eskekz2pWxZH5icqE1WH11eU8HniOOcgPNdkcExm7Kh0+tZhwiGZB26Mnj/XezpT8cqscQf9+8oSRq2n02790WbVLvLrOmkCYRoz37TJwp7sJDqXlFeLodVjQsnM3tnQQA2mU/TNFdH8ETj2QxHk4Nzu38QIVIEOzxknSVkgVgb5btXHRQbCIRSDWCgWYMQKq+LyzJwCZG2Gxod1RhSHj13rP1Hto3ReV+dBGmJpISkhXA54sG9GBBG+O9E9USihyKEmhCc5UawFpG3Skiu4xlm2pyJiYEdoX6KNRxHGcBj1571bduPG81gT84URg1prPtLCEGkYL0OYAGQlkdEmEF1gf74pFuYiRhfmLmH8IEkGfYg3SgWrNbsTZOqiK1nSZP6KfOh+ExZNxHdDXU6/1VAFMEiytbi4VHa7lknLYyy80G+XZcKteGoJyijdcvQF4PgcwIZONmWOEI0zjKm3TNkPRzpAgT3Dd+nHSUTrIyO0IUsi/OkePrc/TX5Q0IehlkwRilTaJD38ZZjVf9pbQqHRol+UL+UEi2y3SCRjfFNPRsQulF2KBFjpeUFp87C6V9/zq5TzqDASbVyyo86c53td4xkFtSxF7Lzt0+XiwP5JdqD6AfRBCoIFHm4liB/H4RxFJ6W4du6pCFmMwLEhr4jM/EJDMhvtzIrgUEKPd/OzIIwWXvsub+KQYEyNqmMXpj9b8RJEovwY7XFJWhQ2UcuSORGypi3mUcuw7SmOED81O/RBuQAbraVCigdEUb4dZKGWieUUzuZppXDaYgsURL0/DVWqAOvgVUexnKExCURYC2TbNJV7GMw28CkmPjX/u5Oz2MMbR6VIoDjffVMryeyc/KQfivIp03bOgXnz5PtjeNLyCXCqzVPHUTt2U+23pBGrb0FCssfOuBa12E47gGR1imLdJoUNrsiuqYxVG2U4E1gNUC73gqkr72HwF/hrPmCWi/qlkqg0jReVTMQvSYBtcRkEUS31h4cOvYzVcWY/dk2ViCCoXE6G2m0VYmjrSY4a3G+GYiA/kSU746BbPkyntsEnEHha2hH3WRRmUTmZCkuXgghOIr47bIUM1R2pJHY6Bb9/2NmryGiYBYiuSlTRuWtyJjvPpVAC7CsjjLeUK/zAOp++q9i7FCsLtzUWbhWceon7JpoTA5RMs2ev9BAic8OuRdN/NduwrNqIVlll4hols0xXr+lfmimVyzer36ypZ3jurHuO+JpU/4J9bQwfKF/2zFH7DHjKnTeExRLJtg+oBGkzYYrBJigCNx3YyNKmXkrxAXmuE1QJNM2FYpQY8l45nxICwAcUpWjF6cpAt66zMmqtf6TG8Y3wm4BHzap10XexDbffXrwJw309kJmhqpFqWLdTpBpZQlfpvmyzebfWoXEMLOYQxxl3fnZAV2ky9yZQ6WbkbRH+Jm/PPseNce9uCSGfgTyuPS06b+FKnuGFCGr2GZ9zyIYtqyDe2Vpd/XHcLXf2nTEAa/S61GGnY3S3Kz8YBY8vGO9/7AZs/5pb1Pcfe65OLLhzQavw0YPPp32QG+/WgXNhGfE7/AI/0fRxZ6Pmd3239kd4YqhyPQclhqx0SMUGunS26PvPMlhWtknOogxkDUCGDamwHytu5VAtxd/ABG1u8yqBQ60VeroWYR9jFkSRx4alKHqv5MLBT5H4bF9GA/uj+kRfIh8kPNN7CNzgQwdI9LKQrS2EFbhWDBqvBH6p6StZROoTXqwmB7U5aiYmjOyhoINXkG5B/NX+HRgjjrEVHLlog0jCGcNEjmJjntwTyxHdk4ClkDc3AiIrOGzeIr8WCJKPU8M6ps+4Qa075Yvm4M8iNiI1qyVbl6dOVguEZsiXHvblS/wElS+arvou8HP5vd2L9uiJZYz/mGX0x7ZtRfBi0JGtC9WeSTZMDcEEWDmjjXbzIx3TyD0yXwgyMiSNdaaFu/cnQmHBDp+O7rZnFiPoQu+ROl4tGWLeajNBc8UeSpo4u4BCJDsYHXKQPGbLtlkbANZ2MzRxQ0opxlUGj8Fi1cyokXWA3gXEXFiA4q86rBmIbOp1eoVjpWDqiProMlVfoi9ROoX6yPyBX2oytosp0IpgdfGQUgvngY+W1I82E2jOxhWoHUsGwm5JOtMnpNAaONVAz8FScY7uLok56tbwLoksEP6ll/mr9hl1aokxmnwlO24NlX38b9zHqH1k82FXfC5GPb7RN9CeOLcrCmn66Kw3KYot/egtAba+aCq+GO4HukElgzNgr0eYnkrR6JjBs9Vd02jDzPpAjvXz7DQn9hTwUqOMycjcBmkEdG5YRzm6KdurTJgxagz1Nu6ottShGl6Zaos0/qREVfN3NGLutCjQil0C6r3qEaOMOhcAutTwUKiKP2+3S+BsNf4HMjmmnAQjpgUUyUz+okpGxqjD5zI0pfs2ZN474S5OUuK6IOvBUXdfuGD2FLt22XGQTaIxdLYbhH1XfBu3rSymjWwOLfTsy+JFuw2PHqkVap3JhNeDojjX5FUShecOSCf45uHLYBMSv44jJ+I5/LSznvFF+7+/SQHphhgfeuMaqGFxD6yHqkIkgt+FYqbzs62UYOv19azuwgzxd6H6eY7aZ4WqCWfd83CMT1lBjGHrdXLzIuyNHzoI88MbdeUYze4yibYH44XJuTHCD2kVmTPYTJ5owl/PR+D3W4cz2EDONLKKsodNvDiHaqfMHjLlYGG8FJdIXary270CTY2Ku2PX10WFYrtQ9ooMLbx4iJQ7DDu2Gvlr70TOVQ85PlhMmL7UJSY3rcSBPeS0lfKcZAP3vXQ+AiUukqNP+QQF0EvuBlN+yRbnE72fC2O1pRTByOqMQHo1Kicu+bLKSU67oOKR0i6snDnqpJdlbToybVwR03uraT/qcp8YUFMZJP9Qo6DYoRyZtlJIp6n01J6feg/ViSUlgo3XaI/JmJjqCOzJ0LPy84IUoN2kSHLDnuMKfogzJbZDbz+37SVd7Lo8IM+9hnjHQDrwOshG5wsDPXrf4c7q7DZmrhadpbABOHTv3w8W7uZmjNuF4157kt24++J6Mx/y3KvhKi/cFUVGTEOUhTW6K3oG7Ac5LIB9m5X53F9XruLoWaflSsaptg46hAYq7K0HPKkwe8h6p4z4Ig64AH/rX7x1331Sour+LIf5nkzgF/VnNF0CB90woxD8zCe3SOWY+dKyq2SYudSMIrCg60wc+lR9TT/fa8LlamBRwZcVfkN5AhJciOf1m4H0Mh0nvViPqZ1wQunpJikhbUdy/vgrMB7Z2BtfrRG83kp1Ui2N8N4B5/pimpyhhd+3JQsxgsxcXwb7reDfjyGXZ6tWyELumjKBVRXmHj3YQJTs6l8vR07k8SiL9ytPLTudmN53dc1ZiaP6XCNNfskeCPVXUPjfzxeSLrea6WO3NEGFivgar1GRf2oSmDPCYLPzz7Tu54thauPJfXfEcIAO+G8rHLhM8M1l4jgpAGy5F7m7mbuUo2KKNJybZ+RIYkwjZzmlenEhpjAQS5tv/UPF6vJXXhtYQ9lOfFBC8dTnL9cTyW9V5RtcYsb4tgSRELMPIR1TEYo6sqD3e1VZSFcRN3poIYJEPLH71Ws11U3ohwfNslkKJMszD89lE9xBgyyVlYmcMibsylrHRcsmsVldEdGHSPBDYpX51m8kdmNjWWIjRrPBOjB3P8Jwf7muHK4oJmpzANsWNVUStYa5UWwcT9q6hr1RYrz8hyu+cpweriWo/wnUZdXfA8sTamj6rjjQI5OojkztelyGTiKhHN3n4rNqAFPCqWfCM3vqzHWlxP92JAWbw5jDrKtm+mDDxYDol5UfphJNn/OJUpk1ktRizd6ETP3jnP6YT8w6DJyTeeT60ERP7+pyiMocmHFBE7HmvQ7AvnwSWOFOMQHZh4xz3rCqNnl/qs2FMJerZwI6bKafMBJdpjLmbaVzM4bkCbLeJaKFxQVWyaIQOtzXXwSknkIwTxKTis1Lz1SLUI080PMIMA7ECs75qzFzN/HZ4ZLwjFfdcjD8nbHcheQ6Z5ZoKZUR2I6IlamWdIyQfUmLeK+M5BAgM6OdHAIdszvLlLLgo3WIu3SsZQ6IUYDx26+xNMFTB4GzTcAQJvVb2A/UNuYOlPlwvvrkYnaESqXq7haLon5j1Kbh1HCdiO5MJbktMYLlAgqj87IRWnNWB0AeI99kp3yvppbrYust/cPQxiWqTlc1PWrj9BK8jrUdjiDXK1YxcCCUD6ZpJwLVI3E9jGDqPjOlFCP3nHPLAILGSM9zn6t4kjoKNb+uuRCy/8vDItIhvIsSHReR+wTYNWVAmUrHJcR91Oy+TsGiaFarmwPceeUqOF9Olwdn+L78jDVv7TehiYribFjjBJcMOR4UE+TrsjbNqNgb5D/hIah9r4k7PEQHNVC/roNW4oDNFhsyrKRw2+2cmqGxjSWMVjbLydKaBs5TBRCmar1/MdkPndY0dCSImVTI2UruaRCR2rC9XaAnyKvWz0StwIX+xjZwua/gM9lDK09ri0GPS8sv0eEg7uL3MWYgsR0L9L8QR931wyAcCNXN/PfaqXN1Rb2s5atGLyzTtJ6cTZk/XIxIS4S1x4oZXIj6YlYlQU8O5ZUliu9gzuzv910UYGMeuYvgdCGFZuVwI//L19GoWGOXu3yjYkfi/K1/DLyh8Aa5qwDMLGXebVZy00x6DVoh8ub2J9P6gNJR5dwQzbRaEQGbwOnFBLa1b6YyKJvjqXtBQSHK0NK1OS9m+jgDjoocse1D+Q+TcDfCDHnyHIEU+WTv6za7NPLO6GCzHiq516tAlSUAGYXJr51lLxNPmCBei9CKFBg4izAe2l5H3X8dWcN/as5I+U3dYZ9Zdkz+hSdo/Gp811TepO64X8H4Rn/JAonvTaepNXpK3yIzOCqpk93ubHGpK4B+sjhL/u+Q47Ipr9KEH7a4VF0JQwFIc12jElr2nwpbGGjkhfKZSZXyVHXO5NJVmr8iQFr1FTpt3OMvTJUi8Zk4ZVNS5bQacHfP5F9hYVH0ZVBIkxiLx1f11LBGpu14ZdZnKrC+3cnCamxKbmwoIXkhun2tHB/djK+z+E8k3Jhr7ERC/ULKRP2JNq9Q75FQJXv05WpNW7p7SdEWGIoOUdn0SnAKk8YZGwFFY7zdhSMCCo4CzQwOiuMe6Y7if/7BjBBkV7Udt6yX4BJSnfPkzPK37DmemubClS8i7zklZJ7+P+Xwxpcg7xuDH14sX13IrB5fVa8QILXzdUUxi3WNn4U22Uv0u4v7cVoZxgPiu5dY2SkhiJOzgPQYuctJpFDmaGa364PUOMnzEY9/fHYK4VQkC3lslGWdVA4G7QDmvuOGJ3UxQw4Ovy7SuFEWC5uQq5w4LArJJt9bVgneEYpcrlo0vksvemBih/e77ChnNRmN0DQR6snXOEZHq9tYa2qQqsKs32tLFELJG1reO/FFLE4gFUSZANdoRjGIIgiwBa3QqpH8QF7y66uuvioJjvC+yV0+HFY8Lkqv9paWqpBb9m2Fl/MtxSw3sbjEdSnkoKulunRxLo68pjueLf5+6tIgBmLDnFjmGz1yQhhWR2vLoSE32Z9F3xbmxRgGyMs5GfsGe5H0Xr0JGuX3bd+egdG/00oFZDIkb9COdv2dauJG36jCJmRuVM59nowWaHO9MtXc3YU6otHhSxMks4Gb2vFIT595ZfSpJlXIG3ShzURiAwsqvtxFsByCInNjxBPVUR1RhXH9ZgVBbBSKAIC3Fweb0Y3cn/HmXNXfbg8ss7RF4sZjuF3iWYImqAHiaKCV42o8qxp5EAaJJr4whKWh19C0ndT4OWxT1pPjw51jk2wFLzMOMwBnGbtRiQx3y4YKKf/hXIRyjhot2Qj+NonhisyjElZQo9AgbhDVLUMNQ6iK2BsShqKMtzCw0k5Sb496OTS3QumMmb43lTBdJqT9WCfoSHniIsA7LbkhQeoSZO/0AWBGbNzEywEHyGEDaNZfIbW5o+k9ep4kXpLt+Z7bh8OvQzcnwrg911HxR3dOxNRx1PWtdh84i8jKN/Ufd/f6xkTz9JM65P+/8QzwcgWerWoqsQx4fjTyHhIHAcGCwpk2MrGq69oqHjo+x149MalHFlCbjiHB/+kmtnfUG2BHG3SbRVrgUCOL6+2xPdb4tvqwGLty3Pxquebqv9m7d+9zNQPdRG4h7dOG0rp3c4ft/mFEH9rbmKZPHiFVloLDYigBb2M0PGwIR+kBq+Rifd19gKygH/Gtte0O0ep3KwIjaF/7MEzrtnl1Osy7Ifl4qx6P5GXBly+B+NWw5n+3LPin89GqbVmdXS/xT0HgSz4oBqGbLKRik8oCW6FSZL7wtc4obVjHNSpBQ07Q2IWs0osfcgGqaPPvDKqN0Pnmi5H6WukQ8350A5ajvXRSjVrriVtzLK8A7+PRs1qMQwFxyDj7bAPxLaktH7mowbYNLA57qXaJb934WwDJ6oNaD8tp5WBjP8BxshHcWcT62uYaWgRQy+oV74Q9m+1ZcDdVsrjxBBpSRhui4rWbg/uZnvUvtnGvGtNC9pZ3bus33jr9CrF6wnkt64OY9cVnF+0CP1fjPxU9FLCnIJmCR5tp4+rjPtwrM/YhQpa/P/5WkwHblOY25wKVuR0K6I79/USyL0hXAaRscwNf/ltntiUchpCQS0yyRCe8OsTPc690vG0soPC0bCa+S6DpAF3FdPl1rUeSE1uTX7wAeWZbI3CSfhV9ccvyPJa/3LaPbIfXoJLa1hWKXS3OURu4hnzGYEQVJjKhQh3Zna7Uqcdq0jqO6FenCOtmXEUlK037Qjj62qWsZCiE5nhD0EbiNqPkHFglJ75SdzoL5o0E9x52ApI3aALi3xd9oK9XkTI6qb7C3WxCQfgMFnL8O3Hy/nbBj2FfRMLjHyh2eWApwe2cTMRIK+Ccy3gWt/NM3I7kWf9OKuZvX90iwwTdPccT9JVEZuK10y6kIdBV/WeMtXscFY9eno02MkeoH0oY3eyK1ZOuPrb54JULquGyLtkvQQJEdcxquK0iDd1rCTt01+RVMu9FVLPVyteUeUVCYOdKuISiYkuqt66CWqpr1fIP4m60VA+rjUSTCw6KJ76svyY736Y54TX1as5d87I3DbNTSLWwwulFwyiTDqjCnjFZtkC7pLRVqX94Xks6CTYC01bLodJt3kD1sdBTGrpdD6XHHsfHHsFHH6FHPWwLpkMMPcNceOs5axAxiiLWTb0rZYPbgaAFbt2gHPRY+/lj+uBoGbWFLl5A1u9iLilW1Fbg4y9nXAWTX4YBzBUJ5Lka0G/iBATMkXDrR7d7xLNzZzWhSt4qy8d1GCR0hvRIDZASWkT83C/Ps04nL7MPJG/yrUxhCfDyC8rK4J+MQNUjpBx/MNvNCY0Kn4OHjnOUc25kBdDWZZkrUpX7UJm/ikuRN45RdTv1WVS7++GmQAnr3wcIkL4pOOf3yAdZzpxZtZWplKDFqEuxCcziEcAVV4d62ufMmjZ2yxGq6bU3qEc6HlEjGfAornWUQyKWE0EBjJjJMHmjjGLjoS0tNOAcBPP4Lbn5PesGq7IRUmf+SH8c3AyfLTFEGkGJ4BdwpO//FsbioXFDcpoCX1Hjldck0mx8qJyAcNVHT55Cjz9gxuT3FJmTyjcUrssMCKWrbBGpr/4yyVj0oHDJmkWRku7NSBXiHXQ3MnchYl1t5UgX2zsSMzjVjSIzxm5F8Kf0CwWG1Nn5/sedzbWfRif1wDHOpHA279mO+pHrKkkhaLL4mT5T5PxxzEN/6XwRHRFOTVQNr/rEosny0bFgEXBKeT7Cqu6TcbCDD4zArEbAoynhIJFFush+nL/sXZkxZMciNuL0xfrLozwQnpyvc7WYxELGOBbKWJRyfkL+Xg+gZ01HOjQpBV/99CcxIUqbCDMT3DodTPua0W2Fmj4tvAjXk3FP9UYyEchh/gDeQni5wfxhg1lOyR/QEmLJAibZybOwejAO7GjsffA1vxkjfKtJt4G3bgOOFT3GGNPM0hdffY1ZKVhRzduXroN64tvXH5mXvSLflF+aV/tDtPag+eLibVBftiS2UDFEGe/aQ5nE0d6cHz1XHa85H5P8+/KfVxlKiI04gadmZC3AwsGqAgyTI4ptyIdxe2nWei2rGAHZzGrUUedytjjeeyqcpMg1Cm9gghXlukuFKrIv3mIo12HcC5CvsWOpyNVz2buKNYBgd5lKIiiWLRDQ08CoYMqxJSWMoZqXxw3chQcRY7dwEh6yxibJhukF9nfKJU76HmXBpVAI0lzBI5ZVdmU22epF0UvHD9IdQKFbLgx8mto4Ac7aMSJEjYWa2QKNUCGhSPCFqedP+IfP8QhQLAgAiCW4BSOV5/HavjtB0BzEURuD8n53JZEijZHLVehbAQSCSMck78MOyInsquly9QW9lxJtItZ6Ah6SSc3UhPKgGU1bCIjqL3q9ZcJwr6DwX0vVvKLhcDD/ZJgmrus2TESBA4mxaEV5kLZBxZaiqzez5ywY39rtlzHnvRcqUiHTcybLGNqoU+Ab5IenWnc5QWWUUeSPyD4hv1aQ4L3RNb6TQeA6UCeGRe9mbM4J2EHD3WxWneframG2E+z0ZFEeMYw85B4ZOtwIqwMOuGMwS9CkiCpeIETSFZRUNXO5Y75i45N5M7mcCiXKdvW7gcW0Y72Le4vsVRTvP4KcpLf4roewGEGGu5iOKhpg1l6Emd1b0M42rOnTaYrcmskPfFYaEdhlYzQmFpeaRerR0QdOvILo/XkEmI17mwpHeWfDJMyrNJP9FOIttZGb07pq1okvXeAyzi4KcIiQRL2wSSgEiZYqkKJK8nZgEpTFhCEeXFKZjVrtq1lF56eU9c562xrqXXGKSxHexnqsr6zhM5U8OWVKe8JqOyDE9OdxKqi+5TZsQrsJgLH0/L7tW0/O0BlODnkVoNzB2nwJUpI8TqUrvG6viKbtbmBK0nFVr6eMU8X7XPhQGkqKWh0b68p7FDVDmDgaOtvlOPBLqWoCJZONhT0RoxOvzn7s9QrJMcy+1ZcUP0SO97miGmJSVbzNkU3lVDxW9R7J2y6kZEeMD1EZsMueFswPY4tJoClEOJr5dsVCKNxzXQ6aHssP984faqB/SkOJ94/QFQJc7lGiQmvAfqip/bm4mwvr8qnd7Agb20RX6CRNBZLvq5MG4ZTq1r14HbApcjrpLe4SChkGB3oO57ksH1JIaJiAuDRGlxFeFx8fx3XTu4le7X8XY7LVvGAlAy+1ZCAe15Z1ZBGCAnYzWOY1nSp3vwMZhLUCcRRj+J8joyf2Gt4jAIweClGo4w3ghH1YgVTU+T5oaURMjYVML+6O4kij3/qISVFbozYjBVFQ2SW9nwNTbm/+IfZjWlPHULvRIQzBVEvVNGOPo2eNxZ6m9bquc67ihEsq1Z6oTWSuhWV0d6FEhPqOX0fNXe6aPiLeiFC1CYN8lTECIq2m80vh2HT+CplNuwM6GaCRfR3oYh/lAMyTMIy8FCOwNbWscVK1CZ3l/OUo6nFBDXe01tGsUhtl/BOCS7NNHXKl5AIPxjxPBeNtkNF8c52Cz8qAXIC4GtmNOXrqBNOOdw2n1xaQTKgephYQfKbxg3OGB12mW3WpqOfYblsdC0odg1W0zZBTSzr0f/1ipSPCGgUvctwzxYD14uEHP1epzPxgpqb9ycYt6pyB8CHygaUfOudUwe/LUeF92iL7H4OZUp7AmFibZNCS+yuJngtZYhbXBVjH2jNOqM9L4f1sgFxTt7JqQ2EMZT1WEZKXgIzjnAzZZ/X/iktCXhm/CMOroB8cucQec9wE4+BULugPYXHFPp8RKP3C+20BmXJ5HpuYUpn69Bg2AELENON9oC4uwJVIhnJbmQIOwuuR7uvrpyxoBxOx4nsMJhI9ipNJ2P2h0ATpUuTJaeL0/6L0qSyDKgKgbDpANfNxRTV9zLqWo131s+cXnmCbddZyOSrIj6DWKTufX2zFkXUtU+1HhZ1srtLZ2LWfdVWeRg2qCl2QJkA2amFAmAFZqC25FXQSE2UiOktKWIMCDql9kz2NLRj2BNj//bIlH/J8ktNg8mIpl8wVPzhkhBwnTkzlRTvzH+RVBc24qTyKPMMULx96y9C7VupXSmynvrUwtZDLXnoApje1xzsZXIKLW4ZvVFnRfrvgH9Fbywj+wqt5lW5umOKQ29TY2UoNW/fYlNWxq8A1kQOToVC6FYK3V+ztdZhmFnBbkKNLCLSbSY6wMskqtWj8ZpGTdEdCz73QQzyiNR9pirpaeWoUl+rxJcMAW6yjBhvmtvIu0h5Ka7ScRubgW8xlFt00qLv1RjKTLDHZAkRPIk4VhH8XC7FcLc4yPZwsGUdK58XQ93iiV1dr4ilbJ91oS9ztonypVF6EIBylVrZIxMZWTblHuyIUssBsoFGAcIjrstphip5VAyUbyX52nsqE4FnkWFpqua9JC5vejKPIzGoMb86QvSibEROaeTcy8zr9cy8hfdF+GSdeQkoWuiN2QJswG11knelH2kPZr9N3Gj66/7bXb0zd2vC0qYTBSc7twlS25zvkdBJv/3bWebGAcYGzPYaNaA+eVgS2GwEF9ohqNq87VsfYTdPBDMDNaMtFhDSkov+4a+swwzj1yayNmNV8+nqtijxql66NxmpGP6gz5WMznURheA+RZZX3T9tfvXIIs+dJI6hivEeZzrwtZt5DB1NwHvGWV3o8ZZbtFnhjibJlKbErfGlbOZuoj72CrMHht7pCh+ErYdfIVovJIOUOhnGRhsZ2TX8YfxFmi69nTxNEVinTrFwrfTT0aLSyVNPq8QtXLgqgC2P+jr0CpyqfxbGDkEudDrXe/656/+ouAIn6G/XdrQD9eb/kafm5pqDCuUHY93ajfy+i0RddnN9sQF9yQdc9b7etKbcXPl+iVDWqYnNzbv/317bmDoLTk+fPKPBITXRmc16JtzDb42uJQZZh+Ua8IVtrsZVtZfDo3ZE2T36Wx+8GJCJwcV1da8aJwaNrYXRU3SRkbNJ94nB+7aoj9CYvYweBAHvwYMsWHkQ2X5Y8V6Zbeywi4pi9fY3mzJJhOIdwJu/FmGot8ShK3NYbcDKIZuaLn1iApDhnmzcaStqN1CbDx89yi5q6FyUtZvqG28Q7cOXVMH0j2gCrGWEKHTPK7r19LBtTi4Q8txBWnFKBtz/J3HI/I3xq54vnyl3BnAMPQ/3zF3vwASn9mj/sDkj9JFfmUlgmFfBgVV6PRqWW+4FGRKCRtX7kDaqnX1muWV6SZTcjZk19EmrioNzTLIxK3qtjlmByjUljrb8Q5EitzT+Uw6zSbvQFSP3Zk6fqFhqb6hdOndywjcFy1uDiFrYK+MzF/8LxCcE5TXv0iDem8wMG4tsB2fWqN+CnOCDG14SxARO82IuNLmRZvInl4TEYrSLF8aMeE3tzKl0qUecA1ygabRhv6riTYYPhiHhsxltMUCNd9up518EXZGPDIajH/SkzLaoA6X+3jt9qydie7m+/XRjQ3KbQirsH+UZ+H0LX1L6JZdXAFYuaWZd9fJYlupW1zMpMCtYVugonr+cG0BMKDa+rk6fR9gj4aZ1bsDEhY9VMYeLacXNnREWCLebyeRJW4wt+PxFXwWTcnZPBYhPeep4Rg9CPCkVUgZ/PNURFNRaRn93MdsRIcnmcxHY0s8WeiLjC2CrmC/y9VB35ta9QOCiRAMUhFB97Kn4jo0WSDcwgMY78BYsRfqCWKOoWnKKoD0dji7nkPAOH4hJcnvfFZQe8cw7J4dXhMxKVZQd9ah+cAH3PAMxpkXhY/ejEPkuKU2WjMDo/liD48e6Il4qX77CwhxYga6o9509G/18a5dcC8EiUWjoy1SyvXjKytlM90pBBbUTqMa31nO59WanHJGLnsanswvhTKSlP8SnoqJJJ5h6yj9JZol6PO2xFuhkVhkS7vkLx7fKYNn6s+/PK4OeVHibUz/Fx8GH7WGKspwd9I7t0MNXS4kPOv7dDkW53hWceZeaEnzoyE6wp2Hl4W1XCif5MHjsFTpESerTJHVpc/ek1zkYCP78ILKTfn5vbt7Bvbt/Ue837g+z3Py1xH+a5IUdGb2nO15Ceeal4ueh+y3Xkl+IXbFZzvAYb3ilaK4EL9+45tbCw59R0aBnY09jhx1te/fWr2OWZHbJqcc+cRu1lQp3VqJ1NGhuNc++1gNYWZoL+oSSkDWyXo0RtnZ1OJLANBF3wHXkUp/y2Tf8fWDQ87fBjpOaYRp3mQFmn0bR+Wyfs7hZ+m9bMHTi39xxh6Yqmxe3l9yrv/vxbp+uFk0uHDil0aGjhtKn61+O8zXBzuy3P1TZWyhY1yRSfqTWG3IGxiSLF4ykP5r61G+96bRZxvVuUPrzo1aEiTvwZgiP97fwxq9EVj430WGVdotrT4NkPZdWR/oHYAP6NAgXif3wqwIwucDTcJ5qrfXWWoDm5sLeX1V+nJKQSaEOHseEe0VztrzMHLR1LKqvpmaln2Wr2XsVH4M3CDlXtPfW1gebWgWvqe7WdqiZEwdzDlcGHKz0jlGEKgvnBjW0rg4WWyZpNW1e6hB5J8oYij0RT4wXVz9afw5rSS/mjjR+UH4av52tKMZK5W0/fqd/deNrXHq+KR+VWDX9dHf7Ab3hOHv6pxxtXltcK9Cf1BRit/VISB9NJZVPoL+3y5O8ol8MroqmH9WmzGeo6hJ51tfSII4CaA+pkTYIEjQlSh98+NmyieLoNNrshsi59eg0sJiYQAeFxH94Peu23vOwMO47El48+SyjYoGrnD2R56NFR4WiWytpD7mp+cddMgc05/gt0NWjZdnB7dzObPC2h6UmOuj/ICQWEwubZDbuaAjrxfFFTKx06l6VdY6B6WgJyiuPk4NEiyhphbQSGUpGR5dOVDg5KxFBydKgVyBhb0nQOqesXlw8vq41YDal820pPbnYeTZLasMHeRBKxr/KUo8OMnZA27FCl/4YXSiZrq5oClVZUmwQkmKwJo8hdwfiKxiZBZ3anjzLjun38v9DVoOjaAcG1fYRkn2NsRhBtAr0/2aHSVlkES7xNgFv+svW7dT+59++x40+vBG9HdQFoSs3gTBrcXV+KAIgSONQDksVvP2mmtu7FtMlyBXWUL1aokDVyoTlMU+HrpPaQ7wwhmSHdCDx3QkOfUfNeiGJ1V2dtt1S6cOIP7Z/lCxhxw3cKJtbHMx9wwmVVex7DH84APSJc4CWOh3Ayvey0V7jtsK67g0R8lSefQdY4iKGg6QC4EDRM6lATrc6mym8bFaW6MqlaZG33tlBbavubUmqkTIev+KtGUaotk2nEjp5AnO7P3a2X1G/b0NY/IB14jZNjQLcr02Ba879wxKie627Vjf2ioAOdLWhhasEfIHp3I9orhsuGER5pxHpEb0qddXxdP0KV2svqVaf1Jvc6c1uO5m7v2WY+De7jbMza2LMFvM0c8xi+TxueNV0pbSD2yGqMTRO7HdvLekp67BZF4p3iP9yvvV3+5MT/25XBanRr4pjWCUEDzyWhaXR5WbZyYBgooJISbY4aR017nEQTAIFhzPxVj1Zca+0vQAGNFG8//oG2BIlayVbuZTW6NAkJqvgE94ZjPcXd6+NeQ2u2KuJNWr8TvBMovIeI7un0B3dLF5GIrciYnApPOlpUNFki7F6WbSj2pGW5XoRoGFX+BQ0fQWwnZ+RHV3djK/8juXGs4fNVf1HtxYSiwrTm1991vV2RGDcKA4s7JES+QVV9/rp4u6g/yOY9skhqkzOlFpVcrpJaVo3twJuIE7DxKWWzsrj4OVhx6IAt4loS2spu5al4rXk3edvreirTetxrAnB4mn+et413nIf87MTLS8zc7rY4owv4F7E7RhI59NDKI1cTLXQOteXfnbHcdHuSHKra615kh7BcRljF7FWmhdah2c78XNCAThZd07VFoYYh1P4uOwxhRyBa4QgbcvfGncotHGEnHaysZBBgYTLDjBmXjnR2CrS2Nnt+KrTT5bd7HBGjdCeSNgdXRKMGRC9USZpA5js+TKMKqiWhCoY3opRoxySzWlQgG8O5BXaYXeU4b1BPPsRLyFCAEJbPE7KM44VaqIOHOXJU0WPFk3tqzZVGWbKRMLMNmbJHp4PCxNwjRByWRsPiWuy3aRwV7Ag4yGQ7my0BAFV944VIHUWjj6JQ6Tb96wGyK/M180tnT9/MR/2f2LFNKRH2p4f+zzeGfoFSJEiM0UQNaHUSFg6jPs/NoBIMfAVT3mqx4Wy1X6CNUjgV3Q2s0yFrmMtUZWdYXs6QkXWiPGtnJ0g5KXDODbMtMcwuIPP9mQ8Op8Vo+E365WZ+DNUoRn2U5DxxKtw61tH7S4M/yzmPSnsJ5SjWS8mUyNx6EbwJCsZXVb+PbXVmu4e+r1+ZN2Mt7OnqSnZHwonuEK4n7IiML3C4Fow7D+xPyHKjsCJ+rjDpj53ecZYZ9x10gwX0LvXcZHnwbWvXHRanHmyfwWc+P5zDZnsSnpvsOcigoeBq+dJOBuFTR/DIa6VYrvILp3SBskAevoK56b0y1mWaZ8oPLYQ8qCkWImq4Fcii7c2QoTbmxJXfWY2oovqMoaiwu3kIwvydHM0rceQVSqablgWE8CzaRUuNYygsFmsc2gwF18AAhte8LIQgdjjP7mBuqi9MKg4c4rENZ20PI1ZT9EtJam5mVCxeONGP+foyGCAK0DHmvE2Z2KHR0Vf63tB6e8tXDGsoz9xX3F9sWcfdnRd1yDEWHUQ7VrF0/+DjYj9/x+HvXbumf8VUihs80fOYaIuDzUEWqA21JEVTDKvDBf92nywrAiQeOLy8lyc3QSdpXWueoqFZjRqj86mujZx9zSLgtgV2xlqq0axVYWi5cJSF1TpzVsORgFKmx8PH3jmBoqSo6dH3wN4/Ihw5lhdcSjMfzO1/FLVFGJzqlazcaZuHUjvZdF5nhepCOUhIkDi3yD43E7VCsUaW9Um9I6to1f78smIMT0Eiq2TV9gQlmqRr/Wgya+1I74gHa3wNQNsDHjmL19JLecGtnAtQEcvdUgz57OtPb4b1fWPOoObIn6VNBliFSjwnqf6x2O5tgsSIV/tUE0kKjrF0mkBs5JHlV7g6NvHiPlvHtTIbGYbEVxb9qlz9PJHf67G6hX0Dkw1SrcEFsxp1SV1L59BYavC3cW/B1PbCyr4O0hXzYgw8GpneblDAIovINq13GDmDEvePtYeSYU+Xmzs+xh39khMqa3d32HOPDkdROtgnkEjBy94CpCvitIcb0t3ZOqtVH1rDXr/GNqaF/32Z+yJP8uedCY6UzqFlteTVkMprwBBCCYMm2gjMyLBgCc2SJ/Dk9b6oYQZnlX9Zsaqumxcw6ukJuLcDlfR0b9HlfXIEXB4og+/88Xhrb5wKqfJayo6/UD8mH6mpHF/e3ljZWRLWB1NIGf2KRrmLUMq7CE++GGuzm09ulGsba5n7I/101NSO8cL0jS0SdGtMsvamZ3x9G4l8BoH41PEr3u3+WxdvXHkEYeFqJ16RLqBP3oJk0C991XYdcQo9ervSrd3+VZBs2/35RvXyMVWDWk99zXQSpJysTMCGOPW4s4EONLTKp0J+Sfu7ZpRKC5McWYmGPJpWx2AFkah2YVeWUSlfPFv3yJErZjRhCOJpZwLQ4MlwZ2JIwLf/7A++QpS3kIbJD3VuTNzVtWJ2UinXN//9nJeV4cBj+7Mm08s6JJ2kOlgiSF768iq3FBPdYhjuKtIDCboXutkJfQiD+RQScMGh+mxl2aMiVU1k+LL+0SGYZkrLzEPzt5zMI7rGmqXSbPcTWwhC3DM8+6XfMldyn1yeR+CtYWvB+JrmFkFPtsLAi5kn6Co6CRBJUXdco1vGBY3wpIkPnP8pV1BKBBhxJx3+dU1qUKzJmbGCP26OZ4WzJplQnD+lZkZJIsPcZeVMn28k/BYKlhdpFf7PNQgNCNaX6IweaY/iEMQwtc62L/9ctDNJ2Ms+H54vf7WXCApU0obsy/fevBQOEoQrpm1bOXzAdFsvklL47oAtCLNkJ/XJwOxmILnATZ0tMNHlya+3mnhLmeftqj+nbYYVbQbfctWqDJJfoJmhn8082xhM8QkLiKZZ77eBwKhUjZJrYIJ+OtDGebMaNXFbQeJiFshmkKo8rUd/0jiqgLmyHBx8S5czPyQtJeGgOz1qBhmrIgNvPekOdKNY0fCVo6F60mc1CBdPrCuYSsnyYQRiBhkkAnwaWfdwwaxGjY6GzxSnQuPmth58ITFln+B6lmJoIOACJBNhM2ye0pZoGyQwrYXJLAjmPUjVkwwHiIwZra+MBwzzveZRlXRFTG+BYp/xZq6yjf+qHBQ9lo3a036TM0/HoHxhOoh5Br9Hyqvz/Beo/elatcc+Iaj4+cKlgn/qbj5pNdcU94a55BdqCbEZcxb9PY1V26s6VFcHg33K92I5fM8/YWXC2lY+ZvAjwdAjcutJfKSxDvtlLOJnJdrQ40y2y6wewLU8Atb4YGssRpb2QtR0ysqYM5PTJHxNz8ysrDxxXd7rqwjIqrVvuhZSP52+BZw5XQ9paOaA+mxCDDUwNDoqSpn37d3L6JCXPjFCrQ8Vm9+92xzok6mojM2QWM3VdPYsWNPZWdddUc7Vb0xxZionTt9pZ2fzedIWV7UXicIeDwGxwbySFZQKSzDLZtcWKHlNw65BWcO3QfKC6TWPHl+OqxdJLVeFpFDc05cA3L6m7ytx7YPAynR+Ar0zi+q5g2mZXkduRQ0UyH8B6XE8B0GfX4ua+iWtI1paYYGbK+zd8xrbyz5EVDLn2eD2I8eAxPlX/vO+/ipE2SH0wF7r+VXNLX2U1Z1vtTF1N8cK2YVO75yrEg6BZu28bq5ps/sivVTZ53ezkoJWU+ZZjIHsgZACsoW1UrNJvLDP3kCwUMDUFSeehSLelnA1mVtq4gCUdSbuYAutfTMxqJ18rHgERGdJ8hhQjaE9+58ujgFy3uZCSUljltJ0fHBsvyeBrg+zESfqK0wq1RNoUimqQnJ29gILcIP3RLNrgs0tMlJZkGnNSVhgnnnJOheQyR5aMQ8sgFHWboygMKNVEQJ/2hrPQTWUwOD5vnNOHHSuwgug0cnKS2OyOxNR+Xl71SnRVVFNvPbS5BHh4p4aHhfYqFHo7nln2tXLBX4LWuJYTa93BYIOx9qtsPrCgyaZbGCiqipHc1YYvFJWFhnsT47/IPX1jbTUXQzccbqVbLj6qLlO3DOpqMx5Ek5idCwI/zZYFh3oS45/J/W/UHZBK/hSYmxBUEMIbWPLI8feiGD3ZlO7soxRa1DF5BS8jNsl8bv8MJ9CZ8CepJY0tmjWEKdof2kLnDnbrbtREOqTazUktRU/VmoZ+Faci8qpmqiqHJyU1QyuDBZeay+uS/YPpvux/8nFe9wNLF5z8d1vU8nae1QCISaFcWWksgElS0xQCAgRHYvc1aFzmlJSWqfQLFmSgnxH5axLWVp0XTyHnEexMpqYZoGgyaCjPprT3KyJvfhS8XILqYZ8+5PNhw8vjh7u71l/YJNn0dugjEjY7GzFUdv/X+Aoe6bE7FykfqrNrxYxiI+X2IVPjpeJJttciohd4dncquEYnZCyYs0COakJ+xJnOL2IEoVhsvUMAylWPRXkFz2jPVNz+PiK9AEbaFXd/OM1ATEHgJ2XuU065xgMyOhq9aM9FYsHHSIA8RBUrD9dIMnL6WkL4rXVU+EiZIMcP0OscozUSc6USo0+NhP0CHUd9//npEWISiKVqCT8mpNPiVNvLdaONAw3dL+BQsvxCNyUEovCgxvp4vVKlay/VJDujO6RRs9dBpvP8Qw/KbibbtJd7V4mi8tdF6d2t6muLEUApAkcSih0iGZDWUkHftaVBR/ebjw2fRKvDV5Xa9TJe75ti/WgY3fU0VxLbUz20mPVsv6V3WOE+PK2fTBoRuVKBa058xX3sNR0sn2YmG0RzpA5QVp/x9qynvbdjlo76oPyYzSIJdP4ir4GKWeAmR9jbHijZp+2PxFx44YiQmgO0pT+M7NPbVGepFmbaGXNbpHJ19lq0pzQ5xPOQe2aJaB+oi0sXobaxDdYO+MnN4m5Hz+QaJQHq01eNRmfGR7+ZvQmYxnOSMiFOwEaaV5C6GKOJfjBa2sI84nW0n49+PI+GWgYJckErkwO8I9aAjBg0beqagkZxDpVDzqXDTY8nZbQqTf2qbFMonuJXcTmycOLi5OHh8y90rms57kZn0XrETb/+JF3fAHxfkZG3fC22ITeP7aqs7O2S2q0wgSEHVrQCxY94GvPTfOPO3i28UtO7eWmElgWkMRZeXvq9xKqU/TjZF9CXS6+otaomfKe0e6Eojmc/CJlq/u8PDscbemnHQO3VpZYzEF/nbmaeK/B2GFIoAkpZX8dq3dhb9JsCfpuHuX3GxwLogEmPvX/GFJCXw2uCDjEMo22TFFa81cFXidXIZtS/S211JZ2r1UkVet+PItv/LayyWlVE0kdw22gZjp26L0vV1/J9eX+uVcrXzLluYTWklOVM8j8zkQQYW0SyhRitctkNjkNym3M2M+PHLa06K+hUMiEzkVRPUOELrOis5YWsErWPvC0YmDqkfjgU1FoKu7whqwZMYVqgOj5jd+TTrSpCw2SjFNVVdQfgIoMxANTvcpMZ1Wuj+77KUV5fbZGJGyuVf0L05jGMxV/37X2pIYRQ8SOYrCaGbVFuFtaOlkCqJnyqnV+Pje3mhocUzWAksmM/qSwAIoLlEuJPZii3SPD27ozS3M/8wy8oRTK+7YIvGZggMFJb0n2HbhSL+IYVg+Dx4uh3DtFYINd3afsA9OVEktREZ6kcX0NetOAa/ulHP4ByXahCXwRJn+T+jLJ0eqaM6hxr2MVeluBMKvda+O/xXEpOxYZialZ7+RVBX6Ujgg2YHQK2KIksQ3fem4DXn5LsW/Kn46LsVYlq70TU6aLq9bnphQ35fhzG3iubUmiiO0UGAMRLP3XU2dzzZotYxxpmyLWHYkUbLsgHhH/OfA7x+uojKQXyDVSGDsjGSMR2pW9dYxQzGmytwpcWY5xdTiECmRHBacL3oq7JOt4B0274tMMHVWizPcl9V5qTRS3bwEnu141Ob+W/6z4mfV2qKsSYextiovH3mipyt/PdEFIrTDoNfhskN2Rabd6+T8XNcWSBzqbY7VMUlKoK2vwC6CQlqXARap0v/RhSij3KrgUMkzq0JFtzqbqOqGoGIdvxj4PH4t6CvmnbBf3+UnWfJ6Q1hMX46KtEZ/Aytqv+lDDYkXaSlNUHavNAMQdM/lp1tPRrsyqrPjmsrSst+tGpUYoTvazea5yJR5GJGdBexDm0V78YGMemyVVgIiWMFSg7+kMechUsEYY53BvV6OMX+SQyT0akrnyc0rHLIHmKOn9M/czTDkR36QFp5V+3gw1yVWWq648M6kGJuXQbfG9BHuaWYsISnF1ZARHm/bm4r7sb9GPIBRMfazKUCH3hDvCpXC4DIrwxKd+iBdDwUrxfkfb0SAqn6oxT/Y0frHyM4L4nW/0rm322qvXTLyZVjeYzxv3GFbdyYUBm7JIzy8Fmzm9Gkfi3xJf+V5ef9D3mKYUhFX5aQapXurIl6YHhCbiPwXCrjr+xP17J0rCJBpBjfmzoGyVTqnz5a/+OzHZ02u7TZDPhfkyyXh+uiOcZcytDo4X8t/e2UM3I1L8kn6VqnZAAgmWwXh1JbIhp4Gp/WUL4X6LoLRLNI6KmFst6ZdhcNY+Ib4QbPXWefZLzrK3JfnKndHfNhge8Z+4rz7v4LUAsKuQa3Sxsnbf6l5j7p8Kl8CKy+Y2i5WHhsnDnZnj4XRZs6lCP2oNb1WKhge9JM5zKeRoTs52pU8tq65JzI6z0ULTyNKn9vEPoC1A1CaZREZT0E+Z6cx1KbFlcoRKrVJcBY824TUL0V0ISuQKytsB1UJYDzpU2yw12aM9snRgXZdsTdqW7EoPb6tr7kNCSHOWFu0pABavbpaZZp6SBX/qUZHi2EJ03IvOhspVbq6cg1xkT/btYRmfsqVaWXVOXzAfxyrLwjklRUcLe1PbQV9odo30fHxlaB5za3sV+GQs6hd0aWCz080UsiGesdyLIVjog257EJ4hMFd+7iwnnbMCZpNq5nVCdKvCortSil8Ff4/sIsEDesGJKL/HiEq6pPvqSC5vidl0EY0xX+mJLBuaFW1JX7Lpx/38pjj2S/w2mdveQLSMggzwtCUJZ7BrnaP+bDzm5XXYi3UMZUpfb+NoxkB0rZXaQmwUmEuRIcgkVQuicE+c2vLAWYiqh5ThOJBgG1GrYD36YvNAtB4qvuybOPSrIH2Rv1qjxhnpnADCo34Q89D/lFlgERUSlbKteNHiGqvrojTIp6EwnLVjSlhLoAMTVsTLK6bLhbabr+ATbCRlQ3sRtpr88qsm8nd1W1LewHvMORtoz6TFsE+4muFwoB8EEajEtEeJma4IGu14YkftIJCTSHusLS41asPVAAev803lY1R5qqdi2j1Q0qR5QEEYgIiWNDagJouMEmMjJn6tyJIRjFt0ZIxhHdoXB1/197NQqWgS7fPzI8D454Oiqs6x2bqCNEZaz8PNaprjYzxDbndRGJ/NVYukzQrSLGUo2v9nXSB2cZmHygNCdFSk+qZd9joSRebwHxLdUGRui0F2wwLioCi8oVClYn2uaDsyb7MCbBy1N2atwLcb4HLPwkXp4UYEod1a4Y2pOc02hxUQQaHGV6/jewVFddPP/aSoIr60XDEm9HyFiOigha+Tp1SnJEBu8D6zLJHoMt9XwIDDEVPymM7qUnh33/BwX/dw08WqrKCrnj4CK3G8DJZKdAWbsqvSN2egjoNzN0cCxSpfD5tx1w8ILUYh4JZ4xclH+tS7N29lqL7sWoEFheq85ZFVEh/fwfnLQicLlU9Vd2SXyfREfe7INf9Cjzn1k5MbHOTVSSO3C+widKyQu5AO/PEGTLCsIiomaJYChOkgTJaBGJZt/0MgTuYqn2rBM1ljBbJGAe3EGWvomM1TAk8oxsYqO31UX7XLrLaRm6S45SOCJS8DGh3pbX77XiaohNQTCi3K3AnTSwJufDTLOZaLwsv2nud7/DjzIQ4bbpF4wWWfQ4/UnRu0E7YqQNarCwTapAMncOxfhR7Uu5PxdW2/kpjlsbrUnJQl2R1fjy0to7SU1PmLTj23oYob8FYf57JlfJ1BDi1LgYX6r7D9dtaOJfIgz4I5cFGPDd0O9ZBzCYLp1LnrLcEg54qvuI7bsD5VK7hYHroKzKNudyoxU1aaEftNQKajpBwaMB+7ad/rLvhvE989CYc6B4GfW0n58YeZVcX+d6TmmFf+ScBZzwnhxDH83TnnsaDt6qhakPVBysJav72Kqga7fds1a0ZwYcdti8R6Hw8FKtf43plTBhusVyb/+rKL6vfrfT4EEfzEJrEVEMFezOcXPeoP1dc8zg7DLW8zsrfkdWdgf54N2hekys1rNEEeynL/m/SkdQ71JFCviRLbdciTqk90K70cx9QKzER+cLcYLQwlHUbUYyJ74SCZK3wTzu4PL27pJe6LPU22KDWMclGWpAU/6wrimYl3BaAQYZBOuPmGBaT70QUMoqEG2GZfPqftBqbKbj8i+tEO/KEIRSv5wrcrDxRbGA6jlAtN7v+g09Ea9b47VCMyaSZMVwSOuynGvZTNWUSeGTdmYPbZUD7h+4WVpsZ+U2G+ptCKht+W7uECBb8gOxZ7g3NG+5J9wKSl6Y03wRnFtpC0/vTYy/MLitPihlnYGxK1LlByrFLOv/0oHo9BoZb99/+J/sKL8YT9Y1Uecpe/dYOqnTeQlVrgrkq1rqoEPut8GftcQrtm8vv93wYy79+MElOSrw7qRT3zzMBrOHv4uep5Yrbl7q56BLHN/p6ZKMmhxcIDBe/U76TgnBiNml5PEJ0jiNbRb7v3U/oZJZ6pzvK9OxtvnofT30xe1+7S2+ncqyL0Bqz40gi7nf9H76ZRS3OZOZ7SW27vP3AEmF69RxDl5EACW/YRBpqYzcB6MZm03KgWeyqYTtkKQ3qfQXykY+M6TIoyKB1tgYhsVBhWkCSxeYh8Xu51ouzEhVm51Jr3JuAwdHn1BPdZByoh8lo8YXt3A73AU5v9IMMyKqhfwG+fCujIzys6SL3fl7CHVd1jDzaED9D31BEWbGhXtfYrfFqBQ+SoGCoZKpHpfKgFw8vKXQf0tW8XVrpFJmm4O59hnRqPoiDMktmi6BXXbXdKbqdQUmv9bdGFq3VhS6Vvk3lggTH6Osw2q9d1yaFSTVbdgTf0VTK7Rzx26qrLjBFM/LDO3WJBN8T+F3hFkCP49FCIWYNQtDfqyn7iroZ1eSVPZ4iY8Uo6KSGGqekPGxA1zFDI4+JAYWTW/w0xCzrsG1L5OVsZ5HX5LfqeX+Yofrxcqpgs0Ti627J96QdWGxrCVEZJNtw+P3NIaUVvZXCvPEH1K8kOUYlH7O3hGC7N4vMwTQIG7WvLARGRTugUGbozxF9GdS/RoWHeZDANeehmytQQlBflCzARkBmrZa8Y6W9t5b8EO/zyqpHIhB0m275p8zhcl+frEHeX/nnDkqMQiERyAafmxp/4zuc3tJebdZfPHJ100MYi0mh0Go4F4TJIZhKV9XtYYegcJQsrbWqACNUyuVQjE0CqxBixLPRBLgR2V5FIk+hw312vL3vuB/ZYavVBjHsDgow+GPAT/nAG5B/lBSs4PA+8LSiwT/v98himYVYeT+KNFWl7bdeQlam9LmuS84U1MriXxjrQkMhIEtBYNkCeu7talevbNmK1e2cyST1OlKXMv54UkyHn6OGVM7GOOT7rjvJ2wNPqJfEsQ093F1NUCpFIIRcXzf9SNfGcQJYhfLp0mNxe+/pDzDzY2cVmafDvZbVqZtxcNffsOvid7ryYQto2xrE0h8uvkRJSmEauFwgGj3rlHDi9ZpdKW/V4TLztAs3rA8QjTrTat0Ed2ByvX95V6QeHuzPM2LSa+AjVjMtjs4T48o5nnTgLfuphqs6D4b+K2M4dMtYQo196dLOc1H/a/OtU82c4EI6Yfh4XP41UvoiNa1hFkCcfzEgXS28um3gD9oKmW7uyQ6ii/CN+aGpvb2vjf6qaHkt/BvZK9hY0++cuGh9vDOwD5y3s2zG/dWZmfsuYlDuRQbThHz3ydaWRen1swoybvw4uHb55+fINOUVM3yDozDM+W3k2z1iwolbx07pDlYceMdeDiJPJoGCQXOGc+g37EZYejuAu9BjXi5gqP8/Svs6nma5yttNq8SpLJvkS8nkE7AO0mQ/uu3GxrllJgSq59eR2sm3Q2PxnTcPlqoHRWSyYMDqgWosyyP2/DWKLt5N2tCGfREtCLgHT3rDu2Pr9thkqtUbrwl/T+doFro5Q9DPk0h2kqqPre485vNVEq7zr2Z4XwT4edYyq2pryDkPTnrFC5Sil9ulbiWMY8ePz2WmKIE1Kzc+zRWsWqVF/0ulTzFhY8L7Tsx0keorEyhKaqTy1USEWGQ1isLv+Dr/MsT2p6822W2EwGNQ2nyP7T3b4v4xHzc79o28SD1olJr6Jf2EB/Ryp3q+/p7q/jcfjb3C2uTOXVy+svpSUhQjx+scWV1TAFmnw9pYD1vi1mvUWsfTtXO52bwvd0zVncZkuy1pfbt43kwA9XSSNU3IDInnD2T30VjuleuhuL2KhY13qI3ahtlfXuW+LcHXVzmHo1bb7C36uakvblr1V64o+JD8gYW8a3Ld10y11yZUHzMPeV1btC/jVIJbwjSl7RCPoNuPQ8t2p1+9afMlfSJGhmZ634GEHKr8LX1Cj6WAdA/zxtoq3XQj+BY1zryLlqAdjsCcsv8NukBqMErqdgxO9/Mot160nD1weif07PHO6ZdLGYhpqAyLZs29xezhY0Ixwf5AqlysF31qFz3fmNuynCmfMOaiWVTkli2SyjSm5qmCPBoJT7j37e2F7eNF+SuWRiD58r+3IsaNrrzR4pAHrqEklkrawQE1RqAVpSiIvDUSlMwu3cjJOKhQMAizt/4HpHhlb2dgo0IqKA4x5wUdzgoZ8VlxG1babWzIQQ0G+QYm1L/iovyRXymCr4/Jmrmq0b1GwOQmyuqWzrVQxWGzCiDYkfL3Z5POyzHzsSYf+7V4h9tyGRW6kzi0arGiDgCR/KkDDuqTkU/xKna0Gjpi5t3xP5fd8ffm68/YNnL0obZJYQguVpzYQPN5lgIlfZkL0JPqa+bh+wORrxMOZPTZfS+3nvzDuiETah5jZ4SB/hSUmHgXpUfU7oTjaDbP1XvETscTwjDw/Fp2dte2ugY+zfaW+hhrMibPap/Q82M27xOJac/Rsj4fEf7i5mdHPgqfavzlPZN7vPxRjAW9ARrFWtyiu50X+KPjvo3C/NrB5WghLdZ3pxEB+ZmVc5Yn7Me9wtfh80pbhrMKHTGJk4B+OL9X7oAopP0J8n2ENqrjFZovvZbVq4AZuV4659QKWBda9eZIOOc9TJ/ckNnVg31l5/HDHvxJnu8frcr5/rkGtXM/ziu7suYbduV3iVvcIKXaEUPKFP7UmSud/Beutpj9WOH3/cWPqth0bd7DvY9gWWOBe/UnmFUh7VqFixgUnMlcp9LIhlc7uATVTfXza072orFnlSJQHtRarJ8vlG/JJKfpdt7QO37vUu215gj7a+03vf5DyjdCX1KcsYE7Y9qrmTCH5YP8LLKyU7aBPrWl18i0pz9JYfVH30LYUO9RY3Rnme9Gmf90qVLmwjArmvtCm++FUASZdSRMT2aS0On0jPLbpZnE/7X1d0eT8siT114ryEtM8mY6bTS10tAPDoBAYCAKFHXV/C+EgFqSn/ZEqK1Vb3aC561LCy7G2DX7qkN4toODVahN0bjefitXoQJjSqL0CGHzgaFqwJQgjkXK54WHp6NVR+gVzeGUljbGe6Comyzxa66UNFfXMwPhiWZfdgo83T51UNq1cqZ6qjsRIMKPDuypoAjl7QMlWCBynVzoGLSPabCEg0m0SN6jWzYjTmV4maO7WB2sxpaFqpArJ5gfllBq6/fP8FH6QjdQ3UOaZDx+x8oYzHNRZEDacwnlExH5nDsqVkcRSLex2Gqqq1mvJCqtQT6ZbF7YjOd6ow0gtQNkriTqNurYi/UGcgymusHf4I0MqOcssI0vZntOJcfefPFj1hdsHANgHu7evPngy+n7AuT0sn4k7dXfYPrejAMsHnYEnykHZcqfC6cvn7VSg6j4vJaAHCaCA6QY7DxqVeCBwpBhxVh4muxiaDYa+oygMViz8s9h52BrY0/QEdzbA8qzXRa2Rcf74SD6eSvCMruKOO3P/d84izX3CimIupGbQbCbqkT30ZZhPE4GlrLADtC6TLnbJpaJimqld0/u6GTvlIPZO1qiB31uVnkF4J/VXTJ+vl/MWPFH3+j1JJA1hibt8fE64YSONzp1+Yt9bnL8qJrwt3oYAVRoPEwgD4oyEno9FF2BlFQBTQFoNFLURm1JZDjHKYGI1pjS8f/v/I55kp8KMMZWVOMaJa5uFqBLRhrFfW70oPqWNTqGaphhKecdK66Va+qhhdHj5Xx0azEsZBh8dXHejPBZdLc3Slv24Wm/Meg6i1JtGR+3f5I0mVoXrdZsoK3cgBk/jJ24/uiP7UfDhI1zeWjD4XymNtpclgUDFcLgEDJXAYX9awrFIPf1HBUYPMNhXE9uleUFPCncao9mMxxYlNHnpAdyWK64/s1yYczOHeV1celQwhT8Z/Q3p7AgULqU7C39v49p8XmlGWriAtrG3ewUqXEkox/z7HEQu65bTRVAnJp/ZdvX620dlusDK+jtQoYllXel1iISaRNc3c+/8bAi05VhdCEezY4bmUktH4hXjhl0Ys+wEyclsiDARFVExyPshDAQphUJLwZBuvJtWp7OzGJpChstVxFBmMTwuk6xwxfIsIiIXUAFqX5fa5rHmGgrb+r1lHkZkDJQa+yrWYpizulbT2djreDRvjA1i4DS7LLddhVs8o/i0m5bNdYyxg+25SvPUJb/rDzdRkDz4LAMUuQohUtUZToPUAlai0Q01TrdTswwXU9uwbdg+tfBL07b3Vm/WsNg2l8P0WpW0Xvk98Tts+o7c5phbZjlTc+lxH47lqlMts6BWi6EVBqKH/+nFiNVtYa6GFGdPvEkFxtd18pmoaoR1nEp4kNzZ0Jn8wN3jEDbL6OzeFjaDLRNKxY0YseJnUEvYKoATiE3dUaqRQOV9Vszk5736B0EnZGvyGmK9tPi3ZAJfAnY4AuNDw3AXXfn5u8+DXQp60A4ScVR/3i7kTrk9wJzEhhA2OL7+5jUzTqVT4TYwA76FFwnZMga7pZfdeuclNfhoVKjTHA0WKf/IcmWOALKO8RCF0zu+6gC9tTx5hhb14ZfoY+AqMmDy8d2InZ2gqJ2CZq1LQxS/FcgBVE5KOq2hfDR+ZO5m4p76npyNVIcuW8dIiyrWsuEmhHgBUvJHITLfnCETaZpRpQjJp564moqpBk84lAKDvW4wcUv3usDoQmSSIZPCU7NAH+DkjK8leX5+i19whwaCZ8gApeTat0UiBWSRayY3hnMiT0BKAtFCCulNCaEwf8B9N3ce2i6x/rSELcFWgVOio9B7/FpYdl+hwOUWoFCCK+bmZr21UJlVdj9dxHC6C2HQ6rKtIM0zMKCclkDYCelcKAl0FL4F35w6PK4adUNvy5PR3QJ+PY63aS4PV8+fkUVIefTb01qyuYE6noA0LtxxRD9O/BSN16qAcDzNTN07AxJo4jdfx03Hnfuc+455gpiqxPjIW4TTo82M9plt2PcSdOLaYKlFmWY5mLxpeTZqKdDJ9uwMhodJqAEkToxSZczHeIIvPWS6lb1OJXRTyoGwVZtu225tCnC4kslicEViHp8jZtKf8u8PTXIBCisHy9fLkWUoVPnPnkuov0q9DKGnyeQTfn6vhWdVNAJxeIlgF+ik/cqD3cQ1tGH2U6fgyKrSo3mBYbGAw5Wq2ITfgnet616BS4X1y0ificL8vkNJwaAePIEi5XMpYkJDf08x/E33G2uCXEmeMOQGx7B7qBOOTrXgE9Qk6eBll+A8nez2rznImv8LfxtQVf5D+sgDf4CnVN0kthdCszZuTzKyMNzqcSGHv4oIEiJZPhl4Gl4lVWlpWgvUU1u0sS/CWpa3kpb6UJ76UOFzhLjN+VMMo2hQaPQDmhEjQtwg1ujS+nH6vO06cDmo+AlEnMBodCo1wp3VhbiIsGzCpSFfzuqSSwP9OVvA8iMTfO8bZM/6wj2rN7Kjl21Xb2+Pzr65utf0gSL9RnxCvq00UNt09QgPwMk5jVioBSkX9/loKDfMAkWWNhFp4NTXxuqLP659HXDpTn11X/c0nFNySKJYOjCbBY1VRAfpgUOBFcnxL6TAvlqZIyzhu1pxgvfep2RKDqjmHmc+TopBFvwgNF7DaPZTgT7HiflCsHDjzlmDoWLhgW7KK9Zs3djqLwCPakmsk0HjCxSxq0ZrK5/fnb4RcBx5y29J7lxcBS5V3BsmX4DoprHFsnyyo/orgn+HH/Hj2TM55+opQrYIl7NwxPNo3VFP76vdL1cGX6z0JHsaIUYIIG8K3ixqtneeaj2M6F1CtNHe+J72mQeu93llgw/lHFZr1JOqlokgW4RfWbfGqCYVUuVWFsPv+3r4iYZiBvMpcI9aNx/epeLLKs97qDwORMI0Anjn/PxZcI/vRCkjXrn2XNCaC0FrP58r2V2yG+iNt/Cx4znlS2ItHKONtydvOY9UO/RLAOXYcQtfnTv0ymXrq+P1UQPKAUBgY2PorgaV6DVBfd6mNAJZl13W0p6mJHcUuvFVKUnLxyqkSvNRtXKQS/vLGKcJlt1ikWnp9//uwJ/YGxupC1SLsjaEQkgeTCVGskgk57yEpahJYrymspeQ0jfqAenHcgMXgGVgiRK8+Pvmj2b5B9M9g/4CYdDSlSIudWnKEUbGQdLM40h4k7z20gtHcE4j9Sg8sX5xnmm+X3PMfZcToznFYlfW1ReuDBAb8Yi9u1bsb9xbsv2HgSKwRA5aYtD6EZp/Pt3drchLVsqXz84vd3kJN1Jy5mmZccic8g/Z7m/McsZXED/+bnNEve2LzY/wWXsSTTZyVL29migTQHKwIEVOUV+LYSbUa3hJVEOUd7NRLSzIff1lO7pL2VbXJdU93QBQPRgHQ9WmL3dgqg9+u+qCuFN8eWzo20caEFF6+QaKRc/CbHCUZFWFrUAR9OiLxZstwYTyH5WvfHpsOjoF2p5viJva6mpfboWkz2H6GwA2Xs/P05JKMgqMAiar6+xzdTLWGr26CmAolkISMuccQSSgFxcV85Vmb3gxKO2HMtOxM+vXMwj6N7TxO7wfVg52/LZXTzxO7Q7f8kMq3614mNgTWlYk5kuAx8YkZTzsoo1TQ/2FBJhlurTUArbAhZmQmUkYydB9H+bVciFjMze9w1T3nkATpQWdb2yuxo2Mcmob20GNkCuzArCTa9WFBFc4JLTAhWxiqx5cw9c/zNSLUPMfpUa2Jsiuf5z43dXdY56bGBEgERquY8/4c+CodxWMg3msuzpvT/3xHKEfm2+yWl22mLOMkH8da4wzxho/NH5App31YzDwZlFAoeein6xAWL4a1wh5bvNX7+kADy+u1wGz5rxcYMmOkFMMa8kC16hohZT/GklOQxV1/RwT79/PiH8m1cV4ZFPiBuJavj7ycvSgkHwYIorMcKrByCgc0YLMULrBOTe2uED4f14vd4MNEepGr4wVWwtlLksix6XZn9aEdC0IQeB44yVAxc6sDAvQOQWXyLPChEk+b1mwdpgU4/186RPVBodr4R+gTj7POm0I/0iqyl4BppY2gGBdjGo8VbM0uj4jsHVrbrzBdHhrDKL1z0mtgQuH9fYTq7diHOzda6SZlW/LKrNiNNQhEWUFdI027+3urcRraYNcylez6LcrCie1LtCRjrNUrQCoQiYUOFrPRKeWyrexullzaNrBqszBYbU+ot7P4RTHsLYtlEAmQ8Ll87WewdwG54PoNCqVRqd+sBgBh5ZCIa9EHciemsj4Vqz8J6H+p0LIW2sCWOZ/wT/ZkIeHoDAsDvYmDguFDg1DXfnTnlgh6NVYYlNOxV4oLixkamN/5mVZWr60LPZgqFdNjUR0MBYIfH6XSQHR2NrMcNUSezD9e3JZTU3ZoovWAMPmXERtdYbwuxaCYKkyw9laGshq+ug5MNxLXp4q0dfdKjF4YuK5h7EXP26zSsYutgZY3N9sEg7vh+cYiCfCo95XXL9oD37jg9qVN7gGtIEYDGQZWn6BCQTWPLc5JjWsOveWfXj2L8T6S4iVlKtRT9wSXCknpdJZznlP7woPxBxL78BoSlqzVsuZCifY1YmXDFAp6Ptt8cA5BFM7pv9M2u1Fn2jiv2ev8mAAzPrW3Ev/mAmwLcQxd7LnJK3YD+zvaEwLn66j2Um+aik2rqznyrQO486x8DZs/iscCxZ9L6JX1abqbW+/hnxvzfaJsR6av4KwBdHjEdUz55m3n/7JxhuKwkH/YI+C93mfdBuySwrIel5yrMB95o3gAUxKCCl0R34fjphBChOH0E693/jXo8Nt+C1cyxt4MW1K1U3PN/uwxXeCpZtUSNXrU68mLz+7G/i0A3fg6DjbAizIBahOtkcC+WujlK7bEMgpTvEfU6Xf/A3I2bWR7ZEE/qsmnt7XjGyOwzodMWjv6uhgtKnpt1ODZG6usRGF5haPy5A+0IvXKbo6u2ul/TN0KC4QuMxI9NCa9mZ2M5nWpyfVOboSZIiCwrbzBFaW4XYc3yRqhUYut6fz81PVCnw6GNn2oa90xxEn3dvb+W729j/ivLdIlgzUxQFv8QBtecmsgel7ZiFQsn0E9Its0kwwKgdYT2/ajjvx+w44llGvKsHlH8L6hMMMzEXXfFVJvI6NK7lmdyqY1NEh4HU0oZ9q/3VrT2jGWttpyCy+Q7DqiC2IktZAoCce929pQ75UmRutRv8ersfHDNhUJ5bscFv1+tgxGrWq6T6cewsackk7dvVxcI8b9pXtAzvadgxI99geM6iOBeIzWWktMXdgKT9rNNYDtzNbdX6LbIRKewBUyBq9ngZn8dnHplTKi13sEeGAw1+yFC6S/B+KqU1UAXgzqBExXKT/1WoWhml41doOQ8RBRP9BRFflRulGxGf4KkQvs964cH0nQh3fx+xYl9gR38c6XCHaL9biTab7RFp84Yg4opVwZPYhoq43gMalDGC7UAJHoOxQJ8q7KedHekQ6kO1vS0VIxK7vyu1YbX12o8SS1EAW3M72kDHMChuG2HWw0JoV77YZRbqEGrTgdoGPkOty9xXSqueQgZPuhFU+YZxJH3Zr2OdrDbsY21EatgqPf4AMzNEskCRz48svM51J1KubX25RIUV1U5ID4gOdBxB9BxGIqpkti4nfOBeAqN5Idk3E+12l1vvmNRZxmziSo6t1LfZlhiISyZa0oWqPYHP1fAVY0Ne4QkWzrFmNVG1uNt6M6pq+j+oeeAM9/iZ6WHI94ZvhG/7njVxp22v+yUES6jT3x8g+7j5lGbdig1nUHaqfmKGOmQK/oe968vQKp7nuxsE2YZxYYVGlokiVeapbFeyAZLzLopj10MxI+4pq2xhvO7JnjiSS9cvubnWbqnutagmzNHVyz66p6BwV4e5GbjNG3pJd/QL3uNLdZijETHNNpnZhq/W45ILCqspQDXNx30BbG0fWQuRUZtmzbRCB2ez3+S0Bc4NyNCiI4Z+7MX1fPXwmUc73Hz5wzp5OM0OtkGCWolizBJpohWQgOtvswBZYkZU7s2EyPpB9mq/uByxzWBzMz4uH/JID9mU3pmtCYdGxoHqiBLOyn9XLIiAeHXv4q0fUhe7+s7uiYapJi/eVobt6sE5XXZTdHR2MKhTkv6FU3MVD7e2HFtvdrvOZCop21NLdPWLRUpgK+ItkEZ6t1cuKnVLEdU0wGZNBh1HE9Q12WXGsgYUni16MPHMQhToYHHQQhToURKyzuhMtXl+qNRzbL8bct8L95HfxsSuFHlXfaxfFmFsBQcAhZNml686pzlm2WBwOewh/7kv/Kcmpfu647TlMXzIY7wunUh2pcF882J9MwUlW9yp0rXNzylBdJ7rSdSx1kzz9IGsHy+eeL1yCjHLJEodAIeJoRhTT2obwMTevDRaJcogtw74rjGHIjIbByYLRixYhZHM86Hl7tn8j9p5d2cAPISqsGnNPLGlN62T30QgV+RwebxwatR5Zb1WpmFxjAl+O86HVWOQQi+VNUJw7FA/WKQqyOmiMGNwiQTqbHegNkXQ3TyJovmz7tL9HOyYzHAIjc68/BnsP2R7DnJy+n1geT9h69ajHbYSEOn37AB1nGxq1Y0nn4l2X2YrH1AkeSW7WWnpiSVtaL7t/2fcXAexcCN40NGrrOfN/pGlwjMGOwS2/mM3wrd098XgiHfRE4oG8ooKM4+BHLs2Cez7kOlaTxxV+v1K0LhLuLHbjxCR8zEvLwQQEI8AxmcX19eYDeDqZoNRojHYC1cV/jav/LgBG2DiclOSDK93skmALRl/ywMYuZ3Z46OfpsdZUuMXebkD9l/LENZVMwgnW9m7HvhMrG0QbUm87QEAwCBQG9ium/f0GqrNH3ePdON80smfmrRIlvxd2OTGHh2XnEJVAQ7pxDAh8Vibgdj/yF5t8i75RqQKtUCWTChMQS6GVC5ZWl+fgxqDgu5NxcNiF35lKcXo43FMlTgRc4J0Q/nOuqWOjDkL+g7LSViktGmQKGxRlJxDJdjyJyOb5GMTfYBa6nU7pinWEQrD67f19FktfP2uTC6+jo7/fjFsWJO2IdYSFL+GVkN0/ISIl+ES5pXM09bgIiy6GcxR93X0jvpGz8JewmsXGaduw3IsrGwQBdImVJ5EJGx8QhlCEZf5eHr9ZJpn6HjZ9Hih9duVh0vHkgPGdXemeqln+r5U4U+gVwtsxLy2E6+vQjSU7PfiNcqtGp7No5I2U+HFjDLoZrF94Go6RgJPDEjCKav4+kuny+RwORUxavQCv5isVbRZ8P+qFNOQ/J25JtGNpoAp+zNnpPxj0RzD/wY9Q6TassMWrEMa+/kpiukUW2wuOlmtekPeKjffLJFqiKqgKtLa34F0X3H2J0rVlBBmd9TmGRdyYdpR9VN6P7LKptT3L2i/vtelHYqysYhu7Inv4f0BQEXxEwupTQCqvFeRVlKGln0tYSQ5SJGgfLmIlaf/IPRTU3/seOGJAke+YwiKxfUGfvVfyj/gHnA9plij1OqWCYw1/5ErlsO2yhpMfxnOPLh93QpDO2RomlNUroOBN1p6EzCMBJk9VhfXpwsofeKaBnNA8eE4uE7OPmBEPg/kDeqvZcHAhheYXMrLGik6sDODdhxqqv4L6B2GMOUNKdo7LZAgEnfMi7QrXvMygwRRy2bPl9rXMMhatWzycWU5jdZnfHfhxLrSL3FUl/0nyrDZ4CalVJvuy6h2Gbt7NJILqRdXG/OJCBpGtMSvu7Z+6/iyrpdoeJyWDohrBa7H0PbSxGUrrKeQZvkl2lwNXbh51i/V8+d2x1HLCvLSt6pHZOWhV1gY9TBLnWdc/GkOMJ04lat+hejY7ckKdYfqqYGZOYlXOq5YaInVo886olqN1wuftvqW6H5bya1VIbSzresEyfF70vKBHs6Om6lZkrTXEqTVuup78tl5ST3tMm+/K08QhwIqw76YJGc+igyz2p/1pOEBYqm97iYkeIlGbIeYqGbkEVZ6jWZsh4qrorMVXVsz7YbvHlmcGxcun31f+a48kdSvJEuX34U4ots3CAef7czLbxZDflWYjUL12lUr+b+bji3SQmRlWm8Nhj0BgHc4k34O90OCsiX0xk64sV1FmLswGwVk+l+6KCCDeKa5cZ27s2cPG1B65s5Hy2Y/3NS5+dSAM23/gKPp/j7u3ZyAzzL8u3XVlZYNoZvOMyP+Pntw86Zz+zb/fszFaejPbESfLU0MRl9I9GBPJK+gsew5MfrTqXFgsCTdciQC9/E3AyoIYAzrXnUXf4w4MXvWePwlSwPnwNG2s0zrZ+YutKPifiNj98o8/8/ed10k3n99xenIv+q/Cb4hYuEL80NEVTravcdGvJU4+j9KXti50mtLIg9KD7JP9kWzRobwy1YZjRoXW+nP8A+YGNS8loKtBK1qeJxKw9DO6R2IBkoUeeE91/8L9tvuJtzkX0F34T0Ma+SZyTcXYZFkZW2FD4TcXnJc0/C+02rw0ZFVzjZ/0Opj50V1g7SvAWrcMfNyWeoZe4wTjjLHcA4K9RtQzpgGXHCeLrnQPudc1zlaV3UIoBEiNrruonhXMb3fjgdRpcnQqRNU1/0T4HELX+yWZLVgkEqmW87TtO/7Pml22z3v8seinH+fOsjrcpbwQhcUReQM3WjlMDXh/BYnV3RtxSJ3MA+7u98rriBEFTwYh35DXAN9pE3auJ8R98EpmtEroITFntY9VePMAK4vDg/cvvCCJ2OL1h9f8JbqZ62EX2bUM7zoMhtmi+xFvf13zBP0krR0yOCj48F6o1DtK/OsTyW9me7hH/h7qon8Fqm56PXXmQpf7YHd0iKlLOrXs58mjnoYiqsqrbK+YwZz1pHz7hTqPS6zQKQY+/q6AE1XJ689nTJZdqPPaIFM0RwRU/8O8gHnU1J3FLRfXsDMt8duoeihi0wraSDJsSc6jttxcW2Reo6z9IHDf3E156mj00SLFA1E3TcfAq35/q+WplStI7sQABE0+ep6mkxdj9765eOWXj40kzFi290wrQKJTtTHXd50jZFWRPVvGXFoOLsYi8uy0/ASkgp4VuCzvYIl7ghwsBtM+f008PSIvCZgK5nRgHKBRLXXsE84n40OIOWr8Tx8/jJLAVLzi5ttEoWts0DztnjXS8bm4R6ISHbRqDaQ6xkiWc8oHNZZMug6Tw9jMmbDkc3DCkXFsWffbQsk304O54kt1qcz8L6nqNEPPDEnp/qDh3yqH+I1YD7qIC1+2xjgSjy/Z4IVGVtbgb3QgjTWfz6Msz5UmBsPhZFsi0NLm4GVcf5Pr87ka0awbrBHFz+BSm7743/zYRX/2fSz+cmDARVy6PfuUs6BdEiSZi5cdTFFBiEqwGzUaFYFkolhqDPfijZwZfi5DKqsVWgZlPjlCETI4a9ezvKqNAkTSl5SnablPKQOKg3mkQ5LwT9YqapT0kGgzxeEM5NdZGhAt4wyl8FuT4nM+KSk+ckbR0tOieUqU5JBoMzXASFjqKCqxvwir2m+Y9pEr1j0n2iCCAr9ULIgWIumKfaKZSARAxzkqQB+4ZGhXUIbPDkc38cTNdNrt5rrsyvQZ7WzelznpwOUwJzgCOWXQF2k32DOebgOg3SXWIDp1YLEzxDhjv7npD6UoTZlHNW0yYXlfrvduUSj0nOhVzcmVciVobkkqsrISXkU7P6odvDgguqSi7w4IEBt5YtkZRDdGmWvwcWODtK571HqFqDVl/El2F6fSnr8X4n6rE4uRW4IwS2TUWpUk1d8Dyqqyqkpk+Ne5DWVHv36L3FB67MtXHee9worEIGvY35aOD7rKOlcB+/Synd6YCeI+297Iv7ebVWjJH2QPJhqw2iLhd70d7I5EUFVYnpJWZkGl/ZPCovb1NYvfRqy4vqqpqgZZksrFTMviQXkvm7p03tqFjB6TKMEdZYbeVrvefQOkq1nNPQux3xWn0soxCOgSoOwMbZkGg6fk04JAhtTy0MQWKoWHRJvX8jrJuyPXool8YlHhm020d45Wij0e9Pt5wE7ZnkB+pjGPc2IcXTZbl03vO447iOMZleXpghCGlV9QUa6MGf3w0TtRDB29PZYO23x2Q64oO0qCHxfTBfTytbppA0i3mDqEU93nc3ctQj7DSna89/kCK9Jx/TP+/c3/OU9UeH/54c67UY1sqP68+aUKK5lrk+i1VPsvX/T6/Pn8wdfo60fDcISSDmdbSNnZFxud6M033QyxczQUC8ihcOsMOeATAkGFF2N1MwPXUhOcs6PBG7GCqZ0buR15+S0rpncWN2UktRUSnEDgSgG/fb4vTCE/EAFVoIH82kcUKXnrPao7b5LiCJHC4RIYVAKnto0U5eNTa8ZOnYk5wCQ5KcQv/qVt5OlLLsWWnfIAAIZm//1tWFrR9uptPSAUvsbjHzbubl31fvnp83p6Q3k33xmC1g4P7wTrhNLqf3uuU87czUDphi432qxJKs1XTtI4ZUSd3fQShza6E9SJjXXqu/MFXN2/PpqeesaAHJvIz9qZGGdPjLIUHEUCYoITFSNdSVjTF1R44G7h/N6MPLtdy876Vq2C2Nh8N+1piJKY05rd9RZHd/BGTHV356+7xP6L3QEyHe9GQVaBYLW/LqHlLa+0PsrWL9n8G1W+yW/UxOVCpKmeI2sqW+KrsrRi/8txLfzCT/oiuRMChmILGFnUz8w4/xMwdMWfnvC+ve4gw19MS3F106CF30SjkfJy8GuNA38wmRKOQK7VyA2RLnct3fMjDO7PwrE7tpua/OBv+1l0fg6A6NSPwP6m1AJgPECHHzJxlJHDeO+V/j2hSXZAesXQekxoFgNaVgeN5q1m1wuFq/0C9mp7hG8aIWOvqWg4PI8NZqK9Sx5+c4d1ue7lHzLgRKdPelpbbiV0Hj6pVPRG991PezVm1SgYbGT3OUNTfQNjkPLT+2OH3OFA72NZD/T+xEuo2+J5GhlXxmIfD/EbYYAqLsbZ5wAB2Q0K0CJzd6GcxCtcKEEb6JPvEvA82A2fycKWmpyvOZd2BTtYAJ/C/a9Ant936IPXzeaqC9/0foCzyYgkigjhsMBE3Eor86Nvct5Yk/jCplMgJXLLy1hHrd2p19udWhAwL2DeEb/Hx/sMHuIZweDrUC8x5VKr9PmoTKMt7F7N8FS26POo84yWDCHlskd11NMzpL+Esky8ftIBMuWDkPWRpPXXw8hmy/MJx0JgTF4NVGkfIZRHbamETl/8i+qfPi9cJOLeQ7bJhMP0i57ITy8niK2x/T7m6LoaejWNffXfO31JsTlxTi/hKxAOBkWDi/FDXvj6RpY7TG8KNaDLi6g1CSsE7abUfJibA4Iiyou5uQIpBLXMi1xEfW6Pb3kFFP2P5E8tCU87M0I8TxtYLia+5EcDQKfSPkpfAT7OI4u6S4uXCH6ctN6QmK2UtQ+30ioYKn0JVM210a3e+b61xfLT12QKRURi69pV1Jt4rCshtW3K8cojQhww1dVlpVlmh8IsKrV1quK+bFWyrAnAzG96TansPpqCEdF4Gj6XEE4rpDDLStCugDCa+HkqZf5VmxV7Ep2enI93Lp6ysv81xpbGs8D39RKiOvbD3KNGOm0wtPKGDIRyg0NYYeKW6qqSNkNalHQJYGZJSfXnW20xIhwLhk75fSiAOv+DbyIWXfOdMHNA/0P45AoLdBoV2arMR0RucAjd5w5nU24EoNI0D5VO61F9UdHhl+Z8AD1Hcd6HmcGb04ZKSxGIstLS0rIyzaAuM8A7GRfNk6bia6lWsGNkC0l5XO1O1ykoboKi1SETFRktOIlMsBH0iUqOZDHAMajFNIkIxBfMFZHNpgnGq2GPvvSaiiPa9lueolNqHGDfKQEm62dMbN+9+4D0lH6cLsF/6GY4yzztJD6LoJAS6qL58kQg25jfafJpDBuuY2lc5VPJfsNgyk81WrGYMFG01UfFDeGYvHB1xRjiFafls6Ty6NBH1d7+gFk90NqYMULO+lRIiSPxBHkRsL9LfZdFk9Psyf7SqdzPTLkotRoUAlhY6fzs9UKXlmrHOesyvtg+wzGj0LKjwKYCYqUgXg53LnzYsgdZ8iIuoTd8OCCZ0spcYokMDpf3gZ0KoR++N2pjzVfnULfgLSqolxHtYTQYlAZth2Gb3aq73NUadZjeimOg9+8lOsLfR4fCkdWd0k8nqJAqqoUgA9e3KLZdngdIGTSeK/lrVDujt7mIijWfmysSAVe/mBsjFJwxtVuXMx8o9gpHwLqPQlBTmCUMh9g3MlJBVHOcnUdkbdkhtVIknNmCiV9HgVlVdtWo4+x+FdZcE2ZZg3kUq/x8jlEfcVqhvhfV+wVdEdMtKUwZJW3xgEMoMJhvChXC9rjCBBtTE6uSthQZcLFApJ2Bnrq8ecPpn+SWxsECyYxYaeZFGUAHQk0c4QsizsSXH12BXJJjdep6zDDqK6x1ST+iVchHXv8j/MVsqik6Fe8wKcDXUUynhBlZocNZxBAkmrcHWGmaHeU9Nn3ecgfv3BBPJ6PaR+dz5utu5ZOFnxIHoGnmmzXIV1xhdxmlqWF1qVAhjkrKPKXECwqjnj3tUhkeUY/AnczL8aBon+mWfyEiZlyFtUarIx52ECEM5n+AYApMtJxTo2m0kGiVqSb8k7xJYzKU6TnDHeeC7s781CqHgTen5kgvFk1KucTOIYQMkAde6DOpupz5VSzBcG8xLSvxSze0BeW9BzPxgk/5+IR5SbApbBlA6Ndc1kY+VG1KZD0xpO7BjJlYzo/JO4w6xmAVlASGmeEICQQqQex0DVme7XwTaTOR3W+4KigJ8fs5wTPD6rlJedls9o0MOZiflPfeET9h3ApGUV5Fc2BBCoCZIW+tnsOZTbNGGeTfQcpADQJjUkBxhaA5wwD+T6ksHaPAzMJZFfkyumSlRSJL5508cTh8QT6FOiwm8O+f4GbLCff+eh4CLr+jAFECBJ7Oj+kF+ZcGBgf4k1MtJsu1u+D5mB6l19/3eOmvtEz3fHZ7KDz+HOVfIpkraC2rNrRUdj5hyB09tw0EHyqwen9/3/+zvyuaa+RtvUFn0sacOAEuktN6ZC7xDAuVLMAk9Jj9HFs9khAjPUQj6qoqf+jnyXgUjZt5pN4OvYvawbTJ5U1m3VPBaTop2cF0l9N6ej9ZF2aKpC91snuGf+Mg0CQLmA9FAvqGARDLdRqcyLxJJHdii0pvfWNZOlmBM8256ESgHCfy82B5jZvhkm83fklOk9Dmv66vbDgnMLrkR01CtOZE9c1IOoq9Gco/RX7O7T586urD1qA4IOE3eK28et9mfX1dRl222ePbkjaAofmz5xb0zv/3kCm1AA0cZJ+9CATYpgPzYJ/+Th3WN7K0Klkq2Wn/R2vh230CM5o+v59LctNrlMbBgUIMDufl1cxsWGc+KskiEzcrGcCMn9qeGzqNsKocV36ZvZQaio8ljgMLoGmSkMiTZ9Z0es0kq2aquaAo3gIlquZRJE+nsJ4mB7CJqhd6M2tzY/8Np2BltWXFagBRBiOblVmxSyBqGHWcml35kvKW6WLgm3z5Ae2R2z8hd7atq7YayvdqUMc3v7uJyD1pyI0hCr0nEu1iPvPixrAHoIPK+KSo48dZdzBebUvlo3jFKEO9OSmp6sT5J7YiVrT9E5GGkP+psEhJZ5daa6w3onJh7S+EANm9kL7GFQ5Y9tdqIuaLvPoqwPFZrA/pAjStUjOmp3m+tZMZTBkDvXoZ/dnT1Rm8ZSAOAopINZmPa7hEjNa74fRy9ENgqCnoCZzSbvJHq6+/dvh5NsC1wlMVV2D5o+wTbxApWFxp+ejyPSuYjk4xTmofyM9g51DrCg+1XcFa1K5ZjZoFtXoLy1GaAZdW4OhIJWiLYvQL6Xx0bwHjGpjuK7654CUZuYBPxUoYj3wABhQkE1bPAj5AHjWRO/zEQnjnWIFmO/xkG2CrCRS5BH0wGYsGKQUvIJqg+Uu+f6iXYnF2Fnpvc55aINQvHQfFpQgDcgF+MSBOIXsD9FP5zi+lm2Opw2v2e7/Mljuy75r17kI82URKeluxpTSnfNi3ILdk51acyR8fvAjBZCvKXz6G+DDUO63saWOdvPBhucgJGC9dz/6AO/eQTS6ZThPLbYejRRlCecEqIAEccqN+0qNRp6W7ec8o8OP6dD1sXGtG7dlJ2dYZqx2Vv5kys0WP6UHQolBOS6t0HdSiXVLEgswp15nkGlvoLk5bF+sNtTFSvrCmpyfRN1lXCW9XzwZsifZ7cYGPshgu6AX9BEBTS4S2OaEXVSHB902FYAaH6ztHuxeMLRU7zq5AJVhXq0ElVQk52qFwV9mdU72bisaLXIfPbHzRC4eDtI/hp7BOfYmEXqLksSUxR7Bk8kUD5+EvDVtHBQf4tUAIGR2ujdbW+i60UW2tnnUlfcldjAvcpTvQegWjwT3uRvKFrQpaid4fx1Ygecz/hK18pL6BkRWtYEDpOX5m9L9aeTm7j2ZVarh5f8BWsRGGOjy8mAdgimmmvWSVw42hea3tc6H2xts9nUf3slINRodjpzcaNowR4lyddtHVHWD6UMo9AvM4IcSN5/rbycPhze7u6mLUZCKMvuVZeESpDAgQyhcbv2qYX5cfOZ/D8NzTZlBdA6SFHFNihpQJLjUaOGelBsLzrWX38CDK51Vee1EmZSA/mZdBygGc4Znjs9PTHtIEhWElmOSpm7dCw2/fuX3HgzV+BEB7C/TPfc6nQlnSj5N7SXb4jftjW6TtAfSLZaMQKVmZiQLGeHZVH1sXxuirL3rkG4dhzI8rrxFxLrsxJ2r+ah88Gje9CrR4JS3DyyBcBUKNc10/LRVSt9a9pqcZc/QBLITX+mbBxTwIZSLPCfNFu22dIYbJLbfllg/gA/YYpUtE44Uc8Kz0yzaw4ul4cwq9kwSkiV85GQnDIQsSrjabowLgwhJxLX+tNwScFCrwG633t4p40nntQyQ+XEUV/qBywD8tLkrO8+CMKkZDN96LFR2tDRfmaNEKPl+lUKQAXfpAOsCtZ44OpMtTClVKo/ZhEuC8ct4ljNObjZiLGLT/iWWdiBCr0I7pNDQHakqO4p4Q7h9XnIrEAyaVYJCjiwCo9i3gpQByDIANQSVbnHBgYHGzbWDF0115eqjIZLXcDyudq1D0gzWA7xgtrXjkWe99YZR//r41PT3mdi2wLHC5gsW9ON7+cZdzzDIG5qZLA0E73mbwjbuLL990n8Uns8T4m7TZE8f+BpWtdhomdxF+SrbGhSEXuizCf96k13iRaPMd4a4o7dLcEd+5W3b3rviuh5e5HxzirbPCnCthAI7ob0D2i2YDSCRxNimJgs8S4w1Gr/s2mzYATGsflhlM7xY5560VX12cnqvpYwbb4xv6GAQop1FzT62Zp8RcmsDq6e93pAN+GSfD9ARQLoRUvZqGQSiVal0Cpftj4FgRJBX5iFhhPzQ74RUzXcT8a4SmqPy10h/6qYshVbY4TCR3zSSG8c4jq8YuMFCHrLipCEMX3LFyXNGN3OwY0nDPzRApAzajKexUNzd3CiQylVWy+fcHfLmGDob1Ierl/0BhDjjDMRA4L8zDHAz9Kws9mcCVs/DatzMuoKkekVrtEVHRr3sO1eHYEbkJBHm7ovJrICjX1LzoFvz5MQucvrZOUlWTQjgrx28gRXXLmZKLt7KWEDrYfoE3OsGfGOWOTvInRyPhb2zPH7PyRvS39luYS3BK/lyvfB1nyz9VjGbmT1HPdk8D5Vl8cJTbNk8Pdg1JfMJgXEjQB90BBVQwq0vKqkYTQfnd+O0ubv+DTLOxqRG/ze71W7VWm+5GzM5aQxO75iGj1+NyeTw2K1F575Z8r9PJh/yLx38PIXyv9A81hwZ7j5fO1Xq7WK7B7gOinZg1ZiKIVaItYSWT4k42kbHKTv2j75E9HtLxs+SeZMurkKZb5Kg1fVdkVDSjrO5tOtmMCtK1jvbFQPWFoTlsexWqvkrRRP+2RtCCwkdGCRWga4OwkmS0BPH9M1/COYYqR5gVB/X7/WnJlJpNVWKv1SkN8hn7JiQ3hT5Hww0MUhwcUHr6lE1Pr0FT8s5S860/rS7/B/KbpCeOqePJkYriJetIaTkWX5v/AvXtqDuOZeSr6Ax97CmfNHawJxhxR5aYZNWWtxSlbkUFXCzgd7/XbaFY2lzVoOqtcrNV30A7jpDDFHbD9l6zhvM8/sPQHsGe4oRy7jW5gV62NDuj7GF2UJpb4UD4DjV0SxaKLHO40uz0YkhFNkeaI7ifho+R9sIXU7MP2FtC350wMwlBXu/JqqmbjfHaJfclyNlj27cc3lZFP7Euk9dpaSbGehXlaJt3SU0Wqauqql3DPoyEj1Z3HoQTPlq7GrIOxF70K/eXhD//hloTlauUFH38Qk3wrye+QiAasfv7cnIT/OfYuU1d4MEAVavO5G7YABrI3Ri7RIjNPFm2wmgx6ovS8bHM5pjvhs7emGgJ+otVRSnW6i+9C7Y5KnslnvmhMLx/fNIriqWsX7jeurZ+0uZTg7WrW4uZOGZ8b6T3UeLz7zqxcazJ3E4VdQ5WdD7lO7fJmJGfO9wWb/hsRrOQKfaW2q0bWvvl4uF5Dl12va/qlflOWa7BIdq4oyXgJfiqp3A8C5wuZlRvP6hWOymsAa8Ta6+QEFt0QDyTXLXtoPo3nxjeHMX06uQbQ6McQuXG2AiPWanhrQokBbj8dcEhAY5gZQ/JZtZWfSDW8bjjThfH4w47k+LmjF/9Dx2oWCEd4VbaCgRlJ/+rnGG5XdlytvJk+/r+3u3BBzINwyBe7J8Mjy8+ynt0/2BpGJDYqmvydq1QWlRbnOo8C4u8aKelenRlc7mro55FjMmg1HbQkkOpp72PxdOph+BNRSnldICP2ieqT4mfdQVfw227jTsgmfnbe5tbrnO4nVHIHuKK/vXy+ex6PrEwtbdZ3NE911juhbvPQ3TDfcT+6mBFpvHEH4tcK+PLnHox+BlCYvKgjWiQujqC59JTlyZn+7yt80lLcMtnnYniFy9n+RwsFOgwP3IR/07RdFD/3dc6YTGVxjdhduRYHvrnpi2ltCI39LZZZWsFDPxTypSuTNqdpLHyTiWQy6jZFNzFaDJKW+2m1lyJDScRvfAfM07qN5lOXCKh+kjWyNeXqVqlytMBbV/84jTduSfBeeZQQLCftNw1GAiOX1RXRLGUXD5yLwGzBoMVbumRuxYSc/pLpcE/QV8CoPT1hBN3w0QOe7MqWr8mnR0eqB4/09fHQPw2Dbs83ZH62saUrkGZtXi65ZkQe1WIO3viFWL/bDCtIMDeHeNhN/Qg+y8iNnRj+4ML3JBUbIZF3MQizhQwWw3ogyTDuo9H6adVOdGr/MC5KV6FtwMlq2zFp/SMrh9PQPnCcL919NS7XEFfndnKCiMJqSTJc/OgfZk4bC/nygi2nExPaKB00b6h4cb9laZBj8+ZG0YgxkYY78zb7MVndIRezPXpCmNSNR+PIuOYakekVHFaNc+Zb5sfPhA1auEU2EuMyUBjG1EB2eI1AVH4STP4lIvro71YRzRSsCCEvnCsuKkqqrkeXA6mvgCSSuVSflbMw/InqmtWFA8VFx2H59RzW80p4lmWXtVzIjXXlp8QDpnyDb8UHnQAZo1R1GP/h/8f9aOszX0MsAvYOrtp2Cs5T38CkipvEOFers+0TSSC2YdSwwYXsodr0jzRcAxV68cgmzHbYOWnQ96edyuikqLbomuAco1GKjWoVGqjUgK+Ey2OeP1dra1cGUsP4kVeRyAhkEY4DP7CO2K7JgtVBVK4VVKT7uaf0N4wxY/aL+QV02YKtGM5bYYlNPPAMqgIgHyepDAwKzY2Y0RrTSr3K/nsosl26LwNCEB5Kfdkvjo/KqyUKhPKKEA8PtzZsWCwr8XQnf5SVN7L/6fLG45gwGEMOIIO2zNi53MYdihSLDJ4ezJA8RvNSDV+EdxcNXwrLDtdtBRaYfwcA3XSkUX7cYXvxZvhLxyII27kL1h8sbDd5oN7ePytefg2TAVaSdLxOxvIVRW1QADxREbJ4MBA52CstV2oOjzOrqg0KvPn3w7NzzwtQp+ewfuktJ07OPm+JSCv3CrvtAeFyQQCWFkuPWCf2oz1Z2PJ3UUQ6wvTRe18uX2+Akqfe7rd54Po0zWjtb1nNVUGBzxN+2/bbHP77GXSM8kp305t01ZZ2WevYyndh6mRS8rarKy/doaothHpmEII/Vm97Rs/PKR2kZ1V8xwZUojURCzbuD/ctA+ckLiVVpyx/AHQpK9tkhBKrZsiTZcvneU7Gt/MYLyFaL1WLSwWFgOtV5TZnfG2eNcPwKtZgdcogWvMnuyeQHYQfK2Nn1/ofE5nrC3WRX8vFC0B2tsoHYXB7OSVjUNveuKx9FV378V7yL9DQMzAMAUgfK8wPdazvlzKdpbdJiVK30XJpQy+xIozIJGRS+tuiR/v0BXvFF/ZcVa8owfgXrW1kXt8dGpLb+/6zWPHG7kjcqfYeOrK7ZnZ20frhLGGHFBQR3pRfOHu5JJDVeLkM3vSi4aO8tPOlOVvd6Px26BUZVfTG/0lW//+t2fcNZwTBzJZCWDwxu8AXl7RHK/x1U2MNOeE+Y7s8S2FZ10DLx7PHDlTZmnbZpncOR5Gl1e1nfROcfM/9Y+kkUtorRLl4+anXic9d3ntMvTZaN6VW4KsSjKwZ0qxxIlsWIS2wz3de049ExDlfpWL5KquQNhFMDkGWAI5pq/4P+YpcyqtBgu0wa6sYsIvGhoe+1pjSM+YV1agIxqpqaSeoqckU0aqjhgr/SCHs9YwaEXBWV4Q36NQGLpj8oZ+3isCp7kntnxzzAUJXuFlNXIxSbdSwR4AR5B5rqiYJHKttafIwiNdkVlbmd3b/pjTUYL8EL/wq5tOF88WcvVsAibFn6CxHdHPTLmw3cIF3dWovhXodW0hyq8viJAbywkg5HLyKDTPhk+c6GK373OcRTqoXgpWPv++waveik0J81k7xO8tNTT09Z103jXan832xE8dKV/yLd8ene6wbPyANE3/2ZyU8oVPwbO3oY0yfqifEkl3+P6YJMSUJK05lWksnElYIpumMBSZvKw3l8T9n35ZfH12ycD/7W+s0GO7npCMNVXv64YnNf2K6MzSzcf5fnBDy17PmnqCNb5f8R37IXfp7fsjYJ17Gj9gjtcPUaytmzf1a1k6R8K7scjPsZj5TughPpWjuBu0/t884hfFDx+zv++DUA3zXbCfI7CzPJ6jbZoDF4HzCfw9nHOfqnMWpzH0aFIilQKzWzdkJpyo2rbz8JR3UkFoEzG+MqBpKj7YzqYoIOTEHw5rkr5PJZxmN7d313pvr6j/VRQ4OxVp07o2OW5XRQ6GjUMeGvbxTv9t9uk49NPVdV++aX9e/wX/MBUJLo056vMZomofqT88XZLowoUJARZncdiMmW6LZr9KSn5VANktrPIHvnl6+XQz19U8gk9tuDrC5qjGRWq58vavd+IcP4djBQkaiagESzBmJjss5zXiLZsroIMS5SD2Sj+727IvIVJe3clln8fq/zGxV3V+EofWtCv1kxITBw88/Aa2YEdAC1ue1j3VWBAg5qPnH2AADhO3LAARB6kTAckjlHZAylKUPIKOc0APpHCo0yNbK0/SkCa/6uQ7jNX5f4tup7orSP29e2Y64jXd4hzBkIiCdDIH3RiiAFBK3q4MBmYsWXGDAoVz7PZHoEftbEDAVeZ7RGMs3o6fY0YIcN7+Sf4pZ63ziIl5dmlV9ogJj7HMEICvyRE5wMANmgUjZilrUB0j1wogv7oB3e1CaVuKFUKcbun28TIKJ7QZUm3xCSro5MfjXXyBd8o7g+kzqP0+9UecTJWe5aN7Tfmw69VDGxGYBkzglSsuselYAkxNxw54iD+VwwTr0kABKoX85ASTs+/W3EOzJRtU/0DgvOsPHZRukQJtWBa6ZvJ9nfDD+rcAxQfi5pLj98cDYuY0Gg1g38rIincOg+6P+HE8qwlIDBsfGLIXDNVX32nKOg7cHxj4aGuA6YHb1RVMB8BbtsCgF4BXmnk7Pw4X2QS0l83T0dbW1gHYF18qUCy1h4oVx4rLvscb+wBAZmIsfllkOR5/Xnx8DB1/AV2nE+PMs/PJV602/rLl5cnLAsDlZfoy8EHV6q51BRAus2tFBxpys9ft27Zv17qlANjO8mzH+6nzHY67+tXAS0sJ/dev850tqN9Zv/6h66XkFPxlDGt2WQ201kFP1gtCBtYfTQ2kJI+Wd6s4nGPZYkZ433ZdXUbQrKdEn1iK93cDYMphExK9vlF+KzllGGxzvNvS49RvtwdQfvzl9OxyyayEYz9xGs9ZzahTjteJH0IKTvX36u8mZg9um5eZ3KCtCa+myiFrqLizh7IKvFZYO/HSrUHAi9j3XWb1yxNIRxq8nArqHQRDF62DJ3QF/daAvToQGOHqH71/+we3IQt7s0XXBzwlnU74G7kwGeiJ2055/TsG4Amjsnk21N/95d7LPj3po+WmsSB73ctY2mxYSCrA0Lz4acL+5vVozGjlPTkuVHDqe7NXJ/mTkb+/NPj7k4GcoK/r4mtlZWK2hQPBrzMf825/LAql1mfrFvwx6657Dpr/lx+40TmbyXzhq5r/+6kZj49rpypugRYhGS3jdfytuOWvUkYu0oNrCPEsha1Vc6cy4MFmVOdJfFyzOexKFiG4ZQV6W5HWSmAhc2Of+IVyk8pyHxr2YgS+zrMvNlkUGrASNsaXq7tWLrHi6UHpGHyRLuxq8mza9IttAbFsnrSE9gPtbBUsXrUtL2dQ7myGR9DJnSMAJGOdF9jlzXY9YRhq7lUHd7ofhVOVLYX1p4i5o0Naoa6uJcbjooOAqLtu//EZc5raPH7nZO3AcFakUWCPFo9ejdHUjHsDIHu2g6HqGgveZIV2raSYEhTU9ocJvZwZaHz8gBOi5j51Mkc8pLiIzFzcB8Akz2r92GpF25X5NY3ra1wFL31tukm7EFDOlKu6dFXDfvhkc3LAnpG4LX6faHqieO0aWwLb3uhpC7Oz+zzbFKrenkTe6mdW5dU8svxyEZfBNFXzX+iefBDD24NxRoJrQZTGJpP0nxswwDfu6N1RIVXX9OCupISEPWpdNT82vWHXYHty9NI4slW+zTOL8/QozNnocBripyYZ3l4iVYgmX4pKFmMw0NwzkcSuak96cTv5+YUY8MrDLuMFWAxbrVijbFQSuVqHb/vlKQNpskrzwUrSR6DwB7q4Tx3Kj5T4uBuKADxNeBRRam13Zv1kEuv/elAR3L7UtAjtR5caWtG+fUJiQQxeXiGEnUk7gK5bbiTKF16sXUQs5QTWpj/wZbtwj18OQL4UzfGwUoXnaa4Yleb1675NWqhO8es3P13Yr68/laO/GY8J3l0sb4RyGEVJ4lxPP4mwicUVi1J1n1a8tSH5yzNHligzqDVb+m18KfU4KCJRA7jweJMFCoCt/DWB+wIK43qKkOBLEBsrhGq9neFbIzd/Yr75KfecH/cyFdBxqpqQH74XFE4aKa1iF9UeOUJVuQEZ1BbApgJiKI1ySVxVaXpIJR819i+UmE+pVAWU2NCWeQZ1QkqSjebsuu2CvsPkZJX+D6dB6khEAg5dB8QDr9ozyPjVaEdYzvMCUiRjXobcKf1Vmv/23g/Z1PHTOfHjOYTdltZPPv7j3PNqz3ykHvEEMHK6CsjrCKVMYuc68kdjwOrAdXGA7QXUVmOr9FdpmtEtzQkpkP4695F6OA7wJUa9HOH3NkuW03lGQcgPfy6jjzmssgFgrvszdM4lh2S7Tsqta6wsb4zmQPvSqJcph6kf9Q1mCoDerHKPao6ixO+aAox0sgv6Lq41udkE0v8UBGnyxWFX++7e1tdv7ByFzdc7hZS12kp8pXnmHTyxoJkrfiewH+UcLKASYsSYxLTOB0vjSDl0LDMnJrQCC784dB4pIiC8IlUt+rmWgSvoWpXICyMgxR9uPg/HrvCecUFvP+yMwQFAp2BW/Dgt/IE9CqKSquKoOAqGHEAhUFAlCAASBzqFwoU0soOBjEt/laY3dAYJ5a8i0Ep0o0qFBuiv1jFSCGlzwcinC9yDHA21OlnU+aQCvJ008vdhF+uHOh4qWA9FjrE6c60ZcKzASPZHIDSYzW+SIBqT5fJkVkSy3N2IuHBcTw+49tWaLSEP/V4cYuC3IWPK/Ijv3MLSX6WZHTzfvIikl60rRc3Jq/6GTVgT+D49czWsUbhcJnmt4c3MtKle8JuJc7tpFlu52z0kYgAB70c29PuCgQZcMBCejojtgud6/x4ScUVsjzXzHweWVdGRwKKQ1FNILEuntVkMeKvXV3kIEAgOBOK6KCnNTRQ1YLQ6FhZxKqMpynPgDdZImx5xjw5vr3c4tH0zsoPHVUJmudE5HZtfcZ/jeQUAtpBDqEYd/xDl9A0UgI8f/EP9VX6yKnqo6aWvop8FHY7+3GnsThKQS0ofq391DMTDUru7QnuycWjHCfhc9M4Pqah/IAD8hPfxHb/zf9e+3O6+7vOKHlaPR1HQt9XJ1W//oe+uAtokFIuFSqVBAYCPqBJRRgn/pkj/xw+nxwZ6CwpjxXrhv/6Yk4P6zm21aPVMcg4PrJFeqz8UsjqhDgOTXlZP6S0UvTsyoiqmlFXqSSDgx2SQ8VQh4NEpGi9f1Vv4PEgRt+/ressSxnHHmzvsjBlvo8mL85CE8cUTX3hVt0StnxNzbmaX/SbU3Ipli1mncbIIAtsvKzRipCu/DpuWJOTEnioYMwggwZg0Oo4KvtNof3E4+Gr6N7WJQmmiUogP6klSnH4wu3KlnDj3PuBB5hj3aeaZc7axiaXY7pYtrmxugGnS9QPwjd9MrPJwrZ9PIM2mPIgmPx4i1nZlLV/xrr696RT6yhh/uQBtK03kGjOqxp7RCPLhnOSn5zZunNPambFsoKupiReiXWsnBt3prtFYbEN9eKx5LqYghkBdkEkvULDUTGJzgRlLEKMb9AwlCixMrpzxiil3U+sXd5EFDvbVO1wjqN7uSJzfB/+Y0WmjqJySmnMNNVg9rwDN+1pNqB1hnsHPeUZwt1MGMLBJcMKIv97wJJRW3f7G2EtWwSvux6jYSdmj1+jdXa0HN8awNAZ3u6G8FQhml73GwJDdcvDUC7+FjIwob6X24uPfw+Va0em1A0Rd9/kynVans2o1MgBbsxy9PrTuCun6LMY7Md6O1Tvr1LfLJFHMgVIhZVeiAQYTW83sa2vJGUcmgMCJLd1jCFwuKTYMzyCpVEMyt+4yMFi7xdjTnmsRazNcCVjhnsPvwdWW5ExW7daGt9WQnmBAoJ2H10ByCJhZMwXPoFxWdeH7S3sgSJ4LvW8xgyjFlxXnEKRMbYW1w+axDWuq4lJveVGOTxorvIG2Yuy/7bdGWzYGgHJKwKF55WVL/Y7dmY+llQ1Ma3zJLu3u143EVJ4PUUVVuGIzAYLiQMFJFehhcwCbaMHSkHhjQQIMDAymrRyuIpFXHRSqsaUqVZuCluPs5MPsX1TvAXuGmGqe6pbMe8gzIDXxHBFWJAKXX14ny5IBjFa0CT720POKlTsvMG/QgXzEYiXbesUp4xt426MG8abOnMCch06T8L6+nhu9uj42p+/1jTeyZjHZGqfdiAZ1fObGLPwYlJXrZLX0vw5gpOwpqI6trSSCwVssIFkCsurFxGI/9IE/f2JTOO9THR0BwKmIe2G8Vg7lpGw7tmRydKkB2K4qKIzNqoCAp89d3vrEtPGyfk/BYoVWOgTeIwJgSG2xpgvIoRKAlQfuCJQD/5gs9C1ea7CO8x7bWD1Vki7Nr/ukcVxio7PwmdMyXSqprDXShcVotfBrMKpcVWTT2VgwdLhYrmVRqVa9D9Eg2/rJFEwTFZ7sDYi53hFBhV3TIjDaLmxrRFbF3y2hLeJBT58hgssebXUK9yGseipVy5KLCzOgPcAcC1A5LpHpVoRrInZNXXwKVrj0QrPnWTYn1NAIF63vXvG2C4xtlFL7Toqbc9YaXzkW0xHM8dEGkXGAK+pUuUIDluKxYdlxmeurr3vLGkHMtxhsEY+D8dbfaTa0a5mn1lVXnFxy3NWydC5kCeoRJ40ywpSzm3vAdhlq1ysPMvJEEn7NOB68mwIU+kslktn/3/GTx/18QDzgFXoNEQZWcAozSP2PjgZUP+05Rb52tGJZunxOhWyVYp8BFtVvxhRYMdYAsbI5ISuJK5erxbYOXwu5teLTxrgPJDZiKzCeM+ZmCo3I2Rtso3N/2aGNH+sp9rVl+28HaWwVljFpHdlnBMsAib9nbLgORgojFXQDnAx49o2avoxBu3WDMTqQBpSLagYybVPmP83gDFOx4+jTftp/k7eWwjR+O8vSmDnT/d6bQ/dd0Nlw3WZXAwuelvd4RWQ/9d11bDzraU/028Xsh30QXfd2PdaXG50Iody4V7tOpcwRmcDOect2qP8C6uKBa+xjhykT/E8j/pVFyFJ0lcKEpMS9N9Lht79Ejr0v/dBnkHkRzvYk2/fJjYcrK23CPutOa8/nE/yjzHoM/wp+gTD1USX9lpQBnuHSzau/49HTb00PGLMGY7XPLBDVq1RkjXoDa1azQj90P2aUqzatvHCcV27Qa9/oqreUbHXr3aeXrLqVyvcqYNtKKL5HWqOnTKTX4E6AGxcVFsEgfvgslAeUrB/jXy0W9Th/LZwMLa/X8cuhyDGhdjaGETPtQ4VReDv2vD0wdWyf3onnvzYli1yYvI0qbJL6V+NaUp5YmGzlL79O2kBkiMn59DGq8eLUuxEu8Evz6VJKbAclsj5nPZE4sXpK9MSYA9zrfXTsWIB6TI1WEwlPr2lALPqyaq8qVGXdqKjDPP6E9clCYXQ2f1I42YG/W2/ucaRkZtMo4mZN3obx6c729VtAY/QCTf76iQ1rVes3gUfolm+WXExePmd09E/xcvKtZYyU9E0kUD422t4+OgqQK/yqfPFIX1typK9ArFwn7TPFKpCa1v0tbWxskjaUQydsxBskMiMhpaIo8s/hoD3+cRYL98kjvMr174IbeoBGr+yAS51IdzNYzVaDRQ0wqBwdTDURLTl1CyCq+W97Mgec81+2M7f7rEGWG4v766ejS4cOyc/pixPzPB4u/fq3TsT048dXpyCl9He4iN2EyjWdnbLuUoIB9cFLwEXuHDjdfWl2Nj0DUnoGS4y4/XfAPuFMqDqUnBTiiySNsGNfM/B4Kl8xUUQiZkWAR3uuZZ4lzZBIfoEDngeFH1PJg9vjGnBz/2HqJVumVyac6ghlVRG5cJBJPen58Sf3AELD8OHeECrsSBpLTgZYBA+/5YvziH5N1c32m2HvvNWiNrW6expF1UO2ulvv2zzYYx5nBVTO4jgsOzi6c2ZS+6TqWrpFaMiDPD0eJy+wIHzR6LNBZSpG9XSlzlSCcbIGupvwy2Ox/N/jnBTfmiP+BCxWNSKqnc7THMa437y6f/1zWuwdDZzb7nx4a0ikGdJZ/9lac914ev8mDgFg76oZ3yPE3R8dyCzXzTD/hNO5OzNhPGBaE3Of26kBPWho5Ygf2H0w/nHou+49kkK1fkl6dYaZIONMlTF7H3RlRq/dm4WbrEqzse1FK7uwDf3XXlvbO//+D8jud/iEqko/KSkf1DiJTfF3ZUhh/8LhLuZel6ygC7BrATJx6g63lQa0z5JLHUJ5AzaxjG9LDycDDoq0Bb1Bhem3qFpRoz4X5fECE6Wq3hyYH1f0qzqaeF6ua+pmdcU6zIBq+dzwUKYFvaFl/b3FPx9O9NHLfURirFgMY3varQp220Zu0mHcbAtu1jsMRrSsVgz25ZQ8xbZvPTHw7l77U0D0umGKZwbtd3WrXJYwEwB1S9qJi6lO5kW7LJK6tngGpve6FTV1Otpdl4MJiiqSm+FVfEUt0pIbcxLZF4yC4viU0W77BG2rflz3/yPP8fUfrWjpR9lWzHYGq7kNlzxBhtrzilr93mQ0hFKUPocRRFFqhSkIHDs7uPXh4jyNHhujays0H5cZeOyuHg4ciM1NtXg9iUiEExbN60NpVabwu+ItS/FRv70taCqXZgyaZz3IMaFgltRW0BZU14LxBFKDF+ooghCJOwIzXC8+p9tvPwy6Nv5IahI5JqTMMut6x7ti1/+rdLlQl+8JpCQ7KMLE5qvVuQKm3HY5oJ5W/1z60W13BX1I9UEVU6dZavfR2ZrfV9J6oeZYbDSFGp5ViNo4q9wzEjhNVS8hFaP3dA5FPJ1BKuvkXE9Jr6y1qVK+UR7wlTghJmTSmUEr/aArd2mqDaalPeIdCJFZRx+nJepMYYen6hOqkLslmoUdy+IuLmvxjXNbLZg7LGJjI4FdtdOCWpLpMtlbvX7QB8giv5wPWmQt/ok+l4P8GY9KIjHZoL5YUGtvLK6UFfYM9FSkR84gy0dHu3sX1crM+6y4nu5rRZWzuDTueKdUMKkqq1QNnglKhyZl1QuXSL5LheCZkDRpVLIehluUEw+0JDVhvUQh4hY26NDeN1MbVBK5XWu0+zzWyII1ZQ64dB+r34I5lbTQKAUAOu5EUVDWKeyuN4shEff7gpYH9a2VqdJsE3XnBQTOLmkcdesm3NflRjhtSZ0kdI2I+0mTexxaP1XQ63BDZ//B93kYVeHhUmlZzb5Yi6e0i2xjff3Rpptg4SBV9XEF06ypxW5IAhN/zs6VhVqYB0VsiSyfZ+dYpa3CTOvXn/1u/jhkXpyrg6c1fYlrf4FpRvRGtHJSdbj/6bY/cv4BDJ2gCRidNq9BY2K2/ycns4NM+4C3Y5GnGFdenPiYhOBQwP/LCSuRtu8ilH/OjS3ur/Ci9mxNzE+lNdZW4+D4sHcyOcpkO1iXMGgjAX2q2aahKtlkR8PbFzgpKQ6MAqHxbsiT9XsFWFWgOMXvXlXmSHXNXYC9PHrKdXa6WYmKsirpxD/JC35ERkq2PDN405Hd8cs+mNOXriUPfeoSCZ95rNuBi6Y3cxwpsrJrrMWl9A4mhdBcTz+dEjz8bJWSmIKJSuHgT3/z+Tweo0WhqeSm+95yvJOh00KdnwNrKBCIw1VzbDBB8HBAM/qyGxrCMFK4V+Y06jTUKPS4C+JeBclr+vHEHYMlFqC98+/Z6e4jqaHOcOUvFZXTWaU593lB/bhwIN/27sJat/XxCpnROPfGoTyymqbcnnA21OxXjdMT2lGV1x3tUetKzW+NIyyZFyv4Y00Pj/qFxoxChQRrc2jjM21KL7jrJZr0OalnnintqoTXZ+YjiMhBaQ9Dq7orwnODUHpnhXVOo3Zp3a72/NWEioeqakzkffmZoNviUmE7/oqf3zLhbSPjXqtpWiZaYL4qA+9ve615wa3zckX2df/wzds3GYxQhYqSwW1b1fdHWB+I5WdtE46ZnjrD2Rh0BSVqah1YWq8v4fmFJYVLawvwRd2JW5pFmf3FVT19XA2xS96hjYyeklrroaioAh00utZhW178g15skdnVJUZoVFaOSM++TY3zDO7a6LEDzv7VKb1s+XBrTY73XBJ9lJqV5oxNr5Ucng6P+IWaSbkSV0ZDdsNv1e+7C8bTcR4XI9u1tuLMJUx6XNVO4Xh4MpVPUvpQmi7lcFxtFIVdgaqzs/UceAPdJUBLyulHJKElTsH8JupakluKsCD+BOmZaeWq1ogoDlvUrqSSZZcn8JQmRcRqkTVVzdQScaWfDQBp4KPZsPa37BScZjkmhJFzvyX/PxuVwt2/pECxZ+rQ0hIv53RtuyB7pe1uUrZ9YHFLSmWQf9wjf/TFRka/GK+C7mJNytiSbW+fzeswa2dRcXyW3uFkGwTa/z2Bkd1zF1v6elRypbjQqE0qqvYSh5VOpFF9ZzSS2rTzoOcveCQy2tadSPscXKYJOXR3MOWiW2+znCMwRSO2puPX7rWAHhx22cKXdWci7ZNe5rodkya9TIvCOHdt1o49R6doSl9YJ6DnrzdCWCLRezbcPc+LKmgt14/nx3TmWzC9fJl9ISC14LQP+d44bXXZC6bS1J/j/5mvnpl2rp3l0MoK42yVmPraPt+KbmR8Z3fWT56dHnyBk+iCzcr+wergTGRAfuRH0jrb3R5VmqjMj1QVZa4aK91+6HnI97uToatazoQV1OBmwLTSwpih7+jiwx7ldTUz3++r8wUh0V4sILIksleoKr+frXq22/moaioIFHPfZ8tycBCewdJ3t1+7QTauHVOar5LxsfpjtoVmDImzlT/BpvfpKpXa0sJ9nOt4tWrgxku9vI/caSNG4DPPDHLWO4FinsJcmtn6CBSjLMN3rf9hhjGrU200cC0TbfCF8d5bIYXxLZBt6Hh2m/cLQ1d10R8S86b3IweTVnDyx7u8QNHiypzY2+nWyRzk2+0Finnpv/kyvR+ySCS7eVtynSznXexZZGvvlsjeuSOS7rqWkKq6a6g2a4NnuyLZprPxy9u2K5YgG0RGU36/l287r6VUjx77dDj8zNvqTC5yz84RzaHwRpXEOeRXASoJMZk19knfHWo2At0wq1HbRzzn3SF+9uiZuMM7ga7t1X7CTyj0A/GPqI98X/vbqzC+g07vh5sfMMxwESfGE4x1plKxzqCnZkQJIrhCsWB2UV7GIdv1Lsd+1CjstrFRm/4qAtmHmJkrnXtpT7w8p1E7/hr7ddW3BpunfqLonVVXLlgkMWyvzJymaEKRj6Ws00BNspuJX8ukbB1ttdsLDVv3/wZTFr/KeNW5y/YT6+Vwwf9bkqiRrepoWZgrVfiVeWUtQzZngftc11JqWPocZaKbN9q3joFljvpz/GnPPY6YBUPLSkNCjAf70t0vaE1MksXvshxZ9JbbJHtCkkAFAlFzh/LXG0TxXlB6hhVHapYs0g4BnqmCYx68JQLzBEpI5dn2YLuQUAqqfLay34CPkDM0Nc93/UHPls1E+jvWVv82JLzhbDXXQ+F+PCOmep1dqOCgFEcqwBvMdfXr2p4pjHApN/13X7y6pmSQUklhasEahj/S7skBl44OxfF+jgXp6KZ30f6bKepIQrNULeKyxXxuPjNBkbvCyaWK2uRM3j5idmAx9uv//eYcy8TStcUFv1cVOWGQMCTma7meWnBR5B6MersCSaR8LXPhVRnwXLqIXOf6e2bwsUVDkywiRy+os5IFLBll4vdP72lSD1vklSr+E3h9BtA3L0KoC7UYLfRyTEgt02nO+nxm9U+3EbC7/otvjg8eD/y0+bU1CtckXLq9sDo6gX6jIpxwqJn7WQt2C3D5Wn0i30iKjjv+1xJB6uGijuHkvTGO97nw/s5gu4hADq58c9kfV8mLqcGJ/S9/liC5wC2RhV7tdOs+4YNG9TaD5VlzNWMou1/FWgVA1hJhWcGbdh3VZb5gr3urHLViZbCAuSEFOR2cYhhUgONkgHUgI3OzLu1tR9/gaLutTe+Ev7Px2jmOM78wo9evvJpqMwuyq74p813AwoDvA8fmLJJnJkxuCJB1Lj4s1HC1XcBe663Qtwx5C0pUWHREs3Ubo7ClQVTwfZ6AIePXOKLx8fTiSxfUvw+u9/1tfujnsA6k+n3Das+zIxCpOcktFYZ+VyendTWHJ49zMIlcSPceBkzkfD5wHFoQUTNuAbU3eEKq3bGjPyZvS1PxXDW22H6E3ZaPhfX6A3iE+OuCJQCiyva1CwRMe3DGwOCg5XfMk3vhWpCquKKE6+w92z6y8vIMyJv8Ta2opP7BkH4dqjvcicNauPjb9mUH/vv4E7JjgjywCtO4Ed2HjeVsRBRq1TD7o1qLAtSWHXYjLeHVcWYAu2eUVrsb35OfKCIynTHLe55rIrntAx0zRQwXsm1GboetKviAX9osEIRC7cloa3sseNn3yh3AuovqzCaD0mRWSrmrks6u1W7L9n+3jCC68v8KCgzv62uSVEmBVWu6dDIEVq4DzPbOw6pBMfVjgldtKV74xJhAczMMQW2xcd2twJUiqwu3Xi/7mvq67oBil7if/0r4qnefePtxYShEgZgn1auUXbiAZl/YLcA8jAurOubqhkZjq5UVnY8bheuC82ui+qVW8Te439nhsUDCl2iUslaCTtBe+mrHW8EejPxi1OJKtLQcuVzdY7W6D1I+KxkXm5AKqxUNS/7/kSELcrQmqv24frIQfa5Xt1TJW0fRPg3ouBNb6iC3ptGZw5n8Fl6bbhdqmQTiw0Mtj+uoOsCn767X1XZmAyU6Dgd73j0Pq6jDkKPKOiWS8DQG1nhOBP2uouC1SdWMmXgIpENSzmATMxMX00f/CV++V+3dimpfU+YV0Q9KrkOAIruY0ltTH+4EqVGw25QnU3GqmU/ntae8QwgQXPgfOGLGHZwaaN3YruL1Z3KpHoP5rAX62/g+m/x9UzktrqLBEi+hsGtZQ13tTENpKC3xy6D43/BnUgtnfW1DX5B7y6PwT1xZOTyWii37mak5GxY3cg1lWT0A5TSHaUNJisYFEfd3OKR6tDnFMVsStBavHMvbCo4iJxNvh39nijMF2NASOxOfyRXcm7yRk7Kdu9EyS1ACXqyBjo7paAjHL1jEmQyZ/DcYU+mrxTQGj5IyfXxZeJI0SdrI5x1yN0PlUCjUDodD7VQoVE6HPb3BW5Ugp/aQSM//HXiTZ6TQvw1etcNifhP+bTgXH9fXrzf0v1jK4GAbsUTGfR0ORySq1cdFOdNhBzkh20Y38LSGcB7fJh5hPN2Tv/w95p6NzKmPQDOqdtWPf4wS6KRKnKn6iwbtLs9gUonLuc7TWAA2YvN927p7QNC9+vp7oPygHleGsgIX7x9I9gxM8zCy8rVOTCaJwVQq5CwRn4P801ldZFQMOLbiWtNpo1VJUWfb7rNTxAK6WCoVMhkAImi77C16cMWj/P7F0RX9IlFXGl2BfVJ3iy0gBJomRWeW/m0hY34I0FxscK4gw/bcopwD527guVUu4A8lSM5y9Prbylt/j5W5LU4r9JeTrWUJYrljaCIq2r6iuy/4TN6GiZ786I0qRiYtWqfAx7VQmdGeCD6/J+4v19Y/Wqw4dACw06NmjEWm7ykb2Vob7Wa6mW3VfeeaPgtwNH98ZHh4fLT/Ee/R7NsjhzexqmwEjzm6gfmc/zyXsbUtv60rORiwRjrwLG+rDDl6o1LT5i4nIWNbtdbgCW+6qASSl0TT6N42QmUWGjp/7seuf2T/vFDxNsqwzS08Z0c9d/Ps7NAwr1GQoE6BSnoaNCfPnZ/Hfp0oFIkBQEq0demv9wut5VSf3o/zAXHRdRFBgUCg6darY9FGFFUeljU60Ku30DIjFtz8Gi00iDmFh2Q2ntjQHgwt79baEMX5rNqviK0iCFUnvqA6nVjkDmMB1j/kjMOFMBZ/Vz39FPDJP+Vwb0C2Jp751gHQeLblFEY/1+kQ3fNu5/Omh+qQMw2o4UbezMaqySpC8DtSULu6hacEq9qdgEDgEqhv/cRE/9TaDo4LmvXokJ47N9AvDP1uBUann3ZBP5yLEkW7uYF78qXd8cRQd1fH2TbeT0dgOBroeFXigV7RoK7yWBHNe082o73txdn+gcnzGTjIG7qLbbyPKUlbWMELbtpwb4MmMOXweN0JPAB40EAMehOTcJL8HYL67ksxZvYqnVnhG2hNUTuqK7CJEEwdYNctfDMGaq/WmJTBsXgPHQBcLeDHArk/WuLwfVK3AugEfkMbBTx4M/NW9XZGdtW2+cdDxZnt36peeO2hr9sjmTvgIkgpFq5XtVdIBnqWqfqEzWI5HAAEHpMg94fnWKOEHqHR9YnMlK7icwBvVnMVJDe7OFuabqF/3skbCPTPfzO//6/8LtVq2yqC+mvreH5/5iHOof6x/LWc65mXu7MvZ1xnAddVXa683H/C9yJ+sOKM5Ez/MfwJJhoUvTZ1WnX69FR3tcVwNRIA7LyPrGcimJ5YiB6IJa9KHUcq+09LEaMUABDIaV7KVoTSckhF8ohbkdj+PDDXUoQgW2K+o6rtedWpnmi7XW+VEHPawNU8iQG6z1TL9G0DoSHfAYCT/3sBrA++84Am8HcgH3Y3HOA4qG39xGTr+voG1frJiW2JDTXyl0/XVr9yqgZnj7Yuu3tdgKrPjobXZG80sz8tIKVErB3o4kU/aMaSxWECw8xsolpvjbZ5Gayn8sFRiOLMqYu5hcYmwhSPCJIzBhe3cIbPRb+aeYTtK5p2+rQPpvMeA/HX9QZulsn4TpvLs7nGcuv32Q7OXHiX4pM7+Y3wbmczR7M7Hks72Sj9y5Ok7OGlMSXPpR/1Cs087dvpFXjpcUsQVWPLEEtjee6ysnsPrk3tB9NZ9aBNXP/f9yCdEbDlM50GRBDowETVDYpsrVZeYpVSL9V7vda8BKfRlksHY1pVVb9nRP3mKrVBxvlu60VhAW4PebO5xfYXWiW4LcW3cFE1zhqbLDZv1VkkNbUSs64qPlXCx5pqqggt37u7QcEDzHkry9OJs7bpbvve6FL5sY8ZCfNBEUHkz1Rcq5LUdnfWjMDxdtbLa25544SFQTSqB4yLt2Dsr0xaRHC99k9Hze36t0v6cw6yUoL0SwksgrzamHCEmH7gX/zE575wILAk7Byrd0i/LWU49tcd4nH2znhVPMUloUtCEvw/KWkyFOyNdDgqW2JnCrgefvYtnHgXv11uexA6yecSHrxkN/8ZlZ1YRj9d0hb0ICq7IjtsN0pT0UbXB91Dnq5huNYljOoETWNeI+fysC6BTaR+RWdYqmmkmTJxkl/c1pZIhYKxVFCKt4d2bWzlNf9fW6fugcrfdbEN6V6bvTdt3VdPC6qWxOpaamUrHb9kKKjMMQCLodnPlgewgY7KE9FAyevtAO0kAmnW0jwi4zxg/4103GcI0ekhXwHUQWVmy1ZGrx9Lku58IKwPwN9CV5NBMZgYMBc8An6todE+aVKCSszsa2sx37jPI1XqEZ7JyzGWzZ39oAYAYdJMQiz7T1LB+ebc/tULqTXhrcnIt2GPYuZJxg9AmNgWAnDUTFTVs4ik3y6XtRLEhMAkCIQEChUjdibCYRa4myg8w5+/hd+oKRDaZ+XF2muqGDbf3UIEIIF2QyjcBSMLFGDk56MUJq6X4UHp3pr0RrCW8VAUn850W1O0Mrdwef5yJ4/TZQvgajCqwAyMdsF9BTr2za8s5/5UB8m6niJHiarBugmQpCsg4c9p4kBkie1SiO2YDlWOgqJI7RuBJV8BiUM8UFStLSq3pqtGligxlOhas6R1xFDaML1mI7oC0ubiIl4f/szuhxVdPNzxgv8Bzahe8s56C6ZOJG1Lg1A05GPrTd7kR53TGn+V8Ii1Nys2YwJTttOk5Hgq/k3t288tYz2ia7RbiHlqJjl2X2cfEphnjzfrxxRFia9VV7WG6HHQ6MCW2e8QgBKeZjNjkAfVunXnaVq/XfOWXW/hnyfMWte1dZSRVtMoBpof9lhxrRdhq0skzl9jzNjjrd1rTPax7vv+GiCl/7SOA3bwNRXKQeXTxchQHLsj3dFFU7/k83H+wB5X3JAtUv/v6y57S/6olphPzcKgtTH0lelw70io1yH2cw10VO0zRfS2jockXZGS8an34EDp8/jW024wT77Cd3rD8SJsT0OGuMDlZR6q5WaSjuFI3iHz80VmdT1JnbzcHSE0mNN3i2ZQPHi2oJyCNOLizqqn31D1P6v2gh4gzkeMcoG9U/t/y52CpjLdAT1HeCb78ydfoa/59aUUg0G6QV27Ln3/e3qPlPsfaMxLnzZZNJbsWWK0C3o8N9ghPUNP147xSfg9xYJJ5+newWFjVSh2Y1tYl8Bd//87HoWsI0VwgDVUlc6u/ECI7aFlc0hTi//z75LgdH07tWHiDtLvwbuVMEmA8/UXBw7gLD07kl2FwQD8vwUTG0ziOzEM3nVfOcpcfCv3n0BzvORurbq4IaEJRtaW7YIg88LzayRYE54vRqYOL/5MJ7P8lZG/3fHrCgTJNdi7WelsyPMjk4YjGTS0v7ntAid5FDj0Rr+IYNC8QRMe4t2poQTsYRiSulbwsVTGd5GwlmoexYoVl7gc2UwnoBCBgHQ1B0f+2hKgYLAlickaGbKRail/ZOV0Qn0U7T6iHcrBP8fKu37BlLd6hAC1Lb6rhEVXeeNvQ8KkfHrTeHjjBrZN9lajMH16/SIJshdnQ4QAoy0+1pHNlalBZ6eqWguF3MUZEQESv0u71lCYMzKQkJrtGRxF98h7ITy6TJnGEYK5kgOc0lLg7QVF8KYnu/WXj2bzRhixD0jxW6XM11E7eIHAJrm/RFZYMDL5odAGbxuHUBxIEotRUbA2SOKCV8mIlEA7HGQaUB1qHL5BxH4OXnBbGBJS1SVN3R8E+eCXyt/M4H2iRAjo2v6UqLXJR9cbPsXUQ/k08kIQk3E5alpp+jt+wRefZrvht1wixV5aF0Q8lbWkeShcK9g3DxaVLTfb6Q1d0lo6PWENQiY3WESDgE+YfIa+R9ZmQ1MVmO/duLi87wYmZMb/XoJRLrjDO3PdvdOdDjNzzr+9h+dpcbHT06cElL4YQikrffj/xRElZpSF1EcPn1Op4ViWa4kfgXCPICdC74gevxJPqwgjqxOjXYD+T62MchbC5vNcjtX8/OVBgsZ7BPbpyvu/brXM/WKt2rTr0KlLt57J8N7s6ZcmchECzT6FOG3iizv9KS9tut/VPvgH0IvFowFHJbMezWtxWiubL4CAq3xs4UUXK7ngKMW8r8dRVSK1qmCWOcSXwGp6Xpm+ldAuKtwrRNDQQzCL9bkGaxyh1hHrnR4o9BC4zr3J0ENcLF5VE3Vbaqvb0mDdVg9WmV3K7E0F1BDM049Qsz4xfLNMz+2CHqIdRFd0fuvTGS9sQEG1gfc2dOvUhZ8x9BDtIMaw4zt2ppYeAoNY54HrdvqpRN9EN+mbdHThPIYeFnSeKhhW3m/qSt00Hx+XFySi5Gv+h7+4PlUTlV74ulwvYbkYrqbE3ql9PqYJqfmLPMbg7WMD/lKGoKZUT/E1UeVqpemj/TKMS3AUEqfS7gtmjmCwSNqH0vjV/bAzNKg9agJ47bIKI1TBJ87MrYCZwLMhp54biKVr6JqaVnin1uVoTwCDGl50V7cfg+egh6IJe2tvu0sOLfk8s587wS5V6d43ylHwmG4CK0eYtVM7ukvOhmT/Tq3rgwseSADFj0z/8q92AntF0bvzWPbtQYd/eibrYtG/wPPRLgTdD6nhxmPXy+KupkvbRI8Su0jR4oAugzffTRbEvyoxO1n0gnfE5QX3193Ai+njsKG33sSMEiNSZwtZSE6ZSpKUi0LFk9yNG+k8vsyhaeZw9CgxRC6Y1yn77M1UIQtkCboYvOpifkTb5pmWamiRZXQiqrIZ2S2w2hqdMCUjvEL0KJHiGA29pxZ7PZrdLIRsRdsyUXZ0qZ1StRckcRc/FCNNoFi9+FaIHiVSHKPFQerJeZz3BuEaRxLP8nU1YhK/1pud4JLE2f0dpa/915dNwQv44Z8DnmW3HE/DOlwd2ORbl5lVRryzRzkDO/9cAWfEnZ9OqAVGy7y/UOcy7dbIyVQsfrlMrl7HpLTLXyHRMjC09U4UHXrtYS1TZWcJcGnpqITrOko77tGq6tgFNs4vxsPiK6O1tXjtc6p9aWUf348jr49ZKj32ZmbKlXnsXQ0a79ldCr+mVvva/T8mpVsyEEBgSR2cq39gwfZvoD346ZM+nkOb89fihTF+YPJvAZBAvi489uT//B8yaqr+YqzpG/yfx/36Y+9jKn91we4xu5oa7v/dBq8DI2768CiS+Do3v/Mk6w7AxIGZfmUAIzXZ/hFkSTByAGDM7/4BUIGFf8fpQQAYOwSgytvuemQMAVBHavips69p8x65f537scM1k/399rcFPhZEBSGFCayG44znZzqojLguZx3go8HK3oxmfZcB9FAtrR9+ZpHY5KGzyjQGAfZM0jS0OlRZ+weV0J0JEQwNNTsT4H2S4oBmJt9MzUokS7iHymA145Kv2ZFAZfCcY4EZsZ/SdPirQW+OkUHbpGYG6Fhb0yDajG0Yso7FslcHGfThp08g3B0G9+82XGB/rDJAht8uTeYtFCtJ6aSSUQ2JiyaDtibzxKkTQTSQmFmuWRbYI3q6I3/3c/5erR5qRaYZUQzZsnBIJ4zCTqJdQ2bxnE9w0i/MnAleFbv0W7utzTo5K7H459IC0Vm9nxvQvTWr2/alAj6yGp6ZnVYcTFvsMF+ZtqbRdGyw4GTQIFKzz0AChoKmeCO9mq3BvpIp/rkT5bR5R4pticRyI11D20EikK6xNGyrJusR21prFreU18ICjy+k4uWYytYbGsve/UIqni2oEEb2+J0sZEmtVKjtDhXQbkwzlUpAq0kUbUDandz9kh52Vuafmi6ZlB1MaPOWjybmHK6yDDoTfTqU90c1E720n4pM9raH5WccGYqiaVzNl7J9FKs8VJCrPIHmVMfcTklEUEA6a6xIzPCmwKktiAuLOaLVwCDbjDawdj8lEgRDXzWZYNewzrkyf7ex/JkUcUqjn2hAOkjJxQ0cJIzulvT08VT+cut8RBmCq48atcLqn4xds455uJ2GMxlTuIkywymeC3Cqi+bJJmHMa2mpHF5vKstKO3IDMmQUELx62G6eHVOxI/fArJ4HOwkSssTsUUip2MUnJ3J7d6dljyOley0UwLuNCeHorFsRX2IRUJP/t+3mmZTylNzI4+uwHjtcG64Bd6jW8fBUcZnivYuNBc277SN/D9XjqBuKjLd029M6aypDHfrek9VgexmaakI6PIOjzinwBq26mIrxCo4QfpS/NqgYoy7AsK90TpZDoEN0fREpjw3Ktjyj3pbwojUAKWQPrUimFYk8tStNbTtZ+7CR5rZRofPojuoZGRONdquLM7ys41YComKGxjF3QW3NwDjE7ALWzGjlWU1noSWlp/fIoyYW6WKdQznMny2SNzQXO2ObjoedxBKzUgDKBHgHaiKiHARW5AJSm9G+aUPDiiwDwSsVM+mcOIdrSZfhu4WZsol9iYVq4XEK5aD3GoXKIBkeSYolgp29M1GABaUu0chqOFJuQsjX0J+DzegOrKOJKYFwDV7zqoupGCT8L7ZnepLRrOROR6uSa899VOHdzuHZV1Jk4Ok0RbbU8hjlWZmZEZVBVMb1wdBoBWiOuOYyOCXW4gSRwk7lRC/Gk2xnnhK1/Rm7sG+NePr9M9pTNptYxHdwsSymPCuDXVEVUZ+Ofs7vn5Hu7tnEa3bH3SdJZBx2w2DYXEZUd1R2Ok3FFRZRWxMTvVnp4LVjPHZx/PLKgeBVlsN925pIm+/tOD5OExFp7LT2EDDQkhvZjjCrKoO7smc1dLhqy9pj2i+DK7DWEobPj7Tip7bsHBmBj0uLsMjFMQAeq8KXZCi5Y9YAV/YgWUCkVOf0CWMMqqyMP+TR6ZgK5okbrXhnsR8CRoNkS58HSrZ2B6P8MofZRDoTi9WG//cMf0bnWdgz2L7+AnQ7el1Ne9pDu8I4V34pcicNxI19TBrwsSfFIO9S1GlbzAinEEbUW0Vj9Wg6cChf3QP7Aw1WBRrMDzTY0j7JUIupPUqqI7g4RM8+lbFG9d+2GAsmsKKrtJD5sR1MfQzlKXtgVBFRDpDhE0k+wQBPQRCIE9Xy/A7+ZiKLh/PmziBH+5YIEy2ptja7WYNupp/bte1KGnPb4MEtvmLuBjb7SJS/63voSDFvpRVik+uadiSDp9xvEtCKQrvD5/5kNJ/1GGHM8A3xbv4iSm/sc53t2KqlBCNFd0fCKSBOc1LxcyWVWcKYM1i4aUqR/KpwoJRU+ogdqaai5/0iJ/sn+FiTk+KyHOOQn6mHA7TbQFdK8FkVV4sz/RVWbbVEmzUXMRhPtcZSvMT/nx/HrJhrUQC8ycTQQlH42gJ0qK7MBu6+ojNTqkxmKmlPSHfk+hUUe9YvD2zhOGdMx0K2GGMQzvgnRcV4JrV4YxXiZuyOUncRIxerZUlAs+PvaIk77y8554nYL8FnY7sLAT7uxhdnknqNcKxdDuC+OwyFofexZeqHrR02tkn0ZoM4FagRcsBg9/aJKXrU1ydGh54mkHDWubWR8nayDpaxyJICl984a6boHzd8BgXQh2xi0imdBfYW6VFfnxgdqitVYEbImeLnygOegAj3W9cnvxlbkhmXF03rTkufUjOXdGYQCZ5CaRJ3Wv9pInpDEX/b0RnvD/QE2ULXdj/lgDauhlybor0slcofdAv0+UcnS07Az1qDGZfdngkctQB6l6Y5yZp1F8fE5mf9yroPcfo3k9CtHr0U09o27trsVp8MhedT5WHilr3WHjx33f45mLtesS5dsO/PyQYRC4DLGUi2FGYn8SnJN33jsQ0Wff2cdlQRwkSBq05rR4HcVFZKXfSjap2Fa9ILcYJhURZeQ9OkSRyFWsHU/Lq311+cU7I5MxV5mkRqt1oNbUXEAQJ01okC4e2VT16y989/ek7/fQMlUKjMOnaiI1twJI5lADzOTa3ZRV9l9iI+q+5zjkhHgd2lkKBJiJDyZKyUk/xsyB+bJNltwLjRjC0ndVIV2e5dv7lgO1tFQT6oe/+clkeC9v3XdZZuw3UPwm1A5iZfY+MS8jjcULXvibe39sLfLq9jcqJl3zgnGuul5ZxC2dfODxn83kM+dJL9fdLq/6Ib8/8tuQlOmQq8XZHiL8aBMPpZYiJoWBHnAjrfgrsrWPaBzhMTRdI/HyqXhzJ+BmwMqHCFkwCAlgF5wgngoHsUA87VwrM39wXANW9VYwMIVyD/X/tLdDQCE5jujTHbIgUARNCENJ7d2mRImYEcAvIoAOAKdXcr5PZPPWU+qKnJqAFSMiaBEw5iwTmpoho7sMUvrGojSdsvSTWCNlQyvkFGE3WwjC+IHwVAFg9OCTt3kd38YgYu3DgY5xvLaS6Cjo/YuA99wdlNgDN1MXRjOxbgSWsNZ20sGdcUqU7hL14FxNBI3BbYlE0A6OneW9rVhiIW5FvYBeRrQcioMTFjvtoh85ANYZOnXkoyodaucVKdak58mphF9jYpjjq91IlwMETs+brR+qB/2MZrqDeTB1IbaI55nXuKAIZfKN3jOHhzfRKpb95YXOD3iP/gsv/8L/Mfqaz0QDCY7IMt85tEpFvnfYOnAuQZYE9BA990yNYAwfHqwObLxP0kOa/txK5oXcZ9av3Tb8j8vwAkEmqZfStH/QrHjjB2McVQiU1pN6EvNbaAZAgxQvqS+HEAW8uyKGUW4RRFojbzfK0OZCLOM8AcY4ospdMMYaj5i9DfreJsbyIOuD5+eXhbjrVtmZm2fXhOoQUXh8ThfDGJXUE5xVvtaufR7EZ64rK9HoKHfKXMuCCQdtdFBMgtLOl+35t1mkT7R3V/GXoKlBv2LBC7PyjuYbLBQisfo/2nAhTkxg59O8+FhGr4JgSvkTtgbbaNaY+Kks1OweFhvuK38MwMQ7UWIVtx++2PYhEUfQAipC5ZM5JzFGChZRLDXcHCg7jB0DXMSZgvtyG3aIawyHv4XhVVtMx0URcChHOlWXc4/qXWcNpc9ZKxTfE5QOGtpFeT2UUknXRwgofJzjHPdLpmBela+kq0a44Bz/gNGzF7JLxHRKtEiJKbJk6Y0d4laDBinVIrp7iYbDtERcEyTas2J1FYkrrI0GqhIVMsnSZv2dUYOgTZTGHdO1xh0yKRqF9hWx3mVGjbx6qj+cDHvU/bwimf2wGksPi4y7bPc0IHcA5UHavQMHv0cYqMoPoF91JB7seERIMNk7oIwMxvt2ThI58hMQDMNvSC6YxOBsNEauXuFWBjZ1MghiwcnzwGRTgfra5TMQg4lolimog7duxZHDudPuunXkdhVn7H4Z36zYqadvkmE3XHXSvjMHJw5BvIUSKxFzC7zIP6nlS24uqzAAyUbZsHefgTiMAoAl0pgp9GwGHCV3n1PSdNKzVMv0z8Pdv8FySIMDTUU5yjYJbg8u8SS5I36GVU40Ol9Sx3ztHfiR+YRJjvQLtORBDpw+m5/PcNZIIhUjFyD25HzE8NmVjO0VNV7SYDEkWePJcshhU2xOeRh7yPijTxMlLVVq15D6dfPLXQ7Xov3SsRNtQrTrtluqoOppcBxG2pzOasGFtiPFW10gBbZQZFePGGuDDwEDZBqhFPn/62Z5Yd9/lDOVkjakXXrpPu1mXZQmhWnIVcpT1FrnzThgAQ0Fh5guY4/Mjmow2ah2p/oailDpR/2Jb0FGoDmplY7NRUJ5rZMNyVwU5TR5qG0/P47xtIA7eMU3483QAEz78JswA6X2Rn1QoYjLIx4fINwa1FIghWfTh5KxdL4XZ7lRFTKiupQjCG+qErl5Pp2uh4zpJOxYbMKPVCrnNfUBm4Wz5esRnkXSjHd0u7JhJiarx4s4CMcDG+zjzUnpGpudgWJ2xd942GeQB6R1ADc5Qh1abwXEh8+4gwKKuUKZCYGH21Ty7NhFLadmTRPEBdfoJtzUN/WeJ6kIidkqDw6E0IHGQsvaZFzMJ1EPm4Cn6FFJ57lDkPhxqiFeG8Ai4xkHzOBtekdaxVsRRbCD8+k1W6In7WByvrq9Z8Jb7Xw2dYyFFxyFBg/1k1SpotT7hz9hVPHWcB6SUFWLe2MDlVvepo1VsrInPGZnIncLdWo7PA9BKDyxIzBRWJED2dzABgS+mzoE0wzCYhBhgibzZsiBgAH9NtT9SmJNHd3fnVh5Fw7EiEBkRdldXcFC9SkRcm8yQr8VBKYmBdfJIUHg03mIwwcslIdXi/DRebAGOQgY0DGy9CeopFaoCuCPR01vNZd2Y3kJ0Kd5wGAm4qUDe570OxCRqS+O/2TJVtjk3hZV/fD3KcQoDOGckY4d2UC9GSuDAwrcYEh+1KeH1POA2Mc2NpvYNthmTv8XpVzi6X0bosTOcQ4MTIh4Zk74yHVmdGSQBpJIIMXMQciZ5tfSUGxZqDdfqQBiS7gxzwfxEwsU6N9JfRr9MoVBj4e+ecQEXpi3hAX9G4EO43sEgSNigrFEwrKkwygQSUF8cydhBhFbv1D2peRehL7KvTYRouCgjmeF26yXEqDOD4BbOtYK5OocIOJ0fMX0wqRuPgUEiBH5WC5rJVsZRNAPEXyTmEJHx0g60tzGlrQjdFZjpDsgWWvVVmr9EZhOlPXzbxBkmDOkwhmTrmHuyusG7Y5RYTlg8Y5tMNokKKbs9BwAxJZH/n33TI/dtDRjwj0wYA5tBIEOkx0h2LZRkzI+08s1fmX73x3XUbBB7a3eJ6HDpnmyAPskh7ATaeqN5X5mK0TaEDFGY4r60eqNk5qVGyfCAm5oP2N8DO+mlFp5w85xFAOfJageYdAiyGpi5yEirReu3W61o2QPhiidRZpKWeKr7VxXDU/t6/oZNXDsrDwm1dECrUyKDV0kYW4TVWHQP4eWe9yXG8G/6W4y2Va5maD1cIiOryZWMrG3dudkJyJEUEjt46o9kZPwxMl0XwbYLpXNGl5BmdZcFkebuo0Ow11pfseKAmNGqI9jMDqZHtRD7fkJNbx9d9yzrVM9quTKsSItncDgxMbqtj5Pt25sWaF5X/kvgOWTHBNVhmRiXl4nRSWXVm6uFot8WNdHxdyiRkIi4S0ZFBK2/mLXDkFNeQ1kEysq11qVmL9LDKBt0g8thF8fVwOgVJ3yooNYLkwOESpoSb6J/RoiKjcW5c9P88i+TnZa51hMLp3jlZssRiRITVjR9r/dO/4wRzkQGB8Pgg66z78VTn6v62GZN30YAl6cYxGwSWwAAAlvdKRLFiTf1UXVDf9/CfDd2IsMB1QYgmG2YKvonwesNOT8/7lf9GOSSI4BpL9ndgkgmuSm2WUp59ve3Ue6HUX6vOMp+UfQlfrSEjj7bL/droYttXoVUQEO9LeOfdDbWarLc6+jmOG2J+HZpDhQ+jeHZ1SpaMb2QEigxwZUKKM2OXyIXeNnNEf199s6SRbqBT8YX5TRbOaHuU/qkkayMoZsTwlPqFezLRcp8ZmFVTva2lVV7SEfn31XE1wCLGfuytRbSzr+9Ji/cmWvy16mnRxyO/hIc2JO2PdT2eXKweCggQL8Gi2/ftnoCINKikr40ILpssSzZBTn7BXo2B1VTQGVKZL7W+JmKT6TL92eSdV6YNM/VxPaVv+GEeMa4Af8u51eY+mVESgdiRp2kTSYE1TCR4BYhqgl/gCNJfGoPT5Wamy8AdMgrukhB0n1WBebFYRbpG1PbdySlQhz4SBsc/rJNFs3KI2DPAGJETVfjU65Cly49sPQqYUl7k5/3oYdTG/r8NAqSbCQpsYc8mvtS9RZUcAnTWjAmOnQqP6h/ptMuey4v0vB93Wx1eDsx1frrTL79igE0TbESNTNXVct0W2kVRXbzLmA4bNy2S3bCQNXJVVLBUrrwU2LssFrRPCJREdDEvsLdDAU7HjPam9uQi3Z86GfFPVrJQvWhuyEyUZGVMhH6vni/VsRy/dQmqQN3IbOaqOgWKWbTWik+Kl5eldZr7vAgQfr0MZWfTNw854jAjHiyLYM/pmqxWbHPGK+Tw4jMqQj1lLyZrAdR2RnOQgEVolJGlQ+xlPKCezg04wsekIkN7hccp4jDzyWiUmkVe5QvoSmutJlbClNzbnnyW76XWTd/6Is6X0FtnDHBkUFupKzpjsQgmE1rzBU/o3cyXlsgmSITe0KhOcfgYn+2gEKBIbLo4RQjq6DzkGPGVwQIxSdAVhZ4BmyQMK1KBuG2cMaBYGh0ce6wAicPRb6UYRftEQsMswuY6FymC2LDkvOuV73lTBH9M0Lu8UdL3rsxGxuqP1+W6rmWfrgOUZlyUHsohMUEvUmjsqs+GburhkeMhW6rJK/45VicmPSvSy1t2PNH8PqpFay5JBvQb10RggTLdVFc7ZOveX8M8jddP+XgxQHZjpYdrAkgYcRdiGj+xdeWoY3IZKsvOL+6u8yhcdN7gsW8TSmxVnCB0eR9M315Cszpv2U4tC0rOimURcZKWX2K3nfyYX+6jsLvwlm9ZMNf9e5bukOF9FcIGNTYDUUTQ6lVvuigqqbRREeXYovPRVu8hNltEmENxoZ1poCX3s6ezGpXC+c9fq5yC4SnCXSE+1clyPeiG/NiU417aaGVVVvQUDpzkC/SRK0lLtqmU92goVdKcG027YjINgIwwn9GpgKQ1UzZyY6dF3+FwT8FBdwUTAAVWuHpwqQzuVstE2quMuMR9TVkhlV52/Yo5HHiEDdf7d4glFT86YgVPmYkTCqawVd4rTgFkOBl7cg6JnEI3Zg5E1m+I8h2z3Uad9f/iORRal23sY28l0wGAee0pdTmodX4idZ0vk/h/ZlUXmaETogS0GuZ5b0Ph5jINv0Sbo8vL/Zack9PQOZ4ObrDv/6byYyE9D1E8z0hMi0QfapzbO7r4mPFMm+4Ex9h38S7XgKZ7m5NIYndPBL/kOCeGDe/O3WFXRm4e+QTitH1ksQf1xPUgZwocey/t1PdhotkVIeXo3HXn1/PL/daduqMmsjb+P4eHvq0+fBrmn5Z5N+Yd05Q3DHK/a7dEuUyteC/hFDLOBKhX5L4+JKP36nDvdLuch45MKXaf1TEsSfOZxGdcMMZ6Y+Rw3cBjMYShydcGsyPAVBJCZEtcgVkO205WiwDSEzd2hivZNswLO9rpeyzWbphUffPO09NY32IqjgjWsHuRCD8/eyxNeAAaZPVjBQiCIRoW7Zq7TyCO9XRegO/k0nMKXHy6ZVsb1AS8KXNGCQb9glnU9NKRQTwMpsRFmDQZdWLNnaVla6piQkkJ93Miaq7AYPdBCR9exmjZlMVcp/ixvZGlSalr9YS9L4ZkRSz9FUNAECsDS/yz3XY3tj/iIbvhjRoUha+w0ZI2lteZS+ohLXSkSE9OXWH7gdsOX3VeifDrODVMBL5pOErcCADEbbq/Ehc2kRHYYdzQtgFZ/X/Zai0UNzH/iio9WZ8QjOGewDc1JSq7FZ4RgaNUK9xGUHc1l6iHuAyN39kJ8IR/vn5QITKjF1N7uXpDrVXXXbqzbslqCq08nl9dDRryOzLdbKTsAHdX8+6wifo9isV3up19vnPbNO2/dvGc7w0ywhQ9izAEwknH2TGi+xPm7sqmu72U3cPdhvXn17BhyFpuw32ov70Waazgj7Nv64kmtIBtXpZwNZIrMi5w69iULNG4X/sbjCd7V0d1Fh1aOPPmzsw3MMfrBuIK40ivb/IweyXGpshGwqCHy9wYZKaTxZd0vyPHsPCs9yZCYJLvKAVgsZpBDpretaUIC9l/IGZhEIR1WBVZoAMdsoVg0zc1j+tRa1Y7nGVXJ5u1+7V8A+GEBVaqb16z9Q87C1BrC4oz4Svk9ARbmNJusIlpYVixdTVYQxrAeelmKm78tTaDtQjOkQ6wjkeAkdkRlz4GsEpImiBDY5e7BdC8nz44RqXUoB4FD8wbkVIddsygdwJ3MCnCTKeLB2i1uVCBpYgTrE/7tGXhfXNuQd/G5AMNUGLlSln2grhTJ1v/2E+JJ7bB6AbNjnsDI1PlDreNE2TEd4YucDIZZqbvCNzYhh6v+3d2nYq7ROloGcv/lR9VlKxlxQYm5N4eyG93wTkOJPjX6W2ZIg7ofEDWKb34MJ/bOo3WlsaX1vHYYe/lU+KxewcHmbrM4xD84O08kUl2QPoDPKdU+DDDfdA7xqLoMI0k0sA6aYarVvoVy5kYuBX/mDkyCa8gq8gv5rYWBd5AZRdzK48rpxAvy4kOzys4/EB+YpXViLP69vtWKjoX+sCKB7HXymVuY0PCJIeesds7KwTqtoaZygutus2R2GXh1qUYCc92beQryoJ5ZVWrw13DPFqFsFXAHolyIBngfI2yvm378BmhFKTJkRYrITkrBwYY1efJ6k0GphFUe92kOCnJykP+yUrt8YGqsyQnxjKW3L3wTj1QF4xVOkj2whmDuA+u4fvZ7HCH4Yb5INysS59VVpmQlp5TvDsRGPupAPrOSioBUiPfbQNCKaXh+HqeX4QGcLMxtAgrJUppB0KWo99jvEhJ+eCAMaY7CmVL9yR5OiK5byeHcxt77RIkeyU7uG2jMLBsS8VVRZhZl3tBqx3sO40/q+yAk1QPdGBQ7wGCb+mz3/b9/eFciG2RCdYzXpqthxLffje77xohnYvJgorJt175solNUo4uuiaY1g2F0G8X2+9YRBuQomkv4uBfNiHx5WG/o3/Mf/SVD1x6wlfTrqQljYMuONcAmRt9PZNq1gK56RbxvrEo4xq66Jd5KJn2E+0LsLnjh9W4LDQE+5HyQu5h3+BwYcCmnQ0AW0smzYkmWuzzF+P+7I0meTeGOkvlNUf+oc3c3HYklD17IUDOsv2LFlKSWOR6kXCtu8Y3cjvy/s4MjfULyni/mZ1GWoRoM1rTBbpE3aBBFn7jhpWg72FqpFWC8tSmGph8qbSY9B1ttjn0jKS+Vp8no/f1ezXUQTE5p89ASgE7H7kL59oaAkzig0fGk7NiHdFKEGMENmU8ao/taGbILIQVgxMGzdmMdHBVSQTr4J7j+BMRQe5zRpvcB1V0GlarnS4+RR6iEiKNXojLKs2m1C/kJFB6kpgUiaZm7B5Vyq62RXgHY97ycVmWNNLQudKWRhNbNrDrQ9fZH7QN00Zorfh1eKHZ4UZrYXlkt+wDhu3eEyth5Nhwnb3Eiq2x8J/NBl2bxlHoez9IDTd1nLEDkR1i+Z7KUMDNw+kXScF3+jr79TG6puVNHhLxyEnlNuZ+4eFRQwbiss3udZ9bPWercXiv+dlysYNRDr8e03DNOsmnpm3pfY4hEulYAy78jpWmy3rnSryA/GnzIZzkfv4Ju4xORIc5DxIo/noRgNKD8Pmzs91vCO74Zp5v9nkXc/tISD4zp9Ot4PMcsBpNHSq9zni6Lp0JGvZ+UdaTsmGvLAGECZ+x3HRpInKhCJ0X1uT+4myl2X/oDltHi3WUlfrsX8JK+q5am1hVr6jlie3pZvIsyh472fVrK9kBm9G4fAnpcbWmromdddM1b1CzdStw69Z23NPsm6FhuXTrIEveyrwcT/cLka0zuKwlL5wbP2B/td1xWYwssTJbfay9swTWIpGjwHEAOEm9c3q94yXHNUldp4oNb8dx1srijOu5RrJFRWpmj2++yO5JoTCM3Ew/dnUew3Qq6DbXDq+aG3pwyOu6NtZsVpzkgIRNutTIxVz1PH278eJPw1UUFkyj0ZRrLT1kWSeFF9uyM2KLLkpXDUnMxm5V6PEkRZf3kuS7yX0NBFUm4s3rFVp7keE41z3Unw6RxkDzMjbOarMYy3/eSro5lVqW9MHUtK1VLEtwuwAdag1Eo7cFqxyOljOOZLQ3V4AUo2zi2TWtZK0AiSV28LxQzLQE9GLUxWy7pUh/QLiU9CulgMuAJrc5H48XtrqkmQQ3oVHjQksGZvXtvFUUWnssal5sz+7MNo88sUtTsMbavnw52Qxd9Wun0cStapq5EPS96YSvNauedNE/sC1vbsJ5nTwfinSmQOpQteKnt7NEp7vlE0u3oypzyYV0YLXg9u2NYdZo6HgFPj3mmqztYgqUK9OIMpKMZQQoOmqpWLROgEti38EHGRqFfVr9hQnTgVwmncZn4wqD04DxSlZS50KEROKxj/YWADeKzN3nA1Rceua2c47PcdHv7PO+tp2+8ZEqd6+yayXaH94rThn8YgIJS6qYVsRfvq0TFrH3YZ0FJrmgFZiVnCaWtPYBZEsX2bqHj65iFW3scyBcM+HtVQMwOvWZIIvnyjTXt+GYBood5joZX0dgn1zJUCdJ7Womk1RJ2b5ooOfq9u3J+wrqmB3qJfF6DWq8ZvjNUUZUIr95v3CSjowktbGXx6lQwzKeavsQkIboi8Dr8TF6iDvMI+1FhA9CSmG5gVXFRA4J5wh1S2nAhjJmV9yrHy7wPEz2jhViXJ73Npm2FN0OJu4L8GMDtnF+3ShzxRK1XNKrIg69mCj71p4KGmmskwpX+JgF7qeE+/fz3gWkGLgrjB2Mu8higDLR1iYBmRiRsKwBG71uAsCCyUkr4uk4+4jMSLrp8ebfOjGOhAWat3m4onDuVmZFjIbbuPO4sXZxpjjukdBY/vZeQpQBT/ZB8CD6yoIfAo+zHycAbpZ9oMdzn9B+KyO0Kh2rahOFjlRkdCXBWt5uXHWu56idQ0urJaIjb+yhzkEqDVA7uM6m7sKZpDbN2nVvoN8kZmo2hW6lqCZd5T4tQCpIT5pHgrZFX/JmAaIbDpd1kwH3NGEaRxnVGXeNcQBxC1Ol2yPuE1UHpF3riWDSOjH1NisnD20YG0VLwBVdACJgnwJs9LTpiIkT2eSueKVS5i1GmdDYU+ZDAmdw6DqgbBHN2CtUCWPWTyzAG3p2AVUsuC8s25hfI4o6iw2xzmqzUT1K4KysmSI57QByM0syWdEaRXjjZ7ulCvay2VTkEDq7FjqJB5e6wNgt6r9JcAd8yrJU9V1TytohpCngRbQfDHdeBNv12tk54x0Yc/uFH7N+KMDDYYkiAicZsG1NvLiX3+Sif+gqDaMfpPbsWV2iuUHaljIXned9lgGnnLSYpWIXO6LBudw4pf37cYCSx7subUJsNO0YGMwaaZIpsH+krqnrvbQZbRKhfRO2ZNHqdg8N7ispoWXVaGcTADKyttOmmuo/+SBBf+taFooENQz0Ggoi1kga19+ck1f6QOKmk7KqQcCpXTAzbGs14EKRyqLciNc87ODcQ54wt/qHLFluwO1FM8IahUqKvrYI6FPSdeESzExFx9XqKArEIL2+qqqyI+0IVHh0KmsQpvw/XNN1Da47RZ259igHPbo79HXJpRiYzvh7JSeH+tsV0bsJ8rQrdQoVwovWcKZMLxOBGP28geyXuLQzTNY4bbkFcMpBB+qCmubxL6IzP+9gwKQxIo/A9ggG1YmBT9HARy45QyIfDAsd6++SpiUi/Z4IMiAWDqDT2veXZHGuvjDuRw5q+wosYWOrsiRKhJAB0D9/DDjp8bjreRzpOO/+vMO8p7MOEW8vY4MrZZ8dpXM0kTKCOvi2A3GCuXZJT//uLsqze5IMgBtMYgDTFjLxhOStw5qMiirla5MH4Ke6Um/SFUta6AgDCYhV6aUrS22ZeyWFWfXtX++uBwQHQv8CI8NyhYQlEmFtoFj+gns+wLsVhXtissEozlKSymzbOo8l+u/ufG9iQGIPvRCU3jDp7rDFuhjU7ZCNDNIoVvdT2wYCNJNbMi1PqzHrgSf1Cig1+vLugs5drIgbF8u4LnMvJ3Omb5dcdiJ1R7mxeFf4tmN+hRFVuCYJaVQtQQtqj8g8SRRjUiuIlwoAsQCxbHnzkly70Mx9pDUQLE+u6LZJ+W2SC8dqGeFEM6RpFEGc8lSBrH2OcJmPO+kxieM1Iq6Tp1AAij5vnejQEoUExOHXkGFuRkQn92rAUjQbK+PLwioHcxv4TtAUhDUq5yEVV0Ua0Y66NVgrejt22AVT7OACWbKmwEEnu+KIgA9gVkcbQgchuCA8YdyHMchxY8umxxqB+JyxAc10DAIoVdxlk/kpkyYGwSq9mnrnow5HnY+/XUIcNV/WToL9JiZOI5tXo+QM6xl2a8zngSlHUWf2jG+kfIhOEm48inYY5GPgRaz7x3f6rTlo3ZPZ3EEZ44xWqVJYhimzj8RMfFjP72qmGxzbs1ku83WfPwSM0I2sC4gL1uRBuKHpJvyLdsQ3+6yesRd2XJPY9r1cqiEjh1kByTNmKECNPS0MLrHxxArmmRmva7xIhGIH8yCkpz1YS4dQBNYVtWcCDAyFc5mFD1tqoXjXuR0/cccjIOeKtTNO3QENkoipVYBOM5LKyGiHi9pDg1BGjlt2Va94Kk2ayYLckoVjpyd6IWKm8Xq/srViro5mCalZm5sVoB+PPciKeYcvnUaLC8Vx0dcEEj4T12j3LGTTxicz5WWAnUC+12XOXOhK5UzkxudAxsovevfJJMMeNv8TpHAyEtnda/sDEmH7vlR+6IqCPeazFsr0hc3E0gI5Tk0YKp24metW6u8irRamqTDHXK1tkVbyf8yHbhH0z9pXhNYQ8l3KQZ5TXj2I2otdYC0hu0ra9q3vQfFPCi8KlWL0dIDj5Vv1yj4Swg+jj4OBbr8csZOywLYg8nYyb4QZQK94mO8lqDUyt0k6Ngl1AIlh4th118v3A8EBkMwkKjpiKrI1Injlelj6MGCMjZPboOJJEwUhro0HeuFLaU1jaRzrCkZ1wFKf1ZyHUquryLjA8qy9RjhsZOLwjn1y4T46s5SNHJimHqwPHDrXrbMYu5bRroEslMZ+Lvym612iXZ6LRiCAESuZVN5ifR7Ry9C0ZZoHp5VmNDx0DJm/vgY3AGOiSZyknZRHflmcx751tLgqXePg3CkclX92r3nbIy7jzpfVaehpusESiyTSCROzK1NZAp/T9T4hWeqE8W5KrnBqEme4sBQu+DFh2F3LuPM1FU5j36V4IU9DFZvMC5+qPMh39pgJyvq4V/NPoaqj6JqWhz5MHqZdc7uoywwtV0USYbBjGhh7mwZzfpDZHpHd+dlZ6E2fO4LKam4sosGMU5NaY/IJ/hUKwB1jz29fEwTI1wsYkXsbiiaD5FumffeLuJ6PY+fIhk1Y5ynC8+DrLFf/kIkixiPAYdTZNK9KRN4Af6UDy83X4wLLtJ4KsEb9ozAPBW2TRNl5Lgi8G2udRGE2HkD6kaeKbRa597bPkveyKhuHlbvOZWrLo5cz9VcDZjdmjkV3z6n2R7b+PjFRGnOGh2jAop/UfpQlHeyxJN8cnNYtt7pufqJpm+Qy5R6TKhCmIuw5UJarofj0URH8Ev/h18e315fiXtzOx6GvoAw4Y1aJyqyAPinPmlnpAjUlTNFuIHCO/R7r314E4/be5ykiDC5BUJt3L6vXwVpnEttZLQw3F5Z0LjWO4fkjaffvRgj2b2pPMm2y2nUEke4Dsscbsgw+MbHSKzAp5+7DGAaY49wabGY5NFhxKzofH3K2bbyrFAqpGOrWrops028pctAhvIvRuRFyfERyY4kSLauWNTN/wMET0FVwYICaWNiJF3seOlQ0jAxbQV773eomQBBbE/Q+Fq9cYOk+Gq776RoP2zxZte/qL0tZbyLdKidbI5QKti/6UFOqCC8CxgmTpbHwWeBJhQSUXSgiWAVz78GwZ0Yzd2Ba13fB9jjQDjesF5F59GJoZ+BBgzXLojM7mlQgUcRepJM/wGNlCETWmp7e7v1lPvPcRrElZcSWl+mVnuFrWzdLlCNpI6gnINvNOtpYqwet5S98F9ke6bfwLFSEuOzCV259l5a861DEfjBY2x102tZ3UBgCEa6+kz9Qy9mJj/frTOOHAURMUY9udT7qcNS9YzVtUUwJ1XEQrtqSR7W2coEl4JPS9oFRRJoT7rUbq5kU/h4OhRImp7GkF4Wx9bIqEtUHDrsXrrVLPU5dw+Maudy74rg2bmJcxSWFTpaxdduHSkzA9Z/R3bdU+4Gtv0tMorZfXd1YGwxXjGRK69zGarzEGj+6KD9gcK1f2N6yrFl/le9/vr09P7JrdhliXVtXlQr9mRfO1bOT2HOdCIFOLuej1i6c5cswkTOyfGUvsFahehzl+3ozY/rTV1PjKkpu11RxuVHojkhijGhlvQKoW4pCudT3yArYYieDxQ7UfVN3Nvt4mu2T6MpXPXCJZSxB5DzdKiIZOrXXNZxkacj1982GdTsbJJ/Fq56DUYwerHrVkplqRt7Eibl1ThYLHrybd/0njKMANQNJZFKJACKgKeEfyoSMbJTMknUnjr6Mc2p7uKgfBXHr5MN82H9dVJUXPE21aWiGKxaXNaYFWsinThNEEusYjQ6autIio4UfmpQl7da9ZY1Z2niDlCepl7YLw433ucv9yySjEN3fjd661ztl70HEv+84r77VOeMpdaNWl/J0zexzFKQmJaNqWlrFyS6whKK9B/x90t8PZnSeBoYv3M7IkRJAbIXPNI8c1xLz/8W+Vcn1aJcRWyjvAN9k4Q8Fa5n0Qi1D5ijVy4hNoCMFZTkeDrhaGQnu68PB5q7Dw9MzXc0czdi33siQ+Mg7rZYHpi1F51trhDlea80nHu3Y0Y6XK3V5XqA/Ntj+bOMm/a2J/oqcjHYNoNDfBV4gPSQJFFOLU/AOBJ+cEAdkXfiyMHTnDUNXD7f7sx7MhqZZplKegSFJWMtXQZU0sp1Lk/SOMwqoXS3gnEg3Sn2vHs/rvieiB8FIAD5obyeRlrYW9iYdEAgXs7csKxD3vlK8q5h2p5ee+yjAaw3BlWGf6QjOpb2NULEcQXaziULIfpIn6Yw4pvMa9ER0udf5UvDwX58tcYpbmH07dh0vuj+7jDbk4JoPiBseI0KRZlOfeb7uA0/46uv+chpH+ziObXruzqPIxAPRKMzoNvucPzYr9teFzDVSkyKrYZ/IO3x5+HEg9X1bDuQYCNVnUZh/lnwq1N035f0+7Gcb76FKrf6OuGqoM0UssHmkKyC0Uaj8C6s0l1oTniJYm13cVCfHt9Tnnxo7FSZbcq7XtPj/go2zo4F380V0oOlmQbdJL7iJV/Kx6SXWkXgN5zudS+dl43rO4VbkWsD2cd4zzPiqYMmIrDKMr6Vtn0OVnlAKmQxZJvS/U+N4DWq2GsCyp4TtR00PCtbSp4PDs0O0tE0ES4ce1L6/V5QVwMAva7RxsyJhSR6WGzR2zlswKagjY0sHt6oDS95vhJJmt1T5PKLMQmrg4ZFZJJ498i1VHKi+kzMBE79CQ/17LbEtPLReUFN5DTV3ydgmyeme8je8LaVO6r/WVSTDnn9ZV/PMvgrFhrqFk+R5h4W/NB6WLlk0ZIToveWEo7kvBP7w+pLznLHqYrui1V53Ow5FWzgyXkOd2Cq7YeXFsIN3hHlY5nrsSExDzjvNgqHKBTOnFR/DfkZp6K5F4xfXZkWEFTgHgApbaGPXEgRbAuWyiCae2eEbm2dKuu5d0iRaKO7kMrhxEHGUrboKshlJdU5aY4dmKQX304x1kcShxifpdmY3OykvzQM1XYCjGpJLLBYjQSYPGu3aeSehafUwhf8Ep2kGti/TXWS083GyAQWo3w21Wm3bWbBIgI5bv356InnlAO0CrW5K+s3b3RpkuluRNqGTDBcRYchaM7WAcmTENz7ihO06jwONosV2U3SIKKyJ8BVSATGDjTyPsOV2K9vG8bNDhvHFMBN+VJ7MatbXIaLztetO5khjPSsLUp4ro0o2cVVEJAGHgCaXv3BRAugGqIb6BIqh460BIN2gZRPDZVVCM/Q7Bk4jm2avyn48gvxk0HAAxxNaFGSo3nAPf850vXCbZBBmDkVjfE1lwo6MKpoZkuAEyaMpFuxU8KZ8WCCUyon9oihpxG/2HTmXaU+I8m0KQ2z0aYRL9fThDb90ZesUyPjYKUXEbAA445XeDR721/qu5tqaxuvpY4tss8rJZS6FUYVPMkKO1NGanQDC1TONAxJjwzbdWiYHmTeQUTbYEs9k7XKaBRm2BmnQ4IDG0JQbd44GFyX5gZl7MUmLbekImsmYyeHBHYdz9Dps6WjBoPvz1bNuztEsTC9EcdqnEYwN1oCqRIx1PWI5QPgrZEIZ8gxvKPMo5CbBcsTesMSeIMpoE2FNhU90cLh6hRM8XhbbSGw8NZ9z+iM5mSr1VCySlbREYpqWb9WMAj+aiMooMdv1GjXAWkqEX30d4TjVJBUKwv+UNsvH5zS30+TfmAlF2HU8C4lKkZ2UbIv4pUdrZRyRVGOSFvUcZ6fIF4AxcQp6hNxwT/0kRCqUMYaZZwKiNu3Ya3VMvgjoy6OFpEf2mWQ2Cq7PCW6aj157vmNQxQDn8bXOlOjLaoKVM42ZSWYCxh6Om247bifkubpuRUYqSrgs+GNCUrSlnlISpNWZWq3aqgC583hKp/l5BI4/CtPXq3TvihA+5CacqnmpEZds2IfnmrkfRzRFRZSMj7Na++qQyCUlVxy+Ndlyk0iAi4b9qlR1aW86GSB9qv04RRKZtKJ5oC8CchAK4AEDDn2CGGH0WUtTMY/QYXMLVCVGq2Jap5VRkfRlV7fEUUvgo8zuXsGWJdqDOcWDp+shw80Z5gB5OndI3msTRSJyk3GEqXu8dfD0NTaOBLmDqWn3dJp/83EiGpeftUJxiPkjaGnBgpuZbvaOgt6zNMyMXYs3Jh+Mbub5KGGJSvgOxDYDN3B7xLw2T6cVRzmn/eajHzuWnYhh2cEF4AWj3ftAKGwL8idsY5g5AhgPIOMJsag2qg3I1aG7MOCA2IwTODeeNCOEUyESwgeaATuXEr7FNgEhOu5K+JOnzNzDykGmbJAqw2g3PEH6evhHo5kO1tEJv2A5k2aBEOZiqjnup0O7OuittkMEKECgL5rds0Wnsb/HiR2VP65mt+epQJVqcWBgdIkX1m96GnaCsIdr9MQIaAgAvlQlBA+CNwabTW/Frg0DrSivONITp2eCp3pejHDlN5KTzTBxuQ8jOiM2kSA5bgZMUzWE92YV1J7+HqBWItXTQIFcnLWjGH8tPIVZG++upNmx5eG4/H/2Y1YqqAGmcxx7VJ1ACNJb3/K66z4WMzU0/cd0qlZu6mptZyY+x/QIILTu9S0QxPjnBXCjXRZs6KrxMhJSJV1EoQ81duqcJFmcnxoMIdRccTHmce/AVDqk2dvcM+S6f4/CecR1kCLch+kZpzToSWI9VP2eUECKT4SU52eq7hxhLDtSBMgnZlaf5vVESgI3eeyanDcTcqPRNWmmwpjpKdwnEgjKPZSoNNat2WaZ3bDbaikrEl2DZUXH6UFne4ZHnPNC3E4jmYdeIhh3Trm2AMoUcit2QkvfKFrKOVOA4eXzqJS5g7ZM8it2R+XLMzHIMuVYg2rL0GadzBjUHUSP+gCT0ASl2R2kvzeCaTVVIr6SHJJPtO8Alx2jqkreI/uwUuOitqlV0gltxV4Gm6gm+oi5Xc6CFeg2xzzQINTmmI0tfNBbp1i4KKJy7EIhGjvOpQU9C7V4V9E04uekUehFhG7Ytcs3r5ckPqxQBdnwLMIHORCOZ7EQ/ij8tfcyyJWIpUpWTND4f5TS3l7DWkHUAc1V6GS+fuPhBiVG1eXLHr5sK4I5qYWo69blkyQrABfNHxNSlil/SsNuverq1fVb4Y6ua3Zu8CBhITqCLi1G4GEehZTBjcLxeOxu/9ZNqSfkm70gexfROdbDa3Z321dsIDLUYORqFXZpIy13NVucexOIg6c96wqRHQVYgJVUnL/9XZtk92rKp1SoEFFJxHCOHqUgXVLsEgAbjnxkCmVTCmFT7ceElCYx5UGVH7s37ZyAxZjRJjN/vjkjNb4EdUJ2HbomsscQR3nl6rpRm6+EUik1tWBXAWBnv/PCAs5+Wy99r5bWCHJQPVIg41kowuy73tHxiY8lG9Hj+1c5qOm8DcNNAsuPc8rsYQZTOqknmjSGFaHRr+5jQGtj4ZprzQsUFA65WnLKbUtaOTAL7vDcZiy4VKokFhR68tB1b1M2kAhkjDCS8lKdGpUz1dVqQzKfR3FPv0LgkaFoZ+fCGyac7BYNDTPkzYTO0R8TEtuDvDB9XMv2zJEvfHioKBZtqA5JQqbB471BA1ISHknESJNOBRU25a6NXgOPR7PnCT1zLshMz8kFG/BgEJFt/TOeYvRwS+RaZetGNswQy8lDTyp0vDZX48lO4zTjuTP2uX6YCn+pngpdRHPJ5tcbUet4SPzRcI/z5LAj8k05Ewwz7p79p2NV7lhU9ULdc+P/uMpTYUMJ2WTZSYWnNSl6EaBCRtgZLES9ed3HeiFpD6yMCAmJ5fV1jwtOtdA2fZjMyRzHdS23YYLgL6mfu2kQS6hst44kB4EQR4slzt/8gvsQK4qbaY6CDrc4KizPai410ChQrjBkdE9MNOkDJjv2y5TS0LrMAFmU8svMx/la6pkgdr5T3B0NvMNPEZ5aQVSGDTFkf4FwHEB9nLbT5JvTpJI4StsC/DtO6DwbOcv9q172ZP9lnm+GQWZqjz+mUaaY6q7sFo2NwE1l93mCFxI8LBbOIxMgpvmPHnqP5vqtIHRvNr1JpNu9y+jgSau1j+Mb5oVl0eINDw788lxwRFqM0DrMzRqS+spDP1WOTJaavDbk2QK705wd1mFAmn+gyYQjoLQLUdq9JeiEuTUPp4h4dO05gIJG+FKlQ20L9oGDCOicmnQ242k54ojnXkVDlIxqSouTAFf/eGISnDx8OSp0HKK9BzsiDvzGkFGS6XINWHJZM0HL88vLKrpky0fq3hiruSeBndXkaWMcz2r+69DMqzNtT8U3jfDMTWSTm9qcB8HaLEIjW0YaHvrpB8U/rMKkb7y08t0AL4hjqgyUAs4zA1sd6BhMlbLQw2KY2qDopaQKJKktQ/6GxlJYPvtiUHPaDdT1q++K4bmIM/qIUzsFeHazKY1md8GsM3VrBVQYVZgnUENS+CRO+pBVHrvWYp9+UPzbVxds7eun8HGdfIbHFbPAmk5I2U8g95XYt+Mv4/P9mnbQRsFcckLeSC7KHi8y67NDRt8T6TiqSDh6dhVMaa1vP5XsnPFKk292mVnWIPFQ0GfpR3GMdqhWN3HGqHmjOZ//CYEKWc0VvIWThaz+hmYBRQE133v4WVVQCCngPGNwOwfS7YuxtzdrPWxPb+8vj+vFnuxx6LyJMYLchQquRUvVfD/lALRPEd5FQ5o+UW0ZiOmtiNSCSGhhgjXRJUaQiGuiIQnbEn5p4aR1ALkDnYvaHCETl+jtfa7VZRzYALQy7PBwhVA7sWBCBOUDJ+j1RPN1Spgduoo1gL0sWmhPwy0LErFAOZxgyKdP5BRB/up1OsDoMC5QOHHDPnuTa0ciNAiTcItcJWgHlP7yaWbdF6L5UDfFT4lwKsbur7uhir7VfixVki2a03MhZ7WGC6bacw4g0rcsZXLPpRNHnKm+zw6mLGpz8GK8Ef3k7uHk8v7z/fV6GTpvh/my7LPs962S+c6UWXR9TLZvYbF7viOH6tHVovNPW01k8Jfjx1MtSSqLfuqsFCIczfx8H9gve30/D3oCxeLnKN2HidbXNu4BRH8cejsbRnzB+Lq1B5cpKmE6AKbbftAEb+hmbJAgOORHlrneV1owv1ueIcibxOALPLAH70CJcnHvLuy6dXtnKxcz3CxgFqGhLGJY5AXYUwazBFLTpgDKkmoNjnm/K3yLcvasXKOss4LwEivICXdI6T3mbYe5WRd4qyJqwzfmhVFXkd2s6TLSbahfOoZqUMLYvWGiHlsqfscNzIxFCIhaLIi2eWZt5KwNv1c9bKQUpD8kKDL49UGh/dYIWkk3QM7mfqsrTAyGLnJI/Q13jXw1MyTYdlYtF0tQhfQQbGNTRqNhn9aS2l4PVZRmqXW1bh5gFYKnEWNlPwxJ7+VMwyDw0liCmEYSm8cVmQgqfVqBbpg5wUph5bMyDrbj9Tx7tljrEzBKkcQIHoGyGV1+3RXEov4Fm9590MK/TwiEEz69RQmFbCkJBHIDESi+NQjCtlHnw009mdc8JblsytFL1+ldzamT6y699iAWfZEbzi/PLAx7t0Q4Vgv5avWAZoGJyXuXD9gDabGa/FYEg2ipSDBK6jzjh8V38nPk+z5ZAHErlyHO2ilREjuHqXcDZB6Kfdz/13eeJF87pCKqqtJkwy/Ez3MMh6swKCRt4JWp8p8XqXdooN/Fo/W/OLU4KJxW1t4qDc9Sd6XdHkQ38XlxDsA/r/HN5b0JTb6/rI5SaOlYNP/CjOccHU/kcdpQCPT3XZB+awzSfZ4galLulYJDX8Lw+ih/cEjw9dkjcNDOTcBf0XihWTT+DMy885XnbDWFMsiWZDCgBc8gCKvn1s0dI8KdrwMCdB7cvQfeg4uznZSDfghyOCxme/QD1mKz5xhzzDDi6s9jR7TDF6t+Y7t8lXTLJh3+1uk3vnxucKTpQ6ev+KoIr2eigvFP4I/KMl+Y31RJGGd8AWhWGYAjfAET7Kzecla3JlHB703oGwhaWXVT6Oo+RIz3FX+lvZC/Zhv5q0EsB5NSsxAGWWiDWUpkjGuPUkRe63Qtr5mefkz/4JgnudrxZ80cHE9HB9lfNAUEmwgjlX6rIUlVaj0N5DnD7wSG8grG/KXt/OcZ2ps7UhImSvw9phR2vmpx85K8chAnIYTxDU1hQUnVZkFngaA2vr4B1WnKEEwkyJRKywX1++kd9ncM8DNwdIsfYK8CZhLz9vUYbf+g7wCUf6NO8wZTbus8nwj4jdoGzf/ttVwOnwheKylIA1AJhabq32/d5mVWzYNBX7aNtb8Pe5dSR7UhLL+Jmm+MSXWbB/8wZcq0vtXi1ebWwdBEoNodXQM1Nui4I+ycxr7fhEXKikEiQh1QpyLnMrAKO2iISD8YMMfB0jTS1OZh2wD5uXRl+2hKefPPf8oXEvjexLR2EOHHSCEIZLC9EMCIceLTTAtjLlsi6N0hPcy/zoDdUsqdi79LFEuGL3gBasVkxoD4kqksh6oi89u+CIi9rRQYH93sHTWkfb2pwgbEN7TFAO38Ur8/TlFSG4Z+nlW/WksWUPiudlAa3kfQDiKoMgXQxFYQfNcS3PHQdUuLU8L6xRad8NLCZCNWobDTJzjrLRyS9+/+3grWLf+kGeGWre8k5EG99MeLDdgtzNVtxZz6cEVi40vTAQxaW2/Kzs+4+ZlsWXjN8luW3888vprXirYXIF+JNQGIZgi1N9XEOAVRp3wDacUZhVcCsB+kOUW+jyOIoi6oDGSGFQUZ598LwWXcXXxXtbbr+PjimNEvlyisTEDcH3gn4rl31hoC8c6ykqqKxzgCA9jzZ6KZyRWLjOWuc/WOOglqUiQ4Gomw/DYYKuEf9Zw2t8xQEpkF4/iSSHs9MuFChPBzzVIEJJSKDTt+Rsj5bAvORl/2wLY1dHi1H0T72Wxr9ZytuijHa3u3zngetu3whQARwJZ7rVVS3BLLTlX4nIxWOgmxGj9xsrTzoiJLzVGl5ORhUmnlZztZD+4kl9PxAY4XSUrF4WyvyUYHuvUd4fTiEuXS0MFUc7ffgwfLwrw9zvetzr9a2taMXfmr76dCQ9jOmFslZtgqKgevgS1vNHCNQTsjMgSUhs+3rdyJICJmLF4uWTQLj82a/WBA7D1wzIDw0PLE43AT8Dg34wnqw3NTKUw7PfEt4keneAyRnBs0N+bSd2mordbev3eYszd1SJCSjlyTUi7SQuj4T7pN6jlfSm7mZ/Qtt7m9FXbT6F2yRSs5f+kXXjrfL9hXeGiRVIjQ4FFKesjHIQxFQJ7/wKmFhwfeXbdae9CMMaJznamoyLtl0C5gh+nsU6ltqOeqOpnG1zWvwXXhq+VzlN9EvOCSjKlp2eU7On4AdjcCaiC4HRkhygm+a+eS+aVQxnsBrVzWCoLPFoDf2SJeh4mF+Ta0a0Q4VkeWOFGv3eQmR3sc7BJQ55MvrazqbpIAill7zdpEuDGW+YZ4e1ff3IV5Ep9pcd03ysG8RAtvr+OCh9vvKjyuQLTUNykKDRwsyuDohXdM7r1KVKyZDAREKmgF880d0kDbFmt/1h+mxd96uKbAx0+GnDHUA5/AzykS2kqoGkpJC2O17wIay7Q7QsLpUwTNpTG0/Y3jC0/QhvocygEvIgYctXzndiMvcNBWlVsRl9NmOWiW4APaDsasqtrKyZBYisBpwmdeN28tjlamU1f0ukxzDkujzgrCOdb0PL2m+nUvR1z2ErEtCd5bpRoGnWwkguPvwwILCUKIxJmSiDOvyu0sw7zhSKBCS6MnQeSLWj1mt6DsSuU5KghT/D9VosoMc2UwUGciL6HNUAPGroJFjuBsaBILxy7Kwr2D6FS8+nBlxjnSwqHIn2XYxQeuvI16x5GoFxA6QoJw1DEgMkM3WOQkaqVRIMQCX7MUuY+UePwY8Wd99n4rjfVju/PdH8aEs35Ww6sEv3PX7u6+rMls3TSG67ZHWrhd4xlO5HQ/Y9eS0DyXP8nXfVI7wb7pj/KspeSeXleq+Pm+BcTSz3Wd9PV6NJlMsp9vIHBXI0bRDCfIs44+Rm4paPFmjUo838rE/OXp6bC4f9xazpLDJlTOxDU/7dfvvv5ov56cnltbJbj1H1hZ63f/tdKCKAhDSUepHoZoquiznIpoCphGmppZJcP4G9rUCl3tbAXDnUyWKZzh53aEoyG/Mh9vyB6bj3JK+S5d62r2OjrSvUvfNTge19J9D6JHgYw8ijulmVp6lELvcDj3qW9eaVq2ElOinpOnOlFtp0SZg6tgT4Ie4WgvLxqdtEjJXLEoeC62Ql1dRGNHA58iVpIfmMhuyV2iG89LEGrKDT7+P522zDWs/vu6t9wcPd9vTMwGmXk4DlWyoOXm08vort5NLirBzcNeP+UE/51Ux/4y//78HHxYrWAywt2YBeNL64gezwg5E882/WqSisI7JhU2xW2AzdxPFBV+xnJHa/kQXfVw1DnDVJIH7kPz2Pb2OrfX28vj3l27S8Rs0DMJwAp3vaM0BGULZStos9ijunFGyIBqOGP8C0FtVpcgd/5v3SbXOjd5U5c606nVBoCDXR/SjS2fJnKPZsHEaXo+C6KY3P3ZtFkjFAcaDnjtYWFP1hDtniKBCTRwQ2Tx9GqSALHpG12FwbYh5DfpJnHhN7q6eWcvD6/Hexf6qyvpVkQOcv0QcxZ8DTdyj2c9mfXwuXz1JX5hZLQNANmez4Cg4uOSzbWfh5aqTXtdpuXVFMOumybhfjM3LFCvDdEoRpeEhaJZGdtmEJAvt5FVWx4pmTS/YCpT2P8zEGpRXSkzX5Ysd+1whY19dWOnLD0gvdno2pJLQrZRSxM3uVa4J1fT60skDla+POKLwt80oaGs/DziavpCaS5NR+p83LMwV012obonikgevTTOc2Zri8EuA3OaTyNqik+ike1Z6z/FdLs3T0icjz0r3hzzwlEZ9Pa5E3cyTPNeESY13KfvfKP272S1ocWoBUo8MkPmqYtmXYKlnVlnMJAZvTZ60/lkzKKGRFMtW6qh6tk2K5I7utwq0Hr+FZpUNi62rsziay9NPQuDnB/BhQr3/Jwe5b/nq2ubRYx2QtY4AzX6w69Vhg3tDNUsz3P7kF8sieKs5KowExsSwOxUJNPHO6OBMTm0pH8mCHwN3kXcsmwqoDsXtVvMsbmy4Yqm7fmiHiNcozpUIXDpXrpTqJU5eGeUZqIcFYGg2moZfqdMjN624zqLAoBbpLCPbbhlTvdslUB6cqRE49oii2Q4EGOKIpH5PDAlChhVQxRNAU4WzfK0vHtPpYfTY5ouy2lNNlwVQZNGAYFPMU324wVJgM4YhofzsIZBmGy9QEkXckigQrHlUjY3TYVqRRASOVoJrzoJj1DCcLuJNKto1in4bPfaJ76xIw9Dra7DI0OFloIyA4m+SyFeOoy2AQmqIuQsY/DS4Qh13i2lE7rPMbqqSxnz+bgpwFcxd3DMEqnJFlTYVRidcle3OaxF6YLELgFUyyD5YFPI6FCjY9Rd0twbKgrG38ho0cMd1V/Qlec7zQJSSaQt079VNjMoj/vrQUx/Yc2XtZamSbGAW7wm2NTeM4XlViSAlMzO9aY5x03jUZPVbfNB+uVWvunAMYVK3aIhvXt1a74Ed0x8k9eDccbl/tNuTRXRyX1ydTfNHdd0O3FyhfWAtn2gvbaXmOzhIZZoG/B9fetjh55d/qvAKJloGse7AhARX6wKYtSoOnN6tOBFf/KZOHCnPld8mjqX+jC/U8uhbtAUEnaT5f274hDiddgUYPcF1geSuUaxIsD8H5PlAW6wxoKCCT6t/1NFNlm63WLaFJKoSqTt5+t9kY0xeIykHfHEFNsNLZkq6uyXaYY7JcxYosfrw/E8tU4ekrr8FadQKvwZi/Qia5udAQaxlo8iUu1qGibbfCvR9h0MGmL2DTI5bKTRkeWDBxX6gZhE1HBH08pjKu2IGxat8+ppNawlOPBK8mcN1PEL4zzGDNnBZIqHd8NTd/5TxVdZVh+vSK6dl6e89HNBaFfAMO8+Dn8M4Jw/QnO6CWepbefvNMFnl636tvx/ZfvjM2A3NyqZdlapos58lUumMi5ryooCF59ufOAibcFf44fWLJoyhj7xNpz51ZuNMKMkdtfzBVGDW0IPomZn/5yXZY2ajfYe1NnBZW89oM2uZi0+KO5WRK1PWzuwXFT42jmmCBhLbyJgD76pvUO1vjofw35z1V62hFo9KvCViehalXzEHKj4ouqQ+eQPXlVDKsnsog4gWRt00jX6Y/VihhrMnxC2DdIGAku3UfT2flCrC7/dKP3yWgTXDbpXdzo12AB4eemCePDb7WVY2NU0zVpIFhwapv51utWy81oaG5br2uQc39dMIPtmQcDL2Z/OYPbWB6/8l1hHlh5sWdeIyR0m0zYfUVPVdfmDbOh11fR/JQLLgTpBVL3N/oW8VWfmX6q+TJgNIdLO5K39lD3b+RS8/wlmHODMWwecu8jgC4kaXwcdfyR/Uv8J3s3rvW3PZv6VrYMYOBCQjhi/+u6GcpZDRQyj5XOq4hpMGIJpfHnwM/4tuWbTnQqFaG0dadYu1Z/tOOnnmBjsxBvV+xPJPgq8NtsturvR48jBrmZQLuIyRPuV+y7d2kKBr/On5XsnNCgkKpuoqRBqgMVzBtt5OyI3ve30W7jVg+hetB/SrXVM67RmDqnoCysKK+tuqD2FUoXJgESwvIaPdKa+MTHbwsC9TjUyzDOpGf1Vbpntqze5uvqD9/p/nBIu0YOqtJb2qXEvI1Wb2FHmdnag1QxXrVdj+jEP+EcA+cIVNWiNKZPxYMysxdFYhDugAgDrsGxEbZn2cJOry0sznU3NIKyiecpF4rnsuzKPQRS6cEZKuwHK5Sfw4NJUikLyjevN0DlraCMYJ7aA87nwka1/yJjoX/t71jFhSLccUaGH/NNgMumXvP7HE4bEogCQ0gpD1/1O8fOgn4zu/Hn75EwJwA7zUKOoVWgawL5fCPYy/gKIu1le21++kbWpof7Jd9kRee8sPuxW85arj/tQbkUCJ/g40XWzLbtR/rTjJkrfOad/BRN4m3Uy/cyAXj7PPvfeJaJgtz5x6fHcwhUcAJWMVMw/8GIsfmQ2p3U9497p9IWgcM0iveY40wWuDV8hTPSv3h0LnJPT9zx6xJ6OiAFP6kdWVvt2S8g/fxyHb2+PXy+/rufhfrz3nUn+QpmnifmS1jvcU9q33yKXiplP8O7pXVbUEMyHuq5zS99/DddCwBA2kqhsj3zidkto29WCfNMurC5qY9lj/hlXTwsQDpeelMDdd1GKL4qj1tDNnq7FmnZb+Z/hnk2kZ1sWyqYcxRBgu2C3ThV2BMt0DAhhipHgJZpV29Z3aTNNMyn6u68SrSZB3MBGqVr1+R4BYIeEaj/DcsT1KLvcFmRTcPlGXAXCRR+BpAz6lMLbri5HWiKuEbJY7MpCKluSczakRbF7oNfjCviPvIhFxC5KDbnJIbhGxggWfMLcJx6qqWRUWfdCL911XnfJ/TEZt4jCl2KBug/LsYmMYqyvXZFaXhayS8wwXuoZ1/tcH5hX3LFyPQQPHf1JbvTl0ZFXloEyjpyemjR9cu6x0KS5+5vgohN8Wl0VeZZYSslbs48ZvH3DQuazeNCkYSG/izlhb+ra+NVubgYDc9j5pGk0lAxNKuRG2Vgtmm/ah+ml1A1Wk9F+W9CwO83Vgz1GvJb14uTbegG11fztCk+JsIjARv14JEw7ylROc79/tzgStFGHHaYBze6kXIcaUNfgJWj7KCBf8Sgc7+vANFcFK5sV+3YPdOvDLHgO9BBrhjDOPl1yeBScYd8YX8Hw0ZA81USv3EJc27P0RQdZ32e7MulYZP0WlK/fYT/DeLPHmZAU67ucynszoQOzL70fFQrxRZ/Rpi8DLCJHx6VZokT5SdlVyrm/usKm8acHTpej6XS+/3GzJffOi234JvgYggPwc4dVzx379jQqZT9p1Svw9ZOrg8yrByJXsxWzFxO2z8fRMQ2vtEYSN0/q9228WF3MXjpORZCDibiKmQV6bBZARURvgQlFx23U7rNQyN7pZdzITHlnQu9YcZo1J/Af1G1Er2tRmbIBA6ncC2Dd1ZDQ2xxXRDwCEiao8EIrY/5m0yKzbly8rVs+lOYccpF1EnrDKtWjs8T9Ejc2Z8pG9EFPawIBTyYlFW5UiIhHu8zcqWAqSEuFrUvP5jnQypSy92LGCQ0nejKDVMPSup9awsqYCbMeyVmJI1oJE50tdmXr0ITV0foJiPKVSHtIW8sG8IyG/0bDCHgoyLHLjGUKbM0yz7LaCzrlfmz9oCh5xRzPc9UFE10PK5dtBugmboZRW7TvqkdnstxoU3pMaO6Ff5M+XF2hQE0U4VdbowDidoHtpziX3FtZ/bxR2/gJ8/PCxGihJQp4dq5sS4HfojyLzmdfyNluwrqXkdpN+ZCKVd16FGebj12CVmIsd5BLcD2Xs51mpcbWX7yNJohZBlIdSXLDogf/cMsFjunZHvKJnbsKdYc+hakEl31x5zWFmER+C3DjtBFT/+IZEVAa9Z65UGhrnBLJUeuhACVlBKXIqmr+xUm+daM5BZpb68YRL6NjTjJV3HrGrJX6tFMK+Cqhg85kndaJmX0MmqnVSw7fgq2Msj1O4HjQnNWhz2kcMIsaePXs41Nb7JIX8VLPRDFKF5vY3P3al0rEw9PMZ9sS+eLGR6qgFgDY8bVWiPC0K0Mn2ijaWtN3HTBhT83BipAzE0dqdAtU1JXM0jk59Mt0u+0VpC6YFstVRBHpcs9Fw7z87wENGOsW5HI8Kip1VU2XVEIWtqsOJK5kNt5kHjXUKQWiKqTbsvuKlxZ5QonFS+e3sAnu0+s+M6HiNPnbFnsRcZfMJLWXEvRhT+P0bqZu6+1iEDRZZeNDEYPwXQz50WTd0or85kwRE6YOmTB5IPuFFD2E9apU9gpwOiDuwLwMy8z9c7GUROLKSokSvnFrbhAJ57GadpHJQmvLJWoCqE4xibzC8iMiMYWD0gXPYZfzMNyX0HkOYhnt95fQsCfbYOiNhBokV+UmxP69lDQ4nJCcyYYwowCZ5Lmo5aX5gORVnuQd0y19rSHHXz9sDI6aVinLn4BdJvYgOOKkYgNpi/zjWs223mtvrTl81hd/Ivl0ZR9yQNuuuyQaw5b2xYy21FqlEdSrRiLt7lV6KWQcEu9gQydPCUYdGGWYMSoQpYu8X6dK/ESwkXVAZPUSuF994baF2edZHQGyRQNvX82E7Br0LUKPD5kZZLmPG/kKxybFvFq7s6WUX3WLRU5oeaR0Nky33YVVhTy1c8RMxn7WJUWS3UhJv4NTR243TzNFpEihAjw65G6ouSblpPnlS7vjyXQN2ZThXxHxdUrmdyRzoDLacUX2H70o2tVTM4JpMrDJ6xZ53svG1ynuL/eUKipEqSTKYLQPm158jcUkjrUw3me+qMs4R4pdqYRk4gPbTzajU3Ue1ZqWiUc7p7OtImQTzcanlUYxsPH83TxsbVjBPar5R0FTTz7w0l9Vu6cLQmLGuiUcsz5WGmDR0iHgXMyvXcGw9YO0bWinzjHwygnF/E2pjsyiHG1rKmnkp0+ilwtt1e2hnpYvstdMHtzCiMOzsv4T0jOn1UlYJAuK+2ELae1gzYJ2S7JzH1NW2f1yV8SzKGGkkckYlcv8G7nctEaFCeVIIjY8e3Rm3d8JOb0MGSmLrjzhnRdPoWtNYjWDPEYAdi779utX1v9u8dWUFKPqEOqwsYN00wS0kgbgsTpqz30gmRkd3XRWYmLPe/pdzMiSND5prenZwoBavH6GUwkFbBz6skP8ny0+XT5LJ/0s8uGdByVpftPUfbrASpj1jy8VqABVLw0IUqY/M8B/u2FOYfzQnemt3fAVIqFKJDMWJxmfLXyU15K2JamOigLyI1Abu5BObmyN4i0CKGV6BY+v7ryBXof+Tzak+kgOetPMNffEf23bcq+Z5mgpSHZVaqLvUGhm0fwXTHZTDH1W8TQTM+6BHTt8uhCxZUdcmaXXNFbZyWFFcsQA6lC38XHdXNmgtMQRhGHGGKRJ8Wa2PKawyk6E4dzOcOgbAuVyTWGVnSzD+YFhhOy1EinzNJAsaPT1ZjtrZZHRfKtwN2aDupnZI2ntOSFfT2RrSm3usoeYrEM/jynF7oVctkugXz94ibgM0x1quLk5CCTMlzCPUHZXzK357vzPaWez+5Hsmn4z7AzB5SohXyxGBPKseFMLeP+FAUvla3Knp0+wpOujpThPWjITbBqX/Tp74JJuaQMq1PykiJZESH7noTL4ZoljysLC5BwKSBkniEu9yD238Nesc6I2ydXr626VQWNa5k/9DaCnnXMPWTK8zawPizTZPfUzFUc9YYpNR7v+Bl5HdopoOgdCv6hHVbF48gBC1uJ8NTM9+O0qFMJMDNOCDMGqXR/x9jCJFFCHPZcqtRXcHASl0QmJAu5eijKmNAd2pi+icZ8ogegYHdJDoxjBJzrzj1FMz5+5Y9ctiB8ApESLAsb0B2xErCeAdAxpAIHY0n3g4LNOgRuDaElIDjTgSsXKaPLEIYLCb3okUJqOcLhqWxyLryQ2LQgjLxEsaISGOYHY006I1BHb97i3i8l9C3b+kBmbQ08iVdY8xZunR0r5qrhJHQ7ixp7uisMsw2to4rk5N6EjwdBdX2HTk2ZB2qS6NEK7KnPlIkjrGF94zMiZ7yxOvB1hU31el8RT4Wnr18WDvnHkZF7zTb2SnjdQfJOR6CFebTA5aXs8Y+TOKX4aJkUW/kIiOq76Yo9ouA+384l66rTlmWGGNdEfYCs+9SMfk7UQxVVf/SK6YFaLPrPFarksWZ40uY3z1kcB45x/nV9YJZFOD0Xg/Di/VkPGzEXhYd7kY9+JVIMaGsRzMe9ly/AT4PG5t29BO+zbjFD1f8QLOV/tNM90SfjakUVq99jnWvmIKCTfqfHDUxyuOVac1+n+secNgwX8bCLkPFZgqSTRkbpnyJqygFTeHzYTkV4L2aPW8vk9djJiGwBb1yugoiA/u6Iov8PYOoMI/i6gYDQR/6WsVTKBvF9Y39OJ4tLkaJQ/nJFlbXKNM3gcdGkeTw+9/FBCvDQFq4JNL0SWS0RaROmCsGI9z0S0SoMD/owo7j7RNXmJkYWNVa8GIEr2rgPd8ruWs2Khf0tA154XQf9TXtOjjiEt+klYfwOEuv9sig24hXmsOdLUX2PjkDZVocoWvlas1ridZQwJ5uGZbSwSnmKv8RlrmTvkczWdLvCs3EzGkvAzAZ1giZFAUUTUB3B0noFRq5hfDNUhP9PktxGXsUYycMU6Rx87RClhqbpXIRpvIRQOhyTw83mGpqkOQHVvXUo/cgpno1qJ1CYwDcAgg9oJE6l1mXZ6n5GGAtosSsd5a5Th9LlKv/Nx0TeXcW5X0EneYFmCwyt+0xVmGqgU8sSBFvUERkyiAYXfVuTcWNrvLuxn7nyXylskOhNZ5IwvAs8K3XLlz8zlp/+HdWWSHUjRYXN16/9dbUTSNuQuUt9pCXHS/h+nKeIfj7HYBw/xat/JJeYGzO8StjGv6DlFfeEfOZgm8xxZmT/JurSIvVkVsyGowIqcmHlTA+HwwBoI/C8lBX3UnWdYWfP0t4OT5OjE8M+9CYDgnkrFoV5i0MmwRn2zuY1O5t4dgW/Y8WhBexLy4goToOr45Aqs+hCbrakEMBOzEgHHN57BLPXKPZU+FV5iHGb5hmlyLgkZMi6KP1e9cbpCnBKlfaYy43c+l0+0piH5r3NReqaXHAe+QYObHw0akg6PQ985km8sJgnDAHOF38CbMrYBY687bQUANUR1QLmIhgf6HXQRoEG8h/xUrX1zvJACo0qRZDZ3uhrpmBRWeZlwa+mKY53eW6iXKSC/K5pbeZ8JpkVxff/96fG0CTeNLLvzzlg2vfujSEg0xgob1DN1lrQPTbTtDdci61OifMtsB6j7UewyAFHivgqOgwKozog18eBR596dQ1Hc1vk7/Ks3guii81i74yGnZ1mdzMVceHAEQ9sIONg/3i/naIwQ5wH/wsj2pZ5yKRY9NJmj8ojMEsFk9I/TnohyjuJvb4l3jwuqIKnqgi1HJmqKjF4nPRe+kHkTlWq10gO/6jYF8OAZ444mpL5txX/GCt9JX4kFOJwGj/QVpr7tJX5GjEg+nyI9jgGpSoCBy7TwDeCva6Z7TDzUFM/dHd25T3zFYrcWZ5T4rxpxZZWnBCX8m2LdiPGaVRuSovMK4PjSorE7KWNdwDY1ZXRWiIczZ0mfMMLExsM8lN/C8N29H5uENx2nxrFN67QqMo3gw3iRs9JAqMfsh5vM3IOFeP+DmyTKD9JwYjeFg5qH55VvWDs+ihhToxD5u2wDoCywVExoqt1n+tNPDcRmxPnqHhDx7S4zn42yyg+DVLtW03xKWVEIkXQhnXDVqhv3y7NN/jtGNcEUWnnCzoUdnGoTtw/U5mv6IVW3S/NE9dDbeRky/XpQxWSXKSryj9lfocfmWgzIvKXXL5WEqcs0ejD3NebNNf9YyDCppdOwisXofV2Rqrc+5yrOnMyO3tSssMlGbGFQ6t0RYfb8bmzDLI0rHkaBuiQYiPKZm5lfu9Z5QLb1wJrUjOiLUo4aAhIhhcA10kzG+kxt6brDTlJPcefaNhgOU95cGRqkxsq4094vrcFJD6PY0Oo9P+duifs2Eea3V7tSUhOzNg5KU4yAZq3S7bm677vaX6+kTmKpUe4MwULtkZN4GdUjKhRNohbw1h0IFoAK9dC7Lj3tWfzeKKNcx9NyTnInuGFSakn/XKmuPC/hJq3RRh4m036y4nZtATLzBj/Tutj5rPVFluYXAz+lGym0p/QjVL2szcdDb6icdyMyfj2IgkX5MjMSz13uy9NRTzqr5foQquFACYkSIw1w5RjQOffX+6dBzvLNJru7T7U4Sa+1B5NdK5+5LRx+yQePia+QZSbJpdMm8yhQptPZtjqs0tbT6u6tP/lZsg5+/Uhn6dYm9+5sLabzn3z91U8QgVF1TaOfFz5/Txt9C6Yg7k/vm3v55uHy4u3Ht/fn+9A5aqosiUIAt2gErGJGOOCODrpbxKsZbt2+tuiOdRvwiPs1LKSiRdIqc0mpKFVf/D6iCmQIaPWSk3Sg7Yf/B/I5I+7jPWmskaWjvwSx3MZNbIf0AzyDCs+fZajA/EmS/HbyxRqGfdMEMFPPOqbM5opfrjxYj2yVsXyk6jmHovAlnSB0P9zbWrXbrbHWXq06TU1zWSG47vv7rlIWjC8bCvMb3AXk9QEKDQGbCYUYOd3HK+qyzADw+la48ZH0OdHEiJt/Y6Nnbo2FNugfaFG9uA7haUUQEf2JRdbGdTwkXioMu2F57u0Mcvf+STGZzXgm0iJWKsjHQK7LhMdpJyfge0HOU5M7OtBL1QEAqpD57WUhaJU20eH75bM5qHnDl8lunLEM4JY6D+ZAwzAfgh9Tf9K/OZ4rcQCiMLNrz9lP9eiSlyVUIAoU/jgLzuOXJYHDzT8cIRn7F0X/kAemp+ok3Gtbt1koDN3cZw1holWUTD2mJXey0impsB5PXhbom4WOT0xM5hW9tJfb4a4b+qMXtbvBeJn6VNuAKe6knHXpaK2cNzPL/Gq+6r7c1/x9yjffjrfLScot4FIVuxaE5B/+ymaiSR3lT1laBmAkzODdTobQeQ7NRHJFsfG4L8UNIK4tL26HTV9cwqZttDMzrnvJxg1bktE1/MQ36Zbc7jgwBf2WiWjqiTq/ub/dioR35f5h9g4ttj9vP95eFqvyFg/cY/IrqrCGiF+l7stAVNRj2JEML8781KrHLrX4kR8lufvBbqiI7VLTphiRJVRJGkIXzvLNVEzRzZL8OvwEMKru/CDopeahx/P/w8SlCgJNyYSp2DACOYWiyAN/012GXl9Hhmp5ZNftFxZjNO2wMrvr6OnzAoT/5D4u8nT3Vg/Q8J6NFoLZH8C9JGiH/rpNU+V3eoss9b/HKhi8sqBPj3QD9ydX7DDB+jRnW7M6CWlio4//zpQp9uUELUB2BLdq2NFBOpielu5PyoHhdURAIaPu4xD4fF87UXPtXlWZxvN7gs+HIdjo9RXRoipVPhWJGniVCjUJmWp+RdXPSVbrqyMQeEiC/hmaJlJdieZVT9iYJLtfHKsN9kRqn+poF31w9T7wnf7joTXczlkx2HSD5Z8Q8bSTyj3SmeIHcjwJudWM1Od+IR1MoalpNnBp+hx9ErE2QYyG0Cktd4Qv94jBJCo5jqGMGf9IRT6bN5g+FKBHKhQ4O1iwkK2seYvMm/6QDffm/I4q319l1Nt4+hCleELhLOxOUQ04uxUUFoZF38SMs73z0dR5Ok1MQAyl7rni6ccTJrc/mz6kIi4V611mGJF55AIuRZYDw1uu8FhFLqPyd/wMGtI+q79+zXVtGhmoImC5sZ/s7/2WYKXgzYRkqDTz8sgKiVweJKz6xG8r73c9J/Rvy+d9QYS8LCBYyQsji4EevmCv8lW7joRc/ROoH46GwiDHAgOGHumEtTcrgPGbtKyxGW+dXfCs6XQf17PWA8PXSa4hXbJ/nQd7IIn0SzR2x/iwRpUtEG0M9cuhil5020O78DZT+IEge8RWd2f1RsH5yKAUVVEQJqOoxKwjnWemdt0sgNeDZWQvzH67+fAkBiZaX9+oLiZdXZgk1bk+eS7po1bDAAKp698IFmgHwzm0xLibM8wC8ZtAFvUQP7TjvAo6mI9QuBPO4lKMYGclEtuNjUb8DkY9vuhElFH9cNtMAF7ypanR53k7c5FURW4Z27bVtfz2n25lZQ0PcsFLWNxeAAC2QGLwrJ3s3tiGjIxNH5JoJ+/Y2/1JsAYdtE/Oce2M+UybmCBmHrAjatkSvHBoKet7QztbCj7AyfGwmWYvOS60b9IrXSag6lUn6Teh0B3mGmlmZQdu2LKN1bM25GB3BSvtpt3aQ5HO4Tl+oFl11f4JsMp+TkvI2IZKrb374GaHw+aZWUX1g7Fvko4q8E1vWrWg8g+EJekF5qihZ6W3znWw4PJL8xf2VkTt3zCbBprBHJ3kqcuIWua07mLQdSdlWs7YTI5924ui3x5YXRh/b4MNhWyb4dfKTlMKCLMmAUIOlKLcdXU93RcYvl8eaDjMRzBXH6lPVCAqtDVjy8gqoebe0kYzMCaLw0LSuDsmUg5Hd0ME4h3Xsv9v6YfLEmsST/8tzahmiSMe6WjpsObjOsYrXEH6/2rUUGthPSy27AnRoToOcLSRgUeQekSGNUFtT+M20fT884vQiDoIeC2lZm5lHJVvSFZHdcdILptM9GqqmjehZ5/ewA5bdqOvJtyQLj5s18ZcIRSorCFZzC4aIlt87FjbjQI+cW4TKaHO2eYDgoNMgtH9vP4DqXafrE9Y3R7el/aENaLO2mhb98zpDLq+dEgCMlt7ILA3QnDhoKzJx2jqCT6FW+pTvjryd5x/BXY23bHv/O/NsOERcahwv3XtMYxhWj+8cBknNWlpxlMja79twpjR6M8CunPjerA9va5UgRi6ikm/tPMEQbHGW5NL5LdcKs/T/BOZBiLNHLs36Xr0qPY9Z1a/nmOlYwOHZwPCeZkYa/tKISrBq4AhmXQXMPB2EnVtpvXQyw8b5GsTalaPbB+dPRztODnKI6YTic11ytdrjIdoyCyFkpwimW8CL6W7F1T7Z7b+G2JSkvy+zQFhxOfEOrfuciDQRSAj2TiOnchYSUEhwUvuLBASHA0Kj69eue4Ht4RBoEp66daCu5/Oebi7nz4vHtwP9/3t5XFH1OM9MS1ZYH0Nu/U/r6jfsPcatioSNdcme2R/GXFjBSi+3B3taN20feT1R4HQdS/K88VeknjY2xiO42yOgelKtTgDbCmk6/+JbfpH1uQl140n9GbkmF+iVV3Wac3pOuJWoA152NjsN8aJqg725afLWf6bYoW/whCN9aKB/tjvfOgHNwWVfLekyp7YUH71bkyaGl1dv//px3fzZl4fG5OwtOOUGXohz9bdo/PLwaKqK0wMKblLCtgMl4gFcFqF9SEPdCpgsoPIa3MOmVWD2CQmsxB9xe4Z1WK8OeZc1cs4WLNCE3V41JGzRvvKbnLxeuJjuntEta/Z+uvAYHhrjAwe8zTWGUE7egrSFRy9QEEE3lEO3YPTXOpjwUeuf8Ak7MdDTz3pOSd60Uc5d92PEAG0hdnHETtsydQPMenUGQHUFQaJS9JGI2GIGsKT924NSwK2VZdnqu6NOiaKExK+nd1jwJsmsbCN98i2KzpUedXfV5OBByJHL/THSc/c4TcUj25KjwvY+mlklhpun2T6gdV4Hxu6BRhV4O8njJcPW66eKbN5jqMepfbl4xSDLDSOPDBy8+A8erpOQ972VhQetvu3x5U1AfTKVMwGixWW4TtKXK//itn/he5O2CfPyGle+PElyLzRyXxuVyWbzN5z5GAybZPmrHhElO+XO5XodrdonyL8Mq+A1AoRPNHQ3TrU8lELPqLCZTU6KrF5vPXGfT+4J2jU1QtGqVz2+Bs8jX8tPDw+Ld7fovCh//X9/fXldjkdz/RdDePrfZHRZcLBJRqylRsdN3l+zo4aZdIKNbqg6ze6j3yTI/nLYy/U+fqwkthyuO1MZpN8QgmYKW9PhoE3Zq7EvnHENn3FYX7D3GpyvdjqCrcDNGa+cQQfNrf0dRzrOuRnurHc02WDRjg6GnHeAy/Ky1lrQ0V3jX1KfF7wEZ3fCBKjx1/vfOgHNwUVwWiSPlEXdah7+2O9RS5ye1fp+T1/52+LhUO/WtDZNsIq76zURFPfeRgiqhrS6a5D+s1+ypwXC7hPKDQ2ZY5Yom/yWasFw3dglzClcYkMKVcyi7P0dU4AA49+HHxt9omEasc9NFNe08JWIu6N7Ys9uMJJP9sMDrq+dauedb7ATFufi2E3fZIHnT7jUOXj9mEN63Cmuk4dO5URyA5QsXcBG4rZspKtNyJVfgph9g2JuElmNHhYraykPbKFa2tOCDHquE4hA521YPe47AYBD2nCTeu/Nd9c6rUK0KirfNGZq7TOIkueTQ7omcg6GB8UicGmbz4WdNsEL0D9gUmct8VlVFW+DWbfPhHX0iY7OmSQEZMiRHX2pgUTrGrpsKrQnR5zuILPYg7R2vqicZkYKuxzTwAXVlz02fUrTqsLC/GCaa282nPvj0ddmwN6cb3Pv2uhw2Qe2Fae/m2+yBBH2vBcMr8bLHECqK3H2ofbZY8NNbUinkkVfiy8zryLNu9eoQ7g3nzvnD14c/39Tz/V+m/u/fkzxkEY9k/kVA67bhnrjC7e5ufwYboxma7wKt2C2x2FFl022oJ2EbZkTp02zXRI/1aMgfYfAVpPl2jJszpBkOdZJzUnawO7gu5q154SgY1PlnyTotsstN1PL4L9Wrs4f/3+/va4ncb2x7E/2+6Z1Xiv8N6tAXsgoQ2klY4w9im4zWby0h+hgMGgz12o8Aj0EUSRUAfL/wt46taGlPtFB1CM6xNeOIQPxgwlmzsB9TIcgRCrwqrL8+3zaHAc8jZ3LuWefWLBHxbHLD+c6wwTCMaLzOOzZj7odWtTXMGTgl9mXfqfmk86VRhH3yP6/nSx8CXfN+f8WD8seKPWvCSA7oBE/OgH0V0kGfPpexV6GM0sYo8ztIfBwmUIbYitG0iDm0kje/DMwnUBI48nVdYmzJqjYbR5cweHf52sk7tzHk5O7++vz+7mrsfBLq1CCZWFKSsfLpeFAMLzrto8poQpav68lBXLSOZ8XXB2NcadZl7f1VTH7UzT/zx0D2TeHB0yJxwdnp/vV72oT6BzKVtNXyoeKFlndPGmajxA0nw+HfMFPcY3J5JXQ7EbsyIKObg33d0R1Qf6EJ6jdnIwDWiYGRQRlWn/eP9QzjgUfVAQA5SM8q5mY8TOsVxqqhDlxwX3biEYwiXNxN2x0WkEMEone2sBcYGYT8BJ+kNnGwNAgvEFXTQOOmPVEiHfx84YU0xtS9yygF/ahybFQWKulC8Uy9vMK+sfqVi46TmUqCTXQv1+rm+kiXCEOo7je6mX4+2CCh/Qlyi8VcddrPseTtYvB3DzN1IvXj1cXL7+/P6eWbyzI5OokNZwrz8wC/wlVVkoSW4MZoPM7ZTYquOEht/BrWaHH8/ywEs1XGykqU0hz+ux4gL7ReH04QFc5q63l+tlPq3lpkrcBJ/E41lE2wGm1Bsnjn0EL40DRkcTV3bmmA9odco9eePTWCIpIivdbIDJKzTy3UH+pSbIAshyskNyIra+2A0nvbVBgfHP00Tj4Iqg79M4VBDsl12KtGOyMuB+6N4ewhg6FGbyQnbbeaKVE/ERK+UR6i5TgLP9y6lsCO5G9hqGUUsV3oc8rJlSJRKks8vGuq3bvi2FHemifUm8WI1DbdHWAr4fP3SKmgVMgoAemRAGUlTvB7iA7UzMMQznJ/sN1INbscpTeqK/SclC6OYl/mojcCycKJGkT1te7gEd/uROqFyZl/IzdLLQma3YKB2+NpUkNSF61T7PVvyqOJSmnPRhQmqVlfIyXAHoQjAQTK+4aEAA8n292jehc25l/JSO13gJDvV0stpObNLHWjuitCZ+2Wqa0eDZxgpi6V2PMfk2XfE/g18nCHPKxeV2+pr5P1RO/tq+RBHADEbwhGZTYC8BvMGmZ5U6an6MXPM1nHH8QwmnNcCSfxNNZ/3vf7vtlY3Gh/LM5/H/qi8RYzd5os4U8boevluzyJi+et9Rpv0x9NvpUxj6Z6lB7v/IHPmrtFLLltutkiYWggPZhvZhnOMCIJQoG6pNHg8GfGsuy9L1Htz3IeD3Fa1jPfOXYMKO2Y1bsUH2BCU+gvXu8er1vsk6ct3VmogHP6NHo9jxtYF2NDx/MelKnHB+8/Lbj29rPJi5nE7gwdQl8haX9NCRXcqtmhPdOhn3bCfO9BA5Svz3dJ/q6WfOSz7zuKu59BX8TN6bSjJd6hfszmeElvznjLffzo8f3kf30Gm3WQk+e6qfcCFlqu615CLfaJ1ufxnU13vh/omeQAQOOrbSwaCI4IADohHbmGab5HeMyuZmZ4NBbd7gTeBrDngtTPim8q1DTmRML5ZhD0vQoCgLapCTIBMn43NSAa155ra+mUvQXDpfqgDRLlOHkAmIZkyHoILAbPv7budHYl2K3el93NW5OYCGge98NZss2q6YJYadzzzNWeZUMY2So7H6tHl02v1+y1zkGLWsAKZmj6M25uN8N6BJEVd2XA9ADJBNneGen/CHyjkku3I0bCtHR7cyjGcbmixTfgSXRxVWdIPWH4wu/K3b0xjd7tcHY5dm3YuelNJePOWAv9HlN/JinWcILlZXo9xkAA/9n/YwzbG+lqYORDLgsdov+xo+FO5I/wo2m8ZfOKWVDzXBiOswAiZbAKOg6hrTqEytoERNEXGKHYmYtPNnkgaWyMTciTZpRe2sQGXNtne0Fnx10ZvOrtOpBXR35IDpU1BEkqcqjmj7JONhOB39u+NJoykuFG4z03gQlzUTRiU7V/xumVxKiU6h6u355SYzJtpm6t8piZkgu+wbDHkuGQNeC+QUm1KAwldcfn6ynOiVG2UarfevwDRvtbgpCQ0ah96zpKC1UFBtF8CIIf3w9TVR5aZS9diaM22vqYsGR9rjd3En7VceMxBLwHZp/CHIhE1Yahg4qeeHXhga+/R4lX2/nRLtDYKnZ5hUFMKdnwM0Cf36eAuyAZ2rmMgtyegzVtu4sSI5CzKPZLxbvHpf9lZfyptwLizaBTO9HD9wT0IX3P2gRjqss5XSSbwJJYRdafWWuQ/cNTbLI7ZxOZJAdNs15L4dzGyKylkIQ4eJilexNq+Ul0hsU+6jvT3YqGU89sOTK5omOFCKcdrpLdHNt2HqrzU9PJd4OqOz2UBWoMf0h+wr8kH/zflqhFTqxYD7pSjTur+rFwU854K7wJRk1CbMmXfBydf0y/qDRa/mGAuyxhqiSJ7jOYuuRBtP2FPMZBgzQYIOy99iPQIWSonmwc940M03ktBboUW3tYHFv89DhdLmDIUuI6I2N0XeV1iHVk3U218eAWckaG3KzCoaC8JaHt20qps2gwHfeZgx2oRNWUHtxgWWlYIWYcgv7JvY6L05t2Xo6707sfcdEhpvzLDRRzPfNW/zOfYzX2dPxjshDq2W8FQHWUI34UloQi5QWf3KEVmOO7hlCwx3tE2oEjNeX7CGDcP8qedKfgVyqOWJ6eaGsGY8sJLnZFC8hEMMdZyzlb9rSec2U6N8oSqiRFXcxGRCSXL/wICd/EqfFVirZ2Stn09RQFs0yL7sEUBYrc18sc96z1Fv3CLYVWaQ0CPy/IDmgNWg/8LGU2eN1dpwGPJscGOPXCBYDRYGkCf6mbseKmoZ1RP91KxVZRbZVc9DyrYeVAxf05PFO288zdbO041nnvWYECuW/zowH6j102w9/HRlmcWvKUWLA7OhJ+Sp2mRfk6crnk1Os3ULV0XyzHlevMhT33OsxRncO9+G1rAba9OwpYfbWRmvZHOOLAzBbU4BmJgglIm0OH77DTZpFMzTvz0HNnVVPEXpisyMDqP30+JVptYjbVPGUqw5zZDXoMloa2RuRvN8WCCogugtCw7ECU23R+n2eKvCeYQPdWg8l814DRsC6piJHhNvM9hoXeUUD7dYV2AMFhE2u3373U4RO5OaEILYYTXQkexE5Bs8ARlYuRq79FFSs5jxYn/WuIvGBN3EwnoKtrzY1qlygM5nL25XzCKpg2lIPd6yGXK/2bd/IEz7ZPKwLzkL6vpjlS29rh6ROhlyx0s4aTFybelE76TN2NvD4zZCZUQUmPSlRtW+OkB+NePcWb3m/GflBbWspixYCtfTwhxTWFKE8irPVkR17WG15mLUtjuuLfQZB9MKyxPUj2lF3KNAnLD4HDY9E0TzhjVxdJfXroNPA4ZxSzSLM3pzYyjvPLv1RAtqvUZulzCeTTWRsRhrU7Pp5sZGkXwfNZCFGBe69rsT/Nq8PfGG6XDpAcptLGE3xKcTMC6PzXuvjiYXWBvrsZwez0/LfcUdtr2Yps19XPV5ajgFdJIsoijBkz3RpmFY9pV22LsfZrf363HA0wYG7qFA+yQDFglnPJRplLurzMhs+/ZqBrb/HJVbUuDHrquUyHvIbZ/nSVI1LpaXsSTzs5aVIVag/wg3aJxneyAPZ6zTmZg6UJvRWmEmxbWYorewiLOvQQMwjq2h3p4o5xqGGJf8AYIg9IIgj38ELDYD1Ia4sI7xfHpuatChKUpK8QV7JWVz1Bx40s1FWdua7nGRLvz8GFz0Xf/h2RJpsbQ6HAzJAepVca3MLkgzwAr4K34sUsQNlGRPEb0PxisvTS6cqSN7kRSvMKFtyyjA+pqRqCiTAWRTIhD5BlYqY4wfUXUlXZuCny6unQ2J+cKe+uXjOty53eynm6tzTmXtUudjUMQZEyovETCqA+xnndwBJAO5l0YMxcJLnNDBtH52QxOUxgUI5vf910jOhGyH8j26nvxmZt5/mxMRQx3NJnbzeNgADH2oV0/hDBBy83W5Lcc6oeUe5SXqQhl14MhNeZVNjwH56VMdbUuLhI934Gwaefzt8ShF/SYenxevK1Q8PH69v/Kdb5dzZoO4Ylp0ywjpd9mIlA+GCA4ur9V7RR9IKl1rs9mXutLGc2K108986gBD1GLe/BOyiJshbcHVREfEfSv+kW9yvD+sWQWYi07qAB79Ey/s2GU4n47XUNIo5xNRY8iCPkzktoy7WT3cN7g7ySgJIc/RRktGASlOcOdSRwQYsatpcw4aEqQz39+9QtU49KPqdLO3glo+jtT+hjkFp8FSPEfiFZxsefD3b3rsUbVHZN2guEmTD0WZ9EqUXCVwUuCKXiaZYqpw8f9MYe7mEZ6OpfZp0Kzo1Wkk/wwufqDi5siF+kR2ydRYDiHeXgaLIn3hRY6GyU3geGT3u111mgImDPyLNQ5FlWeoXnOy/d//sLwtFqtN+ypHH8NxrnQBg+bY7jjUKrhfyVUu79h6b7Ji5OFmeBEDLDg5PzsRiXMuabAEGv3eTmdyhVQhfvndRxtD4BZBBCWe7VVPt4ftenHPV2tBIyqm8nNNpTnupDJm9Qwz1meEw2Db+ShGy6y+4o/52LfwgyE6rFAclm1FSZYgMgYaRvmKSha6RMVULl2hFV7CNOZlxPbCzSyMjHbXCiszB96scPG4kn+ZoEabphCFhA3HngflYzFbUbgfLtExDxzdlMmWTBgubJTT2aACci6PPcC6aZpoVDHHNgfnKQr4sA7kkD4c6uLS7xWM91RzjYH4PfGMNxOZFz+WeUlD6f/E9a3XGaTIzxjSjYJymq96++3l+X6zFjVxS7Q7esH9Cnpj7Zp3X7zi7e7u3KfKRvYVbZKB0+pOyINMpm3o+kwNFz9Tbp1f6xiYZDwywffjF+YwhNs8vXjgozRNIn60zJX0LSYcqZJ/Tfi8LcGcNIobotiPJfccX5kH1ZE1ObJoVtuqUwoWKQhAAwp6t/1FEC9dIYgZ3PJJ4JbpeuiXR+ly0OSDnSfP5CLw880VOlgOV1n5rm497t5v+fKufdPjX0O3m29826eswNXcJOmP5XNzld0Jsuv1KuVTya/jkicNw2feXWPcznR/n/Xq91sJ4y/f4/+vd6ftShKTl0aEGZqHRLI054yL6DxNdODWidITAiPNrdtqEPho8iwzHX1P2BO6hn3zHLXp1FiIdkleTK5fNIgGT59Ntf1cfTaEwfBCmrSGU8vdlnjOcitSO4oPSG6G66Sodwy5B72iLVqGpOXoM5UKvnmKnCxtYTKph/OXaN9rIcoT7rxXHZkW6N7tm3rZUDCU8e7bTDx2ibiLeKeV5ruCslgyapr4go1gxsrmWWdTpwuPdWA+jwzaKOyPi/CtvOLPYvqOsOeH9Hwo6JHDJ5Xcdm+Nrzf8lLawjDWLolpo5AivSMbxXFeHHvfxDiLq46HWxyl4LwNPBOU+4j1XknaXybBGOO7oN7ij5L5SvxoLBw3y5WoYZdOXrQVHze2Hjt8vuiT3oEFVqYv/youGjJajk6g29y1/H8wXK2NsQ3/Q9rm9Y8OvsONfGN2fSfxpVUZ5KhhZh8hfb8TpHeRxzjyE1N8LdDqU7AptVppkucSdnf2r/vn9m2Y3ku3Jd1/J5IWCfIb6ryh/usisB4JZYrC3h4SB8tMhHRfe195p5XkJU2dCL3wc9ailryNkuVZPccFUKdxgyFKDzjhefs8aVhdvyInRv7rvfI0XThnX0XYvb/FvLpZcxrYthv4I+WWeSsUqIgwHiIqmbNs71m5MSLf57oaIgXvT2RNuf5Q9mdwtHUMqG0XnN/3dV9FGVGPhD4wiZoshsrDgYfXOOTczhaJ5jWRnIiiqEi9rn+0gf6dUfyhMRShf9/zF2pepfPrxzT7bR2evm7TbIdGE+5hz+eOqjebOlf/jiAud7e+Oif7M3/16/UYXOpfON7sij38FJf9ZEjz9bH9WEKNmFGTJ0upTNJDlDXmjXhhW47j0z+vR1V/drc+jd6Pn+FUAz1d+aMP2i/HOOglp4/Dl0axj2XxDvNXomC71gVvzwXgJ9BfMbiJ+sKtu//bh7kH1Wr2PXXbLun+mx5ae4XarBsH3CIY4Sx4eqaLV6g/mbXF0EFugaAXfYJ7gVmPhVJ6GY1Ba0iYx4odLASk+C1OsSGddoa2s2cYEmT/s9n8i2Db9QAQJw+A+4jEwmBlRiSFi9UoCcJS0MoprQjAp/0ZWA0Ofxus3+Wox0GAWGT8e3nXRVyr6ksl5LsZpuE3Kt7nGfBZtXW3WD+QGrPT5e+tGj8RtLkEubouUF+7OXp8523LFUCxrlTBj7vBZLYvAXBPcSsCsbSbcz+CP5jJ0uxWx3nbuNvfqzLjz1pwsQvYE6HN+eL4nzwZA4AdJmOFalEgDo53vaS3g6rlC06U3OtTiNOOE1+5Y6wOJDbwrjDo8OcDcYJFVqt/IkUXHZsPnq3UDm83u2l+lGT66zNP1h3zv9Tbk5tan/4yj3Pcneff7+/85elix9bv65/Gy3NfU20pFRM6Ao8YkY+lh0aI0p78tp1O+qSoPvQLXbbeajRqL1qJWyqUSkYBH4pI4bCaD1kQWQOnisXyk0MyG7rXYZobN7UXp+vCdrPyZYd8ROKeoi+Fs4oMIcJuSGaC00A94nLELnx/32/m4yW+wlpGFlt1memFLjJvrTy1lUYVx93ffV+XtSJNir/ClEUr8jJmC5TH4/Dh279d2zxKd7bnEJ/4iSJsz4U9kc/QP/pj7aNKg1pU9+5jqFaOZuPBlJomFyAr9xkmjm2iQSRNribVeds5lJuZvT88HNDu/JVms+n8KNUxBZ2rye03fv1sWQ2tTp/iK08wV5oeRO6oWZ1ouvkWnFukOeWaaUE/I5UG/TTYwM9B1heSD8532fCpZydHKIBtn7GXAR81UTmVctFdd9HtH+MI/9Sf8UkRqSDSlo+tyKGYvr1ANlso4tViVWA0iQNVnUTdGMIBA8KJ6yLehyyHWonUzU2//QuYo2i4uwLwG8ptXFR0Zij5meq33fEwVQxIcQS1SCrTITjCNsj7IZGqBJaGmZ4h7Xoj5HiWILGj6typ1kTR/2MEs7NvTzap0IVSDhVSneXhZL5iPRHwuaZoiQgRHJDF4yitMPA7YHwluj83NqqXR4mFDZJEGQNoRY1tpqKgSNSCgN46gLS3FCnWbG3X6JPKgbusfLqIgH40dJrPYgGg15Cww8EGVFg3Cae7wUQBFxxQmR0UofKgbSbEN8iY2POi0JAlruE/qrwwPO0wFIPFB3mfF5WyGd6wq4Yp/0eUlLk1ZtOK/MhP6TH9bJr7B3qMH3Nm8hAUj7gBWOL6BM3eWQoXZDwIirz6meMAemePOCE4/c576m8l1AHu1DcjNZbTGvdWmGRFvgJsCaq2GnvZZCs4o+92iNJFH8CCrOMdVPOrsLlcTa/a1X21VsDW4rNNe0Ey+tVWSrTzCnIAcmePOxFvfGXrkOWNkbUV1+OBiIZt1ahE974b7ZotRlMkBHk7DRSSEiU08UrYBIA0xOB7OV1/oyzC7ai0PrqxNc4JbEUETuXtZqVVon7HAOEAYaOOMhPvMCF1rt9ZhIX0pbjNWIobe6pijzr5s6kG84+SQhh5fn/qN2OX8tDc42DbhOM/kuuEGRRLeVuTXDyHNLXzNwKLYCllP3oxOPDrfXMEngLfHD2m8lbCeMmAmXDGHWoXEPlfdJqsuyCKqMMei+KOYLUqNVcYlQBYHoyyBqiSOrjT7n18+ksUbZonPEIdmnxWY6V0Qd8Haq+8ynE9T9Q+fnqVaPnDqo4eniYNdWlzLVwpAlA0I8169ABpRkN6cimmsA94bRLtDJC/mZ23zHXdxEP9o1bPi5zwc4HdMnXp1SDc4H4C5464Re7bUtIzxmgLvz5aMiIgkLanCTHBT1Sw/eh1x5/rqw5DFz+e2iaPd3bqN5Xs///1Z13Ux4Inkh95n69dFzzKTcGw2k52kJbwkXKK30MFR5jYmHK0kk+FN3kHzoYhHmDWbLtnCk2mVxV4yO61WnjEL/cAz8L8i0/sREEQOKYmvAcMXi9RonFbyzbL0JBc6MdhgzTsoqYjQgHRR7kQHC7lyz9LAY9JAqNXrcWfp1D4xbghJoNIeEdjNJVutu8X9CUAF7E1u49tyGeGihQ9A0WC/JEWo4tDv0udJIrmg8ml4i9ctAfHSLx6SO7I40gS4m1OARtEv4FoLxIuSbazhUh/w2BJtpY0ULzt4WWkAPfLTf1+tCPsyfkZL/vidoyFc/eXh1P9FAl1cNfDNVgr1B/5pOLjsGkvtyoqHOu3ryA82NqcbK35hK/jH/8DviPCv4HfA/wV/Av5LdZskHm6fqtfJ9fvb60sX7bDrJTkn57FvQ3CpLDX5x+2vc+tU5a/Cymqk56xxCqeVo9qmJChrXLmWIY2hf/D99hsT/CMz8W1g7hMrXuPaJXbpuZxfJdxUMNOPvByaR4FBcFO4MZVsC0uF2KJy0GAyGJljD00+UP0S6/OBCddy+PUgZQ9xFxLpVKsiddO0GGHOiaYuOkbBc42PxmKROTU1cyDL/Ip80uZFmthpY/M0Gumv6hnjZx/ChEcj/CzPIu/x1glGjFYm5todWLc4rWksPjm1xK/WSYQqPCESlu02kx/xAJ/iOWmjjDhpQ49916KlqwOD4ZU88Bqiblq0b3RmyeK8OY0Hwi5ynwv72b8gS7SQINJAqkRh26uN8+3LjELvPvpkRxPflAmfb35s8ivDnsnyyccu3ziGssFLPnHyBCALs6r/xTfDxqRmGDa5Gfk55OkCSsJLv4hFxj696cj+oXIXnLeaZuGydprX1pqnbyfx6+lLy+qcvFbowGf5VdMa1JI0LZPog1CqUFkGUSBFjc2OzF/VtNjMfxQ2KWpICnFlgJJ4QUcp7Tetap/tNTQ+rvpazaLVM9sDkXv5ltcAV33ZgX/7nGjATXHijV5Jq0wgWunP0FFKNcZqUdW9aZ9RDUBWfhOWOMT15JtBOuaaLGckwsujnvR668HTt1mUcz0eG3RKKHkUnl/tm34EcOOf+d5kesXgIOaYIuMFuI34TpQBxIbv2E/wkmW+2/Yy+0CUvtkMl3d+HNwEVukf/4n/n5xJcpi5VatgFv78S6b1TZaZD0qwYradz/wsIApH85Gso9XRGKMjDb/Y0JUpOyfSHaNz/MEXSmR2aikxQFkHRjrlc/I7Vypmy0q8NdIbei1bdG13za6034IFrc/JAFxPt0j6Oi8iWC888HMsliY4aAyQ4tPZXDf+86Tn4sRatXtKyQ/N+xj+x10RajqNJO2emTqYw3ku7bTfBWiXLr6cxuagXZIIX3a8eQlNuXAa25y1GaY9NrgRFbzj+DLebMrYAC1rzqBZ9E9vZSXNREc38EWQTAzcTTHDq0RETX0/LXFn4V7R6d5DXyfZsx6MfgXeiXz/Ca9HZOUbenMOkW7hbrF7JgezKGSwwaDDtSDd56u9Ra/GRg0Rh9t5y8pBGUTFOUvWME0QDnurRTzULDiAnA72Mvy4F2ECyzLH8Xm9oQ1bwTdWFEYo6LqhA2jfAJbQ0FGi83xaKGRaQlrj3EMCan0cvdfw8V5x8AJsPuWyr3dtQdez+SdNftlpEsj0jigaUMjhlCRxSX2n4cE+rHMLPMwPWwJybknpUql4OErzJ7T98ZSzDTff0UXDwIT1bJ210U6z40NRBJD4/dZ1WLonohOhflCSvJwyM2aqc/oYRw/kh7WO93Hbqe/wrXkDvVlNpIL1p+cfi2EJmm7eaqOMZOHHQu88IUrAHlKA6nTMAV94qWnDGx1fypxaZ/a2usv0jhSTu52Wt8nTa7FNLM2vQXtK1qrHUMAI1RjPpAshqLsjjLYG8wziboXkP5MbmIy27LZ6BR52t9vzOFSuYtt4HS2lzta+/2N3T1g4JVX6PPIfLYfQqSDuVmlPwLVCHzFZcS6TZSSp982ppwzpGFdcLa5h/niTUasJWVUmqaPjl6BhVjMwqErHYMxcqbL3412ZkYq0DzX5UuXQwpcYtVCcHkC+YkmCxCM9ycoIhIHAwMw6Lo15S5Z+bm2LsOtlSxdhjQwNBp8o/1GTgy96vWNjm3RtJGOYftO3Bn0EIXtjaqYkYo627xpRTLMWyPG4lKf+Cd4a3J6IjkQwDMDwZlIqQSFXXnNzm6o1Xyp+WsZHkceFFbvS0EyY2rjXTBG9xi2i/ev4pY1un2hlwwCw4niIr696a01tvHeVXVa1yhxB7BKOhCpLU7lrKUVsWF8WCvj2FJnPxEtsYYmQtts4uK3yUE8ZptpZoy9UfyLYsYNPHUdC2iD8gGTGU7W9J5xQC/QDz1OXrLSqRgrbZ9EeXmVmt5NkUkKNICmTuo6Shv9fgKctkmUW1ryUCY69iYkYSWbaSibod92K0LsGH0hhwGMsPBJR36w8gxAbXmPbQXF0gMGoaQ5JOyfZ2wU/sTKEyjlXJU+i7zKYe/Y02OTa88El1Y0qXAMQdHAdESJ5+nvNul65NyGESHcteOzazPbuj2Hm+/sfxVSWbi2JUdtMVkSulFfZRPVBW/m+9CDaOjr4mQ6xWKR1R6dbRUfBFArW8oIKJQT7Pim1uPU9A6rqCVa8RDHJOuK/mFc23zhjBtqdxJeVx+/5iecFYpzHy2yPRRgiqtTYK3mX4LPnc7S8QaCev1H3Vum5qsl/mXqL8Hs4yZP8dbZtIQAjUFJLWMuH9bDpHQZDdcQRxn1q0CnaK6dqSwpDDzjzbgmtw74HKTrxFtVlKMjabhJBU+047zyfctNp7cFmMg9uVHknHWDzimuvRPi8jVNrs6u3pdkBWOoUNuN8fAqjsaQKkyYjHBzMegnCiKVEre2IiUjGtrCa021s8V2qiaWGgunUdQwhJxRZUy9YKhHCpwHcwF9Qo5lVyvrERzBga+VEnm8MbOTMi64UYomWjqZTaPmhNAs3tCLj8czyZJL0nvWcWpVEXicJqLoyeVuXuSQDvaqdy8ghzbTJeNnSfIRxl9Y9UTiqT7B8bplzFyoRJZ56h9bqvo6uFdfmRuJglTzavzNFwxnZ60qIDVQDIYKBu7ULNVEleRRYIIQ1Leq+HH1CcfHEjes89G3lAjHXhtwEUnp+le5RUEHNMEiChg3Ya8Q7vRSy1Kh1M0QH02Ift4a4cyeuzj2NbIXwyFdds/zj30K0651eCdKg2U3MnvpoW3NvFrUo7qmo2NtW6ar+tTrJqfMNlS/ZrWkUqPmLsaTFD8dcUIoKwZq4GlHZYCWBXaQ/NZJ2MO0sJbI22YLK4+9wxOdbUAohPdqbeu5+oN0Ybic56EMd0w3z3zKRuS8JDBUgUwkdX8d9eEBUGD8rbiN2C/1QmG8WyZKQkfhBMF/xVCMj2o51QbjYC7kuc3JSaTIZiRgdvNf+R9YF65QPMYci0/KoQRVARK4E3SCgO7I4bUfELVFPv+wLD+YTpmlQwTee484/FDK7ufcMApSXaBadHpwBLRfq6LQ76mNjR1+3srjjz2ZH0WGvDjJmfRBOJcqKEpmom+YhXRTg6W1r6h0pye08WxcheydSJ9zvEPH0RcGlExXESGIVb56kiQv1vwNVx6xuc6IdRSTen8AJOUiSCHIGgSmajuDjwZYpAErdW8pFTmrFq56m+5W3iOwFKK0lDi1jeGY1Caiwng1Qo5hVJ2hWJuEUnXaqPaZftwySdfUDWCnI6UKUGkH1bDXbih2Ey9HZc1ymm5Y4RGYD6xs7pu514S+PsyV+erYsh3qxht3Zs3aa+uh4M6cEWMXvVjfzhSuP38lbl8ZtX/bBFV5079rqeee7IbjQ8FdS9L7TStGslOnMr6s8fkTZE2FnwuwrgFjmKublK29amNCLdaUHMmNrCEkwfckqc4adflw9j/xEuqeWNNlrwqNR7SgDzu++QQBiS8hr3BNPIUT9AlBTAM6csifCcoQ6zbkTmXRxFflbK88XlKP36ri9yhEj0D0yhdnQKtZldlU2CGlWrnnUWAyg92IRS2jM2z3fGqH8zUMq5hBXZ11K4sCp1dhNjKAcntTy0H98p1bcoKW5Y0oQrVRh8cwRqvsVMdGyf+cIrsMnU0e512WBenIZHEDvLZu9VGZiFr6Go7FN22rzB4itCc0F1OcXjrGfC3cop0Sbf5sPK9qoVYLeKdLoxagqYy6TBCQ0wcKPE1ZOZ3xWFtQ8jc3y5Bbars5QQGUYU5IyXJml6ildriTgzDTJM3y8/bOzGmnVPZ8Oax1ABS2lszzLCib/I4UmObzJSknd/dfKYTRrxdac6p40bJwAphIKaSeDkalUffYJNrJr1uJ/BRlkiSuMe/m904HouM5RgKwEndQutJzLST2cfLlyH+N2JvMXPIJPQOtasm12XStD4Fyq2jR6blkIfQT3uMzzIRPun15i//Ve7L0+D4/hPnagmdf2YMKJXsU27eWjn2ra9O4eG9+rx/utkTvhkMvdrgW9qb2+2YHEBrdthY+MQWbuEaoSxALDVJbIq9uMt/hcteMez2DxOgB1OLHuFbYlGPjtW0DyZ2RG52wOgbAnpaWAHsgVlRSfBuCVDzd5l7fAUe6egkEQBylFRWPJZU96sjwBzoX8o53Dq8OfzudIcrU6cq8CH4smeq+FpZGczS9axfRlaKlSLu4Gl8fga9IO0ESkkTQcyYUZhxA79mjweGJMUFMyYCuqWYSFHfqgioCTjO+GjxM+NQx+GYHQpMiIWadQdi30yrziYvNzYv9WNCwt8w8rk4DViJqsZOWFLkh5k+b2zQ5JSTXVibQAbi9cXgOvu7SDEXfmkrmu/2kvWWvSzuDIf0xpfQZmhM4/TlZdvqBJEINEKG9IjRvoRV6QfcRB9+h5x7arEk2rh2kUHw3XlHdM7bOo0s6ABAxDXfmDnbdGT/xZH1SnXn+x4wBuW9BvkbTBamCMsWk02yYeuhjbiHXGZN4u5NBbV/OIaUbSbTyYpPsEUsBl8bLjVEC4aD3OzrDnMN2TyNLKDw20R7df+n9aybQWFVMcaCrPhLASn89FIELt92md0aGsJaO6pO01sq1KVqJsQ+z0qJLf6A4k9Kw9Gh9y164CaZRtws5XiLD1Z/ARhPq6aQkY6pQ/UhArJwQpaJamHPkRycwX0SPTbEF+mukBkjijjuxeuNrn2ON8ugABOg1ruGRuG4xgaXihB2bb6MSjWiDZky9BSbdPIbFwgNmzCBeC1bND60b+ABHzHKatqSK89xDLw4QVhR6TOWUtj1B1wmP4hBO6suChLDxUBc0wUL3UEZtH7MYqdFY/Oa6IiHqCsyYuz+7kKeAunkF9rQWn3ElcusTso9shHg5HhCdr1uuGp/w+n8S/x9OgCcFDS3d6No/OdDFayWCeYCbc77A5a3HcO6UMAT01E7IhimExcAm+7WHJVnX7pFJ4Oz9/dMFkN+Y2TFITrwHNNfp0YM9jhRqI5vH4ckfGyKwbF1/pE4UiDsm82ypPqGxBVxDsaMhBVaVZ5lo3slKeM2BN4n3zzIoO+3Ij/Y0MIv2PX51PXWsjJUZvuSE82WSqju92EEypTVSxknaQa7F62Y6hyDIqrWOIqva9QMtM+Fsg7pK65+NcF2LV+EpPYpf43s9PVK0i5v8YQ3/JdWNQ6FdxNroG6HAiZ3oI71PKrbtP1L/BtkTAVdemX5UO9rh9VqfdzQN/62s4saE4ZEj2uUxFMOHyfMK+8KrmgWCWOFzN7wzfHUPvrPMguT0iU/nKMwTSeh7Hd7L8OMnwInuVC/CptUGKDI1bOLf7NAkDfyM6iyBLbDekZRh8C9lyWdJXRD29w2iklVCTSRECREeEy/EZSLdrgghs+lNCDWyKBUiF7jo89GSXjCFV8yb7X3x5a4rmSoo0KM2yB/OKl/v1kI2PSEVPqrM+57ldHlr16HSDTzqbu4jbrZA4yJhskvvTPsTp8K7bLc6ctdwRAdANhaX5ZxpEXlAeGAuvighFMJCjF0p99ByDP8YaQMexjpeus9Nx7MncTPT10k1MPT1efdTzY114Ptj4pinUcUGvMGLPSaQlHfiRVhzjkL7PUy8jg5Y7pCeHfKqgjsbSiadyDPq168lHqg0T3KwV9TdVqR2rEHnfxf/ki53+CqUXEtOKo3+nv7HfYtGr61xV3dMBPMHMMayxuJ7TPeVmc26mSqmoNWqZw5o/N4ioLkNQ/STkyr4+2YoRelhqEKCar2xsAq5yYs/xz8OCDOuh1OlYqbQf96bAXxfKsFh180DPXI7BIUS8rH94JDpuovaQBbfhjOqQI9OJ4BkXrFmlL8tgzBVLIJOsOpvp5GIVYv8ZAP/RFSxIuIVpCACvDH5DG8t8QAPgc0cz8/udpH1NV1SakkZVukcJuzkDWqytjG0vcX8bmVjBWtgV23/FZqd6boSuqVsJr+gE7NPSyOBxFwaM+Muf3Pv+/n5/e3nub/1VI/eGCdEt0WiZAvfieRk9SJXf8PeYnIQAMzsQFrM8xH7b5gaRWbUIhBEmd31EI+hYlXB21jCvAw9bHw3IN3h++nbULCJKkuoGTNG0pilbQGlOC6Cpu6iL45J4WmuEGw2nBr+cYeG3VCFRc6jjjsfFxaRuGb3eKpUKTkQ6kEPQqTh8Dkh4hUr0XPhvoUNBTqdmggeZLtVWdjLP9+t5rN4YesTtZregr8aZJxdA5DEX2vtJGfuMrOdg46nQG8ups4HSvlSFqxULgUBVUEx2sj5+6RGHigMTf90PdMrYQ+Up06aUkdu1HDRr/rId62Tn3AmFTp+uBzUw1fFUybP+OxV/krdkz1OaSyf/ytlQZanyt1pFEVJnYd19RTpjvyOvaI7351feNZJ5q5XQt4aN30E7C5B+RhuGL1fZILSOTSkFNuLClTSfWKRY/Nukgb4Q13gRnCaR/VmOn+KE5y06VxVe1AHn++ECNn559mPwk6+9fHnc6HVWEbf8TXxHYi3o+0D3DJMPySQxD00Zqa682d6XhTmmkfGUqGykOnSgw8NWIpno0ErAp2arpfAualeIkxyaxk0x28Af3ywklmWHlZWVuWGTxnuEvdW3Rg4Lar7sdBm5UOKsQ2pvRsmfqCTR7S3zaVIA6K+qi/hyBT9UZZYmqsjdVk3EliXlaaO6Yjw03daMtH+fz7LO45XH2MXM1xgwwAUS+XwWvQwHjP7mplGd6sPep6sSuc+RG4PqIdNbYAUculP9ZzlJsZRu4k5agVmFiBVPug3v3QM8WXdLf+nPx3HCI5GZ/4u0I9rh25N2qc7mih8maf4V3U26YqdWHH604q9mnM5gRFnmq4yuWbfyvY2p4jgYk7iePxJVCowNBr7QftmVi9fLxZiOh79dXi6PF7RstEPGTwUZCs8Do1H9qzT9xtUIVJygtxqqzKjPMn8rNW2M6kLohFLcIYGH77Qhf91bW5Ye1pv9cRxsZ1sm+xEFVQiFYNs0F7Ky6UlruUae9cEKMYipsQrDAm7FrIK54alKX43ZsVL2/Uc+c590QiZtUI40GxtylCo3Cyw6MGyrTLiKksvb8C4i6/nN4A6nkuN0+4zb6PpE+IRqdXfoDxg7v8TRuW3Pz+d7e2pHdIJBDyH3vADKnYw0gREx4MqYXh5Gq4dJ6fATHQky9iqmxO/CwAYUBLCclmd/wZTgrK9DwX3ItiKsmoR/KEe/psheyBIAdOcdUatikYGRS5ICA9qKPcjYpS8S9Erk3Rm7SPCVKKWW0p1Jwu9a6bxHhEnIGGZ3MCGSMRZp1OBdUok1EtDLnepCg7rNcQ4NKPz6rASFhHs/Pski9zK0bl2pQul6dJOInYgVPqaKm1CrSs+YuClD0jHP3+A+4clBrN+68FycRKQC90Q6+XlGc1xdLe6Z7fyh+6Dg6VyyND+2pkyrR/rpcsgD2TuFEiTEjnGUn4RXs5GO0WNkMEd2CuItMsR4EkWx6MGrfA/LqlGxdiusK8djuCFcsBsn8U/Q9M5O7uqwQjdKu/xRZ6dJx7TojrMgSgA7hQqX+nPGjxzA2j7fsS8IAlyO+HjIKHuGyrm+NRcGkyXXBYlF18MACu+GJeqj6qQ82a6Xb9eaLlYvRJk59EQHK+d+o1W0OJjqMs/i0DE09bjbah3ugrFRbd0yYqTIspQ7F54a9jB5vP3wFi2OGmweDX2U9HDmej046pk3vtPpMmOg0k7QuvHvjC9JReFTy5asJqiYBfeWWty7ZZvbeplrp2D4enA0q2nVp72YL6TaqCnHBcOp7bXSWiRBHcxAxJu8N0sqjOekUqT3SYEENVf+gptyPheoO086VqSEb/66RVSmUkcFodTB8FImKKQ6r4IWRi92W8qsrDD90UCYpDIUquIqnaoyThG38+/Otm0jkI5ZcUba1kSdJTSV4MkuP51EPhE+ymjjvhG8i7ZvEPv1NXct8es+CMn86SppdyuGdgcCVu9pifrURRrA6g/ObzZ6tSoOtgZZ/z1OhBcS/Gp70Lmmd6sypBnU3DxBqCUVf0Ik1WQkETcJiKohZuczwvNY/7ysNuvWB/ru2PNGPvi+Uh/sV/Q37bD+4wlrZaoX0Wp4j9aktLz5ReykFUXvP7eFv4b3UebqZT+t/SR+IUIy+dy0hOydv27SLtJkQ51iZGigr7uzvS0WjYT8bqvFoFEK6E2yRyVj5wVl0H/4sHU1Hdd2j1/H/SDjc2DunMcnKj48vgv2RJrgC33gHkIG8Wl4lfhq7OqHnapahN/ovaM7C5AfKpnN3ku7N6eF62Cfa/NgildO72l3qB9OUzWfwXAFTTDVhh7qrk9GBOoDOPwNjwvEZTw4LLdyHyOnPTqkLGkr5DHIgWlEiX8g62ZPC5J+113SU0KY26wpwz486eeo73cFYtkn4XLnI+qZmA9r6LIwIAHX0M0gcloHxSpEoaI12YyQBuEJTBex1dcuvRRGTBhoN4t32mqvEHFaV5UHs9Q5RCHDhqzKdyu/klsUN9QZPVV77lJrqhHKNWobwpwDpOhAm9BI9KyYUqBUqMa9/qOY0K6gp36kg/SmS8Xd9IPadGeQkhNo6n5Jgq62yk1kdmgmgyDFAXytoHg9XSVVbn3pxx43UJ4ikDQZHrINY+alOYF221Lajqe3YgR4gDb7+jY9NkZvwoEux440nh4cLVKEtayjeyntmRWk2UDTArWUukSOLrUhuvbZDb4qc1Te37yySwP8+Q/mZ16T9LtNO456h9vUjgURnSCKCaX7SEbxFgWmrB6wg3Rtd8dUf5Zp6jfB4oPNwGmO2nCNNk2mdz1AfM8oxj/BuN3HB6RC7gvHRv+xEmuFBkIfUBtsRUhqJEVGNDAgs25I4m5wGtZFmAotcWBv3Z8wSuFQkqQX67U5EN34gdLtqSK/Iz7KM6zajR9DQubRyO2qeO+Tv94PKjYj9nqoX44a3kQdqMZJG7ZBrrDHHX/1tA8D0/2HyooZVc81kb75CYJ1/5/o6dS9qv+LsCdNoyqBIPi7E4nnzaG20FPZxje0OrtCy9s3LPfFF6DmMbOM/yjxW6oCq85g3/aF6Keo9p36Z49zTz4SHJ36ZPZ2bVLI1zP5yHLHbaRm96n5Y50uX5tW0skdPVw5c0ZfMoWzfIo0OvgApxNu2Dv67ukPOFgfWtb4Oap9as5g78Ah61q5oxlmh/Zr1UH+IWTHTom0d/AQd9BhXpPCPltpapnj34n2lcMd/fhhKKI8kGXHeJKPb3LLKEXqwn60zapB3P2QE6muCx6SA91PdgiJTciKxRQYtrV3XqPyXcW5rigarjprayGy2TePwZwiOKo5O0z7at0mPLNkYGM+lYVTkDgHZG/0lqI5DKKsuU2eKtWv4p8df3Pwp1BYr9lf6h9J3NeGu/+JLQ6xz/sc0f7XMgiAAM99M5suCf47Uf0M/D/5PuvqtGtuyj9jeds70H1I3H38CPTeaJTLuJ6/cQi//Mz19z4nzagSgJF5/udnSm0vGDWhnyhpTKuvmZhDmC5CPBnhiSeXUAf6mZMtchkfIogopeAYK+mgrCqmyzB1QdcYR0sGjJPzagZa0sSUI15UeEJDB7Z1Y0TQ6RIW5qI6ndQMej67JAVih/Kr+JEUHE9uA++/O1AZTTW9KS91nn+Fg/cvb2oqovmQi9UYTaZkMJpSJBvSJJyUC+QuoD/3k7yWlM9CtcLWkYRV2jriq0WXGDg74yslwY413H2jDwmRnCojMZZEIr6OJEbgc5aEW5icQbKYvcZACRU0USCbBBQ143IYQQhIqUXTgb7t7R7TVplAP3w1kK43rSVzJniWTioAVrgZXQfLgF/78Jkf5+n11Scdj2yMiQ/LIDGU4m543GMH8EaXDJZuxuh99L5CX+oYNDO2fNbXSNzcuT3oq2wkwG25wdbcrv0DPkfdwYxodGBhBcUyDQi5bR5ySCyfrRi1woI7mEYluDsjEMtv7B/WjFaZEY0OlmlGvkwFAveFFddEqRkJ10bpuRH6M0zDXx39gdagvvlU9DL2zonQ5yXj9ytLU+2JKMGOwN3ei/wxkcm4sT8MfJM6iJXrSNGfdTzQoxgR9Cm+MCrXIJJ5pU46AzobLbHYTnGHaOOMtCd2r/6FO0VbZyxGC4zuxvhhBGzStV3nSGIs5kahIlpkZgJ6Bfd1VAijvq0quFs78hi7GSthZYlRiG7Zb+4h9UPfHIo6I3td/TN62tDeL7nSgb/meuirla7C8xFN7XDlbrcOcJ4kzJtEJjMIJoWOuLrIi1wRRS1uJGbWwHbaKPCQNX7/MVsomrffNCh2jl2aTxOeawgI2VJLBvaHNbR2/jEhDl6H5H0oK273RczZOkxjUb+j2fwvg4C8OoD+wnclCRY8OcaTPERFCF6XSJeSdMHx20Zad1IzOa1i0n4krYAkHhB/iKC5//nZ05MiaUYNsgbinvZiBFKMKPBD3MfPa7BWQdOwPtf0miPNHU9QIc/6SfTBFavLR/4Jq7hGdQ6Czcdu6yPnrwG97Qg977umPx2shKjfaBFX9zWO8c1kkPu0N48WQ6pJBlfp9YtKeWu9QcLE/rSlUBH+C2ZRbuWYqFpAk5B5PXM6jNEwHdUlMP6l1RsNA82/5d4h1Dj5CILuIUsxXtEs9tywA8ndOcRg4f4Ur3VaNFnLekZotNI8DX6HmbAnUXJujO7KgunbbhncX1C2EhxfWBonHLnTh6B3K8vYJG4jqZR9ZRD5pJp3nG/hmkWzbRiVRuT6OzlMfEUkkeR7mOpzFTb8dIb7gZAtJwBo030Tv1BFTiA5BUMbfJfd559MAooBuoJLcX1YsDxgbeybfLHGLqPDBO0GEGrF1RAa3mKkFws8T4hxvKq52iP7/w70JX6b8ZcSfulIPo4ULKRIg/M7Tq6902cryWXhhv32ukuJ16dkXlZINK9WJkE/Ay0FuBmbcqx00SftWp8GGhw2aiQbsTHoD8ZMW8ERgm93dWPBWQEYTRnRX9DyISq0rZzFJxKI1YVxJqvP9GSeY8//TOMTAuA2RMNysN/63lTtU7o5soyFGk/G8fhCWcdNvoeF7uckKHsG8eBCO9CZ1q026rnrxdwk5iEpx/ERWI2CFwoetfyFHj3Zx2xGgSGv87hc4jIBEifn2DgkqEKuPBVlSVn0ueFoXO1tfT78bLIrAl43WrP5k2JrRGSb/N5ulRJUCbTuxUkvQZpCn9NzJ72IRWzDfAx809f5up6PVvS4MNeek1YvfLFTlAAa9MO+DyZif4dKWqEs5lxEfr0ezMv0tpvwQtauuteUffGm9EGzZPsVVNxcKQ6KZ1kPeVH/K9ZevPoQ2ojm7m3XGKuxpD4msR3VHITYW+P/t91IePqZv9JJuxSdv1M1guQCfGvYZ+fLtxiuPqv79DTaUh5ldxEwS81Zci75L7706KDtFvTAYC4HQ8YWZlbNX2lIVY3ty760UbT1wRE3efqTIzJcmZWwezxVClLo7nytaGqEZDxoGcLVVCRNc81Q8Tni5PYrKuTKdapOcc2+dhxa4kHZDHyP4dczdTdNV9A9ixUx81zktaZKkR3M0Vr8rsXPmQeGBULggU4jFaahViF0O4rKuGtPwZu5j2/8AGdVODpSLQvW9gJ0wXWLlW7ZiL6eLIwVgItAZhBtvJz7mH7W26Skr1gzU1HSs1vtKrbhvKsL6nTSiY25qQ8iCxgqD14agIguJlfSkPsEAVvS3wa2g86Zr243t4Py4jMRedQYJQp42OM5BZQkg5s0bjUADy5jycASA158IiIfSi8zjNjw0nKiYHWBDQ6wusmGv9Q4AI1w9kZtk874xOxQX+2MWfB9gBfmPPRnNAI6fb9Lw9WZRBixuqDWXiTZISoH0VuxPYXoLAwfib4TGiyv2WGlIuRP6WoVyRd6GaJA1iC0ClkHzc3qam3xKs0yQV1GfUNtFVrVTg682GwJ5ZYwxqj5nghwQRV7uySBSCq4YUuREJ5gBBKIh8oWQgQvcnmyU0ANwKsQcHONrNfdvIyR+lGRFBDJ+UhmZaVN3c6YGgtEGvFWG9yau4br9LicOM2uz//CLCXoNDNV1oX6GHwHo7iZhocx2AftdUsy7CpRtJVgWsleyrTX/vJerJcSVI6SK1RUHV3l7Zq6+8lsJeXKjuIkOuMQ0yl53q18pI89td1IiUxbOy/dc8yUpntMiJgP0pgXCFeU1XSvOcQyRCTmDhL2DsxVTMa257ZRMOX99pbeMnRIpvhLqYBHmM0IkdiF+mMZz4DpfnN2zM/6ZvybLB1m8KALWeIUIuaFNI6pN0U7jd3UTv0edV4YMpgd2Uh72rn4WWwnvKV+e4rlhR73MsEjywbqG5wk0Cq92dOOLZs9JphnKRo7d523a1Xacxm0h2ixjbNr3fbE5HrfvtI4h9Yp3UZHE+m2mBPu02lSK4HnJ9QU3wgMSbJBAUgAA0NrgAyuPcC7A/XzTWf+fCH/w8+o4dFeGOYVKTcopZ4io3i+7WL2OYkAr1tVhHCBXWDnixLzVYBacH0BICqKAfFs5+mCzgR5QSbnz0x8Rckl9Bcwgbl1JjkoCkMnDMN7DHwsWBDosNbw9Q4O1SerNZFiC2LQm8tluT4vvTN06sTmKWhwtSt8x8eV8GdkyOLQ4QJC2UQxDH92QBV/Ka8Q2UAfh0ZGhrTM3iy8/ubLPGcV0tx0s/m4ZGFxkTo7qXKLOmep8BcxTO2yFBYjxbMVeOgPujl6KQBv/vWlkYjDeWpEQJVIhQ9suMEmE2DlMTa8Z8NDNjgiSgXiBnouoecaQkNYqExQDxKf0DspQPDyJe1WBl1DahS+Drg+YqEFnROT0AwUN7DwJrGjtI2i5hJ6ZlN3GTX16OjO1KUUbd3p7iJ1mkVg0BMYJKQHwlD4AgG7i9idp7fYtFcg7b6lx02E9B8pr5bbklxYti/wVyh2n2FLn8H0iMcJ9QI58yM7nFAuSioRsGLwVwN+r6K3GP20Hr1f0JctXj+gL0u8JcJYm3F7Er1/sTbdo0sxlgir3VQVoSPgaTLP1vHsDM9LcscYq8o/zfA511NOuWK09XyRjLoD6hHKDbLUXH2SGAq5dgwxkrORQ3LB2wsokB0jJwvUu/66AWrZ8AonPI1IKoxjuwy/IP2/i1WEtuQKJSoGjIznbo3b1gx8s1H9klQec66P3WK4uqDcJfm75RV7HJ/EbSHQ2k1NRrClDTX7crhArxHcKbd7haCpsy4WKXakrjA1nZJGpO3ppNDgJJ6BNAzH88+cJB0v0s/g+S93s4zPNgKdkrqp4D4iFJVx1jO2XX9UnRXas3QhkqtJ5ZPYaAiytQqZ0mD9S4Cve16qAiXaKDUVTcGOakXKKolf8H1KV7cdM5ZlGiPv95Eu1ICnsi0dvCQ3bSzhrH0VNBQvToJEKZLF1sHd1lU42eXNUn96utpu2/nxttPqGTGmJRYkcQ3xGynKI/kmimc4fDgAv9+K3BAi/jCeI+3oFfILn3kKGh2M07mLX6sBztR/ffVXxbq1iABAWyypoyehZioaiR/ajBg5PFkkHE4E4/TjEy37WSgpLw8KMrt9mF1YUq2AetRnnfvwb2qcbjTFz2y/9Tl3g7YWfVbmQMSt/KMbJ8QaozOf2I6OnkvGNzMVb2NUIO4K4vdxeCLu9qHATSDTh9NnziQ7e9FS0LoUycss5+OiZqmpJDWhDEt+9a9cuY+5slBjJfayNTiCGnEymmT6p55GkvJBqhvZXV0eOu1ZimiL07ONCYS8Zd5V7hkfEMOB4JU70LuE1uKvDMKuxu8+BWfEuCTwCygegHf3zljBt+VSkyeXqRpNPmPqgan9LtpL5zVGY0fsC+P1MttOlQ733ApSnpJoDETVokkFPa5svVZUtLARBZHvOPklTv1M4gUSDvLVe4qHSBbuW09j6QD0DSkLJJrhDotYUPPTI1hi2ndSnt5cn0+FcVocD0tLsLyVOIJJF+xGYr47ugyRA/KHPsjY/vwOS6tos3p9AD+MUXMxiYF8KQ1sOqJneMPUZqUX+02PnfQ4QpPLCfd6IjvJ1PVmT2qMYJY+Ce0Q+baM6u/1QzumIlq18N1E1XGiEsBVOxT7I4Z/LXrSIqD6wM7WElYCmF3XnfYluJ1GN3x+UuTVyXsU+9ir9+/SbFZvSl5DO1Qv40k1u23wTSV9tbniTcKh5OrOKNdrvnPO9Udk0sON46A1yIFZ8N7xyVWY3V49kI3Krlp01WvLTvIdhcMiJz5f5OR1n57budUdXCMdeesVCr7DcD4F59dwCQu4ZAzHF/peK+lvkG/J63kOzq+ug3wgoX4e0A7SBei/cPt5RwrR2xEbg7jrTkfXMU2LxQzuOsylFDMCOPMdGnwfVsTYQ2NIh+6jxFfBiZRIzB2FX/JHBXuyYKAZtOt2kNe7iGF9uUsEAvN14j3IR6Pob8vtYR8DOcA05yBNZj3XGBc9uWszxnT8XgHA+hH8QPnJcTrnzxuFEqswfhZFSNYj/yMkg3bGvhcob/0BQ7qWPbW/xYrGEXuMpEWYVnwu9hv7poh+KC+aSVZSj2wCMDXqp1JyBV4eTEKbEkUatMtsEx0oxev7EppyDKrY42zNWBJoyMFWjMMEfWOZpbUAJmWGfAoglr1ruH38BQpIyKqhwSPbAbaeZKiCZlOb8fN7qz2bt6R4m2xxuGqb5oeWSRCgBxxOOZ6RA8U8jjkOuLG55EAAJiSqb5BcZGSFv4Fg5BeDEVEgIJSNV2g9r2LVZKSdbI2d+imdajMtWHfbrbHCfhjrlWYb3J4K25RF7d5Bl6U0KskD4BkMKFbnQ4gTSnNoFTOs7mqWoPJxp7zPc3NbI1acTzBHTrnI9rt1Evm3QsrHrWLsf59qXPkceZlQTm4MgRs4wLNHT94BlcaR5UkcAB0wHcdQJKFjgRNsaPJ0zOmFDJbRTB6cLU+q7IxkamSMM7ZTNhADmymQmBB+7ao5Wi85qoOw84PDCcCuD4mPg82nWNwWXihIYl9CYrBGCnV64NOjR4G/IZEMWxeu+fn4GLgLWzVLYe+W9O0tS+kwEJHkc+MnkuO/C/CwoK/6G/IAXTf7Ewf1ne15peLrM6XTUyP05FXMPM0ck4COkloIiDLF2lBp9Fi7bLbfbXuAsqs/sycpBMIS/wOS+sTcG8r8SnOWkikEwY7hmWi4kkF6dTtmobd3owt1achJoCELwO8NpToSzmBTt1I9xgR7NODhMxBeeQKw329kcaMXy6iYziaTONbVg9JLzoLWwnXl5NuDo5e9oTYmN22qyYoMo3HlKMCUAySQAreNaue0SR/SM8Hf76DTbf+rmXRzkC6mQu2qP+YAdOdKXZoOYeEUIsf0F7Z8V7dujeo0Vkv7JZLKoOQ1EySFl1hwD5x8ZJBU01D/RM6TWllTlGXDt+Xzr05QWHQIlk4JoEHaFNjTwdA1ZVTKB5ICjSccRDqAXw4hRfVVu8/EdRqCSJ5aJzHyQECMmxszgM7GkFDzY2jdspPundz1EvrJ76aKTQfme3Ztgxjk2B6ADKgwCBbBIXhrYYjw855r/1GiDzekOuKds4alyXLcZbfdDBAytEpxOgYIEU4EDOm+6AwZct0xCRMwBdfdV6pYvuCE5JTQlAujKEA1Kp1/RHjq1aj1wJaMwj++atBoqx3F8xyzPduyI5GJSFSu2pnd25I9O7yJ2MTlm305kP05mMM5lJeuSUh8EiX54ZfXMUQoCBWhhR5Ff2HR4Oy1komvM+OEF5cUzbDYHC6PLxBOfEViTQbkKFGjRW/7cZ7NbLFCZR6rc3bVrro+0xdHoLMaX5yoXSc9QjprsPOUz/b2G8hGnoou1tn8/FSYlORSVYxFinXZ7GxcqVlfGWI7a1dHI1vpm7larVt8Z+3OzP4YxTgmMUU2xiw2YQu2YYd0dqWH4xg+0S9RjFKUS6qMJrSgTV4H6IJA9iwDzKH4Kel3XbMxF/MkFktjkfisoM2GSxXCFFA+kkWf+mySraRm0OY7fw9/AmaRijaZQxH/2fHgLC6Oxeks1ghFPItjQdBis91IkNGiiNOiT4P2SV6ut/vj+Xp7//j8+g4EQ+FINBZPJFPpTDaXLxRL5Uq1Vm80W+3O2fwbB0N/HfFkOpsvlqv1ZrvbH46n8+V6uz+er7d39uvz51cYxYlkKp3J5vKFoqeXN7n7VipXqrV6o9lqd7q9/mA4Gk+ms/liuVpvtrv94Xg6X1IutfURc+1zv8csYQAyObm4eQgvi49m8wMgBCMohhMkRTMsNofL4wuEIrFEKpMrlCq1RqvTG4wms8VqszucLrcHCAJDoDA4AolCvzvAKPH/sWIdGp3BZL0rQsareHyBUCSWSGVyhVKltlFrd6W7ZkD50hhHC6n9TQQiiUyh0ugMJovN4fL4AqFILJHK5AqlSq3R6vQGo8lssdrsDqfLzd3D0wuEYAQShcZgcXgCkUSmUGl0BpNFllH8iLjcaslYReP5ZTS38j4bDbD2f6Eh8WJLcoVSpdbU0qZdF111ACAEIyiGEyRFMyw2h8vjC4QisUQqkyuUKrVGq9MbjCazxWqzO5wutwcIAkOgMDgCiUJjsDg8gUgiU6g0OoPJYnO4PL5AKBJLpMRradFjxIwVO07c8MALACAgwECAAsPkQoEGAxYceAi8vJFYIpXJFUqVWqPVGbDljicgMEjQYMFDhAwVOkzYcOEjlBxrfaYjQ8yEGi3ENiDYmLcFUmxxJBoLO64AQCBgEFAwsOHCR4gYqbnKgwQNFjxEyJJU98/qS7L9/LiktKy8orKquqa2rr6hsanZJd/yrm4oQavxCJag+9ExsXHxCYlJPljHAAUVuxzPGO4g/IJC3T3Xg1eB7/x5XMkJlaS0bI28orKquqa2rn7fU2NTc0trW/tWNkdnV7fuPXr2Cm7wVTgiMio6RllCLFecqi4h2SCb0B2XlBJOkMJtgtReEyK6CcEoI7ft9iJQc3Sh29Zuj7qtybSKvSa1ot3fcz8WIQVWYwS9LVy+bKjN4fL49G2JrSWVyRVKS4QuG3anwcuO967tU/Bwq3S1PIHEbZVCRXEbAXacAMZtXsqfNdBxO7TV6Q1G+9DNqw25gUyX53n38PTyng6YOWP/3YPASybOhiwbN3kKFAZHIFFoDBaH30EgksgUKo3OYKK6dTE84iM0GtZtxCZa2mSoa7ZYfd3+og6ny83dw9MLhGAEEoXGYHF4gp+LRElWVE03TMt2XM8PwihO0iwvyqpu2q4fxmleiEXNA1k9+66fUSpNNzAt23E9JKIe078KIotx8QVrY9mO6/lBGMVJmuVFWdVN2/XDOM3Luu3Hed0PCMGI9FsoyqRCtkI6WuzwENCodDP1tyx0KzIePR7922oUw38rZCYD/BFJiAA33wgXPkKXjZM0y4uyqpu2U//oo8DlupWV7nHDAy8gEGyqlWJLLfvAxTJGBGRe1PhUcOmNsgGpXLK37xCzRVk19BGn7P8W6nS5AaRo4QR+J5ZIZXKFUqXWMCzCnFanNxgdnZxdXN3cPbjhjlUMKX0eCIUiq2TIQLchN7UPT+CGYJCEDs7ECheK2HAAA5q4hCMuN9WJe7+UKrVGq9MbjCazhVjUPJDVs++y7aFTzbZWe0dnV3Y3JdeCxtlAvALkiZMwzZdpISKVyI+/4G+jR7LoexM1NkQt6a0Z0TyAwueoYuizJpGxOSF3nykkOgZxZ7uqpB/WKEH0nbTuIQdpF/mH9DwuApgfrQRDe8YHhhBYp6AvAxsJxgGZAwaWGe85ixHlJBv4ic6wz8cclPc8C4IMi2LWRrMYnm+BXNWmGcTzSCgTQSAqIt8CQvHnAc0PYuR58GRc0X8JWt47hIQfjGL47hLgZnhcMxz4isYy7cGYg+YOHBYF7odVHJ6OXBVllEcSc5BbXJsIAGK+PhvL7AhlcYTrgkjKg0IC6s4iw1ae3/tn69poWy014SijRxOVkcESjKNSANtzlYfESoO+fvp4EVevqFfM7u1I1KU4c0jRBxo8UvBHBsWHiCPDv61aNEuRH4mW9q7vJnTVXmy6ITfHNnNw79S25g73HYNwIcqSsVHPGH/CsgCIMKGMC6m0sbnGAwgTyriQShv7+/0hw/FyGKqnMbtPZAgTyriQSpvHO6TRXeH3BQARJpRxIZU2Ntd+ACJMKONCKm1srvMARJhQxoVU2thc9wGI8BP5wjv8wqfLjNhaa621mxsGgAgTyvgUcvEPHESwhaeaf0MfETTWNGzqD7G78XX13kGJAIbxPcZCAESYUMaFVNrYXOEBiDCh/9i3PNRfaafnTAQAAAAIIYQbHAZlXEiljc2VHoAIE8q4kEobmys/ABEmlHEhlTY2V3kAIkwo40IqbWyu+gBEmFDGhVTa2FztAYgwoYwLqbSxubkDACGEEEIIIYQQwi0OABBhQhkXUmljc80HIMKEMi6k0sbmWg9AhAllXEiljc21H4AIEy7kAAghhBBCuMUBlNlc9wGIMKGMC6m0sbneAxBhQhkXUmljQxi/Lxy7ys4p1Yq+NupgMXeXNH0OSeIzAQuuL6HsC/8p1HFL6C5/KUilzbqQKzwAESaUcSGVNjZXfOANfifqhkgXf6Rors0RQgghhBBCCCGEEEIIIYQQQlsaDGDKuJBKG5uba22EEEIIIYQQQgghhBBCCCGEEEIIHWUdACDChDIupNLG5moPQIQJZVxIpY3N1R+ACBPKD8UlmSVIUDTDcrwgSrKy1IvzHoAIE8q4kEobmys8ABEmlHEhlTY2V3wAIkwo40IqbWyu9ABEmFDGhVTa2Fz5AYgwoYwLqbSxucoDEGFCGRdSaZOrAkSYUMaFVNrYXO0BiDChjAuptLG5+gMQYUIZF1JpY3ONByDChDIupNLG5pqCBEUzLMcLoiQralpLkKBohuV4QZRkRU1rCxIUzbAcL4iSrKhpHUGCohmW4wVRkhU1rStIUDTDcrwgSrKipvUECYpmZMXfBZatNt0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFsDiH6/6gMQYUIZF1JpQ6Flc1MOAAAAG3c66XE3813nPJf/3/xDd617/dtQmZtyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADYuJu1wmu6i298usyInXPOOeecW+4M7w0BIMKEMi6k0sZOC9BsA/zDupC12fi6mg6EjesPgUUtTI9nrcnuj95DEDdEgpk3+rWB9L+XtypZHUfekDv/3eXoRAmMOe+BEEIIIXxC8IVxIrsRzYdMl5UFoYz/tz4IIfhuvJ9NdjMzCoT2/BiAiFDGhVTa2FzlAYgwoYwLqbSxuZP6DhuACBPKuJBKG5urPwARJpRxIZU2Ntd4ACJMKONCqvQ/+X5QdPAqzew8u40vb5dv8HcjLmPHKuyVfg3s2jCfVmfi8xz06rAcEKvNNI2d2drUYAAiTCjjQiqdWcfNrKt64t49eAwgQhMForftWyP5bzofO9BRnnN2ZxQfQITK+/VBRZLxdU8IqfLkKg9AhAllXLzJj5JzrCW5s/rFM5JhX77+7MTj2i+Ok8zHqTKTQimllFK60QFCKm1sbvYbAAAAAAAAAAAAAAAAAAAAUAZs+YTmcnySOQl9fLTup+8npnPPF7izntc2uMWIiWeDTNtU4ObI5dH/4IHJyuT4+iDrntbyfnLtSJHB4dCdeXV2yOz7AaBLX7RVxoVU2tjlLhZvbm5OlFJKbXsAgAgTyriQShubm7VRa6211lprrbXW89gVAAAAAAAAAGDDahnHC6IkK+rS5rEuAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4Ey0dgAX3XsAIkwo40IqbWyu8ABEmFDGhVTa2FzxAYgwoYwLqbSxudIDEGFCGRdSaWNz5QcgwoQyLqTSxuYqD0CECWVcSKWNzVUfgAgTyriQShubqz0AESaUcSGVNjZXfwAiTCjjQiptbK7xAESYUMaFVNrYXPMBiDChjAupdKb1Aj3jQipt7HLrf4EhBAAAAAAAAADYGkAVACJMKONCKm1sbg4RSYJe3dWCuu9Xtusvck3imJdq22NCoAQQYUIZF1JpY3PlAYgwoYwLqXQmLIdaszDIcE0Z+acDTaj+9vc1oGbCCFE4ereEHJ2L4TbTB+Uw4kbaamyqYUfnaFAOjiBzCLReKXfgXaQMuP4LM4uOEhJc98qhhpgfSGBMbxnlZElK7u5h4FrbfJZee/J5GyWRS0akXHx4MqErX0haWDtVZQqcbmFIqqVqdrXKpAvzI4aNo89qanX+RJBCxy8PmWa7zSqBy5Y8rVZVKDMpbuZAsWhRygiadFFqGMQhiiIUkErUpVrmoXDzEX88IafbGn6/Pr15pywB7hknXbVdNRdYvC3/86utBv+OXKHNlWlOc/OoE75LuFZHS9RbUoAsGYjKVQW27OvKarHZvbUmV7Oy4KGQGDjKiVn584XL+LRlmtjSUS2hmrVm190prtgK6h2pU6tqpL7UXupyqRTQnmkULS0mljKU0nVooOr41ssEmtTr4sMlrCbdVZZg7di8NJsYT7qbWA4bWR63YSu2FId2GmbraCuudBz7Gbv6AG8Bhc8BzoBIinAEhNn4/Tlh/81/5e03KAn/BEX9DA5ncxf1adzGjEhzeClYjywlyl3BSAwjJXa88A84rspgxbTi+kDq5Cq32ClWvpQlgx489V47HLYOwOL+emoAD/5Wc5cZUsdxmcWjhHcAbgCwNw7M4MAsDvBGFPySW0ABB9MCMk3bSDJBgAle9gTATPjLTFhoTwCkTfSxIh0kz0mcemh2q/oK/81iAufCWW24TJY9FHwRzz6jGwxvGXAeQrQGuKTA58F5DQUUQEvZsi6b09+iL6jfa95YqxKn/AXUizgergb/HIjwT5f2C1OhSo26Fl36ALoDoouFKjUtuuRRoEiJMhWq1Khr0aV4ceqiAbc/UHJPe4Ssybo5iYy1Im2+PQK5RX+22e2XAA6B4xKuyJymtXc7ldXSI0yvUFCJRSq3ZZ9fVicv+q9ix9g1Qw+hFaps5InQh8Duhw2tu1riXzqI6tr10G4mICL5ml7Va0KDkDQUQ2wBi8WnerBeclbT27cxZbP0yIK/+Gf7zanz3YX637j80hJ/AQAAAA==";

var samsungSharpSans500Woff = "data:font/woff;base64,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";

var samsungSharpSans500Woff2 = "data:font/woff2;base64,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";

var samsungSharpSans700Woff = "data:font/woff;base64,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";

var samsungSharpSans700Woff2 = "data:font/woff2;base64,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";

const fonts = {
  roboto: {
    fontName: 'Roboto',
    fontFamily: 'Roboto, Trebuchet MS',
    fontWeight: {
      normal: {
        woffURI: robotoRegularWoff,
        woff2URI: robotoRegularWoff2,
        fontWeight: 400
      }
    }
  },
  samsungOne: {
    fontName: 'SamsungOne',
    fontFamily: 'SamsungOne, Trebuchet MS',
    fontWeight: {
      normal: {
        woffURI: samsungOne400Woff,
        woff2URI: samsungOne400Woff2,
        fontWeight: 400
      },
      bold: {
        woffURI: samsungOne700Woff,
        woff2URI: samsungOne700Woff2,
        fontWeight: 700
      },
      bolder: {
        woffURI: samsungOne800Woff,
        woff2URI: samsungOne800Woff2,
        fontWeight: 800
      }
    }
  },
  samsungSharpSans: {
    fontName: 'SamsungSharpSans',
    fontFamily: 'SamsungSharpSans, Trebuchet MS',
    fontWeight: {
      medium: {
        woffURI: samsungSharpSans500Woff,
        woff2URI: samsungSharpSans500Woff2,
        fontWeight: 500
      },
      bold: {
        woffURI: samsungSharpSans700Woff,
        woff2URI: samsungSharpSans700Woff2,
        fontWeight: 700
      }
    }
  },
  lineHeight: {
    heading1: '48px',
    heading2: '32px',
    heading3: '32px',
    heading4: '32px',
    paragraph: '24px',
    caption: '18px',
    tiny: '18px'
  },
  fontSize: {
    heading1: '32px',
    heading2: '24px',
    heading3: '21px',
    heading4: '19px',
    paragraph: '15px',
    caption: '13px',
    tiny: '11px'
  }
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Elements
 */
const buttonDisabled = {
  color: samsungColors.neutrals.darkGrey,
  backgroundColor: samsungColors.neutrals.lightGrey,
  borderColor: samsungColors.neutrals.grey
};
const buttonPrimary = {
  color: samsungColors.neutrals.white,
  backgroundColor: samsungColors.samsungBlue.default,
  borderColor: samsungColors.samsungBlue.default,
  hover: {
    color: samsungColors.neutrals.white,
    backgroundColor: samsungColors.samsungBlue.darker,
    borderColor: samsungColors.samsungBlue.darker
  },
  active: {
    color: samsungColors.neutrals.white,
    backgroundColor: samsungColors.samsungBlue.light,
    borderColor: samsungColors.samsungBlue.light
  },
  focus: {
    boxShadowColor: samsungColors.samsungBlue.default
  },
  disabled: _objectSpread$1({}, buttonDisabled)
};
const buttonSecondary = {
  color: samsungColors.samsungBlue.default,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.samsungBlue.default,
  hover: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.samsungBlue.lighter,
    borderColor: samsungColors.samsungBlue.default
  },
  active: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.samsungBlue.lightest,
    borderColor: samsungColors.samsungBlue.default
  },
  focus: {
    boxShadowColor: samsungColors.samsungBlue.default
  },
  disabled: _objectSpread$1({}, buttonDisabled)
};
const buttonDanger = {
  color: samsungColors.neutrals.white,
  backgroundColor: samsungColors.coral.default,
  borderColor: samsungColors.coral.default,
  hover: {
    color: samsungColors.neutrals.white,
    backgroundColor: samsungColors.coral.darker,
    borderColor: samsungColors.coral.darker
  },
  active: {
    color: samsungColors.neutrals.white,
    backgroundColor: samsungColors.coral.light,
    borderColor: samsungColors.coral.light
  },
  focus: {
    boxShadowColor: samsungColors.coral.default
  },
  disabled: _objectSpread$1({}, buttonDisabled)
};
const buttonLight = {
  color: samsungColors.samsungBlue.default,
  hover: {
    backgroundColor: samsungColors.samsungBlue.lighter
  },
  active: {
    backgroundColor: samsungColors.samsungBlue.lightest
  },
  focus: {
    borderColor: samsungColors.samsungBlue.default
  },
  disabled: _objectSpread$1({}, buttonDisabled)
};
const button = {
  primary: buttonPrimary,
  secondary: buttonSecondary,
  danger: buttonDanger,
  light: buttonLight
};
const dropdownList = {
  backgroundColor: samsungColors.neutrals.white,
  backgroundColorHover: samsungColors.samsungBlue.lightest,
  borderColorDropdown: samsungColors.samsungBlue.default,
  borderColorDropdownSeparator: samsungColors.neutrals.grey,
  color: samsungColors.neutrals.black,
  colorHover: samsungColors.samsungBlue.default,
  colorSubtitle: samsungColors.samsungBlue.light
};
const dropdownButton = {
  color: samsungColors.samsungBlue.default,
  colorOpen: samsungColors.samsungBlue.dark,
  colorDisabled: samsungColors.neutrals.darkGrey,
  backgroundColorOpen: samsungColors.samsungBlue.lightest,
  backgroundColorDisabled: samsungColors.neutrals.grey,
  borderColorOpen: samsungColors.samsungBlue.default
};
const fakeLink = {
  color: samsungColors.samsungBlue.default,
  colorDisabled: samsungColors.neutrals.darkerGrey
};
const downloadButton = {
  backgroundColorPrimary: samsungColors.samsungBlue.default,
  backgroundColorPrimaryHover: samsungColors.samsungBlue.dark,
  backgroundColor: samsungColors.neutrals.white,
  backgroundColorHover: samsungColors.neutrals.grey
};
const tabItem = {
  color: samsungColors.neutrals.darkerGrey,
  colorActive: samsungColors.samsungBlue.default,
  backgroundColorActive: samsungColors.neutrals.white,
  borderColorActive: samsungColors.neutrals.grey
};
const dropdownMenuItem = {
  color: samsungColors.neutrals.black,
  colorHover: samsungColors.samsungBlue.default,
  backgroundColorHover: samsungColors.samsungBlue.lightest,
  colorFocused: samsungColors.neutrals.white,
  backgroundColorFocused: samsungColors.samsungBlue.default,
  colorDisabled: samsungColors.neutrals.darkGrey,
  backgroundColorDisabledFocused: samsungColors.neutrals.grey
};
const toggleButtonGroup = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey,
  colorDisabled: samsungColors.neutrals.grey,
  backgroundColorDisabled: samsungColors.neutrals.white,
  borderColorDisabled: samsungColors.neutrals.grey,
  colorActive: samsungColors.neutrals.white,
  backgroundColorActive: samsungColors.samsungBlue.default,
  backgroundColorActiveHover: samsungColors.samsungBlue.dark,
  borderColorActiveHover: samsungColors.neutrals.darkGrey,
  colorActiveDisabled: samsungColors.neutrals.white,
  backgroundColorActiveDisabled: samsungColors.samsungBlue.light
};
const toggleButton = {
  backgroundColorReactToggleChecked: samsungColors.samsungBlue.default,
  backgroundColorReactToggleCheckedHover: samsungColors.samsungBlue.default,
  backgroundColorReactToggleFocus: samsungColors.samsungBlue.default,
  backgroundColorReactToggleActive: samsungColors.samsungBlue.default
};
const autocompleteItem = {
  backgroundColorHighlighted: samsungColors.samsungBlue.lightest,
  backgroundColor: samsungColors.neutrals.white,
  colorHighlighted: samsungColors.samsungBlue.default,
  color: samsungColors.neutrals.darkGrey
};
const daytimePartingActionButton = {
  color: samsungColors.samsungBlue.dark,
  colorHover: samsungColors.samsungBlue.dark
};
const dropzoneInput = {
  backgroundColorHoveredAccepted: samsungColors.samsungBlue.default,
  borderColorHoveredAccepted: samsungColors.neutrals.white,
  backgroundColorNotAccepted: samsungColors.neutrals.lightGrey,
  borderColorNotAccepted: samsungColors.coral.default,
  colorNotAccepted: samsungColors.coral.default
};
const dropzone = {
  backgroundColor: samsungColors.neutrals.lightGrey,
  borderColor: samsungColors.neutrals.grey,
  backgroundColorHover: samsungColors.neutrals.white,
  borderColorHover: samsungColors.samsungBlue.default
};
const uploaderMessage = {
  color: samsungColors.samsungBlue.default
};
const customTheme = {
  paginationListAnchor: {
    color: samsungColors.skyBlue.default,
    borderColorActive: samsungColors.skyBlue.light
  }
};
const base = {
  anchorColor: samsungColors.skyBlue.default,
  anchorColorHover: samsungColors.skyBlue.default,
  anchorColorActive: samsungColors.seaBlue.default
};
const demandAccess = {
  headerChildSecondColor: samsungColors.samsungBlue.default
};
const segments = {
  spanClearSelectedColor: samsungColors.samsungBlue.default
};
const iconLink = {
  color: samsungColors.neutrals.white,
  borderColor: samsungColors.samsungBlue.default,
  backgroundColor: samsungColors.samsungBlue.default,
  backgroundColorHover: samsungColors.samsungBlue.dark,
  borderColorHover: samsungColors.samsungBlue.dark
};
const styledTargetingViewer = {
  colorClear: samsungColors.samsungBlue.default
};
const headerBarButton = {
  backgroundColor: samsungColors.samsungBlue.default,
  borderColor: samsungColors.samsungBlue.default,
  color: samsungColors.neutrals.white,
  backgroundColorHover: samsungColors.samsungBlue.dark,
  borderColorHover: samsungColors.samsungBlue.dark,
  backgroundColorActive: samsungColors.samsungBlue.darker,
  borderColorActive: samsungColors.samsungBlue.dark,
  colorActive: samsungColors.neutrals.white
};
const helpPopover = {
  helpIconColor: samsungColors.samsungBlue.default,
  backgroundColor: samsungColors.samsungBlue.default,
  backgroundColorUnactive: samsungColors.samsungBlue.lighter,
  backgroundColorDisabled: samsungColors.neutrals.grey
};
const getIcon = {
  created: samsungColors.clover.default,
  updated: samsungColors.saffron.default,
  archived: samsungColors.samsungBlue.default
};
const gridHeaderDropdownButton = {
  backgroundColor: samsungColors.samsungBlue.default,
  color: samsungColors.neutrals.white,
  borderColor: samsungColors.samsungBlue.default,
  backgroundColorHover: samsungColors.samsungBlue.dark,
  colorHover: samsungColors.neutrals.white,
  borderColorHover: samsungColors.samsungBlue.dark
};
const progressLine = {
  backgroundColor: samsungColors.skyBlue.default,
  backgroundColorDefault: samsungColors.skyBlue.default,
  backgroundColorSuccess: samsungColors.clover.default,
  backgroundColorDanger: samsungColors.coral.default,
  backgroundColorWarning: samsungColors.saffron.default
};
const sideNavItem = {
  anchorColor: samsungColors.neutrals.black,
  anchorActiveColor: samsungColors.neutrals.white,
  anchorBackgroundColor: 'transparent',
  anchorActiveBackgroundColor: samsungColors.samsungBlue.default,
  anchorColorHover: samsungColors.neutrals.white,
  anchorBackgroundColorHover: samsungColors.samsungBlue.default
};
const smartFilterLabel = {
  backgroundColorHover: samsungColors.samsungBlue.default,
  colorHover: samsungColors.neutrals.white
};
const smartFilterPill = {
  borderColorFocused: samsungColors.samsungBlue.default,
  borderColor: samsungColors.neutrals.lightGrey
};
const smartTableFilterOptions = {
  menuContainerBackgroundColor: samsungColors.neutrals.white,
  listBackgroundColorHover: samsungColors.samsungBlue.default,
  listColorHover: samsungColors.neutrals.white
};
const smartTableFilterPill = {
  borderColorFocused: samsungColors.samsungBlue.default,
  borderColor: samsungColors.neutrals.lightGrey
};
const bootstrap = {
  buttonPrimaryBackgroundColor: samsungColors.samsungBlue.default,
  buttonPrimaryBorderColor: samsungColors.samsungBlue.default,
  buttonPrimaryBackgroundColorHover: samsungColors.samsungBlue.dark,
  buttonPrimaryBorderColorHover: samsungColors.samsungBlue.dark
};
const flightFormTab = {
  activeColor: samsungColors.samsungBlue.default,
  activeBorder: samsungColors.samsungBlue.default,
  anchor: samsungColors.samsungBlue.default
};
const flightFormTactic = {
  anchor: samsungColors.samsungBlue.default
};
const flightFormFrequencyCap = {
  icon: samsungColors.samsungBlue.default
};
const checkBoxListing = {
  listItemBackground: samsungColors.samsungBlue.default,
  listItemColor: samsungColors.neutrals.white
};
const campaingTab = {
  anchorActiveColor: samsungColors.samsungBlue.default,
  anchorActiveBackground: samsungColors.neutrals.white,
  anchorActiveBottomBorder: samsungColors.neutrals.white
};
const inlineEditButton = {
  editButtonColor: samsungColors.skyBlue.default
};
const barTitle = {
  editColor: samsungColors.skyBlue.default
};
const linkStyleWrapper = {
  anchorColor: samsungColors.skyBlue.default,
  anchorHoverColor: samsungColors.skyBlue.light
};
const beaconsForm = {
  copyIconColor: samsungColors.samsungBlue.default
};
const beaconsFormPixels = {
  anchorColor: samsungColors.samsungBlue.default
};
const toolTriggerIcon = {
  color: samsungColors.samsungBlue.default
};
const generatorTabsActiveAnchor = {
  color: samsungColors.samsungBlue.default
};
const segmentGroupTable = {
  backgroundColorNew: samsungColors.samsungBlue.light,
  backgroundColor: samsungColors.neutrals.white
};
const infoBox = {
  success: samsungColors.clover.default,
  danger: samsungColors.coral.default,
  info: samsungColors.samsungBlue.default,
  pending: samsungColors.daffodil.default,
  primary: samsungColors.samsungBlue.default,
  warning: samsungColors.saffron.default
};
const paginationButton = {
  iconColor: samsungColors.samsungBlue.default,
  iconColorDisabled: samsungColors.neutrals.darkGrey,
  backgroundColor: samsungColors.neutrals.lightGrey,
  backgroundColorDisabled: samsungColors.neutrals.grey,
  borderColor: samsungColors.neutrals.grey,
  borderColorDisabled: samsungColors.neutrals.grey
};
const scheduleEditor = {
  borderColor: samsungColors.neutrals.darkGrey,
  backgroundColor: samsungColors.neutrals.white,
  backgroundColorSelected: samsungColors.samsungBlue.lighter
};
const bulletState = {
  success: samsungColors.clover.default,
  danger: samsungColors.coral.default,
  default: samsungColors.neutrals.darkGrey,
  info: samsungColors.seaBlue.default,
  help: samsungColors.seaBlue.default,
  pending: samsungColors.daffodil.default,
  primary: samsungColors.samsungBlue.default,
  warning: samsungColors.saffron.default
};
const badge = {
  color: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.black,
  backgroundColor: {
    success: samsungColors.clover.default,
    danger: samsungColors.coral.default,
    default: samsungColors.neutrals.darkGrey,
    info: samsungColors.skyBlue.default,
    help: samsungColors.skyBlue.default,
    pending: samsungColors.daffodil.default,
    primary: samsungColors.samsungBlue.default,
    warning: samsungColors.saffron.default,
    enqueued: samsungColors.neutrals.darkGrey
  }
};
const errorBlock = {
  color: samsungColors.coral.default,
  messageBackgroundColor: samsungColors.coral.default,
  messageColor: samsungColors.neutrals.white,
  arrowBorderColor: samsungColors.coral.default,
  fullWidthErrorColor: samsungColors.coral.default,
  fullWidthErrorBackgroundColor: samsungColors.neutrals.white,
  fullWidthErrorBorder: samsungColors.coral.default,
  fullWidthErrorLeftBorder: samsungColors.coral.default,
  inTableErrorColor: samsungColors.neutrals.white,
  inTableErrorBackgroundColor: samsungColors.coral.default
};
const alerts = {
  textColor: samsungColors.neutrals.black,
  backgroundColor: {
    success: samsungColors.clover.lighter,
    danger: samsungColors.coral.lighter,
    error: samsungColors.coral.lighter,
    default: samsungColors.neutrals.lightGrey,
    info: samsungColors.skyBlue.lighter,
    help: samsungColors.skyBlue.lighter,
    pending: samsungColors.daffodil.lighter,
    primary: samsungColors.samsungBlue.lighter,
    warning: samsungColors.saffron.lighter,
    enqueued: samsungColors.neutrals.darkGrey
  },
  color: {
    success: samsungColors.clover.default,
    danger: samsungColors.coral.default,
    error: samsungColors.coral.default,
    default: samsungColors.neutrals.grey,
    info: samsungColors.skyBlue.default,
    help: samsungColors.skyBlue.default,
    pending: samsungColors.daffodil.default,
    primary: samsungColors.samsungBlue.default,
    warning: samsungColors.saffron.default,
    enqueued: samsungColors.neutrals.white
  }
};
const checkMark = {
  color: samsungColors.neutrals.grey,
  backgroundColor: samsungColors.neutrals.grey,
  activeColor: samsungColors.neutrals.white,
  includeActiveColor: samsungColors.clover.default,
  includeInheritColor: samsungColors.clover.lighter,
  excludeActiveColor: samsungColors.coral.default,
  excludeInheritColor: samsungColors.coral.lighter,
  hoverColor: samsungColors.clover.lighter,
  disabledColor: samsungColors.neutrals.lightGrey
};
const requiredField = {
  abbrColor: samsungColors.coral.default,
  color: samsungColors.coral.default
};
const icon = {
  color: {
    success: samsungColors.clover.default,
    danger: samsungColors.coral.default,
    default: samsungColors.neutrals.grey,
    info: samsungColors.skyBlue.default,
    help: samsungColors.skyBlue.default,
    pending: samsungColors.daffodil.default,
    primary: samsungColors.samsungBlue.default,
    warning: samsungColors.saffron.default,
    enqueued: samsungColors.neutrals.darkGrey
  }
};
const targetingAnimated = {
  checkColor: samsungColors.clover.default,
  banColor: samsungColors.coral.default
};
const history = {
  plusColor: samsungColors.clover.default,
  plusBorderColor: samsungColors.clover.lighter,
  plusBackgroundColor: samsungColors.clover.lighter,
  minusColor: samsungColors.coral.default,
  minusBorderColor: samsungColors.coral.lighter,
  minusBackgroundColor: samsungColors.coral.lighter
};
const feeContainer = {
  backgroundColor: samsungColors.skyBlue.lighter
};
const errorGroup = {
  textColor: samsungColors.neutrals.black,
  backgroundColor: samsungColors.coral.lighter
};
const multiSelect = {
  backgroundColor: samsungColors.neutrals.white,
  backgroundColorHighlighted: samsungColors.samsungBlue.default,
  color: samsungColors.neutrals.darkGrey,
  colorHighlighted: samsungColors.neutrals.white,
  iconColor: samsungColors.samsungBlue.default
};
const targetedViewer = {
  includeColor: samsungColors.clover.default,
  excludeColor: samsungColors.coral.default
};
const calloutBox = {
  backgroundColor: {
    danger: samsungColors.coral.lighter,
    warning: samsungColors.saffron.lighter,
    info: samsungColors.skyBlue.lighter
  },
  borderColor: {
    danger: samsungColors.coral.default,
    warning: samsungColors.saffron.default,
    info: samsungColors.skyBlue.default
  }
};
const select = {
  list: {
    backgroundColor: samsungColors.neutrals.white,
    borderColor: samsungColors.samsungBlue.default,
    readOnly: {
      backgroundColor: samsungColors.neutrals.lightGrey
    }
  },
  section: {
    borderColor: samsungColors.neutrals.grey,
    title: {
      color: samsungColors.samsungBlue.light
    }
  },
  option: {
    color: samsungColors.samsungBlue.default,
    hover: {
      backgroundColor: samsungColors.samsungBlue.lighter,
      color: samsungColors.samsungBlue.default
    },
    active: {
      backgroundColor: samsungColors.samsungBlue.lightest,
      color: samsungColors.samsungBlue.default
    },
    disabled: {
      color: samsungColors.neutrals.darkGrey
    }
  }
};
const currencyInput = {
  borderColorFocus: samsungColors.samsungBlue.default
};
const tableError = {
  color: samsungColors.coral.default,
  backgroundColor: samsungColors.coral.lighter,
  backgroundColorHover: samsungColors.coral.lighter
};
const footer = {
  color: samsungColors.neutrals.darkGrey,
  borderColor: samsungColors.neutrals.grey,
  backgroundColor: samsungColors.neutrals.white
};
const sideNav = {
  backgroundColor: samsungColors.neutrals.black,
  subtitleColor: samsungColors.samsungBlue.default,
  togglerBackground: samsungColors.neutrals.black,
  togglerColor: samsungColors.neutrals.white,
  sideNavLink: {
    color: samsungColors.neutrals.grey,
    infoColor: samsungColors.neutrals.white,
    visitedBackgroundColor: samsungColors.samsungBlue.default
  },
  innerSideNavLink: {
    backgroundColor: samsungColors.neutrals.lightGrey,
    hoverColor: samsungColors.samsungBlue.default,
    hoverBackgroundColor: samsungColors.neutrals.lightGrey,
    visitedBackgroundColor: samsungColors.samsungBlue.default
  }
};
const tooltip = {
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.samsungBlue.default,
  color: samsungColors.neutrals.black,
  learnMore: {
    color: samsungColors.skyBlue.default
  }
};
const header = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey
};
const input = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey,
  readOnly: {
    borderColor: samsungColors.neutrals.grey,
    backgroundColor: samsungColors.neutrals.lightGrey
  },
  disabled: {
    color: samsungColors.neutrals.darkGrey,
    borderColor: samsungColors.neutrals.grey,
    backgroundColor: samsungColors.neutrals.lightGrey
  },
  error: {
    borderColor: samsungColors.coral.default,
    color: samsungColors.coral.default
  },
  isFocused: {
    borderColor: samsungColors.samsungBlue.default
  },
  icon: {
    default: {
      color: samsungColors.neutrals.black
    },
    primary: {
      color: samsungColors.samsungBlue.default
    },
    disabled: {
      color: samsungColors.neutrals.darkGrey
    }
  }
};
// Cannot name it `switch`
const _switch = {
  buttonColor: samsungColors.neutrals.white,
  backgroundColor: samsungColors.neutrals.grey,
  checked: {
    backgroundColor: samsungColors.samsungBlue.default
  },
  disabled: {
    buttonColor: samsungColors.neutrals.lightGrey
  }
};
const toggle = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey,
  selected: {
    color: samsungColors.neutrals.white,
    backgroundColor: samsungColors.samsungBlue.default,
    borderColor: 'transparent'
  },
  disabled: {
    color: samsungColors.neutrals.darkGrey,
    backgroundColor: samsungColors.neutrals.lightGrey
  },
  hover: {
    color: samsungColors.neutrals.black,
    backgroundColor: samsungColors.samsungBlue.lighter
  },
  active: {
    color: samsungColors.neutrals.black,
    backgroundColor: samsungColors.samsungBlue.lightest
  }
};
const checkbox = {
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.darkGrey,
  checkColor: samsungColors.neutrals.white,
  hover: {
    backgroundColor: samsungColors.samsungBlue.lighter,
    borderColor: samsungColors.samsungBlue.default,
    checked: {
      backgroundColor: samsungColors.samsungBlue.light,
      borderColor: samsungColors.samsungBlue.light
    }
  },
  focused: {
    borderColor: samsungColors.samsungBlue.default,
    checked: {
      backgroundColor: samsungColors.samsungBlue.light
    }
  },
  checked: {
    backgroundColor: samsungColors.samsungBlue.default,
    borderColor: samsungColors.samsungBlue.default
  },
  disabled: {
    color: samsungColors.neutrals.darkGrey,
    backgroundColor: samsungColors.neutrals.lightGrey,
    borderColor: samsungColors.neutrals.grey,
    checked: {
      checkColor: samsungColors.neutrals.grey
    }
  },
  readOnly: {
    backgroundColor: samsungColors.neutrals.lightGrey,
    borderColor: samsungColors.neutrals.darkGrey,
    checked: {
      checkColor: samsungColors.neutrals.darkGrey
    }
  }
};
const radio = {
  color: samsungColors.neutrals.black,
  borderColor: samsungColors.neutrals.grey,
  backgroundColor: samsungColors.neutrals.white,
  focused: {
    borderColor: samsungColors.samsungBlue.default
  },
  checked: {
    borderColor: samsungColors.neutrals.grey,
    backgroundColor: samsungColors.samsungBlue.default
  },
  disabled: {
    color: samsungColors.neutrals.darkGrey,
    backgroundColor: samsungColors.neutrals.lightGrey,
    borderColor: samsungColors.neutrals.grey,
    checked: {
      backgroundColor: samsungColors.neutrals.grey
    }
  },
  readOnly: {
    backgroundColor: samsungColors.neutrals.lightGrey,
    borderColor: samsungColors.neutrals.darkGrey,
    checked: {
      backgroundColor: samsungColors.neutrals.darkGrey
    }
  }
};
const pill = {
  tooltipLabelColor: samsungColors.neutrals.white,
  default: {
    color: samsungColors.neutrals.white,
    titleColor: samsungColors.neutrals.white,
    iconColor: samsungColors.neutrals.white,
    deleteIconColor: samsungColors.neutrals.white,
    backgroundColor: samsungColors.neutrals.darkGrey,
    hover: {
      deleteIconColor: samsungColors.neutrals.grey,
      backgroundColor: samsungColors.neutrals.lightGrey
    },
    focus: {
      backgroundColor: samsungColors.neutrals.lightGrey
    }
  },
  success: {
    color: samsungColors.neutrals.white,
    titleColor: samsungColors.neutrals.white,
    iconColor: samsungColors.neutrals.white,
    deleteIconColor: samsungColors.neutrals.white,
    backgroundColor: samsungColors.clover.default,
    hover: {
      deleteIconColor: samsungColors.clover.light,
      backgroundColor: samsungColors.clover.dark
    },
    focus: {
      backgroundColor: samsungColors.saffron.darker
    }
  },
  pending: {
    color: samsungColors.neutrals.black,
    titleColor: samsungColors.neutrals.black,
    iconColor: samsungColors.neutrals.black,
    deleteIconColor: samsungColors.neutrals.black,
    backgroundColor: samsungColors.saffron.default,
    hover: {
      deleteIconColor: samsungColors.saffron.dark,
      backgroundColor: samsungColors.saffron.light
    },
    focus: {
      backgroundColor: samsungColors.saffron.lighter
    }
  },
  warning: {
    color: samsungColors.neutrals.white,
    titleColor: samsungColors.neutrals.white,
    iconColor: samsungColors.neutrals.white,
    deleteIconColor: samsungColors.neutrals.white,
    backgroundColor: samsungColors.pepper.default,
    hover: {
      deleteIconColor: samsungColors.pepper.light,
      backgroundColor: samsungColors.pepper.dark
    },
    focus: {
      backgroundColor: samsungColors.pepper.darker
    }
  },
  error: {
    color: samsungColors.neutrals.white,
    titleColor: samsungColors.neutrals.white,
    iconColor: samsungColors.neutrals.white,
    deleteIconColor: samsungColors.neutrals.white,
    backgroundColor: samsungColors.coral.default,
    hover: {
      deleteIconColor: samsungColors.coral.light,
      backgroundColor: samsungColors.coral.dark
    },
    focus: {
      backgroundColor: samsungColors.coral.darker
    }
  },
  outlined: {
    color: samsungColors.neutrals.black,
    titleColor: samsungColors.neutrals.darkGrey,
    iconColor: samsungColors.neutrals.darkGrey,
    deleteIconColor: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.neutrals.white,
    borderColor: samsungColors.neutrals.grey,
    hover: {
      color: samsungColors.samsungBlue.default,
      borderColor: samsungColors.samsungBlue.default,
      deleteIconColor: samsungColors.samsungBlue.light,
      backgroundColor: samsungColors.samsungBlue.lighter
    },
    focus: {
      color: samsungColors.samsungBlue.default,
      borderColor: samsungColors.samsungBlue.default,
      backgroundColor: samsungColors.samsungBlue.lightest
    },
    disabled: {
      backgroundColor: samsungColors.neutrals.lightGrey,
      borderColor: samsungColors.neutrals.grey
    }
  }
};
const tabs = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey,
  disabled: {
    color: samsungColors.neutrals.darkGrey
  },
  selected: {
    color: samsungColors.samsungBlue.default,
    borderColor: samsungColors.samsungBlue.default
  },
  hover: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.samsungBlue.lighter
  },
  active: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.samsungBlue.lightest,
    borderColor: samsungColors.samsungBlue.lighter
  }
};
const ribbon = {
  color: samsungColors.neutrals.black,
  success: {
    backgroundColor: samsungColors.clover.lighter,
    icon: {
      color: samsungColors.clover.default
    }
  },
  info: {
    backgroundColor: samsungColors.skyBlue.lighter,
    icon: {
      color: samsungColors.skyBlue.default
    }
  },
  warning: {
    backgroundColor: samsungColors.saffron.lighter,
    icon: {
      color: samsungColors.pepper.default
    }
  },
  error: {
    backgroundColor: samsungColors.coral.lighter,
    icon: {
      color: samsungColors.coral.default
    }
  },
  insight: {
    backgroundColor: samsungColors.coral.lightest,
    icon: {
      color: samsungColors.samsungBlue.default
    }
  }
};
const modal = {
  color: samsungColors.neutrals.black,
  backgroundColor: samsungColors.neutrals.white
};
const spinner = {
  color: samsungColors.samsungBlue.default
};
const indicator = {
  separator: {
    backgroundColor: samsungColors.neutrals.darkerGrey
  },
  bar: {
    borderColor: samsungColors.neutrals.grey,
    backgroundColor: samsungColors.neutrals.white
  },
  gauge: {
    color: {
      default: samsungColors.neutrals.darkGrey,
      danger: samsungColors.coral.default
    },
    backgroundColor: samsungColors.skyBlue.default
  }
};
const popover = {
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.samsungBlue.default,
  pagination: {
    backgroundColor: samsungColors.neutrals.lightGrey,
    color: samsungColors.neutrals.darkGrey
  },
  icon: {
    color: samsungColors.samsungBlue.default,
    colorDisabled: samsungColors.neutrals.darkGrey
  }
};
const scrollbar = {
  backgroundColor: samsungColors.neutrals.white,
  color: samsungColors.neutrals.grey
};
const uploader = {
  default: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.neutrals.white,
    borderColor: samsungColors.samsungBlue.default
  },
  error: {
    color: samsungColors.coral.default,
    borderColor: samsungColors.coral.default
  },
  hover: {
    backgroundColor: samsungColors.samsungBlue.lightest
  },
  list: {
    borderColor: samsungColors.neutrals.grey
  }
};
const accordion = {
  borderColor: samsungColors.neutrals.grey,
  borderColorFocused: samsungColors.samsungBlue.default
};
const board = {
  borderColor: samsungColors.neutrals.grey,
  backgroundColor: samsungColors.neutrals.white,
  separator: {
    color: samsungColors.neutrals.grey,
    hover: {
      color: samsungColors.samsungBlue.default
    }
  },
  addCard: {
    color: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.neutrals.white,
    borderColor: samsungColors.samsungBlue.default,
    hover: {
      backgroundColor: samsungColors.samsungBlue.lighter
    }
  },
  select: {
    color: samsungColors.neutrals.black,
    icon: {
      color: samsungColors.neutrals.black
    }
  },
  icon: {
    color: samsungColors.neutrals.grey,
    hover: {
      color: samsungColors.samsungBlue.light
    }
  },
  card: {
    hover: {
      icon: {
        color: samsungColors.samsungBlue.default
      }
    }
  },
  dropzone: {
    borderColor: samsungColors.samsungBlue.default,
    backgroundColor: samsungColors.samsungBlue.lightest
  },
  addButton: {
    borderColor: samsungColors.neutrals.grey
  }
};
const list = {
  dividerColor: samsungColors.neutrals.grey,
  subheaderColor: samsungColors.samsungBlue.light,
  descriptionColor: samsungColors.neutrals.darkGrey,
  outline: {
    default: samsungColors.neutrals.grey,
    active: samsungColors.samsungBlue.default
  },
  listItem: {
    color: samsungColors.neutrals.black,
    backgroundColor: samsungColors.neutrals.white,
    hover: {
      color: samsungColors.samsungBlue.default,
      backgroundColor: samsungColors.samsungBlue.lighter
    },
    focus: {
      color: samsungColors.samsungBlue.default,
      backgroundColor: samsungColors.samsungBlue.lightest
    },
    disabled: {
      color: samsungColors.neutrals.darkGrey
    }
  }
};
const tile = {
  backgroundColor: samsungColors.neutrals.white,
  borderColor: samsungColors.neutrals.grey,
  dividerColor: samsungColors.neutrals.grey,
  imageBackgroundColor: 'transparent',
  active: {
    backgroundColor: samsungColors.samsungBlue.lightest,
    textColor: samsungColors.samsungBlue.default
  },
  disabled: {
    backgroundColor: samsungColors.neutrals.lightGrey,
    textColor: samsungColors.neutrals.darkGrey
  },
  hover: {
    backgroundColor: samsungColors.samsungBlue.lighter,
    borderColor: samsungColors.samsungBlue.default,
    dividerColor: samsungColors.samsungBlue.light
  }
};
const overlay = {
  backgroundColor: 'rgba(0, 0, 0, 0.5)'
};
const colors = _objectSpread$1(_objectSpread$1({}, samsungColors), {}, {
  button,
  downloadButton,
  tabItem,
  dropdownMenuItem,
  toggleButtonGroup,
  toggleButton,
  autocompleteItem,
  daytimePartingActionButton,
  dropzoneInput,
  dropzone,
  uploaderMessage,
  customTheme,
  base,
  demandAccess,
  segments,
  iconLink,
  dropdownButton,
  fakeLink,
  styledTargetingViewer,
  headerBarButton,
  helpPopover,
  getIcon,
  gridHeaderDropdownButton,
  progressLine,
  sideNavItem,
  smartFilterLabel,
  smartFilterPill,
  smartTableFilterOptions,
  smartTableFilterPill,
  bootstrap,
  flightFormTab,
  flightFormTactic,
  flightFormFrequencyCap,
  checkBoxListing,
  campaingTab,
  inlineEditButton,
  barTitle,
  linkStyleWrapper,
  beaconsForm,
  beaconsFormPixels,
  toolTriggerIcon,
  generatorTabsActiveAnchor,
  segmentGroupTable,
  infoBox,
  paginationButton,
  scheduleEditor,
  bulletState,
  badge,
  errorBlock,
  alerts,
  checkMark,
  requiredField,
  icon,
  targetingAnimated,
  history,
  feeContainer,
  errorGroup,
  multiSelect,
  targetedViewer,
  calloutBox,
  select,
  currencyInput,
  tableError,
  footer,
  sideNav,
  dropdownList,
  tooltip,
  header,
  input,
  toggle,
  switch: _switch,
  checkbox,
  radio,
  tabs,
  pill,
  ribbon,
  modal,
  spinner,
  indicator,
  popover,
  scrollbar,
  uploader,
  accordion,
  board,
  list,
  tile,
  overlay
});

// References for original spacing format
// none: 0px
// xs: 8px - separating elements within a component
// sm: 16px - internal margin for input fields in forms and other components within a form section
// md: 24px - margin for form sections
// lg: 32px - internal bottom margin at the end of a container, when applying density
// xl: 40px - bottom padding at the end of containers.
const baseValue = 8;
const spacing = (factor, unit = 'px') => baseValue * factor + unit;

const theme = {
  name: 'samsung',
  spacing,
  breakpoints: ['1024px'],
  colors,
  fonts
};
const legacy$1 = {
  zIndex,
  colors: legacy,
  fontFamilies,
  severityToColor
};

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
});

var _objectWithoutProperties = /*@__PURE__*/getDefaultExportFromCjs(objectWithoutProperties);

const dashToPascalCase = str => str.toLowerCase().split('-').map(segment => segment.charAt(0).toUpperCase() + segment.slice(1)).join('');
const camelToDashCase = str => str.replace(/([A-Z])/g, m => `-${m[0].toLowerCase()}`);

const attachProps = (node, newProps, oldProps = {}) => {
  // some test frameworks don't render DOM elements, so we test here to make sure we are dealing with DOM first
  if (node instanceof Element) {
    // add any classes in className to the class list
    const className = getClassName(node.classList, newProps, oldProps);
    if (className !== '') {
      node.className = className;
    }
    Object.keys(newProps).forEach(name => {
      if (name === 'children' || name === 'style' || name === 'ref' || name === 'class' || name === 'className' || name === 'forwardedRef') {
        return;
      }
      if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
        const eventName = name.substring(2);
        const eventNameLc = eventName[0].toLowerCase() + eventName.substring(1);
        if (!isCoveredByReact(eventNameLc)) {
          syncEvent(node, eventNameLc, newProps[name]);
        }
      } else {
        node[name] = newProps[name];
        const propType = typeof newProps[name];
        if (propType === 'string') {
          node.setAttribute(camelToDashCase(name), newProps[name]);
        }
      }
    });
  }
};
const getClassName = (classList, newProps, oldProps) => {
  const newClassProp = newProps.className || newProps.class;
  const oldClassProp = oldProps.className || oldProps.class;
  // map the classes to Maps for performance
  const currentClasses = arrayToMap(classList);
  const incomingPropClasses = arrayToMap(newClassProp ? newClassProp.split(' ') : []);
  const oldPropClasses = arrayToMap(oldClassProp ? oldClassProp.split(' ') : []);
  const finalClassNames = [];
  // loop through each of the current classes on the component
  // to see if it should be a part of the classNames added
  currentClasses.forEach(currentClass => {
    if (incomingPropClasses.has(currentClass)) {
      // add it as its already included in classnames coming in from newProps
      finalClassNames.push(currentClass);
      incomingPropClasses.delete(currentClass);
    } else if (!oldPropClasses.has(currentClass)) {
      // add it as it has NOT been removed by user
      finalClassNames.push(currentClass);
    }
  });
  incomingPropClasses.forEach(s => finalClassNames.push(s));
  return finalClassNames.join(' ');
};
/**
 * Transforms a React event name to a browser event name.
 */
const transformReactEventName = eventNameSuffix => {
  switch (eventNameSuffix) {
    case 'doubleclick':
      return 'dblclick';
  }
  return eventNameSuffix;
};
/**
 * Checks if an event is supported in the current execution environment.
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
const isCoveredByReact = eventNameSuffix => {
  if (typeof document === 'undefined') {
    return true;
  } else {
    const eventName = 'on' + transformReactEventName(eventNameSuffix);
    let isSupported = (eventName in document);
    if (!isSupported) {
      const element = document.createElement('div');
      element.setAttribute(eventName, 'return;');
      isSupported = typeof element[eventName] === 'function';
    }
    return isSupported;
  }
};
const syncEvent = (node, eventName, newEventHandler) => {
  const eventStore = node.__events || (node.__events = {});
  const oldEventHandler = eventStore[eventName];
  // Remove old listener so they don't double up.
  if (oldEventHandler) {
    node.removeEventListener(eventName, oldEventHandler);
  }
  // Bind new listener.
  node.addEventListener(eventName, eventStore[eventName] = function handler(e) {
    if (newEventHandler) {
      newEventHandler.call(this, e);
    }
  });
};
const arrayToMap = arr => {
  const map = new Map();
  arr.forEach(s => map.set(s, s));
  return map;
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const setRef = (ref, value) => {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref != null) {
    // Cast as a MutableRef so we can assign current
    ref.current = value;
  }
};
const mergeRefs = (...refs) => {
  return value => {
    refs.forEach(ref => {
      setRef(ref, value);
    });
  };
};
const createForwardRef = (ReactComponent, displayName) => {
  const forwardRef = (props, ref) => {
    return /*#__PURE__*/React.createElement(ReactComponent, _objectSpread$2(_objectSpread$2({}, props), {}, {
      forwardedRef: ref
    }));
  };
  forwardRef.displayName = displayName;
  return /*#__PURE__*/React.forwardRef(forwardRef);
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const createReactComponent = (tagName, ReactComponentContext, manipulatePropsFunction, defineCustomElement) => {
  if (defineCustomElement !== undefined) {
    defineCustomElement();
  }
  const displayName = dashToPascalCase(tagName);
  const ReactComponent = class ReactComponent extends React.Component {
    constructor(props) {
      super(props);
      this.componentEl = void 0;
      this.setComponentElRef = element => {
        this.componentEl = element;
      };
    }
    componentDidMount() {
      this.componentDidUpdate(this.props);
    }
    componentDidUpdate(prevProps) {
      attachProps(this.componentEl, this.props, prevProps);
    }
    render() {
      const _this$props = this.props,
        {
          children,
          forwardedRef,
          style,
          className,
          ref
        } = _this$props,
        cProps = _objectWithoutProperties(_this$props, ["children", "forwardedRef", "style", "className", "ref"]);
      let propsToPass = Object.keys(cProps).reduce((acc, name) => {
        const value = cProps[name];
        if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
          const eventName = name.substring(2).toLowerCase();
          if (typeof document !== 'undefined' && isCoveredByReact(eventName)) {
            acc[name] = value;
          }
        } else {
          // we should only render strings, booleans, and numbers as attrs in html.
          // objects, functions, arrays etc get synced via properties on mount.
          const type = typeof value;
          if (type === 'string' || type === 'boolean' || type === 'number') {
            acc[camelToDashCase(name)] = value;
          }
        }
        return acc;
      }, {});
      if (manipulatePropsFunction) {
        propsToPass = manipulatePropsFunction(this.props, propsToPass);
      }
      const newProps = _objectSpread$3(_objectSpread$3({}, propsToPass), {}, {
        ref: mergeRefs(forwardedRef, this.setComponentElRef),
        style
      });
      /**
       * We use createElement here instead of
       * React.createElement to work around a
       * bug in Vite (https://github.com/vitejs/vite/issues/6104).
       * React.createElement causes all elements to be rendered
       * as <tagname> instead of the actual Web Component.
       */
      return /*#__PURE__*/createElement$1(tagName, newProps, children);
    }
    static get displayName() {
      return displayName;
    }
  };
  // If context was passed to createReactComponent then conditionally add it to the Component Class
  if (ReactComponentContext) {
    ReactComponent.contextType = ReactComponentContext;
  }
  return createForwardRef(ReactComponent, displayName);
};

/* eslint-disable */
const BeauIcon = /*@__PURE__*/createReactComponent('beau-icon');

// Core Button
const CoreButton = styled.button.withConfig({
  displayName: "styles__CoreButton",
  componentId: "sc-3j5nl9-0"
})(["outline:none;cursor:pointer;border-width:1px;display:inline-flex;align-items:center;justify-content:center;border-style:solid;font-size:", ";line-height:16px;font-family:", ";font-weight:", ";", ";&:disabled{cursor:default;}> .button-icon{margin-right:", ";}> .button-dropdown-icon{margin-left:8px;svg{transform:", ";}}"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  small
}) => small ? SmallButton : LargeButton, ({
  hasLabel,
  theme
}) => hasLabel && theme.spacing(1), ({
  isPressed
}) => isPressed && 'rotate(180deg);');
// Sizes
const SmallButton = css$1(["height:32px;border-radius:8px;width:", ";padding:", ";"], ({
  hasLabel
}) => !hasLabel && '32px', ({
  hasLabel,
  theme
}) => hasLabel && `${theme.spacing(0)} ${theme.spacing(2)}`);
const LargeButton = css$1(["height:42px;border-radius:40px;padding:", ";min-width:80px;"], ({
  theme
}) => `${theme.spacing(1)} ${theme.spacing(2)}`);
// Colors
const ButtonPrimary = styled(CoreButton).withConfig({
  displayName: "styles__ButtonPrimary",
  componentId: "sc-3j5nl9-1"
})(["color:", ";background:", ";border:", ";&:hover{background:", ";border-color:", ";}&:active{background:", ";border-color:", ";}&:focus{box-shadow:", ";}&:disabled{background:", ";color:", ";border-color:", ";cursor:not-allowed;}"], ({
  theme
}) => theme.colors.button.primary.color, ({
  theme
}) => theme.colors.button.primary.backgroundColor, ({
  theme
}) => `1px solid ${theme.colors.button.primary.borderColor}`, ({
  theme
}) => theme.colors.button.primary.hover.backgroundColor, ({
  theme
}) => theme.colors.button.primary.hover.borderColor, ({
  theme
}) => theme.colors.button.primary.active.backgroundColor, ({
  theme
}) => theme.colors.button.primary.active.borderColor, ({
  theme
}) => `0 0 4px ${theme.colors.button.primary.focus.boxShadowColor}`, ({
  theme
}) => theme.colors.button.primary.disabled.backgroundColor, ({
  theme
}) => theme.colors.button.primary.disabled.color, ({
  theme
}) => theme.colors.button.primary.disabled.borderColor);
const ButtonSecondary = styled(CoreButton).withConfig({
  displayName: "styles__ButtonSecondary",
  componentId: "sc-3j5nl9-2"
})(["color:", ";border-color:", ";background:", ";&:hover{background:", ";}&:active{background:", ";}&:focus{box-shadow:", ";}&:disabled{background:", ";color:", ";border-color:", ";cursor:default;}"], ({
  theme
}) => theme.colors.button.secondary.color, ({
  theme
}) => theme.colors.button.secondary.borderColor, ({
  theme
}) => theme.colors.button.secondary.backgroundColor, ({
  theme
}) => theme.colors.button.secondary.hover.backgroundColor, ({
  theme
}) => theme.colors.button.secondary.active.backgroundColor, ({
  theme
}) => `0 0 4px ${theme.colors.button.secondary.focus.boxShadowColor}`, ({
  theme
}) => theme.colors.button.secondary.disabled.backgroundColor, ({
  theme
}) => theme.colors.button.secondary.disabled.color, ({
  theme
}) => theme.colors.button.secondary.disabled.borderColor);
const ButtonDanger = styled(CoreButton).withConfig({
  displayName: "styles__ButtonDanger",
  componentId: "sc-3j5nl9-3"
})(["background:", ";color:", ";border-color:", ";&:hover{background:", ";border-color:", ";}&:active{background:", ";border-color:", ";}&:focus{box-shadow:", ";}&:disabled{background:", ";color:", ";border-color:", ";cursor:default;}"], ({
  theme
}) => theme.colors.button.danger.backgroundColor, ({
  theme
}) => theme.colors.button.danger.color, ({
  theme
}) => theme.colors.button.danger.borderColor, ({
  theme
}) => theme.colors.button.danger.hover.backgroundColor, ({
  theme
}) => theme.colors.button.danger.hover.borderColor, ({
  theme
}) => theme.colors.button.danger.active.backgroundColor, ({
  theme
}) => theme.colors.button.danger.active.borderColor, ({
  theme
}) => `0 0 4px ${theme.colors.button.danger.focus.boxShadowColor}`, ({
  theme
}) => theme.colors.button.danger.disabled.backgroundColor, ({
  theme
}) => theme.colors.button.danger.disabled.color, ({
  theme
}) => theme.colors.button.danger.disabled.borderColor);
const ButtonLight = styled(CoreButton).withConfig({
  displayName: "styles__ButtonLight",
  componentId: "sc-3j5nl9-4"
})(["color:", ";background:none;border-color:transparent;&:hover{background:", ";}&:active{background:", ";}&:focus{border:", ";}&:disabled{background:none;border:0;color:", ";cursor:default;}"], ({
  theme
}) => theme.colors.button.light.color, ({
  theme
}) => theme.colors.button.light.hover.backgroundColor, ({
  theme
}) => theme.colors.button.light.hover.backgroundColor, ({
  theme
}) => `1px solid ${theme.colors.button.light.focus.borderColor}`, ({
  theme
}) => theme.colors.button.light.disabled.color);

const getButtonType = type => {
  switch (type) {
    case 'primary':
      return ButtonPrimary;
    case 'secondary':
      return ButtonSecondary;
    case 'danger':
      return ButtonDanger;
    case 'light':
      return ButtonLight;
    default:
      throw new Error('Unknown type');
  }
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Accounts = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.667 1.75v2.5a.75.75 0 01-.75.75H.75A.75.75 0 010 4.25v-2.5A.75.75 0 01.75 1h3.167a.75.75 0 01.75.75zm5.666 7.5v-2.5a.75.75 0 00-.75-.75H6.417a.75.75 0 00-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 00.75-.75zm1-7.5v2.5c0 .414.336.75.75.75h3.167a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-3.167a.75.75 0 00-.75.75zm-1 2.5v-2.5a.75.75 0 00-.75-.75H6.417a.75.75 0 00-.75.75v2.5c0 .414.335.75.75.75h3.166a.75.75 0 00.75-.75zM3.917 6H.75a.75.75 0 00-.75.75v2.5c0 .414.336.75.75.75h3.167a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75zM0 11.75v2.5c0 .414.336.75.75.75h3.167a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75H.75a.75.75 0 00-.75.75zM12.083 10h3.167a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-3.167a.75.75 0 00-.75.75v2.5c0 .414.336.75.75.75zm0 5h3.167a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75h-3.167a.75.75 0 00-.75.75v2.5c0 .414.336.75.75.75zm-6.416-3.25v2.5c0 .414.335.75.75.75h3.166a.75.75 0 00.75-.75v-2.5a.75.75 0 00-.75-.75H6.417a.75.75 0 00-.75.75z"
})));

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var Actions = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.323 8.323A2.321 2.321 0 018 10.645a2.321 2.321 0 01-2.323-2.322A2.321 2.321 0 018 6a2.321 2.321 0 012.323 2.323zM13.677 6a2.321 2.321 0 00-2.322 2.323 2.321 2.321 0 002.322 2.322A2.321 2.321 0 0016 8.323 2.321 2.321 0 0013.677 6zM2.323 6A2.321 2.321 0 000 8.323a2.321 2.321 0 002.323 2.322 2.321 2.321 0 002.322-2.322A2.321 2.321 0 002.323 6z"
})));

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var Activity = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$2({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.19 8.784H3.891a.432.432 0 00-.433.432v5.19c0 .238.194.432.433.432h1.297a.432.432 0 00.433-.433V9.216a.432.432 0 00-.433-.432zm-3.46 2.594H.432a.432.432 0 00-.432.433v2.594c0 .24.194.433.432.433H1.73a.432.432 0 00.432-.433v-2.594a.432.432 0 00-.432-.433zM8.649 6.19H7.35a.432.432 0 00-.432.433v7.783c0 .24.193.433.432.433H8.65a.432.432 0 00.432-.433V6.622a.432.432 0 00-.432-.433zm3.46-2.594H10.81a.432.432 0 00-.433.432v10.378c0 .24.194.433.433.433h1.297a.432.432 0 00.432-.433V4.027a.432.432 0 00-.432-.432zM15.567 1H14.27a.432.432 0 00-.432.432v12.973c0 .24.193.433.432.433h1.298a.432.432 0 00.432-.433V1.432A.432.432 0 0015.568 1z"
})));

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var Add = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$3({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.857 6.286H9.714V1.143C9.714.512 9.203 0 8.571 0H7.43c-.631 0-1.143.512-1.143 1.143v5.143H1.143C.512 6.286 0 6.798 0 7.429V8.57c0 .632.512 1.143 1.143 1.143h5.143v5.143c0 .631.512 1.143 1.143 1.143H8.57c.632 0 1.143-.512 1.143-1.143V9.714h5.143c.631 0 1.143-.511 1.143-1.143V7.43c0-.631-.512-1.143-1.143-1.143z"
})));

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var Admin = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$4({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0h-9A1.5 1.5 0 002 1.5v13A1.5 1.5 0 003.5 16h9a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0012.5 0zm0 14.5h-9v-13h9v13zm-6-11h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-3c-.275 0-.5.225-.5.5s.225.5.5.5zM8 9c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm-2.8 4h5.6c.387 0 .7-.269.7-.6v-.6c0-.994-.94-1.8-2.1-1.8-.338 0-.584.25-1.4.25-.84 0-1.044-.25-1.4-.25-1.16 0-2.1.806-2.1 1.8v.6c0 .331.313.6.7.6z"
})));

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var Alert = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$5({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 16a2 2 0 002-2H6a2 2 0 002 2zm6.73-4.678c-.603-.65-1.732-1.625-1.732-4.822 0-2.428-1.703-4.372-3.999-4.849V1a1 1 0 10-1.998 0v.651c-2.296.477-3.998 2.42-3.998 4.849 0 3.197-1.13 4.173-1.734 4.822A.976.976 0 001 12a1 1 0 001.003 1h11.994A1 1 0 0015 12a.976.976 0 00-.27-.678z"
})));

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var Archive = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$6({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 14c0 .553.447 1 1 1h12c.553 0 1-.447 1-1V5H1v9zm5-6.625C6 7.169 6.169 7 6.375 7h3.25c.206 0 .375.169.375.375v.25A.376.376 0 019.625 8h-3.25A.376.376 0 016 7.625v-.25zM15 1H1c-.553 0-1 .447-1 1v1.5c0 .275.225.5.5.5h15c.275 0 .5-.225.5-.5V2c0-.553-.447-1-1-1z"
})));

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var ArrowDown = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$7({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.233 12.597l-7.12-7.12a.88.88 0 010-1.244l.83-.83A.88.88 0 012.185 3.4l5.67 5.643 5.67-5.643a.88.88 0 011.242.002l.83.83a.88.88 0 010 1.244l-7.12 7.12a.88.88 0 01-1.244 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var ArrowLeft = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$8({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.257 7.378l7.121-7.12a.88.88 0 011.244 0l.83.83a.88.88 0 01.002 1.242L6.81 8l5.644 5.67c.342.344.341.899-.002 1.242l-.83.83a.88.88 0 01-1.244 0l-7.12-7.12a.88.88 0 010-1.244z"
})));

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var ArrowRight = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$9({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.452 8.622l-7.12 7.12a.88.88 0 01-1.244 0l-.83-.83a.88.88 0 01-.002-1.242L8.9 8 3.256 2.33a.88.88 0 01.002-1.242l.83-.83a.88.88 0 011.244 0l7.12 7.12a.88.88 0 010 1.244z"
})));

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var ArrowTrendDown = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$a({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.55 6.803l.793.793a.853.853 0 010 1.21l-6.939 6.942a.853.853 0 01-1.21 0L.252 8.806a.854.854 0 010-1.21l.793-.793a.858.858 0 011.224.014l4.1 4.303V.857c0-.475.382-.857.857-.857h1.143c.475 0 .857.382.857.857V11.12l4.1-4.303a.852.852 0 011.224-.014z"
})));

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var ArrowTrendUp = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$b({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.045 9.197l-.793-.793a.854.854 0 010-1.21L7.19.252a.854.854 0 011.21 0l6.94 6.938a.854.854 0 010 1.21l-.793.794a.858.858 0 01-1.225-.015l-4.096-4.3v10.264a.855.855 0 01-.857.857H7.226a.855.855 0 01-.857-.857V4.88l-4.1 4.303a.852.852 0 01-1.224.014z"
})));

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var ArrowUp = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$c({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.477 3.402l7.12 7.121a.88.88 0 010 1.244l-.83.83a.88.88 0 01-1.242.002l-5.67-5.644-5.67 5.644a.879.879 0 01-1.242-.002l-.83-.83a.88.88 0 010-1.244l7.12-7.12a.88.88 0 011.244 0z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var Auction = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$d({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.78 6.23l-.707-.708a.75.75 0 00-1.06 0l-.177.177L10.3 2.164l.177-.177a.75.75 0 000-1.06L9.77.218a.75.75 0 00-1.06 0L4.82 4.108a.75.75 0 000 1.06l.708.708a.75.75 0 001.06 0l.177-.177 1.237 1.237L5.47 9.47l-.177-.177a1 1 0 00-1.414 0L.293 12.878a1 1 0 000 1.414l1.414 1.414a1 1 0 001.415 0l3.585-3.585a1 1 0 000-1.415l-.176-.176 2.532-2.533L10.3 9.235l-.176.176a.75.75 0 000 1.061l.707.707a.75.75 0 001.06 0l3.89-3.889a.75.75 0 000-1.06z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var Audiences = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$e({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.4 6.8c.883 0 1.6-.718 1.6-1.6 0-.883-.717-1.6-1.6-1.6-.882 0-1.6.717-1.6 1.6 0 .882.718 1.6 1.6 1.6zm11.2 0c.883 0 1.6-.718 1.6-1.6 0-.883-.717-1.6-1.6-1.6-.883 0-1.6.717-1.6 1.6 0 .882.717 1.6 1.6 1.6zm.8.8h-1.6c-.44 0-.838.178-1.128.465A3.657 3.657 0 0113.55 10.8h1.65a.8.8 0 00.8-.8v-.8c0-.882-.717-1.6-1.6-1.6zM8 7.6c1.547 0 2.8-1.252 2.8-2.8C10.8 3.253 9.547 2 8 2a2.799 2.799 0 00-2.8 2.8c0 1.548 1.252 2.8 2.8 2.8zm1.92.8h-.207c-.52.25-1.098.4-1.713.4s-1.19-.15-1.713-.4H6.08a2.88 2.88 0 00-2.88 2.88V12a1.2 1.2 0 001.2 1.2h7.2a1.2 1.2 0 001.2-1.2v-.72A2.88 2.88 0 009.92 8.4zm-5.593-.335A1.595 1.595 0 003.2 7.6H1.6C.717 7.6 0 8.318 0 9.2v.8a.8.8 0 00.8.8h1.647a3.666 3.666 0 011.88-2.735z"
})));

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var AustralianDollar = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$f({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.538 7.294l-3.376-.988a.922.922 0 01.26-1.806h2.072c.381 0 .756.116 1.069.328.19.128.447.097.61-.062l1.087-1.063a.506.506 0 00-.056-.765A4.42 4.42 0 0012.5 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2h-.079a3.424 3.424 0 00-3.407 3.737c.132 1.441 1.232 2.613 2.62 3.02l3.204.937a.922.922 0 01-.26 1.806h-2.072c-.382 0-.757-.116-1.07-.328a.487.487 0 00-.609.062L7.74 12.297a.506.506 0 00.056.765A4.42 4.42 0 0010.5 14v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.457-.028 2.822-.894 3.304-2.272.672-1.925-.457-3.9-2.266-4.428zM4.972 10.144H1.967L1.392 12H0l2.751-8H4.2l2.751 8H5.547l-.575-1.856zm-.364-1.16l-1.15-3.68-1.138 3.68h2.288z"
})));

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var Bolt = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$g({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 5H8.644L9.975.944A.753.753 0 009.25 0h-4.5a.751.751 0 00-.743.65l-1 7.5c-.06.45.29.85.743.85h3.71l-1.44 6.078a.75.75 0 001.377.547l5.5-9.5A.749.749 0 0012.25 5z"
})));

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var BookmarkStroke = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$h({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0h-9A1.5 1.5 0 002 1.5V16l6-3.5 6 3.5V1.5A1.5 1.5 0 0012.5 0zm0 13.388L8 10.763l-4.5 2.625v-11.7c0-.104.084-.188.188-.188h8.624c.104 0 .188.084.188.188v11.7z"
})));

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var Bookmark = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$i({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2 16V1.5A1.5 1.5 0 013.5 0h9A1.5 1.5 0 0114 1.5V16l-6-3.5L2 16z"
})));

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var BrazilianReal = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$j({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.538 7.294l-3.376-.988a.922.922 0 01.26-1.806h2.072c.381 0 .756.116 1.069.328.19.128.447.097.61-.062l1.087-1.063a.506.506 0 00-.056-.765A4.42 4.42 0 0012.5 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2h-.079a3.424 3.424 0 00-3.407 3.737c.132 1.441 1.232 2.613 2.62 3.02l3.204.937a.922.922 0 01-.26 1.806h-2.072c-.382 0-.757-.116-1.07-.328a.487.487 0 00-.609.062L7.74 12.297a.506.506 0 00.056.765A4.42 4.42 0 0010.5 14v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.457-.028 2.822-.894 3.304-2.272.672-1.925-.457-3.9-2.266-4.428zM2.475 9.138H1.326V12H0V4h2.796c.825 0 1.462.225 1.911.674.457.45.685 1.08.685 1.89 0 .61-.132 1.123-.398 1.535-.265.413-.648.704-1.149.873L5.856 12h-1.59l-1.79-2.862zM1.326 8h1.47c.817 0 1.226-.471 1.226-1.414S3.6 5.17 2.752 5.17H1.325V8z"
})));

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var Bullhorn = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$k({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.667a1.77 1.77 0 00-.889-1.531V1.889c0-.243-.194-.889-.889-.889a.887.887 0 00-.555.195l-2.362 1.89a6.742 6.742 0 01-4.194 1.47H1.778C.796 4.556 0 5.352 0 6.334V9c0 .982.796 1.778 1.778 1.778h.936a6.75 6.75 0 00-.06.889c0 1.104.257 2.148.71 3.081a.872.872 0 00.788.474h2.064c.723 0 1.158-.829.719-1.404a3.538 3.538 0 01-.726-2.151c0-.309.045-.606.122-.89h.78a6.74 6.74 0 014.194 1.472l2.362 1.89a.89.89 0 00.555.194c.692 0 .889-.632.889-.889V9.198c.53-.308.889-.875.889-1.531zm-2.667 3.928l-.918-.734A8.522 8.522 0 007.111 9V6.333c1.92 0 3.804-.66 5.304-1.86l.918-.735v7.857z"
})));

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var Buyer = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$l({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.67 9.37l1.313-5.778a.667.667 0 00-.65-.814H4.423l-.255-1.245A.667.667 0 003.515 1H.667A.667.667 0 000 1.667v.444c0 .368.298.667.667.667h1.94l1.952 9.54a1.555 1.555 0 101.863.238h5.823a1.555 1.555 0 101.767-.29l.153-.674a.667.667 0 00-.65-.814H6.059l-.182-.89h8.143a.667.667 0 00.65-.518z"
})));

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var Calculator = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$m({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.429 13.714c0-.315-.112-.585-.335-.808a1.1 1.1 0 00-.808-.335 1.1 1.1 0 00-.808.335 1.1 1.1 0 00-.335.808c0 .316.111.585.335.808.223.223.492.335.808.335.315 0 .585-.111.808-.335.223-.223.335-.492.335-.808zm3.428 0a1.1 1.1 0 00-.335-.808 1.1 1.1 0 00-.808-.335 1.1 1.1 0 00-.808.335 1.101 1.101 0 00-.335.808c0 .316.112.585.335.808.223.223.493.335.808.335.316 0 .585-.111.808-.335.224-.223.335-.492.335-.808zM3.43 10.286c0-.316-.112-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.316 0-.585.111-.808.335a1.101 1.101 0 00-.335.808c0 .315.111.585.335.808.223.223.492.335.808.335.315 0 .585-.112.808-.335.223-.223.335-.493.335-.808zm6.857 3.428c0-.315-.112-.585-.335-.808a1.1 1.1 0 00-.808-.335 1.1 1.1 0 00-.808.335 1.101 1.101 0 00-.335.808c0 .316.112.585.335.808.223.223.492.335.808.335.315 0 .585-.111.808-.335.223-.223.335-.492.335-.808zm-3.429-3.428c0-.316-.111-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.315 0-.585.111-.808.335a1.101 1.101 0 00-.335.808c0 .315.112.585.335.808.223.223.493.335.808.335.316 0 .585-.112.808-.335.224-.223.335-.493.335-.808zM3.43 6.857c0-.315-.112-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.316 0-.585.112-.808.335a1.101 1.101 0 00-.335.808c0 .316.111.585.335.808.223.223.492.335.808.335.315 0 .585-.112.808-.335.223-.223.335-.492.335-.808zm6.857 3.429c0-.316-.112-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.316 0-.585.111-.808.335a1.101 1.101 0 00-.335.808c0 .315.112.585.335.808.223.223.492.335.808.335.315 0 .585-.112.808-.335.223-.223.335-.493.335-.808zM6.857 6.857c0-.315-.111-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.315 0-.585.112-.808.335a1.101 1.101 0 00-.335.808c0 .316.112.585.335.808.223.223.493.335.808.335.316 0 .585-.112.808-.335.224-.223.335-.492.335-.808zm6.857 6.857v-3.428c0-.31-.113-.578-.339-.804a1.098 1.098 0 00-.804-.34c-.31 0-.577.114-.803.34-.226.226-.34.494-.34.804v3.428c0 .31.114.578.34.804.226.226.494.34.803.34.31 0 .578-.114.804-.34.226-.226.34-.494.34-.804zm-3.428-6.857c0-.315-.112-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.316 0-.585.112-.808.335A1.101 1.101 0 008 6.857c0 .316.112.585.335.808.223.223.492.335.808.335.315 0 .585-.112.808-.335.223-.223.335-.492.335-.808zM13.714 4V1.714a.549.549 0 00-.17-.401.549.549 0 00-.401-.17H1.714a.55.55 0 00-.401.17.55.55 0 00-.17.401V4a.55.55 0 00.17.402.55.55 0 00.401.17h11.429a.549.549 0 00.402-.17.549.549 0 00.17-.402zm0 2.857c0-.315-.111-.585-.335-.808a1.101 1.101 0 00-.808-.335c-.315 0-.584.112-.808.335a1.101 1.101 0 00-.334.808c0 .316.111.585.334.808.224.223.493.335.808.335.316 0 .585-.112.809-.335.223-.223.334-.492.334-.808zm1.143-5.714v13.714c0 .31-.113.578-.34.804-.225.226-.493.339-.803.339H1.143c-.31 0-.578-.113-.804-.34A1.098 1.098 0 010 14.858V1.143C0 .833.113.565.34.339.564.113.832 0 1.142 0h12.571c.31 0 .578.113.804.34.226.225.34.493.34.803z"
})));

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var Calendar = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$n({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.625 9h-1.25A.376.376 0 014 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 015.625 9zM9 8.625v-1.25A.376.376 0 008.625 7h-1.25A.376.376 0 007 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 009 8.625zm3 0v-1.25A.376.376 0 0011.625 7h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0012 8.625zm-3 3v-1.25A.376.376 0 008.625 10h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 009 11.625zm-3 0v-1.25A.376.376 0 005.625 10h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 006 11.625zm6 0v-1.25a.376.376 0 00-.375-.375h-1.25a.376.376 0 00-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 00.375-.375zM15 3.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 14.5v-11A1.5 1.5 0 012.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0115 3.5zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 00.188-.188z"
})));

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var CanadianDollar = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$o({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.538 7.294l-3.376-.988a.922.922 0 01.26-1.806h2.072c.381 0 .756.116 1.069.328.19.128.447.097.61-.062l1.087-1.063a.506.506 0 00-.056-.765A4.42 4.42 0 0012.5 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2h-.079a3.424 3.424 0 00-3.407 3.737c.132 1.441 1.232 2.613 2.62 3.02l3.204.937a.922.922 0 01-.26 1.806h-2.072c-.382 0-.757-.116-1.07-.328a.487.487 0 00-.609.062L7.74 12.297a.506.506 0 00.056.765A4.42 4.42 0 0010.5 14v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.457-.028 2.822-.894 3.304-2.272.672-1.925-.457-3.9-2.266-4.428zM3.525 12c-1.118 0-1.987-.335-2.606-1.004C.306 10.326 0 9.383 0 8.166c0-.848.139-1.585.417-2.211.284-.627.687-1.108 1.206-1.442C2.15 4.17 2.766 4 3.471 4c.385 0 .759.053 1.122.16.37.1.698.242.982.427l-.438.994a3.783 3.783 0 00-1.687-.417c-.677 0-1.2.253-1.57.759-.37.505-.556 1.22-.556 2.146 0 .912.19 1.599.566 2.062.385.463.951.694 1.699.694.64 0 1.178-.124 1.613-.374l.437.972c-.227.178-.53.32-.907.428-.37.1-.773.149-1.207.149z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var CaretAscending = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$p({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.216 5.066L8.433.283a.96.96 0 00-1.362 0L2.284 5.066c-.607.607-.177 1.648.683 1.648h9.566c.86 0 1.29-1.041.683-1.648z"
})));

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var CaretDescending = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$q({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.967 9.286h9.566c.86 0 1.29 1.041.683 1.648l-4.783 4.783a.96.96 0 01-1.362 0l-4.787-4.783c-.607-.607-.177-1.648.683-1.648z"
})));

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var Caret = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$r({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.967 9.286h9.566c.86 0 1.29 1.041.683 1.648l-4.783 4.783a.96.96 0 01-1.362 0l-4.787-4.783c-.607-.607-.177-1.648.683-1.648zm10.249-4.22L8.433.283a.96.96 0 00-1.362 0L2.284 5.066c-.607.607-.177 1.648.683 1.648h9.566c.86 0 1.29-1.041.683-1.648z"
})));

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
var ChartLine = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$s({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 12H2V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V13a1 1 0 001 1h14.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-1-9h-3.69a.75.75 0 00-.53 1.28l1.013 1.013L9 7.586 6.707 5.293a1 1 0 00-1.414 0L3.147 7.44a.5.5 0 000 .707l.706.707a.5.5 0 00.708 0L6 7.414l2.293 2.293a1 1 0 001.414 0l3-3 1.012 1.012A.75.75 0 0015 7.19V3.5A.5.5 0 0014.5 3z"
})));

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
var Check = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$t({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.434 13.697l-5.2-5.2a.8.8 0 010-1.131l1.132-1.132a.8.8 0 011.131 0L6 9.737l7.503-7.503a.8.8 0 011.131 0l1.132 1.132a.8.8 0 010 1.131l-9.2 9.2a.8.8 0 01-1.132 0z"
})));

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
var CheckeredFlag = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$u({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2 0c.553 0 1 .447 1 1v.5L5.156.963a5.143 5.143 0 013.547.39 5.13 5.13 0 004.597 0l.3-.15a.965.965 0 011.4.863v8.74c0 .416-.26.79-.65.938l-1.084.406a5.56 5.56 0 01-4.428-.231 5.538 5.538 0 00-3.829-.419L3 12v3a.999.999 0 11-2 0V1c0-.553.447-1 1-1zm1 5.847l2-.435V7.46l-2 .435v2.043l1.525-.38c.16-.041.316-.076.475-.104V7.46l1.216-.262c.259-.056.521-.078.784-.066v-2c.425.013.85.082 1.262.2L9 5.547V7.63l-1.303-.384A3.129 3.129 0 007 7.128V9.36c.681.06 1.353.21 2 .45V7.631l.71.21c.421.125.852.2 1.29.23V6.064a4.126 4.126 0 01-.725-.141L9 5.547V3.609a7.166 7.166 0 01-1.194-.468A3.236 3.236 0 007 2.866v2.262a4.915 4.915 0 00-1.21.113L5 5.412v-2.35l-2 .5v2.285zm8 4.644a3.523 3.523 0 001.563-.213l.437-.162V7.872l-.247.056a6.015 6.015 0 01-1.753.14v2.423zm2-4.67V3.607a7.128 7.128 0 01-2 .285v2.171c.434.044.875.016 1.303-.08L13 5.818v.003z"
})));

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
var CheckSquare = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$v({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.286 16H1.714A1.714 1.714 0 010 14.286V1.714C0 .767.767 0 1.714 0h12.572C15.233 0 16 .767 16 1.714v12.572c0 .947-.768 1.714-1.714 1.714zm-7.31-3.502l6.57-6.572a.571.571 0 000-.808l-.807-.808a.571.571 0 00-.808 0L6.57 9.67 4.07 7.166a.571.571 0 00-.808 0l-.808.808a.571.571 0 000 .809l3.714 3.714a.571.571 0 00.809 0z"
})));

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
var ChevronDown = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$w({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.077 3h13.846c.958 0 1.437 1.157.76 1.835l-6.921 6.926c-.42.42-1.104.42-1.524 0L.319 4.835C-.36 4.157.118 3 1.077 3z"
})));

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
var ChevronUp = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$x({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.922 12.074H1.078c-.958 0-1.439-1.16-.76-1.837l6.921-6.922c.42-.42 1.102-.42 1.522 0l6.922 6.922c.677.678.197 1.837-.761 1.837z"
})));

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
var Clock = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$y({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.452A6.45 6.45 0 011.548 8 6.45 6.45 0 018 1.548 6.45 6.45 0 0114.452 8 6.45 6.45 0 018 14.452zm1.994-3.368l-2.74-1.99a.39.39 0 01-.157-.313V3.484c0-.213.174-.387.387-.387h1.032c.213 0 .387.174.387.387v4.57l2.155 1.569c.174.125.21.367.084.542l-.606.835a.39.39 0 01-.542.084z"
})));

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
var Close = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$z({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.033 8l4.548-4.549a1.43 1.43 0 000-2.021L14.571.419a1.43 1.43 0 00-2.022 0L8 4.967 3.451.42a1.43 1.43 0 00-2.021 0L.419 1.429a1.43 1.43 0 000 2.022L4.967 8 .42 12.549a1.43 1.43 0 000 2.021l1.01 1.011a1.43 1.43 0 002.022 0L8 11.033l4.549 4.548a1.43 1.43 0 002.021 0l1.011-1.01a1.43 1.43 0 000-2.022L11.033 8z"
})));

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
var Cog = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$A({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.121 9.923l-1.374-.794a6.214 6.214 0 000-2.264l1.374-.794a.39.39 0 00.178-.452 8.033 8.033 0 00-1.765-3.051.388.388 0 00-.477-.074l-1.375.793a6.087 6.087 0 00-1.96-1.132V.57a.386.386 0 00-.304-.377 8.11 8.11 0 00-3.523 0 .386.386 0 00-.303.377v1.587A6.28 6.28 0 003.631 3.29L2.26 2.497a.383.383 0 00-.478.074A7.986 7.986 0 00.018 5.623a.386.386 0 00.177.451l1.375.794a6.214 6.214 0 000 2.264l-1.375.794a.39.39 0 00-.177.451 8.034 8.034 0 001.764 3.052.388.388 0 00.478.074l1.374-.793c.577.496 1.242.88 1.961 1.132v1.587c0 .18.126.339.304.377a8.11 8.11 0 003.522 0 .386.386 0 00.303-.377v-1.587a6.28 6.28 0 001.962-1.132l1.374.793c.158.09.355.062.477-.074a7.986 7.986 0 001.765-3.052.398.398 0 00-.18-.454zm-7.464.654a2.584 2.584 0 01-2.581-2.58 2.584 2.584 0 012.58-2.58 2.584 2.584 0 012.581 2.58 2.584 2.584 0 01-2.58 2.58z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
var Column = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$B({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 1h-13A1.5 1.5 0 000 2.5v11A1.5 1.5 0 001.5 15h13a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0014.5 1zM7 13H2V5h5v8zm7 0H9V5h5v8z"
})));

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
var Copy = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$C({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.56 2.06L12.94.44A1.5 1.5 0 0011.878 0H6.5A1.5 1.5 0 005 1.5V3H2.5A1.5 1.5 0 001 4.5v10A1.5 1.5 0 002.5 16h7a1.5 1.5 0 001.5-1.5V13h2.5a1.5 1.5 0 001.5-1.5V3.121a1.5 1.5 0 00-.44-1.06zM9.313 14.5H2.689a.188.188 0 01-.188-.188V4.688a.187.187 0 01.188-.188H5v7A1.5 1.5 0 006.5 13h3v1.313a.188.188 0 01-.188.187zm4-3H6.689a.188.188 0 01-.188-.188V1.688a.187.187 0 01.188-.188H10v2.75c0 .414.336.75.75.75h2.75v6.313a.188.188 0 01-.188.187zm.188-8h-2v-2h.301c.05 0 .097.02.133.055l1.511 1.511a.187.187 0 01.055.133V3.5z"
})));

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
var Creatives = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$D({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 2h-13A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h13a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0014.5 2zm-.188 10.5H1.688a.188.188 0 01-.188-.188V3.688a.187.187 0 01.188-.188h12.624a.188.188 0 01.188.188v8.624a.188.188 0 01-.188.188zM4 4.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM3 11h10V8.5l-2.735-2.735a.375.375 0 00-.53 0L6 9.5 4.765 8.265a.375.375 0 00-.53 0L3 9.5V11z"
})));

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
var Data = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$E({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 2.286v1.428C15 4.974 11.865 6 8 6S1 4.973 1 3.714V2.286C1 1.026 4.135 0 8 0s7 1.027 7 2.286zM15 5.5v3.214C15 9.974 11.865 11 8 11S1 9.973 1 8.714V5.5c1.504 1.036 4.256 1.518 7 1.518 2.743 0 5.496-.482 7-1.518zm0 5v3.214C15 14.974 11.865 16 8 16s-7-1.027-7-2.286V10.5c1.504 1.036 4.256 1.518 7 1.518 2.743 0 5.496-.482 7-1.518z"
})));

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
var Delete = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$F({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 14.5A1.5 1.5 0 003.5 16h9a1.5 1.5 0 001.5-1.5V4H2v10.5zm8.5-8a.5.5 0 111 0v7a.5.5 0 11-1 0v-7zm-3 0a.5.5 0 111 0v7a.5.5 0 11-1 0v-7zm-3 0a.5.5 0 111 0v7a.5.5 0 11-1 0v-7zm10-5.5h-3.75l-.294-.584A.75.75 0 009.784 0H6.212a.741.741 0 00-.668.416L5.25 1H1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var DensityComfortable = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$G({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 4.333C0 3.597.597 3 1.333 3h13.334C15.403 3 16 3.597 16 4.333v1.6H0v-1.6zM0 6.867h16V9.8H0V6.867zM0 10.733h16v1.6c0 .737-.597 1.334-1.333 1.334H1.333A1.333 1.333 0 010 12.333v-1.6z",
  fill: "currentColor"
})));

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
var DensityCompact = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$H({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 4.333C0 3.597.597 3 1.333 3h13.334C15.403 3 16 3.597 16 4.333v.054H0v-.054zM0 5.32h16v1.387H0V5.32zM0 7.64h16v1.387H0V7.64zM0 9.96h16v1.387H0V9.96zM0 12.28h16v.053c0 .737-.597 1.334-1.333 1.334H1.333A1.333 1.333 0 010 12.333v-.053z",
  fill: "currentColor"
})));

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
var DensityDefault = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$I({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 4.333C0 3.597.597 3 1.333 3h13.334C15.403 3 16 3.597 16 4.333v.634H0v-.634zM0 5.9h16v1.967H0V5.9zM0 8.8h16v1.967H0V8.8zM0 11.7h16v.633c0 .737-.597 1.334-1.333 1.334H1.333A1.333 1.333 0 010 12.333V11.7z",
  fill: "currentColor"
})));

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
var Dollar = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$J({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.536 7.294l-3.375-.988a.922.922 0 01.26-1.806h2.072c.38 0 .756.116 1.068.328.191.128.447.097.61-.062l1.087-1.063a.507.507 0 00-.056-.765A4.419 4.419 0 009.499 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H7.42C5.43 2 3.83 3.71 4.014 5.737c.132 1.441 1.232 2.613 2.62 3.02l3.202.937a.922.922 0 01-.26 1.806h-2.07c-.382 0-.757-.116-1.07-.328a.487.487 0 00-.609.062l-1.088 1.063a.507.507 0 00.057.765c.765.6 1.722.935 2.703.938v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.456-.028 2.822-.894 3.303-2.272a3.432 3.432 0 00-2.266-4.428z"
})));

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
var Download = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$K({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.75 0h2.5c.416 0 .75.334.75.75V6h2.74c.557 0 .835.672.441 1.066l-4.753 4.756a.606.606 0 01-.853 0l-4.76-4.756A.624.624 0 013.257 6H6V.75c0-.416.334-.75.75-.75zM16 11.75v3.5c0 .416-.334.75-.75.75H.75a.748.748 0 01-.75-.75v-3.5c0-.416.334-.75.75-.75h4.584l1.532 1.531c.628.628 1.64.628 2.268 0L10.666 11h4.584c.416 0 .75.334.75.75zm-3.875 2.75a.627.627 0 00-.625-.625.627.627 0 00-.625.625c0 .344.281.625.625.625a.627.627 0 00.625-.625zm2 0a.627.627 0 00-.625-.625.627.627 0 00-.625.625c0 .344.281.625.625.625a.627.627 0 00.625-.625z"
})));

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
var Drag = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$L({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.5 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM7 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1.5 6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6.5-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1.5-3a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
})));

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
var Duplicate = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$M({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 0h-10A1.5 1.5 0 003 1.5V3H1.5A1.5 1.5 0 000 4.5v10A1.5 1.5 0 001.5 16h10a1.5 1.5 0 001.5-1.5V13h1.5a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0014.5 0zm-3.188 14.5H1.688a.188.188 0 01-.188-.188V4.688c0-.104.084-.188.188-.188H3v7A1.5 1.5 0 004.5 13h7v1.313a.188.188 0 01-.188.187zm3-3H4.688a.188.188 0 01-.188-.188V1.688c0-.104.084-.188.188-.188h9.625c.103 0 .187.084.187.188v9.624a.188.188 0 01-.188.188z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.203 5.74h-1.834a.125.125 0 01-.125-.124V3.78a.125.125 0 00-.125-.125h-1.25a.125.125 0 00-.125.125v1.835a.125.125 0 01-.125.125H6.784a.125.125 0 00-.125.125v1.25c0 .068.056.125.125.125H8.62c.068 0 .125.056.125.125V9.2c0 .069.056.125.125.125h1.25a.125.125 0 00.125-.125V7.366c0-.07.056-.125.125-.125h1.834a.125.125 0 00.125-.125v-1.25a.125.125 0 00-.125-.125z",
  fill: "currentColor"
})));

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
var Edit = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$N({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.086 2.914l4 4L4.4 15.602l-3.566.393a.75.75 0 01-.828-.828l.397-3.57 8.684-8.683zm6.475-.596L13.683.439a1.5 1.5 0 00-2.123 0L9.793 2.207l4.001 4 1.767-1.767a1.5 1.5 0 000-2.122z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
var Equal = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$O({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.857 9.857H1.143C.512 9.857 0 10.37 0 11v1.143c0 .63.512 1.143 1.143 1.143h13.714c.631 0 1.143-.512 1.143-1.143V11c0-.631-.512-1.143-1.143-1.143zm0-6.857H1.143C.512 3 0 3.512 0 4.143v1.143c0 .63.512 1.143 1.143 1.143h13.714c.631 0 1.143-.512 1.143-1.143V4.143C16 3.512 15.488 3 14.857 3z"
})));

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
var _Error = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$P({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.923 10.1a.387.387 0 010 .548l-1.278 1.275a.387.387 0 01-.548 0L8 9.806l-2.1 2.117a.387.387 0 01-.548 0l-1.275-1.278a.387.387 0 010-.548L6.194 8 4.077 5.9a.387.387 0 010-.548l1.278-1.278a.387.387 0 01.548 0L8 6.194l2.1-2.117a.387.387 0 01.548 0l1.278 1.278a.387.387 0 010 .548L9.806 8l2.117 2.1z"
})));

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
var Euro = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Q({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.99 15.236l-.248-1.05c-.053-.232-.304-.379-.55-.325a8.07 8.07 0 01-1.699.193c-2.488 0-4.444-1.411-5.25-3.479h4.92a.446.446 0 00.444-.343l.19-.857c.057-.268-.155-.514-.444-.514H5.73a8.633 8.633 0 01-.022-1.715h6.173a.446.446 0 00.444-.339l.194-.857c.06-.268-.156-.518-.444-.518H6.107c.797-2.086 2.754-3.5 5.318-3.5.558 0 1.098.075 1.451.136.236.04.464-.093.524-.31L13.7.7c.069-.243-.095-.486-.357-.532A11.225 11.225 0 0011.471 0c-3.8 0-6.827 2.29-7.822 5.429H2.456c-.25 0-.456.192-.456.428v.857c0 .236.205.429.456.429h.877a9.807 9.807 0 00.016 1.714h-.893c-.25 0-.456.193-.456.429v.857c0 .236.205.428.456.428h1.223C4.667 13.74 7.607 16 11.467 16a9.81 9.81 0 002.184-.257c.243-.057.391-.282.338-.507z"
})));

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
var Exchange = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$R({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 5.25v-.5A.75.75 0 01.75 4h11.937l-.952-.867a.75.75 0 01-.015-1.075l.338-.338a.75.75 0 011.061 0l2.588 2.573a1 1 0 010 1.414L13.12 8.28a.75.75 0 01-1.06 0l-.34-.338a.75.75 0 01.016-1.075L12.687 6H.75A.75.75 0 010 5.25zM15.25 10H3.313l.953-.867a.75.75 0 00.014-1.075l-.338-.338a.75.75 0 00-1.061 0L.293 10.293a1 1 0 000 1.414L2.88 14.28a.75.75 0 001.06 0l.34-.338a.75.75 0 00-.015-1.075L3.313 12H15.25a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z",
  fill: "currentColor"
})));

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
var Exclude = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$S({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm4.197 3.803c2.111 2.111 2.258 5.338.667 7.601L4.596 3.136c2.264-1.592 5.491-1.443 7.601.667zm-8.394 8.394c-2.111-2.111-2.258-5.338-.667-7.601l8.268 8.268c-2.264 1.592-5.491 1.443-7.601-.667z"
})));

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
var Expand = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$T({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.857a.55.55 0 01-.17.402l-2.285 2.286a.549.549 0 01-.402.17.549.549 0 01-.402-.17.549.549 0 01-.17-.402V9H3.43v1.143a.549.549 0 01-.17.402.549.549 0 01-.402.17.549.549 0 01-.402-.17L.17 8.259A.55.55 0 010 7.857a.55.55 0 01.17-.402L2.455 5.17A.55.55 0 012.857 5a.55.55 0 01.402.17.55.55 0 01.17.401v1.143h9.142V5.571c0-.154.057-.288.17-.401a.549.549 0 01.402-.17c.155 0 .288.057.402.17l2.285 2.285a.55.55 0 01.17.402z"
})));

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
var ExternalLink = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$U({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 10h-1a.5.5 0 00-.5.5V14H2V4h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5A1.5 1.5 0 000 3.5v11A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-4a.5.5 0 00-.5-.5zm1.75-10h-4c-.668 0-1.002.81-.531 1.281l1.116 1.117-7.616 7.614a.749.749 0 000 1.062l.708.707a.75.75 0 001.063 0l7.612-7.615 1.117 1.115c.469.469 1.281.14 1.281-.531v-4a.75.75 0 00-.75-.75z"
})));

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
var File = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$V({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 7.75v.875a.376.376 0 01-.375.375h-5.25A.376.376 0 015 8.625V7.75c0-.206.169-.375.375-.375h5.25c.206 0 .375.169.375.375zM10.625 10h-5.25a.376.376 0 00-.375.375v.875c0 .206.169.375.375.375h5.25A.376.376 0 0011 11.25v-.875a.376.376 0 00-.375-.375zM14 4.122V14.5a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 012 14.5v-13A1.5 1.5 0 013.5 0h6.378a1.5 1.5 0 011.06.44l2.621 2.623c.282.278.441.662.441 1.059zm-4-2.5V4h2.378L10 1.622zM12.5 14.5v-9H9.25a.748.748 0 01-.75-.75V1.5h-5v13h9z"
})));

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
var Filter = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$W({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.296 0H.704C.079 0-.236.808.207 1.28l5.418 5.78v6.44c0 .245.112.474.3.614l2.344 1.75c.462.345 1.106-.005 1.106-.615V7.061l5.418-5.78C15.235.808 14.922 0 14.296 0z"
})));

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
var First = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$X({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.988 7.74l5.458-5.457a.96.96 0 011.36 0l.907.907a.96.96 0 010 1.36l-3.865 3.873 3.87 3.869a.96.96 0 010 1.36l-.908.911a.96.96 0 01-1.36 0L7.992 9.105a.96.96 0 01-.004-1.364zM.282 9.106l5.458 5.458a.96.96 0 001.36 0l.908-.907a.96.96 0 000-1.36L4.143 8.423l3.869-3.869a.96.96 0 000-1.36l-.907-.911a.96.96 0 00-1.36 0L.285 7.74a.96.96 0 00-.004 1.364z"
})));

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
var Flight = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Y({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.876.101L.39 8.458a.75.75 0 00.07 1.35l3.321 1.394 8.98-7.913c.171-.153.415.081.268.26L5.5 12.72v2.516c0 .738.891 1.028 1.329.494l1.984-2.416 3.894 1.631a.752.752 0 001.032-.569l2.25-13.5A.75.75 0 0014.876.1z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
var Gem = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$Z({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.89 1H3.11a.33.33 0 00-.277.15L.055 5.239a.334.334 0 00.02.394l7.667 9.468a.333.333 0 00.516 0l7.667-9.468a.334.334 0 00.02-.394L13.17 1.15a.336.336 0 00-.28-.15zm-.537 1.333L14.11 5h-1.9l-1.436-2.667h1.578zm-5.614 0h2.52L10.693 5H5.305L6.74 2.333zm-3.092 0h1.578L3.789 5h-1.9l1.758-2.667zm-1.194 4H3.88l1.898 4.445-3.325-4.444zm2.858 0h5.378L8 13.094l-2.689-6.76zm4.911 4.445l1.895-4.444h1.428l-3.323 4.444z"
})));

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
var Gift = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$_({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 14c0 .553.447 1 1 1h5v-5H1v4zm8 1h5c.553 0 1-.447 1-1v-4H9v5zm6-10h-1.316c.194-.378.316-.797.316-1.25A2.754 2.754 0 0011.25 1c-1.3 0-2.14.666-3.219 2.134C6.953 1.666 6.112 1 4.812 1a2.754 2.754 0 00-2.75 2.75c0 .453.12.872.316 1.25H1c-.553 0-1 .447-1 1v2.5c0 .275.225.5.5.5h15c.275 0 .5-.225.5-.5V6c0-.553-.447-1-1-1zM4.81 5a1.25 1.25 0 110-2.5c.621 0 1.08.103 2.69 2.5H4.81zm6.44 0H8.56c1.606-2.39 2.053-2.5 2.69-2.5a1.25 1.25 0 110 2.5z"
})));

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
var Globe = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$$({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 100 16A8 8 0 008 0zm2.655 11.536l-.365.363a.77.77 0 00-.2.346c-.048.182-.087.367-.153.544L9.376 14.3A6.445 6.445 0 018 14.452v-.884c.055-.407-.246-1.17-.73-1.653a1.032 1.032 0 01-.302-.73v-1.032c0-.376-.203-.721-.531-.903a53.218 53.218 0 00-1.575-.842 4.65 4.65 0 01-1.02-.702l-.027-.023a3.703 3.703 0 01-.582-.669c-.303-.444-.796-1.175-1.116-1.65a6.487 6.487 0 013.33-3.286l.774.387a.516.516 0 00.747-.461v-.365c.257-.042.52-.068.787-.078l.912.913a.516.516 0 010 .73l-.15.15-.334.334c-.101.101-.101.265 0 .365l.15.152c.102.1.102.264 0 .364l-.257.258a.258.258 0 01-.183.076h-.29a.258.258 0 00-.18.073l-.32.311a.258.258 0 00-.05.3l.502 1.007a.258.258 0 01-.23.373h-.182a.258.258 0 01-.17-.063l-.299-.26a.517.517 0 00-.501-.1l-1.006.335a.386.386 0 00-.05.711l.357.179c.304.152.639.23.978.23.34 0 .729.881 1.032 1.033h2.153c.274 0 .537.109.73.302l.442.442a.984.984 0 01.288.696c0 .399-.16.782-.442 1.064zm2.797-2.947a.774.774 0 01-.457-.322l-.58-.87a.773.773 0 010-.859l.632-.947a.773.773 0 01.298-.263l.419-.21c.436.869.688 1.846.688 2.882 0 .28-.024.554-.06.824l-.94-.235z"
})));

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
var Graph = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$10({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.4 10h1.2c.2 0 .4-.2.4-.4V5.4c0-.2-.2-.4-.4-.4h-1.2c-.2 0-.4.2-.4.4v4.2c0 .2.2.4.4.4zm3 0h1.2c.2 0 .4-.2.4-.4V2.4c0-.2-.2-.4-.4-.4h-1.2c-.2 0-.4.2-.4.4v7.2c0 .2.2.4.4.4zm-9 0h1.2c.2 0 .4-.2.4-.4V7.4c0-.2-.2-.4-.4-.4H4.4c-.2 0-.4.2-.4.4v2.2c0 .2.2.4.4.4zm3 0h1.2c.2 0 .4-.2.4-.4V3.4c0-.2-.2-.4-.4-.4H7.4c-.2 0-.4.2-.4.4v6.2c0 .2.2.4.4.4zm8.1 2H2V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V13a1 1 0 001 1h14.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
})));

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
var GridlinesAll = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$11({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.333 3C.597 3 0 3.597 0 4.333v8c0 .737.597 1.334 1.333 1.334h13.334c.736 0 1.333-.597 1.333-1.334v-8C16 3.597 15.403 3 14.667 3H1.333zm6 1.333h-6v3.334h6V4.333zm1.334 0v3.334h6V4.333h-6zM7.333 9h-6v3.333h6V9zm1.334 3.333h6V9h-6v3.333z",
  fill: "currentColor"
})));

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
var GridlinesHorizontal = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$12({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.333C0 3.597.597 3 1.333 3h13.334C15.403 3 16 3.597 16 4.333v8c0 .737-.597 1.334-1.333 1.334H1.333A1.333 1.333 0 010 12.333v-8zm1.333 0h13.334v3.334H1.333V4.333zm0 4.667v3.333h13.334V9H1.333z",
  fill: "currentColor"
})));

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
var GridlinesVertical = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$13({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.333C0 3.597.597 3 1.333 3h13.334C15.403 3 16 3.597 16 4.333v8c0 .737-.597 1.334-1.333 1.334H1.333A1.333 1.333 0 010 12.333v-8zm8.667 0h6v8h-6v-8zm-1.334 0h-6v8h6v-8z",
  fill: "currentColor"
})));

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
var Hashtag = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$14({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.739 5.361l.255-1.428a.429.429 0 00-.422-.504H12.9l.522-2.925A.429.429 0 0013.001 0H11.55a.429.429 0 00-.422.353l-.55 3.076H7.056L7.578.504A.428.428 0 007.156 0H5.705a.429.429 0 00-.422.353l-.55 3.076H1.91a.429.429 0 00-.422.353L1.232 5.21a.428.428 0 00.422.504h2.672l-.817 4.572H.684a.429.429 0 00-.422.353l-.255 1.429a.429.429 0 00.422.504h2.672l-.522 2.924A.428.428 0 003 16h1.45a.429.429 0 00.422-.353l.55-3.075h3.523l-.523 2.924a.428.428 0 00.422.504h1.451a.429.429 0 00.422-.353l.55-3.075h2.824a.429.429 0 00.422-.354l.255-1.428a.429.429 0 00-.422-.504h-2.671l.816-4.572h2.825a.429.429 0 00.422-.353zm-6.385 4.925H5.83l.817-4.572h3.522l-.816 4.572z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
var Hint = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$15({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 8a8 8 0 01-8 8 8.001 8.001 0 118-8zM8.215 2.645c-1.758 0-2.88.74-3.76 2.057-.114.17-.076.4.088.524l1.119.849a.387.387 0 00.538-.068c.576-.731.97-1.155 1.848-1.155.659 0 1.474.424 1.474 1.063 0 .483-.399.731-1.05 1.096-.758.425-1.762.955-1.762 2.28v.128c0 .214.173.387.387.387h1.806a.387.387 0 00.387-.387v-.043c0-.918 2.684-.956 2.684-3.44 0-1.872-1.941-3.29-3.76-3.29zm-.215 8c-.818 0-1.484.666-1.484 1.484S7.182 13.613 8 13.613s1.484-.666 1.484-1.484S8.818 10.645 8 10.645z"
})));

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
var Home = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$16({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.788 5.228L2.667 9.446v4.552a.444.444 0 00.444.444l3.113-.008a.444.444 0 00.442-.444V11.33a.444.444 0 01.444-.444h1.778a.444.444 0 01.444.444v2.657a.444.444 0 00.445.446l3.111.008a.444.444 0 00.445-.444V9.442l-5.12-4.214a.339.339 0 00-.425 0zm8.089 2.867L13.555 6.18V2.333A.333.333 0 0013.222 2h-1.556a.333.333 0 00-.333.333V4.35L8.846 2.304a1.333 1.333 0 00-1.694 0L.12 8.094a.333.333 0 00-.044.47l.708.861a.333.333 0 00.47.045L7.787 4.09a.339.339 0 01.425 0l6.534 5.381a.333.333 0 00.469-.044l.708-.861a.333.333 0 00-.047-.47z"
})));

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
var Id = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$17({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 15.411h2.685V1H0v14.411zM4.451 15.411h4.047c4.383 0 7.502-3.099 7.502-7.205C16 4.119 13.236 1 8.38 1H4.45v14.411zM8.064 3.487c3.573 0 5.251 1.955 5.251 4.719 0 2.685-1.974 4.718-5.133 4.718H7.136V3.487h.928z"
})));

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
var Image$1 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$18({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.557 3.062L10.936.44A1.5 1.5 0 009.876 0H3.5C2.672.003 2 .675 2 1.503V14.5A1.5 1.5 0 003.5 16h8.998a1.5 1.5 0 001.5-1.5V4.124c0-.397-.16-.78-.44-1.062zm-1.18.94H9.997V1.625l2.378 2.377zM3.5 14.5V1.503h4.999v3.25c0 .415.334.749.75.749h3.249V14.5H3.5zm1-1.5h6.998V9.002l-.734-.734a.375.375 0 00-.531 0l-2.734 2.734-1.234-1.234a.375.375 0 00-.531 0L4.5 11v2zM6 5.503a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
})));

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
var Info = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$19({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8.001 8.001 0 000 16A8.001 8.001 0 008 0zm0 3.548a1.355 1.355 0 110 2.71 1.355 1.355 0 010-2.71zm1.806 8.194a.387.387 0 01-.387.387H6.581a.387.387 0 01-.387-.387v-.774c0-.214.173-.387.387-.387h.387V8.516H6.58a.387.387 0 01-.387-.387v-.774c0-.214.173-.387.387-.387h2.064c.214 0 .387.173.387.387v3.226h.387c.214 0 .387.173.387.387v.774z"
})));

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
var Insights = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1a({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.002 14.198a1 1 0 00.167.553l.534.803a1 1 0 00.833.446h1.928a1 1 0 00.833-.446l.534-.803a1 1 0 00.167-.553L11 13H6l.002 1.198zM3 5.5a5.47 5.47 0 001.361 3.618c.516.589 1.324 1.82 1.632 2.858l.003.024h5.008l.003-.024c.308-1.038 1.115-2.269 1.632-2.858a5.47 5.47 0 001.36-3.618A5.5 5.5 0 008.484 0C5.295.01 3 2.593 3 5.5zM8.5 3A2.503 2.503 0 006 5.5a.5.5 0 11-1 0C5 3.57 6.57 2 8.5 2a.5.5 0 110 1z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
var Invisible = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1b({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.85 13.775L.9 2.088a.4.4 0 00-.562.062l-.25.312a.4.4 0 00.062.563L15.1 14.712a.402.402 0 00.562-.062l.25-.313a.4.4 0 00-.062-.562zM7.42 5.662l3.37 2.634a2.793 2.793 0 00-3.37-2.634zm1.16 5.476L5.21 8.504a2.793 2.793 0 003.37 2.634zM8 4.8c2.466 0 4.727 1.375 5.948 3.6-.3.547-.669 1.053-1.1 1.505l.944.737a8.339 8.339 0 001.322-1.877.809.809 0 000-.73C13.757 5.39 11.074 3.6 8 3.6c-.917 0-1.793.175-2.616.47l1.16.907A6.562 6.562 0 018 4.8zM8 12c-2.466 0-4.727-1.375-5.948-3.6.3-.548.67-1.054 1.101-1.505l-.943-.737A8.34 8.34 0 00.887 8.035a.809.809 0 000 .73C2.243 11.41 4.927 13.2 8 13.2c.917 0 1.793-.177 2.616-.47l-1.16-.908A6.577 6.577 0 018 12z"
})));

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
var Last = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1c({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8.01 9.107l-5.46 5.459a.96.96 0 01-1.36 0l-.907-.907a.96.96 0 010-1.361l3.87-3.87L.283 4.56a.96.96 0 010-1.36l.903-.916a.96.96 0 011.36 0l5.46 5.46a.96.96 0 01.004 1.364zm7.707-1.365l-5.46-5.459a.96.96 0 00-1.36 0l-.907.907a.96.96 0 000 1.36l3.87 3.87-3.87 3.87a.96.96 0 000 1.36l.907.908a.96.96 0 001.36 0l5.46-5.46a.955.955 0 000-1.356z"
})));

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
var Link = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1d({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.207 5.793a4.748 4.748 0 010 6.718l-2.1 2.1a4.755 4.755 0 01-6.718 0 4.755 4.755 0 010-6.718l1.16-1.16a.5.5 0 01.853.332c.02.554.12 1.11.302 1.648a.503.503 0 01-.118.519l-.409.409c-.876.876-.903 2.302-.036 3.186a2.252 2.252 0 003.198.016l2.1-2.1a2.25 2.25 0 00-.323-3.45.501.501 0 01-.217-.393c-.013-.33.104-.67.365-.932l.658-.658a.502.502 0 01.643-.054c.23.16.444.34.642.537zM14.61 1.39a4.755 4.755 0 00-6.718 0l-2.1 2.1a4.748 4.748 0 00.641 7.255c.2.14.471.118.644-.054l.658-.658c.26-.261.378-.601.365-.932a.501.501 0 00-.217-.394 2.25 2.25 0 01-.323-3.45l2.1-2.1a2.253 2.253 0 013.198.017c.867.884.84 2.31-.036 3.186l-.41.409a.503.503 0 00-.117.52c.183.536.282 1.093.302 1.647a.5.5 0 00.853.331l1.16-1.16a4.755 4.755 0 000-6.717z"
})));

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
var List = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1e({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm0 5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm14 .5h-10a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm0-10h-10A.5.5 0 005 2v1a.5.5 0 00.5.5h10A.5.5 0 0016 3V2a.5.5 0 00-.5-.5zm0 5h-10A.5.5 0 005 7v1a.5.5 0 00.5.5h10A.5.5 0 0016 8V7a.5.5 0 00-.5-.5z"
})));

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
var Lock = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1f({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.338 7h-.74V4.75c0-2.619-2.104-4.75-4.689-4.75S3.221 2.131 3.221 4.75V7h-.74A1.49 1.49 0 001 8.5v6c0 .828.663 1.5 1.48 1.5h10.858a1.49 1.49 0 001.48-1.5v-6c0-.828-.663-1.5-1.48-1.5zm-4.195 5.25c0 .69-.552 1.25-1.234 1.25-.682 0-1.234-.56-1.234-1.25v-1.5c0-.69.552-1.25 1.234-1.25.682 0 1.234.56 1.234 1.25v1.5zM10.13 7H5.688V4.75c0-1.24.997-2.25 2.221-2.25 1.225 0 2.22 1.01 2.22 2.25V7z"
})));

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
var Logout = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1g({
  viewBox: "0 0 17 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.125 12H3.5a3 3 0 01-3-3V3a3 3 0 013-3h2.625C6.33 0 6.5.169 6.5.375v1.25A.376.376 0 016.125 2H3.5c-.553 0-1 .447-1 1v6c0 .553.447 1 1 1h2.625c.206 0 .375.168.375.374v1.25a.376.376 0 01-.375.375zm3.684-9.472l2.425 2.222H6.25a.748.748 0 00-.75.75v1c0 .415.334.75.75.75h5.984L9.809 9.47a.752.752 0 00-.025 1.085l.684.684c.29.29.766.294 1.06.003l4.75-4.712a.749.749 0 000-1.066L11.53.76a.75.75 0 00-1.06.003l-.684.685c-.303.3-.29.794.022 1.081z"
})));

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
var Mapping = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1h({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.2 10.8H.8a.8.8 0 00-.8.8V14a.8.8 0 00.8.8h2.4A.8.8 0 004 14v-2.4a.8.8 0 00-.8-.8zm-.6-2h4.8V10h1.2V8.8h4.8V10h1.2V8.56c0-.529-.43-.96-.96-.96H8.6V6h1a.8.8 0 00.8-.8V2.8a.8.8 0 00-.8-.8H6.4a.8.8 0 00-.8.8v2.4a.8.8 0 00.8.8h1v1.6H2.36c-.53 0-.96.43-.96.96V10h1.2V8.8zm6.6 2H6.8a.8.8 0 00-.8.8V14a.8.8 0 00.8.8h2.4a.8.8 0 00.8-.8v-2.4a.8.8 0 00-.8-.8zm6 0h-2.4a.8.8 0 00-.8.8V14a.8.8 0 00.8.8h2.4a.8.8 0 00.8-.8v-2.4a.8.8 0 00-.8-.8z"
})));

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
var Marketplace = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1i({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 7.111v.445a.667.667 0 01-.667.666h-.222l-.725 5.078a1.333 1.333 0 01-1.32 1.144H2.934a1.333 1.333 0 01-1.32-1.144L.89 8.222H.667A.667.667 0 010 7.556V7.11c0-.368.298-.666.667-.666h1.87l2.966-4.079a.889.889 0 011.438 1.046L4.735 6.445h6.53L9.059 3.412a.889.889 0 111.438-1.046l2.966 4.079h1.87c.368 0 .667.298.667.666zm-7.333 4.89V8.888a.667.667 0 10-1.334 0V12a.667.667 0 001.334 0zm3.11 0V8.888a.667.667 0 00-1.333 0V12a.667.667 0 001.334 0zm-6.221 0V8.888a.667.667 0 10-1.334 0V12a.667.667 0 101.334 0z"
})));

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
var Menu = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1j({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.571 3.571H15.43A.571.571 0 0016 3V1.571A.571.571 0 0015.429 1H.57A.571.571 0 000 1.571V3c0 .316.256.571.571.571zm0 5.715H15.43A.571.571 0 0016 8.714V7.286a.571.571 0 00-.571-.572H.57A.571.571 0 000 7.286v1.428c0 .316.256.572.571.572zm0 5.714H15.43a.571.571 0 00.571-.571V13a.571.571 0 00-.571-.571H.57A.571.571 0 000 13v1.429c0 .315.256.571.571.571z"
})));

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
var MexicanPeso = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1k({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.538 7.294l-3.376-.988a.922.922 0 01.26-1.806h2.072c.381 0 .756.116 1.069.328.19.128.447.097.61-.062l1.087-1.063a.506.506 0 00-.056-.765A4.42 4.42 0 0012.5 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2h-.079a3.424 3.424 0 00-3.407 3.737c.132 1.441 1.232 2.613 2.62 3.02l3.204.937a.922.922 0 01-.26 1.806h-2.072c-.382 0-.757-.116-1.07-.328a.487.487 0 00-.609.062L7.74 12.297a.506.506 0 00.056.765A4.42 4.42 0 0010.5 14v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.457-.028 2.822-.894 3.304-2.272.672-1.925-.457-3.9-2.266-4.428zM5.79 1.333v6.128h-.991V2.958l-1.38 3.284H2.361L.965 2.933v4.528H0V1.333h1.219l1.676 3.97 1.658-3.97H5.79zM4.143 14.667l-1.261-2.268-1.253 2.268H.495l1.837-3.106-1.77-3.022h1.143l1.21 2.184 1.228-2.184h1.134l-1.811 3.013 1.828 3.115H4.143z"
})));

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
var Minus = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1l({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.857 6H1.143C.512 6 0 6.512 0 7.143v1.143c0 .63.512 1.143 1.143 1.143h13.714c.631 0 1.143-.512 1.143-1.143V7.143C16 6.512 15.488 6 14.857 6z"
})));

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
var MinusSquare = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1m({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.286 0H1.714C.768 0 0 .768 0 1.714v12.572C0 15.232.768 16 1.714 16h12.572c.946 0 1.714-.768 1.714-1.714V1.714C16 .768 15.232 0 14.286 0zm-11 9.429A.43.43 0 012.857 9V7a.43.43 0 01.429-.429h9.428a.43.43 0 01.429.429v2a.43.43 0 01-.429.429H3.286z"
})));

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
var Pause = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1n({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
})));

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
var Percentage = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1o({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 384 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
})));

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
var Performance = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1p({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 2.5a8 8 0 00-6.915 12.022.879.879 0 00.762.422h12.306c.31 0 .606-.155.762-.422A8 8 0 008 2.5zm0 1.778c.409 0 .738.281.842.657-.03.063-.073.117-.096.185l-.256.769a.866.866 0 01-.49.167.889.889 0 010-1.778zm-5.333 8a.889.889 0 110-1.778.889.889 0 010 1.778zM4 7.833a.889.889 0 110-1.778.889.889 0 010 1.778zm6.855-2.011L9.15 10.933c.38.326.627.804.627 1.345 0 .325-.094.626-.247.889H6.47a1.76 1.76 0 01-.247-.89c0-.942.736-1.706 1.664-1.766L9.59 5.4a.667.667 0 011.265.422zm.407 1.589l.431-1.293A.875.875 0 0112 6.056a.889.889 0 010 1.778.876.876 0 01-.738-.423zm2.071 4.867a.89.89 0 110-1.778.89.89 0 010 1.778z"
})));

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
var Pin = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1q({
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.313 6.696L8.931 3h1.319a.75.75 0 00.75-.75V.75a.75.75 0 00-.75-.75h-8.5A.75.75 0 001 .75v1.5c0 .414.336.75.75.75h1.319l-.382 3.696C1.17 7.4 0 8.664 0 10.25c0 .414.336.75.75.75H5v3.25a.25.25 0 00.026.112l.75 1.5a.25.25 0 00.448 0l.75-1.5A.25.25 0 007 14.25V11h4.25a.75.75 0 00.75-.75c0-1.6-1.187-2.857-2.687-3.554z"
})));

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
var Plane = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1r({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.71.79c.334.397.38.96.136 1.69a4.982 4.982 0 01-1.233 1.964l-1.838 1.838 1.827 7.945c.038.145-.008.27-.137.377L13.004 15.7a.322.322 0 01-.217.068.25.25 0 01-.08-.011.316.316 0 01-.24-.183L9.282 9.775l-2.957 2.957.605 2.214a.348.348 0 01-.09.354l-1.097 1.096a.356.356 0 01-.262.103h-.023a.41.41 0 01-.274-.148l-2.158-2.877L.15 11.316c-.083-.053-.133-.14-.148-.262a.39.39 0 01.103-.286L1.2 9.661a.356.356 0 01.262-.103c.046 0 .076.004.092.012l2.214.605 2.957-2.957-5.8-3.185a.382.382 0 01-.193-.274.352.352 0 01.102-.308l1.462-1.462c.106-.099.22-.129.342-.09l7.592 1.814 1.826-1.826A4.982 4.982 0 0114.02.654c.73-.244 1.293-.198 1.69.137z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h16v16H0z"
})))));

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
var Play = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1s({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
})));

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
var Pound = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1t({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13 11.714h-1.082a.429.429 0 00-.428.429v2.03H6V8.857h3.571A.429.429 0 0010 8.43V7.57a.429.429 0 00-.429-.428H6V4.39c0-1.337.957-2.407 2.606-2.407.926 0 1.739.425 2.162.695a.428.428 0 00.563-.092l.702-.868a.429.429 0 00-.084-.619C11.383.695 10.179 0 8.583 0 5.776 0 3.714 1.827 3.714 4.3v2.843h-1a.429.429 0 00-.428.428v.858c0 .236.192.428.428.428h1v5.316H2.43A.429.429 0 002 14.6v.97c0 .237.192.429.429.429H13a.429.429 0 00.429-.429v-3.428a.429.429 0 00-.429-.429z"
})));

function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
var Profile = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1u({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 496 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
})));

function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }
var Refresh = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1v({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
})));

function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }
var Reports = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1w({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 12.5H2V3a.5.5 0 00-.5-.5h-1A.5.5 0 000 3v10.5a1 1 0 001 1h14.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-1-9h-3.69a.75.75 0 00-.53 1.28l1.013 1.013L9 8.086 6.707 5.793a1 1 0 00-1.414 0L3.147 7.94a.5.5 0 000 .707l.706.707a.5.5 0 00.708 0L6 7.914l2.293 2.293a1 1 0 001.414 0l3-3 1.012 1.012A.75.75 0 0015 7.69V4a.5.5 0 00-.499-.5z"
})));

function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }
var Rupee = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1x({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.55 1.714a.44.44 0 00.45-.428V.429A.44.44 0 0013.55 0H2.45A.44.44 0 002 .429v1.13a.44.44 0 00.45.429h3.51c1.465 0 2.52.621 2.98 1.726H2.45a.44.44 0 00-.45.429V5a.44.44 0 00.45.429h6.735c-.129 1.776-1.338 2.869-3.248 2.869H2.45a.44.44 0 00-.45.428v1.25a.42.42 0 00.156.324l6.829 5.596a.464.464 0 00.294.104h2.3c.417 0 .61-.494.293-.753l-6.054-4.961h.5c2.962 0 5.126-1.938 5.274-4.857h1.958A.44.44 0 0014 5v-.857a.44.44 0 00-.45-.429h-2.113a4.762 4.762 0 00-1.02-2h3.133z"
})));

function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }
var Save = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1y({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M433.941 129.941l-83.882-83.882A48 48 0 00316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 00-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 01-6-6V86a6 6 0 016-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 011.757 4.243V426a6 6 0 01-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
})));

function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
var Search = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1z({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.78 14.333l-3.116-3.115a.75.75 0 00-.53-.219h-.51a6.468 6.468 0 001.375-4c0-3.59-2.91-6.499-6.5-6.499S0 3.41 0 7s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 001.06 0l.884-.885a.753.753 0 00.003-1.062zM6.5 10.999c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h16v16H0z"
})))));

function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }
var Seller = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1A({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.448 8.149L7.151 2.85a1.2 1.2 0 00-.848-.351H1.2A1.2 1.2 0 000 3.7v5.103c0 .318.126.623.351.848l5.298 5.297a1.2 1.2 0 001.697 0l5.102-5.102a1.2 1.2 0 000-1.697zM2.8 6.5a1.2 1.2 0 110-2.4 1.2 1.2 0 010 2.4zm12.849 3.346l-5.103 5.102a1.2 1.2 0 01-1.697 0l-.01-.008 4.352-4.352c.425-.425.659-.99.659-1.59 0-.602-.234-1.167-.659-1.592L8.285 2.5h1.218a1.2 1.2 0 01.848.351l5.297 5.298a1.2 1.2 0 010 1.697z"
})));

function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }
var Share = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1B({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.74 6.432l-5.5-4.75A.75.75 0 009 2.25v2.502c-5.02.058-9 1.064-9 5.82 0 1.92 1.237 3.823 2.604 4.817.427.31 1.035-.079.878-.582C2.065 10.275 4.154 9.072 9 9.003v2.747c0 .647.76.983 1.24.568l5.5-4.75a.75.75 0 000-1.136z"
})));

function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }
var Sliders = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1C({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 12.5H5V12c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v.5H.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5H3v.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-.5h10.5c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5zm0-5H13V7c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v.5H.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5H11v.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-.5h2.5c.275 0 .5-.225.5-.5V8c0-.275-.225-.5-.5-.5zm0-5H9V2c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v.5H.5c-.275 0-.5.225-.5.5v1c0 .275.225.5.5.5H7V5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-.5h6.5c.275 0 .5-.225.5-.5V3c0-.275-.225-.5-.5-.5z"
})));

function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
var SortAscending = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1D({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 13.5h-2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-9-8H2V15a.5.5 0 00.5.5h1A.5.5 0 004 15V5.5h1.5a.5.5 0 00.354-.853l-2.5-3a.5.5 0 00-.707 0l-2.5 3A.5.5 0 00.5 5.5zm13 0h-6A.5.5 0 007 6v1a.5.5 0 00.5.5h6A.5.5 0 0014 7V6a.5.5 0 00-.5-.5zm-2 4h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm4-8h-8A.5.5 0 007 2v1a.5.5 0 00.5.5h8A.5.5 0 0016 3V2a.5.5 0 00-.5-.5z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h16v16H0z"
})))));

function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }
var SortDescending = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1E({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 13.5h-2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-4-2H4V2a.5.5 0 00-.5-.5h-1A.5.5 0 002 2v9.5H.5a.5.5 0 00-.353.853l2.5 3a.5.5 0 00.707 0l2.5-3A.5.5 0 005.5 11.5zm8-6h-6A.5.5 0 007 6v1a.5.5 0 00.5.5h6A.5.5 0 0014 7V6a.5.5 0 00-.5-.5zm-2 4h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm4-8h-8A.5.5 0 007 2v1a.5.5 0 00.5.5h8A.5.5 0 0016 3V2a.5.5 0 00-.5-.5z"
})));

function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }
var Star = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1F({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.203 1.494L5.389 5.172l-4.059.592A.89.89 0 00.84 7.28l2.936 2.86-.695 4.042a.888.888 0 001.29.936L8 13.211l3.63 1.908c.645.34 1.414-.205 1.29-.936l-.695-4.041L15.16 7.28a.89.89 0 00-.492-1.517l-4.058-.592-1.814-3.678c-.325-.655-1.267-.663-1.594 0z",
  fill: "currentColor"
})));

function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }
var StarOutlined = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1G({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.397 12.891s0 0 0 0m0 0h0m0 0h0m0 0h0M6.036 6.734l.52-.076.232-.471L8 3.73l1.212 2.457.232.471.52.076 2.711.395-1.961 1.912-.377.367.089.518.464 2.699-2.425-1.275L8 11.106l-.465.244-2.425 1.275.464-2.699.09-.518-.378-.367-1.961-1.912 2.71-.395zm-3.12-.004s0 0 0 0h0z",
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: "2"
})));

function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }
var StatusDot = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1H({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8.5",
  r: "6"
})));

function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }
var StatusDotOutlined = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1I({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "8",
  r: "5",
  fill: "#fff",
  stroke: "currentColor",
  strokeWidth: "2"
})));

function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }
var Strategy = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1J({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.804 7.273l-.205.357a.31.31 0 01-.378.135 2.763 2.763 0 01-.802-.465.31.31 0 01-.07-.392l.205-.358a2.158 2.158 0 01-.398-.685h-.412a.309.309 0 01-.305-.258c-.05-.3-.053-.615 0-.927a.31.31 0 01.305-.26h.412c.09-.253.225-.485.398-.685l-.205-.358a.308.308 0 01.07-.392c.237-.198.51-.355.802-.465a.31.31 0 01.378.135l.205.357c.262-.047.53-.047.792 0l.205-.357a.309.309 0 01.378-.135c.295.11.565.267.803.465a.31.31 0 01.07.392l-.205.358c.172.2.307.432.397.685h.412c.15 0 .28.107.306.257.05.3.052.615 0 .928a.31.31 0 01-.306.26h-.412c-.09.252-.225.485-.397.685l.205.358a.308.308 0 01-.07.392c-.238.198-.51.355-.803.465a.309.309 0 01-.378-.135l-.205-.357c-.26.047-.53.047-.792 0zm-.263-1.47c.963.74 2.06-.358 1.32-1.32-.962-.743-2.06.357-1.32 1.32zM9.66 9.65l.842.42a.601.601 0 01.263.728c-.223.605-.66 1.16-1.065 1.645a.598.598 0 01-.758.133l-.728-.42c-.4.342-.865.614-1.372.792v.84c0 .29-.208.54-.493.59-.615.105-1.26.11-1.897 0a.6.6 0 01-.5-.59v-.84a4.344 4.344 0 01-1.373-.793l-.728.418a.598.598 0 01-.757-.133C.688 11.957.26 11.4.038 10.799c-.1-.273.01-.58.262-.728l.833-.42a4.331 4.331 0 010-1.585L.3 7.643a.596.596 0 01-.262-.725c.222-.605.65-1.16 1.055-1.646a.598.598 0 01.757-.132l.728.42c.4-.343.865-.615 1.373-.793v-.842c0-.288.205-.538.49-.588a5.702 5.702 0 011.9-.002.6.6 0 01.5.59v.84c.507.18.972.45 1.372.792l.728-.42a.598.598 0 01.758.133c.405.485.83 1.04 1.052 1.645.1.273.003.58-.25.728l-.842.42a4.345 4.345 0 010 1.587zm-2.94.528C8.198 8.253 6 6.055 4.075 7.535c-1.48 1.925.717 4.123 2.642 2.643zm6.085 4.568l-.205.357a.31.31 0 01-.378.135 2.763 2.763 0 01-.802-.465.31.31 0 01-.07-.392l.205-.358a2.158 2.158 0 01-.398-.685h-.412a.309.309 0 01-.305-.257c-.05-.3-.053-.615 0-.928a.31.31 0 01.305-.26h.412c.09-.253.225-.485.398-.685l-.205-.358a.308.308 0 01.07-.392c.237-.198.51-.355.802-.465a.31.31 0 01.378.135l.205.357c.262-.047.53-.047.792 0l.205-.357a.309.309 0 01.378-.135c.295.11.565.267.803.465a.31.31 0 01.07.392l-.205.358c.172.2.307.432.397.685h.412c.15 0 .28.107.306.257.05.3.052.615 0 .928a.31.31 0 01-.306.26h-.412c-.09.253-.225.485-.397.685l.205.358a.307.307 0 01-.07.392c-.238.198-.51.355-.803.465a.309.309 0 01-.378-.135l-.205-.357c-.26.047-.53.047-.792 0zm-.263-1.473c.963.74 2.06-.357 1.32-1.32-.962-.74-2.06.357-1.32 1.32z"
})));

function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }
var Success = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1K({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
})));

function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }
var Table = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1L({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 2.5h-13C.672 2.5 0 3.114 0 3.871V13.93c0 .757.672 1.371 1.5 1.371h13c.828 0 1.5-.614 1.5-1.371V3.87c0-.757-.672-1.371-1.5-1.371zM7 13.471H2V10.73h5v2.742zM7 8.9H2V6.157h5V8.9zm7 4.571H9V10.73h5v2.742zM14 8.9H9V6.157h5V8.9z"
})));

function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }
var Targeting = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1M({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
})));

function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }
var Task = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1N({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.143 13.929h5.714v-1.143H9.143v1.143zM5.714 9.357h9.143V8.214H5.714v1.143zm5.715-4.571h3.428V3.643H11.43v1.143zM16 12.214V14.5a.55.55 0 01-.17.402.55.55 0 01-.401.17H.57a.55.55 0 01-.401-.17A.55.55 0 010 14.5v-2.286a.55.55 0 01.17-.402.55.55 0 01.401-.17H15.43a.55.55 0 01.401.17.55.55 0 01.17.402zm0-4.571v2.286a.55.55 0 01-.17.401.55.55 0 01-.401.17H.57a.55.55 0 01-.401-.17A.55.55 0 010 9.93V7.643a.55.55 0 01.17-.402.55.55 0 01.401-.17H15.43a.55.55 0 01.401.17.55.55 0 01.17.402zm0-4.572v2.286a.55.55 0 01-.17.402.55.55 0 01-.401.17H.57a.55.55 0 01-.401-.17.55.55 0 01-.17-.402V3.071a.55.55 0 01.17-.401.55.55 0 01.401-.17H15.43a.55.55 0 01.401.17.55.55 0 01.17.401z"
})));

function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }
var TVScreen = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1O({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.2 2h13.6A1.2 1.2 0 0116 3.2v8a1.2 1.2 0 01-1.2 1.2h-6v.8h4.4a.4.4 0 01.4.4v.8a.4.4 0 01-.4.4H2.8a.4.4 0 01-.4-.4v-.8a.4.4 0 01.4-.4h4.4v-.8h-6A1.2 1.2 0 010 11.2v-8A1.2 1.2 0 011.2 2zm.4 8.8h12.8V3.6H1.6v7.2z"
})));

function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }
var Unlock = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1P({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.764 1.5c-2.333.008-4.208 1.9-4.208 4.197v1.928H1.333C.597 7.625 0 8.213 0 8.938v5.25c0 .724.597 1.312 1.333 1.312h9.778c.736 0 1.333-.588 1.333-1.313v-5.25c0-.724-.597-1.312-1.333-1.312H9.778V5.681c0-1.083.88-1.983 1.98-1.993 1.111-.011 2.02.877 2.02 1.968v2.188a.66.66 0 00.666.656h.89A.66.66 0 0016 7.844V5.656c0-2.297-1.903-4.164-4.236-4.156zm-4.43 10.719c0 .604-.498 1.094-1.112 1.094-.614 0-1.11-.49-1.11-1.094v-1.313c0-.604.496-1.093 1.11-1.093.614 0 1.111.489 1.111 1.093v1.313z"
})));

function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }
var Upload = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1Q({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
})));

function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }
var UserTesting = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1R({
  viewBox: "0 0 16 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.6 8.9a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zm2.24.8h-.417a4.357 4.357 0 01-3.646 0H3.36A3.36 3.36 0 000 13.06v1.04a1.2 1.2 0 001.2 1.2H10a1.2 1.2 0 001.2-1.2v-1.04A3.36 3.36 0 007.84 9.7zm8.075-3.21l-.695-.703a.296.296 0 00-.42-.002l-2.62 2.6-1.137-1.145a.296.296 0 00-.42-.003l-.703.698a.296.296 0 00-.002.42l2.042 2.057a.296.296 0 00.42.003l3.532-3.505a.299.299 0 00.003-.42z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .5)",
  d: "M0 0h16v16H0z"
})))));

function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }
var Visible = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1S({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 5.222a3.081 3.081 0 00-.868.14c.13.228.2.486.201.75a1.555 1.555 0 01-1.555 1.555 1.539 1.539 0 01-.75-.201A3.103 3.103 0 108 5.222zm7.903 2.706C14.397 4.988 11.415 3 8 3 4.585 3 1.602 4.99.097 7.928a.899.899 0 000 .81c1.506 2.94 4.488 4.929 7.903 4.929 3.415 0 6.398-1.99 7.903-4.928a.898.898 0 000-.811zM8 12.333c-2.74 0-5.253-1.527-6.61-4 1.357-2.472 3.87-4 6.61-4s5.252 1.528 6.61 4c-1.357 2.473-3.87 4-6.61 4z"
})));

function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }
var Warning = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1T({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.82 13.223c.513.888-.13 2-1.155 2H1.335a1.334 1.334 0 01-1.155-2L6.845 1.666a1.334 1.334 0 012.31 0l6.665 11.557zM8 10.833a1.278 1.278 0 100 2.556 1.278 1.278 0 000-2.556zM6.787 6.24l.206 3.778c.01.177.156.315.333.315h1.348a.333.333 0 00.333-.315l.206-3.778a.333.333 0 00-.333-.351H7.12a.333.333 0 00-.333.351z"
})));

function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }
var WarningCircle = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1U({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 8A8 8 0 110 8a8 8 0 0116 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.4 11.178a1.597 1.597 0 113.195 0 1.597 1.597 0 01-3.195 0zm.339-2.616L6.48 3.84a.417.417 0 01.416-.44h2.201c.239 0 .43.201.416.44l-.258 4.722a.417.417 0 01-.416.394H7.155a.417.417 0 01-.416-.394z",
  fill: "#fff"
})));

function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }
var Group = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1V({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 1a1 1 0 011-1h14a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm2 1h12v5H2V2zm0 7h12v5H2V9z"
})));

function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }
var Ungroup = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1W({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 1a1 1 0 00-1-1H1a1 1 0 00-1 1v6h16V1zm-2 1H2v3h12V2zM16 9H0v6a1 1 0 001 1h14a1 1 0 001-1V9zm-2 2H2v3h12v-3z"
})));

var Icons = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Accounts: Accounts,
	Actions: Actions,
	Activity: Activity,
	Add: Add,
	Admin: Admin,
	Alert: Alert,
	Archive: Archive,
	ArrowDown: ArrowDown,
	ArrowLeft: ArrowLeft,
	ArrowRight: ArrowRight,
	ArrowTrendDown: ArrowTrendDown,
	ArrowTrendUp: ArrowTrendUp,
	ArrowUp: ArrowUp,
	Auction: Auction,
	Audiences: Audiences,
	AustralianDollar: AustralianDollar,
	Bolt: Bolt,
	Bookmark: Bookmark,
	BrazilianReal: BrazilianReal,
	BookmarkStroke: BookmarkStroke,
	Bullhorn: Bullhorn,
	Buyer: Buyer,
	Calculator: Calculator,
	Calendar: Calendar,
	CanadianDollar: CanadianDollar,
	Caret: Caret,
	CaretAscending: CaretAscending,
	CaretDescending: CaretDescending,
	ChartLine: ChartLine,
	Check: Check,
	CheckeredFlag: CheckeredFlag,
	CheckSquare: CheckSquare,
	ChevronDown: ChevronDown,
	ChevronUp: ChevronUp,
	Clock: Clock,
	Close: Close,
	Cog: Cog,
	Column: Column,
	Copy: Copy,
	Creatives: Creatives,
	Data: Data,
	Delete: Delete,
	DensityComfortable: DensityComfortable,
	DensityCompact: DensityCompact,
	DensityDefault: DensityDefault,
	Dollar: Dollar,
	Download: Download,
	Drag: Drag,
	Duplicate: Duplicate,
	Edit: Edit,
	Equal: Equal,
	Error: _Error,
	Euro: Euro,
	Exchange: Exchange,
	Exclude: Exclude,
	Expand: Expand,
	ExternalLink: ExternalLink,
	File: File,
	Filter: Filter,
	First: First,
	Flight: Flight,
	Gem: Gem,
	Gift: Gift,
	Globe: Globe,
	Graph: Graph,
	GridlinesAll: GridlinesAll,
	GridlinesHorizontal: GridlinesHorizontal,
	GridlinesVertical: GridlinesVertical,
	Hashtag: Hashtag,
	Hint: Hint,
	Home: Home,
	Id: Id,
	Image: Image$1,
	Info: Info,
	Insights: Insights,
	Invisible: Invisible,
	Last: Last,
	Link: Link,
	List: List,
	Lock: Lock,
	Logout: Logout,
	Mapping: Mapping,
	Marketplace: Marketplace,
	Menu: Menu,
	MexicanPeso: MexicanPeso,
	Minus: Minus,
	MinusSquare: MinusSquare,
	Pause: Pause,
	Percentage: Percentage,
	Performance: Performance,
	Pin: Pin,
	Plane: Plane,
	Play: Play,
	Pound: Pound,
	Profile: Profile,
	Refresh: Refresh,
	Reports: Reports,
	Rupee: Rupee,
	Save: Save,
	Search: Search,
	Seller: Seller,
	Share: Share,
	Sliders: Sliders,
	SortAscending: SortAscending,
	SortDescending: SortDescending,
	Star: Star,
	StarOutlined: StarOutlined,
	StatusDot: StatusDot,
	StatusDotOutlined: StatusDotOutlined,
	Strategy: Strategy,
	Success: Success,
	Table: Table,
	Targeting: Targeting,
	Task: Task,
	TvScreen: TVScreen,
	Unlock: Unlock,
	Upload: Upload,
	UserTesting: UserTesting,
	Visible: Visible,
	WarningCircle: WarningCircle,
	Warning: Warning,
	Group: Group,
	Ungroup: Ungroup
});

const IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1qy3vyk-0"
})(["display:inline-flex;align-self:center;cursor:", ";> svg{fill:currentColor;}"], ({
  hasClick,
  disabled
}) => !disabled && hasClick && 'pointer');

const useClickOutside = (ref, callback, disabled) => {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(() => {
    const listener = event => {
      if (ref) {
        const {
          current: el
        } = ref;
        el && !el.contains(event.target) && callbackRef.current(event);
      }
    };
    const removeListener = () => {
      document.removeEventListener('mousedown', listener);
    };
    if (disabled) {
      removeListener();
      return;
    }
    document.addEventListener('mousedown', listener);
    return () => {
      removeListener();
    };
  }, [ref, disabled]);
};

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});

const breakpoints = theme.breakpoints;
const useBreakpointIndex = () => {
  const [value, setValue] = useState(0);
  useLayoutEffect(() => {
    const getIndex = () => breakpoints.filter(bp => window.matchMedia(`screen and (min-width: ${bp})`).matches).length;
    const onResize = () => {
      const newValue = getIndex();
      if (value !== newValue) {
        setValue(newValue);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoints, value]);
  return value;
};
function useResponsiveValue(values) {
  const index = useBreakpointIndex();
  return values[index >= values.length ? values.length - 1 : index];
}

function getIconName(type) {
  switch (type) {
    case 'success':
      return 'Success';
    case 'info':
      return 'Info';
    case 'warning':
      return 'Warning';
    case 'error':
    case 'danger':
      return 'Error';
    case 'insight':
      return 'Insights';
    default:
      return 'Info';
  }
}
const getIconDimension = size => {
  switch (size) {
    case 'large':
      return '24';
    case 'medium':
      return '16';
    case 'small':
      return '12';
    case 'tiny':
      return '8';
    default:
      return '16';
  }
};

function ConditionalWrapper({
  condition,
  wrapper,
  children
}) {
  return condition ? wrapper(children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
}

const Icon = ({
  name,
  color,
  title,
  disabled,
  size = 'medium',
  className,
  onClick,
  'data-testid': dataTestId = 'beau-icon'
}) => {
  const Icon = Icons[name];
  const dimension = getIconDimension(size);
  const handleClick = e => {
    !disabled && onClick && onClick(e);
  };
  return /*#__PURE__*/React.createElement(IconWrapper, {
    name: name,
    disabled: disabled,
    title: title,
    hasClick: !!onClick,
    onClick: handleClick,
    className: className,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Icon, {
    width: dimension,
    height: dimension,
    color: color
  }));
};
Icon.displayName = 'Icon';

const ICONS_NAMES = ['Accounts', 'Actions', 'Activity', 'Add', 'Admin', 'Alert', 'Archive', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowTrendDown', 'ArrowTrendUp', 'ArrowUp', 'Auction', 'Audiences', 'AustralianDollar', 'Bolt', 'Bookmark', 'BrazilianReal', 'BookmarkStroke', 'Bullhorn', 'Buyer', 'Calculator', 'Calendar', 'CanadianDollar', 'Caret', 'CaretAscending', 'CaretDescending', 'ChartLine', 'Check', 'CheckeredFlag', 'CheckSquare', 'ChevronDown', 'ChevronUp', 'Clock', 'Close', 'Cog', 'Column', 'Copy', 'Creatives', 'Data', 'Delete', 'DensityComfortable', 'DensityCompact', 'DensityDefault', 'Dollar', 'Download', 'Drag', 'Duplicate', 'Edit', 'Equal', 'Error', 'Euro', 'Exchange', 'Exclude', 'Expand', 'ExternalLink', 'File', 'Filter', 'First', 'Flight', 'Gem', 'Gift', 'Globe', 'Graph', 'GridlinesAll', 'GridlinesHorizontal', 'GridlinesVertical', 'Hashtag', 'Hint', 'Home', 'Id', 'Image', 'Info', 'Insights', 'Invisible', 'Last', 'Link', 'List', 'Lock', 'Logout', 'Mapping', 'Marketplace', 'Menu', 'MexicanPeso', 'Minus', 'MinusSquare', 'Pause', 'Percentage', 'Performance', 'Pin', 'Plane', 'Play', 'Pound', 'Profile', 'Refresh', 'Reports', 'Rupee', 'Save', 'Search', 'Seller', 'Share', 'Sliders', 'SortAscending', 'SortDescending', 'Star', 'StarOutlined', 'StatusDot', 'StatusDotOutlined', 'Strategy', 'Success', 'Table', 'Targeting', 'Task', 'TvScreen', 'Unlock', 'Upload', 'UserTesting', 'Visible', 'Warning', 'WarningCircle', 'Group', 'Ungroup'];

const Button = ({
  className,
  submit = false,
  type = 'primary',
  small = false,
  icon,
  form,
  toggle = false,
  isPressed = false,
  disabled = false,
  children,
  'data-testid': dataTestId = 'beau-button',
  onClick
}) => {
  const ButtonBase = getButtonType(type);
  const handleClick = e => {
    onClick?.(e);
  };
  return /*#__PURE__*/React.createElement(ButtonBase, {
    type: submit ? 'submit' : 'button',
    className: className,
    isPressed: isPressed,
    hasLabel: !!children,
    small: small,
    disabled: disabled,
    onClick: handleClick,
    "data-testid": dataTestId,
    form: form
  }, icon && /*#__PURE__*/React.createElement(Icon, {
    className: 'button-icon',
    name: icon
  }), children, toggle && /*#__PURE__*/React.createElement(Icon, {
    className: 'button-dropdown-icon',
    size: "small",
    name: 'ArrowDown'
  }));
};

var common = {
  black: '#000',
  white: '#fff'
};

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _extends$1X() {
  _extends$1X = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1X.apply(this, arguments);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function isPlainObject(item) {
  return item && _typeof(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$1X({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = chainPropTypes(propTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(propTypes.element.isRequired, acceptingRef);

function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent$1(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementTypeAcceptingRef$1 = chainPropTypes(propTypes.elementType, elementTypeAcceptingRef);

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends$1X({}, propTypes, _defineProperty$1({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1=60103,c$1=60106,d$1=60107,e$1=60108,f$1=60114,g$1=60109,h$1=60110,k$1=60112,l$1=60113,m$1=60120,n$1=60115,p$1=60116,q$1=60121,r$1=60122,u=60117,v$1=60129,w$1=60131;
if("function"===typeof Symbol&&Symbol.for){var x$1=Symbol.for;b$1=x$1("react.element");c$1=x$1("react.portal");d$1=x$1("react.fragment");e$1=x$1("react.strict_mode");f$1=x$1("react.profiler");g$1=x$1("react.provider");h$1=x$1("react.context");k$1=x$1("react.forward_ref");l$1=x$1("react.suspense");m$1=x$1("react.suspense_list");n$1=x$1("react.memo");p$1=x$1("react.lazy");q$1=x$1("react.block");r$1=x$1("react.server.block");u=x$1("react.fundamental");v$1=x$1("react.debug_trace_mode");w$1=x$1("react.legacy_hidden");}
function y$1(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$1:switch(a=a.type,a){case d$1:case f$1:case e$1:case l$1:case m$1:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$1:case p$1:case n$1:case g$1:return a;default:return t}}case c$1:return t}}}var z$1=g$1,A$1=b$1,B=k$1,C=d$1,D=p$1,E=n$1,F=c$1,G=f$1,H=e$1,I=l$1;var ContextConsumer$1=h$1;var ContextProvider$1=z$1;var Element$2=A$1;var ForwardRef$1=B;var Fragment$1=C;var Lazy$1=D;var Memo$1=E;var Portal$1=F;var Profiler$1=G;var StrictMode$1=H;
var Suspense$1=I;var isAsyncMode$1=function(){return !1};var isConcurrentMode$1=function(){return !1};var isContextConsumer$1=function(a){return y$1(a)===h$1};var isContextProvider$1=function(a){return y$1(a)===g$1};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$1};var isForwardRef$1=function(a){return y$1(a)===k$1};var isFragment$1=function(a){return y$1(a)===d$1};var isLazy$1=function(a){return y$1(a)===p$1};var isMemo$1=function(a){return y$1(a)===n$1};
var isPortal$1=function(a){return y$1(a)===c$1};var isProfiler$1=function(a){return y$1(a)===f$1};var isStrictMode$1=function(a){return y$1(a)===e$1};var isSuspense$1=function(a){return y$1(a)===l$1};var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$1||a===e$1||a===l$1||a===m$1||a===w$1||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===u||a.$$typeof===q$1||a[0]===r$1)?!0:!1};
var typeOf$1=y$1;

var reactIs_production_min$1 = {
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$2,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$1,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

var reactIs_development$1 = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIs$1.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs$1.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

var refType = propTypes.oneOfType([propTypes.func, propTypes.object]);

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties$1(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends$1X({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$1X({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends$1X({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty$1({}, breakpoints.up('sm'), _extends$1X({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty$1(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty$1(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo[300],
    main: indigo[500],
    dark: indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink.A200,
    main: pink.A400,
    dark: pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red[300],
    main: red[500],
    dark: red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange[300],
    main: orange[500],
    dark: orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue[300],
    main: blue[500],
    dark: blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green[300],
    main: green[500],
    dark: green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties$1(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$1X({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createMuiTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createMuiTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends$1X({
    // A collection of common colors.
    common: common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties$1(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$1X({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$1X({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

var responsivePropType = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.string, propTypes.object, propTypes.array]) : {};

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (process.env.NODE_ENV !== 'production') {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (_typeof(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = memoize(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = _slicedToArray(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing$1(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return handleBreakpoints(props, propValue, styleFromPropValue);
  }).reduce(merge, {});
}

spacing$1.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing$1.filterProps = spacingKeys;

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties$1(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex$1 = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties$1(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty$1({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1X({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends$1X({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends$1X({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$1X({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$1X({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$1X({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends$1X({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$1X({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize$1 = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize$1(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize$1(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$1X({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends$1X({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends$1X({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends$1X({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends$1X({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends$1X({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends$1X({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp$1 = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp$1 = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp$1);
    var nestedSelectors = nestedProp.split(separatorRegExp$1);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends$1X({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends$1X({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp$1, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends$1X({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends$1X({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins$1 = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins$1.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins$1.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache$1 = {};

if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache$1[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache$1[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[prop] != null) {
    return cache$1[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache$1[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache$1[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache$1[prop];
}

var cache$1$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1$1[cacheKey] != null) {
    return cache$1$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1$1[cacheKey] = prefixedValue;
  return cache$1$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functionPlugin(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends$1X({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};

var ThemeContext = React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties$1(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React.useContext(StylesContext);

  var context = _extends$1X({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: propTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: propTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: propTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: propTypes.bool,

  /**
   * JSS's instance.
   */
  jss: propTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: propTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: propTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: propTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: propTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends$1X({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends$1X({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends$1X({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends$1X({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties$1(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = _extends$1X({}, React.useContext(StylesContext), stylesOptions2);

    var instance = React.useRef();
    var shouldUpdate = React.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

function r$2(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$2(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$2(e))&&(n&&(n+=" "),n+=t);return n}

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties$1(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends$1X({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = _objectWithoutProperties$1(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends$1X({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React.createElement(Component, _extends$1X({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: propTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(propTypes.oneOfType([propTypes.func, propTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics_cjs(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var defaultTheme = createMuiTheme();

function useTheme$1() {
  var theme = useTheme() || defaultTheme;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

function withStyles$1(stylesOrCreator, options) {
  return withStyles(stylesOrCreator, _extends$1X({
    defaultTheme: defaultTheme
  }, options));
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/createElement$1("title", null, titleAccess) : null);
});
process.env.NODE_ENV !== "production" ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: propTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: propTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: propTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: propTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: propTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: propTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles$1(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React.createElement(SvgIcon$1, _extends$1X({
      ref: ref
    }, props), path);
  };

  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(Component));
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

// TODO v5: consider to make it private
function setRef$1(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (process.env.NODE_ENV !== 'production') {
    useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef$1(refA, refValue);
      setRef$1(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = useCallback(function (instance) {
    var node = findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]) : null;

var TransitionGroupContext = React.createContext(null);

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) forceReflow(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React.cloneElement(React.Children.only(children), childProps))
    );
  };

  return Transition;
}(React.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.shape({
    current: typeof Element === 'undefined' ? propTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return propTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values$1 = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$1X({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values$1(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: propTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: propTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: propTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: propTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: propTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: propTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? duration.standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition : _props$TransitionComp,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "collapsedHeight", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = useTheme$1();
  var timer = useRef();
  var wrapperRef = useRef(null);
  var autoTransitionDuration = useRef();
  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
  useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = useRef(null);
  var handleRef = useForkRef(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/createElement$1(TransitionComponent, _extends$1X({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/createElement$1(Component, _extends$1X({
      className: clsx(classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: _extends$1X({
        minHeight: collapsedHeight
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/createElement$1("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/createElement$1("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: propTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: propTypes.bool,

  /**
   * @ignore
   */
  onEnter: propTypes.func,

  /**
   * @ignore
   */
  onEntered: propTypes.func,

  /**
   * @ignore
   */
  onEntering: propTypes.func,

  /**
   * @ignore
   */
  onExit: propTypes.func,

  /**
   * @ignore
   */
  onExited: propTypes.func,

  /**
   * @ignore
   */
  onExiting: propTypes.func,

  /**
   * @ignore
   */
  style: propTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: propTypes.oneOfType([propTypes.oneOf(['auto']), propTypes.number, propTypes.shape({
    appear: propTypes.number,
    enter: propTypes.number,
    exit: propTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
var Collapse$1 = withStyles$1(styles$1, {
  name: 'MuiCollapse'
})(Collapse);

var styles$2 = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return _extends$1X({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(propTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: propTypes.bool,

  /**
   * The variant to use.
   */
  variant: propTypes.oneOf(['elevation', 'outlined'])
} : void 0;
var Paper$1 = withStyles$1(styles$2, {
  name: 'MuiPaper'
})(Paper);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = createContext({});

if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}

var styles$3 = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /*#__PURE__*/forwardRef(function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Collapse$1 : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = useCallback(function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = Children.toArray(childrenProp),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = useMemo(function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/createElement$1(Paper$1, _extends$1X({
    className: clsx(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/createElement$1(AccordionContext.Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/createElement$1(TransitionComponent, _extends$1X({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/createElement$1("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
process.env.NODE_ENV !== "production" ? Accordion.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion.
   */
  children: chainPropTypes(propTypes.node.isRequired, function (props) {
    var summary = Children.toArray(props.children)[0];

    if (reactIs$1.isFragment(summary)) {
      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * If `true`, expands the accordion by default.
   */
  defaultExpanded: propTypes.bool,

  /**
   * If `true`, the accordion will be displayed in a disabled state.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: propTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: propTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: propTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: propTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: propTypes.object
} : void 0;
var Accordion$1 = withStyles$1(styles$3, {
  name: 'MuiAccordion'
})(Accordion);

var styles$4 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /*#__PURE__*/forwardRef(function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties$1(props, ["classes", "className"]);

  return /*#__PURE__*/createElement$1("div", _extends$1X({
    className: clsx(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion details.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string
} : void 0;
var AccordionDetails$1 = withStyles$1(styles$4, {
  name: 'MuiAccordionDetails'
})(AccordionDetails);

var useEnhancedEffect$1 = typeof window === 'undefined' ? useEffect : useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect$1(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/createElement$1("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/createElement$1("span", {
    className: childClassName
  }));
}

process.env.NODE_ENV !== "production" ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: propTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: propTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: propTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: propTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: propTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: propTypes.number,

  /**
   * exit delay
   */
  timeout: propTypes.number.isRequired
} : void 0;

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties$1(props, ["center", "classes", "className"]);

  var _React$useState = useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = useRef(0);
  var rippleCallback = useRef(null);
  useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = useRef(null);
  var container = useRef(null);
  useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/createElement$1(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/createElement$1("span", _extends$1X({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/createElement$1(TransitionGroup, {
    component: null,
    exit: true
  }, ripples));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: propTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string
} : void 0;
var TouchRipple$1 = withStyles$1(styles$5, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/memo(TouchRipple));

var styles$6 = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties$1(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return findDOMNode(buttonRef.current);
  }

  var rippleRef = useRef(null);

  var _React$useState = useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/createElement$1(ComponentProp, _extends$1X({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  createElement$1(TouchRipple$1, _extends$1X({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: propTypes.bool,

  /**
   * The content of the component.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: propTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: propTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: propTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: propTypes.string,

  /**
   * @ignore
   */
  href: propTypes.string,

  /**
   * @ignore
   */
  onBlur: propTypes.func,

  /**
   * @ignore
   */
  onClick: propTypes.func,

  /**
   * @ignore
   */
  onDragLeave: propTypes.func,

  /**
   * @ignore
   */
  onFocus: propTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: propTypes.func,

  /**
   * @ignore
   */
  onKeyDown: propTypes.func,

  /**
   * @ignore
   */
  onKeyUp: propTypes.func,

  /**
   * @ignore
   */
  onMouseDown: propTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: propTypes.func,

  /**
   * @ignore
   */
  onMouseUp: propTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: propTypes.func,

  /**
   * @ignore
   */
  onTouchMove: propTypes.func,

  /**
   * @ignore
   */
  onTouchStart: propTypes.func,

  /**
   * @ignore
   */
  tabIndex: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: propTypes.object,

  /**
   * @ignore
   */
  type: propTypes.oneOfType([propTypes.oneOf(['button', 'reset', 'submit']), propTypes.string])
} : void 0;
var ButtonBase$1 = withStyles$1(styles$6, {
  name: 'MuiButtonBase'
})(ButtonBase);

var styles$7 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties$1(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/createElement$1(ButtonBase$1, _extends$1X({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/createElement$1("span", {
    className: classes.label
  }, children));
});
process.env.NODE_ENV !== "production" ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(propTypes.node, function (props) {
    var found = Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: propTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: propTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: propTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: propTypes.oneOf(['small', 'medium'])
} : void 0;
var IconButton$1 = withStyles$1(styles$7, {
  name: 'MuiIconButton'
})(IconButton);

var styles$8 = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/forwardRef(function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = useState(false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = useContext(AccordionContext),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/createElement$1(ButtonBase$1, _extends$1X({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: clsx(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/createElement$1("div", {
    className: clsx(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/createElement$1(IconButton$1, _extends$1X({
    className: clsx(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
process.env.NODE_ENV !== "production" ? AccordionSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion summary.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: propTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: propTypes.object,

  /**
   * @ignore
   */
  onBlur: propTypes.func,

  /**
   * @ignore
   */
  onClick: propTypes.func,

  /**
   * @ignore
   */
  onFocusVisible: propTypes.func
} : void 0;
var AccordionSummary$1 = withStyles$1(styles$8, {
  name: 'MuiAccordionSummary'
})(AccordionSummary);

var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var styles$9 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = /*#__PURE__*/forwardRef(function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$1(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return /*#__PURE__*/createElement$1(ComponentProp, _extends$1X({
    className: clsx(classes.root, className),
    ref: ref
  }, other), children, /*#__PURE__*/createElement$1("span", {
    className: clsx(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(capitalize(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(capitalize(anchorOrigin.vertical)).concat(capitalize(anchorOrigin.horizontal)).concat(capitalize(overlap))], color !== 'default' && classes["color".concat(capitalize(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
  }, displayValue));
});
process.env.NODE_ENV !== "production" ? Badge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   */
  anchorOrigin: propTypes.shape({
    horizontal: propTypes.oneOf(['left', 'right']).isRequired,
    vertical: propTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: propTypes.node,

  /**
   * The badge will be added relative to this node.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'error', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: propTypes.bool,

  /**
   * Max count to show.
   */
  max: propTypes.number,

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap: propTypes.oneOf(['circle', 'rectangle']),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: propTypes.bool,

  /**
   * The variant to use.
   */
  variant: propTypes.oneOf(['dot', 'standard'])
} : void 0;
var Badge$1 = withStyles$1(styles$9, {
  name: 'MuiBadge'
})(Badge);

var styles$a = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties$1(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize(align))], display !== 'initial' && classes["display".concat(capitalize(display))]),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: propTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: propTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: propTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: propTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: propTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: propTypes.object
} : void 0;
var Typography$1 = withStyles$1(styles$a, {
  name: 'MuiTypography'
})(Typography);

/**
 * @ignore - internal component.
 */

var FormControlContext = createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return useContext(FormControlContext);
}

var styles$b = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = _objectWithoutProperties$1(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = useFormControl();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/createElement$1(IconButton$1, _extends$1X({
    component: "span",
    className: clsx(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/createElement$1("input", _extends$1X({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: propTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: propTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * @ignore
   */
  defaultChecked: propTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: propTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: propTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: propTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /*
   * @ignore
   */
  name: propTypes.string,

  /**
   * @ignore
   */
  onBlur: propTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: propTypes.func,

  /**
   * @ignore
   */
  onFocus: propTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: propTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: propTypes.bool,

  /**
   * @ignore
   */
  tabIndex: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: propTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: propTypes.any
} : void 0;
var SwitchBase$1 = withStyles$1(styles$b, {
  name: 'PrivateSwitchBase'
})(SwitchBase);

/**
 * @ignore - internal component.
 */

var CheckBoxOutlineBlankIcon = createSvgIcon( /*#__PURE__*/createElement$1("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

/**
 * @ignore - internal component.
 */

var CheckBoxIcon = createSvgIcon( /*#__PURE__*/createElement$1("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

/**
 * @ignore - internal component.
 */

var IndeterminateCheckBoxIcon = createSvgIcon( /*#__PURE__*/createElement$1("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

var styles$c = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/createElement$1(CheckBoxIcon, null);
var defaultIcon = /*#__PURE__*/createElement$1(CheckBoxOutlineBlankIcon, null);
var defaultIndeterminateIcon = /*#__PURE__*/createElement$1(IndeterminateCheckBoxIcon, null);
var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties$1(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/createElement$1(SwitchBase$1, _extends$1X({
    type: "checkbox",
    classes: {
      root: clsx(classes.root, classes["color".concat(capitalize(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: _extends$1X({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/cloneElement(icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/cloneElement(indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: propTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: propTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: propTypes.node,

  /**
   * The id of the `input` element.
   */
  id: propTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: propTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: propTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: propTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: propTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: propTypes.bool,

  /**
   * The size of the checkbox.
   * `small` is equivalent to the dense checkbox styling.
   */
  size: propTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: propTypes.any
} : void 0;
var Checkbox$1 = withStyles$1(styles$c, {
  name: 'MuiCheckbox'
})(Checkbox);

/**
 * @ignore - internal component.
 */

var CancelIcon = createSvgIcon( /*#__PURE__*/createElement$1("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

var styles$d = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = fade(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: emphasize(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: emphasize(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: emphasize(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: emphasize(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: emphasize(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: emphasize(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: fade(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: fade(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: fade(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: fade(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: fade(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/forwardRef(function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = _objectWithoutProperties$1(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = useRef(null);
  var handleRef = useForkRef(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? ButtonBase$1 : 'div');
  var moreProps = Component === ButtonBase$1 ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = clsx(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(capitalize(color))] : classes["deleteIconOutlinedColor".concat(capitalize(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/isValidElement(deleteIconProp) ? /*#__PURE__*/cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/createElement$1(CancelIcon, {
      className: clsx(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(capitalize(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/isValidElement(iconProp)) {
    icon = /*#__PURE__*/cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(capitalize(color))])
    });
  }

  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    role: clickable || onDelete ? 'button' : undefined,
    className: clsx(classes.root, className, color !== 'default' && [classes["color".concat(capitalize(color))], clickable && classes["clickableColor".concat(capitalize(color))], onDelete && classes["deletableColor".concat(capitalize(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/createElement$1("span", {
    className: clsx(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
process.env.NODE_ENV !== "production" ? Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Avatar element.
   */
  avatar: propTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: propTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: propTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: propTypes.bool,

  /**
   * Icon element.
   */
  icon: propTypes.element,

  /**
   * The content of the label.
   */
  label: propTypes.node,

  /**
   * @ignore
   */
  onClick: propTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: propTypes.func,

  /**
   * @ignore
   */
  onKeyDown: propTypes.func,

  /**
   * @ignore
   */
  onKeyUp: propTypes.func,

  /**
   * The size of the chip.
   */
  size: propTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: propTypes.oneOf(['default', 'outlined'])
} : void 0;
var Chip$1 = withStyles$1(styles$d, {
  name: 'MuiChip'
})(Chip);

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = useRef(false);
  var nodeRef = useRef(null);
  var activatedRef = useRef(false);
  var syntheticEventRef = useRef(false);
  useEffect(function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = useCallback(function (instance) {
    // #StrictMode ready
    nodeRef.current = findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = useEventCallback(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = ownerDocument(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = ownerDocument(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/createElement$1(Fragment$2, null, /*#__PURE__*/cloneElement(children, childrenProps));
}

process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   */
  disableReactTree: propTypes.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: propTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: propTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: propTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return findDOMNode(container);
}

var useEnhancedEffect$2 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal$2 = /*#__PURE__*/forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = useForkRef( /*#__PURE__*/isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$2(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$2(function () {
    if (mountNode && !disablePortal) {
      setRef$1(ref, mountNode);
      return function () {
        setRef$1(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect$2(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/isValidElement(children)) {
      return /*#__PURE__*/cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/createPortal(children, mountNode) : mountNode;
});
process.env.NODE_ENV !== "production" ? Portal$2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: propTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: propTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, propTypes.instanceOf(Component), propTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: propTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: propTypes.func
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal$2['propTypes' + ''] = exactProp(Portal$2.propTypes);
}

var styles$e = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: fade(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = _objectWithoutProperties$1(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Divider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Absolutely position the element.
   */
  absolute: propTypes.bool,

  /**
   * @ignore
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   */
  flexItem: propTypes.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: propTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: propTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: propTypes.string,

  /**
   * The variant to use.
   */
  variant: propTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
var MUIDivider = withStyles$1(styles$e, {
  name: 'MuiDivider'
})(Divider);

function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect$3 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
var styles$f = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/forwardRef(function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$rowsMin = props.rowsMin,
      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
      style = props.style,
      value = props.value,
      other = _objectWithoutProperties$1(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);

  var rowsMin = rows || rowsMinProp;

  var _React$useRef = useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = useRef(null);
  var handleRef = useForkRef(ref, inputRef);
  var shadowRef = useRef(null);
  var renders = useRef(0);

  var _React$useState = useState({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = useCallback(function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (rowsMin) {
      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
    }

    if (rowsMax) {
      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (process.env.NODE_ENV !== 'production') {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [rowsMax, rowsMin, props.placeholder]);
  useEffect(function () {
    var handleResize = debounce(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect$3(function () {
    syncHeight();
  });
  useEffect(function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/createElement$1(Fragment$2, null, /*#__PURE__*/createElement$1("textarea", _extends$1X({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: rowsMin,
    style: _extends$1X({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/createElement$1("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: _extends$1X({}, styles$f.shadow, style)
  }));
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * @ignore
   */
  onChange: propTypes.func,

  /**
   * @ignore
   */
  placeholder: propTypes.string,

  /**
   * Use `rowsMin` instead. The prop will be removed in v5.
   *
   * @deprecated
   */
  rows: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * Maximum number of rows to display.
   */
  rowsMax: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  rowsMin: propTypes.oneOfType([propTypes.number, propTypes.string]),

  /**
   * @ignore
   */
  style: propTypes.object,

  /**
   * @ignore
   */
  value: propTypes.oneOfType([propTypes.arrayOf(propTypes.string), propTypes.number, propTypes.string])
} : void 0;

var styles$g = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/forwardRef(function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = _objectWithoutProperties$1(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = useFormControl();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/createElement$1("label", _extends$1X({
    className: clsx(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(capitalize(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/cloneElement(control, controlProps), /*#__PURE__*/createElement$1(Typography$1, {
    component: "span",
    className: clsx(classes.label, disabled && classes.disabled)
  }, label));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: propTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: propTypes.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: propTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: propTypes.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: propTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: propTypes.func,

  /**
   * The value of the component.
   */
  value: propTypes.any
} : void 0;
var FormControlLabel$1 = withStyles$1(styles$g, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles$h = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/forwardRef(function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition : _props$TransitionComp,
      other = _objectWithoutProperties$1(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = useRef();
  var autoTimeout = useRef();
  var theme = useTheme$1();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/createElement$1(TransitionComponent, _extends$1X({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/cloneElement(children, _extends$1X({
      style: _extends$1X({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$h[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: propTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: propTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: propTypes.bool,

  /**
   * @ignore
   */
  onEnter: propTypes.func,

  /**
   * @ignore
   */
  onEntered: propTypes.func,

  /**
   * @ignore
   */
  onEntering: propTypes.func,

  /**
   * @ignore
   */
  onExit: propTypes.func,

  /**
   * @ignore
   */
  onExited: propTypes.func,

  /**
   * @ignore
   */
  onExiting: propTypes.func,

  /**
   * @ignore
   */
  style: propTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: propTypes.oneOfType([propTypes.oneOf(['auto']), propTypes.number, propTypes.shape({
    appear: propTypes.number,
    enter: propTypes.number,
    exit: propTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;

var TRANSITION_DURATION = 4; // seconds

var styles$i = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? lighten(color, 0.62) : darken(color, 0.5);
  };

  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4,
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },

    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0 -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0 -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var LinearProgress = /*#__PURE__*/forwardRef(function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties$1(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);

  var theme = useTheme$1();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }

      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return /*#__PURE__*/createElement$1("div", _extends$1X({
    className: clsx(classes.root, classes["color".concat(capitalize(color))], className, {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'buffer': classes.buffer,
      'query': classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? /*#__PURE__*/createElement$1("div", {
    className: clsx(classes.dashed, classes["dashedColor".concat(capitalize(color))])
  }) : null, /*#__PURE__*/createElement$1("div", {
    className: clsx(classes.bar, classes["barColor".concat(capitalize(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      'determinate': classes.bar1Determinate,
      'buffer': classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : /*#__PURE__*/createElement$1("div", {
    className: clsx(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(capitalize(color))], classes.bar2Buffer] : classes["barColor".concat(capitalize(color))]),
    style: inlineStyles.bar2
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: propTypes.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: propTypes.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: propTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
var LinearProgress$1 = withStyles$1(styles$i, {
  name: 'MuiLinearProgress'
})(LinearProgress);

/**
 * @ignore - internal component.
 */

var ListContext = createContext({});

if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}

var styles$j = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List$1 = /*#__PURE__*/forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/createElement$1(ListContext.Provider, {
    value: context
  }, /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
process.env.NODE_ENV !== "production" ? List$1.propTypes = {
  /**
   * The content of the component.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: propTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: propTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: propTypes.node
} : void 0;
var List$2 = withStyles$1(styles$j, {
  name: 'MuiList'
})(List$1);

var styles$k = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect$4 = typeof window === 'undefined' ? useEffect : useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = _objectWithoutProperties$1(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = _objectWithoutProperties$1(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = useContext(ListContext);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = useRef(null);
  useEnhancedEffect$4(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(handleOwnRef, ref);

  var componentProps = _extends$1X({
    className: clsx(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(classes.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/createElement$1(ListContext.Provider, {
      value: childContext
    }, /*#__PURE__*/createElement$1(ContainerComponent, _extends$1X({
      className: clsx(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/createElement$1(Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/createElement$1(ListContext.Provider, {
    value: childContext
  }, /*#__PURE__*/createElement$1(Component, _extends$1X({
    ref: handleRef
  }, componentProps), children));
});
process.env.NODE_ENV !== "production" ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: propTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: propTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: propTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(propTypes.node, function (props) {
    var children = Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: propTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: propTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: propTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: propTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: propTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: propTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: propTypes.bool
} : void 0;
var ListItem$1 = withStyles$1(styles$k, {
  name: 'MuiListItem'
})(ListItem);

var styles$l = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/forwardRef(function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties$1(props, ["classes", "className"]);

  var context = useContext(ListContext);
  return /*#__PURE__*/createElement$1("div", _extends$1X({
    className: clsx(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string
} : void 0;
var ListItemIcon$1 = withStyles$1(styles$l, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

var styles$m = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = /*#__PURE__*/forwardRef(function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = _objectWithoutProperties$1(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = useContext(ListContext),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== Typography$1 && !disableTypography) {
    primary = /*#__PURE__*/createElement$1(Typography$1, _extends$1X({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== Typography$1 && !disableTypography) {
    secondary = /*#__PURE__*/createElement$1(Typography$1, _extends$1X({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return /*#__PURE__*/createElement$1("div", _extends$1X({
    className: clsx(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
process.env.NODE_ENV !== "production" ? ListItemText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Alias for the `primary` prop.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: propTypes.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: propTypes.bool,

  /**
   * The main content element.
   */
  primary: propTypes.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: propTypes.object,

  /**
   * The secondary content element.
   */
  secondary: propTypes.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: propTypes.object
} : void 0;
var ListItemText$1 = withStyles$1(styles$m, {
  name: 'MuiListItemText'
})(ListItemText);

var styles$n = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = /*#__PURE__*/forwardRef(function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = _objectWithoutProperties$1(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: propTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: propTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: propTypes.bool
} : void 0;
var ListSubheader$1 = withStyles$1(styles$n, {
  name: 'MuiListSubheader'
})(ListSubheader);

var styles$o = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$1X({}, theme.typography.body1, _defineProperty$1({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: _extends$1X({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/createElement$1(ListItem$1, _extends$1X({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: _extends$1X({
      dense: classes.dense
    }, ListItemClasses),
    className: clsx(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: propTypes.bool,

  /**
   * @ignore
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: propTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: propTypes.object,

  /**
   * @ignore
   */
  role: propTypes.string,

  /**
   * @ignore
   */
  selected: propTypes.bool,

  /**
   * @ignore
   */
  tabIndex: propTypes.number
} : void 0;
var MenuItem$1 = withStyles$1(styles$o, {
  name: 'MuiMenuItem'
})(MenuItem);

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser$1 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser$1 && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$2 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1Y = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$1Y({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$1Y({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update$1() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$1Y({}, attributes, data.attributes);
  data.styles = _extends$1Y({}, styles, data.styles);
  data.arrowStyles = _extends$1Y({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$2(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$2(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$1Y({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$2({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$2({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$1Y({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$2({}, side, reference[side]),
      end: defineProperty$2({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$1Y({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$1(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$1Y({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$1Y({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$1Y({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$1Y({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update$1.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect$5 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper$1 = /*#__PURE__*/forwardRef(function Popper$1(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = _objectWithoutProperties$1(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = useRef(null);
  var ownRef = useForkRef(tooltipRef, ref);
  var popperRef = useRef(null);
  var handlePopperRef = useForkRef(popperRef, popperRefProp);
  var handlePopperRefRef = useRef(handlePopperRef);
  useEnhancedEffect$5(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = useTheme();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = useState(rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = useCallback(function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new Popper(getAnchorEl(anchorEl), tooltipRef.current, _extends$1X({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: _extends$1X({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: createChainedFunction(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: createChainedFunction(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = useCallback(function (node) {
    setRef$1(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  useEffect(function () {
    return function () {
      handleClose();
    };
  }, []);
  useEffect(function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/createElement$1(Portal$2, {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/createElement$1("div", _extends$1X({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: _extends$1X({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
process.env.NODE_ENV !== "production" ? Popper$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(propTypes.oneOfType([HTMLElementType, propTypes.object, propTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: propTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([propTypes.node, propTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: propTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, propTypes.instanceOf(Component), propTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: propTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: propTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: propTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: propTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: propTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: propTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,

  /**
   * @ignore
   */
  style: propTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: propTypes.bool
} : void 0;

var styles$p = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = /*#__PURE__*/forwardRef(function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties$1(props, ["classes", "className", "color", "edge", "size"]);

  var icon = /*#__PURE__*/createElement$1("span", {
    className: classes.thumb
  });
  return /*#__PURE__*/createElement$1("span", {
    className: clsx(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat(capitalize(size))])
  }, /*#__PURE__*/createElement$1(SwitchBase$1, _extends$1X({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: clsx(classes.switchBase, classes["color".concat(capitalize(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), /*#__PURE__*/createElement$1("span", {
    className: classes.track
  }));
});
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: propTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: propTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * @ignore
   */
  defaultChecked: propTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: propTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: propTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: propTypes.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: propTypes.node,

  /**
   * The id of the `input` element.
   */
  id: propTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: propTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: propTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: propTypes.bool,

  /**
   * The size of the switch.
   * `small` is equivalent to the dense switch styling.
   */
  size: propTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: propTypes.any
} : void 0;
var Switch$1 = withStyles$1(styles$p, {
  name: 'MuiSwitch'
})(Switch);

/**
 * @ignore - internal component.
 */

var TableContext = createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

var styles$q = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': _extends$1X({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table$1 = /*#__PURE__*/forwardRef(function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'default' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = useMemo(function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/createElement$1(TableContext.Provider, {
    value: table
  }, /*#__PURE__*/createElement$1(Component, _extends$1X({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: clsx(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
process.env.NODE_ENV !== "production" ? Table$1.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: propTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: propTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: propTypes.bool
} : void 0;
var Table$2 = withStyles$1(styles$q, {
  name: 'MuiTable'
})(Table$1);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

var styles$r = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var defaultComponent$1 = 'tbody';
var TableBody = /*#__PURE__*/forwardRef(function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$1 : _props$component,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component"]);

  return /*#__PURE__*/createElement$1(Tablelvl2Context.Provider, {
    value: tablelvl2
  }, /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className),
    ref: ref,
    role: Component === defaultComponent$1 ? null : 'rowgroup'
  }, other)));
});
process.env.NODE_ENV !== "production" ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
var TableBody$1 = withStyles$1(styles$r, {
  name: 'MuiTableBody'
})(TableBody);

var styles$s = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$1X({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? lighten(fade(theme.palette.divider, 1), 0.88) : darken(fade(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/forwardRef(function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = _objectWithoutProperties$1(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = useContext(TableContext);
  var tablelvl2 = useContext(Tablelvl2Context);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    ref: ref,
    className: clsx(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(capitalize(align))], padding !== 'default' && classes["padding".concat(capitalize(padding))], size !== 'medium' && classes["size".concat(capitalize(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
process.env.NODE_ENV !== "production" ? TableCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: propTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: propTypes.oneOf(['checkbox', 'default', 'none']),

  /**
   * Set scope attribute.
   */
  scope: propTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: propTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: propTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: propTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
var TableCell$1 = withStyles$1(styles$s, {
  name: 'MuiTableCell'
})(TableCell);

var styles$t = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2$1 = {
  variant: 'head'
};
var defaultComponent$2 = 'thead';
var TableHead = /*#__PURE__*/forwardRef(function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$2 : _props$component,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component"]);

  return /*#__PURE__*/createElement$1(Tablelvl2Context.Provider, {
    value: tablelvl2$1
  }, /*#__PURE__*/createElement$1(Component, _extends$1X({
    className: clsx(classes.root, className),
    ref: ref,
    role: Component === defaultComponent$2 ? null : 'rowgroup'
  }, other)));
});
process.env.NODE_ENV !== "production" ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
var TableHead$1 = withStyles$1(styles$t, {
  name: 'MuiTableHead'
})(TableHead);

var styles$u = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent$3 = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/forwardRef(function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$3 : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = _objectWithoutProperties$1(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = useContext(Tablelvl2Context);
  return /*#__PURE__*/createElement$1(Component, _extends$1X({
    ref: ref,
    className: clsx(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent$3 ? null : 'row'
  }, other));
});
process.env.NODE_ENV !== "production" ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: propTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object.isRequired,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: propTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: propTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: propTypes.bool
} : void 0;
var TableRow$1 = withStyles$1(styles$u, {
  name: 'MuiTableRow'
})(TableRow);

function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var styles$v = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: fade(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round$1(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: fade(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round$1(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: _defineProperty$1({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: _defineProperty$1({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: _defineProperty$1({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: _defineProperty$1({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
var Tooltip = /*#__PURE__*/forwardRef(function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? Popper$1 : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties$1(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = useTheme$1();

  var _React$useState = useState(),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = useState(null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = useRef(false);
  var closeTimer = useRef();
  var enterTimer = useRef();
  var leaveTimer = useRef();
  var touchTimer = useRef();

  var _useControlled = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _React$useRef = useRef(openProp !== undefined),
        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks


    useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  var id = useId(idProp);
  useEffect(function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = useState(false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = useForkRef(setChildNode, ref);
  var handleFocusRef = useForkRef(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = useCallback(function (instance) {
    // #StrictMode ready
    setRef$1(handleFocusRef, findDOMNode(instance));
  }, [handleFocusRef]);
  var handleRef = useForkRef(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = _extends$1X({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (children.props.title) {
      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  var mergedPopperProps = useMemo(function () {
    return deepmerge({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/createElement$1(Fragment$2, null, /*#__PURE__*/cloneElement(children, childrenProps), /*#__PURE__*/createElement$1(PopperComponent, _extends$1X({
    className: clsx(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/createElement$1(TransitionComponent, _extends$1X({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/createElement$1("div", {
      className: clsx(classes.tooltip, classes["tooltipPlacement".concat(capitalize(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/createElement$1("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: propTypes.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: propTypes.object,

  /**
   * @ignore
   */
  className: propTypes.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: propTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: propTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: propTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: propTypes.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   */
  enterNextDelay: propTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: propTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: propTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: propTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: propTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: propTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: propTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: propTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: propTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: propTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   */
  PopperComponent: propTypes.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: propTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: propTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: propTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: propTypes.object
} : void 0;
var Tooltip$1 = withStyles$1(styles$v, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip);

const Unchecked = css$1(["&:hover{.beauCheckboxIconWrapper{fill:", ";stroke:", ";}}&.beauCheckboxFocused{.beauCheckboxIconWrapper{stroke:", ";}}"], ({
  theme
}) => theme.colors.checkbox.hover.backgroundColor, ({
  theme
}) => theme.colors.checkbox.hover.borderColor, ({
  theme
}) => theme.colors.checkbox.focused.borderColor);
const Checked = css$1(["&.beauCheckboxChecked,&.beauCheckboxIndeterminate{color:", ";&:hover{.beauCheckboxIconWrapper{fill:", ";stroke:", ";}}&.beauCheckboxFocused{.beauCheckboxIconWrapper{fill:", ";}}}"], ({
  theme
}) => theme.colors.checkbox.checked.backgroundColor, ({
  theme
}) => theme.colors.checkbox.hover.checked.backgroundColor, ({
  theme
}) => theme.colors.checkbox.hover.checked.borderColor, ({
  theme
}) => theme.colors.checkbox.focused.checked.backgroundColor);
const Disabled = css$1(["&.beauCheckboxDisabled{.beauCheckboxIconWrapper{fill:", ";stroke:", ";}.beauCheckboxIconCheck,.beauCheckboxIconIndeterminate{fill:", ";}}"], ({
  theme
}) => theme.colors.checkbox.disabled.backgroundColor, ({
  theme
}) => theme.colors.checkbox.disabled.borderColor, ({
  theme
}) => theme.colors.checkbox.disabled.checked.checkColor);
const ReadOnly = css$1(["&.beauCheckboxReadOnly{.beauCheckboxIconWrapper{fill:", ";stroke:", ";}.beauCheckboxIconCheck,.beauCheckboxIconIndeterminate{fill:", ";}}"], ({
  theme
}) => theme.colors.checkbox.readOnly.backgroundColor, ({
  theme
}) => theme.colors.checkbox.readOnly.borderColor, ({
  theme
}) => theme.colors.checkbox.readOnly.checked.checkColor);
const CheckboxWrapper = styled(Checkbox$1).withConfig({
  displayName: "styles__CheckboxWrapper",
  componentId: "sc-1oudhqw-0"
})(["&.beauCheckbox{padding:0;", " ", " ", " ", "}"], Unchecked, Checked, Disabled, ReadOnly);
const InputPlacementTop = css$1(["align-items:flex-start;.beauCheckbox{margin-top:4px;}"]);
const CheckboxAndLabel = styled(FormControlLabel$1).withConfig({
  displayName: "styles__CheckboxAndLabel",
  componentId: "sc-1oudhqw-1"
})(["&.beauCheckboxLabelWrapper{margin:0;", "}&.beauCheckboxLabelDisabled{cursor:not-allowed !important;}.beauCheckboxLabel{font-family:", ";font-size:", ";line-height:", ";", ";&.beauCheckboxLabelDisabled{color:", ";}}"], ({
  $inputPlacement
}) => $inputPlacement === 'top' && InputPlacementTop, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  labelPlacement
}) => labelPlacement === 'start' ? `margin-right: 8px` : `margin-left: 8px`, ({
  theme
}) => theme.colors.checkbox.disabled.color);

function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }
var Checked$1 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1Z({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  className: styles["beauCheckboxIconWrapper"] || "beauCheckboxIconWrapper",
  x: ".5",
  y: ".5",
  width: "15",
  height: "15",
  rx: "3.5",
  fill: "currentColor",
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["beauCheckboxIconCheck"] || "beauCheckboxIconCheck",
  d: "M6.076 12.273l-3.9-3.9a.6.6 0 010-.849l.848-.848a.6.6 0 01.849 0L6.5 9.303l5.627-5.627a.6.6 0 01.849 0l.848.848a.6.6 0 010 .849l-6.9 6.9a.6.6 0 01-.848 0z",
  fill: "#fff"
})));

function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }
var Unchecked$1 = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1_({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  className: styles["beauCheckboxIconWrapper"] || "beauCheckboxIconWrapper",
  x: ".5",
  y: ".5",
  width: "15",
  height: "15",
  rx: "3.5",
  fill: "#fff",
  stroke: "currentColor"
})));

function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }
var Indeterminate = (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends$1$({
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  className: styles["beauCheckboxIconWrapper"] || "beauCheckboxIconWrapper",
  x: ".5",
  y: ".5",
  width: "15",
  height: "15",
  rx: "3.5",
  fill: "currentColor",
  stroke: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["beauCheckboxIconIndeterminate"] || "beauCheckboxIconIndeterminate",
  d: "M13.143 6.5H2.857A.857.857 0 002 7.357v.857c0 .474.384.857.857.857h10.286A.857.857 0 0014 8.214v-.857a.857.857 0 00-.857-.857z",
  fill: "#fff"
})));

const Checkbox$2 = /*#__PURE__*/React.forwardRef(({
  children,
  name = 'checkbox',
  checked = false,
  disabled = false,
  readOnly = false,
  indeterminate = false,
  labelPlacement = 'right',
  inputPlacement = 'top',
  'data-testid': dataTestId = 'beau-checkbox',
  onChange,
  onClick,
  className
}, ref) => {
  const getLabelPlacementFromType = placement => placement === 'right' ? 'end' : 'start';
  const labelClasses = {
    root: 'beauCheckboxLabelWrapper',
    label: 'beauCheckboxLabel',
    disabled: 'beauCheckboxLabelDisabled'
  };
  const checkboxClasses = {
    root: 'beauCheckbox',
    disabled: disabled ? 'beauCheckboxDisabled' : 'beauCheckboxReadOnly',
    checked: 'beauCheckboxChecked',
    indeterminate: 'beauCheckboxIndeterminate'
  };
  const CheckboxOnly = /*#__PURE__*/React.createElement(CheckboxWrapper, {
    ref: ref,
    disableRipple: true,
    checked: checked,
    onChange: onChange,
    className: className,
    classes: checkboxClasses,
    focusVisibleClassName: "beauCheckboxFocused",
    disabled: disabled || readOnly,
    indeterminate: indeterminate,
    onClick: onClick,
    inputProps: {
      name: name,
      'aria-label': name,
      'data-testid': dataTestId
    },
    icon: /*#__PURE__*/React.createElement(Unchecked$1, null),
    checkedIcon: /*#__PURE__*/React.createElement(Checked$1, null),
    indeterminateIcon: /*#__PURE__*/React.createElement(Indeterminate, null)
  });
  return children ? /*#__PURE__*/React.createElement(CheckboxAndLabel, {
    label: children,
    control: CheckboxOnly,
    classes: labelClasses,
    "$inputPlacement": inputPlacement,
    labelPlacement: getLabelPlacementFromType(labelPlacement)
  }) : CheckboxOnly;
});
Checkbox$2.displayName = 'Checkbox';

const DropdownContext = /*#__PURE__*/React.createContext(undefined);
function useDropdownContext() {
  const context = React.useContext(DropdownContext);
  if (context === undefined) {
    throw new Error('useDropdownContext must be used within a DropdownContext.Provider');
  }
  return context;
}

const BaseButton = ({
  type = 'primary',
  icon,
  small = false,
  toggle = false,
  disabled = false,
  children,
  'data-testid': dataTestId = 'beau-dropdown-button',
  className,
  onClick
}) => {
  const {
    isDropdownOpen,
    handleDropdownOpen
  } = useDropdownContext();
  const handleClick = () => {
    handleDropdownOpen && handleDropdownOpen();
    onClick && onClick();
  };
  return /*#__PURE__*/React.createElement(Button, {
    toggle: toggle,
    isPressed: isDropdownOpen,
    onClick: handleClick,
    type: type,
    small: small,
    icon: icon,
    disabled: disabled,
    "data-testid": dataTestId,
    className: className
  }, children);
};

const {
  colors: {
    dropdownList: dropdownList$1
  },
  fonts: {
    samsungOne
  }
} = theme;
const ItemWrapper = styled.li.withConfig({
  displayName: "styles__ItemWrapper",
  componentId: "sc-2bd227-0"
})(["list-style:none;cursor:pointer;padding:4px 10px;:hover,:active,:focus{background-color:", ";}a{display:block;color:", ";font-weight:", ";text-decoration:none;&:hover,&:active,&:focus{text-shadow:0 0 0.01px ", ";text-decoration:none;color:", ";}}"], dropdownList$1.backgroundColorHover, dropdownList$1.color, samsungOne.fontWeight.normal.fontWeight, dropdownList$1.colorHover, dropdownList$1.colorHover);

const {
  colors: {
    dropdownList: dropdownList$2
  },
  fonts: {
    samsungOne: samsungOne$1
  }
} = theme;
const Title = styled.li.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1bjdxmn-0"
})(["padding:8px 10px 4px 10px;color:", ";font-weight:", ";text-transform:uppercase;"], dropdownList$2.colorSubtitle, samsungOne$1.fontWeight.bold.fontWeight);
const SectionWrapper = styled.ul.withConfig({
  displayName: "styles__SectionWrapper",
  componentId: "sc-1bjdxmn-1"
})(["margin:0;list-style:none;padding:0;border-bottom:1px solid ", ";border-top:1px solid ", ";margin-top:-1px;"], dropdownList$2.borderColorDropdownSeparator, dropdownList$2.borderColorDropdownSeparator);

const Dropdown = styled.div.withConfig({
  displayName: "styles__Dropdown",
  componentId: "sc-5bk6bt-0"
})(["overflow-x:auto;z-index:9999;min-width:150px;width:auto;white-space:nowrap;border-radius:8px;font-size:", ";line-height:", ";font-family:", ";background-color:", ";border:1px solid ", ";"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.colors.dropdownList.backgroundColor, ({
  theme
}) => theme.colors.dropdownList.borderColorDropdown);
const Wrapper = styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-5bk6bt-1"
})(["overflow:auto;border-radius:8px;max-height:40vh;> ", ":first-child{border-top:none;margin-top:0;}> ", ":last-child{border-bottom:none;}", "{padding-right:20px;}"], SectionWrapper, SectionWrapper, ItemWrapper);

const Item = ({
  children,
  onClick,
  target,
  rel,
  href,
  'data-testid': dataTestId = 'beau-dropdown-item'
}) => {
  const {
    handleDropdownOpen
  } = useDropdownContext();
  const handleClick = event => {
    handleDropdownOpen && handleDropdownOpen();
    if (onClick) {
      event.preventDefault();
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(ItemWrapper, null, /*#__PURE__*/React.createElement("a", {
    onClick: handleClick,
    "data-testid": dataTestId,
    target: target,
    rel: rel,
    href: href
  }, children));
};

const Section = ({
  title,
  children,
  'data-testid': dataTestId = 'beau-dropdown-section'
}) => {
  return /*#__PURE__*/React.createElement(SectionWrapper, {
    "data-testid": dataTestId
  }, title && /*#__PURE__*/React.createElement(Title, null, title), children);
};

/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? useLayoutEffect : useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements$1 = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$2(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getBoundingClientRect$1(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$2(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var currentNode = getParentNode$1(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent$1(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

var max = Math.max;
var min = Math.min;
var round$2 = Math.round;

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow$1(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$2 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow$1,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(round$2(x * dpr) / dpr) || 0,
    y: round$2(round$2(y * dpr) / dpr) || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top) {
      sideY = bottom; // $FlowFixMe[prop-missing]

      y -= offsetParent[heightProp] - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right; // $FlowFixMe[prop-missing]

      x -= offsetParent[widthProp] - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect$2(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

var hash$1 = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash$1[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect$1(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$1(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent$1(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect$1(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent$1(element) : element;

  if (!isElement$2(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$2(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$2(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect$1(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement$1(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement$1(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement$1(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement$1(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement$1(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$2 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip$1,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide$1(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$2 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide$1
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements$1.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$2 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset$1
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis || checkAltAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

    if (checkMainAxis) {
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$2 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow$1,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$2(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$2(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent$1(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$2, preventOverflow$2, arrow$2, hide$2];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const List$3 = ({
  children,
  rootId = 'app',
  'data-testid': dataTestId = 'beau-dropdown-list',
  right = false
}) => {
  const {
    isDropdownOpen,
    dropdownRef
  } = useDropdownContext();
  const [listRef, setListRef] = useState(null);
  const {
    styles,
    attributes,
    update
  } = usePopper(dropdownRef, listRef, {
    placement: right ? 'bottom-end' : 'bottom-start',
    strategy: 'fixed',
    modifiers: [{
      name: 'flip',
      options: {
        fallbackPlacements: ['top-start', 'top-end', 'bottom-end', 'bottom-start']
      }
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 8]
      }
    }]
  });
  useEffect(() => {
    isDropdownOpen && update?.();
  }, [isDropdownOpen]);
  const root = document.getElementById(rootId);
  return isDropdownOpen ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Dropdown, _objectSpread$4({
    "data-testid": dataTestId,
    ref: setListRef,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/React.createElement(Wrapper, null, children)), root ?? document.body) : null;
};
List$3.Section = Section;
List$3.Item = Item;
//Storybooks naming fix
List$3.Section.displayName = 'Dropdown.List.Section';
List$3.Item.displayName = 'Dropdown.List.Item';

const DropdownWrapper = styled.div.withConfig({
  displayName: "styles__DropdownWrapper",
  componentId: "sc-11siezk-0"
})(["display:inline-block;"]);
const PopperWrapper = styled.div.withConfig({
  displayName: "styles__PopperWrapper",
  componentId: "sc-11siezk-1"
})(["display:inherit;"]);

const Dropdown$1 = ({
  children,
  'data-testid': dataTestId = 'beau-dropdown'
}) => {
  const [popperRef, setPopperRef] = useState(null);
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    document.addEventListener('click', e => handleClickOutside(e), false);
    return () => {
      document.removeEventListener('click', e => handleClickOutside(e), false);
    };
  }, []);
  const handleClickOutside = e => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };
  const handleDropdownOpen = React.useCallback(() => {
    return setIsOpen(oldIsOpen => !oldIsOpen);
  }, []);
  const value = React.useMemo(() => ({
    isDropdownOpen: isOpen,
    dropdownRef: popperRef,
    handleDropdownOpen
  }), [isOpen]);
  return /*#__PURE__*/React.createElement(DropdownContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(DropdownWrapper, {
    ref: wrapperRef,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(PopperWrapper, {
    ref: setPopperRef
  }, children)));
};
Dropdown$1.Button = BaseButton;
Dropdown$1.List = List$3;
//Storybooks naming fix
Dropdown$1.displayName = 'Dropdown';
Dropdown$1.Button.displayName = 'Dropdown.Button';
Dropdown$1.List.displayName = 'Dropdown.List';

const FlexWrapper = styled.div.withConfig({
  displayName: "styles__FlexWrapper",
  componentId: "m3pgki-0"
})(["position:relative;box-sizing:border-box;display:", ";justify-content:", ";align-items:", ";flex-direction:", ";gap:", ";flex-wrap:", ";width:", ";;"], ({
  inline
}) => inline ? 'inline-flex' : 'flex', ({
  justifyContent
}) => justifyContent, ({
  alignItems
}) => alignItems, ({
  direction
}) => direction, ({
  gap,
  theme
}) => gap && theme.spacing(gap), ({
  flexWrap
}) => flexWrap && 'wrap', ({
  inline
}) => !inline && '100%');

function Flex({
  className,
  'data-testid': dataTestId = 'beau-flex',
  children,
  horizontalAlign = 'stretch',
  verticalAlign = 'stretch',
  direction = 'row',
  gap = 0,
  wrap = false,
  inline = false
}) {
  return /*#__PURE__*/React.createElement(FlexWrapper, {
    className: className,
    "data-testid": dataTestId,
    justifyContent: direction === 'column' ? verticalAlign : horizontalAlign,
    alignItems: direction === 'column' ? horizontalAlign : verticalAlign,
    direction: direction,
    gap: gap,
    flexWrap: wrap,
    inline: inline
  }, children);
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const TooltipWrapper = styled(_ref => {
  let {
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, ["className"]);
  return /*#__PURE__*/React.createElement(Tooltip$1, _objectSpread$5(_objectSpread$5({
    title: props.title,
    // eslint-disable-next-line react/no-children-prop
    children: props.children
  }, props), {}, {
    classes: {
      popper: className
    }
  }));
}).withConfig({
  displayName: "styles__TooltipWrapper",
  componentId: "sc-1fw7y28-0"
})([".MuiTooltip-tooltip{border-radius:8px;padding:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";background-color:", ";border:1px solid ", ";box-shadow:0px 0px 8px rgb(0 0 0 / 50%);.MuiTooltip-arrow{&:before{border:1px solid ", ";box-sizing:border-box;}color:", ";}}"], ({
  theme
}) => `${theme.spacing(1)} ${theme.spacing(2)}`, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.colors.tooltip.color, ({
  theme
}) => theme.colors.tooltip.backgroundColor, ({
  theme
}) => theme.colors.tooltip.borderColor, ({
  theme
}) => theme.colors.tooltip.borderColor, ({
  theme
}) => theme.colors.tooltip.backgroundColor);
const LearnMore = styled.a.withConfig({
  displayName: "styles__LearnMore",
  componentId: "sc-1fw7y28-1"
})(["font-family:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";text-decoration:none;align-self:flex-end;"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.colors.tooltip.learnMore.color);

const Tooltip$2 = function ({
  children,
  title,
  delay = false,
  disabled = false,
  learnMoreLink,
  placement = 'top',
  interactive = true,
  className,
  'data-testid': dataTestId = 'beau-tooltip'
}) {
  const learnMore = /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, title, /*#__PURE__*/React.createElement(LearnMore, {
    href: learnMoreLink,
    rel: "help",
    target: "_blank"
  }, "Learn More"));
  return /*#__PURE__*/React.createElement(TooltipWrapper, {
    arrow: true,
    enterDelay: delay ? 1000 : 100,
    enterNextDelay: delay ? 1000 : 0,
    title: learnMoreLink ? learnMore : title,
    interactive: interactive,
    disableFocusListener: disabled,
    disableHoverListener: disabled,
    disableTouchListener: disabled,
    placement: placement,
    PopperProps: {
      'data-testid': dataTestId
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: className
  }, children));
};

const EllipsisWrapper = styled.div.withConfig({
  displayName: "styles__EllipsisWrapper",
  componentId: "ox3uwk-0"
})(["position:relative;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:auto;"]);
const FormatWrapper = styled.div.withConfig({
  displayName: "styles__FormatWrapper",
  componentId: "ox3uwk-1"
})(["&,*{font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;color:inherit !important;text-decoration:inherit;font-style:inherit;}"]);

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return _root.Date.now();
};

var now_1 = now$1;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$3(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$3;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject_1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce_1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var patchResizeCallback = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch (refreshMode) {
        case 'debounce':
            return debounce_1(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var isFunction$1 = function (fn) { return typeof fn === 'function'; };
var isSSR = function () { return typeof window === 'undefined'; };
var isDOMElement = function (element) {
    return element instanceof Element || element instanceof HTMLDocument;
};var ResizeDetector = /** @class */ (function (_super) {
    __extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function () {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function () {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if (isSSR()) {
                return;
            }
            if (targetRef && targetRef.current) {
                _this.targetRef.current = targetRef.current;
            }
            var element = _this.getElement();
            if (!element) {
                // can't find element to observe
                return;
            }
            if (_this.observableElement && _this.observableElement === element) {
                // element is already observed
                return;
            }
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function () {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if (isSSR())
                return null;
            // in case we pass a querySelector
            if (querySelector)
                return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && isDOMElement(targetDomEl))
                return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && isDOMElement(_this.targetRef.current))
                return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = findDOMNode(_this);
            if (!currentElement)
                return null;
            var renderType = _this.getRenderType();
            switch (renderType) {
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function (entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight)
                return;
            var notifyResize = function (_a) {
                var width = _a.width, height = _a.height;
                if (_this.state.width === width && _this.state.height === height) {
                    // skip if dimensions haven't changed
                    return;
                }
                if ((_this.state.width === width && !handleHeight) || (_this.state.height === height && !handleWidth)) {
                    // process `handleHeight/handleWidth` props
                    return;
                }
                onResize === null || onResize === void 0 ? void 0 : onResize(width, height);
                _this.setState({ width: width, height: height });
            };
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function () {
            var _a = _this.props, render = _a.render, children = _a.children;
            if (isFunction$1(render)) {
                // DEPRECATED. Use `Child Function Pattern` instead
                return 'renderProp';
            }
            if (isFunction$1(children)) {
                return 'childFunction';
            }
            if (isValidElement(children)) {
                return 'child';
            }
            if (Array.isArray(children)) {
                // DEPRECATED. Wrap children with a single parent
                return 'childArray';
            }
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.sizeRef = {
            current: _this.state
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = createRef();
        _this.observableElement = null;
        if (isSSR()) {
            return _this;
        }
        _this.resizeHandler = patchResizeCallback(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function () {
        this.attachObserver();
        this.sizeRef.current = this.state;
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (isSSR()) {
            return;
        }
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = { width: width, height: height, targetRef: this.targetRef };
        var renderType = this.getRenderType();
        switch (renderType) {
            case 'renderProp':
                return render === null || render === void 0 ? void 0 : render(childProps);
            case 'childFunction': {
                var childFunction = children;
                return childFunction === null || childFunction === void 0 ? void 0 : childFunction(childProps);
            }
            case 'child': {
                // @TODO bug prone logic
                var child = children;
                if (child.type && typeof child.type === 'string') {
 var nativeProps = __rest(childProps, ["targetRef"]);
                    return cloneElement(child, nativeProps);
                }
                // class or functional component otherwise
                return cloneElement(child, childProps);
            }
            case 'childArray': {
                var childArray = children;
                return childArray.map(function (el) { return !!el && cloneElement(el, childProps); });
            }
            default:
                return React.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}(PureComponent));function useResizeDetector(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skipOnMount, skipOnMount = _c === void 0 ? false : _c, refreshMode = _b.refreshMode, _d = _b.refreshRate, refreshRate = _d === void 0 ? 1000 : _d, refreshOptions = _b.refreshOptions, _e = _b.handleWidth, handleWidth = _e === void 0 ? true : _e, _f = _b.handleHeight, handleHeight = _f === void 0 ? true : _f, targetRef = _b.targetRef, observerOptions = _b.observerOptions, onResize = _b.onResize;
    var skipResize = useRef(skipOnMount);
    var _g = useState({
        width: undefined,
        height: undefined
    }), size = _g[0], setSize = _g[1];
    // we are going to use this ref to store the last element that was passed to the hook
    var _h = useState((targetRef === null || targetRef === void 0 ? void 0 : targetRef.current) || null), refElement = _h[0], setRefElement = _h[1];
    // if targetRef is passed, we need to update the refElement
    // we have to use setTimeout because ref get assigned after the hook is called
    // in the future releases we are going to remove targetRef and force users to use ref returned by the hook
    if (targetRef) {
        setTimeout(function () {
            if (targetRef.current !== refElement) {
                setRefElement(targetRef.current);
            }
        }, 0);
    }
    // this is a callback that will be called every time the ref is changed
    // we call setState inside to trigger rerender
    var onRefChange = useCallback(function (node) {
        if (node !== refElement) {
            setRefElement(node);
        }
    }, [refElement]);
    // adding `current` to make it compatible with useRef shape
    onRefChange.current = refElement;
    useEffect(function () {
        return function () {
            // component is unmounted
            // clear ref to avoid memory leaks
            setRefElement(null);
            onRefChange.current = null;
        };
    }, []);
    var shouldSetSize = useCallback(function (prevSize, nextSize) {
        if (prevSize.width === nextSize.width && prevSize.height === nextSize.height) {
            // skip if dimensions haven't changed
            return false;
        }
        if ((prevSize.width === nextSize.width && !handleHeight) ||
            (prevSize.height === nextSize.height && !handleWidth)) {
            // process `handleHeight/handleWidth` props
            return false;
        }
        return true;
    }, [handleWidth, handleHeight]);
    var resizeCallback = useCallback(function (entries) {
        if (!handleWidth && !handleHeight)
            return;
        if (skipResize.current) {
            skipResize.current = false;
            return;
        }
        entries.forEach(function (entry) {
            var _a = (entry === null || entry === void 0 ? void 0 : entry.contentRect) || {}, width = _a.width, height = _a.height;
            setSize(function (prevSize) {
                if (!shouldSetSize(prevSize, { width: width, height: height }))
                    return prevSize;
                return { width: width, height: height };
            });
        });
    }, [handleWidth, handleHeight, skipResize, shouldSetSize]);
    var resizeHandler = useCallback(patchResizeCallback(resizeCallback, refreshMode, refreshRate, refreshOptions), [
        resizeCallback,
        refreshMode,
        refreshRate,
        refreshOptions
    ]);
    // on refElement change
    useEffect(function () {
        var resizeObserver;
        if (refElement) {
            resizeObserver = new window.ResizeObserver(resizeHandler);
            resizeObserver.observe(refElement, observerOptions);
        }
        else {
            if (size.width || size.height) {
                setSize({ width: undefined, height: undefined });
            }
        }
        return function () {
            var _a, _b, _c;
            (_a = resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect) === null || _a === void 0 ? void 0 : _a.call(resizeObserver);
            (_c = (_b = resizeHandler).cancel) === null || _c === void 0 ? void 0 : _c.call(_b);
        };
    }, [resizeHandler, refElement]);
    useEffect(function () {
        onResize === null || onResize === void 0 ? void 0 : onResize(size.width, size.height);
    }, [size]);
    return __assign({ ref: onRefChange }, size);
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Ellipsis = function (_ref) {
  let {
      children,
      'data-testid': dataTestId = 'beau-ellipsis'
    } = _ref,
    tooltipProps = _objectWithoutProperties(_ref, ["children", "data-testid"]);
  //refreshMode: 'debounce' and refreshRate: 0 are here to fix the "ResizeObserver loop limit exceeded" issue while we waiting for React 18
  //https://github.com/maslianok/react-resize-detector/issues/45
  const {
    ref
  } = useResizeDetector({
    handleHeight: false,
    refreshMode: 'debounce',
    refreshRate: 0
  });
  const isOverflow = ref.current && ref.current.scrollWidth > ref.current.offsetWidth;
  return /*#__PURE__*/React.createElement(Tooltip$2, _objectSpread$6({
    disabled: !isOverflow,
    "data-testid": dataTestId,
    title: /*#__PURE__*/React.createElement(FormatWrapper, null, children)
  }, tooltipProps), /*#__PURE__*/React.createElement(EllipsisWrapper, {
    ref: ref
  }, children));
};

const FooterWrapper = styled.footer.withConfig({
  displayName: "styles__FooterWrapper",
  componentId: "sc-1a8qcpc-0"
})(["color:", ";background-color:", ";border-top:1px solid ", ";padding:0 ", ";min-height:56px;display:flex;justify-content:", ";align-items:center;gap:", ";"], ({
  theme
}) => theme.colors.footer.color, ({
  theme
}) => theme.colors.footer.backgroundColor, ({
  theme
}) => theme.colors.footer.borderColor, ({
  theme
}) => theme.spacing(3), ({
  hasButtons
}) => hasButtons ? 'space-between' : 'flex-start', ({
  theme
}) => theme.spacing(2));
const CopyrightWrapper = styled.div.withConfig({
  displayName: "styles__CopyrightWrapper",
  componentId: "sc-1a8qcpc-1"
})(["font-family:", ";font-size:", ";line-height:", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption);
const ButtonWrapper = styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-1a8qcpc-2"
})(["display:flex;gap:", ";"], ({
  theme
}) => theme.spacing(2));

const COPYRIGHT = `Samsung DSP © ${new Date().getFullYear()}`;
const Footer = ({
  className,
  copyright = COPYRIGHT,
  children,
  'data-testid': dataTestId = 'beau-footer'
}) => {
  return /*#__PURE__*/React.createElement(FooterWrapper, {
    "data-testid": dataTestId,
    className: className,
    hasButtons: !!children
  }, copyright && /*#__PURE__*/React.createElement(CopyrightWrapper, null, copyright), children && /*#__PURE__*/React.createElement(ButtonWrapper, {
    "data-testid": "beau-footer-children"
  }, children));
};

const RowContext = /*#__PURE__*/React.createContext(undefined);
function useRow() {
  const context = React.useContext(RowContext);
  if (context === undefined) {
    throw new Error('Col must be used within a Row');
  }
  return context;
}

const getPourcentage = column => `${100 * column / 12}%`;
const getFlex = column => `0 0 ${getPourcentage(column)}`;
const ColWrapper = styled.div.withConfig({
  displayName: "styles__ColWrapper",
  componentId: "sc-1yjgiuh-0"
})(["position:relative;box-sizing:border-box;display:block;flex:", ";max-width:", ";padding-right:", ";padding-left:", ";order:", ";"], ({
  column
}) => getFlex(column), ({
  column
}) => getPourcentage(column), ({
  gap,
  theme
}) => gap && `calc(${theme.spacing(gap)} / 2)`, ({
  gap,
  theme
}) => gap && `calc(${theme.spacing(gap)} / 2)`, ({
  order
}) => order);

function Col({
  children,
  column = 12,
  order,
  className,
  'data-testid': dataTestId = 'beau-col'
}) {
  const {
    gap
  } = useRow();
  const responsiveColumn = useResponsiveValue(Array.isArray(column) ? column : [column]);
  return /*#__PURE__*/React.createElement(ColWrapper, {
    className: className,
    column: responsiveColumn,
    gap: gap,
    order: order,
    "data-testid": dataTestId
  }, children);
}

const RowWrapper = styled.div.withConfig({
  displayName: "styles__RowWrapper",
  componentId: "sc-1gi8wft-0"
})(["display:flex;flex-flow:row wrap;row-gap:", ";margin-left:", ";margin-right:", ";"], ({
  gap,
  theme
}) => gap && theme.spacing(gap), ({
  gap,
  theme
}) => gap && `calc(-${theme.spacing(gap)} / 2)`, ({
  gap,
  theme
}) => gap && `calc(-${theme.spacing(gap)} / 2)`);

function Row({
  className,
  children,
  gap = 0,
  'data-testid': dataTestId = 'beau-row'
}) {
  return /*#__PURE__*/React.createElement(RowWrapper, {
    className: className,
    gap: gap,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(RowContext.Provider, {
    value: {
      gap
    }
  }, children));
}

const HeaderWrapper = styled.div.withConfig({
  displayName: "styles__HeaderWrapper",
  componentId: "fxssjd-0"
})(["display:flex;align-items:center;height:72px;padding:0 24px;color:", ";background-color:", ";border-bottom:1px solid ", ";> *:not(:first-child){margin-left:5px;}> *:not(:last-child){margin-right:5px;}"], ({
  theme
}) => theme.colors.header.color, ({
  theme
}) => theme.colors.header.backgroundColor, ({
  theme
}) => theme.colors.header.borderColor);

const BackButtonWrapper = styled.a.withConfig({
  displayName: "styles__BackButtonWrapper",
  componentId: "sc-10nmlz8-0"
})(["display:flex;align-items:center;text-decoration:none;cursor:pointer;font-size:", ";line-height:", ";color:", ";&:hover,&:focus,&:active,&:visited{text-decoration:none;color:", ";}"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.colors.header.color, ({
  theme
}) => theme.colors.header.color);

const BackButton = ({
  url,
  onClick,
  'data-testid': dataTestId = 'beau-header-backbutton'
}) => /*#__PURE__*/React.createElement(BackButtonWrapper, {
  href: url,
  onClick: onClick,
  "data-testid": dataTestId
}, /*#__PURE__*/React.createElement(Icon, {
  name: "ArrowLeft"
}));

const TitleWrapper = styled.span.withConfig({
  displayName: "styles__TitleWrapper",
  componentId: "sc-1cvmq9j-0"
})(["font-size:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading2, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);

const SubtitleWrapper = styled.span.withConfig({
  displayName: "styles__SubtitleWrapper",
  componentId: "vaj551-0"
})(["font-size:", ";font-weight:", ";display:flex;> div{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;}"], ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.medium.fontWeight);

const HeadingWrapper = styled.div.withConfig({
  displayName: "styles__HeadingWrapper",
  componentId: "sc-1un5eo3-0"
})(["display:flex;align-items:center;flex-grow:1;vertical-align:center;text-transform:capitalize;padding-right:30px;font-family:", ";line-height:", ";&,& > ", ",& > ", "{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}> ", "{max-width:40%;}:not(:last-child) > ", "{max-width:25%;}> ", " + ", "{::before{content:'\u2014';margin:0 8px;}}"], ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.lineHeight.heading1, TitleWrapper, SubtitleWrapper, SubtitleWrapper, SubtitleWrapper, TitleWrapper, SubtitleWrapper);

const Subtitle = ({
  children,
  'data-testid': dataTestId = 'beau-header-heading-subtitle'
}) => /*#__PURE__*/React.createElement(SubtitleWrapper, {
  "data-testid": dataTestId
}, /*#__PURE__*/React.createElement(Ellipsis, {
  placement: "bottom"
}, children));

const Title$1 = ({
  children,
  'data-testid': dataTestId = 'beau-header-heading-title'
}) => /*#__PURE__*/React.createElement(TitleWrapper, {
  "data-testid": dataTestId
}, /*#__PURE__*/React.createElement(Ellipsis, {
  placement: "bottom"
}, children));

const Heading = ({
  children,
  'data-testid': dataTestId = 'beau-header-heading'
}) => {
  return /*#__PURE__*/React.createElement(HeadingWrapper, {
    "data-testid": dataTestId
  }, children);
};
Heading.displayName = 'Heading';
Heading.Title = Title$1;
Heading.Subtitle = Subtitle;
//Storybooks naming fix
Heading.Title.displayName = 'Heading.Title';
Heading.Subtitle.displayName = 'Heading.Subtitle';

const ButtonGroupWrapper = styled.div.withConfig({
  displayName: "styles__ButtonGroupWrapper",
  componentId: "jiyf3x-0"
})(["display:flex;align-items:center;justify-content:flex-end;> *:not(:first-child){margin-left:16px;}"]);

const ButtonGroup = ({
  children,
  'data-testid': dataTestId = 'beau-buttongroup'
}) => {
  return /*#__PURE__*/React.createElement(ButtonGroupWrapper, {
    "data-testid": dataTestId
  }, children);
};
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.Button = Button;
ButtonGroup.Dropdown = Dropdown$1;

const HeaderComponent = ({
  className,
  children,
  'data-testid': dataTestId = 'beau-header'
}) => {
  return /*#__PURE__*/React.createElement(HeaderWrapper, {
    "data-testid": dataTestId,
    className: className
  }, children);
};
const Header = HeaderComponent;
Header.BackButton = BackButton;
Header.Heading = Heading;
Header.ButtonGroup = ButtonGroup;
//Storybooks naming fix
Header.displayName = 'Header';
Header.BackButton.displayName = 'Header.BackButton';
Header.Heading.displayName = 'Header.Heading';
Header.ButtonGroup.displayName = 'Header.ButtonGroup';

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray_1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol_1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$4.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/* Built-in method references that are verified to be native. */
var Map$1 = _getNative(_root, 'Map');

var _Map = Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || _MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = _MapCache;

var memoize_1 = memoize$2;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize_1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray_1(value)) {
    return value;
  }
  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
}

var _castPath = castPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol_1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = _castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[_toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : _baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get;

const IndicatorWrapper = styled.div.withConfig({
  displayName: "styles__IndicatorWrapper",
  componentId: "sc-173r2h1-0"
})(["display:flex;flex-direction:column;"]);
const LabelContainer = styled.div.withConfig({
  displayName: "styles__LabelContainer",
  componentId: "sc-173r2h1-1"
})(["display:flex;justify-content:space-between;"]);
const Label = styled.span.withConfig({
  displayName: "styles__Label",
  componentId: "sc-173r2h1-2"
})(["font-size:", ";line-height:16px;font-family:", ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"], ({
  theme
}) => theme.fonts.fontSize.tiny, ({
  theme
}) => theme.fonts.roboto.fontFamily);
const Progress = styled(LinearProgress$1).withConfig({
  displayName: "styles__Progress",
  componentId: "sc-173r2h1-3"
})(["&.beauIndicator{box-sizing:border-box;border:", ";height:", ";border-radius:", ";background-color:", ";.beauIndicatorBar{", ";background-color:", ";}}"], ({
  theme
}) => `1px solid ${theme.colors.indicator.bar.borderColor}`, ({
  $large
}) => $large ? '16px' : '8px', ({
  $large
}) => $large ? '20px' : '8px', ({
  theme
}) => theme.colors.indicator.bar.backgroundColor, ({
  $reverse,
  value
}) => $reverse ? `transform: translateX(calc(100% - ${value}%)) !important;` : '', ({
  theme,
  $color = 'skyBlue.default'
}) => get_1(theme.colors, $color));

const Indicator = function ({
  leftLabel,
  rightLabel,
  loading = false,
  reverse = false,
  percentage = 0,
  large = false,
  color,
  'data-testid': dataTestId = 'beau-indicator'
} = {}) {
  const variant = loading ? 'indeterminate' : 'determinate';
  const value = Math.min(100, Math.max(0, percentage));
  return /*#__PURE__*/React.createElement(IndicatorWrapper, {
    "data-testid": dataTestId
  }, (leftLabel || rightLabel) && /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(Label, null, leftLabel), /*#__PURE__*/React.createElement(Label, null, rightLabel)), /*#__PURE__*/React.createElement(Progress, {
    "$large": large,
    "$reverse": reverse,
    variant: variant,
    value: value,
    "$color": color,
    classes: {
      root: 'beauIndicator',
      bar: 'beauIndicatorBar'
    }
  }));
};

const BaseInputWrapper = styled.input.withConfig({
  displayName: "styles__BaseInputWrapper",
  componentId: "sc-1752i58-0"
})(["", ""], ({
  theme
}) => `
  display: block;
  padding: 0;
  position: relative;
  width: 100%;
  height: 32px;
  min-width: 0;
  font-family: SamsungOne;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  color: ${theme.colors.input.color};
  background-color: transparent;
  box-sizing: border-box;
  border-width: 0px;

  &:focus,
  &:active,
  &:read-only,
  &:disabled {
    outline-style: none;
  }
  
  &:disabled {
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
        color: ${theme.colors.input.disabled.color};
  }
  &:focus {
        border-color: ${theme.colors.input.isFocused.borderColor};
  }`);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

var defineProperty$3 = (function() {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$2 = defineProperty$3;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty$2) {
    _defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$5.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq_1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$7.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys$1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}

var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$9.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}

var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');

var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = _getNative(_root, 'Set');

var _Set = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (_Map && getTag(new _Map) != mapTag$1) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$1) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$c.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$a.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array$1 = _root.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$2:
      return _cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return _cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return _cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? _baseCreate(_getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$3;
}

var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$3 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$3;
}

var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag$2] = cloneableTags[arrayTag$1] =
cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] =
cloneableTags[boolTag$2] = cloneableTags[dateTag$2] =
cloneableTags[float32Tag$2] = cloneableTags[float64Tag$2] =
cloneableTags[int8Tag$2] = cloneableTags[int16Tag$2] =
cloneableTags[int32Tag$2] = cloneableTags[mapTag$4] =
cloneableTags[numberTag$2] = cloneableTags[objectTag$2] =
cloneableTags[regexpTag$2] = cloneableTags[setTag$4] =
cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] =
cloneableTags[uint8Tag$2] = cloneableTags[uint8ClampedTag$2] =
cloneableTags[uint16Tag$2] = cloneableTags[uint32Tag$2] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag$2] =
cloneableTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == funcTag$2 || tag == genTag$1;

    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$2 || tag == argsTag$2 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet_1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? keysIn_1 : keys_1);

  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : _baseGet(object, _baseSlice(path, 0, -1));
}

var _parent = parent;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = _castPath(path, object);
  object = _parent(object, path);
  return object == null || delete object[_toKey(last_1(path))];
}

var _baseUnset = baseUnset;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$b.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject_1(value) ? undefined : value;
}

var _customOmitClone = customOmitClone;

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

var flatten_1 = flatten;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax$1(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$1(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return _apply(func, this, otherArgs);
  };
}

var _overRest = overRest;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

var identity_1 = identity;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty$2 ? identity_1 : function(func, string) {
  return _defineProperty$2(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant_1(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString;

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = _shortOut(_baseSetToString);

var _setToString = setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return _setToString(_overRest(func, undefined, flatten_1), func + '');
}

var _flatRest = flatRest;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = _flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = _arrayMap(paths, function(path) {
    path = _castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  _copyObject(object, _getAllKeysIn(object), result);
  if (isDeep) {
    result = _baseClone(result, CLONE_DEEP_FLAG$1 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$1, _customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    _baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

const InputContext = /*#__PURE__*/React.createContext(undefined);
function useInputContext() {
  const context = React.useContext(InputContext);
  if (context === undefined) {
    throw new Error('InputContext must be used within a InputContext.Provider');
  }
  return context;
}

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const BaseInput = /*#__PURE__*/React.forwardRef(({
  style,
  className
}, forwardedRef) => {
  const _useInputContext = useInputContext(),
    {
      value,
      dataTestId,
      error,
      onChange
    } = _useInputContext,
    params = _objectWithoutProperties(_useInputContext, ["value", "dataTestId", "error", "onChange"]);
  const propsWrapper = omit_1(params, ['maxLength']);
  const handleChange = e => onChange && onChange(e.target.value, e);
  return /*#__PURE__*/React.createElement(BaseInputWrapper, _objectSpread$7({
    "aria-invalid": error,
    id: params.name,
    className: className,
    ref: forwardedRef,
    value: value,
    style: style,
    "data-testid": dataTestId,
    onChange: handleChange
  }, propsWrapper));
});
BaseInput.displayName = 'BaseInput';

const Field = styled(BaseInput).attrs(({
  'data-testid': dataTestId = 'beau-input-field'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Field",
  componentId: "sc-14h84u4-0"
})(["flex-grow:1;width:initial;"]);

const Label$1 = styled.div.attrs(({
  'data-testid': dataTestId = 'beau-input-label'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Label",
  componentId: "sc-1x1aee-0"
})(["display:flex;align-items:center;padding-left:", ";padding-right:", ";background-color:", ";font-family:", ";font-style:normal;font-weight:normal;font-size:", ";"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.colors.neutrals.lightGrey, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph);

const InputWrapper = styled.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "hn4j1-0"
})(["display:inline-flex;width:100%;border-width:1px;border-style:solid;border-radius:8px;overflow:hidden;> *:not(input){padding:0 8px;}> *:not(", "):first-child{padding-left:8px;}> *:not(", "):last-child{padding-right:8px;}> ", ":first-child{margin-right:8px;border-right:1px solid ", ";}> ", ":last-child{margin-left:8px;border-left:1px solid ", ";}", ""], Label$1, Label$1, Label$1, ({
  theme
}) => theme.colors.input.readOnly.borderColor, Label$1, ({
  theme
}) => theme.colors.input.readOnly.borderColor, ({
  readOnly,
  disabled,
  isFocused,
  error,
  theme
}) => {
  if (readOnly) {
    return `
        outline-style: none;
        background-color: ${theme.colors.input.readOnly.backgroundColor};
        border-color: ${theme.colors.input.readOnly.borderColor};
    `;
  }
  if (disabled) {
    return `
        outline-style: none;
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
    `;
  }
  if (error) {
    return `
        border-color: ${theme.colors.input.error.borderColor};
      `;
  }
  if (isFocused) {
    return `
        background-color: ${theme.colors.input.backgroundColor};
        border-color: ${theme.colors.input.isFocused.borderColor};
        outline-style: none;
    `;
  }
  return `
      background-color: ${theme.colors.input.backgroundColor};
      border-color: ${theme.colors.input.borderColor};
    `;
});
const Item$1 = styled.div.withConfig({
  displayName: "styles__Item",
  componentId: "hn4j1-1"
})(["display:flex;align-items:center;> *{padding:0 2px;}> *:first-child{padding-left:0;}> *:last-child{padding-right:0;}"]);

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Icon$1 = _ref => {
  let {
      primary,
      'data-testid': dataTestId = 'beau-input-icon'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["primary", "data-testid"]);
  const {
    disabled
  } = useInputContext();
  const getColor = () => {
    if (disabled) {
      return theme.colors.input.icon.disabled.color;
    }
    return primary ? theme.colors.input.icon.primary.color : theme.colors.input.icon.default.color;
  };
  return /*#__PURE__*/React.createElement(Item$1, null, /*#__PURE__*/React.createElement(Icon, _objectSpread$8({
    color: getColor(),
    "data-testid": dataTestId
  }, props)));
};

const ShowPasswordIcon = ({
  onClick,
  showPassword
}) => /*#__PURE__*/React.createElement(Item$1, null, /*#__PURE__*/React.createElement(Icon, {
  "data-testid": "beau-input-icon-password",
  name: showPassword ? 'Invisible' : 'Visible',
  size: "medium",
  onClick: onClick
}));

const MaxCounterWrapper = styled.span.withConfig({
  displayName: "styles__MaxCounterWrapper",
  componentId: "ccuptw-0"
})(({
  theme,
  error
}) => `
  font-size: ${theme.fonts.fontSize.caption};
  line-height: ${theme.fonts.lineHeight.caption};
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-weight: ${theme.fonts.samsungOne.fontWeight.normal.fontWeight};
  color: ${error ? theme.colors.input.error.color : theme.colors.neutrals.grey};
  width: max-content;
`);

const MaxCounter = ({
  'data-testid': dataTestId = 'beau-input-maxcounter'
}) => {
  const {
    value = '',
    error,
    maxLength
  } = useInputContext();
  return /*#__PURE__*/React.createElement(Item$1, null, /*#__PURE__*/React.createElement(MaxCounterWrapper, {
    error: error,
    "data-testid": dataTestId
  }, `${value.length}/${maxLength}`));
};

const Wrapper$1 = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-12o34ay-0"
})(["display:flex;align-items:center;"]);
const ColorPreview = styled.div.withConfig({
  displayName: "style__ColorPreview",
  componentId: "sc-12o34ay-1"
})(["display:inline-block;background-color:", ";height:24px;width:24px;border-radius:4px;"], props => props.color);

const Color = ({
  color,
  'data-testid': dataTestId = 'beau-input-color'
}) => /*#__PURE__*/React.createElement(Wrapper$1, null, /*#__PURE__*/React.createElement(ColorPreview, {
  "data-testid": dataTestId,
  color: color
}));

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const hasError = ({
  error,
  value,
  maxLength
}) => {
  if (error) {
    return error;
  }
  if (!!value) {
    // Get maxLength error
    return !!maxLength && value.length > maxLength;
  }
  return false;
};
const TextInput = function (_ref) {
  let {
      children,
      className,
      type = 'text',
      error: _error = false,
      disabled = false,
      readOnly = false,
      required = false,
      autoFocus = false,
      autoComplete = 'on',
      onChange,
      onFocus,
      onBlur,
      onClick,
      onKeyDown,
      'data-testid': dataTestId = 'beau-text-input'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["children", "className", "type", "error", "disabled", "readOnly", "required", "autoFocus", "autoComplete", "onChange", "onFocus", "onBlur", "onClick", "onKeyDown", "data-testid"]);
  const [isFocused, setIsFocused] = useState(false);
  const error = hasError({
    error: _error,
    value: props.value,
    maxLength: props.maxLength
  });
  const handleFocus = e => {
    if (!disabled && !readOnly) {
      setIsFocused(true);
    }
    onFocus && onFocus(e);
  };
  const handleBlur = e => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  return /*#__PURE__*/React.createElement(InputContext.Provider, {
    value: _objectSpread$9({
      error,
      type: !showPassword && type === 'password' ? 'password' : 'text',
      disabled,
      readOnly: readOnly,
      required,
      autoFocus,
      autoComplete,
      dataTestId,
      onChange,
      onKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur
    }, props)
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    className: className,
    isFocused: isFocused,
    error: error,
    readOnly: readOnly,
    disabled: disabled,
    onClick: onClick
  }, children ?? /*#__PURE__*/React.createElement(BaseInput, null), type === 'password' && /*#__PURE__*/React.createElement(ShowPasswordIcon, {
    showPassword: showPassword,
    onClick: togglePasswordVisibility
  })));
};
TextInput.Item = Item$1;
TextInput.Field = Field;
TextInput.Label = Label$1;
TextInput.Icon = Icon$1;
TextInput.MaxCounter = MaxCounter;
TextInput.Color = Color;
//Storybooks naming fix
TextInput.displayName = 'TextInput';
TextInput.Item.displayName = 'TextInput.Item';
TextInput.Field.displayName = 'TextInput.Field';
TextInput.Icon.displayName = 'TextInput.Icon';
TextInput.Label.displayName = 'TextInput.Label';
TextInput.MaxCounter.displayName = 'TextInput.MaxCounter';
TextInput.Color.displayName = 'TextInput.Color';

const BaseInputWrapper$1 = styled.input.withConfig({
  displayName: "styles__BaseInputWrapper",
  componentId: "sc-1803g1l-0"
})(({
  theme,
  incrementable
}) => `
  display: block;
  padding: 0;
  position: relative;
  width: 100%;
  height: 32px;
  min-width: 0;
  font-family: SamsungOne;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  color: ${theme.colors.input.color};
  box-sizing: border-box;
  border-width: 0px;
  
  // Remove arrow type number on Webkit
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: ${incrementable ? 'auto' : 'none'};
    margin: ${incrementable ? 'initial' : '0'};
  }

  // Remove arrow type number on Firefox
  &[type=number] {
    -moz-appearance: textfield;
  }

  &:focus,
  &:active,
  &:read-only,
  &:disabled {
    outline-style: none;
  }
  
  &:disabled {
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
        color: ${theme.colors.input.disabled.color};
  }
  &:read-only {
        background-color: ${theme.colors.input.readOnly.backgroundColor};
        border-color: ${theme.colors.input.readOnly.borderColor};
  }
  &:focus {
        border-color: ${theme.colors.input.isFocused.borderColor};
  }
`);

const InputContext$1 = /*#__PURE__*/React.createContext(undefined);
function useInputContext$1() {
  const context = React.useContext(InputContext$1);
  if (context === undefined) {
    throw new Error('InputContext must be used within a InputContext.Provider');
  }
  return context;
}

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const BaseInput$1 = /*#__PURE__*/React.forwardRef(({
  style,
  className
}, forwardedRef) => {
  const _useInputContext = useInputContext$1(),
    {
      value = '',
      dataTestId
    } = _useInputContext,
    params = _objectWithoutProperties(_useInputContext, ["value", "dataTestId"]);
  const propsWrapper = omit_1(params, ['max', 'maxLength']);
  return /*#__PURE__*/React.createElement(BaseInputWrapper$1, _objectSpread$a({
    id: params.name,
    className: className,
    ref: forwardedRef,
    value: value,
    style: style,
    "data-testid": dataTestId
  }, propsWrapper));
});
BaseInput$1.displayName = 'BaseInput';

const Field$1 = styled(BaseInput$1).attrs(({
  'data-testid': dataTestId = 'beau-input-field'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Field",
  componentId: "lbz6qm-0"
})(["flex-grow:1;width:initial;"]);

const Label$2 = styled.div.attrs(({
  'data-testid': dataTestId = 'beau-input-label'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Label",
  componentId: "sc-10kqnjx-0"
})(["display:flex;align-items:center;padding-left:8px;padding-right:50px;background-color:", ";font-family:", ";font-style:normal;font-weight:normal;font-size:", ";"], ({
  theme
}) => theme.colors.neutrals.lightGrey, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph);

const InputWrapper$1 = styled.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-1cbw0xr-0"
})(["display:inline-flex;width:100%;border-width:1px;border-style:solid;border-radius:8px;overflow:hidden;> *:not(input){padding:0 8px;}> *:not(", "):first-child{padding-left:8px;}> *:not(", "):last-child{padding-right:8px;}> ", ":first-child{margin-right:8px;}> ", ":last-child{margin-left:8px;}", ""], Label$2, Label$2, Label$2, Label$2, ({
  readOnly,
  disabled,
  isFocused,
  error,
  theme
}) => {
  if (readOnly) {
    return `
        outline-style: none;
        background-color: ${theme.colors.input.readOnly.backgroundColor};
        border-color: ${theme.colors.input.readOnly.borderColor};
    `;
  }
  if (disabled) {
    return `
        outline-style: none;
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
    `;
  }
  if (error) {
    return `
        border-color: ${theme.colors.input.error.borderColor};
      `;
  }
  if (isFocused) {
    return `
        background-color: ${theme.colors.input.backgroundColor};
        border-color: ${theme.colors.input.isFocused.borderColor};
        outline-style: none;
    `;
  }
  return `
      background-color: ${theme.colors.input.backgroundColor};
      border-color: ${theme.colors.input.borderColor};
    `;
});
const Item$2 = styled.div.withConfig({
  displayName: "styles__Item",
  componentId: "sc-1cbw0xr-1"
})(["display:flex;align-items:center;> *{padding:0 2px;}> *:first-child{padding-left:0;}> *:last-child{padding-right:0;}"]);

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Icon$2 = _ref => {
  let {
      primary,
      'data-testid': dataTestId = 'beau-input-icon'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["primary", "data-testid"]);
  const color = primary ? theme.colors.input.icon.primary.color : theme.colors.input.icon.default.color;
  return /*#__PURE__*/React.createElement(Item$2, null, /*#__PURE__*/React.createElement(Icon, _objectSpread$b({
    color: color,
    "data-testid": dataTestId
  }, props)));
};

const MaxCounterWrapper$1 = styled.span.withConfig({
  displayName: "styles__MaxCounterWrapper",
  componentId: "n3p539-0"
})(({
  theme,
  error
}) => `
  font-size: ${theme.fonts.fontSize.caption};
  line-height: ${theme.fonts.lineHeight.caption};
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-weight: ${theme.fonts.samsungOne.fontWeight.normal.fontWeight};
  color: ${error ? theme.colors.input.error.color : theme.colors.neutrals.grey};
  width: max-content;
`);

const MaxCounter$1 = ({
  'data-testid': dataTestId = 'beau-input-maxcounter'
}) => {
  const {
    value = '',
    error,
    max,
    maxLength,
    type
  } = useInputContext$1();
  return /*#__PURE__*/React.createElement(Item$2, null, /*#__PURE__*/React.createElement(MaxCounterWrapper$1, {
    error: error,
    "data-testid": dataTestId
  }, type === 'number' ? `Max Value ${max}` : `${value.length}/${maxLength}`));
};

const Wrapper$2 = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-156ltjv-0"
})(["display:flex;align-items:center;"]);
const ColorPreview$1 = styled.div.withConfig({
  displayName: "style__ColorPreview",
  componentId: "sc-156ltjv-1"
})(["display:inline-block;background-color:", ";height:24px;width:24px;border-radius:4px;"], props => props.color);

const Color$1 = ({
  color,
  'data-testid': dataTestId = 'beau-input-color'
}) => /*#__PURE__*/React.createElement(Wrapper$2, null, /*#__PURE__*/React.createElement(ColorPreview$1, {
  "data-testid": dataTestId,
  color: color
}));

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const hasError$1 = ({
  error,
  value,
  type,
  max,
  maxLength
}) => {
  if (error) {
    return error;
  }
  if (!!value) {
    // Get max / maxLength error
    return type === 'number' ? !!max && value > max : !!maxLength && value.length > maxLength;
  }
  return false;
};
/**
 * @deprecated This Input is deprecated in favor of TextInput or NumberInput
 */
const Input = function (_ref) {
  let {
      children,
      className,
      error: _error = false,
      disabled = false,
      readOnly = false,
      required = false,
      autoComplete = 'on',
      onFocus,
      onBlur,
      onClick,
      'data-testid': dataTestId = 'beau-input'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["children", "className", "error", "disabled", "readOnly", "required", "autoComplete", "onFocus", "onBlur", "onClick", "data-testid"]);
  const [isFocused, setIsFocused] = useState(false);
  const error = hasError$1({
    error: _error,
    value: props.value,
    type: props.type,
    max: props.max,
    maxLength: props.maxLength
  });
  const handleFocus = e => {
    if (!disabled && !readOnly) {
      setIsFocused(true);
    }
    onFocus && onFocus(e);
  };
  const handleBlur = e => {
    setIsFocused(false);
    onBlur && onBlur(e);
  };
  return /*#__PURE__*/React.createElement(InputContext$1.Provider, {
    value: _objectSpread$c({
      error,
      disabled,
      readOnly,
      required,
      autoComplete,
      dataTestId,
      onFocus: handleFocus,
      onBlur: handleBlur
    }, props)
  }, /*#__PURE__*/React.createElement(InputWrapper$1, {
    className: className,
    isFocused: isFocused,
    error: error,
    readOnly: readOnly,
    disabled: disabled,
    onClick: onClick
  }, children ?? /*#__PURE__*/React.createElement(BaseInput$1, null)));
};
Input.Item = Item$2;
Input.Field = Field$1;
Input.Label = Label$2;
Input.Icon = Icon$2;
Input.MaxCounter = MaxCounter$1;
Input.Color = Color$1;
//Storybooks naming fix
Input.Item.displayName = 'Input.Item';
Input.Field.displayName = 'Input.Field';
Input.Icon.displayName = 'Input.Icon';
Input.Label.displayName = 'Input.Label';
Input.MaxCounter.displayName = 'Input.MaxCounter';
Input.Color.displayName = 'Input.Color';

const TitleWrapper$1 = styled.div.withConfig({
  displayName: "styles__TitleWrapper",
  componentId: "sc-14l2vg0-0"
})(["display:flex;text-transform:capitalize;justify-content:", ";font-size:", ";line-height:", ";font-family:", ";font-weight:", ";padding:", ";"], ({
  center
}) => !!center && 'center', ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.lineHeight.heading4, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight, ({
  theme
}) => `0 ${theme.spacing(3)}`);

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Title$2 = _ref => {
  let {
      'data-testid': dataTestId = 'beau-modal-title'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["data-testid"]);
  return /*#__PURE__*/React.createElement(TitleWrapper$1, _objectSpread$d({
    "data-testid": dataTestId
  }, props));
};

const scrollbar$1 = css$1(["::-webkit-scrollbar{background:", ";width:8px;}::-webkit-scrollbar-thumb{background:", ";border-radius:8px;}"], ({
  theme
}) => theme.colors.scrollbar.backgroundColor, ({
  theme
}) => theme.colors.scrollbar.color);

const ContentWrapper = styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-18d1cq3-0"
})(["display:flex;overflow-y:auto;flex-direction:column;justify-content:", ";font-size:", ";line-height:", ";font-family:", ";padding:", ";margin:", ";", ";"], ({
  center
}) => !!center && 'center', ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => `0 ${theme.spacing(2)}`, ({
  theme
}) => `0 ${theme.spacing(1)}`, scrollbar$1);

const Content = ({
  center,
  children,
  'data-testid': dataTestId = 'beau-modal-content'
}) => {
  return /*#__PURE__*/React.createElement(ContentWrapper, {
    center: center,
    "data-testid": dataTestId
  }, children);
};

const BaseButtonGroupWrapper = styled.div.withConfig({
  displayName: "styles__BaseButtonGroupWrapper",
  componentId: "r0pout-0"
})(["padding:", ";"], ({
  theme
}) => `0 ${theme.spacing(3)}`);

const BaseButtonGroup = ({
  children,
  'data-testid': dataTestId = 'beau-modal-buttongroup'
}) => {
  return /*#__PURE__*/React.createElement(BaseButtonGroupWrapper, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    "data-testid": dataTestId
  }, children));
};

const ModalWrapper = styled.div.withConfig({
  displayName: "styles__ModalWrapper",
  componentId: "sc-1rieqst-0"
})(["padding:", ";border-radius:8px;color:", ";background-color:", ";max-height:", ";width:", ";max-width:", ";display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => `${theme.spacing(3)} 0`, ({
  theme
}) => theme.colors.modal.color, ({
  theme
}) => theme.colors.modal.backgroundColor, ({
  theme
}) => `calc(100vh - calc(${theme.spacing(1)} * 18))`, ({
  maxWidth
}) => maxWidth, ({
  theme
}) => `calc(100vw - calc(${theme.spacing(1)} * 18))`, ({
  theme
}) => theme.spacing(3));
const OverlayWrapper = styled.div.withConfig({
  displayName: "styles__OverlayWrapper",
  componentId: "sc-1rieqst-1"
})(["top:0;left:0;right:0;bottom:0;display:flex;justify-content:center;align-items:center;z-index:1000;position:fixed;background-color:rgba(0,0,0,0.5);"]);

const getMaxWidth = size => {
  switch (size) {
    case 'small':
      return '368px';
    case 'medium':
      return '768px';
    case 'large':
      return '1104px';
    default:
      return '768px';
  }
};
const ModalComponent = ({
  children,
  size = 'medium',
  show = false,
  className = '',
  onHide,
  'data-testid': dataTestId = 'beau-modal'
}) => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (show) {
      document.addEventListener('keydown', handleEscape, false);
    } else {
      document.removeEventListener('keydown', handleEscape, false);
    }
    return () => document.removeEventListener('keydown', handleEscape, false);
  }, [show]);
  const handleEscape = e => {
    if (e.key === 'Escape') {
      onHide();
    }
  };
  return show ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(OverlayWrapper, null, /*#__PURE__*/React.createElement(ModalWrapper, {
    "data-testid": dataTestId,
    className: className,
    ref: wrapperRef,
    maxWidth: getMaxWidth(size)
  }, children)), document.body) : null;
};
ModalComponent.displayName = 'Modal';
const Modal = ModalComponent;
Modal.Title = Title$2;
Modal.Content = Content;
Modal.ButtonGroup = BaseButtonGroup;
Modal.Title.displayName = 'Modal.Title';
Modal.Content.displayName = 'Modal.Content';
Modal.ButtonGroup.displayName = 'Modal.ButtonGroup';

const PillWrapper = styled(Chip$1).withConfig({
  displayName: "styles__PillWrapper",
  componentId: "sc-3ehc8d-0"
})(["&.beauPill{display:flex;height:unset;border-radius:24px;font-size:", ";font-family:", ";font-weight:", ";line-height:", ";padding:", " 10px;cursor:inherit;color:", ";background-color:", ";", ";&:hover{", "}&:focus,&:active{", "}", ";&.beauPillDisabled{", "}.deleteIcon{width:unset;height:unset;margin:0 0 0 4px;color:", ";&:hover{color:", ";}}&.beauPillDeletable:focus{background-color:", ";.deleteIcon{color:", ";}}.startIcon{width:unset;height:unset;margin:0 4px 0 0;color:", ";svg{", ";}}.beauPillLabelWrapper{padding:0;}}"], theme.fonts.fontSize.tiny, theme.fonts.samsungOne.fontFamily, theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  $size
}) => $size === 'small' ? '12px' : '16px', ({
  $size
}) => $size === 'large' ? '2px' : '0', ({
  $variant
}) => theme.colors.pill[$variant].color, ({
  $variant
}) => theme.colors.pill[$variant].backgroundColor, ({
  $variant
}) => $variant === 'outlined' && `box-shadow: inset 0px 0px 0px 1px ${theme.colors.pill.outlined.borderColor}`, ({
  onClick,
  $variant
}) => onClick && `background-color: ${theme.colors.pill[$variant].hover.backgroundColor};
          ${$variant === 'outlined' && `box-shadow: inset 0px 0px 0px 1px ${theme.colors.pill.outlined.hover.borderColor};
             color:${theme.colors.pill.outlined.hover.color};`}`, ({
  onClick,
  $variant
}) => onClick && `background-color: ${theme.colors.pill[$variant].focus.backgroundColor};
        ${$variant === 'outlined' ? `box-shadow: inset 0px 0px 0px 1px ${theme.colors.pill.outlined.focus.borderColor};
               color:${theme.colors.pill.outlined.focus.color};` : 'box-shadow: none'}`, ({
  $readOnly
}) => $readOnly && `background-color: ${theme.colors.pill.outlined.disabled.backgroundColor};
        border-color: ${theme.colors.pill.outlined.disabled.borderColor}
        `, ({
  $variant
}) => $variant === 'outlined' ? `background-color: ${theme.colors.pill.outlined.disabled.backgroundColor};
        border-color: ${theme.colors.pill.outlined.disabled.borderColor}` : '', ({
  $variant
}) => theme.colors.pill[$variant].deleteIconColor, ({
  $variant
}) => theme.colors.pill[$variant].hover.deleteIconColor, ({
  $variant
}) => theme.colors.pill[$variant].backgroundColor, ({
  $variant
}) => theme.colors.pill[$variant].hover.deleteIconColor, ({
  $variant
}) => theme.colors.pill[$variant].iconColor, ({
  $size
}) => $size === 'large' && LargeIcon);
const LargeIcon = css$1(["width:10px;height:10px;"]);
const Label$3 = styled.span.withConfig({
  displayName: "styles__Label",
  componentId: "sc-3ehc8d-1"
})(["margin-right:4px;color:", ";"], ({
  $variant
}) => theme.colors.pill[$variant].titleColor);

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Pill = function ({
  value,
  label,
  icon,
  size = 'large',
  variant = 'default',
  tooltipPlacement = 'top',
  disabled,
  readOnly = false,
  onRemove,
  onClick,
  'data-testid': dataTestId = 'beau-pill',
  className
}) {
  const ExtendedButtonProps = onClick && {
    disableRipple: true
  };
  const contents = /*#__PURE__*/React.createElement(Ellipsis, {
    placement: tooltipPlacement
  }, label && /*#__PURE__*/React.createElement(Label$3, {
    "$variant": variant
  }, label), /*#__PURE__*/React.createElement("span", null, value));
  return /*#__PURE__*/React.createElement(PillWrapper, _objectSpread$e({
    "$size": size,
    label: contents,
    "$variant": variant,
    onClick: onClick,
    onDelete: !disabled && !readOnly ? onRemove : undefined,
    disabled: disabled,
    "$readOnly": readOnly,
    "data-testid": dataTestId,
    className: className,
    classes: {
      root: 'beauPill',
      label: 'beauPillLabelWrapper',
      disabled: 'beauPillDisabled',
      deletable: 'beauPillDeletable'
    },
    icon: icon && /*#__PURE__*/React.createElement(Icon, {
      size: "tiny",
      name: icon,
      className: "startIcon",
      "data-testid": `beau-pill-starticon-${icon}`
    }),
    deleteIcon: /*#__PURE__*/React.createElement(Icon, {
      size: "tiny",
      name: "Close",
      className: "deleteIcon",
      "data-testid": "beau-pill-deleteicon"
    })
  }, ExtendedButtonProps));
};

const PaginationWrapper = styled.div.withConfig({
  displayName: "styles__PaginationWrapper",
  componentId: "ku0rw2-0"
})(["margin-top:10px;display:flex;justify-content:space-between;border-bottom-left-radius:8px;border-bottom-right-radius:8px;"]);
const CountWrapper = styled.div.withConfig({
  displayName: "styles__CountWrapper",
  componentId: "ku0rw2-1"
})(["align-self:center;color:", ";user-select:none;font-size:", ";line-height:", ";font-family:", ";"], ({
  theme
}) => theme.colors.popover.pagination.color, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.samsungOne.fontFamily);
const ButtonGroupWrapper$1 = styled.div.withConfig({
  displayName: "styles__ButtonGroupWrapper",
  componentId: "ku0rw2-2"
})(["display:flex;width:39px;justify-content:space-between;"]);

const getIconColor = disabled => disabled ? theme.colors.popover.icon.colorDisabled : theme.colors.popover.icon.color;
const Pagination = ({
  current,
  total,
  onBack,
  onForward
}) => {
  const backIconColor = getIconColor(current <= 1);
  const forwardIconColor = getIconColor(current >= total);
  return /*#__PURE__*/React.createElement(PaginationWrapper, null, /*#__PURE__*/React.createElement(CountWrapper, null, current, " of ", total), /*#__PURE__*/React.createElement(ButtonGroupWrapper$1, null, /*#__PURE__*/React.createElement(Icon, {
    name: "ArrowLeft",
    size: "small",
    color: backIconColor,
    disabled: current <= 1,
    onClick: onBack
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "ArrowRight",
    size: "small",
    color: forwardIconColor,
    disabled: current >= total,
    onClick: onForward
  })));
};
Pagination.displayName = 'Pagination';

const PageWrapper = styled.div.withConfig({
  displayName: "styles__PageWrapper",
  componentId: "f8icvr-0"
})(["font-size:", ";line-height:", ";font-family:", ";"], ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.samsungOne.fontFamily);

const Page = function ({
  children
}) {
  return /*#__PURE__*/React.createElement(PageWrapper, null, children);
};
Page.displayName = 'Page';

const Arrow = styled.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-1xyrbn1-0"
})(["&,&::before{position:absolute;width:12px;height:12px;background:", ";}&{visibility:hidden;}&::before{visibility:visible;content:'';border-right:1px solid ", ";border-bottom:1px solid ", ";}", ""], ({
  theme
}) => theme.colors.popover.backgroundColor, ({
  theme
}) => theme.colors.popover.borderColor, ({
  theme
}) => theme.colors.popover.borderColor, ({
  placement
}) => {
  switch (placement) {
    case 'top':
    case 'top-start':
    case 'top-end':
      return `
          bottom: -6px;
          &:before {
            transform: rotate(45deg);
          }
        `;
    case 'bottom':
    case 'bottom-start':
    case 'bottom-end':
      return `
          top: -7px;
          &:before {
            transform: rotate(-135deg);
          }
        `;
    case 'right':
    case 'right-start':
    case 'right-end':
      return `
          left: -7px;
          &:before {
            transform: rotate(135deg);
          }
          `;
    case 'left':
    case 'left-start':
    case 'left-end':
      return `
          right: -6px;
          &:before {
            transform: rotate(-45deg);
          }
        `;
    default:
      return ``;
  }
});
const getSize$1 = size => {
  switch (size) {
    case 'tiny':
      return '208px';
    case 'small':
      return '260px';
    case 'medium':
      return '340px';
    case 'large':
    default:
      return '432px';
  }
};
const PopoverWrapper = styled.div.withConfig({
  displayName: "styles__PopoverWrapper",
  componentId: "sc-1xyrbn1-1"
})(["box-sizing:border-box;position:absolute;display:flex;flex-direction:column;border-radius:8px;width:", ";max-width:", ";padding:", ";background:", ";border:1px solid ", ";z-index:100;"], ({
  size
}) => getSize$1(size), ({
  theme
}) => `calc(100vw - ${theme.spacing(2)} * 2)`, ({
  theme
}) => theme.spacing(2), ({
  theme
}) => theme.colors.popover.backgroundColor, ({
  theme
}) => theme.colors.popover.borderColor);
const TitleWrapper$2 = styled.div.withConfig({
  displayName: "styles__TitleWrapper",
  componentId: "sc-1xyrbn1-2"
})(["margin-bottom:10px;line-height:", ";font-size:", ";font-weight:", ";font-family:", ";"], ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  theme
}) => theme.fonts.samsungOne.fontFamily);
const ContentWrapper$1 = styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1xyrbn1-3"
})(["overflow:auto;font-size:", ";line-height:", ";font-family:", ";"], ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.samsungOne.fontFamily);

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const getPageCount = children => React.Children.toArray(children).filter(child => child.type == Page).length;
const PopoverComponent = ({
  title,
  target,
  children,
  onClose,
  show,
  size = 'large',
  placement = 'bottom',
  'data-testid': dataTestId = 'beau-popover',
  className
}) => {
  const wrapperRef = useRef(null);
  const [pagination, setPagination] = useState(1);
  const [popperElement, setPopperElement] = useState(null);
  const [arrowElement, setArrowElement] = useState(null);
  const content = React.Children.toArray(children);
  const hasPagination = useMemo(() => getPageCount(children) > 1, [children]);
  const {
    styles,
    attributes
  } = usePopper(target, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowElement,
        padding: 8
      }
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 15]
      }
    }]
  });
  const handleBack = () => setPagination(pagination => pagination - 1);
  const handleForward = () => setPagination(pagination => pagination + 1);
  useClickOutside(wrapperRef, () => {
    onClose && onClose();
  }, !show);
  return show ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(PopoverWrapper, _objectSpread$f({
    className: className,
    ref: setPopperElement,
    size: size,
    style: styles.popper,
    "data-testid": dataTestId
  }, attributes.popper), !!title && /*#__PURE__*/React.createElement(TitleWrapper$2, null, title), hasPagination ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ContentWrapper$1, null, content[pagination - 1]), /*#__PURE__*/React.createElement(Pagination, {
    current: pagination,
    total: getPageCount(children),
    onBack: handleBack,
    onForward: handleForward
  })) : /*#__PURE__*/React.createElement(ContentWrapper$1, null, children), /*#__PURE__*/React.createElement(Arrow, {
    ref: setArrowElement,
    style: styles.arrow,
    "data-arrow-popper": true,
    placement: attributes.popper?.['data-popper-placement']
  }))), document.body) : null;
};
PopoverComponent.displayName = 'Popover';
const Popover = PopoverComponent;
Popover.Page = Page;
Popover.Page.displayName = 'Popover.Page';

const RadioContext = /*#__PURE__*/createContext(undefined);
function useRadioContext() {
  const context = React.useContext(RadioContext);
  if (context === undefined) {
    throw new Error('RadioContext must be used within a RadioProvider');
  }
  return context;
}

const InputWrapper$2 = styled.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "kqbcva-0"
})(["display:inline-block;position:relative;height:16px;width:16px;align-self:", ";top:", ";flex-shrink:0;"], ({
  placement
}) => placement === 'center' ? 'center' : 'start', ({
  placement
}) => placement === 'center' ? 'initial' : '4px');
const Radio = styled.div.withConfig({
  displayName: "styles__Radio",
  componentId: "kqbcva-1"
})(["display:flex;justify-content:center;position:absolute;bottom:0;left:0;right:0;top:0;border-radius:50%;"]);
const Circle = styled.div.withConfig({
  displayName: "styles__Circle",
  componentId: "kqbcva-2"
})(["border-radius:50%;align-self:center;height:12px;width:12px;"]);
const Input$1 = styled.input.withConfig({
  displayName: "styles__Input",
  componentId: "kqbcva-3"
})(["width:100%;height:100%;margin:0;opacity:0;+ ", "{color:", ";border:1px solid ", ";}:focus-visible + ", "{border-color:", ";}+ ", " > ", "{background-color:", ";}:checked + ", " > ", "{background-color:", ";}:disabled + ", "{cursor:inherit;color:", ";border-color:", ";}:disabled + ", " > ", "{background-color:", ";}:disabled:checked + ", " > ", "{color:", ";background-color:", ";}&[readonly] + ", "{cursor:auto;color:", ";background-color:", ";border-color:", ";}&[readonly]:checked + ", " > ", "{color:", ";background-color:", ";}"], Radio, ({
  theme
}) => theme.colors.checkbox.checkColor, ({
  theme
}) => theme.colors.radio.borderColor, Radio, ({
  theme
}) => theme.colors.radio.focused.borderColor, Radio, Circle, ({
  theme
}) => theme.colors.radio.backgroundColor, Radio, Circle, ({
  theme
}) => theme.colors.radio.checked.backgroundColor, Radio, ({
  theme
}) => theme.colors.checkbox.disabled.checkColor, ({
  theme
}) => theme.colors.radio.disabled.borderColor, Radio, Circle, ({
  theme
}) => theme.colors.radio.disabled.backgroundColor, Radio, Circle, ({
  theme
}) => theme.colors.radio.disabled.checked.checkColor, ({
  theme
}) => theme.colors.radio.disabled.checked.backgroundColor, Radio, ({
  theme
}) => theme.colors.radio.readOnly.checkColor, ({
  theme
}) => theme.colors.radio.readOnly.backgroundColor, ({
  theme
}) => theme.colors.radio.readOnly.borderColor, Radio, Circle, ({
  theme
}) => theme.colors.radio.readOnly.checked.checkColor, ({
  theme
}) => theme.colors.radio.readOnly.checked.backgroundColor);

const InputComponent = ({
  placement
}) => {
  const {
    onChange,
    name,
    disabled,
    checked,
    readOnly
  } = useRadioContext();
  return /*#__PURE__*/React.createElement(InputWrapper$2, {
    placement: placement
  }, /*#__PURE__*/React.createElement(Input$1, {
    "aria-checked": !!checked,
    checked: !!checked,
    type: "radio",
    name: name,
    readOnly: readOnly,
    disabled: disabled || readOnly,
    onChange: onChange,
    onClick: e => {
      e.stopPropagation();
    }
  }), /*#__PURE__*/React.createElement(Radio, null, /*#__PURE__*/React.createElement(Circle, null)));
};

const Wrapper$3 = styled.label.withConfig({
  displayName: "styles__Wrapper",
  componentId: "ic3jg4-0"
})(["display:flex;flex-direction:", ";padding:2px;border-radius:8px;border:1px solid transparent;", ";"], ({
  labelPlacement
}) => labelPlacement === 'left' ? 'row-reverse' : 'row', ({
  error,
  disabled,
  theme
}) => {
  if (error) {
    return `
        border-color: ${theme.colors.input.error.borderColor};
      `;
  }
  if (disabled) {
    return `
        color: ${theme.colors.radio.disabled.color};
        cursor: not-allowed;
    `;
  }
  return `
        color: ${theme.colors.radio.color};
        cursor: pointer;
    `;
});
const Label$4 = styled.span.withConfig({
  displayName: "styles__Label",
  componentId: "ic3jg4-1"
})(["font-family:", ";font-size:", ";line-height:", ";align-self:center;", ";", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  placement
}) => placement === 'left' ? `margin-right: 8px` : `margin-left: 8px`, ({
  placement
}) => placement === 'left' && `text-align: right`);

const Radio$1 = ({
  children,
  name,
  value,
  labelPlacement = 'right',
  inputPlacement = 'top',
  checked = false,
  disabled = false,
  readOnly = false,
  onChange,
  className,
  'data-testid': dataTestId = 'beau-radio'
}) => {
  return /*#__PURE__*/React.createElement(Wrapper$3, {
    labelPlacement: labelPlacement,
    "data-testid": dataTestId,
    className: className,
    disabled: disabled
  }, /*#__PURE__*/React.createElement(RadioContext.Provider, {
    value: {
      name,
      value,
      checked,
      disabled,
      readOnly,
      onChange
    }
  }, /*#__PURE__*/React.createElement(InputComponent, {
    placement: inputPlacement
  }), children && /*#__PURE__*/React.createElement(Label$4, {
    placement: labelPlacement
  }, children)));
};

const RadioGroupContext = /*#__PURE__*/createContext(undefined);
function useRadioGroupContext() {
  const context = React.useContext(RadioGroupContext);
  if (context === undefined) {
    throw new Error('useRadioGroupContext must be used within a RadioGroupContext.Provider');
  }
  return context;
}

const BaseRadio = ({
  children,
  value,
  disabled: _disabled,
  readOnly: _readOnly,
  labelPlacement: _labelPlacement = 'right',
  inputPlacement: _inputPlacement = 'top',
  className,
  'data-testid': dataTestId = 'beau-radio'
}) => {
  const {
    onChange,
    name,
    disabled,
    checked,
    readOnly,
    labelPlacement,
    inputPlacement
  } = useRadioGroupContext();
  return /*#__PURE__*/React.createElement(Radio$1, {
    "data-testid": dataTestId,
    className: className,
    value: value,
    name: name,
    checked: checked === value,
    disabled: disabled ?? _disabled,
    readOnly: readOnly ?? _readOnly,
    labelPlacement: labelPlacement ?? _labelPlacement,
    inputPlacement: inputPlacement ?? _inputPlacement,
    onChange: () => {
      onChange && onChange(value);
    }
  }, children);
};

const RadioGroup = ({
  children,
  name,
  checked,
  disabled = false,
  readOnly = false,
  labelPlacement,
  inputPlacement,
  onChange,
  'data-testid': dataTestId = 'beau-radiogroup'
}) => {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: {
      name,
      checked,
      disabled,
      readOnly,
      labelPlacement,
      inputPlacement,
      onChange
    }
  }, children));
};
RadioGroup.Radio = BaseRadio;
//Storybooks naming fix
RadioGroup.displayName = 'RadioGroup';
RadioGroup.Radio.displayName = 'RadioGroup.Radio';

const Link$1 = styled.a.attrs(({
  isExternal
}) => ({
  target: isExternal ? '_blank' : '',
  rel: isExternal ? 'noopener' : ''
})).withConfig({
  displayName: "Link",
  componentId: "sc-4sxdr-0"
})(["font-family:", ";line-height:", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.lineHeight.paragraph);

const RibbonWrapper = styled.div.withConfig({
  displayName: "styles__RibbonWrapper",
  componentId: "sc-1l7xkx0-0"
})(["display:flex;padding:4px 8px;background:", ";border-radius:8px;width:100%;box-sizing:border-box;font-family:", ";font-size:", ";line-height:", ";"], ({
  backgroundColor
}) => backgroundColor, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption);
const ContentWrapper$2 = styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1l7xkx0-1"
})(["display:block;padding:4px 8px;"]);
const CloseWrapper = styled.div.withConfig({
  displayName: "styles__CloseWrapper",
  componentId: "sc-1l7xkx0-2"
})(["padding:4px;svg{width:12px;&:hover{cursor:pointer;}}"]);
const IconWrapper$1 = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-1l7xkx0-3"
})(["padding-top:5px;"]);
const Title$3 = styled.div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1l7xkx0-4"
})(["font-weight:", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const StyledLink = styled(Link$1).withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-1l7xkx0-5"
})(["display:block;"]);

const Ribbon = ({
  children,
  type,
  show = true,
  canClose = false,
  className,
  'data-testid': dataTestId = 'beau-ribbon'
}) => {
  const colors = theme.colors.ribbon[type];
  const [isVisible, setIsVisible] = useState(show);
  useEffect(() => {
    setIsVisible(show);
  }, [show]);
  return isVisible ? /*#__PURE__*/React.createElement(RibbonWrapper, {
    backgroundColor: colors.backgroundColor,
    className: className,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(IconWrapper$1, null, /*#__PURE__*/React.createElement(Icon, {
    name: getIconName(type),
    color: colors.icon.color
  })), /*#__PURE__*/React.createElement(ContentWrapper$2, null, children), canClose && /*#__PURE__*/React.createElement(CloseWrapper, {
    onClick: () => setIsVisible(false)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: 'Close',
    color: 'black'
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};
Ribbon.Title = Title$3;
Ribbon.Link = StyledLink;
//Storybooks naming fix
Ribbon.displayName = 'Alert';
Ribbon.Title.displayName = 'Alert.Title';

const Wrapper$4 = styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1okd96m-0"
})(["position:relative;display:inline-block;width:100%;box-sizing:border-box;border-width:1px;border-style:solid;border-radius:8px;", ";", ";", ""], ({
  isOpen,
  popperPosition
}) => isOpen && `border-${popperPosition}-left-radius: 0 !important`, ({
  isOpen,
  popperPosition
}) => isOpen && `border-${popperPosition}-right-radius: 0 !important`, ({
  disabled,
  error,
  theme,
  isOpen,
  isFocused
}) => {
  if (disabled) {
    return `
        border-color: ${theme.colors.input.disabled.borderColor};
    `;
  }
  if (error) {
    return `
        border-color: ${theme.colors.input.error.borderColor};
      `;
  }
  if (isFocused) {
    return `
        border-color: ${theme.colors.input.isFocused.borderColor};
    `;
  }
  return `
      border-color: ${isOpen ? theme.colors.input.isFocused.borderColor : theme.colors.input.borderColor};
    `;
});
const OptionsWrapper = styled.ul.withConfig({
  displayName: "styles__OptionsWrapper",
  componentId: "sc-1okd96m-1"
})(["margin:0;padding:0;"]);
const OptionsFixedWrapper = styled.ul.withConfig({
  displayName: "styles__OptionsFixedWrapper",
  componentId: "sc-1okd96m-2"
})(["margin:0;padding:0;border-bottom:", ";"], ({
  theme
}) => `1px solid ${theme.colors.select.section.borderColor}`);
const ListWrapper = styled.div.withConfig({
  displayName: "styles__ListWrapper",
  componentId: "sc-1okd96m-3"
})(["position:absolute;width:100%;border-width:1px;border-color:", ";border-style:solid;background-color:", ";", ";", ";overflow:hidden;overflow-y:auto;z-index:1000;max-height:40vh;"], ({
  theme
}) => theme.colors.select.list.borderColor, ({
  theme,
  readOnly
}) => readOnly ? theme.colors.select.list.readOnly.backgroundColor : theme.colors.select.list.backgroundColor, ({
  popperPosition
}) => `border-${popperPosition}-left-radius: 8px;`, ({
  popperPosition
}) => `border-${popperPosition}-right-radius: 8px;`);
const NoItemsWrapper = styled.div.withConfig({
  displayName: "styles__NoItemsWrapper",
  componentId: "sc-1okd96m-4"
})(["text-align:center;padding:7px;font-family:", ";font-style:normal;font-weight:normal;font-size:", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph);

const SelectContext = /*#__PURE__*/React.createContext(undefined);
function useSelectContext() {
  const context = React.useContext(SelectContext);
  if (context === undefined) {
    throw new Error('SelectContext must be used within a SelectContext.Provider');
  }
  return context;
}

const Title$4 = styled.span.withConfig({
  displayName: "styles__Title",
  componentId: "sc-15b5oyk-0"
})(["font-size:", ";line-height:", ";font-weight:", ";color:", ";"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  highlight,
  theme
}) => highlight && theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  highlight,
  theme
}) => highlight && theme.colors.select.option.color);
const Description = styled.span.withConfig({
  displayName: "styles__Description",
  componentId: "sc-15b5oyk-1"
})(["font-weight:", ";font-size:", ";line-height:", ";color:", ";white-space:pre-line;"], ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.colors.neutrals.darkGrey);
const Suffix = styled.span.withConfig({
  displayName: "styles__Suffix",
  componentId: "sc-15b5oyk-2"
})(["font-weight:", ";font-size:", ";line-height:", ";color:", ";margin-left:5px;"], ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.colors.select.option.hover.color);
const disabledOption = css$1(["color:", ";cursor:not-allowed;&:active{background-color:initial;color:", ";font-weight:initial;", "{color:", ";}}"], ({
  theme
}) => theme.colors.select.option.disabled.color, ({
  theme
}) => theme.colors.select.option.disabled.color, Description, ({
  theme
}) => theme.colors.select.option.disabled.color);
const activeOption = css$1(["&:active{background-color:", ";color:", ";font-weight:", ";", "{color:", ";}}"], ({
  theme
}) => theme.colors.select.option.active.backgroundColor, ({
  theme
}) => theme.colors.select.option.active.color, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, Description, ({
  theme
}) => theme.colors.select.option.hover.color);
const focusedOption = css$1(["background-color:", ";color:", ";cursor:pointer;font-weight:", ";", "{color:", ";}"], ({
  theme
}) => theme.colors.select.option.hover.backgroundColor, ({
  theme
}) => theme.colors.select.option.hover.color, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, Description, ({
  theme
}) => theme.colors.select.option.hover.color);
const OptionWrapper = styled.li.withConfig({
  displayName: "styles__OptionWrapper",
  componentId: "sc-15b5oyk-3"
})(["padding-top:4px;padding-bottom:4px;padding-left:", ";padding-right:", ";font-family:", ";", " ", " ", ""], ({
  theme,
  isIndent
}) => isIndent ? '30px' : theme.spacing(1), ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  isFocused,
  disabled
}) => isFocused && !disabled && focusedOption, activeOption, ({
  disabled
}) => disabled && disabledOption);
const StyledCheckbox = styled(Checkbox$2).withConfig({
  displayName: "styles__StyledCheckbox",
  componentId: "sc-15b5oyk-4"
})(["&.beauCheckbox{margin-top:4px;}"]);

const Option = ({
  value,
  title,
  group,
  fixed = false,
  description,
  suffix,
  'data-testid': dataTestId,
  disabled = false
}) => {
  const {
    isSectionSelectable,
    selectedObject,
    handleSelect,
    isMulti,
    focusedValue,
    setFocusedValue,
    dataTestId: selectDataTestId
  } = useSelectContext();
  const isSelected = !!selectedObject[value];
  const handleClick = () => !disabled && handleSelect({
    value,
    label: title,
    group,
    suffix,
    description
  });
  const handleMouseEnter = () => setFocusedValue({
    value,
    label: title
  });
  const getDataTestId = dataTestId ?? `${selectDataTestId}-option-${value}`;
  return /*#__PURE__*/React.createElement(OptionWrapper, {
    "data-testid": getDataTestId,
    onClick: handleClick,
    onMouseDown: e => {
      e.preventDefault();
      e.stopPropagation();
    },
    isFocused: focusedValue?.value === value,
    onMouseEnter: handleMouseEnter,
    disabled: disabled,
    isIndent: isSectionSelectable
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 1,
    verticalAlign: "flex-start"
  }, isMulti && /*#__PURE__*/React.createElement(StyledCheckbox, {
    name: "selected-checked",
    checked: isSelected,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    horizontalAlign: "space-between"
  }, /*#__PURE__*/React.createElement(Title$4, {
    highlight: fixed && !isMulti && !disabled
  }, title), suffix && /*#__PURE__*/React.createElement(Suffix, null, suffix)), description && /*#__PURE__*/React.createElement(Description, null, description))));
};

const Title$5 = styled.span.withConfig({
  displayName: "styles__Title",
  componentId: "uq3c9s-0"
})(["display:inline-block;color:", ";font-family:", ";font-style:normal;font-weight:bold;font-size:", ";text-transform:uppercase;"], ({
  theme
}) => theme.colors.select.section.title.color, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph);
const TitleWrapper$3 = styled(Flex).withConfig({
  displayName: "styles__TitleWrapper",
  componentId: "uq3c9s-1"
})(["padding:", ";"], ({
  theme
}) => `4px ${theme.spacing(1)}`);

const Section$1 = ({
  title,
  children,
  fixed = false,
  'data-testid': dataTestId = 'beau-select-section'
}) => {
  const {
    isSectionCollapsible,
    isSectionSelectable,
    selectedObject,
    handleSectionSelect
  } = useSelectContext();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isChecked, setIsChecked] = useState(false);
  const isChildrenVisible = !isSectionCollapsible || !isCollapsed;
  const handleCheckboxChange = () => {
    //Select options
    const options = Array.isArray(children) ? children.map(({
      props: {
        value,
        group,
        title,
        description,
        suffix
      }
    }) => ({
      value,
      group,
      label: title,
      description,
      suffix
    })).filter(({
      value
    }) => isChecked ? selectedObject[value] : !selectedObject[value]) : [];
    handleSectionSelect(options, !isChecked);
    //Change Checkbox state
    setIsChecked(!isChecked);
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TitleWrapper$3, {
    gap: 1
  }, isSectionSelectable && !fixed && /*#__PURE__*/React.createElement(Checkbox$2, {
    name: `select-section-check-${title}`,
    checked: isChecked,
    onChange: handleCheckboxChange
  }), isSectionCollapsible && /*#__PURE__*/React.createElement(Icon, {
    name: isCollapsed ? 'ArrowRight' : 'ArrowDown',
    "data-testid": isCollapsed ? 'beau-select-section-icon-arrow-right' : 'beau-select-section-icon-arrow-down',
    size: "small",
    onClick: () => setIsCollapsed(!isCollapsed)
  }), title && /*#__PURE__*/React.createElement(Title$5, null, title)), isChildrenVisible && children);
};
Section$1.Option = Option;
//Storybooks naming fix
Section$1.Option.displayName = 'Section.Option';

const InputWrapper$3 = styled(TextInput).withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-1l9kwby-0"
})(["border:none;&:hover{cursor:", ";}", ""], ({
  disabled,
  isOpen,
  readOnly
}) => disabled ? 'not-allowed' : isOpen && !readOnly ? 'cursor' : 'pointer', ({
  searchable,
  theme
}) => {
  if (!searchable) {
    return `
        background-color: ${theme.colors.input.backgroundColor};
        border-color: ${theme.colors.input.isFocused.borderColor};
    `;
  }
  return '';
});

const dotFlashing1 = keyframes(["0%,100%{opacity:1;}33%{opacity:0.4;}66%{opacity:0.2;}"]);
const dotFlashing2 = keyframes(["0%,100%{opacity:0.4;}33%{opacity:1;}66%{opacity:0.2;}"]);
const dotFlashing3 = keyframes(["0%,100%{opacity:0.2;}33%{opacity:0.4;}66%{opacity:1;}"]);
const SpinnerWrapper = styled.div.withConfig({
  displayName: "styles__SpinnerWrapper",
  componentId: "sc-1akwi38-0"
})(["display:flex;", ";", ";", ";div:first-child{animation:", " 1.3s infinite ease-in;}div:nth-child(2){animation:", " 1.3s infinite ease-in;}div:nth-child(3){animation:", " 1.3s infinite ease-in;}"], ({
  center
}) => center && 'justify-content: center', ({
  center
}) => center && 'align-items: stretch', ({
  center
}) => center && 'height: inherit', dotFlashing1, dotFlashing2, dotFlashing3);

const Spinner = function ({
  size = 'medium',
  className,
  center = false,
  'data-testid': dataTestId = 'beau-spinner'
}) {
  const color = theme.colors.spinner.color;
  return /*#__PURE__*/React.createElement(SpinnerWrapper, {
    className: className,
    center: center,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "StatusDot",
    color: color,
    size: size
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "StatusDot",
    color: color,
    size: size
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "StatusDot",
    color: color,
    size: size
  }));
};

const Input$2 = /*#__PURE__*/React.forwardRef(({
  className,
  value,
  popperPosition,
  name = 'selectInput',
  placeholder = 'Select',
  disabled = false,
  readOnly = false,
  searchable = true,
  clearable = false,
  error = false,
  onChange,
  onBlur,
  onFocus
}, forwardedRef) => {
  const {
    selected,
    handleSelect,
    handleClear,
    isMulti,
    isOpen,
    loading,
    setIsOpen,
    inputFocused
  } = useSelectContext();
  const fieldRef = useRef(null);
  //refreshMode: 'debounce' and refreshRate: 0 are here to fix the "ResizeObserver loop limit exceeded" issue while we waiting for React 18
  //https://github.com/maslianok/react-resize-detector/issues/45
  const {
    width,
    ref
  } = useResizeDetector({
    refreshMode: 'debounce',
    refreshRate: 0
  });
  const [pillsAreTooLarge, setPillsAreTooLarge] = useState(false);
  const [maxWidthPill, setMaxWidthPill] = useState(0);
  useEffect(() => {
    isOpen && setPillsAreTooLarge(false);
  }, [isOpen]);
  useLayoutEffect(() => {
    isOpen && !readOnly && !inputFocused && fieldRef?.current?.focus();
  }, [isOpen, inputFocused, readOnly]);
  useLayoutEffect(() => {
    if (!isOpen && isMulti && width && selected.length > 0) {
      // This takes the input width, takes a portion for pills space and splits that into each selected pill
      const currentMaxWidthPill = width * 0.6 / selected.length;
      setMaxWidthPill(currentMaxWidthPill);
      // Applies a min width to each pill, lower than this crops the pill ellipsis
      const arePillsTooLarge = currentMaxWidthPill < 50;
      setPillsAreTooLarge(arePillsTooLarge);
    }
  }, [isOpen, width, selected]);
  useImperativeHandle(forwardedRef, () => ({
    blur: () => {
      fieldRef?.current?.blur();
    }
  }));
  const getInputValue = () => {
    if (isOpen) {
      return value;
    }
    if (isMulti || typeof selected === 'undefined' || selected.length === 0) {
      return '';
    }
    return selected[0].label;
  };
  const handleChange = newValue => {
    if (!isOpen) {
      setIsOpen(true);
    }
    onChange && onChange(newValue);
  };
  const getPlaceholder = () => {
    if (readOnly || disabled || !searchable) {
      return isMulti || selected.length === 0 ? placeholder : selected[0].label;
    }
    return inputFocused ? 'Search' : placeholder;
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(InputWrapper$3, {
    className: className,
    isOpen: isOpen,
    name: name,
    popperPosition: popperPosition,
    placeholder: getPlaceholder(),
    value: getInputValue(),
    autoComplete: "off",
    disabled: disabled,
    readOnly: readOnly,
    searchable: searchable,
    error: error,
    onChange: newValue => handleChange(newValue),
    onClick: () => {
      if (!isOpen && !disabled) {
        setIsOpen(true);
      }
      if (isOpen && readOnly) {
        setIsOpen(false);
      }
    },
    onFocus: e => !inputFocused && !disabled && !readOnly && onFocus(e),
    onBlur: e => inputFocused && !disabled && !readOnly && onBlur(e),
    "data-lpignore": "true"
  }, isMulti && selected.length > 0 && (!isOpen || isOpen && readOnly) ? /*#__PURE__*/React.createElement(InputWrapper$3.Item, {
    style: {
      whiteSpace: 'nowrap'
    }
  }, !pillsAreTooLarge ? selected.map(({
    value,
    label
  }) => /*#__PURE__*/React.createElement("div", {
    key: value,
    style: {
      maxWidth: maxWidthPill && `${maxWidthPill}px`
    }
  }, /*#__PURE__*/React.createElement(Pill, {
    value: label,
    variant: "outlined",
    disabled: disabled,
    readOnly: readOnly,
    onRemove: e => {
      e.stopPropagation();
      handleSelect({
        value,
        label
      });
    }
  }))) : /*#__PURE__*/React.createElement(Pill, {
    value: `${selected.length} selected`,
    variant: "outlined",
    disabled: disabled,
    readOnly: readOnly,
    onRemove: e => {
      e.stopPropagation();
      handleClear();
    }
  })) : null, /*#__PURE__*/React.createElement(InputWrapper$3.Field, {
    ref: fieldRef,
    style: {
      cursor: 'inherit'
    }
  }), loading && isOpen && /*#__PURE__*/React.createElement(InputWrapper$3.Item, null, /*#__PURE__*/React.createElement(Spinner, {
    size: "tiny"
  })), clearable && selected.length > 0 && /*#__PURE__*/React.createElement(InputWrapper$3.Icon, {
    name: 'Close',
    onClick: e => {
      e.stopPropagation();
      handleClear();
    },
    size: "small",
    primary: true
  }), /*#__PURE__*/React.createElement(InputWrapper$3.Icon, {
    name: isOpen ? 'ArrowUp' : 'ArrowDown',
    disabled: disabled,
    onClick: e => {
      e.stopPropagation();
      setIsOpen(prev => {
        if (prev) {
          fieldRef?.current?.blur();
        }
        return !prev;
      });
    },
    size: "small"
  })));
});
Input$2.displayName = 'Input';

function mergeRefs$1(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function isMulti(props) {
  return !!props.multi;
}
/**
 * Helpers function
 */
const isSearchValid = (search, title, description) => title.toLowerCase().includes(search.toLowerCase()) || description?.toLowerCase().includes(search.toLowerCase());
const selectedToArray = (selected, multi) => {
  if (!selected) {
    return [];
  }
  return multi ? selected : [selected];
};
const cleanOptions = ({
  childrenArray,
  optionsFixed,
  search,
  async
}) => {
  const isOptionValid = option => {
    if (optionsFixed.some(opt => opt.label === option.props.title)) {
      return false;
    }
    if (!async && search !== '') {
      return isSearchValid(search, option.props.title, option.props.description);
    }
    return true;
  };
  return childrenArray.reduce((acc, child) => {
    if (child.type === Section$1) {
      // If Child is a Select.Section Component, extract the Select.Options...
      const options = cleanOptions({
        childrenArray: Array.isArray(child.props.children) ? child.props.children : [child.props.children],
        optionsFixed,
        search,
        async
      });
      return options.length > 0 ? [...acc, /*#__PURE__*/React.cloneElement(child, {
        children: options
      })] : acc;
    } else {
      // If Child is a Select.Option Component and that one is valid
      return isOptionValid(child) ? [...acc, child] : acc;
    }
  }, []);
};
const getOptionsOnly = cleanChildren => cleanChildren.reduce((acc, child) => {
  if (child.type === Section$1) {
    const options = getOptionsOnly(child.props.children);
    return [...acc, ...options];
  } else {
    const {
      value,
      title,
      description,
      disabled
    } = child.props;
    return [...acc, {
      value,
      label: title,
      description,
      disabled
    }];
  }
}, []);
/**
 * Component
 */
//Use native React defaultProps feature in order not to destructuring props within SelectComponent and use the Typescript TypeGuard feature
const defaultProps$1 = {
  multi: false,
  disabled: false,
  loading: false,
  clearable: false,
  async: false,
  error: false,
  searchable: true,
  isSectionCollapsible: false,
  isSectionSelectable: false
};
const SelectComponent = props => {
  const {
    children,
    selected: _selected,
    disabled,
    readOnly,
    searchable,
    loading,
    error,
    name,
    className,
    placeholder,
    isSectionCollapsible,
    async,
    onSearch,
    onBlur,
    onFocus,
    'data-testid': dataTestId = 'beau-select'
  } = props;
  /*
   * States
   */
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);
  const [popperElement, setPopperElement] = useState(null);
  const [optionsFixed, setOptionsFixed] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [focusedValue, setFocusedValue] = useState();
  const [inputFocused, setInputFocused] = useState(false);
  const {
    styles,
    attributes,
    update
  } = usePopper(wrapperRef.current, popperElement, {
    placement: 'bottom',
    modifiers: [{
      name: 'flip',
      options: {
        fallbackPlacements: ['top']
      }
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, -1]
      }
    }]
  });
  //refreshMode: 'debounce' and refreshRate: 0 are here to fix the "ResizeObserver loop limit exceeded" issue while we waiting for React 18
  //https://github.com/maslianok/react-resize-detector/issues/45
  const {
    ref: refResize,
    height
  } = useResizeDetector({
    handleWidth: false,
    refreshMode: 'debounce',
    refreshRate: 0
  });
  useLayoutEffect(() => {
    //Update the poper position when the Select's content change (Useful for async Select)
    if (isOpen) {
      update?.();
    }
  }, [height, update, isOpen]);
  /*
   * Getters
   */
  const childrenArray = useMemo(() => React.Children.toArray(children), [children]);
  const selected = useMemo(() => selectedToArray(_selected, isMulti(props)), [_selected, isMulti(props)]);
  const selectedObject = lodash.chain(selected).keyBy(({
    value
  }) => value).value();
  const optionsFixedFiltered = useMemo(() => search.length > 0 ? optionsFixed.filter(opt => isSearchValid(search, opt.label)) : optionsFixed, [optionsFixed, search]);
  const cleanChildren = useMemo(() => cleanOptions({
    childrenArray,
    optionsFixed,
    search,
    async
  }), [childrenArray, optionsFixed, search]);
  const optionsValues = useMemo(() => [...optionsFixedFiltered, ...getOptionsOnly(cleanChildren)], [cleanChildren, optionsFixedFiltered]);
  useEffect(() => {
    const activeOptions = optionsValues.filter(value => !value.disabled);
    setFocusedValue(activeOptions?.[0]);
  }, [cleanChildren]);
  /*
   * Handlers
   */
  useEffect(() => {
    setOptionsFixed(selected.map(item => readOnly ? _objectSpread$g(_objectSpread$g({}, item), {}, {
      disabled: true
    }) : item));
    if (!isOpen && search.length > 0) {
      handleInputChange('');
    }
  }, [isOpen]);
  const handleSelect = option => {
    if (!option.disabled) {
      const isSelected = selectedObject[option.value];
      props.onSelect && props.onSelect(option, !isSelected);
      if (!isMulti(props)) {
        setIsOpen(false);
        inputRef?.current?.blur();
      }
    }
  };
  const handleSectionSelect = (options, newState) => {
    const enabledOptions = options.filter(({
      disabled
    }) => !disabled);
    props.onSectionSelect && props.onSectionSelect(enabledOptions, newState);
  };
  const handleClear = () => {
    props.onClear && props.onClear();
  };
  const handleInputChange = newValue => {
    setSearch(newValue);
    onSearch && onSearch(newValue);
  };
  /**
   * KeyboardEvent
   **/
  const changeOptionFocus = direction => {
    let newIndex = -1;
    const activeOptions = optionsValues.filter(value => !value.disabled);
    const focusedIndex = focusedValue ? activeOptions.findIndex(({
      value
    }) => value === focusedValue.value) : -1;
    const lastIndex = activeOptions.length - 1;
    switch (direction) {
      case 'previous':
        if (focusedIndex > 0) {
          newIndex = focusedIndex - 1;
        } else {
          // if nothing is focused, focus the last value first
          newIndex = lastIndex;
        }
        break;
      case 'next':
        if (focusedIndex < lastIndex) {
          newIndex = focusedIndex + 1;
        } else {
          // if nothing is focused, focus the first value first
          newIndex = 0;
        }
        break;
    }
    setFocusedValue(activeOptions[newIndex]);
  };
  const onKeyDown = event => {
    switch (event.key) {
      case 'ArrowUp':
        changeOptionFocus('previous');
        break;
      case 'ArrowDown':
        changeOptionFocus('next');
        break;
      case 'Enter':
        focusedValue && handleSelect(focusedValue);
        break;
      case 'Escape':
      case 'Tab':
        setIsOpen(false);
        inputRef?.current?.blur();
    }
  };
  const hasSelected = optionsFixedFiltered?.length > 0;
  const popperPosition = attributes?.popper?.['data-popper-placement'] ?? 'bottom';
  const handleClickAway = () => {
    if (isOpen) {
      setIsOpen(false);
      inputRef?.current?.blur();
    }
  };
  const handleBlur = e => {
    setInputFocused(false);
    onBlur && onBlur(e);
  };
  const handleFocus = e => {
    setInputFocused(true);
    onFocus && onFocus(e);
  };
  /**
   * JSX
   **/
  return /*#__PURE__*/React.createElement(SelectContext.Provider, {
    value: {
      dataTestId,
      selected,
      selectedObject,
      isMulti: isMulti(props),
      loading: loading,
      isOpen,
      isSectionCollapsible,
      isSectionSelectable: isMulti(props) && props.isSectionSelectable,
      focusedValue,
      setFocusedValue,
      setIsOpen,
      handleClear,
      handleSelect,
      handleSectionSelect,
      inputFocused
    }
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClickAway
  }, /*#__PURE__*/React.createElement(Wrapper$4, {
    className: className,
    ref: mergeRefs$1([wrapperRef, refResize]),
    "data-testid": dataTestId,
    onKeyDown: onKeyDown,
    popperPosition: popperPosition,
    isOpen: isOpen,
    disabled: disabled,
    error: error,
    isFocused: inputFocused
  }, /*#__PURE__*/React.createElement(Input$2, {
    ref: inputRef,
    value: search,
    placeholder: placeholder,
    disabled: disabled,
    readOnly: readOnly || !searchable,
    searchable: searchable,
    popperPosition: popperPosition,
    clearable: isMulti(props) ? false : props.clearable,
    name: name,
    error: error,
    onChange: handleInputChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }), isOpen && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(ListWrapper, _objectSpread$g({
    "data-testid": 'list-wrapper',
    ref: setPopperElement,
    hasSelected: hasSelected,
    popperPosition: popperPosition,
    readOnly: readOnly,
    onMouseLeave: () => setFocusedValue(undefined),
    style: _objectSpread$g(_objectSpread$g({}, styles.popper), {}, {
      maxWidth: wrapperRef?.current?.scrollWidth
    })
  }, attributes.popper), hasSelected ? /*#__PURE__*/React.createElement(SelectedOptions, {
    options: optionsFixedFiltered
  }) : null, !readOnly ? /*#__PURE__*/React.createElement(OptionsWrapper, null, React.Children.count(cleanChildren) === 0 || loading ? /*#__PURE__*/React.createElement(NoItemsWrapper, null, loading ? 'Loading...' : 'No items found') : cleanChildren) : null), document.body))));
};
function SelectedOptions({
  options
}) {
  return /*#__PURE__*/React.createElement(OptionsFixedWrapper, null, lodash.chain(options).groupBy('group').map((options, group) => /*#__PURE__*/React.createElement(ConditionalWrapper, {
    key: group,
    condition: group !== 'undefined',
    wrapper: children => /*#__PURE__*/React.createElement(Section$1, {
      title: group,
      key: group,
      fixed: true
    }, children)
  }, options.map(option => /*#__PURE__*/React.createElement(Option, {
    key: option.value,
    value: option.value,
    group: option.group,
    title: option.label,
    suffix: option.suffix,
    description: option.description,
    disabled: option.disabled,
    fixed: true
  })))).value());
}
SelectComponent.defaultProps = defaultProps$1;
const Select = SelectComponent;
Select.Option = Option;
Select.Section = Section$1;
//Storybooks naming fix
Select.displayName = 'Select';
Select.Option.displayName = 'Select.Option';
Select.Section.displayName = 'Select.Section';

const TabWrapper = styled.button.withConfig({
  displayName: "styles__TabWrapper",
  componentId: "lg7490-0"
})(({
  selected,
  theme
}) => `
  position: relative;
  box-sizing: border-box;
  height: 100%;
  padding: 0px 30px;
  outline: none;
  font-size: ${theme.fonts.fontSize.paragraph};
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-weight: ${theme.fonts.samsungOne.fontWeight.bold.fontWeight};
  line-height: ${theme.fonts.lineHeight.paragraph};
  cursor: default;
  display: flex;
  align-items: center;
  color: ${theme.colors.tabs.color};
  background-color: ${theme.colors.tabs.backgroundColor};
  border: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  :disabled {
    color: ${theme.colors.tabs.disabled.color};
    pointer-events: none;
  }

  ${selected ? `
    color: ${theme.colors.tabs.selected.color};
  ` : `
    :hover {
      color: ${theme.colors.tabs.hover.color};
      background-color: ${theme.colors.tabs.hover.backgroundColor};
      cursor: pointer;
    }

    :active {
      color: ${theme.colors.tabs.active.color};
      background-color: ${theme.colors.tabs.active.backgroundColor};
    }
  `}
`);
const Indicator$1 = styled.span.withConfig({
  displayName: "styles__Indicator",
  componentId: "lg7490-1"
})(["width:100%;bottom:-1px;left:0;height:2px;position:absolute;background-color:", ";"], ({
  theme
}) => theme.colors.tabs.selected.borderColor);
const BaseIcon = styled(Icon).withConfig({
  displayName: "styles__BaseIcon",
  componentId: "lg7490-2"
})(["margin-right:8px;"]);

const TabsContext = /*#__PURE__*/React.createContext(undefined);
function useTabsContext() {
  const context = React.useContext(TabsContext);
  if (context === undefined) {
    throw new Error('TabsContext must be used within a TabsContext.Provider');
  }
  return context;
}

const NoAnchor = css$1(["transform:none;align-self:center;position:unset;margin-left:", ";"], ({
  theme
}) => theme.spacing(1));
const BadgeWrapper = styled(Badge$1).withConfig({
  displayName: "styles__BadgeWrapper",
  componentId: "dao655-0"
})([".beauBadge{color:", ";background-color:", ";box-shadow:", ";font-family:", ";font-size:", ";font-weight:", ";height:16px;min-width:16px;padding:0 5px;", ";&.beauBadgeDot{padding:0;height:4px;width:4px;min-width:4px;border-radius:100%;transform:none;align-self:flex-start;position:unset;margin-left:2px;}&.beauBadgeInvisible{display:none;}}"], ({
  theme
}) => theme.colors.badge.color, ({
  theme
}) => theme.colors.badge.backgroundColor.danger, ({
  $outlined,
  theme
}) => $outlined ? `inset 0px 0px 0px 1px ${theme.colors.badge.borderColor}` : 'none', ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.tiny, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  $anchor
}) => !$anchor && NoAnchor);

const Badge$2 = function ({
  children,
  max = 999,
  label,
  outlined = false,
  invisible,
  dot = false,
  anchor = true,
  'data-testid': dataTestId = 'beau-badge'
}) {
  const badgeContent = label && label >= 0 ? /*#__PURE__*/React.createElement("span", {
    "data-testid": dataTestId
  }, label > max ? /*#__PURE__*/React.createElement(Icon, {
    name: "Actions",
    size: "tiny",
    "data-testid": "beau-badge-icon"
  }) : label) : undefined;
  return /*#__PURE__*/React.createElement(BadgeWrapper, {
    max: max,
    "$anchor": anchor,
    "$outlined": outlined,
    invisible: invisible,
    badgeContent: badgeContent,
    variant: dot ? 'dot' : 'standard',
    classes: {
      badge: 'beauBadge',
      dot: 'beauBadgeDot',
      invisible: 'beauBadgeInvisible'
    }
  }, children);
};

const Tab = function ({
  className,
  value,
  children,
  icon,
  errors,
  maxErrors = 99,
  disabled = false,
  'data-testid': dataTestId = 'beau-tabs-tab'
}) {
  const {
    selected,
    onChange
  } = useTabsContext();
  const isSelected = selected === value;
  const handleClick = () => {
    !disabled && onChange?.(value);
  };
  return /*#__PURE__*/React.createElement(TabWrapper, {
    className: className,
    disabled: disabled,
    selected: isSelected,
    onClick: handleClick,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Badge$2, {
    label: errors,
    max: maxErrors,
    anchor: false,
    "data-testid": "beau-tab-error"
  }, !!icon && /*#__PURE__*/React.createElement(BaseIcon, {
    name: icon
  }), children), isSelected && /*#__PURE__*/React.createElement(Indicator$1, null));
};
Tab.displayName = 'Tab';

const TabsWrapper = styled.div.withConfig({
  displayName: "styles__TabsWrapper",
  componentId: "sc-1b6n53d-0"
})(["display:flex;height:42px;background-color:", ";border-top-left-radius:8px;border-top-right-radius:8px;border-bottom:1px solid ", ";"], ({
  variant,
  theme
}) => variant !== 'transparent' && theme.colors.tabs.backgroundColor, ({
  theme
}) => theme.colors.tabs.borderColor);

const Tabs = function ({
  children,
  selected,
  variant = 'default',
  onChange,
  className,
  'data-testid': dataTestId = 'beau-tabs'
}) {
  return /*#__PURE__*/React.createElement(TabsWrapper, {
    variant: variant,
    className: className,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: {
      selected,
      onChange
    }
  }, children));
};
Tabs.Tab = Tab;
//Storybooks naming fix
Tabs.displayName = 'Tabs';
Tabs.Tab.displayName = 'Tabs.Tab';

const TextAreaWrapper = styled(TextareaAutosize).withConfig({
  displayName: "styles__TextAreaWrapper",
  componentId: "sc-1umcdcv-0"
})(["display:block;padding:4px 6px;position:relative;resize:vertical;width:100%;min-height:32px;font-family:", ";font-size:", ";line-height:", ";font-weight:", ";color:", ";box-sizing:border-box;border-width:1px;border-style:solid;border-radius:8px;border-color:", ";background-color:", ";outline:none;outline-width:0px;&:disabled{outline-style:none;cursor:not-allowed;color:", ";background-color:", ";border-color:", ";}&:read-only{outline-style:none;background-color:", ";border-color:", ";}:not(:read-only)&:focus{background-color:", ";border-color:", ";outline-style:none;}"], ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight, ({
  theme
}) => theme.colors.input.color, ({
  theme,
  $error
}) => $error ? theme.colors.input.error.borderColor : theme.colors.input.borderColor, ({
  theme
}) => theme.colors.input.backgroundColor, ({
  theme
}) => theme.colors.input.disabled.color, ({
  theme
}) => theme.colors.input.disabled.backgroundColor, ({
  theme
}) => theme.colors.input.disabled.borderColor, ({
  theme
}) => theme.colors.input.readOnly.backgroundColor, ({
  theme
}) => theme.colors.input.readOnly.borderColor, ({
  theme
}) => theme.colors.input.backgroundColor, ({
  theme
}) => theme.colors.input.isFocused.borderColor);

const TextArea = function ({
  value,
  name,
  rowsMax,
  rowsMin,
  cols,
  autoFocus,
  required,
  autoComplete,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  onClick,
  error = false,
  readOnly = false,
  disabled = false,
  'data-testid': dataTestId = 'beau-textarea'
}) {
  const handleChange = e => {
    const value = e.target.value;
    onChange?.(value);
  };
  return /*#__PURE__*/React.createElement(TextAreaWrapper, {
    "$error": error,
    readOnly: readOnly,
    disabled: disabled,
    "data-testid": dataTestId,
    value: value,
    name: name,
    id: name,
    rowsMax: rowsMax,
    rowsMin: rowsMin,
    cols: cols,
    autoFocus: autoFocus,
    required: required,
    autoComplete: autoComplete,
    placeholder: placeholder,
    onChange: handleChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: onClick
  });
};

const ButtonWrapper$1 = styled.button.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "vhrlgf-0"
})(({
  selected,
  theme
}) => `
  padding: 4px 16px;
  outline: none;
  background-color: ${theme.colors.toggle.backgroundColor};
  border: 1px solid ${theme.colors.toggle.borderColor};
  color: ${theme.colors.toggle.color};
  line-height: ${theme.fonts.lineHeight.paragraph};
  font-size: ${theme.fonts.fontSize.paragraph};
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-weight: ${theme.fonts.samsungOne.fontWeight.normal.fontWeight};

  ${selected ? `
    font-weight: ${theme.fonts.samsungOne.fontWeight.bold.fontWeight};
    background-color: ${theme.colors.toggle.selected.backgroundColor};
    color: ${theme.colors.toggle.selected.color};
    border-color: ${theme.colors.toggle.selected.borderColor};
  ` : `
    :hover {
      background-color: ${theme.colors.toggle.hover.backgroundColor};
      color: ${theme.colors.toggle.hover.color};
      cursor: pointer;
    }

    :active {
      background-color: ${theme.colors.toggle.active.backgroundColor};
      color: ${theme.colors.toggle.active.color};
    }

    :disabled {
      background-color: ${theme.colors.toggle.disabled.backgroundColor};
      color: ${theme.colors.toggle.disabled.color};
      cursor: auto;
    }
  `}
`);

const ToggleContext = /*#__PURE__*/React.createContext(undefined);
function useToggleContext() {
  const context = React.useContext(ToggleContext);
  if (context === undefined) {
    throw new Error('ToggleContext must be used within a ToggleContext.Provider');
  }
  return context;
}

const Button$1 = function ({
  value,
  children,
  disabled = false,
  'data-testid': dataTestId = 'beau-toggle-button'
}) {
  const {
    selected,
    disabled: contextDisabled,
    onChange
  } = useToggleContext();
  const isSelected = selected === value;
  return /*#__PURE__*/React.createElement(ButtonWrapper$1, {
    selected: isSelected,
    "data-isselected": isSelected,
    disabled: contextDisabled || disabled,
    onClick: () => onChange?.(value),
    "data-testid": dataTestId
  }, children);
};

const ToggleWrapper = styled.div.withConfig({
  displayName: "styles__ToggleWrapper",
  componentId: "nn6ckk-0"
})(["height:32px;> *{height:100%;}> *:not(:first-child){border-left:0px;}> *:first-child{border-top-left-radius:8px;border-bottom-left-radius:8px;}> *:last-child{border-top-right-radius:8px;border-bottom-right-radius:8px;}"]);

const Toggle = function (_ref) {
  let {
      children,
      selectOnDisable,
      className,
      'data-testid': dataTestId = 'beau-toggle'
    } = _ref,
    value = _objectWithoutProperties(_ref, ["children", "selectOnDisable", "className", "data-testid"]);
  useEffect(() => {
    // When disabling all toggle buttons at once, switch to the default value, if it is set.
    value.disabled && selectOnDisable && value.onChange?.(selectOnDisable);
  }, [value.disabled]);
  return /*#__PURE__*/React.createElement(ToggleContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(ToggleWrapper, {
    className: className,
    "data-testid": dataTestId
  }, children));
};
Toggle.Button = Button$1;
//Storybooks naming fix
Toggle.displayName = 'Toggle';
Toggle.Button.displayName = 'Toggle.Button';

const AlertWrapper = styled.aside.withConfig({
  displayName: "styles__AlertWrapper",
  componentId: "sc-8dt0v0-0"
})(["background-color:", ";padding:", ";border-radius:8px;border:1px solid ", ";display:flex;width:544px;opacity:0;transform:scale(0.9) translateY(50%);transition:all 300ms ease-out;", ""], ({
  theme,
  severity
}) => theme.colors.alerts.backgroundColor[severity], ({
  theme
}) => `${theme.spacing(2)}`, ({
  theme,
  severity
}) => theme.colors.alerts.color[severity], ({
  alertState
}) => {
  switch (alertState) {
    case 'active':
      return `
          opacity: 1;
          transform: translateY(0%) scale(1);
        `;
    case 'closing':
      return `
          opacity: 0;
          transform: translateY(50%);
        `;
    default:
      return `
          opacity: 0;
          transform: scale(0.9) translateY(50%);
        `;
  }
});
const LabelWrapper = styled.div.withConfig({
  displayName: "styles__LabelWrapper",
  componentId: "sc-8dt0v0-1"
})(["flex-grow:1;padding:", ";color:", ";font-family:", ";font-size:", ";line-height:", ";"], ({
  theme
}) => `0 ${theme.spacing(2)}`, ({
  theme
}) => theme.colors.alerts.textColor, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph);
const RoundedIcon = styled(Icon).withConfig({
  displayName: "styles__RoundedIcon",
  componentId: "sc-8dt0v0-2"
})(["align-self:flex-start;"]);
const CloseIcon = styled(Icon).withConfig({
  displayName: "styles__CloseIcon",
  componentId: "sc-8dt0v0-3"
})(["align-self:flex-start;position:relative;top:4px;"]);
const Title$6 = styled.div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-8dt0v0-4"
})(["font-weight:", ";"], ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const StyledLink$1 = styled(Link$1).withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-8dt0v0-5"
})(["display:block;"]);

const Alert$1 = function ({
  severity = 'info',
  isDismissable = true,
  timeout = 3000,
  onRemove,
  children,
  'data-testid': dataTestId = 'beau-alert'
}) {
  // Guarantees the Alert will not get stuck active if timeout and isDismissable are falsy.
  timeout = !timeout && !isDismissable ? 3000 : timeout;
  const [alertState, setAlertState] = useState('inactive');
  let timeoutHandlerId;
  const iconName = getIconName(severity);
  useEffect(() => {
    setAlertState('active');
    if (timeout) {
      timeoutHandlerId = window.setTimeout(() => removeAlert(), timeout);
    }
  }, []);
  const removeAlert = () => {
    setAlertState('closing');
    timeoutHandlerId && window.clearTimeout(timeoutHandlerId);
    window.setTimeout(() => {
      setAlertState('inactive');
      onRemove(); // Call onRemove on the parent only after animation is finished.
    }, 300);
  };
  return /*#__PURE__*/React.createElement(AlertWrapper, {
    severity: severity,
    alertState: alertState,
    "data-testid": dataTestId,
    role: 'alert'
  }, /*#__PURE__*/React.createElement(RoundedIcon, {
    className: iconName,
    name: iconName,
    size: "large",
    color: theme.colors.alerts.color[severity]
  }), /*#__PURE__*/React.createElement(LabelWrapper, null, children), isDismissable && /*#__PURE__*/React.createElement(CloseIcon, {
    className: 'Close',
    name: 'Close',
    onClick: removeAlert,
    color: 'black',
    size: "medium"
  }));
};
Alert$1.Title = Title$6;
Alert$1.Link = StyledLink$1;
//Storybooks naming fix
Alert$1.displayName = 'Alert';
Alert$1.Title.displayName = 'Alert.Title';

const AccordionWrapper = styled(Accordion$1).withConfig({
  displayName: "styles__AccordionWrapper",
  componentId: "sc-1rlqlih-0"
})(["&.beauAccordion{width:100%;border-radius:8px;padding:", ";border:", ";&.beauAccordionExpanded{margin:0;}&.beauAccordionFocused{border-color:", ";}&:before{display:none;}}"], ({
  theme
}) => theme.spacing(2), ({
  theme
}) => `1px solid ${theme.colors.accordion.borderColor}`, ({
  theme
}) => theme.colors.accordion.borderColorFocused);
const AccordionTitle = styled(AccordionSummary$1).withConfig({
  displayName: "styles__AccordionTitle",
  componentId: "sc-1rlqlih-1"
})(["&.beauAccordionTitleWrapper{padding:0;min-height:unset;&.beauAccordionTitleExpanded{min-height:unset;}&.beauAccordionTitleFocused{background-color:unset;}}.beauAccordionTitle{margin:0;display:initial;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";&.beauAccordionTitleExpanded{margin:0;}}.beauAccordionButton{padding:", ";}"], ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight, ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.lineHeight.heading4, ({
  theme
}) => theme.spacing(1));
const AccordionContents = styled(AccordionDetails$1).withConfig({
  displayName: "styles__AccordionContents",
  componentId: "sc-1rlqlih-2"
})(["&.beauAccordionContents{flex-direction:column;padding:", ";}"], ({
  theme
}) => `0 0 ${theme.spacing(2)}`);
const AccordionDivider = styled(MUIDivider).withConfig({
  displayName: "styles__AccordionDivider",
  componentId: "sc-1rlqlih-3"
})(["&.beauAccordionDivider{margin:", ";background-color:", ";}"], ({
  theme
}) => `${theme.spacing(1)} 0 ${theme.spacing(3)}`, ({
  theme
}) => theme.colors.accordion.borderColor);

const Accordion$2 = /*#__PURE__*/React.forwardRef(({
  id,
  title,
  children,
  defaultCollapsed = false,
  expanded,
  onChange,
  'data-testid': dataTestId = 'beau-accordion',
  className
}, forwaredRef) => {
  const [isFocused, setIsFocused] = useState(false);
  return /*#__PURE__*/React.createElement(AccordionWrapper, {
    ref: forwaredRef,
    id: id,
    expanded: expanded,
    onChange: onChange,
    square: true,
    elevation: 0,
    defaultExpanded: !defaultCollapsed,
    "data-testid": dataTestId,
    classes: {
      root: isFocused ? 'beauAccordion beauAccordionFocused' : 'beauAccordion',
      expanded: 'beauAccordionExpanded'
    },
    className: className
  }, /*#__PURE__*/React.createElement(AccordionTitle, {
    id: `${id}-title`,
    "aria-controls": `${id}-content`,
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    IconButtonProps: {
      disableRipple: true,
      edge: false
    },
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      name: "ArrowDown",
      "data-testid": "beau-accordionIcon"
    }),
    classes: {
      root: 'beauAccordionTitleWrapper',
      content: 'beauAccordionTitle',
      expanded: 'beauAccordionTitleExpanded',
      focused: 'beauAccordionTitleFocused',
      expandIcon: 'beauAccordionButton'
    }
  }, title), /*#__PURE__*/React.createElement(AccordionContents, {
    className: "beauAccordionContents"
  }, /*#__PURE__*/React.createElement(AccordionDivider, {
    className: "beauAccordionDivider",
    "data-testid": "beau-accordionDivider"
  }), children));
});
Accordion$2.displayName = 'Accordion';

/**
 * Create the React Context
 */

var DndContext = createContext({
  dragDropManager: undefined
});

var HandlerRole;

(function (HandlerRole) {
  HandlerRole["SOURCE"] = "SOURCE";
  HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */
function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame

    throw error;
  }
}

var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';

function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

// cheap lodash replacements

/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */
function get$1(obj, path, defaultValue) {
  return path.split('.').reduce(function (a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
/**
 * drop-in replacement for _.without
 */

function without(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
/**
 * drop-in replacement for _.isString
 * @param input
 */

function isObject$1(input) {
  return _typeof$2(input) === 'object';
}
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */

function xor(itemsA, itemsB) {
  var map = new Map();

  var insertItem = function insertItem(item) {
    map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map.forEach(function (count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */

function intersection(itemsA, itemsB) {
  return itemsA.filter(function (t) {
    return itemsB.indexOf(t) > -1;
  });
}

var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource,
        publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc,
        clientOffset = options.clientOffset,
        getSourceClientOffset = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry(); // Initialize the coordinates using the client offset

    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants(sourceIds, monitor, registry); // Get the draggable source

    var sourceId = getDraggableSource(sourceIds, monitor);

    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    } // Get the source client offset


    var sourceClientOffset = null;

    if (clientOffset) {
      if (!getSourceClientOffset) {
        throw new Error('getSourceClientOffset must be defined');
      }

      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
      sourceClientOffset = getSourceClientOffset(sourceId);
    } // Initialize the full coordinates


    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId); // If source.beginDrag returns null, this is an indicator to cancel the drag

    if (item == null) {
      return undefined;
    }

    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType: itemType,
        item: item,
        sourceId: sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}

function verifyInvariants(sourceIds, monitor, registry) {
  invariant(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
  sourceIds.forEach(function (sourceId) {
    invariant(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
  });
}

function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
  invariant(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}

function verifyItemIsObject(item) {
  invariant(isObject$1(item), 'Item must be an object.');
}

function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;

  for (var i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }

  return sourceId;
}

function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();

    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}

function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        clientOffset = _ref.clientOffset;

    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds: targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}

function verifyTargetIdsIsArray(targetIdsArg) {
  invariant(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}

function checkInvariants(targetIds, monitor, registry) {
  invariant(monitor.isDragging(), 'Cannot call hover while not dragging.');
  invariant(!monitor.didDrop(), 'Cannot call hover after drop.');

  for (var i = 0; i < targetIds.length; i++) {
    var targetId = targetIds[i];
    invariant(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
    var target = registry.getTarget(targetId);
    invariant(target, 'Expected targetIds to be registered.');
  }
}

function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  // Remove those targetIds that don't match the targetType.  This
  // fixes shallow isOver which would only be non-shallow because of
  // non-matching targets.
  for (var i = targetIds.length - 1; i >= 0; i--) {
    var targetId = targetIds[i];
    var targetType = registry.getTargetType(targetId);

    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}

function hoverAllTargets(targetIds, monitor, registry) {
  // Finally call hover on all matching targets.
  targetIds.forEach(function (targetId) {
    var target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyInvariants$1(monitor);
    var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action

    targetIds.forEach(function (targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$h(_objectSpread$h({}, options), dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}

function verifyInvariants$1(monitor) {
  invariant(monitor.isDragging(), 'Cannot call drop while not dragging.');
  invariant(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}

function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : undefined;
  verifyDropResultType(dropResult);

  if (typeof dropResult === 'undefined') {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }

  return dropResult;
}

function verifyDropResultType(dropResult) {
  invariant(typeof dropResult === 'undefined' || isObject$1(dropResult), 'Drop result must either be an object or undefined.');
}

function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}

function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();

    if (sourceId != null) {
      var source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
    }

    return {
      type: END_DRAG
    };
  };
}

function verifyIsDragging(monitor) {
  invariant(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }
var DragDropManagerImpl = /*#__PURE__*/function () {
  function DragDropManagerImpl(store, monitor) {
    var _this = this;

    _classCallCheck(this, DragDropManagerImpl);

    this.isSetUp = false;

    this.handleRefCountChange = function () {
      var shouldSetUp = _this.store.getState().refCount > 0;

      if (_this.backend) {
        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();

          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();

          _this.isSetUp = false;
        }
      }
    };

    this.store = store;
    this.monitor = monitor;
    store.subscribe(this.handleRefCountChange);
  }

  _createClass$1(DragDropManagerImpl, [{
    key: "receiveBackend",
    value: function receiveBackend(backend) {
      this.backend = backend;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      /* eslint-disable-next-line @typescript-eslint/no-this-alias */
      var manager = this;
      var dispatch = this.store.dispatch;

      function bindActionCreator(actionCreator) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          var action = actionCreator.apply(manager, args);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      var actions = createDragDropActions(this);
      return Object.keys(actions).reduce(function (boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);

  return DragDropManagerImpl;
}();

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$2(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$2(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

var strictEquality = function strictEquality(a, b) {
  return a === b;
};
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */

function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */

function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;

  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }

  return true;
}

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$i(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };

    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }

      return _objectSpread$i(_objectSpread$i({}, state), {}, {
        clientOffset: payload.clientOffset
      });

    case END_DRAG:
    case DROP:
      return initialState;

    default:
      return state;
  }
}

var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId: targetId
    }
  };
}
function removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId: sourceId
    }
  };
}
function removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId: targetId
    }
  };
}

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$j(Object(source), true).forEach(function (key) { _defineProperty$5(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var initialState$1 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function reduce$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var payload = action.payload;

  switch (action.type) {
    case BEGIN_DRAG:
      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });

    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        isSourcePublic: true
      });

    case HOVER:
      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        targetIds: payload.targetIds
      });

    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }

      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        targetIds: without(state.targetIds, payload.targetId)
      });

    case DROP:
      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });

    case END_DRAG:
      return _objectSpread$j(_objectSpread$j({}, state), {}, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });

    default:
      return state;
  }
}

function reduce$2() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;

    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;

    default:
      return state;
  }
}

var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */

function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }

  if (dirtyIds === ALL || typeof handlerIds === 'undefined') {
    return true;
  }

  var commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}

function reduce$3() {

  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case HOVER:
      break;

    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;

    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }

  var _action$payload = action.payload,
      _action$payload$targe = _action$payload.targetIds,
      targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe,
      _action$payload$prevT = _action$payload.prevTargetIds,
      prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);

  if (!didChange) {
    return NONE;
  } // Check the target ids at the innermost position. If they are valid, add them
  // to the result


  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];

  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }

    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }

  return result;
}

function reduce$4() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}

function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$k(Object(source), true).forEach(function (key) { _defineProperty$6(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function reduce$5() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: reduce$3(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread$k(_objectSpread$k({}, action.payload), {}, {
        prevTargetIds: get$1(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: reduce(state.dragOffset, action),
    refCount: reduce$2(state.refCount, action),
    dragOperation: reduce$1(state.dragOperation, action),
    stateId: reduce$4(state.stateId)
  };
}

/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */

function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */

function getSourceClientOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset,
      initialSourceClientOffset = state.initialSourceClientOffset;

  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }

  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */

function getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset,
      initialClientOffset = state.initialClientOffset;

  if (!clientOffset || !initialClientOffset) {
    return null;
  }

  return subtract(clientOffset, initialClientOffset);
}

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$2(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }
var DragDropMonitorImpl = /*#__PURE__*/function () {
  function DragDropMonitorImpl(store, registry) {
    _classCallCheck$1(this, DragDropMonitorImpl);

    this.store = store;
    this.registry = registry;
  }

  _createClass$2(DragDropMonitorImpl, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        handlerIds: undefined
      };
      var handlerIds = options.handlerIds;
      invariant(typeof listener === 'function', 'listener must be a function.');
      invariant(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
      var prevStateId = this.store.getState().stateId;

      var handleChange = function handleChange() {
        var state = _this.store.getState();

        var currentStateId = state.stateId;

        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);

          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this2 = this;

      invariant(typeof listener === 'function', 'listener must be a function.');
      var previousState = this.store.getState().dragOffset;

      var handleChange = function handleChange() {
        var nextState = _this2.store.getState().dragOffset;

        if (nextState === previousState) {
          return;
        }

        previousState = nextState;
        listener();
      };

      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (this.isDragging()) {
        return false;
      }

      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var target = this.registry.getTarget(targetId);
      invariant(target, "Expected to find a valid target. targetId=".concat(targetId));

      if (!this.isDragging() || this.didDrop()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      // undefined on initial render
      if (!sourceId) {
        return false;
      }

      var source = this.registry.getSource(sourceId, true);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));

      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }

      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();

      if (sourceType !== draggedItemType) {
        return false;
      }

      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };

      // undefined on initial render
      if (!targetId) {
        return false;
      }

      var shallow = options.shallow;

      if (!this.isDragging()) {
        return false;
      }

      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();

      if (draggedItemType && !matchesType(targetType, draggedItemType)) {
        return false;
      }

      var targetIds = this.getTargetIds();

      if (!targetIds.length) {
        return false;
      }

      var index = targetIds.indexOf(targetId);

      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset$1() {
      return getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset$1() {
      return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]);

  return DragDropMonitorImpl;
}();

var nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
function validateSourceContract(source) {
  invariant(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
  invariant(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
  invariant(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
  invariant(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
  invariant(typeof target.hover === 'function', 'Expected hover to be a function.');
  invariant(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function (t) {
      return validateType(t, false);
    });
    return;
  }

  invariant(typeof type === 'string' || _typeof$3(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

var makeRequestCall_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeRequestCallFromTimer = makeRequestCallFromTimer;
exports.makeRequestCallFromMutationObserver = makeRequestCallFromMutationObserver;
exports.makeRequestCall = void 0;
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const scope = typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const makeRequestCall = typeof BrowserMutationObserver === 'function' ? // reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
makeRequestCallFromMutationObserver : // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
makeRequestCallFromTimer;
exports.makeRequestCall = makeRequestCall;


});

var AsapQueue_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});

class AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q , requestFlush  } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q  } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++){
                        q[scan] = q[scan + this.index];
                    }
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (makeRequestCall_1).makeRequestCall(this.flush);
        this.requestErrorThrow = (makeRequestCall_1).makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) {
                throw this.pendingErrors.shift();
            }
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
exports.AsapQueue = AsapQueue;


});

var RawTask_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
class RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
exports.RawTask = RawTask;


});

var TaskFactory_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});

class TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new RawTask_1.RawTask(this.onError, (t)=>tasks[tasks.length] = t
        );
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
exports.TaskFactory = TaskFactory;


});

var asap_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.asap = asap;


const asapQueue = new AsapQueue_1.AsapQueue();
const taskFactory = new TaskFactory_1.TaskFactory(asapQueue.registerPendingError);
function asap(task) {
    asapQueue.enqueueTask(taskFactory.create(task));
}


});

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});


});

var cjs = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _asapJs = _interopRequireWildcard(asap_1);
Object.keys(_asapJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _asapJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _asapJs[key];
        }
    });
});
var _typesJs = _interopRequireWildcard(types);
Object.keys(_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typesJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typesJs[key];
        }
    });
});
var _asapQueueJs = _interopRequireWildcard(AsapQueue_1);
Object.keys(_asapQueueJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _asapQueueJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _asapQueueJs[key];
        }
    });
});
var _taskFactoryJs = _interopRequireWildcard(TaskFactory_1);
Object.keys(_taskFactoryJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _taskFactoryJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _taskFactoryJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}


});

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function getNextHandlerId(role) {
  var id = getNextUniqueId().toString();

  switch (role) {
    case HandlerRole.SOURCE:
      return "S".concat(id);

    case HandlerRole.TARGET:
      return "T".concat(id);

    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}

function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case 'S':
      return HandlerRole.SOURCE;

    case 'T':
      return HandlerRole.TARGET;

    default:
      invariant(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}

function mapContainsValue(map, searchValue) {
  var entries = map.entries();
  var isDone = false;

  do {
    var _entries$next = entries.next(),
        done = _entries$next.done,
        _entries$next$value = _slicedToArray$1(_entries$next.value, 2),
        value = _entries$next$value[1];

    if (value === searchValue) {
      return true;
    }

    isDone = !!done;
  } while (!isDone);

  return false;
}

var HandlerRegistryImpl = /*#__PURE__*/function () {
  function HandlerRegistryImpl(store) {
    _classCallCheck$2(this, HandlerRegistryImpl);

    this.types = new Map();
    this.dragSources = new Map();
    this.dropTargets = new Map();
    this.pinnedSourceId = null;
    this.pinnedSource = null;
    this.store = store;
  }

  _createClass$3(HandlerRegistryImpl, [{
    key: "addSource",
    value: function addSource$1(type, source) {
      validateType(type);
      validateSourceContract(source);
      var sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
      this.store.dispatch(addSource(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget$1(type, target) {
      validateType(type, true);
      validateTargetContract(target);
      var targetId = this.addHandler(HandlerRole.TARGET, type, target);
      this.store.dispatch(addTarget(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      invariant(this.isSourceId(sourceId), 'Expected a valid source ID.');
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      invariant(this.isTargetId(targetId), 'Expected a valid target ID.');
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource$1(sourceId) {
      var _this = this;

      invariant(this.getSource(sourceId), 'Expected an existing source.');
      this.store.dispatch(removeSource(sourceId));
      cjs.asap(function () {
        _this.dragSources.delete(sourceId);

        _this.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget$1(targetId) {
      invariant(this.getTarget(targetId), 'Expected an existing target.');
      this.store.dispatch(removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      invariant(source, 'Expected an existing source.');
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      invariant(this.pinnedSource, 'No source is pinned at the time.');
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);

      if (role === HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }

      return id;
    }
  }]);

  return HandlerRegistryImpl;
}();

function createDragDropManager(backendFactory) {
  var globalContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var backendOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debugMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var store = makeStoreInstance(debugMode);
  var monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
  var manager = new DragDropManagerImpl(store, monitor);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}

function makeStoreInstance(debugMode) {
  // TODO: if we ever make a react-native version of this,
  // we'll need to consider how to pull off dev-tooling
  var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce$5, debugMode && reduxDevTools && reduxDevTools({
    name: 'dnd-core',
    instanceId: 'dnd-core'
  }));
}

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var refCount = 0;
var INSTANCE_SYM = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
/**
 * A React component that provides the React-DnD context
 */

var DndProvider = memo(function DndProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$2(_ref, ["children"]);

  var _getDndContextValue = getDndContextValue(props),
      _getDndContextValue2 = _slicedToArray$2(_getDndContextValue, 2),
      manager = _getDndContextValue2[0],
      isGlobalInstance = _getDndContextValue2[1]; // memoized from props

  /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */


  useEffect(function () {
    if (isGlobalInstance) {
      var context = getGlobalContext();
      ++refCount;
      return function () {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
  }, []);
  return jsx(DndContext.Provider, Object.assign({
    value: manager
  }, {
    children: children
  }), void 0);
});

function getDndContextValue(props) {
  if ('manager' in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }

  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}

function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var debugMode = arguments.length > 3 ? arguments[3] : undefined;
  var ctx = context;

  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: createDragDropManager(backend, context, options, debugMode)
    };
  }

  return ctx[INSTANCE_SYM];
}

function getGlobalContext() {
  return typeof global !== 'undefined' ? global : window;
}

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }
var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl = /*#__PURE__*/function () {
  function DragSourceMonitorImpl(manager) {
    _classCallCheck$3(this, DragSourceMonitorImpl);

    this.sourceId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass$4(DragSourceMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(sourceId) {
      this.sourceId = sourceId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.sourceId;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      invariant(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingCanDrag = true;
        return this.internalMonitor.canDragSource(this.sourceId);
      } finally {
        isCallingCanDrag = false;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      if (!this.sourceId) {
        return false;
      }

      invariant(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor');

      try {
        isCallingIsDragging = true;
        return this.internalMonitor.isDraggingSource(this.sourceId);
      } finally {
        isCallingIsDragging = false;
      }
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      return this.internalMonitor.isDraggingSource(sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId, options) {
      return this.internalMonitor.isOverTarget(targetId, options);
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.internalMonitor.getTargetIds();
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return this.internalMonitor.isSourcePublic();
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.internalMonitor.getSourceId();
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      return this.internalMonitor.subscribeToOffsetChange(listener);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      return this.internalMonitor.canDragSource(sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      return this.internalMonitor.canDropOnTarget(targetId);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DragSourceMonitorImpl;
}();

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); return Constructor; }
var isCallingCanDrop = false;
var DropTargetMonitorImpl = /*#__PURE__*/function () {
  function DropTargetMonitorImpl(manager) {
    _classCallCheck$4(this, DropTargetMonitorImpl);

    this.targetId = null;
    this.internalMonitor = manager.getMonitor();
  }

  _createClass$5(DropTargetMonitorImpl, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(targetId) {
      this.targetId = targetId;
    }
  }, {
    key: "getHandlerId",
    value: function getHandlerId() {
      return this.targetId;
    }
  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, options) {
      return this.internalMonitor.subscribeToStateChange(listener, options);
    }
  }, {
    key: "canDrop",
    value: function canDrop() {
      // Cut out early if the target id has not been set. This should prevent errors
      // where the user has an older version of dnd-core like in
      // https://github.com/react-dnd/react-dnd/issues/1310
      if (!this.targetId) {
        return false;
      }

      invariant(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor');

      try {
        isCallingCanDrop = true;
        return this.internalMonitor.canDropOnTarget(this.targetId);
      } finally {
        isCallingCanDrop = false;
      }
    }
  }, {
    key: "isOver",
    value: function isOver(options) {
      if (!this.targetId) {
        return false;
      }

      return this.internalMonitor.isOverTarget(this.targetId, options);
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.internalMonitor.getItemType();
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.internalMonitor.getItem();
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.internalMonitor.getDropResult();
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.internalMonitor.didDrop();
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.internalMonitor.getInitialClientOffset();
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.internalMonitor.getInitialSourceClientOffset();
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset() {
      return this.internalMonitor.getSourceClientOffset();
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.internalMonitor.getClientOffset();
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset() {
      return this.internalMonitor.getDifferenceFromInitialOffset();
    }
  }]);

  return DropTargetMonitorImpl;
}();

function throwIfCompositeComponentElement(element) {
  // Custom components can no longer be wrapped directly in React DnD 2.0
  // so that we don't need to depend on findDOMNode() from react-dom.
  if (typeof element.type === 'string') {
    return;
  }

  var displayName = element.type.displayName || element.type.name || 'the component';
  throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
  return function () {
    var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    // When passed a node, call the hook straight away.
    if (!isValidElement(elementOrNode)) {
      var node = elementOrNode;
      hook(node, options); // return the node so it can be chained (e.g. when within callback refs
      // <div ref={node => connectDragSource(connectDropTarget(node))}/>

      return node;
    } // If passed a ReactElement, clone it and attach this function as a ref.
    // This helps us achieve a neat API where user doesn't even know that refs
    // are being used under the hood.


    var element = elementOrNode;
    throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly

    var ref = options ? function (node) {
      return hook(node, options);
    } : hook;
    return cloneWithRef(element, ref);
  };
}

function wrapConnectorHooks(hooks) {
  var wrappedHooks = {};
  Object.keys(hooks).forEach(function (key) {
    var hook = hooks[key]; // ref objects should be passed straight through without wrapping

    if (key.endsWith('Ref')) {
      wrappedHooks[key] = hooks[key];
    } else {
      var wrappedHook = wrapHookToRecognizeElement(hook);

      wrappedHooks[key] = function () {
        return wrappedHook;
      };
    }
  });
  return wrappedHooks;
}

function setRef$2(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else {
    ref.current = node;
  }
}

function cloneWithRef(element, newRef) {
  var previousRef = element.ref;
  invariant(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs');

  if (!previousRef) {
    // When there is no ref on the element, use the new ref directly
    return cloneElement(element, {
      ref: newRef
    });
  } else {
    return cloneElement(element, {
      ref: function ref(node) {
        setRef$2(previousRef, node);
        setRef$2(newRef, node);
      }
    });
  }
}

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

function isRef(obj) {
  return (// eslint-disable-next-line no-prototype-builtins
    obj !== null && _typeof$4(obj) === 'object' && Object.prototype.hasOwnProperty.call(obj, 'current')
  );
}

function shallowEqual(objA, objB, compare, compareContext) {
  var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (compareResult !== void 0) {
    return !!compareResult;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];
    compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }

  return true;
}

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); return Constructor; }
var SourceConnector = /*#__PURE__*/function () {
  function SourceConnector(backend) {
    var _this = this;

    _classCallCheck$5(this, SourceConnector);

    this.hooks = wrapConnectorHooks({
      dragSource: function dragSource(node, options) {
        _this.clearDragSource();

        _this.dragSourceOptions = options || null;

        if (isRef(node)) {
          _this.dragSourceRef = node;
        } else {
          _this.dragSourceNode = node;
        }

        _this.reconnectDragSource();
      },
      dragPreview: function dragPreview(node, options) {
        _this.clearDragPreview();

        _this.dragPreviewOptions = options || null;

        if (isRef(node)) {
          _this.dragPreviewRef = node;
        } else {
          _this.dragPreviewNode = node;
        }

        _this.reconnectDragPreview();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dragSourceRef = null;
    this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function

    this.dragPreviewRef = null;
    this.dragPreviewOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDragSource = null;
    this.lastConnectedDragSourceOptions = null;
    this.lastConnectedDragPreview = null;
    this.lastConnectedDragPreviewOptions = null;
    this.backend = backend;
  }

  _createClass$6(SourceConnector, [{
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (this.handlerId === newHandlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "connectTarget",
    get: function get() {
      return this.dragSource;
    }
  }, {
    key: "dragSourceOptions",
    get: function get() {
      return this.dragSourceOptionsInternal;
    },
    set: function set(options) {
      this.dragSourceOptionsInternal = options;
    }
  }, {
    key: "dragPreviewOptions",
    get: function get() {
      return this.dragPreviewOptionsInternal;
    },
    set: function set(options) {
      this.dragPreviewOptionsInternal = options;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      this.reconnectDragSource();
      this.reconnectDragPreview();
    }
  }, {
    key: "reconnectDragSource",
    value: function reconnectDragSource() {
      var dragSource = this.dragSource; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();

      if (didChange) {
        this.disconnectDragSource();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragSource) {
        this.lastConnectedDragSource = dragSource;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragSource = dragSource;
        this.lastConnectedDragSourceOptions = this.dragSourceOptions;
        this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
      }
    }
  }, {
    key: "reconnectDragPreview",
    value: function reconnectDragPreview() {
      var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe

      var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();

      if (didChange) {
        this.disconnectDragPreview();
      }

      if (!this.handlerId) {
        return;
      }

      if (!dragPreview) {
        this.lastConnectedDragPreview = dragPreview;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDragPreview = dragPreview;
        this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
        this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
      }
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didConnectedDragSourceChange",
    value: function didConnectedDragSourceChange() {
      return this.lastConnectedDragSource !== this.dragSource;
    }
  }, {
    key: "didConnectedDragPreviewChange",
    value: function didConnectedDragPreviewChange() {
      return this.lastConnectedDragPreview !== this.dragPreview;
    }
  }, {
    key: "didDragSourceOptionsChange",
    value: function didDragSourceOptionsChange() {
      return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
  }, {
    key: "didDragPreviewOptionsChange",
    value: function didDragPreviewOptionsChange() {
      return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
  }, {
    key: "disconnectDragSource",
    value: function disconnectDragSource() {
      if (this.dragSourceUnsubscribe) {
        this.dragSourceUnsubscribe();
        this.dragSourceUnsubscribe = undefined;
      }
    }
  }, {
    key: "disconnectDragPreview",
    value: function disconnectDragPreview() {
      if (this.dragPreviewUnsubscribe) {
        this.dragPreviewUnsubscribe();
        this.dragPreviewUnsubscribe = undefined;
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
      }
    }
  }, {
    key: "dragSource",
    get: function get() {
      return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
  }, {
    key: "dragPreview",
    get: function get() {
      return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
  }, {
    key: "clearDragSource",
    value: function clearDragSource() {
      this.dragSourceNode = null;
      this.dragSourceRef = null;
    }
  }, {
    key: "clearDragPreview",
    value: function clearDragPreview() {
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }]);

  return SourceConnector;
}();

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); return Constructor; }
var TargetConnector = /*#__PURE__*/function () {
  function TargetConnector(backend) {
    var _this = this;

    _classCallCheck$6(this, TargetConnector);

    this.hooks = wrapConnectorHooks({
      dropTarget: function dropTarget(node, options) {
        _this.clearDropTarget();

        _this.dropTargetOptions = options;

        if (isRef(node)) {
          _this.dropTargetRef = node;
        } else {
          _this.dropTargetNode = node;
        }

        _this.reconnect();
      }
    });
    this.handlerId = null; // The drop target may either be attached via ref or connect function

    this.dropTargetRef = null;
    this.dropTargetOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDropTarget = null;
    this.lastConnectedDropTargetOptions = null;
    this.backend = backend;
  }

  _createClass$7(TargetConnector, [{
    key: "connectTarget",
    get: function get() {
      return this.dropTarget;
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      // if nothing has changed then don't resubscribe
      var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();

      if (didChange) {
        this.disconnectDropTarget();
      }

      var dropTarget = this.dropTarget;

      if (!this.handlerId) {
        return;
      }

      if (!dropTarget) {
        this.lastConnectedDropTarget = dropTarget;
        return;
      }

      if (didChange) {
        this.lastConnectedHandlerId = this.handlerId;
        this.lastConnectedDropTarget = dropTarget;
        this.lastConnectedDropTargetOptions = this.dropTargetOptions;
        this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
      }
    }
  }, {
    key: "receiveHandlerId",
    value: function receiveHandlerId(newHandlerId) {
      if (newHandlerId === this.handlerId) {
        return;
      }

      this.handlerId = newHandlerId;
      this.reconnect();
    }
  }, {
    key: "dropTargetOptions",
    get: function get() {
      return this.dropTargetOptionsInternal;
    },
    set: function set(options) {
      this.dropTargetOptionsInternal = options;
    }
  }, {
    key: "didHandlerIdChange",
    value: function didHandlerIdChange() {
      return this.lastConnectedHandlerId !== this.handlerId;
    }
  }, {
    key: "didDropTargetChange",
    value: function didDropTargetChange() {
      return this.lastConnectedDropTarget !== this.dropTarget;
    }
  }, {
    key: "didOptionsChange",
    value: function didOptionsChange() {
      return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
  }, {
    key: "disconnectDropTarget",
    value: function disconnectDropTarget() {
      if (this.unsubscribeDropTarget) {
        this.unsubscribeDropTarget();
        this.unsubscribeDropTarget = undefined;
      }
    }
  }, {
    key: "dropTarget",
    get: function get() {
      return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
  }, {
    key: "clearDropTarget",
    value: function clearDropTarget() {
      this.dropTargetRef = null;
      this.dropTargetNode = null;
    }
  }]);

  return TargetConnector;
}();

function registerTarget(type, target, manager) {
  var registry = manager.getRegistry();
  var targetId = registry.addTarget(type, target);
  return [targetId, function () {
    return registry.removeTarget(targetId);
  }];
}
function registerSource(type, source, manager) {
  var registry = manager.getRegistry();
  var sourceId = registry.addSource(type, source);
  return [sourceId, function () {
    return registry.removeSource(sourceId);
  }];
}

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); return Constructor; }

var DragSourceImpl = /*#__PURE__*/function () {
  function DragSourceImpl(spec, monitor, connector) {
    _classCallCheck$7(this, DragSourceImpl);

    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }

  _createClass$8(DragSourceImpl, [{
    key: "beginDrag",
    value: function beginDrag() {
      var _result;

      var spec = this.spec;
      var monitor = this.monitor;
      var result = null;

      if (_typeof$5(spec.item) === 'object') {
        result = spec.item;
      } else if (typeof spec.item === 'function') {
        result = spec.item(monitor);
      } else {
        result = {};
      }

      return (_result = result) !== null && _result !== void 0 ? _result : null;
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (typeof spec.canDrag === 'boolean') {
        return spec.canDrag;
      } else if (typeof spec.canDrag === 'function') {
        return spec.canDrag(monitor);
      } else {
        return true;
      }
    }
  }, {
    key: "isDragging",
    value: function isDragging(globalMonitor, target) {
      var spec = this.spec;
      var monitor = this.monitor;
      var isDragging = spec.isDragging;
      return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
      var spec = this.spec;
      var monitor = this.monitor;
      var connector = this.connector;
      var end = spec.end;

      if (end) {
        end(monitor.getItem(), monitor);
      }

      connector.reconnect();
    }
  }]);

  return DragSourceImpl;
}();

function useDragSource(spec, monitor, connector) {
  var handler = useMemo(function () {
    return new DragSourceImpl(spec, monitor, connector);
  }, [monitor, connector]);
  useEffect(function () {
    handler.spec = spec;
  }, [spec]);
  return handler;
}

/**
 * A hook to retrieve the DragDropManager from Context
 */

function useDragDropManager() {
  var _useContext = useContext(DndContext),
      dragDropManager = _useContext.dragDropManager;

  invariant(dragDropManager != null, 'Expected drag drop context');
  return dragDropManager;
}

function useDragType(spec) {
  return useMemo(function () {
    var result = spec.type;
    invariant(result != null, 'spec.type must be defined');
    return result;
  }, [spec]);
}

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
function useRegisteredDragSource(spec, monitor, connector) {
  var manager = useDragDropManager();
  var handler = useDragSource(spec, monitor, connector);
  var itemType = useDragType(spec);
  useIsomorphicLayoutEffect$1(function registerDragSource() {
    if (itemType != null) {
      var _registerSource = registerSource(itemType, handler, manager),
          _registerSource2 = _slicedToArray$3(_registerSource, 2),
          handlerId = _registerSource2[0],
          unregister = _registerSource2[1];

      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
  }, [manager, monitor, connector, handler, itemType]);
}

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function useOptionalFactory(arg, deps) {
  var memoDeps = _toConsumableArray$1(deps || []);

  if (deps == null && typeof arg !== 'function') {
    memoDeps.push(arg);
  }

  return useMemo(function () {
    return typeof arg === 'function' ? arg() : arg;
  }, memoDeps);
}

function useDragSourceMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DragSourceMonitorImpl(manager);
  }, [manager]);
}

function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
  var manager = useDragDropManager();
  var connector = useMemo(function () {
    return new SourceConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect$1(function () {
    connector.dragSourceOptions = dragSourceOptions || null;
    connector.reconnect();
  }, [connector, dragSourceOptions]);
  useIsomorphicLayoutEffect$1(function () {
    connector.dragPreviewOptions = dragPreviewOptions || null;
    connector.reconnect();
  }, [connector, dragPreviewOptions]);
  return connector;
}

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */

function useCollector(monitor, collect, onUpdate) {
  var _useState = useState(function () {
    return collect(monitor);
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      collected = _useState2[0],
      setCollected = _useState2[1];

  var updateCollected = useCallback(function () {
    var nextValue = collect(monitor); // This needs to be a deep-equality check because some monitor-collected values
    // include XYCoord objects that may be equivalent, but do not have instance equality.

    if (!fastDeepEqual(collected, nextValue)) {
      setCollected(nextValue);

      if (onUpdate) {
        onUpdate();
      }
    }
  }, [collected, monitor, onUpdate]); // update the collected properties after react renders.
  // Note that the "Dustbin Stress Test" fails if this is not
  // done when the component updates

  useIsomorphicLayoutEffect$1(updateCollected);
  return [collected, updateCollected];
}

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$5(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
function useMonitorOutput(monitor, collect, onCollect) {
  var _useCollector = useCollector(monitor, collect, onCollect),
      _useCollector2 = _slicedToArray$5(_useCollector, 2),
      collected = _useCollector2[0],
      updateCollected = _useCollector2[1];

  useIsomorphicLayoutEffect$1(function subscribeToMonitorStateChange() {
    var handlerId = monitor.getHandlerId();

    if (handlerId == null) {
      return;
    }

    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [handlerId]
    });
  }, [monitor, updateCollected]);
  return collected;
}

function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(monitor, collector || function () {
    return {};
  }, function () {
    return connector.reconnect();
  });
}

function useConnectDragSource(connector) {
  return useMemo(function () {
    return connector.hooks.dragSource();
  }, [connector]);
}
function useConnectDragPreview(connector) {
  return useMemo(function () {
    return connector.hooks.dragPreview();
  }, [connector]);
}

/**
 * useDragSource hook
 * @param sourceSpec The drag source specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrag(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  var monitor = useDragSourceMonitor();
  var connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDragSource(connector), useConnectDragPreview(connector)];
}

/**
 * Internal utility hook to get an array-version of spec.accept.
 * The main utility here is that we aren't creating a new array on every render if a non-array spec.accept is passed in.
 * @param spec
 */

function useAccept(spec) {
  var accept = spec.accept;
  return useMemo(function () {
    invariant(spec.accept != null, 'accept must be defined');
    return Array.isArray(accept) ? accept : [accept];
  }, [accept]);
}

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); return Constructor; }

var DropTargetImpl = /*#__PURE__*/function () {
  function DropTargetImpl(spec, monitor) {
    _classCallCheck$8(this, DropTargetImpl);

    this.spec = spec;
    this.monitor = monitor;
  }

  _createClass$9(DropTargetImpl, [{
    key: "canDrop",
    value: function canDrop() {
      var spec = this.spec;
      var monitor = this.monitor;
      return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
  }, {
    key: "hover",
    value: function hover() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.hover) {
        spec.hover(monitor.getItem(), monitor);
      }
    }
  }, {
    key: "drop",
    value: function drop() {
      var spec = this.spec;
      var monitor = this.monitor;

      if (spec.drop) {
        return spec.drop(monitor.getItem(), monitor);
      }
    }
  }]);

  return DropTargetImpl;
}();

function useDropTarget(spec, monitor) {
  var dropTarget = useMemo(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  useEffect(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}

function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$6(); }

function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$6(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }
function useRegisteredDropTarget(spec, monitor, connector) {
  var manager = useDragDropManager();
  var dropTarget = useDropTarget(spec, monitor);
  var accept = useAccept(spec);
  useIsomorphicLayoutEffect$1(function registerDropTarget() {
    var _registerTarget = registerTarget(accept, dropTarget, manager),
        _registerTarget2 = _slicedToArray$6(_registerTarget, 2),
        handlerId = _registerTarget2[0],
        unregister = _registerTarget2[1];

    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [manager, monitor, dropTarget, connector, accept.map(function (a) {
    return a.toString();
  }).join('|')]);
}

function useDropTargetMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DropTargetMonitorImpl(manager);
  }, [manager]);
}

function useDropTargetConnector(options) {
  var manager = useDragDropManager();
  var connector = useMemo(function () {
    return new TargetConnector(manager.getBackend());
  }, [manager]);
  useIsomorphicLayoutEffect$1(function () {
    connector.dropTargetOptions = options || null;
    connector.reconnect();
  }, [options]);
  return connector;
}

function useConnectDropTarget(connector) {
  return useMemo(function () {
    return connector.hooks.dropTarget();
  }, [connector]);
}

/**
 * useDropTarget Hook
 * @param spec The drop target specification (object or function, function preferred)
 * @param deps The memoization deps array to use when evaluating spec changes
 */

function useDrop(specArg, deps) {
  var spec = useOptionalFactory(specArg, deps);
  var monitor = useDropTargetMonitor();
  var connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [useCollectedProps(spec.collect, monitor, connector), useConnectDropTarget(connector)];
}

// cheap lodash replacements
function memoize$3(fn) {
  var result = null;

  var memoized = function memoized() {
    if (result == null) {
      result = fn();
    }

    return result;
  };

  return memoized;
}
/**
 * drop-in replacement for _.without
 */

function without$1(items, item) {
  return items.filter(function (i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = new Set();

  var insertItem = function insertItem(item) {
    return set.add(item);
  };

  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  set.forEach(function (key) {
    return result.push(key);
  });
  return result;
}

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); return Constructor; }
var EnterLeaveCounter = /*#__PURE__*/function () {
  function EnterLeaveCounter(isNodeInDocument) {
    _classCallCheck$9(this, EnterLeaveCounter);

    this.entered = [];
    this.isNodeInDocument = isNodeInDocument;
  }

  _createClass$a(EnterLeaveCounter, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this;

      var previousLength = this.entered.length;

      var isNodeEntered = function isNodeEntered(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };

      this.entered = union(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;
      this.entered = without$1(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);

  return EnterLeaveCounter;
}();

var isFirefox$1 = memoize$3(function () {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = memoize$3(function () {
  return Boolean(window.safari);
});

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); return Constructor; }

var MonotonicInterpolant = /*#__PURE__*/function () {
  function MonotonicInterpolant(xs, ys) {
    _classCallCheck$a(this, MonotonicInterpolant);

    var length = xs.length; // Rearrange xs and ys so that xs is sorted

    var indexes = [];

    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }

    indexes.sort(function (a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    }); // Get consecutive differences and slopes
    var dxs = [];
    var ms = [];
    var dx;
    var dy;

    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      ms.push(dy / dx);
    } // Get degree-1 coefficients


    var c1s = [ms[0]];

    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var m2 = ms[_i2];
      var mNext = ms[_i2 + 1];

      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }

    c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients

    var c2s = [];
    var c3s = [];
    var m;

    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];

      var _common = c1 + c1s[_i3 + 1] - m - m;

      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }

    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }

  _createClass$b(MonotonicInterpolant, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs,
          ys = this.ys,
          c1s = this.c1s,
          c2s = this.c2s,
          c3s = this.c3s; // The rightmost point in the dataset should give an exact result

      var i = xs.length - 1;

      if (x === xs[i]) {
        return ys[i];
      } // Search for the interval x is in, returning the corresponding y if x is one of the original xs


      var low = 0;
      var high = c3s.length - 1;
      var mid;

      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];

        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }

      i = Math.max(0, high); // Interpolate

      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);

  return MonotonicInterpolant;
}();

var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

  if (!el) {
    return null;
  }

  var _el$getBoundingClient = el.getBoundingClientRect(),
      top = _el$getBoundingClient.top,
      left = _el$getBoundingClient.left;

  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}

function isImageNode(node) {
  var _document$documentEle;

  return node.nodeName === 'IMG' && (isFirefox$1() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers

  if (isSafari() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }

  return {
    dragPreviewWidth: dragPreviewWidth,
    dragPreviewHeight: dragPreviewHeight
  };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  // The browsers will use the image intrinsic size under different conditions.
  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
  var isImage = isImageNode(dragPreview);
  var dragPreviewNode = isImage ? sourceNode : dragPreview;
  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  var sourceWidth = sourceNode.offsetWidth,
      sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX,
      anchorY = anchorPoint.anchorY;

  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
      dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
      dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

  var calculateYOffset = function calculateYOffset() {
    var interpolantY = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the top
    offsetFromDragPreview.y, // Align at the center
    offsetFromDragPreview.y / sourceHeight * dragPreviewHeight, // Dock to the bottom
    offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
    var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug

    if (isSafari() && isImage) {
      // We'll have to wait for @3x to see if this is entirely correct
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }

    return y;
  };

  var calculateXOffset = function calculateXOffset() {
    // Interpolate coordinates depending on anchor point
    // If you know a simpler way to do this, let me know
    var interpolantX = new MonotonicInterpolant([0, 0.5, 1], [// Dock to the left
    offsetFromDragPreview.x, // Align at the center
    offsetFromDragPreview.x / sourceWidth * dragPreviewWidth, // Dock to the right
    offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
    return interpolantX.interpolate(anchorX);
  }; // Force offsets if specified in the options.


  var offsetX = offsetPoint.offsetX,
      offsetY = offsetPoint.offsetY;
  var isManualOffsetX = offsetX === 0 || offsetX;
  var isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}

var FILE = '__NATIVE_FILE__';
var URL = '__NATIVE_URL__';
var TEXT = '__NATIVE_TEXT__';
var HTML = '__NATIVE_HTML__';

var NativeTypes = /*#__PURE__*/Object.freeze({
	__proto__: null,
	FILE: FILE,
	URL: URL,
	TEXT: TEXT,
	HTML: HTML
});

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer.getData(typeToTry);
  }, '');
  return result != null ? result : defaultValue;
}

var _nativeTypesConfig;

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty$7(_nativeTypesConfig, FILE, {
  exposeProperties: {
    files: function files(dataTransfer) {
      return Array.prototype.slice.call(dataTransfer.files);
    },
    items: function items(dataTransfer) {
      return dataTransfer.items;
    }
  },
  matchesTypes: ['Files']
}), _defineProperty$7(_nativeTypesConfig, HTML, {
  exposeProperties: {
    html: function html(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
  },
  matchesTypes: ['Html', 'text/html']
}), _defineProperty$7(_nativeTypesConfig, URL, {
  exposeProperties: {
    urls: function urls(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
    }
  },
  matchesTypes: ['Url', 'text/uri-list']
}), _defineProperty$7(_nativeTypesConfig, TEXT, {
  exposeProperties: {
    text: function text(dataTransfer, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
    }
  },
  matchesTypes: ['Text', 'text/plain']
}), _nativeTypesConfig);

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); return Constructor; }

var NativeDragSource = /*#__PURE__*/function () {
  function NativeDragSource(config) {
    _classCallCheck$b(this, NativeDragSource);

    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }

  _createClass$c(NativeDragSource, [{
    key: "initializeExposedProperties",
    value: function initializeExposedProperties() {
      var _this = this;

      Object.keys(this.config.exposeProperties).forEach(function (property) {
        Object.defineProperty(_this.item, property, {
          configurable: true,
          enumerable: true,
          get: function get() {
            // eslint-disable-next-line no-console
            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
            return null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function loadDataTransfer(dataTransfer) {
      var _this2 = this;

      if (dataTransfer) {
        var newProperties = {};
        Object.keys(this.config.exposeProperties).forEach(function (property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        });
        Object.defineProperties(this.item, newProperties);
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {// empty
    }
  }]);

  return NativeDragSource;
}();

function createNativeDragSource(type, dataTransfer) {
  var result = new NativeDragSource(nativeTypesConfig[type]);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  if (!dataTransfer) {
    return null;
  }

  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
    return matchesTypes.some(function (t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); return Constructor; }

var OptionsReader = /*#__PURE__*/function () {
  function OptionsReader(globalContext, options) {
    _classCallCheck$c(this, OptionsReader);

    this.ownerDocument = null;
    this.globalContext = globalContext;
    this.optionsArgs = options;
  }

  _createClass$d(OptionsReader, [{
    key: "window",
    get: function get() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== 'undefined') {
        return window;
      }

      return undefined;
    }
  }, {
    key: "document",
    get: function get() {
      var _this$globalContext;

      if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) {
        return this.globalContext.document;
      } else if (this.window) {
        return this.window.document;
      } else {
        return undefined;
      }
    }
  }, {
    key: "rootElement",
    get: function get() {
      var _this$optionsArgs;

      return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
    }
  }]);

  return OptionsReader;
}();

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$l(Object(source), true).forEach(function (key) { _defineProperty$8(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); return Constructor; }
var HTML5BackendImpl = /*#__PURE__*/function () {
  function HTML5BackendImpl(manager, globalContext, options) {
    var _this = this;

    _classCallCheck$d(this, HTML5BackendImpl);

    this.sourcePreviewNodes = new Map();
    this.sourcePreviewNodeOptions = new Map();
    this.sourceNodes = new Map();
    this.sourceNodeOptions = new Map();
    this.dragStartSourceIds = null;
    this.dropTargetIds = [];
    this.dragEnterTargetIds = [];
    this.currentNativeSource = null;
    this.currentNativeHandle = null;
    this.currentDragSourceNode = null;
    this.altKeyPressed = false;
    this.mouseMoveTimeoutTimer = null;
    this.asyncEndDragFrameId = null;
    this.dragOverTargetIds = null;

    this.getSourceClientOffset = function (sourceId) {
      var source = _this.sourceNodes.get(sourceId);

      return source && getNodeClientOffset(source) || null;
    };

    this.endDragNativeItem = function () {
      if (!_this.isDraggingNativeItem()) {
        return;
      }

      _this.actions.endDrag();

      if (_this.currentNativeHandle) {
        _this.registry.removeSource(_this.currentNativeHandle);
      }

      _this.currentNativeHandle = null;
      _this.currentNativeSource = null;
    };

    this.isNodeInDocument = function (node) {
      // Check the node either in the main document or in the current context
      return Boolean(node && _this.document && _this.document.body && document.body.contains(node));
    };

    this.endDragIfSourceWasRemovedFromDOM = function () {
      var node = _this.currentDragSourceNode;

      if (node == null || _this.isNodeInDocument(node)) {
        return;
      }

      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    };

    this.handleTopDragStartCapture = function () {
      _this.clearCurrentDragSourceNode();

      _this.dragStartSourceIds = [];
    };

    this.handleTopDragStart = function (e) {
      if (e.defaultPrevented) {
        return;
      }

      var dragStartSourceIds = _this.dragStartSourceIds;
      _this.dragStartSourceIds = null;
      var clientOffset = getEventClientOffset(e); // Avoid crashing if we missed a drop event or our previous drag died

      if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      } // Don't publish the source just yet (see why below)


      _this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: _this.getSourceClientOffset,
        clientOffset: clientOffset
      });

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (_this.monitor.isDragging()) {
        if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
          // Use custom drag image if user specifies it.
          // If child drag source refuses drag but parent agrees,
          // use parent's node as drag image. Neither works in IE though.
          var sourceId = _this.monitor.getSourceId();

          var sourceNode = _this.sourceNodes.get(sourceId);

          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;

          if (dragPreview) {
            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(),
                anchorX = _this$getCurrentSourc.anchorX,
                anchorY = _this$getCurrentSourc.anchorY,
                offsetX = _this$getCurrentSourc.offsetX,
                offsetY = _this$getCurrentSourc.offsetY;

            var anchorPoint = {
              anchorX: anchorX,
              anchorY: anchorY
            };
            var offsetPoint = {
              offsetX: offsetX,
              offsetY: offsetY
            };
            var dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }

        try {
          // Firefox won't drag without setting data
          dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData('application/json', {});
        } catch (err) {// IE doesn't support MIME types in setData
        } // Store drag source node so we can check whether
        // it is removed from DOM and trigger endDrag manually.


        _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?


        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(),
            captureDraggingState = _this$getCurrentSourc2.captureDraggingState;

        if (!captureDraggingState) {
          // Usually we want to publish it in the next tick so that browser
          // is able to screenshot the current (not yet dragging) state.
          //
          // It also neatly avoids a situation where render() returns null
          // in the same tick for the source element, and browser freaks out.
          setTimeout(function () {
            return _this.actions.publishDragSource();
          }, 0);
        } else {
          // In some cases the user may want to override this behavior, e.g.
          // to work around IE not supporting custom drag previews.
          //
          // When using a custom drag layer, the only way to prevent
          // the default drag preview from drawing in IE is to screenshot
          // the dragging state in which the node itself has zero opacity
          // and height. In this case, though, returning null from render()
          // will abruptly end the dragging, which is not obvious.
          //
          // This is the reason such behavior is strictly opt-in.
          _this.actions.publishDragSource();
        }
      } else if (nativeType) {
        // A native item (such as URL) dragged from inside the document
        _this.beginDragNativeItem(nativeType);
      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
        // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
        // Just let it drag. It's a native type (URL or text) and will be picked up in
        // dragenter handler.
        return;
      } else {
        // If by this time no drag source reacted, tell browser not to drag.
        e.preventDefault();
      }
    };

    this.handleTopDragEndCapture = function () {
      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        // Firefox can dispatch this event in an infinite loop
        // if dragend handler does something like showing an alert.
        // Only proceed if we have not handled it already.
        _this.actions.endDrag();
      }
    };

    this.handleTopDragEnterCapture = function (e) {
      _this.dragEnterTargetIds = [];

      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);

      if (!isFirstEnter || _this.monitor.isDragging()) {
        return;
      }

      var dataTransfer = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer);

      if (nativeType) {
        // A native item (such as file or URL) dragged from outside the document
        _this.beginDragNativeItem(nativeType, dataTransfer);
      }
    };

    this.handleTopDragEnter = function (e) {
      var dragEnterTargetIds = _this.dragEnterTargetIds;
      _this.dragEnterTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        return;
      }

      _this.altKeyPressed = e.altKey; // If the target changes position as the result of `dragenter`, `dragover` might still
      // get dispatched despite target being no longer there. The easy solution is to check
      // whether there actually is a target before firing `hover`.

      if (dragEnterTargetIds.length > 0) {
        _this.actions.hover(dragEnterTargetIds, {
          clientOffset: getEventClientOffset(e)
        });
      }

      var canDrop = dragEnterTargetIds.some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // IE requires this to fire dragover events
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      }
    };

    this.handleTopDragOverCapture = function () {
      _this.dragOverTargetIds = [];
    };

    this.handleTopDragOver = function (e) {
      var dragOverTargetIds = _this.dragOverTargetIds;
      _this.dragOverTargetIds = [];

      if (!_this.monitor.isDragging()) {
        // This is probably a native item type we don't understand.
        // Prevent default "drop and blow away the whole document" action.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }

        return;
      }

      _this.altKeyPressed = e.altKey;

      _this.actions.hover(dragOverTargetIds || [], {
        clientOffset: getEventClientOffset(e)
      });

      var canDrop = (dragOverTargetIds || []).some(function (targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });

      if (canDrop) {
        // Show user-specified drop effect.
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      } else if (_this.isDraggingNativeItem()) {
        // Don't show a nice cursor but still prevent default
        // "drop and blow away the whole document" action.
        e.preventDefault();
      } else {
        e.preventDefault();

        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = 'none';
        }
      }
    };

    this.handleTopDragLeaveCapture = function (e) {
      if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      }

      var isLastLeave = _this.enterLeaveCounter.leave(e.target);

      if (!isLastLeave) {
        return;
      }

      if (_this.isDraggingNativeItem()) {
        setTimeout(function () {
          return _this.endDragNativeItem();
        }, 0);
      }
    };

    this.handleTopDropCapture = function (e) {
      _this.dropTargetIds = [];

      if (_this.isDraggingNativeItem()) {
        var _this$currentNativeSo;

        e.preventDefault();
        (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 ? void 0 : _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
      }

      _this.enterLeaveCounter.reset();
    };

    this.handleTopDrop = function (e) {
      var dropTargetIds = _this.dropTargetIds;
      _this.dropTargetIds = [];

      _this.actions.hover(dropTargetIds, {
        clientOffset: getEventClientOffset(e)
      });

      _this.actions.drop({
        dropEffect: _this.getCurrentDropEffect()
      });

      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      } else if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    };

    this.handleSelectStart = function (e) {
      var target = e.target; // Only IE requires us to explicitly say
      // we want drag drop operation to start

      if (typeof target.dragDrop !== 'function') {
        return;
      } // Inputs and textareas should be selectable


      if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      } // For other targets, ask IE
      // to enable drag and drop


      e.preventDefault();
      target.dragDrop();
    };

    this.options = new OptionsReader(globalContext, options);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
  /**
   * Generate profiling statistics for the HTML5Backend.
   */


  _createClass$e(HTML5BackendImpl, [{
    key: "profile",
    value: function profile() {
      var _this$dragStartSource, _this$dragOverTargetI;

      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodeOptions: this.sourceNodeOptions.size,
        sourceNodes: this.sourceNodes.size,
        dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
        dropTargetIds: this.dropTargetIds.length,
        dragEnterTargetIds: this.dragEnterTargetIds.length,
        dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
      };
    } // public for test

  }, {
    key: "window",
    get: function get() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function get() {
      return this.options.document;
    }
    /**
     * Get the root element to use for event subscriptions
     */

  }, {
    key: "rootElement",
    get: function get() {
      return this.options.rootElement;
    }
  }, {
    key: "setup",
    value: function setup() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      if (root.__isReactDndBackendSetUp) {
        throw new Error('Cannot have two HTML5 backends at the same time.');
      }

      root.__isReactDndBackendSetUp = true;
      this.addEventListeners(root);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var root = this.rootElement;

      if (root === undefined) {
        return;
      }

      root.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.rootElement);
      this.clearCurrentDragSourceNode();

      if (this.asyncEndDragFrameId) {
        var _this$window;

        (_this$window = this.window) === null || _this$window === void 0 ? void 0 : _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;

      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function () {
        _this2.sourcePreviewNodes.delete(sourceId);

        _this2.sourcePreviewNodeOptions.delete(sourceId);
      };
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node, options) {
      var _this3 = this;

      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);

      var handleDragStart = function handleDragStart(e) {
        return _this3.handleDragStart(e, sourceId);
      };

      var handleSelectStart = function handleSelectStart(e) {
        return _this3.handleSelectStart(e);
      };

      node.setAttribute('draggable', 'true');
      node.addEventListener('dragstart', handleDragStart);
      node.addEventListener('selectstart', handleSelectStart);
      return function () {
        _this3.sourceNodes.delete(sourceId);

        _this3.sourceNodeOptions.delete(sourceId);

        node.removeEventListener('dragstart', handleDragStart);
        node.removeEventListener('selectstart', handleSelectStart);
        node.setAttribute('draggable', 'false');
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;

      var handleDragEnter = function handleDragEnter(e) {
        return _this4.handleDragEnter(e, targetId);
      };

      var handleDragOver = function handleDragOver(e) {
        return _this4.handleDragOver(e, targetId);
      };

      var handleDrop = function handleDrop(e) {
        return _this4.handleDrop(e, targetId);
      };

      node.addEventListener('dragenter', handleDragEnter);
      node.addEventListener('dragover', handleDragOver);
      node.addEventListener('drop', handleDrop);
      return function () {
        node.removeEventListener('dragenter', handleDragEnter);
        node.removeEventListener('dragover', handleDragOver);
        node.removeEventListener('drop', handleDrop);
      };
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.addEventListener) {
        return;
      }

      target.addEventListener('dragstart', this.handleTopDragStart);
      target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.addEventListener('dragend', this.handleTopDragEndCapture, true);
      target.addEventListener('dragenter', this.handleTopDragEnter);
      target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.addEventListener('dragover', this.handleTopDragOver);
      target.addEventListener('dragover', this.handleTopDragOverCapture, true);
      target.addEventListener('drop', this.handleTopDrop);
      target.addEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(target) {
      // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
      if (!target.removeEventListener) {
        return;
      }

      target.removeEventListener('dragstart', this.handleTopDragStart);
      target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
      target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
      target.removeEventListener('dragenter', this.handleTopDragEnter);
      target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
      target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
      target.removeEventListener('dragover', this.handleTopDragOver);
      target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
      target.removeEventListener('drop', this.handleTopDrop);
      target.removeEventListener('drop', this.handleTopDropCapture, true);
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return _objectSpread$l({
        dropEffect: this.altKeyPressed ? 'copy' : 'move'
      }, sourceNodeOptions || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        // It makes more sense to default to 'copy' for native resources
        return 'copy';
      }

      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return _objectSpread$l({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      }, sourcePreviewNodeOptions || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes).some(function (key) {
        return NativeTypes[key] === itemType;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function beginDragNativeItem(type, dataTransfer) {
      this.clearCurrentDragSourceNode();
      this.currentNativeSource = createNativeDragSource(type, dataTransfer);
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function setCurrentDragSourceNode(node) {
      var _this5 = this;

      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869

      var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
      // means it has ended and the drag source node disappeared from DOM,
      // so the browser didn't dispatch the dragend event.
      //
      // We need to wait before we start listening for mousemove events.
      // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
      // immediately in some browsers.
      //
      // See:
      //   * https://github.com/react-dnd/react-dnd/pull/928
      //   * https://github.com/react-dnd/react-dnd/issues/869
      //

      this.mouseMoveTimeoutTimer = setTimeout(function () {
        var _this5$rootElement;

        return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;

        if (this.rootElement) {
          var _this$window2;

          (_this$window2 = this.window) === null || _this$window2 === void 0 ? void 0 : _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
          this.rootElement.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
        }

        this.mouseMoveTimeoutTimer = null;
        return true;
      }

      return false;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e, sourceId) {
      if (e.defaultPrevented) {
        return;
      }

      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }

      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }

      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }]);

  return HTML5BackendImpl;
}();

var HTML5Backend = function createBackend(manager, context, options) {
  return new HTML5BackendImpl(manager, context, options);
};

const AddButtonWrapper = styled.div.withConfig({
  displayName: "styles__AddButtonWrapper",
  componentId: "sc-1gzd50r-0"
})(["display:none;position:absolute;right:-1px;top:50%;transform:translateY(-50%);"]);
const DragWrapper = styled.div.withConfig({
  displayName: "styles__DragWrapper",
  componentId: "sc-1gzd50r-1"
})(["margin-right:4px;display:flex;cursor:move;"]);
const StyledIcon = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1gzd50r-2"
})(["color:", ";> *:hover{color:", ";}"], ({
  theme
}) => theme.colors.board.icon.color, ({
  theme
}) => theme.colors.board.icon.hover.color);
const StyledButton = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1gzd50r-3"
})(["border-top-right-radius:0;border-bottom-right-radius:0;border-right-color:", ";:not(:hover){border-color:", ";}"], ({
  theme
}) => theme.colors.board.addButton.borderColor, ({
  theme
}) => theme.colors.board.separator.color);
const HeaderPrimary = styled.div.withConfig({
  displayName: "styles__HeaderPrimary",
  componentId: "sc-1gzd50r-4"
})(["display:flex;", ":active ~ ", "{display:none !important;}"], DragWrapper, AddButtonWrapper);
const CardHeader = styled.div.withConfig({
  displayName: "styles__CardHeader",
  componentId: "sc-1gzd50r-5"
})(["display:flex;margin-bottom:2px;justify-content:space-between;line-height:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);
const StyledCard = styled.div.withConfig({
  displayName: "styles__StyledCard",
  componentId: "sc-1gzd50r-6"
})(["box-sizing:border-box;height:100%;display:flex;flex-direction:column;padding:", ";font-size:", ";font-family:", ";font-weight:", ";&:hover{", "{display:block;}", "{color:", ";}}"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight, AddButtonWrapper, StyledIcon, ({
  theme
}) => theme.colors.board.card.hover.icon.color);
const SpinnerWrapper$1 = styled.div.withConfig({
  displayName: "styles__SpinnerWrapper",
  componentId: "sc-1gzd50r-7"
})(["height:100%;box-sizing:border-box;display:flex;align-items:center;justify-content:center;"]);
const DropdzoneWrapper = styled.div.withConfig({
  displayName: "styles__DropdzoneWrapper",
  componentId: "sc-1gzd50r-8"
})(["box-sizing:border-box;height:100%;padding:", ";"], ({
  theme
}) => theme.spacing(1));
const DropZone = styled.div.withConfig({
  displayName: "styles__DropZone",
  componentId: "sc-1gzd50r-9"
})(["box-sizing:border-box;height:100%;border-radius:8px;border:1px dashed ", ";background-color:", ";"], ({
  theme
}) => theme.colors.board.dropzone.borderColor, ({
  theme
}) => theme.colors.board.dropzone.backgroundColor);
const CardContent = styled.div.withConfig({
  displayName: "styles__CardContent",
  componentId: "sc-1gzd50r-10"
})(["flex-grow:1;width:100%;"]);
const HoverBorder = styled.div.withConfig({
  displayName: "styles__HoverBorder",
  componentId: "sc-1gzd50r-11"
})(["display:block;position:absolute;pointer-events:none;background-color:", ";height:", ";width:3px;border-radius:16px;top:", ";left:", ";"], ({
  theme
}) => theme.colors.board.separator.hover.color, ({
  coordinates,
  theme
}) => `calc(${coordinates.height}px - ${theme.spacing(2)})`, ({
  coordinates,
  theme
}) => `calc(${coordinates.y}px + ${theme.spacing(1)})`, ({
  coordinates
}) => `calc(${coordinates.x}px - ${coordinates.direction === 'left' ? 2 : 1}px);`);

const BoardWrapper = styled.div.withConfig({
  displayName: "styles__BoardWrapper",
  componentId: "sc-65mq0x-0"
})(["display:grid;grid-row-gap:2px;grid-column-gap:1px;grid-template-columns:repeat(auto-fill,minmax(216px,auto));grid-auto-rows:112px;border-radius:8px;border:", ";background-color:", ";overflow:hidden;"], ({
  theme
}) => `1px solid ${theme.colors.board.borderColor}`, ({
  theme
}) => theme.colors.board.backgroundColor);
const CardWrapper = styled.div.withConfig({
  displayName: "styles__CardWrapper",
  componentId: "sc-65mq0x-1"
})(["display:flex;flex-direction:column;position:relative;&:after,&:before{content:'';display:block;position:absolute;background-color:", ";pointer-events:none;}&:after{height:1px;width:calc(100% + 1px);bottom:-1px;}&:before{height:calc(100% - ", ");width:1px;top:", ";right:-1px;}&:last-of-type{", "{display:block;}}"], ({
  theme
}) => theme.colors.board.separator.color, ({
  theme
}) => theme.spacing(2), ({
  theme
}) => theme.spacing(1), AddButtonWrapper);

const BoardContext = /*#__PURE__*/createContext(undefined);
function useBoardContext() {
  const context = React.useContext(BoardContext);
  if (context === undefined) {
    throw new Error('BoardContext must be used within a BoardContext.Provider');
  }
  return context;
}

const StyledHint = styled.div.withConfig({
  displayName: "styles__StyledHint",
  componentId: "gqyyxa-0"
})(["cursor:pointer;display:flex;"]);

const Hint$1 = ({
  children
}) => {
  const [target, setTarget] = React.useState(null);
  const [showPopover, setShowPopover] = useState(false);
  const handleClick = e => {
    setTarget(e.currentTarget);
    setShowPopover(showPopover => !showPopover);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHint, {
    "data-testid": 'beau-board-hint'
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Hint",
    onClick: handleClick,
    "data-testid": "beau-board-hint-icon"
  })), /*#__PURE__*/React.createElement(Popover, {
    show: showPopover,
    onClose: () => setShowPopover(false),
    target: target,
    placement: "top",
    "data-testid": "beau-board-hint-popover"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, children)));
};

const MenuWrapper = styled.div.withConfig({
  displayName: "styles__MenuWrapper",
  componentId: "icxx5-0"
})(["min-width:206px;border-radius:8px;border:1px solid ", ";z-index:999;background:white;.MuiListSubheader-sticky{position:relative;background-color:unset;}"], ({
  theme
}) => theme.colors.list.outline.active);

const ItemCSS = css$1(["&.beauListItem{padding:4px 10px;min-height:auto;color:", ";background-color:", ";&:hover{color:", ";background-color:", ";.beauListItemTextTitle{font-weight:", ";}.beauListItemTextDescription{color:", ";}.beauListItemStartIcon,+ .beauListItemEndIcon{color:", ";}}&.beauListItemFocused{color:", ";background-color:", ";.beauListItemTextTitle{font-weight:", ";}.beauListItemTextDescription{color:", ";}.beauListItemStartIcon,+ .beauListItemEndIcon{color:", ";}}&.beauListItemDisabled{color:", ";opacity:1;.beauListItemStartIcon,+ .beauListItemEndIcon{color:", ";}}&:first-of-type{border-top-right-radius:inherit;border-top-left-radius:inherit;}&:last-of-type{border-bottom-right-radius:inherit;border-bottom-left-radius:inherit;}.MuiBadge-root{width:100%;}}"], ({
  theme
}) => theme.colors.list.listItem.color, ({
  theme
}) => theme.colors.list.listItem.backgroundColor, ({
  theme
}) => theme.colors.list.listItem.hover.color, ({
  theme
}) => theme.colors.list.listItem.hover.backgroundColor, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  theme
}) => theme.colors.list.listItem.hover.color, ({
  theme
}) => theme.colors.list.listItem.hover.color, ({
  theme
}) => theme.colors.list.listItem.focus.color, ({
  theme
}) => theme.colors.list.listItem.focus.backgroundColor, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight, ({
  theme
}) => theme.colors.list.listItem.focus.color, ({
  theme
}) => theme.colors.list.listItem.focus.color, ({
  theme
}) => theme.colors.list.listItem.disabled.color, ({
  theme
}) => theme.colors.list.listItem.disabled.color);
const ListItemWrapper = styled(ListItem$1).withConfig({
  displayName: "styles__ListItemWrapper",
  componentId: "sc-1pvwl7o-0"
})(["", ""], ItemCSS);
const Text = styled(ListItemText$1).withConfig({
  displayName: "styles__Text",
  componentId: "sc-1pvwl7o-1"
})(["&.beauListItemText{margin:0;.beauListItemTextTitle,.beauListItemTextDescription{display:flex;text-transform:capitalize;}.beauListItemTextDescription{color:", ";}}"], ({
  theme
}) => theme.colors.list.descriptionColor);
const StartIcon = styled(ListItemIcon$1).withConfig({
  displayName: "styles__StartIcon",
  componentId: "sc-1pvwl7o-2"
})(["&.beauListItemStartIcon{align-self:center;color:", ";min-width:calc( ", "px + ", " );}"], ({
  theme
}) => theme.colors.list.listItem.color, ({
  $size
}) => getIconDimension($size), ({
  theme
}) => theme.spacing(1));
const CheckboxWrapper$1 = styled(ListItemIcon$1).withConfig({
  displayName: "styles__CheckboxWrapper",
  componentId: "sc-1pvwl7o-3"
})(["&.beauListItemCheckbox{margin-top:4px;min-width:unset;align-self:flex-start;margin-right:", ";}"], ({
  theme
}) => theme.spacing(1));
const RadioWrapper = styled(ListItemIcon$1).withConfig({
  displayName: "styles__RadioWrapper",
  componentId: "sc-1pvwl7o-4"
})(["&.beauListItemRadio{margin-top:1px;min-width:unset;align-self:flex-start;margin-right:", ";}"], ({
  theme
}) => theme.spacing(1));

const Heading1Strong = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading1, ({
  theme
}) => theme.fonts.lineHeight.heading1, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);
const Heading2Strong = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading2, ({
  theme
}) => theme.fonts.lineHeight.heading2, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);
const Heading3Strong = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading3, ({
  theme
}) => theme.fonts.lineHeight.heading3, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);
const Heading4Regular = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.lineHeight.heading4, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.medium.fontWeight);
const Heading4Strong = css$1(["", " font-weight:", ";"], Heading4Regular, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);
const ParagraphRegular = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight);
const ParagraphStrong = css$1(["", " font-weight:", ";"], ParagraphRegular, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const CaptionRegular = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight);
const CaptionStrong = css$1(["", " font-family:", ";font-weight:", ";"], CaptionRegular, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const CaptionTabular = css$1(["", " font-family:", ";font-weight:", ";"], CaptionRegular, ({
  theme
}) => theme.fonts.roboto.fontFamily, ({
  theme
}) => theme.fonts.roboto.fontWeight.normal.fontWeight);
const TinyRegular = css$1(["font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.tiny, ({
  theme
}) => theme.fonts.lineHeight.tiny, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.normal.fontWeight);
const TinyStrong = css$1(["", " font-weight:", ";"], TinyRegular, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const TinyTabular = css$1(["", " font-family:", ";font-weight:", ";"], TinyRegular, ({
  theme
}) => theme.fonts.roboto.fontFamily, ({
  theme
}) => theme.fonts.roboto.fontWeight.normal.fontWeight);
const VariantsCSS = {
  heading1strong: Heading1Strong,
  heading2strong: Heading2Strong,
  heading3strong: Heading3Strong,
  heading4regular: Heading4Regular,
  heading4strong: Heading4Strong,
  paragraphregular: ParagraphRegular,
  paragraphstrong: ParagraphStrong,
  captionregular: CaptionRegular,
  captionstrong: CaptionStrong,
  captiontabular: CaptionTabular,
  tinystrong: TinyStrong,
  tinyregular: TinyRegular,
  tinytabular: TinyTabular
};
const TypographyWrapper = styled(Typography$1).withConfig({
  displayName: "styles__TypographyWrapper",
  componentId: "sc-1pyod7y-0"
})(["&.beauTypography{", ";letter-spacing:0;color:", ";text-transform:", ";}"], ({
  $variant
}) => VariantsCSS[$variant], ({
  $color
}) => $color, ({
  $transform
}) => $transform);

const variantMapping = {
  heading1strong: 'h1',
  heading2strong: 'h2',
  heading3strong: 'h3',
  heading4strong: 'h4',
  heading4regular: 'h4',
  paragraphstrong: 'p',
  paragraphregular: 'p',
  captionstrong: 'span',
  captionregular: 'span',
  captiontabular: 'span',
  tinystrong: 'span',
  tinyregular: 'span',
  tinytabular: 'span'
};
const Typography$2 = function ({
  className,
  children,
  variant = 'paragraphregular',
  color = 'inherit',
  transform = 'inherit',
  'data-testid': dataTestId = 'beau-typography',
  component
}) {
  return /*#__PURE__*/createElement$1(TypographyWrapper, {
    className: `beauTypography ${className}`,
    "$variant": variant,
    "$color": color,
    "$transform": transform,
    "data-testid": dataTestId,
    component: component ? component : variantMapping[variant]
  }, children);
};

const ItemContents = ({
  title,
  description,
  onClick,
  startIcon,
  endIcon,
  iconSize = 'medium',
  disabled = false,
  checked = false,
  toggleType,
  required = false,
  alert = 0
}) => /*#__PURE__*/React.createElement(Badge$2, {
  label: alert,
  anchor: false
}, toggleType === 'checkbox' && /*#__PURE__*/React.createElement(CheckboxWrapper$1, {
  className: "beauListItemCheckbox"
}, /*#__PURE__*/React.createElement(Checkbox$2, {
  name: title,
  checked: checked,
  onChange: onClick,
  disabled: disabled,
  "data-testid": "beau-list-listitem-checkbox"
})), toggleType === 'radio' && /*#__PURE__*/React.createElement(RadioWrapper, {
  className: "beauListItemRadio"
}, /*#__PURE__*/React.createElement(Radio$1, {
  name: title,
  checked: checked,
  onChange: onClick,
  disabled: disabled,
  inputPlacement: "center",
  "data-testid": "beau-list-listitem-radio"
})), startIcon && /*#__PURE__*/React.createElement(StartIcon, {
  "$size": iconSize,
  className: "beauListItemStartIcon"
}, /*#__PURE__*/React.createElement(Icon, {
  size: iconSize,
  name: startIcon,
  "data-testid": `beau-list-listitem-startIcon_${startIcon}`
})), /*#__PURE__*/React.createElement(Text, {
  disableTypography: true,
  className: "beauListItemText",
  primary: /*#__PURE__*/React.createElement(Badge$2, {
    dot: required
  }, /*#__PURE__*/React.createElement(Typography$2, {
    className: "beauListItemTextTitle"
  }, title)),
  secondary: /*#__PURE__*/React.createElement(Typography$2, {
    variant: "captionregular",
    className: "beauListItemTextDescription"
  }, description)
}), endIcon && /*#__PURE__*/React.createElement(Icon, {
  size: iconSize,
  name: endIcon,
  "data-testid": `beau-list-listitem-endIcon_${endIcon}`
}));

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const MenuItemWrapper = styled(MenuItem$1).withConfig({
  displayName: "Item__MenuItemWrapper",
  componentId: "sc-1v39qwu-0"
})(["", ""], ItemCSS);
const Item$3 = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/React.createElement(MenuItemWrapper, {
    ref: ref,
    disableRipple: true,
    onClick: props.onClick,
    disabled: props.disabled,
    className: "beauListItem",
    "data-testid": props['data-testid'],
    // eslint-disable-next-line
    // @ts-ignore
    ListItemClasses: {
      focusVisible: 'beauListItemFocused',
      disabled: 'beauListItemDisabled'
    }
  }, /*#__PURE__*/React.createElement(ItemContents, _objectSpread$m({}, props)));
});
Item$3.displayName = 'Item';

function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Item$4 = props => /*#__PURE__*/React.createElement(ListItemWrapper, {
  button: true,
  disableRipple: true,
  onClick: props.onClick,
  disabled: props.disabled,
  "data-testid": props['data-testid'],
  classes: {
    root: 'beauListItem',
    focusVisible: 'beauListItemFocused',
    disabled: 'beauListItemDisabled'
  }
}, /*#__PURE__*/React.createElement(ItemContents, _objectSpread$n({}, props)));

const Divider$1 = styled(MUIDivider).withConfig({
  displayName: "styles__Divider",
  componentId: "sc-1l9xat-0"
})(["&.MuiDivider-root{background-color:", ";}"], ({
  theme
}) => theme.colors.list.dividerColor);

const SubheaderWrapper = styled(ListSubheader$1).withConfig({
  displayName: "styles__SubheaderWrapper",
  componentId: "sc-174jb48-0"
})(["&.beauListSubheader{padding:4px 10px;}"]);

const Subheader = ({
  title,
  transform
}) => /*#__PURE__*/React.createElement(SubheaderWrapper, {
  className: "beauListSubheader",
  disableGutters: true
}, /*#__PURE__*/React.createElement(Typography$2, {
  variant: "paragraphstrong",
  transform: transform,
  color: theme.colors.list.subheaderColor
}, title));

function ownKeys$o(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$o(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Menu$1 = function ({
  'data-testid': dataTestId = 'beau-menu',
  anchorEl,
  children,
  onClose,
  placement = 'bottom'
}) {
  const isOpen = Boolean(anchorEl);
  const [listRef, setListRef] = useState(null);
  const {
    styles,
    attributes
  } = usePopper(anchorEl, listRef, {
    placement: placement,
    strategy: 'fixed',
    modifiers: [{
      name: 'flip',
      options: {
        fallbackPlacements: ['top-start', 'top-end', 'bottom-end', 'bottom-start']
      }
    }, {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 8]
      }
    }]
  });
  return isOpen ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: onClose
  }, /*#__PURE__*/React.createElement(MenuWrapper, _objectSpread$o({
    "data-testid": dataTestId,
    ref: setListRef,
    style: styles.popper
  }, attributes.popper), /*#__PURE__*/React.createElement(React.Fragment, null, children ? children : /*#__PURE__*/React.createElement(Item$3, {
    title: "No items found",
    disabled: true
  })))), anchorEl ?? document.body) : null;
};
Menu$1.Item = Item$3;
Menu$1.Divider = Divider$1;
Menu$1.Subheader = Subheader;

const StyledIcon$1 = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-1ee4ok-0"
})(["margin:0 ", ";pointer-events:none;color:", ";"], ({
  theme
}) => theme.spacing(1), ({
  open,
  theme
}) => open ? theme.colors.board.select.icon.color : 'inherit');
const StyledHeading = styled.span.withConfig({
  displayName: "styles__StyledHeading",
  componentId: "sc-1ee4ok-1"
})(["color:", ";"], ({
  open,
  theme
}) => open ? theme.colors.header.color : 'inherit');
const StyledButton$1 = styled.div.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1ee4ok-2"
})([":hover{cursor:pointer;}:hover,:active,:focus{color:", ";}"], ({
  theme
}) => theme.colors.samsungBlue.light);

const Select$1 = ({
  value,
  options,
  onChange,
  onCancel
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const buttonRef = React.useRef(null);
  const hasOptions = options.length;
  const isOpen = Boolean(anchorEl);
  const isNewCard = !value;
  useEffect(() => {
    if (isNewCard && !anchorEl) {
      setAnchorEl(() => buttonRef.current);
    }
  }, []);
  useEffect(() => {
    const handleEscape = e => {
      e.key === 'Escape' && handleCancel();
    };
    isOpen ? document.addEventListener('keydown', handleEscape, false) : document.removeEventListener('keydown', handleEscape, false);
    return () => document.removeEventListener('keydown', handleEscape, false);
  }, [isOpen]);
  const toggleMenu = () => {
    setAnchorEl(anchor => {
      if (anchor) {
        handleCancel();
        return null;
      }
      return buttonRef.current;
    });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCancel = () => {
    onCancel();
    handleClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton$1, {
    ref: buttonRef,
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement(StyledHeading, {
    open: isOpen,
    role: "heading"
  }, isNewCard ? 'Select new card' : value), /*#__PURE__*/React.createElement(StyledIcon$1, {
    open: isOpen,
    name: isOpen ? 'ArrowUp' : 'ArrowDown',
    size: "small"
  })), /*#__PURE__*/React.createElement(Menu$1, {
    anchorEl: anchorEl,
    open: isOpen,
    onClose: handleClose,
    placement: "bottom-start",
    "data-testid": "beau-board-card-select-menu"
  }, hasOptions ? options.map((label, idx) => /*#__PURE__*/React.createElement(Menu$1.Item, {
    key: `${label}${idx}`,
    title: label,
    onClick: () => onChange(label)
  })) : /*#__PURE__*/React.createElement(Menu$1.Item, {
    disabled: true,
    title: "No items found",
    onClick: handleClose
  })));
};

const Card = ({
  label,
  loading = false,
  hint,
  children,
  'data-testid': dataTestId = 'beau-board-card'
}) => {
  const {
    unSelectedCards,
    addCard,
    removeCard,
    changeCard,
    moveCard,
    findCardIndex
  } = useBoardContext();
  const ref = useRef(null);
  const originalIndex = findCardIndex(label);
  const [coordinates, setCoordinates] = useState();
  const [{
    isDragging
  }, drag, preview] = useDrag(() => ({
    type: 'Card',
    item: () => ({
      label,
      originalIndex,
      borderDirection: null
    }),
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  }), [label, originalIndex]);
  // useDrop hook is responsible for handling whether any item gets hovered or dropped on the element
  const [{
    isHovering,
    item
  }, drop] = useDrop(() => ({
    // Accept will make sure only these element type can be droppable on this element
    accept: 'Card',
    collect: monitor => ({
      isHovering: monitor.isOver(),
      item: monitor.getItem()
    }),
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.originalIndex;
      const hoverIndex = originalIndex;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientX = clientOffset.x - hoverBoundingRect.left;
      const stateBorder = hoverClientX > hoverMiddleX ? 'right' : 'left';
      if (stateBorder !== item.borderDirection) {
        setCoordinates(borderPosition(stateBorder));
        item.borderDirection = stateBorder;
      }
    },
    drop(item) {
      const dragIndex = item.originalIndex;
      const hoverIndex = originalIndex;
      const targetIndex = getTargetIndex(dragIndex, hoverIndex, item.borderDirection);
      if (dragIndex === targetIndex) {
        return;
      }
      const draggedLabel = item.label;
      moveCard(draggedLabel, targetIndex);
    }
  }), [findCardIndex, moveCard]);
  const getTargetIndex = (dragIndex, hoverIndex, direction) => {
    if (dragIndex === hoverIndex) {
      return dragIndex;
    } else if (dragIndex < hoverIndex) {
      return direction === 'left' ? hoverIndex - 1 : hoverIndex;
    } else {
      return direction === 'left' ? hoverIndex : hoverIndex + 1;
    }
  };
  useEffect(() => {
    //Initialize the first state of border: Useful when we drag between rows
    isHovering && item?.borderDirection && originalIndex !== item.originalIndex && setCoordinates(borderPosition(item.borderDirection));
  }, [isHovering]);
  drop(ref); // Initialize drag and drop into the element using its reference.
  const borderPosition = direction => {
    const rect = ref.current?.getBoundingClientRect();
    return rect ? {
      height: rect.height,
      x: direction === 'left' ? rect.x : rect.x + rect.width,
      y: rect.y + window.scrollY,
      direction
    } : undefined;
  };
  return /*#__PURE__*/React.createElement(CardWrapper, {
    ref: ref,
    "data-testid": dataTestId
  }, (() => {
    if (loading) {
      return /*#__PURE__*/React.createElement(SpinnerWrapper$1, null, /*#__PURE__*/React.createElement(Spinner, {
        "data-testid": "beau-board-card-spinner"
      }));
    } else if (isDragging) {
      return /*#__PURE__*/React.createElement(DropdzoneWrapper, null, /*#__PURE__*/React.createElement(DropZone, null));
    } else {
      return /*#__PURE__*/React.createElement(StyledCard, {
        ref: preview
      }, /*#__PURE__*/React.createElement(CardHeader, null, /*#__PURE__*/React.createElement(HeaderPrimary, null, label && /*#__PURE__*/React.createElement(DragWrapper, {
        ref: drag
      }, /*#__PURE__*/React.createElement(StyledIcon, {
        name: "Drag",
        "data-testid": "beau-board-card-dragIcon"
      })), /*#__PURE__*/React.createElement(Select$1, {
        value: label,
        options: unSelectedCards,
        onChange: newLabel => changeCard(label, newLabel),
        onCancel: () => !label && removeCard(label)
      }), label && /*#__PURE__*/React.createElement(React.Fragment, null, !!hint && /*#__PURE__*/React.createElement(Hint$1, null, hint), /*#__PURE__*/React.createElement(AddButtonWrapper, null, /*#__PURE__*/React.createElement(StyledButton, {
        small: true,
        icon: "Add",
        type: "secondary",
        disabled: unSelectedCards.length === 0,
        onClick: () => addCard(originalIndex + 1),
        "data-testid": "beau-board-card-addButton"
      })))), label && /*#__PURE__*/React.createElement(StyledIcon, {
        name: "Close",
        size: "small",
        onClick: () => removeCard(label),
        "data-testid": "beau-board-card-closeIcon"
      })), /*#__PURE__*/React.createElement(CardContent, null, children));
    }
  })(), isHovering && coordinates && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(HoverBorder, {
    coordinates: coordinates
  }), document.body));
};

const StyledButton$2 = styled(Button).withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-1rvratm-0"
})(["height:100%;border-radius:8px;font-size:", ";font-family:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily);
const AddCardWrapper = styled(CardWrapper).withConfig({
  displayName: "styles__AddCardWrapper",
  componentId: "sc-1rvratm-1"
})(["padding:", ";"], ({
  theme
}) => theme.spacing(1));

const AddCard = () => {
  const {
    addCard
  } = useBoardContext();
  return /*#__PURE__*/React.createElement(AddCardWrapper, null, /*#__PURE__*/React.createElement(StyledButton$2, {
    icon: "Add",
    type: "secondary",
    onClick: () => addCard(0),
    "data-testid": "beau-board-addCard"
  }, "Add Card"));
};

var immutabilityHelper = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */
    return typeof obj === 'object' && !('toString' in obj) ?
        Object.prototype.toString.call(obj).slice(8, -1) :
        obj;
}
var isProduction = typeof process === 'object' && process.env.NODE_ENV === 'production';
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */
        if (isProduction) {
            throw new Error('Invariant failed');
        }
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ (function (target, source) {
    getAllKeys(source).forEach(function (key) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    });
    return target;
});
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function'
    ? function (obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)); }
    /* istanbul ignore next */
    : function (obj) { return Object.keys(obj); };
function copy(object) {
    return Array.isArray(object)
        ? assign(object.constructor(object.length), object)
        : (type(object) === 'Map')
            ? new Map(object)
            : (type(object) === 'Set')
                ? new Set(object)
                : (object && typeof object === 'object')
                    ? assign(Object.create(Object.getPrototypeOf(object)), object)
                    /* istanbul ignore next */
                    : object;
}
var Context = /** @class */ (function () {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function (x, y) { return x === y; };
        this.update.newContext = function () { return new Context().update; };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function () {
            return this.update.isEquals;
        },
        set: function (value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function (directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function (object, $spec) {
        var _this = this;
        var spec = (typeof $spec === 'function') ? { $apply: $spec } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) {
            invariant(!Array.isArray(spec), function () { return "update(): You provided an invalid spec to update(). The spec may " +
                "not contain an array except as the value of $set, $push, $unshift, " +
                "$splice or any custom command allowing an array value."; });
        }
        invariant(typeof spec === 'object' && spec !== null, function () { return "update(): You provided an invalid spec to update(). The spec and " +
            "every included key path must be plain objects containing one of the " +
            ("following commands: " + Object.keys(_this.commands).join(', ') + "."); });
        var nextObject = object;
        getAllKeys(spec).forEach(function (key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) {
                    nextObject = object;
                }
            }
            else {
                var nextValueForKey = type(object) === 'Map'
                    ? _this.update(object.get(key), spec[key])
                    : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map'
                    ? nextObject.get(key)
                    : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue)
                    || typeof nextValueForKey === 'undefined'
                        && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) {
                        nextObject = copy(object);
                    }
                    if (type(nextObject) === 'Map') {
                        nextObject.set(key, nextValueForKey);
                    }
                    else {
                        nextObject[key] = nextValueForKey;
                    }
                }
            }
        });
        return nextObject;
    };
    return Context;
}());
exports.Context = Context;
var defaultCommands = {
    $push: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function (value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function (value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function (args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) {
                nextObject = copy(originalObject);
            }
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function (value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function (targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function (target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function (value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function (key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function (values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') {
            values.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (nextObject === originalObject && nextObject.get(key) !== value) {
                    nextObject = copy(originalObject);
                }
                nextObject.set(key, value);
            });
        }
        else {
            values.forEach(function (value) {
                if (nextObject === originalObject && !nextObject.has(value)) {
                    nextObject = copy(originalObject);
                }
                nextObject.add(value);
            });
        }
        return nextObject;
    },
    $remove: function (value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function (key) {
            if (nextObject === originalObject && nextObject.has(key)) {
                nextObject = copy(originalObject);
            }
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function (value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function (key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) {
                    nextObject = copy(originalObject);
                }
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function (value, original) {
        invariantApply(value);
        return value(original);
    },
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function () { return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + "."; });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function () { return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " +
        "Did you forget to wrap your parameter in an array?"; });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function () { return "Expected $splice target to be an array; got " + stringifiable(value); });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function () { return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " +
        "Did you forget to wrap your parameters in an array?"; });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function () { return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + "."; });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function () { return "Cannot have more than one key in an object with $set"; });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function () { return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue); });
    invariant(target && typeof target === 'object', function () { return "update(): $merge expects a target of type 'object'; got " + stringifiable(target); });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function () { return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget); });
}
});

var update$2 = /*@__PURE__*/getDefaultExportFromCjs(immutabilityHelper);

const Board = ({
  children,
  'data-testid': dataTestId = 'beau-board',
  onChange
}) => {
  const initialCards = useMemo(() => React.Children.toArray(children).map(({
    props: {
      label
    }
  }) => label), [children]);
  /*
   * Helper
   */
  const filterShownChildren = () => {
    return initialCards.filter(label => {
      const child = React.Children.toArray(children).find(({
        props
      }) => props.label === label);
      return child.props.isShown;
    });
  };
  /*
   * States
   */
  const [selectedCards, setSelectedCards] = useState(() => filterShownChildren());
  useEffect(() => {
    setSelectedCards(filterShownChildren());
  }, [children]);
  /*
   * Derived States
   */
  const unSelectedCards = initialCards.filter(label1 => !selectedCards.some(label2 => label1 === label2)).sort((label1, label2) => label1.localeCompare(label2));
  /*
   * Helpers
   */
  const findCardIndex = useCallback(label => {
    const card = selectedCards.find(l => l === label);
    return selectedCards.indexOf(card);
  }, [selectedCards]);
  const addCard = useCallback(index => {
    const newCards = [...selectedCards];
    newCards.splice(index, 0, '');
    setSelectedCards(update$2(selectedCards, {
      $set: newCards
    }));
  }, [selectedCards]);
  const removeCard = useCallback(label => {
    const index = findCardIndex(label);
    const newSelectedCards = update$2(selectedCards, {
      $splice: [[index, 1]]
    });
    if (label !== '' && onChange) {
      onChange(newSelectedCards);
    }
    setSelectedCards(newSelectedCards);
  }, [selectedCards, findCardIndex]);
  const changeCard = useCallback((currentLabel, newLabel) => {
    const index = findCardIndex(currentLabel);
    const newSelectedCards = update$2(selectedCards, {
      [index]: {
        $set: newLabel
      }
    });
    onChange && onChange(newSelectedCards);
    setSelectedCards(newSelectedCards);
  }, [selectedCards, findCardIndex]);
  const moveCard = useCallback((label, atIndex) => {
    const index = findCardIndex(label);
    const newSelectedCards = update$2(selectedCards, {
      $splice: [[index, 1], [atIndex, 0, label]]
    });
    onChange && onChange(newSelectedCards);
    setSelectedCards(newSelectedCards);
  }, [selectedCards, findCardIndex]);
  return /*#__PURE__*/React.createElement(BoardWrapper, {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(DndProvider, {
    backend: HTML5Backend
  }, /*#__PURE__*/React.createElement(BoardContext.Provider, {
    value: {
      unSelectedCards,
      addCard,
      removeCard,
      changeCard,
      moveCard,
      findCardIndex
    }
  }, selectedCards.length ? selectedCards.map((label, idx) => {
    const Child = React.Children.toArray(children).find(({
      props
    }) => props.label === label);
    return Child ? /*#__PURE__*/React.cloneElement(Child, {
      key: `${label}${idx}`
    }) : /*#__PURE__*/React.createElement(Card, {
      label,
      key: `${label}${idx}`
    });
  }) : /*#__PURE__*/React.createElement(AddCard, null))));
};
Board.displayName = 'Board';
Board.Card = Card;
Board.Card.displayName = 'Board.Card';

/**
 * react-number-format - 4.7.3
 * Author : Sudhanshu Yadav
 * Copyright (c) 2016, 2021 to Sudhanshu Yadav, released under the MIT license.
 * https://github.com/s-yadav/react-number-format
 */

//     

                                                               

// basic noop function
function noop$1() {}
function returnTrue() {
  return true;
}

function charIsNumber(char         ) {
  return !!(char || '').match(/\d/);
}

function isNil(val     ) {
  return val === null || val === undefined;
}

function escapeRegExp(str        ) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
}

function getThousandsGroupRegex(thousandsGroupStyle        ) {
  switch (thousandsGroupStyle) {
    case 'lakh':
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case 'wan':
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case 'thousand':
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}

function applyThousandSeparator(
  str        ,
  thousandSeparator        ,
  thousandsGroupStyle        
) {
  var thousandsGroupRegex = getThousandsGroupRegex(thousandsGroupStyle);
  var index = str.search(/[1-9]/);
  index = index === -1 ? str.length : index;
  return (
    str.substring(0, index) +
    str.substring(index, str.length).replace(thousandsGroupRegex, '$1' + thousandSeparator)
  );
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr        , allowNegative) {
  if ( allowNegative === void 0 ) allowNegative          = true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation,
  };
}

function fixLeadingZero(numStr         ) {
  if (!numStr) { return numStr; }
  var isNegative = numStr[0] === '-';
  if (isNegative) { numStr = numStr.substring(1, numStr.length); }
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return ("" + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? ("." + afterDecimal) : ''));
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr        , scale        , fixedDecimalScale         ) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

function repeat(str, count) {
  return Array(count + 1).join(str);
}

function toNumericString(num) {
  num += ''; // typecast number to string

  // store the sign and remove it from the number.
  var sign = num[0] === '-' ? '-' : '';
  if (sign) { num = num.substring(1); }

  // split the number into cofficient and exponent
  var ref = num.split(/[eE]/g);
  var coefficient = ref[0];
  var exponent = ref[1];

  // covert exponent to number;
  exponent = Number(exponent);

  // if there is no exponent part or its 0, return the coffiecient with sign
  if (!exponent) { return sign + coefficient; }

  coefficient = coefficient.replace('.', '');

  /**
   * for scientific notation the current decimal index will be after first number (index 0)
   * So effective decimal index will always be 1 + exponent value
   */
  var decimalIndex = 1 + exponent;

  var coffiecientLn = coefficient.length;

  if (decimalIndex < 0) {
    // if decimal index is less then 0 add preceding 0s
    // add 1 as join will have
    coefficient = '0.' + repeat('0', Math.abs(decimalIndex)) + coefficient;
  } else if (decimalIndex >= coffiecientLn) {
    // if decimal index is less then 0 add leading 0s
    coefficient = coefficient + repeat('0', decimalIndex - coffiecientLn);
  } else {
    // else add decimal point at proper index
    coefficient =
      (coefficient.substring(0, decimalIndex) || '0') + '.' + coefficient.substring(decimalIndex);
  }

  return sign + coefficient;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr        , scale        , fixedDecimalScale         ) {
  //if number is empty don't do anything return empty string
  if (['', '-'].indexOf(numStr) !== -1) { return numStr; }

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
  var ref = splitDecimal(numStr);
  var beforeDecimal = ref.beforeDecimal;
  var afterDecimal = ref.afterDecimal;
  var hasNagation = ref.hasNagation;
  var floatValue = parseFloat(("0." + (afterDecimal || '0')));
  var floatValueStr =
    afterDecimal.length <= scale ? ("0." + afterDecimal) : floatValue.toFixed(scale);
  var roundedDecimalParts = floatValueStr.split('.');
  var intPart = beforeDecimal
    .split('')
    .reverse()
    .reduce(function (roundedStr, current, idx) {
      if (roundedStr.length > idx) {
        return (
          (Number(roundedStr[0]) + Number(current)).toString() +
          roundedStr.substring(1, roundedStr.length)
        );
      }
      return current + roundedStr;
    }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(
    roundedDecimalParts[1] || '',
    Math.min(scale, afterDecimal.length),
    fixedDecimalScale
  );
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return ("" + negation + intPart + decimalSeparator + decimalPart);
}

/** set the caret positon in an input field **/
function setCaretPosition(el                  , caretPos        ) {
  el.value = el.value;
  // ^ this is used to not only get 'focus', but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue        , newValue        ) {
  var i = 0,
    j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) { i++; }

  //check what has been changed from last
  while (
    prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] &&
    newLength - j > i &&
    prevLength - j > i
  ) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp$1(num        , min        , max        ) {
  return Math.min(Math.max(num, min), max);
}

function getCurrentCaretPosition(el                  ) {
  /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
  return Math.max(el.selectionStart, el.selectionEnd);
}

function addInputMode(format                                   ) {
  return (
    format ||
    (typeof navigator !== 'undefined' &&
      !(navigator.platform && /iPhone|iPod/.test(navigator.platform)))
  );
}

//     
function objectWithoutProperties$1 (obj, exclude) { var target = {}; for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k]; return target; }

var defaultProps$2 = {
  displayType: 'input',
  decimalSeparator: '.',
  thousandsGroupStyle: 'thousand',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  allowLeadingZeros: false,
  isNumericString: false,
  type: 'text',
  onValueChange: noop$1,
  onChange: noop$1,
  onKeyDown: noop$1,
  onMouseUp: noop$1,
  onFocus: noop$1,
  onBlur: noop$1,
  isAllowed: returnTrue,
};
var NumberFormat = /*@__PURE__*/(function (superclass) {
  function NumberFormat(props        ) {
    superclass.call(this, props);
    var defaultValue = props.defaultValue;

    //validate props
    this.validateProps();

    var formattedValue = this.formatValueProp(defaultValue);

    this.state = {
      value: formattedValue,
      numAsString: this.removeFormatting(formattedValue),
      mounted: false,
    };

    this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  if ( superclass ) NumberFormat.__proto__ = superclass;
  NumberFormat.prototype = Object.create( superclass && superclass.prototype );
  NumberFormat.prototype.constructor = NumberFormat;

  NumberFormat.prototype.componentDidMount = function componentDidMount () {
    // set mounted state
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      mounted: true,
    });
  };

  NumberFormat.prototype.componentDidUpdate = function componentDidUpdate (prevProps        ) {
    this.updateValueIfRequired(prevProps);
  };

  NumberFormat.prototype.componentWillUnmount = function componentWillUnmount () {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);
  };

  NumberFormat.prototype.updateValueIfRequired = function updateValueIfRequired (prevProps        ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var focusedElm = ref.focusedElm;
    var stateValue = state.value;
    var lastNumStr = state.numAsString; if ( lastNumStr === void 0 ) lastNumStr = '';

    // If only state changed no need to do any thing
    if (prevProps !== props) {
      //validate props
      this.validateProps();

      var lastValueWithNewFormat = this.formatNumString(lastNumStr);

      var formattedValue = isNil(props.value) ? lastValueWithNewFormat : this.formatValueProp();
      var numAsString = this.removeFormatting(formattedValue);

      var floatValue = parseFloat(numAsString);
      var lastFloatValue = parseFloat(lastNumStr);

      if (
        //while typing set state only when float value changes
        ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue) ||
        //can also set state when float value is same and the format props changes
        lastValueWithNewFormat !== stateValue ||
        //set state always when not in focus and formatted value is changed
        (focusedElm === null && formattedValue !== stateValue)
      ) {
        this.updateValue({ formattedValue: formattedValue, numAsString: numAsString, input: focusedElm });
      }
    }
  };

  /** Misc methods **/
  NumberFormat.prototype.getFloatString = function getFloatString (num) {
    if ( num === void 0 ) num         = '';

    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var numRegex = this.getNumberRegex(true);

    //remove negation for regex check
    var hasNegation = num[0] === '-';
    if (hasNegation) { num = num.replace('-', ''); }

    //if decimal scale is zero remove decimal and number after decimalSeparator
    if (decimalSeparator && decimalScale === 0) {
      num = num.split(decimalSeparator)[0];
    }

    num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

    //remove extra decimals
    var firstDecimalIndex = num.indexOf('.');

    if (firstDecimalIndex !== -1) {
      num = (num.substring(0, firstDecimalIndex)) + "." + (num
        .substring(firstDecimalIndex + 1, num.length)
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), ''));
    }

    //add negation back
    if (hasNegation) { num = '-' + num; }

    return num;
  };

  //returned regex assumes decimalSeparator is as per prop
  NumberFormat.prototype.getNumberRegex = function getNumberRegex (g         , ignoreDecimalSeparator          ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var customNumerals = ref.customNumerals;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    return new RegExp(
      '[0-9' +
        (customNumerals ? customNumerals.join('') : '') +
        ']' +
        (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format
          ? '|' + escapeRegExp(decimalSeparator)
          : ''),
      g ? 'g' : undefined
    );
  };

  NumberFormat.prototype.getSeparators = function getSeparators () {
    var ref = this.props;
    var decimalSeparator = ref.decimalSeparator;
    var ref$1 = this.props;
    var thousandSeparator = ref$1.thousandSeparator;
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;

    if (thousandSeparator === true) {
      thousandSeparator = ',';
    }
    if (!allowedDecimalSeparators) {
      allowedDecimalSeparators = [decimalSeparator, '.'];
    }

    return {
      decimalSeparator: decimalSeparator,
      thousandSeparator: thousandSeparator,
      allowedDecimalSeparators: allowedDecimalSeparators,
    };
  };

  NumberFormat.prototype.getMaskAtIndex = function getMaskAtIndex (index        ) {
    var ref = this.props;
    var mask = ref.mask; if ( mask === void 0 ) mask = ' ';
    if (typeof mask === 'string') {
      return mask;
    }

    return mask[index] || ' ';
  };

  NumberFormat.prototype.getValueObject = function getValueObject (formattedValue        , numAsString        ) {
    var floatValue = parseFloat(numAsString);

    return {
      formattedValue: formattedValue,
      value: numAsString,
      floatValue: isNaN(floatValue) ? undefined : floatValue,
    };
  };

  NumberFormat.prototype.validateProps = function validateProps () {
    var ref = this.props;
    var mask = ref.mask;

    //validate decimalSeparator and thousandSeparator
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;
    var thousandSeparator = ref$1.thousandSeparator;

    if (decimalSeparator === thousandSeparator) {
      throw new Error(("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: " + thousandSeparator + " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: " + decimalSeparator + " (default value for decimalSeparator is .)\n       "));
    }

    //validate mask
    if (mask) {
      var maskAsStr = mask === 'string' ? mask : mask.toString();
      if (maskAsStr.match(/\d/g)) {
        throw new Error(("\n          Mask " + mask + " should not contain numeric character;\n        "));
      }
    }
  };
  /** Misc methods end **/

  /** caret specific methods **/
  NumberFormat.prototype.setPatchedCaretPosition = function setPatchedCaretPosition (el                  , caretPos        , currentValue        ) {
    /* setting caret position within timeout of 0ms is required for mobile chrome,
    otherwise browser resets the caret position after we set it
    We are also setting it without timeout so that in normal browser we don't see the flickering */
    setCaretPosition(el, caretPos);
    this.caretPositionTimeout = setTimeout(function () {
      if (el.value === currentValue) { setCaretPosition(el, caretPos); }
    }, 0);
  };

  /* This keeps the caret within typing area so people can't type in between prefix or suffix */
  NumberFormat.prototype.correctCaretPosition = function correctCaretPosition (value        , caretPos        , direction         ) {
    var ref = this.props;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;

    //if value is empty return 0
    if (value === '') { return 0; }

    //caret position should be between 0 and value length
    caretPos = clamp$1(caretPos, 0, value.length);

    //in case of format as number limit between prefix and suffix
    if (!format) {
      var hasNegation = value[0] === '-';
      return clamp$1(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
    }

    //in case if custom format method don't do anything
    if (typeof format === 'function') { return caretPos; }

    /* in case format is string find the closest # position from the caret position */

    //in case the caretPos have input value on it don't do anything
    if (format[caretPos] === '#' && charIsNumber(value[caretPos])) {
      return caretPos;
    }

    //if caretPos is just after input value don't do anything
    if (format[caretPos - 1] === '#' && charIsNumber(value[caretPos - 1])) {
      return caretPos;
    }

    //find the nearest caret position
    var firstHashPosition = format.indexOf('#');
    var lastHashPosition = format.lastIndexOf('#');

    //limit the cursor between the first # position and the last # position
    caretPos = clamp$1(caretPos, firstHashPosition, lastHashPosition + 1);

    var nextPos = format.substring(caretPos, format.length).indexOf('#');
    var caretLeftBound = caretPos;
    var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

    //get the position where the last number is present
    while (
      caretLeftBound > firstHashPosition &&
      (format[caretLeftBound] !== '#' || !charIsNumber(value[caretLeftBound]))
    ) {
      caretLeftBound -= 1;
    }

    var goToLeft =
      !charIsNumber(value[caretRightBound]) ||
      (direction === 'left' && caretPos !== firstHashPosition) ||
      caretPos - caretLeftBound < caretRightBound - caretPos;

    if (goToLeft) {
      //check if number should be taken after the bound or after it
      //if number preceding a valid number keep it after
      return charIsNumber(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
    }

    return caretRightBound;
  };

  NumberFormat.prototype.getCaretPosition = function getCaretPosition (inputValue        , formattedValue        , caretPos        ) {
    var ref = this.props;
    var format = ref.format;
    var stateValue = this.state.value;
    var numRegex = this.getNumberRegex(true);
    var inputNumber = (inputValue.match(numRegex) || []).join('');
    var formattedNumber = (formattedValue.match(numRegex) || []).join('');
    var j, i;

    j = 0;

    for (i = 0; i < caretPos; i++) {
      var currentInputChar = inputValue[i] || '';
      var currentFormatChar = formattedValue[j] || '';
      //no need to increase new cursor position if formatted value does not have those characters
      //case inputValue = 1a23 and formattedValue =  123
      if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) {
        continue;
      }

      //When we are striping out leading zeros maintain the new cursor position
      //Case inputValue = 00023 and formattedValue = 23;
      if (
        currentInputChar === '0' &&
        currentFormatChar.match(numRegex) &&
        currentFormatChar !== '0' &&
        inputNumber.length !== formattedNumber.length
      ) {
        continue;
      }

      //we are not using currentFormatChar because j can change here
      while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
        j++;
      }
      j++;
    }

    if (typeof format === 'string' && !stateValue) {
      //set it to the maximum value so it goes after the last number
      j = formattedValue.length;
    }

    //correct caret position if its outside of editable area
    j = this.correctCaretPosition(formattedValue, j);

    return j;
  };
  /** caret specific methods ends **/

  /** methods to remove formattting **/
  NumberFormat.prototype.removePrefixAndSuffix = function removePrefixAndSuffix (val        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;

    //remove prefix and suffix
    if (!format && val) {
      var isNegative = val[0] === '-';

      //remove negation sign
      if (isNegative) { val = val.substring(1, val.length); }

      //remove prefix
      val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

      //remove suffix
      var suffixLastIndex = val.lastIndexOf(suffix);
      val =
        suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length
          ? val.substring(0, suffixLastIndex)
          : val;

      //add negation sign back
      if (isNegative) { val = '-' + val; }
    }

    return val;
  };

  NumberFormat.prototype.removePatternFormatting = function removePatternFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var formatArray = format.split('#').filter(function (str) { return str !== ''; });
    var start = 0;
    var numStr = '';

    for (var i = 0, ln = formatArray.length; i <= ln; i++) {
      var part = formatArray[i] || '';

      //if i is the last fragment take the index of end of the value
      //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
      var index = i === ln ? val.length : val.indexOf(part, start);

      /* in any case if we don't find the pattern part in the value assume the val as numeric string
      This will be also in case if user has started typing, in any other case it will not be -1
      unless wrong prop value is provided */
      if (index === -1) {
        numStr = val;
        break;
      } else {
        numStr += val.substring(start, index);
        start = index + part.length;
      }
    }

    return (numStr.match(/\d/g) || []).join('');
  };

  NumberFormat.prototype.removeFormatting = function removeFormatting (val        ) {
    var ref = this.props;
    var format = ref.format;
    var removeFormatting = ref.removeFormatting;
    if (!val) { return val; }

    if (!format) {
      val = this.removePrefixAndSuffix(val);
      val = this.getFloatString(val);
    } else if (typeof format === 'string') {
      val = this.removePatternFormatting(val);
    } else if (typeof removeFormatting === 'function') {
      //condition need to be handled if format method is provide,
      val = removeFormatting(val);
    } else {
      val = (val.match(/\d/g) || []).join('');
    }
    return val;
  };
  /** methods to remove formattting end **/

  /*** format specific methods start ***/
  /**
   * Format when # based string is provided
   * @param  {string} numStr Numeric String
   * @return {string}        formatted Value
   */
  NumberFormat.prototype.formatWithPattern = function formatWithPattern (numStr        ) {
    var ref = this.props;
    var format = ref.format;
    var hashCount = 0;
    var formattedNumberAry = format.split('');
    for (var i = 0, ln = format.length; i < ln; i++) {
      if (format[i] === '#') {
        formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
        hashCount += 1;
      }
    }
    return formattedNumberAry.join('');
  };
  /**
   * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
   * @return {string} formatted Value
   */
  NumberFormat.prototype.formatAsNumber = function formatAsNumber (numStr        ) {
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var allowNegative = ref.allowNegative;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var ref$1 = this.getSeparators();
    var thousandSeparator = ref$1.thousandSeparator;
    var decimalSeparator = ref$1.decimalSeparator;

    var hasDecimalSeparator = numStr.indexOf('.') !== -1 || (decimalScale && fixedDecimalScale);
    var ref$2 = splitDecimal(numStr, allowNegative);
    var beforeDecimal = ref$2.beforeDecimal;
    var afterDecimal = ref$2.afterDecimal;
    var addNegation = ref$2.addNegation; // eslint-disable-line prefer-const

    //apply decimal precision if its defined
    if (decimalScale !== undefined) {
      afterDecimal = limitToScale(afterDecimal, decimalScale, fixedDecimalScale);
    }

    if (thousandSeparator) {
      beforeDecimal = applyThousandSeparator(beforeDecimal, thousandSeparator, thousandsGroupStyle);
    }

    //add prefix and suffix
    if (prefix) { beforeDecimal = prefix + beforeDecimal; }
    if (suffix) { afterDecimal = afterDecimal + suffix; }

    //restore negation sign
    if (addNegation) { beforeDecimal = '-' + beforeDecimal; }

    numStr = beforeDecimal + ((hasDecimalSeparator && decimalSeparator) || '') + afterDecimal;

    return numStr;
  };

  NumberFormat.prototype.formatNumString = function formatNumString (numStr) {
    if ( numStr === void 0 ) numStr         = '';

    var ref = this.props;
    var format = ref.format;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var customNumerals = ref.customNumerals;
    var formattedValue = numStr;

    if (customNumerals && customNumerals.length === 10) {
      var customNumeralRegex = new RegExp('[' + customNumerals.join('') + ']', 'g');
      formattedValue = numStr.replace(customNumeralRegex, function (digit) { return customNumerals.indexOf(digit).toString(); }
      );
    }

    if (numStr === '' && !allowEmptyFormatting) {
      formattedValue = '';
    } else if (numStr === '-' && !format) {
      formattedValue = '-';
    } else if (typeof format === 'string') {
      formattedValue = this.formatWithPattern(formattedValue);
    } else if (typeof format === 'function') {
      formattedValue = format(formattedValue);
    } else {
      formattedValue = this.formatAsNumber(formattedValue);
    }

    return formattedValue;
  };

  NumberFormat.prototype.formatValueProp = function formatValueProp (defaultValue                 ) {
    var ref = this.props;
    var format = ref.format;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var ref$1 = this.props;
    var value = ref$1.value;
    var isNumericString = ref$1.isNumericString;

    // if value is undefined or null, use defaultValue instead
    value = isNil(value) ? defaultValue : value;

    var isNonNumericFalsy = !value && value !== 0;

    if (isNonNumericFalsy && allowEmptyFormatting) {
      value = '';
    }

    // if value is not defined return empty string
    if (isNonNumericFalsy && !allowEmptyFormatting) { return ''; }

    if (typeof value === 'number') {
      value = toNumericString(value);
      isNumericString = true;
    }

    //change infinity value to empty string
    if (value === 'Infinity' && isNumericString) {
      value = '';
    }

    //round the number based on decimalScale
    //format only if non formatted value is provided
    if (isNumericString && !format && typeof decimalScale === 'number') {
      value = roundToPrecision(value, decimalScale, fixedDecimalScale);
    }

    var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

    return formattedValue;
  };

  NumberFormat.prototype.formatNegation = function formatNegation (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var allowNegative = ref.allowNegative;
    var negationRegex = new RegExp('(-)');
    var doubleNegationRegex = new RegExp('(-)(.)*(-)');

    // Check number has '-' value
    var hasNegation = negationRegex.test(value);

    // Check number has 2 or more '-' values
    var removeNegation = doubleNegationRegex.test(value);

    //remove negation
    value = value.replace(/-/g, '');

    if (hasNegation && !removeNegation && allowNegative) {
      value = '-' + value;
    }

    return value;
  };

  NumberFormat.prototype.formatInput = function formatInput (value) {
    if ( value === void 0 ) value         = '';

    var ref = this.props;
    var format = ref.format;

    //format negation only if we are formatting as number
    if (!format) {
      value = this.removePrefixAndSuffix(value);
      value = this.formatNegation(value);
    }

    //remove formatting from number
    value = this.removeFormatting(value);

    return this.formatNumString(value);
  };

  /*** format specific methods end ***/
  NumberFormat.prototype.isCharacterAFormat = function isCharacterAFormat (caretPos        , value        ) {
    var ref = this.props;
    var format = ref.format;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var ref$1 = this.getSeparators();
    var decimalSeparator = ref$1.decimalSeparator;

    //check within format pattern
    if (typeof format === 'string' && format[caretPos] !== '#') { return true; }

    //check in number format
    if (
      !format &&
      (caretPos < prefix.length ||
        caretPos >= value.length - suffix.length ||
        (decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator))
    ) {
      return true;
    }

    return false;
  };

  /**
   * This will check if any formatting got removed by the delete or backspace and reset the value
   * It will also work as fallback if android chome keyDown handler does not work
   **/
  NumberFormat.prototype.correctInputValue = function correctInputValue (caretPos        , lastValue        , value        ) {
    var this$1 = this;

    var ref = this.props;
    var format = ref.format;
    var allowNegative = ref.allowNegative;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var decimalScale = ref.decimalScale;
    var ref$1 = this.getSeparators();
    var allowedDecimalSeparators = ref$1.allowedDecimalSeparators;
    var decimalSeparator = ref$1.decimalSeparator;
    var lastNumStr = this.state.numAsString || '';
    var ref$2 = this.selectionBeforeInput;
    var selectionStart = ref$2.selectionStart;
    var selectionEnd = ref$2.selectionEnd;
    var ref$3 = findChangedIndex(lastValue, value);
    var start = ref$3.start;
    var end = ref$3.end;

    /** Check for any allowed decimal separator is added in the numeric format and replace it with decimal separator */
    if (
      !format &&
      start === end &&
      allowedDecimalSeparators.indexOf(value[selectionStart]) !== -1
    ) {
      var separator = decimalScale === 0 ? '' : decimalSeparator;
      return (
        value.substr(0, selectionStart) + separator + value.substr(selectionStart + 1, value.length)
      );
    }

    var leftBound = !!format ? 0 : prefix.length;
    var rightBound = lastValue.length - (!!format ? 0 : suffix.length);

    if (
      // don't do anything if something got added
      value.length > lastValue.length ||
      // or if the new value is an empty string
      !value.length ||
      // or if nothing has changed, in which case start will be same as end
      start === end ||
      // or in case if whole input is selected and new value is typed
      (selectionStart === 0 && selectionEnd === lastValue.length) ||
      // or in case if the whole content is replaced by browser, example (autocomplete)
      (start === 0 && end === lastValue.length) ||
      // or if charcters between prefix and suffix is selected.
      // For numeric inputs we apply the format so, prefix and suffix can be ignored
      (selectionStart === leftBound && selectionEnd === rightBound)
    ) {
      return value;
    }

    // check whether the deleted portion has a character that is part of a format
    var deletedValues = lastValue.substr(start, end - start);
    var formatGotDeleted = !![].concat( deletedValues ).find(function (deletedVal, idx) { return this$1.isCharacterAFormat(idx + start, lastValue); }
    );

    // if it has, only remove characters that are not part of the format
    if (formatGotDeleted) {
      var deletedValuePortion = lastValue.substr(start);
      var recordIndexOfFormatCharacters = {};
      var resolvedPortion = [];
      [].concat( deletedValuePortion ).forEach(function (currentPortion, idx) {
        if (this$1.isCharacterAFormat(idx + start, lastValue)) {
          recordIndexOfFormatCharacters[idx] = currentPortion;
        } else if (idx > deletedValues.length - 1) {
          resolvedPortion.push(currentPortion);
        }
      });

      Object.keys(recordIndexOfFormatCharacters).forEach(function (idx) {
        if (resolvedPortion.length > idx) {
          resolvedPortion.splice(idx, 0, recordIndexOfFormatCharacters[idx]);
        } else {
          resolvedPortion.push(recordIndexOfFormatCharacters[idx]);
        }
      });

      value = lastValue.substr(0, start) + resolvedPortion.join('');
    }

    //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
    //clear all numbers in such case while keeping the - sign
    if (!format) {
      var numericString = this.removeFormatting(value);
      var ref$4 = splitDecimal(
        numericString,
        allowNegative
      );
      var beforeDecimal = ref$4.beforeDecimal;
      var afterDecimal = ref$4.afterDecimal;
      var addNegation = ref$4.addNegation; // eslint-disable-line prefer-const

      //clear only if something got deleted
      var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
      if (
        numericString.length < lastNumStr.length &&
        isBeforeDecimalPoint &&
        beforeDecimal === '' &&
        !parseFloat(afterDecimal)
      ) {
        return addNegation ? '-' : '';
      }
    }

    return value;
  };

  /** Update value and caret position */
  NumberFormat.prototype.updateValue = function updateValue (params   
                           
                        
                       
                            
                     
                              
   ) {
    var formattedValue = params.formattedValue;
    var input = params.input;
    var setCaretPosition = params.setCaretPosition; if ( setCaretPosition === void 0 ) setCaretPosition = true;
    var numAsString = params.numAsString;
    var caretPos = params.caretPos;
    var ref = this.props;
    var onValueChange = ref.onValueChange;
    var ref$1 = this.state;
    var lastValue = ref$1.value;

    if (input) {
      //set caret position, and value imperatively when element is provided
      if (setCaretPosition) {
        //calculate caret position if not defined
        if (!caretPos) {
          var inputValue = params.inputValue || input.value;

          var currentCaretPosition = getCurrentCaretPosition(input);

          /**
           * set the value imperatively, this is required for IE fix
           * This is also required as if new caret position is beyond the previous value.
           * Caret position will not be set correctly
           */
          input.value = formattedValue;

          //get the caret position
          caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);
        }

        //set caret position
        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      } else {
        /**
         * if we are not setting caret position set the value imperatively.
         * This is required on onBlur method
         */
        input.value = formattedValue;
      }
    }

    //calculate numeric string if not passed
    if (numAsString === undefined) {
      numAsString = this.removeFormatting(formattedValue);
    }

    //update state if value is changed
    if (formattedValue !== lastValue) {
      this.setState({ value: formattedValue, numAsString: numAsString });

      // trigger onValueChange synchronously, so parent is updated along with the number format. Fix for #277, #287
      onValueChange(this.getValueObject(formattedValue, numAsString));
    }
  };

  NumberFormat.prototype.onChange = function onChange (e                     ) {
    var el = e.target;
    var inputValue = el.value;
    var ref = this;
    var state = ref.state;
    var props = ref.props;
    var isAllowed = props.isAllowed;
    var lastValue = state.value || '';

    var currentCaretPosition = getCurrentCaretPosition(el);

    inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

    var formattedValue = this.formatInput(inputValue) || '';
    var numAsString = this.removeFormatting(formattedValue);

    var valueObj = this.getValueObject(formattedValue, numAsString);
    var isChangeAllowed = isAllowed(valueObj);

    if (!isChangeAllowed) {
      formattedValue = lastValue;
    }

    this.updateValue({ formattedValue: formattedValue, numAsString: numAsString, inputValue: inputValue, input: el });

    if (isChangeAllowed) {
      props.onChange(e);
    }
  };

  NumberFormat.prototype.onBlur = function onBlur (e                     ) {
    var ref = this;
    var props = ref.props;
    var state = ref.state;
    var format = props.format;
    var onBlur = props.onBlur;
    var allowLeadingZeros = props.allowLeadingZeros;
    var numAsString = state.numAsString;
    var lastValue = state.value;
    this.focusedElm = null;

    clearTimeout(this.focusTimeout);
    clearTimeout(this.caretPositionTimeout);

    if (!format) {
      // if the numAsString is not a valid number reset it to empty
      if (isNaN(parseFloat(numAsString))) {
        numAsString = '';
      }

      if (!allowLeadingZeros) {
        numAsString = fixLeadingZero(numAsString);
      }

      var formattedValue = this.formatNumString(numAsString);

      //change the state
      if (formattedValue !== lastValue) {
        // the event needs to be persisted because its properties can be accessed in an asynchronous way
        this.updateValue({
          formattedValue: formattedValue,
          numAsString: numAsString,
          input: e.target,
          setCaretPosition: false,
        });
        onBlur(e);
        return;
      }
    }
    onBlur(e);
  };

  NumberFormat.prototype.onKeyDown = function onKeyDown (e                             ) {
    var el = e.target;
    var key = e.key;
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';
    var expectedCaretPosition;
    var ref = this.props;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var format = ref.format;
    var onKeyDown = ref.onKeyDown;
    var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
    var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
    var negativeRegex = new RegExp('-');
    var isPatternFormat = typeof format === 'string';

    this.selectionBeforeInput = {
      selectionStart: selectionStart,
      selectionEnd: selectionEnd,
    };

    //Handle backspace and delete against non numerical/decimal characters or arrow keys
    if (key === 'ArrowLeft' || key === 'Backspace') {
      expectedCaretPosition = selectionStart - 1;
    } else if (key === 'ArrowRight') {
      expectedCaretPosition = selectionStart + 1;
    } else if (key === 'Delete') {
      expectedCaretPosition = selectionStart;
    }

    //if expectedCaretPosition is not set it means we don't want to Handle keyDown
    //also if multiple characters are selected don't handle
    if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
      onKeyDown(e);
      return;
    }

    var newCaretPosition = expectedCaretPosition;
    var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
    var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

    if (key === 'ArrowLeft' || key === 'ArrowRight') {
      var direction = key === 'ArrowLeft' ? 'left' : 'right';
      newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
    } else if (
      key === 'Delete' &&
      !numRegex.test(value[expectedCaretPosition]) &&
      !negativeRegex.test(value[expectedCaretPosition])
    ) {
      while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
        newCaretPosition++;
      }
    } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
      /* NOTE: This is special case when backspace is pressed on a
      negative value while the cursor position is after prefix. We can't handle it on onChange because
      we will not have any information of keyPress
      */
      if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
        var newValue = value.substring(1);
        this.updateValue({
          formattedValue: newValue,
          caretPos: newCaretPosition,
          input: el,
        });
      } else if (!negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
          newCaretPosition--;
        }
        newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
      }
    }

    if (
      newCaretPosition !== expectedCaretPosition ||
      expectedCaretPosition < leftBound ||
      expectedCaretPosition > rightBound
    ) {
      e.preventDefault();
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
            Remove this when you find different solution */
    if (e.isUnitTestRun) {
      this.setPatchedCaretPosition(el, newCaretPosition, value);
    }

    onKeyDown(e);
  };

  /** required to handle the caret position when click anywhere within the input **/
  NumberFormat.prototype.onMouseUp = function onMouseUp (e                          ) {
    var el = e.target;

    /**
     * NOTE: we have to give default value for value as in case when custom input is provided
     * value can come as undefined when nothing is provided on value prop.
     */
    var selectionStart = el.selectionStart;
    var selectionEnd = el.selectionEnd;
    var value = el.value; if ( value === void 0 ) value = '';

    if (selectionStart === selectionEnd) {
      var caretPosition = this.correctCaretPosition(value, selectionStart);
      if (caretPosition !== selectionStart) {
        this.setPatchedCaretPosition(el, caretPosition, value);
      }
    }

    this.props.onMouseUp(e);
  };

  NumberFormat.prototype.onFocus = function onFocus (e                     ) {
    var this$1 = this;

    // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
    // (onFocus event target selectionStart is always 0 before setTimeout)
    e.persist();

    this.focusedElm = e.target;
    this.focusTimeout = setTimeout(function () {
      var el = e.target;
      var selectionStart = el.selectionStart;
      var selectionEnd = el.selectionEnd;
      var value = el.value; if ( value === void 0 ) value = '';

      var caretPosition = this$1.correctCaretPosition(value, selectionStart);

      //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
      if (
        caretPosition !== selectionStart &&
        !(selectionStart === 0 && selectionEnd === value.length)
      ) {
        this$1.setPatchedCaretPosition(el, caretPosition, value);
      }

      this$1.props.onFocus(e);
    }, 0);
  };

  NumberFormat.prototype.render = function render () {
    var ref = this.props;
    var type = ref.type;
    var displayType = ref.displayType;
    var customInput = ref.customInput;
    var renderText = ref.renderText;
    var getInputRef = ref.getInputRef;
    var format = ref.format;
    var thousandSeparator = ref.thousandSeparator;
    var decimalSeparator = ref.decimalSeparator;
    var allowedDecimalSeparators = ref.allowedDecimalSeparators;
    var thousandsGroupStyle = ref.thousandsGroupStyle;
    var decimalScale = ref.decimalScale;
    var fixedDecimalScale = ref.fixedDecimalScale;
    var prefix = ref.prefix;
    var suffix = ref.suffix;
    var removeFormatting = ref.removeFormatting;
    var mask = ref.mask;
    var defaultValue = ref.defaultValue;
    var isNumericString = ref.isNumericString;
    var allowNegative = ref.allowNegative;
    var allowEmptyFormatting = ref.allowEmptyFormatting;
    var allowLeadingZeros = ref.allowLeadingZeros;
    var onValueChange = ref.onValueChange;
    var isAllowed = ref.isAllowed;
    var customNumerals = ref.customNumerals;
    var onChange = ref.onChange;
    var onKeyDown = ref.onKeyDown;
    var onMouseUp = ref.onMouseUp;
    var onFocus = ref.onFocus;
    var onBlur = ref.onBlur;
    var propValue = ref.value;
    var rest = objectWithoutProperties$1( ref, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "thousandSeparator", "decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "decimalScale", "fixedDecimalScale", "prefix", "suffix", "removeFormatting", "mask", "defaultValue", "isNumericString", "allowNegative", "allowEmptyFormatting", "allowLeadingZeros", "onValueChange", "isAllowed", "customNumerals", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value"] );
    var otherProps = rest;
    var ref$1 = this.state;
    var value = ref$1.value;
    var mounted = ref$1.mounted;

    // add input mode on element based on format prop and device once the component is mounted
    var inputMode = mounted && addInputMode(format) ? 'numeric' : undefined;

    var inputProps = Object.assign({ inputMode: inputMode }, otherProps, {
      type: type,
      value: value,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onMouseUp: this.onMouseUp,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
    });

    if (displayType === 'text') {
      return renderText ? (
        renderText(value, otherProps) || null
      ) : (
        React.createElement( 'span', Object.assign({}, otherProps, { ref: getInputRef }),
          value
        )
      );
    } else if (customInput) {
      var CustomInput = customInput;
      return React.createElement( CustomInput, Object.assign({}, inputProps, { ref: getInputRef }));
    }

    return React.createElement( 'input', Object.assign({}, inputProps, { ref: getInputRef }));
  };

  return NumberFormat;
}(React.Component));

NumberFormat.defaultProps = defaultProps$2;

const BaseInputWrapper$2 = styled(NumberFormat).withConfig({
  displayName: "styles__BaseInputWrapper",
  componentId: "b6jlbc-0"
})(({
  theme
}) => `
  display: block;
  padding: 0;
  position: relative;
  width: 100%;
  height: 32px;
  min-width: 0;
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-style: normal;
  font-weight: ${theme.fonts.samsungOne.fontWeight.normal.fontWeight};
  font-size: ${theme.fonts.fontSize.paragraph};
  line-height: ${theme.fonts.lineHeight.paragraph};
  color: ${theme.colors.input.color};
  box-sizing: border-box;
  border-width: 0px;
  
  // Remove arrow type number on Webkit
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  // Remove arrow type number on Firefox
  &[type=number] {
    -moz-appearance: textfield;
  }

  &:focus,
  &:active,
  &:read-only,
  &:disabled {
    outline-style: none;
  }
  
  &:disabled {
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
        color: ${theme.colors.input.disabled.color};
  }
  &:read-only {
        background-color: ${theme.colors.input.readOnly.backgroundColor};
        border-color: ${theme.colors.input.readOnly.borderColor};
  }
  &:focus {
        border-color: ${theme.colors.input.isFocused.borderColor};
  }
`);

const InputContext$2 = /*#__PURE__*/React.createContext(undefined);
function useInputContext$2() {
  const context = React.useContext(InputContext$2);
  if (context === undefined) {
    throw new Error('InputContext must be used within a InputContext.Provider');
  }
  return context;
}
const outsideTheRange = (value, min, max) => isNumber(value) ? isNumber(max) && value > max || isNumber(min) && value < min : false;
const isNumber = value => typeof value === 'number';
const nFormatter = (num, digits = 2, dropTrailingZeros) => {
  const lookup = [{
    value: 1e18,
    symbol: 'E'
  }, {
    value: 1e15,
    symbol: 'P'
  }, {
    value: 1e12,
    symbol: 'T'
  }, {
    value: 1e9,
    symbol: 'B'
  }, {
    value: 1e6,
    symbol: 'M'
  }];
  if (num < 1e6) {
    return Number(num.toFixed(digits));
  }
  const item = lookup.find(el => {
    return num >= el.value;
  });
  const result = item ? (num / item.value).toFixed(digits) : num.toFixed(digits);
  return `${dropTrailingZeros ? Number(result) : result}${item ? item.symbol : ''}`;
};

const BaseInput$2 = /*#__PURE__*/React.forwardRef(({
  style,
  className
}, forwardedRef) => {
  const {
    name,
    value: _value,
    min,
    max,
    decimalPrecision,
    readOnly,
    required,
    disabled,
    placeholder,
    thousandSeparator,
    allowNegative,
    hasError,
    onChange,
    onKeyDown,
    onBlur,
    onFocus
  } = useInputContext$2();
  const value = _value ?? ''; //Reset value case: https://github.com/s-yadav/react-number-format/issues/528
  const handleChange = ({
    floatValue
  }) => {
    onChange(floatValue ?? null);
  };
  return /*#__PURE__*/React.createElement(BaseInputWrapper$2, {
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-invalid": hasError,
    ref: forwardedRef,
    style: style,
    className: className,
    id: name,
    name: name,
    value: value,
    placeholder: placeholder,
    thousandSeparator: thousandSeparator,
    decimalScale: decimalPrecision,
    allowNegative: allowNegative,
    onValueChange: handleChange,
    readOnly: readOnly,
    required: required,
    disabled: disabled,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown
  });
});
BaseInput$2.displayName = 'BaseInput';

const Field$2 = styled(BaseInput$2).attrs(({
  'data-testid': dataTestId = 'beau-input-field'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Field",
  componentId: "sc-183ykf-0"
})(["flex-grow:1;width:initial;"]);

const Label$5 = styled.div.attrs(({
  'data-testid': dataTestId = 'beau-input-label'
}) => ({
  'data-testid': dataTestId
})).withConfig({
  displayName: "Label",
  componentId: "sc-1ebntnt-0"
})(["display:flex;align-items:center;padding-left:", ";padding-right:", ";background-color:", ";font-family:", ";font-style:normal;font-weight:normal;font-size:", ";"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.colors.neutrals.lightGrey, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph);

const InputWrapper$4 = styled.div.withConfig({
  displayName: "styles__InputWrapper",
  componentId: "sc-5lvfz7-0"
})(["display:inline-flex;width:100%;border-width:1px;border-style:solid;border-radius:8px;overflow:hidden;box-sizing:border-box;> *:not(input){padding:0 8px;}> *:not(", "):first-child{padding-left:8px;}> *:not(", "):last-child{padding-right:8px;}> ", ":first-child{margin-right:8px;border-right:1px solid ", ";}> ", ":last-child{margin-left:8px;border-left:1px solid ", ";}", ""], Label$5, Label$5, Label$5, ({
  theme
}) => theme.colors.input.readOnly.borderColor, Label$5, ({
  theme
}) => theme.colors.input.readOnly.borderColor, ({
  readOnly,
  disabled,
  isFocused,
  error,
  theme
}) => {
  if (readOnly) {
    return `
        outline-style: none;
        background-color: ${theme.colors.input.readOnly.backgroundColor};
        border-color: ${theme.colors.input.readOnly.borderColor};
    `;
  }
  if (disabled) {
    return `
        outline-style: none;
        cursor:not-allowed;
        background-color: ${theme.colors.input.disabled.backgroundColor};
        border-color: ${theme.colors.input.disabled.borderColor};
    `;
  }
  if (error) {
    return `
        border-color: ${theme.colors.input.error.borderColor};
      `;
  }
  if (isFocused) {
    return `
        background-color: ${theme.colors.input.backgroundColor};
        border-color: ${theme.colors.input.isFocused.borderColor};
        outline-style: none;
    `;
  }
  return `
      background-color: ${theme.colors.input.backgroundColor};
      border-color: ${theme.colors.input.borderColor};
    `;
});
const Item$5 = styled.div.withConfig({
  displayName: "styles__Item",
  componentId: "sc-5lvfz7-1"
})(["display:flex;align-items:center;> *{padding:0 2px;}> *:first-child{padding-left:0;}> *:last-child{padding-right:0;}"]);

function ownKeys$p(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$p(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$p(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$p(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const Icon$3 = _ref => {
  let {
      primary,
      'data-testid': dataTestId = 'beau-input-icon'
    } = _ref,
    props = _objectWithoutProperties(_ref, ["primary", "data-testid"]);
  const color = primary ? theme.colors.input.icon.primary.color : theme.colors.input.icon.default.color;
  return /*#__PURE__*/React.createElement(Item$5, {
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Icon, _objectSpread$p({
    color: color
  }, props)));
};

const HintWrapper = styled.span.withConfig({
  displayName: "styles__HintWrapper",
  componentId: "sc-4zwsqg-0"
})(({
  theme,
  error
}) => `
  font-size: ${theme.fonts.fontSize.caption};
  line-height: ${theme.fonts.lineHeight.caption};
  font-family: ${theme.fonts.samsungOne.fontFamily};
  font-weight: ${theme.fonts.samsungOne.fontWeight.normal.fontWeight};
  color: ${error ? theme.colors.input.error.color : theme.colors.neutrals.grey};
  width: max-content;
`);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = _root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite$1(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

var _isFinite = isFinite$1;

const Hint$2 = () => {
  const {
    value,
    min,
    max
  } = useInputContext$2();
  const getLabel = () => {
    if (_isFinite(min) && _isFinite(max)) {
      return `Range Value : ${nFormatter(Number(min))} - ${nFormatter(Number(max))}`;
    } else if (_isFinite(min)) {
      return `Min Value : ${nFormatter(Number(min))}`;
    } else {
      return `Max Value : ${nFormatter(Number(max))}`;
    }
  };
  return /*#__PURE__*/React.createElement(Item$1, null, /*#__PURE__*/React.createElement(HintWrapper, {
    "data-testid": "beau-input-hint",
    error: outsideTheRange(value, min, max)
  }, getLabel()));
};

const NumberInput = ({
  'data-testid': dataTestId = 'beau-number-input',
  children,
  className,
  name,
  value,
  max,
  min,
  decimalPrecision,
  placeholder,
  thousandSeparator = false,
  error = false,
  disabled = false,
  readOnly = false,
  required = false,
  keepWithinRange = false,
  allowNegative = false,
  hideHint = false,
  onFocus,
  onBlur,
  onClick,
  onChange,
  onKeyDown
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasError = error || outsideTheRange(value, min, max);
  const isHintVisible = (isNumber(min) || isNumber(max)) && !hideHint;
  const handleChange = newValue => {
    onChange && onChange(newValue);
  };
  const handleFocus = useCallback(e => {
    if (!disabled && !readOnly) {
      setIsFocused(true);
    }
    onFocus && onFocus(e);
  }, [disabled, readOnly]);
  const clamb = useCallback(() => {
    let newValue = null;
    if (isNumber(value)) {
      if (isNumber(min) && isNumber(max)) {
        newValue = Math.min(max, Math.max(min, value));
      } else if (isNumber(min)) {
        newValue = Math.max(min, value);
      } else if (isNumber(max)) {
        newValue = Math.min(max, value);
      }
      if (value !== newValue) {
        handleChange(newValue);
      }
    }
  }, [value, min, max]);
  const handleBlur = useCallback(e => {
    setIsFocused(false);
    onBlur && onBlur(e);
    if (keepWithinRange) {
      clamb();
    }
  }, [keepWithinRange, clamb]);
  return /*#__PURE__*/React.createElement(InputWrapper$4, {
    "data-testid": dataTestId,
    className: className,
    isFocused: isFocused,
    error: hasError,
    readOnly: readOnly,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(InputContext$2.Provider, {
    value: {
      value,
      name,
      min,
      max,
      placeholder,
      decimalPrecision,
      hasError,
      disabled,
      readOnly,
      required,
      allowNegative,
      thousandSeparator,
      onKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange
    }
  }, children ?? /*#__PURE__*/React.createElement(BaseInput$2, null), isHintVisible && /*#__PURE__*/React.createElement(Hint$2, null)));
};
NumberInput.Item = Item$5;
NumberInput.Field = Field$2;
NumberInput.Label = Label$5;
NumberInput.Icon = Icon$3;
//Storybooks naming fix
NumberInput.displayName = 'NumberInput';
NumberInput.Item.displayName = 'NumberInput.Item';
NumberInput.Field.displayName = 'NumberInput.Field';
NumberInput.Icon.displayName = 'NumberInput.Icon';
NumberInput.Label.displayName = 'NumberInput.Label';

var reactTable_production_min = createCommonjsModule(function (module, exports) {
!function(e,t){t(exports,React);}(commonjsGlobal,(function(e,t){function n(e,t,n,o,r,i,u){try{var l=e[i](u),s=l.value;}catch(e){return void n(e)}l.done?t(s):Promise.resolve(s).then(o,r);}function o(e){return function(){var t=this,o=arguments;return new Promise((function(r,i){var u=e.apply(t,o);function l(e){n(u,r,i,l,s,"next",e);}function s(e){n(u,r,i,l,s,"throw",e);}l(void 0);}))}}function r(){return (r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o]);}return e}).apply(this,arguments)}function i(e,t){if(null==e)return {};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);return r}function u(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=typeof o)return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var l={init:"init"},s=function(e){var t=e.value;return void 0===t?"":t},a=function(){return t.createElement(t.Fragment,null," ")},c={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,o=t.className;return e=r({},e,{},i(t,["style","className"])),n&&(e.style=e.style?r({},e.style||{},{},n||{}):n),o&&(e.className=e.className?e.className+" "+o:o),""===e.className&&delete e.className,e}),{})}var f=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,o){return function e(t,n,o){return "function"==typeof n?e({},n(t,o)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,o,r({},t,{userProps:n}))}),{})}},p=function(e,t,n,o){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},g=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n);}))};function v(e,t,n,o){e.findIndex((function(e){return e.pluginName===n}));t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}));}));}function m(e,t){return "function"==typeof e?e(t):e}function h(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function w(e,n){var o=t.useRef(!1);y((function(){o.current&&e(),o.current=!0;}),n);}function R(e,t,n){return void 0===n&&(n={}),function(o,i){void 0===i&&(i={});var u="string"==typeof o?t[o]:o;if(void 0===u)throw console.info(t),new Error("Renderer Error ☝️");return b(u,r({},e,{column:t},n,{},i))}}function b(e,n){return function(e){return "function"==typeof e&&((t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent);var t;}(o=e)||"function"==typeof o||function(e){return "object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(o)?t.createElement(e,n):e;var o;}function S(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=r({},e,{parent:t,depth:n})),e.columns&&(e.columns=S(e.columns,e,n+1)),e}))}function C(e){return G(e,"columns")}function x(e){var t=e.id,n=e.accessor,o=e.Header;if("string"==typeof n){t=t||n;var r=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var o,r="function"==typeof t?t:JSON.stringify(t),i=E.get(r)||function(){var e=function(e){return function e(t,n){void 0===n&&(n=[]);if(Array.isArray(t))for(var o=0;o<t.length;o+=1)e(t[o],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(W,".").replace(O,"").split(".")}(t);return E.set(r,e),e}();try{o=i.reduce((function(e,t){return e[t]}),e);}catch(e){}return void 0!==o?o:n}(e,r)};}if(!t&&"string"==typeof o&&o&&(t=o),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function P(e,t){if(!t)throw new Error;return Object.assign(e,r({Header:a,Footer:a},c,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function B(e,t,n){void 0===n&&(n=function(){return {}});for(var o=[],i=e,u=0,l=function(){return u++},s=function(){var e={headers:[]},u=[],s=i.some((function(e){return e.parent}));i.forEach((function(o){var i,a=[].concat(u).reverse()[0];if(s){if(o.parent)i=r({},o.parent,{originalId:o.parent.id,id:o.parent.id+"_"+l(),headers:[o]},n(o));else i=P(r({originalId:o.id+"_placeholder",id:o.id+"_placeholder_"+l(),placeholderOf:o,headers:[o]},n(o)),t);a&&a.originalId===i.originalId?a.headers.push(o):u.push(i);}e.headers.push(o);})),o.push(e),i=u;};i.length;)s();return o.reverse()}var E=new Map;function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var o=0;o<t.length;o+=1)if(void 0!==t[o])return t[o]}function F(e){if("function"==typeof e)return e}function G(e,t){var n=[];return function e(o){o.forEach((function(o){o[t]?e(o[t]):n.push(o);}));}(e),n}function A(e,t){var n=t.manualExpandedKey,o=t.expanded,r=t.expandSubRows,i=void 0===r||r,u=[];return e.forEach((function(e){return function e(t,r){void 0===r&&(r=!0),t.isExpanded=t.original&&t.original[n]||o[t.id],t.canExpand=t.subRows&&!!t.subRows.length,r&&u.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}));}(e)})),u}function k(e,t,n){return F(e)||t[e]||n[e]||n.text}function H(e,t,n){return e?e(t,n):void 0===t}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var z=null;var W=/\[/g,O=/\]/g;var M=function(e){return r({role:"table"},e)},j=function(e){return r({role:"rowgroup"},e)},N=function(e,t){var n=t.column;return r({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},L=function(e,t){var n=t.column;return r({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},D=function(e,t){return r({key:"headerGroup_"+t.index,role:"row"},e)},V=function(e,t){return r({key:"footerGroup_"+t.index},e)},_=function(e,t){return r({key:"row_"+t.row.id,role:"row"},e)},X=function(e,t){var n=t.cell;return r({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function q(){return {useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[D],getFooterGroupProps:[V],getHeaderProps:[N],getFooterProps:[L],getRowProps:[_],getCellProps:[X],useFinalInstance:[]}}l.resetHiddenColumns="resetHiddenColumns",l.toggleHideColumn="toggleHideColumn",l.setHiddenColumns="setHiddenColumns",l.toggleHideAllColumns="toggleHideAllColumns";var K=function(e){e.getToggleHiddenProps=[U],e.getToggleHideAllColumnsProps=[$],e.stateReducers.push(J),e.useInstanceBeforeDimensions.push(Y),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(Q);};K.pluginName="useColumnVisibility";var U=function(e,t){var n=t.column;return [e,{onChange:function(e){n.toggleHidden(!e.target.checked);},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},$=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked);},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function J(e,t,n,o){if(t.type===l.init)return r({hiddenColumns:[]},e);if(t.type===l.resetHiddenColumns)return r({},e,{hiddenColumns:o.initialState.hiddenColumns||[]});if(t.type===l.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return r({},e,{hiddenColumns:i})}return t.type===l.setHiddenColumns?r({},e,{hiddenColumns:m(t.value,e.hiddenColumns)}):t.type===l.toggleHideAllColumns?r({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?o.allColumns.map((function(e){return e.id})):[]}):void 0}function Y(e){var n=e.headers,o=e.state.hiddenColumns;t.useRef(!1).current;var r=0;n.forEach((function(e){return r+=function e(t,n){t.isVisible=n&&!o.includes(t.id);var r=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return r+=e(n,t.isVisible)})):r=t.isVisible?1:0,t.totalVisibleHeaderCount=r,r}(e,!0)}));}function Q(e){var n=e.columns,o=e.flatHeaders,r=e.dispatch,i=e.allColumns,u=e.getHooks,s=e.state.hiddenColumns,a=e.autoResetHiddenColumns,c=void 0===a||a,d=h(e),p=i.length===s.length,g=t.useCallback((function(e,t){return r({type:l.toggleHideColumn,columnId:e,value:t})}),[r]),v=t.useCallback((function(e){return r({type:l.setHiddenColumns,value:e})}),[r]),m=t.useCallback((function(e){return r({type:l.toggleHideAllColumns,value:e})}),[r]),y=f(u().getToggleHideAllColumnsProps,{instance:d()});o.forEach((function(e){e.toggleHidden=function(t){r({type:l.toggleHideColumn,columnId:e.id,value:t});},e.getToggleHiddenProps=f(u().getToggleHiddenProps,{instance:d(),column:e});}));var R=h(c);w((function(){R()&&r({type:l.resetHiddenColumns});}),[r,n]),Object.assign(e,{allColumnsHidden:p,toggleHideColumn:g,setHiddenColumns:v,toggleHideAllColumns:m,getToggleHideAllColumnsProps:y});}var Z={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},oe=function(e,t,n){return ""+(n?[n.id,t].join("."):t)},re=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?Z:t,o=e.defaultColumn,u=void 0===o?ee:o,l=e.getSubRows,s=void 0===l?ne:l,a=e.getRowId,c=void 0===a?oe:a,d=e.stateReducer,f=void 0===d?te:d,p=e.useControlledState,g=void 0===p?re:p;return r({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:u,getSubRows:s,getRowId:c,stateReducer:f,useControlledState:g})}function ue(e,t){void 0===t&&(t=0);var n=0,o=0,r=0,i=0;return e.forEach((function(e){var u=e.headers;if(e.totalLeft=t,u&&u.length){var l=ue(u,t),s=l[0],a=l[1],c=l[2],d=l[3];e.totalMinWidth=s,e.totalWidth=a,e.totalMaxWidth=c,e.totalFlexWidth=d;}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,o+=e.totalWidth,r+=e.totalMaxWidth,i+=e.totalFlexWidth);})),[n,o,r,i]}function le(e){var t=e.data,n=e.rows,o=e.flatRows,r=e.rowsById,i=e.column,u=e.getRowId,l=e.getSubRows,s=e.accessValueHooks,a=e.getInstance;t.forEach((function(e,c){return function e(n,c,d,f,g){void 0===d&&(d=0);var v=n,m=u(n,c,f),h=r[m];if(h)h.subRows&&h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h)}));else if((h={id:m,original:v,index:c,depth:d,cells:[{}]}).cells.map=T,h.cells.filter=T,h.cells.forEach=T,h.cells[0].getCellProps=T,h.values={},g.push(h),o.push(h),r[m]=h,h.originalSubRows=l(n,c),h.originalSubRows){var y=[];h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h,y)})),h.subRows=y;}i.accessor&&(h.values[i.id]=i.accessor(n,c,h,g,t)),h.values[i.id]=p(s,h.values[i.id],{row:h,column:i,instance:a()});}(e,c,0,void 0,n)}));}l.resetExpanded="resetExpanded",l.toggleRowExpanded="toggleRowExpanded",l.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function(e){e.getToggleAllRowsExpandedProps=[ae],e.getToggleRowExpandedProps=[ce],e.stateReducers.push(de),e.useInstance.push(fe),e.prepareRow.push(pe);};se.pluginName="useExpanded";var ae=function(e,t){var n=t.instance;return [e,{onClick:function(e){n.toggleAllRowsExpanded();},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ce=function(e,t){var n=t.row;return [e,{onClick:function(){n.toggleRowExpanded();},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,o){if(t.type===l.init)return r({expanded:{}},e);if(t.type===l.resetExpanded)return r({},e,{expanded:o.initialState.expanded||{}});if(t.type===l.toggleAllRowsExpanded){var s=t.value,a=o.isAllRowsExpanded,c=o.rowsById;if(void 0!==s?s:!a){var d={};return Object.keys(c).forEach((function(e){d[e]=!0;})),r({},e,{expanded:d})}return r({},e,{expanded:{}})}if(t.type===l.toggleRowExpanded){var f,p=t.id,g=t.value,v=e.expanded[p],m=void 0!==g?g:!v;if(!v&&m)return r({},e,{expanded:r({},e.expanded,(f={},f[p]=!0,f))});if(v&&!m){var h=e.expanded;h[p];return r({},e,{expanded:i(h,[p].map(u))})}return e}}function fe(e){var n=e.data,o=e.rows,r=e.rowsById,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.paginateExpandedRows,a=void 0===s||s,c=e.expandSubRows,d=void 0===c||c,p=e.autoResetExpanded,g=void 0===p||p,m=e.getHooks,y=e.plugins,R=e.state.expanded,b=e.dispatch;v(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S=h(g),C=Boolean(Object.keys(r).length&&Object.keys(R).length);C&&Object.keys(r).some((function(e){return !R[e]}))&&(C=!1),w((function(){S()&&b({type:l.resetExpanded});}),[b,n]);var x=t.useCallback((function(e,t){b({type:l.toggleRowExpanded,id:e,value:t});}),[b]),P=t.useCallback((function(e){return b({type:l.toggleAllRowsExpanded,value:e})}),[b]),B=t.useMemo((function(){return a?A(o,{manualExpandedKey:u,expanded:R,expandSubRows:d}):o}),[a,o,u,R,d]),E=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length);})),t}(R)}),[R]),I=h(e),F=f(m().getToggleAllRowsExpandedProps,{instance:I()});Object.assign(e,{preExpandedRows:o,expandedRows:B,rows:B,expandedDepth:E,isAllRowsExpanded:C,toggleRowExpanded:x,toggleAllRowsExpanded:P,getToggleAllRowsExpandedProps:F});}function pe(e,t){var n=t.instance.getHooks,o=t.instance;e.toggleRowExpanded=function(t){return o.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=f(n().getToggleRowExpandedProps,{instance:o,row:e});}var ge=function(e,t,n){return e=e.filter((function(e){return t.some((function(t){var o=e.values[t];return String(o).toLowerCase().includes(String(n).toLowerCase())}))}))};ge.autoRemove=function(e){return !e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o).toLowerCase()===String(n).toLowerCase()}))}))};ve.autoRemove=function(e){return !e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o)===String(n)}))}))};me.autoRemove=function(e){return !e};var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};he.autoRemove=function(e){return !e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.every((function(e){return o.includes(e)}))}))}))};ye.autoRemove=function(e){return !e||!e.length};var we=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.some((function(e){return o.includes(e)}))}))}))};we.autoRemove=function(e){return !e||!e.length};var Re=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return n.includes(o)}))}))};Re.autoRemove=function(e){return !e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};be.autoRemove=function(e){return void 0===e};var Se=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Se.autoRemove=function(e){return null==e};var Ce=function(e,t,n){var o=n||[],r=o[0],i=o[1];if((r="number"==typeof r?r:-1/0)>(i="number"==typeof i?i:1/0)){var u=r;r=i,i=u;}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=r&&n<=i}))}))};Ce.autoRemove=function(e){return !e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l.resetFilters="resetFilters",l.setFilter="setFilter",l.setAllFilters="setAllFilters";var Pe=function(e){e.stateReducers.push(Be),e.useInstance.push(Ee);};function Be(e,t,n,o){if(t.type===l.init)return r({filters:[]},e);if(t.type===l.resetFilters)return r({},e,{filters:o.initialState.filters||[]});if(t.type===l.setFilter){var i=t.columnId,u=t.filterValue,s=o.allColumns,a=o.filterTypes,c=s.find((function(e){return e.id===i}));if(!c)throw new Error("React-Table: Could not find a column with id: "+i);var d=k(c.filter,a||{},xe),f=e.filters.find((function(e){return e.id===i})),p=m(u,f&&f.value);return H(d.autoRemove,p,c)?r({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):r({},e,f?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:p}:e}))}:{filters:[].concat(e.filters,[{id:i,value:p}])})}if(t.type===l.setAllFilters){var g=t.filters,v=o.allColumns,h=o.filterTypes;return r({},e,{filters:m(g,e.filters).filter((function(e){var t=v.find((function(t){return t.id===e.id}));return !H(k(t.filter,h||{},xe).autoRemove,e.value,t)}))})}}function Ee(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.manualFilters,c=e.defaultCanFilter,d=void 0!==c&&c,f=e.disableFilters,p=e.state.filters,g=e.dispatch,v=e.autoResetFilters,m=void 0===v||v,y=t.useCallback((function(e,t){g({type:l.setFilter,columnId:e,filterValue:t});}),[g]),R=t.useCallback((function(e){g({type:l.setAllFilters,filters:e});}),[g]);u.forEach((function(e){var t=e.id,n=e.accessor,o=e.defaultCanFilter,r=e.disableFilters;e.canFilter=n?I(!0!==r&&void 0,!0!==f&&void 0,!0):I(o,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=p.find((function(e){return e.id===t}));e.filterValue=i&&i.value;}));var b=t.useMemo((function(){if(a||!p.length)return [o,r,i];var e=[],t={};return [function n(o,r){void 0===r&&(r=0);var i=o;return (i=p.reduce((function(e,t){var n=t.id,o=t.value,i=u.find((function(e){return e.id===n}));if(!i)return e;0===r&&(i.preFilteredRows=e);var l=k(i.filter,s||{},xe);return l?(i.filteredRows=l(e,[n],o),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),o)).forEach((function(o){e.push(o),t[o.id]=o,o.subRows&&(o.subRows=o.subRows&&o.subRows.length>0?n(o.subRows,r+1):o.subRows);})),i}(o),e,t]}),[a,p,o,r,i,u,s]),S=b[0],C=b[1],x=b[2];t.useMemo((function(){u.filter((function(e){return !p.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=S,e.filteredRows=S;}));}),[S,p,u]);var P=h(m);w((function(){P()&&g({type:l.resetFilters});}),[g,a?null:n]),Object.assign(e,{preFilteredRows:o,preFilteredFlatRows:r,preFilteredRowsById:i,filteredRows:S,filteredFlatRows:C,filteredRowsById:x,rows:S,flatRows:C,rowsById:x,setFilter:y,setAllFilters:R});}Pe.pluginName="useFilters",l.resetGlobalFilter="resetGlobalFilter",l.setGlobalFilter="setGlobalFilter";var Ie=function(e){e.stateReducers.push(Fe),e.useInstance.push(Ge);};function Fe(e,t,n,o){if(t.type===l.resetGlobalFilter)return r({},e,{globalFilter:o.initialState.globalFilter||void 0});if(t.type===l.setGlobalFilter){var u=t.filterValue,s=o.userFilterTypes,a=k(o.globalFilter,s||{},xe),c=m(u,e.globalFilter);if(H(a.autoRemove,c)){e.globalFilter;return i(e,["globalFilter"])}return r({},e,{globalFilter:c})}}function Ge(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.globalFilter,c=e.manualGlobalFilter,d=e.state.globalFilter,f=e.dispatch,p=e.autoResetGlobalFilter,g=void 0===p||p,v=e.disableGlobalFilter,m=t.useCallback((function(e){f({type:l.setGlobalFilter,filterValue:e});}),[f]),y=t.useMemo((function(){if(c||void 0===d)return [o,r,i];var e=[],t={},n=k(a,s||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),o;u.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=I(!0!==t&&void 0,!0!==v&&void 0,!0);}));var l=u.filter((function(e){return !0===e.canFilter}));return [function o(r){return (r=n(r,l.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?o(n.subRows):n.subRows;})),r}(o),e,t]}),[c,d,a,s,u,o,r,i,v]),R=y[0],b=y[1],S=y[2],C=h(g);w((function(){C()&&f({type:l.resetGlobalFilter});}),[f,c?null:n]),Object.assign(e,{preGlobalFilteredRows:o,preGlobalFilteredFlatRows:r,preGlobalFilteredRowsById:i,globalFilteredRows:R,globalFilteredFlatRows:b,globalFilteredRowsById:S,rows:R,flatRows:b,rowsById:S,setGlobalFilter:m,disableGlobalFilter:v});}function Ae(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e));})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e));})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e));})),t+".."+n},average:function(e){return Ae(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),He=[],Te={};l.resetGroupBy="resetGroupBy",l.setGroupBy="setGroupBy",l.toggleGroupBy="toggleGroupBy";var ze=function(e){e.getGroupByToggleProps=[We],e.stateReducers.push(Oe),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Me),e.useInstance.push(Ne),e.prepareRow.push(Le);};ze.pluginName="useGroupBy";var We=function(e,t){var n=t.header;return [e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy();}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Oe(e,t,n,o){if(t.type===l.init)return r({groupBy:[]},e);if(t.type===l.resetGroupBy)return r({},e,{groupBy:o.initialState.groupBy||[]});if(t.type===l.setGroupBy)return r({},e,{groupBy:t.value});if(t.type===l.toggleGroupBy){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.groupBy.includes(i);return r({},e,s?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Me(e,t){var n=t.instance.state.groupBy,o=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),r=e.filter((function(e){return !n.includes(e.id)}));return (e=[].concat(o,r)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id);})),e}var je={};function Ne(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.flatHeaders,a=e.groupByFn,c=void 0===a?De:a,d=e.manualGroupBy,p=e.aggregations,g=void 0===p?je:p,m=e.plugins,y=e.state.groupBy,R=e.dispatch,b=e.autoResetGroupBy,S=void 0===b||b,C=e.disableGroupBy,x=e.defaultCanGroupBy,P=e.getHooks;v(m,["useColumnOrder","useFilters"],"useGroupBy");var B=h(e);u.forEach((function(t){var n=t.accessor,o=t.defaultGroupBy,r=t.disableGroupBy;t.canGroupBy=n?I(t.canGroupBy,!0!==r&&void 0,!0!==C&&void 0,!0):I(t.canGroupBy,o,x,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));var E=t.useCallback((function(e,t){R({type:l.toggleGroupBy,columnId:e,value:t});}),[R]),F=t.useCallback((function(e){R({type:l.setGroupBy,value:e});}),[R]);s.forEach((function(e){e.getGroupByToggleProps=f(P().getGroupByToggleProps,{instance:B(),header:e});}));var A=t.useMemo((function(){if(d||!y.length)return [o,r,i,He,Te,r,i];var e=y.filter((function(e){return u.find((function(t){return t.id===e}))})),t=[],n={},l=[],s={},a=[],f={},p=function o(r,i,d){if(void 0===i&&(i=0),i===e.length)return r;var p=e[i],v=c(r,p);return Object.entries(v).map((function(r,c){var v=r[0],m=r[1],h=p+":"+v,y=o(m,i+1,h=d?d+">"+h:h),w=i?G(m,"leafRows"):m,R=function(t,n,o){var r={};return u.forEach((function(i){if(e.includes(i.id))r[i.id]=n[0]?n[0].values[i.id]:null;else {var u="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||ke[i.aggregate];if(u){var l=n.map((function(e){return e.values[i.id]})),s=t.map((function(e){var t=e.values[i.id];if(!o&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||ke[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i);}return t}));r[i.id]=u(s,l);}else {if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");r[i.id]=null;}}})),r}(w,m,i),b={id:h,isGrouped:!0,groupByID:p,groupByVal:v,values:R,subRows:y,leafRows:w,depth:i,index:c};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),b}))}(o);return p.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),[p,t,n,l,s,a,f]}),[d,y,o,r,i,u,g,c]),k=A[0],H=A[1],T=A[2],z=A[3],W=A[4],O=A[5],M=A[6],j=h(S);w((function(){j()&&R({type:l.resetGroupBy});}),[R,d?null:n]),Object.assign(e,{preGroupedRows:o,preGroupedFlatRow:r,preGroupedRowsById:i,groupedRows:k,groupedFlatRows:H,groupedRowsById:T,onlyGroupedFlatRows:z,onlyGroupedRowsById:W,nonGroupedFlatRows:O,nonGroupedRowsById:M,rows:k,flatRows:H,rowsById:T,toggleGroupBy:E,setGroupBy:F});}function Le(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length);}));}function De(e,t){return e.reduce((function(e,n,o){var r=""+n.values[t];return e[r]=Array.isArray(e[r])?e[r]:[],e[r].push(n),e}),{})}var Ve=/([0-9]+)/gm;function _e(e,t){return e===t?0:e>t?1:-1}function Xe(e,t,n){return [e.values[n],t.values[n]]}function qe(e){return "number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ke=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=qe(r),i=qe(i),r=r.split(Ve).filter(Boolean),i=i.split(Ve).filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=parseInt(u,10),a=parseInt(l,10),c=[s,a].sort();if(isNaN(c[0])){if(u>l)return 1;if(l>u)return -1}else {if(isNaN(c[1]))return isNaN(s)?-1:1;if(s>a)return 1;if(a>s)return -1}}return r.length-i.length},datetime:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];return _e(r=r.getTime(),i=i.getTime())},basic:function(e,t,n){var o=Xe(e,t,n);return _e(o[0],o[1])},string:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=r.split("").filter(Boolean),i=i.split("").filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=u.toLowerCase(),a=l.toLowerCase();if(s>a)return 1;if(a>s)return -1;if(u>l)return 1;if(l>u)return -1}return r.length-i.length},number:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1],u=/[^0-9.]/gi;return _e(r=Number(String(r).replace(u,"")),i=Number(String(i).replace(u,"")))}});l.resetSortBy="resetSortBy",l.setSortBy="setSortBy",l.toggleSortBy="toggleSortBy",l.clearSortBy="clearSortBy",c.sortType="alphanumeric",c.sortDescFirst=!1;var Ue=function(e){e.getSortByToggleProps=[$e],e.stateReducers.push(Je),e.useInstance.push(Ye);};Ue.pluginName="useSortBy";var $e=function(e,t){var n=t.instance,o=t.column,r=n.isMultiSortEvent,i=void 0===r?function(e){return e.shiftKey}:r;return [e,{onClick:o.canSort?function(e){e.persist(),o.toggleSortBy(void 0,!n.disableMultiSort&&i(e));}:void 0,style:{cursor:o.canSort?"pointer":void 0},title:o.canSort?"Toggle SortBy":void 0}]};function Je(e,t,n,o){if(t.type===l.init)return r({sortBy:[]},e);if(t.type===l.resetSortBy)return r({},e,{sortBy:o.initialState.sortBy||[]});if(t.type===l.clearSortBy)return r({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===l.setSortBy)return r({},e,{sortBy:t.sortBy});if(t.type===l.toggleSortBy){var i,u=t.columnId,s=t.desc,a=t.multi,c=o.allColumns,d=o.disableMultiSort,f=o.disableSortRemove,p=o.disableMultiRemove,g=o.maxMultiSortColCount,v=void 0===g?Number.MAX_SAFE_INTEGER:g,m=e.sortBy,h=c.find((function(e){return e.id===u})).sortDescFirst,y=m.find((function(e){return e.id===u})),w=m.findIndex((function(e){return e.id===u})),R=null!=s,b=[];return "toggle"!==(i=!d&&a?y?"toggle":"add":w!==m.length-1||1!==m.length?"replace":y?"toggle":"replace")||f||R||a&&p||!(y&&y.desc&&!h||!y.desc&&h)||(i="remove"),"replace"===i?b=[{id:u,desc:R?s:h}]:"add"===i?(b=[].concat(m,[{id:u,desc:R?s:h}])).splice(0,b.length-v):"toggle"===i?b=m.map((function(e){return e.id===u?r({},e,{desc:R?s:!y.desc}):e})):"remove"===i&&(b=m.filter((function(e){return e.id!==u}))),r({},e,{sortBy:b})}}function Ye(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.allColumns,u=e.orderByFn,s=void 0===u?Qe:u,a=e.sortTypes,c=e.manualSortBy,d=e.defaultCanSort,p=e.disableSortBy,g=e.flatHeaders,m=e.state.sortBy,y=e.dispatch,R=e.plugins,b=e.getHooks,S=e.autoResetSortBy,C=void 0===S||S;v(R,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:l.setSortBy,sortBy:e});}),[y]),P=t.useCallback((function(e,t,n){y({type:l.toggleSortBy,columnId:e,desc:t,multi:n});}),[y]),B=h(e);g.forEach((function(e){var t=e.accessor,n=e.canSort,o=e.disableSortBy,r=e.id,i=t?I(!0!==o&&void 0,!0!==p&&void 0,!0):I(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return P(e.id,t,n)},e.clearSortBy=function(){y({type:l.clearSortBy,columnId:e.id});}),e.getSortByToggleProps=f(b().getSortByToggleProps,{instance:B(),column:e});var u=m.find((function(e){return e.id===r}));e.isSorted=!!u,e.sortedIndex=m.findIndex((function(e){return e.id===r})),e.isSortedDesc=e.isSorted?u.desc:void 0;}));var E=t.useMemo((function(){if(c||!m.length)return [o,r];var e=[],t=m.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return [function n(o){var r=s(o,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,o=F(n)||(a||{})[n]||Ke[n];if(!o)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return o(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return r.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows));})),r}(o),e]}),[c,m,o,r,i,s,a]),G=E[0],A=E[1],k=h(C);w((function(){k()&&y({type:l.resetSortBy});}),[c?null:n]),Object.assign(e,{preSortedRows:o,preSortedFlatRows:r,sortedRows:G,sortedFlatRows:A,rows:G,flatRows:A,setSortBy:x,toggleSortBy:P});}function Qe(e,t,n){return [].concat(e).sort((function(e,o){for(var r=0;r<t.length;r+=1){var i=t[r],u=!1===n[r]||"desc"===n[r],l=i(e,o);if(0!==l)return u?-l:l}return n[0]?e.index-o.index:o.index-e.index}))}l.resetPage="resetPage",l.gotoPage="gotoPage",l.setPageSize="setPageSize";var Ze=function(e){e.stateReducers.push(et),e.useInstance.push(tt);};function et(e,t,n,o){if(t.type===l.init)return r({pageSize:10,pageIndex:0},e);if(t.type===l.resetPage)return r({},e,{pageIndex:o.initialState.pageIndex||0});if(t.type===l.gotoPage){var i=o.pageCount,u=o.page,s=m(t.pageIndex,e.pageIndex),a=!1;return s>e.pageIndex?a=-1===i?u.length>=e.pageSize:s<i:s<e.pageIndex&&(a=s>-1),a?r({},e,{pageIndex:s}):e}if(t.type===l.setPageSize){var c=t.pageSize,d=e.pageSize*e.pageIndex;return r({},e,{pageIndex:Math.floor(d/c),pageSize:c})}}function tt(e){var n=e.rows,o=e.autoResetPage,r=void 0===o||o,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.plugins,a=e.pageCount,c=e.paginateExpandedRows,d=void 0===c||c,f=e.expandSubRows,p=void 0===f||f,g=e.state,m=g.pageSize,y=g.pageIndex,R=g.expanded,b=g.globalFilter,S=g.filters,C=g.groupBy,x=g.sortBy,P=e.dispatch,B=e.data,E=e.manualPagination;v(s,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I=h(r);w((function(){I()&&P({type:l.resetPage});}),[P,E?null:B,b,S,C,x]);var F=E?a:Math.ceil(n.length/m),G=t.useMemo((function(){return F>0?[].concat(new Array(F)).fill(null).map((function(e,t){return t})):[]}),[F]),k=t.useMemo((function(){var e;if(E)e=n;else {var t=m*y,o=t+m;e=n.slice(t,o);}return d?e:A(e,{manualExpandedKey:u,expanded:R,expandSubRows:p})}),[p,R,u,E,y,m,d,n]),H=y>0,T=-1===F?k.length>=m:y<F-1,z=t.useCallback((function(e){P({type:l.gotoPage,pageIndex:e});}),[P]),W=t.useCallback((function(){return z((function(e){return e-1}))}),[z]),O=t.useCallback((function(){return z((function(e){return e+1}))}),[z]),M=t.useCallback((function(e){P({type:l.setPageSize,pageSize:e});}),[P]);Object.assign(e,{pageOptions:G,pageCount:F,page:k,canPreviousPage:H,canNextPage:T,gotoPage:z,previousPage:W,nextPage:O,setPageSize:M});}Ze.pluginName="usePagination",l.resetPivot="resetPivot",l.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[rt],e.stateReducers.push(it),e.useInstanceAfterData.push(ut),e.allColumns.push(lt),e.accessValue.push(st),e.materializedColumns.push(at),e.materializedColumnsDeps.push(ct),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(ft),e.useInstance.push(pt),e.prepareRow.push(gt);};nt.pluginName="usePivotColumns";var ot=[],rt=function(e,t){var n=t.header;return [e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot();}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,o){if(t.type===l.init)return r({pivotColumns:ot},e);if(t.type===l.resetPivot)return r({},e,{pivotColumns:o.initialState.pivotColumns||ot});if(t.type===l.togglePivot){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.pivotColumns.includes(i);return r({},e,s?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function ut(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id);}));}function lt(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set;})),e}function st(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function at(e,t){var n=t.instance,o=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var u=i.pivotColumns.map((function(e){return o.find((function(t){return t.id===e}))})).filter(Boolean),l=o.filter((function(e){return !e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),s=C(function e(t,n,o){void 0===t&&(t=0),void 0===o&&(o=[]);var i=u[t];return i?Array.from(i.uniqueValues).sort().map((function(u){var l=r({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+u:u,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+u:i.id+"."+u,pivotValue:u});return l.columns=e(t+1,l,[].concat(o,[function(e){return e.values[i.id]===u}])),l})):l.map((function(e){return r({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,r){if(o.every((function(e){return e(r)})))return r.values[e.id]}})}))}());return [].concat(e,s)}function ct(e,t){var n=t.instance.state,o=n.pivotColumns,r=n.groupBy;return [].concat(e,[o,r])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return !e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function ft(e,t){var n=t.instance;return [].concat(e,[n.state.pivotColumns,n.state.groupBy])}function pt(e){var t=e.columns,n=e.allColumns,o=e.flatHeaders,r=e.getHooks,i=e.plugins,u=e.dispatch,s=e.autoResetPivot,a=void 0===s||s,c=e.manaulPivot,d=e.disablePivot,p=e.defaultCanPivot;v(i,["useGroupBy"],"usePivotColumns");var g=h(e);n.forEach((function(t){var n=t.accessor,o=t.defaultPivot,r=t.disablePivot;t.canPivot=n?I(t.canPivot,!0!==r&&void 0,!0!==d&&void 0,!0):I(t.canPivot,o,p,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));o.forEach((function(e){e.getPivotToggleProps=f(r().getPivotToggleProps,{instance:g(),header:e});}));var m=h(a);w((function(){m()&&u({type:l.resetPivot});}),[u,c?null:t]),Object.assign(e,{togglePivot:function(e,t){u({type:l.togglePivot,columnId:e,value:t});}});}function gt(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted;}));}l.resetSelectedRows="resetSelectedRows",l.toggleAllRowsSelected="toggleAllRowsSelected",l.toggleRowSelected="toggleRowSelected",l.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function(e){e.getToggleRowSelectedProps=[mt],e.getToggleAllRowsSelectedProps=[ht],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(wt),e.useInstance.push(Rt),e.prepareRow.push(bt);};vt.pluginName="useRowSelect";var mt=function(e,t){var n=t.instance,o=t.row,r=n.manualRowSelectedKey,i=void 0===r?"isSelected":r;return [e,{onChange:function(e){o.toggleRowSelected(e.target.checked);},style:{cursor:"pointer"},checked:!(!o.original||!o.original[i])||o.isSelected,title:"Toggle Row Selected",indeterminate:o.isSomeSelected}]},ht=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function wt(e,t,n,o){if(t.type===l.init)return r({selectedRowIds:{}},e);if(t.type===l.resetSelectedRows)return r({},e,{selectedRowIds:o.initialState.selectedRowIds||{}});if(t.type===l.toggleAllRowsSelected){var i=t.value,u=o.isAllRowsSelected,s=o.rowsById,a=o.nonGroupedRowsById,c=void 0===a?s:a,d=void 0!==i?i:!u,f=Object.assign({},e.selectedRowIds);return d?Object.keys(c).forEach((function(e){f[e]=!0;})):Object.keys(c).forEach((function(e){delete f[e];})),r({},e,{selectedRowIds:f})}if(t.type===l.toggleRowSelected){var p=t.id,g=t.value,v=o.rowsById,m=o.selectSubRows,h=void 0===m||m,y=o.getSubRows,w=e.selectedRowIds[p],R=void 0!==g?g:!w;if(w===R)return e;var b=r({},e.selectedRowIds);return function e(t){var n=v[t];if(n.isGrouped||(R?b[t]=!0:delete b[t]),h&&y(n))return y(n).forEach((function(t){return e(t.id)}))}(p),r({},e,{selectedRowIds:b})}if(t.type===l.toggleAllPageRowsSelected){var S=t.value,C=o.page,x=o.rowsById,P=o.selectSubRows,B=void 0===P||P,E=o.isAllPageRowsSelected,I=o.getSubRows,F=void 0!==S?S:!E,G=r({},e.selectedRowIds);return C.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(F?G[t]=!0:delete G[t]),B&&I(n))return I(n).forEach((function(t){return e(t.id)}))}(e.id)})),r({},e,{selectedRowIds:G})}return e}function Rt(e){var n=e.data,o=e.rows,r=e.getHooks,i=e.plugins,u=e.rowsById,s=e.nonGroupedRowsById,a=void 0===s?u:s,c=e.autoResetSelectedRows,d=void 0===c||c,p=e.state.selectedRowIds,g=e.selectSubRows,m=void 0===g||g,y=e.dispatch,R=e.page,b=e.getSubRows;v(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S=t.useMemo((function(){var e=[];return o.forEach((function(t){var n=m?function e(t,n,o){if(n[t.id])return !0;var r=o(t);if(r&&r.length){var i=!0,u=!1;return r.forEach((function(t){u&&!i||(e(t,n,o)?u=!0:i=!1);})),!!i||!!u&&null}return !1}(t,p,b):!!p[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t);})),e}),[o,m,p,b]),C=Boolean(Object.keys(a).length&&Object.keys(p).length),x=C;C&&Object.keys(a).some((function(e){return !p[e]}))&&(C=!1),C||R&&R.length&&R.some((function(e){var t=e.id;return !p[t]}))&&(x=!1);var P=h(d);w((function(){P()&&y({type:l.resetSelectedRows});}),[y,n]);var B=t.useCallback((function(e){return y({type:l.toggleAllRowsSelected,value:e})}),[y]),E=t.useCallback((function(e){return y({type:l.toggleAllPageRowsSelected,value:e})}),[y]),I=t.useCallback((function(e,t){return y({type:l.toggleRowSelected,id:e,value:t})}),[y]),F=h(e),G=f(r().getToggleAllRowsSelectedProps,{instance:F()}),A=f(r().getToggleAllPageRowsSelectedProps,{instance:F()});Object.assign(e,{selectedFlatRows:S,isAllRowsSelected:C,isAllPageRowsSelected:x,toggleRowSelected:I,toggleAllRowsSelected:B,getToggleAllRowsSelectedProps:G,getToggleAllPageRowsSelectedProps:A,toggleAllPageRowsSelected:E});}function bt(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=f(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e});}var St=function(e){return {}},Ct=function(e){return {}};l.setRowState="setRowState",l.setCellState="setCellState",l.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(Pt),e.useInstance.push(Bt),e.prepareRow.push(Et);};function Pt(e,t,n,o){var i=o.initialRowStateAccessor,u=void 0===i?St:i,s=o.initialCellStateAccessor,a=void 0===s?Ct:s,c=o.rowsById;if(t.type===l.init)return r({rowState:{}},e);if(t.type===l.resetRowState)return r({},e,{rowState:o.initialState.rowState||{}});if(t.type===l.setRowState){var d,f=t.rowId,p=t.value,g=void 0!==e.rowState[f]?e.rowState[f]:u(c[f]);return r({},e,{rowState:r({},e.rowState,(d={},d[f]=m(p,g),d))})}if(t.type===l.setCellState){var v,h,y,w,R,b=t.rowId,S=t.columnId,C=t.value,x=void 0!==e.rowState[b]?e.rowState[b]:u(c[b]),P=void 0!==(null==x?void 0:null==(v=x.cellState)?void 0:v[S])?x.cellState[S]:a(null==(h=c[b])?void 0:null==(y=h.cells)?void 0:y.find((function(e){return e.column.id===S})));return r({},e,{rowState:r({},e.rowState,(R={},R[b]=r({},x,{cellState:r({},x.cellState||{},(w={},w[S]=m(C,P),w))}),R))})}}function Bt(e){var n=e.autoResetRowState,o=void 0===n||n,r=e.data,i=e.dispatch,u=t.useCallback((function(e,t){return i({type:l.setRowState,rowId:e,value:t})}),[i]),s=t.useCallback((function(e,t,n){return i({type:l.setCellState,rowId:e,columnId:t,value:n})}),[i]),a=h(o);w((function(){a()&&i({type:l.resetRowState});}),[r]),Object.assign(e,{setRowState:u,setCellState:s});}function Et(e,t){var n=t.instance,o=n.initialRowStateAccessor,r=void 0===o?St:o,i=n.initialCellStateAccessor,u=void 0===i?Ct:i,l=n.state.rowState;e&&(e.state=void 0!==l[e.id]?l[e.id]:r(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:u(t),t.setState=function(o){return n.setCellState(e.id,t.column.id,o)};})));}xt.pluginName="useRowState",l.resetColumnOrder="resetColumnOrder",l.setColumnOrder="setColumnOrder";var It=function(e){e.stateReducers.push(Ft),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Gt),e.useInstance.push(At);};function Ft(e,t,n,o){return t.type===l.init?r({columnOrder:[]},e):t.type===l.resetColumnOrder?r({},e,{columnOrder:o.initialState.columnOrder||[]}):t.type===l.setColumnOrder?r({},e,{columnOrder:m(t.columnOrder,e.columnOrder)}):void 0}function Gt(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var o=[].concat(n),r=[].concat(e),i=[],u=function(){var e=o.shift(),t=r.findIndex((function(t){return t.id===e}));t>-1&&i.push(r.splice(t,1)[0]);};r.length&&o.length;)u();return [].concat(i,r)}function At(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:l.setColumnOrder,columnOrder:e})}),[n]);}It.pluginName="useColumnOrder",c.canResize=!0,l.columnStartResizing="columnStartResizing",l.columnResizing="columnResizing",l.columnDoneResizing="columnDoneResizing",l.resetResize="resetResize";var kt=function(e){e.getResizerProps=[Ht],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(Tt),e.useInstance.push(Wt),e.useInstanceBeforeDimensions.push(zt);},Ht=function(e,t){var n=t.instance,o=t.header,r=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0;}var o=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e);t.push(n);}(e),t}(t).map((function(e){return [e.id,e.totalWidth]})),i=n?Math.round(e.touches[0].clientX):e.clientX,u=function(e){r({type:l.columnResizing,clientX:e});},s=function(){return r({type:l.columnDoneResizing})},a={mouse:{moveEvent:"mousemove",moveHandler:function(e){return u(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",a.mouse.moveHandler),document.removeEventListener("mouseup",a.mouse.upHandler),s();}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),u(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(a.touch.moveEvent,a.touch.moveHandler),document.removeEventListener(a.touch.upEvent,a.touch.moveHandler),s();}}},c=n?a.touch:a.mouse,d=!!function(){if("boolean"==typeof z)return z;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t);}catch(t){e=!1;}return z=e}()&&{passive:!1};document.addEventListener(c.moveEvent,c.moveHandler,d),document.addEventListener(c.upEvent,c.upHandler,d),r({type:l.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:o,clientX:i});};return [e,{onMouseDown:function(e){return e.persist()||i(e,o)},onTouchStart:function(e){return e.persist()||i(e,o)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function Tt(e,t){if(t.type===l.init)return r({columnResizing:{columnWidths:{}}},e);if(t.type===l.resetResize)return r({},e,{columnResizing:{columnWidths:{}}});if(t.type===l.columnStartResizing){var n=t.clientX,o=t.columnId,i=t.columnWidth,u=t.headerIdWidths;return r({},e,{columnResizing:r({},e.columnResizing,{startX:n,headerIdWidths:u,columnWidth:i,isResizingColumn:o})})}if(t.type===l.columnResizing){var s=t.clientX,a=e.columnResizing,c=a.startX,d=a.columnWidth,f=a.headerIdWidths,p=(s-c)/d,g={};return (void 0===f?[]:f).forEach((function(e){var t=e[0],n=e[1];g[t]=Math.max(n+n*p,0);})),r({},e,{columnResizing:r({},e.columnResizing,{columnWidths:r({},e.columnResizing.columnWidths,{},g)})})}return t.type===l.columnDoneResizing?r({},e,{columnResizing:r({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}kt.pluginName="useResizeColumns";var zt=function(e){var t=e.flatHeaders,n=e.disableResizing,o=e.getHooks,r=e.state.columnResizing,i=h(e);t.forEach((function(e){var t=I(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=r.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=r.isResizingColumn===e.id,t&&(e.getResizerProps=f(o().getResizerProps,{instance:i(),header:e}));}));};function Wt(e){var n=e.plugins,o=e.dispatch,r=e.autoResetResize,i=void 0===r||r,u=e.columns;v(n,["useAbsoluteLayout"],"useResizeColumns");var s=h(i);w((function(){s()&&o({type:l.resetResize});}),[u]);var a=t.useCallback((function(){return o({type:l.resetResize})}),[o]);Object.assign(e,{resetResizing:a});}var Ot={position:"absolute",top:0},Mt=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Ot,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}));};Mt.pluginName="useAbsoluteLayout";var jt=function(e,t){return [e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Nt={display:"inline-block",boxSizing:"border-box"},Lt=function(e,t){return [e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Dt=function(e){e.getRowProps.push(Lt),e.getHeaderGroupProps.push(Lt),e.getFooterGroupProps.push(Lt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Nt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]}));};function Vt(e){e.getTableProps.push(_t),e.getRowProps.push(Xt),e.getHeaderGroupProps.push(Xt),e.getFooterGroupProps.push(Xt),e.getHeaderProps.push(qt),e.getCellProps.push(Kt),e.getFooterProps.push(Ut);}Dt.pluginName="useBlockLayout",Vt.pluginName="useFlexLayout";var _t=function(e,t){return [e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Xt=function(e,t){return [e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},qt=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Kt=function(e,t){var n=t.cell;return [e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Ut=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function $t(e){e.stateReducers.push(Qt),e.getTableProps.push(Jt),e.getHeaderProps.push(Yt);}$t.pluginName="useGridLayout";var Jt=function(e,t){return [e,{style:{display:"grid",gridTemplateColumns:t.instance.state.gridLayout.columnWidths.map((function(e){return e})).join(" ")}}]},Yt=function(e,t){return [e,{id:"header-cell-"+t.column.id,style:{position:"sticky"}}]};function Qt(e,t,n,o){if("init"===t.type)return r({gridLayout:{columnWidths:o.columns.map((function(){return "auto"}))}},e);if("columnStartResizing"===t.type){var i=t.columnId,u=o.visibleColumns.findIndex((function(e){return e.id===i})),l=function(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}(i);return void 0!==l?r({},e,{gridLayout:r({},e.gridLayout,{columnId:i,columnIndex:u,startingWidth:l})}):e}if("columnResizing"===t.type){var s=e.gridLayout,a=s.columnIndex,c=s.startingWidth,d=s.columnWidths,f=c-(e.columnResizing.startX-t.clientX),p=[].concat(d);return p[a]=f+"px",r({},e,{gridLayout:r({},e.gridLayout,{columnWidths:p})})}}e._UNSTABLE_usePivotColumns=nt,e.actions=l,e.defaultColumn=c,e.defaultGroupByFn=De,e.defaultOrderByFn=Qe,e.defaultRenderer=s,e.emptyRenderer=a,e.ensurePluginOrder=v,e.flexRender=b,e.functionalUpdate=m,e.loopHooks=g,e.makePropGetter=f,e.makeRenderer=R,e.reduceHooks=p,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Mt,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var r=t.useRef({}),i=h(e),u=h(n);return t.useCallback(function(){var e=o(regeneratorRuntime.mark((function e(){var t,n,l,s=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=s.length,n=new Array(t),l=0;l<t;l++)n[l]=s[l];return r.current.promise||(r.current.promise=new Promise((function(e,t){r.current.resolve=e,r.current.reject=t;}))),r.current.timeout&&clearTimeout(r.current.timeout),r.current.timeout=setTimeout(o(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete r.current.timeout,e.prev=1,e.t0=r.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),r.current.reject(e.t2);case 12:return e.prev=12,delete r.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),u()),e.abrupt("return",r.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,u])},e.useBlockLayout=Dt,e.useColumnOrder=It,e.useExpanded=se,e.useFilters=Pe,e.useFlexLayout=Vt,e.useGetLatest=h,e.useGlobalFilter=Ie,e.useGridLayout=$t,e.useGroupBy=ze,e.useMountedLayoutEffect=w,e.usePagination=Ze,e.useResizeColumns=kt,e.useRowSelect=vt,e.useRowState=xt,e.useSortBy=Ue,e.useTable=function(e){for(var n=arguments.length,o=new Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];e=ie(e),o=[K].concat(o);var u=t.useRef({}),s=h(u.current);Object.assign(s(),r({},e,{plugins:o,hooks:q()})),o.filter(Boolean).forEach((function(e){e(s().hooks);}));var a=h(s().hooks);s().getHooks=a,delete s().hooks,Object.assign(s(),p(a().useOptions,ie(e)));var c=s(),d=c.data,v=c.columns,m=c.initialState,y=c.defaultColumn,w=c.getSubRows,b=c.getRowId,E=c.stateReducer,I=c.useControlledState,F=h(E),G=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return [].concat(a().stateReducers,Array.isArray(F())?F():[F()]).reduce((function(n,o){return o(n,t,e,s())||n}),e)}),[a,F,s]),A=t.useReducer(G,void 0,(function(){return G(m,{type:l.init})})),k=A[0],H=A[1],T=p([].concat(a().useControlledState,[I]),k,{instance:s()});Object.assign(s(),{state:T,dispatch:H});var z=t.useMemo((function(){return S(p(a().columns,v,{instance:s()}))}),[a,s,v].concat(p(a().columnsDeps,[],{instance:s()})));s().columns=z;var W=t.useMemo((function(){return p(a().allColumns,C(z),{instance:s()}).map(x)}),[z,a,s].concat(p(a().allColumnsDeps,[],{instance:s()})));s().allColumns=W;var O=t.useMemo((function(){for(var e=[],t=[],n={},o=[].concat(W);o.length;){var r=o.shift();le({data:d,rows:e,flatRows:t,rowsById:n,column:r,getRowId:b,getSubRows:w,accessValueHooks:a().accessValue,getInstance:s});}return [e,t,n]}),[W,d,b,w,a,s]),M=O[0],j=O[1],N=O[2];Object.assign(s(),{rows:M,initialRows:[].concat(M),flatRows:j,rowsById:N}),g(a().useInstanceAfterData,s());var L=t.useMemo((function(){return p(a().visibleColumns,W,{instance:s()}).map((function(e){return P(e,y)}))}),[a,W,s,y].concat(p(a().visibleColumnsDeps,[],{instance:s()})));W=t.useMemo((function(){var e=[].concat(L);return W.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t);})),e}),[W,L]),s().allColumns=W;var D=t.useMemo((function(){return p(a().headerGroups,B(L,y),s())}),[a,L,y,s].concat(p(a().headerGroupsDeps,[],{instance:s()})));s().headerGroups=D;var V=t.useMemo((function(){return D.length?D[0].headers:[]}),[D]);s().headers=V,s().flatHeaders=D.reduce((function(e,t){return [].concat(e,t.headers)}),[]),g(a().useInstanceBeforeDimensions,s());var _=L.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");L=t.useMemo((function(){return L.filter((function(e){return e.isVisible}))}),[L,_]),s().visibleColumns=L;var X=ue(V),U=X[0],$=X[1],J=X[2];return s().totalColumnsMinWidth=U,s().totalColumnsWidth=$,s().totalColumnsMaxWidth=J,g(a().useInstance,s()),[].concat(s().flatHeaders,s().allColumns).forEach((function(e){e.render=R(s(),e),e.getHeaderProps=f(a().getHeaderProps,{instance:s(),column:e}),e.getFooterProps=f(a().getFooterProps,{instance:s(),column:e});})),s().headerGroups=t.useMemo((function(){return D.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=f(a().getHeaderGroupProps,{instance:s(),headerGroup:e,index:t}),e.getFooterGroupProps=f(a().getFooterGroupProps,{instance:s(),headerGroup:e,index:t}),!0)}))}),[D,s,a]),s().footerGroups=[].concat(s().headerGroups).reverse(),s().prepareRow=t.useCallback((function(e){e.getRowProps=f(a().getRowProps,{instance:s(),row:e}),e.allCells=W.map((function(t){var n=e.values[t.id],o={column:t,row:e,value:n};return o.getCellProps=f(a().getCellProps,{instance:s(),cell:o}),o.render=R(s(),t,{row:e,cell:o,value:n}),o})),e.cells=L.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),g(a().prepareRow,e,{instance:s()});}),[a,s,W,L]),s().getTableProps=f(a().getTableProps,{instance:s()}),s().getTableBodyProps=f(a().getTableBodyProps,{instance:s()}),g(a().useFinalInstance,s()),s()},Object.defineProperty(e,"__esModule",{value:!0});}));

});

var reactTable_development = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   factory(exports, React) ;
}(commonjsGlobal, (function (exports, React) {
  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];

    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }

    return (hint === "string" ? String : Number)(input);
  }

  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");

    return typeof key === "symbol" ? key : String(key);
  }

  var renderErr = 'Renderer Error ☝️';
  var actions = {
    init: 'init'
  };
  var defaultRenderer = function defaultRenderer(_ref) {
    var _ref$value = _ref.value,
        value = _ref$value === void 0 ? '' : _ref$value;
    return value;
  };
  var emptyRenderer = function emptyRenderer() {
    return React.createElement(React.Fragment, null, "\xA0");
  };
  var defaultColumn = {
    Cell: defaultRenderer,
    width: 150,
    minWidth: 0,
    maxWidth: Number.MAX_SAFE_INTEGER
  };

  function mergeProps() {
    for (var _len = arguments.length, propList = new Array(_len), _key = 0; _key < _len; _key++) {
      propList[_key] = arguments[_key];
    }

    return propList.reduce(function (props, next) {
      var style = next.style,
          className = next.className,
          rest = _objectWithoutPropertiesLoose(next, ["style", "className"]);

      props = _extends({}, props, {}, rest);

      if (style) {
        props.style = props.style ? _extends({}, props.style || {}, {}, style || {}) : style;
      }

      if (className) {
        props.className = props.className ? props.className + ' ' + className : className;
      }

      if (props.className === '') {
        delete props.className;
      }

      return props;
    }, {});
  }

  function handlePropGetter(prevProps, userProps, meta) {
    // Handle a lambda, pass it the previous props
    if (typeof userProps === 'function') {
      return handlePropGetter({}, userProps(prevProps, meta));
    } // Handle an array, merge each item as separate props


    if (Array.isArray(userProps)) {
      return mergeProps.apply(void 0, [prevProps].concat(userProps));
    } // Handle an object by default, merge the two objects


    return mergeProps(prevProps, userProps);
  }

  var makePropGetter = function makePropGetter(hooks, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return function (userProps) {
      if (userProps === void 0) {
        userProps = {};
      }

      return [].concat(hooks, [userProps]).reduce(function (prev, next) {
        return handlePropGetter(prev, next, _extends({}, meta, {
          userProps: userProps
        }));
      }, {});
    };
  };
  var reduceHooks = function reduceHooks(hooks, initial, meta, allowUndefined) {
    if (meta === void 0) {
      meta = {};
    }

    return hooks.reduce(function (prev, next) {
      var nextValue = next(prev, meta);

      {
        if (!allowUndefined && typeof nextValue === 'undefined') {
          console.info(next);
          throw new Error('React Table: A reducer hook ☝️ just returned undefined! This is not allowed.');
        }
      }

      return nextValue;
    }, initial);
  };
  var loopHooks = function loopHooks(hooks, context, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return hooks.forEach(function (hook) {
      var nextValue = hook(context, meta);

      {
        if (typeof nextValue !== 'undefined') {
          console.info(hook, nextValue);
          throw new Error('React Table: A loop-type hook ☝️ just returned a value! This is not allowed.');
        }
      }
    });
  };
  function ensurePluginOrder(plugins, befores, pluginName, afters) {
    if ( afters) {
      throw new Error("Defining plugins in the \"after\" section of ensurePluginOrder is no longer supported (see plugin " + pluginName + ")");
    }

    var pluginIndex = plugins.findIndex(function (plugin) {
      return plugin.pluginName === pluginName;
    });

    if (pluginIndex === -1) {
      {
        throw new Error("The plugin \"" + pluginName + "\" was not found in the plugin list!\nThis usually means you need to need to name your plugin hook by setting the 'pluginName' property of the hook function, eg:\n\n  " + pluginName + ".pluginName = '" + pluginName + "'\n");
      }
    }

    befores.forEach(function (before) {
      var beforeIndex = plugins.findIndex(function (plugin) {
        return plugin.pluginName === before;
      });

      if (beforeIndex > -1 && beforeIndex > pluginIndex) {
        {
          throw new Error("React Table: The " + pluginName + " plugin hook must be placed after the " + before + " plugin hook!");
        }
      }
    });
  }
  function functionalUpdate(updater, old) {
    return typeof updater === 'function' ? updater(old) : updater;
  }
  function useGetLatest(obj) {
    var ref = React.useRef();
    ref.current = obj;
    return React.useCallback(function () {
      return ref.current;
    }, []);
  } // SSR has issues with useLayoutEffect still, so use useEffect during SSR

  var safeUseLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;
  function useMountedLayoutEffect(fn, deps) {
    var mountedRef = React.useRef(false);
    safeUseLayoutEffect(function () {
      if (mountedRef.current) {
        fn();
      }

      mountedRef.current = true; // eslint-disable-next-line
    }, deps);
  }
  function useAsyncDebounce(defaultFn, defaultWait) {
    if (defaultWait === void 0) {
      defaultWait = 0;
    }

    var debounceRef = React.useRef({});
    var getDefaultFn = useGetLatest(defaultFn);
    var getDefaultWait = useGetLatest(defaultWait);
    return React.useCallback(
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _len2,
            args,
            _key2,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                for (_len2 = _args2.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                if (!debounceRef.current.promise) {
                  debounceRef.current.promise = new Promise(function (resolve, reject) {
                    debounceRef.current.resolve = resolve;
                    debounceRef.current.reject = reject;
                  });
                }

                if (debounceRef.current.timeout) {
                  clearTimeout(debounceRef.current.timeout);
                }

                debounceRef.current.timeout = setTimeout(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          delete debounceRef.current.timeout;
                          _context.prev = 1;
                          _context.t0 = debounceRef.current;
                          _context.next = 5;
                          return getDefaultFn().apply(void 0, args);

                        case 5:
                          _context.t1 = _context.sent;

                          _context.t0.resolve.call(_context.t0, _context.t1);

                          _context.next = 12;
                          break;

                        case 9:
                          _context.prev = 9;
                          _context.t2 = _context["catch"](1);
                          debounceRef.current.reject(_context.t2);

                        case 12:
                          _context.prev = 12;
                          delete debounceRef.current.promise;
                          return _context.finish(12);

                        case 15:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[1, 9, 12, 15]]);
                })), getDefaultWait());
                return _context2.abrupt("return", debounceRef.current.promise);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }(), [getDefaultFn, getDefaultWait]);
  }
  function makeRenderer(instance, column, meta) {
    if (meta === void 0) {
      meta = {};
    }

    return function (type, userProps) {
      if (userProps === void 0) {
        userProps = {};
      }

      var Comp = typeof type === 'string' ? column[type] : type;

      if (typeof Comp === 'undefined') {
        console.info(column);
        throw new Error(renderErr);
      }

      return flexRender(Comp, _extends({}, instance, {
        column: column
      }, meta, {}, userProps));
    };
  }
  function flexRender(Comp, props) {
    return isReactComponent(Comp) ? React.createElement(Comp, props) : Comp;
  }

  function isReactComponent(component) {
    return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
  }

  function isClassComponent(component) {
    return typeof component === 'function' && function () {
      var proto = Object.getPrototypeOf(component);
      return proto.prototype && proto.prototype.isReactComponent;
    }();
  }

  function isExoticComponent(component) {
    return typeof component === 'object' && typeof component.$$typeof === 'symbol' && ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description);
  }

  function linkColumnStructure(columns, parent, depth) {
    if (depth === void 0) {
      depth = 0;
    }

    return columns.map(function (column) {
      column = _extends({}, column, {
        parent: parent,
        depth: depth
      });
      assignColumnAccessor(column);

      if (column.columns) {
        column.columns = linkColumnStructure(column.columns, column, depth + 1);
      }

      return column;
    });
  }
  function flattenColumns(columns) {
    return flattenBy(columns, 'columns');
  }
  function assignColumnAccessor(column) {
    // First check for string accessor
    var id = column.id,
        accessor = column.accessor,
        Header = column.Header;

    if (typeof accessor === 'string') {
      id = id || accessor;
      var accessorPath = accessor.split('.');

      accessor = function accessor(row) {
        return getBy(row, accessorPath);
      };
    }

    if (!id && typeof Header === 'string' && Header) {
      id = Header;
    }

    if (!id && column.columns) {
      console.error(column);
      throw new Error('A column ID (or unique "Header" value) is required!');
    }

    if (!id) {
      console.error(column);
      throw new Error('A column ID (or string accessor) is required!');
    }

    Object.assign(column, {
      id: id,
      accessor: accessor
    });
    return column;
  }
  function decorateColumn(column, userDefaultColumn) {
    if (!userDefaultColumn) {
      throw new Error();
    }

    Object.assign(column, _extends({
      // Make sure there is a fallback header, just in case
      Header: emptyRenderer,
      Footer: emptyRenderer
    }, defaultColumn, {}, userDefaultColumn, {}, column));
    Object.assign(column, {
      originalWidth: column.width
    });
    return column;
  } // Build the header groups from the bottom up

  function makeHeaderGroups(allColumns, defaultColumn, additionalHeaderProperties) {
    if (additionalHeaderProperties === void 0) {
      additionalHeaderProperties = function additionalHeaderProperties() {
        return {};
      };
    }

    var headerGroups = [];
    var scanColumns = allColumns;
    var uid = 0;

    var getUID = function getUID() {
      return uid++;
    };

    var _loop = function _loop() {
      // The header group we are creating
      var headerGroup = {
        headers: []
      }; // The parent columns we're going to scan next

      var parentColumns = [];
      var hasParents = scanColumns.some(function (d) {
        return d.parent;
      }); // Scan each column for parents

      scanColumns.forEach(function (column) {
        // What is the latest (last) parent column?
        var latestParentColumn = [].concat(parentColumns).reverse()[0];
        var newParent;

        if (hasParents) {
          // If the column has a parent, add it if necessary
          if (column.parent) {
            newParent = _extends({}, column.parent, {
              originalId: column.parent.id,
              id: column.parent.id + "_" + getUID(),
              headers: [column]
            }, additionalHeaderProperties(column));
          } else {
            // If other columns have parents, we'll need to add a place holder if necessary
            var originalId = column.id + "_placeholder";
            newParent = decorateColumn(_extends({
              originalId: originalId,
              id: column.id + "_placeholder_" + getUID(),
              placeholderOf: column,
              headers: [column]
            }, additionalHeaderProperties(column)), defaultColumn);
          } // If the resulting parent columns are the same, just add
          // the column and increment the header span


          if (latestParentColumn && latestParentColumn.originalId === newParent.originalId) {
            latestParentColumn.headers.push(column);
          } else {
            parentColumns.push(newParent);
          }
        }

        headerGroup.headers.push(column);
      });
      headerGroups.push(headerGroup); // Start scanning the parent columns

      scanColumns = parentColumns;
    };

    while (scanColumns.length) {
      _loop();
    }

    return headerGroups.reverse();
  }
  var pathObjCache = new Map();
  function getBy(obj, path, def) {
    if (!path) {
      return obj;
    }

    var cacheKey = typeof path === 'function' ? path : JSON.stringify(path);

    var pathObj = pathObjCache.get(cacheKey) || function () {
      var pathObj = makePathArray(path);
      pathObjCache.set(cacheKey, pathObj);
      return pathObj;
    }();

    var val;

    try {
      val = pathObj.reduce(function (cursor, pathPart) {
        return cursor[pathPart];
      }, obj);
    } catch (e) {// continue regardless of error
    }

    return typeof val !== 'undefined' ? val : def;
  }
  function getFirstDefined() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    for (var i = 0; i < args.length; i += 1) {
      if (typeof args[i] !== 'undefined') {
        return args[i];
      }
    }
  }
  function isFunction(a) {
    if (typeof a === 'function') {
      return a;
    }
  }
  function flattenBy(arr, key) {
    var flat = [];

    var recurse = function recurse(arr) {
      arr.forEach(function (d) {
        if (!d[key]) {
          flat.push(d);
        } else {
          recurse(d[key]);
        }
      });
    };

    recurse(arr);
    return flat;
  }
  function expandRows(rows, _ref) {
    var manualExpandedKey = _ref.manualExpandedKey,
        expanded = _ref.expanded,
        _ref$expandSubRows = _ref.expandSubRows,
        expandSubRows = _ref$expandSubRows === void 0 ? true : _ref$expandSubRows;
    var expandedRows = [];

    var handleRow = function handleRow(row, addToExpandedRows) {
      if (addToExpandedRows === void 0) {
        addToExpandedRows = true;
      }

      row.isExpanded = row.original && row.original[manualExpandedKey] || expanded[row.id];
      row.canExpand = row.subRows && !!row.subRows.length;

      if (addToExpandedRows) {
        expandedRows.push(row);
      }

      if (row.subRows && row.subRows.length && row.isExpanded) {
        row.subRows.forEach(function (row) {
          return handleRow(row, expandSubRows);
        });
      }
    };

    rows.forEach(function (row) {
      return handleRow(row);
    });
    return expandedRows;
  }
  function getFilterMethod(filter, userFilterTypes, filterTypes) {
    return isFunction(filter) || userFilterTypes[filter] || filterTypes[filter] || filterTypes.text;
  }
  function shouldAutoRemoveFilter(autoRemove, value, column) {
    return autoRemove ? autoRemove(value, column) : typeof value === 'undefined';
  }
  function unpreparedAccessWarning() {
    throw new Error('React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.');
  }
  var passiveSupported = null;
  function passiveEventSupported() {
    // memoize support to avoid adding multiple test events
    if (typeof passiveSupported === 'boolean') return passiveSupported;
    var supported = false;

    try {
      var options = {
        get passive() {
          supported = true;
          return false;
        }

      };
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    } catch (err) {
      supported = false;
    }

    passiveSupported = supported;
    return passiveSupported;
  } //

  var reOpenBracket = /\[/g;
  var reCloseBracket = /\]/g;

  function makePathArray(obj) {
    return flattenDeep(obj) // remove all periods in parts
    .map(function (d) {
      return String(d).replace('.', '_');
    }) // join parts using period
    .join('.') // replace brackets with periods
    .replace(reOpenBracket, '.').replace(reCloseBracket, '') // split it back out on periods
    .split('.');
  }

  function flattenDeep(arr, newArr) {
    if (newArr === void 0) {
      newArr = [];
    }

    if (!Array.isArray(arr)) {
      newArr.push(arr);
    } else {
      for (var i = 0; i < arr.length; i += 1) {
        flattenDeep(arr[i], newArr);
      }
    }

    return newArr;
  }

  var defaultGetTableProps = function defaultGetTableProps(props) {
    return _extends({
      role: 'table'
    }, props);
  };

  var defaultGetTableBodyProps = function defaultGetTableBodyProps(props) {
    return _extends({
      role: 'rowgroup'
    }, props);
  };

  var defaultGetHeaderProps = function defaultGetHeaderProps(props, _ref) {
    var column = _ref.column;
    return _extends({
      key: "header_" + column.id,
      colSpan: column.totalVisibleHeaderCount,
      role: 'columnheader'
    }, props);
  };

  var defaultGetFooterProps = function defaultGetFooterProps(props, _ref2) {
    var column = _ref2.column;
    return _extends({
      key: "footer_" + column.id,
      colSpan: column.totalVisibleHeaderCount
    }, props);
  };

  var defaultGetHeaderGroupProps = function defaultGetHeaderGroupProps(props, _ref3) {
    var index = _ref3.index;
    return _extends({
      key: "headerGroup_" + index,
      role: 'row'
    }, props);
  };

  var defaultGetFooterGroupProps = function defaultGetFooterGroupProps(props, _ref4) {
    var index = _ref4.index;
    return _extends({
      key: "footerGroup_" + index
    }, props);
  };

  var defaultGetRowProps = function defaultGetRowProps(props, _ref5) {
    var row = _ref5.row;
    return _extends({
      key: "row_" + row.id,
      role: 'row'
    }, props);
  };

  var defaultGetCellProps = function defaultGetCellProps(props, _ref6) {
    var cell = _ref6.cell;
    return _extends({
      key: "cell_" + cell.row.id + "_" + cell.column.id,
      role: 'cell'
    }, props);
  };

  function makeDefaultPluginHooks() {
    return {
      useOptions: [],
      stateReducers: [],
      useControlledState: [],
      columns: [],
      columnsDeps: [],
      allColumns: [],
      allColumnsDeps: [],
      accessValue: [],
      materializedColumns: [],
      materializedColumnsDeps: [],
      useInstanceAfterData: [],
      visibleColumns: [],
      visibleColumnsDeps: [],
      headerGroups: [],
      headerGroupsDeps: [],
      useInstanceBeforeDimensions: [],
      useInstance: [],
      prepareRow: [],
      getTableProps: [defaultGetTableProps],
      getTableBodyProps: [defaultGetTableBodyProps],
      getHeaderGroupProps: [defaultGetHeaderGroupProps],
      getFooterGroupProps: [defaultGetFooterGroupProps],
      getHeaderProps: [defaultGetHeaderProps],
      getFooterProps: [defaultGetFooterProps],
      getRowProps: [defaultGetRowProps],
      getCellProps: [defaultGetCellProps],
      useFinalInstance: []
    };
  }

  actions.resetHiddenColumns = 'resetHiddenColumns';
  actions.toggleHideColumn = 'toggleHideColumn';
  actions.setHiddenColumns = 'setHiddenColumns';
  actions.toggleHideAllColumns = 'toggleHideAllColumns';
  var useColumnVisibility = function useColumnVisibility(hooks) {
    hooks.getToggleHiddenProps = [defaultGetToggleHiddenProps];
    hooks.getToggleHideAllColumnsProps = [defaultGetToggleHideAllColumnsProps];
    hooks.stateReducers.push(reducer);
    hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions);
    hooks.headerGroupsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.hiddenColumns]);
    });
    hooks.useInstance.push(useInstance);
  };
  useColumnVisibility.pluginName = 'useColumnVisibility';

  var defaultGetToggleHiddenProps = function defaultGetToggleHiddenProps(props, _ref2) {
    var column = _ref2.column;
    return [props, {
      onChange: function onChange(e) {
        column.toggleHidden(!e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: column.isVisible,
      title: 'Toggle Column Visible'
    }];
  };

  var defaultGetToggleHideAllColumnsProps = function defaultGetToggleHideAllColumnsProps(props, _ref3) {
    var instance = _ref3.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleHideAllColumns(!e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: !instance.allColumnsHidden && !instance.state.hiddenColumns.length,
      title: 'Toggle All Columns Hidden',
      indeterminate: !instance.allColumnsHidden && instance.state.hiddenColumns.length
    }];
  };

  function reducer(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        hiddenColumns: []
      }, state);
    }

    if (action.type === actions.resetHiddenColumns) {
      return _extends({}, state, {
        hiddenColumns: instance.initialState.hiddenColumns || []
      });
    }

    if (action.type === actions.toggleHideColumn) {
      var should = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.includes(action.columnId);
      var hiddenColumns = should ? [].concat(state.hiddenColumns, [action.columnId]) : state.hiddenColumns.filter(function (d) {
        return d !== action.columnId;
      });
      return _extends({}, state, {
        hiddenColumns: hiddenColumns
      });
    }

    if (action.type === actions.setHiddenColumns) {
      return _extends({}, state, {
        hiddenColumns: functionalUpdate(action.value, state.hiddenColumns)
      });
    }

    if (action.type === actions.toggleHideAllColumns) {
      var shouldAll = typeof action.value !== 'undefined' ? action.value : !state.hiddenColumns.length;
      return _extends({}, state, {
        hiddenColumns: shouldAll ? instance.allColumns.map(function (d) {
          return d.id;
        }) : []
      });
    }
  }

  function useInstanceBeforeDimensions(instance) {
    var headers = instance.headers,
        hiddenColumns = instance.state.hiddenColumns;
    var isMountedRef = React.useRef(false);

    if (!isMountedRef.current) ;

    var handleColumn = function handleColumn(column, parentVisible) {
      column.isVisible = parentVisible && !hiddenColumns.includes(column.id);
      var totalVisibleHeaderCount = 0;

      if (column.headers && column.headers.length) {
        column.headers.forEach(function (subColumn) {
          return totalVisibleHeaderCount += handleColumn(subColumn, column.isVisible);
        });
      } else {
        totalVisibleHeaderCount = column.isVisible ? 1 : 0;
      }

      column.totalVisibleHeaderCount = totalVisibleHeaderCount;
      return totalVisibleHeaderCount;
    };

    var totalVisibleHeaderCount = 0;
    headers.forEach(function (subHeader) {
      return totalVisibleHeaderCount += handleColumn(subHeader, true);
    });
  }

  function useInstance(instance) {
    var columns = instance.columns,
        flatHeaders = instance.flatHeaders,
        dispatch = instance.dispatch,
        allColumns = instance.allColumns,
        getHooks = instance.getHooks,
        hiddenColumns = instance.state.hiddenColumns,
        _instance$autoResetHi = instance.autoResetHiddenColumns,
        autoResetHiddenColumns = _instance$autoResetHi === void 0 ? true : _instance$autoResetHi;
    var getInstance = useGetLatest(instance);
    var allColumnsHidden = allColumns.length === hiddenColumns.length;
    var toggleHideColumn = React.useCallback(function (columnId, value) {
      return dispatch({
        type: actions.toggleHideColumn,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var setHiddenColumns = React.useCallback(function (value) {
      return dispatch({
        type: actions.setHiddenColumns,
        value: value
      });
    }, [dispatch]);
    var toggleHideAllColumns = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleHideAllColumns,
        value: value
      });
    }, [dispatch]);
    var getToggleHideAllColumnsProps = makePropGetter(getHooks().getToggleHideAllColumnsProps, {
      instance: getInstance()
    });
    flatHeaders.forEach(function (column) {
      column.toggleHidden = function (value) {
        dispatch({
          type: actions.toggleHideColumn,
          columnId: column.id,
          value: value
        });
      };

      column.getToggleHiddenProps = makePropGetter(getHooks().getToggleHiddenProps, {
        instance: getInstance(),
        column: column
      });
    });
    var getAutoResetHiddenColumns = useGetLatest(autoResetHiddenColumns);
    useMountedLayoutEffect(function () {
      if (getAutoResetHiddenColumns()) {
        dispatch({
          type: actions.resetHiddenColumns
        });
      }
    }, [dispatch, columns]);
    Object.assign(instance, {
      allColumnsHidden: allColumnsHidden,
      toggleHideColumn: toggleHideColumn,
      setHiddenColumns: setHiddenColumns,
      toggleHideAllColumns: toggleHideAllColumns,
      getToggleHideAllColumnsProps: getToggleHideAllColumnsProps
    });
  }

  var defaultInitialState = {};
  var defaultColumnInstance = {};

  var defaultReducer = function defaultReducer(state, action, prevState) {
    return state;
  };

  var defaultGetSubRows = function defaultGetSubRows(row, index) {
    return row.subRows || [];
  };

  var defaultGetRowId = function defaultGetRowId(row, index, parent) {
    return "" + (parent ? [parent.id, index].join('.') : index);
  };

  var defaultUseControlledState = function defaultUseControlledState(d) {
    return d;
  };

  function applyDefaults(props) {
    var _props$initialState = props.initialState,
        initialState = _props$initialState === void 0 ? defaultInitialState : _props$initialState,
        _props$defaultColumn = props.defaultColumn,
        defaultColumn = _props$defaultColumn === void 0 ? defaultColumnInstance : _props$defaultColumn,
        _props$getSubRows = props.getSubRows,
        getSubRows = _props$getSubRows === void 0 ? defaultGetSubRows : _props$getSubRows,
        _props$getRowId = props.getRowId,
        getRowId = _props$getRowId === void 0 ? defaultGetRowId : _props$getRowId,
        _props$stateReducer = props.stateReducer,
        stateReducer = _props$stateReducer === void 0 ? defaultReducer : _props$stateReducer,
        _props$useControlledS = props.useControlledState,
        useControlledState = _props$useControlledS === void 0 ? defaultUseControlledState : _props$useControlledS,
        rest = _objectWithoutPropertiesLoose(props, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]);

    return _extends({}, rest, {
      initialState: initialState,
      defaultColumn: defaultColumn,
      getSubRows: getSubRows,
      getRowId: getRowId,
      stateReducer: stateReducer,
      useControlledState: useControlledState
    });
  }

  var useTable = function useTable(props) {
    for (var _len = arguments.length, plugins = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      plugins[_key - 1] = arguments[_key];
    }

    // Apply default props
    props = applyDefaults(props); // Add core plugins

    plugins = [useColumnVisibility].concat(plugins); // Create the table instance

    var instanceRef = React.useRef({}); // Create a getter for the instance (helps avoid a lot of potential memory leaks)

    var getInstance = useGetLatest(instanceRef.current); // Assign the props, plugins and hooks to the instance

    Object.assign(getInstance(), _extends({}, props, {
      plugins: plugins,
      hooks: makeDefaultPluginHooks()
    })); // Allow plugins to register hooks as early as possible

    plugins.filter(Boolean).forEach(function (plugin) {
      plugin(getInstance().hooks);
    }); // Consume all hooks and make a getter for them

    var getHooks = useGetLatest(getInstance().hooks);
    getInstance().getHooks = getHooks;
    delete getInstance().hooks; // Allow useOptions hooks to modify the options coming into the table

    Object.assign(getInstance(), reduceHooks(getHooks().useOptions, applyDefaults(props)));

    var _getInstance = getInstance(),
        data = _getInstance.data,
        userColumns = _getInstance.columns,
        initialState = _getInstance.initialState,
        defaultColumn = _getInstance.defaultColumn,
        getSubRows = _getInstance.getSubRows,
        getRowId = _getInstance.getRowId,
        stateReducer = _getInstance.stateReducer,
        useControlledState = _getInstance.useControlledState; // Setup user reducer ref


    var getStateReducer = useGetLatest(stateReducer); // Build the reducer

    var reducer = React.useCallback(function (state, action) {
      // Detect invalid actions
      if (!action.type) {
        console.info({
          action: action
        });
        throw new Error('Unknown Action 👆');
      } // Reduce the state from all plugin reducers


      return [].concat(getHooks().stateReducers, Array.isArray(getStateReducer()) ? getStateReducer() : [getStateReducer()]).reduce(function (s, handler) {
        return handler(s, action, state, getInstance()) || s;
      }, state);
    }, [getHooks, getStateReducer, getInstance]); // Start the reducer

    var _React$useReducer = React.useReducer(reducer, undefined, function () {
      return reducer(initialState, {
        type: actions.init
      });
    }),
        reducerState = _React$useReducer[0],
        dispatch = _React$useReducer[1]; // Allow the user to control the final state with hooks


    var state = reduceHooks([].concat(getHooks().useControlledState, [useControlledState]), reducerState, {
      instance: getInstance()
    });
    Object.assign(getInstance(), {
      state: state,
      dispatch: dispatch
    }); // Decorate All the columns

    var columns = React.useMemo(function () {
      return linkColumnStructure(reduceHooks(getHooks().columns, userColumns, {
        instance: getInstance()
      }));
    }, [getHooks, getInstance, userColumns].concat(reduceHooks(getHooks().columnsDeps, [], {
      instance: getInstance()
    })));
    getInstance().columns = columns; // Get the flat list of all columns and allow hooks to decorate
    // those columns (and trigger this memoization via deps)

    var allColumns = React.useMemo(function () {
      return reduceHooks(getHooks().allColumns, flattenColumns(columns), {
        instance: getInstance()
      }).map(assignColumnAccessor);
    }, [columns, getHooks, getInstance].concat(reduceHooks(getHooks().allColumnsDeps, [], {
      instance: getInstance()
    })));
    getInstance().allColumns = allColumns; // Access the row model using initial columns

    var _React$useMemo = React.useMemo(function () {
      var rows = [];
      var flatRows = [];
      var rowsById = {};
      var allColumnsQueue = [].concat(allColumns);

      while (allColumnsQueue.length) {
        var column = allColumnsQueue.shift();
        accessRowsForColumn({
          data: data,
          rows: rows,
          flatRows: flatRows,
          rowsById: rowsById,
          column: column,
          getRowId: getRowId,
          getSubRows: getSubRows,
          accessValueHooks: getHooks().accessValue,
          getInstance: getInstance
        });
      }

      return [rows, flatRows, rowsById];
    }, [allColumns, data, getRowId, getSubRows, getHooks, getInstance]),
        rows = _React$useMemo[0],
        flatRows = _React$useMemo[1],
        rowsById = _React$useMemo[2];

    Object.assign(getInstance(), {
      rows: rows,
      initialRows: [].concat(rows),
      flatRows: flatRows,
      rowsById: rowsById // materializedColumns,

    });
    loopHooks(getHooks().useInstanceAfterData, getInstance()); // Get the flat list of all columns AFTER the rows
    // have been access, and allow hooks to decorate
    // those columns (and trigger this memoization via deps)

    var visibleColumns = React.useMemo(function () {
      return reduceHooks(getHooks().visibleColumns, allColumns, {
        instance: getInstance()
      }).map(function (d) {
        return decorateColumn(d, defaultColumn);
      });
    }, [getHooks, allColumns, getInstance, defaultColumn].concat(reduceHooks(getHooks().visibleColumnsDeps, [], {
      instance: getInstance()
    }))); // Combine new visible columns with all columns

    allColumns = React.useMemo(function () {
      var columns = [].concat(visibleColumns);
      allColumns.forEach(function (column) {
        if (!columns.find(function (d) {
          return d.id === column.id;
        })) {
          columns.push(column);
        }
      });
      return columns;
    }, [allColumns, visibleColumns]);
    getInstance().allColumns = allColumns;

    {
      var duplicateColumns = allColumns.filter(function (column, i) {
        return allColumns.findIndex(function (d) {
          return d.id === column.id;
        }) !== i;
      });

      if (duplicateColumns.length) {
        console.info(allColumns);
        throw new Error("Duplicate columns were found with ids: \"" + duplicateColumns.map(function (d) {
          return d.id;
        }).join(', ') + "\" in the columns array above");
      }
    } // Make the headerGroups


    var headerGroups = React.useMemo(function () {
      return reduceHooks(getHooks().headerGroups, makeHeaderGroups(visibleColumns, defaultColumn), getInstance());
    }, [getHooks, visibleColumns, defaultColumn, getInstance].concat(reduceHooks(getHooks().headerGroupsDeps, [], {
      instance: getInstance()
    })));
    getInstance().headerGroups = headerGroups; // Get the first level of headers

    var headers = React.useMemo(function () {
      return headerGroups.length ? headerGroups[0].headers : [];
    }, [headerGroups]);
    getInstance().headers = headers; // Provide a flat header list for utilities

    getInstance().flatHeaders = headerGroups.reduce(function (all, headerGroup) {
      return [].concat(all, headerGroup.headers);
    }, []);
    loopHooks(getHooks().useInstanceBeforeDimensions, getInstance()); // Filter columns down to visible ones

    var visibleColumnsDep = visibleColumns.filter(function (d) {
      return d.isVisible;
    }).map(function (d) {
      return d.id;
    }).sort().join('_');
    visibleColumns = React.useMemo(function () {
      return visibleColumns.filter(function (d) {
        return d.isVisible;
      });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [visibleColumns, visibleColumnsDep]);
    getInstance().visibleColumns = visibleColumns; // Header Visibility is needed by this point

    var _calculateHeaderWidth = calculateHeaderWidths(headers),
        totalColumnsMinWidth = _calculateHeaderWidth[0],
        totalColumnsWidth = _calculateHeaderWidth[1],
        totalColumnsMaxWidth = _calculateHeaderWidth[2];

    getInstance().totalColumnsMinWidth = totalColumnsMinWidth;
    getInstance().totalColumnsWidth = totalColumnsWidth;
    getInstance().totalColumnsMaxWidth = totalColumnsMaxWidth;
    loopHooks(getHooks().useInstance, getInstance()) // Each materialized header needs to be assigned a render function and other
    // prop getter properties here.
    ;
    [].concat(getInstance().flatHeaders, getInstance().allColumns).forEach(function (column) {
      // Give columns/headers rendering power
      column.render = makeRenderer(getInstance(), column); // Give columns/headers a default getHeaderProps

      column.getHeaderProps = makePropGetter(getHooks().getHeaderProps, {
        instance: getInstance(),
        column: column
      }); // Give columns/headers a default getFooterProps

      column.getFooterProps = makePropGetter(getHooks().getFooterProps, {
        instance: getInstance(),
        column: column
      });
    });
    getInstance().headerGroups = React.useMemo(function () {
      return headerGroups.filter(function (headerGroup, i) {
        // Filter out any headers and headerGroups that don't have visible columns
        headerGroup.headers = headerGroup.headers.filter(function (column) {
          var recurse = function recurse(headers) {
            return headers.filter(function (column) {
              if (column.headers) {
                return recurse(column.headers);
              }

              return column.isVisible;
            }).length;
          };

          if (column.headers) {
            return recurse(column.headers);
          }

          return column.isVisible;
        }); // Give headerGroups getRowProps

        if (headerGroup.headers.length) {
          headerGroup.getHeaderGroupProps = makePropGetter(getHooks().getHeaderGroupProps, {
            instance: getInstance(),
            headerGroup: headerGroup,
            index: i
          });
          headerGroup.getFooterGroupProps = makePropGetter(getHooks().getFooterGroupProps, {
            instance: getInstance(),
            headerGroup: headerGroup,
            index: i
          });
          return true;
        }

        return false;
      });
    }, [headerGroups, getInstance, getHooks]);
    getInstance().footerGroups = [].concat(getInstance().headerGroups).reverse(); // The prepareRow function is absolutely necessary and MUST be called on
    // any rows the user wishes to be displayed.

    getInstance().prepareRow = React.useCallback(function (row) {
      row.getRowProps = makePropGetter(getHooks().getRowProps, {
        instance: getInstance(),
        row: row
      }); // Build the visible cells for each row

      row.allCells = allColumns.map(function (column) {
        var value = row.values[column.id];
        var cell = {
          column: column,
          row: row,
          value: value
        }; // Give each cell a getCellProps base

        cell.getCellProps = makePropGetter(getHooks().getCellProps, {
          instance: getInstance(),
          cell: cell
        }); // Give each cell a renderer function (supports multiple renderers)

        cell.render = makeRenderer(getInstance(), column, {
          row: row,
          cell: cell,
          value: value
        });
        return cell;
      });
      row.cells = visibleColumns.map(function (column) {
        return row.allCells.find(function (cell) {
          return cell.column.id === column.id;
        });
      }); // need to apply any row specific hooks (useExpanded requires this)

      loopHooks(getHooks().prepareRow, row, {
        instance: getInstance()
      });
    }, [getHooks, getInstance, allColumns, visibleColumns]);
    getInstance().getTableProps = makePropGetter(getHooks().getTableProps, {
      instance: getInstance()
    });
    getInstance().getTableBodyProps = makePropGetter(getHooks().getTableBodyProps, {
      instance: getInstance()
    });
    loopHooks(getHooks().useFinalInstance, getInstance());
    return getInstance();
  };

  function calculateHeaderWidths(headers, left) {
    if (left === void 0) {
      left = 0;
    }

    var sumTotalMinWidth = 0;
    var sumTotalWidth = 0;
    var sumTotalMaxWidth = 0;
    var sumTotalFlexWidth = 0;
    headers.forEach(function (header) {
      var subHeaders = header.headers;
      header.totalLeft = left;

      if (subHeaders && subHeaders.length) {
        var _calculateHeaderWidth2 = calculateHeaderWidths(subHeaders, left),
            totalMinWidth = _calculateHeaderWidth2[0],
            totalWidth = _calculateHeaderWidth2[1],
            totalMaxWidth = _calculateHeaderWidth2[2],
            totalFlexWidth = _calculateHeaderWidth2[3];

        header.totalMinWidth = totalMinWidth;
        header.totalWidth = totalWidth;
        header.totalMaxWidth = totalMaxWidth;
        header.totalFlexWidth = totalFlexWidth;
      } else {
        header.totalMinWidth = header.minWidth;
        header.totalWidth = Math.min(Math.max(header.minWidth, header.width), header.maxWidth);
        header.totalMaxWidth = header.maxWidth;
        header.totalFlexWidth = header.canResize ? header.totalWidth : 0;
      }

      if (header.isVisible) {
        left += header.totalWidth;
        sumTotalMinWidth += header.totalMinWidth;
        sumTotalWidth += header.totalWidth;
        sumTotalMaxWidth += header.totalMaxWidth;
        sumTotalFlexWidth += header.totalFlexWidth;
      }
    });
    return [sumTotalMinWidth, sumTotalWidth, sumTotalMaxWidth, sumTotalFlexWidth];
  }

  function accessRowsForColumn(_ref) {
    var data = _ref.data,
        rows = _ref.rows,
        flatRows = _ref.flatRows,
        rowsById = _ref.rowsById,
        column = _ref.column,
        getRowId = _ref.getRowId,
        getSubRows = _ref.getSubRows,
        accessValueHooks = _ref.accessValueHooks,
        getInstance = _ref.getInstance;

    // Access the row's data column-by-column
    // We do it this way so we can incrementally add materialized
    // columns after the first pass and avoid excessive looping
    var accessRow = function accessRow(originalRow, rowIndex, depth, parent, parentRows) {
      if (depth === void 0) {
        depth = 0;
      }

      // Keep the original reference around
      var original = originalRow;
      var id = getRowId(originalRow, rowIndex, parent);
      var row = rowsById[id]; // If the row hasn't been created, let's make it

      if (!row) {
        row = {
          id: id,
          original: original,
          index: rowIndex,
          depth: depth,
          cells: [{}] // This is a dummy cell

        }; // Override common array functions (and the dummy cell's getCellProps function)
        // to show an error if it is accessed without calling prepareRow

        row.cells.map = unpreparedAccessWarning;
        row.cells.filter = unpreparedAccessWarning;
        row.cells.forEach = unpreparedAccessWarning;
        row.cells[0].getCellProps = unpreparedAccessWarning; // Create the cells and values

        row.values = {}; // Push this row into the parentRows array

        parentRows.push(row); // Keep track of every row in a flat array

        flatRows.push(row); // Also keep track of every row by its ID

        rowsById[id] = row; // Get the original subrows

        row.originalSubRows = getSubRows(originalRow, rowIndex); // Then recursively access them

        if (row.originalSubRows) {
          var subRows = [];
          row.originalSubRows.forEach(function (d, i) {
            return accessRow(d, i, depth + 1, row, subRows);
          }); // Keep the new subRows array on the row

          row.subRows = subRows;
        }
      } else if (row.subRows) {
        // If the row exists, then it's already been accessed
        // Keep recursing, but don't worry about passing the
        // accumlator array (those rows already exist)
        row.originalSubRows.forEach(function (d, i) {
          return accessRow(d, i, depth + 1, row);
        });
      } // If the column has an accessor, use it to get a value


      if (column.accessor) {
        row.values[column.id] = column.accessor(originalRow, rowIndex, row, parentRows, data);
      } // Allow plugins to manipulate the column value


      row.values[column.id] = reduceHooks(accessValueHooks, row.values[column.id], {
        row: row,
        column: column,
        instance: getInstance()
      }, true);
    };

    data.forEach(function (originalRow, rowIndex) {
      return accessRow(originalRow, rowIndex, 0, undefined, rows);
    });
  }

  actions.resetExpanded = 'resetExpanded';
  actions.toggleRowExpanded = 'toggleRowExpanded';
  actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';
  var useExpanded = function useExpanded(hooks) {
    hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
    hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
    hooks.stateReducers.push(reducer$1);
    hooks.useInstance.push(useInstance$1);
    hooks.prepareRow.push(prepareRow);
  };
  useExpanded.pluginName = 'useExpanded';

  var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      onClick: function onClick(e) {
        instance.toggleAllRowsExpanded();
      },
      style: {
        cursor: 'pointer'
      },
      title: 'Toggle All Rows Expanded'
    }];
  };

  var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
    var row = _ref2.row;
    return [props, {
      onClick: function onClick() {
        row.toggleRowExpanded();
      },
      style: {
        cursor: 'pointer'
      },
      title: 'Toggle Row Expanded'
    }];
  }; // Reducer


  function reducer$1(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        expanded: {}
      }, state);
    }

    if (action.type === actions.resetExpanded) {
      return _extends({}, state, {
        expanded: instance.initialState.expanded || {}
      });
    }

    if (action.type === actions.toggleAllRowsExpanded) {
      var value = action.value;
      var isAllRowsExpanded = instance.isAllRowsExpanded,
          rowsById = instance.rowsById;
      var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;

      if (expandAll) {
        var expanded = {};
        Object.keys(rowsById).forEach(function (rowId) {
          expanded[rowId] = true;
        });
        return _extends({}, state, {
          expanded: expanded
        });
      }

      return _extends({}, state, {
        expanded: {}
      });
    }

    if (action.type === actions.toggleRowExpanded) {
      var id = action.id,
          setExpanded = action.value;
      var exists = state.expanded[id];
      var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;

      if (!exists && shouldExist) {
        var _extends2;

        return _extends({}, state, {
          expanded: _extends({}, state.expanded, (_extends2 = {}, _extends2[id] = true, _extends2))
        });
      } else if (exists && !shouldExist) {
        var _state$expanded = state.expanded,
            _ = _state$expanded[id],
            rest = _objectWithoutPropertiesLoose(_state$expanded, [id].map(_toPropertyKey));

        return _extends({}, state, {
          expanded: rest
        });
      } else {
        return state;
      }
    }
  }

  function useInstance$1(instance) {
    var data = instance.data,
        rows = instance.rows,
        rowsById = instance.rowsById,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$autoResetEx = instance.autoResetExpanded,
        autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        expanded = instance.state.expanded,
        dispatch = instance.dispatch;
    ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
    var getAutoResetExpanded = useGetLatest(autoResetExpanded);
    var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);

    if (isAllRowsExpanded) {
      if (Object.keys(rowsById).some(function (id) {
        return !expanded[id];
      })) {
        isAllRowsExpanded = false;
      }
    } // Bypass any effects from firing when this changes


    useMountedLayoutEffect(function () {
      if (getAutoResetExpanded()) {
        dispatch({
          type: actions.resetExpanded
        });
      }
    }, [dispatch, data]);
    var toggleRowExpanded = React.useCallback(function (id, value) {
      dispatch({
        type: actions.toggleRowExpanded,
        id: id,
        value: value
      });
    }, [dispatch]);
    var toggleAllRowsExpanded = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllRowsExpanded,
        value: value
      });
    }, [dispatch]);
    var expandedRows = React.useMemo(function () {
      if (paginateExpandedRows) {
        return expandRows(rows, {
          manualExpandedKey: manualExpandedKey,
          expanded: expanded,
          expandSubRows: expandSubRows
        });
      }

      return rows;
    }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
    var expandedDepth = React.useMemo(function () {
      return findExpandedDepth(expanded);
    }, [expanded]);
    var getInstance = useGetLatest(instance);
    var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
      instance: getInstance()
    });
    Object.assign(instance, {
      preExpandedRows: rows,
      expandedRows: expandedRows,
      rows: expandedRows,
      expandedDepth: expandedDepth,
      isAllRowsExpanded: isAllRowsExpanded,
      toggleRowExpanded: toggleRowExpanded,
      toggleAllRowsExpanded: toggleAllRowsExpanded,
      getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
    });
  }

  function prepareRow(row, _ref3) {
    var getHooks = _ref3.instance.getHooks,
        instance = _ref3.instance;

    row.toggleRowExpanded = function (set) {
      return instance.toggleRowExpanded(row.id, set);
    };

    row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
      instance: instance,
      row: row
    });
  }

  function findExpandedDepth(expanded) {
    var maxDepth = 0;
    Object.keys(expanded).forEach(function (id) {
      var splitId = id.split('.');
      maxDepth = Math.max(maxDepth, splitId.length);
    });
    return maxDepth;
  }

  var text = function text(rows, ids, filterValue) {
    rows = rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return String(rowValue).toLowerCase().includes(String(filterValue).toLowerCase());
      });
    });
    return rows;
  };

  text.autoRemove = function (val) {
    return !val;
  };

  var exactText = function exactText(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue !== undefined ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase() : true;
      });
    });
  };

  exactText.autoRemove = function (val) {
    return !val;
  };

  var exactTextCase = function exactTextCase(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue !== undefined ? String(rowValue) === String(filterValue) : true;
      });
    });
  };

  exactTextCase.autoRemove = function (val) {
    return !val;
  };

  var includes = function includes(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue.includes(filterValue);
      });
    });
  };

  includes.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesAll = function includesAll(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue && rowValue.length && filterValue.every(function (val) {
          return rowValue.includes(val);
        });
      });
    });
  };

  includesAll.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesSome = function includesSome(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue && rowValue.length && filterValue.some(function (val) {
          return rowValue.includes(val);
        });
      });
    });
  };

  includesSome.autoRemove = function (val) {
    return !val || !val.length;
  };

  var includesValue = function includesValue(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return filterValue.includes(rowValue);
      });
    });
  };

  includesValue.autoRemove = function (val) {
    return !val || !val.length;
  };

  var exact = function exact(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue === filterValue;
      });
    });
  };

  exact.autoRemove = function (val) {
    return typeof val === 'undefined';
  };

  var equals = function equals(rows, ids, filterValue) {
    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id]; // eslint-disable-next-line eqeqeq

        return rowValue == filterValue;
      });
    });
  };

  equals.autoRemove = function (val) {
    return val == null;
  };

  var between = function between(rows, ids, filterValue) {
    var _ref = filterValue || [],
        min = _ref[0],
        max = _ref[1];

    min = typeof min === 'number' ? min : -Infinity;
    max = typeof max === 'number' ? max : Infinity;

    if (min > max) {
      var temp = min;
      min = max;
      max = temp;
    }

    return rows.filter(function (row) {
      return ids.some(function (id) {
        var rowValue = row.values[id];
        return rowValue >= min && rowValue <= max;
      });
    });
  };

  between.autoRemove = function (val) {
    return !val || typeof val[0] !== 'number' && typeof val[1] !== 'number';
  };

  var filterTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    text: text,
    exactText: exactText,
    exactTextCase: exactTextCase,
    includes: includes,
    includesAll: includesAll,
    includesSome: includesSome,
    includesValue: includesValue,
    exact: exact,
    equals: equals,
    between: between
  });

  actions.resetFilters = 'resetFilters';
  actions.setFilter = 'setFilter';
  actions.setAllFilters = 'setAllFilters';
  var useFilters = function useFilters(hooks) {
    hooks.stateReducers.push(reducer$2);
    hooks.useInstance.push(useInstance$2);
  };
  useFilters.pluginName = 'useFilters';

  function reducer$2(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        filters: []
      }, state);
    }

    if (action.type === actions.resetFilters) {
      return _extends({}, state, {
        filters: instance.initialState.filters || []
      });
    }

    if (action.type === actions.setFilter) {
      var columnId = action.columnId,
          filterValue = action.filterValue;
      var allColumns = instance.allColumns,
          userFilterTypes = instance.filterTypes;
      var column = allColumns.find(function (d) {
        return d.id === columnId;
      });

      if (!column) {
        throw new Error("React-Table: Could not find a column with id: " + columnId);
      }

      var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);
      var previousfilter = state.filters.find(function (d) {
        return d.id === columnId;
      });
      var newFilter = functionalUpdate(filterValue, previousfilter && previousfilter.value); //

      if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter, column)) {
        return _extends({}, state, {
          filters: state.filters.filter(function (d) {
            return d.id !== columnId;
          })
        });
      }

      if (previousfilter) {
        return _extends({}, state, {
          filters: state.filters.map(function (d) {
            if (d.id === columnId) {
              return {
                id: columnId,
                value: newFilter
              };
            }

            return d;
          })
        });
      }

      return _extends({}, state, {
        filters: [].concat(state.filters, [{
          id: columnId,
          value: newFilter
        }])
      });
    }

    if (action.type === actions.setAllFilters) {
      var filters = action.filters;
      var _allColumns = instance.allColumns,
          _userFilterTypes = instance.filterTypes;
      return _extends({}, state, {
        // Filter out undefined values
        filters: functionalUpdate(filters, state.filters).filter(function (filter) {
          var column = _allColumns.find(function (d) {
            return d.id === filter.id;
          });

          var filterMethod = getFilterMethod(column.filter, _userFilterTypes || {}, filterTypes);

          if (shouldAutoRemoveFilter(filterMethod.autoRemove, filter.value, column)) {
            return false;
          }

          return true;
        })
      });
    }
  }

  function useInstance$2(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        manualFilters = instance.manualFilters,
        _instance$defaultCanF = instance.defaultCanFilter,
        defaultCanFilter = _instance$defaultCanF === void 0 ? false : _instance$defaultCanF,
        disableFilters = instance.disableFilters,
        filters = instance.state.filters,
        dispatch = instance.dispatch,
        _instance$autoResetFi = instance.autoResetFilters,
        autoResetFilters = _instance$autoResetFi === void 0 ? true : _instance$autoResetFi;
    var setFilter = React.useCallback(function (columnId, filterValue) {
      dispatch({
        type: actions.setFilter,
        columnId: columnId,
        filterValue: filterValue
      });
    }, [dispatch]);
    var setAllFilters = React.useCallback(function (filters) {
      dispatch({
        type: actions.setAllFilters,
        filters: filters
      });
    }, [dispatch]);
    allColumns.forEach(function (column) {
      var id = column.id,
          accessor = column.accessor,
          columnDefaultCanFilter = column.defaultCanFilter,
          columnDisableFilters = column.disableFilters; // Determine if a column is filterable

      column.canFilter = accessor ? getFirstDefined(columnDisableFilters === true ? false : undefined, disableFilters === true ? false : undefined, true) : getFirstDefined(columnDefaultCanFilter, defaultCanFilter, false); // Provide the column a way of updating the filter value

      column.setFilter = function (val) {
        return setFilter(column.id, val);
      }; // Provide the current filter value to the column for
      // convenience


      var found = filters.find(function (d) {
        return d.id === id;
      });
      column.filterValue = found && found.value;
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualFilters || !filters.length) {
        return [rows, flatRows, rowsById];
      }

      var filteredFlatRows = [];
      var filteredRowsById = {}; // Filters top level and nested rows

      var filterRows = function filterRows(rows, depth) {
        if (depth === void 0) {
          depth = 0;
        }

        var filteredRows = rows;
        filteredRows = filters.reduce(function (filteredSoFar, _ref) {
          var columnId = _ref.id,
              filterValue = _ref.value;
          // Find the filters column
          var column = allColumns.find(function (d) {
            return d.id === columnId;
          });

          if (!column) {
            return filteredSoFar;
          }

          if (depth === 0) {
            column.preFilteredRows = filteredSoFar;
          }

          var filterMethod = getFilterMethod(column.filter, userFilterTypes || {}, filterTypes);

          if (!filterMethod) {
            console.warn("Could not find a valid 'column.filter' for column with the ID: " + column.id + ".");
            return filteredSoFar;
          } // Pass the rows, id, filterValue and column to the filterMethod
          // to get the filtered rows back


          column.filteredRows = filterMethod(filteredSoFar, [columnId], filterValue);
          return column.filteredRows;
        }, rows); // Apply the filter to any subRows
        // We technically could do this recursively in the above loop,
        // but that would severely hinder the API for the user, since they
        // would be required to do that recursion in some scenarios

        filteredRows.forEach(function (row) {
          filteredFlatRows.push(row);
          filteredRowsById[row.id] = row;

          if (!row.subRows) {
            return;
          }

          row.subRows = row.subRows && row.subRows.length > 0 ? filterRows(row.subRows, depth + 1) : row.subRows;
        });
        return filteredRows;
      };

      return [filterRows(rows), filteredFlatRows, filteredRowsById];
    }, [manualFilters, filters, rows, flatRows, rowsById, allColumns, userFilterTypes]),
        filteredRows = _React$useMemo[0],
        filteredFlatRows = _React$useMemo[1],
        filteredRowsById = _React$useMemo[2];

    React.useMemo(function () {
      // Now that each filtered column has it's partially filtered rows,
      // lets assign the final filtered rows to all of the other columns
      var nonFilteredColumns = allColumns.filter(function (column) {
        return !filters.find(function (d) {
          return d.id === column.id;
        });
      }); // This essentially enables faceted filter options to be built easily
      // using every column's preFilteredRows value

      nonFilteredColumns.forEach(function (column) {
        column.preFilteredRows = filteredRows;
        column.filteredRows = filteredRows;
      });
    }, [filteredRows, filters, allColumns]);
    var getAutoResetFilters = useGetLatest(autoResetFilters);
    useMountedLayoutEffect(function () {
      if (getAutoResetFilters()) {
        dispatch({
          type: actions.resetFilters
        });
      }
    }, [dispatch, manualFilters ? null : data]);
    Object.assign(instance, {
      preFilteredRows: rows,
      preFilteredFlatRows: flatRows,
      preFilteredRowsById: rowsById,
      filteredRows: filteredRows,
      filteredFlatRows: filteredFlatRows,
      filteredRowsById: filteredRowsById,
      rows: filteredRows,
      flatRows: filteredFlatRows,
      rowsById: filteredRowsById,
      setFilter: setFilter,
      setAllFilters: setAllFilters
    });
  }

  actions.resetGlobalFilter = 'resetGlobalFilter';
  actions.setGlobalFilter = 'setGlobalFilter';
  var useGlobalFilter = function useGlobalFilter(hooks) {
    hooks.stateReducers.push(reducer$3);
    hooks.useInstance.push(useInstance$3);
  };
  useGlobalFilter.pluginName = 'useGlobalFilter';

  function reducer$3(state, action, previousState, instance) {
    if (action.type === actions.resetGlobalFilter) {
      return _extends({}, state, {
        globalFilter: instance.initialState.globalFilter || undefined
      });
    }

    if (action.type === actions.setGlobalFilter) {
      var filterValue = action.filterValue;
      var userFilterTypes = instance.userFilterTypes;
      var filterMethod = getFilterMethod(instance.globalFilter, userFilterTypes || {}, filterTypes);
      var newFilter = functionalUpdate(filterValue, state.globalFilter); //

      if (shouldAutoRemoveFilter(filterMethod.autoRemove, newFilter)) {
        var globalFilter = state.globalFilter,
            stateWithoutGlobalFilter = _objectWithoutPropertiesLoose(state, ["globalFilter"]);

        return stateWithoutGlobalFilter;
      }

      return _extends({}, state, {
        globalFilter: newFilter
      });
    }
  }

  function useInstance$3(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        userFilterTypes = instance.filterTypes,
        globalFilter = instance.globalFilter,
        manualGlobalFilter = instance.manualGlobalFilter,
        globalFilterValue = instance.state.globalFilter,
        dispatch = instance.dispatch,
        _instance$autoResetGl = instance.autoResetGlobalFilter,
        autoResetGlobalFilter = _instance$autoResetGl === void 0 ? true : _instance$autoResetGl,
        disableGlobalFilter = instance.disableGlobalFilter;
    var setGlobalFilter = React.useCallback(function (filterValue) {
      dispatch({
        type: actions.setGlobalFilter,
        filterValue: filterValue
      });
    }, [dispatch]); // TODO: Create a filter cache for incremental high speed multi-filtering
    // This gets pretty complicated pretty fast, since you have to maintain a
    // cache for each row group (top-level rows, and each row's recursive subrows)
    // This would make multi-filtering a lot faster though. Too far?

    var _React$useMemo = React.useMemo(function () {
      if (manualGlobalFilter || typeof globalFilterValue === 'undefined') {
        return [rows, flatRows, rowsById];
      }

      var filteredFlatRows = [];
      var filteredRowsById = {};
      var filterMethod = getFilterMethod(globalFilter, userFilterTypes || {}, filterTypes);

      if (!filterMethod) {
        console.warn("Could not find a valid 'globalFilter' option.");
        return rows;
      }

      allColumns.forEach(function (column) {
        var columnDisableGlobalFilter = column.disableGlobalFilter;
        column.canFilter = getFirstDefined(columnDisableGlobalFilter === true ? false : undefined, disableGlobalFilter === true ? false : undefined, true);
      });
      var filterableColumns = allColumns.filter(function (c) {
        return c.canFilter === true;
      }); // Filters top level and nested rows

      var filterRows = function filterRows(filteredRows) {
        filteredRows = filterMethod(filteredRows, filterableColumns.map(function (d) {
          return d.id;
        }), globalFilterValue);
        filteredRows.forEach(function (row) {
          filteredFlatRows.push(row);
          filteredRowsById[row.id] = row;
          row.subRows = row.subRows && row.subRows.length ? filterRows(row.subRows) : row.subRows;
        });
        return filteredRows;
      };

      return [filterRows(rows), filteredFlatRows, filteredRowsById];
    }, [manualGlobalFilter, globalFilterValue, globalFilter, userFilterTypes, allColumns, rows, flatRows, rowsById, disableGlobalFilter]),
        globalFilteredRows = _React$useMemo[0],
        globalFilteredFlatRows = _React$useMemo[1],
        globalFilteredRowsById = _React$useMemo[2];

    var getAutoResetGlobalFilter = useGetLatest(autoResetGlobalFilter);
    useMountedLayoutEffect(function () {
      if (getAutoResetGlobalFilter()) {
        dispatch({
          type: actions.resetGlobalFilter
        });
      }
    }, [dispatch, manualGlobalFilter ? null : data]);
    Object.assign(instance, {
      preGlobalFilteredRows: rows,
      preGlobalFilteredFlatRows: flatRows,
      preGlobalFilteredRowsById: rowsById,
      globalFilteredRows: globalFilteredRows,
      globalFilteredFlatRows: globalFilteredFlatRows,
      globalFilteredRowsById: globalFilteredRowsById,
      rows: globalFilteredRows,
      flatRows: globalFilteredFlatRows,
      rowsById: globalFilteredRowsById,
      setGlobalFilter: setGlobalFilter,
      disableGlobalFilter: disableGlobalFilter
    });
  }

  function sum(values, aggregatedValues) {
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return aggregatedValues.reduce(function (sum, next) {
      return sum + (typeof next === 'number' ? next : 0);
    }, 0);
  }
  function min(values) {
    var min = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        min = Math.min(min, value);
      }
    });
    return min;
  }
  function max(values) {
    var max = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        max = Math.max(max, value);
      }
    });
    return max;
  }
  function minMax(values) {
    var min = values[0] || 0;
    var max = values[0] || 0;
    values.forEach(function (value) {
      if (typeof value === 'number') {
        min = Math.min(min, value);
        max = Math.max(max, value);
      }
    });
    return min + ".." + max;
  }
  function average(values) {
    return sum(null, values) / values.length;
  }
  function median(values) {
    if (!values.length) {
      return null;
    }

    var mid = Math.floor(values.length / 2);
    var nums = [].concat(values).sort(function (a, b) {
      return a - b;
    });
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
  }
  function unique(values) {
    return Array.from(new Set(values).values());
  }
  function uniqueCount(values) {
    return new Set(values).size;
  }
  function count(values) {
    return values.length;
  }

  var aggregations = /*#__PURE__*/Object.freeze({
    __proto__: null,
    sum: sum,
    min: min,
    max: max,
    minMax: minMax,
    average: average,
    median: median,
    unique: unique,
    uniqueCount: uniqueCount,
    count: count
  });

  var emptyArray = [];
  var emptyObject = {}; // Actions

  actions.resetGroupBy = 'resetGroupBy';
  actions.setGroupBy = 'setGroupBy';
  actions.toggleGroupBy = 'toggleGroupBy';
  var useGroupBy = function useGroupBy(hooks) {
    hooks.getGroupByToggleProps = [defaultGetGroupByToggleProps];
    hooks.stateReducers.push(reducer$4);
    hooks.visibleColumnsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.groupBy]);
    });
    hooks.visibleColumns.push(visibleColumns);
    hooks.useInstance.push(useInstance$4);
    hooks.prepareRow.push(prepareRow$1);
  };
  useGroupBy.pluginName = 'useGroupBy';

  var defaultGetGroupByToggleProps = function defaultGetGroupByToggleProps(props, _ref2) {
    var header = _ref2.header;
    return [props, {
      onClick: header.canGroupBy ? function (e) {
        e.persist();
        header.toggleGroupBy();
      } : undefined,
      style: {
        cursor: header.canGroupBy ? 'pointer' : undefined
      },
      title: 'Toggle GroupBy'
    }];
  }; // Reducer


  function reducer$4(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        groupBy: []
      }, state);
    }

    if (action.type === actions.resetGroupBy) {
      return _extends({}, state, {
        groupBy: instance.initialState.groupBy || []
      });
    }

    if (action.type === actions.setGroupBy) {
      var value = action.value;
      return _extends({}, state, {
        groupBy: value
      });
    }

    if (action.type === actions.toggleGroupBy) {
      var columnId = action.columnId,
          setGroupBy = action.value;
      var resolvedGroupBy = typeof setGroupBy !== 'undefined' ? setGroupBy : !state.groupBy.includes(columnId);

      if (resolvedGroupBy) {
        return _extends({}, state, {
          groupBy: [].concat(state.groupBy, [columnId])
        });
      }

      return _extends({}, state, {
        groupBy: state.groupBy.filter(function (d) {
          return d !== columnId;
        })
      });
    }
  }

  function visibleColumns(columns, _ref3) {
    var groupBy = _ref3.instance.state.groupBy;
    // Sort grouped columns to the start of the column list
    // before the headers are built
    var groupByColumns = groupBy.map(function (g) {
      return columns.find(function (col) {
        return col.id === g;
      });
    }).filter(Boolean);
    var nonGroupByColumns = columns.filter(function (col) {
      return !groupBy.includes(col.id);
    });
    columns = [].concat(groupByColumns, nonGroupByColumns);
    columns.forEach(function (column) {
      column.isGrouped = groupBy.includes(column.id);
      column.groupedIndex = groupBy.indexOf(column.id);
    });
    return columns;
  }

  var defaultUserAggregations = {};

  function useInstance$4(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        rowsById = instance.rowsById,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        _instance$groupByFn = instance.groupByFn,
        groupByFn = _instance$groupByFn === void 0 ? defaultGroupByFn : _instance$groupByFn,
        manualGroupBy = instance.manualGroupBy,
        _instance$aggregation = instance.aggregations,
        userAggregations = _instance$aggregation === void 0 ? defaultUserAggregations : _instance$aggregation,
        plugins = instance.plugins,
        groupBy = instance.state.groupBy,
        dispatch = instance.dispatch,
        _instance$autoResetGr = instance.autoResetGroupBy,
        autoResetGroupBy = _instance$autoResetGr === void 0 ? true : _instance$autoResetGr,
        disableGroupBy = instance.disableGroupBy,
        defaultCanGroupBy = instance.defaultCanGroupBy,
        getHooks = instance.getHooks;
    ensurePluginOrder(plugins, ['useColumnOrder', 'useFilters'], 'useGroupBy');
    var getInstance = useGetLatest(instance);
    allColumns.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnGroupBy = column.defaultGroupBy,
          columnDisableGroupBy = column.disableGroupBy;
      column.canGroupBy = accessor ? getFirstDefined(column.canGroupBy, columnDisableGroupBy === true ? false : undefined, disableGroupBy === true ? false : undefined, true) : getFirstDefined(column.canGroupBy, defaultColumnGroupBy, defaultCanGroupBy, false);

      if (column.canGroupBy) {
        column.toggleGroupBy = function () {
          return instance.toggleGroupBy(column.id);
        };
      }

      column.Aggregated = column.Aggregated || column.Cell;
    });
    var toggleGroupBy = React.useCallback(function (columnId, value) {
      dispatch({
        type: actions.toggleGroupBy,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var setGroupBy = React.useCallback(function (value) {
      dispatch({
        type: actions.setGroupBy,
        value: value
      });
    }, [dispatch]);
    flatHeaders.forEach(function (header) {
      header.getGroupByToggleProps = makePropGetter(getHooks().getGroupByToggleProps, {
        instance: getInstance(),
        header: header
      });
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualGroupBy || !groupBy.length) {
        return [rows, flatRows, rowsById, emptyArray, emptyObject, flatRows, rowsById];
      } // Ensure that the list of filtered columns exist


      var existingGroupBy = groupBy.filter(function (g) {
        return allColumns.find(function (col) {
          return col.id === g;
        });
      }); // Find the columns that can or are aggregating
      // Uses each column to aggregate rows into a single value

      var aggregateRowsToValues = function aggregateRowsToValues(leafRows, groupedRows, depth) {
        var values = {};
        allColumns.forEach(function (column) {
          // Don't aggregate columns that are in the groupBy
          if (existingGroupBy.includes(column.id)) {
            values[column.id] = groupedRows[0] ? groupedRows[0].values[column.id] : null;
            return;
          } // Aggregate the values


          var aggregateFn = typeof column.aggregate === 'function' ? column.aggregate : userAggregations[column.aggregate] || aggregations[column.aggregate];

          if (aggregateFn) {
            // Get the columnValues to aggregate
            var groupedValues = groupedRows.map(function (row) {
              return row.values[column.id];
            }); // Get the columnValues to aggregate

            var leafValues = leafRows.map(function (row) {
              var columnValue = row.values[column.id];

              if (!depth && column.aggregateValue) {
                var aggregateValueFn = typeof column.aggregateValue === 'function' ? column.aggregateValue : userAggregations[column.aggregateValue] || aggregations[column.aggregateValue];

                if (!aggregateValueFn) {
                  console.info({
                    column: column
                  });
                  throw new Error("React Table: Invalid column.aggregateValue option for column listed above");
                }

                columnValue = aggregateValueFn(columnValue, row, column);
              }

              return columnValue;
            });
            values[column.id] = aggregateFn(leafValues, groupedValues);
          } else if (column.aggregate) {
            console.info({
              column: column
            });
            throw new Error("React Table: Invalid column.aggregate option for column listed above");
          } else {
            values[column.id] = null;
          }
        });
        return values;
      };

      var groupedFlatRows = [];
      var groupedRowsById = {};
      var onlyGroupedFlatRows = [];
      var onlyGroupedRowsById = {};
      var nonGroupedFlatRows = [];
      var nonGroupedRowsById = {}; // Recursively group the data

      var groupUpRecursively = function groupUpRecursively(rows, depth, parentId) {
        if (depth === void 0) {
          depth = 0;
        }

        // This is the last level, just return the rows
        if (depth === existingGroupBy.length) {
          return rows;
        }

        var columnId = existingGroupBy[depth]; // Group the rows together for this level

        var rowGroupsMap = groupByFn(rows, columnId); // Peform aggregations for each group

        var aggregatedGroupedRows = Object.entries(rowGroupsMap).map(function (_ref4, index) {
          var groupByVal = _ref4[0],
              groupedRows = _ref4[1];
          var id = columnId + ":" + groupByVal;
          id = parentId ? parentId + ">" + id : id; // First, Recurse to group sub rows before aggregation

          var subRows = groupUpRecursively(groupedRows, depth + 1, id); // Flatten the leaf rows of the rows in this group

          var leafRows = depth ? flattenBy(groupedRows, 'leafRows') : groupedRows;
          var values = aggregateRowsToValues(leafRows, groupedRows, depth);
          var row = {
            id: id,
            isGrouped: true,
            groupByID: columnId,
            groupByVal: groupByVal,
            values: values,
            subRows: subRows,
            leafRows: leafRows,
            depth: depth,
            index: index
          };
          subRows.forEach(function (subRow) {
            groupedFlatRows.push(subRow);
            groupedRowsById[subRow.id] = subRow;

            if (subRow.isGrouped) {
              onlyGroupedFlatRows.push(subRow);
              onlyGroupedRowsById[subRow.id] = subRow;
            } else {
              nonGroupedFlatRows.push(subRow);
              nonGroupedRowsById[subRow.id] = subRow;
            }
          });
          return row;
        });
        return aggregatedGroupedRows;
      };

      var groupedRows = groupUpRecursively(rows);
      groupedRows.forEach(function (subRow) {
        groupedFlatRows.push(subRow);
        groupedRowsById[subRow.id] = subRow;

        if (subRow.isGrouped) {
          onlyGroupedFlatRows.push(subRow);
          onlyGroupedRowsById[subRow.id] = subRow;
        } else {
          nonGroupedFlatRows.push(subRow);
          nonGroupedRowsById[subRow.id] = subRow;
        }
      }); // Assign the new data

      return [groupedRows, groupedFlatRows, groupedRowsById, onlyGroupedFlatRows, onlyGroupedRowsById, nonGroupedFlatRows, nonGroupedRowsById];
    }, [manualGroupBy, groupBy, rows, flatRows, rowsById, allColumns, userAggregations, groupByFn]),
        groupedRows = _React$useMemo[0],
        groupedFlatRows = _React$useMemo[1],
        groupedRowsById = _React$useMemo[2],
        onlyGroupedFlatRows = _React$useMemo[3],
        onlyGroupedRowsById = _React$useMemo[4],
        nonGroupedFlatRows = _React$useMemo[5],
        nonGroupedRowsById = _React$useMemo[6];

    var getAutoResetGroupBy = useGetLatest(autoResetGroupBy);
    useMountedLayoutEffect(function () {
      if (getAutoResetGroupBy()) {
        dispatch({
          type: actions.resetGroupBy
        });
      }
    }, [dispatch, manualGroupBy ? null : data]);
    Object.assign(instance, {
      preGroupedRows: rows,
      preGroupedFlatRow: flatRows,
      preGroupedRowsById: rowsById,
      groupedRows: groupedRows,
      groupedFlatRows: groupedFlatRows,
      groupedRowsById: groupedRowsById,
      onlyGroupedFlatRows: onlyGroupedFlatRows,
      onlyGroupedRowsById: onlyGroupedRowsById,
      nonGroupedFlatRows: nonGroupedFlatRows,
      nonGroupedRowsById: nonGroupedRowsById,
      rows: groupedRows,
      flatRows: groupedFlatRows,
      rowsById: groupedRowsById,
      toggleGroupBy: toggleGroupBy,
      setGroupBy: setGroupBy
    });
  }

  function prepareRow$1(row) {
    row.allCells.forEach(function (cell) {
      var _row$subRows;

      // Grouped cells are in the groupBy and the pivot cell for the row
      cell.isGrouped = cell.column.isGrouped && cell.column.id === row.groupByID; // Placeholder cells are any columns in the groupBy that are not grouped

      cell.isPlaceholder = !cell.isGrouped && cell.column.isGrouped; // Aggregated cells are not grouped, not repeated, but still have subRows

      cell.isAggregated = !cell.isGrouped && !cell.isPlaceholder && ((_row$subRows = row.subRows) == null ? void 0 : _row$subRows.length);
    });
  }

  function defaultGroupByFn(rows, columnId) {
    return rows.reduce(function (prev, row, i) {
      // TODO: Might want to implement a key serializer here so
      // irregular column values can still be grouped if needed?
      var resKey = "" + row.values[columnId];
      prev[resKey] = Array.isArray(prev[resKey]) ? prev[resKey] : [];
      prev[resKey].push(row);
      return prev;
    }, {});
  }

  var reSplitAlphaNumeric = /([0-9]+)/gm; // Mixed sorting is slow, but very inclusive of many edge cases.
  // It handles numbers, mixed alphanumeric combinations, and even
  // null, undefined, and Infinity

  var alphanumeric = function alphanumeric(rowA, rowB, columnId) {
    var _getRowValuesByColumn = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn[0],
        b = _getRowValuesByColumn[1]; // Force to strings (or "" for unsupported types)


    a = toString(a);
    b = toString(b); // Split on number groups, but keep the delimiter
    // Then remove falsey split values

    a = a.split(reSplitAlphaNumeric).filter(Boolean);
    b = b.split(reSplitAlphaNumeric).filter(Boolean); // While

    while (a.length && b.length) {
      var aa = a.shift();
      var bb = b.shift();
      var an = parseInt(aa, 10);
      var bn = parseInt(bb, 10);
      var combo = [an, bn].sort(); // Both are string

      if (isNaN(combo[0])) {
        if (aa > bb) {
          return 1;
        }

        if (bb > aa) {
          return -1;
        }

        continue;
      } // One is a string, one is a number


      if (isNaN(combo[1])) {
        return isNaN(an) ? -1 : 1;
      } // Both are numbers


      if (an > bn) {
        return 1;
      }

      if (bn > an) {
        return -1;
      }
    }

    return a.length - b.length;
  };
  function datetime(rowA, rowB, columnId) {
    var _getRowValuesByColumn2 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn2[0],
        b = _getRowValuesByColumn2[1];

    a = a.getTime();
    b = b.getTime();
    return compareBasic(a, b);
  }
  function basic(rowA, rowB, columnId) {
    var _getRowValuesByColumn3 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn3[0],
        b = _getRowValuesByColumn3[1];

    return compareBasic(a, b);
  }
  function string(rowA, rowB, columnId) {
    var _getRowValuesByColumn4 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn4[0],
        b = _getRowValuesByColumn4[1];

    a = a.split('').filter(Boolean);
    b = b.split('').filter(Boolean);

    while (a.length && b.length) {
      var aa = a.shift();
      var bb = b.shift();
      var alower = aa.toLowerCase();
      var blower = bb.toLowerCase(); // Case insensitive comparison until characters match

      if (alower > blower) {
        return 1;
      }

      if (blower > alower) {
        return -1;
      } // If lowercase characters are identical


      if (aa > bb) {
        return 1;
      }

      if (bb > aa) {
        return -1;
      }

      continue;
    }

    return a.length - b.length;
  }
  function number(rowA, rowB, columnId) {
    var _getRowValuesByColumn5 = getRowValuesByColumnID(rowA, rowB, columnId),
        a = _getRowValuesByColumn5[0],
        b = _getRowValuesByColumn5[1];

    var replaceNonNumeric = /[^0-9.]/gi;
    a = Number(String(a).replace(replaceNonNumeric, ''));
    b = Number(String(b).replace(replaceNonNumeric, ''));
    return compareBasic(a, b);
  } // Utils

  function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
  }

  function getRowValuesByColumnID(row1, row2, columnId) {
    return [row1.values[columnId], row2.values[columnId]];
  }

  function toString(a) {
    if (typeof a === 'number') {
      if (isNaN(a) || a === Infinity || a === -Infinity) {
        return '';
      }

      return String(a);
    }

    if (typeof a === 'string') {
      return a;
    }

    return '';
  }

  var sortTypes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alphanumeric: alphanumeric,
    datetime: datetime,
    basic: basic,
    string: string,
    number: number
  });

  actions.resetSortBy = 'resetSortBy';
  actions.setSortBy = 'setSortBy';
  actions.toggleSortBy = 'toggleSortBy';
  actions.clearSortBy = 'clearSortBy';
  defaultColumn.sortType = 'alphanumeric';
  defaultColumn.sortDescFirst = false;
  var useSortBy = function useSortBy(hooks) {
    hooks.getSortByToggleProps = [defaultGetSortByToggleProps];
    hooks.stateReducers.push(reducer$5);
    hooks.useInstance.push(useInstance$5);
  };
  useSortBy.pluginName = 'useSortBy';

  var defaultGetSortByToggleProps = function defaultGetSortByToggleProps(props, _ref) {
    var instance = _ref.instance,
        column = _ref.column;
    var _instance$isMultiSort = instance.isMultiSortEvent,
        isMultiSortEvent = _instance$isMultiSort === void 0 ? function (e) {
      return e.shiftKey;
    } : _instance$isMultiSort;
    return [props, {
      onClick: column.canSort ? function (e) {
        e.persist();
        column.toggleSortBy(undefined, !instance.disableMultiSort && isMultiSortEvent(e));
      } : undefined,
      style: {
        cursor: column.canSort ? 'pointer' : undefined
      },
      title: column.canSort ? 'Toggle SortBy' : undefined
    }];
  }; // Reducer


  function reducer$5(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        sortBy: []
      }, state);
    }

    if (action.type === actions.resetSortBy) {
      return _extends({}, state, {
        sortBy: instance.initialState.sortBy || []
      });
    }

    if (action.type === actions.clearSortBy) {
      var sortBy = state.sortBy;
      var newSortBy = sortBy.filter(function (d) {
        return d.id !== action.columnId;
      });
      return _extends({}, state, {
        sortBy: newSortBy
      });
    }

    if (action.type === actions.setSortBy) {
      var _sortBy = action.sortBy;
      return _extends({}, state, {
        sortBy: _sortBy
      });
    }

    if (action.type === actions.toggleSortBy) {
      var columnId = action.columnId,
          desc = action.desc,
          multi = action.multi;
      var allColumns = instance.allColumns,
          disableMultiSort = instance.disableMultiSort,
          disableSortRemove = instance.disableSortRemove,
          disableMultiRemove = instance.disableMultiRemove,
          _instance$maxMultiSor = instance.maxMultiSortColCount,
          maxMultiSortColCount = _instance$maxMultiSor === void 0 ? Number.MAX_SAFE_INTEGER : _instance$maxMultiSor;
      var _sortBy2 = state.sortBy; // Find the column for this columnId

      var column = allColumns.find(function (d) {
        return d.id === columnId;
      });
      var sortDescFirst = column.sortDescFirst; // Find any existing sortBy for this column

      var existingSortBy = _sortBy2.find(function (d) {
        return d.id === columnId;
      });

      var existingIndex = _sortBy2.findIndex(function (d) {
        return d.id === columnId;
      });

      var hasDescDefined = typeof desc !== 'undefined' && desc !== null;
      var _newSortBy = []; // What should we do with this sort action?

      var sortAction;

      if (!disableMultiSort && multi) {
        if (existingSortBy) {
          sortAction = 'toggle';
        } else {
          sortAction = 'add';
        }
      } else {
        // Normal mode
        if (existingIndex !== _sortBy2.length - 1 || _sortBy2.length !== 1) {
          sortAction = 'replace';
        } else if (existingSortBy) {
          sortAction = 'toggle';
        } else {
          sortAction = 'replace';
        }
      } // Handle toggle states that will remove the sortBy


      if (sortAction === 'toggle' && // Must be toggling
      !disableSortRemove && // If disableSortRemove, disable in general
      !hasDescDefined && ( // Must not be setting desc
      multi ? !disableMultiRemove : true) && ( // If multi, don't allow if disableMultiRemove
      existingSortBy && // Finally, detect if it should indeed be removed
      existingSortBy.desc && !sortDescFirst || !existingSortBy.desc && sortDescFirst)) {
        sortAction = 'remove';
      }

      if (sortAction === 'replace') {
        _newSortBy = [{
          id: columnId,
          desc: hasDescDefined ? desc : sortDescFirst
        }];
      } else if (sortAction === 'add') {
        _newSortBy = [].concat(_sortBy2, [{
          id: columnId,
          desc: hasDescDefined ? desc : sortDescFirst
        }]); // Take latest n columns

        _newSortBy.splice(0, _newSortBy.length - maxMultiSortColCount);
      } else if (sortAction === 'toggle') {
        // This flips (or sets) the
        _newSortBy = _sortBy2.map(function (d) {
          if (d.id === columnId) {
            return _extends({}, d, {
              desc: hasDescDefined ? desc : !existingSortBy.desc
            });
          }

          return d;
        });
      } else if (sortAction === 'remove') {
        _newSortBy = _sortBy2.filter(function (d) {
          return d.id !== columnId;
        });
      }

      return _extends({}, state, {
        sortBy: _newSortBy
      });
    }
  }

  function useInstance$5(instance) {
    var data = instance.data,
        rows = instance.rows,
        flatRows = instance.flatRows,
        allColumns = instance.allColumns,
        _instance$orderByFn = instance.orderByFn,
        orderByFn = _instance$orderByFn === void 0 ? defaultOrderByFn : _instance$orderByFn,
        userSortTypes = instance.sortTypes,
        manualSortBy = instance.manualSortBy,
        defaultCanSort = instance.defaultCanSort,
        disableSortBy = instance.disableSortBy,
        flatHeaders = instance.flatHeaders,
        sortBy = instance.state.sortBy,
        dispatch = instance.dispatch,
        plugins = instance.plugins,
        getHooks = instance.getHooks,
        _instance$autoResetSo = instance.autoResetSortBy,
        autoResetSortBy = _instance$autoResetSo === void 0 ? true : _instance$autoResetSo;
    ensurePluginOrder(plugins, ['useFilters', 'useGlobalFilter', 'useGroupBy', 'usePivotColumns'], 'useSortBy');
    var setSortBy = React.useCallback(function (sortBy) {
      dispatch({
        type: actions.setSortBy,
        sortBy: sortBy
      });
    }, [dispatch]); // Updates sorting based on a columnId, desc flag and multi flag

    var toggleSortBy = React.useCallback(function (columnId, desc, multi) {
      dispatch({
        type: actions.toggleSortBy,
        columnId: columnId,
        desc: desc,
        multi: multi
      });
    }, [dispatch]); // use reference to avoid memory leak in #1608

    var getInstance = useGetLatest(instance); // Add the getSortByToggleProps method to columns and headers

    flatHeaders.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnCanSort = column.canSort,
          columnDisableSortBy = column.disableSortBy,
          id = column.id;
      var canSort = accessor ? getFirstDefined(columnDisableSortBy === true ? false : undefined, disableSortBy === true ? false : undefined, true) : getFirstDefined(defaultCanSort, defaultColumnCanSort, false);
      column.canSort = canSort;

      if (column.canSort) {
        column.toggleSortBy = function (desc, multi) {
          return toggleSortBy(column.id, desc, multi);
        };

        column.clearSortBy = function () {
          dispatch({
            type: actions.clearSortBy,
            columnId: column.id
          });
        };
      }

      column.getSortByToggleProps = makePropGetter(getHooks().getSortByToggleProps, {
        instance: getInstance(),
        column: column
      });
      var columnSort = sortBy.find(function (d) {
        return d.id === id;
      });
      column.isSorted = !!columnSort;
      column.sortedIndex = sortBy.findIndex(function (d) {
        return d.id === id;
      });
      column.isSortedDesc = column.isSorted ? columnSort.desc : undefined;
    });

    var _React$useMemo = React.useMemo(function () {
      if (manualSortBy || !sortBy.length) {
        return [rows, flatRows];
      }

      var sortedFlatRows = []; // Filter out sortBys that correspond to non existing columns

      var availableSortBy = sortBy.filter(function (sort) {
        return allColumns.find(function (col) {
          return col.id === sort.id;
        });
      });

      var sortData = function sortData(rows) {
        // Use the orderByFn to compose multiple sortBy's together.
        // This will also perform a stable sorting using the row index
        // if needed.
        var sortedData = orderByFn(rows, availableSortBy.map(function (sort) {
          // Support custom sorting methods for each column
          var column = allColumns.find(function (d) {
            return d.id === sort.id;
          });

          if (!column) {
            throw new Error("React-Table: Could not find a column with id: " + sort.id + " while sorting");
          }

          var sortType = column.sortType; // Look up sortBy functions in this order:
          // column function
          // column string lookup on user sortType
          // column string lookup on built-in sortType
          // default function
          // default string lookup on user sortType
          // default string lookup on built-in sortType

          var sortMethod = isFunction(sortType) || (userSortTypes || {})[sortType] || sortTypes[sortType];

          if (!sortMethod) {
            throw new Error("React-Table: Could not find a valid sortType of '" + sortType + "' for column '" + sort.id + "'.");
          } // Return the correct sortFn.
          // This function should always return in ascending order


          return function (a, b) {
            return sortMethod(a, b, sort.id, sort.desc);
          };
        }), // Map the directions
        availableSortBy.map(function (sort) {
          // Detect and use the sortInverted option
          var column = allColumns.find(function (d) {
            return d.id === sort.id;
          });

          if (column && column.sortInverted) {
            return sort.desc;
          }

          return !sort.desc;
        })); // If there are sub-rows, sort them

        sortedData.forEach(function (row) {
          sortedFlatRows.push(row);

          if (!row.subRows || row.subRows.length === 0) {
            return;
          }

          row.subRows = sortData(row.subRows);
        });
        return sortedData;
      };

      return [sortData(rows), sortedFlatRows];
    }, [manualSortBy, sortBy, rows, flatRows, allColumns, orderByFn, userSortTypes]),
        sortedRows = _React$useMemo[0],
        sortedFlatRows = _React$useMemo[1];

    var getAutoResetSortBy = useGetLatest(autoResetSortBy);
    useMountedLayoutEffect(function () {
      if (getAutoResetSortBy()) {
        dispatch({
          type: actions.resetSortBy
        });
      }
    }, [manualSortBy ? null : data]);
    Object.assign(instance, {
      preSortedRows: rows,
      preSortedFlatRows: flatRows,
      sortedRows: sortedRows,
      sortedFlatRows: sortedFlatRows,
      rows: sortedRows,
      flatRows: sortedFlatRows,
      setSortBy: setSortBy,
      toggleSortBy: toggleSortBy
    });
  }

  function defaultOrderByFn(arr, funcs, dirs) {
    return [].concat(arr).sort(function (rowA, rowB) {
      for (var i = 0; i < funcs.length; i += 1) {
        var sortFn = funcs[i];
        var desc = dirs[i] === false || dirs[i] === 'desc';
        var sortInt = sortFn(rowA, rowB);

        if (sortInt !== 0) {
          return desc ? -sortInt : sortInt;
        }
      }

      return dirs[0] ? rowA.index - rowB.index : rowB.index - rowA.index;
    });
  }

  var pluginName = 'usePagination'; // Actions

  actions.resetPage = 'resetPage';
  actions.gotoPage = 'gotoPage';
  actions.setPageSize = 'setPageSize';
  var usePagination = function usePagination(hooks) {
    hooks.stateReducers.push(reducer$6);
    hooks.useInstance.push(useInstance$6);
  };
  usePagination.pluginName = pluginName;

  function reducer$6(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        pageSize: 10,
        pageIndex: 0
      }, state);
    }

    if (action.type === actions.resetPage) {
      return _extends({}, state, {
        pageIndex: instance.initialState.pageIndex || 0
      });
    }

    if (action.type === actions.gotoPage) {
      var pageCount = instance.pageCount,
          page = instance.page;
      var newPageIndex = functionalUpdate(action.pageIndex, state.pageIndex);
      var canNavigate = false;

      if (newPageIndex > state.pageIndex) {
        // next page
        canNavigate = pageCount === -1 ? page.length >= state.pageSize : newPageIndex < pageCount;
      } else if (newPageIndex < state.pageIndex) {
        // prev page
        canNavigate = newPageIndex > -1;
      }

      if (!canNavigate) {
        return state;
      }

      return _extends({}, state, {
        pageIndex: newPageIndex
      });
    }

    if (action.type === actions.setPageSize) {
      var pageSize = action.pageSize;
      var topRowIndex = state.pageSize * state.pageIndex;
      var pageIndex = Math.floor(topRowIndex / pageSize);
      return _extends({}, state, {
        pageIndex: pageIndex,
        pageSize: pageSize
      });
    }
  }

  function useInstance$6(instance) {
    var rows = instance.rows,
        _instance$autoResetPa = instance.autoResetPage,
        autoResetPage = _instance$autoResetPa === void 0 ? true : _instance$autoResetPa,
        _instance$manualExpan = instance.manualExpandedKey,
        manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
        plugins = instance.plugins,
        userPageCount = instance.pageCount,
        _instance$paginateExp = instance.paginateExpandedRows,
        paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
        _instance$expandSubRo = instance.expandSubRows,
        expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
        _instance$state = instance.state,
        pageSize = _instance$state.pageSize,
        pageIndex = _instance$state.pageIndex,
        expanded = _instance$state.expanded,
        globalFilter = _instance$state.globalFilter,
        filters = _instance$state.filters,
        groupBy = _instance$state.groupBy,
        sortBy = _instance$state.sortBy,
        dispatch = instance.dispatch,
        data = instance.data,
        manualPagination = instance.manualPagination;
    ensurePluginOrder(plugins, ['useGlobalFilter', 'useFilters', 'useGroupBy', 'useSortBy', 'useExpanded'], 'usePagination');
    var getAutoResetPage = useGetLatest(autoResetPage);
    useMountedLayoutEffect(function () {
      if (getAutoResetPage()) {
        dispatch({
          type: actions.resetPage
        });
      }
    }, [dispatch, manualPagination ? null : data, globalFilter, filters, groupBy, sortBy]);
    var pageCount = manualPagination ? userPageCount : Math.ceil(rows.length / pageSize);
    var pageOptions = React.useMemo(function () {
      return pageCount > 0 ? [].concat(new Array(pageCount)).fill(null).map(function (d, i) {
        return i;
      }) : [];
    }, [pageCount]);
    var page = React.useMemo(function () {
      var page;

      if (manualPagination) {
        page = rows;
      } else {
        var pageStart = pageSize * pageIndex;
        var pageEnd = pageStart + pageSize;
        page = rows.slice(pageStart, pageEnd);
      }

      if (paginateExpandedRows) {
        return page;
      }

      return expandRows(page, {
        manualExpandedKey: manualExpandedKey,
        expanded: expanded,
        expandSubRows: expandSubRows
      });
    }, [expandSubRows, expanded, manualExpandedKey, manualPagination, pageIndex, pageSize, paginateExpandedRows, rows]);
    var canPreviousPage = pageIndex > 0;
    var canNextPage = pageCount === -1 ? page.length >= pageSize : pageIndex < pageCount - 1;
    var gotoPage = React.useCallback(function (pageIndex) {
      dispatch({
        type: actions.gotoPage,
        pageIndex: pageIndex
      });
    }, [dispatch]);
    var previousPage = React.useCallback(function () {
      return gotoPage(function (old) {
        return old - 1;
      });
    }, [gotoPage]);
    var nextPage = React.useCallback(function () {
      return gotoPage(function (old) {
        return old + 1;
      });
    }, [gotoPage]);
    var setPageSize = React.useCallback(function (pageSize) {
      dispatch({
        type: actions.setPageSize,
        pageSize: pageSize
      });
    }, [dispatch]);
    Object.assign(instance, {
      pageOptions: pageOptions,
      pageCount: pageCount,
      page: page,
      canPreviousPage: canPreviousPage,
      canNextPage: canNextPage,
      gotoPage: gotoPage,
      previousPage: previousPage,
      nextPage: nextPage,
      setPageSize: setPageSize
    });
  }

  actions.resetPivot = 'resetPivot';
  actions.togglePivot = 'togglePivot';
  var _UNSTABLE_usePivotColumns = function _UNSTABLE_usePivotColumns(hooks) {
    hooks.getPivotToggleProps = [defaultGetPivotToggleProps];
    hooks.stateReducers.push(reducer$7);
    hooks.useInstanceAfterData.push(useInstanceAfterData);
    hooks.allColumns.push(allColumns);
    hooks.accessValue.push(accessValue);
    hooks.materializedColumns.push(materializedColumns);
    hooks.materializedColumnsDeps.push(materializedColumnsDeps);
    hooks.visibleColumns.push(visibleColumns$1);
    hooks.visibleColumnsDeps.push(visibleColumnsDeps);
    hooks.useInstance.push(useInstance$7);
    hooks.prepareRow.push(prepareRow$2);
  };
  _UNSTABLE_usePivotColumns.pluginName = 'usePivotColumns';
  var defaultPivotColumns = [];

  var defaultGetPivotToggleProps = function defaultGetPivotToggleProps(props, _ref) {
    var header = _ref.header;
    return [props, {
      onClick: header.canPivot ? function (e) {
        e.persist();
        header.togglePivot();
      } : undefined,
      style: {
        cursor: header.canPivot ? 'pointer' : undefined
      },
      title: 'Toggle Pivot'
    }];
  }; // Reducer


  function reducer$7(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        pivotColumns: defaultPivotColumns
      }, state);
    }

    if (action.type === actions.resetPivot) {
      return _extends({}, state, {
        pivotColumns: instance.initialState.pivotColumns || defaultPivotColumns
      });
    }

    if (action.type === actions.togglePivot) {
      var columnId = action.columnId,
          setPivot = action.value;
      var resolvedPivot = typeof setPivot !== 'undefined' ? setPivot : !state.pivotColumns.includes(columnId);

      if (resolvedPivot) {
        return _extends({}, state, {
          pivotColumns: [].concat(state.pivotColumns, [columnId])
        });
      }

      return _extends({}, state, {
        pivotColumns: state.pivotColumns.filter(function (d) {
          return d !== columnId;
        })
      });
    }
  }

  function useInstanceAfterData(instance) {
    instance.allColumns.forEach(function (column) {
      column.isPivotSource = instance.state.pivotColumns.includes(column.id);
    });
  }

  function allColumns(columns, _ref2) {
    var instance = _ref2.instance;
    columns.forEach(function (column) {
      column.isPivotSource = instance.state.pivotColumns.includes(column.id);
      column.uniqueValues = new Set();
    });
    return columns;
  }

  function accessValue(value, _ref3) {
    var column = _ref3.column;

    if (column.uniqueValues && typeof value !== 'undefined') {
      column.uniqueValues.add(value);
    }

    return value;
  }

  function materializedColumns(materialized, _ref4) {
    var instance = _ref4.instance;
    var allColumns = instance.allColumns,
        state = instance.state;

    if (!state.pivotColumns.length || !state.groupBy || !state.groupBy.length) {
      return materialized;
    }

    var pivotColumns = state.pivotColumns.map(function (id) {
      return allColumns.find(function (d) {
        return d.id === id;
      });
    }).filter(Boolean);
    var sourceColumns = allColumns.filter(function (d) {
      return !d.isPivotSource && !state.groupBy.includes(d.id) && !state.pivotColumns.includes(d.id);
    });

    var buildPivotColumns = function buildPivotColumns(depth, parent, pivotFilters) {
      if (depth === void 0) {
        depth = 0;
      }

      if (pivotFilters === void 0) {
        pivotFilters = [];
      }

      var pivotColumn = pivotColumns[depth];

      if (!pivotColumn) {
        return sourceColumns.map(function (sourceColumn) {
          // TODO: We could offer support here for renesting pivoted
          // columns inside copies of their header groups. For now,
          // that seems like it would be (1) overkill on nesting, considering
          // you already get nesting for every pivot level and (2)
          // really hard. :)
          return _extends({}, sourceColumn, {
            canPivot: false,
            isPivoted: true,
            parent: parent,
            depth: depth,
            id: "" + (parent ? parent.id + "." + sourceColumn.id : sourceColumn.id),
            accessor: function accessor(originalRow, i, row) {
              if (pivotFilters.every(function (filter) {
                return filter(row);
              })) {
                return row.values[sourceColumn.id];
              }
            }
          });
        });
      }

      var uniqueValues = Array.from(pivotColumn.uniqueValues).sort();
      return uniqueValues.map(function (uniqueValue) {
        var columnGroup = _extends({}, pivotColumn, {
          Header: pivotColumn.PivotHeader || typeof pivotColumn.header === 'string' ? pivotColumn.Header + ": " + uniqueValue : uniqueValue,
          isPivotGroup: true,
          parent: parent,
          depth: depth,
          id: parent ? parent.id + "." + pivotColumn.id + "." + uniqueValue : pivotColumn.id + "." + uniqueValue,
          pivotValue: uniqueValue
        });

        columnGroup.columns = buildPivotColumns(depth + 1, columnGroup, [].concat(pivotFilters, [function (row) {
          return row.values[pivotColumn.id] === uniqueValue;
        }]));
        return columnGroup;
      });
    };

    var newMaterialized = flattenColumns(buildPivotColumns());
    return [].concat(materialized, newMaterialized);
  }

  function materializedColumnsDeps(deps, _ref5) {
    var _ref5$instance$state = _ref5.instance.state,
        pivotColumns = _ref5$instance$state.pivotColumns,
        groupBy = _ref5$instance$state.groupBy;
    return [].concat(deps, [pivotColumns, groupBy]);
  }

  function visibleColumns$1(visibleColumns, _ref6) {
    var state = _ref6.instance.state;
    visibleColumns = visibleColumns.filter(function (d) {
      return !d.isPivotSource;
    });

    if (state.pivotColumns.length && state.groupBy && state.groupBy.length) {
      visibleColumns = visibleColumns.filter(function (column) {
        return column.isGrouped || column.isPivoted;
      });
    }

    return visibleColumns;
  }

  function visibleColumnsDeps(deps, _ref7) {
    var instance = _ref7.instance;
    return [].concat(deps, [instance.state.pivotColumns, instance.state.groupBy]);
  }

  function useInstance$7(instance) {
    var columns = instance.columns,
        allColumns = instance.allColumns,
        flatHeaders = instance.flatHeaders,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        dispatch = instance.dispatch,
        _instance$autoResetPi = instance.autoResetPivot,
        autoResetPivot = _instance$autoResetPi === void 0 ? true : _instance$autoResetPi,
        manaulPivot = instance.manaulPivot,
        disablePivot = instance.disablePivot,
        defaultCanPivot = instance.defaultCanPivot;
    ensurePluginOrder(plugins, ['useGroupBy'], 'usePivotColumns');
    var getInstance = useGetLatest(instance);
    allColumns.forEach(function (column) {
      var accessor = column.accessor,
          defaultColumnPivot = column.defaultPivot,
          columnDisablePivot = column.disablePivot;
      column.canPivot = accessor ? getFirstDefined(column.canPivot, columnDisablePivot === true ? false : undefined, disablePivot === true ? false : undefined, true) : getFirstDefined(column.canPivot, defaultColumnPivot, defaultCanPivot, false);

      if (column.canPivot) {
        column.togglePivot = function () {
          return instance.togglePivot(column.id);
        };
      }

      column.Aggregated = column.Aggregated || column.Cell;
    });

    var togglePivot = function togglePivot(columnId, value) {
      dispatch({
        type: actions.togglePivot,
        columnId: columnId,
        value: value
      });
    };

    flatHeaders.forEach(function (header) {
      header.getPivotToggleProps = makePropGetter(getHooks().getPivotToggleProps, {
        instance: getInstance(),
        header: header
      });
    });
    var getAutoResetPivot = useGetLatest(autoResetPivot);
    useMountedLayoutEffect(function () {
      if (getAutoResetPivot()) {
        dispatch({
          type: actions.resetPivot
        });
      }
    }, [dispatch, manaulPivot ? null : columns]);
    Object.assign(instance, {
      togglePivot: togglePivot
    });
  }

  function prepareRow$2(row) {
    row.allCells.forEach(function (cell) {
      // Grouped cells are in the pivotColumns and the pivot cell for the row
      cell.isPivoted = cell.column.isPivoted;
    });
  }

  var pluginName$1 = 'useRowSelect'; // Actions

  actions.resetSelectedRows = 'resetSelectedRows';
  actions.toggleAllRowsSelected = 'toggleAllRowsSelected';
  actions.toggleRowSelected = 'toggleRowSelected';
  actions.toggleAllPageRowsSelected = 'toggleAllPageRowsSelected';
  var useRowSelect = function useRowSelect(hooks) {
    hooks.getToggleRowSelectedProps = [defaultGetToggleRowSelectedProps];
    hooks.getToggleAllRowsSelectedProps = [defaultGetToggleAllRowsSelectedProps];
    hooks.getToggleAllPageRowsSelectedProps = [defaultGetToggleAllPageRowsSelectedProps];
    hooks.stateReducers.push(reducer$8);
    hooks.useInstance.push(useInstance$8);
    hooks.prepareRow.push(prepareRow$3);
  };
  useRowSelect.pluginName = pluginName$1;

  var defaultGetToggleRowSelectedProps = function defaultGetToggleRowSelectedProps(props, _ref) {
    var instance = _ref.instance,
        row = _ref.row;
    var _instance$manualRowSe = instance.manualRowSelectedKey,
        manualRowSelectedKey = _instance$manualRowSe === void 0 ? 'isSelected' : _instance$manualRowSe;
    var checked = false;

    if (row.original && row.original[manualRowSelectedKey]) {
      checked = true;
    } else {
      checked = row.isSelected;
    }

    return [props, {
      onChange: function onChange(e) {
        row.toggleRowSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: checked,
      title: 'Toggle Row Selected',
      indeterminate: row.isSomeSelected
    }];
  };

  var defaultGetToggleAllRowsSelectedProps = function defaultGetToggleAllRowsSelectedProps(props, _ref2) {
    var instance = _ref2.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleAllRowsSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: instance.isAllRowsSelected,
      title: 'Toggle All Rows Selected',
      indeterminate: Boolean(!instance.isAllRowsSelected && Object.keys(instance.state.selectedRowIds).length)
    }];
  };

  var defaultGetToggleAllPageRowsSelectedProps = function defaultGetToggleAllPageRowsSelectedProps(props, _ref3) {
    var instance = _ref3.instance;
    return [props, {
      onChange: function onChange(e) {
        instance.toggleAllPageRowsSelected(e.target.checked);
      },
      style: {
        cursor: 'pointer'
      },
      checked: instance.isAllPageRowsSelected,
      title: 'Toggle All Current Page Rows Selected',
      indeterminate: Boolean(!instance.isAllPageRowsSelected && instance.page.some(function (_ref4) {
        var id = _ref4.id;
        return instance.state.selectedRowIds[id];
      }))
    }];
  }; // eslint-disable-next-line max-params


  function reducer$8(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        selectedRowIds: {}
      }, state);
    }

    if (action.type === actions.resetSelectedRows) {
      return _extends({}, state, {
        selectedRowIds: instance.initialState.selectedRowIds || {}
      });
    }

    if (action.type === actions.toggleAllRowsSelected) {
      var setSelected = action.value;
      var isAllRowsSelected = instance.isAllRowsSelected,
          rowsById = instance.rowsById,
          _instance$nonGroupedR = instance.nonGroupedRowsById,
          nonGroupedRowsById = _instance$nonGroupedR === void 0 ? rowsById : _instance$nonGroupedR;
      var selectAll = typeof setSelected !== 'undefined' ? setSelected : !isAllRowsSelected; // Only remove/add the rows that are visible on the screen
      //  Leave all the other rows that are selected alone.

      var selectedRowIds = Object.assign({}, state.selectedRowIds);

      if (selectAll) {
        Object.keys(nonGroupedRowsById).forEach(function (rowId) {
          selectedRowIds[rowId] = true;
        });
      } else {
        Object.keys(nonGroupedRowsById).forEach(function (rowId) {
          delete selectedRowIds[rowId];
        });
      }

      return _extends({}, state, {
        selectedRowIds: selectedRowIds
      });
    }

    if (action.type === actions.toggleRowSelected) {
      var id = action.id,
          _setSelected = action.value;
      var _rowsById = instance.rowsById,
          _instance$selectSubRo = instance.selectSubRows,
          selectSubRows = _instance$selectSubRo === void 0 ? true : _instance$selectSubRo,
          getSubRows = instance.getSubRows;
      var isSelected = state.selectedRowIds[id];
      var shouldExist = typeof _setSelected !== 'undefined' ? _setSelected : !isSelected;

      if (isSelected === shouldExist) {
        return state;
      }

      var newSelectedRowIds = _extends({}, state.selectedRowIds);

      var handleRowById = function handleRowById(id) {
        var row = _rowsById[id];

        if (!row.isGrouped) {
          if (shouldExist) {
            newSelectedRowIds[id] = true;
          } else {
            delete newSelectedRowIds[id];
          }
        }

        if (selectSubRows && getSubRows(row)) {
          return getSubRows(row).forEach(function (row) {
            return handleRowById(row.id);
          });
        }
      };

      handleRowById(id);
      return _extends({}, state, {
        selectedRowIds: newSelectedRowIds
      });
    }

    if (action.type === actions.toggleAllPageRowsSelected) {
      var _setSelected2 = action.value;

      var page = instance.page,
          _rowsById2 = instance.rowsById,
          _instance$selectSubRo2 = instance.selectSubRows,
          _selectSubRows = _instance$selectSubRo2 === void 0 ? true : _instance$selectSubRo2,
          isAllPageRowsSelected = instance.isAllPageRowsSelected,
          _getSubRows = instance.getSubRows;

      var _selectAll = typeof _setSelected2 !== 'undefined' ? _setSelected2 : !isAllPageRowsSelected;

      var _newSelectedRowIds = _extends({}, state.selectedRowIds);

      var _handleRowById = function _handleRowById(id) {
        var row = _rowsById2[id];

        if (!row.isGrouped) {
          if (_selectAll) {
            _newSelectedRowIds[id] = true;
          } else {
            delete _newSelectedRowIds[id];
          }
        }

        if (_selectSubRows && _getSubRows(row)) {
          return _getSubRows(row).forEach(function (row) {
            return _handleRowById(row.id);
          });
        }
      };

      page.forEach(function (row) {
        return _handleRowById(row.id);
      });
      return _extends({}, state, {
        selectedRowIds: _newSelectedRowIds
      });
    }

    return state;
  }

  function useInstance$8(instance) {
    var data = instance.data,
        rows = instance.rows,
        getHooks = instance.getHooks,
        plugins = instance.plugins,
        rowsById = instance.rowsById,
        _instance$nonGroupedR2 = instance.nonGroupedRowsById,
        nonGroupedRowsById = _instance$nonGroupedR2 === void 0 ? rowsById : _instance$nonGroupedR2,
        _instance$autoResetSe = instance.autoResetSelectedRows,
        autoResetSelectedRows = _instance$autoResetSe === void 0 ? true : _instance$autoResetSe,
        selectedRowIds = instance.state.selectedRowIds,
        _instance$selectSubRo3 = instance.selectSubRows,
        selectSubRows = _instance$selectSubRo3 === void 0 ? true : _instance$selectSubRo3,
        dispatch = instance.dispatch,
        page = instance.page,
        getSubRows = instance.getSubRows;
    ensurePluginOrder(plugins, ['useFilters', 'useGroupBy', 'useSortBy', 'useExpanded', 'usePagination'], 'useRowSelect');
    var selectedFlatRows = React.useMemo(function () {
      var selectedFlatRows = [];
      rows.forEach(function (row) {
        var isSelected = selectSubRows ? getRowIsSelected(row, selectedRowIds, getSubRows) : !!selectedRowIds[row.id];
        row.isSelected = !!isSelected;
        row.isSomeSelected = isSelected === null;

        if (isSelected) {
          selectedFlatRows.push(row);
        }
      });
      return selectedFlatRows;
    }, [rows, selectSubRows, selectedRowIds, getSubRows]);
    var isAllRowsSelected = Boolean(Object.keys(nonGroupedRowsById).length && Object.keys(selectedRowIds).length);
    var isAllPageRowsSelected = isAllRowsSelected;

    if (isAllRowsSelected) {
      if (Object.keys(nonGroupedRowsById).some(function (id) {
        return !selectedRowIds[id];
      })) {
        isAllRowsSelected = false;
      }
    }

    if (!isAllRowsSelected) {
      if (page && page.length && page.some(function (_ref5) {
        var id = _ref5.id;
        return !selectedRowIds[id];
      })) {
        isAllPageRowsSelected = false;
      }
    }

    var getAutoResetSelectedRows = useGetLatest(autoResetSelectedRows);
    useMountedLayoutEffect(function () {
      if (getAutoResetSelectedRows()) {
        dispatch({
          type: actions.resetSelectedRows
        });
      }
    }, [dispatch, data]);
    var toggleAllRowsSelected = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllRowsSelected,
        value: value
      });
    }, [dispatch]);
    var toggleAllPageRowsSelected = React.useCallback(function (value) {
      return dispatch({
        type: actions.toggleAllPageRowsSelected,
        value: value
      });
    }, [dispatch]);
    var toggleRowSelected = React.useCallback(function (id, value) {
      return dispatch({
        type: actions.toggleRowSelected,
        id: id,
        value: value
      });
    }, [dispatch]);
    var getInstance = useGetLatest(instance);
    var getToggleAllRowsSelectedProps = makePropGetter(getHooks().getToggleAllRowsSelectedProps, {
      instance: getInstance()
    });
    var getToggleAllPageRowsSelectedProps = makePropGetter(getHooks().getToggleAllPageRowsSelectedProps, {
      instance: getInstance()
    });
    Object.assign(instance, {
      selectedFlatRows: selectedFlatRows,
      isAllRowsSelected: isAllRowsSelected,
      isAllPageRowsSelected: isAllPageRowsSelected,
      toggleRowSelected: toggleRowSelected,
      toggleAllRowsSelected: toggleAllRowsSelected,
      getToggleAllRowsSelectedProps: getToggleAllRowsSelectedProps,
      getToggleAllPageRowsSelectedProps: getToggleAllPageRowsSelectedProps,
      toggleAllPageRowsSelected: toggleAllPageRowsSelected
    });
  }

  function prepareRow$3(row, _ref6) {
    var instance = _ref6.instance;

    row.toggleRowSelected = function (set) {
      return instance.toggleRowSelected(row.id, set);
    };

    row.getToggleRowSelectedProps = makePropGetter(instance.getHooks().getToggleRowSelectedProps, {
      instance: instance,
      row: row
    });
  }

  function getRowIsSelected(row, selectedRowIds, getSubRows) {
    if (selectedRowIds[row.id]) {
      return true;
    }

    var subRows = getSubRows(row);

    if (subRows && subRows.length) {
      var allChildrenSelected = true;
      var someSelected = false;
      subRows.forEach(function (subRow) {
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) {
          return;
        }

        if (getRowIsSelected(subRow, selectedRowIds, getSubRows)) {
          someSelected = true;
        } else {
          allChildrenSelected = false;
        }
      });
      return allChildrenSelected ? true : someSelected ? null : false;
    }

    return false;
  }

  var defaultInitialRowStateAccessor = function defaultInitialRowStateAccessor(row) {
    return {};
  };

  var defaultInitialCellStateAccessor = function defaultInitialCellStateAccessor(cell) {
    return {};
  }; // Actions


  actions.setRowState = 'setRowState';
  actions.setCellState = 'setCellState';
  actions.resetRowState = 'resetRowState';
  var useRowState = function useRowState(hooks) {
    hooks.stateReducers.push(reducer$9);
    hooks.useInstance.push(useInstance$9);
    hooks.prepareRow.push(prepareRow$4);
  };
  useRowState.pluginName = 'useRowState';

  function reducer$9(state, action, previousState, instance) {
    var _instance$initialRowS = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS,
        _instance$initialCell = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell,
        rowsById = instance.rowsById;

    if (action.type === actions.init) {
      return _extends({
        rowState: {}
      }, state);
    }

    if (action.type === actions.resetRowState) {
      return _extends({}, state, {
        rowState: instance.initialState.rowState || {}
      });
    }

    if (action.type === actions.setRowState) {
      var _extends2;

      var rowId = action.rowId,
          value = action.value;
      var oldRowState = typeof state.rowState[rowId] !== 'undefined' ? state.rowState[rowId] : initialRowStateAccessor(rowsById[rowId]);
      return _extends({}, state, {
        rowState: _extends({}, state.rowState, (_extends2 = {}, _extends2[rowId] = functionalUpdate(value, oldRowState), _extends2))
      });
    }

    if (action.type === actions.setCellState) {
      var _oldRowState$cellStat, _rowsById$_rowId, _rowsById$_rowId$cell, _extends3, _extends4;

      var _rowId = action.rowId,
          columnId = action.columnId,
          _value = action.value;

      var _oldRowState = typeof state.rowState[_rowId] !== 'undefined' ? state.rowState[_rowId] : initialRowStateAccessor(rowsById[_rowId]);

      var oldCellState = typeof (_oldRowState == null ? void 0 : (_oldRowState$cellStat = _oldRowState.cellState) == null ? void 0 : _oldRowState$cellStat[columnId]) !== 'undefined' ? _oldRowState.cellState[columnId] : initialCellStateAccessor((_rowsById$_rowId = rowsById[_rowId]) == null ? void 0 : (_rowsById$_rowId$cell = _rowsById$_rowId.cells) == null ? void 0 : _rowsById$_rowId$cell.find(function (cell) {
        return cell.column.id === columnId;
      }));
      return _extends({}, state, {
        rowState: _extends({}, state.rowState, (_extends4 = {}, _extends4[_rowId] = _extends({}, _oldRowState, {
          cellState: _extends({}, _oldRowState.cellState || {}, (_extends3 = {}, _extends3[columnId] = functionalUpdate(_value, oldCellState), _extends3))
        }), _extends4))
      });
    }
  }

  function useInstance$9(instance) {
    var _instance$autoResetRo = instance.autoResetRowState,
        autoResetRowState = _instance$autoResetRo === void 0 ? true : _instance$autoResetRo,
        data = instance.data,
        dispatch = instance.dispatch;
    var setRowState = React.useCallback(function (rowId, value) {
      return dispatch({
        type: actions.setRowState,
        rowId: rowId,
        value: value
      });
    }, [dispatch]);
    var setCellState = React.useCallback(function (rowId, columnId, value) {
      return dispatch({
        type: actions.setCellState,
        rowId: rowId,
        columnId: columnId,
        value: value
      });
    }, [dispatch]);
    var getAutoResetRowState = useGetLatest(autoResetRowState);
    useMountedLayoutEffect(function () {
      if (getAutoResetRowState()) {
        dispatch({
          type: actions.resetRowState
        });
      }
    }, [data]);
    Object.assign(instance, {
      setRowState: setRowState,
      setCellState: setCellState
    });
  }

  function prepareRow$4(row, _ref) {
    var instance = _ref.instance;
    var _instance$initialRowS2 = instance.initialRowStateAccessor,
        initialRowStateAccessor = _instance$initialRowS2 === void 0 ? defaultInitialRowStateAccessor : _instance$initialRowS2,
        _instance$initialCell2 = instance.initialCellStateAccessor,
        initialCellStateAccessor = _instance$initialCell2 === void 0 ? defaultInitialCellStateAccessor : _instance$initialCell2,
        rowState = instance.state.rowState;

    if (row) {
      row.state = typeof rowState[row.id] !== 'undefined' ? rowState[row.id] : initialRowStateAccessor(row);

      row.setState = function (updater) {
        return instance.setRowState(row.id, updater);
      };

      row.cells.forEach(function (cell) {
        if (!row.state.cellState) {
          row.state.cellState = {};
        }

        cell.state = typeof row.state.cellState[cell.column.id] !== 'undefined' ? row.state.cellState[cell.column.id] : initialCellStateAccessor(cell);

        cell.setState = function (updater) {
          return instance.setCellState(row.id, cell.column.id, updater);
        };
      });
    }
  }

  actions.resetColumnOrder = 'resetColumnOrder';
  actions.setColumnOrder = 'setColumnOrder';
  var useColumnOrder = function useColumnOrder(hooks) {
    hooks.stateReducers.push(reducer$a);
    hooks.visibleColumnsDeps.push(function (deps, _ref) {
      var instance = _ref.instance;
      return [].concat(deps, [instance.state.columnOrder]);
    });
    hooks.visibleColumns.push(visibleColumns$2);
    hooks.useInstance.push(useInstance$a);
  };
  useColumnOrder.pluginName = 'useColumnOrder';

  function reducer$a(state, action, previousState, instance) {
    if (action.type === actions.init) {
      return _extends({
        columnOrder: []
      }, state);
    }

    if (action.type === actions.resetColumnOrder) {
      return _extends({}, state, {
        columnOrder: instance.initialState.columnOrder || []
      });
    }

    if (action.type === actions.setColumnOrder) {
      return _extends({}, state, {
        columnOrder: functionalUpdate(action.columnOrder, state.columnOrder)
      });
    }
  }

  function visibleColumns$2(columns, _ref2) {
    var columnOrder = _ref2.instance.state.columnOrder;

    // If there is no order, return the normal columns
    if (!columnOrder || !columnOrder.length) {
      return columns;
    }

    var columnOrderCopy = [].concat(columnOrder); // If there is an order, make a copy of the columns

    var columnsCopy = [].concat(columns); // And make a new ordered array of the columns

    var columnsInOrder = []; // Loop over the columns and place them in order into the new array

    var _loop = function _loop() {
      var targetColumnId = columnOrderCopy.shift();
      var foundIndex = columnsCopy.findIndex(function (d) {
        return d.id === targetColumnId;
      });

      if (foundIndex > -1) {
        columnsInOrder.push(columnsCopy.splice(foundIndex, 1)[0]);
      }
    };

    while (columnsCopy.length && columnOrderCopy.length) {
      _loop();
    } // If there are any columns left, add them to the end


    return [].concat(columnsInOrder, columnsCopy);
  }

  function useInstance$a(instance) {
    var dispatch = instance.dispatch;
    instance.setColumnOrder = React.useCallback(function (columnOrder) {
      return dispatch({
        type: actions.setColumnOrder,
        columnOrder: columnOrder
      });
    }, [dispatch]);
  }

  defaultColumn.canResize = true; // Actions

  actions.columnStartResizing = 'columnStartResizing';
  actions.columnResizing = 'columnResizing';
  actions.columnDoneResizing = 'columnDoneResizing';
  actions.resetResize = 'resetResize';
  var useResizeColumns = function useResizeColumns(hooks) {
    hooks.getResizerProps = [defaultGetResizerProps];
    hooks.getHeaderProps.push({
      style: {
        position: 'relative'
      }
    });
    hooks.stateReducers.push(reducer$b);
    hooks.useInstance.push(useInstance$b);
    hooks.useInstanceBeforeDimensions.push(useInstanceBeforeDimensions$1);
  };

  var defaultGetResizerProps = function defaultGetResizerProps(props, _ref) {
    var instance = _ref.instance,
        header = _ref.header;
    var dispatch = instance.dispatch;

    var onResizeStart = function onResizeStart(e, header) {
      var isTouchEvent = false;

      if (e.type === 'touchstart') {
        // lets not respond to multiple touches (e.g. 2 or 3 fingers)
        if (e.touches && e.touches.length > 1) {
          return;
        }

        isTouchEvent = true;
      }

      var headersToResize = getLeafHeaders(header);
      var headerIdWidths = headersToResize.map(function (d) {
        return [d.id, d.totalWidth];
      });
      var clientX = isTouchEvent ? Math.round(e.touches[0].clientX) : e.clientX;

      var dispatchMove = function dispatchMove(clientXPos) {
        dispatch({
          type: actions.columnResizing,
          clientX: clientXPos
        });
      };

      var dispatchEnd = function dispatchEnd() {
        return dispatch({
          type: actions.columnDoneResizing
        });
      };

      var handlersAndEvents = {
        mouse: {
          moveEvent: 'mousemove',
          moveHandler: function moveHandler(e) {
            return dispatchMove(e.clientX);
          },
          upEvent: 'mouseup',
          upHandler: function upHandler(e) {
            document.removeEventListener('mousemove', handlersAndEvents.mouse.moveHandler);
            document.removeEventListener('mouseup', handlersAndEvents.mouse.upHandler);
            dispatchEnd();
          }
        },
        touch: {
          moveEvent: 'touchmove',
          moveHandler: function moveHandler(e) {
            if (e.cancelable) {
              e.preventDefault();
              e.stopPropagation();
            }

            dispatchMove(e.touches[0].clientX);
            return false;
          },
          upEvent: 'touchend',
          upHandler: function upHandler(e) {
            document.removeEventListener(handlersAndEvents.touch.moveEvent, handlersAndEvents.touch.moveHandler);
            document.removeEventListener(handlersAndEvents.touch.upEvent, handlersAndEvents.touch.moveHandler);
            dispatchEnd();
          }
        }
      };
      var events = isTouchEvent ? handlersAndEvents.touch : handlersAndEvents.mouse;
      var passiveIfSupported = passiveEventSupported() ? {
        passive: false
      } : false;
      document.addEventListener(events.moveEvent, events.moveHandler, passiveIfSupported);
      document.addEventListener(events.upEvent, events.upHandler, passiveIfSupported);
      dispatch({
        type: actions.columnStartResizing,
        columnId: header.id,
        columnWidth: header.totalWidth,
        headerIdWidths: headerIdWidths,
        clientX: clientX
      });
    };

    return [props, {
      onMouseDown: function onMouseDown(e) {
        return e.persist() || onResizeStart(e, header);
      },
      onTouchStart: function onTouchStart(e) {
        return e.persist() || onResizeStart(e, header);
      },
      style: {
        cursor: 'col-resize'
      },
      draggable: false,
      role: 'separator'
    }];
  };

  useResizeColumns.pluginName = 'useResizeColumns';

  function reducer$b(state, action) {
    if (action.type === actions.init) {
      return _extends({
        columnResizing: {
          columnWidths: {}
        }
      }, state);
    }

    if (action.type === actions.resetResize) {
      return _extends({}, state, {
        columnResizing: {
          columnWidths: {}
        }
      });
    }

    if (action.type === actions.columnStartResizing) {
      var clientX = action.clientX,
          columnId = action.columnId,
          columnWidth = action.columnWidth,
          headerIdWidths = action.headerIdWidths;
      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          startX: clientX,
          headerIdWidths: headerIdWidths,
          columnWidth: columnWidth,
          isResizingColumn: columnId
        })
      });
    }

    if (action.type === actions.columnResizing) {
      var _clientX = action.clientX;

      var _state$columnResizing = state.columnResizing,
          startX = _state$columnResizing.startX,
          _columnWidth = _state$columnResizing.columnWidth,
          _state$columnResizing2 = _state$columnResizing.headerIdWidths,
          _headerIdWidths = _state$columnResizing2 === void 0 ? [] : _state$columnResizing2;

      var deltaX = _clientX - startX;
      var percentageDeltaX = deltaX / _columnWidth;
      var newColumnWidths = {};

      _headerIdWidths.forEach(function (_ref2) {
        var headerId = _ref2[0],
            headerWidth = _ref2[1];
        newColumnWidths[headerId] = Math.max(headerWidth + headerWidth * percentageDeltaX, 0);
      });

      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          columnWidths: _extends({}, state.columnResizing.columnWidths, {}, newColumnWidths)
        })
      });
    }

    if (action.type === actions.columnDoneResizing) {
      return _extends({}, state, {
        columnResizing: _extends({}, state.columnResizing, {
          startX: null,
          isResizingColumn: null
        })
      });
    }
  }

  var useInstanceBeforeDimensions$1 = function useInstanceBeforeDimensions(instance) {
    var flatHeaders = instance.flatHeaders,
        disableResizing = instance.disableResizing,
        getHooks = instance.getHooks,
        columnResizing = instance.state.columnResizing;
    var getInstance = useGetLatest(instance);
    flatHeaders.forEach(function (header) {
      var canResize = getFirstDefined(header.disableResizing === true ? false : undefined, disableResizing === true ? false : undefined, true);
      header.canResize = canResize;
      header.width = columnResizing.columnWidths[header.id] || header.originalWidth || header.width;
      header.isResizing = columnResizing.isResizingColumn === header.id;

      if (canResize) {
        header.getResizerProps = makePropGetter(getHooks().getResizerProps, {
          instance: getInstance(),
          header: header
        });
      }
    });
  };

  function useInstance$b(instance) {
    var plugins = instance.plugins,
        dispatch = instance.dispatch,
        _instance$autoResetRe = instance.autoResetResize,
        autoResetResize = _instance$autoResetRe === void 0 ? true : _instance$autoResetRe,
        columns = instance.columns;
    ensurePluginOrder(plugins, ['useAbsoluteLayout'], 'useResizeColumns');
    var getAutoResetResize = useGetLatest(autoResetResize);
    useMountedLayoutEffect(function () {
      if (getAutoResetResize()) {
        dispatch({
          type: actions.resetResize
        });
      }
    }, [columns]);
    var resetResizing = React.useCallback(function () {
      return dispatch({
        type: actions.resetResize
      });
    }, [dispatch]);
    Object.assign(instance, {
      resetResizing: resetResizing
    });
  }

  function getLeafHeaders(header) {
    var leafHeaders = [];

    var recurseHeader = function recurseHeader(header) {
      if (header.columns && header.columns.length) {
        header.columns.map(recurseHeader);
      }

      leafHeaders.push(header);
    };

    recurseHeader(header);
    return leafHeaders;
  }

  var cellStyles = {
    position: 'absolute',
    top: 0
  };
  var useAbsoluteLayout = function useAbsoluteLayout(hooks) {
    hooks.getTableBodyProps.push(getRowStyles);
    hooks.getRowProps.push(getRowStyles);
    hooks.getHeaderGroupProps.push(getRowStyles);
    hooks.getFooterGroupProps.push(getRowStyles);
    hooks.getHeaderProps.push(function (props, _ref) {
      var column = _ref.column;
      return [props, {
        style: _extends({}, cellStyles, {
          left: column.totalLeft + "px",
          width: column.totalWidth + "px"
        })
      }];
    });
    hooks.getCellProps.push(function (props, _ref2) {
      var cell = _ref2.cell;
      return [props, {
        style: _extends({}, cellStyles, {
          left: cell.column.totalLeft + "px",
          width: cell.column.totalWidth + "px"
        })
      }];
    });
    hooks.getFooterProps.push(function (props, _ref3) {
      var column = _ref3.column;
      return [props, {
        style: _extends({}, cellStyles, {
          left: column.totalLeft + "px",
          width: column.totalWidth + "px"
        })
      }];
    });
  };
  useAbsoluteLayout.pluginName = 'useAbsoluteLayout';

  var getRowStyles = function getRowStyles(props, _ref4) {
    var instance = _ref4.instance;
    return [props, {
      style: {
        position: 'relative',
        width: instance.totalColumnsWidth + "px"
      }
    }];
  };

  var cellStyles$1 = {
    display: 'inline-block',
    boxSizing: 'border-box'
  };

  var getRowStyles$1 = function getRowStyles(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        display: 'flex',
        width: instance.totalColumnsWidth + "px"
      }
    }];
  };

  var useBlockLayout = function useBlockLayout(hooks) {
    hooks.getRowProps.push(getRowStyles$1);
    hooks.getHeaderGroupProps.push(getRowStyles$1);
    hooks.getFooterGroupProps.push(getRowStyles$1);
    hooks.getHeaderProps.push(function (props, _ref2) {
      var column = _ref2.column;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: column.totalWidth + "px"
        })
      }];
    });
    hooks.getCellProps.push(function (props, _ref3) {
      var cell = _ref3.cell;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: cell.column.totalWidth + "px"
        })
      }];
    });
    hooks.getFooterProps.push(function (props, _ref4) {
      var column = _ref4.column;
      return [props, {
        style: _extends({}, cellStyles$1, {
          width: column.totalWidth + "px"
        })
      }];
    });
  };
  useBlockLayout.pluginName = 'useBlockLayout';

  function useFlexLayout(hooks) {
    hooks.getTableProps.push(getTableProps);
    hooks.getRowProps.push(getRowStyles$2);
    hooks.getHeaderGroupProps.push(getRowStyles$2);
    hooks.getFooterGroupProps.push(getRowStyles$2);
    hooks.getHeaderProps.push(getHeaderProps);
    hooks.getCellProps.push(getCellProps);
    hooks.getFooterProps.push(getFooterProps);
  }
  useFlexLayout.pluginName = 'useFlexLayout';

  var getTableProps = function getTableProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        minWidth: instance.totalColumnsMinWidth + "px"
      }
    }];
  };

  var getRowStyles$2 = function getRowStyles(props, _ref2) {
    var instance = _ref2.instance;
    return [props, {
      style: {
        display: 'flex',
        flex: '1 0 auto',
        minWidth: instance.totalColumnsMinWidth + "px"
      }
    }];
  };

  var getHeaderProps = function getHeaderProps(props, _ref3) {
    var column = _ref3.column;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
        minWidth: column.totalMinWidth + "px",
        width: column.totalWidth + "px"
      }
    }];
  };

  var getCellProps = function getCellProps(props, _ref4) {
    var cell = _ref4.cell;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: cell.column.totalFlexWidth + " 0 auto",
        minWidth: cell.column.totalMinWidth + "px",
        width: cell.column.totalWidth + "px"
      }
    }];
  };

  var getFooterProps = function getFooterProps(props, _ref5) {
    var column = _ref5.column;
    return [props, {
      style: {
        boxSizing: 'border-box',
        flex: column.totalFlexWidth ? column.totalFlexWidth + " 0 auto" : undefined,
        minWidth: column.totalMinWidth + "px",
        width: column.totalWidth + "px"
      }
    }];
  };

  function useGridLayout(hooks) {
    hooks.stateReducers.push(reducer$c);
    hooks.getTableProps.push(getTableProps$1);
    hooks.getHeaderProps.push(getHeaderProps$1);
  }
  useGridLayout.pluginName = 'useGridLayout';

  var getTableProps$1 = function getTableProps(props, _ref) {
    var instance = _ref.instance;
    return [props, {
      style: {
        display: "grid",
        gridTemplateColumns: instance.state.gridLayout.columnWidths.map(function (w) {
          return w;
        }).join(" ")
      }
    }];
  };

  var getHeaderProps$1 = function getHeaderProps(props, _ref2) {
    var column = _ref2.column;
    return [props, {
      id: "header-cell-" + column.id,
      style: {
        position: "sticky" //enables a scroll wrapper to be placed around the table and have sticky headers

      }
    }];
  };

  function reducer$c(state, action, previousState, instance) {
    if (action.type === "init") {
      return _extends({
        gridLayout: {
          columnWidths: instance.columns.map(function () {
            return "auto";
          })
        }
      }, state);
    }

    if (action.type === "columnStartResizing") {
      var columnId = action.columnId;
      var columnIndex = instance.visibleColumns.findIndex(function (col) {
        return col.id === columnId;
      });
      var elWidth = getElementWidth(columnId);

      if (elWidth !== undefined) {
        return _extends({}, state, {
          gridLayout: _extends({}, state.gridLayout, {
            columnId: columnId,
            columnIndex: columnIndex,
            startingWidth: elWidth
          })
        });
      } else {
        return state;
      }
    }

    if (action.type === "columnResizing") {
      var _state$gridLayout = state.gridLayout,
          _columnIndex = _state$gridLayout.columnIndex,
          startingWidth = _state$gridLayout.startingWidth,
          columnWidths = _state$gridLayout.columnWidths;
      var change = state.columnResizing.startX - action.clientX;
      var newWidth = startingWidth - change;
      var columnWidthsCopy = [].concat(columnWidths);
      columnWidthsCopy[_columnIndex] = newWidth + "px";
      return _extends({}, state, {
        gridLayout: _extends({}, state.gridLayout, {
          columnWidths: columnWidthsCopy
        })
      });
    }
  }

  function getElementWidth(columnId) {
    var _document$getElementB;

    var width = (_document$getElementB = document.getElementById("header-cell-" + columnId)) == null ? void 0 : _document$getElementB.offsetWidth;

    if (width !== undefined) {
      return width;
    }
  }

  exports._UNSTABLE_usePivotColumns = _UNSTABLE_usePivotColumns;
  exports.actions = actions;
  exports.defaultColumn = defaultColumn;
  exports.defaultGroupByFn = defaultGroupByFn;
  exports.defaultOrderByFn = defaultOrderByFn;
  exports.defaultRenderer = defaultRenderer;
  exports.emptyRenderer = emptyRenderer;
  exports.ensurePluginOrder = ensurePluginOrder;
  exports.flexRender = flexRender;
  exports.functionalUpdate = functionalUpdate;
  exports.loopHooks = loopHooks;
  exports.makePropGetter = makePropGetter;
  exports.makeRenderer = makeRenderer;
  exports.reduceHooks = reduceHooks;
  exports.safeUseLayoutEffect = safeUseLayoutEffect;
  exports.useAbsoluteLayout = useAbsoluteLayout;
  exports.useAsyncDebounce = useAsyncDebounce;
  exports.useBlockLayout = useBlockLayout;
  exports.useColumnOrder = useColumnOrder;
  exports.useExpanded = useExpanded;
  exports.useFilters = useFilters;
  exports.useFlexLayout = useFlexLayout;
  exports.useGetLatest = useGetLatest;
  exports.useGlobalFilter = useGlobalFilter;
  exports.useGridLayout = useGridLayout;
  exports.useGroupBy = useGroupBy;
  exports.useMountedLayoutEffect = useMountedLayoutEffect;
  exports.usePagination = usePagination;
  exports.useResizeColumns = useResizeColumns;
  exports.useRowSelect = useRowSelect;
  exports.useRowState = useRowState;
  exports.useSortBy = useSortBy;
  exports.useTable = useTable;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

});

var reactTable = createCommonjsModule(function (module) {
if (process.env.NODE_ENV === 'production') {
  module.exports = reactTable_production_min;
} else {
  module.exports = reactTable_development;
}
});

function ownKeys$q(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$q(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$q(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$q(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const checkErrors = columns => {
  const hasGroups = !!columns.find(column => column.parent);
  const stickyColumnsWithoutGroup = columns.filter(column => column.sticky && !column.parent).map(({
    Header
  }) => `'${Header}'`);
  if (hasGroups && stickyColumnsWithoutGroup.length) {
    throw new Error(`WARNING react-table-sticky:
      \nYour ReactTable has group and sticky columns outside groups, and that will break UI.
      \nYou must place ${stickyColumnsWithoutGroup.join(' and ')} columns into a group (even a group with an empty Header label)\n`);
  }
  const bugWithUnderColumnsSticky = columns.find(parentCol => !parentCol.sticky && parentCol.columns && parentCol.columns.find(col => col.sticky));
  if (!bugWithUnderColumnsSticky) return;
  const childBugs = bugWithUnderColumnsSticky.columns?.find(({
    sticky
  }) => sticky);
  if (!childBugs) return;
  throw new Error(`WARNING react-table-sticky:
    \nYour ReactTable contain columns group with at least one child columns sticky.
    \nWhen ReactTable has columns groups, only columns groups can be sticky
    \nYou must set sticky: 'left' | 'right' for the '${bugWithUnderColumnsSticky.Header}'
    column, or remove the sticky property of '${childBugs.Header}' column.`);
};
function getStickyValue(column) {
  if (column.sticky === 'left' || column.sticky === 'right') {
    return column.sticky;
  }
  if (column.parent) {
    return getStickyValue(column.parent);
  }
  return null;
}
function columnIsLastLeftSticky(columnId, columns) {
  const index = columns.findIndex(({
    id
  }) => id === columnId);
  const column = columns[index];
  const nextColumn = columns[index + 1];
  const columnIsLeftSticky = getStickyValue(column) === 'left';
  const nextColumnIsLeftSticky = nextColumn && getStickyValue(nextColumn) === 'left';
  return columnIsLeftSticky && !nextColumnIsLeftSticky;
}
function columnIsFirstRightSticky(columnId, columns) {
  const index = columns.findIndex(({
    id
  }) => id === columnId);
  const column = columns[index];
  const prevColumn = columns[index - 1];
  const columnIsRightSticky = getStickyValue(column) === 'right';
  const prevColumnIsRightSticky = prevColumn && getStickyValue(prevColumn) === 'right';
  return columnIsRightSticky && !prevColumnIsRightSticky;
}
function getMarginRight(columnId, columns) {
  const currentIndex = columns.findIndex(({
    id
  }) => id === columnId);
  let rightMargin = 0;
  for (let i = currentIndex + 1; i < columns.length; i += 1) {
    if (columns[i].isVisible !== false) {
      rightMargin += columns[i].width;
    }
  }
  return rightMargin;
}
const cellStylesSticky = {
  // hard coded inline style will be remove in the next major release
  position: 'sticky',
  zIndex: 3
};
function findHeadersSameLevel(header, headers) {
  return headers.filter(flatHeaderItem => {
    return flatHeaderItem.depth === header.depth;
  });
}
function getStickyProps(header, instance) {
  let style = {};
  const dataAttrs = {};
  checkErrors(instance.columns);
  const sticky = getStickyValue(header);
  if (sticky) {
    style = _objectSpread$q({}, cellStylesSticky);
    dataAttrs['data-sticky-td'] = true;
    const headers = findHeadersSameLevel(header, instance.flatHeaders);
    const margin = sticky === 'left' ? header.totalLeft : getMarginRight(header.id, headers);
    style = _objectSpread$q(_objectSpread$q({}, style), {}, {
      [sticky]: `${margin}px`
    });
    const isLastLeftSticky = header.id === 'selection' ? instance.columns.filter(column => column.sticky === 'left').length === 0 : columnIsLastLeftSticky(header.id, headers);
    if (isLastLeftSticky) {
      dataAttrs['data-sticky-last-left-td'] = true;
    }
    const isFirstRightSticky = columnIsFirstRightSticky(header.id, headers);
    if (isFirstRightSticky) {
      dataAttrs['data-sticky-first-right-td'] = true;
    }
  }
  return _objectSpread$q({
    style
  }, dataAttrs);
}
const useSticky = hooks => {
  hooks.getHeaderProps.push((props, {
    instance,
    column
  }) => {
    const nextProps = getStickyProps(column, instance);
    return [props, nextProps];
  });
  hooks.getCellProps.push((props, {
    instance,
    cell
  }) => {
    const nextProps = getStickyProps(cell.column, instance);
    return [props, nextProps];
  });
};
useSticky.pluginName = 'useSticky';

const Density = {
  compact: '7px',
  default: '15px',
  comfortable: '23px'
};
const HorizontalGridlines = css$1(["border-bottom:1px solid ", ";"], ({
  theme
}) => theme.colors.neutrals.grey);
const VerticalGridlines = css$1(["border-right:1px solid ", ";"], ({
  theme
}) => theme.colors.neutrals.grey);
const AllGridlines = css$1(["", " ", ""], HorizontalGridlines, VerticalGridlines);
const GridlinesCSS = {
  horizontal: HorizontalGridlines,
  vertical: VerticalGridlines,
  all: AllGridlines
};
const cellFont = css$1(["font-family:", ";font-size:", ";line-height:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.roboto.fontFamily, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.lineHeight.caption, ({
  theme
}) => theme.fonts.roboto.fontWeight.normal.fontWeight);
const headerCellFont = css$1(["letter-spacing:0;line-height:16px;text-transform:uppercase;font-size:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const SortIcon = styled(Icon).withConfig({
  displayName: "styles__SortIcon",
  componentId: "jez603-0"
})(["color:", ";&:hover{color:", ";}&:focus,&:active{color:", ";}"], ({
  theme
}) => theme.colors.neutrals.grey, ({
  theme
}) => theme.colors.samsungBlue.light, ({
  theme
}) => theme.colors.samsungBlue.default);
const PinIcon = styled(Icon).withConfig({
  displayName: "styles__PinIcon",
  componentId: "jez603-1"
})(["color:", ";padding-right:4px;opacity:", ";&:hover{color:", ";}&:focus,&:active{color:", ";}svg{cursor:", ";}"], ({
  theme,
  pinned
}) => pinned ? theme.colors.samsungBlue.default : theme.colors.neutrals.grey, ({
  disabled
}) => disabled ? 0.3 : 1, ({
  theme
}) => theme.colors.samsungBlue.light, ({
  theme
}) => theme.colors.samsungBlue.default, ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer');
const TableOverflowWrapper = styled.div.withConfig({
  displayName: "styles__TableOverflowWrapper",
  componentId: "jez603-2"
})(["width:100%;overflow:auto;"]);
const TopBarWrapper = styled.div.withConfig({
  displayName: "styles__TopBarWrapper",
  componentId: "jez603-3"
})(["display:flex;align-items:center;padding:", ";background-color:", ";border:1px solid ", ";border-bottom:unset;border-top-left-radius:8px;border-top-right-radius:8px;"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.colors.neutrals.lightGrey, ({
  theme
}) => theme.colors.neutrals.grey);
const TableWrapper = styled(Table$2).withConfig({
  displayName: "styles__TableWrapper",
  componentId: "jez603-4"
})([".beauTableRow:first-of-type{.beauTableHeaderCell{border-top:1px solid ", ";", "}}.beauTableRow:last-child{.beauTableBodyCell{border-bottom:1px solid ", ";&:first-of-type{border-bottom-left-radius:8px;}&:last-of-type{border-bottom-right-radius:8px;}}}.beauTableCell{&.beauTableBodyCell{border:0;padding:", " ", ";", " &:first-of-type{border-left:1px solid ", ";}&:last-of-type{border-right:1px solid ", ";}}&.beauTableCustomCell{padding:0;}}.noDataRow{.beauTableCell{background-color:", ";border-bottom-left-radius:8px;border-bottom-right-radius:8px;}}.tr{:last-child{.td{border-bottom:0;}}}.th,.td{padding:5px;border-bottom:1px solid #ddd;border-right:1px solid #ddd;background-color:#fff;overflow:hidden;:last-child{border-right:0;}}&.sticky{overflow:scroll;.body{position:relative;z-index:0;}[data-sticky-td]{position:sticky;}[data-sticky-last-left-td]{border-right:", " solid ", "!important;}[data-sticky-first-right-td]{border-left:", " solid ", "!important;}}"], ({
  theme
}) => theme.colors.neutrals.grey, ({
  $hasTopBar
}) => !$hasTopBar && `&:first-of-type {
          border-top-left-radius: 8px;
          
        }
        &:last-of-type {
          border-top-right-radius: 8px;
        }
        `, ({
  theme
}) => theme.colors.neutrals.grey, ({
  $density
}) => Density[$density], ({
  theme
}) => `${theme.spacing(1)}`, ({
  $gridlines
}) => GridlinesCSS[$gridlines], ({
  theme
}) => theme.colors.neutrals.grey, ({
  theme
}) => theme.colors.neutrals.grey, ({
  theme
}) => lighten(theme.colors.neutrals.grey, 0.85), ({
  $gridlines
}) => ['all', 'vertical'].includes($gridlines) ? '2px' : '1px', ({
  theme
}) => theme.colors.neutrals.grey, ({
  $gridlines
}) => ['all', 'vertical'].includes($gridlines) ? '2px' : '1px', ({
  theme
}) => theme.colors.neutrals.grey);
const RowWrapper$1 = styled(TableRow$1).withConfig({
  displayName: "styles__RowWrapper",
  componentId: "jez603-5"
})(["&.beauTableRow{&.beauTableRowHover:hover{td{background-color:hsl(231 32% 93% / 1);}}}"]);
const CellWrapper = styled(TableCell$1).withConfig({
  displayName: "styles__CellWrapper",
  componentId: "jez603-6"
})(["background-color:white;&.beauTableCell{&.beauTableHeaderCell{padding:0;background-color:", ";border-right:1px solid ", ";border-bottom:1px solid ", ";&:first-of-type{border-left:1px solid ", ";}&.beauTableBodyCell{", ";}}}"], ({
  theme
}) => theme.colors.neutrals.lightGrey, ({
  theme
}) => theme.colors.neutrals.grey, ({
  theme
}) => theme.colors.neutrals.grey, ({
  theme
}) => theme.colors.neutrals.grey, cellFont);
const HeaderCell = styled.div.withConfig({
  displayName: "styles__HeaderCell",
  componentId: "jez603-7"
})(["", " padding:", ";display:grid;align-items:center;grid-template-columns:1fr min-content min-content;user-select:none;"], headerCellFont, ({
  theme
}) => theme.spacing(1));
const NoDataCell = styled.div.withConfig({
  displayName: "styles__NoDataCell",
  componentId: "jez603-8"
})(["display:flex;justify-content:center;color:", ";font-family:", ";font-size:", ";line-height:14px;font-weight:", ";"], ({
  theme
}) => theme.colors.neutrals.darkGrey, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.samsungOne.fontWeight.bold.fontWeight);
const ResizerColumn = styled.div.withConfig({
  displayName: "styles__ResizerColumn",
  componentId: "jez603-9"
})(["position:absolute;right:0;top:0;height:100%;width:5px;background:rgba(0,0,0,0.5);cursor:col-resize;user-select:none;touch-action:none;&:hover{background-color:", ";opacity:1;}@media (hover:hover){opacity:0;}"], ({
  theme
}) => theme.colors.samsungBlue.light);
const LoadingSpinnerCell = styled.div.withConfig({
  displayName: "styles__LoadingSpinnerCell",
  componentId: "jez603-10"
})(["display:flex;justify-content:center;align-items:center;"]);

const TableContext$1 = /*#__PURE__*/createContext(undefined);
function useTableContext() {
  const context = React.useContext(TableContext$1);
  if (context === undefined) {
    throw new Error('TableContext must be used within a TableContext.Provider');
  }
  return context;
}
const sortColumns = cols => [...cols].sort((a, b) => {
  // sort 'left' sticky columns to the start of the array
  if (a.sticky === 'left') return -1;
  if (b.sticky === 'left') return 1;
  // sort 'right' sticky columns to the end of the array
  if (a.sticky === 'right') return 1;
  if (b.sticky === 'right') return -1;
  return 0;
});

const PaginationWrapper$1 = styled.div.withConfig({
  displayName: "styles__PaginationWrapper",
  componentId: "sc-1knwoke-0"
})(["display:flex;align-items:center;justify-content:flex-end;padding:", ";padding-right:0;.paginationSelect{width:140px;}"], ({
  theme
}) => theme.spacing(1));
const Buttons = styled.div.withConfig({
  displayName: "styles__Buttons",
  componentId: "sc-1knwoke-1"
})(["display:flex;padding-right:", ";padding-left:", ";.paginationPrevious{border-radius:25% 0% 0% 25%;}.paginationNext{border-radius:0% 25% 25% 0%;}"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.spacing(1));
const Label$6 = styled.span.withConfig({
  displayName: "styles__Label",
  componentId: "sc-1knwoke-2"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";"], ({
  theme
}) => theme.colors.neutrals.darkGrey, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.caption, ({
  theme
}) => theme.fonts.roboto.fontWeight.normal.fontWeight);

const Pagination$1 = ({
  page,
  totalRowCount,
  previousPage,
  canPreviousPage,
  nextPage,
  canNextPage,
  setPageSize,
  pageSize,
  pageIndex
}) => {
  const rowsFrom = 1 + pageIndex * pageSize;
  const pageLength = canNextPage ? pageSize : page.length;
  const rowsTo = Math.min(pageLength + pageIndex * pageSize, totalRowCount);
  return /*#__PURE__*/React.createElement(PaginationWrapper$1, {
    "data-testid": "beau-table-pagination"
  }, /*#__PURE__*/React.createElement(Label$6, null, rowsFrom, "-", rowsTo, " of ", totalRowCount), /*#__PURE__*/React.createElement(Buttons, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "beau-table-pagination-previous",
    className: "paginationPrevious",
    icon: "ArrowLeft",
    onClick: () => previousPage(),
    disabled: !canPreviousPage,
    small: true,
    type: "secondary"
  }), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "beau-table-pagination-next",
    className: "paginationNext",
    icon: "ArrowRight",
    onClick: () => nextPage(),
    disabled: !canNextPage,
    small: true,
    type: "secondary"
  })), /*#__PURE__*/React.createElement(Select, {
    "data-testid": "beau-table-pagination-select",
    className: "paginationSelect",
    onSelect: ({
      value
    }) => setPageSize(Number(value)),
    placeholder: "items per page",
    selected: {
      label: `${pageSize} per page`,
      value: pageSize
    },
    searchable: false
  }, [10, 25, 50, 100].map(pageSize => /*#__PURE__*/React.createElement(Select.Option, {
    key: pageSize,
    value: pageSize,
    title: `${pageSize} per page`
  }))));
};

const ColumnPickerWrapper = styled.div.withConfig({
  displayName: "styles__ColumnPickerWrapper",
  componentId: "sc-1e5k4ua-0"
})(["margin-left:auto;.columnPickerButton{margin-left:", ";}"], ({
  theme
}) => theme.spacing(1));

const rowDensity = ['compact', 'default', 'comfortable'];
const tableGridlines = ['horizontal', 'vertical', 'all'];

const TableColumnPicker = ({
  disabledColumns,
  'data-testid': dataTestId = 'beau-column-picker'
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    gridlines,
    setGridlines,
    density,
    setDensity,
    columns,
    toggleHideColumn
  } = useTableContext();
  const handleClick = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const hideableColumns = columns.filter(column => column.id !== 'selection');
  const densityIconNames = {
    default: 'DensityDefault',
    comfortable: 'DensityComfortable',
    compact: 'DensityCompact'
  };
  const gridlinesIconNames = {
    all: 'GridlinesAll',
    vertical: 'GridlinesVertical',
    horizontal: 'GridlinesHorizontal'
  };
  return /*#__PURE__*/React.createElement(ColumnPickerWrapper, null, /*#__PURE__*/React.createElement(Button, {
    small: true,
    icon: "Column",
    type: "secondary",
    onClick: handleClick,
    className: "columnPickerButton",
    "data-testid": dataTestId + '-button'
  }), /*#__PURE__*/React.createElement(Menu$1, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    placement: "bottom-end",
    "data-testid": dataTestId + '-menu'
  }, /*#__PURE__*/React.createElement(Menu$1.Subheader, {
    title: "Columns",
    transform: "uppercase"
  }), hideableColumns?.map(column => {
    const {
      checked
    } = column.getToggleHiddenProps();
    return /*#__PURE__*/React.createElement(Menu$1.Item, {
      key: column.id,
      checked: checked,
      toggleType: "checkbox",
      title: column.Header,
      disabled: disabledColumns?.includes(column.id) || column.sticky === 'left',
      onClick: () => toggleHideColumn(column.id, checked)
    });
  }), /*#__PURE__*/React.createElement(Menu$1.Divider, null), /*#__PURE__*/React.createElement(Menu$1.Subheader, {
    title: "Row Density",
    transform: "uppercase"
  }), rowDensity.map(option => /*#__PURE__*/React.createElement(Menu$1.Item, {
    key: option,
    title: option,
    toggleType: "radio",
    checked: option === density,
    onClick: () => setDensity(option),
    endIcon: densityIconNames[option],
    iconSize: "large"
  })), /*#__PURE__*/React.createElement(Menu$1.Divider, null), /*#__PURE__*/React.createElement(Menu$1.Subheader, {
    title: "Gridlines",
    transform: "uppercase"
  }), tableGridlines.map(option => /*#__PURE__*/React.createElement(Menu$1.Item, {
    key: option,
    title: option,
    toggleType: "radio",
    checked: option === gridlines,
    onClick: () => setGridlines(option),
    endIcon: gridlinesIconNames[option],
    iconSize: "large"
  }))));
};
TableColumnPicker.displayName = 'Table.ColumnPicker';

const SelectionCell = styled(Flex).withConfig({
  displayName: "styles__SelectionCell",
  componentId: "sc-7ha7oz-0"
})(["&.sortable{padding-right:6px;}"]);

const TableSelectionMenu = props => {
  const {
    'data-testid': dataTestId,
    options,
    onChange,
    children,
    rowsSelectedCount,
    className
  } = props;
  const defaultRef = useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isOpen = Boolean(anchorEl);
  const [selectedMenuItem, setSelectedMenuItem] = React.useState('all');
  const handleClick = event => {
    event && event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = event => {
    event && event.stopPropagation();
    setAnchorEl(null);
  };
  const handleMenuChange = (option, event) => {
    event && event.stopPropagation();
    setSelectedMenuItem(option);
    onChange && onChange(option);
  };
  useClickOutside(defaultRef, event => {
    handleClose(event);
  }, isOpen);
  useEffect(() => {
    if (rowsSelectedCount === 0 && selectedMenuItem === 'selected') {
      setSelectedMenuItem('all');
      onChange && onChange('all');
    }
  }, [rowsSelectedCount]);
  return /*#__PURE__*/React.createElement(SelectionCell, {
    "data-testid": `${dataTestId}-checkbox-header`,
    horizontalAlign: "space-between",
    className: className
  }, children, /*#__PURE__*/React.createElement(Icon, {
    "data-testid": 'menu-select-icon',
    name: isOpen ? 'ArrowUp' : 'ArrowDown',
    onClick: handleClick
  }), /*#__PURE__*/React.createElement(Menu$1, {
    anchorEl: anchorEl,
    open: isOpen,
    onClose: handleClose,
    placement: "bottom-start",
    "data-testid": dataTestId + '-menu'
  }, /*#__PURE__*/React.createElement(Subheader, {
    title: "View selections",
    transform: "uppercase"
  }), options.map(({
    key,
    label
  }) => /*#__PURE__*/React.createElement(Item$3, {
    onClick: e => {
      handleMenuChange(key, e);
    },
    checked: selectedMenuItem === key,
    title: label,
    key: key,
    toggleType: "radio",
    "data-testid": `beau-header-select-option-${key}`
  }))));
};
TableSelectionMenu.displayName = 'SelectionMenu';

function ownKeys$r(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$r(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$r(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$r(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const HIDDEN_PINNED_COLUMNS = ['selection', 'actions'];
const Table$3 = function ({
  columns: initialColumns,
  data,
  sortBy: initialSortBy,
  density = 'default',
  gridlines = 'horizontal',
  sortable = false,
  resizable = false,
  pinnable = false,
  pagination = false,
  manualPagination = false,
  totalRowCount = undefined,
  rowSelection = false,
  selectionVariation = 'column',
  selectedRows = [],
  pageIndex: _pageIndex = 0,
  onRowSelected,
  onColumnHidden,
  onDensityChange,
  onGridlinesChange,
  onPaginationChange,
  children,
  hiddenColumns = [],
  className,
  'data-testid': dataTestId = 'beau-table',
  isLoading = false,
  noDataMessage = 'No Data Available'
}) {
  if (manualPagination && totalRowCount === undefined) {
    throw new Error('totalRowCount property is required when using manualPagination');
  }
  pagination = pagination || manualPagination;
  const rowClassnames = {
    root: 'beauTableRow',
    hover: 'beauTableRowHover'
  };
  const cellClassnames = {
    root: 'beauTableCell',
    head: 'beauTableHeaderCell',
    body: 'beauTableBodyCell'
  };
  const [rowDensity, setDensity] = useState(density);
  const [tableGridlines, setGridlines] = useState(gridlines);
  const [pageCount, setPageCount] = useState(manualPagination ? Math.ceil(totalRowCount / 10) : -1);
  const tableHead = useRef(null);
  const tablOverflowWrapper = useRef(null);
  // Converts the props from the number[] interface to the interface react-table needs.
  // ex: [0,1] to { 0: true, 1: true }
  const initiallySelectedRows = Object.fromEntries(selectedRows.map((_, i) => [selectedRows[i], true]));
  const hooksArray = pinnable ? [reactTable.useBlockLayout] : [];
  const [columns, setColumns] = useState(() => sortColumns(initialColumns));
  const selectionColumnWidth = rowSelection ? sortable ? 78 : 56 : 32;
  const initiallyExpandedRows = data.reduce((prev, curr, index) => curr.initiallyExpanded ? _objectSpread$r(_objectSpread$r({}, prev), {}, {
    [index]: true
  }) : prev, {});
  const {
    rows,
    prepareRow,
    page,
    setPageSize,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    headerGroups,
    getTableProps,
    getTableBodyProps,
    selectedFlatRows,
    visibleColumns,
    allColumns,
    toggleHideColumn,
    setHiddenColumns,
    toggleRowSelected,
    state: {
      pageSize,
      pageIndex,
      sortBy
    },
    gotoPage
  } = reactTable.useTable(_objectSpread$r(_objectSpread$r({
    data,
    columns,
    autoResetPage: false,
    autoResetSortBy: false,
    autoResetSelectedRows: false,
    autoResetHiddenColumns: false,
    disableSortBy: !sortable,
    disableResizing: !resizable,
    disablePagination: !pagination,
    manualPagination
  }, manualPagination && {
    pageCount
  }), {}, {
    manualSortBy: manualPagination && sortable,
    initialState: _objectSpread$r({
      pageIndex: _pageIndex,
      selectedRowIds: initiallySelectedRows,
      hiddenColumns,
      expanded: initiallyExpandedRows
    }, initialSortBy && {
      sortBy: initialSortBy
    })
  }), reactTable.useFilters, reactTable.useSortBy, reactTable.useExpanded, reactTable.usePagination, reactTable.useRowSelect, reactTable.useResizeColumns, reactTable.useColumnOrder, ...hooksArray, hooks => {
    pinnable && hooks.visibleColumns.push(columns => columns.map(column => _objectSpread$r(_objectSpread$r({}, column), column.id.toLocaleLowerCase() === 'actions' && {
      sticky: 'right'
    })));
  }, useSticky, hooks => {
    rowSelection && hooks.visibleColumns.push(columns => [{
      id: 'selection',
      sticky: pinnable ? 'left' : undefined,
      disableFilters: false,
      accessor: 'select-column',
      width: selectionColumnWidth,
      maxWidth: selectionColumnWidth,
      filter: (rows, _, filterValue) => filterValue === null ? rows : rows.filter(({
        isSelected
      }) => isSelected === filterValue),
      // eslint-disable-next-line react/display-name
      Header: ({
        getToggleAllRowsSelectedProps,
        preFilteredRows,
        setFilter
      }) => {
        const selectionValues = {
          selected: true,
          unselected: false,
          all: null
        };
        const handleSelectionChange = option => {
          setFilter('selection', () => selectionValues[option]);
        };
        const selectedlength = preFilteredRows.filter(row => row.isSelected).length;
        return /*#__PURE__*/React.createElement(TableSelectionMenu, {
          options: [{
            key: 'all',
            label: 'All'
          }, {
            key: 'selected',
            label: `Selected (${selectedlength || 0})`
          }, {
            key: 'unselected',
            label: `Not Selected (${preFilteredRows.length - selectedlength})`
          }],
          rowsSelectedCount: selectedlength,
          onChange: handleSelectionChange,
          "data-testid": `${dataTestId}-checkbox-selection-menu`,
          className: sortable ? 'sortable' : ''
        }, /*#__PURE__*/React.createElement(Checkbox$2, _objectSpread$r({
          name: 'checkbox-selection',
          "data-testid": `${dataTestId}-checkbox-selection`,
          onClick: e => e.stopPropagation()
        }, getToggleAllRowsSelectedProps())));
      },
      // eslint-disable-next-line react/display-name
      Cell: ({
        row
      }) => /*#__PURE__*/React.createElement(Flex, {
        horizontalAlign: "flex-start",
        verticalAlign: "center"
      }, /*#__PURE__*/React.createElement(Checkbox$2, _objectSpread$r({
        "data-testid": `${dataTestId}-checkbox-row-${row.id}`,
        name: `checkbox-${row.id}`
      }, row.getToggleRowSelectedProps())))
    }, ...columns]);
  });
  useEffect(() => {
    const selectedRows = selectedFlatRows.map(({
      original
    }) => original);
    onRowSelected && onRowSelected(selectedRows);
  }, [selectedFlatRows.length]);
  useEffect(() => {
    const shownColumns = visibleColumns.map(({
      id
    }) => id).filter(id => id !== 'selection');
    onColumnHidden && onColumnHidden(shownColumns);
  }, [visibleColumns.length]);
  // This is a temporary solution until we update to Table V8 so that we can leverage the built-in resets features
  useEffect(() => {
    setHiddenColumns(hiddenColumns);
  }, [hiddenColumns.join('')]);
  useEffect(() => {
    onDensityChange && onDensityChange(rowDensity);
  }, [rowDensity]);
  useEffect(() => {
    onGridlinesChange && onGridlinesChange(tableGridlines);
  }, [tableGridlines]);
  useEffect(() => {
    onPaginationChange && onPaginationChange({
      pageIndex,
      pageSize,
      sortBy
    });
  }, [pageIndex, pageSize, sortBy]);
  useEffect(() => {
    gotoPage(_pageIndex);
  }, [_pageIndex]);
  useEffect(() => {
    if (manualPagination && pageSize && totalRowCount) {
      setPageCount(Math.ceil(totalRowCount / pageSize));
    }
  }, [pageSize, totalRowCount, manualPagination]);
  const isDataEmpty = !data || !rows.length;
  const columnCount = Math.max(...headerGroups.map(({
    headers
  }) => headers.length));
  const isColumnInRange = isSticky => {
    const numberOfStickyColumns = columns.filter(column => column.sticky).length + (rowSelection ? 1 : 0);
    const visibleScrollWidth = tablOverflowWrapper.current ? tablOverflowWrapper.current?.offsetWidth - visibleColumns[numberOfStickyColumns]?.totalLeft - 80 : 180;
    const minimumVisibleWidth = 170;
    return visibleScrollWidth > minimumVisibleWidth || isSticky;
  };
  const generateTableBody = () => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(RowWrapper$1, {
        className: "loadingSpinner"
      }, /*#__PURE__*/React.createElement(CellWrapper, {
        classes: cellClassnames,
        colSpan: columnCount,
        "data-testid": "beau-table-loading-cell"
      }, /*#__PURE__*/React.createElement(LoadingSpinnerCell, null, /*#__PURE__*/React.createElement(Spinner, null))));
    }
    if (isDataEmpty) {
      return /*#__PURE__*/React.createElement(RowWrapper$1, {
        className: "noDataRow"
      }, /*#__PURE__*/React.createElement(CellWrapper, {
        classes: cellClassnames,
        colSpan: columnCount,
        "data-testid": "beau-table-nodata-cell"
      }, /*#__PURE__*/React.createElement(NoDataCell, null, noDataMessage)));
    }
    return (pagination ? page : rows).map(row => {
      prepareRow(row);
      const originalRowData = row.original;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: row.id
      }, /*#__PURE__*/React.createElement(RowWrapper$1, _objectSpread$r(_objectSpread$r({}, row.getRowProps()), {}, {
        classes: rowClassnames,
        hover: true,
        role: "content-row",
        tabIndex: -1,
        "data-testid": `${dataTestId}-row`,
        onClick: () => {
          if (rowSelection && selectionVariation === 'row') {
            toggleRowSelected(row.id, !row.isSelected);
          }
        }
      }), row.cells.map(cell => {
        return /*#__PURE__*/React.createElement(CellWrapper, _objectSpread$r(_objectSpread$r({
          "$isSelectableCell": rowSelection && cell.column.id === 'selection',
          onClick: () => {
            if (cell.column.id === 'selection' && selectionVariation === 'column') {
              toggleRowSelected(row.id, !row.isSelected);
            }
          }
        }, cell.getCellProps()), {}, {
          classes: cellClassnames,
          "data-testid": `${dataTestId}-${cell.column.id}-data`
        }), /*#__PURE__*/React.createElement(Flex, {
          gap: 1
        }, cell.column.canRowExpand && (row.canExpand || originalRowData.customComponentRow) ? /*#__PURE__*/React.createElement("div", _objectSpread$r({}, row.getToggleRowExpandedProps()), /*#__PURE__*/React.createElement(Icon, {
          name: row.isExpanded ? 'ArrowDown' : 'ArrowRight',
          "data-testid": `beau-table-expand-row-icon_${cell.column.id}_${cell.row.index}`
        })) : null, cell.render('Cell')));
      })), row.isExpanded && originalRowData.customComponentRow ? /*#__PURE__*/React.createElement(RowWrapper$1, null, /*#__PURE__*/React.createElement(CellWrapper, {
        classes: cellClassnames,
        className: "beauTableCustomCell",
        colSpan: columnCount
      }, originalRowData.customComponentRow?.(row.values))) : null);
    });
  };
  const togglePinedColumn = (e, columnId, stickySide) => {
    e.stopPropagation();
    setColumns(prevColumns => sortColumns(initialColumns.map(col => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      let newCol = prevColumns.find(c => c.accessor === col.accessor);
      if (newCol && newCol.accessor === columnId) {
        newCol = _objectSpread$r(_objectSpread$r({}, newCol), {}, {
          sticky: newCol.sticky ? undefined : stickySide
        });
      }
      return newCol;
    })));
  };
  return /*#__PURE__*/React.createElement(TableContext$1.Provider, {
    value: {
      density: rowDensity,
      setDensity,
      gridlines: tableGridlines,
      setGridlines,
      columns: allColumns,
      toggleHideColumn
    }
  }, children && /*#__PURE__*/React.createElement(TopBarWrapper, null, children), /*#__PURE__*/React.createElement(TableOverflowWrapper, {
    ref: tablOverflowWrapper
  }, /*#__PURE__*/React.createElement(TableWrapper, _objectSpread$r({
    stickyHeader: true,
    className: className,
    "aria-label": "table",
    "data-testid": dataTestId,
    "$density": rowDensity,
    "$gridlines": tableGridlines,
    "$hasTopBar": !!children,
    "$isSelectable": rowSelection
  }, getTableProps({
    className: pinnable ? 'sticky' : ''
  })), /*#__PURE__*/React.createElement(TableHead$1, {
    className: "beauTableHeader",
    "data-testid": dataTestId + '-head'
  }, headerGroups.map(headerGroup => /*#__PURE__*/React.createElement(RowWrapper$1, _objectSpread$r(_objectSpread$r({
    ref: tableHead
  }, headerGroup.getHeaderGroupProps()), {}, {
    classes: rowClassnames
  }), headerGroup.headers.map(column => /*#__PURE__*/React.createElement(CellWrapper, _objectSpread$r(_objectSpread$r(_objectSpread$r({
    "$isSelectableCell": rowSelection
  }, column.getHeaderProps(column.getSortByToggleProps())), column.getHeaderProps({
    style: _objectSpread$r(_objectSpread$r(_objectSpread$r({
      zIndex: 4
    }, column.totalWidth !== undefined && {
      width: column.totalWidth
    }), column.minWidth !== undefined && {
      minWidth: column.minWidth
    }), column.maxWidth !== undefined && {
      maxWidth: column.maxWidth
    })
  })), {}, {
    classes: cellClassnames
  }), /*#__PURE__*/React.createElement(HeaderCell, null, column.render('Header'), pinnable && !HIDDEN_PINNED_COLUMNS.includes(column.id) && /*#__PURE__*/React.createElement(PinIcon, {
    name: 'Pin',
    disabled: !isColumnInRange(!!column.sticky),
    pinned: !!column.sticky,
    title: isColumnInRange(!!column.sticky) ? 'Pin Column' : 'Please unpin other column first',
    "data-testid": `beau-table-pinnable-icon_${column.id}`,
    onClick: e => togglePinedColumn(e, column.id, 'left')
  }), column.canSort && /*#__PURE__*/React.createElement(SortIcon, {
    name: column.isSorted ? column.isSortedDesc ? 'CaretDescending' : 'CaretAscending' : 'Caret',
    "data-testid": `beau-table-sort-icon_${column.id}`
  }), column.canResize && /*#__PURE__*/React.createElement(ResizerColumn, _objectSpread$r(_objectSpread$r({}, column.getResizerProps()), {}, {
    "data-testid": 'beau-column-resizing-bar'
  })))))))), /*#__PURE__*/React.createElement(TableBody$1, _objectSpread$r(_objectSpread$r({}, getTableBodyProps()), {}, {
    "data-testid": dataTestId + '-body'
  }), generateTableBody()))), !isDataEmpty && pagination && /*#__PURE__*/React.createElement(Pagination$1, {
    page: page,
    totalRowCount: totalRowCount ?? rows.length,
    pageSize: pageSize,
    setPageSize: setPageSize,
    nextPage: nextPage,
    previousPage: previousPage,
    canNextPage: canNextPage,
    canPreviousPage: canPreviousPage,
    pageIndex: pageIndex
  }));
};
Table$3.ColumnPicker = TableColumnPicker;

const HoverFocus = css$1([".beauSwitchIconButton:hover,.beauSwitchFocused{background:none;.beauSwitchThumb{box-shadow:0 0 0 1px #1428a0;}}"]);
const Checked$2 = css$1([".beauSwitchChecked{& + .beauSwitchTrack{opacity:1;background-color:#1428a0;}}"]);
const Disabled$1 = css$1([".beauSwitchDisabled{.beauSwitchThumb{border-color:#777777;}& + .beauSwitchTrack{opacity:1;border-color:#777777;background-color:white;}&.beauSwitchChecked{& + .beauSwitchTrack{background-color:#777777;}}}"]);
const SwitchWrapper = styled(Switch$1).withConfig({
  displayName: "styles__SwitchWrapper",
  componentId: "sc-63uceu-0"
})(["&.beauSwitch{padding:10px;.beauSwitchTrack{opacity:1;border-radius:10px;background-color:white;border:1px solid #1428a0;}.beauSwitchThumb{width:22px;height:22px;box-shadow:none;background-color:white;border:1px solid #1428a0;}.beauSwitchIconButton{padding:8px;}", " ", " ", "}"], HoverFocus, Checked$2, Disabled$1);
const InputPlacementTop$1 = css$1(["align-items:flex-start;.beauSwitchLabel{margin-top:8px;}"]);
const SwitchAndLabel = styled(FormControlLabel$1).withConfig({
  displayName: "styles__SwitchAndLabel",
  componentId: "sc-63uceu-1"
})(["&.beauSwitchLabelWrapper{margin:0;", "}.beauSwitchLabel{font-family:", ";font-size:", ";line-height:", ";", ";&.beauSwitchLabelDisabled{color:initial;}}"], ({
  $inputPlacement
}) => $inputPlacement === 'top' && InputPlacementTop$1, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  labelPlacement
}) => labelPlacement === 'start' ? `margin-right: -2px` : `margin-left: -2px`);

const Switch$2 = function ({
  children,
  name = 'switch',
  checked = false,
  disabled = false,
  inputPlacement = 'top',
  labelPlacement = 'right',
  className,
  'data-testid': dataTestId = 'beau-switch',
  onChange
}) {
  const getLabelPlacementFromType = placement => placement === 'right' ? 'end' : 'start';
  const labelClasses = {
    root: 'beauSwitchLabelWrapper',
    label: 'beauSwitchLabel',
    disabled: 'beauSwitchLabelDisabled'
  };
  const switchClasses = {
    root: 'beauSwitch',
    track: 'beauSwitchTrack',
    thumb: 'beauSwitchThumb',
    checked: 'beauSwitchChecked',
    disabled: 'beauSwitchDisabled',
    switchBase: 'beauSwitchIconButton'
  };
  const SwitchOnly = /*#__PURE__*/React.createElement(SwitchWrapper, {
    className: !children ? className : '',
    name: name,
    disableRipple: true,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    classes: switchClasses,
    focusVisibleClassName: "beauSwitchFocused",
    inputProps: {
      name: name,
      'aria-label': name,
      'data-testid': dataTestId
    }
  });
  return children ? /*#__PURE__*/React.createElement(SwitchAndLabel, {
    className: className,
    label: children,
    control: SwitchOnly,
    classes: labelClasses,
    "$inputPlacement": inputPlacement,
    labelPlacement: getLabelPlacementFromType(labelPlacement)
  }) : SwitchOnly;
};

const NotDense = css$1(["&.beauList{border-radius:8px;box-shadow:inset 0px 0px 0px 1px ", ";padding:", ";}.beauListItem{border-top-right-radius:8px;border-bottom-right-radius:8px;border-left:1px solid ", ";padding:", ";&:hover,&.beauListItemFocused{border-color:", ";}&:first-of-type{border-top-left-radius:0;}&:last-of-type{border-bottom-left-radius:0;}}.beauListSubheader{border-left:1px solid ", ";padding:", ";}.MuiDivider-root{margin:", ";}"], ({
  theme
}) => theme.colors.list.outline.default, ({
  theme
}) => `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(2)} 0 `, ({
  theme
}) => theme.colors.list.outline.default, ({
  theme
}) => `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(2)}`, ({
  theme
}) => theme.colors.list.outline.active, ({
  theme
}) => theme.colors.list.outline.default, ({
  theme
}) => `${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(2)}`, ({
  theme
}) => `${theme.spacing(0.5)} 0 ${theme.spacing(0.5)} ${theme.spacing(2)}`);
const ListWrapper$1 = styled(List$2).withConfig({
  displayName: "styles__ListWrapper",
  componentId: "fsckn1-0"
})(["&.beauList{min-width:206px;", " background-color:", ";}"], ({
  $dense
}) => !$dense && NotDense, ({
  theme
}) => theme.colors.list.listItem.backgroundColor);

const List$4 = function ({
  dense,
  children,
  'data-testid': dataTestId = 'beau-list',
  className
}) {
  return /*#__PURE__*/React.createElement(ListWrapper$1, {
    "$dense": dense,
    className: `beauList ${className}`,
    disablePadding: true,
    "data-testid": dataTestId
  }, children);
};
List$4.Item = Item$4;
List$4.Divider = Divider$1;
List$4.Subheader = Subheader;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var Browser = (function () {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}());
var Env = (function () {
    function Env() {
        this.browser = new Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}());
var env = new Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    env.wxa = true;
    env.touchEventsSupported = true;
}
else if (typeof document === 'undefined' && typeof self !== 'undefined') {
    env.worker = true;
}
else if (typeof navigator === 'undefined') {
    env.node = true;
    env.svgSupported = true;
}
else {
    detect(navigator.userAgent, env);
}
function detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/)
        || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = (/micromessenger/i).test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) {
        browser.weChat = true;
    }
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window
        && (browser.edge || (browser.ie && +browser.version >= 11));
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = ((browser.ie && 'transition' in style)
        || browser.edge
        || (('WebKitCSSMatrix' in window) && ('m11' in new WebKitCSSMatrix()))
        || 'MozPerspective' in style)
        && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported
        || (browser.ie && +browser.version >= 9);
}

var DEFAULT_FONT_SIZE = 12;
var DEFAULT_FONT_FAMILY = 'sans-serif';
var DEFAULT_FONT = DEFAULT_FONT_SIZE + "px " + DEFAULT_FONT_FAMILY;
var OFFSET = 20;
var SCALE = 100;
var defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') {
        return map;
    }
    for (var i = 0; i < mapStr.length; i++) {
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - OFFSET) / SCALE;
        map[char] = size;
    }
    return map;
}
var DEFAULT_TEXT_WIDTH_MAP = getTextWidthMap(defaultWidthMapStr);
var platformApi = {
    createCanvas: function () {
        return typeof document !== 'undefined'
            && document.createElement('canvas');
    },
    measureText: (function () {
        var _ctx;
        var _cachedFont;
        return function (text, font) {
            if (!_ctx) {
                var canvas = platformApi.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) {
                    _cachedFont = _ctx.font = font || DEFAULT_FONT;
                }
                return _ctx.measureText(text);
            }
            else {
                text = text || '';
                font = font || DEFAULT_FONT;
                var res = /(\d+)px/.exec(font);
                var fontSize = res && +res[1] || DEFAULT_FONT_SIZE;
                var width = 0;
                if (font.indexOf('mono') >= 0) {
                    width = fontSize * text.length;
                }
                else {
                    for (var i = 0; i < text.length; i++) {
                        var preCalcWidth = DEFAULT_TEXT_WIDTH_MAP[text[i]];
                        width += preCalcWidth == null ? fontSize : (preCalcWidth * fontSize);
                    }
                }
                return { width: width };
            }
        };
    })(),
    loadImage: function (src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function setPlatformAPI(newPlatformApis) {
    for (var key in platformApi) {
        if (newPlatformApis[key]) {
            platformApi[key] = newPlatformApis[key];
        }
    }
}

var BUILTIN_OBJECT = reduce$6([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function (obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var TYPED_ARRAY = reduce$6([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function (obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var objToString = Object.prototype.toString;
var arrayProto$1 = Array.prototype;
var nativeForEach = arrayProto$1.forEach;
var nativeFilter = arrayProto$1.filter;
var nativeSlice = arrayProto$1.slice;
var nativeMap = arrayProto$1.map;
var ctorFunction = function () { }.constructor;
var protoFunction = ctorFunction ? ctorFunction.prototype : null;
var protoKey = '__proto__';
var idStart = 0x0907;
function guid() {
    return idStart++;
}
function logError() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        console.error.apply(console, args);
    }
}
function clone(source) {
    if (source == null || typeof source !== 'object') {
        return source;
    }
    var result = source;
    var typeStr = objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!isPrimitive(source)) {
            result = [];
            for (var i = 0, len = source.length; i < len; i++) {
                result[i] = clone(source[i]);
            }
        }
    }
    else if (TYPED_ARRAY[typeStr]) {
        if (!isPrimitive(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) {
                result = Ctor.from(source);
            }
            else {
                result = new Ctor(source.length);
                for (var i = 0, len = source.length; i < len; i++) {
                    result[i] = source[i];
                }
            }
        }
    }
    else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
        result = {};
        for (var key in source) {
            if (source.hasOwnProperty(key) && key !== protoKey) {
                result[key] = clone(source[key]);
            }
        }
    }
    return result;
}
function merge$1(target, source, overwrite) {
    if (!isObject$2(source) || !isObject$2(target)) {
        return overwrite ? clone(source) : target;
    }
    for (var key in source) {
        if (source.hasOwnProperty(key) && key !== protoKey) {
            var targetProp = target[key];
            var sourceProp = source[key];
            if (isObject$2(sourceProp)
                && isObject$2(targetProp)
                && !isArray$1(sourceProp)
                && !isArray$1(targetProp)
                && !isDom(sourceProp)
                && !isDom(targetProp)
                && !isBuiltInObject(sourceProp)
                && !isBuiltInObject(targetProp)
                && !isPrimitive(sourceProp)
                && !isPrimitive(targetProp)) {
                merge$1(targetProp, sourceProp, overwrite);
            }
            else if (overwrite || !(key in target)) {
                target[key] = clone(source[key]);
            }
        }
    }
    return target;
}
function mergeAll(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for (var i = 1, len = targetAndSources.length; i < len; i++) {
        result = merge$1(result, targetAndSources[i], overwrite);
    }
    return result;
}
function extend(target, source) {
    if (Object.assign) {
        Object.assign(target, source);
    }
    else {
        for (var key in source) {
            if (source.hasOwnProperty(key) && key !== protoKey) {
                target[key] = source[key];
            }
        }
    }
    return target;
}
function defaults(target, source, overlay) {
    var keysArr = keys$2(source);
    for (var i = 0; i < keysArr.length; i++) {
        var key = keysArr[i];
        if ((overlay ? source[key] != null : target[key] == null)) {
            target[key] = source[key];
        }
    }
    return target;
}
var createCanvas = platformApi.createCanvas;
function indexOf(array, value) {
    if (array) {
        if (array.indexOf) {
            return array.indexOf(value);
        }
        for (var i = 0, len = array.length; i < len; i++) {
            if (array[i] === value) {
                return i;
            }
        }
    }
    return -1;
}
function inherits(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() { }
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for (var prop in clazzPrototype) {
        if (clazzPrototype.hasOwnProperty(prop)) {
            clazz.prototype[prop] = clazzPrototype[prop];
        }
    }
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function mixin(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for (var i = 0; i < keyList.length; i++) {
            var key = keyList[i];
            if (key !== 'constructor') {
                if ((override ? source[key] != null : target[key] == null)) {
                    target[key] = source[key];
                }
            }
        }
    }
    else {
        defaults(target, source, override);
    }
}
function isArrayLike$1(data) {
    if (!data) {
        return false;
    }
    if (typeof data === 'string') {
        return false;
    }
    return typeof data.length === 'number';
}
function each(arr, cb, context) {
    if (!(arr && cb)) {
        return;
    }
    if (arr.forEach && arr.forEach === nativeForEach) {
        arr.forEach(cb, context);
    }
    else if (arr.length === +arr.length) {
        for (var i = 0, len = arr.length; i < len; i++) {
            cb.call(context, arr[i], i, arr);
        }
    }
    else {
        for (var key in arr) {
            if (arr.hasOwnProperty(key)) {
                cb.call(context, arr[key], key, arr);
            }
        }
    }
}
function map(arr, cb, context) {
    if (!arr) {
        return [];
    }
    if (!cb) {
        return slice(arr);
    }
    if (arr.map && arr.map === nativeMap) {
        return arr.map(cb, context);
    }
    else {
        var result = [];
        for (var i = 0, len = arr.length; i < len; i++) {
            result.push(cb.call(context, arr[i], i, arr));
        }
        return result;
    }
}
function reduce$6(arr, cb, memo, context) {
    if (!(arr && cb)) {
        return;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        memo = cb.call(context, memo, arr[i], i, arr);
    }
    return memo;
}
function filter(arr, cb, context) {
    if (!arr) {
        return [];
    }
    if (!cb) {
        return slice(arr);
    }
    if (arr.filter && arr.filter === nativeFilter) {
        return arr.filter(cb, context);
    }
    else {
        var result = [];
        for (var i = 0, len = arr.length; i < len; i++) {
            if (cb.call(context, arr[i], i, arr)) {
                result.push(arr[i]);
            }
        }
        return result;
    }
}
function find$1(arr, cb, context) {
    if (!(arr && cb)) {
        return;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        if (cb.call(context, arr[i], i, arr)) {
            return arr[i];
        }
    }
}
function keys$2(obj) {
    if (!obj) {
        return [];
    }
    if (Object.keys) {
        return Object.keys(obj);
    }
    var keyList = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            keyList.push(key);
        }
    }
    return keyList;
}
function bindPolyfill(func, context) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return function () {
        return func.apply(context, args.concat(nativeSlice.call(arguments)));
    };
}
var bind = (protoFunction && isFunction$3(protoFunction.bind))
    ? protoFunction.call.bind(protoFunction.bind)
    : bindPolyfill;
function curry(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return function () {
        return func.apply(this, args.concat(nativeSlice.call(arguments)));
    };
}
function isArray$1(value) {
    if (Array.isArray) {
        return Array.isArray(value);
    }
    return objToString.call(value) === '[object Array]';
}
function isFunction$3(value) {
    return typeof value === 'function';
}
function isString(value) {
    return typeof value === 'string';
}
function isStringSafe(value) {
    return objToString.call(value) === '[object String]';
}
function isNumber$1(value) {
    return typeof value === 'number';
}
function isObject$2(value) {
    var type = typeof value;
    return type === 'function' || (!!value && type === 'object');
}
function isBuiltInObject(value) {
    return !!BUILTIN_OBJECT[objToString.call(value)];
}
function isTypedArray$1(value) {
    return !!TYPED_ARRAY[objToString.call(value)];
}
function isDom(value) {
    return typeof value === 'object'
        && typeof value.nodeType === 'number'
        && typeof value.ownerDocument === 'object';
}
function isGradientObject(value) {
    return value.colorStops != null;
}
function isImagePatternObject(value) {
    return value.image != null;
}
function isRegExp(value) {
    return objToString.call(value) === '[object RegExp]';
}
function eqNaN(value) {
    return value !== value;
}
function retrieve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    for (var i = 0, len = args.length; i < len; i++) {
        if (args[i] != null) {
            return args[i];
        }
    }
}
function retrieve2(value0, value1) {
    return value0 != null
        ? value0
        : value1;
}
function retrieve3(value0, value1, value2) {
    return value0 != null
        ? value0
        : value1 != null
            ? value1
            : value2;
}
function slice(arr) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return nativeSlice.apply(arr, args);
}
function normalizeCssArray(val) {
    if (typeof (val) === 'number') {
        return [val, val, val, val];
    }
    var len = val.length;
    if (len === 2) {
        return [val[0], val[1], val[0], val[1]];
    }
    else if (len === 3) {
        return [val[0], val[1], val[2], val[1]];
    }
    return val;
}
function assert(condition, message) {
    if (!condition) {
        throw new Error(message);
    }
}
function trim(str) {
    if (str == null) {
        return null;
    }
    else if (typeof str.trim === 'function') {
        return str.trim();
    }
    else {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
}
var primitiveKey = '__ec_primitive__';
function setAsPrimitive(obj) {
    obj[primitiveKey] = true;
}
function isPrimitive(obj) {
    return obj[primitiveKey];
}
var MapPolyfill = (function () {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function (key) {
        var existed = this.has(key);
        if (existed) {
            delete this.data[key];
        }
        return existed;
    };
    MapPolyfill.prototype.has = function (key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function (key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function (key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function () {
        return keys$2(this.data);
    };
    MapPolyfill.prototype.forEach = function (callback) {
        var data = this.data;
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                callback(data[key], key);
            }
        }
    };
    return MapPolyfill;
}());
var isNativeMapSupported = typeof Map === 'function';
function maybeNativeMap() {
    return (isNativeMapSupported ? new Map() : new MapPolyfill());
}
var HashMap = (function () {
    function HashMap(obj) {
        var isArr = isArray$1(obj);
        this.data = maybeNativeMap();
        var thisMap = this;
        (obj instanceof HashMap)
            ? obj.each(visit)
            : (obj && each(obj, visit));
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function (key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function (key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function (key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function (cb, context) {
        this.data.forEach(function (value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function () {
        var keys = this.data.keys();
        return isNativeMapSupported
            ? Array.from(keys)
            : keys;
    };
    HashMap.prototype.removeKey = function (key) {
        this.data["delete"](key);
    };
    return HashMap;
}());
function createHashMap(obj) {
    return new HashMap(obj);
}
function concatArray(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for (var i = 0; i < a.length; i++) {
        newArray[i] = a[i];
    }
    var offset = a.length;
    for (var i = 0; i < b.length; i++) {
        newArray[i + offset] = b[i];
    }
    return newArray;
}
function createObject(proto, properties) {
    var obj;
    if (Object.create) {
        obj = Object.create(proto);
    }
    else {
        var StyleCtor = function () { };
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) {
        extend(obj, properties);
    }
    return obj;
}
function disableUserSelect(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function hasOwn(own, prop) {
    return own.hasOwnProperty(prop);
}
function noop$2() { }
var RADIAN_TO_DEGREE = 180 / Math.PI;

var util = /*#__PURE__*/Object.freeze({
	__proto__: null,
	guid: guid,
	logError: logError,
	clone: clone,
	merge: merge$1,
	mergeAll: mergeAll,
	extend: extend,
	defaults: defaults,
	createCanvas: createCanvas,
	indexOf: indexOf,
	inherits: inherits,
	mixin: mixin,
	isArrayLike: isArrayLike$1,
	each: each,
	map: map,
	reduce: reduce$6,
	filter: filter,
	find: find$1,
	keys: keys$2,
	bind: bind,
	curry: curry,
	isArray: isArray$1,
	isFunction: isFunction$3,
	isString: isString,
	isStringSafe: isStringSafe,
	isNumber: isNumber$1,
	isObject: isObject$2,
	isBuiltInObject: isBuiltInObject,
	isTypedArray: isTypedArray$1,
	isDom: isDom,
	isGradientObject: isGradientObject,
	isImagePatternObject: isImagePatternObject,
	isRegExp: isRegExp,
	eqNaN: eqNaN,
	retrieve: retrieve,
	retrieve2: retrieve2,
	retrieve3: retrieve3,
	slice: slice,
	normalizeCssArray: normalizeCssArray,
	assert: assert,
	trim: trim,
	setAsPrimitive: setAsPrimitive,
	isPrimitive: isPrimitive,
	HashMap: HashMap,
	createHashMap: createHashMap,
	concatArray: concatArray,
	createObject: createObject,
	disableUserSelect: disableUserSelect,
	hasOwn: hasOwn,
	noop: noop$2,
	RADIAN_TO_DEGREE: RADIAN_TO_DEGREE
});

function create(x, y) {
    if (x == null) {
        x = 0;
    }
    if (y == null) {
        y = 0;
    }
    return [x, y];
}
function copy(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function clone$1(v) {
    return [v[0], v[1]];
}
function set(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function add$1(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function scaleAndAdd(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function sub(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function len(v) {
    return Math.sqrt(lenSquare(v));
}
var length = len;
function lenSquare(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var lengthSquare = lenSquare;
function mul(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function div(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function dot(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function scale(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function normalize(out, v) {
    var d = len(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    }
    else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function distance(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0])
        + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var dist = distance;
function distanceSquare(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0])
        + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var distSquare = distanceSquare;
function negate(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function lerp(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function applyTransform(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function min$1(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function max$1(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}

var vector = /*#__PURE__*/Object.freeze({
	__proto__: null,
	create: create,
	copy: copy,
	clone: clone$1,
	set: set,
	add: add$1,
	scaleAndAdd: scaleAndAdd,
	sub: sub,
	len: len,
	length: length,
	lenSquare: lenSquare,
	lengthSquare: lengthSquare,
	mul: mul,
	div: div,
	dot: dot,
	scale: scale,
	normalize: normalize,
	distance: distance,
	dist: dist,
	distanceSquare: distanceSquare,
	distSquare: distSquare,
	negate: negate,
	lerp: lerp,
	applyTransform: applyTransform,
	min: min$1,
	max: max$1
});

var Param = (function () {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}());
var Draggable = (function () {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function (e) {
        var draggingTarget = e.target;
        while (draggingTarget && !draggingTarget.draggable) {
            draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        }
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function (e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) {
                    this.handler.dispatchToElement(new Param(lastDropTarget, e), 'dragleave', e.event);
                }
                if (dropTarget && dropTarget !== lastDropTarget) {
                    this.handler.dispatchToElement(new Param(dropTarget, e), 'dragenter', e.event);
                }
            }
        }
    };
    Draggable.prototype._dragEnd = function (e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            draggingTarget.dragging = false;
        }
        this.handler.dispatchToElement(new Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) {
            this.handler.dispatchToElement(new Param(this._dropTarget, e), 'drop', e.event);
        }
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}());

var Eventful = (function () {
    function Eventful(eventProcessors) {
        if (eventProcessors) {
            this._$eventProcessor = eventProcessors;
        }
    }
    Eventful.prototype.on = function (event, query, handler, context) {
        if (!this._$handlers) {
            this._$handlers = {};
        }
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) {
            return this;
        }
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
            query = eventProcessor.normalizeQuery(query);
        }
        if (!_h[event]) {
            _h[event] = [];
        }
        for (var i = 0; i < _h[event].length; i++) {
            if (_h[event][i].h === handler) {
                return this;
            }
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: (context || this),
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        (lastWrap && lastWrap.callAtLast)
            ? _h[event].splice(lastIndex, 0, wrap)
            : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function (eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function (eventType, handler) {
        var _h = this._$handlers;
        if (!_h) {
            return this;
        }
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for (var i = 0, l = _h[eventType].length; i < l; i++) {
                    if (_h[eventType][i].h !== handler) {
                        newList.push(_h[eventType][i]);
                    }
                }
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) {
                delete _h[eventType];
            }
        }
        else {
            delete _h[eventType];
        }
        return this;
    };
    Eventful.prototype.trigger = function (eventType) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._$handlers) {
            return this;
        }
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for (var i = 0; i < len; i++) {
                var hItem = _h[i];
                if (eventProcessor
                    && eventProcessor.filter
                    && hItem.query != null
                    && !eventProcessor.filter(eventType, hItem.query)) {
                    continue;
                }
                switch (argLen) {
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger
            && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._$handlers) {
            return this;
        }
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for (var i = 0; i < len; i++) {
                var hItem = _h[i];
                if (eventProcessor
                    && eventProcessor.filter
                    && hItem.query != null
                    && !eventProcessor.filter(type, hItem.query)) {
                    continue;
                }
                switch (argLen) {
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger
            && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}());

var LN2 = Math.log(2);
function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) {
        return detCache[cacheKey];
    }
    if (rank === 1) {
        var colStart = Math.round(Math.log(((1 << fullRank) - 1) & ~colMask) / LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | (1 << rowStart);
    var subRowStart = rowStart + 1;
    while (rowMask & (1 << subRowStart)) {
        subRowStart++;
    }
    var sum = 0;
    for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j]
                * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function buildTransformer(src, dest) {
    var mA = [
        [src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]],
        [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]],
        [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]],
        [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]],
        [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]],
        [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]],
        [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]],
        [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]
    ];
    var detCache = {};
    var det = determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) {
        return;
    }
    var vh = [];
    for (var i = 0; i < 8; i++) {
        for (var j = 0; j < 8; j++) {
            vh[j] == null && (vh[j] = 0);
            vh[j] += ((i + j) % 2 ? -1 : 1)
                * determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache)
                / det * dest[i];
        }
    }
    return function (out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}

var EVENT_SAVED_PROP = '___zrEVENTSAVED';
var _calcOut = [];
function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
    return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true)
        && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
}
function transformCoordWithViewport(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
        var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
        var markers = prepareCoordMarkers(el, saved);
        var transformer = preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) {
        return markers;
    }
    markers = saved.markers = [];
    var propLR = ['left', 'right'];
    var propTB = ['top', 'bottom'];
    for (var i = 0; i < 4; i++) {
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for (var i = 0; i < 4; i++) {
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return (oldCoordTheSame && transformer)
        ? transformer
        : (saved.srcCoords = srcCoords,
            saved[transformerName] = inverse
                ? buildTransformer(destCoords, srcCoords)
                : buildTransformer(srcCoords, destCoords));
}
function isCanvasEl(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var replaceReg = /([&<>"'])/g;
var replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function encodeHTML(source) {
    return source == null
        ? ''
        : (source + '').replace(replaceReg, function (str, c) {
            return replaceMap[c];
        });
}

var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var _calcOut$1 = [];
var firefoxNotSupportOffsetXY = env.browser.firefox
    && +env.browser.version.split('.')[0] < 39;
function clientToLocal(el, e, out, calculate) {
    out = out || {};
    if (calculate) {
        calculateZrXY(el, e, out);
    }
    else if (firefoxNotSupportOffsetXY
        && e.layerX != null
        && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    }
    else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    }
    else {
        calculateZrXY(el, e, out);
    }
    return out;
}
function calculateZrXY(el, e, out) {
    if (env.domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if (isCanvasEl(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        }
        else {
            if (transformCoordWithViewport(_calcOut$1, el, ex, ey)) {
                out.zrX = _calcOut$1[0];
                out.zrY = _calcOut$1[1];
                return;
            }
        }
    }
    out.zrX = out.zrY = 0;
}
function getNativeEvent(e) {
    return e
        || window.event;
}
function normalizeEvent(el, e, calculate) {
    e = getNativeEvent(e);
    if (e.zrX != null) {
        return e;
    }
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        clientToLocal(el, e, e, calculate);
        var wheelDelta = getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    }
    else {
        var touch = eventType !== 'touchend'
            ? e.targetTouches[0]
            : e.changedTouches[0];
        touch && clientToLocal(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
        e.which = (button & 1 ? 1 : (button & 2 ? 3 : (button & 4 ? 2 : 0)));
    }
    return e;
}
function getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) {
        return rawWheelDelta;
    }
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) {
        return rawWheelDelta;
    }
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1
        : deltaY < 0 ? 1
            : deltaX > 0 ? -1
                : 1;
    return 3 * delta * sign;
}
function addEventListener(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function removeEventListener(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var stop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function isMiddleOrRightButtonOnMouseUpDown(e) {
    return e.which === 2 || e.which === 3;
}

var GestureMgr = (function () {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function (event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function () {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function (event, target, root) {
        var touches = event.touches;
        if (!touches) {
            return;
        }
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for (var i = 0, len = touches.length; i < len; i++) {
            var touch = touches[i];
            var pos = clientToLocal(root, touch, {});
            trackItem.points.push([pos.zrX, pos.zrY]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function (event) {
        for (var eventName in recognizers) {
            if (recognizers.hasOwnProperty(eventName)) {
                var gestureInfo = recognizers[eventName](this._track, event);
                if (gestureInfo) {
                    return gestureInfo;
                }
            }
        }
    };
    return GestureMgr;
}());
function dist$1(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var recognizers = {
    pinch: function (tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) {
            return;
        }
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre
            && pinchPre.length > 1
            && pinchEnd
            && pinchEnd.length > 1) {
            var pinchScale = dist$1(pinchEnd) / dist$1(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};

function create$1() {
    return [1, 0, 0, 1, 0, 0];
}
function identity$1(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function copy$1(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function mul$1(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function translate(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function rotate(out, a, rad) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * atx + st * aty;
    out[5] = ct * aty - st * atx;
    return out;
}
function scale$1(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function invert(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) {
        return null;
    }
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function clone$2(a) {
    var b = create$1();
    copy$1(b, a);
    return b;
}

var matrix = /*#__PURE__*/Object.freeze({
	__proto__: null,
	create: create$1,
	identity: identity$1,
	copy: copy$1,
	mul: mul$1,
	translate: translate,
	rotate: rotate,
	scale: scale$1,
	invert: invert,
	clone: clone$2
});

var Point = (function () {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function (other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function () {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function (x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function (other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function (other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function (scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function (other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function (other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function (other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function () {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function () {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function (other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function (other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function () {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function (m) {
        if (!m) {
            return;
        }
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function (out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function (input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function (p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function (p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function (p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function (p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function (p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function (out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function (out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function (out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function (out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function (out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}());

var mathMin = Math.min;
var mathMax = Math.max;
var lt = new Point();
var rb = new Point();
var lb = new Point();
var rt = new Point();
var minTv = new Point();
var maxTv = new Point();
var BoundingRect = (function () {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function (other) {
        var x = mathMin(other.x, this.x);
        var y = mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) {
            this.width = mathMax(other.x + other.width, this.x + this.width) - x;
        }
        else {
            this.width = other.width;
        }
        if (isFinite(this.y) && isFinite(this.height)) {
            this.height = mathMax(other.y + other.height, this.y + this.height) - y;
        }
        else {
            this.height = other.height;
        }
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function (m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function (b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = create$1();
        translate(m, m, [-a.x, -a.y]);
        scale$1(m, m, [sx, sy]);
        translate(m, m, [b.x, b.y]);
        return m;
    };
    BoundingRect.prototype.intersect = function (b, mtv) {
        if (!b) {
            return false;
        }
        if (!(b instanceof BoundingRect)) {
            b = BoundingRect.create(b);
        }
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) {
                        Point.set(maxTv, -d0, 0);
                    }
                    else {
                        Point.set(maxTv, d1, 0);
                    }
                }
            }
            else {
                if (dx < dMin) {
                    dMin = dx;
                    if (d0 < d1) {
                        Point.set(minTv, d0, 0);
                    }
                    else {
                        Point.set(minTv, -d1, 0);
                    }
                }
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) {
                        Point.set(maxTv, 0, -d2);
                    }
                    else {
                        Point.set(maxTv, 0, d3);
                    }
                }
            }
            else {
                if (dx < dMin) {
                    dMin = dx;
                    if (d2 < d3) {
                        Point.set(minTv, 0, d2);
                    }
                    else {
                        Point.set(minTv, 0, -d3);
                    }
                }
            }
        }
        if (mtv) {
            Point.copy(mtv, overlap ? minTv : maxTv);
        }
        return overlap;
    };
    BoundingRect.prototype.contain = function (x, y) {
        var rect = this;
        return x >= rect.x
            && x <= (rect.x + rect.width)
            && y >= rect.y
            && y <= (rect.y + rect.height);
    };
    BoundingRect.prototype.clone = function () {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function (other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function () {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function () {
        return isFinite(this.x)
            && isFinite(this.y)
            && isFinite(this.width)
            && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function () {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function (rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function (target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function (target, source, m) {
        if (!m) {
            if (target !== source) {
                BoundingRect.copy(target, source);
            }
            return;
        }
        if (m[1] < 1e-5 && m[1] > -1e-5 && m[2] < 1e-5 && m[2] > -1e-5) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        lt.x = lb.x = source.x;
        lt.y = rt.y = source.y;
        rb.x = rt.x = source.x + source.width;
        rb.y = lb.y = source.y + source.height;
        lt.transform(m);
        rt.transform(m);
        rb.transform(m);
        lb.transform(m);
        target.x = mathMin(lt.x, rb.x, lb.x, rt.x);
        target.y = mathMin(lt.y, rb.y, lb.y, rt.y);
        var maxX = mathMax(lt.x, rb.x, lb.x, rt.x);
        var maxY = mathMax(lt.y, rb.y, lb.y, rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}());

var SILENT = 'silent';
function makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: stopEvent
    };
}
function stopEvent() {
    stop(this.event);
}
var EmptyProxy = (function (_super) {
    __extends$1(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function () { };
    EmptyProxy.prototype.setCursor = function () { };
    return EmptyProxy;
}(Eventful));
var HoveredResult = (function () {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}());
var handlerNames = [
    'click', 'dblclick', 'mousewheel', 'mouseout',
    'mouseup', 'mousedown', 'mousemove', 'contextmenu'
];
var tmpRect = new BoundingRect(0, 0, 0, 0);
var Handler = (function (_super) {
    __extends$1(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new Draggable(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function (proxy) {
        if (this.proxy) {
            this.proxy.dispose();
        }
        if (proxy) {
            each(handlerNames, function (name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function (event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
            this.dispatchToElement(lastHovered, 'mouseout', event);
        }
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
            this.dispatchToElement(hovered, 'mouseover', event);
        }
    };
    Handler.prototype.mouseout = function (event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') {
            this.dispatchToElement(this._hovered, 'mouseout', event);
        }
        if (eventControl !== 'no_globalout') {
            this.trigger('globalout', { type: 'globalout', event: event });
        }
    };
    Handler.prototype.resize = function () {
        this._hovered = new HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function (eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function () {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function (cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function (targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) {
            return;
        }
        var eventKey = ('on' + eventName);
        var eventPacket = makeEventPacket(eventName, targetInfo, event);
        while (el) {
            el[eventKey]
                && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) {
                break;
            }
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) {
                this.painter.eachOtherLayer(function (layer) {
                    if (typeof (layer[eventKey]) === 'function') {
                        layer[eventKey].call(layer, eventPacket);
                    }
                    if (layer.trigger) {
                        layer.trigger(eventName, eventPacket);
                    }
                });
            }
        }
    };
    Handler.prototype.findHover = function (x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new HoveredResult(x, y);
        setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new BoundingRect(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for (var i = list.length - 1; i >= 0; i--) {
                var el = list[i];
                if (el !== exclude
                    && !el.ignore
                    && !el.ignoreCoarsePointer
                    && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    tmpRect.copy(el.getBoundingRect());
                    if (el.transform) {
                        tmpRect.applyTransform(el.transform);
                    }
                    if (tmpRect.intersect(pointerRect)) {
                        candidates.push(el);
                    }
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for (var r = 0; r < targetSizeHalf; r += rStep) {
                    for (var theta = 0; theta < PI2; theta += thetaStep) {
                        var x1 = x + r * Math.cos(theta);
                        var y1 = y + r * Math.sin(theta);
                        setHoverTarget(candidates, out, x1, y1, exclude);
                        if (out.target) {
                            return out;
                        }
                    }
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function (event, stage) {
        if (!this._gestureMgr) {
            this._gestureMgr = new GestureMgr();
        }
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}(Eventful));
each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
    Handler.prototype[name] = function (event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [event.zrX, event.zrY];
            this._upEl = hoveredTarget;
        }
        else if (name === 'mouseup') {
            this._upEl = hoveredTarget;
        }
        else if (name === 'click') {
            if (this._downEl !== this._upEl
                || !this._downPoint
                || dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
                return;
            }
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while (el) {
            if (el.ignoreClip) {
                ignoreClip = true;
            }
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) {
                    return false;
                }
                if (el.silent) {
                    isSilent = true;
                }
            }
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? SILENT : true;
    }
    return false;
}
function setHoverTarget(list, out, x, y, exclude) {
    for (var i = list.length - 1; i >= 0; i--) {
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude
            && !el.ignore
            && (hoverCheckResult = isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}

var DEFAULT_MIN_MERGE = 32;
var DEFAULT_MIN_GALLOPING = 7;
function minRunLength(n) {
    var r = 0;
    while (n >= DEFAULT_MIN_MERGE) {
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) {
        return 1;
    }
    if (compare(array[runHi++], array[lo]) < 0) {
        while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
            runHi++;
        }
        reverseRun(array, lo, runHi);
    }
    else {
        while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
            runHi++;
        }
    }
    return runHi - lo;
}
function reverseRun(array, lo, hi) {
    hi--;
    while (lo < hi) {
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) {
        start++;
    }
    for (; start < hi; start++) {
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while (left < right) {
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) {
                right = mid;
            }
            else {
                left = mid + 1;
            }
        }
        var n = start - left;
        switch (n) {
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while (n > 0) {
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        lastOffset += hint;
        offset += hint;
    }
    else {
        maxOffset = hint + 1;
        while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while (lastOffset < offset) {
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) {
            lastOffset = m + 1;
        }
        else {
            offset = m;
        }
    }
    return offset;
}
function gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    else {
        maxOffset = length - hint;
        while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) {
                offset = maxOffset;
            }
        }
        if (offset > maxOffset) {
            offset = maxOffset;
        }
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while (lastOffset < offset) {
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) {
            offset = m;
        }
        else {
            lastOffset = m + 1;
        }
    }
    return offset;
}
function TimSort(array, compare) {
    var minGallop = DEFAULT_MIN_GALLOPING;
    var length = 0;
    var runStart;
    var runLength;
    var stackSize = 0;
    length = array.length;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while (stackSize > 1) {
            var n = stackSize - 2;
            if ((n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1])
                || (n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1])) {
                if (runLength[n - 1] < runLength[n + 1]) {
                    n--;
                }
            }
            else if (runLength[n] > runLength[n + 1]) {
                break;
            }
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while (stackSize > 1) {
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
                n--;
            }
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) {
            return;
        }
        length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) {
            return;
        }
        if (length1 <= length2) {
            mergeLow(start1, length1, start2, length2);
        }
        else {
            mergeHigh(start1, length1, start2, length2);
        }
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for (i = 0; i < length1; i++) {
            tmp[i] = array[start1 + i];
        }
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for (i = 0; i < length1; i++) {
                array[dest + i] = tmp[cursor1 + i];
            }
            return;
        }
        if (length1 === 1) {
            for (i = 0; i < length2; i++) {
                array[dest + i] = array[cursor2 + i];
            }
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while (1) {
            count1 = 0;
            count2 = 0;
            exit = false;
            do {
                if (compare(array[cursor2], tmp[cursor1]) < 0) {
                    array[dest++] = array[cursor2++];
                    count2++;
                    count1 = 0;
                    if (--length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                else {
                    array[dest++] = tmp[cursor1++];
                    count1++;
                    count2 = 0;
                    if (--length1 === 1) {
                        exit = true;
                        break;
                    }
                }
            } while ((count1 | count2) < _minGallop);
            if (exit) {
                break;
            }
            do {
                count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for (i = 0; i < count1; i++) {
                        array[dest + i] = tmp[cursor1 + i];
                    }
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for (i = 0; i < count2; i++) {
                        array[dest + i] = array[cursor2 + i];
                    }
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
            if (exit) {
                break;
            }
            if (_minGallop < 0) {
                _minGallop = 0;
            }
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for (i = 0; i < length2; i++) {
                array[dest + i] = array[cursor2 + i];
            }
            array[dest + length2] = tmp[cursor1];
        }
        else if (length1 === 0) {
            throw new Error();
        }
        else {
            for (i = 0; i < length1; i++) {
                array[dest + i] = tmp[cursor1 + i];
            }
        }
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for (i = 0; i < length2; i++) {
            tmp[i] = array[start2 + i];
        }
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for (i = 0; i < length2; i++) {
                array[customCursor + i] = tmp[i];
            }
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for (i = length1 - 1; i >= 0; i--) {
                array[customDest + i] = array[customCursor + i];
            }
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while (true) {
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do {
                if (compare(tmp[cursor2], array[cursor1]) < 0) {
                    array[dest--] = array[cursor1--];
                    count1++;
                    count2 = 0;
                    if (--length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                else {
                    array[dest--] = tmp[cursor2--];
                    count2++;
                    count1 = 0;
                    if (--length2 === 1) {
                        exit = true;
                        break;
                    }
                }
            } while ((count1 | count2) < _minGallop);
            if (exit) {
                break;
            }
            do {
                count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for (i = count1 - 1; i >= 0; i--) {
                        array[customDest + i] = array[customCursor + i];
                    }
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for (i = 0; i < count2; i++) {
                        array[customDest + i] = tmp[customCursor + i];
                    }
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
            if (exit) {
                break;
            }
            if (_minGallop < 0) {
                _minGallop = 0;
            }
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) {
            minGallop = 1;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for (i = length1 - 1; i >= 0; i--) {
                array[customDest + i] = array[customCursor + i];
            }
            array[dest] = tmp[cursor2];
        }
        else if (length2 === 0) {
            throw new Error();
        }
        else {
            customCursor = dest - (length2 - 1);
            for (i = 0; i < length2; i++) {
                array[customCursor + i] = tmp[i];
            }
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function sort(array, compare, lo, hi) {
    if (!lo) {
        lo = 0;
    }
    if (!hi) {
        hi = array.length;
    }
    var remaining = hi - lo;
    if (remaining < 2) {
        return;
    }
    var runLength = 0;
    if (remaining < DEFAULT_MIN_MERGE) {
        runLength = makeAscendingRun(array, lo, hi, compare);
        binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = TimSort(array, compare);
    var minRun = minRunLength(remaining);
    do {
        runLength = makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) {
                force = minRun;
            }
            binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    } while (remaining !== 0);
    ts.forceMergeRuns();
}

var REDRAW_BIT = 1;
var STYLE_CHANGED_BIT = 2;
var SHAPE_CHANGED_BIT = 4;

var invalidZErrorLogged = false;
function logInvalidZError() {
    if (invalidZErrorLogged) {
        return;
    }
    invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) {
            return a.z2 - b.z2;
        }
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var Storage = (function () {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = shapeCompareFunc;
    }
    Storage.prototype.traverse = function (cb, context) {
        for (var i = 0; i < this._roots.length; i++) {
            this._roots[i].traverse(cb, context);
        }
    };
    Storage.prototype.getDisplayList = function (update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) {
            this.updateDisplayList(includeIgnore);
        }
        return displayList;
    };
    Storage.prototype.updateDisplayList = function (includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for (var i = 0, len = roots.length; i < len; i++) {
            this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        }
        displayList.length = this._displayListLen;
        sort(displayList, shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function (el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) {
            return;
        }
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) {
            clipPaths = null;
        }
        else if (userSetClipPath) {
            if (clipPaths) {
                clipPaths = clipPaths.slice();
            }
            else {
                clipPaths = [];
            }
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while (currentClipPath) {
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                if (el.__dirty) {
                    child.__dirty |= REDRAW_BIT;
                }
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        }
        else {
            var disp = el;
            if (clipPaths && clipPaths.length) {
                disp.__clipPaths = clipPaths;
            }
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) {
                disp.__clipPaths = [];
            }
            if (isNaN(disp.z)) {
                logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) {
            this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        }
        var textGuide = el.getTextGuideLine();
        if (textGuide) {
            this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        }
        var textEl = el.getTextContent();
        if (textEl) {
            this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
        }
    };
    Storage.prototype.addRoot = function (el) {
        if (el.__zr && el.__zr.storage === this) {
            return;
        }
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function (el) {
        if (el instanceof Array) {
            for (var i = 0, l = el.length; i < l; i++) {
                this.delRoot(el[i]);
            }
            return;
        }
        var idx = indexOf(this._roots, el);
        if (idx >= 0) {
            this._roots.splice(idx, 1);
        }
    };
    Storage.prototype.delAllRoots = function () {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function () {
        return this._roots;
    };
    Storage.prototype.dispose = function () {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}());

var requestAnimationFrame$1;
requestAnimationFrame$1 = (env.hasGlobalWindow
    && ((window.requestAnimationFrame && window.requestAnimationFrame.bind(window))
        || (window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window))
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame)) || function (func) {
    return setTimeout(func, 16);
};
var requestAnimationFrame$2 = requestAnimationFrame$1;

var easingFuncs = {
    linear: function (k) {
        return k;
    },
    quadraticIn: function (k) {
        return k * k;
    },
    quadraticOut: function (k) {
        return k * (2 - k);
    },
    quadraticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k;
        }
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function (k) {
        return k * k * k;
    },
    cubicOut: function (k) {
        return --k * k * k + 1;
    },
    cubicInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k;
        }
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function (k) {
        return k * k * k * k;
    },
    quarticOut: function (k) {
        return 1 - (--k * k * k * k);
    },
    quarticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k * k;
        }
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function (k) {
        return k * k * k * k * k;
    },
    quinticOut: function (k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function (k) {
        if ((k *= 2) < 1) {
            return 0.5 * k * k * k * k * k;
        }
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function (k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function (k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function (k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function (k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function (k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function (k) {
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if ((k *= 2) < 1) {
            return 0.5 * Math.pow(1024, k - 1);
        }
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function (k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function (k) {
        return Math.sqrt(1 - (--k * k));
    },
    circularInOut: function (k) {
        if ((k *= 2) < 1) {
            return -0.5 * (Math.sqrt(1 - k * k) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        return -(a * Math.pow(2, 10 * (k -= 1))
            * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        return (a * Math.pow(2, -10 * k)
            * Math.sin((k - s) * (2 * Math.PI) / p) + 1);
    },
    elasticInOut: function (k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) {
            return 0;
        }
        if (k === 1) {
            return 1;
        }
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        }
        else {
            s = p * Math.asin(1 / a) / (2 * Math.PI);
        }
        if ((k *= 2) < 1) {
            return -0.5 * (a * Math.pow(2, 10 * (k -= 1))
                * Math.sin((k - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (k -= 1))
            * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function (k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function (k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function (k) {
        var s = 1.70158 * 1.525;
        if ((k *= 2) < 1) {
            return 0.5 * (k * k * ((s + 1) * k - s));
        }
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function (k) {
        return 1 - easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function (k) {
        if (k < (1 / 2.75)) {
            return 7.5625 * k * k;
        }
        else if (k < (2 / 2.75)) {
            return 7.5625 * (k -= (1.5 / 2.75)) * k + 0.75;
        }
        else if (k < (2.5 / 2.75)) {
            return 7.5625 * (k -= (2.25 / 2.75)) * k + 0.9375;
        }
        else {
            return 7.5625 * (k -= (2.625 / 2.75)) * k + 0.984375;
        }
    },
    bounceInOut: function (k) {
        if (k < 0.5) {
            return easingFuncs.bounceIn(k * 2) * 0.5;
        }
        return easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};

var mathPow = Math.pow;
var mathSqrt = Math.sqrt;
var EPSILON = 1e-8;
var EPSILON_NUMERIC = 1e-4;
var THREE_SQRT = mathSqrt(3);
var ONE_THIRD = 1 / 3;
var _v0 = create();
var _v1 = create();
var _v2 = create();
function isAroundZero(val) {
    return val > -EPSILON && val < EPSILON;
}
function isNotAroundZero(val) {
    return val > EPSILON || val < -EPSILON;
}
function cubicAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1)
        + t * t * (t * p3 + 3 * onet * p2);
}
function cubicDerivativeAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet
        + (p3 - p2) * t * t);
}
function cubicRootAt(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if (isAroundZero(A) && isAroundZero(B)) {
        if (isAroundZero(b)) {
            roots[0] = 0;
        }
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
    }
    else {
        var disc = B * B - 4 * A * C;
        if (isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) {
                Y1 = -mathPow(-Y1, ONE_THIRD);
            }
            else {
                Y1 = mathPow(Y1, ONE_THIRD);
            }
            if (Y2 < 0) {
                Y2 = -mathPow(-Y2, ONE_THIRD);
            }
            else {
                Y2 = mathPow(Y2, ONE_THIRD);
            }
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
        else {
            var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
            if (t3 >= 0 && t3 <= 1) {
                roots[n++] = t3;
            }
        }
    }
    return n;
}
function cubicExtrema(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if (isAroundZero(a)) {
        if (isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                extrema[n++] = t1;
            }
        }
    }
    else {
        var disc = b * b - 4 * a * c;
        if (isAroundZero(disc)) {
            extrema[0] = -b / (2 * a);
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                extrema[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                extrema[n++] = t2;
            }
        }
    }
    return n;
}
function cubicSubdivide(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    _v0[0] = x;
    _v0[1] = y;
    for (var _t = 0; _t < 1; _t += 0.05) {
        _v1[0] = cubicAt(x0, x1, x2, x3, _t);
        _v1[1] = cubicAt(y0, y1, y2, y3, _t);
        d1 = distSquare(_v0, _v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for (var i = 0; i < 32; i++) {
        if (interval < EPSILON_NUMERIC) {
            break;
        }
        prev = t - interval;
        next = t + interval;
        _v1[0] = cubicAt(x0, x1, x2, x3, prev);
        _v1[1] = cubicAt(y0, y1, y2, y3, prev);
        d1 = distSquare(_v1, _v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        }
        else {
            _v2[0] = cubicAt(x0, x1, x2, x3, next);
            _v2[1] = cubicAt(y0, y1, y2, y3, next);
            d2 = distSquare(_v2, _v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            }
            else {
                interval *= 0.5;
            }
        }
    }
    if (out) {
        out[0] = cubicAt(x0, x1, x2, x3, t);
        out[1] = cubicAt(y0, y1, y2, y3, t);
    }
    return mathSqrt(d);
}
function cubicLength(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for (var i = 1; i <= iteration; i++) {
        var t = i * step;
        var x = cubicAt(x0, x1, x2, x3, t);
        var y = cubicAt(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function quadraticAt(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function quadraticDerivativeAt(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function quadraticRootAt(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if (isAroundZero(a)) {
        if (isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
    }
    else {
        var disc = b * b - 4 * a * c;
        if (isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
        }
        else if (disc > 0) {
            var discSqrt = mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) {
                roots[n++] = t1;
            }
            if (t2 >= 0 && t2 <= 1) {
                roots[n++] = t2;
            }
        }
    }
    return n;
}
function quadraticExtremum(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) {
        return 0.5;
    }
    else {
        return (p0 - p1) / divider;
    }
}
function quadraticSubdivide(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    _v0[0] = x;
    _v0[1] = y;
    for (var _t = 0; _t < 1; _t += 0.05) {
        _v1[0] = quadraticAt(x0, x1, x2, _t);
        _v1[1] = quadraticAt(y0, y1, y2, _t);
        var d1 = distSquare(_v0, _v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for (var i = 0; i < 32; i++) {
        if (interval < EPSILON_NUMERIC) {
            break;
        }
        var prev = t - interval;
        var next = t + interval;
        _v1[0] = quadraticAt(x0, x1, x2, prev);
        _v1[1] = quadraticAt(y0, y1, y2, prev);
        var d1 = distSquare(_v1, _v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        }
        else {
            _v2[0] = quadraticAt(x0, x1, x2, next);
            _v2[1] = quadraticAt(y0, y1, y2, next);
            var d2 = distSquare(_v2, _v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            }
            else {
                interval *= 0.5;
            }
        }
    }
    if (out) {
        out[0] = quadraticAt(x0, x1, x2, t);
        out[1] = quadraticAt(y0, y1, y2, t);
    }
    return mathSqrt(d);
}
function quadraticLength(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for (var i = 1; i <= iteration; i++) {
        var t = i * step;
        var x = quadraticAt(x0, x1, x2, t);
        var y = quadraticAt(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}

var regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function createCubicEasingFunc(cubicEasingStr) {
    var cubic = cubicEasingStr && regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +trim(points[0]);
        var b_1 = +trim(points[1]);
        var c_1 = +trim(points[2]);
        var d_1 = +trim(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) {
            return;
        }
        var roots_1 = [];
        return function (p) {
            return p <= 0
                ? 0 : p >= 1
                ? 1
                : cubicRootAt(0, a_1, c_1, 1, p, roots_1) && cubicAt(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}

var Clip = (function () {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || noop$2;
        this.ondestroy = opts.ondestroy || noop$2;
        this.onrestart = opts.onrestart || noop$2;
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function (globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) {
            percent = 0;
        }
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            }
            else {
                return true;
            }
        }
        return false;
    };
    Clip.prototype.pause = function () {
        this._paused = true;
    };
    Clip.prototype.resume = function () {
        this._paused = false;
    };
    Clip.prototype.setEasing = function (easing) {
        this.easing = easing;
        this.easingFunc = isFunction$3(easing)
            ? easing
            : easingFuncs[easing] || createCubicEasingFunc(easing);
    };
    return Clip;
}());

var Entry = (function () {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}());
var LinkedList = (function () {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function (val) {
        var entry = new Entry(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function (entry) {
        if (!this.head) {
            this.head = this.tail = entry;
        }
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function (entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) {
            prev.next = next;
        }
        else {
            this.head = next;
        }
        if (next) {
            next.prev = prev;
        }
        else {
            this.tail = prev;
        }
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function () {
        return this._len;
    };
    LinkedList.prototype.clear = function () {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}());
var LRU = (function () {
    function LRU(maxSize) {
        this._list = new LinkedList();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function (key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) {
                entry.value = value;
            }
            else {
                entry = new Entry(value);
            }
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function (key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function () {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function () {
        return this._list.len();
    };
    return LRU;
}());

var kCSSColorTable = {
    'transparent': [0, 0, 0, 0], 'aliceblue': [240, 248, 255, 1],
    'antiquewhite': [250, 235, 215, 1], 'aqua': [0, 255, 255, 1],
    'aquamarine': [127, 255, 212, 1], 'azure': [240, 255, 255, 1],
    'beige': [245, 245, 220, 1], 'bisque': [255, 228, 196, 1],
    'black': [0, 0, 0, 1], 'blanchedalmond': [255, 235, 205, 1],
    'blue': [0, 0, 255, 1], 'blueviolet': [138, 43, 226, 1],
    'brown': [165, 42, 42, 1], 'burlywood': [222, 184, 135, 1],
    'cadetblue': [95, 158, 160, 1], 'chartreuse': [127, 255, 0, 1],
    'chocolate': [210, 105, 30, 1], 'coral': [255, 127, 80, 1],
    'cornflowerblue': [100, 149, 237, 1], 'cornsilk': [255, 248, 220, 1],
    'crimson': [220, 20, 60, 1], 'cyan': [0, 255, 255, 1],
    'darkblue': [0, 0, 139, 1], 'darkcyan': [0, 139, 139, 1],
    'darkgoldenrod': [184, 134, 11, 1], 'darkgray': [169, 169, 169, 1],
    'darkgreen': [0, 100, 0, 1], 'darkgrey': [169, 169, 169, 1],
    'darkkhaki': [189, 183, 107, 1], 'darkmagenta': [139, 0, 139, 1],
    'darkolivegreen': [85, 107, 47, 1], 'darkorange': [255, 140, 0, 1],
    'darkorchid': [153, 50, 204, 1], 'darkred': [139, 0, 0, 1],
    'darksalmon': [233, 150, 122, 1], 'darkseagreen': [143, 188, 143, 1],
    'darkslateblue': [72, 61, 139, 1], 'darkslategray': [47, 79, 79, 1],
    'darkslategrey': [47, 79, 79, 1], 'darkturquoise': [0, 206, 209, 1],
    'darkviolet': [148, 0, 211, 1], 'deeppink': [255, 20, 147, 1],
    'deepskyblue': [0, 191, 255, 1], 'dimgray': [105, 105, 105, 1],
    'dimgrey': [105, 105, 105, 1], 'dodgerblue': [30, 144, 255, 1],
    'firebrick': [178, 34, 34, 1], 'floralwhite': [255, 250, 240, 1],
    'forestgreen': [34, 139, 34, 1], 'fuchsia': [255, 0, 255, 1],
    'gainsboro': [220, 220, 220, 1], 'ghostwhite': [248, 248, 255, 1],
    'gold': [255, 215, 0, 1], 'goldenrod': [218, 165, 32, 1],
    'gray': [128, 128, 128, 1], 'green': [0, 128, 0, 1],
    'greenyellow': [173, 255, 47, 1], 'grey': [128, 128, 128, 1],
    'honeydew': [240, 255, 240, 1], 'hotpink': [255, 105, 180, 1],
    'indianred': [205, 92, 92, 1], 'indigo': [75, 0, 130, 1],
    'ivory': [255, 255, 240, 1], 'khaki': [240, 230, 140, 1],
    'lavender': [230, 230, 250, 1], 'lavenderblush': [255, 240, 245, 1],
    'lawngreen': [124, 252, 0, 1], 'lemonchiffon': [255, 250, 205, 1],
    'lightblue': [173, 216, 230, 1], 'lightcoral': [240, 128, 128, 1],
    'lightcyan': [224, 255, 255, 1], 'lightgoldenrodyellow': [250, 250, 210, 1],
    'lightgray': [211, 211, 211, 1], 'lightgreen': [144, 238, 144, 1],
    'lightgrey': [211, 211, 211, 1], 'lightpink': [255, 182, 193, 1],
    'lightsalmon': [255, 160, 122, 1], 'lightseagreen': [32, 178, 170, 1],
    'lightskyblue': [135, 206, 250, 1], 'lightslategray': [119, 136, 153, 1],
    'lightslategrey': [119, 136, 153, 1], 'lightsteelblue': [176, 196, 222, 1],
    'lightyellow': [255, 255, 224, 1], 'lime': [0, 255, 0, 1],
    'limegreen': [50, 205, 50, 1], 'linen': [250, 240, 230, 1],
    'magenta': [255, 0, 255, 1], 'maroon': [128, 0, 0, 1],
    'mediumaquamarine': [102, 205, 170, 1], 'mediumblue': [0, 0, 205, 1],
    'mediumorchid': [186, 85, 211, 1], 'mediumpurple': [147, 112, 219, 1],
    'mediumseagreen': [60, 179, 113, 1], 'mediumslateblue': [123, 104, 238, 1],
    'mediumspringgreen': [0, 250, 154, 1], 'mediumturquoise': [72, 209, 204, 1],
    'mediumvioletred': [199, 21, 133, 1], 'midnightblue': [25, 25, 112, 1],
    'mintcream': [245, 255, 250, 1], 'mistyrose': [255, 228, 225, 1],
    'moccasin': [255, 228, 181, 1], 'navajowhite': [255, 222, 173, 1],
    'navy': [0, 0, 128, 1], 'oldlace': [253, 245, 230, 1],
    'olive': [128, 128, 0, 1], 'olivedrab': [107, 142, 35, 1],
    'orange': [255, 165, 0, 1], 'orangered': [255, 69, 0, 1],
    'orchid': [218, 112, 214, 1], 'palegoldenrod': [238, 232, 170, 1],
    'palegreen': [152, 251, 152, 1], 'paleturquoise': [175, 238, 238, 1],
    'palevioletred': [219, 112, 147, 1], 'papayawhip': [255, 239, 213, 1],
    'peachpuff': [255, 218, 185, 1], 'peru': [205, 133, 63, 1],
    'pink': [255, 192, 203, 1], 'plum': [221, 160, 221, 1],
    'powderblue': [176, 224, 230, 1], 'purple': [128, 0, 128, 1],
    'red': [255, 0, 0, 1], 'rosybrown': [188, 143, 143, 1],
    'royalblue': [65, 105, 225, 1], 'saddlebrown': [139, 69, 19, 1],
    'salmon': [250, 128, 114, 1], 'sandybrown': [244, 164, 96, 1],
    'seagreen': [46, 139, 87, 1], 'seashell': [255, 245, 238, 1],
    'sienna': [160, 82, 45, 1], 'silver': [192, 192, 192, 1],
    'skyblue': [135, 206, 235, 1], 'slateblue': [106, 90, 205, 1],
    'slategray': [112, 128, 144, 1], 'slategrey': [112, 128, 144, 1],
    'snow': [255, 250, 250, 1], 'springgreen': [0, 255, 127, 1],
    'steelblue': [70, 130, 180, 1], 'tan': [210, 180, 140, 1],
    'teal': [0, 128, 128, 1], 'thistle': [216, 191, 216, 1],
    'tomato': [255, 99, 71, 1], 'turquoise': [64, 224, 208, 1],
    'violet': [238, 130, 238, 1], 'wheat': [245, 222, 179, 1],
    'white': [255, 255, 255, 1], 'whitesmoke': [245, 245, 245, 1],
    'yellow': [255, 255, 0, 1], 'yellowgreen': [154, 205, 50, 1]
};
function clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') {
        return clampCssByte(parseFloat(str) / 100 * 255);
    }
    return clampCssByte(parseInt(str, 10));
}
function parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') {
        return clampCssFloat(parseFloat(str) / 100);
    }
    return clampCssFloat(parseFloat(str));
}
function cssHueToRgb(m1, m2, h) {
    if (h < 0) {
        h += 1;
    }
    else if (h > 1) {
        h -= 1;
    }
    if (h * 6 < 1) {
        return m1 + (m2 - m1) * h * 6;
    }
    if (h * 2 < 1) {
        return m2;
    }
    if (h * 3 < 2) {
        return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    }
    return m1;
}
function lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var colorCache = new LRU(20);
var lastRemovedArr = null;
function putToCache(colorStr, rgbaArr) {
    if (lastRemovedArr) {
        copyRgba(lastRemovedArr, rgbaArr);
    }
    lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || (rgbaArr.slice()));
}
function parse(colorStr, rgbaArr) {
    if (!colorStr) {
        return;
    }
    rgbaArr = rgbaArr || [];
    var cached = colorCache.get(colorStr);
    if (cached) {
        return copyRgba(rgbaArr, cached);
    }
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in kCSSColorTable) {
        copyRgba(rgbaArr, kCSSColorTable[str]);
        putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            setRgba(rgbaArr, ((iv & 0xf00) >> 4) | ((iv & 0xf00) >> 8), (iv & 0xf0) | ((iv & 0xf0) >> 4), (iv & 0xf) | ((iv & 0xf) << 4), strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch (fname) {
            case 'rgba':
                if (params.length !== 4) {
                    return params.length === 3
                        ? setRgba(rgbaArr, +params[0], +params[1], +params[2], 1)
                        : setRgba(rgbaArr, 0, 0, 0, 1);
                }
                alpha = parseCssFloat(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), params.length === 3 ? alpha : parseCssFloat(params[3]));
                    putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                }
                else {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = parseCssFloat(params[3]);
                hsla2rgba(params, rgbaArr);
                putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                hsla2rgba(params, rgbaArr);
                putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function hsla2rgba(hsla, rgba) {
    var h = (((parseFloat(hsla[0]) % 360) + 360) % 360) / 360;
    var s = parseCssFloat(hsla[1]);
    var l = parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) {
        rgba[3] = hsla[3];
    }
    return rgba;
}
function rgba2hsla(rgba) {
    if (!rgba) {
        return;
    }
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    }
    else {
        if (L < 0.5) {
            S = delta / (vMax + vMin);
        }
        else {
            S = delta / (2 - vMax - vMin);
        }
        var deltaR = (((vMax - R) / 6) + (delta / 2)) / delta;
        var deltaG = (((vMax - G) / 6) + (delta / 2)) / delta;
        var deltaB = (((vMax - B) / 6) + (delta / 2)) / delta;
        if (R === vMax) {
            H = deltaB - deltaG;
        }
        else if (G === vMax) {
            H = (1 / 3) + deltaR - deltaB;
        }
        else if (B === vMax) {
            H = (2 / 3) + deltaG - deltaR;
        }
        if (H < 0) {
            H += 1;
        }
        if (H > 1) {
            H -= 1;
        }
    }
    var hsla = [H * 360, S, L];
    if (rgba[3] != null) {
        hsla.push(rgba[3]);
    }
    return hsla;
}
function lift(color, level) {
    var colorArr = parse(color);
    if (colorArr) {
        for (var i = 0; i < 3; i++) {
            if (level < 0) {
                colorArr[i] = colorArr[i] * (1 - level) | 0;
            }
            else {
                colorArr[i] = ((255 - colorArr[i]) * level + colorArr[i]) | 0;
            }
            if (colorArr[i] > 255) {
                colorArr[i] = 255;
            }
            else if (colorArr[i] < 0) {
                colorArr[i] = 0;
            }
        }
        return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function toHex(color) {
    var colorArr = parse(color);
    if (colorArr) {
        return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + (+colorArr[2])).toString(16).slice(1);
    }
}
function fastLerp(normalizedValue, colors, out) {
    if (!(colors && colors.length)
        || !(normalizedValue >= 0 && normalizedValue <= 1)) {
        return;
    }
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var fastMapToColor = fastLerp;
function lerp$1(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length)
        || !(normalizedValue >= 0 && normalizedValue <= 1)) {
        return;
    }
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = parse(colors[leftIndex]);
    var rightColor = parse(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = stringify([
        clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)),
        clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)),
        clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)),
        clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput
        ? {
            color: color,
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            value: value
        }
        : color;
}
var mapToColor = lerp$1;
function modifyHSL(color, h, s, l) {
    var colorArr = parse(color);
    if (color) {
        colorArr = rgba2hsla(colorArr);
        h != null && (colorArr[0] = clampCssAngle(h));
        s != null && (colorArr[1] = parseCssFloat(s));
        l != null && (colorArr[2] = parseCssFloat(l));
        return stringify(hsla2rgba(colorArr), 'rgba');
    }
}
function modifyAlpha(color, alpha) {
    var colorArr = parse(color);
    if (colorArr && alpha != null) {
        colorArr[3] = clampCssFloat(alpha);
        return stringify(colorArr, 'rgba');
    }
}
function stringify(arrColor, type) {
    if (!arrColor || !arrColor.length) {
        return;
    }
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
        colorStr += ',' + arrColor[3];
    }
    return type + '(' + colorStr + ')';
}
function lum(color, backgroundLum) {
    var arr = parse(color);
    return arr
        ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255
            + (1 - arr[3]) * backgroundLum
        : 0;
}
function random() {
    return stringify([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}

var color = /*#__PURE__*/Object.freeze({
	__proto__: null,
	parse: parse,
	lift: lift,
	toHex: toHex,
	fastLerp: fastLerp,
	fastMapToColor: fastMapToColor,
	lerp: lerp$1,
	mapToColor: mapToColor,
	modifyHSL: modifyHSL,
	modifyAlpha: modifyAlpha,
	stringify: stringify,
	lum: lum,
	random: random
});

var mathRound = Math.round;
function normalizeColor(color) {
    var opacity;
    if (!color || color === 'transparent') {
        color = 'none';
    }
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = parse(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var EPSILON$1 = 1e-4;
function isAroundZero$1(transform) {
    return transform < EPSILON$1 && transform > -EPSILON$1;
}
function round3(transform) {
    return mathRound(transform * 1e3) / 1e3;
}
function round4(transform) {
    return mathRound(transform * 1e4) / 1e4;
}
function getMatrixStr(m) {
    return 'matrix('
        + round3(m[0]) + ','
        + round3(m[1]) + ','
        + round3(m[2]) + ','
        + round3(m[3]) + ','
        + round4(m[4]) + ','
        + round4(m[5])
        + ')';
}
var TEXT_ALIGN_TO_ANCHOR = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function adjustTextY(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') {
        y += lineHeight / 2;
    }
    else if (textBaseline === 'bottom') {
        y -= lineHeight / 2;
    }
    return y;
}
function hasShadow(style) {
    return style
        && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function getShadowKey(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function isImagePattern(val) {
    return val && (!!val.image);
}
function isSVGPattern(val) {
    return val && (!!val.svgElement);
}
function isPattern(val) {
    return isImagePattern(val) || isSVGPattern(val);
}
function isLinearGradient(val) {
    return val.type === 'linear';
}
function isRadialGradient(val) {
    return val.type === 'radial';
}
function isGradient(val) {
    return val && (val.type === 'linear'
        || val.type === 'radial');
}
function getIdURL(id) {
    return "url(#" + id + ")";
}
function getPathPrecision(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function getSRTTransformString(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * RADIAN_TO_DEGREE;
    var scaleX = retrieve2(transform.scaleX, 1);
    var scaleY = retrieve2(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) {
        res.push("translate(" + x + "px," + y + "px)");
    }
    if (rotation) {
        res.push("rotate(" + rotation + ")");
    }
    if (scaleX !== 1 || scaleY !== 1) {
        res.push("scale(" + scaleX + "," + scaleY + ")");
    }
    if (skewX || skewY) {
        res.push("skew(" + mathRound(skewX * RADIAN_TO_DEGREE) + "deg, " + mathRound(skewY * RADIAN_TO_DEGREE) + "deg)");
    }
    return res.join(' ');
}
var encodeBase64 = (function () {
    if (env.hasGlobalWindow && isFunction$3(window.btoa)) {
        return function (str) {
            return window.btoa(unescape(encodeURIComponent(str)));
        };
    }
    if (typeof Buffer !== 'undefined') {
        return function (str) {
            return Buffer.from(str).toString('base64');
        };
    }
    return function (str) {
        if (process.env.NODE_ENV !== 'production') {
            logError('Base64 isn\'t natively supported in the current environment.');
        }
        return null;
    };
})();

var arraySlice = Array.prototype.slice;
function interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for (var i = 0; i < len; i++) {
        out[i] = interpolateNumber(p0[i], p1[i], percent);
    }
    return out;
}
function interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for (var i = 0; i < len; i++) {
        if (!out[i]) {
            out[i] = [];
        }
        for (var j = 0; j < len2; j++) {
            out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
        }
    }
    return out;
}
function add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for (var i = 0; i < len; i++) {
        out[i] = p0[i] + p1[i] * sign;
    }
    return out;
}
function add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for (var i = 0; i < len; i++) {
        if (!out[i]) {
            out[i] = [];
        }
        for (var j = 0; j < len2; j++) {
            out[i][j] = p0[i][j] + p1[i][j] * sign;
        }
    }
    return out;
}
function fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || { color: [0, 0, 0, 0], offset: 0 };
    for (var i = shorterLen; i < Math.max(len0, len1); i++) {
        shorterArr.push({
            offset: last.offset,
            color: last.color.slice()
        });
    }
}
function fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) {
        return;
    }
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) {
            arr0.length = arr1Len;
        }
        else {
            for (var i = arr0Len; i < arr1Len; i++) {
                arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
            }
        }
    }
    var len2 = arr0[0] && arr0[0].length;
    for (var i = 0; i < arr0.length; i++) {
        if (arrDim === 1) {
            if (isNaN(arr0[i])) {
                arr0[i] = arr1[i];
            }
        }
        else {
            for (var j = 0; j < len2; j++) {
                if (isNaN(arr0[i][j])) {
                    arr0[i][j] = arr1[i][j];
                }
            }
        }
    }
}
function cloneValue(value) {
    if (isArrayLike$1(value)) {
        var len = value.length;
        if (isArrayLike$1(value[0])) {
            var ret = [];
            for (var i = 0; i < len; i++) {
                ret.push(arraySlice.call(value[i]));
            }
            return ret;
        }
        return arraySlice.call(value);
    }
    return value;
}
function rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function guessArrayDim(value) {
    return isArrayLike$1(value && value[0]) ? 2 : 1;
}
var VALUE_TYPE_NUMBER = 0;
var VALUE_TYPE_1D_ARRAY = 1;
var VALUE_TYPE_2D_ARRAY = 2;
var VALUE_TYPE_COLOR = 3;
var VALUE_TYPE_LINEAR_GRADIENT = 4;
var VALUE_TYPE_RADIAL_GRADIENT = 5;
var VALUE_TYPE_UNKOWN = 6;
function isGradientValueType(valType) {
    return valType === VALUE_TYPE_LINEAR_GRADIENT || valType === VALUE_TYPE_RADIAL_GRADIENT;
}
function isArrayValueType(valType) {
    return valType === VALUE_TYPE_1D_ARRAY || valType === VALUE_TYPE_2D_ARRAY;
}
var tmpRgba = [0, 0, 0, 0];
var Track = (function () {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function () {
        return this._finished;
    };
    Track.prototype.setFinished = function () {
        this._finished = true;
        if (this._additiveTrack) {
            this._additiveTrack.setFinished();
        }
    };
    Track.prototype.needsAnimate = function () {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function () {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function (time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if (isArrayLike$1(rawValue)) {
            var arrayDim = guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !isNumber$1(rawValue[0])
                || arrayDim === 2 && !isNumber$1(rawValue[0][0])) {
                discrete = true;
            }
        }
        else {
            if (isNumber$1(rawValue) && !eqNaN(rawValue)) {
                valType = VALUE_TYPE_NUMBER;
            }
            else if (isString(rawValue)) {
                if (!isNaN(+rawValue)) {
                    valType = VALUE_TYPE_NUMBER;
                }
                else {
                    var colorArray = parse(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = VALUE_TYPE_COLOR;
                    }
                }
            }
            else if (isGradientObject(rawValue)) {
                var parsedGradient = extend({}, value);
                parsedGradient.colorStops = map(rawValue.colorStops, function (colorStop) { return ({
                    offset: colorStop.offset,
                    color: parse(colorStop.color)
                }); });
                if (isLinearGradient(rawValue)) {
                    valType = VALUE_TYPE_LINEAR_GRADIENT;
                }
                else if (isRadialGradient(rawValue)) {
                    valType = VALUE_TYPE_RADIAL_GRADIENT;
                }
                value = parsedGradient;
            }
        }
        if (len === 0) {
            this.valType = valType;
        }
        else if (valType !== this.valType || valType === VALUE_TYPE_UNKOWN) {
            discrete = true;
        }
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = isFunction$3(easing)
                ? easing
                : easingFuncs[easing] || createCubicEasingFunc(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function (maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) {
            kfs.sort(function (a, b) {
                return a.time - b.time;
            });
        }
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = isArrayValueType(valType);
        var isGradient = isGradientValueType(valType);
        for (var i = 0; i < kfsLen; i++) {
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) {
                    fillArray(value, lastValue, valType);
                }
                else if (isGradient) {
                    fillColorStops(value.colorStops, lastValue.colorStops);
                }
            }
        }
        if (!isDiscrete
            && valType !== VALUE_TYPE_RADIAL_GRADIENT
            && additiveTrack
            && this.needsAnimate()
            && additiveTrack.needsAnimate()
            && valType === additiveTrack.valType
            && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for (var i = 0; i < kfsLen; i++) {
                if (valType === VALUE_TYPE_NUMBER) {
                    kfs[i].additiveValue = kfs[i].value - startValue;
                }
                else if (valType === VALUE_TYPE_COLOR) {
                    kfs[i].additiveValue =
                        add1DArray([], kfs[i].value, startValue, -1);
                }
                else if (isArrayValueType(valType)) {
                    kfs[i].additiveValue = valType === VALUE_TYPE_1D_ARRAY
                        ? add1DArray([], kfs[i].value, startValue, -1)
                        : add2DArray([], kfs[i].value, startValue, -1);
                }
            }
        }
    };
    Track.prototype.step = function (target, percent) {
        if (this._finished) {
            return;
        }
        if (this._additiveTrack && this._additiveTrack._finished) {
            this._additiveTrack = null;
        }
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) {
            frame = nextFrame = keyframes[0];
        }
        else {
            if (percent < 0) {
                frameIdx = 0;
            }
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for (frameIdx = start; frameIdx >= 0; frameIdx--) {
                    if (keyframes[frameIdx].percent <= percent) {
                        break;
                    }
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            }
            else {
                for (frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++) {
                    if (keyframes[frameIdx].percent > percent) {
                        break;
                    }
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) {
            return;
        }
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = (nextFrame.percent - frame.percent);
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) {
            w = nextFrame.easingFunc(w);
        }
        var targetArr = isAdditive ? this._additiveValue
            : (isValueColor ? tmpRgba : target[propName]);
        if ((isArrayValueType(valType) || isValueColor) && !targetArr) {
            targetArr = this._additiveValue = [];
        }
        if (this.discrete) {
            target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        }
        else if (isArrayValueType(valType)) {
            valType === VALUE_TYPE_1D_ARRAY
                ? interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w)
                : interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        }
        else if (isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: interpolateNumber(val.x, nextVal_1.x, w),
                y: interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: map(val.colorStops, function (colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: rgba2String(interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = interpolateNumber(val.y2, nextVal_1.y2, w);
            }
            else {
                target[propName].r = interpolateNumber(val.r, nextVal_1.r, w);
            }
        }
        else if (isValueColor) {
            interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) {
                target[propName] = rgba2String(targetArr);
            }
        }
        else {
            var value = interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) {
                this._additiveValue = value;
            }
            else {
                target[propName] = value;
            }
        }
        if (isAdditive) {
            this._addToTarget(target);
        }
    };
    Track.prototype._addToTarget = function (target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === VALUE_TYPE_NUMBER) {
            target[propName] = target[propName] + additiveValue;
        }
        else if (valType === VALUE_TYPE_COLOR) {
            parse(target[propName], tmpRgba);
            add1DArray(tmpRgba, tmpRgba, additiveValue, 1);
            target[propName] = rgba2String(tmpRgba);
        }
        else if (valType === VALUE_TYPE_1D_ARRAY) {
            add1DArray(target[propName], target[propName], additiveValue, 1);
        }
        else if (valType === VALUE_TYPE_2D_ARRAY) {
            add2DArray(target[propName], target[propName], additiveValue, 1);
        }
    };
    return Track;
}());
var Animator = (function () {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            logError('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function () {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function () {
        return this._delay;
    };
    Animator.prototype.getLoop = function () {
        return this._loop;
    };
    Animator.prototype.getTarget = function () {
        return this._target;
    };
    Animator.prototype.changeTarget = function (target) {
        this._target = target;
    };
    Animator.prototype.when = function (time, props, easing) {
        return this.whenWithKeys(time, props, keys$2(props), easing);
    };
    Animator.prototype.whenWithKeys = function (time, props, propNames, easing) {
        var tracks = this._tracks;
        for (var i = 0; i < propNames.length; i++) {
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === VALUE_TYPE_COLOR && initialValue) {
                        initialValue = rgba2String(initialValue);
                    }
                }
                else {
                    initialValue = this._target[propName];
                }
                if (initialValue == null) {
                    continue;
                }
                if (time > 0) {
                    track.addKeyframe(0, cloneValue(initialValue), easing);
                }
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, cloneValue(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function () {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function () {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function () {
        return !!this._paused;
    };
    Animator.prototype.duration = function (duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function () {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for (var i = 0; i < len; i++) {
                doneList[i].call(this);
            }
        }
    };
    Animator.prototype._abortedCallback = function () {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) {
            animation.removeClip(this._clip);
        }
        this._clip = null;
        if (abortedList) {
            for (var i = 0; i < abortedList.length; i++) {
                abortedList[i].call(this);
            }
        }
    };
    Animator.prototype._setTracksFinished = function () {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for (var i = 0; i < tracksKeys.length; i++) {
            tracks[tracksKeys[i]].setFinished();
        }
    };
    Animator.prototype._getAdditiveTrack = function (trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) {
            for (var i = 0; i < additiveAnimators.length; i++) {
                var track = additiveAnimators[i].getTrack(trackName);
                if (track) {
                    additiveTrack = track;
                }
            }
        }
        return additiveTrack;
    };
    Animator.prototype.start = function (easing) {
        if (this._started > 0) {
            return;
        }
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for (var i = 0; i < this._trackKeys.length; i++) {
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) {
                        self._target[track.propName] = lastKf.rawValue;
                    }
                    track.setFinished();
                }
                else {
                    tracks.push(track);
                }
            }
        }
        if (tracks.length || this._force) {
            var clip = new Clip({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function (percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for (var i = 0; i < additiveAnimators.length; i++) {
                            if (additiveAnimators[i]._clip) {
                                stillHasAdditiveAnimator = true;
                                break;
                            }
                        }
                        if (!stillHasAdditiveAnimator) {
                            self._additiveAnimators = null;
                        }
                    }
                    for (var i = 0; i < tracks.length; i++) {
                        tracks[i].step(self._target, percent);
                    }
                    var onframeList = self._onframeCbs;
                    if (onframeList) {
                        for (var i = 0; i < onframeList.length; i++) {
                            onframeList[i](self._target, percent);
                        }
                    }
                },
                ondestroy: function () {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) {
                this.animation.addClip(clip);
            }
            if (easing) {
                clip.setEasing(easing);
            }
        }
        else {
            this._doneCallback();
        }
        return this;
    };
    Animator.prototype.stop = function (forwardToLast) {
        if (!this._clip) {
            return;
        }
        var clip = this._clip;
        if (forwardToLast) {
            clip.onframe(1);
        }
        this._abortedCallback();
    };
    Animator.prototype.delay = function (time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function (cb) {
        if (cb) {
            if (!this._onframeCbs) {
                this._onframeCbs = [];
            }
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function (cb) {
        if (cb) {
            if (!this._doneCbs) {
                this._doneCbs = [];
            }
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function (cb) {
        if (cb) {
            if (!this._abortedCbs) {
                this._abortedCbs = [];
            }
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function () {
        return this._clip;
    };
    Animator.prototype.getTrack = function (propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function () {
        var _this = this;
        return map(this._trackKeys, function (key) { return _this._tracks[key]; });
    };
    Animator.prototype.stopTracks = function (propNames, forwardToLast) {
        if (!propNames.length || !this._clip) {
            return true;
        }
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for (var i = 0; i < propNames.length; i++) {
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) {
                    track.step(this._target, 1);
                }
                else if (this._started === 1) {
                    track.step(this._target, 0);
                }
                track.setFinished();
            }
        }
        var allAborted = true;
        for (var i = 0; i < tracksKeys.length; i++) {
            if (!tracks[tracksKeys[i]].isFinished()) {
                allAborted = false;
                break;
            }
        }
        if (allAborted) {
            this._abortedCallback();
        }
        return allAborted;
    };
    Animator.prototype.saveTo = function (target, trackKeys, firstOrLast) {
        if (!target) {
            return;
        }
        trackKeys = trackKeys || this._trackKeys;
        for (var i = 0; i < trackKeys.length; i++) {
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) {
                continue;
            }
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) {
                target[propName] = cloneValue(kf.rawValue);
            }
        }
    };
    Animator.prototype.__changeFinalValue = function (finalProps, trackKeys) {
        trackKeys = trackKeys || keys$2(finalProps);
        for (var i = 0; i < trackKeys.length; i++) {
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) {
                continue;
            }
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}());

function getTime() {
    return new Date().getTime();
}
var Animation = (function (_super) {
    __extends$1(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function (clip) {
        if (clip.animation) {
            this.removeClip(clip);
        }
        if (!this._head) {
            this._head = this._tail = clip;
        }
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function (animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) {
            this.addClip(clip);
        }
    };
    Animation.prototype.removeClip = function (clip) {
        if (!clip.animation) {
            return;
        }
        var prev = clip.prev;
        var next = clip.next;
        if (prev) {
            prev.next = next;
        }
        else {
            this._head = next;
        }
        if (next) {
            next.prev = prev;
        }
        else {
            this._tail = prev;
        }
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function (animator) {
        var clip = animator.getClip();
        if (clip) {
            this.removeClip(clip);
        }
        animator.animation = null;
    };
    Animation.prototype.update = function (notTriggerFrameAndStageUpdate) {
        var time = getTime() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while (clip) {
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            }
            else {
                clip = nextClip;
            }
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function () {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                requestAnimationFrame$2(step);
                !self._paused && self.update();
            }
        }
        requestAnimationFrame$2(step);
    };
    Animation.prototype.start = function () {
        if (this._running) {
            return;
        }
        this._time = getTime();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function () {
        this._running = false;
    };
    Animation.prototype.pause = function () {
        if (!this._paused) {
            this._pauseStart = getTime();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function () {
        if (this._paused) {
            this._pausedTime += getTime() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function () {
        var clip = this._head;
        while (clip) {
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function () {
        return this._head == null;
    };
    Animation.prototype.animate = function (target, options) {
        options = options || {};
        this.start();
        var animator = new Animator(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}(Eventful));

var TOUCH_CLICK_DELAY = 300;
var globalEventSupported = env.domSupported;
var localNativeListenerNames = (function () {
    var mouseHandlerNames = [
        'click', 'dblclick', 'mousewheel', 'wheel', 'mouseout',
        'mouseup', 'mousedown', 'mousemove', 'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart', 'touchend', 'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1, pointerup: 1, pointermove: 1, pointerout: 1
    };
    var pointerHandlerNames = map(mouseHandlerNames, function (name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
})();
var globalNativeListenerNames = {
    mouse: ['mousemove', 'mouseup'],
    pointer: ['pointermove', 'pointerup']
};
var wheelEventSupported = false;
function isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function () {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function markTouch(event) {
    event && (event.zrByTouch = true);
}
function normalizeGlobalEvent(instance, event) {
    return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
}
function isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while (elTmp && elTmp.nodeType !== 9
        && !(isLocal = elTmp.domBelongToZr
            || (elTmp !== el && elTmp === instance.painterRoot))) {
        elTmp = elTmp.parentNode;
    }
    return isLocal;
}
var FakeGlobalEvent = (function () {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = noop$2;
        this.stopImmediatePropagation = noop$2;
        this.preventDefault = noop$2;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}());
var localDOMHandlers = {
    mousedown: function (event) {
        event = normalizeEvent(this.dom, event);
        this.__mayPointerCapture = [event.zrX, event.zrY];
        this.trigger('mousedown', event);
    },
    mousemove: function (event) {
        event = normalizeEvent(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
            this.__togglePointerCapture(true);
        }
        this.trigger('mousemove', event);
    },
    mouseup: function (event) {
        event = normalizeEvent(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function (event) {
        event = normalizeEvent(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!isLocalEl(this, element)) {
            if (this.__pointerCapturing) {
                event.zrEventControl = 'no_globalout';
            }
            this.trigger('mouseout', event);
        }
    },
    wheel: function (event) {
        wheelEventSupported = true;
        event = normalizeEvent(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function (event) {
        if (wheelEventSupported) {
            return;
        }
        event = normalizeEvent(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function (event) {
        event = normalizeEvent(this.dom, event);
        markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        localDOMHandlers.mousemove.call(this, event);
        localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function (event) {
        event = normalizeEvent(this.dom, event);
        markTouch(event);
        this.handler.processGesture(event, 'change');
        localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function (event) {
        event = normalizeEvent(this.dom, event);
        markTouch(event);
        this.handler.processGesture(event, 'end');
        localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - (+this.__lastTouchMoment) < TOUCH_CLICK_DELAY) {
            localDOMHandlers.click.call(this, event);
        }
    },
    pointerdown: function (event) {
        localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function (event) {
        if (!isPointerFromTouch(event)) {
            localDOMHandlers.mousemove.call(this, event);
        }
    },
    pointerup: function (event) {
        localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function (event) {
        if (!isPointerFromTouch(event)) {
            localDOMHandlers.mouseout.call(this, event);
        }
    }
};
each(['click', 'dblclick', 'contextmenu'], function (name) {
    localDOMHandlers[name] = function (event) {
        event = normalizeEvent(this.dom, event);
        this.trigger(name, event);
    };
});
var globalDOMHandlers = {
    pointermove: function (event) {
        if (!isPointerFromTouch(event)) {
            globalDOMHandlers.mousemove.call(this, event);
        }
    },
    pointerup: function (event) {
        globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function (event) {
        this.trigger('mousemove', event);
    },
    mouseup: function (event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if (env.pointerEventsSupported) {
        each(localNativeListenerNames.pointer, function (nativeEventName) {
            mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
    else {
        if (env.touchEventsSupported) {
            each(localNativeListenerNames.touch, function (nativeEventName) {
                mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                    domHandlers[nativeEventName].call(instance, event);
                    setTouchTimer(scope);
                });
            });
        }
        each(localNativeListenerNames.mouse, function (nativeEventName) {
            mountSingleDOMEventListener(scope, nativeEventName, function (event) {
                event = getNativeEvent(event);
                if (!scope.touching) {
                    domHandlers[nativeEventName].call(instance, event);
                }
            });
        });
    }
}
function mountGlobalDOMEventListeners(instance, scope) {
    if (env.pointerEventsSupported) {
        each(globalNativeListenerNames.pointer, mount);
    }
    else if (!env.touchEventsSupported) {
        each(globalNativeListenerNames.mouse, mount);
    }
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = getNativeEvent(event);
            if (!isLocalEl(instance, event.target)) {
                event = normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, { capture: true });
    }
}
function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    addEventListener(scope.domTarget, nativeEventName, listener, opt);
}
function unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for (var nativeEventName in mounted) {
        if (mounted.hasOwnProperty(nativeEventName)) {
            removeEventListener(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
        }
    }
    scope.mounted = {};
}
var DOMHandlerScope = (function () {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}());
var HandlerDomProxy = (function (_super) {
    __extends$1(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
        if (globalEventSupported) {
            _this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
        }
        mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function () {
        unmountDOMEventListeners(this._localHandlerScope);
        if (globalEventSupported) {
            unmountDOMEventListeners(this._globalHandlerScope);
        }
    };
    HandlerDomProxy.prototype.setCursor = function (cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function (isPointerCapturing) {
        this.__mayPointerCapture = null;
        if (globalEventSupported
            && ((+this.__pointerCapturing) ^ (+isPointerCapturing))) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing
                ? mountGlobalDOMEventListeners(this, globalHandlerScope)
                : unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}(Eventful));

var dpr = 1;
if (env.hasGlobalWindow) {
    dpr = Math.max(window.devicePixelRatio
        || (window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI)
        || 1, 1);
}
var devicePixelRatio = dpr;
var DARK_MODE_THRESHOLD = 0.4;
var DARK_LABEL_COLOR = '#333';
var LIGHT_LABEL_COLOR = '#ccc';
var LIGHTER_LABEL_COLOR = '#eee';

var mIdentity = identity$1;
var EPSILON$2 = 5e-5;
function isNotAroundZero$1(val) {
    return val > EPSILON$2 || val < -EPSILON$2;
}
var scaleTmp = [];
var tmpTransform = [];
var originTransform = create$1();
var abs = Math.abs;
var Transformable = (function () {
    function Transformable() {
    }
    Transformable.prototype.getLocalTransform = function (m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function (arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function (arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function (arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function (arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function () {
        return isNotAroundZero$1(this.rotation)
            || isNotAroundZero$1(this.x)
            || isNotAroundZero$1(this.y)
            || isNotAroundZero$1(this.scaleX - 1)
            || isNotAroundZero$1(this.scaleY - 1)
            || isNotAroundZero$1(this.skewX)
            || isNotAroundZero$1(this.skewY);
    };
    Transformable.prototype.updateTransform = function () {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            m && mIdentity(m);
            return;
        }
        m = m || create$1();
        if (needLocalTransform) {
            this.getLocalTransform(m);
        }
        else {
            mIdentity(m);
        }
        if (parentTransform) {
            if (needLocalTransform) {
                mul$1(m, parentTransform, m);
            }
            else {
                copy$1(m, parentTransform);
            }
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function (m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale(scaleTmp);
            var relX = scaleTmp[0] < 0 ? -1 : 1;
            var relY = scaleTmp[1] < 0 ? -1 : 1;
            var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
            var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || create$1();
        invert(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function () {
        var transformNode = this;
        var ancestors = [];
        while (transformNode) {
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while (transformNode = ancestors.pop()) {
            transformNode.updateTransform();
        }
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function (m) {
        if (!m) {
            return;
        }
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function () {
        if (!this.transform) {
            return;
        }
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            mul$1(tmpTransform, parent.invTransform, m);
            m = tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            originTransform[4] = ox;
            originTransform[5] = oy;
            mul$1(tmpTransform, m, originTransform);
            tmpTransform[4] -= ox;
            tmpTransform[5] -= oy;
            m = tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function (out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) {
            out[0] = -out[0];
        }
        if (m[3] < 0) {
            out[1] = -out[1];
        }
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function (x, y) {
        var v2 = [x, y];
        var invTransform = this.invTransform;
        if (invTransform) {
            applyTransform(v2, v2, invTransform);
        }
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function (x, y) {
        var v2 = [x, y];
        var transform = this.transform;
        if (transform) {
            applyTransform(v2, v2, transform);
        }
        return v2;
    };
    Transformable.prototype.getLineScale = function () {
        var m = this.transform;
        return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10
            ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1]))
            : 1;
    };
    Transformable.prototype.copyTransform = function (source) {
        copyTransform(this, source);
    };
    Transformable.getLocalTransform = function (target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        }
        else {
            m[4] = m[5] = 0;
        }
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && rotate(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = (function () {
        var proto = Transformable.prototype;
        proto.scaleX =
            proto.scaleY =
                proto.globalScaleRatio = 1;
        proto.x =
            proto.y =
                proto.originX =
                    proto.originY =
                        proto.skewX =
                            proto.skewY =
                                proto.rotation =
                                    proto.anchorX =
                                        proto.anchorY = 0;
    })();
    return Transformable;
}());
var TRANSFORMABLE_PROPS = [
    'x', 'y', 'originX', 'originY', 'anchorX', 'anchorY', 'rotation', 'scaleX', 'scaleY', 'skewX', 'skewY'
];
function copyTransform(target, source) {
    for (var i = 0; i < TRANSFORMABLE_PROPS.length; i++) {
        var propName = TRANSFORMABLE_PROPS[i];
        target[propName] = source[propName];
    }
}

var textWidthCache = {};
function getWidth(text, font) {
    font = font || DEFAULT_FONT;
    var cacheOfFont = textWidthCache[font];
    if (!cacheOfFont) {
        cacheOfFont = textWidthCache[font] = new LRU(500);
    }
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = platformApi.measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function innerGetBoundingRect(text, font, textAlign, textBaseline) {
    var width = getWidth(text, font);
    var height = getLineHeight(font);
    var x = adjustTextX(0, width, textAlign);
    var y = adjustTextY$1(0, height, textBaseline);
    var rect = new BoundingRect(x, y, width, height);
    return rect;
}
function getBoundingRect(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) {
        return innerGetBoundingRect(textLines[0], font, textAlign, textBaseline);
    }
    else {
        var uniondRect = new BoundingRect(0, 0, 0, 0);
        for (var i = 0; i < textLines.length; i++) {
            var rect = innerGetBoundingRect(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function adjustTextX(x, width, textAlign) {
    if (textAlign === 'right') {
        x -= width;
    }
    else if (textAlign === 'center') {
        x -= width / 2;
    }
    return x;
}
function adjustTextY$1(y, height, verticalAlign) {
    if (verticalAlign === 'middle') {
        y -= height / 2;
    }
    else if (verticalAlign === 'bottom') {
        y -= height;
    }
    return y;
}
function getLineHeight(font) {
    return getWidth('国', font);
}
function parsePercent(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) {
            return parseFloat(value) / 100 * maxValue;
        }
        return parseFloat(value);
    }
    return value;
}
function calculateTextPosition(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += parsePercent(textPosition[0], rect.width);
        y += parsePercent(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    }
    else {
        switch (textPosition) {
            case 'left':
                x -= distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'right':
                x += distance + width;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'top':
                x += width / 2;
                y -= distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'bottom':
                x += width / 2;
                y += height + distance;
                textAlign = 'center';
                break;
            case 'inside':
                x += width / 2;
                y += halfHeight;
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'insideLeft':
                x += distance;
                y += halfHeight;
                textVerticalAlign = 'middle';
                break;
            case 'insideRight':
                x += width - distance;
                y += halfHeight;
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideTop':
                x += width / 2;
                y += distance;
                textAlign = 'center';
                break;
            case 'insideBottom':
                x += width / 2;
                y += height - distance;
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideTopLeft':
                x += distance;
                y += distance;
                break;
            case 'insideTopRight':
                x += width - distance;
                y += distance;
                textAlign = 'right';
                break;
            case 'insideBottomLeft':
                x += distance;
                y += height - distance;
                textVerticalAlign = 'bottom';
                break;
            case 'insideBottomRight':
                x += width - distance;
                y += height - distance;
                textAlign = 'right';
                textVerticalAlign = 'bottom';
                break;
        }
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}

var PRESERVED_NORMAL_STATE = '__zr_normal__';
var PRIMARY_STATES_KEYS = TRANSFORMABLE_PROPS.concat(['ignore']);
var DEFAULT_ANIMATABLE_MAP = reduce$6(TRANSFORMABLE_PROPS, function (obj, key) {
    obj[key] = true;
    return obj;
}, { ignore: false });
var tmpTextPosCalcRes = {};
var tmpBoundingRect = new BoundingRect(0, 0, 0, 0);
var Element$3 = (function () {
    function Element(props) {
        this.id = guid();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function (props) {
        this.attr(props);
    };
    Element.prototype.drift = function (dx, dy, e) {
        switch (this.draggable) {
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) {
            m = this.transform = [1, 0, 0, 1, 0, 0];
        }
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function () { };
    Element.prototype.afterUpdate = function () { };
    Element.prototype.update = function () {
        this.updateTransform();
        if (this.__dirty) {
            this.updateInnerText();
        }
    };
    Element.prototype.updateInnerText = function (forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) {
                this.textConfig = {};
            }
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = tmpBoundingRect;
                if (textConfig.layoutRect) {
                    layoutRect.copy(textConfig.layoutRect);
                }
                else {
                    layoutRect.copy(this.getBoundingRect());
                }
                if (!isLocal) {
                    layoutRect.applyTransform(this.transform);
                }
                if (this.calculateTextPosition) {
                    this.calculateTextPosition(tmpTextPosCalcRes, textConfig, layoutRect);
                }
                else {
                    calculateTextPosition(tmpTextPosCalcRes, textConfig, layoutRect);
                }
                innerTransformable.x = tmpTextPosCalcRes.x;
                innerTransformable.y = tmpTextPosCalcRes.y;
                textAlign = tmpTextPosCalcRes.align;
                textVerticalAlign = tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    }
                    else {
                        relOriginX = parsePercent(textOrigin[0], layoutRect.width);
                        relOriginY = parsePercent(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) {
                innerTransformable.rotation = textConfig.rotation;
            }
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null
                ? (typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0)
                : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') {
                    textFill = this.getInsideTextFill();
                }
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            }
            else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') {
                    textFill = this.getOutsideFill();
                }
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill
                || textStroke !== innerTextDefaultStyle.stroke
                || autoStroke !== innerTextDefaultStyle.autoStroke
                || textAlign !== innerTextDefaultStyle.align
                || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= REDRAW_BIT;
            if (textStyleChanged) {
                textEl.dirtyStyle(true);
            }
        }
    };
    Element.prototype.canBeInsideText = function () {
        return true;
    };
    Element.prototype.getInsideTextFill = function () {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function (textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function () {
        return this.__zr && this.__zr.isDarkMode() ? LIGHT_LABEL_COLOR : DARK_LABEL_COLOR;
    };
    Element.prototype.getOutsideStroke = function (textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && parse(backgroundColor);
        if (!colorArr) {
            colorArr = [255, 255, 255, 1];
        }
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for (var i = 0; i < 3; i++) {
            colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        }
        colorArr[3] = 1;
        return stringify(colorArr, 'rgba');
    };
    Element.prototype.traverse = function (cb, context) { };
    Element.prototype.attrKV = function (key, value) {
        if (key === 'textConfig') {
            this.setTextConfig(value);
        }
        else if (key === 'textContent') {
            this.setTextContent(value);
        }
        else if (key === 'clipPath') {
            this.setClipPath(value);
        }
        else if (key === 'extra') {
            this.extra = this.extra || {};
            extend(this.extra, value);
        }
        else {
            this[key] = value;
        }
    };
    Element.prototype.hide = function () {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function () {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function (keyOrObj, value) {
        if (typeof keyOrObj === 'string') {
            this.attrKV(keyOrObj, value);
        }
        else if (isObject$2(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = keys$2(obj);
            for (var i = 0; i < keysArr.length; i++) {
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function (toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for (var i = 0; i < this.animators.length; i++) {
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== PRESERVED_NORMAL_STATE) {
                continue;
            }
            var targetName = animator.targetName;
            var target = targetName
                ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function (toState) {
        var normalState = this._normalState;
        if (!normalState) {
            normalState = this._normalState = {};
        }
        if (toState.textConfig && !normalState.textConfig) {
            normalState.textConfig = this.textConfig;
        }
        this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function (toState, normalState, primaryKeys) {
        for (var i = 0; i < primaryKeys.length; i++) {
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) {
                normalState[key] = this[key];
            }
        }
    };
    Element.prototype.hasState = function () {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function (name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function (name) {
        var states = this.states;
        if (!states[name]) {
            states[name] = {};
        }
        return states[name];
    };
    Element.prototype.clearStates = function (noAnimation) {
        this.useState(PRESERVED_NORMAL_STATE, false, noAnimation);
    };
    Element.prototype.useState = function (stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === PRESERVED_NORMAL_STATE;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) {
            return;
        }
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if (indexOf(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) {
            return;
        }
        var state;
        if (this.stateProxy && !toNormalState) {
            state = this.stateProxy(stateName);
        }
        if (!state) {
            state = (this.states && this.states[stateName]);
        }
        if (!state && !toNormalState) {
            logError("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) {
            this.saveCurrentToNormalState(state);
        }
        var useHoverLayer = !!((state && state.hoverLayer) || forceUseHoverLayer);
        if (useHoverLayer) {
            this._toggleHoverLayerFlag(true);
        }
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) {
            textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        }
        if (textGuide) {
            textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        }
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        }
        else {
            if (!keepCurrentStates) {
                this.currentStates = [stateName];
            }
            else {
                this.currentStates.push(stateName);
            }
        }
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~REDRAW_BIT;
        }
        return state;
    };
    Element.prototype.useStates = function (states, noAnimation, forceUseHoverLayer) {
        if (!states.length) {
            this.clearStates();
        }
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for (var i = 0; i < len; i++) {
                    if (states[i] !== currentStates[i]) {
                        notChange = false;
                        break;
                    }
                }
            }
            if (notChange) {
                return;
            }
            for (var i = 0; i < len; i++) {
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) {
                    stateObj = this.stateProxy(stateName, states);
                }
                if (!stateObj) {
                    stateObj = this.states[stateName];
                }
                if (stateObj) {
                    stateObjects.push(stateObj);
                }
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!((lastStateObj && lastStateObj.hoverLayer) || forceUseHoverLayer);
            if (useHoverLayer) {
                this._toggleHoverLayerFlag(true);
            }
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) {
                textContent.useStates(states, noAnimation, useHoverLayer);
            }
            if (textGuide) {
                textGuide.useStates(states, noAnimation, useHoverLayer);
            }
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~REDRAW_BIT;
            }
        }
    };
    Element.prototype._updateAnimationTargets = function () {
        for (var i = 0; i < this.animators.length; i++) {
            var animator = this.animators[i];
            if (animator.targetName) {
                animator.changeTarget(this[animator.targetName]);
            }
        }
    };
    Element.prototype.removeState = function (state) {
        var idx = indexOf(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function (oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = indexOf(currentStates, oldState);
        var newStateExists = indexOf(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) {
                currentStates[idx] = newState;
            }
            else {
                currentStates.splice(idx, 1);
            }
        }
        else if (forceAdd && !newStateExists) {
            currentStates.push(newState);
        }
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function (state, enable) {
        if (enable) {
            this.useState(state, true);
        }
        else {
            this.removeState(state);
        }
    };
    Element.prototype._mergeStates = function (states) {
        var mergedState = {};
        var mergedTextConfig;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            extend(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                extend(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) {
            mergedState.textConfig = mergedTextConfig;
        }
        return mergedState;
    };
    Element.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = extend({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            extend(this.textConfig, state.textConfig);
        }
        else if (needsRestoreToNormal) {
            if (normalState.textConfig) {
                this.textConfig = normalState.textConfig;
            }
        }
        var transitionTarget = {};
        var hasTransition = false;
        for (var i = 0; i < PRIMARY_STATES_KEYS.length; i++) {
            var key = PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                }
                else {
                    this[key] = state[key];
                }
            }
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    }
                    else {
                        this[key] = normalState[key];
                    }
                }
            }
        }
        if (!transition) {
            for (var i = 0; i < this.animators.length; i++) {
                var animator = this.animators[i];
                var targetName = animator.targetName;
                if (!animator.getLoop()) {
                    animator.__changeFinalValue(targetName
                        ? (state || normalState)[targetName]
                        : (state || normalState));
                }
            }
        }
        if (hasTransition) {
            this._transitionState(stateName, transitionTarget, animationCfg);
        }
    };
    Element.prototype._attachComponent = function (componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) {
            if (process.env.NODE_ENV !== 'production') {
                throw new Error('Text element has been added to zrender.');
            }
            return;
        }
        if (componentEl === this) {
            if (process.env.NODE_ENV !== 'production') {
                throw new Error('Recursive component attachment.');
            }
            return;
        }
        var zr = this.__zr;
        if (zr) {
            componentEl.addSelfToZr(zr);
        }
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function (componentEl) {
        if (componentEl.__zr) {
            componentEl.removeSelfFromZr(componentEl.__zr);
        }
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function () {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function (clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) {
            this.removeClipPath();
        }
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function () {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function () {
        return this._textContent;
    };
    Element.prototype.setTextContent = function (textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) {
            return;
        }
        if (previousTextContent && previousTextContent !== textEl) {
            this.removeTextContent();
        }
        if (process.env.NODE_ENV !== 'production') {
            if (textEl.__zr && !textEl.__hostTarget) {
                throw new Error('Text element has been added to zrender.');
            }
        }
        textEl.innerTransformable = new Transformable();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function (cfg) {
        if (!this.textConfig) {
            this.textConfig = {};
        }
        extend(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function () {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function () {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function () {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function (guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) {
            this.removeTextGuideLine();
        }
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function () {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function () {
        this.__dirty |= REDRAW_BIT;
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) {
                zr.refreshHover();
            }
            else {
                zr.refresh();
            }
        }
        if (this.__hostTarget) {
            this.__hostTarget.markRedraw();
        }
    };
    Element.prototype.dirty = function () {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function (inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) {
            textContent.__inHover = inHover;
        }
        if (textGuide) {
            textGuide.__inHover = inHover;
        }
    };
    Element.prototype.addSelfToZr = function (zr) {
        if (this.__zr === zr) {
            return;
        }
        this.__zr = zr;
        var animators = this.animators;
        if (animators) {
            for (var i = 0; i < animators.length; i++) {
                zr.animation.addAnimator(animators[i]);
            }
        }
        if (this._clipPath) {
            this._clipPath.addSelfToZr(zr);
        }
        if (this._textContent) {
            this._textContent.addSelfToZr(zr);
        }
        if (this._textGuide) {
            this._textGuide.addSelfToZr(zr);
        }
    };
    Element.prototype.removeSelfFromZr = function (zr) {
        if (!this.__zr) {
            return;
        }
        this.__zr = null;
        var animators = this.animators;
        if (animators) {
            for (var i = 0; i < animators.length; i++) {
                zr.animation.removeAnimator(animators[i]);
            }
        }
        if (this._clipPath) {
            this._clipPath.removeSelfFromZr(zr);
        }
        if (this._textContent) {
            this._textContent.removeSelfFromZr(zr);
        }
        if (this._textGuide) {
            this._textGuide.removeSelfFromZr(zr);
        }
    };
    Element.prototype.animate = function (key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        if (process.env.NODE_ENV !== 'production') {
            if (!target) {
                logError('Property "'
                    + key
                    + '" is not existed in element '
                    + this.id);
                return;
            }
        }
        var animator = new Animator(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function (animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function () {
            el.updateDuringAnimation(key);
        }).done(function () {
            var animators = el.animators;
            var idx = indexOf(animators, animator);
            if (idx >= 0) {
                animators.splice(idx, 1);
            }
        });
        this.animators.push(animator);
        if (zr) {
            zr.animation.addAnimator(animator);
        }
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function (key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function (scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for (var i = 0; i < len; i++) {
            var animator = animators[i];
            if (!scope || scope === animator.scope) {
                animator.stop(forwardToLast);
            }
            else {
                leftAnimators.push(animator);
            }
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function (target, cfg, animationProps) {
        animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function (target, cfg, animationProps) {
        animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function (stateName, target, cfg, animationProps) {
        var animators = animateTo(this, target, cfg, animationProps);
        for (var i = 0; i < animators.length; i++) {
            animators[i].__fromStateTransition = stateName;
        }
    };
    Element.prototype.getBoundingRect = function () {
        return null;
    };
    Element.prototype.getPaintRect = function () {
        return null;
    };
    Element.initDefaultProps = (function () {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore =
            elProto.silent =
                elProto.isGroup =
                    elProto.draggable =
                        elProto.dragging =
                            elProto.ignoreClip =
                                elProto.__inHover = false;
        elProto.__dirty = REDRAW_BIT;
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function () {
                    if (process.env.NODE_ENV !== 'production') {
                        logDeprecatedError(key, xKey, yKey);
                    }
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function (pos) {
                    if (process.env.NODE_ENV !== 'production') {
                        logDeprecatedError(key, xKey, yKey);
                    }
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function () {
                        return self[xKey];
                    },
                    set: function (val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function () {
                        return self[yKey];
                    },
                    set: function (val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    })();
    return Element;
}());
mixin(Element$3, Eventful);
mixin(Element$3, Transformable);
function animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function () {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) {
            doneHappened
                ? (cfgDone && cfgDone())
                : (cfgAborted && cfgAborted());
        }
    };
    var abortedCb = function () {
        finishCount--;
        if (finishCount <= 0) {
            doneHappened
                ? (cfgDone && cfgDone())
                : (cfgAborted && cfgAborted());
        }
    };
    if (!finishCount) {
        cfgDone && cfgDone();
    }
    if (animators.length > 0 && cfg.during) {
        animators[0].during(function (target, percent) {
            cfg.during(percent);
        });
    }
    for (var i = 0; i < animators.length; i++) {
        var animator = animators[i];
        if (doneCb) {
            animator.done(doneCb);
        }
        if (abortedCb) {
            animator.aborted(abortedCb);
        }
        if (cfg.force) {
            animator.duration(cfg.duration);
        }
        animator.start(cfg.easing);
    }
    return animators;
}
function copyArrShallow(source, target, len) {
    for (var i = 0; i < len; i++) {
        source[i] = target[i];
    }
}
function is2DArray(value) {
    return isArrayLike$1(value[0]);
}
function copyValue(target, source, key) {
    if (isArrayLike$1(source[key])) {
        if (!isArrayLike$1(target[key])) {
            target[key] = [];
        }
        if (isTypedArray$1(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new (source[key].constructor)(len);
                copyArrShallow(target[key], source[key], len);
            }
        }
        else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if (is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for (var i = 0; i < len0; i++) {
                    if (!targetArr[i]) {
                        targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                    }
                    else {
                        copyArrShallow(targetArr[i], sourceArr[i], len1);
                    }
                }
            }
            else {
                copyArrShallow(targetArr, sourceArr, len0);
            }
            targetArr.length = sourceArr.length;
        }
    }
    else {
        target[key] = source[key];
    }
}
function isValueSame(val1, val2) {
    return val1 === val2
        || isArrayLike$1(val1) && isArrayLike$1(val2) && is1DArraySame(val1, val2);
}
function is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        if (arr0[i] !== arr1[i]) {
            return false;
        }
    }
    return true;
}
function animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = keys$2(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !isObject$2(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for (var k = 0; k < targetKeys.length; k++) {
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null
            && (animateAll || animationProps[innerKey])) {
            if (isObject$2(targetVal)
                && !isArrayLike$1(targetVal)
                && !isGradientObject(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            }
            else {
                animationKeys.push(innerKey);
            }
        }
        else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) {
        for (var i = 0; i < existsAnimators.length; i++) {
            var animator = existsAnimators[i];
            if (animator.targetName === topKey) {
                var allAborted = animator.stopTracks(animationKeys);
                if (allAborted) {
                    var idx = indexOf(existsAnimators, animator);
                    existsAnimators.splice(idx, 1);
                }
            }
        }
    }
    if (!cfg.force) {
        animationKeys = filter(animationKeys, function (key) { return !isValueSame(target[key], animateObj[key]); });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0
        || (cfg.force && !animators.length)) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) {
                revertedSource = {};
            }
            for (var i = 0; i < keyLen; i++) {
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) {
                    revertedSource[innerKey] = target[innerKey];
                }
                else {
                    animateObj[innerKey] = target[innerKey];
                }
            }
        }
        else if (setToFinal) {
            sourceClone = {};
            for (var i = 0; i < keyLen; i++) {
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = cloneValue(animateObj[innerKey]);
                copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new Animator(animateObj, false, false, additive ? filter(existsAnimators, function (animator) { return animator.targetName === topKey; }) : null);
        animator.targetName = topKey;
        if (cfg.scope) {
            animator.scope = cfg.scope;
        }
        if (setToFinal && revertedSource) {
            animator.whenWithKeys(0, revertedSource, animationKeys);
        }
        if (sourceClone) {
            animator.whenWithKeys(0, sourceClone, animationKeys);
        }
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}

var Group$1 = (function (_super) {
    __extends$1(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function () {
        return this._children;
    };
    Group.prototype.children = function () {
        return this._children.slice();
    };
    Group.prototype.childAt = function (idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function (name) {
        var children = this._children;
        for (var i = 0; i < children.length; i++) {
            if (children[i].name === name) {
                return children[i];
            }
        }
    };
    Group.prototype.childCount = function () {
        return this._children.length;
    };
    Group.prototype.add = function (child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
            if (process.env.NODE_ENV !== 'production') {
                if (child.__hostTarget) {
                    throw 'This elemenet has been used as an attachment';
                }
            }
        }
        return this;
    };
    Group.prototype.addBefore = function (child, nextSibling) {
        if (child && child !== this && child.parent !== this
            && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function (oldChild, newChild) {
        var idx = indexOf(this._children, oldChild);
        if (idx >= 0) {
            this.replaceAt(newChild, idx);
        }
        return this;
    };
    Group.prototype.replaceAt = function (child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) {
                old.removeSelfFromZr(zr);
            }
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function (child) {
        if (child.parent) {
            child.parent.remove(child);
        }
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) {
            child.addSelfToZr(zr);
        }
        zr && zr.refresh();
    };
    Group.prototype.remove = function (child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = indexOf(children, child);
        if (idx < 0) {
            return this;
        }
        children.splice(idx, 1);
        child.parent = null;
        if (zr) {
            child.removeSelfFromZr(zr);
        }
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function () {
        var children = this._children;
        var zr = this.__zr;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (zr) {
                child.removeSelfFromZr(zr);
            }
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function (cb, context) {
        var children = this._children;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function (cb, context) {
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) {
                child.traverse(cb, context);
            }
        }
        return this;
    };
    Group.prototype.addSelfToZr = function (zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function (zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function (includeChildren) {
        var tmpRect = new BoundingRect(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            if (child.ignore || child.invisible) {
                continue;
            }
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                BoundingRect.applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            }
            else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}(Element$3));
Group$1.prototype.type = 'group';

/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/
var painterCtors = {};
var instances = {};
function delInstance(id) {
    delete instances[id];
}
function isDarkMode(backgroundColor) {
    if (!backgroundColor) {
        return false;
    }
    if (typeof backgroundColor === 'string') {
        return lum(backgroundColor, 1) < DARK_MODE_THRESHOLD;
    }
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for (var i = 0; i < len; i++) {
            totalLum += lum(colorStops[i].color, 1);
        }
        totalLum /= len;
        return totalLum < DARK_MODE_THRESHOLD;
    }
    return false;
}
var ZRender = (function () {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new Storage();
        var rendererType = opts.renderer || 'canvas';
        if (!painterCtors[rendererType]) {
            rendererType = keys$2(painterCtors)[0];
        }
        if (process.env.NODE_ENV !== 'production') {
            if (!painterCtors[rendererType]) {
                throw new Error("Renderer '" + rendererType + "' is not imported. Please import it first.");
            }
        }
        opts.useDirtyRect = opts.useDirtyRect == null
            ? false
            : opts.useDirtyRect;
        var painter = new painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handerProxy = (!env.node && !env.worker && !ssrMode)
            ? new HandlerDomProxy(painter.getViewportRoot(), painter.root)
            : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = (useCoarsePointer == null || useCoarsePointer === 'auto')
            ? env.touchEventsSupported
            : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) {
            pointerSize = retrieve2(opts.pointerSize, defaultPointerSize);
        }
        this.handler = new Handler(storage, painter, handerProxy, painter.root, pointerSize);
        this.animation = new Animation({
            stage: {
                update: ssrMode ? null : function () { return _this._flush(true); }
            }
        });
        if (!ssrMode) {
            this.animation.start();
        }
    }
    ZRender.prototype.add = function (el) {
        if (!el) {
            return;
        }
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function (el) {
        if (!el) {
            return;
        }
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function (zLevel, config) {
        if (this.painter.configLayer) {
            this.painter.configLayer(zLevel, config);
        }
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function (backgroundColor) {
        if (this.painter.setBackgroundColor) {
            this.painter.setBackgroundColor(backgroundColor);
        }
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function () {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function (darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function () {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function (fromInside) {
        if (!fromInside) {
            this.animation.update(true);
        }
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function () {
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function () {
        this._flush(false);
    };
    ZRender.prototype._flush = function (fromInside) {
        var triggerRendered;
        var start = getTime();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = getTime();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        }
        else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) {
                this.animation.stop();
            }
        }
    };
    ZRender.prototype.setSleepAfterStill = function (stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function () {
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function () {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function () {
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') {
            this.painter.refreshHover();
        }
    };
    ZRender.prototype.resize = function (opts) {
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function () {
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function () {
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function () {
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function (cursorStyle) {
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function (x, y) {
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function (eventName, eventHandler, context) {
        this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function (eventName, eventHandler) {
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function (eventName, event) {
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function () {
        var roots = this.storage.getRoots();
        for (var i = 0; i < roots.length; i++) {
            if (roots[i] instanceof Group$1) {
                roots[i].removeSelfFromZr(this);
            }
        }
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function () {
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation =
            this.storage =
                this.painter =
                    this.handler = null;
        delInstance(this.id);
    };
    return ZRender;
}());
function init(dom, opts) {
    var zr = new ZRender(guid(), dom, opts);
    instances[zr.id] = zr;
    return zr;
}
function dispose(zr) {
    zr.dispose();
}
function disposeAll() {
    for (var key in instances) {
        if (instances.hasOwnProperty(key)) {
            instances[key].dispose();
        }
    }
    instances = {};
}
function getInstance(id) {
    return instances[id];
}
function registerPainter(name, Ctor) {
    painterCtors[name] = Ctor;
}
var version = '5.4.1';

var zrender = /*#__PURE__*/Object.freeze({
	__proto__: null,
	init: init,
	dispose: dispose,
	disposeAll: disposeAll,
	getInstance: getInstance,
	registerPainter: registerPainter,
	version: version
});

var RADIAN_EPSILON = 1e-4; // Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.

var ROUND_SUPPORTED_PRECISION_MAX = 20;

function _trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
}
/**
 * Linear mapping a value from domain to range
 * @param  val
 * @param  domain Domain extent domain[0] can be bigger than domain[1]
 * @param  range  Range extent range[0] can be bigger than range[1]
 * @param  clamp Default to be false
 */


function linearMap(val, domain, range, clamp) {
  var d0 = domain[0];
  var d1 = domain[1];
  var r0 = range[0];
  var r1 = range[1];
  var subDomain = d1 - d0;
  var subRange = r1 - r0;

  if (subDomain === 0) {
    return subRange === 0 ? r0 : (r0 + r1) / 2;
  } // Avoid accuracy problem in edge, such as
  // 146.39 - 62.83 === 83.55999999999999.
  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
  // It is a little verbose for efficiency considering this method
  // is a hotspot.


  if (clamp) {
    if (subDomain > 0) {
      if (val <= d0) {
        return r0;
      } else if (val >= d1) {
        return r1;
      }
    } else {
      if (val >= d0) {
        return r0;
      } else if (val <= d1) {
        return r1;
      }
    }
  } else {
    if (val === d0) {
      return r0;
    }

    if (val === d1) {
      return r1;
    }
  }

  return (val - d0) / subDomain * subRange + r0;
}
/**
 * Convert a percent string to absolute number.
 * Returns NaN if percent is not a valid string or number
 */

function parsePercent$1(percent, all) {
  switch (percent) {
    case 'center':
    case 'middle':
      percent = '50%';
      break;

    case 'left':
    case 'top':
      percent = '0%';
      break;

    case 'right':
    case 'bottom':
      percent = '100%';
      break;
  }

  if (isString(percent)) {
    if (_trim(percent).match(/%$/)) {
      return parseFloat(percent) / 100 * all;
    }

    return parseFloat(percent);
  }

  return percent == null ? NaN : +percent;
}
function round$3(x, precision, returnStr) {
  if (precision == null) {
    precision = 10;
  } // Avoid range error


  precision = Math.min(Math.max(0, precision), ROUND_SUPPORTED_PRECISION_MAX); // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'

  x = (+x).toFixed(precision);
  return returnStr ? x : +x;
}
/**
 * Inplacd asc sort arr.
 * The input arr will be modified.
 */

function asc(arr) {
  arr.sort(function (a, b) {
    return a - b;
  });
  return arr;
}
/**
 * Get precision.
 */

function getPrecision(val) {
  val = +val;

  if (isNaN(val)) {
    return 0;
  } // It is much faster than methods converting number to string as follows
  //      let tmp = val.toString();
  //      return tmp.length - 1 - tmp.indexOf('.');
  // especially when precision is low
  // Notice:
  // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
  //     (see https://jsbench.me/2vkpcekkvw/1)
  // (2) If the val is less than for example 1e-15, the result may be incorrect.
  //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)


  if (val > 1e-14) {
    var e = 1;

    for (var i = 0; i < 15; i++, e *= 10) {
      if (Math.round(val * e) / e === val) {
        return i;
      }
    }
  }

  return getPrecisionSafe(val);
}
/**
 * Get precision with slow but safe method
 */

function getPrecisionSafe(val) {
  // toLowerCase for: '3.4E-12'
  var str = val.toString().toLowerCase(); // Consider scientific notation: '3.4e-12' '3.4e+12'

  var eIndex = str.indexOf('e');
  var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
  var significandPartLen = eIndex > 0 ? eIndex : str.length;
  var dotIndex = str.indexOf('.');
  var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
  return Math.max(0, decimalPartLen - exp);
}
/**
 * Minimal dicernible data precisioin according to a single pixel.
 */

function getPixelPrecision(dataExtent, pixelExtent) {
  var log = Math.log;
  var LN10 = Math.LN10;
  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.

  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
  return !isFinite(precision) ? 20 : precision;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainder method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param valueList a list of all data
 * @param idx index of the data to be processed in valueList
 * @param precision integer number showing digits of precision
 * @return percent ranging from 0 to 100
 */

function getPercentWithPrecision(valueList, idx, precision) {
  if (!valueList[idx]) {
    return 0;
  }

  var seats = getPercentSeats(valueList, precision);
  return seats[idx] || 0;
}
/**
 * Get a data of given precision, assuring the sum of percentages
 * in valueList is 1.
 * The largest remainder method is used.
 * https://en.wikipedia.org/wiki/Largest_remainder_method
 *
 * @param valueList a list of all data
 * @param precision integer number showing digits of precision
 * @return {Array<number>}
 */

function getPercentSeats(valueList, precision) {
  var sum = reduce$6(valueList, function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);

  if (sum === 0) {
    return [];
  }

  var digits = Math.pow(10, precision);
  var votesPerQuota = map(valueList, function (val) {
    return (isNaN(val) ? 0 : val) / sum * digits * 100;
  });
  var targetSeats = digits * 100;
  var seats = map(votesPerQuota, function (votes) {
    // Assign automatic seats.
    return Math.floor(votes);
  });
  var currentSum = reduce$6(seats, function (acc, val) {
    return acc + val;
  }, 0);
  var remainder = map(votesPerQuota, function (votes, idx) {
    return votes - seats[idx];
  }); // Has remainding votes.

  while (currentSum < targetSeats) {
    // Find next largest remainder.
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;

    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    } // Add a vote to max remainder.


    ++seats[maxId];
    remainder[maxId] = 0;
    ++currentSum;
  }

  return map(seats, function (seat) {
    return seat / digits;
  });
}
/**
 * Solve the floating point adding problem like 0.1 + 0.2 === 0.30000000000000004
 * See <http://0.30000000000000004.com/>
 */

function addSafe(val0, val1) {
  var maxPrecision = Math.max(getPrecision(val0), getPrecision(val1)); // const multiplier = Math.pow(10, maxPrecision);
  // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;

  var sum = val0 + val1; // // PENDING: support more?

  return maxPrecision > ROUND_SUPPORTED_PRECISION_MAX ? sum : round$3(sum, maxPrecision);
} // Number.MAX_SAFE_INTEGER, ie do not support.

var MAX_SAFE_INTEGER$2 = 9007199254740991;
/**
 * To 0 - 2 * PI, considering negative radian.
 */

function remRadian(radian) {
  var pi2 = Math.PI * 2;
  return (radian % pi2 + pi2) % pi2;
}
/**
 * @param {type} radian
 * @return {boolean}
 */

function isRadianAroundZero(val) {
  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
} // eslint-disable-next-line

var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line

/**
 * @param value valid type: number | string | Date, otherwise return `new Date(NaN)`
 *   These values can be accepted:
 *   + An instance of Date, represent a time in its own time zone.
 *   + Or string in a subset of ISO 8601, only including:
 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
 *     all of which will be treated as local time if time zone is not specified
 *     (see <https://momentjs.com/>).
 *   + Or other string format, including (all of which will be treated as local time):
 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
 *   + a timestamp, which represent a time in UTC.
 * @return date Never be null/undefined. If invalid, return `new Date(NaN)`.
 */

function parseDate(value) {
  if (value instanceof Date) {
    return value;
  } else if (isString(value)) {
    // Different browsers parse date in different way, so we parse it manually.
    // Some other issues:
    // new Date('1970-01-01') is UTC,
    // new Date('1970/01/01') and new Date('1970-1-01') is local.
    // See issue #3623
    var match = TIME_REG.exec(value);

    if (!match) {
      // return Invalid Date.
      return new Date(NaN);
    } // Use local time when no timezone offset is specified.


    if (!match[8]) {
      // match[n] can only be string or undefined.
      // But take care of '12' + 1 => '121'.
      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
    // For example, system timezone is set as "Time Zone: America/Toronto",
    // then these code will get different result:
    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
    // So we should not use `new Date`, but use `Date.UTC`.
    else {
        var hour = +match[4] || 0;

        if (match[8].toUpperCase() !== 'Z') {
          hour -= +match[8].slice(0, 3);
        }

        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
      }
  } else if (value == null) {
    return new Date(NaN);
  }

  return new Date(Math.round(value));
}
/**
 * Quantity of a number. e.g. 0.1, 1, 10, 100
 *
 * @param val
 * @return
 */

function quantity(val) {
  return Math.pow(10, quantityExponent(val));
}
/**
 * Exponent of the quantity of a number
 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
 *
 * @param val non-negative value
 * @return
 */

function quantityExponent(val) {
  if (val === 0) {
    return 0;
  }

  var exp = Math.floor(Math.log(val) / Math.LN10);
  /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */

  if (val / Math.pow(10, exp) >= 10) {
    exp++;
  }

  return exp;
}
/**
 * find a “nice” number approximately equal to x. Round the number if round = true,
 * take ceiling if round = false. The primary observation is that the “nicest”
 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
 *
 * See "Nice Numbers for Graph Labels" of Graphic Gems.
 *
 * @param  val Non-negative value.
 * @param  round
 * @return Niced number
 */

function nice(val, round) {
  var exponent = quantityExponent(val);
  var exp10 = Math.pow(10, exponent);
  var f = val / exp10; // 1 <= f < 10

  var nf;

  if (round) {
    if (f < 1.5) {
      nf = 1;
    } else if (f < 2.5) {
      nf = 2;
    } else if (f < 4) {
      nf = 3;
    } else if (f < 7) {
      nf = 5;
    } else {
      nf = 10;
    }
  } else {
    if (f < 1) {
      nf = 1;
    } else if (f < 2) {
      nf = 2;
    } else if (f < 3) {
      nf = 3;
    } else if (f < 5) {
      nf = 5;
    } else {
      nf = 10;
    }
  }

  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
  // 20 is the uppper bound of toFixed.

  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
/**
 * This code was copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
 * See the license statement at the head of this file.
 * @param ascArr
 */

function quantile(ascArr, p) {
  var H = (ascArr.length - 1) * p + 1;
  var h = Math.floor(H);
  var v = +ascArr[h - 1];
  var e = H - h;
  return e ? v + e * (ascArr[h] - v) : v;
}
/**
 * Order intervals asc, and split them when overlap.
 * expect(numberUtil.reformIntervals([
 *     {interval: [18, 62], close: [1, 1]},
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [1, 1]},
 *     {interval: [62, 150], close: [1, 1]},
 *     {interval: [106, 150], close: [1, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ])).toEqual([
 *     {interval: [-Infinity, -70], close: [0, 0]},
 *     {interval: [-70, -26], close: [1, 1]},
 *     {interval: [-26, 18], close: [0, 1]},
 *     {interval: [18, 62], close: [0, 1]},
 *     {interval: [62, 150], close: [0, 1]},
 *     {interval: [150, Infinity], close: [0, 0]}
 * ]);
 * @param list, where `close` mean open or close
 *        of the interval, and Infinity can be used.
 * @return The origin list, which has been reformed.
 */

function reformIntervals(list) {
  list.sort(function (a, b) {
    return littleThan(a, b, 0) ? -1 : 1;
  });
  var curr = -Infinity;
  var currClose = 1;

  for (var i = 0; i < list.length;) {
    var interval = list[i].interval;
    var close_1 = list[i].close;

    for (var lg = 0; lg < 2; lg++) {
      if (interval[lg] <= curr) {
        interval[lg] = curr;
        close_1[lg] = !lg ? 1 - currClose : 1;
      }

      curr = interval[lg];
      currClose = close_1[lg];
    }

    if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) {
      list.splice(i, 1);
    } else {
      i++;
    }
  }

  return list;

  function littleThan(a, b, lg) {
    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
  }
}
/**
 * [Numeric is defined as]:
 *     `parseFloat(val) == val`
 * For example:
 * numeric:
 *     typeof number except NaN, '-123', '123', '2e3', '-2e3', '011', 'Infinity', Infinity,
 *     and they rounded by white-spaces or line-terminal like ' -123 \n ' (see es spec)
 * not-numeric:
 *     null, undefined, [], {}, true, false, 'NaN', NaN, '123ab',
 *     empty string, string with only white-spaces or line-terminal (see es spec),
 *     0x12, '0x12', '-0x12', 012, '012', '-012',
 *     non-string, ...
 *
 * @test See full test cases in `test/ut/spec/util/number.js`.
 * @return Must be a typeof number. If not numeric, return NaN.
 */

function numericToNumber(val) {
  var valFloat = parseFloat(val);
  return valFloat == val // eslint-disable-line eqeqeq
  && (valFloat !== 0 || !isString(val) || val.indexOf('x') <= 0) // For case ' 0x0 '.
  ? valFloat : NaN;
}
/**
 * Definition of "numeric": see `numericToNumber`.
 */

function isNumeric$1(val) {
  return !isNaN(numericToNumber(val));
}
/**
 * Use random base to prevent users hard code depending on
 * this auto generated marker id.
 * @return An positive integer.
 */

function getRandomIdBase() {
  return Math.round(Math.random() * 9);
}
/**
 * Get the greatest common divisor.
 *
 * @param {number} a one number
 * @param {number} b the other number
 */

function getGreatestCommonDividor(a, b) {
  if (b === 0) {
    return a;
  }

  return getGreatestCommonDividor(b, a % b);
}
/**
 * Get the least common multiple.
 *
 * @param {number} a one number
 * @param {number} b the other number
 */

function getLeastCommonMultiple(a, b) {
  if (a == null) {
    return b;
  }

  if (b == null) {
    return a;
  }

  return a * b / getGreatestCommonDividor(a, b);
}

var ECHARTS_PREFIX = '[ECharts] ';
var storedLogs = {};
var hasConsole = typeof console !== 'undefined' // eslint-disable-next-line
&& console.warn && console.log;

function outputLog(type, str, onlyOnce) {
  if (hasConsole) {
    if (onlyOnce) {
      if (storedLogs[str]) {
        return;
      }

      storedLogs[str] = true;
    } // eslint-disable-next-line


    console[type](ECHARTS_PREFIX + str);
  }
}

function log(str, onlyOnce) {
  outputLog('log', str, onlyOnce);
}
function warn(str, onlyOnce) {
  outputLog('warn', str, onlyOnce);
}
function error(str, onlyOnce) {
  outputLog('error', str, onlyOnce);
}
function deprecateLog(str) {
  if (process.env.NODE_ENV !== 'production') {
    // Not display duplicate message.
    outputLog('warn', 'DEPRECATED: ' + str, true);
  }
}
function deprecateReplaceLog(oldOpt, newOpt, scope) {
  if (process.env.NODE_ENV !== 'production') {
    deprecateLog((scope ? "[" + scope + "]" : '') + (oldOpt + " is deprecated, use " + newOpt + " instead."));
  }
}
/**
 * If in __DEV__ environment, get console printable message for users hint.
 * Parameters are separated by ' '.
 * @usage
 * makePrintable('This is an error on', someVar, someObj);
 *
 * @param hintInfo anything about the current execution context to hint users.
 * @throws Error
 */

function makePrintable() {
  var hintInfo = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    hintInfo[_i] = arguments[_i];
  }

  var msg = '';

  if (process.env.NODE_ENV !== 'production') {
    // Fuzzy stringify for print.
    // This code only exist in dev environment.
    var makePrintableStringIfPossible_1 = function (val) {
      return val === void 0 ? 'undefined' : val === Infinity ? 'Infinity' : val === -Infinity ? '-Infinity' : eqNaN(val) ? 'NaN' : val instanceof Date ? 'Date(' + val.toISOString() + ')' : isFunction$3(val) ? 'function () { ... }' : isRegExp(val) ? val + '' : null;
    };

    msg = map(hintInfo, function (arg) {
      if (isString(arg)) {
        // Print without quotation mark for some statement.
        return arg;
      } else {
        var printableStr = makePrintableStringIfPossible_1(arg);

        if (printableStr != null) {
          return printableStr;
        } else if (typeof JSON !== 'undefined' && JSON.stringify) {
          try {
            return JSON.stringify(arg, function (n, val) {
              var printableStr = makePrintableStringIfPossible_1(val);
              return printableStr == null ? val : printableStr;
            }); // In most cases the info object is small, so do not line break.
          } catch (err) {
            return '?';
          }
        } else {
          return '?';
        }
      }
    }).join(' ');
  }

  return msg;
}
/**
 * @throws Error
 */

function throwError(msg) {
  throw new Error(msg);
}

function interpolateNumber$1(p0, p1, percent) {
  return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */


var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
/**
 * If value is not array, then translate it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */

function normalizeToArray(value) {
  return value instanceof Array ? value : value == null ? [] : [value];
}
/**
 * Sync default option between normal and emphasis like `position` and `show`
 * In case some one will write code like
 *     label: {
 *          show: false,
 *          position: 'outside',
 *          fontSize: 18
 *     },
 *     emphasis: {
 *          label: { show: true }
 *     }
 */

function defaultEmphasis(opt, key, subOpts) {
  // Caution: performance sensitive.
  if (opt) {
    opt[key] = opt[key] || {};
    opt.emphasis = opt.emphasis || {};
    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal

    for (var i = 0, len = subOpts.length; i < len; i++) {
      var subOptName = subOpts[i];

      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
        opt.emphasis[key][subOptName] = opt[key][subOptName];
      }
    }
  }
}
var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
//     // FIXME: deprecated, check and remove it.
//     'textStyle'
// ]);

/**
 * The method does not ensure performance.
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method retrieves value from data.
 */

function getDataItemValue(dataItem) {
  return isObject$2(dataItem) && !isArray$1(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
/**
 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
 * This helper method determine if dataItem has extra option besides value
 */

function isDataItemOption(dataItem) {
  return isObject$2(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
/**
 * Mapping to existings for merge.
 *
 * Mode "normalMege":
 *     The mapping result (merge result) will keep the order of the existing
 *     component, rather than the order of new option. Because we should ensure
 *     some specified index reference (like xAxisIndex) keep work.
 *     And in most cases, "merge option" is used to update partial option but not
 *     be expected to change the order.
 *
 * Mode "replaceMege":
 *     (1) Only the id mapped components will be merged.
 *     (2) Other existing components (except internal components) will be removed.
 *     (3) Other new options will be used to create new component.
 *     (4) The index of the existing components will not be modified.
 *     That means their might be "hole" after the removal.
 *     The new components are created first at those available index.
 *
 * Mode "replaceAll":
 *     This mode try to support that reproduce an echarts instance from another
 *     echarts instance (via `getOption`) in some simple cases.
 *     In this scenario, the `result` index are exactly the consistent with the `newCmptOptions`,
 *     which ensures the component index referring (like `xAxisIndex: ?`) corrent. That is,
 *     the "hole" in `newCmptOptions` will also be kept.
 *     On the contrary, other modes try best to eliminate holes.
 *     PENDING: This is an experimental mode yet.
 *
 * @return See the comment of <MappingResult>.
 */

function mappingToExists(existings, newCmptOptions, mode) {
  var isNormalMergeMode = mode === 'normalMerge';
  var isReplaceMergeMode = mode === 'replaceMerge';
  var isReplaceAllMode = mode === 'replaceAll';
  existings = existings || [];
  newCmptOptions = (newCmptOptions || []).slice();
  var existingIdIdxMap = createHashMap(); // Validate id and name on user input option.

  each(newCmptOptions, function (cmptOption, index) {
    if (!isObject$2(cmptOption)) {
      newCmptOptions[index] = null;
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      // There is some legacy case that name is set as `false`.
      // But should work normally rather than throw error.
      if (cmptOption.id != null && !isValidIdOrName(cmptOption.id)) {
        warnInvalidateIdOrName(cmptOption.id);
      }

      if (cmptOption.name != null && !isValidIdOrName(cmptOption.name)) {
        warnInvalidateIdOrName(cmptOption.name);
      }
    }
  });
  var result = prepareResult(existings, existingIdIdxMap, mode);

  if (isNormalMergeMode || isReplaceMergeMode) {
    mappingById(result, existings, existingIdIdxMap, newCmptOptions);
  }

  if (isNormalMergeMode) {
    mappingByName(result, newCmptOptions);
  }

  if (isNormalMergeMode || isReplaceMergeMode) {
    mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
  } else if (isReplaceAllMode) {
    mappingInReplaceAllMode(result, newCmptOptions);
  }

  makeIdAndName(result); // The array `result` MUST NOT contain elided items, otherwise the
  // forEach will omit those items and result in incorrect result.

  return result;
}

function prepareResult(existings, existingIdIdxMap, mode) {
  var result = [];

  if (mode === 'replaceAll') {
    return result;
  } // Do not use native `map` to in case that the array `existings`
  // contains elided items, which will be omitted.


  for (var index = 0; index < existings.length; index++) {
    var existing = existings[index]; // Because of replaceMerge, `existing` may be null/undefined.

    if (existing && existing.id != null) {
      existingIdIdxMap.set(existing.id, index);
    } // For non-internal-componnets:
    //     Mode "normalMerge": all existings kept.
    //     Mode "replaceMerge": all existing removed unless mapped by id.
    // For internal-components:
    //     go with "replaceMerge" approach in both mode.


    result.push({
      existing: mode === 'replaceMerge' || isComponentIdInternal(existing) ? null : existing,
      newOption: null,
      keyInfo: null,
      brandNew: null
    });
  }

  return result;
}

function mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
  // Mapping by id if specified.
  each(newCmptOptions, function (cmptOption, index) {
    if (!cmptOption || cmptOption.id == null) {
      return;
    }

    var optionId = makeComparableKey(cmptOption.id);
    var existingIdx = existingIdIdxMap.get(optionId);

    if (existingIdx != null) {
      var resultItem = result[existingIdx];
      assert(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
      resultItem.newOption = cmptOption; // In both mode, if id matched, new option will be merged to
      // the existings rather than creating new component model.

      resultItem.existing = existings[existingIdx];
      newCmptOptions[index] = null;
    }
  });
}

function mappingByName(result, newCmptOptions) {
  // Mapping by name if specified.
  each(newCmptOptions, function (cmptOption, index) {
    if (!cmptOption || cmptOption.name == null) {
      return;
    }

    for (var i = 0; i < result.length; i++) {
      var existing = result[i].existing;

      if (!result[i].newOption // Consider name: two map to one.
      // Can not match when both ids existing but different.
      && existing && (existing.id == null || cmptOption.id == null) && !isComponentIdInternal(cmptOption) && !isComponentIdInternal(existing) && keyExistAndEqual('name', existing, cmptOption)) {
        result[i].newOption = cmptOption;
        newCmptOptions[index] = null;
        return;
      }
    }
  });
}

function mappingByIndex(result, newCmptOptions, brandNew) {
  each(newCmptOptions, function (cmptOption) {
    if (!cmptOption) {
      return;
    } // Find the first place that not mapped by id and not internal component (consider the "hole").


    var resultItem;
    var nextIdx = 0;

    while ( // Be `!resultItem` only when `nextIdx >= result.length`.
    (resultItem = result[nextIdx]) && ( // (1) Existing models that already have id should be able to mapped to. Because
    // after mapping performed, model will always be assigned with an id if user not given.
    // After that all models have id.
    // (2) If new option has id, it can only set to a hole or append to the last. It should
    // not be merged to the existings with different id. Because id should not be overwritten.
    // (3) Name can be overwritten, because axis use name as 'show label text'.
    resultItem.newOption || isComponentIdInternal(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
    resultItem.existing && cmptOption.id != null && !keyExistAndEqual('id', cmptOption, resultItem.existing))) {
      nextIdx++;
    }

    if (resultItem) {
      resultItem.newOption = cmptOption;
      resultItem.brandNew = brandNew;
    } else {
      result.push({
        newOption: cmptOption,
        brandNew: brandNew,
        existing: null,
        keyInfo: null
      });
    }

    nextIdx++;
  });
}

function mappingInReplaceAllMode(result, newCmptOptions) {
  each(newCmptOptions, function (cmptOption) {
    // The feature "reproduce" requires "hole" will also reproduced
    // in case that component index referring are broken.
    result.push({
      newOption: cmptOption,
      brandNew: true,
      existing: null,
      keyInfo: null
    });
  });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */


function makeIdAndName(mapResult) {
  // We use this id to hash component models and view instances
  // in echarts. id can be specified by user, or auto generated.
  // The id generation rule ensures new view instance are able
  // to mapped to old instance when setOption are called in
  // no-merge mode. So we generate model id by name and plus
  // type in view id.
  // name can be duplicated among components, which is convenient
  // to specify multi components (like series) by one name.
  // Ensure that each id is distinct.
  var idMap = createHashMap();
  each(mapResult, function (item) {
    var existing = item.existing;
    existing && idMap.set(existing.id, item);
  });
  each(mapResult, function (item) {
    var opt = item.newOption; // Force ensure id not duplicated.

    assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
    opt && opt.id != null && idMap.set(opt.id, item);
    !item.keyInfo && (item.keyInfo = {});
  }); // Make name and id.

  each(mapResult, function (item, index) {
    var existing = item.existing;
    var opt = item.newOption;
    var keyInfo = item.keyInfo;

    if (!isObject$2(opt)) {
      return;
    } // Name can be overwritten. Consider case: axis.name = '20km'.
    // But id generated by name will not be changed, which affect
    // only in that case: setOption with 'not merge mode' and view
    // instance will be recreated, which can be accepted.


    keyInfo.name = opt.name != null ? makeComparableKey(opt.name) : existing ? existing.name // Avoid that different series has the same name,
    // because name may be used like in color pallet.
    : DUMMY_COMPONENT_NAME_PREFIX + index;

    if (existing) {
      keyInfo.id = makeComparableKey(existing.id);
    } else if (opt.id != null) {
      keyInfo.id = makeComparableKey(opt.id);
    } else {
      // Consider this situatoin:
      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
      // Series with the same name between optionA and optionB
      // should be mapped.
      var idNum = 0;

      do {
        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
      } while (idMap.get(keyInfo.id));
    }

    idMap.set(keyInfo.id, item);
  });
}

function keyExistAndEqual(attr, obj1, obj2) {
  var key1 = convertOptionIdName(obj1[attr], null);
  var key2 = convertOptionIdName(obj2[attr], null); // See `MappingExistingItem`. `id` and `name` trade string equals to number.

  return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */


function makeComparableKey(val) {
  if (process.env.NODE_ENV !== 'production') {
    if (val == null) {
      throw new Error();
    }
  }

  return convertOptionIdName(val, '');
}

function convertOptionIdName(idOrName, defaultValue) {
  if (idOrName == null) {
    return defaultValue;
  }

  return isString(idOrName) ? idOrName : isNumber$1(idOrName) || isStringSafe(idOrName) ? idOrName + '' : defaultValue;
}

function warnInvalidateIdOrName(idOrName) {
  if (process.env.NODE_ENV !== 'production') {
    warn('`' + idOrName + '` is invalid id or name. Must be a string or number.');
  }
}

function isValidIdOrName(idOrName) {
  return isStringSafe(idOrName) || isNumeric$1(idOrName);
}

function isNameSpecified(componentModel) {
  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.

  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
}
/**
 * @public
 * @param {Object} cmptOption
 * @return {boolean}
 */

function isComponentIdInternal(cmptOption) {
  return cmptOption && cmptOption.id != null && makeComparableKey(cmptOption.id).indexOf(INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function makeInternalComponentId(idSuffix) {
  return INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function setComponentTypeToKeyInfo(mappingResult, mainType, componentModelCtor) {
  // Set mainType and complete subType.
  each(mappingResult, function (item) {
    var newOption = item.newOption;

    if (isObject$2(newOption)) {
      item.keyInfo.mainType = mainType;
      item.keyInfo.subType = determineSubType(mainType, newOption, item.existing, componentModelCtor);
    }
  });
}

function determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
  var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
  : componentModelCtor.determineSubType(mainType, newCmptOption); // tooltip, markline, markpoint may always has no subType

  return subType;
}
/**
 * A helper for removing duplicate items between batchA and batchB,
 * and in themselves, and categorize by series.
 *
 * @param batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @param batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
 * @return result: [resultBatchA, resultBatchB]
 */


function compressBatches(batchA, batchB) {
  var mapA = {};
  var mapB = {};
  makeMap(batchA || [], mapA);
  makeMap(batchB || [], mapB, mapA);
  return [mapToArray(mapA), mapToArray(mapB)];

  function makeMap(sourceBatch, map, otherMap) {
    for (var i = 0, len = sourceBatch.length; i < len; i++) {
      var seriesId = convertOptionIdName(sourceBatch[i].seriesId, null);

      if (seriesId == null) {
        return;
      }

      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
      var otherDataIndices = otherMap && otherMap[seriesId];

      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
        var dataIndex = dataIndices[j];

        if (otherDataIndices && otherDataIndices[dataIndex]) {
          otherDataIndices[dataIndex] = null;
        } else {
          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
        }
      }
    }
  }

  function mapToArray(map, isData) {
    var result = [];

    for (var i in map) {
      if (map.hasOwnProperty(i) && map[i] != null) {
        if (isData) {
          result.push(+i);
        } else {
          var dataIndices = mapToArray(map[i], true);
          dataIndices.length && result.push({
            seriesId: i,
            dataIndex: dataIndices
          });
        }
      }
    }

    return result;
  }
}
/**
 * @param payload Contains dataIndex (means rawIndex) / dataIndexInside / name
 *                         each of which can be Array or primary type.
 * @return dataIndex If not found, return undefined/null.
 */

function queryDataIndex(data, payload) {
  if (payload.dataIndexInside != null) {
    return payload.dataIndexInside;
  } else if (payload.dataIndex != null) {
    return isArray$1(payload.dataIndex) ? map(payload.dataIndex, function (value) {
      return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
  } else if (payload.name != null) {
    return isArray$1(payload.name) ? map(payload.name, function (value) {
      return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
  }
}
/**
 * Enable property storage to any host object.
 * Notice: Serialization is not supported.
 *
 * For example:
 * let inner = zrUitl.makeInner();
 *
 * function some1(hostObj) {
 *      inner(hostObj).someProperty = 1212;
 *      ...
 * }
 * function some2() {
 *      let fields = inner(this);
 *      fields.someProperty1 = 1212;
 *      fields.someProperty2 = 'xx';
 *      ...
 * }
 *
 * @return {Function}
 */

function makeInner() {
  var key = '__ec_inner_' + innerUniqueIndex++;
  return function (hostObj) {
    return hostObj[key] || (hostObj[key] = {});
  };
}
var innerUniqueIndex = getRandomIdBase();
/**
 * The same behavior as `component.getReferringComponents`.
 */

function parseFinder(ecModel, finderInput, opt) {
  var _a = preParseFinder(finderInput, opt),
      mainTypeSpecified = _a.mainTypeSpecified,
      queryOptionMap = _a.queryOptionMap,
      others = _a.others;

  var result = others;
  var defaultMainType = opt ? opt.defaultMainType : null;

  if (!mainTypeSpecified && defaultMainType) {
    queryOptionMap.set(defaultMainType, {});
  }

  queryOptionMap.each(function (queryOption, mainType) {
    var queryResult = queryReferringComponents(ecModel, mainType, queryOption, {
      useDefault: defaultMainType === mainType,
      enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
      enableNone: opt && opt.enableNone != null ? opt.enableNone : true
    });
    result[mainType + 'Models'] = queryResult.models;
    result[mainType + 'Model'] = queryResult.models[0];
  });
  return result;
}
function preParseFinder(finderInput, opt) {
  var finder;

  if (isString(finderInput)) {
    var obj = {};
    obj[finderInput + 'Index'] = 0;
    finder = obj;
  } else {
    finder = finderInput;
  }

  var queryOptionMap = createHashMap();
  var others = {};
  var mainTypeSpecified = false;
  each(finder, function (value, key) {
    // Exclude 'dataIndex' and other illgal keys.
    if (key === 'dataIndex' || key === 'dataIndexInside') {
      others[key] = value;
      return;
    }

    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
    var mainType = parsedKey[1];
    var queryType = (parsedKey[2] || '').toLowerCase();

    if (!mainType || !queryType || opt && opt.includeMainTypes && indexOf(opt.includeMainTypes, mainType) < 0) {
      return;
    }

    mainTypeSpecified = mainTypeSpecified || !!mainType;
    var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
    queryOption[queryType] = value;
  });
  return {
    mainTypeSpecified: mainTypeSpecified,
    queryOptionMap: queryOptionMap,
    others: others
  };
}
var SINGLE_REFERRING = {
  useDefault: true,
  enableAll: false,
  enableNone: false
};
var MULTIPLE_REFERRING = {
  useDefault: false,
  enableAll: true,
  enableNone: true
};
function queryReferringComponents(ecModel, mainType, userOption, opt) {
  opt = opt || SINGLE_REFERRING;
  var indexOption = userOption.index;
  var idOption = userOption.id;
  var nameOption = userOption.name;
  var result = {
    models: null,
    specified: indexOption != null || idOption != null || nameOption != null
  };

  if (!result.specified) {
    // Use the first as default if `useDefault`.
    var firstCmpt = void 0;
    result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [firstCmpt] : [];
    return result;
  }

  if (indexOption === 'none' || indexOption === false) {
    assert(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
    result.models = [];
    return result;
  } // `queryComponents` will return all components if
  // both all of index/id/name are null/undefined.


  if (indexOption === 'all') {
    assert(opt.enableAll, '`"all"` is not a valid value on index option.');
    indexOption = idOption = nameOption = null;
  }

  result.models = ecModel.queryComponents({
    mainType: mainType,
    index: indexOption,
    id: idOption,
    name: nameOption
  });
  return result;
}
function setAttribute(dom, key, value) {
  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function getAttribute(dom, key) {
  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function getTooltipRenderMode(renderModeOption) {
  if (renderModeOption === 'auto') {
    // Using html when `document` exists, use richText otherwise
    return env.domSupported ? 'html' : 'richText';
  } else {
    return renderModeOption || 'html';
  }
}
/**
 * Group a list by key.
 */

function groupData(array, getKey // return key
) {
  var buckets = createHashMap();
  var keys = [];
  each(array, function (item) {
    var key = getKey(item);
    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
  });
  return {
    keys: keys,
    buckets: buckets
  };
}
/**
 * Interpolate raw values of a series with percent
 *
 * @param data         data
 * @param labelModel   label model of the text element
 * @param sourceValue  start value. May be null/undefined when init.
 * @param targetValue  end value
 * @param percent      0~1 percentage; 0 uses start value while 1 uses end value
 * @return             interpolated values
 *                     If `sourceValue` and `targetValue` are `number`, return `number`.
 *                     If `sourceValue` and `targetValue` are `string`, return `string`.
 *                     If `sourceValue` and `targetValue` are `(string | number)[]`, return `(string | number)[]`.
 *                     Other cases do not supported.
 */

function interpolateRawValues(data, precision, sourceValue, targetValue, percent) {
  var isAutoPrecision = precision == null || precision === 'auto';

  if (targetValue == null) {
    return targetValue;
  }

  if (isNumber$1(targetValue)) {
    var value = interpolateNumber$1(sourceValue || 0, targetValue, percent);
    return round$3(value, isAutoPrecision ? Math.max(getPrecision(sourceValue || 0), getPrecision(targetValue)) : precision);
  } else if (isString(targetValue)) {
    return percent < 1 ? sourceValue : targetValue;
  } else {
    var interpolated = [];
    var leftArr = sourceValue;
    var rightArr = targetValue;
    var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);

    for (var i = 0; i < length_1; ++i) {
      var info = data.getDimensionInfo(i); // Don't interpolate ordinal dims

      if (info && info.type === 'ordinal') {
        // In init, there is no `sourceValue`, but should better not to get undefined result.
        interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
      } else {
        var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
        var rightVal = rightArr[i];
        var value = interpolateNumber$1(leftVal, rightVal, percent);
        interpolated[i] = round$3(value, isAutoPrecision ? Math.max(getPrecision(leftVal), getPrecision(rightVal)) : precision);
      }
    }

    return interpolated;
  }
}

var TYPE_DELIMITER = '.';
var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
/**
 * Notice, parseClassType('') should returns {main: '', sub: ''}
 * @public
 */

function parseClassType(componentType) {
  var ret = {
    main: '',
    sub: ''
  };

  if (componentType) {
    var typeArr = componentType.split(TYPE_DELIMITER);
    ret.main = typeArr[0] || '';
    ret.sub = typeArr[1] || '';
  }

  return ret;
}
/**
 * @public
 */

function checkClassType(componentType) {
  assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}

function isExtendedClass(clz) {
  return !!(clz && clz[IS_EXTENDED_CLASS]);
}
/**
 * Implements `ExtendableConstructor` for `rootClz`.
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & ExtendableConstructor
 * enableClassExtend(Xxx as XxxConstructor);
 * ```
 */

function enableClassExtend(rootClz, mandatoryMethods) {
  rootClz.$constructor = rootClz; // FIXME: not necessary?

  rootClz.extend = function (proto) {
    if (process.env.NODE_ENV !== 'production') {
      each(mandatoryMethods, function (method) {
        if (!proto[method]) {
          console.warn('Method `' + method + '` should be implemented' + (proto.type ? ' in ' + proto.type : '') + '.');
        }
      });
    }

    var superClass = this;
    var ExtendedClass;

    if (isESClass(superClass)) {
      ExtendedClass =
      /** @class */
      function (_super) {
        __extends$1(class_1, _super);

        function class_1() {
          return _super.apply(this, arguments) || this;
        }

        return class_1;
      }(superClass);
    } else {
      // For backward compat, we both support ts class inheritance and this
      // "extend" approach.
      // The constructor should keep the same behavior as ts class inheritance:
      // If this constructor/$constructor is not declared, auto invoke the super
      // constructor.
      // If this constructor/$constructor is declared, it is responsible for
      // calling the super constructor.
      ExtendedClass = function () {
        (proto.$constructor || superClass).apply(this, arguments);
      };

      inherits(ExtendedClass, this);
    }

    extend(ExtendedClass.prototype, proto);
    ExtendedClass[IS_EXTENDED_CLASS] = true;
    ExtendedClass.extend = this.extend;
    ExtendedClass.superCall = superCall;
    ExtendedClass.superApply = superApply;
    ExtendedClass.superClass = superClass;
    return ExtendedClass;
  };
}

function isESClass(fn) {
  return isFunction$3(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
/**
 * A work around to both support ts extend and this extend mechanism.
 * on sub-class.
 * @usage
 * ```ts
 * class Component { ... }
 * classUtil.enableClassExtend(Component);
 * classUtil.enableClassManagement(Component, {registerWhenExtend: true});
 *
 * class Series extends Component { ... }
 * // Without calling `markExtend`, `registerWhenExtend` will not work.
 * Component.markExtend(Series);
 * ```
 */


function mountExtend(SubClz, SupperClz) {
  SubClz.extend = SupperClz.extend;
} // A random offset.

var classBase = Math.round(Math.random() * 10);
/**
 * Implements `CheckableConstructor` for `target`.
 * Can not use instanceof, consider different scope by
 * cross domain or es module import in ec extensions.
 * Mount a method "isInstance()" to Clz.
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & CheckableConstructor;
 * enableClassCheck(Xxx as XxxConstructor)
 * ```
 */

function enableClassCheck(target) {
  var classAttr = ['__\0is_clz', classBase++].join('_');
  target.prototype[classAttr] = true;

  if (process.env.NODE_ENV !== 'production') {
    assert(!target.isInstance, 'The method "is" can not be defined.');
  }

  target.isInstance = function (obj) {
    return !!(obj && obj[classAttr]);
  };
} // superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.

function superCall(context, methodName) {
  var args = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    args[_i - 2] = arguments[_i];
  }

  return this.superClass.prototype[methodName].apply(context, args);
}

function superApply(context, methodName, args) {
  return this.superClass.prototype[methodName].apply(context, args);
}
/**
 * Implements `ClassManager` for `target`
 *
 * @usage
 * ```ts
 * class Xxx {}
 * type XxxConstructor = typeof Xxx & ClassManager
 * enableClassManagement(Xxx as XxxConstructor);
 * ```
 */


function enableClassManagement(target) {
  /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */
  var storage = {};

  target.registerClass = function (clz) {
    // `type` should not be a "instance member".
    // If using TS class, should better declared as `static type = 'series.pie'`.
    // otherwise users have to mount `type` on prototype manually.
    // For backward compat and enable instance visit type via `this.type`,
    // we still support fetch `type` from prototype.
    var componentFullType = clz.type || clz.prototype.type;

    if (componentFullType) {
      checkClassType(componentFullType); // If only static type declared, we assign it to prototype mandatorily.

      clz.prototype.type = componentFullType;
      var componentTypeInfo = parseClassType(componentFullType);

      if (!componentTypeInfo.sub) {
        if (process.env.NODE_ENV !== 'production') {
          if (storage[componentTypeInfo.main]) {
            console.warn(componentTypeInfo.main + ' exists.');
          }
        }

        storage[componentTypeInfo.main] = clz;
      } else if (componentTypeInfo.sub !== IS_CONTAINER) {
        var container = makeContainer(componentTypeInfo);
        container[componentTypeInfo.sub] = clz;
      }
    }

    return clz;
  };

  target.getClass = function (mainType, subType, throwWhenNotFound) {
    var clz = storage[mainType];

    if (clz && clz[IS_CONTAINER]) {
      clz = subType ? clz[subType] : null;
    }

    if (throwWhenNotFound && !clz) {
      throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
    }

    return clz;
  };

  target.getClassesByMainType = function (componentType) {
    var componentTypeInfo = parseClassType(componentType);
    var result = [];
    var obj = storage[componentTypeInfo.main];

    if (obj && obj[IS_CONTAINER]) {
      each(obj, function (o, type) {
        type !== IS_CONTAINER && result.push(o);
      });
    } else {
      result.push(obj);
    }

    return result;
  };

  target.hasClass = function (componentType) {
    // Just consider componentType.main.
    var componentTypeInfo = parseClassType(componentType);
    return !!storage[componentTypeInfo.main];
  };
  /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */


  target.getAllClassMainTypes = function () {
    var types = [];
    each(storage, function (obj, type) {
      types.push(type);
    });
    return types;
  };
  /**
   * If a main type is container and has sub types
   */


  target.hasSubTypes = function (componentType) {
    var componentTypeInfo = parseClassType(componentType);
    var obj = storage[componentTypeInfo.main];
    return obj && obj[IS_CONTAINER];
  };

  function makeContainer(componentTypeInfo) {
    var container = storage[componentTypeInfo.main];

    if (!container || !container[IS_CONTAINER]) {
      container = storage[componentTypeInfo.main] = {};
      container[IS_CONTAINER] = true;
    }

    return container;
  }
} // /**
//  * @param {string|Array.<string>} properties
//  */
// export function setReadOnly(obj, properties) {
// FIXME It seems broken in IE8 simulation of IE11
// if (!zrUtil.isArray(properties)) {
//     properties = properties != null ? [properties] : [];
// }
// zrUtil.each(properties, function (prop) {
//     let value = obj[prop];
//     Object.defineProperty
//         && Object.defineProperty(obj, prop, {
//             value: value, writable: false
//         });
//     zrUtil.isArray(obj[prop])
//         && Object.freeze
//         && Object.freeze(obj[prop]);
// });
// }

function makeStyleMapper(properties, ignoreParent) {
  // Normalize
  for (var i = 0; i < properties.length; i++) {
    if (!properties[i][1]) {
      properties[i][1] = properties[i][0];
    }
  }

  ignoreParent = ignoreParent || false;
  return function (model, excludes, includes) {
    var style = {};

    for (var i = 0; i < properties.length; i++) {
      var propName = properties[i][1];

      if (excludes && indexOf(excludes, propName) >= 0 || includes && indexOf(includes, propName) < 0) {
        continue;
      }

      var val = model.getShallow(propName, ignoreParent);

      if (val != null) {
        style[properties[i][0]] = val;
      }
    } // TODO Text or image?


    return style;
  };
}

var AREA_STYLE_KEY_MAP = [['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getAreaStyle = makeStyleMapper(AREA_STYLE_KEY_MAP);

var AreaStyleMixin =
/** @class */
function () {
  function AreaStyleMixin() {}

  AreaStyleMixin.prototype.getAreaStyle = function (excludes, includes) {
    return getAreaStyle(this, excludes, includes);
  };

  return AreaStyleMixin;
}();

var globalImageCache = new LRU(50);
function findExistImage(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    }
    else {
        return newImageOrSrc;
    }
}
function createOrUpdateImage(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) {
        return image;
    }
    else if (typeof newImageOrSrc === 'string') {
        if ((image && image.__zrImageSrc === newImageOrSrc) || !hostEl) {
            return image;
        }
        var cachedImgObj = globalImageCache.get(newImageOrSrc);
        var pendingWrap = { hostEl: hostEl, cb: onload, cbPayload: cbPayload };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
        }
        else {
            image = platformApi.loadImage(newImageOrSrc, imageOnLoad, imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [pendingWrap]
            });
        }
        return image;
    }
    else {
        return newImageOrSrc;
    }
}
function imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for (var i = 0; i < cachedImgObj.pending.length; i++) {
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function isImageReady(image) {
    return image && image.width && image.height;
}

var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function truncateText(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        return '';
    }
    var textLines = (text + '').split('\n');
    options = prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for (var i = 0, len = textLines.length; i < len; i++) {
        textLines[i] = truncateSingleLine(textLines[i], options);
    }
    return textLines.join('\n');
}
function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = extend({}, options);
    preparedOpts.font = font;
    ellipsis = retrieve2(ellipsis, '...');
    preparedOpts.maxIterations = retrieve2(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = retrieve2(options.minChar, 0);
    preparedOpts.cnCharWidth = getWidth('国', font);
    var ascCharWidth = preparedOpts.ascCharWidth = getWidth('a', font);
    preparedOpts.placeholder = retrieve2(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
        contentWidth -= ascCharWidth;
    }
    var ellipsisWidth = getWidth(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) {
        return '';
    }
    var lineWidth = getWidth(textLine, font);
    if (lineWidth <= containerWidth) {
        return textLine;
    }
    for (var j = 0;; j++) {
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0
            ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth)
            : lineWidth > 0
                ? Math.floor(textLine.length * contentWidth / lineWidth)
                : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = getWidth(textLine, font);
    }
    if (textLine === '') {
        textLine = options.placeholder;
    }
    return textLine;
}
function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for (var len = text.length; i < len && width < contentWidth; i++) {
        var charCode = text.charCodeAt(i);
        width += (0 <= charCode && charCode <= 127) ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function parsePlainText(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = getLineHeight(font);
    var lineHeight = retrieve2(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!(style.backgroundColor);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var width = style.width;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) {
        lines = text ? wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    }
    else {
        lines = text ? text.split('\n') : [];
    }
    var contentHeight = lines.length * lineHeight;
    var height = retrieve2(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for (var i = 0; i < lines.length; i++) {
            lines[i] = truncateSingleLine(lines[i], options);
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    for (var i = 0; i < lines.length; i++) {
        contentWidth = Math.max(getWidth(lines[i], font), contentWidth);
    }
    if (width == null) {
        width = contentWidth;
    }
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) {
        outerWidth = width;
    }
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width
    };
}
var RichTextToken = (function () {
    function RichTextToken() {
    }
    return RichTextToken;
}());
var RichTextLine = (function () {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) {
            this.tokens = tokens;
        }
    }
    return RichTextLine;
}());
var RichTextContentBlock = (function () {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}());
function parseRichText(text, style) {
    var contentBlock = new RichTextContentBlock();
    text != null && (text += '');
    if (!text) {
        return contentBlock;
    }
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null
        ? { width: topWidth, accumWidth: 0, breakAll: overflow === 'breakAll' }
        : null;
    var lastIndex = STYLE_REG.lastIndex = 0;
    var result;
    while ((result = STYLE_REG.exec(text)) != null) {
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) {
            pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        }
        pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) {
        pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    }
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for (var i = 0; i < contentBlock.lines.length; i++) {
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for (var j = 0; j < line.tokens.length; j++) {
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = getLineHeight(font);
            var tokenHeight = retrieve2(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = retrieve3(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                }
                else {
                    contentBlock.lines = contentBlock.lines.slice(0, i);
                }
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = getWidth(token.text, font);
            }
            else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = findExistImage(bgImg);
                        if (isImageReady(bgImg)) {
                            token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                        }
                    }
                }
                var remainTruncWidth = truncate && topWidth != null
                    ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    }
                    else {
                        token.text = truncateText(token.text, remainTruncWidth - paddingH, font, style.ellipsis, { minChar: style.truncateMinChar });
                        token.width = token.contentWidth = getWidth(token.text, font);
                    }
                }
                else {
                    token.contentWidth = getWidth(token.text, font);
                }
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = retrieve2(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = retrieve2(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for (var i = 0; i < pendingList.length; i++) {
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = parsePercent(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        }
        else {
            var res = wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    else {
        strLines = str.split('\n');
    }
    for (var i = 0; i < strLines.length; i++) {
        var text = strLines[i];
        var token = new RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') {
            token.width = tokenStyle.width;
        }
        else {
            token.width = linesWidths
                ? linesWidths[i]
                : getWidth(text, font);
        }
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new RichTextLine())).tokens;
            var tokensLen = tokens.length;
            (tokensLen === 1 && tokens[0].isLineHolder)
                ? (tokens[0] = token)
                : ((text || !tokensLen || isEmptyStr) && tokens.push(token));
        }
        else {
            lines.push(new RichTextLine([token]));
        }
    }
}
function isLatin(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x21 && code <= 0x17F;
}
var breakCharMap = reduce$6(',&?/;] '.split(''), function (obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function isWordBreakChar(ch) {
    if (isLatin(ch)) {
        if (breakCharMap[ch]) {
            return true;
        }
        return false;
    }
    return true;
}
function wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for (var i = 0; i < text.length; i++) {
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = getWidth(ch, font);
        var inWord = isBreakAll ? false : !isWordBreakChar(ch);
        if (!lines.length
            ? lastAccumWidth + accumWidth + chWidth > lineWidth
            : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                }
                else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            }
            else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                }
                else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        }
        else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) {
        line += currentWord;
    }
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) {
        accumWidth += lastAccumWidth;
    }
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}

var STYLE_MAGIC_KEY = '__zr_style_' + Math.round((Math.random() * 10));
var DEFAULT_COMMON_STYLE = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var DEFAULT_COMMON_ANIMATION_PROPS = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
DEFAULT_COMMON_STYLE[STYLE_MAGIC_KEY] = true;
var PRIMARY_STATES_KEYS$1 = ['z', 'z2', 'invisible'];
var PRIMARY_STATES_KEYS_IN_HOVER_LAYER = ['invisible'];
var Displayable = (function (_super) {
    __extends$1(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function (props) {
        var keysArr = keys$2(props);
        for (var i = 0; i < keysArr.length; i++) {
            var key = keysArr[i];
            if (key === 'style') {
                this.useStyle(props[key]);
            }
            else {
                _super.prototype.attrKV.call(this, key, props[key]);
            }
        }
        if (!this.style) {
            this.useStyle({});
        }
    };
    Displayable.prototype.beforeBrush = function () { };
    Displayable.prototype.afterBrush = function () { };
    Displayable.prototype.innerBeforeBrush = function () { };
    Displayable.prototype.innerAfterBrush = function () { };
    Displayable.prototype.shouldBePainted = function (viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore
            || this.invisible
            || this.style.opacity === 0
            || (this.culling
                && isDisplayableCulled(this, viewWidth, viewHeight))
            || (m && !m[0] && !m[3])) {
            return false;
        }
        if (considerClipPath && this.__clipPaths) {
            for (var i = 0; i < this.__clipPaths.length; ++i) {
                if (this.__clipPaths[i].isZeroArea()) {
                    return false;
                }
            }
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while (parent_1) {
                if (parent_1.ignore) {
                    return false;
                }
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function (x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function (cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function (x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function () {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new BoundingRect(0, 0, 0, 0));
            if (transform) {
                BoundingRect.applyTransform(rect, elRect, transform);
            }
            else {
                rect.copy(elRect);
            }
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function (paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new BoundingRect(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        }
        else {
            this._prevPaintRect = null;
        }
    };
    Displayable.prototype.getPrevPaintRect = function () {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function (loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function (targetKey) {
        if (targetKey === 'style') {
            this.dirtyStyle();
        }
        else {
            this.markRedraw();
        }
    };
    Displayable.prototype.attrKV = function (key, value) {
        if (key !== 'style') {
            _super.prototype.attrKV.call(this, key, value);
        }
        else {
            if (!this.style) {
                this.useStyle(value);
            }
            else {
                this.setStyle(value);
            }
        }
    };
    Displayable.prototype.setStyle = function (keyOrObj, value) {
        if (typeof keyOrObj === 'string') {
            this.style[keyOrObj] = value;
        }
        else {
            extend(this.style, keyOrObj);
        }
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function (notRedraw) {
        if (!notRedraw) {
            this.markRedraw();
        }
        this.__dirty |= STYLE_CHANGED_BIT;
        if (this._rect) {
            this._rect = null;
        }
    };
    Displayable.prototype.dirty = function () {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function () {
        return !!(this.__dirty & STYLE_CHANGED_BIT);
    };
    Displayable.prototype.styleUpdated = function () {
        this.__dirty &= ~STYLE_CHANGED_BIT;
    };
    Displayable.prototype.createStyle = function (obj) {
        return createObject(DEFAULT_COMMON_STYLE, obj);
    };
    Displayable.prototype.useStyle = function (obj) {
        if (!obj[STYLE_MAGIC_KEY]) {
            obj = this.createStyle(obj);
        }
        if (this.__inHover) {
            this.__hoverStyle = obj;
        }
        else {
            this.style = obj;
        }
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function (obj) {
        return obj[STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function (toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) {
            normalState.style = this._mergeStyle(this.createStyle(), this.style);
        }
        this._savePrimaryToNormal(toState, normalState, PRIMARY_STATES_KEYS$1);
    };
    Displayable.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) {
                    targetStyle = state.style;
                }
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            }
            else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        }
        else if (needsRestoreToNormal) {
            targetStyle = normalState.style;
        }
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = keys$2(sourceStyle);
                    for (var i = 0; i < changedKeys.length; i++) {
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = keys$2(targetStyle);
                for (var i = 0; i < targetKeys.length; i++) {
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            }
            else {
                this.useStyle(targetStyle);
            }
        }
        var statesKeys = this.__inHover ? PRIMARY_STATES_KEYS_IN_HOVER_LAYER : PRIMARY_STATES_KEYS$1;
        for (var i = 0; i < statesKeys.length; i++) {
            var key = statesKeys[i];
            if (state && state[key] != null) {
                this[key] = state[key];
            }
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    this[key] = normalState[key];
                }
            }
        }
    };
    Displayable.prototype._mergeStates = function (states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) {
            mergedState.style = mergedStyle;
        }
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function (targetStyle, sourceStyle) {
        extend(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function () {
        return DEFAULT_COMMON_ANIMATION_PROPS;
    };
    Displayable.initDefaultProps = (function () {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = REDRAW_BIT | STYLE_CHANGED_BIT;
    })();
    return Displayable;
}(Element$3));
var tmpRect$1 = new BoundingRect(0, 0, 0, 0);
var viewRect = new BoundingRect(0, 0, 0, 0);
function isDisplayableCulled(el, width, height) {
    tmpRect$1.copy(el.getBoundingRect());
    if (el.transform) {
        tmpRect$1.applyTransform(el.transform);
    }
    viewRect.width = width;
    viewRect.height = height;
    return !tmpRect$1.intersect(viewRect);
}

var mathMin$1 = Math.min;
var mathMax$1 = Math.max;
var mathSin = Math.sin;
var mathCos = Math.cos;
var PI2 = Math.PI * 2;
var start$1 = create();
var end$1 = create();
var extremity = create();
function fromPoints(points, min, max) {
    if (points.length === 0) {
        return;
    }
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for (var i = 1; i < points.length; i++) {
        p = points[i];
        left = mathMin$1(left, p[0]);
        right = mathMax$1(right, p[0]);
        top = mathMin$1(top, p[1]);
        bottom = mathMax$1(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function fromLine(x0, y0, x1, y1, min, max) {
    min[0] = mathMin$1(x0, x1);
    min[1] = mathMin$1(y0, y1);
    max[0] = mathMax$1(x0, x1);
    max[1] = mathMax$1(y0, y1);
}
var xDim = [];
var yDim = [];
function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema$1 = cubicExtrema;
    var cubicAt$1 = cubicAt;
    var n = cubicExtrema$1(x0, x1, x2, x3, xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for (var i = 0; i < n; i++) {
        var x = cubicAt$1(x0, x1, x2, x3, xDim[i]);
        min[0] = mathMin$1(x, min[0]);
        max[0] = mathMax$1(x, max[0]);
    }
    n = cubicExtrema$1(y0, y1, y2, y3, yDim);
    for (var i = 0; i < n; i++) {
        var y = cubicAt$1(y0, y1, y2, y3, yDim[i]);
        min[1] = mathMin$1(y, min[1]);
        max[1] = mathMax$1(y, max[1]);
    }
    min[0] = mathMin$1(x0, min[0]);
    max[0] = mathMax$1(x0, max[0]);
    min[0] = mathMin$1(x3, min[0]);
    max[0] = mathMax$1(x3, max[0]);
    min[1] = mathMin$1(y0, min[1]);
    max[1] = mathMax$1(y0, max[1]);
    min[1] = mathMin$1(y3, min[1]);
    max[1] = mathMax$1(y3, max[1]);
}
function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum$1 = quadraticExtremum;
    var quadraticAt$1 = quadraticAt;
    var tx = mathMax$1(mathMin$1(quadraticExtremum$1(x0, x1, x2), 1), 0);
    var ty = mathMax$1(mathMin$1(quadraticExtremum$1(y0, y1, y2), 1), 0);
    var x = quadraticAt$1(x0, x1, x2, tx);
    var y = quadraticAt$1(y0, y1, y2, ty);
    min[0] = mathMin$1(x0, x2, x);
    min[1] = mathMin$1(y0, y2, y);
    max[0] = mathMax$1(x0, x2, x);
    max[1] = mathMax$1(y0, y2, y);
}
function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = min$1;
    var vec2Max = max$1;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    start$1[0] = mathCos(startAngle) * rx + x;
    start$1[1] = mathSin(startAngle) * ry + y;
    end$1[0] = mathCos(endAngle) * rx + x;
    end$1[1] = mathSin(endAngle) * ry + y;
    vec2Min(min, start$1, end$1);
    vec2Max(max, start$1, end$1);
    startAngle = startAngle % (PI2);
    if (startAngle < 0) {
        startAngle = startAngle + PI2;
    }
    endAngle = endAngle % (PI2);
    if (endAngle < 0) {
        endAngle = endAngle + PI2;
    }
    if (startAngle > endAngle && !anticlockwise) {
        endAngle += PI2;
    }
    else if (startAngle < endAngle && anticlockwise) {
        startAngle += PI2;
    }
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
        if (angle > startAngle) {
            extremity[0] = mathCos(angle) * rx + x;
            extremity[1] = mathSin(angle) * ry + y;
            vec2Min(min, extremity, min);
            vec2Max(max, extremity, max);
        }
    }
}

var CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var tmpOutX = [];
var tmpOutY = [];
var min$2 = [];
var max$2 = [];
var min2 = [];
var max2 = [];
var mathMin$2 = Math.min;
var mathMax$2 = Math.max;
var mathCos$1 = Math.cos;
var mathSin$1 = Math.sin;
var mathAbs = Math.abs;
var PI = Math.PI;
var PI2$1 = PI * 2;
var hasTypedArray = typeof Float32Array !== 'undefined';
var tmpAngles = [];
function modPI2(radian) {
    var n = Math.round(radian / PI * 1e8) / 1e8;
    return (n % 2) * PI;
}
function normalizeArcAngles(angles, anticlockwise) {
    var newStartAngle = modPI2(angles[0]);
    if (newStartAngle < 0) {
        newStartAngle += PI2$1;
    }
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= PI2$1) {
        newEndAngle = newStartAngle + PI2$1;
    }
    else if (anticlockwise && newStartAngle - newEndAngle >= PI2$1) {
        newEndAngle = newStartAngle - PI2$1;
    }
    else if (!anticlockwise && newStartAngle > newEndAngle) {
        newEndAngle = newStartAngle + (PI2$1 - modPI2(newStartAngle - newEndAngle));
    }
    else if (anticlockwise && newStartAngle < newEndAngle) {
        newEndAngle = newStartAngle - (PI2$1 - modPI2(newEndAngle - newStartAngle));
    }
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var PathProxy = (function () {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) {
            this._saveData = false;
        }
        if (this._saveData) {
            this.data = [];
        }
    }
    PathProxy.prototype.increaseVersion = function () {
        this._version++;
    };
    PathProxy.prototype.getVersion = function () {
        return this._version;
    };
    PathProxy.prototype.setScale = function (sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = mathAbs(segmentIgnoreThreshold / devicePixelRatio / sx) || 0;
            this._uy = mathAbs(segmentIgnoreThreshold / devicePixelRatio / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function (dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function (ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function () {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function () {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function () {
        if (this._saveData) {
            this._len = 0;
        }
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function (x, y) {
        this._drawPendingPt();
        this.addData(CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function (x, y) {
        var dx = mathAbs(x - this._xi);
        var dy = mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData(CMD.L, x, y);
        if (this._ctx && exceedUnit) {
            this._ctx.lineTo(x, y);
        }
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        }
        else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function (x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) {
            this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        }
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function (x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData(CMD.Q, x1, y1, x2, y2);
        if (this._ctx) {
            this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        }
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        tmpAngles[0] = startAngle;
        tmpAngles[1] = endAngle;
        normalizeArcAngles(tmpAngles, anticlockwise);
        startAngle = tmpAngles[0];
        endAngle = tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData(CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = mathCos$1(endAngle) * r + cx;
        this._yi = mathSin$1(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function (x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) {
            this._ctx.arcTo(x1, y1, x2, y2, radius);
        }
        return this;
    };
    PathProxy.prototype.rect = function (x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData(CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function () {
        this._drawPendingPt();
        this.addData(CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) {
            ctx.closePath();
        }
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function (ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function (ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function () {
        return this._len;
    };
    PathProxy.prototype.setData = function (data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && hasTypedArray) {
            this.data = new Float32Array(len);
        }
        for (var i = 0; i < len; i++) {
            this.data[i] = data[i];
        }
        this._len = len;
    };
    PathProxy.prototype.appendPath = function (path) {
        if (!(path instanceof Array)) {
            path = [path];
        }
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for (var i = 0; i < len; i++) {
            appendSize += path[i].len();
        }
        if (hasTypedArray && (this.data instanceof Float32Array)) {
            this.data = new Float32Array(offset + appendSize);
        }
        for (var i = 0; i < len; i++) {
            var appendPathData = path[i].data;
            for (var k = 0; k < appendPathData.length; k++) {
                this.data[offset++] = appendPathData[k];
            }
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function (cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) {
            return;
        }
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for (var i = 0; i < arguments.length; i++) {
            data[this._len++] = arguments[i];
        }
    };
    PathProxy.prototype._drawPendingPt = function () {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function () {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for (var i = 0; i < this._len; i++) {
                newData[i] = this.data[i];
            }
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function () {
        if (!this._saveData) {
            return;
        }
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if (hasTypedArray && this._len > 11) {
                this.data = new Float32Array(data);
            }
        }
    };
    PathProxy.prototype.getBoundingRect = function () {
        min$2[0] = min$2[1] = min2[0] = min2[1] = Number.MAX_VALUE;
        max$2[0] = max$2[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for (i = 0; i < this._len;) {
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch (cmd) {
                case CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    min2[0] = x0;
                    min2[1] = y0;
                    max2[0] = x0;
                    max2[1] = y0;
                    break;
                case CMD.L:
                    fromLine(xi, yi, data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.C:
                    fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.Q:
                    fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = mathCos$1(startAngle) * rx + cx;
                        y0 = mathSin$1(startAngle) * ry + cy;
                    }
                    fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
                    xi = mathCos$1(endAngle) * rx + cx;
                    yi = mathSin$1(endAngle) * ry + cy;
                    break;
                case CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
                    break;
                case CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            min$1(min$2, min$2, min2);
            max$1(max$2, max$2, max2);
        }
        if (i === 0) {
            min$2[0] = min$2[1] = max$2[0] = max$2[1] = 0;
        }
        return new BoundingRect(min$2[0], min$2[1], max$2[0] - min$2[0], max$2[1] - min$2[1]);
    };
    PathProxy.prototype._calculateLength = function () {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) {
            this._pathSegLen = [];
        }
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for (var i = 0; i < len;) {
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch (cmd) {
                case CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case CMD.L: {
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if (mathAbs(dx) > ux || mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                }
                case CMD.C: {
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = cubicLength(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                }
                case CMD.Q: {
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = quadraticLength(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                }
                case CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = mathCos$1(startAngle) * rx + cx;
                        y0 = mathSin$1(startAngle) * ry + cy;
                    }
                    l = mathMax$2(rx, ry) * mathMin$2(PI2$1, Math.abs(delta));
                    xi = mathCos$1(endAngle) * rx + cx;
                    yi = mathSin$1(endAngle) * ry + cy;
                    break;
                case CMD.R: {
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                }
                case CMD.Z: {
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
                }
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function (ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) {
                this._calculateLength();
            }
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) {
                return;
            }
        }
        lo: for (var i = 0; i < len;) {
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch (cmd) {
                case CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case CMD.L: {
                    x = d[i++];
                    y = d[i++];
                    var dx = mathAbs(x - xi);
                    var dy = mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    }
                    else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                }
                case CMD.C: {
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            cubicSubdivide(xi, x1, x2, x3, t, tmpOutX);
                            cubicSubdivide(yi, y1, y2, y3, t, tmpOutY);
                            ctx.bezierCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2], tmpOutX[3], tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                }
                case CMD.Q: {
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            quadraticSubdivide(xi, x1, x2, t, tmpOutX);
                            quadraticSubdivide(yi, y1, y2, t, tmpOutY);
                            ctx.quadraticCurveTo(tmpOutX[1], tmpOutY[1], tmpOutX[2], tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                }
                case CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = (rx > ry) ? rx : ry;
                    var isEllipse = mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) {
                        ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    }
                    else {
                        ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    }
                    if (breakBuild) {
                        break lo;
                    }
                    if (isFirst) {
                        x0 = mathCos$1(startAngle) * rx + cx;
                        y0 = mathSin$1(startAngle) * ry + cy;
                    }
                    xi = mathCos$1(endAngle) * rx + cx;
                    yi = mathSin$1(endAngle) * ry + cy;
                    break;
                case CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + mathMin$2(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) {
                                ctx.lineTo(x + width, y + mathMin$2(d_1, height));
                            }
                            d_1 -= height;
                            if (d_1 > 0) {
                                ctx.lineTo(x + mathMax$2(width - d_1, 0), y + height);
                            }
                            d_1 -= width;
                            if (d_1 > 0) {
                                ctx.lineTo(x, y + mathMax$2(height - d_1, 0));
                            }
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function () {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice()
            : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = CMD;
    PathProxy.initDefaultProps = (function () {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    })();
    return PathProxy;
}());

function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if ((y > y0 + _l && y > y1 + _l)
        || (y < y0 - _l && y < y1 - _l)
        || (x > x0 + _l && x > x1 + _l)
        || (x < x0 - _l && x < x1 - _l)) {
        return false;
    }
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    }
    else {
        return Math.abs(x - x0) <= _l / 2;
    }
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}

function containStroke$1(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    if ((y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l)
        || (y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l)
        || (x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l)
        || (x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l)) {
        return false;
    }
    var d = cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}

function containStroke$2(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    if ((y > y0 + _l && y > y1 + _l && y > y2 + _l)
        || (y < y0 - _l && y < y1 - _l && y < y2 - _l)
        || (x > x0 + _l && x > x1 + _l && x > x2 + _l)
        || (x < x0 - _l && x < x1 - _l && x < x2 - _l)) {
        return false;
    }
    var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}

var PI2$2 = Math.PI * 2;
function normalizeRadian(angle) {
    angle %= PI2$2;
    if (angle < 0) {
        angle += PI2$2;
    }
    return angle;
}

var PI2$3 = Math.PI * 2;
function containStroke$3(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) {
        return false;
    }
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if ((d - _l > r) || (d + _l < r)) {
        return false;
    }
    if (Math.abs(startAngle - endAngle) % PI2$3 < 1e-4) {
        return true;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = normalizeRadian(endAngle);
        endAngle = normalizeRadian(tmp);
    }
    else {
        startAngle = normalizeRadian(startAngle);
        endAngle = normalizeRadian(endAngle);
    }
    if (startAngle > endAngle) {
        endAngle += PI2$3;
    }
    var angle = Math.atan2(y, x);
    if (angle < 0) {
        angle += PI2$3;
    }
    return (angle >= startAngle && angle <= endAngle)
        || (angle + PI2$3 >= startAngle && angle + PI2$3 <= endAngle);
}

function windingLine(x0, y0, x1, y1, x, y) {
    if ((y > y0 && y > y1) || (y < y0 && y < y1)) {
        return 0;
    }
    if (y1 === y0) {
        return 0;
    }
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) {
        dir = y1 < y0 ? 0.5 : -0.5;
    }
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}

var CMD$1 = PathProxy.CMD;
var PI2$4 = Math.PI * 2;
var EPSILON$3 = 1e-4;
function isAroundEqual(a, b) {
    return Math.abs(a - b) < EPSILON$3;
}
var roots = [-1, -1, -1];
var extrema = [-1, -1];
function swapExtrema() {
    var tmp = extrema[0];
    extrema[0] = extrema[1];
    extrema[1] = tmp;
}
function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if ((y > y0 && y > y1 && y > y2 && y > y3)
        || (y < y0 && y < y1 && y < y2 && y < y3)) {
        return 0;
    }
    var nRoots = cubicRootAt(y0, y1, y2, y3, y, roots);
    if (nRoots === 0) {
        return 0;
    }
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for (var i = 0; i < nRoots; i++) {
            var t = roots[i];
            var unit = (t === 0 || t === 1) ? 0.5 : 1;
            var x_ = cubicAt(x0, x1, x2, x3, t);
            if (x_ < x) {
                continue;
            }
            if (nExtrema < 0) {
                nExtrema = cubicExtrema(y0, y1, y2, y3, extrema);
                if (extrema[1] < extrema[0] && nExtrema > 1) {
                    swapExtrema();
                }
                y0_ = cubicAt(y0, y1, y2, y3, extrema[0]);
                if (nExtrema > 1) {
                    y1_ = cubicAt(y0, y1, y2, y3, extrema[1]);
                }
            }
            if (nExtrema === 2) {
                if (t < extrema[0]) {
                    w += y0_ < y0 ? unit : -unit;
                }
                else if (t < extrema[1]) {
                    w += y1_ < y0_ ? unit : -unit;
                }
                else {
                    w += y3 < y1_ ? unit : -unit;
                }
            }
            else {
                if (t < extrema[0]) {
                    w += y0_ < y0 ? unit : -unit;
                }
                else {
                    w += y3 < y0_ ? unit : -unit;
                }
            }
        }
        return w;
    }
}
function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if ((y > y0 && y > y1 && y > y2)
        || (y < y0 && y < y1 && y < y2)) {
        return 0;
    }
    var nRoots = quadraticRootAt(y0, y1, y2, y, roots);
    if (nRoots === 0) {
        return 0;
    }
    else {
        var t = quadraticExtremum(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = quadraticAt(y0, y1, y2, t);
            for (var i = 0; i < nRoots; i++) {
                var unit = (roots[i] === 0 || roots[i] === 1) ? 0.5 : 1;
                var x_ = quadraticAt(x0, x1, x2, roots[i]);
                if (x_ < x) {
                    continue;
                }
                if (roots[i] < t) {
                    w += y_ < y0 ? unit : -unit;
                }
                else {
                    w += y2 < y_ ? unit : -unit;
                }
            }
            return w;
        }
        else {
            var unit = (roots[0] === 0 || roots[0] === 1) ? 0.5 : 1;
            var x_ = quadraticAt(x0, x1, x2, roots[0]);
            if (x_ < x) {
                return 0;
            }
            return y2 < y0 ? unit : -unit;
        }
    }
}
function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) {
        return 0;
    }
    var tmp = Math.sqrt(r * r - y * y);
    roots[0] = -tmp;
    roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) {
        return 0;
    }
    if (dTheta >= PI2$4 - 1e-4) {
        startAngle = 0;
        endAngle = PI2$4;
        var dir = anticlockwise ? 1 : -1;
        if (x >= roots[0] + cx && x <= roots[1] + cx) {
            return dir;
        }
        else {
            return 0;
        }
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += PI2$4;
        endAngle += PI2$4;
    }
    var w = 0;
    for (var i = 0; i < 2; i++) {
        var x_ = roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) {
                angle = PI2$4 + angle;
            }
            if ((angle >= startAngle && angle <= endAngle)
                || (angle + PI2$4 >= startAngle && angle + PI2$4 <= endAngle)) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
                    dir = -dir;
                }
                w += dir;
            }
        }
    }
    return w;
}
function containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for (var i = 0; i < len;) {
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === CMD$1.M && i > 1) {
            if (!isStroke) {
                w += windingLine(xi, yi, x0, y0, x, y);
            }
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch (cmd) {
            case CMD$1.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case CMD$1.L:
                if (isStroke) {
                    if (containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD$1.C:
                if (isStroke) {
                    if (containStroke$1(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD$1.Q:
                if (isStroke) {
                    if (containStroke$2(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                }
                xi = data[i++];
                yi = data[i++];
                break;
            case CMD$1.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) {
                    w += windingLine(xi, yi, x1, y1, x, y);
                }
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if (containStroke$3(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                }
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case CMD$1.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if (containStroke(x0, y0, x1, y0, lineWidth, x, y)
                        || containStroke(x1, y0, x1, y1, lineWidth, x, y)
                        || containStroke(x1, y1, x0, y1, lineWidth, x, y)
                        || containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingLine(x1, y0, x1, y1, x, y);
                    w += windingLine(x0, y1, x0, y0, x, y);
                }
                break;
            case CMD$1.Z:
                if (isStroke) {
                    if (containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
                        return true;
                    }
                }
                else {
                    w += windingLine(xi, yi, x0, y0, x, y);
                }
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !isAroundEqual(yi, y0)) {
        w += windingLine(xi, yi, x0, y0, x, y) || 0;
    }
    return w !== 0;
}
function contain(pathProxy, x, y) {
    return containPath(pathProxy, 0, false, x, y);
}
function containStroke$4(pathProxy, lineWidth, x, y) {
    return containPath(pathProxy, lineWidth, true, x, y);
}

var DEFAULT_PATH_STYLE = defaults({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, DEFAULT_COMMON_STYLE);
var DEFAULT_PATH_ANIMATION_PROPS = {
    style: defaults({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, DEFAULT_COMMON_ANIMATION_PROPS.style)
};
var pathCopyParams = TRANSFORMABLE_PROPS.concat(['invisible',
    'culling', 'z', 'z2', 'zlevel', 'parent'
]);
var Path = (function (_super) {
    __extends$1(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function () {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) {
                decalEl.buildPath = function (ctx) {
                    _this.buildPath(ctx, _this.shape);
                };
            }
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for (var key in style) {
                if (decalElStyle[key] !== style[key]) {
                    decalElStyle[key] = style[key];
                }
            }
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for (var i = 0; i < pathCopyParams.length; ++i) {
                decalEl[pathCopyParams[i]] = this[pathCopyParams[i]];
            }
            decalEl.__dirty |= REDRAW_BIT;
        }
        else if (this._decalEl) {
            this._decalEl = null;
        }
    };
    Path.prototype.getDecalElement = function () {
        return this._decalEl;
    };
    Path.prototype._init = function (props) {
        var keysArr = keys$2(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) {
            this.useStyle(defaultStyle);
        }
        for (var i = 0; i < keysArr.length; i++) {
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) {
                    this.useStyle(value);
                }
                else {
                    extend(this.style, value);
                }
            }
            else if (key === 'shape') {
                extend(this.shape, value);
            }
            else {
                _super.prototype.attrKV.call(this, key, value);
            }
        }
        if (!this.style) {
            this.useStyle({});
        }
    };
    Path.prototype.getDefaultStyle = function () {
        return null;
    };
    Path.prototype.getDefaultShape = function () {
        return {};
    };
    Path.prototype.canBeInsideText = function () {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function () {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if (isString(pathFill)) {
                var fillLum = lum(pathFill, 0);
                if (fillLum > 0.5) {
                    return DARK_LABEL_COLOR;
                }
                else if (fillLum > 0.2) {
                    return LIGHTER_LABEL_COLOR;
                }
                return LIGHT_LABEL_COLOR;
            }
            else if (pathFill) {
                return LIGHT_LABEL_COLOR;
            }
        }
        return DARK_LABEL_COLOR;
    };
    Path.prototype.getInsideTextStroke = function (textFill) {
        var pathFill = this.style.fill;
        if (isString(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = lum(textFill, 0) < DARK_MODE_THRESHOLD;
            if (isDarkMode === isDarkLabel) {
                return pathFill;
            }
        }
    };
    Path.prototype.buildPath = function (ctx, shapeCfg, inBatch) { };
    Path.prototype.pathUpdated = function () {
        this.__dirty &= ~SHAPE_CHANGED_BIT;
    };
    Path.prototype.getUpdatedPathProxy = function (inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function () {
        this.path = new PathProxy(false);
    };
    Path.prototype.hasStroke = function () {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function () {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function () {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || (this.__dirty & SHAPE_CHANGED_BIT)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function (x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) {
                        lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    }
                    if (containStroke$4(pathProxy, lineWidth / lineScale, x, y)) {
                        return true;
                    }
                }
            }
            if (this.hasFill()) {
                return contain(pathProxy, x, y);
            }
        }
        return false;
    };
    Path.prototype.dirtyShape = function () {
        this.__dirty |= SHAPE_CHANGED_BIT;
        if (this._rect) {
            this._rect = null;
        }
        if (this._decalEl) {
            this._decalEl.dirtyShape();
        }
        this.markRedraw();
    };
    Path.prototype.dirty = function () {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function (loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function (targetKey) {
        if (targetKey === 'style') {
            this.dirtyStyle();
        }
        else if (targetKey === 'shape') {
            this.dirtyShape();
        }
        else {
            this.markRedraw();
        }
    };
    Path.prototype.attrKV = function (key, value) {
        if (key === 'shape') {
            this.setShape(value);
        }
        else {
            _super.prototype.attrKV.call(this, key, value);
        }
    };
    Path.prototype.setShape = function (keyOrObj, value) {
        var shape = this.shape;
        if (!shape) {
            shape = this.shape = {};
        }
        if (typeof keyOrObj === 'string') {
            shape[keyOrObj] = value;
        }
        else {
            extend(shape, keyOrObj);
        }
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function () {
        return !!(this.__dirty & SHAPE_CHANGED_BIT);
    };
    Path.prototype.createStyle = function (obj) {
        return createObject(DEFAULT_PATH_STYLE, obj);
    };
    Path.prototype._innerSaveToNormal = function (toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) {
            normalState.shape = extend({}, this.shape);
        }
    };
    Path.prototype._applyStateObj = function (stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) {
                    targetShape = state.shape;
                }
                else {
                    targetShape = extend({}, normalState.shape);
                    extend(targetShape, state.shape);
                }
            }
            else {
                targetShape = extend({}, keepCurrentStates ? this.shape : normalState.shape);
                extend(targetShape, state.shape);
            }
        }
        else if (needsRestoreToNormal) {
            targetShape = normalState.shape;
        }
        if (targetShape) {
            if (transition) {
                this.shape = extend({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = keys$2(targetShape);
                for (var i = 0; i < shapeKeys.length; i++) {
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') {
                        this.shape[key] = targetShape[key];
                    }
                    else {
                        targetShapePrimaryProps[key] = targetShape[key];
                    }
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            }
            else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function (states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for (var i = 0; i < states.length; i++) {
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) {
            mergedState.shape = mergedShape;
        }
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function () {
        return DEFAULT_PATH_ANIMATION_PROPS;
    };
    Path.prototype.isZeroArea = function () {
        return false;
    };
    Path.extend = function (defaultProps) {
        var Sub = (function (_super) {
            __extends$1(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function () {
                return clone(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function () {
                return clone(defaultProps.shape);
            };
            return Sub;
        }(Path));
        for (var key in defaultProps) {
            if (typeof defaultProps[key] === 'function') {
                Sub.prototype[key] = defaultProps[key];
            }
        }
        return Sub;
    };
    Path.initDefaultProps = (function () {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = REDRAW_BIT | STYLE_CHANGED_BIT | SHAPE_CHANGED_BIT;
    })();
    return Path;
}(Displayable));

var DEFAULT_TSPAN_STYLE = defaults({
    strokeFirst: true,
    font: DEFAULT_FONT,
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, DEFAULT_PATH_STYLE);
var TSpan = (function (_super) {
    __extends$1(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function () {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function () {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function (obj) {
        return createObject(DEFAULT_TSPAN_STYLE, obj);
    };
    TSpan.prototype.setBoundingRect = function (rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function () {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? (text += '') : (text = '');
            var rect = getBoundingRect(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = (function () {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    })();
    return TSpan;
}(Displayable));
TSpan.prototype.type = 'tspan';

var DEFAULT_IMAGE_STYLE = defaults({
    x: 0,
    y: 0
}, DEFAULT_COMMON_STYLE);
var DEFAULT_IMAGE_ANIMATION_PROPS = {
    style: defaults({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, DEFAULT_COMMON_ANIMATION_PROPS.style)
};
function isImageLike(source) {
    return !!(source
        && typeof source !== 'string'
        && source.width && source.height);
}
var ZRImage = (function (_super) {
    __extends$1(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function (obj) {
        return createObject(DEFAULT_IMAGE_STYLE, obj);
    };
    ZRImage.prototype._getSize = function (dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) {
            return size;
        }
        var imageSource = isImageLike(style.image)
            ? style.image : this.__image;
        if (!imageSource) {
            return 0;
        }
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) {
            return imageSource[dim];
        }
        else {
            return imageSource[dim] / imageSource[otherDim] * otherDimSize;
        }
    };
    ZRImage.prototype.getWidth = function () {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function () {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function () {
        return DEFAULT_IMAGE_ANIMATION_PROPS;
    };
    ZRImage.prototype.getBoundingRect = function () {
        var style = this.style;
        if (!this._rect) {
            this._rect = new BoundingRect(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        }
        return this._rect;
    };
    return ZRImage;
}(Displayable));
ZRImage.prototype.type = 'image';

function buildPath(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') {
        r1 = r2 = r3 = r4 = r;
    }
    else if (r instanceof Array) {
        if (r.length === 1) {
            r1 = r2 = r3 = r4 = r[0];
        }
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        }
        else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        }
        else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    }
    else {
        r1 = r2 = r3 = r4 = 0;
    }
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}

var round$4 = Math.round;
function subPixelOptimizeLine(outputShape, inputShape, style) {
    if (!inputShape) {
        return;
    }
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) {
        return outputShape;
    }
    if (round$4(x1 * 2) === round$4(x2 * 2)) {
        outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
    }
    if (round$4(y1 * 2) === round$4(y2 * 2)) {
        outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
    }
    return outputShape;
}
function subPixelOptimizeRect(outputShape, inputShape, style) {
    if (!inputShape) {
        return;
    }
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) {
        return outputShape;
    }
    outputShape.x = subPixelOptimize(originX, lineWidth, true);
    outputShape.y = subPixelOptimize(originY, lineWidth, true);
    outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function subPixelOptimize(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) {
        return position;
    }
    var doubledPosition = round$4(position * 2);
    return (doubledPosition + round$4(lineWidth)) % 2 === 0
        ? doubledPosition / 2
        : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}

var RectShape = (function () {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}());
var subPixelOptimizeOutputShape = {};
var Rect = (function (_super) {
    __extends$1(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function () {
        return new RectShape();
    };
    Rect.prototype.buildPath = function (ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        }
        else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) {
            ctx.rect(x, y, width, height);
        }
        else {
            buildPath(ctx, shape);
        }
    };
    Rect.prototype.isZeroArea = function () {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}(Path));
Rect.prototype.type = 'rect';

var DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var DEFAULT_STROKE_LINE_WIDTH = 2;
var DEFAULT_TEXT_ANIMATION_PROPS = {
    style: defaults({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, DEFAULT_COMMON_ANIMATION_PROPS.style)
};
var ZRText = (function (_super) {
    __extends$1(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function () {
        return this._children;
    };
    ZRText.prototype.update = function () {
        _super.prototype.update.call(this);
        if (this.styleChanged()) {
            this._updateSubTexts();
        }
        for (var i = 0; i < this._children.length; i++) {
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function () {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) {
                this.transform = innerTransformable.transform;
            }
        }
        else {
            _super.prototype.updateTransform.call(this);
        }
    };
    ZRText.prototype.getLocalTransform = function (m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable
            ? innerTransformable.getLocalTransform(m)
            : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function () {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function () {
        this._childCursor = 0;
        normalizeTextStyle(this.style);
        this.style.rich
            ? this._updateRichTexts()
            : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function (zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].__zr = zr;
        }
    };
    ZRText.prototype.removeSelfFromZr = function (zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for (var i = 0; i < this._children.length; i++) {
            this._children[i].__zr = null;
        }
    };
    ZRText.prototype.getBoundingRect = function () {
        if (this.styleChanged()) {
            this._updateSubTexts();
        }
        if (!this._rect) {
            var tmpRect = new BoundingRect(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for (var i = 0; i < children.length; i++) {
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                }
                else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function (defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function (textContent) {
        if (process.env.NODE_ENV !== 'production') {
            throw new Error('Can\'t attach text on another text');
        }
    };
    ZRText.prototype._mergeStyle = function (targetStyle, sourceStyle) {
        if (!sourceStyle) {
            return targetStyle;
        }
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || (sourceRich && {});
        extend(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        }
        else if (targetRich) {
            targetStyle.rich = targetRich;
        }
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function (targetRich, sourceRich) {
        var richNames = keys$2(sourceRich);
        for (var i = 0; i < richNames.length; i++) {
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            extend(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function () {
        return DEFAULT_TEXT_ANIMATION_PROPS;
    };
    ZRText.prototype._getOrCreateChild = function (Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) {
            child = new Ctor();
        }
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function () {
        var style = this.style;
        var textFont = style.font || DEFAULT_FONT;
        var textPadding = style.padding;
        var text = getStyleText(style);
        var contentBlock = parsePlainText(text, style);
        var needDrawBg = needDrawBackground(style);
        var bgColorDrawn = !!(style.backgroundColor);
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = adjustTextY$1(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = adjustTextX(baseX, outerWidth, textAlign);
            var boxY = adjustTextY$1(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') {
                textY += textPadding[0];
            }
            else if (verticalAlign === 'bottom') {
                textY -= textPadding[2];
            }
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = getFill('fill' in style
            ? style.fill
            : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = getStroke('stroke' in style
            ? style.stroke
            : (!bgColorDrawn
                && (!defaultStyle.autoStroke || useDefaultFill))
                ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
                : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null
            && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for (var i = 0; i < textLines.length; i++) {
            var el = this._getOrCreateChild(TSpan);
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) {
                subElStyle.textAlign = textAlign;
            }
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) {
                el.setBoundingRect(new BoundingRect(adjustTextX(subElStyle.x, style.width, subElStyle.textAlign), adjustTextY$1(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
            }
        }
    };
    ZRText.prototype._updateRichTexts = function () {
        var style = this.style;
        var text = getStyleText(style);
        var contentBlock = parseRichText(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = adjustTextX(baseX, outerWidth, textAlign);
        var boxY = adjustTextY$1(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if (needDrawBackground(style)) {
            this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        var bgColorDrawn = !!(style.backgroundColor);
        for (var i = 0; i < contentBlock.lines.length; i++) {
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while (leftIndex < tokenCount
                && (token = tokens[leftIndex], !token.align || token.align === 'left')) {
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while (rightIndex >= 0
                && (token = tokens[rightIndex], token.align === 'right')) {
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while (leftIndex <= rightIndex) {
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function (token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') {
            y = lineTop + token.height / 2;
        }
        else if (verticalAlign === 'bottom') {
            y = lineTop + lineHeight - token.height / 2;
        }
        var needDrawBg = !token.isLineHolder && needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right'
            ? x - token.width
            : textAlign === 'center'
                ? x - token.width / 2
                : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild(TSpan);
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = getFill('fill' in tokenStyle ? tokenStyle.fill
            : 'fill' in style ? style.fill
                : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = getStroke('stroke' in tokenStyle ? tokenStyle.stroke
            : 'stroke' in style ? style.stroke
                : (!bgColorDrawn
                    && !parentBgColorDrawn
                    && (!defaultStyle.autoStroke || useDefaultFill)) ? (defaultLineWidth = DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke)
                    : null);
        var hasShadow = tokenStyle.textShadowBlur > 0
            || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || DEFAULT_FONT;
        subElStyle.opacity = retrieve3(tokenStyle.opacity, style.opacity, 1);
        setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = retrieve3(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = retrieve2(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) {
            subElStyle.fill = textFill;
        }
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new BoundingRect(adjustTextX(subElStyle.x, textWidth, subElStyle.textAlign), adjustTextY$1(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function (style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || (textBorderWidth && textBorderColor)) {
            rectEl = this._getOrCreateChild(Rect);
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = retrieve2(style.fillOpacity, 1);
        }
        else if (isImageBg) {
            imgEl = this._getOrCreateChild(ZRImage);
            imgEl.onload = function () {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = retrieve2(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = retrieve3(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function (style) {
        var font = '';
        if (hasSeparateFont(style)) {
            font = [
                style.fontStyle,
                style.fontWeight,
                parseFontSize(style.fontSize),
                style.fontFamily || 'sans-serif'
            ].join(' ');
        }
        return font && trim(font) || style.textFont || style.font;
    };
    return ZRText;
}(Displayable));
var VALID_TEXT_ALIGN = { left: true, right: 1, center: 1 };
var VALID_TEXT_VERTICAL_ALIGN = { top: 1, bottom: 1, middle: 1 };
var FONT_PARTS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily'];
function parseFontSize(fontSize) {
    if (typeof fontSize === 'string'
        && (fontSize.indexOf('px') !== -1
            || fontSize.indexOf('rem') !== -1
            || fontSize.indexOf('em') !== -1)) {
        return fontSize;
    }
    else if (!isNaN(+fontSize)) {
        return fontSize + 'px';
    }
    else {
        return DEFAULT_FONT_SIZE + 'px';
    }
}
function setSeparateFont(targetStyle, sourceStyle) {
    for (var i = 0; i < FONT_PARTS.length; i++) {
        var fontProp = FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) {
            targetStyle[fontProp] = val;
        }
    }
}
function hasSeparateFont(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function normalizeTextStyle(style) {
    normalizeStyle(style);
    each(style.rich, normalizeStyle);
    return style;
}
function normalizeStyle(style) {
    if (style) {
        style.font = ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = (textAlign == null || VALID_TEXT_ALIGN[textAlign]) ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = (verticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[verticalAlign]) ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) {
            style.padding = normalizeCssArray(style.padding);
        }
    }
}
function getStroke(stroke, lineWidth) {
    return (stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none')
        ? null
        : (stroke.image || stroke.colorStops)
            ? '#000'
            : stroke;
}
function getFill(fill) {
    return (fill == null || fill === 'none')
        ? null
        : (fill.image || fill.colorStops)
            ? '#000'
            : fill;
}
function getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right'
        ? (x - textPadding[1])
        : textAlign === 'center'
            ? (x + textPadding[3] / 2 - textPadding[1] / 2)
            : (x + textPadding[3]);
}
function getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function needDrawBackground(style) {
    return !!(style.backgroundColor
        || style.lineHeight
        || (style.borderWidth && style.borderColor));
}

var getECData = makeInner();
var setCommonECData = function (seriesIndex, dataType, dataIdx, el) {
  if (el) {
    var ecData = getECData(el); // Add data index and series index for indexing the data by element
    // Useful in tooltip

    ecData.dataIndex = dataIdx;
    ecData.dataType = dataType;
    ecData.seriesIndex = seriesIndex; // TODO: not store dataIndex on children.

    if (el.type === 'group') {
      el.traverse(function (child) {
        var childECData = getECData(child);
        childECData.seriesIndex = seriesIndex;
        childECData.dataIndex = dataIdx;
        childECData.dataType = dataType;
      });
    }
  }
};

var _highlightNextDigit = 1;
var _highlightKeyMap = {};
var getSavedStates = makeInner();
var getComponentStates = makeInner();
var HOVER_STATE_NORMAL = 0;
var HOVER_STATE_BLUR = 1;
var HOVER_STATE_EMPHASIS = 2;
var SPECIAL_STATES = ['emphasis', 'blur', 'select'];
var DISPLAY_STATES = ['normal', 'emphasis', 'blur', 'select'];
var Z2_EMPHASIS_LIFT = 10;
var Z2_SELECT_LIFT = 9;
var HIGHLIGHT_ACTION_TYPE = 'highlight';
var DOWNPLAY_ACTION_TYPE = 'downplay';
var SELECT_ACTION_TYPE = 'select';
var UNSELECT_ACTION_TYPE = 'unselect';
var TOGGLE_SELECT_ACTION_TYPE = 'toggleSelect';

function hasFillOrStroke(fillOrStroke) {
  return fillOrStroke != null && fillOrStroke !== 'none';
} // Most lifted color are duplicated.


var liftedColorCache = new LRU(100);

function liftColor(color$1) {
  if (isString(color$1)) {
    var liftedColor = liftedColorCache.get(color$1);

    if (!liftedColor) {
      liftedColor = lift(color$1, -0.1);
      liftedColorCache.put(color$1, liftedColor);
    }

    return liftedColor;
  } else if (isGradientObject(color$1)) {
    var ret = extend({}, color$1);
    ret.colorStops = map(color$1.colorStops, function (stop) {
      return {
        offset: stop.offset,
        color: lift(stop.color, -0.1)
      };
    });
    return ret;
  } // Change nothing.


  return color$1;
}

function doChangeHoverState(el, stateName, hoverStateEnum) {
  if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) {
    el.onHoverStateChange(stateName);
  }

  el.hoverState = hoverStateEnum;
}

function singleEnterEmphasis(el) {
  // Only mark the flag.
  // States will be applied in the echarts.ts in next frame.
  doChangeHoverState(el, 'emphasis', HOVER_STATE_EMPHASIS);
}

function singleLeaveEmphasis(el) {
  // Only mark the flag.
  // States will be applied in the echarts.ts in next frame.
  if (el.hoverState === HOVER_STATE_EMPHASIS) {
    doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
  }
}

function singleEnterBlur(el) {
  doChangeHoverState(el, 'blur', HOVER_STATE_BLUR);
}

function singleLeaveBlur(el) {
  if (el.hoverState === HOVER_STATE_BLUR) {
    doChangeHoverState(el, 'normal', HOVER_STATE_NORMAL);
  }
}

function singleEnterSelect(el) {
  el.selected = true;
}

function singleLeaveSelect(el) {
  el.selected = false;
}

function updateElementState(el, updater, commonParam) {
  updater(el, commonParam);
}

function traverseUpdateState(el, updater, commonParam) {
  updateElementState(el, updater, commonParam);
  el.isGroup && el.traverse(function (child) {
    updateElementState(child, updater, commonParam);
  });
}

function setStatesFlag(el, stateName) {
  switch (stateName) {
    case 'emphasis':
      el.hoverState = HOVER_STATE_EMPHASIS;
      break;

    case 'normal':
      el.hoverState = HOVER_STATE_NORMAL;
      break;

    case 'blur':
      el.hoverState = HOVER_STATE_BLUR;
      break;

    case 'select':
      el.selected = true;
  }
}

function getFromStateStyle(el, props, toStateName, defaultValue) {
  var style = el.style;
  var fromState = {};

  for (var i = 0; i < props.length; i++) {
    var propName = props[i];
    var val = style[propName];
    fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
  }

  for (var i = 0; i < el.animators.length; i++) {
    var animator = el.animators[i];

    if (animator.__fromStateTransition // Don't consider the animation to emphasis state.
    && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') {
      animator.saveTo(fromState, props);
    }
  }

  return fromState;
}

function createEmphasisDefaultState(el, stateName, targetStates, state) {
  var hasSelect = targetStates && indexOf(targetStates, 'select') >= 0;
  var cloned = false;

  if (el instanceof Path) {
    var store = getSavedStates(el);
    var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
    var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;

    if (hasFillOrStroke(fromFill) || hasFillOrStroke(fromStroke)) {
      state = state || {};
      var emphasisStyle = state.style || {}; // inherit case

      if (emphasisStyle.fill === 'inherit') {
        cloned = true;
        state = extend({}, state);
        emphasisStyle = extend({}, emphasisStyle);
        emphasisStyle.fill = fromFill;
      } // Apply default color lift
      else if (!hasFillOrStroke(emphasisStyle.fill) && hasFillOrStroke(fromFill)) {
          cloned = true; // Not modify the original value.

          state = extend({}, state);
          emphasisStyle = extend({}, emphasisStyle); // Already being applied 'emphasis'. DON'T lift color multiple times.

          emphasisStyle.fill = liftColor(fromFill);
        } // Not highlight stroke if fill has been highlighted.
        else if (!hasFillOrStroke(emphasisStyle.stroke) && hasFillOrStroke(fromStroke)) {
            if (!cloned) {
              state = extend({}, state);
              emphasisStyle = extend({}, emphasisStyle);
            }

            emphasisStyle.stroke = liftColor(fromStroke);
          }

      state.style = emphasisStyle;
    }
  }

  if (state) {
    // TODO Share with textContent?
    if (state.z2 == null) {
      if (!cloned) {
        state = extend({}, state);
      }

      var z2EmphasisLift = el.z2EmphasisLift;
      state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : Z2_EMPHASIS_LIFT);
    }
  }

  return state;
}

function createSelectDefaultState(el, stateName, state) {
  // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
  if (state) {
    // TODO Share with textContent?
    if (state.z2 == null) {
      state = extend({}, state);
      var z2SelectLift = el.z2SelectLift;
      state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : Z2_SELECT_LIFT);
    }
  }

  return state;
}

function createBlurDefaultState(el, stateName, state) {
  var hasBlur = indexOf(el.currentStates, stateName) >= 0;
  var currentOpacity = el.style.opacity;
  var fromState = !hasBlur ? getFromStateStyle(el, ['opacity'], stateName, {
    opacity: 1
  }) : null;
  state = state || {};
  var blurStyle = state.style || {};

  if (blurStyle.opacity == null) {
    // clone state
    state = extend({}, state);
    blurStyle = extend({
      // Already being applied 'emphasis'. DON'T mul opacity multiple times.
      opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
    }, blurStyle);
    state.style = blurStyle;
  }

  return state;
}

function elementStateProxy(stateName, targetStates) {
  var state = this.states[stateName];

  if (this.style) {
    if (stateName === 'emphasis') {
      return createEmphasisDefaultState(this, stateName, targetStates, state);
    } else if (stateName === 'blur') {
      return createBlurDefaultState(this, stateName, state);
    } else if (stateName === 'select') {
      return createSelectDefaultState(this, stateName, state);
    }
  }

  return state;
}
/**
 * Set hover style (namely "emphasis style") of element.
 * @param el Should not be `zrender/graphic/Group`.
 * @param focus 'self' | 'selfInSeries' | 'series'
 */


function setDefaultStateProxy(el) {
  el.stateProxy = elementStateProxy;
  var textContent = el.getTextContent();
  var textGuide = el.getTextGuideLine();

  if (textContent) {
    textContent.stateProxy = elementStateProxy;
  }

  if (textGuide) {
    textGuide.stateProxy = elementStateProxy;
  }
}
function enterEmphasisWhenMouseOver(el, e) {
  !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !el.__highByOuter && traverseUpdateState(el, singleEnterEmphasis);
}
function leaveEmphasisWhenMouseOut(el, e) {
  !shouldSilent(el, e) // "emphasis" event highlight has higher priority than mouse highlight.
  && !el.__highByOuter && traverseUpdateState(el, singleLeaveEmphasis);
}
function enterEmphasis(el, highlightDigit) {
  el.__highByOuter |= 1 << (highlightDigit || 0);
  traverseUpdateState(el, singleEnterEmphasis);
}
function leaveEmphasis(el, highlightDigit) {
  !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdateState(el, singleLeaveEmphasis);
}
function enterBlur(el) {
  traverseUpdateState(el, singleEnterBlur);
}
function leaveBlur(el) {
  traverseUpdateState(el, singleLeaveBlur);
}
function enterSelect(el) {
  traverseUpdateState(el, singleEnterSelect);
}
function leaveSelect(el) {
  traverseUpdateState(el, singleLeaveSelect);
}

function shouldSilent(el, e) {
  return el.__highDownSilentOnTouch && e.zrByTouch;
}

function allLeaveBlur(api) {
  var model = api.getModel();
  var leaveBlurredSeries = [];
  var allComponentViews = [];
  model.eachComponent(function (componentType, componentModel) {
    var componentStates = getComponentStates(componentModel);
    var isSeries = componentType === 'series';
    var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
    !isSeries && allComponentViews.push(view);

    if (componentStates.isBlured) {
      // Leave blur anyway
      view.group.traverse(function (child) {
        singleLeaveBlur(child);
      });
      isSeries && leaveBlurredSeries.push(componentModel);
    }

    componentStates.isBlured = false;
  });
  each(allComponentViews, function (view) {
    if (view && view.toggleBlurSeries) {
      view.toggleBlurSeries(leaveBlurredSeries, false, model);
    }
  });
}
function blurSeries(targetSeriesIndex, focus, blurScope, api) {
  var ecModel = api.getModel();
  blurScope = blurScope || 'coordinateSystem';

  function leaveBlurOfIndices(data, dataIndices) {
    for (var i = 0; i < dataIndices.length; i++) {
      var itemEl = data.getItemGraphicEl(dataIndices[i]);
      itemEl && leaveBlur(itemEl);
    }
  }

  if (targetSeriesIndex == null) {
    return;
  }

  if (!focus || focus === 'none') {
    return;
  }

  var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
  var targetCoordSys = targetSeriesModel.coordinateSystem;

  if (targetCoordSys && targetCoordSys.master) {
    targetCoordSys = targetCoordSys.master;
  }

  var blurredSeries = [];
  ecModel.eachSeries(function (seriesModel) {
    var sameSeries = targetSeriesModel === seriesModel;
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.master) {
      coordSys = coordSys.master;
    }

    var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.

    if (!( // Not blur other series if blurScope series
    blurScope === 'series' && !sameSeries // Not blur other coordinate system if blurScope is coordinateSystem
    || blurScope === 'coordinateSystem' && !sameCoordSys // Not blur self series if focus is series.
    || focus === 'series' && sameSeries // TODO blurScope: coordinate system
    )) {
      var view = api.getViewOfSeriesModel(seriesModel);
      view.group.traverse(function (child) {
        singleEnterBlur(child);
      });

      if (isArrayLike$1(focus)) {
        leaveBlurOfIndices(seriesModel.getData(), focus);
      } else if (isObject$2(focus)) {
        var dataTypes = keys$2(focus);

        for (var d = 0; d < dataTypes.length; d++) {
          leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
        }
      }

      blurredSeries.push(seriesModel);
      getComponentStates(seriesModel).isBlured = true;
    }
  });
  ecModel.eachComponent(function (componentType, componentModel) {
    if (componentType === 'series') {
      return;
    }

    var view = api.getViewOfComponentModel(componentModel);

    if (view && view.toggleBlurSeries) {
      view.toggleBlurSeries(blurredSeries, true, ecModel);
    }
  });
}
function blurComponent(componentMainType, componentIndex, api) {
  if (componentMainType == null || componentIndex == null) {
    return;
  }

  var componentModel = api.getModel().getComponent(componentMainType, componentIndex);

  if (!componentModel) {
    return;
  }

  getComponentStates(componentModel).isBlured = true;
  var view = api.getViewOfComponentModel(componentModel);

  if (!view || !view.focusBlurEnabled) {
    return;
  }

  view.group.traverse(function (child) {
    singleEnterBlur(child);
  });
}
function blurSeriesFromHighlightPayload(seriesModel, payload, api) {
  var seriesIndex = seriesModel.seriesIndex;
  var data = seriesModel.getData(payload.dataType);

  if (!data) {
    if (process.env.NODE_ENV !== 'production') {
      error("Unknown dataType " + payload.dataType);
    }

    return;
  }

  var dataIndex = queryDataIndex(data, payload); // Pick the first one if there is multiple/none exists.

  dataIndex = (isArray$1(dataIndex) ? dataIndex[0] : dataIndex) || 0;
  var el = data.getItemGraphicEl(dataIndex);

  if (!el) {
    var count = data.count();
    var current = 0; // If data on dataIndex is NaN.

    while (!el && current < count) {
      el = data.getItemGraphicEl(current++);
    }
  }

  if (el) {
    var ecData = getECData(el);
    blurSeries(seriesIndex, ecData.focus, ecData.blurScope, api);
  } else {
    // If there is no element put on the data. Try getting it from raw option
    // TODO Should put it on seriesModel?
    var focus_1 = seriesModel.get(['emphasis', 'focus']);
    var blurScope = seriesModel.get(['emphasis', 'blurScope']);

    if (focus_1 != null) {
      blurSeries(seriesIndex, focus_1, blurScope, api);
    }
  }
}
function findComponentHighDownDispatchers(componentMainType, componentIndex, name, api) {
  var ret = {
    focusSelf: false,
    dispatchers: null
  };

  if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) {
    return ret;
  }

  var componentModel = api.getModel().getComponent(componentMainType, componentIndex);

  if (!componentModel) {
    return ret;
  }

  var view = api.getViewOfComponentModel(componentModel);

  if (!view || !view.findHighDownDispatchers) {
    return ret;
  }

  var dispatchers = view.findHighDownDispatchers(name); // At presnet, the component (like Geo) only blur inside itself.
  // So we do not use `blurScope` in component.

  var focusSelf;

  for (var i = 0; i < dispatchers.length; i++) {
    if (process.env.NODE_ENV !== 'production' && !isHighDownDispatcher(dispatchers[i])) {
      error('param should be highDownDispatcher');
    }

    if (getECData(dispatchers[i]).focus === 'self') {
      focusSelf = true;
      break;
    }
  }

  return {
    focusSelf: focusSelf,
    dispatchers: dispatchers
  };
}
function handleGlobalMouseOverForHighDown(dispatcher, e, api) {
  if (process.env.NODE_ENV !== 'production' && !isHighDownDispatcher(dispatcher)) {
    error('param should be highDownDispatcher');
  }

  var ecData = getECData(dispatcher);

  var _a = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api),
      dispatchers = _a.dispatchers,
      focusSelf = _a.focusSelf; // If `findHighDownDispatchers` is supported on the component,
  // highlight/downplay elements with the same name.


  if (dispatchers) {
    if (focusSelf) {
      blurComponent(ecData.componentMainType, ecData.componentIndex, api);
    }

    each(dispatchers, function (dispatcher) {
      return enterEmphasisWhenMouseOver(dispatcher, e);
    });
  } else {
    // Try blur all in the related series. Then emphasis the hoverred.
    // TODO. progressive mode.
    blurSeries(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);

    if (ecData.focus === 'self') {
      blurComponent(ecData.componentMainType, ecData.componentIndex, api);
    } // Other than series, component that not support `findHighDownDispatcher` will
    // also use it. But in this case, highlight/downplay are only supported in
    // mouse hover but not in dispatchAction.


    enterEmphasisWhenMouseOver(dispatcher, e);
  }
}
function handleGlobalMouseOutForHighDown(dispatcher, e, api) {
  if (process.env.NODE_ENV !== 'production' && !isHighDownDispatcher(dispatcher)) {
    error('param should be highDownDispatcher');
  }

  allLeaveBlur(api);
  var ecData = getECData(dispatcher);
  var dispatchers = findComponentHighDownDispatchers(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;

  if (dispatchers) {
    each(dispatchers, function (dispatcher) {
      return leaveEmphasisWhenMouseOut(dispatcher, e);
    });
  } else {
    leaveEmphasisWhenMouseOut(dispatcher, e);
  }
}
function toggleSelectionFromPayload(seriesModel, payload, api) {
  if (!isSelectChangePayload(payload)) {
    return;
  }

  var dataType = payload.dataType;
  var data = seriesModel.getData(dataType);
  var dataIndex = queryDataIndex(data, payload);

  if (!isArray$1(dataIndex)) {
    dataIndex = [dataIndex];
  }

  seriesModel[payload.type === TOGGLE_SELECT_ACTION_TYPE ? 'toggleSelect' : payload.type === SELECT_ACTION_TYPE ? 'select' : 'unselect'](dataIndex, dataType);
}
function updateSeriesElementSelection(seriesModel) {
  var allData = seriesModel.getAllData();
  each(allData, function (_a) {
    var data = _a.data,
        type = _a.type;
    data.eachItemGraphicEl(function (el, idx) {
      seriesModel.isSelected(idx, type) ? enterSelect(el) : leaveSelect(el);
    });
  });
}
function getAllSelectedIndices(ecModel) {
  var ret = [];
  ecModel.eachSeries(function (seriesModel) {
    var allData = seriesModel.getAllData();
    each(allData, function (_a) {
      var data = _a.data,
          type = _a.type;
      var dataIndices = seriesModel.getSelectedDataIndices();

      if (dataIndices.length > 0) {
        var item = {
          dataIndex: dataIndices,
          seriesIndex: seriesModel.seriesIndex
        };

        if (type != null) {
          item.dataType = type;
        }

        ret.push(item);
      }
    });
  });
  return ret;
}
/**
 * Enable the function that mouseover will trigger the emphasis state.
 *
 * NOTE:
 * This function should be used on the element with dataIndex, seriesIndex.
 *
 */

function enableHoverEmphasis(el, focus, blurScope) {
  setAsHighDownDispatcher(el, true);
  traverseUpdateState(el, setDefaultStateProxy);
  enableHoverFocus(el, focus, blurScope);
}
function disableHoverEmphasis(el) {
  setAsHighDownDispatcher(el, false);
}
function toggleHoverEmphasis(el, focus, blurScope, isDisabled) {
  isDisabled ? disableHoverEmphasis(el) : enableHoverEmphasis(el, focus, blurScope);
}
function enableHoverFocus(el, focus, blurScope) {
  var ecData = getECData(el);

  if (focus != null) {
    // TODO dataIndex may be set after this function. This check is not useful.
    // if (ecData.dataIndex == null) {
    //     if (__DEV__) {
    //         console.warn('focus can only been set on element with dataIndex');
    //     }
    // }
    // else {
    ecData.focus = focus;
    ecData.blurScope = blurScope; // }
  } else if (ecData.focus) {
    ecData.focus = null;
  }
}
var OTHER_STATES = ['emphasis', 'blur', 'select'];
var defaultStyleGetterMap = {
  itemStyle: 'getItemStyle',
  lineStyle: 'getLineStyle',
  areaStyle: 'getAreaStyle'
};
/**
 * Set emphasis/blur/selected states of element.
 */

function setStatesStylesFromModel(el, itemModel, styleType, // default itemStyle
getter) {
  styleType = styleType || 'itemStyle';

  for (var i = 0; i < OTHER_STATES.length; i++) {
    var stateName = OTHER_STATES[i];
    var model = itemModel.getModel([stateName, styleType]);
    var state = el.ensureState(stateName); // Let it throw error if getterType is not found.

    state.style = getter ? getter(model) : model[defaultStyleGetterMap[styleType]]();
  }
}
/**
 *
 * Set element as highlight / downplay dispatcher.
 * It will be checked when element received mouseover event or from highlight action.
 * It's in change of all highlight/downplay behavior of it's children.
 *
 * @param el
 * @param el.highDownSilentOnTouch
 *        In touch device, mouseover event will be trigger on touchstart event
 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
 *        conveniently use hoverStyle when tap on touch screen without additional
 *        code for compatibility.
 *        But if the chart/component has select feature, which usually also use
 *        hoverStyle, there might be conflict between 'select-highlight' and
 *        'hover-highlight' especially when roam is enabled (see geo for example).
 *        In this case, `highDownSilentOnTouch` should be used to disable
 *        hover-highlight on touch device.
 * @param asDispatcher If `false`, do not set as "highDownDispatcher".
 */

function setAsHighDownDispatcher(el, asDispatcher) {
  var disable = asDispatcher === false;
  var extendedEl = el; // Make `highDownSilentOnTouch` and `onStateChange` only work after
  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.

  if (el.highDownSilentOnTouch) {
    extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
  } // Simple optimize, since this method might be
  // called for each elements of a group in some cases.


  if (!disable || extendedEl.__highDownDispatcher) {
    // Emphasis, normal can be triggered manually by API or other components like hover link.
    // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
    // Also keep previous record.
    extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
    extendedEl.__highDownDispatcher = !disable;
  }
}
function isHighDownDispatcher(el) {
  return !!(el && el.__highDownDispatcher);
}
/**
 * Enable component highlight/downplay features:
 * + hover link (within the same name)
 * + focus blur in component
 */

function enableComponentHighDownFeatures(el, componentModel, componentHighDownName) {
  var ecData = getECData(el);
  ecData.componentMainType = componentModel.mainType;
  ecData.componentIndex = componentModel.componentIndex;
  ecData.componentHighDownName = componentHighDownName;
}
/**
 * Support highlight/downplay record on each elements.
 * For the case: hover highlight/downplay (legend, visualMap, ...) and
 * user triggered highlight/downplay should not conflict.
 * Only all of the highlightDigit cleared, return to normal.
 * @param {string} highlightKey
 * @return {number} highlightDigit
 */

function getHighlightDigit(highlightKey) {
  var highlightDigit = _highlightKeyMap[highlightKey];

  if (highlightDigit == null && _highlightNextDigit <= 32) {
    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
  }

  return highlightDigit;
}
function isSelectChangePayload(payload) {
  var payloadType = payload.type;
  return payloadType === SELECT_ACTION_TYPE || payloadType === UNSELECT_ACTION_TYPE || payloadType === TOGGLE_SELECT_ACTION_TYPE;
}
function isHighDownPayload(payload) {
  var payloadType = payload.type;
  return payloadType === HIGHLIGHT_ACTION_TYPE || payloadType === DOWNPLAY_ACTION_TYPE;
}
function savePathStates(el) {
  var store = getSavedStates(el);
  store.normalFill = el.style.fill;
  store.normalStroke = el.style.stroke;
  var selectState = el.states.select || {};
  store.selectFill = selectState.style && selectState.style.fill || null;
  store.selectStroke = selectState.style && selectState.style.stroke || null;
}

var CMD$2 = PathProxy.CMD;
var points = [[], [], []];
var mathSqrt$1 = Math.sqrt;
var mathAtan2 = Math.atan2;
function transformPath(path, m) {
    if (!m) {
        return;
    }
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = CMD$2.M;
    var C = CMD$2.C;
    var L = CMD$2.L;
    var R = CMD$2.R;
    var A = CMD$2.A;
    var Q = CMD$2.Q;
    for (i = 0, j = 0; i < len;) {
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch (cmd) {
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = mathSqrt$1(m[0] * m[0] + m[1] * m[1]);
                var sy = mathSqrt$1(m[2] * m[2] + m[3] * m[3]);
                var angle = mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                applyTransform(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                applyTransform(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for (k = 0; k < nPoint; k++) {
            var p_1 = points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            applyTransform(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}

var mathSqrt$2 = Math.sqrt;
var mathSin$2 = Math.sin;
var mathCos$2 = Math.cos;
var PI$1 = Math.PI;
function vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
}
function vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1)
        * Math.acos(vRatio(u, v));
}
function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * (PI$1 / 180.0);
    var xp = mathCos$2(psi) * (x1 - x2) / 2.0
        + mathSin$2(psi) * (y1 - y2) / 2.0;
    var yp = -1 * mathSin$2(psi) * (x1 - x2) / 2.0
        + mathCos$2(psi) * (y1 - y2) / 2.0;
    var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
    if (lambda > 1) {
        rx *= mathSqrt$2(lambda);
        ry *= mathSqrt$2(lambda);
    }
    var f = (fa === fs ? -1 : 1)
        * mathSqrt$2((((rx * rx) * (ry * ry))
            - ((rx * rx) * (yp * yp))
            - ((ry * ry) * (xp * xp))) / ((rx * rx) * (yp * yp)
            + (ry * ry) * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0
        + mathCos$2(psi) * cxp
        - mathSin$2(psi) * cyp;
    var cy = (y1 + y2) / 2.0
        + mathSin$2(psi) * cxp
        + mathCos$2(psi) * cyp;
    var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
    var u = [(xp - cxp) / rx, (yp - cyp) / ry];
    var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
    var dTheta = vAngle(u, v);
    if (vRatio(u, v) <= -1) {
        dTheta = PI$1;
    }
    if (vRatio(u, v) >= 1) {
        dTheta = 0;
    }
    if (dTheta < 0) {
        var n = Math.round(dTheta / PI$1 * 1e6) / 1e6;
        dTheta = PI$1 * 2 + (n % 2) * PI$1;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function createPathProxyFromString(data) {
    var path = new PathProxy();
    if (!data) {
        return path;
    }
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = PathProxy.CMD;
    var cmdList = data.match(commandReg);
    if (!cmdList) {
        return path;
    }
    for (var l = 0; l < cmdList.length; l++) {
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match(numberReg) || [];
        var pLen = p.length;
        for (var i = 0; i < pLen; i++) {
            p[i] = parseFloat(p[i]);
        }
        var off = 0;
        while (off < pLen) {
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch (cmdStr) {
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var SVGPath = (function (_super) {
    __extends$1(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function (m) { };
    return SVGPath;
}(Path));
function isPathProxy(path) {
    return path.setData != null;
}
function createPathOptions(str, opts) {
    var pathProxy = createPathProxyFromString(str);
    var innerOpts = extend({}, opts);
    innerOpts.buildPath = function (path) {
        if (isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) {
                path.rebuildPath(ctx, 1);
            }
        }
        else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function (m) {
        transformPath(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function createFromString(str, opts) {
    return new SVGPath(createPathOptions(str, opts));
}
function extendFromString(str, defaultOpts) {
    var innerOpts = createPathOptions(str, defaultOpts);
    var Sub = (function (_super) {
        __extends$1(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }(SVGPath));
    return Sub;
}
function mergePath(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for (var i = 0; i < len; i++) {
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new Path(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function (path) {
        if (isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) {
                path.rebuildPath(ctx, 1);
            }
        }
    };
    return pathBundle;
}
function clonePath(sourcePath, opts) {
    opts = opts || {};
    var path = new Path();
    if (sourcePath.shape) {
        path.setShape(sourcePath.shape);
    }
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) {
        transformPath(path.path, sourcePath.getComputedTransform());
    }
    else {
        if (opts.toLocal) {
            path.setLocalTransform(sourcePath.getComputedTransform());
        }
        else {
            path.copyTransform(sourcePath);
        }
    }
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}

var CircleShape = (function () {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}());
var Circle$1 = (function (_super) {
    __extends$1(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function () {
        return new CircleShape();
    };
    Circle.prototype.buildPath = function (ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}(Path));
Circle$1.prototype.type = 'circle';

var EllipseShape = (function () {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}());
var Ellipse = (function (_super) {
    __extends$1(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function () {
        return new EllipseShape();
    };
    Ellipse.prototype.buildPath = function (ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}(Path));
Ellipse.prototype.type = 'ellipse';

var PI$2 = Math.PI;
var PI2$5 = PI$2 * 2;
var mathSin$3 = Math.sin;
var mathCos$3 = Math.cos;
var mathACos = Math.acos;
var mathATan2 = Math.atan2;
var mathAbs$1 = Math.abs;
var mathSqrt$3 = Math.sqrt;
var mathMax$3 = Math.max;
var mathMin$3 = Math.min;
var e$2 = 1e-4;
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < e$2) {
        return;
    }
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [x0 + t * dx10, y0 + t * dy10];
}
function computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / mathSqrt$3(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * mathSqrt$3(mathMax$3(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function normalizeCornerRadius(cr) {
    var arr;
    if (isArray$1(cr)) {
        var len = cr.length;
        if (!len) {
            return cr;
        }
        if (len === 1) {
            arr = [cr[0], cr[0], 0, 0];
        }
        else if (len === 2) {
            arr = [cr[0], cr[0], cr[1], cr[1]];
        }
        else if (len === 3) {
            arr = cr.concat(cr[2]);
        }
        else {
            arr = cr;
        }
    }
    else {
        arr = [cr, cr, cr, cr];
    }
    return arr;
}
function buildPath$1(ctx, shape) {
    var _a;
    var radius = mathMax$3(shape.r, 0);
    var innerRadius = mathMax$3(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) {
        return;
    }
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) {
        return;
    }
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = mathAbs$1(endAngle - startAngle);
    var mod = arc > PI2$5 && arc % PI2$5;
    mod > e$2 && (arc = mod);
    if (!(radius > e$2)) {
        ctx.moveTo(cx, cy);
    }
    else if (arc > PI2$5 - e$2) {
        ctx.moveTo(cx + radius * mathCos$3(startAngle), cy + radius * mathSin$3(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > e$2) {
            ctx.moveTo(cx + innerRadius * mathCos$3(endAngle), cy + innerRadius * mathSin$3(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * mathCos$3(startAngle);
        var yrs = radius * mathSin$3(startAngle);
        var xire = innerRadius * mathCos$3(endAngle);
        var yire = innerRadius * mathSin$3(endAngle);
        var hasArc = arc > e$2;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) {
                _a = normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            }
            var halfRd = mathAbs$1(radius - innerRadius) / 2;
            ocrs = mathMin$3(halfRd, ocrStart);
            ocre = mathMin$3(halfRd, ocrEnd);
            icrs = mathMin$3(halfRd, icrStart);
            icre = mathMin$3(halfRd, icrEnd);
            limitedOcrMax = ocrMax = mathMax$3(ocrs, ocre);
            limitedIcrMax = icrMax = mathMax$3(icrs, icre);
            if (ocrMax > e$2 || icrMax > e$2) {
                xre = radius * mathCos$3(endAngle);
                yre = radius * mathSin$3(endAngle);
                xirs = innerRadius * mathCos$3(startAngle);
                yirs = innerRadius * mathSin$3(startAngle);
                if (arc < PI$2) {
                    var it_1 = intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / mathSin$3(mathACos((x0 * x1 + y0 * y1) / (mathSqrt$3(x0 * x0 + y0 * y0) * mathSqrt$3(x1 * x1 + y1 * y1))) / 2);
                        var b = mathSqrt$3(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = mathMin$3(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = mathMin$3(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) {
            ctx.moveTo(cx + xrs, cy + yrs);
        }
        else if (limitedOcrMax > e$2) {
            var crStart = mathMin$3(ocrStart, limitedOcrMax);
            var crEnd = mathMin$3(ocrEnd, limitedOcrMax);
            var ct0 = computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) {
                ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        }
        else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > e$2) || !hasArc) {
            ctx.lineTo(cx + xire, cy + yire);
        }
        else if (limitedIcrMax > e$2) {
            var crStart = mathMin$3(icrStart, limitedIcrMax);
            var crEnd = mathMin$3(icrEnd, limitedIcrMax);
            var ct0 = computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) {
                ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, mathATan2(ct0.y0, ct0.x0), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, mathATan2(ct0.y0, ct0.x0), mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, mathATan2(ct1.y1, ct1.x1), mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        }
        else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}

var SectorShape = (function () {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}());
var Sector = (function (_super) {
    __extends$1(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function () {
        return new SectorShape();
    };
    Sector.prototype.buildPath = function (ctx, shape) {
        buildPath$1(ctx, shape);
    };
    Sector.prototype.isZeroArea = function () {
        return this.shape.startAngle === this.shape.endAngle
            || this.shape.r === this.shape.r0;
    };
    return Sector;
}(Path));
Sector.prototype.type = 'sector';

var RingShape = (function () {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}());
var Ring = (function (_super) {
    __extends$1(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function () {
        return new RingShape();
    };
    Ring.prototype.buildPath = function (ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}(Path));
Ring.prototype.type = 'ring';

function smoothBezier(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [Infinity, Infinity];
        max = [-Infinity, -Infinity];
        for (var i = 0, len = points.length; i < len; i++) {
            min$1(min, min, points[i]);
            max$1(max, max, points[i]);
        }
        min$1(min, min, constraint[0]);
        max$1(max, max, constraint[1]);
    }
    for (var i = 0, len = points.length; i < len; i++) {
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        }
        else {
            if (i === 0 || i === len - 1) {
                cps.push(clone$1(points[i]));
                continue;
            }
            else {
                prevPoint = points[i - 1];
                nextPoint = points[i + 1];
            }
        }
        sub(v, nextPoint, prevPoint);
        scale(v, v, smooth);
        var d0 = distance(point, prevPoint);
        var d1 = distance(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        scale(v1, v, -d0);
        scale(v2, v, d1);
        var cp0 = add$1([], point, v1);
        var cp1 = add$1([], point, v2);
        if (constraint) {
            max$1(cp0, cp0, min);
            min$1(cp0, cp0, max);
            max$1(cp1, cp1, min);
            min$1(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) {
        cps.push(cps.shift());
    }
    return cps;
}

function buildPath$2(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for (var i = 0; i < (closePath ? len : len - 1); i++) {
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        }
        else {
            ctx.moveTo(points[0][0], points[0][1]);
            for (var i = 1, l = points.length; i < l; i++) {
                ctx.lineTo(points[i][0], points[i][1]);
            }
        }
        closePath && ctx.closePath();
    }
}

var PolygonShape = (function () {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}());
var Polygon = (function (_super) {
    __extends$1(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function () {
        return new PolygonShape();
    };
    Polygon.prototype.buildPath = function (ctx, shape) {
        buildPath$2(ctx, shape, true);
    };
    return Polygon;
}(Path));
Polygon.prototype.type = 'polygon';

var PolylineShape = (function () {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}());
var Polyline = (function (_super) {
    __extends$1(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function () {
        return new PolylineShape();
    };
    Polyline.prototype.buildPath = function (ctx, shape) {
        buildPath$2(ctx, shape, false);
    };
    return Polyline;
}(Path));
Polyline.prototype.type = 'polyline';

var subPixelOptimizeOutputShape$1 = {};
var LineShape = (function () {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}());
var Line = (function (_super) {
    __extends$1(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function () {
        return new LineShape();
    };
    Line.prototype.buildPath = function (ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = subPixelOptimizeLine(subPixelOptimizeOutputShape$1, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        }
        else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) {
            return;
        }
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function (p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}(Path));
Line.prototype.type = 'line';

var out = [];
var BezierCurveShape = (function () {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}());
function someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) {
        return [
            (isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
            (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
        ];
    }
    else {
        return [
            (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t),
            (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)
        ];
    }
}
var BezierCurve = (function (_super) {
    __extends$1(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function () {
        return new BezierCurveShape();
    };
    BezierCurve.prototype.buildPath = function (ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) {
            return;
        }
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                quadraticSubdivide(x1, cpx1, x2, percent, out);
                cpx1 = out[1];
                x2 = out[2];
                quadraticSubdivide(y1, cpy1, y2, percent, out);
                cpy1 = out[1];
                y2 = out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        }
        else {
            if (percent < 1) {
                cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
                cpx1 = out[1];
                cpx2 = out[2];
                x2 = out[3];
                cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
                cpy1 = out[1];
                cpy2 = out[2];
                y2 = out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function (t) {
        return someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function (t) {
        var p = someVectorAt(this.shape, t, true);
        return normalize(p, p);
    };
    return BezierCurve;
}(Path));
BezierCurve.prototype.type = 'bezier-curve';

var ArcShape = (function () {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}());
var Arc = (function (_super) {
    __extends$1(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function () {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function () {
        return new ArcShape();
    };
    Arc.prototype.buildPath = function (ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}(Path));
Arc.prototype.type = 'arc';

var CompoundPath = (function (_super) {
    __extends$1(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function () {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for (var i = 0; i < paths.length; i++) {
            dirtyPath = dirtyPath || paths[i].shapeChanged();
        }
        if (dirtyPath) {
            this.dirtyShape();
        }
    };
    CompoundPath.prototype.beforeBrush = function () {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for (var i = 0; i < paths.length; i++) {
            if (!paths[i].path) {
                paths[i].createPathProxy();
            }
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function (ctx, shape) {
        var paths = shape.paths || [];
        for (var i = 0; i < paths.length; i++) {
            paths[i].buildPath(ctx, paths[i].shape, true);
        }
    };
    CompoundPath.prototype.afterBrush = function () {
        var paths = this.shape.paths || [];
        for (var i = 0; i < paths.length; i++) {
            paths[i].pathUpdated();
        }
    };
    CompoundPath.prototype.getBoundingRect = function () {
        this._updatePathDirty.call(this);
        return Path.prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}(Path));

var Gradient = (function () {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function (offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}());

var LinearGradient = (function (_super) {
    __extends$1(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}(Gradient));

var RadialGradient = (function (_super) {
    __extends$1(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}(Gradient));

var extent = [0, 0];
var extent2 = [0, 0];
var minTv$1 = new Point();
var maxTv$1 = new Point();
var OrientedBoundingRect = (function () {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [0, 0];
        for (var i = 0; i < 4; i++) {
            this._corners[i] = new Point();
        }
        for (var i = 0; i < 2; i++) {
            this._axes[i] = new Point();
        }
        if (rect) {
            this.fromBoundingRect(rect, transform);
        }
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function (rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) {
            for (var i = 0; i < 4; i++) {
                corners[i].transform(transform);
            }
        }
        Point.sub(axes[0], corners[1], corners[0]);
        Point.sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for (var i = 0; i < 2; i++) {
            this._origin[i] = axes[i].dot(corners[0]);
        }
    };
    OrientedBoundingRect.prototype.intersect = function (other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        minTv$1.set(Infinity, Infinity);
        maxTv$1.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, minTv$1, maxTv$1, noMtv, 1)) {
            overlapped = false;
            if (noMtv) {
                return overlapped;
            }
        }
        if (!this._intersectCheckOneSide(other, this, minTv$1, maxTv$1, noMtv, -1)) {
            overlapped = false;
            if (noMtv) {
                return overlapped;
            }
        }
        if (!noMtv) {
            Point.copy(mtv, overlapped ? minTv$1 : maxTv$1);
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function (self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for (var i = 0; i < 2; i++) {
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, extent);
            this._getProjMinMaxOnAxis(i, other._corners, extent2);
            if (extent[1] < extent2[0] || extent[0] > extent2[1]) {
                overlapped = false;
                if (noMtv) {
                    return overlapped;
                }
                var dist0 = Math.abs(extent2[0] - extent[1]);
                var dist1 = Math.abs(extent[0] - extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) {
                        Point.scale(maxTv, axis, -dist0 * inverse);
                    }
                    else {
                        Point.scale(maxTv, axis, dist1 * inverse);
                    }
                }
            }
            else if (minTv) {
                var dist0 = Math.abs(extent2[0] - extent[1]);
                var dist1 = Math.abs(extent[0] - extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) {
                        Point.scale(minTv, axis, dist0 * inverse);
                    }
                    else {
                        Point.scale(minTv, axis, -dist1 * inverse);
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function (dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for (var i = 1; i < corners.length; i++) {
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}());

var m$2 = [];
var IncrementalDisplayable = (function (_super) {
    __extends$1(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function (cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function () {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function () {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function () {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function () {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function () {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function (displayable, notPersistent) {
        if (notPersistent) {
            this._temporaryDisplayables.push(displayable);
        }
        else {
            this._displayables.push(displayable);
        }
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function (displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for (var i = 0; i < displayables.length; i++) {
            this.addDisplayable(displayables[i], notPersistent);
        }
    };
    IncrementalDisplayable.prototype.getDisplayables = function () {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function () {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function (cb) {
        for (var i = this._cursor; i < this._displayables.length; i++) {
            cb && cb(this._displayables[i]);
        }
        for (var i = 0; i < this._temporaryDisplayables.length; i++) {
            cb && cb(this._temporaryDisplayables[i]);
        }
    };
    IncrementalDisplayable.prototype.update = function () {
        this.updateTransform();
        for (var i = this._cursor; i < this._displayables.length; i++) {
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for (var i = 0; i < this._temporaryDisplayables.length; i++) {
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function () {
        if (!this._rect) {
            var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
            for (var i = 0; i < this._displayables.length; i++) {
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) {
                    childRect.applyTransform(displayable.getLocalTransform(m$2));
                }
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function (x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) {
            for (var i = 0; i < this._displayables.length; i++) {
                var displayable = this._displayables[i];
                if (displayable.contain(x, y)) {
                    return true;
                }
            }
        }
        return false;
    };
    return IncrementalDisplayable;
}(Displayable));

var transitionStore = makeInner();
/**
 * Return null if animation is disabled.
 */

function getAnimationConfig(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
  var animationPayload; // Check if there is global animation configuration from dataZoom/resize can override the config in option.
  // If animation is enabled. Will use this animation config in payload.
  // If animation is disabled. Just ignore it.

  if (animatableModel && animatableModel.ecModel) {
    var updatePayload = animatableModel.ecModel.getUpdatePayload();
    animationPayload = updatePayload && updatePayload.animation;
  }

  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
  var isUpdate = animationType === 'update';

  if (animationEnabled) {
    var duration = void 0;
    var easing = void 0;
    var delay = void 0;

    if (extraOpts) {
      duration = retrieve2(extraOpts.duration, 200);
      easing = retrieve2(extraOpts.easing, 'cubicOut');
      delay = 0;
    } else {
      duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
      easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
      delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
    } // animation from payload has highest priority.


    if (animationPayload) {
      animationPayload.duration != null && (duration = animationPayload.duration);
      animationPayload.easing != null && (easing = animationPayload.easing);
      animationPayload.delay != null && (delay = animationPayload.delay);
    }

    if (isFunction$3(delay)) {
      delay = delay(dataIndex, extraDelayParams);
    }

    if (isFunction$3(duration)) {
      duration = duration(dataIndex);
    }

    var config = {
      duration: duration || 0,
      delay: delay,
      easing: easing
    };
    return config;
  } else {
    return null;
  }
}

function animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
  var isFrom = false;
  var removeOpt;

  if (isFunction$3(dataIndex)) {
    during = cb;
    cb = dataIndex;
    dataIndex = null;
  } else if (isObject$2(dataIndex)) {
    cb = dataIndex.cb;
    during = dataIndex.during;
    isFrom = dataIndex.isFrom;
    removeOpt = dataIndex.removeOpt;
    dataIndex = dataIndex.dataIndex;
  }

  var isRemove = animationType === 'leave';

  if (!isRemove) {
    // Must stop the remove animation.
    el.stopAnimation('leave');
  }

  var animationConfig = getAnimationConfig(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);

  if (animationConfig && animationConfig.duration > 0) {
    var duration = animationConfig.duration;
    var animationDelay = animationConfig.delay;
    var animationEasing = animationConfig.easing;
    var animateConfig = {
      duration: duration,
      delay: animationDelay || 0,
      easing: animationEasing,
      done: cb,
      force: !!cb || !!during,
      // Set to final state in update/init animation.
      // So the post processing based on the path shape can be done correctly.
      setToFinal: !isRemove,
      scope: animationType,
      during: during
    };
    isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
  } else {
    el.stopAnimation(); // If `isFrom`, the props is the "from" props.

    !isFrom && el.attr(props); // Call during at least once.

    during && during(1);
    cb && cb();
  }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */


function updateProps(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
  animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
/**
 * Init graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 */

function initProps(el, props, animatableModel, dataIndex, cb, during) {
  animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
/**
 * If element is removed.
 * It can determine if element is having remove animation.
 */

function isElementRemoved(el) {
  if (!el.__zr) {
    return true;
  }

  for (var i = 0; i < el.animators.length; i++) {
    var animator = el.animators[i];

    if (animator.scope === 'leave') {
      return true;
    }
  }

  return false;
}
/**
 * Remove graphic element
 */

function removeElement(el, props, animatableModel, dataIndex, cb, during) {
  // Don't do remove animation twice.
  if (isElementRemoved(el)) {
    return;
  }

  animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}

function fadeOutDisplayable(el, animatableModel, dataIndex, done) {
  el.removeTextContent();
  el.removeTextGuideLine();
  removeElement(el, {
    style: {
      opacity: 0
    }
  }, animatableModel, dataIndex, done);
}

function removeElementWithFadeOut(el, animatableModel, dataIndex) {
  function doRemove() {
    el.parent && el.parent.remove(el);
  } // Hide label and labelLine first
  // TODO Also use fade out animation?


  if (!el.isGroup) {
    fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
  } else {
    el.traverse(function (disp) {
      if (!disp.isGroup) {
        // Can invoke doRemove multiple times.
        fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
      }
    });
  }
}
/**
 * Save old style for style transition in universalTransition module.
 * It's used when element will be reused in each render.
 * For chart like map, heatmap, which will always create new element.
 * We don't need to save this because universalTransition can get old style from the old element
 */

function saveOldStyle(el) {
  transitionStore(el).oldStyle = el.style;
}
function getOldStyle(el) {
  return transitionStore(el).oldStyle;
}

var mathMax$4 = Math.max;
var mathMin$4 = Math.min;
var _customShapeMap = {};
/**
 * Extend shape with parameters
 */

function extendShape(opts) {
  return Path.extend(opts);
}
var extendPathFromString = extendFromString;
/**
 * Extend path
 */

function extendPath(pathData, opts) {
  return extendPathFromString(pathData, opts);
}
/**
 * Register a user defined shape.
 * The shape class can be fetched by `getShapeClass`
 * This method will overwrite the registered shapes, including
 * the registered built-in shapes, if using the same `name`.
 * The shape can be used in `custom series` and
 * `graphic component` by declaring `{type: name}`.
 *
 * @param name
 * @param ShapeClass Can be generated by `extendShape`.
 */

function registerShape(name, ShapeClass) {
  _customShapeMap[name] = ShapeClass;
}
/**
 * Find shape class registered by `registerShape`. Usually used in
 * fetching user defined shape.
 *
 * [Caution]:
 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
 * to use user registered shapes.
 * Because the built-in shape (see `getBuiltInShape`) will be registered by
 * `registerShape` by default. That enables users to get both built-in
 * shapes as well as the shapes belonging to themsleves. But users can overwrite
 * the built-in shapes by using names like 'circle', 'rect' via calling
 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
 * in case that it is overwritten by users, except that some features, like
 * `custom series`, `graphic component`, do it deliberately.
 *
 * (2) In the features like `custom series`, `graphic component`, the user input
 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
 * are reserved names, that is, if some user registers a shape named `'image'`,
 * the shape will not be used. If we intending to add some more reserved names
 * in feature, that might bring break changes (disable some existing user shape
 * names). But that case probably rarely happens. So we don't make more mechanism
 * to resolve this issue here.
 *
 * @param name
 * @return The shape class. If not found, return nothing.
 */

function getShapeClass(name) {
  if (_customShapeMap.hasOwnProperty(name)) {
    return _customShapeMap[name];
  }
}
/**
 * Create a path element from path data string
 * @param pathData
 * @param opts
 * @param rect
 * @param layout 'center' or 'cover' default to be cover
 */

function makePath(pathData, opts, rect, layout) {
  var path = createFromString(pathData, opts);

  if (rect) {
    if (layout === 'center') {
      rect = centerGraphic(rect, path.getBoundingRect());
    }

    resizePath(path, rect);
  }

  return path;
}
/**
 * Create a image element from image url
 * @param imageUrl image url
 * @param opts options
 * @param rect constrain rect
 * @param layout 'center' or 'cover'. Default to be 'cover'
 */

function makeImage(imageUrl, rect, layout) {
  var zrImg = new ZRImage({
    style: {
      image: imageUrl,
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    onload: function (img) {
      if (layout === 'center') {
        var boundingRect = {
          width: img.width,
          height: img.height
        };
        zrImg.setStyle(centerGraphic(rect, boundingRect));
      }
    }
  });
  return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */

function centerGraphic(rect, boundingRect) {
  // Set rect to center, keep width / height ratio.
  var aspect = boundingRect.width / boundingRect.height;
  var width = rect.height * aspect;
  var height;

  if (width <= rect.width) {
    height = rect.height;
  } else {
    width = rect.width;
    height = width / aspect;
  }

  var cx = rect.x + rect.width / 2;
  var cy = rect.y + rect.height / 2;
  return {
    x: cx - width / 2,
    y: cy - height / 2,
    width: width,
    height: height
  };
}

var mergePath$1 = mergePath;
/**
 * Resize a path to fit the rect
 * @param path
 * @param rect
 */

function resizePath(path, rect) {
  if (!path.applyTransform) {
    return;
  }

  var pathRect = path.getBoundingRect();
  var m = pathRect.calculateTransform(rect);
  path.applyTransform(m);
}
/**
 * Sub pixel optimize line for canvas
 */

function subPixelOptimizeLine$1(shape, lineWidth) {
  subPixelOptimizeLine(shape, shape, {
    lineWidth: lineWidth
  });
  return shape;
}
/**
 * Sub pixel optimize rect for canvas
 */

function subPixelOptimizeRect$1(param) {
  subPixelOptimizeRect(param.shape, param.shape, param.style);
  return param;
}
/**
 * Sub pixel optimize for canvas
 *
 * @param position Coordinate, such as x, y
 * @param lineWidth Should be nonnegative integer.
 * @param positiveOrNegative Default false (negative).
 * @return Optimized position.
 */

var subPixelOptimize$1 = subPixelOptimize;
/**
 * Get transform matrix of target (param target),
 * in coordinate of its ancestor (param ancestor)
 *
 * @param target
 * @param [ancestor]
 */

function getTransform(target, ancestor) {
  var mat = identity$1([]);

  while (target && target !== ancestor) {
    mul$1(mat, target.getLocalTransform(), mat);
    target = target.parent;
  }

  return mat;
}
/**
 * Apply transform to an vertex.
 * @param target [x, y]
 * @param transform Can be:
 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
 * @param invert Whether use invert matrix.
 * @return [x, y]
 */

function applyTransform$1(target, transform, invert$1) {
  if (transform && !isArrayLike$1(transform)) {
    transform = Transformable.getLocalTransform(transform);
  }

  if (invert$1) {
    transform = invert([], transform);
  }

  return applyTransform([], target, transform);
}
/**
 * @param direction 'left' 'right' 'top' 'bottom'
 * @param transform Transform matrix: like [1, 0, 0, 1, 0, 0]
 * @param invert Whether use invert matrix.
 * @return Transformed direction. 'left' 'right' 'top' 'bottom'
 */

function transformDirection(direction, transform, invert) {
  // Pick a base, ensure that transform result will not be (0, 0).
  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
  vertex = applyTransform$1(vertex, transform, invert);
  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}

function isNotGroup(el) {
  return !el.isGroup;
}

function isPath(el) {
  return el.shape != null;
}
/**
 * Apply group transition animation from g1 to g2.
 * If no animatableModel, no animation.
 */


function groupTransition(g1, g2, animatableModel) {
  if (!g1 || !g2) {
    return;
  }

  function getElMap(g) {
    var elMap = {};
    g.traverse(function (el) {
      if (isNotGroup(el) && el.anid) {
        elMap[el.anid] = el;
      }
    });
    return elMap;
  }

  function getAnimatableProps(el) {
    var obj = {
      x: el.x,
      y: el.y,
      rotation: el.rotation
    };

    if (isPath(el)) {
      obj.shape = extend({}, el.shape);
    }

    return obj;
  }

  var elMap1 = getElMap(g1);
  g2.traverse(function (el) {
    if (isNotGroup(el) && el.anid) {
      var oldEl = elMap1[el.anid];

      if (oldEl) {
        var newProp = getAnimatableProps(el);
        el.attr(getAnimatableProps(oldEl));
        updateProps(el, newProp, animatableModel, getECData(el).dataIndex);
      }
    }
  });
}
function clipPointsByRect(points, rect) {
  // FIXME: This way might be incorrect when graphic clipped by a corner
  // and when element has a border.
  return map(points, function (point) {
    var x = point[0];
    x = mathMax$4(x, rect.x);
    x = mathMin$4(x, rect.x + rect.width);
    var y = point[1];
    y = mathMax$4(y, rect.y);
    y = mathMin$4(y, rect.y + rect.height);
    return [x, y];
  });
}
/**
 * Return a new clipped rect. If rect size are negative, return undefined.
 */

function clipRectByRect(targetRect, rect) {
  var x = mathMax$4(targetRect.x, rect.x);
  var x2 = mathMin$4(targetRect.x + targetRect.width, rect.x + rect.width);
  var y = mathMax$4(targetRect.y, rect.y);
  var y2 = mathMin$4(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
  // should be painted. So return undefined.

  if (x2 >= x && y2 >= y) {
    return {
      x: x,
      y: y,
      width: x2 - x,
      height: y2 - y
    };
  }
}
function createIcon(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
  var innerOpts = extend({
    rectHover: true
  }, opt);
  var style = innerOpts.style = {
    strokeNoScale: true
  };
  rect = rect || {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  };

  if (iconStr) {
    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), defaults(style, rect), new ZRImage(innerOpts)) : makePath(iconStr.replace('path://', ''), innerOpts, rect, 'center');
  }
}
/**
 * Return `true` if the given line (line `a`) and the given polygon
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 */

function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
    var p = points[i];

    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
      return true;
    }

    p2 = p;
  }
}
/**
 * Return `true` if the given two lines (line `a` and line `b`)
 * are intersect.
 * Note that we do not count colinear as intersect here because no
 * requirement for that. We could do that if required in future.
 */

function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
  var mx = a2x - a1x;
  var my = a2y - a1y;
  var nx = b2x - b1x;
  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
  //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.

  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);

  if (nearZero(nmCrossProduct)) {
    return false;
  } // `vec_m` and `vec_n` are intersect iff
  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.


  var b1a1x = a1x - b1x;
  var b1a1y = a1y - b1y;
  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;

  if (q < 0 || q > 1) {
    return false;
  }

  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;

  if (p < 0 || p > 1) {
    return false;
  }

  return true;
}
/**
 * Cross product of 2-dimension vector.
 */

function crossProduct2d(x1, y1, x2, y2) {
  return x1 * y2 - x2 * y1;
}

function nearZero(val) {
  return val <= 1e-6 && val >= -1e-6;
}

function setTooltipConfig(opt) {
  var itemTooltipOption = opt.itemTooltipOption;
  var componentModel = opt.componentModel;
  var itemName = opt.itemName;
  var itemTooltipOptionObj = isString(itemTooltipOption) ? {
    formatter: itemTooltipOption
  } : itemTooltipOption;
  var mainType = componentModel.mainType;
  var componentIndex = componentModel.componentIndex;
  var formatterParams = {
    componentType: mainType,
    name: itemName,
    $vars: ['name']
  };
  formatterParams[mainType + 'Index'] = componentIndex;
  var formatterParamsExtra = opt.formatterParamsExtra;

  if (formatterParamsExtra) {
    each(keys$2(formatterParamsExtra), function (key) {
      if (!hasOwn(formatterParams, key)) {
        formatterParams[key] = formatterParamsExtra[key];
        formatterParams.$vars.push(key);
      }
    });
  }

  var ecData = getECData(opt.el);
  ecData.componentMainType = mainType;
  ecData.componentIndex = componentIndex;
  ecData.tooltipConfig = {
    name: itemName,
    option: defaults({
      content: itemName,
      formatterParams: formatterParams
    }, itemTooltipOptionObj)
  };
}

function traverseElement(el, cb) {
  var stopped; // TODO
  // Polyfill for fixing zrender group traverse don't visit it's root issue.

  if (el.isGroup) {
    stopped = cb(el);
  }

  if (!stopped) {
    el.traverse(cb);
  }
}

function traverseElements(els, cb) {
  if (els) {
    if (isArray$1(els)) {
      for (var i = 0; i < els.length; i++) {
        traverseElement(els[i], cb);
      }
    } else {
      traverseElement(els, cb);
    }
  }
} // Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.

registerShape('circle', Circle$1);
registerShape('ellipse', Ellipse);
registerShape('sector', Sector);
registerShape('ring', Ring);
registerShape('polygon', Polygon);
registerShape('polyline', Polyline);
registerShape('rect', Rect);
registerShape('line', Line);
registerShape('bezierCurve', BezierCurve);
registerShape('arc', Arc);

var graphic = /*#__PURE__*/Object.freeze({
	__proto__: null,
	updateProps: updateProps,
	initProps: initProps,
	removeElement: removeElement,
	removeElementWithFadeOut: removeElementWithFadeOut,
	isElementRemoved: isElementRemoved,
	extendShape: extendShape,
	extendPath: extendPath,
	registerShape: registerShape,
	getShapeClass: getShapeClass,
	makePath: makePath,
	makeImage: makeImage,
	mergePath: mergePath$1,
	resizePath: resizePath,
	subPixelOptimizeLine: subPixelOptimizeLine$1,
	subPixelOptimizeRect: subPixelOptimizeRect$1,
	subPixelOptimize: subPixelOptimize$1,
	getTransform: getTransform,
	applyTransform: applyTransform$1,
	transformDirection: transformDirection,
	groupTransition: groupTransition,
	clipPointsByRect: clipPointsByRect,
	clipRectByRect: clipRectByRect,
	createIcon: createIcon,
	linePolygonIntersect: linePolygonIntersect,
	lineLineIntersect: lineLineIntersect,
	setTooltipConfig: setTooltipConfig,
	traverseElements: traverseElements,
	Group: Group$1,
	Image: ZRImage,
	Text: ZRText,
	Circle: Circle$1,
	Ellipse: Ellipse,
	Sector: Sector,
	Ring: Ring,
	Polygon: Polygon,
	Polyline: Polyline,
	Rect: Rect,
	Line: Line,
	BezierCurve: BezierCurve,
	Arc: Arc,
	IncrementalDisplayable: IncrementalDisplayable,
	CompoundPath: CompoundPath,
	LinearGradient: LinearGradient,
	RadialGradient: RadialGradient,
	BoundingRect: BoundingRect,
	OrientedBoundingRect: OrientedBoundingRect,
	Point: Point,
	Path: Path
});

var EMPTY_OBJ = {};
function setLabelText(label, labelTexts) {
  for (var i = 0; i < SPECIAL_STATES.length; i++) {
    var stateName = SPECIAL_STATES[i];
    var text = labelTexts[stateName];
    var state = label.ensureState(stateName);
    state.style = state.style || {};
    state.style.text = text;
  }

  var oldStates = label.currentStates.slice();
  label.clearStates(true);
  label.setStyle({
    text: labelTexts.normal
  });
  label.useStates(oldStates, true);
}

function getLabelText(opt, stateModels, interpolatedValue) {
  var labelFetcher = opt.labelFetcher;
  var labelDataIndex = opt.labelDataIndex;
  var labelDimIndex = opt.labelDimIndex;
  var normalModel = stateModels.normal;
  var baseText;

  if (labelFetcher) {
    baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
      interpolatedValue: interpolatedValue
    } : null);
  }

  if (baseText == null) {
    baseText = isFunction$3(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
  }

  var statesText = {
    normal: baseText
  };

  for (var i = 0; i < SPECIAL_STATES.length; i++) {
    var stateName = SPECIAL_STATES[i];
    var stateModel = stateModels[stateName];
    statesText[stateName] = retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
  }

  return statesText;
}

function setLabelStyle(targetEl, labelStatesModels, opt, stateSpecified // TODO specified position?
) {
  opt = opt || EMPTY_OBJ;
  var isSetOnText = targetEl instanceof ZRText;
  var needsCreateText = false;

  for (var i = 0; i < DISPLAY_STATES.length; i++) {
    var stateModel = labelStatesModels[DISPLAY_STATES[i]];

    if (stateModel && stateModel.getShallow('show')) {
      needsCreateText = true;
      break;
    }
  }

  var textContent = isSetOnText ? targetEl : targetEl.getTextContent();

  if (needsCreateText) {
    if (!isSetOnText) {
      // Reuse the previous
      if (!textContent) {
        textContent = new ZRText();
        targetEl.setTextContent(textContent);
      } // Use same state proxy


      if (targetEl.stateProxy) {
        textContent.stateProxy = targetEl.stateProxy;
      }
    }

    var labelStatesTexts = getLabelText(opt, labelStatesModels);
    var normalModel = labelStatesModels.normal;
    var showNormal = !!normalModel.getShallow('show');
    var normalStyle = createTextStyle(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
    normalStyle.text = labelStatesTexts.normal;

    if (!isSetOnText) {
      // Always create new
      targetEl.setTextConfig(createTextConfig(normalModel, opt, false));
    }

    for (var i = 0; i < SPECIAL_STATES.length; i++) {
      var stateName = SPECIAL_STATES[i];
      var stateModel = labelStatesModels[stateName];

      if (stateModel) {
        var stateObj = textContent.ensureState(stateName);
        var stateShow = !!retrieve2(stateModel.getShallow('show'), showNormal);

        if (stateShow !== showNormal) {
          stateObj.ignore = !stateShow;
        }

        stateObj.style = createTextStyle(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
        stateObj.style.text = labelStatesTexts[stateName];

        if (!isSetOnText) {
          var targetElEmphasisState = targetEl.ensureState(stateName);
          targetElEmphasisState.textConfig = createTextConfig(stateModel, opt, true);
        }
      }
    } // PENDING: if there is many requirements that emphasis position
    // need to be different from normal position, we might consider
    // auto silent is those cases.


    textContent.silent = !!normalModel.getShallow('silent'); // Keep x and y

    if (textContent.style.x != null) {
      normalStyle.x = textContent.style.x;
    }

    if (textContent.style.y != null) {
      normalStyle.y = textContent.style.y;
    }

    textContent.ignore = !showNormal; // Always create new style.

    textContent.useStyle(normalStyle);
    textContent.dirty();

    if (opt.enableTextSetter) {
      labelInner(textContent).setLabelText = function (interpolatedValue) {
        var labelStatesTexts = getLabelText(opt, labelStatesModels, interpolatedValue);
        setLabelText(textContent, labelStatesTexts);
      };
    }
  } else if (textContent) {
    // Not display rich text.
    textContent.ignore = true;
  }

  targetEl.dirty();
}
function getLabelStatesModels(itemModel, labelName) {
  labelName = labelName || 'label';
  var statesModels = {
    normal: itemModel.getModel(labelName)
  };

  for (var i = 0; i < SPECIAL_STATES.length; i++) {
    var stateName = SPECIAL_STATES[i];
    statesModels[stateName] = itemModel.getModel([stateName, labelName]);
  }

  return statesModels;
}
/**
 * Set basic textStyle properties.
 */

function createTextStyle(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
  var textStyle = {};
  setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
  specifiedTextStyle && extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);

  return textStyle;
}
function createTextConfig(textStyleModel, opt, isNotNormal) {
  opt = opt || {};
  var textConfig = {};
  var labelPosition;
  var labelRotate = textStyleModel.getShallow('rotate');
  var labelDistance = retrieve2(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
  var labelOffset = textStyleModel.getShallow('offset');
  labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
  // in bar series, and magric type should be considered.

  labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');

  if (labelPosition != null) {
    textConfig.position = labelPosition;
  }

  if (labelOffset != null) {
    textConfig.offset = labelOffset;
  }

  if (labelRotate != null) {
    labelRotate *= Math.PI / 180;
    textConfig.rotation = labelRotate;
  }

  if (labelDistance != null) {
    textConfig.distance = labelDistance;
  } // fill and auto is determined by the color of path fill if it's not specified by developers.


  textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
  return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */

function setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
  // Consider there will be abnormal when merge hover style to normal style if given default value.
  opt = opt || EMPTY_OBJ;
  var ecModel = textStyleModel.ecModel;
  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
  // {
  //     data: [{
  //         value: 12,
  //         label: {
  //             rich: {
  //                 // no 'a' here but using parent 'a'.
  //             }
  //         }
  //     }],
  //     rich: {
  //         a: { ... }
  //     }
  // }

  var richItemNames = getRichItemNames(textStyleModel);
  var richResult;

  if (richItemNames) {
    richResult = {};

    for (var name_1 in richItemNames) {
      if (richItemNames.hasOwnProperty(name_1)) {
        // Cascade is supported in rich.
        var richTextStyle = textStyleModel.getModel(['rich', name_1]); // In rich, never `disableBox`.
        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
        // the default color `'blue'` will not be adopted if no color declared in `rich`.
        // That might confuses users. So probably we should put `textStyleModel` as the
        // root ancestor of the `richTextStyle`. But that would be a break change.

        setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
      }
    }
  }

  if (richResult) {
    textStyle.rich = richResult;
  }

  var overflow = textStyleModel.get('overflow');

  if (overflow) {
    textStyle.overflow = overflow;
  }

  var margin = textStyleModel.get('minMargin');

  if (margin != null) {
    textStyle.margin = margin;
  }

  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
} // Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel


function getRichItemNames(textStyleModel) {
  // Use object to remove duplicated names.
  var richItemNameMap;

  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
    var rich = (textStyleModel.option || EMPTY_OBJ).rich;

    if (rich) {
      richItemNameMap = richItemNameMap || {};
      var richKeys = keys$2(rich);

      for (var i = 0; i < richKeys.length; i++) {
        var richKey = richKeys[i];
        richItemNameMap[richKey] = 1;
      }
    }

    textStyleModel = textStyleModel.parentModel;
  }

  return richItemNameMap;
}

var TEXT_PROPS_WITH_GLOBAL = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'];
var TEXT_PROPS_SELF = ['align', 'lineHeight', 'width', 'height', 'tag', 'verticalAlign'];
var TEXT_PROPS_BOX = ['padding', 'borderWidth', 'borderRadius', 'borderDashOffset', 'backgroundColor', 'borderColor', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];

function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
  // In merge mode, default value should not be given.
  globalTextStyle = !isNotNormal && globalTextStyle || EMPTY_OBJ;
  var inheritColor = opt && opt.inheritColor;
  var fillColor = textStyleModel.getShallow('color');
  var strokeColor = textStyleModel.getShallow('textBorderColor');
  var opacity = retrieve2(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);

  if (fillColor === 'inherit' || fillColor === 'auto') {
    if (process.env.NODE_ENV !== 'production') {
      if (fillColor === 'auto') {
        deprecateReplaceLog('color: \'auto\'', 'color: \'inherit\'');
      }
    }

    if (inheritColor) {
      fillColor = inheritColor;
    } else {
      fillColor = null;
    }
  }

  if (strokeColor === 'inherit' || strokeColor === 'auto') {
    if (process.env.NODE_ENV !== 'production') {
      if (strokeColor === 'auto') {
        deprecateReplaceLog('color: \'auto\'', 'color: \'inherit\'');
      }
    }

    if (inheritColor) {
      strokeColor = inheritColor;
    } else {
      strokeColor = null;
    }
  }

  if (!isAttached) {
    // Only use default global textStyle.color if text is individual.
    // Otherwise it will use the strategy of attached text color because text may be on a path.
    fillColor = fillColor || globalTextStyle.color;
    strokeColor = strokeColor || globalTextStyle.textBorderColor;
  }

  if (fillColor != null) {
    textStyle.fill = fillColor;
  }

  if (strokeColor != null) {
    textStyle.stroke = strokeColor;
  }

  var textBorderWidth = retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);

  if (textBorderWidth != null) {
    textStyle.lineWidth = textBorderWidth;
  }

  var textBorderType = retrieve2(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);

  if (textBorderType != null) {
    textStyle.lineDash = textBorderType;
  }

  var textBorderDashOffset = retrieve2(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);

  if (textBorderDashOffset != null) {
    textStyle.lineDashOffset = textBorderDashOffset;
  }

  if (!isNotNormal && opacity == null && !inRich) {
    opacity = opt && opt.defaultOpacity;
  }

  if (opacity != null) {
    textStyle.opacity = opacity;
  } // TODO


  if (!isNotNormal && !isAttached) {
    // Set default finally.
    if (textStyle.fill == null && opt.inheritColor) {
      textStyle.fill = opt.inheritColor;
    }
  } // Do not use `getFont` here, because merge should be supported, where
  // part of these properties may be changed in emphasis style, and the
  // others should remain their original value got from normal style.


  for (var i = 0; i < TEXT_PROPS_WITH_GLOBAL.length; i++) {
    var key = TEXT_PROPS_WITH_GLOBAL[i];
    var val = retrieve2(textStyleModel.getShallow(key), globalTextStyle[key]);

    if (val != null) {
      textStyle[key] = val;
    }
  }

  for (var i = 0; i < TEXT_PROPS_SELF.length; i++) {
    var key = TEXT_PROPS_SELF[i];
    var val = textStyleModel.getShallow(key);

    if (val != null) {
      textStyle[key] = val;
    }
  }

  if (textStyle.verticalAlign == null) {
    var baseline = textStyleModel.getShallow('baseline');

    if (baseline != null) {
      textStyle.verticalAlign = baseline;
    }
  }

  if (!isBlock || !opt.disableBox) {
    for (var i = 0; i < TEXT_PROPS_BOX.length; i++) {
      var key = TEXT_PROPS_BOX[i];
      var val = textStyleModel.getShallow(key);

      if (val != null) {
        textStyle[key] = val;
      }
    }

    var borderType = textStyleModel.getShallow('borderType');

    if (borderType != null) {
      textStyle.borderDash = borderType;
    }

    if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) {
      if (process.env.NODE_ENV !== 'production') {
        if (textStyle.backgroundColor === 'auto') {
          deprecateReplaceLog('backgroundColor: \'auto\'', 'backgroundColor: \'inherit\'');
        }
      }

      textStyle.backgroundColor = inheritColor;
    }

    if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) {
      if (process.env.NODE_ENV !== 'production') {
        if (textStyle.borderColor === 'auto') {
          deprecateReplaceLog('borderColor: \'auto\'', 'borderColor: \'inherit\'');
        }
      }

      textStyle.borderColor = inheritColor;
    }
  }
}

function getFont(opt, ecModel) {
  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
  return trim([// FIXME in node-canvas fontWeight is before fontStyle
  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
}
var labelInner = makeInner();
function setLabelValueAnimation(label, labelStatesModels, value, getDefaultText) {
  if (!label) {
    return;
  }

  var obj = labelInner(label);
  obj.prevValue = obj.value;
  obj.value = value;
  var normalLabelModel = labelStatesModels.normal;
  obj.valueAnimation = normalLabelModel.get('valueAnimation');

  if (obj.valueAnimation) {
    obj.precision = normalLabelModel.get('precision');
    obj.defaultInterpolatedText = getDefaultText;
    obj.statesModels = labelStatesModels;
  }
}
function animateLabelValue(textEl, dataIndex, data, animatableModel, labelFetcher) {
  var labelInnerStore = labelInner(textEl);

  if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) {
    // Value not changed, no new label animation
    return;
  }

  var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText; // Consider the case that being animating, do not use the `obj.value`,
  // Otherwise it will jump to the `obj.value` when this new animation started.

  var currValue = retrieve2(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
  var targetValue = labelInnerStore.value;

  function during(percent) {
    var interpolated = interpolateRawValues(data, labelInnerStore.precision, currValue, targetValue, percent);
    labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
    var labelText = getLabelText({
      labelDataIndex: dataIndex,
      labelFetcher: labelFetcher,
      defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
    }, labelInnerStore.statesModels, interpolated);
    setLabelText(textEl, labelText);
  }

  textEl.percent = 0;
  (labelInnerStore.prevValue == null ? initProps : updateProps)(textEl, {
    // percent is used to prevent animation from being aborted #15916
    percent: 1
  }, animatableModel, dataIndex, null, during);
}

var PATH_COLOR = ['textStyle', 'color'];
var textStyleParams = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'padding', 'lineHeight', 'rich', 'width', 'height', 'overflow']; // TODO Performance improvement?

var tmpText = new ZRText();

var TextStyleMixin =
/** @class */
function () {
  function TextStyleMixin() {}
  /**
   * Get color property or get color from option.textStyle.color
   */
  // TODO Callback


  TextStyleMixin.prototype.getTextColor = function (isEmphasis) {
    var ecModel = this.ecModel;
    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
  };
  /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */


  TextStyleMixin.prototype.getFont = function () {
    return getFont({
      fontStyle: this.getShallow('fontStyle'),
      fontWeight: this.getShallow('fontWeight'),
      fontSize: this.getShallow('fontSize'),
      fontFamily: this.getShallow('fontFamily')
    }, this.ecModel);
  };

  TextStyleMixin.prototype.getTextRect = function (text) {
    var style = {
      text: text,
      verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
    };

    for (var i = 0; i < textStyleParams.length; i++) {
      style[textStyleParams[i]] = this.getShallow(textStyleParams[i]);
    }

    tmpText.useStyle(style);
    tmpText.update();
    return tmpText.getBoundingRect();
  };

  return TextStyleMixin;
}();

var LINE_STYLE_KEY_MAP = [['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'type'], ['lineDashOffset', 'dashOffset'], ['lineCap', 'cap'], ['lineJoin', 'join'], ['miterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getLineStyle = makeStyleMapper(LINE_STYLE_KEY_MAP);

var LineStyleMixin =
/** @class */
function () {
  function LineStyleMixin() {}

  LineStyleMixin.prototype.getLineStyle = function (excludes) {
    return getLineStyle(this, excludes);
  };

  return LineStyleMixin;
}();

var ITEM_STYLE_KEY_MAP = [['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['lineDash', 'borderType'], ['lineDashOffset', 'borderDashOffset'], ['lineCap', 'borderCap'], ['lineJoin', 'borderJoin'], ['miterLimit', 'borderMiterLimit'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
];
var getItemStyle = makeStyleMapper(ITEM_STYLE_KEY_MAP);

var ItemStyleMixin =
/** @class */
function () {
  function ItemStyleMixin() {}

  ItemStyleMixin.prototype.getItemStyle = function (excludes, includes) {
    return getItemStyle(this, excludes, includes);
  };

  return ItemStyleMixin;
}();

var Model =
/** @class */
function () {
  function Model(option, parentModel, ecModel) {
    this.parentModel = parentModel;
    this.ecModel = ecModel;
    this.option = option; // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
  }

  Model.prototype.init = function (option, parentModel, ecModel) {
    var rest = [];

    for (var _i = 3; _i < arguments.length; _i++) {
      rest[_i - 3] = arguments[_i];
    }
  };
  /**
   * Merge the input option to me.
   */


  Model.prototype.mergeOption = function (option, ecModel) {
    merge$1(this.option, option, true);
  }; // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
  // TODO: TYPE strict key check?
  // get(path: string | string[], ignoreParent?: boolean): ModelOption;


  Model.prototype.get = function (path, ignoreParent) {
    if (path == null) {
      return this.option;
    }

    return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
  };

  Model.prototype.getShallow = function (key, ignoreParent) {
    var option = this.option;
    var val = option == null ? option : option[key];

    if (val == null && !ignoreParent) {
      var parentModel = this.parentModel;

      if (parentModel) {
        // FIXME:TS do not know how to make it works
        val = parentModel.getShallow(key);
      }
    }

    return val;
  }; // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
  // getModel(path: string | string[], parentModel?: Model): Model;
  // TODO 'a.b.c' is deprecated


  Model.prototype.getModel = function (path, parentModel) {
    var hasPath = path != null;
    var pathFinal = hasPath ? this.parsePath(path) : null;
    var obj = hasPath ? this._doGet(pathFinal) : this.option;
    parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
    return new Model(obj, parentModel, this.ecModel);
  };
  /**
   * If model has option
   */


  Model.prototype.isEmpty = function () {
    return this.option == null;
  };

  Model.prototype.restoreData = function () {}; // Pending


  Model.prototype.clone = function () {
    var Ctor = this.constructor;
    return new Ctor(clone(this.option));
  }; // setReadOnly(properties): void {
  // clazzUtil.setReadOnly(this, properties);
  // }
  // If path is null/undefined, return null/undefined.


  Model.prototype.parsePath = function (path) {
    if (typeof path === 'string') {
      return path.split('.');
    }

    return path;
  }; // Resolve path for parent. Perhaps useful when parent use a different property.
  // Default to be a identity resolver.
  // Can be modified to a different resolver.


  Model.prototype.resolveParentPath = function (path) {
    return path;
  }; // FIXME:TS check whether put this method here


  Model.prototype.isAnimationEnabled = function () {
    if (!env.node && this.option) {
      if (this.option.animation != null) {
        return !!this.option.animation;
      } else if (this.parentModel) {
        return this.parentModel.isAnimationEnabled();
      }
    }
  };

  Model.prototype._doGet = function (pathArr, parentModel) {
    var obj = this.option;

    if (!pathArr) {
      return obj;
    }

    for (var i = 0; i < pathArr.length; i++) {
      // Ignore empty
      if (!pathArr[i]) {
        continue;
      } // obj could be number/string/... (like 0)


      obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;

      if (obj == null) {
        break;
      }
    }

    if (obj == null && parentModel) {
      obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
    }

    return obj;
  };

  return Model;
}();

enableClassExtend(Model);
enableClassCheck(Model);
mixin(Model, LineStyleMixin);
mixin(Model, ItemStyleMixin);
mixin(Model, AreaStyleMixin);
mixin(Model, TextStyleMixin);

var base$1 = Math.round(Math.random() * 10);
/**
 * @public
 * @param {string} type
 * @return {string}
 */

function getUID(type) {
  // Considering the case of crossing js context,
  // use Math.random to make id as unique as possible.
  return [type || '', base$1++].join('_');
}
/**
 * Implements `SubTypeDefaulterManager` for `target`.
 */

function enableSubTypeDefaulter(target) {
  var subTypeDefaulters = {};

  target.registerSubTypeDefaulter = function (componentType, defaulter) {
    var componentTypeInfo = parseClassType(componentType);
    subTypeDefaulters[componentTypeInfo.main] = defaulter;
  };

  target.determineSubType = function (componentType, option) {
    var type = option.type;

    if (!type) {
      var componentTypeMain = parseClassType(componentType).main;

      if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
        type = subTypeDefaulters[componentTypeMain](option);
      }
    }

    return type;
  };
}
/**
 * Implements `TopologicalTravelable<any>` for `entity`.
 *
 * Topological travel on Activity Network (Activity On Vertices).
 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
 * If there is circular dependencey, Error will be thrown.
 */

function enableTopologicalTravel(entity, dependencyGetter) {
  /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */
  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
    if (!targetNameList.length) {
      return;
    }

    var result = makeDepndencyGraph(fullNameList);
    var graph = result.graph;
    var noEntryList = result.noEntryList;
    var targetNameSet = {};
    each(targetNameList, function (name) {
      targetNameSet[name] = true;
    });

    while (noEntryList.length) {
      var currComponentType = noEntryList.pop();
      var currVertex = graph[currComponentType];
      var isInTargetNameSet = !!targetNameSet[currComponentType];

      if (isInTargetNameSet) {
        callback.call(context, currComponentType, currVertex.originalDeps.slice());
        delete targetNameSet[currComponentType];
      }

      each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
    }

    each(targetNameSet, function () {
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        errMsg = makePrintable('Circular dependency may exists: ', targetNameSet, targetNameList, fullNameList);
      }

      throw new Error(errMsg);
    });

    function removeEdge(succComponentType) {
      graph[succComponentType].entryCount--;

      if (graph[succComponentType].entryCount === 0) {
        noEntryList.push(succComponentType);
      }
    } // Consider this case: legend depends on series, and we call
    // chart.setOption({series: [...]}), where only series is in option.
    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
    // not be called, but only sereis.mergeOption is called. Thus legend
    // have no chance to update its local record about series (like which
    // name of series is available in legend).


    function removeEdgeAndAdd(succComponentType) {
      targetNameSet[succComponentType] = true;
      removeEdge(succComponentType);
    }
  };

  function makeDepndencyGraph(fullNameList) {
    var graph = {};
    var noEntryList = [];
    each(fullNameList, function (name) {
      var thisItem = createDependencyGraphItem(graph, name);
      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
      thisItem.entryCount = availableDeps.length;

      if (thisItem.entryCount === 0) {
        noEntryList.push(name);
      }

      each(availableDeps, function (dependentName) {
        if (indexOf(thisItem.predecessor, dependentName) < 0) {
          thisItem.predecessor.push(dependentName);
        }

        var thatItem = createDependencyGraphItem(graph, dependentName);

        if (indexOf(thatItem.successor, dependentName) < 0) {
          thatItem.successor.push(name);
        }
      });
    });
    return {
      graph: graph,
      noEntryList: noEntryList
    };
  }

  function createDependencyGraphItem(graph, name) {
    if (!graph[name]) {
      graph[name] = {
        predecessor: [],
        successor: []
      };
    }

    return graph[name];
  }

  function getAvailableDependencies(originalDeps, fullNameList) {
    var availableDeps = [];
    each(originalDeps, function (dep) {
      indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
    });
    return availableDeps;
  }
}
function inheritDefaultOption(superOption, subOption) {
  // See also `model/Component.ts#getDefaultOption`
  return merge$1(merge$1({}, superOption, true), subOption, true);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Language: English.
 */
var langEN = {
  time: {
    month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthAbbr: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayOfWeekAbbr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  },
  legend: {
    selector: {
      all: 'All',
      inverse: 'Inv'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: 'Box Select',
        polygon: 'Lasso Select',
        lineX: 'Horizontally Select',
        lineY: 'Vertically Select',
        keep: 'Keep Selections',
        clear: 'Clear Selections'
      }
    },
    dataView: {
      title: 'Data View',
      lang: ['Data View', 'Close', 'Refresh']
    },
    dataZoom: {
      title: {
        zoom: 'Zoom',
        back: 'Zoom Reset'
      }
    },
    magicType: {
      title: {
        line: 'Switch to Line Chart',
        bar: 'Switch to Bar Chart',
        stack: 'Stack',
        tiled: 'Tile'
      }
    },
    restore: {
      title: 'Restore'
    },
    saveAsImage: {
      title: 'Save as Image',
      lang: ['Right Click to Save Image']
    }
  },
  series: {
    typeNames: {
      pie: 'Pie chart',
      bar: 'Bar chart',
      line: 'Line chart',
      scatter: 'Scatter plot',
      effectScatter: 'Ripple scatter plot',
      radar: 'Radar chart',
      tree: 'Tree',
      treemap: 'Treemap',
      boxplot: 'Boxplot',
      candlestick: 'Candlestick',
      k: 'K line chart',
      heatmap: 'Heat map',
      map: 'Map',
      parallel: 'Parallel coordinate map',
      lines: 'Line graph',
      graph: 'Relationship graph',
      sankey: 'Sankey diagram',
      funnel: 'Funnel chart',
      gauge: 'Gauge',
      pictorialBar: 'Pictorial bar',
      themeRiver: 'Theme River Map',
      sunburst: 'Sunburst'
    }
  },
  aria: {
    general: {
      withTitle: 'This is a chart about "{title}"',
      withoutTitle: 'This is a chart'
    },
    series: {
      single: {
        prefix: '',
        withName: ' with type {seriesType} named {seriesName}.',
        withoutName: ' with type {seriesType}.'
      },
      multiple: {
        prefix: '. It consists of {seriesCount} series count.',
        withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
        withoutName: ' The {seriesId} series is a {seriesType}.',
        separator: {
          middle: '',
          end: ''
        }
      }
    },
    data: {
      allData: 'The data is as follows: ',
      partialData: 'The first {displayCnt} items are: ',
      withName: 'the data for {name} is {value}',
      withoutName: '{value}',
      separator: {
        middle: ', ',
        end: '. '
      }
    }
  }
};

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
var langZH = {
  time: {
    month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    monthAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    dayOfWeek: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    dayOfWeekAbbr: ['日', '一', '二', '三', '四', '五', '六']
  },
  legend: {
    selector: {
      all: '全选',
      inverse: '反选'
    }
  },
  toolbox: {
    brush: {
      title: {
        rect: '矩形选择',
        polygon: '圈选',
        lineX: '横向选择',
        lineY: '纵向选择',
        keep: '保持选择',
        clear: '清除选择'
      }
    },
    dataView: {
      title: '数据视图',
      lang: ['数据视图', '关闭', '刷新']
    },
    dataZoom: {
      title: {
        zoom: '区域缩放',
        back: '区域缩放还原'
      }
    },
    magicType: {
      title: {
        line: '切换为折线图',
        bar: '切换为柱状图',
        stack: '切换为堆叠',
        tiled: '切换为平铺'
      }
    },
    restore: {
      title: '还原'
    },
    saveAsImage: {
      title: '保存为图片',
      lang: ['右键另存为图片']
    }
  },
  series: {
    typeNames: {
      pie: '饼图',
      bar: '柱状图',
      line: '折线图',
      scatter: '散点图',
      effectScatter: '涟漪散点图',
      radar: '雷达图',
      tree: '树图',
      treemap: '矩形树图',
      boxplot: '箱型图',
      candlestick: 'K线图',
      k: 'K线图',
      heatmap: '热力图',
      map: '地图',
      parallel: '平行坐标图',
      lines: '线图',
      graph: '关系图',
      sankey: '桑基图',
      funnel: '漏斗图',
      gauge: '仪表盘图',
      pictorialBar: '象形柱图',
      themeRiver: '主题河流图',
      sunburst: '旭日图'
    }
  },
  aria: {
    general: {
      withTitle: '这是一个关于“{title}”的图表。',
      withoutTitle: '这是一个图表，'
    },
    series: {
      single: {
        prefix: '',
        withName: '图表类型是{seriesType}，表示{seriesName}。',
        withoutName: '图表类型是{seriesType}。'
      },
      multiple: {
        prefix: '它由{seriesCount}个图表系列组成。',
        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
        withoutName: '第{seriesId}个系列是一个{seriesType}，',
        separator: {
          middle: '；',
          end: '。'
        }
      }
    },
    data: {
      allData: '其数据是——',
      partialData: '其中，前{displayCnt}项是——',
      withName: '{name}的数据是{value}',
      withoutName: '{value}',
      separator: {
        middle: '，',
        end: ''
      }
    }
  }
};

var LOCALE_ZH = 'ZH';
var LOCALE_EN = 'EN';
var DEFAULT_LOCALE = LOCALE_EN;
var localeStorage = {};
var localeModels = {};
var SYSTEM_LANG = !env.domSupported ? DEFAULT_LOCALE : function () {
  var langStr = (
  /* eslint-disable-next-line */
  document.documentElement.lang || navigator.language || navigator.browserLanguage).toUpperCase();
  return langStr.indexOf(LOCALE_ZH) > -1 ? LOCALE_ZH : DEFAULT_LOCALE;
}();
function registerLocale(locale, localeObj) {
  locale = locale.toUpperCase();
  localeModels[locale] = new Model(localeObj);
  localeStorage[locale] = localeObj;
} // export function getLocale(locale: string) {
//     return localeStorage[locale];
// }

function createLocaleObject(locale) {
  if (isString(locale)) {
    var localeObj = localeStorage[locale.toUpperCase()] || {};

    if (locale === LOCALE_ZH || locale === LOCALE_EN) {
      return clone(localeObj);
    } else {
      return merge$1(clone(localeObj), clone(localeStorage[DEFAULT_LOCALE]), false);
    }
  } else {
    return merge$1(clone(locale), clone(localeStorage[DEFAULT_LOCALE]), false);
  }
}
function getLocaleModel(lang) {
  return localeModels[lang];
}
function getDefaultLocaleModel() {
  return localeModels[DEFAULT_LOCALE];
} // Default locale

registerLocale(LOCALE_EN, langEN);
registerLocale(LOCALE_ZH, langZH);

var ONE_SECOND = 1000;
var ONE_MINUTE = ONE_SECOND * 60;
var ONE_HOUR = ONE_MINUTE * 60;
var ONE_DAY = ONE_HOUR * 24;
var ONE_YEAR = ONE_DAY * 365;
var defaultLeveledFormatter = {
  year: '{yyyy}',
  month: '{MMM}',
  day: '{d}',
  hour: '{HH}:{mm}',
  minute: '{HH}:{mm}',
  second: '{HH}:{mm}:{ss}',
  millisecond: '{HH}:{mm}:{ss} {SSS}',
  none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var fullDayFormatter = '{yyyy}-{MM}-{dd}';
var fullLeveledFormatter = {
  year: '{yyyy}',
  month: '{yyyy}-{MM}',
  day: fullDayFormatter,
  hour: fullDayFormatter + ' ' + defaultLeveledFormatter.hour,
  minute: fullDayFormatter + ' ' + defaultLeveledFormatter.minute,
  second: fullDayFormatter + ' ' + defaultLeveledFormatter.second,
  millisecond: defaultLeveledFormatter.none
};
var primaryTimeUnits = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'];
var timeUnits = ['year', 'half-year', 'quarter', 'month', 'week', 'half-week', 'day', 'half-day', 'quarter-day', 'hour', 'minute', 'second', 'millisecond'];
function pad(str, len) {
  str += '';
  return '0000'.substr(0, len - str.length) + str;
}
function getPrimaryTimeUnit(timeUnit) {
  switch (timeUnit) {
    case 'half-year':
    case 'quarter':
      return 'month';

    case 'week':
    case 'half-week':
      return 'day';

    case 'half-day':
    case 'quarter-day':
      return 'hour';

    default:
      // year, minutes, second, milliseconds
      return timeUnit;
  }
}
function isPrimaryTimeUnit(timeUnit) {
  return timeUnit === getPrimaryTimeUnit(timeUnit);
}
function getDefaultFormatPrecisionOfInterval(timeUnit) {
  switch (timeUnit) {
    case 'year':
    case 'month':
      return 'day';

    case 'millisecond':
      return 'millisecond';

    default:
      // Also for day, hour, minute, second
      return 'second';
  }
}
function format$1( // Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
  var date = parseDate(time);
  var y = date[fullYearGetterName(isUTC)]();
  var M = date[monthGetterName(isUTC)]() + 1;
  var q = Math.floor((M - 1) / 3) + 1;
  var d = date[dateGetterName(isUTC)]();
  var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
  var H = date[hoursGetterName(isUTC)]();
  var h = (H - 1) % 12 + 1;
  var m = date[minutesGetterName(isUTC)]();
  var s = date[secondsGetterName(isUTC)]();
  var S = date[millisecondsGetterName(isUTC)]();
  var localeModel = lang instanceof Model ? lang : getLocaleModel(lang || SYSTEM_LANG) || getDefaultLocaleModel();
  var timeModel = localeModel.getModel('time');
  var month = timeModel.get('month');
  var monthAbbr = timeModel.get('monthAbbr');
  var dayOfWeek = timeModel.get('dayOfWeek');
  var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
  return (template || '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, y % 100 + '').replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, pad(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, pad(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, pad(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, pad(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, pad(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, pad(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, pad(S, 3)).replace(/{S}/g, S + '');
}
function leveledFormat(tick, idx, formatter, lang, isUTC) {
  var template = null;

  if (isString(formatter)) {
    // Single formatter for all units at all levels
    template = formatter;
  } else if (isFunction$3(formatter)) {
    // Callback formatter
    template = formatter(tick.value, idx, {
      level: tick.level
    });
  } else {
    var defaults$1 = extend({}, defaultLeveledFormatter);

    if (tick.level > 0) {
      for (var i = 0; i < primaryTimeUnits.length; ++i) {
        defaults$1[primaryTimeUnits[i]] = "{primary|" + defaults$1[primaryTimeUnits[i]] + "}";
      }
    }

    var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
    : defaults(formatter, defaults$1) : defaults$1;
    var unit = getUnitFromValue(tick.value, isUTC);

    if (mergedFormatter[unit]) {
      template = mergedFormatter[unit];
    } else if (mergedFormatter.inherit) {
      // Unit formatter is not defined and should inherit from bigger units
      var targetId = timeUnits.indexOf(unit);

      for (var i = targetId - 1; i >= 0; --i) {
        if (mergedFormatter[unit]) {
          template = mergedFormatter[unit];
          break;
        }
      }

      template = template || defaults$1.none;
    }

    if (isArray$1(template)) {
      var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
      levelId = Math.min(levelId, template.length - 1);
      template = template[levelId];
    }
  }

  return format$1(new Date(tick.value), template, isUTC, lang);
}
function getUnitFromValue(value, isUTC) {
  var date = parseDate(value);
  var M = date[monthGetterName(isUTC)]() + 1;
  var d = date[dateGetterName(isUTC)]();
  var h = date[hoursGetterName(isUTC)]();
  var m = date[minutesGetterName(isUTC)]();
  var s = date[secondsGetterName(isUTC)]();
  var S = date[millisecondsGetterName(isUTC)]();
  var isSecond = S === 0;
  var isMinute = isSecond && s === 0;
  var isHour = isMinute && m === 0;
  var isDay = isHour && h === 0;
  var isMonth = isDay && d === 1;
  var isYear = isMonth && M === 1;

  if (isYear) {
    return 'year';
  } else if (isMonth) {
    return 'month';
  } else if (isDay) {
    return 'day';
  } else if (isHour) {
    return 'hour';
  } else if (isMinute) {
    return 'minute';
  } else if (isSecond) {
    return 'second';
  } else {
    return 'millisecond';
  }
}
function getUnitValue(value, unit, isUTC) {
  var date = isNumber$1(value) ? parseDate(value) : value;
  unit = unit || getUnitFromValue(value, isUTC);

  switch (unit) {
    case 'year':
      return date[fullYearGetterName(isUTC)]();

    case 'half-year':
      return date[monthGetterName(isUTC)]() >= 6 ? 1 : 0;

    case 'quarter':
      return Math.floor((date[monthGetterName(isUTC)]() + 1) / 4);

    case 'month':
      return date[monthGetterName(isUTC)]();

    case 'day':
      return date[dateGetterName(isUTC)]();

    case 'half-day':
      return date[hoursGetterName(isUTC)]() / 24;

    case 'hour':
      return date[hoursGetterName(isUTC)]();

    case 'minute':
      return date[minutesGetterName(isUTC)]();

    case 'second':
      return date[secondsGetterName(isUTC)]();

    case 'millisecond':
      return date[millisecondsGetterName(isUTC)]();
  }
}
function fullYearGetterName(isUTC) {
  return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function monthGetterName(isUTC) {
  return isUTC ? 'getUTCMonth' : 'getMonth';
}
function dateGetterName(isUTC) {
  return isUTC ? 'getUTCDate' : 'getDate';
}
function hoursGetterName(isUTC) {
  return isUTC ? 'getUTCHours' : 'getHours';
}
function minutesGetterName(isUTC) {
  return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function secondsGetterName(isUTC) {
  return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function millisecondsGetterName(isUTC) {
  return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function fullYearSetterName(isUTC) {
  return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function monthSetterName(isUTC) {
  return isUTC ? 'setUTCMonth' : 'setMonth';
}
function dateSetterName(isUTC) {
  return isUTC ? 'setUTCDate' : 'setDate';
}
function hoursSetterName(isUTC) {
  return isUTC ? 'setUTCHours' : 'setHours';
}
function minutesSetterName(isUTC) {
  return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function secondsSetterName(isUTC) {
  return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function millisecondsSetterName(isUTC) {
  return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}

function getTextRect(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
  var textEl = new ZRText({
    style: {
      text: text,
      font: font,
      align: align,
      verticalAlign: verticalAlign,
      padding: padding,
      rich: rich,
      overflow: truncate ? 'truncate' : null,
      lineHeight: lineHeight
    }
  });
  return textEl.getBoundingRect();
}

/**
 * Add a comma each three digit.
 */

function addCommas(x) {
  if (!isNumeric$1(x)) {
    return isString(x) ? x : '-';
  }

  var parts = (x + '').split('.');
  return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function toCamelCase(str, upperCaseFirst) {
  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });

  if (upperCaseFirst && str) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
}
var normalizeCssArray$1 = normalizeCssArray;
/**
 * Make value user readable for tooltip and label.
 * "User readable":
 *     Try to not print programmer-specific text like NaN, Infinity, null, undefined.
 *     Avoid to display an empty string, which users can not recognize there is
 *     a value and it might look like a bug.
 */

function makeValueReadable(value, valueType, useUTC) {
  var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';

  function stringToUserReadable(str) {
    return str && trim(str) ? str : '-';
  }

  function isNumberUserReadable(num) {
    return !!(num != null && !isNaN(num) && isFinite(num));
  }

  var isTypeTime = valueType === 'time';
  var isValueDate = value instanceof Date;

  if (isTypeTime || isValueDate) {
    var date = isTypeTime ? parseDate(value) : value;

    if (!isNaN(+date)) {
      return format$1(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
    } else if (isValueDate) {
      return '-';
    } // In other cases, continue to try to display the value in the following code.

  }

  if (valueType === 'ordinal') {
    return isStringSafe(value) ? stringToUserReadable(value) : isNumber$1(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
  } // By default.


  var numericResult = numericToNumber(value);
  return isNumberUserReadable(numericResult) ? addCommas(numericResult) : isStringSafe(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

var wrapVar = function (varName, seriesIdx) {
  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
/**
 * Template formatter
 * @param {Array.<Object>|Object} paramsList
 */


function formatTpl(tpl, paramsList, encode) {
  if (!isArray$1(paramsList)) {
    paramsList = [paramsList];
  }

  var seriesLen = paramsList.length;

  if (!seriesLen) {
    return '';
  }

  var $vars = paramsList[0].$vars || [];

  for (var i = 0; i < $vars.length; i++) {
    var alias = TPL_VAR_ALIAS[i];
    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
  }

  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
    for (var k = 0; k < $vars.length; k++) {
      var val = paramsList[seriesIdx][$vars[k]];
      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
    }
  }

  return tpl;
}
/**
 * simple Template formatter
 */

function formatTplSimple(tpl, param, encode) {
  each(param, function (value, key) {
    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
  });
  return tpl;
}
function getTooltipMarker(inOpt, extraCssText) {
  var opt = isString(inOpt) ? {
    color: inOpt,
    extraCssText: extraCssText
  } : inOpt || {};
  var color = opt.color;
  var type = opt.type;
  extraCssText = opt.extraCssText;
  var renderMode = opt.renderMode || 'html';

  if (!color) {
    return '';
  }

  if (renderMode === 'html') {
    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' // Only support string
    + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
  } else {
    // Should better not to auto generate style name by auto-increment number here.
    // Because this util is usually called in tooltip formatter, which is probably
    // called repeatedly when mouse move and the auto-increment number increases fast.
    // Users can make their own style name by theirselves, make it unique and readable.
    var markerId = opt.markerId || 'markerX';
    return {
      renderMode: renderMode,
      content: '{' + markerId + '|}  ',
      style: type === 'subItem' ? {
        width: 4,
        height: 4,
        borderRadius: 2,
        backgroundColor: color
      } : {
        width: 10,
        height: 10,
        borderRadius: 5,
        backgroundColor: color
      }
    };
  }
}
/**
 * @deprecated Use `time/format` instead.
 * ISO Date format
 * @param {string} tpl
 * @param {number} value
 * @param {boolean} [isUTC=false] Default in local time.
 *           see `module:echarts/scale/Time`
 *           and `module:echarts/util/number#parseDate`.
 * @inner
 */

function formatTime(tpl, value, isUTC) {
  if (process.env.NODE_ENV !== 'production') {
    deprecateReplaceLog('echarts.format.formatTime', 'echarts.time.format');
  }

  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
    tpl = 'MM-dd\nyyyy';
  }

  var date = parseDate(value);
  var getUTC = isUTC ? 'getUTC' : 'get';
  var y = date[getUTC + 'FullYear']();
  var M = date[getUTC + 'Month']() + 1;
  var d = date[getUTC + 'Date']();
  var h = date[getUTC + 'Hours']();
  var m = date[getUTC + 'Minutes']();
  var s = date[getUTC + 'Seconds']();
  var S = date[getUTC + 'Milliseconds']();
  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', pad(y % 100 + '', 2)).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
  return tpl;
}
/**
 * Capital first
 * @param {string} str
 * @return {string}
 */

function capitalFirst(str) {
  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
/**
 * @return Never be null/undefined.
 */

function convertToColorString(color, defaultColor) {
  defaultColor = defaultColor || 'transparent';
  return isString(color) ? color : isObject$2(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
/**
 * open new tab
 * @param link url
 * @param target blank or self
 */

function windowOpen(link, target) {
  /* global window */
  if (target === '_blank' || target === 'blank') {
    var blank = window.open();
    blank.opener = null;
    blank.location.href = link;
  } else {
    window.open(link, target);
  }
}

var each$1 = each;
/**
 * @public
 */

var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
/**
 * @public
 */

var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];

function boxLayout(orient, group, gap, maxWidth, maxHeight) {
  var x = 0;
  var y = 0;

  if (maxWidth == null) {
    maxWidth = Infinity;
  }

  if (maxHeight == null) {
    maxHeight = Infinity;
  }

  var currentLineMaxSize = 0;
  group.eachChild(function (child, idx) {
    var rect = child.getBoundingRect();
    var nextChild = group.childAt(idx + 1);
    var nextChildRect = nextChild && nextChild.getBoundingRect();
    var nextX;
    var nextY;

    if (orient === 'horizontal') {
      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
      // FIXME compare before adding gap?

      if (nextX > maxWidth || child.newline) {
        x = 0;
        nextX = moveX;
        y += currentLineMaxSize + gap;
        currentLineMaxSize = rect.height;
      } else {
        // FIXME: consider rect.y is not `0`?
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
      }
    } else {
      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group

      if (nextY > maxHeight || child.newline) {
        x += currentLineMaxSize + gap;
        y = 0;
        nextY = moveY;
        currentLineMaxSize = rect.width;
      } else {
        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
      }
    }

    if (child.newline) {
      return;
    }

    child.x = x;
    child.y = y;
    child.markRedraw();
    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
  });
}
/**
 * VBox or HBox layouting
 * @param {string} orient
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */


var box = boxLayout;
/**
 * VBox layouting
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var vbox = curry(boxLayout, 'vertical');
/**
 * HBox layouting
 * @param {module:zrender/graphic/Group} group
 * @param {number} gap
 * @param {number} [width=Infinity]
 * @param {number} [height=Infinity]
 */

var hbox = curry(boxLayout, 'horizontal');
/**
 * If x or x2 is not specified or 'center' 'left' 'right',
 * the width would be as long as possible.
 * If y or y2 is not specified or 'middle' 'top' 'bottom',
 * the height would be as long as possible.
 */

function getAvailableSize(positionInfo, containerRect, margin) {
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var x = parsePercent$1(positionInfo.left, containerWidth);
  var y = parsePercent$1(positionInfo.top, containerHeight);
  var x2 = parsePercent$1(positionInfo.right, containerWidth);
  var y2 = parsePercent$1(positionInfo.bottom, containerHeight);
  (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
  (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
  (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
  (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
  margin = normalizeCssArray$1(margin || 0);
  return {
    width: Math.max(x2 - x - margin[1] - margin[3], 0),
    height: Math.max(y2 - y - margin[0] - margin[2], 0)
  };
}
/**
 * Parse position info.
 */

function getLayoutRect$1(positionInfo, containerRect, margin) {
  margin = normalizeCssArray$1(margin || 0);
  var containerWidth = containerRect.width;
  var containerHeight = containerRect.height;
  var left = parsePercent$1(positionInfo.left, containerWidth);
  var top = parsePercent$1(positionInfo.top, containerHeight);
  var right = parsePercent$1(positionInfo.right, containerWidth);
  var bottom = parsePercent$1(positionInfo.bottom, containerHeight);
  var width = parsePercent$1(positionInfo.width, containerWidth);
  var height = parsePercent$1(positionInfo.height, containerHeight);
  var verticalMargin = margin[2] + margin[0];
  var horizontalMargin = margin[1] + margin[3];
  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right

  if (isNaN(width)) {
    width = containerWidth - right - horizontalMargin - left;
  }

  if (isNaN(height)) {
    height = containerHeight - bottom - verticalMargin - top;
  }

  if (aspect != null) {
    // If width and height are not given
    // 1. Graph should not exceeds the container
    // 2. Aspect must be keeped
    // 3. Graph should take the space as more as possible
    // FIXME
    // Margin is not considered, because there is no case that both
    // using margin and aspect so far.
    if (isNaN(width) && isNaN(height)) {
      if (aspect > containerWidth / containerHeight) {
        width = containerWidth * 0.8;
      } else {
        height = containerHeight * 0.8;
      }
    } // Calculate width or height with given aspect


    if (isNaN(width)) {
      width = aspect * height;
    }

    if (isNaN(height)) {
      height = width / aspect;
    }
  } // If left is not specified, calculate left from right and width


  if (isNaN(left)) {
    left = containerWidth - right - width - horizontalMargin;
  }

  if (isNaN(top)) {
    top = containerHeight - bottom - height - verticalMargin;
  } // Align left and top


  switch (positionInfo.left || positionInfo.right) {
    case 'center':
      left = containerWidth / 2 - width / 2 - margin[3];
      break;

    case 'right':
      left = containerWidth - width - horizontalMargin;
      break;
  }

  switch (positionInfo.top || positionInfo.bottom) {
    case 'middle':
    case 'center':
      top = containerHeight / 2 - height / 2 - margin[0];
      break;

    case 'bottom':
      top = containerHeight - height - verticalMargin;
      break;
  } // If something is wrong and left, top, width, height are calculated as NaN


  left = left || 0;
  top = top || 0;

  if (isNaN(width)) {
    // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
  }

  if (isNaN(height)) {
    // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
  }

  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
  rect.margin = margin;
  return rect;
}
/**
 * Position a zr element in viewport
 *  Group position is specified by either
 *  {left, top}, {right, bottom}
 *  If all properties exists, right and bottom will be igonred.
 *
 * Logic:
 *     1. Scale (against origin point in parent coord)
 *     2. Rotate (against origin point in parent coord)
 *     3. Translate (with el.position by this method)
 * So this method only fixes the last step 'Translate', which does not affect
 * scaling and rotating.
 *
 * If be called repeatedly with the same input el, the same result will be gotten.
 *
 * Return true if the layout happened.
 *
 * @param el Should have `getBoundingRect` method.
 * @param positionInfo
 * @param positionInfo.left
 * @param positionInfo.top
 * @param positionInfo.right
 * @param positionInfo.bottom
 * @param positionInfo.width Only for opt.boundingModel: 'raw'
 * @param positionInfo.height Only for opt.boundingModel: 'raw'
 * @param containerRect
 * @param margin
 * @param opt
 * @param opt.hv Only horizontal or only vertical. Default to be [1, 1]
 * @param opt.boundingMode
 *        Specify how to calculate boundingRect when locating.
 *        'all': Position the boundingRect that is transformed and uioned
 *               both itself and its descendants.
 *               This mode simplies confine the elements in the bounding
 *               of their container (e.g., using 'right: 0').
 *        'raw': Position the boundingRect that is not transformed and only itself.
 *               This mode is useful when you want a element can overflow its
 *               container. (Consider a rotated circle needs to be located in a corner.)
 *               In this mode positionInfo.width/height can only be number.
 */

function positionElement(el, positionInfo, containerRect, margin, opt, out) {
  var h = !opt || !opt.hv || opt.hv[0];
  var v = !opt || !opt.hv || opt.hv[1];
  var boundingMode = opt && opt.boundingMode || 'all';
  out = out || el;
  out.x = el.x;
  out.y = el.y;

  if (!h && !v) {
    return false;
  }

  var rect;

  if (boundingMode === 'raw') {
    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
  } else {
    rect = el.getBoundingRect();

    if (el.needLocalTransform()) {
      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
      // which should not be modified.

      rect = rect.clone();
      rect.applyTransform(transform);
    }
  } // The real width and height can not be specified but calculated by the given el.


  var layoutRect = getLayoutRect$1(defaults({
    width: rect.width,
    height: rect.height
  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
  // (see zrender/core/Transformable#getLocalTransform),
  // we can just only modify el.position to get final result.

  var dx = h ? layoutRect.x - rect.x : 0;
  var dy = v ? layoutRect.y - rect.y : 0;

  if (boundingMode === 'raw') {
    out.x = dx;
    out.y = dy;
  } else {
    out.x += dx;
    out.y += dy;
  }

  if (out === el) {
    el.markRedraw();
  }

  return true;
}
/**
 * @param option Contains some of the properties in HV_NAMES.
 * @param hvIdx 0: horizontal; 1: vertical.
 */

function sizeCalculable(option, hvIdx) {
  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
}
function fetchLayoutMode(ins) {
  var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
  return isObject$2(layoutMode) ? layoutMode : layoutMode ? {
    type: layoutMode
  } : null;
}
/**
 * Consider Case:
 * When default option has {left: 0, width: 100}, and we set {right: 0}
 * through setOption or media query, using normal zrUtil.merge will cause
 * {right: 0} does not take effect.
 *
 * @example
 * ComponentModel.extend({
 *     init: function () {
 *         ...
 *         let inputPositionParams = layout.getLayoutParams(option);
 *         this.mergeOption(inputPositionParams);
 *     },
 *     mergeOption: function (newOption) {
 *         newOption && zrUtil.merge(thisOption, newOption, true);
 *         layout.mergeLayoutParam(thisOption, newOption);
 *     }
 * });
 *
 * @param targetOption
 * @param newOption
 * @param opt
 */

function mergeLayoutParam(targetOption, newOption, opt) {
  var ignoreSize = opt && opt.ignoreSize;
  !isArray$1(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
  var hResult = merge(HV_NAMES[0], 0);
  var vResult = merge(HV_NAMES[1], 1);
  copy(HV_NAMES[0], targetOption, hResult);
  copy(HV_NAMES[1], targetOption, vResult);

  function merge(names, hvIdx) {
    var newParams = {};
    var newValueCount = 0;
    var merged = {};
    var mergedValueCount = 0;
    var enoughParamNumber = 2;
    each$1(names, function (name) {
      merged[name] = targetOption[name];
    });
    each$1(names, function (name) {
      // Consider case: newOption.width is null, which is
      // set by user for removing width setting.
      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
      hasValue(newParams, name) && newValueCount++;
      hasValue(merged, name) && mergedValueCount++;
    });

    if (ignoreSize[hvIdx]) {
      // Only one of left/right is premitted to exist.
      if (hasValue(newOption, names[1])) {
        merged[names[2]] = null;
      } else if (hasValue(newOption, names[2])) {
        merged[names[1]] = null;
      }

      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // or targetOption: {right: ...} and newOption: {width: ...},
    // There is no conflict when merged only has params count
    // little than enoughParamNumber.


    if (mergedValueCount === enoughParamNumber || !newValueCount) {
      return merged;
    } // Case: newOption: {width: ..., right: ...},
    // Than we can make sure user only want those two, and ignore
    // all origin params in targetOption.
    else if (newValueCount >= enoughParamNumber) {
        return newParams;
      } else {
        // Chose another param from targetOption by priority.
        for (var i = 0; i < names.length; i++) {
          var name_1 = names[i];

          if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
            newParams[name_1] = targetOption[name_1];
            break;
          }
        }

        return newParams;
      }
  }

  function hasProp(obj, name) {
    return obj.hasOwnProperty(name);
  }

  function hasValue(obj, name) {
    return obj[name] != null && obj[name] !== 'auto';
  }

  function copy(names, target, source) {
    each$1(names, function (name) {
      target[name] = source[name];
    });
  }
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 */

function getLayoutParams(source) {
  return copyLayoutParams({}, source);
}
/**
 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
 * @param {Object} source
 * @return {Object} Result contains those props.
 */

function copyLayoutParams(target, source) {
  source && target && each$1(LOCATION_PARAMS, function (name) {
    source.hasOwnProperty(name) && (target[name] = source[name]);
  });
  return target;
}

var inner$1 = makeInner();

var ComponentModel =
/** @class */
function (_super) {
  __extends$1(ComponentModel, _super);

  function ComponentModel(option, parentModel, ecModel) {
    var _this = _super.call(this, option, parentModel, ecModel) || this;

    _this.uid = getUID('ec_cpt_model');
    return _this;
  }

  ComponentModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
  };

  ComponentModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
    var layoutMode = fetchLayoutMode(this);
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
    var themeModel = ecModel.getTheme();
    merge$1(option, themeModel.get(this.mainType));
    merge$1(option, this.getDefaultOption());

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  };

  ComponentModel.prototype.mergeOption = function (option, ecModel) {
    merge$1(this.option, option, true);
    var layoutMode = fetchLayoutMode(this);

    if (layoutMode) {
      mergeLayoutParam(this.option, option, layoutMode);
    }
  };
  /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */


  ComponentModel.prototype.optionUpdated = function (newCptOption, isInit) {};
  /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */


  ComponentModel.prototype.getDefaultOption = function () {
    var ctor = this.constructor; // If using class declaration, it is different to travel super class
    // in legacy env and auto merge defaultOption. So if using class
    // declaration, defaultOption should be merged manually.

    if (!isExtendedClass(ctor)) {
      // When using ts class, defaultOption must be declared as static.
      return ctor.defaultOption;
    } // FIXME: remove this approach?


    var fields = inner$1(this);

    if (!fields.defaultOption) {
      var optList = [];
      var clz = ctor;

      while (clz) {
        var opt = clz.prototype.defaultOption;
        opt && optList.push(opt);
        clz = clz.superClass;
      }

      var defaultOption = {};

      for (var i = optList.length - 1; i >= 0; i--) {
        defaultOption = merge$1(defaultOption, optList[i], true);
      }

      fields.defaultOption = defaultOption;
    }

    return fields.defaultOption;
  };
  /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */


  ComponentModel.prototype.getReferringComponents = function (mainType, opt) {
    var indexKey = mainType + 'Index';
    var idKey = mainType + 'Id';
    return queryReferringComponents(this.ecModel, mainType, {
      index: this.get(indexKey, true),
      id: this.get(idKey, true)
    }, opt);
  };

  ComponentModel.prototype.getBoxLayoutParams = function () {
    // Consider itself having box layout configs.
    var boxLayoutModel = this;
    return {
      left: boxLayoutModel.get('left'),
      top: boxLayoutModel.get('top'),
      right: boxLayoutModel.get('right'),
      bottom: boxLayoutModel.get('bottom'),
      width: boxLayoutModel.get('width'),
      height: boxLayoutModel.get('height')
    };
  };
  /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */


  ComponentModel.prototype.getZLevelKey = function () {
    return '';
  };

  ComponentModel.prototype.setZLevel = function (zlevel) {
    this.option.zlevel = zlevel;
  };

  ComponentModel.protoInitialize = function () {
    var proto = ComponentModel.prototype;
    proto.type = 'component';
    proto.id = '';
    proto.name = '';
    proto.mainType = '';
    proto.subType = '';
    proto.componentIndex = 0;
  }();

  return ComponentModel;
}(Model);

mountExtend(ComponentModel, Model);
enableClassManagement(ComponentModel);
enableSubTypeDefaulter(ComponentModel);
enableTopologicalTravel(ComponentModel, getDependencies);

function getDependencies(componentType) {
  var deps = [];
  each(ComponentModel.getClassesByMainType(componentType), function (clz) {
    deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
  }); // Ensure main type.

  deps = map(deps, function (type) {
    return parseClassType(type).main;
  }); // Hack dataset for convenience.

  if (componentType !== 'dataset' && indexOf(deps, 'dataset') <= 0) {
    deps.unshift('dataset');
  }

  return deps;
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var platform = ''; // Navigator not exists in node

if (typeof navigator !== 'undefined') {
  /* global navigator */
  platform = navigator.platform || '';
}

var decalColor = 'rgba(0, 0, 0, 0.2)';
var globalDefault = {
  darkMode: 'auto',
  // backgroundColor: 'rgba(0,0,0,0)',
  colorBy: 'series',
  color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
  aria: {
    decal: {
      decals: [{
        color: decalColor,
        dashArrayX: [1, 0],
        dashArrayY: [2, 5],
        symbolSize: 1,
        rotation: Math.PI / 6
      }, {
        color: decalColor,
        symbol: 'circle',
        dashArrayX: [[8, 8], [0, 8, 8, 0]],
        dashArrayY: [6, 0],
        symbolSize: 0.8
      }, {
        color: decalColor,
        dashArrayX: [1, 0],
        dashArrayY: [4, 3],
        rotation: -Math.PI / 4
      }, {
        color: decalColor,
        dashArrayX: [[6, 6], [0, 6, 6, 0]],
        dashArrayY: [6, 0]
      }, {
        color: decalColor,
        dashArrayX: [[1, 0], [1, 6]],
        dashArrayY: [1, 0, 6, 0],
        rotation: Math.PI / 4
      }, {
        color: decalColor,
        symbol: 'triangle',
        dashArrayX: [[9, 9], [0, 9, 9, 0]],
        dashArrayY: [7, 2],
        symbolSize: 0.75
      }]
    }
  },
  // If xAxis and yAxis declared, grid is created by default.
  // grid: {},
  textStyle: {
    // color: '#000',
    // decoration: 'none',
    // PENDING
    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
    // fontFamily: 'Arial, Verdana, sans-serif',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
  // Default is source-over
  blendMode: null,
  stateAnimation: {
    duration: 300,
    easing: 'cubicOut'
  },
  animation: 'auto',
  animationDuration: 1000,
  animationDurationUpdate: 500,
  animationEasing: 'cubicInOut',
  animationEasingUpdate: 'cubicInOut',
  animationThreshold: 2000,
  // Configuration for progressive/incremental rendering
  progressiveThreshold: 3000,
  progressive: 400,
  // Threshold of if use single hover layer to optimize.
  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
  // which is unexpected.
  // see example <echarts/test/heatmap-large.html>.
  hoverLayerThreshold: 3000,
  // See: module:echarts/scale/Time
  useUTC: false
};

var VISUAL_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'itemGroupId', 'seriesName']);
var SOURCE_FORMAT_ORIGINAL = 'original';
var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
var SOURCE_FORMAT_UNKNOWN = 'unknown';
var SERIES_LAYOUT_BY_COLUMN = 'column';
var SERIES_LAYOUT_BY_ROW = 'row';

var BE_ORDINAL = {
  Must: 1,
  Might: 2,
  Not: 3 // Other cases

};
var innerGlobalModel = makeInner();
/**
 * MUST be called before mergeOption of all series.
 */

function resetSourceDefaulter(ecModel) {
  // `datasetMap` is used to make default encode.
  innerGlobalModel(ecModel).datasetMap = createHashMap();
}
/**
 * [The strategy of the arrengment of data dimensions for dataset]:
 * "value way": all axes are non-category axes. So series one by one take
 *     several (the number is coordSysDims.length) dimensions from dataset.
 *     The result of data arrengment of data dimensions like:
 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
 * "category way": at least one axis is category axis. So the the first data
 *     dimension is always mapped to the first category axis and shared by
 *     all of the series. The other data dimensions are taken by series like
 *     "value way" does.
 *     The result of data arrengment of data dimensions like:
 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
 *
 * @return encode Never be `null/undefined`.
 */

function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
  var encode = {};
  var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel || !coordDimensions) {
    return encode;
  }

  var encodeItemName = [];
  var encodeSeriesName = [];
  var ecModel = seriesModel.ecModel;
  var datasetMap = innerGlobalModel(ecModel).datasetMap;
  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
  var baseCategoryDimIndex;
  var categoryWayValueDimStart;
  coordDimensions = coordDimensions.slice();
  each(coordDimensions, function (coordDimInfoLoose, coordDimIdx) {
    var coordDimInfo = isObject$2(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
      name: coordDimInfoLoose
    };

    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
      baseCategoryDimIndex = coordDimIdx;
      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
    }

    encode[coordDimInfo.name] = [];
  });
  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
    categoryWayDim: categoryWayValueDimStart,
    valueWayDim: 0
  }); // TODO
  // Auto detect first time axis and do arrangement.

  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
    var coordDimName = coordDimInfo.name;
    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.

    if (baseCategoryDimIndex == null) {
      var start = datasetRecord.valueWayDim;
      pushDim(encode[coordDimName], start, count);
      pushDim(encodeSeriesName, start, count);
      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
      // especially when encode x y specified.
      // consider: when multiple series share one dimension
      // category axis, series name should better use
      // the other dimension name. On the other hand, use
      // both dimensions name.
    } // In category way, the first category axis.
    else if (baseCategoryDimIndex === coordDimIdx) {
        pushDim(encode[coordDimName], 0, count);
        pushDim(encodeItemName, 0, count);
      } // In category way, the other axis.
      else {
          var start = datasetRecord.categoryWayDim;
          pushDim(encode[coordDimName], start, count);
          pushDim(encodeSeriesName, start, count);
          datasetRecord.categoryWayDim += count;
        }
  });

  function pushDim(dimIdxArr, idxFrom, idxCount) {
    for (var i = 0; i < idxCount; i++) {
      dimIdxArr.push(idxFrom + i);
    }
  }

  function getDataDimCountOnCoordDim(coordDimInfo) {
    var dimsDef = coordDimInfo.dimsDef;
    return dimsDef ? dimsDef.length : 1;
  }

  encodeItemName.length && (encode.itemName = encodeItemName);
  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
  return encode;
}
/**
 * Work for data like [{name: ..., value: ...}, ...].
 *
 * @return encode Never be `null/undefined`.
 */

function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
  var encode = {};
  var datasetModel = querySeriesUpstreamDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.

  if (!datasetModel) {
    return encode;
  }

  var sourceFormat = source.sourceFormat;
  var dimensionsDefine = source.dimensionsDefine;
  var potentialNameDimIndex;

  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    each(dimensionsDefine, function (dim, idx) {
      if ((isObject$2(dim) ? dim.name : dim) === 'name') {
        potentialNameDimIndex = idx;
      }
    });
  }

  var idxResult = function () {
    var idxRes0 = {};
    var idxRes1 = {};
    var guessRecords = []; // 5 is an experience value.

    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
      guessRecords.push(guessResult);
      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
      // and then find a name dim with the priority:
      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".

      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
        idxRes0.v = i;
      }

      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
        idxRes0.n = i;
      }

      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
        return idxRes0;
      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
      // find the first BE_ORDINAL.Might as the value dim,
      // and then find a name dim with the priority:
      // "other dim" > "the value dim itself".
      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
      // treated as number.


      if (!isPureNumber) {
        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
          idxRes1.v = i;
        }

        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
          idxRes1.n = i;
        }
      }
    }

    function fulfilled(idxResult) {
      return idxResult.v != null && idxResult.n != null;
    }

    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
  }();

  if (idxResult) {
    encode.value = [idxResult.v]; // `potentialNameDimIndex` has highest priority.

    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label uses itemName in charts.
    // So we don't set encodeLabel here.

    encode.itemName = [nameDimIndex];
    encode.seriesName = [nameDimIndex];
  }

  return encode;
}
/**
 * @return If return null/undefined, indicate that should not use datasetModel.
 */

function querySeriesUpstreamDatasetModel(seriesModel) {
  // Caution: consider the scenario:
  // A dataset is declared and a series is not expected to use the dataset,
  // and at the beginning `setOption({series: { noData })` (just prepare other
  // option but no data), then `setOption({series: {data: [...]}); In this case,
  // the user should set an empty array to avoid that dataset is used by default.
  var thisData = seriesModel.get('data', true);

  if (!thisData) {
    return queryReferringComponents(seriesModel.ecModel, 'dataset', {
      index: seriesModel.get('datasetIndex', true),
      id: seriesModel.get('datasetId', true)
    }, SINGLE_REFERRING).models[0];
  }
}
/**
 * @return Always return an array event empty.
 */

function queryDatasetUpstreamDatasetModels(datasetModel) {
  // Only these attributes declared, we by defualt reference to `datasetIndex: 0`.
  // Otherwise, no reference.
  if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) {
    return [];
  }

  return queryReferringComponents(datasetModel.ecModel, 'dataset', {
    index: datasetModel.get('fromDatasetIndex', true),
    id: datasetModel.get('fromDatasetId', true)
  }, SINGLE_REFERRING).models;
}
/**
 * The rule should not be complex, otherwise user might not
 * be able to known where the data is wrong.
 * The code is ugly, but how to make it neat?
 */

function guessOrdinal(source, dimIndex) {
  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
} // dimIndex may be overflow source data.
// return {BE_ORDINAL}

function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
  var result; // Experience value.

  var maxLoop = 5;

  if (isTypedArray$1(data)) {
    return BE_ORDINAL.Not;
  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
  // always exists in source.


  var dimName;
  var dimType;

  if (dimensionsDefine) {
    var dimDefItem = dimensionsDefine[dimIndex];

    if (isObject$2(dimDefItem)) {
      dimName = dimDefItem.name;
      dimType = dimDefItem.type;
    } else if (isString(dimDefItem)) {
      dimName = dimDefItem;
    }
  }

  if (dimType != null) {
    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
  }

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    var dataArrayRows = data;

    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
      var sample = dataArrayRows[dimIndex];

      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
        if ((result = detectValue(sample[startIndex + i])) != null) {
          return result;
        }
      }
    } else {
      for (var i = 0; i < dataArrayRows.length && i < maxLoop; i++) {
        var row = dataArrayRows[startIndex + i];

        if (row && (result = detectValue(row[dimIndex])) != null) {
          return result;
        }
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    var dataObjectRows = data;

    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < dataObjectRows.length && i < maxLoop; i++) {
      var item = dataObjectRows[i];

      if (item && (result = detectValue(item[dimName])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    var dataKeyedColumns = data;

    if (!dimName) {
      return BE_ORDINAL.Not;
    }

    var sample = dataKeyedColumns[dimName];

    if (!sample || isTypedArray$1(sample)) {
      return BE_ORDINAL.Not;
    }

    for (var i = 0; i < sample.length && i < maxLoop; i++) {
      if ((result = detectValue(sample[i])) != null) {
        return result;
      }
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var dataOriginal = data;

    for (var i = 0; i < dataOriginal.length && i < maxLoop; i++) {
      var item = dataOriginal[i];
      var val = getDataItemValue(item);

      if (!isArray$1(val)) {
        return BE_ORDINAL.Not;
      }

      if ((result = detectValue(val[dimIndex])) != null) {
        return result;
      }
    }
  }

  function detectValue(val) {
    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
    // `isFinit('')` get `true`.

    if (val != null && isFinite(val) && val !== '') {
      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
    } else if (beStr && val !== '-') {
      return BE_ORDINAL.Must;
    }
  }

  return BE_ORDINAL.Not;
}

var internalOptionCreatorMap = createHashMap();
function registerInternalOptionCreator(mainType, creator) {
  assert(internalOptionCreatorMap.get(mainType) == null && creator);
  internalOptionCreatorMap.set(mainType, creator);
}
function concatInternalOptions(ecModel, mainType, newCmptOptionList) {
  var internalOptionCreator = internalOptionCreatorMap.get(mainType);

  if (!internalOptionCreator) {
    return newCmptOptionList;
  }

  var internalOptions = internalOptionCreator(ecModel);

  if (!internalOptions) {
    return newCmptOptionList;
  }

  if (process.env.NODE_ENV !== 'production') {
    for (var i = 0; i < internalOptions.length; i++) {
      assert(isComponentIdInternal(internalOptions[i]));
    }
  }

  return newCmptOptionList.concat(internalOptions);
}

var innerColor = makeInner();
var innerDecal = makeInner();

var PaletteMixin =
/** @class */
function () {
  function PaletteMixin() {}

  PaletteMixin.prototype.getColorFromPalette = function (name, scope, requestNum) {
    var defaultPalette = normalizeToArray(this.get('color', true));
    var layeredPalette = this.get('colorLayer', true);
    return getFromPalette(this, innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
  };

  PaletteMixin.prototype.clearColorPalette = function () {
    clearPalette(this, innerColor);
  };

  return PaletteMixin;
}();

function getDecalFromPalette(ecModel, name, scope, requestNum) {
  var defaultDecals = normalizeToArray(ecModel.get(['aria', 'decal', 'decals']));
  return getFromPalette(ecModel, innerDecal, defaultDecals, null, name, scope, requestNum);
}

function getNearestPalette(palettes, requestColorNum) {
  var paletteNum = palettes.length; // TODO palettes must be in order

  for (var i = 0; i < paletteNum; i++) {
    if (palettes[i].length > requestColorNum) {
      return palettes[i];
    }
  }

  return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */


function getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
  scope = scope || that;
  var scopeFields = inner(scope);
  var paletteIdx = scopeFields.paletteIdx || 0;
  var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.

  if (paletteNameMap.hasOwnProperty(name)) {
    return paletteNameMap[name];
  }

  var palette = requestNum == null || !layeredPalette ? defaultPalette : getNearestPalette(layeredPalette, requestNum); // In case can't find in layered color palette.

  palette = palette || defaultPalette;

  if (!palette || !palette.length) {
    return;
  }

  var pickedPaletteItem = palette[paletteIdx];

  if (name) {
    paletteNameMap[name] = pickedPaletteItem;
  }

  scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
  return pickedPaletteItem;
}

function clearPalette(that, inner) {
  inner(that).paletteIdx = 0;
  inner(that).paletteNameMap = {};
}

// Internal method names:
// -----------------------

var reCreateSeriesIndices;
var assertSeriesInitialized;
var initBase;
var OPTION_INNER_KEY = '\0_ec_inner';
var OPTION_INNER_VALUE = 1;
var BUITIN_COMPONENTS_MAP = {
  grid: 'GridComponent',
  polar: 'PolarComponent',
  geo: 'GeoComponent',
  singleAxis: 'SingleAxisComponent',
  parallel: 'ParallelComponent',
  calendar: 'CalendarComponent',
  graphic: 'GraphicComponent',
  toolbox: 'ToolboxComponent',
  tooltip: 'TooltipComponent',
  axisPointer: 'AxisPointerComponent',
  brush: 'BrushComponent',
  title: 'TitleComponent',
  timeline: 'TimelineComponent',
  markPoint: 'MarkPointComponent',
  markLine: 'MarkLineComponent',
  markArea: 'MarkAreaComponent',
  legend: 'LegendComponent',
  dataZoom: 'DataZoomComponent',
  visualMap: 'VisualMapComponent',
  // aria: 'AriaComponent',
  // dataset: 'DatasetComponent',
  // Dependencies
  xAxis: 'GridComponent',
  yAxis: 'GridComponent',
  angleAxis: 'PolarComponent',
  radiusAxis: 'PolarComponent'
};
var BUILTIN_CHARTS_MAP = {
  line: 'LineChart',
  bar: 'BarChart',
  pie: 'PieChart',
  scatter: 'ScatterChart',
  radar: 'RadarChart',
  map: 'MapChart',
  tree: 'TreeChart',
  treemap: 'TreemapChart',
  graph: 'GraphChart',
  gauge: 'GaugeChart',
  funnel: 'FunnelChart',
  parallel: 'ParallelChart',
  sankey: 'SankeyChart',
  boxplot: 'BoxplotChart',
  candlestick: 'CandlestickChart',
  effectScatter: 'EffectScatterChart',
  lines: 'LinesChart',
  heatmap: 'HeatmapChart',
  pictorialBar: 'PictorialBarChart',
  themeRiver: 'ThemeRiverChart',
  sunburst: 'SunburstChart',
  custom: 'CustomChart'
};
var componetsMissingLogPrinted = {};

function checkMissingComponents(option) {
  each(option, function (componentOption, mainType) {
    if (!ComponentModel.hasClass(mainType)) {
      var componentImportName = BUITIN_COMPONENTS_MAP[mainType];

      if (componentImportName && !componetsMissingLogPrinted[componentImportName]) {
        error("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
        componetsMissingLogPrinted[componentImportName] = true;
      }
    }
  });
}

var GlobalModel =
/** @class */
function (_super) {
  __extends$1(GlobalModel, _super);

  function GlobalModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GlobalModel.prototype.init = function (option, parentModel, ecModel, theme, locale, optionManager) {
    theme = theme || {};
    this.option = null; // Mark as not initialized.

    this._theme = new Model(theme);
    this._locale = new Model(locale);
    this._optionManager = optionManager;
  };

  GlobalModel.prototype.setOption = function (option, opts, optionPreprocessorFuncs) {
    if (process.env.NODE_ENV !== 'production') {
      assert(option != null, 'option is null/undefined');
      assert(option[OPTION_INNER_KEY] !== OPTION_INNER_VALUE, 'please use chart.getOption()');
    }

    var innerOpt = normalizeSetOptionInput(opts);

    this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);

    this._resetOption(null, innerOpt);
  };
  /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */


  GlobalModel.prototype.resetOption = function (type, opt) {
    return this._resetOption(type, normalizeSetOptionInput(opt));
  };

  GlobalModel.prototype._resetOption = function (type, opt) {
    var optionChanged = false;
    var optionManager = this._optionManager;

    if (!type || type === 'recreate') {
      var baseOption = optionManager.mountOption(type === 'recreate');

      if (process.env.NODE_ENV !== 'production') {
        checkMissingComponents(baseOption);
      }

      if (!this.option || type === 'recreate') {
        initBase(this, baseOption);
      } else {
        this.restoreData();

        this._mergeOption(baseOption, opt);
      }

      optionChanged = true;
    }

    if (type === 'timeline' || type === 'media') {
      this.restoreData();
    } // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
    // it should better not have the same props with `MediaUnit['option']`.
    // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
    // rather than original "baseOption". If they both override a prop, the result might be
    // unexpected when media state changed after `setOption` called.
    // If we really need to modify a props in each `MediaUnit['option']`, use the full version
    // (`{baseOption, media}`) in `setOption`.
    // For `timeline`, the case is the same.


    if (!type || type === 'recreate' || type === 'timeline') {
      var timelineOption = optionManager.getTimelineOption(this);

      if (timelineOption) {
        optionChanged = true;

        this._mergeOption(timelineOption, opt);
      }
    }

    if (!type || type === 'recreate' || type === 'media') {
      var mediaOptions = optionManager.getMediaOption(this);

      if (mediaOptions.length) {
        each(mediaOptions, function (mediaOption) {
          optionChanged = true;

          this._mergeOption(mediaOption, opt);
        }, this);
      }
    }

    return optionChanged;
  };

  GlobalModel.prototype.mergeOption = function (option) {
    this._mergeOption(option, null);
  };

  GlobalModel.prototype._mergeOption = function (newOption, opt) {
    var option = this.option;
    var componentsMap = this._componentsMap;
    var componentsCount = this._componentsCount;
    var newCmptTypes = [];
    var newCmptTypeMap = createHashMap();
    var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
    resetSourceDefaulter(this); // If no component class, merge directly.
    // For example: color, animaiton options, etc.

    each(newOption, function (componentOption, mainType) {
      if (componentOption == null) {
        return;
      }

      if (!ComponentModel.hasClass(mainType)) {
        // globalSettingTask.dirty();
        option[mainType] = option[mainType] == null ? clone(componentOption) : merge$1(option[mainType], componentOption, true);
      } else if (mainType) {
        newCmptTypes.push(mainType);
        newCmptTypeMap.set(mainType, true);
      }
    });

    if (replaceMergeMainTypeMap) {
      // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
      // we trade it as it is declared in option as `{xxx: []}`. Because:
      // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
      // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
      replaceMergeMainTypeMap.each(function (val, mainTypeInReplaceMerge) {
        if (ComponentModel.hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
          newCmptTypes.push(mainTypeInReplaceMerge);
          newCmptTypeMap.set(mainTypeInReplaceMerge, true);
        }
      });
    }

    ComponentModel.topologicalTravel(newCmptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);

    function visitComponent(mainType) {
      var newCmptOptionList = concatInternalOptions(this, mainType, normalizeToArray(newOption[mainType]));
      var oldCmptList = componentsMap.get(mainType);
      var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
      !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
      var mappingResult = mappingToExists(oldCmptList, newCmptOptionList, mergeMode); // Set mainType and complete subType.

      setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel); // Empty it before the travel, in order to prevent `this._componentsMap`
      // from being used in the `init`/`mergeOption`/`optionUpdated` of some
      // components, which is probably incorrect logic.

      option[mainType] = null;
      componentsMap.set(mainType, null);
      componentsCount.set(mainType, 0);
      var optionsByMainType = [];
      var cmptsByMainType = [];
      var cmptsCountByMainType = 0;
      var tooltipExists;
      var tooltipWarningLogged;
      each(mappingResult, function (resultItem, index) {
        var componentModel = resultItem.existing;
        var newCmptOption = resultItem.newOption;

        if (!newCmptOption) {
          if (componentModel) {
            // Consider where is no new option and should be merged using {},
            // see removeEdgeAndAdd in topologicalTravel and
            // ComponentModel.getAllClassMainTypes.
            componentModel.mergeOption({}, this);
            componentModel.optionUpdated({}, false);
          } // If no both `resultItem.exist` and `resultItem.option`,
          // either it is in `replaceMerge` and not matched by any id,
          // or it has been removed in previous `replaceMerge` and left a "hole" in this component index.

        } else {
          var isSeriesType = mainType === 'series';
          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
          );

          if (!ComponentModelClass) {
            if (process.env.NODE_ENV !== 'production') {
              var subType = resultItem.keyInfo.subType;
              var seriesImportName = BUILTIN_CHARTS_MAP[subType];

              if (!componetsMissingLogPrinted[subType]) {
                componetsMissingLogPrinted[subType] = true;

                if (seriesImportName) {
                  error("Series " + subType + " is used but not imported.\nimport { " + seriesImportName + " } from 'echarts/charts';\necharts.use([" + seriesImportName + "]);");
                } else {
                  error("Unknown series " + subType);
                }
              }
            }

            return;
          } // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.


          if (mainType === 'tooltip') {
            if (tooltipExists) {
              if (process.env.NODE_ENV !== 'production') {
                if (!tooltipWarningLogged) {
                  warn('Currently only one tooltip component is allowed.');
                  tooltipWarningLogged = true;
                }
              }

              return;
            }

            tooltipExists = true;
          }

          if (componentModel && componentModel.constructor === ComponentModelClass) {
            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();

            componentModel.mergeOption(newCmptOption, this);
            componentModel.optionUpdated(newCmptOption, false);
          } else {
            // PENDING Global as parent ?
            var extraOpt = extend({
              componentIndex: index
            }, resultItem.keyInfo);
            componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt); // Assign `keyInfo`

            extend(componentModel, extraOpt);

            if (resultItem.brandNew) {
              componentModel.__requireNewView = true;
            }

            componentModel.init(newCmptOption, this, this); // Call optionUpdated after init.
            // newCmptOption has been used as componentModel.option
            // and may be merged with theme and default, so pass null
            // to avoid confusion.

            componentModel.optionUpdated(null, true);
          }
        }

        if (componentModel) {
          optionsByMainType.push(componentModel.option);
          cmptsByMainType.push(componentModel);
          cmptsCountByMainType++;
        } else {
          // Always do assign to avoid elided item in array.
          optionsByMainType.push(void 0);
          cmptsByMainType.push(void 0);
        }
      }, this);
      option[mainType] = optionsByMainType;
      componentsMap.set(mainType, cmptsByMainType);
      componentsCount.set(mainType, cmptsCountByMainType); // Backup series for filtering.

      if (mainType === 'series') {
        reCreateSeriesIndices(this);
      }
    } // If no series declared, ensure `_seriesIndices` initialized.


    if (!this._seriesIndices) {
      reCreateSeriesIndices(this);
    }
  };
  /**
   * Get option for output (cloned option and inner info removed)
   */


  GlobalModel.prototype.getOption = function () {
    var option = clone(this.option);
    each(option, function (optInMainType, mainType) {
      if (ComponentModel.hasClass(mainType)) {
        var opts = normalizeToArray(optInMainType); // Inner cmpts need to be removed.
        // Inner cmpts might not be at last since ec5.0, but still
        // compatible for users: if inner cmpt at last, splice the returned array.

        var realLen = opts.length;
        var metNonInner = false;

        for (var i = realLen - 1; i >= 0; i--) {
          // Remove options with inner id.
          if (opts[i] && !isComponentIdInternal(opts[i])) {
            metNonInner = true;
          } else {
            opts[i] = null;
            !metNonInner && realLen--;
          }
        }

        opts.length = realLen;
        option[mainType] = opts;
      }
    });
    delete option[OPTION_INNER_KEY];
    return option;
  };

  GlobalModel.prototype.getTheme = function () {
    return this._theme;
  };

  GlobalModel.prototype.getLocaleModel = function () {
    return this._locale;
  };

  GlobalModel.prototype.setUpdatePayload = function (payload) {
    this._payload = payload;
  };

  GlobalModel.prototype.getUpdatePayload = function () {
    return this._payload;
  };
  /**
   * @param idx If not specified, return the first one.
   */


  GlobalModel.prototype.getComponent = function (mainType, idx) {
    var list = this._componentsMap.get(mainType);

    if (list) {
      var cmpt = list[idx || 0];

      if (cmpt) {
        return cmpt;
      } else if (idx == null) {
        for (var i = 0; i < list.length; i++) {
          if (list[i]) {
            return list[i];
          }
        }
      }
    }
  };
  /**
   * @return Never be null/undefined.
   */


  GlobalModel.prototype.queryComponents = function (condition) {
    var mainType = condition.mainType;

    if (!mainType) {
      return [];
    }

    var index = condition.index;
    var id = condition.id;
    var name = condition.name;

    var cmpts = this._componentsMap.get(mainType);

    if (!cmpts || !cmpts.length) {
      return [];
    }

    var result;

    if (index != null) {
      result = [];
      each(normalizeToArray(index), function (idx) {
        cmpts[idx] && result.push(cmpts[idx]);
      });
    } else if (id != null) {
      result = queryByIdOrName('id', id, cmpts);
    } else if (name != null) {
      result = queryByIdOrName('name', name, cmpts);
    } else {
      // Return all non-empty components in that mainType
      result = filter(cmpts, function (cmpt) {
        return !!cmpt;
      });
    }

    return filterBySubType(result, condition);
  };
  /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */


  GlobalModel.prototype.findComponents = function (condition) {
    var query = condition.query;
    var mainType = condition.mainType;
    var queryCond = getQueryCond(query);
    var result = queryCond ? this.queryComponents(queryCond) // Retrieve all non-empty components.
    : filter(this._componentsMap.get(mainType), function (cmpt) {
      return !!cmpt;
    });
    return doFilter(filterBySubType(result, condition));

    function getQueryCond(q) {
      var indexAttr = mainType + 'Index';
      var idAttr = mainType + 'Id';
      var nameAttr = mainType + 'Name';
      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
        mainType: mainType,
        // subType will be filtered finally.
        index: q[indexAttr],
        id: q[idAttr],
        name: q[nameAttr]
      } : null;
    }

    function doFilter(res) {
      return condition.filter ? filter(res, condition.filter) : res;
    }
  };

  GlobalModel.prototype.eachComponent = function (mainType, cb, context) {
    var componentsMap = this._componentsMap;

    if (isFunction$3(mainType)) {
      var ctxForAll_1 = cb;
      var cbForAll_1 = mainType;
      componentsMap.each(function (cmpts, componentType) {
        for (var i = 0; cmpts && i < cmpts.length; i++) {
          var cmpt = cmpts[i];
          cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
        }
      });
    } else {
      var cmpts = isString(mainType) ? componentsMap.get(mainType) : isObject$2(mainType) ? this.findComponents(mainType) : null;

      for (var i = 0; cmpts && i < cmpts.length; i++) {
        var cmpt = cmpts[i];
        cmpt && cb.call(context, cmpt, cmpt.componentIndex);
      }
    }
  };
  /**
   * Get series list before filtered by name.
   */


  GlobalModel.prototype.getSeriesByName = function (name) {
    var nameStr = convertOptionIdName(name, null);
    return filter(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
    });
  };
  /**
   * Get series list before filtered by index.
   */


  GlobalModel.prototype.getSeriesByIndex = function (seriesIndex) {
    return this._componentsMap.get('series')[seriesIndex];
  };
  /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */


  GlobalModel.prototype.getSeriesByType = function (subType) {
    return filter(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries && oneSeries.subType === subType;
    });
  };
  /**
   * Get all series before filtered.
   */


  GlobalModel.prototype.getSeries = function () {
    return filter(this._componentsMap.get('series'), function (oneSeries) {
      return !!oneSeries;
    });
  };
  /**
   * Count series before filtered.
   */


  GlobalModel.prototype.getSeriesCount = function () {
    return this._componentsCount.get('series');
  };
  /**
   * After filtering, series may be different
   * from raw series.
   */


  GlobalModel.prototype.eachSeries = function (cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      cb.call(context, series, rawSeriesIndex);
    }, this);
  };
  /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */


  GlobalModel.prototype.eachRawSeries = function (cb, context) {
    each(this._componentsMap.get('series'), function (series) {
      series && cb.call(context, series, series.componentIndex);
    });
  };
  /**
   * After filtering, series may be different.
   * from raw series.
   */


  GlobalModel.prototype.eachSeriesByType = function (subType, cb, context) {
    assertSeriesInitialized(this);
    each(this._seriesIndices, function (rawSeriesIndex) {
      var series = this._componentsMap.get('series')[rawSeriesIndex];

      if (series.subType === subType) {
        cb.call(context, series, rawSeriesIndex);
      }
    }, this);
  };
  /**
   * Iterate raw series before filtered of given type.
   */


  GlobalModel.prototype.eachRawSeriesByType = function (subType, cb, context) {
    return each(this.getSeriesByType(subType), cb, context);
  };

  GlobalModel.prototype.isSeriesFiltered = function (seriesModel) {
    assertSeriesInitialized(this);
    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
  };

  GlobalModel.prototype.getCurrentSeriesIndices = function () {
    return (this._seriesIndices || []).slice();
  };

  GlobalModel.prototype.filterSeries = function (cb, context) {
    assertSeriesInitialized(this);
    var newSeriesIndices = [];
    each(this._seriesIndices, function (seriesRawIdx) {
      var series = this._componentsMap.get('series')[seriesRawIdx];

      cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
    }, this);
    this._seriesIndices = newSeriesIndices;
    this._seriesIndicesMap = createHashMap(newSeriesIndices);
  };

  GlobalModel.prototype.restoreData = function (payload) {
    reCreateSeriesIndices(this);
    var componentsMap = this._componentsMap;
    var componentTypes = [];
    componentsMap.each(function (components, componentType) {
      if (ComponentModel.hasClass(componentType)) {
        componentTypes.push(componentType);
      }
    });
    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType) {
      each(componentsMap.get(componentType), function (component) {
        if (component && (componentType !== 'series' || !isNotTargetSeries(component, payload))) {
          component.restoreData();
        }
      });
    });
  };

  GlobalModel.internalField = function () {
    reCreateSeriesIndices = function (ecModel) {
      var seriesIndices = ecModel._seriesIndices = [];
      each(ecModel._componentsMap.get('series'), function (series) {
        // series may have been removed by `replaceMerge`.
        series && seriesIndices.push(series.componentIndex);
      });
      ecModel._seriesIndicesMap = createHashMap(seriesIndices);
    };

    assertSeriesInitialized = function (ecModel) {
      // Components that use _seriesIndices should depends on series component,
      // which make sure that their initialization is after series.
      if (process.env.NODE_ENV !== 'production') {
        if (!ecModel._seriesIndices) {
          throw new Error('Option should contains series.');
        }
      }
    };

    initBase = function (ecModel, baseOption) {
      // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
      // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
      ecModel.option = {};
      ecModel.option[OPTION_INNER_KEY] = OPTION_INNER_VALUE; // Init with series: [], in case of calling findSeries method
      // before series initialized.

      ecModel._componentsMap = createHashMap({
        series: []
      });
      ecModel._componentsCount = createHashMap(); // If user spefied `option.aria`, aria will be enable. This detection should be
      // performed before theme and globalDefault merge.

      var airaOption = baseOption.aria;

      if (isObject$2(airaOption) && airaOption.enabled == null) {
        airaOption.enabled = true;
      }

      mergeTheme(baseOption, ecModel._theme.option); // TODO Needs clone when merging to the unexisted property

      merge$1(baseOption, globalDefault, false);

      ecModel._mergeOption(baseOption, null);
    };
  }();

  return GlobalModel;
}(Model);

function isNotTargetSeries(seriesModel, payload) {
  if (payload) {
    var index = payload.seriesIndex;
    var id = payload.seriesId;
    var name_1 = payload.seriesName;
    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
  }
}

function mergeTheme(option, theme) {
  // PENDING
  // NOT use `colorLayer` in theme if option has `color`
  var notMergeColorLayer = option.color && !option.colorLayer;
  each(theme, function (themeItem, name) {
    if (name === 'colorLayer' && notMergeColorLayer) {
      return;
    } // If it is component model mainType, the model handles that merge later.
    // otherwise, merge them here.


    if (!ComponentModel.hasClass(name)) {
      if (typeof themeItem === 'object') {
        option[name] = !option[name] ? clone(themeItem) : merge$1(option[name], themeItem, false);
      } else {
        if (option[name] == null) {
          option[name] = themeItem;
        }
      }
    }
  });
}

function queryByIdOrName(attr, idOrName, cmpts) {
  // Here is a break from echarts4: string and number are
  // treated as equal.
  if (isArray$1(idOrName)) {
    var keyMap_1 = createHashMap();
    each(idOrName, function (idOrNameItem) {
      if (idOrNameItem != null) {
        var idName = convertOptionIdName(idOrNameItem, null);
        idName != null && keyMap_1.set(idOrNameItem, true);
      }
    });
    return filter(cmpts, function (cmpt) {
      return cmpt && keyMap_1.get(cmpt[attr]);
    });
  } else {
    var idName_1 = convertOptionIdName(idOrName, null);
    return filter(cmpts, function (cmpt) {
      return cmpt && idName_1 != null && cmpt[attr] === idName_1;
    });
  }
}

function filterBySubType(components, condition) {
  // Using hasOwnProperty for restrict. Consider
  // subType is undefined in user payload.
  return condition.hasOwnProperty('subType') ? filter(components, function (cmpt) {
    return cmpt && cmpt.subType === condition.subType;
  }) : components;
}

function normalizeSetOptionInput(opts) {
  var replaceMergeMainTypeMap = createHashMap();
  opts && each(normalizeToArray(opts.replaceMerge), function (mainType) {
    if (process.env.NODE_ENV !== 'production') {
      assert(ComponentModel.hasClass(mainType), '"' + mainType + '" is not valid component main type in "replaceMerge"');
    }

    replaceMergeMainTypeMap.set(mainType, true);
  });
  return {
    replaceMergeMainTypeMap: replaceMergeMainTypeMap
  };
}

mixin(GlobalModel, PaletteMixin);

var availableMethods = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isSSR', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', // 'getModel',
'getOption', // 'getViewOfComponentModel',
// 'getViewOfSeriesModel',
'getId', 'updateLabelLayout'];

var ExtensionAPI =
/** @class */
function () {
  function ExtensionAPI(ecInstance) {
    each(availableMethods, function (methodName) {
      this[methodName] = bind(ecInstance[methodName], ecInstance);
    }, this);
  }

  return ExtensionAPI;
}();

var coordinateSystemCreators = {};

var CoordinateSystemManager =
/** @class */
function () {
  function CoordinateSystemManager() {
    this._coordinateSystems = [];
  }

  CoordinateSystemManager.prototype.create = function (ecModel, api) {
    var coordinateSystems = [];
    each(coordinateSystemCreators, function (creator, type) {
      var list = creator.create(ecModel, api);
      coordinateSystems = coordinateSystems.concat(list || []);
    });
    this._coordinateSystems = coordinateSystems;
  };

  CoordinateSystemManager.prototype.update = function (ecModel, api) {
    each(this._coordinateSystems, function (coordSys) {
      coordSys.update && coordSys.update(ecModel, api);
    });
  };

  CoordinateSystemManager.prototype.getCoordinateSystems = function () {
    return this._coordinateSystems.slice();
  };

  CoordinateSystemManager.register = function (type, creator) {
    coordinateSystemCreators[type] = creator;
  };

  CoordinateSystemManager.get = function (type) {
    return coordinateSystemCreators[type];
  };

  return CoordinateSystemManager;
}();

var QUERY_REG = /^(min|max)?(.+)$/; // Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;

/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */

var OptionManager =
/** @class */
function () {
  // timeline.notMerge is not supported in ec3. Firstly there is rearly
  // case that notMerge is needed. Secondly supporting 'notMerge' requires
  // rawOption cloned and backuped when timeline changed, which does no
  // good to performance. What's more, that both timeline and setOption
  // method supply 'notMerge' brings complex and some problems.
  // Consider this case:
  // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
  // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
  function OptionManager(api) {
    this._timelineOptions = [];
    this._mediaList = [];
    /**
     * -1, means default.
     * empty means no media.
     */

    this._currentMediaIndices = [];
    this._api = api;
  }

  OptionManager.prototype.setOption = function (rawOption, optionPreprocessorFuncs, opt) {
    if (rawOption) {
      // That set dat primitive is dangerous if user reuse the data when setOption again.
      each(normalizeToArray(rawOption.series), function (series) {
        series && series.data && isTypedArray$1(series.data) && setAsPrimitive(series.data);
      });
      each(normalizeToArray(rawOption.dataset), function (dataset) {
        dataset && dataset.source && isTypedArray$1(dataset.source) && setAsPrimitive(dataset.source);
      });
    } // Caution: some series modify option data, if do not clone,
    // it should ensure that the repeat modify correctly
    // (create a new object when modify itself).


    rawOption = clone(rawOption); // FIXME
    // If some property is set in timeline options or media option but
    // not set in baseOption, a warning should be given.

    var optionBackup = this._optionBackup;
    var newParsedOption = parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);

    if (optionBackup) {
      // FIXME
      // the restore merge solution is essentially incorrect.
      // the mapping can not be 100% consistent with ecModel, which probably brings
      // potential bug!
      // The first merge is delayed, because in most cases, users do not call `setOption` twice.
      // let fakeCmptsMap = this._fakeCmptsMap;
      // if (!fakeCmptsMap) {
      //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
      //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
      // }
      // mergeToBackupOption(
      //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
      // );
      // For simplicity, timeline options and media options do not support merge,
      // that is, if you `setOption` twice and both has timeline options, the latter
      // timeline options will not be merged to the former, but just substitute them.
      if (newParsedOption.timelineOptions.length) {
        optionBackup.timelineOptions = newParsedOption.timelineOptions;
      }

      if (newParsedOption.mediaList.length) {
        optionBackup.mediaList = newParsedOption.mediaList;
      }

      if (newParsedOption.mediaDefault) {
        optionBackup.mediaDefault = newParsedOption.mediaDefault;
      }
    } else {
      this._optionBackup = newParsedOption;
    }
  };

  OptionManager.prototype.mountOption = function (isRecreate) {
    var optionBackup = this._optionBackup;
    this._timelineOptions = optionBackup.timelineOptions;
    this._mediaList = optionBackup.mediaList;
    this._mediaDefault = optionBackup.mediaDefault;
    this._currentMediaIndices = [];
    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
    // called, and is merged into every new option by inner method `mergeToBackupOption`
    // each time `setOption` called, can be only used in `isRecreate`, because
    // its reliability is under suspicion. In other cases option merge is
    // performed by `model.mergeOption`.
    ? optionBackup.baseOption : this._newBaseOption);
  };

  OptionManager.prototype.getTimelineOption = function (ecModel) {
    var option;
    var timelineOptions = this._timelineOptions;

    if (timelineOptions.length) {
      // getTimelineOption can only be called after ecModel inited,
      // so we can get currentIndex from timelineModel.
      var timelineModel = ecModel.getComponent('timeline');

      if (timelineModel) {
        option = clone( // FIXME:TS as TimelineModel or quivlant interface
        timelineOptions[timelineModel.getCurrentIndex()]);
      }
    }

    return option;
  };

  OptionManager.prototype.getMediaOption = function (ecModel) {
    var ecWidth = this._api.getWidth();

    var ecHeight = this._api.getHeight();

    var mediaList = this._mediaList;
    var mediaDefault = this._mediaDefault;
    var indices = [];
    var result = []; // No media defined.

    if (!mediaList.length && !mediaDefault) {
      return result;
    } // Multi media may be applied, the latter defined media has higher priority.


    for (var i = 0, len = mediaList.length; i < len; i++) {
      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
        indices.push(i);
      }
    } // FIXME
    // Whether mediaDefault should force users to provide? Otherwise
    // the change by media query can not be recorvered.


    if (!indices.length && mediaDefault) {
      indices = [-1];
    }

    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
      result = map(indices, function (index) {
        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
      });
    } // Otherwise return nothing.


    this._currentMediaIndices = indices;
    return result;
  };

  return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */


function parseRawOption( // `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
  var mediaList = [];
  var mediaDefault;
  var baseOption;
  var declaredBaseOption = rawOption.baseOption; // Compatible with ec2, [RAW_OPTION_PATTERNS] above.

  var timelineOnRoot = rawOption.timeline;
  var timelineOptionsOnRoot = rawOption.options;
  var mediaOnRoot = rawOption.media;
  var hasMedia = !!rawOption.media;
  var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);

  if (declaredBaseOption) {
    baseOption = declaredBaseOption; // For merge option.

    if (!baseOption.timeline) {
      baseOption.timeline = timelineOnRoot;
    }
  } // For convenience, enable to use the root option as the `baseOption`:
  // `{ ...normalOptionProps, media: [{ ... }, { ... }] }`
  else {
      if (hasTimeline || hasMedia) {
        rawOption.options = rawOption.media = null;
      }

      baseOption = rawOption;
    }

  if (hasMedia) {
    if (isArray$1(mediaOnRoot)) {
      each(mediaOnRoot, function (singleMedia) {
        if (process.env.NODE_ENV !== 'production') {
          // Real case of wrong config.
          if (singleMedia && !singleMedia.option && isObject$2(singleMedia.query) && isObject$2(singleMedia.query.option)) {
            error('Illegal media option. Must be like { media: [ { query: {}, option: {} } ] }');
          }
        }

        if (singleMedia && singleMedia.option) {
          if (singleMedia.query) {
            mediaList.push(singleMedia);
          } else if (!mediaDefault) {
            // Use the first media default.
            mediaDefault = singleMedia;
          }
        }
      });
    } else {
      if (process.env.NODE_ENV !== 'production') {
        // Real case of wrong config.
        error('Illegal media option. Must be an array. Like { media: [ {...}, {...} ] }');
      }
    }
  }

  doPreprocess(baseOption);
  each(timelineOptionsOnRoot, function (option) {
    return doPreprocess(option);
  });
  each(mediaList, function (media) {
    return doPreprocess(media.option);
  });

  function doPreprocess(option) {
    each(optionPreprocessorFuncs, function (preProcess) {
      preProcess(option, isNew);
    });
  }

  return {
    baseOption: baseOption,
    timelineOptions: timelineOptionsOnRoot || [],
    mediaDefault: mediaDefault,
    mediaList: mediaList
  };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */


function applyMediaQuery(query, ecWidth, ecHeight) {
  var realMap = {
    width: ecWidth,
    height: ecHeight,
    aspectratio: ecWidth / ecHeight // lower case for convenience.

  };
  var applicable = true;
  each(query, function (value, attr) {
    var matched = attr.match(QUERY_REG);

    if (!matched || !matched[1] || !matched[2]) {
      return;
    }

    var operator = matched[1];
    var realAttr = matched[2].toLowerCase();

    if (!compare(realMap[realAttr], value, operator)) {
      applicable = false;
    }
  });
  return applicable;
}

function compare(real, expect, operator) {
  if (operator === 'min') {
    return real >= expect;
  } else if (operator === 'max') {
    return real <= expect;
  } else {
    // Equals
    return real === expect;
  }
}

function indicesEquals(indices1, indices2) {
  // indices is always order by asc and has only finite number.
  return indices1.join(',') === indices2.join(',');
}

var each$2 = each;
var isObject$3 = isObject$2;
var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];

function compatEC2ItemStyle(opt) {
  var itemStyleOpt = opt && opt.itemStyle;

  if (!itemStyleOpt) {
    return;
  }

  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
    var styleName = POSSIBLE_STYLES[i];
    var normalItemStyleOpt = itemStyleOpt.normal;
    var emphasisItemStyleOpt = itemStyleOpt.emphasis;

    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
      if (process.env.NODE_ENV !== 'production') {
        deprecateReplaceLog("itemStyle.normal." + styleName, styleName);
      }

      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].normal) {
        opt[styleName].normal = normalItemStyleOpt[styleName];
      } else {
        merge$1(opt[styleName].normal, normalItemStyleOpt[styleName]);
      }

      normalItemStyleOpt[styleName] = null;
    }

    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
      if (process.env.NODE_ENV !== 'production') {
        deprecateReplaceLog("itemStyle.emphasis." + styleName, "emphasis." + styleName);
      }

      opt[styleName] = opt[styleName] || {};

      if (!opt[styleName].emphasis) {
        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
      } else {
        merge$1(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
      }

      emphasisItemStyleOpt[styleName] = null;
    }
  }
}

function convertNormalEmphasis(opt, optType, useExtend) {
  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
    var normalOpt = opt[optType].normal;
    var emphasisOpt = opt[optType].emphasis;

    if (normalOpt) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line max-len
        deprecateLog("'normal' hierarchy in " + optType + " has been removed since 4.0. All style properties are configured in " + optType + " directly now.");
      } // Timeline controlStyle has other properties besides normal and emphasis


      if (useExtend) {
        opt[optType].normal = opt[optType].emphasis = null;
        defaults(opt[optType], normalOpt);
      } else {
        opt[optType] = normalOpt;
      }
    }

    if (emphasisOpt) {
      if (process.env.NODE_ENV !== 'production') {
        deprecateLog(optType + ".emphasis has been changed to emphasis." + optType + " since 4.0");
      }

      opt.emphasis = opt.emphasis || {};
      opt.emphasis[optType] = emphasisOpt; // Also compat the case user mix the style and focus together in ec3 style
      // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }

      if (emphasisOpt.focus) {
        opt.emphasis.focus = emphasisOpt.focus;
      }

      if (emphasisOpt.blurScope) {
        opt.emphasis.blurScope = emphasisOpt.blurScope;
      }
    }
  }
}

function removeEC3NormalStatus(opt) {
  convertNormalEmphasis(opt, 'itemStyle');
  convertNormalEmphasis(opt, 'lineStyle');
  convertNormalEmphasis(opt, 'areaStyle');
  convertNormalEmphasis(opt, 'label');
  convertNormalEmphasis(opt, 'labelLine'); // treemap

  convertNormalEmphasis(opt, 'upperLabel'); // graph

  convertNormalEmphasis(opt, 'edgeLabel');
}

function compatTextStyle(opt, propName) {
  // Check whether is not object (string\null\undefined ...)
  var labelOptSingle = isObject$3(opt) && opt[propName];
  var textStyle = isObject$3(labelOptSingle) && labelOptSingle.textStyle;

  if (textStyle) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line max-len
      deprecateLog("textStyle hierarchy in " + propName + " has been removed since 4.0. All textStyle properties are configured in " + propName + " directly now.");
    }

    for (var i = 0, len = TEXT_STYLE_OPTIONS.length; i < len; i++) {
      var textPropName = TEXT_STYLE_OPTIONS[i];

      if (textStyle.hasOwnProperty(textPropName)) {
        labelOptSingle[textPropName] = textStyle[textPropName];
      }
    }
  }
}

function compatEC3CommonStyles(opt) {
  if (opt) {
    removeEC3NormalStatus(opt);
    compatTextStyle(opt, 'label');
    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
  }
}

function processSeries(seriesOpt) {
  if (!isObject$3(seriesOpt)) {
    return;
  }

  compatEC2ItemStyle(seriesOpt);
  removeEC3NormalStatus(seriesOpt);
  compatTextStyle(seriesOpt, 'label'); // treemap

  compatTextStyle(seriesOpt, 'upperLabel'); // graph

  compatTextStyle(seriesOpt, 'edgeLabel');

  if (seriesOpt.emphasis) {
    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap

    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph

    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
  }

  var markPoint = seriesOpt.markPoint;

  if (markPoint) {
    compatEC2ItemStyle(markPoint);
    compatEC3CommonStyles(markPoint);
  }

  var markLine = seriesOpt.markLine;

  if (markLine) {
    compatEC2ItemStyle(markLine);
    compatEC3CommonStyles(markLine);
  }

  var markArea = seriesOpt.markArea;

  if (markArea) {
    compatEC3CommonStyles(markArea);
  }

  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
  // then the backward compat based on option type will not be performed.

  if (seriesOpt.type === 'graph') {
    data = data || seriesOpt.nodes;
    var edgeData = seriesOpt.links || seriesOpt.edges;

    if (edgeData && !isTypedArray$1(edgeData)) {
      for (var i = 0; i < edgeData.length; i++) {
        compatEC3CommonStyles(edgeData[i]);
      }
    }

    each(seriesOpt.categories, function (opt) {
      removeEC3NormalStatus(opt);
    });
  }

  if (data && !isTypedArray$1(data)) {
    for (var i = 0; i < data.length; i++) {
      compatEC3CommonStyles(data[i]);
    }
  } // mark point data


  markPoint = seriesOpt.markPoint;

  if (markPoint && markPoint.data) {
    var mpData = markPoint.data;

    for (var i = 0; i < mpData.length; i++) {
      compatEC3CommonStyles(mpData[i]);
    }
  } // mark line data


  markLine = seriesOpt.markLine;

  if (markLine && markLine.data) {
    var mlData = markLine.data;

    for (var i = 0; i < mlData.length; i++) {
      if (isArray$1(mlData[i])) {
        compatEC3CommonStyles(mlData[i][0]);
        compatEC3CommonStyles(mlData[i][1]);
      } else {
        compatEC3CommonStyles(mlData[i]);
      }
    }
  } // Series


  if (seriesOpt.type === 'gauge') {
    compatTextStyle(seriesOpt, 'axisLabel');
    compatTextStyle(seriesOpt, 'title');
    compatTextStyle(seriesOpt, 'detail');
  } else if (seriesOpt.type === 'treemap') {
    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
    each(seriesOpt.levels, function (opt) {
      removeEC3NormalStatus(opt);
    });
  } else if (seriesOpt.type === 'tree') {
    removeEC3NormalStatus(seriesOpt.leaves);
  } // sunburst starts from ec4, so it does not need to compat levels.

}

function toArr(o) {
  return isArray$1(o) ? o : o ? [o] : [];
}

function toObj(o) {
  return (isArray$1(o) ? o[0] : o) || {};
}

function globalCompatStyle(option, isTheme) {
  each$2(toArr(option.series), function (seriesOpt) {
    isObject$3(seriesOpt) && processSeries(seriesOpt);
  });
  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
  each$2(axes, function (axisName) {
    each$2(toArr(option[axisName]), function (axisOpt) {
      if (axisOpt) {
        compatTextStyle(axisOpt, 'axisLabel');
        compatTextStyle(axisOpt.axisPointer, 'label');
      }
    });
  });
  each$2(toArr(option.parallel), function (parallelOpt) {
    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
    compatTextStyle(parallelAxisDefault, 'axisLabel');
    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
  });
  each$2(toArr(option.calendar), function (calendarOpt) {
    convertNormalEmphasis(calendarOpt, 'itemStyle');
    compatTextStyle(calendarOpt, 'dayLabel');
    compatTextStyle(calendarOpt, 'monthLabel');
    compatTextStyle(calendarOpt, 'yearLabel');
  }); // radar.name.textStyle

  each$2(toArr(option.radar), function (radarOpt) {
    compatTextStyle(radarOpt, 'name'); // Use axisName instead of name because component has name property

    if (radarOpt.name && radarOpt.axisName == null) {
      radarOpt.axisName = radarOpt.name;
      delete radarOpt.name;

      if (process.env.NODE_ENV !== 'production') {
        deprecateLog('name property in radar component has been changed to axisName');
      }
    }

    if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
      radarOpt.axisNameGap = radarOpt.nameGap;
      delete radarOpt.nameGap;

      if (process.env.NODE_ENV !== 'production') {
        deprecateLog('nameGap property in radar component has been changed to axisNameGap');
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      each$2(radarOpt.indicator, function (indicatorOpt) {
        if (indicatorOpt.text) {
          deprecateReplaceLog('text', 'name', 'radar.indicator');
        }
      });
    }
  });
  each$2(toArr(option.geo), function (geoOpt) {
    if (isObject$3(geoOpt)) {
      compatEC3CommonStyles(geoOpt);
      each$2(toArr(geoOpt.regions), function (regionObj) {
        compatEC3CommonStyles(regionObj);
      });
    }
  });
  each$2(toArr(option.timeline), function (timelineOpt) {
    compatEC3CommonStyles(timelineOpt);
    convertNormalEmphasis(timelineOpt, 'label');
    convertNormalEmphasis(timelineOpt, 'itemStyle');
    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
    var data = timelineOpt.data;
    isArray$1(data) && each(data, function (item) {
      if (isObject$2(item)) {
        convertNormalEmphasis(item, 'label');
        convertNormalEmphasis(item, 'itemStyle');
      }
    });
  });
  each$2(toArr(option.toolbox), function (toolboxOpt) {
    convertNormalEmphasis(toolboxOpt, 'iconStyle');
    each$2(toolboxOpt.feature, function (featureOpt) {
      convertNormalEmphasis(featureOpt, 'iconStyle');
    });
  });
  compatTextStyle(toObj(option.axisPointer), 'label');
  compatTextStyle(toObj(option.tooltip).axisPointer, 'label'); // Clean logs
  // storedLogs = {};
}

function get$2(opt, path) {
  var pathArr = path.split(',');
  var obj = opt;

  for (var i = 0; i < pathArr.length; i++) {
    obj = obj && obj[pathArr[i]];

    if (obj == null) {
      break;
    }
  }

  return obj;
}

function set$1(opt, path, val, overwrite) {
  var pathArr = path.split(',');
  var obj = opt;
  var key;
  var i = 0;

  for (; i < pathArr.length - 1; i++) {
    key = pathArr[i];

    if (obj[key] == null) {
      obj[key] = {};
    }

    obj = obj[key];
  }

  if (overwrite || obj[pathArr[i]] == null) {
    obj[pathArr[i]] = val;
  }
}

function compatLayoutProperties(option) {
  option && each(LAYOUT_PROPERTIES, function (prop) {
    if (prop[0] in option && !(prop[1] in option)) {
      option[prop[1]] = option[prop[0]];
    }
  });
}

var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
var BAR_ITEM_STYLE_MAP = [['borderRadius', 'barBorderRadius'], ['borderColor', 'barBorderColor'], ['borderWidth', 'barBorderWidth']];

function compatBarItemStyle(option) {
  var itemStyle = option && option.itemStyle;

  if (itemStyle) {
    for (var i = 0; i < BAR_ITEM_STYLE_MAP.length; i++) {
      var oldName = BAR_ITEM_STYLE_MAP[i][1];
      var newName = BAR_ITEM_STYLE_MAP[i][0];

      if (itemStyle[oldName] != null) {
        itemStyle[newName] = itemStyle[oldName];

        if (process.env.NODE_ENV !== 'production') {
          deprecateReplaceLog(oldName, newName);
        }
      }
    }
  }
}

function compatPieLabel(option) {
  if (!option) {
    return;
  }

  if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) {
    if (process.env.NODE_ENV !== 'production') {
      deprecateReplaceLog('label.margin', 'label.edgeDistance', 'pie');
    }

    option.edgeDistance = option.margin;
  }
}

function compatSunburstState(option) {
  if (!option) {
    return;
  }

  if (option.downplay && !option.blur) {
    option.blur = option.downplay;

    if (process.env.NODE_ENV !== 'production') {
      deprecateReplaceLog('downplay', 'blur', 'sunburst');
    }
  }
}

function compatGraphFocus(option) {
  if (!option) {
    return;
  }

  if (option.focusNodeAdjacency != null) {
    option.emphasis = option.emphasis || {};

    if (option.emphasis.focus == null) {
      if (process.env.NODE_ENV !== 'production') {
        deprecateReplaceLog('focusNodeAdjacency', 'emphasis: { focus: \'adjacency\'}', 'graph/sankey');
      }

      option.emphasis.focus = 'adjacency';
    }
  }
}

function traverseTree(data, cb) {
  if (data) {
    for (var i = 0; i < data.length; i++) {
      cb(data[i]);
      data[i] && traverseTree(data[i].children, cb);
    }
  }
}

function globalBackwardCompat(option, isTheme) {
  globalCompatStyle(option, isTheme); // Make sure series array for model initialization.

  option.series = normalizeToArray(option.series);
  each(option.series, function (seriesOpt) {
    if (!isObject$2(seriesOpt)) {
      return;
    }

    var seriesType = seriesOpt.type;

    if (seriesType === 'line') {
      if (seriesOpt.clipOverflow != null) {
        seriesOpt.clip = seriesOpt.clipOverflow;

        if (process.env.NODE_ENV !== 'production') {
          deprecateReplaceLog('clipOverflow', 'clip', 'line');
        }
      }
    } else if (seriesType === 'pie' || seriesType === 'gauge') {
      if (seriesOpt.clockWise != null) {
        seriesOpt.clockwise = seriesOpt.clockWise;

        if (process.env.NODE_ENV !== 'production') {
          deprecateReplaceLog('clockWise', 'clockwise');
        }
      }

      compatPieLabel(seriesOpt.label);
      var data = seriesOpt.data;

      if (data && !isTypedArray$1(data)) {
        for (var i = 0; i < data.length; i++) {
          compatPieLabel(data[i]);
        }
      }

      if (seriesOpt.hoverOffset != null) {
        seriesOpt.emphasis = seriesOpt.emphasis || {};

        if (seriesOpt.emphasis.scaleSize = null) {
          if (process.env.NODE_ENV !== 'production') {
            deprecateReplaceLog('hoverOffset', 'emphasis.scaleSize');
          }

          seriesOpt.emphasis.scaleSize = seriesOpt.hoverOffset;
        }
      }
    } else if (seriesType === 'gauge') {
      var pointerColor = get$2(seriesOpt, 'pointer.color');
      pointerColor != null && set$1(seriesOpt, 'itemStyle.color', pointerColor);
    } else if (seriesType === 'bar') {
      compatBarItemStyle(seriesOpt);
      compatBarItemStyle(seriesOpt.backgroundStyle);
      compatBarItemStyle(seriesOpt.emphasis);
      var data = seriesOpt.data;

      if (data && !isTypedArray$1(data)) {
        for (var i = 0; i < data.length; i++) {
          if (typeof data[i] === 'object') {
            compatBarItemStyle(data[i]);
            compatBarItemStyle(data[i] && data[i].emphasis);
          }
        }
      }
    } else if (seriesType === 'sunburst') {
      var highlightPolicy = seriesOpt.highlightPolicy;

      if (highlightPolicy) {
        seriesOpt.emphasis = seriesOpt.emphasis || {};

        if (!seriesOpt.emphasis.focus) {
          seriesOpt.emphasis.focus = highlightPolicy;

          if (process.env.NODE_ENV !== 'production') {
            deprecateReplaceLog('highlightPolicy', 'emphasis.focus', 'sunburst');
          }
        }
      }

      compatSunburstState(seriesOpt);
      traverseTree(seriesOpt.data, compatSunburstState);
    } else if (seriesType === 'graph' || seriesType === 'sankey') {
      compatGraphFocus(seriesOpt); // TODO nodes, edges?
    } else if (seriesType === 'map') {
      if (seriesOpt.mapType && !seriesOpt.map) {
        if (process.env.NODE_ENV !== 'production') {
          deprecateReplaceLog('mapType', 'map', 'map');
        }

        seriesOpt.map = seriesOpt.mapType;
      }

      if (seriesOpt.mapLocation) {
        if (process.env.NODE_ENV !== 'production') {
          deprecateLog('`mapLocation` is not used anymore.');
        }

        defaults(seriesOpt, seriesOpt.mapLocation);
      }
    }

    if (seriesOpt.hoverAnimation != null) {
      seriesOpt.emphasis = seriesOpt.emphasis || {};

      if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) {
        if (process.env.NODE_ENV !== 'production') {
          deprecateReplaceLog('hoverAnimation', 'emphasis.scale');
        }

        seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
      }
    }

    compatLayoutProperties(seriesOpt);
  }); // dataRange has changed to visualMap

  if (option.dataRange) {
    option.visualMap = option.dataRange;
  }

  each(COMPATITABLE_COMPONENTS, function (componentName) {
    var options = option[componentName];

    if (options) {
      if (!isArray$1(options)) {
        options = [options];
      }

      each(options, function (option) {
        compatLayoutProperties(option);
      });
    }
  });
}

//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatedly.
//     Should be executed after series is filtered and before stack calculation.

function dataStack(ecModel) {
  var stackInfoMap = createHashMap();
  ecModel.eachSeries(function (seriesModel) {
    var stack = seriesModel.get('stack'); // Compatible: when `stack` is set as '', do not stack.

    if (stack) {
      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
      var data = seriesModel.getData();
      var stackInfo = {
        // Used for calculate axis extent automatically.
        // TODO: Type getCalculationInfo return more specific type?
        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
        stackedDimension: data.getCalculationInfo('stackedDimension'),
        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
        data: data,
        seriesModel: seriesModel
      }; // If stacked on axis that do not support data stack.

      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
        return;
      }

      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
      stackInfoList.push(stackInfo);
    }
  });
  stackInfoMap.each(calculateStack);
}

function calculateStack(stackInfoList) {
  each(stackInfoList, function (targetStackInfo, idxInStack) {
    var resultVal = [];
    var resultNaN = [NaN, NaN];
    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
    var targetData = targetStackInfo.data;
    var isStackedByIndex = targetStackInfo.isStackedByIndex;
    var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign'; // Should not write on raw data, because stack series model list changes
    // depending on legend selection.

    targetData.modify(dims, function (v0, v1, dataIndex) {
      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
      // should also be NaN, to draw a appropriate belt area.

      if (isNaN(sum)) {
        return resultNaN;
      }

      var byValue;
      var stackedDataRawIndex;

      if (isStackedByIndex) {
        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
      } else {
        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
      } // If stackOver is NaN, chart view will render point on value start.


      var stackedOver = NaN;

      for (var j = idxInStack - 1; j >= 0; j--) {
        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.

        if (!isStackedByIndex) {
          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
        }

        if (stackedDataRawIndex >= 0) {
          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data

          if (stackStrategy === 'all' // single stack group
          || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
          || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
          ) {
              // The sum has to be very small to be affected by the
              // floating arithmetic problem. An incorrect result will probably
              // cause axis min/max to be filtered incorrectly.
              sum = addSafe(sum, val);
              stackedOver = val;
              break;
            }
        }
      }

      resultVal[0] = sum;
      resultVal[1] = stackedOver;
      return resultVal;
    });
  });
}

var SourceImpl =
/** @class */
function () {
  function SourceImpl(fields) {
    this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
    this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN; // Visit config

    this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
    this.startIndex = fields.startIndex || 0;
    this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
    this.metaRawOption = fields.metaRawOption;
    var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;

    if (dimensionsDefine) {
      for (var i = 0; i < dimensionsDefine.length; i++) {
        var dim = dimensionsDefine[i];

        if (dim.type == null) {
          if (guessOrdinal(this, i) === BE_ORDINAL.Must) {
            dim.type = 'ordinal';
          }
        }
      }
    }
  }

  return SourceImpl;
}();

function isSourceInstance(val) {
  return val instanceof SourceImpl;
}
/**
 * Create a source from option.
 * NOTE: Created source is immutable. Don't change any properties in it.
 */

function createSource(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
  sourceFormat = sourceFormat || detectSourceFormat(sourceData);
  var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
  var determined = determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
  var source = new SourceImpl({
    data: sourceData,
    sourceFormat: sourceFormat,
    seriesLayoutBy: seriesLayoutBy,
    dimensionsDefine: determined.dimensionsDefine,
    startIndex: determined.startIndex,
    dimensionsDetectedCount: determined.dimensionsDetectedCount,
    metaRawOption: clone(thisMetaRawOption)
  });
  return source;
}
/**
 * Wrap original series data for some compatibility cases.
 */

function createSourceFromSeriesDataOption(data) {
  return new SourceImpl({
    data: data,
    sourceFormat: isTypedArray$1(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL
  });
}
/**
 * Clone source but excludes source data.
 */

function cloneSourceShallow(source) {
  return new SourceImpl({
    data: source.data,
    sourceFormat: source.sourceFormat,
    seriesLayoutBy: source.seriesLayoutBy,
    dimensionsDefine: clone(source.dimensionsDefine),
    startIndex: source.startIndex,
    dimensionsDetectedCount: source.dimensionsDetectedCount
  });
}
/**
 * Note: An empty array will be detected as `SOURCE_FORMAT_ARRAY_ROWS`.
 */

function detectSourceFormat(data) {
  var sourceFormat = SOURCE_FORMAT_UNKNOWN;

  if (isTypedArray$1(data)) {
    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
  } else if (isArray$1(data)) {
    // FIXME Whether tolerate null in top level array?
    if (data.length === 0) {
      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
    }

    for (var i = 0, len = data.length; i < len; i++) {
      var item = data[i];

      if (item == null) {
        continue;
      } else if (isArray$1(item)) {
        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
        break;
      } else if (isObject$2(item)) {
        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
        break;
      }
    }
  } else if (isObject$2(data)) {
    for (var key in data) {
      if (hasOwn(data, key) && isArrayLike$1(data[key])) {
        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
        break;
      }
    }
  }

  return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */

function determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
  var dimensionsDetectedCount;
  var startIndex; // PENDING: Could data be null/undefined here?
  // currently, if `dataset.source` not specified, error thrown.
  // if `series.data` not specified, nothing rendered without error thrown.
  // Should test these cases.

  if (!data) {
    return {
      dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
      startIndex: startIndex,
      dimensionsDetectedCount: dimensionsDetectedCount
    };
  }

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    var dataArrayRows = data; // Rule: Most of the first line are string: it is header.
    // Caution: consider a line with 5 string and 1 number,
    // it still can not be sure it is a head, because the
    // 5 string may be 5 values of category columns.

    if (sourceHeader === 'auto' || sourceHeader == null) {
      arrayRowsTravelFirst(function (val) {
        // '-' is regarded as null/undefined.
        if (val != null && val !== '-') {
          if (isString(val)) {
            startIndex == null && (startIndex = 1);
          } else {
            startIndex = 0;
          }
        } // 10 is an experience number, avoid long loop.

      }, seriesLayoutBy, dataArrayRows, 10);
    } else {
      startIndex = isNumber$1(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
    }

    if (!dimensionsDefine && startIndex === 1) {
      dimensionsDefine = [];
      arrayRowsTravelFirst(function (val, index) {
        dimensionsDefine[index] = val != null ? val + '' : '';
      }, seriesLayoutBy, dataArrayRows, Infinity);
    }

    dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    if (!dimensionsDefine) {
      dimensionsDefine = objectRowsCollectDimensions(data);
    }
  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
    if (!dimensionsDefine) {
      dimensionsDefine = [];
      each(data, function (colArr, key) {
        dimensionsDefine.push(key);
      });
    }
  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var value0 = getDataItemValue(data[0]);
    dimensionsDetectedCount = isArray$1(value0) && value0.length || 1;
  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
    if (process.env.NODE_ENV !== 'production') {
      assert(!!dimensionsDefine, 'dimensions must be given if data is TypedArray.');
    }
  }

  return {
    startIndex: startIndex,
    dimensionsDefine: normalizeDimensionsOption(dimensionsDefine),
    dimensionsDetectedCount: dimensionsDetectedCount
  };
}

function objectRowsCollectDimensions(data) {
  var firstIndex = 0;
  var obj;

  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line


  if (obj) {
    var dimensions_1 = [];
    each(obj, function (value, key) {
      dimensions_1.push(key);
    });
    return dimensions_1;
  }
} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.


function normalizeDimensionsOption(dimensionsDefine) {
  if (!dimensionsDefine) {
    // The meaning of null/undefined is different from empty array.
    return;
  }

  var nameMap = createHashMap();
  return map(dimensionsDefine, function (rawItem, index) {
    rawItem = isObject$2(rawItem) ? rawItem : {
      name: rawItem
    }; // Other fields will be discarded.

    var item = {
      name: rawItem.name,
      displayName: rawItem.displayName,
      type: rawItem.type
    }; // User can set null in dimensions.
    // We don't auto specify name, otherwise a given name may
    // cause it to be referred unexpectedly.

    if (item.name == null) {
      return item;
    } // Also consider number form like 2012.


    item.name += ''; // User may also specify displayName.
    // displayName will always exists except user not
    // specified or dim name is not specified or detected.
    // (A auto generated dim name will not be used as
    // displayName).

    if (item.displayName == null) {
      item.displayName = item.name;
    }

    var exist = nameMap.get(item.name);

    if (!exist) {
      nameMap.set(item.name, {
        count: 1
      });
    } else {
      item.name += '-' + exist.count++;
    }

    return item;
  });
}

function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
    for (var i = 0; i < data.length && i < maxLoop; i++) {
      cb(data[i] ? data[i][0] : null, i);
    }
  } else {
    var value0 = data[0] || [];

    for (var i = 0; i < value0.length && i < maxLoop; i++) {
      cb(value0[i], i);
    }
  }
}

function shouldRetrieveDataByName(source) {
  var sourceFormat = source.sourceFormat;
  return sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS;
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var _a, _b, _c; // TODO
var providerMethods;
var mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */

var DefaultDataProvider =
/** @class */
function () {
  function DefaultDataProvider(sourceParam, dimSize) {
    // let source: Source;
    var source = !isSourceInstance(sourceParam) ? createSourceFromSeriesDataOption(sourceParam) : sourceParam; // declare source is Source;

    this._source = source;
    var data = this._data = source.data; // Typed array. TODO IE10+?

    if (source.sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
      if (process.env.NODE_ENV !== 'production') {
        if (dimSize == null) {
          throw new Error('Typed array data must specify dimension size');
        }
      }

      this._offset = 0;
      this._dimSize = dimSize;
      this._data = data;
    }

    mountMethods(this, data, source);
  }

  DefaultDataProvider.prototype.getSource = function () {
    return this._source;
  };

  DefaultDataProvider.prototype.count = function () {
    return 0;
  };

  DefaultDataProvider.prototype.getItem = function (idx, out) {
    return;
  };

  DefaultDataProvider.prototype.appendData = function (newData) {};

  DefaultDataProvider.prototype.clean = function () {};

  DefaultDataProvider.protoInitialize = function () {
    // PENDING: To avoid potential incompat (e.g., prototype
    // is visited somewhere), still init them on prototype.
    var proto = DefaultDataProvider.prototype;
    proto.pure = false;
    proto.persistent = true;
  }();

  DefaultDataProvider.internalField = function () {
    var _a;

    mountMethods = function (provider, data, source) {
      var sourceFormat = source.sourceFormat;
      var seriesLayoutBy = source.seriesLayoutBy;
      var startIndex = source.startIndex;
      var dimsDef = source.dimensionsDefine;
      var methods = providerMethods[getMethodMapKey(sourceFormat, seriesLayoutBy)];

      if (process.env.NODE_ENV !== 'production') {
        assert(methods, 'Invalide sourceFormat: ' + sourceFormat);
      }

      extend(provider, methods);

      if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
        provider.getItem = getItemForTypedArray;
        provider.count = countForTypedArray;
        provider.fillStorage = fillStorageForTypedArray;
      } else {
        var rawItemGetter = getRawSourceItemGetter(sourceFormat, seriesLayoutBy);
        provider.getItem = bind(rawItemGetter, null, data, startIndex, dimsDef);
        var rawCounter = getRawSourceDataCounter(sourceFormat, seriesLayoutBy);
        provider.count = bind(rawCounter, null, data, startIndex, dimsDef);
      }
    };

    var getItemForTypedArray = function (idx, out) {
      idx = idx - this._offset;
      out = out || [];
      var data = this._data;
      var dimSize = this._dimSize;
      var offset = dimSize * idx;

      for (var i = 0; i < dimSize; i++) {
        out[i] = data[offset + i];
      }

      return out;
    };

    var fillStorageForTypedArray = function (start, end, storage, extent) {
      var data = this._data;
      var dimSize = this._dimSize;

      for (var dim = 0; dim < dimSize; dim++) {
        var dimExtent = extent[dim];
        var min = dimExtent[0] == null ? Infinity : dimExtent[0];
        var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
        var count = end - start;
        var arr = storage[dim];

        for (var i = 0; i < count; i++) {
          // appendData with TypedArray will always do replace in provider.
          var val = data[i * dimSize + dim];
          arr[start + i] = val;
          val < min && (min = val);
          val > max && (max = val);
        }

        dimExtent[0] = min;
        dimExtent[1] = max;
      }
    };

    var countForTypedArray = function () {
      return this._data ? this._data.length / this._dimSize : 0;
    };

    providerMethods = (_a = {}, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = {
      pure: true,
      appendData: appendDataSimply
    }, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = {
      pure: true,
      appendData: function () {
        throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
      }
    }, _a[SOURCE_FORMAT_OBJECT_ROWS] = {
      pure: true,
      appendData: appendDataSimply
    }, _a[SOURCE_FORMAT_KEYED_COLUMNS] = {
      pure: true,
      appendData: function (newData) {
        var data = this._data;
        each(newData, function (newCol, key) {
          var oldCol = data[key] || (data[key] = []);

          for (var i = 0; i < (newCol || []).length; i++) {
            oldCol.push(newCol[i]);
          }
        });
      }
    }, _a[SOURCE_FORMAT_ORIGINAL] = {
      appendData: appendDataSimply
    }, _a[SOURCE_FORMAT_TYPED_ARRAY] = {
      persistent: false,
      pure: true,
      appendData: function (newData) {
        if (process.env.NODE_ENV !== 'production') {
          assert(isTypedArray$1(newData), 'Added data must be TypedArray if data in initialization is TypedArray');
        }

        this._data = newData;
      },
      // Clean self if data is already used.
      clean: function () {
        // PENDING
        this._offset += this.count();
        this._data = null;
      }
    }, _a);

    function appendDataSimply(newData) {
      for (var i = 0; i < newData.length; i++) {
        this._data.push(newData[i]);
      }
    }
  }();

  return DefaultDataProvider;
}();

var getItemSimply = function (rawData, startIndex, dimsDef, idx) {
  return rawData[idx];
};

var rawSourceItemGetterMap = (_a = {}, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = function (rawData, startIndex, dimsDef, idx) {
  return rawData[idx + startIndex];
}, _a[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = function (rawData, startIndex, dimsDef, idx, out) {
  idx += startIndex;
  var item = out || [];
  var data = rawData;

  for (var i = 0; i < data.length; i++) {
    var row = data[i];
    item[i] = row ? row[idx] : null;
  }

  return item;
}, _a[SOURCE_FORMAT_OBJECT_ROWS] = getItemSimply, _a[SOURCE_FORMAT_KEYED_COLUMNS] = function (rawData, startIndex, dimsDef, idx, out) {
  var item = out || [];

  for (var i = 0; i < dimsDef.length; i++) {
    var dimName = dimsDef[i].name;

    if (process.env.NODE_ENV !== 'production') {
      if (dimName == null) {
        throw new Error();
      }
    }

    var col = rawData[dimName];
    item[i] = col ? col[idx] : null;
  }

  return item;
}, _a[SOURCE_FORMAT_ORIGINAL] = getItemSimply, _a);
function getRawSourceItemGetter(sourceFormat, seriesLayoutBy) {
  var method = rawSourceItemGetterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];

  if (process.env.NODE_ENV !== 'production') {
    assert(method, 'Do not support get item on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
  }

  return method;
}

var countSimply = function (rawData, startIndex, dimsDef) {
  return rawData.length;
};

var rawSourceDataCounterMap = (_b = {}, _b[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_COLUMN] = function (rawData, startIndex, dimsDef) {
  return Math.max(0, rawData.length - startIndex);
}, _b[SOURCE_FORMAT_ARRAY_ROWS + '_' + SERIES_LAYOUT_BY_ROW] = function (rawData, startIndex, dimsDef) {
  var row = rawData[0];
  return row ? Math.max(0, row.length - startIndex) : 0;
}, _b[SOURCE_FORMAT_OBJECT_ROWS] = countSimply, _b[SOURCE_FORMAT_KEYED_COLUMNS] = function (rawData, startIndex, dimsDef) {
  var dimName = dimsDef[0].name;

  if (process.env.NODE_ENV !== 'production') {
    if (dimName == null) {
      throw new Error();
    }
  }

  var col = rawData[dimName];
  return col ? col.length : 0;
}, _b[SOURCE_FORMAT_ORIGINAL] = countSimply, _b);
function getRawSourceDataCounter(sourceFormat, seriesLayoutBy) {
  var method = rawSourceDataCounterMap[getMethodMapKey(sourceFormat, seriesLayoutBy)];

  if (process.env.NODE_ENV !== 'production') {
    assert(method, 'Do not support count on "' + sourceFormat + '", "' + seriesLayoutBy + '".');
  }

  return method;
}

var getRawValueSimply = function (dataItem, dimIndex, property) {
  return dataItem[dimIndex];
};

var rawSourceValueGetterMap = (_c = {}, _c[SOURCE_FORMAT_ARRAY_ROWS] = getRawValueSimply, _c[SOURCE_FORMAT_OBJECT_ROWS] = function (dataItem, dimIndex, property) {
  return dataItem[property];
}, _c[SOURCE_FORMAT_KEYED_COLUMNS] = getRawValueSimply, _c[SOURCE_FORMAT_ORIGINAL] = function (dataItem, dimIndex, property) {
  // FIXME: In some case (markpoint in geo (geo-map.html)),
  // dataItem is {coord: [...]}
  var value = getDataItemValue(dataItem);
  return !(value instanceof Array) ? value : value[dimIndex];
}, _c[SOURCE_FORMAT_TYPED_ARRAY] = getRawValueSimply, _c);
function getRawSourceValueGetter(sourceFormat) {
  var method = rawSourceValueGetterMap[sourceFormat];

  if (process.env.NODE_ENV !== 'production') {
    assert(method, 'Do not support get value on "' + sourceFormat + '".');
  }

  return method;
}

function getMethodMapKey(sourceFormat, seriesLayoutBy) {
  return sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
// Consider persistent.
// Caution: why use raw value to display on label or tooltip?
// A reason is to avoid format. For example time value we do not know
// how to format is expected. More over, if stack is used, calculated
// value may be 0.91000000001, which have brings trouble to display.
// TODO: consider how to treat null/undefined/NaN when display?


function retrieveRawValue(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
  if (!data) {
    return;
  } // Consider data may be not persistent.


  var dataItem = data.getRawDataItem(dataIndex);

  if (dataItem == null) {
    return;
  }

  var store = data.getStore();
  var sourceFormat = store.getSource().sourceFormat;

  if (dim != null) {
    var dimIndex = data.getDimensionIndex(dim);
    var property = store.getDimensionProperty(dimIndex);
    return getRawSourceValueGetter(sourceFormat)(dataItem, dimIndex, property);
  } else {
    var result = dataItem;

    if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
      result = getDataItemValue(dataItem);
    }

    return result;
  }
}

var DIMENSION_LABEL_REG = /\{@(.+?)\}/g;

var DataFormatMixin =
/** @class */
function () {
  function DataFormatMixin() {}
  /**
   * Get params for formatter
   */


  DataFormatMixin.prototype.getDataParams = function (dataIndex, dataType) {
    var data = this.getData(dataType);
    var rawValue = this.getRawValue(dataIndex, dataType);
    var rawDataIndex = data.getRawIndex(dataIndex);
    var name = data.getName(dataIndex);
    var itemOpt = data.getRawDataItem(dataIndex);
    var style = data.getItemVisual(dataIndex, 'style');
    var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
    var borderColor = style && style.stroke;
    var mainType = this.mainType;
    var isSeries = mainType === 'series';
    var userOutput = data.userOutput && data.userOutput.get();
    return {
      componentType: mainType,
      componentSubType: this.subType,
      componentIndex: this.componentIndex,
      seriesType: isSeries ? this.subType : null,
      seriesIndex: this.seriesIndex,
      seriesId: isSeries ? this.id : null,
      seriesName: isSeries ? this.name : null,
      name: name,
      dataIndex: rawDataIndex,
      data: itemOpt,
      dataType: dataType,
      value: rawValue,
      color: color,
      borderColor: borderColor,
      dimensionNames: userOutput ? userOutput.fullDimensions : null,
      encode: userOutput ? userOutput.encode : null,
      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
      $vars: ['seriesName', 'name', 'value']
    };
  };
  /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */


  DataFormatMixin.prototype.getFormattedLabel = function (dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
    status = status || 'normal';
    var data = this.getData(dataType);
    var params = this.getDataParams(dataIndex, dataType);

    if (extendParams) {
      params.value = extendParams.interpolatedValue;
    }

    if (labelDimIndex != null && isArray$1(params.value)) {
      params.value = params.value[labelDimIndex];
    }

    if (!formatter) {
      var itemModel = data.getItemModel(dataIndex); // @ts-ignore

      formatter = itemModel.get(status === 'normal' ? ['label', 'formatter'] : [status, 'label', 'formatter']);
    }

    if (isFunction$3(formatter)) {
      params.status = status;
      params.dimensionIndex = labelDimIndex;
      return formatter(params);
    } else if (isString(formatter)) {
      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
      // Do not support '}' in dim name util have to.

      return str.replace(DIMENSION_LABEL_REG, function (origin, dimStr) {
        var len = dimStr.length;
        var dimLoose = dimStr;

        if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') {
          dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0

          if (process.env.NODE_ENV !== 'production') {
            if (isNaN(dimLoose)) {
              error("Invalide label formatter: @" + dimStr + ", only support @[0], @[1], @[2], ...");
            }
          }
        }

        var val = retrieveRawValue(data, dataIndex, dimLoose);

        if (extendParams && isArray$1(extendParams.interpolatedValue)) {
          var dimIndex = data.getDimensionIndex(dimLoose);

          if (dimIndex >= 0) {
            val = extendParams.interpolatedValue[dimIndex];
          }
        }

        return val != null ? val + '' : '';
      });
    }
  };
  /**
   * Get raw value in option
   */


  DataFormatMixin.prototype.getRawValue = function (idx, dataType) {
    return retrieveRawValue(this.getData(dataType), idx);
  };
  /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */


  DataFormatMixin.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    // Empty function
    return;
  };

  return DataFormatMixin;
}();
// but guess little chance has been used outside. Do we need to backward
// compat it?
// type TooltipFormatResultLegacyObject = {
//     // `html` means the markup language text, either in 'html' or 'richText'.
//     // The name `html` is not appropriate because in 'richText' it is not a HTML
//     // string. But still support it for backward compatibility.
//     html: string;
//     markers: Dictionary<ColorString>;
// };

/**
 * For backward compat, normalize the return from `formatTooltip`.
 */

function normalizeTooltipFormatResult(result) {
  var markupText; // let markers: Dictionary<ColorString>;

  var markupFragment;

  if (isObject$2(result)) {
    if (result.type) {
      markupFragment = result;
    } else {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('The return type of `formatTooltip` is not supported: ' + makePrintable(result));
      }
    } // else {
    //     markupText = (result as TooltipFormatResultLegacyObject).html;
    //     markers = (result as TooltipFormatResultLegacyObject).markers;
    //     if (markersExisting) {
    //         markers = zrUtil.merge(markersExisting, markers);
    //     }
    // }

  } else {
    markupText = result;
  }

  return {
    text: markupText,
    // markers: markers || markersExisting,
    frag: markupFragment
  };
}

/**
 * @param {Object} define
 * @return See the return of `createTask`.
 */

function createTask(define) {
  return new Task$1(define);
}

var Task$1 =
/** @class */
function () {
  function Task(define) {
    define = define || {};
    this._reset = define.reset;
    this._plan = define.plan;
    this._count = define.count;
    this._onDirty = define.onDirty;
    this._dirty = true;
  }
  /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */


  Task.prototype.perform = function (performArgs) {
    var upTask = this._upstream;
    var skip = performArgs && performArgs.skip; // TODO some refactor.
    // Pull data. Must pull data each time, because context.data
    // may be updated by Series.setData.

    if (this._dirty && upTask) {
      var context = this.context;
      context.data = context.outputData = upTask.context.outputData;
    }

    if (this.__pipeline) {
      this.__pipeline.currentTask = this;
    }

    var planResult;

    if (this._plan && !skip) {
      planResult = this._plan(this.context);
    } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
    // elements uniformed distributed when progress, especially when moving or zooming.


    var lastModBy = normalizeModBy(this._modBy);
    var lastModDataCount = this._modDataCount || 0;
    var modBy = normalizeModBy(performArgs && performArgs.modBy);
    var modDataCount = performArgs && performArgs.modDataCount || 0;

    if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
      planResult = 'reset';
    }

    function normalizeModBy(val) {
      !(val >= 1) && (val = 1); // jshint ignore:line

      return val;
    }

    var forceFirstProgress;

    if (this._dirty || planResult === 'reset') {
      this._dirty = false;
      forceFirstProgress = this._doReset(skip);
    }

    this._modBy = modBy;
    this._modDataCount = modDataCount;
    var step = performArgs && performArgs.step;

    if (upTask) {
      if (process.env.NODE_ENV !== 'production') {
        assert(upTask._outputDueEnd != null);
      }

      this._dueEnd = upTask._outputDueEnd;
    } // DataTask or overallTask
    else {
        if (process.env.NODE_ENV !== 'production') {
          assert(!this._progress || this._count);
        }

        this._dueEnd = this._count ? this._count(this.context) : Infinity;
      } // Note: Stubs, that its host overall task let it has progress, has progress.
    // If no progress, pass index from upstream to downstream each time plan called.


    if (this._progress) {
      var start = this._dueIndex;
      var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);

      if (!skip && (forceFirstProgress || start < end)) {
        var progress = this._progress;

        if (isArray$1(progress)) {
          for (var i = 0; i < progress.length; i++) {
            this._doProgress(progress[i], start, end, modBy, modDataCount);
          }
        } else {
          this._doProgress(progress, start, end, modBy, modDataCount);
        }
      }

      this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
      // input data is the same, so use `dueIndex` as `outputDueEnd`.

      var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;

      if (process.env.NODE_ENV !== 'production') {
        // ??? Can not rollback.
        assert(outputDueEnd >= this._outputDueEnd);
      }

      this._outputDueEnd = outputDueEnd;
    } else {
      // (1) Some overall task has no progress.
      // (2) Stubs, that its host overall task do not let it has progress, has no progress.
      // This should always be performed so it can be passed to downstream.
      this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
    }

    return this.unfinished();
  };

  Task.prototype.dirty = function () {
    this._dirty = true;
    this._onDirty && this._onDirty(this.context);
  };

  Task.prototype._doProgress = function (progress, start, end, modBy, modDataCount) {
    iterator.reset(start, end, modBy, modDataCount);
    this._callingProgress = progress;

    this._callingProgress({
      start: start,
      end: end,
      count: end - start,
      next: iterator.next
    }, this.context);
  };

  Task.prototype._doReset = function (skip) {
    this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
    this._settedOutputEnd = null;
    var progress;
    var forceFirstProgress;

    if (!skip && this._reset) {
      progress = this._reset(this.context);

      if (progress && progress.progress) {
        forceFirstProgress = progress.forceFirstProgress;
        progress = progress.progress;
      } // To simplify no progress checking, array must has item.


      if (isArray$1(progress) && !progress.length) {
        progress = null;
      }
    }

    this._progress = progress;
    this._modBy = this._modDataCount = null;
    var downstream = this._downstream;
    downstream && downstream.dirty();
    return forceFirstProgress;
  };

  Task.prototype.unfinished = function () {
    return this._progress && this._dueIndex < this._dueEnd;
  };
  /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */


  Task.prototype.pipe = function (downTask) {
    if (process.env.NODE_ENV !== 'production') {
      assert(downTask && !downTask._disposed && downTask !== this);
    } // If already downstream, do not dirty downTask.


    if (this._downstream !== downTask || this._dirty) {
      this._downstream = downTask;
      downTask._upstream = this;
      downTask.dirty();
    }
  };

  Task.prototype.dispose = function () {
    if (this._disposed) {
      return;
    }

    this._upstream && (this._upstream._downstream = null);
    this._downstream && (this._downstream._upstream = null);
    this._dirty = false;
    this._disposed = true;
  };

  Task.prototype.getUpstream = function () {
    return this._upstream;
  };

  Task.prototype.getDownstream = function () {
    return this._downstream;
  };

  Task.prototype.setOutputEnd = function (end) {
    // This only happens in dataTask, dataZoom, map, currently.
    // where dataZoom do not set end each time, but only set
    // when reset. So we should record the set end, in case
    // that the stub of dataZoom perform again and earse the
    // set end by upstream.
    this._outputDueEnd = this._settedOutputEnd = end;
  };

  return Task;
}();

var iterator = function () {
  var end;
  var current;
  var modBy;
  var modDataCount;
  var winCount;
  var it = {
    reset: function (s, e, sStep, sCount) {
      current = s;
      end = e;
      modBy = sStep;
      modDataCount = sCount;
      winCount = Math.ceil(modDataCount / modBy);
      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
    }
  };
  return it;

  function sequentialNext() {
    return current < end ? current++ : null;
  }

  function modNext() {
    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
    // Use normal linear rendering mode.
    : current;
    current++;
    return result;
  }
}(); // -----------------------------------------------------------------------------
// For stream debug (Should be commented out after used!)
// @usage: printTask(this, 'begin');
// @usage: printTask(this, null, {someExtraProp});
// @usage: Use `__idxInPipeline` as conditional breakpiont.
//
// window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
//     window.ecTaskUID == null && (window.ecTaskUID = 0);
//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
//     let props = [];
//     if (task.__pipeline) {
//         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
//         props.push({text: '__idxInPipeline/total', value: val});
//     } else {
//         let stubCount = 0;
//         task.agentStubMap.each(() => stubCount++);
//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
//     }
//     props.push({text: 'uid', value: task.uidDebug});
//     if (task.__pipeline) {
//         props.push({text: 'pipelineId', value: task.__pipeline.id});
//         task.agent && props.push(
//             {text: 'stubFor', value: task.agent.uidDebug}
//         );
//     }
//     props.push(
//         {text: 'dirty', value: task._dirty},
//         {text: 'dueIndex', value: task._dueIndex},
//         {text: 'dueEnd', value: task._dueEnd},
//         {text: 'outputDueEnd', value: task._outputDueEnd}
//     );
//     if (extra) {
//         Object.keys(extra).forEach(key => {
//             props.push({text: key, value: extra[key]});
//         });
//     }
//     let args = ['color: blue'];
//     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
//         args.push('color: green', 'color: red'),
//         `${item.text}: %c${item.value}`
//     )).join('%c, ');
//     console.log.apply(console, [msg].concat(args));
//     // console.log(this);
// };
// window.printPipeline = function (task: any, prefix: string) {
//     const pipeline = task.__pipeline;
//     let currTask = pipeline.head;
//     while (currTask) {
//         window.printTask(currTask, prefix);
//         currTask = currTask._downstream;
//     }
// };
// window.showChain = function (chainHeadTask) {
//     var chain = [];
//     var task = chainHeadTask;
//     while (task) {
//         chain.push({
//             task: task,
//             up: task._upstream,
//             down: task._downstream,
//             idxInPipeline: task.__idxInPipeline
//         });
//         task = task._downstream;
//     }
//     return chain;
// };
// window.findTaskInChain = function (task, chainHeadTask) {
//     let chain = window.showChain(chainHeadTask);
//     let result = [];
//     for (let i = 0; i < chain.length; i++) {
//         let chainItem = chain[i];
//         if (chainItem.task === task) {
//             result.push(i);
//         }
//     }
//     return result;
// };
// window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
//     let chainA = window.showChain(chainHeadTaskA);
//     for (let i = 0; i < chainA.length; i++) {
//         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
//     }
// };

/**
 * Convert raw the value in to inner value in List.
 *
 * [Performance sensitive]
 *
 * [Caution]: this is the key logic of user value parser.
 * For backward compatibility, do not modify it until you have to!
 */

function parseDataValue(value, // For high performance, do not omit the second param.
opt) {
  // Performance sensitive.
  var dimType = opt && opt.type;

  if (dimType === 'ordinal') {
    // If given value is a category string
    return value;
  }

  if (dimType === 'time' // spead up when using timestamp
  && !isNumber$1(value) && value != null && value !== '-') {
    value = +parseDate(value);
  } // dimType defaults 'number'.
  // If dimType is not ordinal and value is null or undefined or NaN or '-',
  // parse to NaN.
  // number-like string (like ' 123 ') can be converted to a number.
  // where null/undefined or other string will be converted to NaN.


  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
  // If object, also parse to NaN
  : +value;
}
var valueParserMap = createHashMap({
  'number': function (val) {
    // Do not use `numericToNumber` here. We have `numericToNumber` by default.
    // Here the number parser can have loose rule:
    // enable to cut suffix: "120px" => 120, "14%" => 14.
    return parseFloat(val);
  },
  'time': function (val) {
    // return timestamp.
    return +parseDate(val);
  },
  'trim': function (val) {
    return isString(val) ? trim(val) : val;
  }
});
function getRawValueParser(type) {
  return valueParserMap.get(type);
}
var ORDER_COMPARISON_OP_MAP = {
  lt: function (lval, rval) {
    return lval < rval;
  },
  lte: function (lval, rval) {
    return lval <= rval;
  },
  gt: function (lval, rval) {
    return lval > rval;
  },
  gte: function (lval, rval) {
    return lval >= rval;
  }
};

var FilterOrderComparator =
/** @class */
function () {
  function FilterOrderComparator(op, rval) {
    if (!isNumber$1(rval)) {
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'rvalue of "<", ">", "<=", ">=" can only be number in filter.';
      }

      throwError(errMsg);
    }

    this._opFn = ORDER_COMPARISON_OP_MAP[op];
    this._rvalFloat = numericToNumber(rval);
  } // Performance sensitive.


  FilterOrderComparator.prototype.evaluate = function (lval) {
    // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
    return isNumber$1(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn(numericToNumber(lval), this._rvalFloat);
  };

  return FilterOrderComparator;
}();

var SortOrderComparator =
/** @class */
function () {
  /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */
  function SortOrderComparator(order, incomparable) {
    var isDesc = order === 'desc';
    this._resultLT = isDesc ? 1 : -1;

    if (incomparable == null) {
      incomparable = isDesc ? 'min' : 'max';
    }

    this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
  } // See [SORT_COMPARISON_RULE].
  // Performance sensitive.


  SortOrderComparator.prototype.evaluate = function (lval, rval) {
    // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
    var lvalFloat = isNumber$1(lval) ? lval : numericToNumber(lval);
    var rvalFloat = isNumber$1(rval) ? rval : numericToNumber(rval);
    var lvalNotNumeric = isNaN(lvalFloat);
    var rvalNotNumeric = isNaN(rvalFloat);

    if (lvalNotNumeric) {
      lvalFloat = this._incomparable;
    }

    if (rvalNotNumeric) {
      rvalFloat = this._incomparable;
    }

    if (lvalNotNumeric && rvalNotNumeric) {
      var lvalIsStr = isString(lval);
      var rvalIsStr = isString(rval);

      if (lvalIsStr) {
        lvalFloat = rvalIsStr ? lval : 0;
      }

      if (rvalIsStr) {
        rvalFloat = lvalIsStr ? rval : 0;
      }
    }

    return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
  };

  return SortOrderComparator;
}();

var FilterEqualityComparator =
/** @class */
function () {
  function FilterEqualityComparator(isEq, rval) {
    this._rval = rval;
    this._isEQ = isEq;
    this._rvalTypeof = typeof rval;
    this._rvalFloat = numericToNumber(rval);
  } // Performance sensitive.


  FilterEqualityComparator.prototype.evaluate = function (lval) {
    var eqResult = lval === this._rval;

    if (!eqResult) {
      var lvalTypeof = typeof lval;

      if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) {
        eqResult = numericToNumber(lval) === this._rvalFloat;
      }
    }

    return this._isEQ ? eqResult : !eqResult;
  };

  return FilterEqualityComparator;
}();
/**
 * [FILTER_COMPARISON_RULE]
 * `lt`|`lte`|`gt`|`gte`:
 * + rval must be a number. And lval will be converted to number (`numericToNumber`) to compare.
 * `eq`:
 * + If same type, compare with `===`.
 * + If there is one number, convert to number (`numericToNumber`) to compare.
 * + Else return `false`.
 * `ne`:
 * + Not `eq`.
 *
 *
 * [SORT_COMPARISON_RULE]
 * All the values are grouped into three categories:
 * + "numeric" (number and numeric string)
 * + "non-numeric-string" (string that excluding numeric string)
 * + "others"
 * "numeric" vs "numeric": values are ordered by number order.
 * "non-numeric-string" vs "non-numeric-string": values are ordered by ES spec (#sec-abstract-relational-comparison).
 * "others" vs "others": do not change order (always return 0).
 * "numeric" vs "non-numeric-string": "non-numeric-string" is treated as "incomparable".
 * "number" vs "others": "others" is treated as "incomparable".
 * "non-numeric-string" vs "others": "others" is treated as "incomparable".
 * "incomparable" will be seen as -Infinity or Infinity (depends on the settings).
 * MEMO:
 *   Non-numeric string sort makes sense when we need to put the items with the same tag together.
 *   But if we support string sort, we still need to avoid the misleading like `'2' > '12'`,
 *   So we treat "numeric-string" sorted by number order rather than string comparison.
 *
 *
 * [CHECK_LIST_OF_THE_RULE_DESIGN]
 * + Do not support string comparison until required. And also need to
 *   avoid the misleading of "2" > "12".
 * + Should avoid the misleading case:
 *   `" 22 " gte "22"` is `true` but `" 22 " eq "22"` is `false`.
 * + JS bad case should be avoided: null <= 0, [] <= 0, ' ' <= 0, ...
 * + Only "numeric" can be converted to comparable number, otherwise converted to NaN.
 *   See `util/number.ts#numericToNumber`.
 *
 * @return If `op` is not `RelationalOperator`, return null;
 */


function createFilterComparator(op, rval) {
  return op === 'eq' || op === 'ne' ? new FilterEqualityComparator(op === 'eq', rval) : hasOwn(ORDER_COMPARISON_OP_MAP, op) ? new FilterOrderComparator(op, rval) : null;
}

/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */

var ExternalSource =
/** @class */
function () {
  function ExternalSource() {}

  ExternalSource.prototype.getRawData = function () {
    // Only built-in transform available.
    throw new Error('not supported');
  };

  ExternalSource.prototype.getRawDataItem = function (dataIndex) {
    // Only built-in transform available.
    throw new Error('not supported');
  };

  ExternalSource.prototype.cloneRawData = function () {
    return;
  };
  /**
   * @return If dimension not found, return null/undefined.
   */


  ExternalSource.prototype.getDimensionInfo = function (dim) {
    return;
  };
  /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */


  ExternalSource.prototype.cloneAllDimensionInfo = function () {
    return;
  };

  ExternalSource.prototype.count = function () {
    return;
  };
  /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */


  ExternalSource.prototype.retrieveValue = function (dataIndex, dimIndex) {
    return;
  };

  ExternalSource.prototype.retrieveValueFromItem = function (dataItem, dimIndex) {
    return;
  };

  ExternalSource.prototype.convertValue = function (rawVal, dimInfo) {
    return parseDataValue(rawVal, dimInfo);
  };

  return ExternalSource;
}();

function createExternalSource(internalSource, externalTransform) {
  var extSource = new ExternalSource();
  var data = internalSource.data;
  var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
  var sourceHeaderCount = internalSource.startIndex;
  var errMsg = '';

  if (internalSource.seriesLayoutBy !== SERIES_LAYOUT_BY_COLUMN) {
    // For the logic simplicity in transformer, only 'culumn' is
    // supported in data transform. Otherwise, the `dimensionsDefine`
    // might be detected by 'row', which probably confuses users.
    if (process.env.NODE_ENV !== 'production') {
      errMsg = '`seriesLayoutBy` of upstream dataset can only be "column" in data transform.';
    }

    throwError(errMsg);
  } // [MEMO]
  // Create a new dimensions structure for exposing.
  // Do not expose all dimension info to users directly.
  // Because the dimension is probably auto detected from data and not might reliable.
  // Should not lead the transformers to think that is reliable and return it.
  // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.


  var dimensions = [];
  var dimsByName = {};
  var dimsDef = internalSource.dimensionsDefine;

  if (dimsDef) {
    each(dimsDef, function (dimDef, idx) {
      var name = dimDef.name;
      var dimDefExt = {
        index: idx,
        name: name,
        displayName: dimDef.displayName
      };
      dimensions.push(dimDefExt); // Users probably do not specify dimension name. For simplicity, data transform
      // does not generate dimension name.

      if (name != null) {
        // Dimension name should not be duplicated.
        // For simplicity, data transform forbids name duplication, do not generate
        // new name like module `completeDimensions.ts` did, but just tell users.
        var errMsg_1 = '';

        if (hasOwn(dimsByName, name)) {
          if (process.env.NODE_ENV !== 'production') {
            errMsg_1 = 'dimension name "' + name + '" duplicated.';
          }

          throwError(errMsg_1);
        }

        dimsByName[name] = dimDefExt;
      }
    });
  } // If dimension definitions are not defined and can not be detected.
  // e.g., pure data `[[11, 22], ...]`.
  else {
      for (var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++) {
        // Do not generete name or anything others. The consequence process in
        // `transform` or `series` probably have there own name generation strategry.
        dimensions.push({
          index: i
        });
      }
    } // Implement public methods:


  var rawItemGetter = getRawSourceItemGetter(sourceFormat, SERIES_LAYOUT_BY_COLUMN);

  if (externalTransform.__isBuiltIn) {
    extSource.getRawDataItem = function (dataIndex) {
      return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
    };

    extSource.getRawData = bind(getRawData, null, internalSource);
  }

  extSource.cloneRawData = bind(cloneRawData, null, internalSource);
  var rawCounter = getRawSourceDataCounter(sourceFormat, SERIES_LAYOUT_BY_COLUMN);
  extSource.count = bind(rawCounter, null, data, sourceHeaderCount, dimensions);
  var rawValueGetter = getRawSourceValueGetter(sourceFormat);

  extSource.retrieveValue = function (dataIndex, dimIndex) {
    var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
    return retrieveValueFromItem(rawItem, dimIndex);
  };

  var retrieveValueFromItem = extSource.retrieveValueFromItem = function (dataItem, dimIndex) {
    if (dataItem == null) {
      return;
    }

    var dimDef = dimensions[dimIndex]; // When `dimIndex` is `null`, `rawValueGetter` return the whole item.

    if (dimDef) {
      return rawValueGetter(dataItem, dimIndex, dimDef.name);
    }
  };

  extSource.getDimensionInfo = bind(getDimensionInfo, null, dimensions, dimsByName);
  extSource.cloneAllDimensionInfo = bind(cloneAllDimensionInfo, null, dimensions);
  return extSource;
}

function getRawData(upstream) {
  var sourceFormat = upstream.sourceFormat;

  if (!isSupportedSourceFormat(sourceFormat)) {
    var errMsg = '';

    if (process.env.NODE_ENV !== 'production') {
      errMsg = '`getRawData` is not supported in source format ' + sourceFormat;
    }

    throwError(errMsg);
  }

  return upstream.data;
}

function cloneRawData(upstream) {
  var sourceFormat = upstream.sourceFormat;
  var data = upstream.data;

  if (!isSupportedSourceFormat(sourceFormat)) {
    var errMsg = '';

    if (process.env.NODE_ENV !== 'production') {
      errMsg = '`cloneRawData` is not supported in source format ' + sourceFormat;
    }

    throwError(errMsg);
  }

  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
    var result = [];

    for (var i = 0, len = data.length; i < len; i++) {
      // Not strictly clone for performance
      result.push(data[i].slice());
    }

    return result;
  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
    var result = [];

    for (var i = 0, len = data.length; i < len; i++) {
      // Not strictly clone for performance
      result.push(extend({}, data[i]));
    }

    return result;
  }
}

function getDimensionInfo(dimensions, dimsByName, dim) {
  if (dim == null) {
    return;
  } // Keep the same logic as `List::getDimension` did.


  if (isNumber$1(dim) // If being a number-like string but not being defined a dimension name.
  || !isNaN(dim) && !hasOwn(dimsByName, dim)) {
    return dimensions[dim];
  } else if (hasOwn(dimsByName, dim)) {
    return dimsByName[dim];
  }
}

function cloneAllDimensionInfo(dimensions) {
  return clone(dimensions);
}

var externalTransformMap = createHashMap();
function registerExternalTransform(externalTransform) {
  externalTransform = clone(externalTransform);
  var type = externalTransform.type;
  var errMsg = '';

  if (!type) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'Must have a `type` when `registerTransform`.';
    }

    throwError(errMsg);
  }

  var typeParsed = type.split(':');

  if (typeParsed.length !== 2) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'Name must include namespace like "ns:regression".';
    }

    throwError(errMsg);
  } // Namespace 'echarts:xxx' is official namespace, where the transforms should
  // be called directly via 'xxx' rather than 'echarts:xxx'.


  var isBuiltIn = false;

  if (typeParsed[0] === 'echarts') {
    type = typeParsed[1];
    isBuiltIn = true;
  }

  externalTransform.__isBuiltIn = isBuiltIn;
  externalTransformMap.set(type, externalTransform);
}
function applyDataTransform(rawTransOption, sourceList, infoForPrint) {
  var pipedTransOption = normalizeToArray(rawTransOption);
  var pipeLen = pipedTransOption.length;
  var errMsg = '';

  if (!pipeLen) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'If `transform` declared, it should at least contain one transform.';
    }

    throwError(errMsg);
  }

  for (var i = 0, len = pipeLen; i < len; i++) {
    var transOption = pipedTransOption[i];
    sourceList = applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i); // piped transform only support single input, except the fist one.
    // piped transform only support single output, except the last one.

    if (i !== len - 1) {
      sourceList.length = Math.max(sourceList.length, 1);
    }
  }

  return sourceList;
}

function applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
  var errMsg = '';

  if (!upSourceList.length) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'Must have at least one upstream dataset.';
    }

    throwError(errMsg);
  }

  if (!isObject$2(transOption)) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'transform declaration must be an object rather than ' + typeof transOption + '.';
    }

    throwError(errMsg);
  }

  var transType = transOption.type;
  var externalTransform = externalTransformMap.get(transType);

  if (!externalTransform) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = 'Can not find transform on type "' + transType + '".';
    }

    throwError(errMsg);
  } // Prepare source


  var extUpSourceList = map(upSourceList, function (upSource) {
    return createExternalSource(upSource, externalTransform);
  });
  var resultList = normalizeToArray(externalTransform.transform({
    upstream: extUpSourceList[0],
    upstreamList: extUpSourceList,
    config: clone(transOption.config)
  }));

  if (process.env.NODE_ENV !== 'production') {
    if (transOption.print) {
      var printStrArr = map(resultList, function (extSource) {
        var pipeIndexStr = pipeIndex != null ? ' === pipe index: ' + pipeIndex : '';
        return ['=== dataset index: ' + infoForPrint.datasetIndex + pipeIndexStr + ' ===', '- transform result data:', makePrintable(extSource.data), '- transform result dimensions:', makePrintable(extSource.dimensions)].join('\n');
      }).join('\n');
      log(printStrArr);
    }
  }

  return map(resultList, function (result, resultIndex) {
    var errMsg = '';

    if (!isObject$2(result)) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'A transform should not return some empty results.';
      }

      throwError(errMsg);
    }

    if (!result.data) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'Transform result data should be not be null or undefined';
      }

      throwError(errMsg);
    }

    var sourceFormat = detectSourceFormat(result.data);

    if (!isSupportedSourceFormat(sourceFormat)) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'Transform result data should be array rows or object rows.';
      }

      throwError(errMsg);
    }

    var resultMetaRawOption;
    var firstUpSource = upSourceList[0];
    /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */

    if (firstUpSource && resultIndex === 0 // If transformer returns `dimensions`, it means that the transformer has different
    // dimensions definitions. We do not inherit anything from upstream.
    && !result.dimensions) {
      var startIndex = firstUpSource.startIndex; // We copy the header of upstream to the result, because:
      // (1) The returned data always does not contain header line and can not be used
      // as dimension-detection. In this case we can not use "detected dimensions" of
      // upstream directly, because it might be detected based on different `seriesLayoutBy`.
      // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
      // So the original detected header should be add to the result, otherwise they can not be read.

      if (startIndex) {
        result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
      }

      resultMetaRawOption = {
        seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
        sourceHeader: startIndex,
        dimensions: firstUpSource.metaRawOption.dimensions
      };
    } else {
      resultMetaRawOption = {
        seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
        sourceHeader: 0,
        dimensions: result.dimensions
      };
    }

    return createSource(result.data, resultMetaRawOption, null);
  });
}

function isSupportedSourceFormat(sourceFormat) {
  return sourceFormat === SOURCE_FORMAT_ARRAY_ROWS || sourceFormat === SOURCE_FORMAT_OBJECT_ROWS;
}

var UNDEFINED = 'undefined';
/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
// Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
// different from the Ctor of typed array.

var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
var CtorFloat64Array = typeof Float64Array === UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */

var dataCtors = {
  'float': CtorFloat64Array,
  'int': CtorInt32Array,
  // Ordinal data type can be string or int
  'ordinal': Array,
  'number': Array,
  'time': CtorFloat64Array
};
var defaultDimValueGetters;

function getIndicesCtor(rawCount) {
  // The possible max value in this._indicies is always this._rawCount despite of filtering.
  return rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
}

function getInitialExtent() {
  return [Infinity, -Infinity];
}

function cloneChunk(originalChunk) {
  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.

  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}

function prepareStore(store, dimIdx, dimType, end, append) {
  var DataCtor = dataCtors[dimType || 'float'];

  if (append) {
    var oldStore = store[dimIdx];
    var oldLen = oldStore && oldStore.length;

    if (!(oldLen === end)) {
      var newStore = new DataCtor(end); // The cost of the copy is probably inconsiderable
      // within the initial chunkSize.

      for (var j = 0; j < oldLen; j++) {
        newStore[j] = oldStore[j];
      }

      store[dimIdx] = newStore;
    }
  } else {
    store[dimIdx] = new DataCtor(end);
  }
}
/**
 * Basically, DataStore API keep immutable.
 */

var DataStore =
/** @class */
function () {
  function DataStore() {
    this._chunks = []; // It will not be calculated util needed.

    this._rawExtent = [];
    this._extent = [];
    this._count = 0;
    this._rawCount = 0;
    this._calcDimNameToIdx = createHashMap();
  }
  /**
   * Initialize from data
   */


  DataStore.prototype.initData = function (provider, inputDimensions, dimValueGetter) {
    if (process.env.NODE_ENV !== 'production') {
      assert(isFunction$3(provider.getItem) && isFunction$3(provider.count), 'Invalid data provider.');
    }

    this._provider = provider; // Clear

    this._chunks = [];
    this._indices = null;
    this.getRawIndex = this._getRawIdxIdentity;
    var source = provider.getSource();
    var defaultGetter = this.defaultDimValueGetter = defaultDimValueGetters[source.sourceFormat]; // Default dim value getter

    this._dimValueGetter = dimValueGetter || defaultGetter; // Reset raw extent.

    this._rawExtent = [];
    var willRetrieveDataByName = shouldRetrieveDataByName(source);
    this._dimensions = map(inputDimensions, function (dim) {
      if (process.env.NODE_ENV !== 'production') {
        if (willRetrieveDataByName) {
          assert(dim.property != null);
        }
      }

      return {
        // Only pick these two props. Not leak other properties like orderMeta.
        type: dim.type,
        property: dim.property
      };
    });

    this._initDataFromProvider(0, provider.count());
  };

  DataStore.prototype.getProvider = function () {
    return this._provider;
  };
  /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */


  DataStore.prototype.getSource = function () {
    return this._provider.getSource();
  };
  /**
   * @caution Only used in dataStack.
   */


  DataStore.prototype.ensureCalculationDimension = function (dimName, type) {
    var calcDimNameToIdx = this._calcDimNameToIdx;
    var dimensions = this._dimensions;
    var calcDimIdx = calcDimNameToIdx.get(dimName);

    if (calcDimIdx != null) {
      if (dimensions[calcDimIdx].type === type) {
        return calcDimIdx;
      }
    } else {
      calcDimIdx = dimensions.length;
    }

    dimensions[calcDimIdx] = {
      type: type
    };
    calcDimNameToIdx.set(dimName, calcDimIdx);
    this._chunks[calcDimIdx] = new dataCtors[type || 'float'](this._rawCount);
    this._rawExtent[calcDimIdx] = getInitialExtent();
    return calcDimIdx;
  };

  DataStore.prototype.collectOrdinalMeta = function (dimIdx, ordinalMeta) {
    var chunk = this._chunks[dimIdx];
    var dim = this._dimensions[dimIdx];
    var rawExtents = this._rawExtent;
    var offset = dim.ordinalOffset || 0;
    var len = chunk.length;

    if (offset === 0) {
      // We need to reset the rawExtent if collect is from start.
      // Because this dimension may be guessed as number and calcuating a wrong extent.
      rawExtents[dimIdx] = getInitialExtent();
    }

    var dimRawExtent = rawExtents[dimIdx]; // Parse from previous data offset. len may be changed after appendData

    for (var i = offset; i < len; i++) {
      var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);

      if (!isNaN(val)) {
        dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
        dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
      }
    }

    dim.ordinalMeta = ordinalMeta;
    dim.ordinalOffset = len;
    dim.type = 'ordinal'; // Force to be ordinal
  };

  DataStore.prototype.getOrdinalMeta = function (dimIdx) {
    var dimInfo = this._dimensions[dimIdx];
    var ordinalMeta = dimInfo.ordinalMeta;
    return ordinalMeta;
  };

  DataStore.prototype.getDimensionProperty = function (dimIndex) {
    var item = this._dimensions[dimIndex];
    return item && item.property;
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */


  DataStore.prototype.appendData = function (data) {
    if (process.env.NODE_ENV !== 'production') {
      assert(!this._indices, 'appendData can only be called on raw data.');
    }

    var provider = this._provider;
    var start = this.count();
    provider.appendData(data);
    var end = provider.count();

    if (!provider.persistent) {
      end += start;
    }

    if (start < end) {
      this._initDataFromProvider(start, end, true);
    }

    return [start, end];
  };

  DataStore.prototype.appendValues = function (values, minFillLen) {
    var chunks = this._chunks;
    var dimensions = this._dimensions;
    var dimLen = dimensions.length;
    var rawExtent = this._rawExtent;
    var start = this.count();
    var end = start + Math.max(values.length, minFillLen || 0);

    for (var i = 0; i < dimLen; i++) {
      var dim = dimensions[i];
      prepareStore(chunks, i, dim.type, end, true);
    }

    var emptyDataItem = [];

    for (var idx = start; idx < end; idx++) {
      var sourceIdx = idx - start; // Store the data by dimensions

      for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
        var dim = dimensions[dimIdx];
        var val = defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
        chunks[dimIdx][idx] = val;
        var dimRawExtent = rawExtent[dimIdx];
        val < dimRawExtent[0] && (dimRawExtent[0] = val);
        val > dimRawExtent[1] && (dimRawExtent[1] = val);
      }
    }

    this._rawCount = this._count = end;
    return {
      start: start,
      end: end
    };
  };

  DataStore.prototype._initDataFromProvider = function (start, end, append) {
    var provider = this._provider;
    var chunks = this._chunks;
    var dimensions = this._dimensions;
    var dimLen = dimensions.length;
    var rawExtent = this._rawExtent;
    var dimNames = map(dimensions, function (dim) {
      return dim.property;
    });

    for (var i = 0; i < dimLen; i++) {
      var dim = dimensions[i];

      if (!rawExtent[i]) {
        rawExtent[i] = getInitialExtent();
      }

      prepareStore(chunks, i, dim.type, end, append);
    }

    if (provider.fillStorage) {
      provider.fillStorage(start, end, chunks, rawExtent);
    } else {
      var dataItem = [];

      for (var idx = start; idx < end; idx++) {
        // NOTICE: Try not to write things into dataItem
        dataItem = provider.getItem(idx, dataItem); // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // Store the data by dimensions

        for (var dimIdx = 0; dimIdx < dimLen; dimIdx++) {
          var dimStorage = chunks[dimIdx]; // PENDING NULL is empty or zero

          var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);

          dimStorage[idx] = val;
          var dimRawExtent = rawExtent[dimIdx];
          val < dimRawExtent[0] && (dimRawExtent[0] = val);
          val > dimRawExtent[1] && (dimRawExtent[1] = val);
        }
      }
    }

    if (!provider.persistent && provider.clean) {
      // Clean unused data if data source is typed array.
      provider.clean();
    }

    this._rawCount = this._count = end; // Reset data extent

    this._extent = [];
  };

  DataStore.prototype.count = function () {
    return this._count;
  };
  /**
   * Get value. Return NaN if idx is out of range.
   */


  DataStore.prototype.get = function (dim, idx) {
    if (!(idx >= 0 && idx < this._count)) {
      return NaN;
    }

    var dimStore = this._chunks[dim];
    return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
  };

  DataStore.prototype.getValues = function (dimensions, idx) {
    var values = [];
    var dimArr = [];

    if (idx == null) {
      idx = dimensions; // TODO get all from store?

      dimensions = []; // All dimensions

      for (var i = 0; i < this._dimensions.length; i++) {
        dimArr.push(i);
      }
    } else {
      dimArr = dimensions;
    }

    for (var i = 0, len = dimArr.length; i < len; i++) {
      values.push(this.get(dimArr[i], idx));
    }

    return values;
  };
  /**
   * @param dim concrete dim
   */


  DataStore.prototype.getByRawIndex = function (dim, rawIdx) {
    if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
      return NaN;
    }

    var dimStore = this._chunks[dim];
    return dimStore ? dimStore[rawIdx] : NaN;
  };
  /**
   * Get sum of data in one dimension
   */


  DataStore.prototype.getSum = function (dim) {
    var dimData = this._chunks[dim];
    var sum = 0;

    if (dimData) {
      for (var i = 0, len = this.count(); i < len; i++) {
        var value = this.get(dim, i);

        if (!isNaN(value)) {
          sum += value;
        }
      }
    }

    return sum;
  };
  /**
   * Get median of data in one dimension
   */


  DataStore.prototype.getMedian = function (dim) {
    var dimDataArray = []; // map all data of one dimension

    this.each([dim], function (val) {
      if (!isNaN(val)) {
        dimDataArray.push(val);
      }
    }); // TODO
    // Use quick select?

    var sortedDimDataArray = dimDataArray.sort(function (a, b) {
      return a - b;
    });
    var len = this.count(); // calculate median

    return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
  };
  /**
   * Retrieve the index with given raw data index.
   */


  DataStore.prototype.indexOfRawIndex = function (rawIndex) {
    if (rawIndex >= this._rawCount || rawIndex < 0) {
      return -1;
    }

    if (!this._indices) {
      return rawIndex;
    } // Indices are ascending


    var indices = this._indices; // If rawIndex === dataIndex

    var rawDataIndex = indices[rawIndex];

    if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
      return rawIndex;
    }

    var left = 0;
    var right = this._count - 1;

    while (left <= right) {
      var mid = (left + right) / 2 | 0;

      if (indices[mid] < rawIndex) {
        left = mid + 1;
      } else if (indices[mid] > rawIndex) {
        right = mid - 1;
      } else {
        return mid;
      }
    }

    return -1;
  };
  /**
   * Retrieve the index of nearest value.
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices have
   *         the same value, they are put to the result.
   */


  DataStore.prototype.indicesOfNearest = function (dim, value, maxDistance) {
    var chunks = this._chunks;
    var dimData = chunks[dim];
    var nearestIndices = [];

    if (!dimData) {
      return nearestIndices;
    }

    if (maxDistance == null) {
      maxDistance = Infinity;
    }

    var minDist = Infinity;
    var minDiff = -1;
    var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/SeriesData.js`.

    for (var i = 0, len = this.count(); i < len; i++) {
      var dataIndex = this.getRawIndex(i);
      var diff = value - dimData[dataIndex];
      var dist = Math.abs(diff);

      if (dist <= maxDistance) {
        // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
        // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
        // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
        // So we chose the one that `diff >= 0` in this csae.
        // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
        // should be push to `nearestIndices`.
        if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
          minDist = dist;
          minDiff = diff;
          nearestIndicesLen = 0;
        }

        if (diff === minDiff) {
          nearestIndices[nearestIndicesLen++] = i;
        }
      }
    }

    nearestIndices.length = nearestIndicesLen;
    return nearestIndices;
  };

  DataStore.prototype.getIndices = function () {
    var newIndices;
    var indices = this._indices;

    if (indices) {
      var Ctor = indices.constructor;
      var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.

      if (Ctor === Array) {
        newIndices = new Ctor(thisCount);

        for (var i = 0; i < thisCount; i++) {
          newIndices[i] = indices[i];
        }
      } else {
        newIndices = new Ctor(indices.buffer, 0, thisCount);
      }
    } else {
      var Ctor = getIndicesCtor(this._rawCount);
      newIndices = new Ctor(this.count());

      for (var i = 0; i < newIndices.length; i++) {
        newIndices[i] = i;
      }
    }

    return newIndices;
  };
  /**
   * Data filter.
   */


  DataStore.prototype.filter = function (dims, cb) {
    if (!this._count) {
      return this;
    }

    var newStore = this.clone();
    var count = newStore.count();
    var Ctor = getIndicesCtor(newStore._rawCount);
    var newIndices = new Ctor(count);
    var value = [];
    var dimSize = dims.length;
    var offset = 0;
    var dim0 = dims[0];
    var chunks = newStore._chunks;

    for (var i = 0; i < count; i++) {
      var keep = void 0;
      var rawIdx = newStore.getRawIndex(i); // Simple optimization

      if (dimSize === 0) {
        keep = cb(i);
      } else if (dimSize === 1) {
        var val = chunks[dim0][rawIdx];
        keep = cb(val, i);
      } else {
        var k = 0;

        for (; k < dimSize; k++) {
          value[k] = chunks[dims[k]][rawIdx];
        }

        value[k] = i;
        keep = cb.apply(null, value);
      }

      if (keep) {
        newIndices[offset++] = rawIdx;
      }
    } // Set indices after filtered.


    if (offset < count) {
      newStore._indices = newIndices;
    }

    newStore._count = offset; // Reset data extent

    newStore._extent = [];

    newStore._updateGetRawIdx();

    return newStore;
  };
  /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */


  DataStore.prototype.selectRange = function (range) {
    var newStore = this.clone();
    var len = newStore._count;

    if (!len) {
      return this;
    }

    var dims = keys$2(range);
    var dimSize = dims.length;

    if (!dimSize) {
      return this;
    }

    var originalCount = newStore.count();
    var Ctor = getIndicesCtor(newStore._rawCount);
    var newIndices = new Ctor(originalCount);
    var offset = 0;
    var dim0 = dims[0];
    var min = range[dim0][0];
    var max = range[dim0][1];
    var storeArr = newStore._chunks;
    var quickFinished = false;

    if (!newStore._indices) {
      // Extreme optimization for common case. About 2x faster in chrome.
      var idx = 0;

      if (dimSize === 1) {
        var dimStorage = storeArr[dims[0]];

        for (var i = 0; i < len; i++) {
          var val = dimStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
          // value indicates the line should be broken. But for the case like
          // scatter plot, a data item with empty value will not be rendered,
          // but the axis extent may be effected if some other dim of the data
          // item has value. Fortunately it is not a significant negative effect.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = idx;
          }

          idx++;
        }

        quickFinished = true;
      } else if (dimSize === 2) {
        var dimStorage = storeArr[dims[0]];
        var dimStorage2 = storeArr[dims[1]];
        var min2 = range[dims[1]][0];
        var max2 = range[dims[1]][1];

        for (var i = 0; i < len; i++) {
          var val = dimStorage[i];
          var val2 = dimStorage2[i]; // Do not filter NaN, see comment above.

          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
            newIndices[offset++] = idx;
          }

          idx++;
        }

        quickFinished = true;
      }
    }

    if (!quickFinished) {
      if (dimSize === 1) {
        for (var i = 0; i < originalCount; i++) {
          var rawIndex = newStore.getRawIndex(i);
          var val = storeArr[dims[0]][rawIndex]; // Do not filter NaN, see comment above.

          if (val >= min && val <= max || isNaN(val)) {
            newIndices[offset++] = rawIndex;
          }
        }
      } else {
        for (var i = 0; i < originalCount; i++) {
          var keep = true;
          var rawIndex = newStore.getRawIndex(i);

          for (var k = 0; k < dimSize; k++) {
            var dimk = dims[k];
            var val = storeArr[dimk][rawIndex]; // Do not filter NaN, see comment above.

            if (val < range[dimk][0] || val > range[dimk][1]) {
              keep = false;
            }
          }

          if (keep) {
            newIndices[offset++] = newStore.getRawIndex(i);
          }
        }
      }
    } // Set indices after filtered.


    if (offset < originalCount) {
      newStore._indices = newIndices;
    }

    newStore._count = offset; // Reset data extent

    newStore._extent = [];

    newStore._updateGetRawIdx();

    return newStore;
  }; // /**
  //  * Data mapping to a plain array
  //  */
  // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
  //     const result: any[] = [];
  //     this.each(dims, function () {
  //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
  //     });
  //     return result;
  // }

  /**
   * Data mapping to a new List with given dimensions
   */


  DataStore.prototype.map = function (dims, cb) {
    // TODO only clone picked chunks.
    var target = this.clone(dims);

    this._updateDims(target, dims, cb);

    return target;
  };
  /**
   * @caution Danger!! Only used in dataStack.
   */


  DataStore.prototype.modify = function (dims, cb) {
    this._updateDims(this, dims, cb);
  };

  DataStore.prototype._updateDims = function (target, dims, cb) {
    var targetChunks = target._chunks;
    var tmpRetValue = [];
    var dimSize = dims.length;
    var dataCount = target.count();
    var values = [];
    var rawExtent = target._rawExtent;

    for (var i = 0; i < dims.length; i++) {
      rawExtent[dims[i]] = getInitialExtent();
    }

    for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
      var rawIndex = target.getRawIndex(dataIndex);

      for (var k = 0; k < dimSize; k++) {
        values[k] = targetChunks[dims[k]][rawIndex];
      }

      values[dimSize] = dataIndex;
      var retValue = cb && cb.apply(null, values);

      if (retValue != null) {
        // a number or string (in oridinal dimension)?
        if (typeof retValue !== 'object') {
          tmpRetValue[0] = retValue;
          retValue = tmpRetValue;
        }

        for (var i = 0; i < retValue.length; i++) {
          var dim = dims[i];
          var val = retValue[i];
          var rawExtentOnDim = rawExtent[dim];
          var dimStore = targetChunks[dim];

          if (dimStore) {
            dimStore[rawIndex] = val;
          }

          if (val < rawExtentOnDim[0]) {
            rawExtentOnDim[0] = val;
          }

          if (val > rawExtentOnDim[1]) {
            rawExtentOnDim[1] = val;
          }
        }
      }
    }
  };
  /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */


  DataStore.prototype.lttbDownSample = function (valueDimension, rate) {
    var target = this.clone([valueDimension], true);
    var targetStorage = target._chunks;
    var dimStore = targetStorage[valueDimension];
    var len = this.count();
    var sampledIndex = 0;
    var frameSize = Math.floor(1 / rate);
    var currentRawIndex = this.getRawIndex(0);
    var maxArea;
    var area;
    var nextRawIndex;
    var newIndices = new (getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len)); // First frame use the first data.

    newIndices[sampledIndex++] = currentRawIndex;

    for (var i = 1; i < len - 1; i += frameSize) {
      var nextFrameStart = Math.min(i + frameSize, len - 1);
      var nextFrameEnd = Math.min(i + frameSize * 2, len);
      var avgX = (nextFrameEnd + nextFrameStart) / 2;
      var avgY = 0;

      for (var idx = nextFrameStart; idx < nextFrameEnd; idx++) {
        var rawIndex = this.getRawIndex(idx);
        var y = dimStore[rawIndex];

        if (isNaN(y)) {
          continue;
        }

        avgY += y;
      }

      avgY /= nextFrameEnd - nextFrameStart;
      var frameStart = i;
      var frameEnd = Math.min(i + frameSize, len);
      var pointAX = i - 1;
      var pointAY = dimStore[currentRawIndex];
      maxArea = -1;
      nextRawIndex = frameStart;
      var firstNaNIndex = -1;
      var countNaN = 0; // Find a point from current frame that construct a triangel with largest area with previous selected point
      // And the average of next frame.

      for (var idx = frameStart; idx < frameEnd; idx++) {
        var rawIndex = this.getRawIndex(idx);
        var y = dimStore[rawIndex];

        if (isNaN(y)) {
          countNaN++;

          if (firstNaNIndex < 0) {
            firstNaNIndex = rawIndex;
          }

          continue;
        } // Calculate triangle area over three buckets


        area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));

        if (area > maxArea) {
          maxArea = area;
          nextRawIndex = rawIndex; // Next a is this b
        }
      }

      if (countNaN > 0 && countNaN < frameEnd - frameStart) {
        // Append first NaN point in every bucket.
        // It is necessary to ensure the correct order of indices.
        newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
        nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
      }

      newIndices[sampledIndex++] = nextRawIndex;
      currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
    } // First frame use the last data.


    newIndices[sampledIndex++] = this.getRawIndex(len - 1);
    target._count = sampledIndex;
    target._indices = newIndices;
    target.getRawIndex = this._getRawIdx;
    return target;
  };
  /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */


  DataStore.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
    var target = this.clone([dimension], true);
    var targetStorage = target._chunks;
    var frameValues = [];
    var frameSize = Math.floor(1 / rate);
    var dimStore = targetStorage[dimension];
    var len = this.count();
    var rawExtentOnDim = target._rawExtent[dimension] = getInitialExtent();
    var newIndices = new (getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
    var offset = 0;

    for (var i = 0; i < len; i += frameSize) {
      // Last frame
      if (frameSize > len - i) {
        frameSize = len - i;
        frameValues.length = frameSize;
      }

      for (var k = 0; k < frameSize; k++) {
        var dataIdx = this.getRawIndex(i + k);
        frameValues[k] = dimStore[dataIdx];
      }

      var value = sampleValue(frameValues);
      var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1)); // Only write value on the filtered data

      dimStore[sampleFrameIdx] = value;

      if (value < rawExtentOnDim[0]) {
        rawExtentOnDim[0] = value;
      }

      if (value > rawExtentOnDim[1]) {
        rawExtentOnDim[1] = value;
      }

      newIndices[offset++] = sampleFrameIdx;
    }

    target._count = offset;
    target._indices = newIndices;

    target._updateGetRawIdx();

    return target;
  };
  /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */


  DataStore.prototype.each = function (dims, cb) {
    if (!this._count) {
      return;
    }

    var dimSize = dims.length;
    var chunks = this._chunks;

    for (var i = 0, len = this.count(); i < len; i++) {
      var rawIdx = this.getRawIndex(i); // Simple optimization

      switch (dimSize) {
        case 0:
          cb(i);
          break;

        case 1:
          cb(chunks[dims[0]][rawIdx], i);
          break;

        case 2:
          cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
          break;

        default:
          var k = 0;
          var value = [];

          for (; k < dimSize; k++) {
            value[k] = chunks[dims[k]][rawIdx];
          } // Index


          value[k] = i;
          cb.apply(null, value);
      }
    }
  };
  /**
   * Get extent of data in one dimension
   */


  DataStore.prototype.getDataExtent = function (dim) {
    // Make sure use concrete dim as cache name.
    var dimData = this._chunks[dim];
    var initialExtent = getInitialExtent();

    if (!dimData) {
      return initialExtent;
    } // Make more strict checkings to ensure hitting cache.


    var currEnd = this.count(); // Consider the most cases when using data zoom, `getDataExtent`
    // happened before filtering. We cache raw extent, which is not
    // necessary to be cleared and recalculated when restore data.

    var useRaw = !this._indices;
    var dimExtent;

    if (useRaw) {
      return this._rawExtent[dim].slice();
    }

    dimExtent = this._extent[dim];

    if (dimExtent) {
      return dimExtent.slice();
    }

    dimExtent = initialExtent;
    var min = dimExtent[0];
    var max = dimExtent[1];

    for (var i = 0; i < currEnd; i++) {
      var rawIdx = this.getRawIndex(i);
      var value = dimData[rawIdx];
      value < min && (min = value);
      value > max && (max = value);
    }

    dimExtent = [min, max];
    this._extent[dim] = dimExtent;
    return dimExtent;
  };
  /**
   * Get raw data item
   */


  DataStore.prototype.getRawDataItem = function (idx) {
    var rawIdx = this.getRawIndex(idx);

    if (!this._provider.persistent) {
      var val = [];
      var chunks = this._chunks;

      for (var i = 0; i < chunks.length; i++) {
        val.push(chunks[i][rawIdx]);
      }

      return val;
    } else {
      return this._provider.getItem(rawIdx);
    }
  };
  /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */


  DataStore.prototype.clone = function (clonedDims, ignoreIndices) {
    var target = new DataStore();
    var chunks = this._chunks;
    var clonedDimsMap = clonedDims && reduce$6(clonedDims, function (obj, dimIdx) {
      obj[dimIdx] = true;
      return obj;
    }, {});

    if (clonedDimsMap) {
      for (var i = 0; i < chunks.length; i++) {
        // Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : cloneChunk(chunks[i]);
      }
    } else {
      target._chunks = chunks;
    }

    this._copyCommonProps(target);

    if (!ignoreIndices) {
      target._indices = this._cloneIndices();
    }

    target._updateGetRawIdx();

    return target;
  };

  DataStore.prototype._copyCommonProps = function (target) {
    target._count = this._count;
    target._rawCount = this._rawCount;
    target._provider = this._provider;
    target._dimensions = this._dimensions;
    target._extent = clone(this._extent);
    target._rawExtent = clone(this._rawExtent);
  };

  DataStore.prototype._cloneIndices = function () {
    if (this._indices) {
      var Ctor = this._indices.constructor;
      var indices = void 0;

      if (Ctor === Array) {
        var thisCount = this._indices.length;
        indices = new Ctor(thisCount);

        for (var i = 0; i < thisCount; i++) {
          indices[i] = this._indices[i];
        }
      } else {
        indices = new Ctor(this._indices);
      }

      return indices;
    }

    return null;
  };

  DataStore.prototype._getRawIdxIdentity = function (idx) {
    return idx;
  };

  DataStore.prototype._getRawIdx = function (idx) {
    if (idx < this._count && idx >= 0) {
      return this._indices[idx];
    }

    return -1;
  };

  DataStore.prototype._updateGetRawIdx = function () {
    this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
  };

  DataStore.internalField = function () {
    function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
      return parseDataValue(dataItem[dimIndex], this._dimensions[dimIndex]);
    }

    defaultDimValueGetters = {
      arrayRows: getDimValueSimply,
      objectRows: function (dataItem, property, dataIndex, dimIndex) {
        return parseDataValue(dataItem[property], this._dimensions[dimIndex]);
      },
      keyedColumns: getDimValueSimply,
      original: function (dataItem, property, dataIndex, dimIndex) {
        // Performance sensitive, do not use modelUtil.getDataItemValue.
        // If dataItem is an plain object with no value field, the let `value`
        // will be assigned with the object, but it will be tread correctly
        // in the `convertValue`.
        var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
        return parseDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
        : value, this._dimensions[dimIndex]);
      },
      typedArray: function (dataItem, property, dataIndex, dimIndex) {
        return dataItem[dimIndex];
      }
    };
  }();

  return DataStore;
}();

/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */

var SourceManager =
/** @class */
function () {
  function SourceManager(sourceHost) {
    // Cached source. Do not repeat calculating if not dirty.
    this._sourceList = [];
    this._storeList = []; // version sign of each upstream source manager.

    this._upstreamSignList = [];
    this._versionSignBase = 0;
    this._dirty = true;
    this._sourceHost = sourceHost;
  }
  /**
   * Mark dirty.
   */


  SourceManager.prototype.dirty = function () {
    this._setLocalSource([], []);

    this._storeList = [];
    this._dirty = true;
  };

  SourceManager.prototype._setLocalSource = function (sourceList, upstreamSignList) {
    this._sourceList = sourceList;
    this._upstreamSignList = upstreamSignList;
    this._versionSignBase++;

    if (this._versionSignBase > 9e10) {
      this._versionSignBase = 0;
    }
  };
  /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */


  SourceManager.prototype._getVersionSign = function () {
    return this._sourceHost.uid + '_' + this._versionSignBase;
  };
  /**
   * Always return a source instance. Otherwise throw error.
   */


  SourceManager.prototype.prepareSource = function () {
    // For the case that call `setOption` multiple time but no data changed,
    // cache the result source to prevent from repeating transform.
    if (this._isDirty()) {
      this._createSource();

      this._dirty = false;
    }
  };

  SourceManager.prototype._createSource = function () {
    this._setLocalSource([], []);

    var sourceHost = this._sourceHost;

    var upSourceMgrList = this._getUpstreamSourceManagers();

    var hasUpstream = !!upSourceMgrList.length;
    var resultSourceList;
    var upstreamSignList;

    if (isSeries(sourceHost)) {
      var seriesModel = sourceHost;
      var data = void 0;
      var sourceFormat = void 0;
      var upSource = void 0; // Has upstream dataset

      if (hasUpstream) {
        var upSourceMgr = upSourceMgrList[0];
        upSourceMgr.prepareSource();
        upSource = upSourceMgr.getSource();
        data = upSource.data;
        sourceFormat = upSource.sourceFormat;
        upstreamSignList = [upSourceMgr._getVersionSign()];
      } // Series data is from own.
      else {
          data = seriesModel.get('data', true);
          sourceFormat = isTypedArray$1(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
          upstreamSignList = [];
        } // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.


      var newMetaRawOption = this._getSourceMetaRawOption() || {};
      var upMetaRawOption = upSource && upSource.metaRawOption || {};
      var seriesLayoutBy = retrieve2(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
      var sourceHeader = retrieve2(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader); // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
      // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
      // but series need `seriesLayoutBy: 'row'`.

      var dimensions = retrieve2(newMetaRawOption.dimensions, upMetaRawOption.dimensions); // We share source with dataset as much as possible
      // to avoid extra memory cost of high dimensional data.

      var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
      resultSourceList = needsCreateSource ? [createSource(data, {
        seriesLayoutBy: seriesLayoutBy,
        sourceHeader: sourceHeader,
        dimensions: dimensions
      }, sourceFormat)] : [];
    } else {
      var datasetModel = sourceHost; // Has upstream dataset.

      if (hasUpstream) {
        var result = this._applyTransform(upSourceMgrList);

        resultSourceList = result.sourceList;
        upstreamSignList = result.upstreamSignList;
      } // Is root dataset.
      else {
          var sourceData = datasetModel.get('source', true);
          resultSourceList = [createSource(sourceData, this._getSourceMetaRawOption(), null)];
          upstreamSignList = [];
        }
    }

    if (process.env.NODE_ENV !== 'production') {
      assert(resultSourceList && upstreamSignList);
    }

    this._setLocalSource(resultSourceList, upstreamSignList);
  };

  SourceManager.prototype._applyTransform = function (upMgrList) {
    var datasetModel = this._sourceHost;
    var transformOption = datasetModel.get('transform', true);
    var fromTransformResult = datasetModel.get('fromTransformResult', true);

    if (process.env.NODE_ENV !== 'production') {
      assert(fromTransformResult != null || transformOption != null);
    }

    if (fromTransformResult != null) {
      var errMsg = '';

      if (upMgrList.length !== 1) {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = 'When using `fromTransformResult`, there should be only one upstream dataset';
        }

        doThrow(errMsg);
      }
    }

    var sourceList;
    var upSourceList = [];
    var upstreamSignList = [];
    each(upMgrList, function (upMgr) {
      upMgr.prepareSource();
      var upSource = upMgr.getSource(fromTransformResult || 0);
      var errMsg = '';

      if (fromTransformResult != null && !upSource) {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = 'Can not retrieve result by `fromTransformResult`: ' + fromTransformResult;
        }

        doThrow(errMsg);
      }

      upSourceList.push(upSource);
      upstreamSignList.push(upMgr._getVersionSign());
    });

    if (transformOption) {
      sourceList = applyDataTransform(transformOption, upSourceList, {
        datasetIndex: datasetModel.componentIndex
      });
    } else if (fromTransformResult != null) {
      sourceList = [cloneSourceShallow(upSourceList[0])];
    }

    return {
      sourceList: sourceList,
      upstreamSignList: upstreamSignList
    };
  };

  SourceManager.prototype._isDirty = function () {
    if (this._dirty) {
      return true;
    } // All sourceList is from the some upstream.


    var upSourceMgrList = this._getUpstreamSourceManagers();

    for (var i = 0; i < upSourceMgrList.length; i++) {
      var upSrcMgr = upSourceMgrList[i];

      if ( // Consider the case that there is ancestor diry, call it recursively.
      // The performance is probably not an issue because usually the chain is not long.
      upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) {
        return true;
      }
    }
  };
  /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */


  SourceManager.prototype.getSource = function (sourceIndex) {
    sourceIndex = sourceIndex || 0;
    var source = this._sourceList[sourceIndex];

    if (!source) {
      // Series may share source instance with dataset.
      var upSourceMgrList = this._getUpstreamSourceManagers();

      return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
    }

    return source;
  };
  /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */


  SourceManager.prototype.getSharedDataStore = function (seriesDimRequest) {
    if (process.env.NODE_ENV !== 'production') {
      assert(isSeries(this._sourceHost), 'Can only call getDataStore on series source manager.');
    }

    var schema = seriesDimRequest.makeStoreSchema();
    return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
  };

  SourceManager.prototype._innerGetDataStore = function (storeDims, seriesSource, sourceReadKey) {
    // TODO Can use other sourceIndex?
    var sourceIndex = 0;
    var storeList = this._storeList;
    var cachedStoreMap = storeList[sourceIndex];

    if (!cachedStoreMap) {
      cachedStoreMap = storeList[sourceIndex] = {};
    }

    var cachedStore = cachedStoreMap[sourceReadKey];

    if (!cachedStore) {
      var upSourceMgr = this._getUpstreamSourceManagers()[0];

      if (isSeries(this._sourceHost) && upSourceMgr) {
        cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
      } else {
        cachedStore = new DataStore(); // Always create store from source of series.

        cachedStore.initData(new DefaultDataProvider(seriesSource, storeDims.length), storeDims);
      }

      cachedStoreMap[sourceReadKey] = cachedStore;
    }

    return cachedStore;
  };
  /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */


  SourceManager.prototype._getUpstreamSourceManagers = function () {
    // Always get the relationship from the raw option.
    // Do not cache the link of the dependency graph, so that
    // there is no need to update them when change happens.
    var sourceHost = this._sourceHost;

    if (isSeries(sourceHost)) {
      var datasetModel = querySeriesUpstreamDatasetModel(sourceHost);
      return !datasetModel ? [] : [datasetModel.getSourceManager()];
    } else {
      return map(queryDatasetUpstreamDatasetModels(sourceHost), function (datasetModel) {
        return datasetModel.getSourceManager();
      });
    }
  };

  SourceManager.prototype._getSourceMetaRawOption = function () {
    var sourceHost = this._sourceHost;
    var seriesLayoutBy;
    var sourceHeader;
    var dimensions;

    if (isSeries(sourceHost)) {
      seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
      sourceHeader = sourceHost.get('sourceHeader', true);
      dimensions = sourceHost.get('dimensions', true);
    } // See [REQUIREMENT_MEMO], `non-root-dataset` do not support them.
    else if (!this._getUpstreamSourceManagers().length) {
        var model = sourceHost;
        seriesLayoutBy = model.get('seriesLayoutBy', true);
        sourceHeader = model.get('sourceHeader', true);
        dimensions = model.get('dimensions', true);
      }

    return {
      seriesLayoutBy: seriesLayoutBy,
      sourceHeader: sourceHeader,
      dimensions: dimensions
    };
  };

  return SourceManager;
}();
// disable the transform merge, but do not disable transform clone from rawOption.

function disableTransformOptionMerge(datasetModel) {
  var transformOption = datasetModel.option.transform;
  transformOption && setAsPrimitive(datasetModel.option.transform);
}

function isSeries(sourceHost) {
  // Avoid circular dependency with Series.ts
  return sourceHost.mainType === 'series';
}

function doThrow(errMsg) {
  throw new Error(errMsg);
}

var TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1'; // TODO: more textStyle option

function getTooltipTextStyle(textStyle, renderMode) {
  var nameFontColor = textStyle.color || '#6e7079';
  var nameFontSize = textStyle.fontSize || 12;
  var nameFontWeight = textStyle.fontWeight || '400';
  var valueFontColor = textStyle.color || '#464646';
  var valueFontSize = textStyle.fontSize || 14;
  var valueFontWeight = textStyle.fontWeight || '900';

  if (renderMode === 'html') {
    // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
      // eslint-disable-next-line max-len
      nameStyle: "font-size:" + encodeHTML(nameFontSize + '') + "px;color:" + encodeHTML(nameFontColor) + ";font-weight:" + encodeHTML(nameFontWeight + ''),
      // eslint-disable-next-line max-len
      valueStyle: "font-size:" + encodeHTML(valueFontSize + '') + "px;color:" + encodeHTML(valueFontColor) + ";font-weight:" + encodeHTML(valueFontWeight + '')
    };
  } else {
    return {
      nameStyle: {
        fontSize: nameFontSize,
        fill: nameFontColor,
        fontWeight: nameFontWeight
      },
      valueStyle: {
        fontSize: valueFontSize,
        fill: valueFontColor,
        fontWeight: valueFontWeight
      }
    };
  }
} // See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)


var HTML_GAPS = [0, 10, 20, 30];
var RICH_TEXT_GAPS = ['', '\n', '\n\n', '\n\n\n']; // eslint-disable-next-line max-len

function createTooltipMarkup(type, option) {
  option.type = type;
  return option;
}

function isSectionFragment(frag) {
  return frag.type === 'section';
}

function getBuilder(frag) {
  return isSectionFragment(frag) ? buildSection : buildNameValue;
}

function getBlockGapLevel(frag) {
  if (isSectionFragment(frag)) {
    var gapLevel_1 = 0;
    var subBlockLen = frag.blocks.length;
    var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
    each(frag.blocks, function (subBlock) {
      var subGapLevel = getBlockGapLevel(subBlock); // If the some of the sub-blocks have some gaps (like 10px) inside, this block
      // should use a larger gap (like 20px) to distinguish those sub-blocks.

      if (subGapLevel >= gapLevel_1) {
        gapLevel_1 = subGapLevel + +(hasInnerGap_1 && ( // 0 always can not be readable gap level.
        !subGapLevel // If no header, always keep the sub gap level. Otherwise
        // look weird in case `multipleSeries`.
        || isSectionFragment(subBlock) && !subBlock.noHeader));
      }
    });
    return gapLevel_1;
  }

  return 0;
}

function buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
  var noHeader = fragment.noHeader;
  var gaps = getGap(getBlockGapLevel(fragment));
  var subMarkupTextList = [];
  var subBlocks = fragment.blocks || [];
  assert(!subBlocks || isArray$1(subBlocks));
  subBlocks = subBlocks || [];
  var orderMode = ctx.orderMode;

  if (fragment.sortBlocks && orderMode) {
    subBlocks = subBlocks.slice();
    var orderMap = {
      valueAsc: 'asc',
      valueDesc: 'desc'
    };

    if (hasOwn(orderMap, orderMode)) {
      var comparator_1 = new SortOrderComparator(orderMap[orderMode], null);
      subBlocks.sort(function (a, b) {
        return comparator_1.evaluate(a.sortParam, b.sortParam);
      });
    } // FIXME 'seriesDesc' necessary?
    else if (orderMode === 'seriesDesc') {
        subBlocks.reverse();
      }
  }

  each(subBlocks, function (subBlock, idx) {
    var valueFormatter = fragment.valueFormatter;
    var subMarkupText = getBuilder(subBlock)( // Inherit valueFormatter
    valueFormatter ? extend(extend({}, ctx), {
      valueFormatter: valueFormatter
    }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
    subMarkupText != null && subMarkupTextList.push(subMarkupText);
  });
  var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : wrapBlockHTML(subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);

  if (noHeader) {
    return subMarkupText;
  }

  var displayableHeader = makeValueReadable(fragment.header, 'ordinal', ctx.useUTC);
  var nameStyle = getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;

  if (ctx.renderMode === 'richText') {
    return wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
  } else {
    return wrapBlockHTML("<div style=\"" + nameStyle + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodeHTML(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
  }
}

function buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
  var renderMode = ctx.renderMode;
  var noName = fragment.noName;
  var noValue = fragment.noValue;
  var noMarker = !fragment.markerType;
  var name = fragment.name;
  var useUTC = ctx.useUTC;

  var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function (value) {
    value = isArray$1(value) ? value : [value];
    return map(value, function (val, idx) {
      return makeValueReadable(val, isArray$1(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
    });
  };

  if (noName && noValue) {
    return;
  }

  var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
  var readableName = noName ? '' : makeValueReadable(name, 'ordinal', useUTC);
  var valueTypeOption = fragment.valueType;
  var readableValueList = noValue ? [] : valueFormatter(fragment.value);
  var valueAlignRight = !noMarker || !noName; // It little weird if only value next to marker but far from marker.

  var valueCloseToMarker = !noMarker && noName;

  var _a = getTooltipTextStyle(toolTipTextStyle, renderMode),
      nameStyle = _a.nameStyle,
      valueStyle = _a.valueStyle;

  return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameRichText(ctx, readableName, nameStyle)) // Value has commas inside, so use ' ' as delimiter for multiple values.
  + (noValue ? '' : wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : wrapBlockHTML((noMarker ? '' : markerStr) + (noName ? '' : wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
/**
 * @return markupText. null/undefined means no content.
 */


function buildTooltipMarkup(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
  if (!fragment) {
    return;
  }

  var builder = getBuilder(fragment);
  var ctx = {
    useUTC: useUTC,
    renderMode: renderMode,
    orderMode: orderMode,
    markupStyleCreator: markupStyleCreator,
    valueFormatter: fragment.valueFormatter
  };
  return builder(ctx, fragment, 0, toolTipTextStyle);
}

function getGap(gapLevel) {
  return {
    html: HTML_GAPS[gapLevel],
    richText: RICH_TEXT_GAPS[gapLevel]
  };
}

function wrapBlockHTML(encodedContent, topGap) {
  var clearfix = '<div style="clear:both"></div>';
  var marginCSS = "margin: " + topGap + "px 0 0";
  return "<div style=\"" + marginCSS + ";" + TOOLTIP_LINE_HEIGHT_CSS + ";\">" + encodedContent + clearfix + '</div>';
}

function wrapInlineNameHTML(name, leftHasMarker, style) {
  var marginCss = leftHasMarker ? 'margin-left:2px' : '';
  return "<span style=\"" + style + ";" + marginCss + "\">" + encodeHTML(name) + '</span>';
}

function wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
  // Do not too close to marker, considering there are multiple values separated by spaces.
  var paddingStr = valueCloseToMarker ? '10px' : '20px';
  var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
  valueList = isArray$1(valueList) ? valueList : [valueList];
  return "<span style=\"" + alignCSS + ";" + style + "\">" // Value has commas inside, so use '  ' as delimiter for multiple values.
  + map(valueList, function (value) {
    return encodeHTML(value);
  }).join('&nbsp;&nbsp;') + '</span>';
}

function wrapInlineNameRichText(ctx, name, style) {
  return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}

function wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
  var styles = [style];
  var paddingLeft = valueCloseToMarker ? 10 : 20;
  alignRight && styles.push({
    padding: [0, 0, 0, paddingLeft],
    align: 'right'
  }); // Value has commas inside, so use '  ' as delimiter for multiple values.

  return ctx.markupStyleCreator.wrapRichTextStyle(isArray$1(values) ? values.join('  ') : values, styles);
}

function retrieveVisualColorForTooltipMarker(series, dataIndex) {
  var style = series.getData().getItemVisual(dataIndex, 'style');
  var color = style[series.visualDrawType];
  return convertToColorString(color);
}
function getPaddingFromTooltipModel(model, renderMode) {
  var padding = model.get('padding');
  return padding != null ? padding // We give slightly different to look pretty.
  : renderMode === 'richText' ? [8, 10] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */

var TooltipMarkupStyleCreator =
/** @class */
function () {
  function TooltipMarkupStyleCreator() {
    this.richTextStyles = {}; // Notice that "generate a style name" usuall happens repeatly when mouse moving and
    // displaying a tooltip. So we put the `_nextStyleNameId` as a member of each creator
    // rather than static shared by all creators (which will cause it increase to fast).

    this._nextStyleNameId = getRandomIdBase();
  }

  TooltipMarkupStyleCreator.prototype._generateStyleName = function () {
    return '__EC_aUTo_' + this._nextStyleNameId++;
  };

  TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function (markerType, colorStr, renderMode) {
    var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
    var marker = getTooltipMarker({
      color: colorStr,
      type: markerType,
      renderMode: renderMode,
      markerId: markerId
    });

    if (isString(marker)) {
      return marker;
    } else {
      if (process.env.NODE_ENV !== 'production') {
        assert(markerId);
      }

      this.richTextStyles[markerId] = marker.style;
      return marker.content;
    }
  };
  /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */


  TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function (text, styles) {
    var finalStl = {};

    if (isArray$1(styles)) {
      each(styles, function (stl) {
        return extend(finalStl, stl);
      });
    } else {
      extend(finalStl, styles);
    }

    var styleName = this._generateStyleName();

    this.richTextStyles[styleName] = finalStl;
    return "{" + styleName + "|" + text + "}";
  };

  return TooltipMarkupStyleCreator;
}();

function defaultSeriesFormatTooltip(opt) {
  var series = opt.series;
  var dataIndex = opt.dataIndex;
  var multipleSeries = opt.multipleSeries;
  var data = series.getData();
  var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
  var tooltipDimLen = tooltipDims.length;
  var value = series.getRawValue(dataIndex);
  var isValueArr = isArray$1(value);
  var markerColor = retrieveVisualColorForTooltipMarker(series, dataIndex); // Complicated rule for pretty tooltip.

  var inlineValue;
  var inlineValueType;
  var subBlocks;
  var sortParam;

  if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
    var formatArrResult = formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
    inlineValue = formatArrResult.inlineValues;
    inlineValueType = formatArrResult.inlineValueTypes;
    subBlocks = formatArrResult.blocks; // Only support tooltip sort by the first inline value. It's enough in most cases.

    sortParam = formatArrResult.inlineValues[0];
  } else if (tooltipDimLen) {
    var dimInfo = data.getDimensionInfo(tooltipDims[0]);
    sortParam = inlineValue = retrieveRawValue(data, dataIndex, tooltipDims[0]);
    inlineValueType = dimInfo.type;
  } else {
    sortParam = inlineValue = isValueArr ? value[0] : value;
  } // Do not show generated series name. It might not be readable.


  var seriesNameSpecified = isNameSpecified(series);
  var seriesName = seriesNameSpecified && series.name || '';
  var itemName = data.getName(dataIndex);
  var inlineName = multipleSeries ? seriesName : itemName;
  return createTooltipMarkup('section', {
    header: seriesName,
    // When series name not specified, do not show a header line with only '-'.
    // This case alway happen in tooltip.trigger: 'item'.
    noHeader: multipleSeries || !seriesNameSpecified,
    sortParam: sortParam,
    blocks: [createTooltipMarkup('nameValue', {
      markerType: 'item',
      markerColor: markerColor,
      // Do not mix display seriesName and itemName in one tooltip,
      // which might confuses users.
      name: inlineName,
      // name dimension might be auto assigned, where the name might
      // be not readable. So we check trim here.
      noName: !trim(inlineName),
      value: inlineValue,
      valueType: inlineValueType
    })].concat(subBlocks || [])
  });
}

function formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
  // check: category-no-encode-has-axis-data in dataset.html
  var data = series.getData();
  var isValueMultipleLine = reduce$6(value, function (isValueMultipleLine, val, idx) {
    var dimItem = data.getDimensionInfo(idx);
    return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
  }, false);
  var inlineValues = [];
  var inlineValueTypes = [];
  var blocks = [];
  tooltipDims.length ? each(tooltipDims, function (dim) {
    setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
  }) // By default, all dims is used on tooltip.
  : each(value, setEachItem);

  function setEachItem(val, dim) {
    var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.

    if (!dimInfo || dimInfo.otherDims.tooltip === false) {
      return;
    }

    if (isValueMultipleLine) {
      blocks.push(createTooltipMarkup('nameValue', {
        markerType: 'subItem',
        markerColor: colorStr,
        name: dimInfo.displayName,
        value: val,
        valueType: dimInfo.type
      }));
    } else {
      inlineValues.push(val);
      inlineValueTypes.push(dimInfo.type);
    }
  }

  return {
    inlineValues: inlineValues,
    inlineValueTypes: inlineValueTypes,
    blocks: blocks
  };
}

var inner$2 = makeInner();

function getSelectionKey(data, dataIndex) {
  return data.getName(dataIndex) || data.getId(dataIndex);
}

var SERIES_UNIVERSAL_TRANSITION_PROP = '__universalTransitionEnabled';

var SeriesModel =
/** @class */
function (_super) {
  __extends$1(SeriesModel, _super);

  function SeriesModel() {
    // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
    // the class members must not be initialized in constructor or declaration place.
    // Otherwise there is bad case:
    //   class A {xxx = 1;}
    //   enableClassExtend(A);
    //   class B extends A {}
    //   var C = B.extend({xxx: 5});
    //   var c = new C();
    //   console.log(c.xxx); // expect 5 but always 1.
    var _this = _super !== null && _super.apply(this, arguments) || this; // ---------------------------------------
    // Props about data selection
    // ---------------------------------------


    _this._selectedDataIndicesMap = {};
    return _this;
  }

  SeriesModel.prototype.init = function (option, parentModel, ecModel) {
    this.seriesIndex = this.componentIndex;
    this.dataTask = createTask({
      count: dataTaskCount,
      reset: dataTaskReset
    });
    this.dataTask.context = {
      model: this
    };
    this.mergeDefaultAndTheme(option, ecModel);
    var sourceManager = inner$2(this).sourceManager = new SourceManager(this);
    sourceManager.prepareSource();
    var data = this.getInitialData(option, ecModel);
    wrapData(data, this);
    this.dataTask.context.data = data;

    if (process.env.NODE_ENV !== 'production') {
      assert(data, 'getInitialData returned invalid data.');
    }

    inner$2(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
    // dataBeforeProcessed by cloneShallow), cloneShallow will
    // cause data.graph.data !== data when using
    // module:echarts/data/Graph or module:echarts/data/Tree.
    // See module:echarts/data/helper/linkSeriesData
    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
    // init or merge stage, because the data can be restored. So we do not `restoreData`
    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
    // Call `seriesModel.getRawData()` instead.
    // this.restoreData();

    autoSeriesName(this);

    this._initSelectedMapFromData(data);
  };
  /**
   * Util for merge default and theme to option
   */


  SeriesModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
    var layoutMode = fetchLayoutMode(this);
    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
    // But if name duplicate between series subType
    // (for example: parallel) add component mainType,
    // add suffix 'Series'.

    var themeSubType = this.subType;

    if (ComponentModel.hasClass(themeSubType)) {
      themeSubType += 'Series';
    }

    merge$1(option, ecModel.getTheme().get(this.subType));
    merge$1(option, this.getDefaultOption()); // Default label emphasis `show`

    defaultEmphasis(option, 'label', ['show']);
    this.fillDataTextStyle(option.data);

    if (layoutMode) {
      mergeLayoutParam(option, inputPositionParams, layoutMode);
    }
  };

  SeriesModel.prototype.mergeOption = function (newSeriesOption, ecModel) {
    // this.settingTask.dirty();
    newSeriesOption = merge$1(this.option, newSeriesOption, true);
    this.fillDataTextStyle(newSeriesOption.data);
    var layoutMode = fetchLayoutMode(this);

    if (layoutMode) {
      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
    }

    var sourceManager = inner$2(this).sourceManager;
    sourceManager.dirty();
    sourceManager.prepareSource();
    var data = this.getInitialData(newSeriesOption, ecModel);
    wrapData(data, this);
    this.dataTask.dirty();
    this.dataTask.context.data = data;
    inner$2(this).dataBeforeProcessed = data;
    autoSeriesName(this);

    this._initSelectedMapFromData(data);
  };

  SeriesModel.prototype.fillDataTextStyle = function (data) {
    // Default data label emphasis `show`
    // FIXME Tree structure data ?
    // FIXME Performance ?
    if (data && !isTypedArray$1(data)) {
      var props = ['show'];

      for (var i = 0; i < data.length; i++) {
        if (data[i] && data[i].label) {
          defaultEmphasis(data[i], 'label', props);
        }
      }
    }
  };
  /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */


  SeriesModel.prototype.getInitialData = function (option, ecModel) {
    return;
  };
  /**
   * Append data to list
   */


  SeriesModel.prototype.appendData = function (params) {
    // FIXME ???
    // (1) If data from dataset, forbidden append.
    // (2) support append data of dataset.
    var data = this.getRawData();
    data.appendData(params.data);
  };
  /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */


  SeriesModel.prototype.getData = function (dataType) {
    var task = getCurrentTask(this);

    if (task) {
      var data = task.context.data;
      return dataType == null ? data : data.getLinkedData(dataType);
    } else {
      // When series is not alive (that may happen when click toolbox
      // restore or setOption with not merge mode), series data may
      // be still need to judge animation or something when graphic
      // elements want to know whether fade out.
      return inner$2(this).data;
    }
  };

  SeriesModel.prototype.getAllData = function () {
    var mainData = this.getData();
    return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [{
      data: mainData
    }];
  };

  SeriesModel.prototype.setData = function (data) {
    var task = getCurrentTask(this);

    if (task) {
      var context = task.context; // Consider case: filter, data sample.
      // FIXME:TS never used, so comment it
      // if (context.data !== data && task.modifyOutputEnd) {
      //     task.setOutputEnd(data.count());
      // }

      context.outputData = data; // Caution: setData should update context.data,
      // Because getData may be called multiply in a
      // single stage and expect to get the data just
      // set. (For example, AxisProxy, x y both call
      // getData and setDate sequentially).
      // So the context.data should be fetched from
      // upstream each time when a stage starts to be
      // performed.

      if (task !== this.dataTask) {
        context.data = data;
      }
    }

    inner$2(this).data = data;
  };

  SeriesModel.prototype.getEncode = function () {
    var encode = this.get('encode', true);

    if (encode) {
      return createHashMap(encode);
    }
  };

  SeriesModel.prototype.getSourceManager = function () {
    return inner$2(this).sourceManager;
  };

  SeriesModel.prototype.getSource = function () {
    return this.getSourceManager().getSource();
  };
  /**
   * Get data before processed
   */


  SeriesModel.prototype.getRawData = function () {
    return inner$2(this).dataBeforeProcessed;
  };

  SeriesModel.prototype.getColorBy = function () {
    var colorBy = this.get('colorBy');
    return colorBy || 'series';
  };

  SeriesModel.prototype.isColorBySeries = function () {
    return this.getColorBy() === 'series';
  };
  /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */


  SeriesModel.prototype.getBaseAxis = function () {
    var coordSys = this.coordinateSystem; // @ts-ignore

    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
  };
  /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */


  SeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    return defaultSeriesFormatTooltip({
      series: this,
      dataIndex: dataIndex,
      multipleSeries: multipleSeries
    });
  };

  SeriesModel.prototype.isAnimationEnabled = function () {
    var ecModel = this.ecModel; // Disable animation if using echarts in node but not give ssr flag.
    // In ssr mode, renderToString will generate svg with css animation.

    if (env.node && !(ecModel && ecModel.ssr)) {
      return false;
    }

    var animationEnabled = this.getShallow('animation');

    if (animationEnabled) {
      if (this.getData().count() > this.getShallow('animationThreshold')) {
        animationEnabled = false;
      }
    }

    return !!animationEnabled;
  };

  SeriesModel.prototype.restoreData = function () {
    this.dataTask.dirty();
  };

  SeriesModel.prototype.getColorFromPalette = function (name, scope, requestColorNum) {
    var ecModel = this.ecModel; // PENDING

    var color = PaletteMixin.prototype.getColorFromPalette.call(this, name, scope, requestColorNum);

    if (!color) {
      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
    }

    return color;
  };
  /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */


  SeriesModel.prototype.coordDimToDataDim = function (coordDim) {
    return this.getRawData().mapDimensionsAll(coordDim);
  };
  /**
   * Get progressive rendering count each step
   */


  SeriesModel.prototype.getProgressive = function () {
    return this.get('progressive');
  };
  /**
   * Get progressive rendering count each step
   */


  SeriesModel.prototype.getProgressiveThreshold = function () {
    return this.get('progressiveThreshold');
  }; // PENGING If selectedMode is null ?


  SeriesModel.prototype.select = function (innerDataIndices, dataType) {
    this._innerSelect(this.getData(dataType), innerDataIndices);
  };

  SeriesModel.prototype.unselect = function (innerDataIndices, dataType) {
    var selectedMap = this.option.selectedMap;

    if (!selectedMap) {
      return;
    }

    var selectedMode = this.option.selectedMode;
    var data = this.getData(dataType);

    if (selectedMode === 'series' || selectedMap === 'all') {
      this.option.selectedMap = {};
      this._selectedDataIndicesMap = {};
      return;
    }

    for (var i = 0; i < innerDataIndices.length; i++) {
      var dataIndex = innerDataIndices[i];
      var nameOrId = getSelectionKey(data, dataIndex);
      selectedMap[nameOrId] = false;
      this._selectedDataIndicesMap[nameOrId] = -1;
    }
  };

  SeriesModel.prototype.toggleSelect = function (innerDataIndices, dataType) {
    var tmpArr = [];

    for (var i = 0; i < innerDataIndices.length; i++) {
      tmpArr[0] = innerDataIndices[i];
      this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
    }
  };

  SeriesModel.prototype.getSelectedDataIndices = function () {
    if (this.option.selectedMap === 'all') {
      return [].slice.call(this.getData().getIndices());
    }

    var selectedDataIndicesMap = this._selectedDataIndicesMap;
    var nameOrIds = keys$2(selectedDataIndicesMap);
    var dataIndices = [];

    for (var i = 0; i < nameOrIds.length; i++) {
      var dataIndex = selectedDataIndicesMap[nameOrIds[i]];

      if (dataIndex >= 0) {
        dataIndices.push(dataIndex);
      }
    }

    return dataIndices;
  };

  SeriesModel.prototype.isSelected = function (dataIndex, dataType) {
    var selectedMap = this.option.selectedMap;

    if (!selectedMap) {
      return false;
    }

    var data = this.getData(dataType);
    return (selectedMap === 'all' || selectedMap[getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get(['select', 'disabled']);
  };

  SeriesModel.prototype.isUniversalTransitionEnabled = function () {
    if (this[SERIES_UNIVERSAL_TRANSITION_PROP]) {
      return true;
    }

    var universalTransitionOpt = this.option.universalTransition; // Quick reject

    if (!universalTransitionOpt) {
      return false;
    }

    if (universalTransitionOpt === true) {
      return true;
    } // Can be simply 'universalTransition: true'


    return universalTransitionOpt && universalTransitionOpt.enabled;
  };

  SeriesModel.prototype._innerSelect = function (data, innerDataIndices) {
    var _a, _b;

    var option = this.option;
    var selectedMode = option.selectedMode;
    var len = innerDataIndices.length;

    if (!selectedMode || !len) {
      return;
    }

    if (selectedMode === 'series') {
      option.selectedMap = 'all';
    } else if (selectedMode === 'multiple') {
      if (!isObject$2(option.selectedMap)) {
        option.selectedMap = {};
      }

      var selectedMap = option.selectedMap;

      for (var i = 0; i < len; i++) {
        var dataIndex = innerDataIndices[i]; // TODO different types of data share same object.

        var nameOrId = getSelectionKey(data, dataIndex);
        selectedMap[nameOrId] = true;
        this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
      }
    } else if (selectedMode === 'single' || selectedMode === true) {
      var lastDataIndex = innerDataIndices[len - 1];
      var nameOrId = getSelectionKey(data, lastDataIndex);
      option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
      this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
    }
  };

  SeriesModel.prototype._initSelectedMapFromData = function (data) {
    // Ignore select info in data if selectedMap exists.
    // NOTE It's only for legacy usage. edge data is not supported.
    if (this.option.selectedMap) {
      return;
    }

    var dataIndices = [];

    if (data.hasItemOption) {
      data.each(function (idx) {
        var rawItem = data.getRawDataItem(idx);

        if (rawItem && rawItem.selected) {
          dataIndices.push(idx);
        }
      });
    }

    if (dataIndices.length > 0) {
      this._innerSelect(data, dataIndices);
    }
  }; // /**
  //  * @see {module:echarts/stream/Scheduler}
  //  */
  // abstract pipeTask: null


  SeriesModel.registerClass = function (clz) {
    return ComponentModel.registerClass(clz);
  };

  SeriesModel.protoInitialize = function () {
    var proto = SeriesModel.prototype;
    proto.type = 'series.__base__';
    proto.seriesIndex = 0;
    proto.ignoreStyleOnData = false;
    proto.hasSymbolVisual = false;
    proto.defaultSymbol = 'circle'; // Make sure the values can be accessed!

    proto.visualStyleAccessPath = 'itemStyle';
    proto.visualDrawType = 'fill';
  }();

  return SeriesModel;
}(ComponentModel);

mixin(SeriesModel, DataFormatMixin);
mixin(SeriesModel, PaletteMixin);
mountExtend(SeriesModel, ComponentModel);
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */

function autoSeriesName(seriesModel) {
  // User specified name has higher priority, otherwise it may cause
  // series can not be queried unexpectedly.
  var name = seriesModel.name;

  if (!isNameSpecified(seriesModel)) {
    seriesModel.name = getSeriesAutoName(seriesModel) || name;
  }
}

function getSeriesAutoName(seriesModel) {
  var data = seriesModel.getRawData();
  var dataDims = data.mapDimensionsAll('seriesName');
  var nameArr = [];
  each(dataDims, function (dataDim) {
    var dimInfo = data.getDimensionInfo(dataDim);
    dimInfo.displayName && nameArr.push(dimInfo.displayName);
  });
  return nameArr.join(' ');
}

function dataTaskCount(context) {
  return context.model.getRawData().count();
}

function dataTaskReset(context) {
  var seriesModel = context.model;
  seriesModel.setData(seriesModel.getRawData().cloneShallow());
  return dataTaskProgress;
}

function dataTaskProgress(param, context) {
  // Avoid repead cloneShallow when data just created in reset.
  if (context.outputData && param.end > context.outputData.count()) {
    context.model.getRawData().cloneShallow(context.outputData);
  }
} // TODO refactor


function wrapData(data, seriesModel) {
  each(concatArray(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function (methodName) {
    data.wrapMethod(methodName, curry(onDataChange, seriesModel));
  });
}

function onDataChange(seriesModel, newList) {
  var task = getCurrentTask(seriesModel);

  if (task) {
    // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
  }

  return newList;
}

function getCurrentTask(seriesModel) {
  var scheduler = (seriesModel.ecModel || {}).scheduler;
  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);

  if (pipeline) {
    // When pipline finished, the currrentTask keep the last
    // task (renderTask).
    var task = pipeline.currentTask;

    if (task) {
      var agentStubMap = task.agentStubMap;

      if (agentStubMap) {
        task = agentStubMap.get(seriesModel.uid);
      }
    }

    return task;
  }
}

var ComponentView =
/** @class */
function () {
  function ComponentView() {
    this.group = new Group$1();
    this.uid = getUID('viewComponent');
  }

  ComponentView.prototype.init = function (ecModel, api) {};

  ComponentView.prototype.render = function (model, ecModel, api, payload) {};

  ComponentView.prototype.dispose = function (ecModel, api) {};

  ComponentView.prototype.updateView = function (model, ecModel, api, payload) {// Do nothing;
  };

  ComponentView.prototype.updateLayout = function (model, ecModel, api, payload) {// Do nothing;
  };

  ComponentView.prototype.updateVisual = function (model, ecModel, api, payload) {// Do nothing;
  };
  /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */


  ComponentView.prototype.toggleBlurSeries = function (seriesModels, isBlur, ecModel) {// Do nothing;
  };
  /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */


  ComponentView.prototype.eachRendered = function (cb) {
    var group = this.group;

    if (group) {
      group.traverse(cb);
    }
  };

  return ComponentView;
}();
enableClassExtend(ComponentView);
enableClassManagement(ComponentView);

/**
 * @return {string} If large mode changed, return string 'reset';
 */

function createRenderPlanner() {
  var inner = makeInner();
  return function (seriesModel) {
    var fields = inner(seriesModel);
    var pipelineContext = seriesModel.pipelineContext;
    var originalLarge = !!fields.large;
    var originalProgressive = !!fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
    // exists. See #11611 . Probably we need to modify this structure, see the comment
    // on `performRawSeries` in `Schedular.js`.

    var large = fields.large = !!(pipelineContext && pipelineContext.large);
    var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
    return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
  };
}

var inner$3 = makeInner();
var renderPlanner = createRenderPlanner();

var ChartView =
/** @class */
function () {
  function ChartView() {
    this.group = new Group$1();
    this.uid = getUID('viewChart');
    this.renderTask = createTask({
      plan: renderTaskPlan,
      reset: renderTaskReset
    });
    this.renderTask.context = {
      view: this
    };
  }

  ChartView.prototype.init = function (ecModel, api) {};

  ChartView.prototype.render = function (seriesModel, ecModel, api, payload) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error('render method must been implemented');
    }
  };
  /**
   * Highlight series or specified data item.
   */


  ChartView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData(payload && payload.dataType);

    if (!data) {
      if (process.env.NODE_ENV !== 'production') {
        error("Unknown dataType " + payload.dataType);
      }

      return;
    }

    toggleHighlight(data, payload, 'emphasis');
  };
  /**
   * Downplay series or specified data item.
   */


  ChartView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData(payload && payload.dataType);

    if (!data) {
      if (process.env.NODE_ENV !== 'production') {
        error("Unknown dataType " + payload.dataType);
      }

      return;
    }

    toggleHighlight(data, payload, 'normal');
  };
  /**
   * Remove self.
   */


  ChartView.prototype.remove = function (ecModel, api) {
    this.group.removeAll();
  };
  /**
   * Dispose self.
   */


  ChartView.prototype.dispose = function (ecModel, api) {};

  ChartView.prototype.updateView = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  }; // FIXME never used?


  ChartView.prototype.updateLayout = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  }; // FIXME never used?


  ChartView.prototype.updateVisual = function (seriesModel, ecModel, api, payload) {
    this.render(seriesModel, ecModel, api, payload);
  };
  /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */


  ChartView.prototype.eachRendered = function (cb) {
    traverseElements(this.group, cb);
  };

  ChartView.markUpdateMethod = function (payload, methodName) {
    inner$3(payload).updateMethod = methodName;
  };

  ChartView.protoInitialize = function () {
    var proto = ChartView.prototype;
    proto.type = 'chart';
  }();

  return ChartView;
}();
/**
 * Set state of single element
 */

function elSetState(el, state, highlightDigit) {
  if (el && isHighDownDispatcher(el)) {
    (state === 'emphasis' ? enterEmphasis : leaveEmphasis)(el, highlightDigit);
  }
}

function toggleHighlight(data, payload, state) {
  var dataIndex = queryDataIndex(data, payload);
  var highlightDigit = payload && payload.highlightKey != null ? getHighlightDigit(payload.highlightKey) : null;

  if (dataIndex != null) {
    each(normalizeToArray(dataIndex), function (dataIdx) {
      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
  } else {
    data.eachItemGraphicEl(function (el) {
      elSetState(el, state, highlightDigit);
    });
  }
}

enableClassExtend(ChartView, ['dispose']);
enableClassManagement(ChartView);

function renderTaskPlan(context) {
  return renderPlanner(context.model);
}

function renderTaskReset(context) {
  var seriesModel = context.model;
  var ecModel = context.ecModel;
  var api = context.api;
  var payload = context.payload; // FIXME: remove updateView updateVisual

  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
  var view = context.view;
  var updateMethod = payload && inner$3(payload).updateMethod;
  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
  // is less than progressive threshold.
  : 'render';

  if (methodName !== 'render') {
    view[methodName](seriesModel, ecModel, api, payload);
  }

  return progressMethodMap[methodName];
}

var progressMethodMap = {
  incrementalPrepareRender: {
    progress: function (params, context) {
      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
    }
  },
  render: {
    // Put view.render in `progress` to support appendData. But in this case
    // view.render should not be called in reset, otherwise it will be called
    // twise. Use `forceFirstProgress` to make sure that view.render is called
    // in any cases.
    forceFirstProgress: true,
    progress: function (params, context) {
      context.view.render(context.model, context.ecModel, context.api, context.payload);
    }
  }
};

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var ORIGIN_METHOD = '\0__throttleOriginMethod';
var RATE = '\0__throttleRate';
var THROTTLE_TYPE = '\0__throttleType';
/**
 * @public
 * @param {(Function)} fn
 * @param {number} [delay=0] Unit: ms.
 * @param {boolean} [debounce=false]
 *        true: If call interval less than `delay`, only the last call works.
 *        false: If call interval less than `delay, call works on fixed rate.
 * @return {(Function)} throttled fn.
 */

function throttle$1(fn, delay, debounce) {
  var currCall;
  var lastCall = 0;
  var lastExec = 0;
  var timer = null;
  var diff;
  var scope;
  var args;
  var debounceNextCall;
  delay = delay || 0;

  function exec() {
    lastExec = new Date().getTime();
    timer = null;
    fn.apply(scope, args || []);
  }

  var cb = function () {
    var cbArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      cbArgs[_i] = arguments[_i];
    }

    currCall = new Date().getTime();
    scope = this;
    args = cbArgs;
    var thisDelay = debounceNextCall || delay;
    var thisDebounce = debounceNextCall || debounce;
    debounceNextCall = null;
    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
    // than a new call of `cb`, that is, preserving the command order. Consider
    // calculating "scale rate" when roaming as an example. When a call of `cb`
    // happens, either the `exec` is called dierectly, or the call is delayed.
    // But the delayed call should never be later than next call of `cb`. Under
    // this assurance, we can simply update view state each time `dispatchAction`
    // triggered by user roaming, but not need to add extra code to avoid the
    // state being "rolled-back".

    if (thisDebounce) {
      timer = setTimeout(exec, thisDelay);
    } else {
      if (diff >= 0) {
        exec();
      } else {
        timer = setTimeout(exec, -diff);
      }
    }

    lastCall = currCall;
  };
  /**
   * Clear throttle.
   * @public
   */


  cb.clear = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  /**
   * Enable debounce once.
   */


  cb.debounceNextCall = function (debounceDelay) {
    debounceNextCall = debounceDelay;
  };

  return cb;
}
/**
 * Create throttle method or update throttle rate.
 *
 * @example
 * ComponentView.prototype.render = function () {
 *     ...
 *     throttle.createOrUpdate(
 *         this,
 *         '_dispatchAction',
 *         this.model.get('throttle'),
 *         'fixRate'
 *     );
 * };
 * ComponentView.prototype.remove = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 * ComponentView.prototype.dispose = function () {
 *     throttle.clear(this, '_dispatchAction');
 * };
 *
 */

function createOrUpdate(obj, fnAttr, rate, throttleType) {
  var fn = obj[fnAttr];

  if (!fn) {
    return;
  }

  var originFn = fn[ORIGIN_METHOD] || fn;
  var lastThrottleType = fn[THROTTLE_TYPE];
  var lastRate = fn[RATE];

  if (lastRate !== rate || lastThrottleType !== throttleType) {
    if (rate == null || !throttleType) {
      return obj[fnAttr] = originFn;
    }

    fn = obj[fnAttr] = throttle$1(originFn, rate, throttleType === 'debounce');
    fn[ORIGIN_METHOD] = originFn;
    fn[THROTTLE_TYPE] = throttleType;
    fn[RATE] = rate;
  }

  return fn;
}
/**
 * Clear throttle. Example see throttle.createOrUpdate.
 */

function clear(obj, fnAttr) {
  var fn = obj[fnAttr];

  if (fn && fn[ORIGIN_METHOD]) {
    // Clear throttle
    fn.clear && fn.clear();
    obj[fnAttr] = fn[ORIGIN_METHOD];
  }
}

var inner$4 = makeInner();
var defaultStyleMappers = {
  itemStyle: makeStyleMapper(ITEM_STYLE_KEY_MAP, true),
  lineStyle: makeStyleMapper(LINE_STYLE_KEY_MAP, true)
};
var defaultColorKey = {
  lineStyle: 'stroke',
  itemStyle: 'fill'
};

function getStyleMapper(seriesModel, stylePath) {
  var styleMapper = seriesModel.visualStyleMapper || defaultStyleMappers[stylePath];

  if (!styleMapper) {
    console.warn("Unknown style type '" + stylePath + "'.");
    return defaultStyleMappers.itemStyle;
  }

  return styleMapper;
}

function getDefaultColorKey(seriesModel, stylePath) {
  // return defaultColorKey[stylePath] ||
  var colorKey = seriesModel.visualDrawType || defaultColorKey[stylePath];

  if (!colorKey) {
    console.warn("Unknown style type '" + stylePath + "'.");
    return 'fill';
  }

  return colorKey;
}

var seriesStyleTask = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle

    var styleModel = seriesModel.getModel(stylePath);
    var getStyle = getStyleMapper(seriesModel, stylePath);
    var globalStyle = getStyle(styleModel);
    var decalOption = styleModel.getShallow('decal');

    if (decalOption) {
      data.setVisual('decal', decalOption);
      decalOption.dirty = true;
    } // TODO


    var colorKey = getDefaultColorKey(seriesModel, stylePath);
    var color = globalStyle[colorKey]; // TODO style callback

    var colorCallback = isFunction$3(color) ? color : null;
    var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto'; // Get from color palette by default.

    if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
      // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
      // make it effect palette. Because some scenarios users need to make some series
      // transparent or as background, which should better not effect the palette.
      var colorPalette = seriesModel.getColorFromPalette( // TODO series count changed.
      seriesModel.name, null, ecModel.getSeriesCount());

      if (!globalStyle[colorKey]) {
        globalStyle[colorKey] = colorPalette;
        data.setVisual('colorFromPalette', true);
      }

      globalStyle.fill = globalStyle.fill === 'auto' || isFunction$3(globalStyle.fill) ? colorPalette : globalStyle.fill;
      globalStyle.stroke = globalStyle.stroke === 'auto' || isFunction$3(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
    }

    data.setVisual('style', globalStyle);
    data.setVisual('drawType', colorKey); // Only visible series has each data be visual encoded

    if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
      data.setVisual('colorFromPalette', false);
      return {
        dataEach: function (data, idx) {
          var dataParams = seriesModel.getDataParams(idx);
          var itemStyle = extend({}, globalStyle);
          itemStyle[colorKey] = colorCallback(dataParams);
          data.setItemVisual(idx, 'style', itemStyle);
        }
      };
    }
  }
};
var sharedModel = new Model();
var dataStyleTask = {
  createOnAllSeries: true,
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();
    var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle'; // Set in itemStyle

    var getStyle = getStyleMapper(seriesModel, stylePath);
    var colorKey = data.getVisual('drawType');
    return {
      dataEach: data.hasItemOption ? function (data, idx) {
        // Not use getItemModel for performance considuration
        var rawItem = data.getRawDataItem(idx);

        if (rawItem && rawItem[stylePath]) {
          sharedModel.option = rawItem[stylePath];
          var style = getStyle(sharedModel);
          var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
          extend(existsStyle, style);

          if (sharedModel.option.decal) {
            data.setItemVisual(idx, 'decal', sharedModel.option.decal);
            sharedModel.option.decal.dirty = true;
          }

          if (colorKey in style) {
            data.setItemVisual(idx, 'colorFromPalette', false);
          }
        }
      } : null
    };
  }
}; // Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.

var dataColorPaletteTask = {
  performRawSeries: true,
  overallReset: function (ecModel) {
    // Each type of series uses one scope.
    // Pie and funnel are using different scopes.
    var paletteScopeGroupByType = createHashMap();
    ecModel.eachSeries(function (seriesModel) {
      var colorBy = seriesModel.getColorBy();

      if (seriesModel.isColorBySeries()) {
        return;
      }

      var key = seriesModel.type + '-' + colorBy;
      var colorScope = paletteScopeGroupByType.get(key);

      if (!colorScope) {
        colorScope = {};
        paletteScopeGroupByType.set(key, colorScope);
      }

      inner$4(seriesModel).scope = colorScope;
    });
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) {
        return;
      }

      var dataAll = seriesModel.getRawData();
      var idxMap = {};
      var data = seriesModel.getData();
      var colorScope = inner$4(seriesModel).scope;
      var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
      var colorKey = getDefaultColorKey(seriesModel, stylePath);
      data.each(function (idx) {
        var rawIdx = data.getRawIndex(idx);
        idxMap[rawIdx] = idx;
      }); // Iterate on data before filtered. To make sure color from palette can be
      // Consistent when toggling legend.

      dataAll.each(function (rawIdx) {
        var idx = idxMap[rawIdx];
        var fromPalette = data.getItemVisual(idx, 'colorFromPalette'); // Get color from palette for each data only when the color is inherited from series color, which is
        // also picked from color palette. So following situation is not in the case:
        // 1. series.itemStyle.color is set
        // 2. color is encoded by visualMap

        if (fromPalette) {
          var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
          var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
          var dataCount = dataAll.count();
          itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
        }
      });
    });
  }
};

var PI$3 = Math.PI;
/**
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [opts]
 * @param {string} [opts.text]
 * @param {string} [opts.color]
 * @param {string} [opts.textColor]
 * @return {module:zrender/Element}
 */

function defaultLoading(api, opts) {
  opts = opts || {};
  defaults(opts, {
    text: 'loading',
    textColor: '#000',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontFamily: 'sans-serif',
    maskColor: 'rgba(255, 255, 255, 0.8)',
    showSpinner: true,
    color: '#5470c6',
    spinnerRadius: 10,
    lineWidth: 5,
    zlevel: 0
  });
  var group = new Group$1();
  var mask = new Rect({
    style: {
      fill: opts.maskColor
    },
    zlevel: opts.zlevel,
    z: 10000
  });
  group.add(mask);
  var textContent = new ZRText({
    style: {
      text: opts.text,
      fill: opts.textColor,
      fontSize: opts.fontSize,
      fontWeight: opts.fontWeight,
      fontStyle: opts.fontStyle,
      fontFamily: opts.fontFamily
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  var labelRect = new Rect({
    style: {
      fill: 'none'
    },
    textContent: textContent,
    textConfig: {
      position: 'right',
      distance: 10
    },
    zlevel: opts.zlevel,
    z: 10001
  });
  group.add(labelRect);
  var arc;

  if (opts.showSpinner) {
    arc = new Arc({
      shape: {
        startAngle: -PI$3 / 2,
        endAngle: -PI$3 / 2 + 0.1,
        r: opts.spinnerRadius
      },
      style: {
        stroke: opts.color,
        lineCap: 'round',
        lineWidth: opts.lineWidth
      },
      zlevel: opts.zlevel,
      z: 10001
    });
    arc.animateShape(true).when(1000, {
      endAngle: PI$3 * 3 / 2
    }).start('circularInOut');
    arc.animateShape(true).when(1000, {
      startAngle: PI$3 * 3 / 2
    }).delay(300).start('circularInOut');
    group.add(arc);
  } // Inject resize


  group.resize = function () {
    var textWidth = textContent.getBoundingRect().width;
    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
    // textDistance needs to be calculated when both animation and text exist

    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) // only show the text
    + (opts.showSpinner ? 0 : textWidth / 2) // only show the spinner
    + (textWidth ? 0 : r);
    var cy = api.getHeight() / 2;
    opts.showSpinner && arc.setShape({
      cx: cx,
      cy: cy
    });
    labelRect.setShape({
      x: cx - r,
      y: cy - r,
      width: r * 2,
      height: r * 2
    });
    mask.setShape({
      x: 0,
      y: 0,
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  group.resize();
  return group;
}

var Scheduler =
/** @class */
function () {
  function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
    // key: handlerUID
    this._stageTaskMap = createHashMap();
    this.ecInstance = ecInstance;
    this.api = api; // Fix current processors in case that in some rear cases that
    // processors might be registered after echarts instance created.
    // Register processors incrementally for a echarts instance is
    // not supported by this stream architecture.

    dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
    visualHandlers = this._visualHandlers = visualHandlers.slice();
    this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
  }

  Scheduler.prototype.restoreData = function (ecModel, payload) {
    // TODO: Only restore needed series and components, but not all components.
    // Currently `restoreData` of all of the series and component will be called.
    // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
    // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
    // and some components like coordinate system, axes, dataZoom, visualMap only
    // need their target series refresh.
    // (1) If we are implementing this feature some day, we should consider these cases:
    // if a data processor depends on a component (e.g., dataZoomProcessor depends
    // on the settings of `dataZoom`), it should be re-performed if the component
    // is modified by `setOption`.
    // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
    // it should be re-performed when the result array of `getTargetSeries` changed.
    // We use `dependencies` to cover these issues.
    // (3) How to update target series when coordinate system related components modified.
    // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
    // and this case all of the tasks will be set as dirty.
    ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
    // depends on all of the series.
    // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
    // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
    // that the overall task is set as dirty and to be performed, otherwise it probably cause
    // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
    // probably cause state chaos (consider `dataZoomProcessor`).

    this._stageTaskMap.each(function (taskRecord) {
      var overallTask = taskRecord.overallTask;
      overallTask && overallTask.dirty();
    });
  }; // If seriesModel provided, incremental threshold is check by series data.


  Scheduler.prototype.getPerformArgs = function (task, isBlock) {
    // For overall task
    if (!task.__pipeline) {
      return;
    }

    var pipeline = this._pipelineMap.get(task.__pipeline.id);

    var pCtx = pipeline.context;
    var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
    var step = incremental ? pipeline.step : null;
    var modDataCount = pCtx && pCtx.modDataCount;
    var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
    return {
      step: step,
      modBy: modBy,
      modDataCount: modDataCount
    };
  };

  Scheduler.prototype.getPipeline = function (pipelineId) {
    return this._pipelineMap.get(pipelineId);
  };
  /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */


  Scheduler.prototype.updateStreamModes = function (seriesModel, view) {
    var pipeline = this._pipelineMap.get(seriesModel.uid);

    var data = seriesModel.getData();
    var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
    // animation frame. Note that some types of series do not provide
    // `view.incrementalPrepareRender` but support `chart.appendData`. We
    // use the term `incremental` but not `progressive` to describe the
    // case that `chart.appendData`.

    var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
    var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
    // see `test/candlestick-large3.html`

    var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
    seriesModel.pipelineContext = pipeline.context = {
      progressiveRender: progressiveRender,
      modDataCount: modDataCount,
      large: large
    };
  };

  Scheduler.prototype.restorePipelines = function (ecModel) {
    var scheduler = this;
    var pipelineMap = scheduler._pipelineMap = createHashMap();
    ecModel.eachSeries(function (seriesModel) {
      var progressive = seriesModel.getProgressive();
      var pipelineId = seriesModel.uid;
      pipelineMap.set(pipelineId, {
        id: pipelineId,
        head: null,
        tail: null,
        threshold: seriesModel.getProgressiveThreshold(),
        progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
        blockIndex: -1,
        step: Math.round(progressive || 700),
        count: 0
      });

      scheduler._pipe(seriesModel, seriesModel.dataTask);
    });
  };

  Scheduler.prototype.prepareStageTasks = function () {
    var stageTaskMap = this._stageTaskMap;
    var ecModel = this.api.getModel();
    var api = this.api;
    each(this._allHandlers, function (handler) {
      var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        // Currently do not need to support to sepecify them both.
        errMsg = '"reset" and "overallReset" must not be both specified.';
      }

      assert(!(handler.reset && handler.overallReset), errMsg);
      handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
      handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
    }, this);
  };

  Scheduler.prototype.prepareView = function (view, model, ecModel, api) {
    var renderTask = view.renderTask;
    var context = renderTask.context;
    context.model = model;
    context.ecModel = ecModel;
    context.api = api;
    renderTask.__block = !view.incrementalPrepareRender;

    this._pipe(model, renderTask);
  };

  Scheduler.prototype.performDataProcessorTasks = function (ecModel, payload) {
    // If we do not use `block` here, it should be considered when to update modes.
    this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
      block: true
    });
  };

  Scheduler.prototype.performVisualTasks = function (ecModel, payload, opt) {
    this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
  };

  Scheduler.prototype._performStageTasks = function (stageHandlers, ecModel, payload, opt) {
    opt = opt || {};
    var unfinished = false;
    var scheduler = this;
    each(stageHandlers, function (stageHandler, idx) {
      if (opt.visualType && opt.visualType !== stageHandler.visualType) {
        return;
      }

      var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);

      var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
      var overallTask = stageHandlerRecord.overallTask;

      if (overallTask) {
        var overallNeedDirty_1;
        var agentStubMap = overallTask.agentStubMap;
        agentStubMap.each(function (stub) {
          if (needSetDirty(opt, stub)) {
            stub.dirty();
            overallNeedDirty_1 = true;
          }
        });
        overallNeedDirty_1 && overallTask.dirty();
        scheduler.updatePayload(overallTask, payload);
        var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
        // then execute the overall task. And stub will call seriesModel.setData,
        // which ensures that in the overallTask seriesModel.getData() will not
        // return incorrect data.

        agentStubMap.each(function (stub) {
          stub.perform(performArgs_1);
        });

        if (overallTask.perform(performArgs_1)) {
          unfinished = true;
        }
      } else if (seriesTaskMap) {
        seriesTaskMap.each(function (task, pipelineId) {
          if (needSetDirty(opt, task)) {
            task.dirty();
          }

          var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
          // if intending to declare `performRawSeries` in handlers, only
          // stream-independent (specifically, data item independent) operations can be
          // performed. Because if a series is filtered, most of the tasks will not
          // be performed. A stream-dependent operation probably cause wrong biz logic.
          // Perhaps we should not provide a separate callback for this case instead
          // of providing the config `performRawSeries`. The stream-dependent operations
          // and stream-independent operations should better not be mixed.

          performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
          scheduler.updatePayload(task, payload);

          if (task.perform(performArgs)) {
            unfinished = true;
          }
        });
      }
    });

    function needSetDirty(opt, task) {
      return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
    }

    this.unfinished = unfinished || this.unfinished;
  };

  Scheduler.prototype.performSeriesTasks = function (ecModel) {
    var unfinished;
    ecModel.eachSeries(function (seriesModel) {
      // Progress to the end for dataInit and dataRestore.
      unfinished = seriesModel.dataTask.perform() || unfinished;
    });
    this.unfinished = unfinished || this.unfinished;
  };

  Scheduler.prototype.plan = function () {
    // Travel pipelines, check block.
    this._pipelineMap.each(function (pipeline) {
      var task = pipeline.tail;

      do {
        if (task.__block) {
          pipeline.blockIndex = task.__idxInPipeline;
          break;
        }

        task = task.getUpstream();
      } while (task);
    });
  };

  Scheduler.prototype.updatePayload = function (task, payload) {
    payload !== 'remain' && (task.context.payload = payload);
  };

  Scheduler.prototype._createSeriesStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
    var scheduler = this;
    var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap; // The count of stages are totally about only several dozen, so
    // do not need to reuse the map.

    var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = createHashMap();
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
    // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
    // it works but it may cause other irrelevant charts blocked.

    if (stageHandler.createOnAllSeries) {
      ecModel.eachRawSeries(create);
    } else if (seriesType) {
      ecModel.eachRawSeriesByType(seriesType, create);
    } else if (getTargetSeries) {
      getTargetSeries(ecModel, api).each(create);
    }

    function create(seriesModel) {
      var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
      // Reuse original task instance.

      var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || createTask({
        plan: seriesTaskPlan,
        reset: seriesTaskReset,
        count: seriesTaskCount
      }));
      task.context = {
        model: seriesModel,
        ecModel: ecModel,
        api: api,
        // PENDING: `useClearVisual` not used?
        useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
        plan: stageHandler.plan,
        reset: stageHandler.reset,
        scheduler: scheduler
      };

      scheduler._pipe(seriesModel, task);
    }
  };

  Scheduler.prototype._createOverallStageTask = function (stageHandler, stageHandlerRecord, ecModel, api) {
    var scheduler = this;
    var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
    || createTask({
      reset: overallTaskReset
    });
    overallTask.context = {
      ecModel: ecModel,
      api: api,
      overallReset: stageHandler.overallReset,
      scheduler: scheduler
    };
    var oldAgentStubMap = overallTask.agentStubMap; // The count of stages are totally about only several dozen, so
    // do not need to reuse the map.

    var newAgentStubMap = overallTask.agentStubMap = createHashMap();
    var seriesType = stageHandler.seriesType;
    var getTargetSeries = stageHandler.getTargetSeries;
    var overallProgress = true;
    var shouldOverallTaskDirty = false; // FIXME:TS never used, so comment it
    // let modifyOutputEnd = stageHandler.modifyOutputEnd;
    // An overall task with seriesType detected or has `getTargetSeries`, we add
    // stub in each pipelines, it will set the overall task dirty when the pipeline
    // progress. Moreover, to avoid call the overall task each frame (too frequent),
    // we set the pipeline block.

    var errMsg = '';

    if (process.env.NODE_ENV !== 'production') {
      errMsg = '"createOnAllSeries" is not supported for "overallReset", ' + 'because it will block all streams.';
    }

    assert(!stageHandler.createOnAllSeries, errMsg);

    if (seriesType) {
      ecModel.eachRawSeriesByType(seriesType, createStub);
    } else if (getTargetSeries) {
      getTargetSeries(ecModel, api).each(createStub);
    } // Otherwise, (usually it is legacy case), the overall task will only be
    // executed when upstream is dirty. Otherwise the progressive rendering of all
    // pipelines will be disabled unexpectedly. But it still needs stubs to receive
    // dirty info from upstream.
    else {
        overallProgress = false;
        each(ecModel.getSeries(), createStub);
      }

    function createStub(seriesModel) {
      var pipelineId = seriesModel.uid;
      var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || ( // When the result of `getTargetSeries` changed, the overallTask
      // should be set as dirty and re-performed.
      shouldOverallTaskDirty = true, createTask({
        reset: stubReset,
        onDirty: stubOnDirty
      })));
      stub.context = {
        model: seriesModel,
        overallProgress: overallProgress // FIXME:TS never used, so comment it
        // modifyOutputEnd: modifyOutputEnd

      };
      stub.agent = overallTask;
      stub.__block = overallProgress;

      scheduler._pipe(seriesModel, stub);
    }

    if (shouldOverallTaskDirty) {
      overallTask.dirty();
    }
  };

  Scheduler.prototype._pipe = function (seriesModel, task) {
    var pipelineId = seriesModel.uid;

    var pipeline = this._pipelineMap.get(pipelineId);

    !pipeline.head && (pipeline.head = task);
    pipeline.tail && pipeline.tail.pipe(task);
    pipeline.tail = task;
    task.__idxInPipeline = pipeline.count++;
    task.__pipeline = pipeline;
  };

  Scheduler.wrapStageHandler = function (stageHandler, visualType) {
    if (isFunction$3(stageHandler)) {
      stageHandler = {
        overallReset: stageHandler,
        seriesType: detectSeriseType(stageHandler)
      };
    }

    stageHandler.uid = getUID('stageHandler');
    visualType && (stageHandler.visualType = visualType);
    return stageHandler;
  };
  return Scheduler;
}();

function overallTaskReset(context) {
  context.overallReset(context.ecModel, context.api, context.payload);
}

function stubReset(context) {
  return context.overallProgress && stubProgress;
}

function stubProgress() {
  this.agent.dirty();
  this.getDownstream().dirty();
}

function stubOnDirty() {
  this.agent && this.agent.dirty();
}

function seriesTaskPlan(context) {
  return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}

function seriesTaskReset(context) {
  if (context.useClearVisual) {
    context.data.clearAllVisual();
  }

  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
    return makeSeriesTaskProgress(idx);
  }) : singleSeriesTaskProgress;
}

var singleSeriesTaskProgress = makeSeriesTaskProgress(0);

function makeSeriesTaskProgress(resetDefineIdx) {
  return function (params, context) {
    var data = context.data;
    var resetDefine = context.resetDefines[resetDefineIdx];

    if (resetDefine && resetDefine.dataEach) {
      for (var i = params.start; i < params.end; i++) {
        resetDefine.dataEach(data, i);
      }
    } else if (resetDefine && resetDefine.progress) {
      resetDefine.progress(params, data);
    }
  };
}

function seriesTaskCount(context) {
  return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */


function detectSeriseType(legacyFunc) {
  seriesType = null;

  try {
    // Assume there is no async when calling `eachSeriesByType`.
    legacyFunc(ecModelMock, apiMock);
  } catch (e) {}

  return seriesType;
}

var ecModelMock = {};
var apiMock = {};
var seriesType;
mockMethods(ecModelMock, GlobalModel);
mockMethods(apiMock, ExtensionAPI);

ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
  seriesType = type;
};

ecModelMock.eachComponent = function (cond) {
  if (cond.mainType === 'series' && cond.subType) {
    seriesType = cond.subType;
  }
};

function mockMethods(target, Clz) {
  /* eslint-disable */
  for (var name_1 in Clz.prototype) {
    // Do not use hasOwnProperty
    target[name_1] = noop$2;
  }
  /* eslint-enable */

}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
var lightTheme = {
  color: colorAll,
  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
};

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var contrastColor = '#B9B8CE';
var backgroundColor = '#100C2A';

var axisCommon = function () {
  return {
    axisLine: {
      lineStyle: {
        color: contrastColor
      }
    },
    splitLine: {
      lineStyle: {
        color: '#484753'
      }
    },
    splitArea: {
      areaStyle: {
        color: ['rgba(255,255,255,0.02)', 'rgba(255,255,255,0.05)']
      }
    },
    minorSplitLine: {
      lineStyle: {
        color: '#20203B'
      }
    }
  };
};

var colorPalette = ['#4992ff', '#7cffb2', '#fddd60', '#ff6e76', '#58d9f9', '#05c091', '#ff8a45', '#8d48e3', '#dd79ff'];
var theme$1 = {
  darkMode: true,
  color: colorPalette,
  backgroundColor: backgroundColor,
  axisPointer: {
    lineStyle: {
      color: '#817f91'
    },
    crossStyle: {
      color: '#817f91'
    },
    label: {
      // TODO Contrast of label backgorundColor
      color: '#fff'
    }
  },
  legend: {
    textStyle: {
      color: contrastColor
    }
  },
  textStyle: {
    color: contrastColor
  },
  title: {
    textStyle: {
      color: '#EEF1FA'
    },
    subtextStyle: {
      color: '#B9B8CE'
    }
  },
  toolbox: {
    iconStyle: {
      borderColor: contrastColor
    }
  },
  dataZoom: {
    borderColor: '#71708A',
    textStyle: {
      color: contrastColor
    },
    brushStyle: {
      color: 'rgba(135,163,206,0.3)'
    },
    handleStyle: {
      color: '#353450',
      borderColor: '#C5CBE3'
    },
    moveHandleStyle: {
      color: '#B0B6C3',
      opacity: 0.3
    },
    fillerColor: 'rgba(135,163,206,0.2)',
    emphasis: {
      handleStyle: {
        borderColor: '#91B7F2',
        color: '#4D587D'
      },
      moveHandleStyle: {
        color: '#636D9A',
        opacity: 0.7
      }
    },
    dataBackground: {
      lineStyle: {
        color: '#71708A',
        width: 1
      },
      areaStyle: {
        color: '#71708A'
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: '#87A3CE'
      },
      areaStyle: {
        color: '#87A3CE'
      }
    }
  },
  visualMap: {
    textStyle: {
      color: contrastColor
    }
  },
  timeline: {
    lineStyle: {
      color: contrastColor
    },
    label: {
      color: contrastColor
    },
    controlStyle: {
      color: contrastColor,
      borderColor: contrastColor
    }
  },
  calendar: {
    itemStyle: {
      color: backgroundColor
    },
    dayLabel: {
      color: contrastColor
    },
    monthLabel: {
      color: contrastColor
    },
    yearLabel: {
      color: contrastColor
    }
  },
  timeAxis: axisCommon(),
  logAxis: axisCommon(),
  valueAxis: axisCommon(),
  categoryAxis: axisCommon(),
  line: {
    symbol: 'circle'
  },
  graph: {
    color: colorPalette
  },
  gauge: {
    title: {
      color: contrastColor
    },
    axisLine: {
      lineStyle: {
        color: [[1, 'rgba(207,212,219,0.2)']]
      }
    },
    axisLabel: {
      color: contrastColor
    },
    detail: {
      color: '#EEF1FA'
    }
  },
  candlestick: {
    itemStyle: {
      color: '#f64e56',
      color0: '#54ea92',
      borderColor: '#f64e56',
      borderColor0: '#54ea92' // borderColor: '#ca2824',
      // borderColor0: '#09a443'

    }
  }
};
theme$1.categoryAxis.splitLine.show = false;

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */

var ECEventProcessor =
/** @class */
function () {
  function ECEventProcessor() {}

  ECEventProcessor.prototype.normalizeQuery = function (query) {
    var cptQuery = {};
    var dataQuery = {};
    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.

    if (isString(query)) {
      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.

      cptQuery.mainType = condCptType.main || null;
      cptQuery.subType = condCptType.sub || null;
    } // `query` is an object, convert to {mainType, index, name, id}.
    else {
        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
        // can not be used in `compomentModel.filterForExposedEvent`.
        var suffixes_1 = ['Index', 'Name', 'Id'];
        var dataKeys_1 = {
          name: 1,
          dataIndex: 1,
          dataType: 1
        };
        each(query, function (val, key) {
          var reserved = false;

          for (var i = 0; i < suffixes_1.length; i++) {
            var propSuffix = suffixes_1[i];
            var suffixPos = key.lastIndexOf(propSuffix);

            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.

              if (mainType !== 'data') {
                cptQuery.mainType = mainType;
                cptQuery[propSuffix.toLowerCase()] = val;
                reserved = true;
              }
            }
          }

          if (dataKeys_1.hasOwnProperty(key)) {
            dataQuery[key] = val;
            reserved = true;
          }

          if (!reserved) {
            otherQuery[key] = val;
          }
        });
      }

    return {
      cptQuery: cptQuery,
      dataQuery: dataQuery,
      otherQuery: otherQuery
    };
  };

  ECEventProcessor.prototype.filter = function (eventType, query) {
    // They should be assigned before each trigger call.
    var eventInfo = this.eventInfo;

    if (!eventInfo) {
      return true;
    }

    var targetEl = eventInfo.targetEl;
    var packedEvent = eventInfo.packedEvent;
    var model = eventInfo.model;
    var view = eventInfo.view; // For event like 'globalout'.

    if (!model || !view) {
      return true;
    }

    var cptQuery = query.cptQuery;
    var dataQuery = query.dataQuery;
    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));

    function check(query, host, prop, propOnHost) {
      return query[prop] == null || host[propOnHost || prop] === query[prop];
    }
  };

  ECEventProcessor.prototype.afterTrigger = function () {
    // Make sure the eventInfo won't be used in next trigger.
    this.eventInfo = null;
  };

  return ECEventProcessor;
}();

var SYMBOL_PROPS_WITH_CB = ['symbol', 'symbolSize', 'symbolRotate', 'symbolOffset'];
var SYMBOL_PROPS = SYMBOL_PROPS_WITH_CB.concat(['symbolKeepAspect']); // Encoding visual for all series include which is filtered for legend drawing

var seriesSymbolTask = {
  createOnAllSeries: true,
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();

    if (seriesModel.legendIcon) {
      data.setVisual('legendIcon', seriesModel.legendIcon);
    }

    if (!seriesModel.hasSymbolVisual) {
      return;
    }

    var symbolOptions = {};
    var symbolOptionsCb = {};
    var hasCallback = false;

    for (var i = 0; i < SYMBOL_PROPS_WITH_CB.length; i++) {
      var symbolPropName = SYMBOL_PROPS_WITH_CB[i];
      var val = seriesModel.get(symbolPropName);

      if (isFunction$3(val)) {
        hasCallback = true;
        symbolOptionsCb[symbolPropName] = val;
      } else {
        symbolOptions[symbolPropName] = val;
      }
    }

    symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
    data.setVisual(extend({
      legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
      symbolKeepAspect: seriesModel.get('symbolKeepAspect')
    }, symbolOptions)); // Only visible series has each data be visual encoded

    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var symbolPropsCb = keys$2(symbolOptionsCb);

    function dataEach(data, idx) {
      var rawValue = seriesModel.getRawValue(idx);
      var params = seriesModel.getDataParams(idx);

      for (var i = 0; i < symbolPropsCb.length; i++) {
        var symbolPropName = symbolPropsCb[i];
        data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
      }
    }

    return {
      dataEach: hasCallback ? dataEach : null
    };
  }
};
var dataSymbolTask = {
  createOnAllSeries: true,
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    if (!seriesModel.hasSymbolVisual) {
      return;
    } // Only visible series has each data be visual encoded


    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();

    function dataEach(data, idx) {
      var itemModel = data.getItemModel(idx);

      for (var i = 0; i < SYMBOL_PROPS.length; i++) {
        var symbolPropName = SYMBOL_PROPS[i];
        var val = itemModel.getShallow(symbolPropName, true);

        if (val != null) {
          data.setItemVisual(idx, symbolPropName, val);
        }
      }
    }

    return {
      dataEach: data.hasItemOption ? dataEach : null
    };
  }
};

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getItemVisualFromData(data, dataIndex, key) {
  switch (key) {
    case 'color':
      var style = data.getItemVisual(dataIndex, 'style');
      return style[data.getVisual('drawType')];

    case 'opacity':
      return data.getItemVisual(dataIndex, 'style').opacity;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      return data.getItemVisual(dataIndex, key);

    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Unknown visual type " + key);
      }

  }
}
function getVisualFromData(data, key) {
  switch (key) {
    case 'color':
      var style = data.getVisual('style');
      return style[data.getVisual('drawType')];

    case 'opacity':
      return data.getVisual('style').opacity;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      return data.getVisual(key);

    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Unknown visual type " + key);
      }

  }
}
function setItemVisualFromData(data, dataIndex, key, value) {
  switch (key) {
    case 'color':
      // Make sure not sharing style object.
      var style = data.ensureUniqueItemVisual(dataIndex, 'style');
      style[data.getVisual('drawType')] = value; // Mark the color has been changed, not from palette anymore

      data.setItemVisual(dataIndex, 'colorFromPalette', false);
      break;

    case 'opacity':
      data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
      break;

    case 'symbol':
    case 'symbolSize':
    case 'liftZ':
      data.setItemVisual(dataIndex, key, value);
      break;

    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Unknown visual type " + key);
      }

  }
}

// Inlucdes: pieSelect, pieUnSelect, pieToggleSelect, mapSelect, mapUnSelect, mapToggleSelect

function createLegacyDataSelectAction(seriesType, ecRegisterAction) {
  function getSeriesIndices(ecModel, payload) {
    var seriesIndices = [];
    ecModel.eachComponent({
      mainType: 'series',
      subType: seriesType,
      query: payload
    }, function (seriesModel) {
      seriesIndices.push(seriesModel.seriesIndex);
    });
    return seriesIndices;
  }

  each([[seriesType + 'ToggleSelect', 'toggleSelect'], [seriesType + 'Select', 'select'], [seriesType + 'UnSelect', 'unselect']], function (eventsMap) {
    ecRegisterAction(eventsMap[0], function (payload, ecModel, api) {
      payload = extend({}, payload);

      if (process.env.NODE_ENV !== 'production') {
        deprecateReplaceLog(payload.type, eventsMap[1]);
      }

      api.dispatchAction(extend(payload, {
        type: eventsMap[1],
        seriesIndex: getSeriesIndices(ecModel, payload)
      }));
    });
  });
}

function handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
  var legacyEventName = type + eventPostfix;

  if (!ecIns.isSilent(legacyEventName)) {
    if (process.env.NODE_ENV !== 'production') {
      deprecateLog("event " + legacyEventName + " is deprecated.");
    }

    ecModel.eachComponent({
      mainType: 'series',
      subType: 'pie'
    }, function (seriesModel) {
      var seriesIndex = seriesModel.seriesIndex;
      var selectedMap = seriesModel.option.selectedMap;
      var selected = payload.selected;

      for (var i = 0; i < selected.length; i++) {
        if (selected[i].seriesIndex === seriesIndex) {
          var data = seriesModel.getData();
          var dataIndex = queryDataIndex(data, payload.fromActionPayload);
          ecIns.trigger(legacyEventName, {
            type: legacyEventName,
            seriesId: seriesModel.id,
            name: isArray$1(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
            selected: isString(selectedMap) ? selectedMap : extend({}, selectedMap)
          });
        }
      }
    });
  }
}

function handleLegacySelectEvents(messageCenter, ecIns, api) {
  messageCenter.on('selectchanged', function (params) {
    var ecModel = api.getModel();

    if (params.isFromClick) {
      handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
    } else if (params.fromAction === 'select') {
      handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
    } else if (params.fromAction === 'unselect') {
      handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
      handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
    }
  });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function findEventDispatcher(target, det, returnFirstMatch) {
  var found;

  while (target) {
    if (det(target)) {
      found = target;

      if (returnFirstMatch) {
        break;
      }
    }

    target = target.__hostTarget || target.parent;
  }

  return found;
}

var wmUniqueIndex = Math.round(Math.random() * 9);
var supportDefineProperty = typeof Object.defineProperty === 'function';
var WeakMap$1 = (function () {
    function WeakMap() {
        this._id = '__ec_inner_' + wmUniqueIndex++;
    }
    WeakMap.prototype.get = function (key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function (key, value) {
        var target = this._guard(key);
        if (supportDefineProperty) {
            Object.defineProperty(target, this._id, {
                value: value,
                enumerable: false,
                configurable: true
            });
        }
        else {
            target[this._id] = value;
        }
        return this;
    };
    WeakMap.prototype["delete"] = function (key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function (key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function (key) {
        if (key !== Object(key)) {
            throw TypeError('Value of WeakMap is not a non-null object.');
        }
        return key;
    };
    return WeakMap;
}());

/**
 * Triangle shape
 * @inner
 */

var Triangle = Path.extend({
  type: 'triangle',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy + height);
    path.lineTo(cx - width, cy + height);
    path.closePath();
  }
});
/**
 * Diamond shape
 * @inner
 */

var Diamond = Path.extend({
  type: 'diamond',
  shape: {
    cx: 0,
    cy: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var width = shape.width / 2;
    var height = shape.height / 2;
    path.moveTo(cx, cy - height);
    path.lineTo(cx + width, cy);
    path.lineTo(cx, cy + height);
    path.lineTo(cx - width, cy);
    path.closePath();
  }
});
/**
 * Pin shape
 * @inner
 */

var Pin$1 = Path.extend({
  type: 'pin',
  shape: {
    // x, y on the cusp
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (path, shape) {
    var x = shape.x;
    var y = shape.y;
    var w = shape.width / 5 * 3; // Height must be larger than width

    var h = Math.max(w, shape.height);
    var r = w / 2; // Dist on y with tangent point and circle center

    var dy = r * r / (h - r);
    var cy = y - h + r + dy;
    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center

    var dx = Math.cos(angle) * r;
    var tanX = Math.sin(angle);
    var tanY = Math.cos(angle);
    var cpLen = r * 0.6;
    var cpLen2 = r * 0.7;
    path.moveTo(x - dx, cy + dy);
    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
    path.closePath();
  }
});
/**
 * Arrow shape
 * @inner
 */

var Arrow$1 = Path.extend({
  type: 'arrow',
  shape: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  buildPath: function (ctx, shape) {
    var height = shape.height;
    var width = shape.width;
    var x = shape.x;
    var y = shape.y;
    var dx = width / 3 * 2;
    ctx.moveTo(x, y);
    ctx.lineTo(x + dx, y + height);
    ctx.lineTo(x, y + height / 4 * 3);
    ctx.lineTo(x - dx, y + height);
    ctx.lineTo(x, y);
    ctx.closePath();
  }
});
/**
 * Map of path constructors
 */
// TODO Use function to build symbol path.

var symbolCtors = {
  line: Line,
  rect: Rect,
  roundRect: Rect,
  square: Rect,
  circle: Circle$1,
  diamond: Diamond,
  pin: Pin$1,
  arrow: Arrow$1,
  triangle: Triangle
};
var symbolShapeMakers = {
  line: function (x, y, w, h, shape) {
    shape.x1 = x;
    shape.y1 = y + h / 2;
    shape.x2 = x + w;
    shape.y2 = y + h / 2;
  },
  rect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
  },
  roundRect: function (x, y, w, h, shape) {
    shape.x = x;
    shape.y = y;
    shape.width = w;
    shape.height = h;
    shape.r = Math.min(w, h) / 4;
  },
  square: function (x, y, w, h, shape) {
    var size = Math.min(w, h);
    shape.x = x;
    shape.y = y;
    shape.width = size;
    shape.height = size;
  },
  circle: function (x, y, w, h, shape) {
    // Put circle in the center of square
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.r = Math.min(w, h) / 2;
  },
  diamond: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  pin: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  arrow: function (x, y, w, h, shape) {
    shape.x = x + w / 2;
    shape.y = y + h / 2;
    shape.width = w;
    shape.height = h;
  },
  triangle: function (x, y, w, h, shape) {
    shape.cx = x + w / 2;
    shape.cy = y + h / 2;
    shape.width = w;
    shape.height = h;
  }
};
var symbolBuildProxies = {};
each(symbolCtors, function (Ctor, name) {
  symbolBuildProxies[name] = new Ctor();
});
var SymbolClz = Path.extend({
  type: 'symbol',
  shape: {
    symbolType: '',
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  calculateTextPosition: function (out, config, rect) {
    var res = calculateTextPosition(out, config, rect);
    var shape = this.shape;

    if (shape && shape.symbolType === 'pin' && config.position === 'inside') {
      res.y = rect.y + rect.height * 0.4;
    }

    return res;
  },
  buildPath: function (ctx, shape, inBundle) {
    var symbolType = shape.symbolType;

    if (symbolType !== 'none') {
      var proxySymbol = symbolBuildProxies[symbolType];

      if (!proxySymbol) {
        // Default rect
        symbolType = 'rect';
        proxySymbol = symbolBuildProxies[symbolType];
      }

      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
    }
  }
}); // Provide setColor helper method to avoid determine if set the fill or stroke outside

function symbolPathSetColor(color, innerColor) {
  if (this.type !== 'image') {
    var symbolStyle = this.style;

    if (this.__isEmptyBrush) {
      symbolStyle.stroke = color;
      symbolStyle.fill = innerColor || '#fff'; // TODO Same width with lineStyle in LineView

      symbolStyle.lineWidth = 2;
    } else if (this.shape.symbolType === 'line') {
      symbolStyle.stroke = color;
    } else {
      symbolStyle.fill = color;
    }

    this.markRedraw();
  }
}
/**
 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
 */


function createSymbol(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
  // TODO Support image object, DynamicImage.
  var isEmpty = symbolType.indexOf('empty') === 0;

  if (isEmpty) {
    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
  }

  var symbolPath;

  if (symbolType.indexOf('image://') === 0) {
    symbolPath = makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else if (symbolType.indexOf('path://') === 0) {
    symbolPath = makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
  } else {
    symbolPath = new SymbolClz({
      shape: {
        symbolType: symbolType,
        x: x,
        y: y,
        width: w,
        height: h
      }
    });
  }

  symbolPath.__isEmptyBrush = isEmpty; // TODO Should deprecate setColor

  symbolPath.setColor = symbolPathSetColor;

  if (color) {
    symbolPath.setColor(color);
  }

  return symbolPath;
}
function normalizeSymbolSize(symbolSize) {
  if (!isArray$1(symbolSize)) {
    symbolSize = [+symbolSize, +symbolSize];
  }

  return [symbolSize[0] || 0, symbolSize[1] || 0];
}
function normalizeSymbolOffset(symbolOffset, symbolSize) {
  if (symbolOffset == null) {
    return;
  }

  if (!isArray$1(symbolOffset)) {
    symbolOffset = [symbolOffset, symbolOffset];
  }

  return [parsePercent$1(symbolOffset[0], symbolSize[0]) || 0, parsePercent$1(retrieve2(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0];
}

function isSafeNum(num) {
    return isFinite(num);
}
function createLinearGradient(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = isSafeNum(x) ? x : 0;
    x2 = isSafeNum(x2) ? x2 : 1;
    y = isSafeNum(y) ? y : 0;
    y2 = isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function createRadialGradient(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = isSafeNum(x) ? x : 0.5;
    y = isSafeNum(y) ? y : 0.5;
    r = r >= 0 && isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function getCanvasGradient(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial'
        ? createRadialGradient(ctx, obj, rect)
        : createLinearGradient(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for (var i = 0; i < colorStops.length; i++) {
        canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    }
    return canvasGradient;
}
function isClipPathChanged(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || (!clipPaths && !prevClipPaths)) {
        return false;
    }
    if (!clipPaths || !prevClipPaths || (clipPaths.length !== prevClipPaths.length)) {
        return true;
    }
    for (var i = 0; i < clipPaths.length; i++) {
        if (clipPaths[i] !== prevClipPaths[i]) {
            return true;
        }
    }
    return false;
}
function parseInt10(val) {
    return parseInt(val, 10);
}
function getSize$2(root, whIdx, opts) {
    var wh = ['width', 'height'][whIdx];
    var cwh = ['clientWidth', 'clientHeight'][whIdx];
    var plt = ['paddingLeft', 'paddingTop'][whIdx];
    var prb = ['paddingRight', 'paddingBottom'][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') {
        return parseFloat(opts[wh]);
    }
    var stl = document.defaultView.getComputedStyle(root);
    return ((root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh]))
        - (parseInt10(stl[plt]) || 0)
        - (parseInt10(stl[prb]) || 0)) | 0;
}

function normalizeLineDash(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) {
        return null;
    }
    return lineType === 'dashed'
        ? [4 * lineWidth, 2 * lineWidth]
        : lineType === 'dotted'
            ? [lineWidth]
            : isNumber$1(lineType)
                ? [lineType] : isArray$1(lineType) ? lineType : null;
}
function getLineDash(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && normalizeLineDash(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = (style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = map(lineDash, function (rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [lineDash, lineDashOffset];
}

var pathProxyForDraw = new PathProxy(true);
function styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    }
    else {
        ctx.fill();
    }
}
function doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    }
    else {
        ctx.stroke();
    }
}
function createCanvasPattern(ctx, pattern, el) {
    var image = createOrUpdateImage(pattern.image, pattern.__image, el);
    if (isImageReady(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function'
            && canvasPattern
            && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf((pattern.x || 0), (pattern.y || 0));
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * RADIAN_TO_DEGREE);
            matrix.scaleSelf((pattern.scaleX || 1), (pattern.scaleY || 1));
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = styleHasStroke(style);
    var hasFill = styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) {
        el.createPathProxy();
    }
    var path = el.path || pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) {
            rect = el.getBoundingRect();
        }
        if (hasFillGradient) {
            fillGradient = dirtyFlag
                ? getCanvasGradient(ctx, fill, rect)
                : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag
                ? getCanvasGradient(ctx, stroke, rect)
                : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = (dirtyFlag || !el.__canvasFillPattern)
                ? createCanvasPattern(ctx, fill, el)
                : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = (dirtyFlag || !el.__canvasStrokePattern)
                ? createCanvasPattern(ctx, stroke, el)
                : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) {
            ctx.fillStyle = fillGradient;
        }
        else if (hasFillPattern) {
            if (fillPattern) {
                ctx.fillStyle = fillPattern;
            }
            else {
                hasFill = false;
            }
        }
        if (hasStrokeGradient) {
            ctx.strokeStyle = strokeGradient;
        }
        else if (hasStrokePattern) {
            if (strokePattern) {
                ctx.strokeStyle = strokePattern;
            }
            else {
                hasStroke = false;
            }
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) {
        _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
    }
    var needsRebuild = true;
    if (firstDraw || (dirtyFlag & SHAPE_CHANGED_BIT)) {
        path.setDPR(ctx.dpr);
        if (strokePart) {
            path.setContext(null);
        }
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) {
        path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    }
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) {
                doStrokePath(ctx, style);
            }
            if (hasFill) {
                doFillPath(ctx, style);
            }
        }
        else {
            if (hasFill) {
                doFillPath(ctx, style);
            }
            if (hasStroke) {
                doStrokePath(ctx, style);
            }
        }
    }
    if (lineDash) {
        ctx.setLineDash([]);
    }
}
function brushImage(ctx, el, style) {
    var image = el.__image = createOrUpdateImage(style.image, el.__image, el, el.onload);
    if (!image || !isImageReady(image)) {
        return;
    }
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) {
        width = height * aspect;
    }
    else if (height == null && width != null) {
        height = width / aspect;
    }
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    }
    else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    }
    else {
        ctx.drawImage(image, x, y, width, height);
    }
}
function brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || DEFAULT_FONT;
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) {
            _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
        }
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if (styleHasStroke(style)) {
                ctx.strokeText(text, style.x, style.y);
            }
            if (styleHasFill(style)) {
                ctx.fillText(text, style.x, style.y);
            }
        }
        else {
            if (styleHasFill(style)) {
                ctx.fillText(text, style.x, style.y);
            }
            if (styleHasStroke(style)) {
                ctx.strokeText(text, style.x, style.y);
            }
        }
        if (lineDash) {
            ctx.setLineDash([]);
        }
    }
}
var SHADOW_NUMBER_PROPS = ['shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
var STROKE_PROPS = [
    ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]
];
function bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) {
            return false;
        }
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? DEFAULT_COMMON_STYLE.opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || DEFAULT_COMMON_STYLE.blend;
    }
    for (var i = 0; i < SHADOW_NUMBER_PROPS.length; i++) {
        var propName = SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || DEFAULT_COMMON_STYLE.shadowColor;
    }
    return styleChanged;
}
function bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = getStyle(el, scope.inHover);
    var prevStyle = forceSetAll
        ? null
        : (prevEl && getStyle(prevEl, scope.inHover) || {});
    if (style === prevStyle) {
        return false;
    }
    var styleChanged = bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / ((style.strokeNoScale && el.getLineScale) ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for (var i = 0; i < STROKE_PROPS.length; i++) {
        var prop = STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return bindCommonProps(ctx, getStyle(el, scope.inHover), prevEl && getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) {
        ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    }
    else {
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
}
function updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for (var i = 0; i < clipPaths.length; i++) {
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function isTransformChanged(m0, m1) {
    if (m0 && m1) {
        return m0[0] !== m1[0]
            || m0[1] !== m1[1]
            || m0[2] !== m1[2]
            || m0[3] !== m1[3]
            || m0[4] !== m1[4]
            || m0[5] !== m1[5];
    }
    else if (!m0 && !m1) {
        return false;
    }
    return true;
}
var DRAW_TYPE_PATH = 1;
var DRAW_TYPE_IMAGE = 2;
var DRAW_TYPE_TEXT = 3;
var DRAW_TYPE_INCREMENTAL = 4;
function canPathBatch(style) {
    var hasFill = styleHasFill(style);
    var hasStroke = styleHasStroke(style);
    return !(style.lineDash
        || !(+hasFill ^ +hasStroke)
        || (hasFill && typeof style.fill !== 'string')
        || (hasStroke && typeof style.stroke !== 'string')
        || style.strokePercent < 1
        || style.strokeOpacity < 1
        || style.fillOpacity < 1);
}
function flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function getStyle(el, inHover) {
    return inHover ? (el.__hoverStyle || el.style) : el.style;
}
function brushSingle(ctx, el) {
    brush(ctx, el, { inHover: false, viewWidth: 0, viewHeight: 0 }, true);
}
function brush(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~REDRAW_BIT;
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            flushPathDrawn(ctx, scope);
            ctx.save();
            updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) {
        forceSetStyle = forceSetTransform = true;
    }
    var canBatchPath = el instanceof Path
        && el.autoBatch
        && canPathBatch(el.style);
    if (forceSetTransform || isTransformChanged(m, prevEl.transform)) {
        flushPathDrawn(ctx, scope);
        setContextTransform(ctx, el);
    }
    else if (!canBatchPath) {
        flushPathDrawn(ctx, scope);
    }
    var style = getStyle(el, scope.inHover);
    if (el instanceof Path) {
        if (scope.lastDrawType !== DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = DRAW_TYPE_PATH;
        }
        bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || (!scope.batchFill && !scope.batchStroke)) {
            ctx.beginPath();
        }
        brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    }
    else {
        if (el instanceof TSpan) {
            if (scope.lastDrawType !== DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_TEXT;
            }
            bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            brushText(ctx, el, style);
        }
        else if (el instanceof ZRImage) {
            if (scope.lastDrawType !== DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_IMAGE;
            }
            bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            brushImage(ctx, el, style);
        }
        else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = DRAW_TYPE_INCREMENTAL;
            }
            brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) {
        flushPathDrawn(ctx, scope);
    }
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for (i = el.getCursor(), len = displayables.length; i < len; i++) {
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        brush(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for (var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++) {
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        brush(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}

var decalMap = new WeakMap$1();
var decalCache = new LRU(100);
var decalKeys = ['symbol', 'symbolSize', 'symbolKeepAspect', 'color', 'backgroundColor', 'dashArrayX', 'dashArrayY', 'maxTileWidth', 'maxTileHeight'];
/**
 * Create or update pattern image from decal options
 *
 * @param {InnerDecalObject | 'none'} decalObject decal options, 'none' if no decal
 * @return {Pattern} pattern with generated image, null if no decal
 */

function createOrUpdatePatternFromDecal(decalObject, api) {
  if (decalObject === 'none') {
    return null;
  }

  var dpr = api.getDevicePixelRatio();
  var zr = api.getZr();
  var isSVG = zr.painter.type === 'svg';

  if (decalObject.dirty) {
    decalMap["delete"](decalObject);
  }

  var oldPattern = decalMap.get(decalObject);

  if (oldPattern) {
    return oldPattern;
  }

  var decalOpt = defaults(decalObject, {
    symbol: 'rect',
    symbolSize: 1,
    symbolKeepAspect: true,
    color: 'rgba(0, 0, 0, 0.2)',
    backgroundColor: null,
    dashArrayX: 5,
    dashArrayY: 5,
    rotation: 0,
    maxTileWidth: 512,
    maxTileHeight: 512
  });

  if (decalOpt.backgroundColor === 'none') {
    decalOpt.backgroundColor = null;
  }

  var pattern = {
    repeat: 'repeat'
  };
  setPatternnSource(pattern);
  pattern.rotation = decalOpt.rotation;
  pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
  decalMap.set(decalObject, pattern);
  decalObject.dirty = false;
  return pattern;

  function setPatternnSource(pattern) {
    var keys = [dpr];
    var isValidKey = true;

    for (var i = 0; i < decalKeys.length; ++i) {
      var value = decalOpt[decalKeys[i]];

      if (value != null && !isArray$1(value) && !isString(value) && !isNumber$1(value) && typeof value !== 'boolean') {
        isValidKey = false;
        break;
      }

      keys.push(value);
    }

    var cacheKey;

    if (isValidKey) {
      cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
      var cache = decalCache.get(cacheKey);

      if (cache) {
        isSVG ? pattern.svgElement = cache : pattern.image = cache;
      }
    }

    var dashArrayX = normalizeDashArrayX(decalOpt.dashArrayX);
    var dashArrayY = normalizeDashArrayY(decalOpt.dashArrayY);
    var symbolArray = normalizeSymbolArray(decalOpt.symbol);
    var lineBlockLengthsX = getLineBlockLengthX(dashArrayX);
    var lineBlockLengthY = getLineBlockLengthY(dashArrayY);
    var canvas = !isSVG && platformApi.createCanvas();
    var svgRoot = isSVG && {
      tag: 'g',
      attrs: {},
      key: 'dcl',
      children: []
    };
    var pSize = getPatternSize();
    var ctx;

    if (canvas) {
      canvas.width = pSize.width * dpr;
      canvas.height = pSize.height * dpr;
      ctx = canvas.getContext('2d');
    }

    brushDecal();

    if (isValidKey) {
      decalCache.put(cacheKey, canvas || svgRoot);
    }

    pattern.image = canvas;
    pattern.svgElement = svgRoot;
    pattern.svgWidth = pSize.width;
    pattern.svgHeight = pSize.height;
    /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */

    function getPatternSize() {
      /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */
      var width = 1;

      for (var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i) {
        width = getLeastCommonMultiple(width, lineBlockLengthsX[i]);
      }

      var symbolRepeats = 1;

      for (var i = 0, xlen = symbolArray.length; i < xlen; ++i) {
        symbolRepeats = getLeastCommonMultiple(symbolRepeats, symbolArray[i].length);
      }

      width *= symbolRepeats;
      var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;

      if (process.env.NODE_ENV !== 'production') {
        var warn = function (attrName) {
          /* eslint-disable-next-line */
          console.warn("Calculated decal size is greater than " + attrName + " due to decal option settings so " + attrName + " is used for the decal size. Please consider changing the decal option to make a smaller decal or set " + attrName + " to be larger to avoid incontinuity.");
        };

        if (width > decalOpt.maxTileWidth) {
          warn('maxTileWidth');
        }

        if (height > decalOpt.maxTileHeight) {
          warn('maxTileHeight');
        }
      }

      return {
        width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
        height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
      };
    }

    function brushDecal() {
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (decalOpt.backgroundColor) {
          ctx.fillStyle = decalOpt.backgroundColor;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
      }

      var ySum = 0;

      for (var i = 0; i < dashArrayY.length; ++i) {
        ySum += dashArrayY[i];
      }

      if (ySum <= 0) {
        // dashArrayY is 0, draw nothing
        return;
      }

      var y = -lineBlockLengthY;
      var yId = 0;
      var yIdTotal = 0;
      var xId0 = 0;

      while (y < pSize.height) {
        if (yId % 2 === 0) {
          var symbolYId = yIdTotal / 2 % symbolArray.length;
          var x = 0;
          var xId1 = 0;
          var xId1Total = 0;

          while (x < pSize.width * 2) {
            var xSum = 0;

            for (var i = 0; i < dashArrayX[xId0].length; ++i) {
              xSum += dashArrayX[xId0][i];
            }

            if (xSum <= 0) {
              // Skip empty line
              break;
            } // E.g., [15, 5, 20, 5] draws only for 15 and 20


            if (xId1 % 2 === 0) {
              var size = (1 - decalOpt.symbolSize) * 0.5;
              var left = x + dashArrayX[xId0][xId1] * size;
              var top_1 = y + dashArrayY[yId] * size;
              var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
              var height = dashArrayY[yId] * decalOpt.symbolSize;
              var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
              brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
            }

            x += dashArrayX[xId0][xId1];
            ++xId1Total;
            ++xId1;

            if (xId1 === dashArrayX[xId0].length) {
              xId1 = 0;
            }
          }

          ++xId0;

          if (xId0 === dashArrayX.length) {
            xId0 = 0;
          }
        }

        y += dashArrayY[yId];
        ++yIdTotal;
        ++yId;

        if (yId === dashArrayY.length) {
          yId = 0;
        }
      }

      function brushSymbol(x, y, width, height, symbolType) {
        var scale = isSVG ? 1 : dpr;
        var symbol = createSymbol(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);

        if (isSVG) {
          var symbolVNode = zr.painter.renderOneToVNode(symbol);

          if (symbolVNode) {
            svgRoot.children.push(symbolVNode);
          }
        } else {
          // Paint to canvas for all other renderers.
          brushSingle(ctx, symbol);
        }
      }
    }
  }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */

function normalizeSymbolArray(symbol) {
  if (!symbol || symbol.length === 0) {
    return [['rect']];
  }

  if (isString(symbol)) {
    return [[symbol]];
  }

  var isAllString = true;

  for (var i = 0; i < symbol.length; ++i) {
    if (!isString(symbol[i])) {
      isAllString = false;
      break;
    }
  }

  if (isAllString) {
    return normalizeSymbolArray([symbol]);
  }

  var result = [];

  for (var i = 0; i < symbol.length; ++i) {
    if (isString(symbol[i])) {
      result.push([symbol[i]]);
    } else {
      result.push(symbol[i]);
    }
  }

  return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */


function normalizeDashArrayX(dash) {
  if (!dash || dash.length === 0) {
    return [[0, 0]];
  }

  if (isNumber$1(dash)) {
    var dashValue = Math.ceil(dash);
    return [[dashValue, dashValue]];
  }
  /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */


  var isAllNumber = true;

  for (var i = 0; i < dash.length; ++i) {
    if (!isNumber$1(dash[i])) {
      isAllNumber = false;
      break;
    }
  }

  if (isAllNumber) {
    return normalizeDashArrayX([dash]);
  }

  var result = [];

  for (var i = 0; i < dash.length; ++i) {
    if (isNumber$1(dash[i])) {
      var dashValue = Math.ceil(dash[i]);
      result.push([dashValue, dashValue]);
    } else {
      var dashValue = map(dash[i], function (n) {
        return Math.ceil(n);
      });

      if (dashValue.length % 2 === 1) {
        // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
      } else {
        result.push(dashValue);
      }
    }
  }

  return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */


function normalizeDashArrayY(dash) {
  if (!dash || typeof dash === 'object' && dash.length === 0) {
    return [0, 0];
  }

  if (isNumber$1(dash)) {
    var dashValue_1 = Math.ceil(dash);
    return [dashValue_1, dashValue_1];
  }

  var dashValue = map(dash, function (n) {
    return Math.ceil(n);
  });
  return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */


function getLineBlockLengthX(dash) {
  return map(dash, function (line) {
    return getLineBlockLengthY(line);
  });
}

function getLineBlockLengthY(dash) {
  var blockLength = 0;

  for (var i = 0; i < dash.length; ++i) {
    blockLength += dash[i];
  }

  if (dash.length % 2 === 1) {
    // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
  }

  return blockLength;
}

function decalVisual(ecModel, api) {
  ecModel.eachRawSeries(function (seriesModel) {
    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var data = seriesModel.getData();

    if (data.hasItemVisual()) {
      data.each(function (idx) {
        var decal = data.getItemVisual(idx, 'decal');

        if (decal) {
          var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
          itemStyle.decal = createOrUpdatePatternFromDecal(decal, api);
        }
      });
    }

    var decal = data.getVisual('decal');

    if (decal) {
      var style = data.getVisual('style');
      style.decal = createOrUpdatePatternFromDecal(decal, api);
    }
  });
}

var lifecycle = new Eventful();

// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.

var implsStore = {}; // TODO Type

function registerImpl(name, impl) {
  if (process.env.NODE_ENV !== 'production') {
    if (implsStore[name]) {
      error("Already has an implementation of " + name + ".");
    }
  }

  implsStore[name] = impl;
}
function getImpl(name) {
  if (process.env.NODE_ENV !== 'production') {
    if (!implsStore[name]) {
      error("Implementation of " + name + " doesn't exists.");
    }
  }

  return implsStore[name];
}

var version$1 = '5.4.1';
var dependencies = {
  zrender: '5.4.1'
};
var TEST_FRAME_REMAIN_TIME = 1;
var PRIORITY_PROCESSOR_SERIES_FILTER = 800; // Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.

var PRIORITY_PROCESSOR_DATASTACK = 900; // "Data filter" will block the stream, so it should be
// put at the beginning of data processing.

var PRIORITY_PROCESSOR_FILTER = 1000;
var PRIORITY_PROCESSOR_DEFAULT = 2000;
var PRIORITY_PROCESSOR_STATISTIC = 5000;
var PRIORITY_VISUAL_LAYOUT = 1000;
var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var PRIORITY_VISUAL_GLOBAL = 2000;
var PRIORITY_VISUAL_CHART = 3000;
var PRIORITY_VISUAL_COMPONENT = 4000; // Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)

var PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500; // Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.

var PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var PRIORITY_VISUAL_BRUSH = 5000;
var PRIORITY_VISUAL_ARIA = 6000;
var PRIORITY_VISUAL_DECAL = 7000;
var PRIORITY = {
  PROCESSOR: {
    FILTER: PRIORITY_PROCESSOR_FILTER,
    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
  },
  VISUAL: {
    LAYOUT: PRIORITY_VISUAL_LAYOUT,
    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
    GLOBAL: PRIORITY_VISUAL_GLOBAL,
    CHART: PRIORITY_VISUAL_CHART,
    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
    COMPONENT: PRIORITY_VISUAL_COMPONENT,
    BRUSH: PRIORITY_VISUAL_BRUSH,
    CHART_ITEM: PRIORITY_VISUAL_CHART_DATA_CUSTOM,
    ARIA: PRIORITY_VISUAL_ARIA,
    DECAL: PRIORITY_VISUAL_DECAL
  }
}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).

var IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var PENDING_UPDATE = '__pendingUpdate';
var STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var ACTION_REG = /^[a-zA-Z0-9_]+$/;
var CONNECT_STATUS_KEY = '__connectUpdateStatus';
var CONNECT_STATUS_PENDING = 0;
var CONNECT_STATUS_UPDATING = 1;
var CONNECT_STATUS_UPDATED = 2;

function createRegisterEventWithLowercaseECharts(method) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    if (this.isDisposed()) {
      disposedWarning(this.id);
      return;
    }

    return toLowercaseNameAndCallEventful(this, method, args);
  };
}

function createRegisterEventWithLowercaseMessageCenter(method) {
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return toLowercaseNameAndCallEventful(this, method, args);
  };
}

function toLowercaseNameAndCallEventful(host, method, args) {
  // `args[0]` is event name. Event name is all lowercase.
  args[0] = args[0] && args[0].toLowerCase();
  return Eventful.prototype[method].apply(host, args);
}

var MessageCenter =
/** @class */
function (_super) {
  __extends$1(MessageCenter, _super);

  function MessageCenter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return MessageCenter;
}(Eventful);

var messageCenterProto = MessageCenter.prototype;
messageCenterProto.on = createRegisterEventWithLowercaseMessageCenter('on');
messageCenterProto.off = createRegisterEventWithLowercaseMessageCenter('off'); // ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------

var prepare$1;
var prepareView;
var updateDirectly;
var updateMethods;
var doConvertPixel;
var updateStreamModes;
var doDispatchAction;
var flushPendingActions;
var triggerUpdatedEvent;
var bindRenderedEvent;
var bindMouseEvent;
var render;
var renderComponents;
var renderSeries;
var createExtensionAPI;
var enableConnect;
var markStatusToUpdate;
var applyChangedStates;

var ECharts =
/** @class */
function (_super) {
  __extends$1(ECharts, _super);

  function ECharts(dom, // Theme name or themeOption.
  theme, opts) {
    var _this = _super.call(this, new ECEventProcessor()) || this;

    _this._chartsViews = [];
    _this._chartsMap = {};
    _this._componentsViews = [];
    _this._componentsMap = {}; // Can't dispatch action during rendering procedure

    _this._pendingActions = [];
    opts = opts || {}; // Get theme by name

    if (isString(theme)) {
      theme = themeStorage[theme];
    }

    _this._dom = dom;
    var defaultRenderer = 'canvas';
    var defaultCoarsePointer = 'auto';
    var defaultUseDirtyRect = false;

    if (process.env.NODE_ENV !== 'production') {
      var root =
      /* eslint-disable-next-line */
      env.hasGlobalWindow ? window : global;
      defaultRenderer = root.__ECHARTS__DEFAULT__RENDERER__ || defaultRenderer;
      defaultCoarsePointer = retrieve2(root.__ECHARTS__DEFAULT__COARSE_POINTER, defaultCoarsePointer);
      var devUseDirtyRect = root.__ECHARTS__DEFAULT__USE_DIRTY_RECT__;
      defaultUseDirtyRect = devUseDirtyRect == null ? defaultUseDirtyRect : devUseDirtyRect;
    }

    var zr = _this._zr = init(dom, {
      renderer: opts.renderer || defaultRenderer,
      devicePixelRatio: opts.devicePixelRatio,
      width: opts.width,
      height: opts.height,
      ssr: opts.ssr,
      useDirtyRect: retrieve2(opts.useDirtyRect, defaultUseDirtyRect),
      useCoarsePointer: retrieve2(opts.useCoarsePointer, defaultCoarsePointer),
      pointerSize: opts.pointerSize
    });
    _this._ssr = opts.ssr; // Expect 60 fps.

    _this._throttledZrFlush = throttle$1(bind(zr.flush, zr), 17);
    theme = clone(theme);
    theme && globalBackwardCompat(theme, true);
    _this._theme = theme;
    _this._locale = createLocaleObject(opts.locale || SYSTEM_LANG);
    _this._coordSysMgr = new CoordinateSystemManager();
    var api = _this._api = createExtensionAPI(_this); // Sort on demand

    function prioritySortFunc(a, b) {
      return a.__prio - b.__prio;
    }

    sort(visualFuncs, prioritySortFunc);
    sort(dataProcessorFuncs, prioritySortFunc);
    _this._scheduler = new Scheduler(_this, api, dataProcessorFuncs, visualFuncs);
    _this._messageCenter = new MessageCenter(); // Init mouse events

    _this._initEvents(); // In case some people write `window.onresize = chart.resize`


    _this.resize = bind(_this.resize, _this);
    zr.animation.on('frame', _this._onframe, _this);
    bindRenderedEvent(zr, _this);
    bindMouseEvent(zr, _this); // ECharts instance can be used as value.

    setAsPrimitive(_this);
    return _this;
  }

  ECharts.prototype._onframe = function () {
    if (this._disposed) {
      return;
    }

    applyChangedStates(this);
    var scheduler = this._scheduler; // Lazy update

    if (this[PENDING_UPDATE]) {
      var silent = this[PENDING_UPDATE].silent;
      this[IN_MAIN_PROCESS_KEY] = true;

      try {
        prepare$1(this);
        updateMethods.update.call(this, null, this[PENDING_UPDATE].updateParams);
      } catch (e) {
        this[IN_MAIN_PROCESS_KEY] = false;
        this[PENDING_UPDATE] = null;
        throw e;
      } // At present, in each frame, zrender performs:
      //   (1) animation step forward.
      //   (2) trigger('frame') (where this `_onframe` is called)
      //   (3) zrender flush (render).
      // If we do nothing here, since we use `setToFinal: true`, the step (3) above
      // will render the final state of the elements before the real animation started.


      this._zr.flush();

      this[IN_MAIN_PROCESS_KEY] = false;
      this[PENDING_UPDATE] = null;
      flushPendingActions.call(this, silent);
      triggerUpdatedEvent.call(this, silent);
    } // Avoid do both lazy update and progress in one frame.
    else if (scheduler.unfinished) {
        // Stream progress.
        var remainTime = TEST_FRAME_REMAIN_TIME;
        var ecModel = this._model;
        var api = this._api;
        scheduler.unfinished = false;

        do {
          var startTime = +new Date();
          scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.

          scheduler.performDataProcessorTasks(ecModel);
          updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
          // each frame is not a good user experience. So we follow the rule that
          // the extent of the coordinate system is determined in the first frame (the
          // frame is executed immediately after task reset.
          // this._coordSysMgr.update(ecModel, api);
          // console.log('--- ec frame visual ---', remainTime);

          scheduler.performVisualTasks(ecModel);
          renderSeries(this, this._model, api, 'remain', {});
          remainTime -= +new Date() - startTime;
        } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.


        if (!scheduler.unfinished) {
          this._zr.flush();
        } // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.

      }
  };

  ECharts.prototype.getDom = function () {
    return this._dom;
  };

  ECharts.prototype.getId = function () {
    return this.id;
  };

  ECharts.prototype.getZr = function () {
    return this._zr;
  };

  ECharts.prototype.isSSR = function () {
    return this._ssr;
  };
  /* eslint-disable-next-line */


  ECharts.prototype.setOption = function (option, notMerge, lazyUpdate) {
    if (this[IN_MAIN_PROCESS_KEY]) {
      if (process.env.NODE_ENV !== 'production') {
        error('`setOption` should not be called during main process.');
      }

      return;
    }

    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var silent;
    var replaceMerge;
    var transitionOpt;

    if (isObject$2(notMerge)) {
      lazyUpdate = notMerge.lazyUpdate;
      silent = notMerge.silent;
      replaceMerge = notMerge.replaceMerge;
      transitionOpt = notMerge.transition;
      notMerge = notMerge.notMerge;
    }

    this[IN_MAIN_PROCESS_KEY] = true;

    if (!this._model || notMerge) {
      var optionManager = new OptionManager(this._api);
      var theme = this._theme;
      var ecModel = this._model = new GlobalModel();
      ecModel.scheduler = this._scheduler;
      ecModel.ssr = this._ssr;
      ecModel.init(null, null, null, theme, this._locale, optionManager);
    }

    this._model.setOption(option, {
      replaceMerge: replaceMerge
    }, optionPreprocessorFuncs);

    var updateParams = {
      seriesTransition: transitionOpt,
      optionChanged: true
    };

    if (lazyUpdate) {
      this[PENDING_UPDATE] = {
        silent: silent,
        updateParams: updateParams
      };
      this[IN_MAIN_PROCESS_KEY] = false; // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
      // It should wake it up to make sure zrender start to render at the next frame.

      this.getZr().wakeUp();
    } else {
      try {
        prepare$1(this);
        updateMethods.update.call(this, null, updateParams);
      } catch (e) {
        this[PENDING_UPDATE] = null;
        this[IN_MAIN_PROCESS_KEY] = false;
        throw e;
      } // Ensure zr refresh sychronously, and then pixel in canvas can be
      // fetched after `setOption`.


      if (!this._ssr) {
        // not use flush when using ssr mode.
        this._zr.flush();
      }

      this[PENDING_UPDATE] = null;
      this[IN_MAIN_PROCESS_KEY] = false;
      flushPendingActions.call(this, silent);
      triggerUpdatedEvent.call(this, silent);
    }
  };
  /**
   * @deprecated
   */


  ECharts.prototype.setTheme = function () {
    deprecateLog('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
  }; // We don't want developers to use getModel directly.


  ECharts.prototype.getModel = function () {
    return this._model;
  };

  ECharts.prototype.getOption = function () {
    return this._model && this._model.getOption();
  };

  ECharts.prototype.getWidth = function () {
    return this._zr.getWidth();
  };

  ECharts.prototype.getHeight = function () {
    return this._zr.getHeight();
  };

  ECharts.prototype.getDevicePixelRatio = function () {
    return this._zr.painter.dpr
    /* eslint-disable-next-line */
    || env.hasGlobalWindow && window.devicePixelRatio || 1;
  };
  /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */


  ECharts.prototype.getRenderedCanvas = function (opts) {
    if (process.env.NODE_ENV !== 'production') {
      deprecateReplaceLog('getRenderedCanvas', 'renderToCanvas');
    }

    return this.renderToCanvas(opts);
  };

  ECharts.prototype.renderToCanvas = function (opts) {
    opts = opts || {};
    var painter = this._zr.painter;

    if (process.env.NODE_ENV !== 'production') {
      if (painter.type !== 'canvas') {
        throw new Error('renderToCanvas can only be used in the canvas renderer.');
      }
    }

    return painter.getRenderedCanvas({
      backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
      pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
    });
  };

  ECharts.prototype.renderToSVGString = function (opts) {
    opts = opts || {};
    var painter = this._zr.painter;

    if (process.env.NODE_ENV !== 'production') {
      if (painter.type !== 'svg') {
        throw new Error('renderToSVGString can only be used in the svg renderer.');
      }
    }

    return painter.renderToString({
      useViewBox: opts.useViewBox
    });
  };
  /**
   * Get svg data url
   */


  ECharts.prototype.getSvgDataURL = function () {
    if (!env.svgSupported) {
      return;
    }

    var zr = this._zr;
    var list = zr.storage.getDisplayList(); // Stop animations

    each(list, function (el) {
      el.stopAnimation(null, true);
    });
    return zr.painter.toDataURL();
  };

  ECharts.prototype.getDataURL = function (opts) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    opts = opts || {};
    var excludeComponents = opts.excludeComponents;
    var ecModel = this._model;
    var excludesComponentViews = [];
    var self = this;
    each(excludeComponents, function (componentType) {
      ecModel.eachComponent({
        mainType: componentType
      }, function (component) {
        var view = self._componentsMap[component.__viewId];

        if (!view.group.ignore) {
          excludesComponentViews.push(view);
          view.group.ignore = true;
        }
      });
    });
    var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
    each(excludesComponentViews, function (view) {
      view.group.ignore = false;
    });
    return url;
  };

  ECharts.prototype.getConnectedDataURL = function (opts) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var isSvg = opts.type === 'svg';
    var groupId = this.group;
    var mathMin = Math.min;
    var mathMax = Math.max;
    var MAX_NUMBER = Infinity;

    if (connectedGroups[groupId]) {
      var left_1 = MAX_NUMBER;
      var top_1 = MAX_NUMBER;
      var right_1 = -MAX_NUMBER;
      var bottom_1 = -MAX_NUMBER;
      var canvasList_1 = [];
      var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
      each(instances$1, function (chart, id) {
        if (chart.group === groupId) {
          var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas(clone(opts));
          var boundingRect = chart.getDom().getBoundingClientRect();
          left_1 = mathMin(boundingRect.left, left_1);
          top_1 = mathMin(boundingRect.top, top_1);
          right_1 = mathMax(boundingRect.right, right_1);
          bottom_1 = mathMax(boundingRect.bottom, bottom_1);
          canvasList_1.push({
            dom: canvas,
            left: boundingRect.left,
            top: boundingRect.top
          });
        }
      });
      left_1 *= dpr_1;
      top_1 *= dpr_1;
      right_1 *= dpr_1;
      bottom_1 *= dpr_1;
      var width = right_1 - left_1;
      var height = bottom_1 - top_1;
      var targetCanvas = platformApi.createCanvas();
      var zr_1 = init(targetCanvas, {
        renderer: isSvg ? 'svg' : 'canvas'
      });
      zr_1.resize({
        width: width,
        height: height
      });

      if (isSvg) {
        var content_1 = '';
        each(canvasList_1, function (item) {
          var x = item.left - left_1;
          var y = item.top - top_1;
          content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
        });
        zr_1.painter.getSvgRoot().innerHTML = content_1;

        if (opts.connectedBackgroundColor) {
          zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
        }

        zr_1.refreshImmediately();
        return zr_1.painter.toDataURL();
      } else {
        // Background between the charts
        if (opts.connectedBackgroundColor) {
          zr_1.add(new Rect({
            shape: {
              x: 0,
              y: 0,
              width: width,
              height: height
            },
            style: {
              fill: opts.connectedBackgroundColor
            }
          }));
        }

        each(canvasList_1, function (item) {
          var img = new ZRImage({
            style: {
              x: item.left * dpr_1 - left_1,
              y: item.top * dpr_1 - top_1,
              image: item.dom
            }
          });
          zr_1.add(img);
        });
        zr_1.refreshImmediately();
        return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
      }
    } else {
      return this.getDataURL(opts);
    }
  };

  ECharts.prototype.convertToPixel = function (finder, value) {
    return doConvertPixel(this, 'convertToPixel', finder, value);
  };

  ECharts.prototype.convertFromPixel = function (finder, value) {
    return doConvertPixel(this, 'convertFromPixel', finder, value);
  };
  /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */


  ECharts.prototype.containPixel = function (finder, value) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var ecModel = this._model;
    var result;
    var findResult = parseFinder(ecModel, finder);
    each(findResult, function (models, key) {
      key.indexOf('Models') >= 0 && each(models, function (model) {
        var coordSys = model.coordinateSystem;

        if (coordSys && coordSys.containPoint) {
          result = result || !!coordSys.containPoint(value);
        } else if (key === 'seriesModels') {
          var view = this._chartsMap[model.__viewId];

          if (view && view.containPoint) {
            result = result || view.containPoint(value, model);
          } else {
            if (process.env.NODE_ENV !== 'production') {
              warn(key + ': ' + (view ? 'The found component do not support containPoint.' : 'No view mapping to the found component.'));
            }
          }
        } else {
          if (process.env.NODE_ENV !== 'production') {
            warn(key + ': containPoint is not supported');
          }
        }
      }, this);
    }, this);
    return !!result;
  };
  /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */


  ECharts.prototype.getVisual = function (finder, visualType) {
    var ecModel = this._model;
    var parsedFinder = parseFinder(ecModel, finder, {
      defaultMainType: 'series'
    });
    var seriesModel = parsedFinder.seriesModel;

    if (process.env.NODE_ENV !== 'production') {
      if (!seriesModel) {
        warn('There is no specified series model');
      }
    }

    var data = seriesModel.getData();
    var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
    return dataIndexInside != null ? getItemVisualFromData(data, dataIndexInside, visualType) : getVisualFromData(data, visualType);
  };
  /**
   * Get view of corresponding component model
   */


  ECharts.prototype.getViewOfComponentModel = function (componentModel) {
    return this._componentsMap[componentModel.__viewId];
  };
  /**
   * Get view of corresponding series model
   */


  ECharts.prototype.getViewOfSeriesModel = function (seriesModel) {
    return this._chartsMap[seriesModel.__viewId];
  };

  ECharts.prototype._initEvents = function () {
    var _this = this;

    each(MOUSE_EVENT_NAMES, function (eveName) {
      var handler = function (e) {
        var ecModel = _this.getModel();

        var el = e.target;
        var params;
        var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.

        if (isGlobalOut) {
          params = {};
        } else {
          el && findEventDispatcher(el, function (parent) {
            var ecData = getECData(parent);

            if (ecData && ecData.dataIndex != null) {
              var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
              params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType) || {};
              return true;
            } // If element has custom eventData of components
            else if (ecData.eventData) {
                params = extend({}, ecData.eventData);
                return true;
              }
          }, true);
        } // Contract: if params prepared in mouse event,
        // these properties must be specified:
        // {
        //    componentType: string (component main type)
        //    componentIndex: number
        // }
        // Otherwise event query can not work.


        if (params) {
          var componentType = params.componentType;
          var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
          // markLine/markPoint/markArea, the componentType is
          // 'markLine'/'markPoint'/'markArea', but we should better
          // enable them to be queried by seriesIndex, since their
          // option is set in each series.

          if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
            componentType = 'series';
            componentIndex = params.seriesIndex;
          }

          var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
          var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];

          if (process.env.NODE_ENV !== 'production') {
            // `event.componentType` and `event[componentTpype + 'Index']` must not
            // be missed, otherwise there is no way to distinguish source component.
            // See `dataFormat.getDataParams`.
            if (!isGlobalOut && !(model && view)) {
              warn('model or view can not be found by params');
            }
          }

          params.event = e;
          params.type = eveName;
          _this._$eventProcessor.eventInfo = {
            targetEl: el,
            packedEvent: params,
            model: model,
            view: view
          };

          _this.trigger(eveName, params);
        }
      }; // Consider that some component (like tooltip, brush, ...)
      // register zr event handler, but user event handler might
      // do anything, such as call `setOption` or `dispatchAction`,
      // which probably update any of the content and probably
      // cause problem if it is called previous other inner handlers.


      handler.zrEventfulCallAtLast = true;

      _this._zr.on(eveName, handler, _this);
    });
    each(eventActionMap, function (actionType, eventType) {
      _this._messageCenter.on(eventType, function (event) {
        this.trigger(eventType, event);
      }, _this);
    }); // Extra events
    // TODO register?

    each(['selectchanged'], function (eventType) {
      _this._messageCenter.on(eventType, function (event) {
        this.trigger(eventType, event);
      }, _this);
    });
    handleLegacySelectEvents(this._messageCenter, this, this._api);
  };

  ECharts.prototype.isDisposed = function () {
    return this._disposed;
  };

  ECharts.prototype.clear = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this.setOption({
      series: []
    }, true);
  };

  ECharts.prototype.dispose = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._disposed = true;
    var dom = this.getDom();

    if (dom) {
      setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
    }

    var chart = this;
    var api = chart._api;
    var ecModel = chart._model;
    each(chart._componentsViews, function (component) {
      component.dispose(ecModel, api);
    });
    each(chart._chartsViews, function (chart) {
      chart.dispose(ecModel, api);
    }); // Dispose after all views disposed

    chart._zr.dispose(); // Set properties to null.
    // To reduce the memory cost in case the top code still holds this instance unexpectedly.


    chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
    delete instances$1[chart.id];
  };
  /**
   * Resize the chart
   */


  ECharts.prototype.resize = function (opts) {
    if (this[IN_MAIN_PROCESS_KEY]) {
      if (process.env.NODE_ENV !== 'production') {
        error('`resize` should not be called during main process.');
      }

      return;
    }

    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._zr.resize(opts);

    var ecModel = this._model; // Resize loading effect

    this._loadingFX && this._loadingFX.resize();

    if (!ecModel) {
      return;
    }

    var needPrepare = ecModel.resetOption('media');
    var silent = opts && opts.silent; // There is some real cases that:
    // chart.setOption(option, { lazyUpdate: true });
    // chart.resize();

    if (this[PENDING_UPDATE]) {
      if (silent == null) {
        silent = this[PENDING_UPDATE].silent;
      }

      needPrepare = true;
      this[PENDING_UPDATE] = null;
    }

    this[IN_MAIN_PROCESS_KEY] = true;

    try {
      needPrepare && prepare$1(this);
      updateMethods.update.call(this, {
        type: 'resize',
        animation: extend({
          // Disable animation
          duration: 0
        }, opts && opts.animation)
      });
    } catch (e) {
      this[IN_MAIN_PROCESS_KEY] = false;
      throw e;
    }

    this[IN_MAIN_PROCESS_KEY] = false;
    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  };

  ECharts.prototype.showLoading = function (name, cfg) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    if (isObject$2(name)) {
      cfg = name;
      name = '';
    }

    name = name || 'default';
    this.hideLoading();

    if (!loadingEffects[name]) {
      if (process.env.NODE_ENV !== 'production') {
        warn('Loading effects ' + name + ' not exists.');
      }

      return;
    }

    var el = loadingEffects[name](this._api, cfg);
    var zr = this._zr;
    this._loadingFX = el;
    zr.add(el);
  };
  /**
   * Hide loading effect
   */


  ECharts.prototype.hideLoading = function () {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    this._loadingFX && this._zr.remove(this._loadingFX);
    this._loadingFX = null;
  };

  ECharts.prototype.makeActionFromEvent = function (eventObj) {
    var payload = extend({}, eventObj);
    payload.type = eventActionMap[eventObj.type];
    return payload;
  };
  /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */


  ECharts.prototype.dispatchAction = function (payload, opt) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    if (!isObject$2(opt)) {
      opt = {
        silent: !!opt
      };
    }

    if (!actions[payload.type]) {
      return;
    } // Avoid dispatch action before setOption. Especially in `connect`.


    if (!this._model) {
      return;
    } // May dispatchAction in rendering procedure


    if (this[IN_MAIN_PROCESS_KEY]) {
      this._pendingActions.push(payload);

      return;
    }

    var silent = opt.silent;
    doDispatchAction.call(this, payload, silent);
    var flush = opt.flush;

    if (flush) {
      this._zr.flush();
    } else if (flush !== false && env.browser.weChat) {
      // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
      // hang when sliding page (on touch event), which cause that zr does not
      // refresh until user interaction finished, which is not expected.
      // But `dispatchAction` may be called too frequently when pan on touch
      // screen, which impacts performance if do not throttle them.
      this._throttledZrFlush();
    }

    flushPendingActions.call(this, silent);
    triggerUpdatedEvent.call(this, silent);
  };

  ECharts.prototype.updateLabelLayout = function () {
    lifecycle.trigger('series:layoutlabels', this._model, this._api, {
      // Not adding series labels.
      // TODO
      updatedSeries: []
    });
  };

  ECharts.prototype.appendData = function (params) {
    if (this._disposed) {
      disposedWarning(this.id);
      return;
    }

    var seriesIndex = params.seriesIndex;
    var ecModel = this.getModel();
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (process.env.NODE_ENV !== 'production') {
      assert(params.data && seriesModel);
    }

    seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
    // system, util some scenario require that. In the expected usage of
    // `appendData`, the initial extent of coordinate system should better
    // be fixed by axis `min`/`max` setting or initial data, otherwise if
    // the extent changed while `appendData`, the location of the painted
    // graphic elements have to be changed, which make the usage of
    // `appendData` meaningless.

    this._scheduler.unfinished = true;
    this.getZr().wakeUp();
  }; // A work around for no `internal` modifier in ts yet but
  // need to strictly hide private methods to JS users.


  ECharts.internalField = function () {
    prepare$1 = function (ecIns) {
      var scheduler = ecIns._scheduler;
      scheduler.restorePipelines(ecIns._model);
      scheduler.prepareStageTasks();
      prepareView(ecIns, true);
      prepareView(ecIns, false);
      scheduler.plan();
    };
    /**
     * Prepare view instances of charts and components
     */


    prepareView = function (ecIns, isComponent) {
      var ecModel = ecIns._model;
      var scheduler = ecIns._scheduler;
      var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
      var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
      var zr = ecIns._zr;
      var api = ecIns._api;

      for (var i = 0; i < viewList.length; i++) {
        viewList[i].__alive = false;
      }

      isComponent ? ecModel.eachComponent(function (componentType, model) {
        componentType !== 'series' && doPrepare(model);
      }) : ecModel.eachSeries(doPrepare);

      function doPrepare(model) {
        // By default view will be reused if possible for the case that `setOption` with "notMerge"
        // mode and need to enable transition animation. (Usually, when they have the same id, or
        // especially no id but have the same type & name & index. See the `model.id` generation
        // rule in `makeIdAndName` and `viewId` generation rule here).
        // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
        // the new model has nothing to do with the old model.
        var requireNewView = model.__requireNewView; // This command should not work twice.

        model.__requireNewView = false; // Consider: id same and type changed.

        var viewId = '_ec_' + model.id + '_' + model.type;
        var view = !requireNewView && viewMap[viewId];

        if (!view) {
          var classType = parseClassType(model.type);
          var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : // FIXME:TS
          // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
          // For backward compat, still support a chart type declared as only subType
          // like "liquidfill", but recommend "series.liquidfill"
          // But need a base class to make a type series.
          ChartView.getClass(classType.sub);

          if (process.env.NODE_ENV !== 'production') {
            assert(Clazz, classType.sub + ' does not exist.');
          }

          view = new Clazz();
          view.init(ecModel, api);
          viewMap[viewId] = view;
          viewList.push(view);
          zr.add(view.group);
        }

        model.__viewId = view.__id = viewId;
        view.__alive = true;
        view.__model = model;
        view.group.__ecComponentInfo = {
          mainType: model.mainType,
          index: model.componentIndex
        };
        !isComponent && scheduler.prepareView(view, model, ecModel, api);
      }

      for (var i = 0; i < viewList.length;) {
        var view = viewList[i];

        if (!view.__alive) {
          !isComponent && view.renderTask.dispose();
          zr.remove(view.group);
          view.dispose(ecModel, api);
          viewList.splice(i, 1);

          if (viewMap[view.__id] === view) {
            delete viewMap[view.__id];
          }

          view.__id = view.group.__ecComponentInfo = null;
        } else {
          i++;
        }
      }
    };

    updateDirectly = function (ecIns, method, payload, mainType, subType) {
      var ecModel = ecIns._model;
      ecModel.setUpdatePayload(payload); // broadcast

      if (!mainType) {
        // FIXME
        // Chart will not be update directly here, except set dirty.
        // But there is no such scenario now.
        each([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
        return;
      }

      var query = {};
      query[mainType + 'Id'] = payload[mainType + 'Id'];
      query[mainType + 'Index'] = payload[mainType + 'Index'];
      query[mainType + 'Name'] = payload[mainType + 'Name'];
      var condition = {
        mainType: mainType,
        query: query
      };
      subType && (condition.subType = subType); // subType may be '' by parseClassType;

      var excludeSeriesId = payload.excludeSeriesId;
      var excludeSeriesIdMap;

      if (excludeSeriesId != null) {
        excludeSeriesIdMap = createHashMap();
        each(normalizeToArray(excludeSeriesId), function (id) {
          var modelId = convertOptionIdName(id, null);

          if (modelId != null) {
            excludeSeriesIdMap.set(modelId, true);
          }
        });
      } // If dispatchAction before setOption, do nothing.


      ecModel && ecModel.eachComponent(condition, function (model) {
        var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;

        if (isExcluded) {
          return;
        }

        if (isHighDownPayload(payload)) {
          if (model instanceof SeriesModel) {
            if (payload.type === HIGHLIGHT_ACTION_TYPE && !payload.notBlur && !model.get(['emphasis', 'disabled'])) {
              blurSeriesFromHighlightPayload(model, payload, ecIns._api);
            }
          } else {
            var _a = findComponentHighDownDispatchers(model.mainType, model.componentIndex, payload.name, ecIns._api),
                focusSelf = _a.focusSelf,
                dispatchers = _a.dispatchers;

            if (payload.type === HIGHLIGHT_ACTION_TYPE && focusSelf && !payload.notBlur) {
              blurComponent(model.mainType, model.componentIndex, ecIns._api);
            } // PENDING:
            // Whether to put this "enter emphasis" code in `ComponentView`,
            // which will be the same as `ChartView` but might be not necessary
            // and will be far from this logic.


            if (dispatchers) {
              each(dispatchers, function (dispatcher) {
                payload.type === HIGHLIGHT_ACTION_TYPE ? enterEmphasis(dispatcher) : leaveEmphasis(dispatcher);
              });
            }
          }
        } else if (isSelectChangePayload(payload)) {
          // TODO geo
          if (model instanceof SeriesModel) {
            toggleSelectionFromPayload(model, payload, ecIns._api);
            updateSeriesElementSelection(model);
            markStatusToUpdate(ecIns);
          }
        }
      }, ecIns);
      ecModel && ecModel.eachComponent(condition, function (model) {
        var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;

        if (isExcluded) {
          return;
        }
        callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
      }, ecIns);

      function callView(view) {
        view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
      }
    };

    updateMethods = {
      prepareAndUpdate: function (payload) {
        prepare$1(this);
        updateMethods.update.call(this, payload, {
          // Needs to mark option changed if newOption is given.
          // It's from MagicType.
          // TODO If use a separate flag optionChanged in payload?
          optionChanged: payload.newOption != null
        });
      },
      update: function (payload, updateParams) {
        var ecModel = this._model;
        var api = this._api;
        var zr = this._zr;
        var coordSysMgr = this._coordSysMgr;
        var scheduler = this._scheduler; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload);
        scheduler.restoreData(ecModel, payload);
        scheduler.performSeriesTasks(ecModel); // TODO
        // Save total ecModel here for undo/redo (after restoring data and before processing data).
        // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
        // Create new coordinate system each update
        // In LineView may save the old coordinate system and use it to get the original point.

        coordSysMgr.create(ecModel, api);
        scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
        // stream modes after data processing, where the filtered data is used to
        // determine whether to use progressive rendering.

        updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
        // can be fetched when coord sys updating (consider the barGrid extent fix). But
        // the drawback is the full coord info can not be fetched. Fortunately this full
        // coord is not required in stream mode updater currently.

        coordSysMgr.update(ecModel, api);
        clearColorPalette(ecModel);
        scheduler.performVisualTasks(ecModel, payload);
        render(this, ecModel, api, payload, updateParams); // Set background

        var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
        var darkMode = ecModel.get('darkMode');
        zr.setBackgroundColor(backgroundColor); // Force set dark mode.

        if (darkMode != null && darkMode !== 'auto') {
          zr.setDarkMode(darkMode);
        }

        lifecycle.trigger('afterupdate', ecModel, api);
      },
      updateTransform: function (payload) {
        var _this = this;

        var ecModel = this._model;
        var api = this._api; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload); // ChartView.markUpdateMethod(payload, 'updateTransform');

        var componentDirtyList = [];
        ecModel.eachComponent(function (componentType, componentModel) {
          if (componentType === 'series') {
            return;
          }

          var componentView = _this.getViewOfComponentModel(componentModel);

          if (componentView && componentView.__alive) {
            if (componentView.updateTransform) {
              var result = componentView.updateTransform(componentModel, ecModel, api, payload);
              result && result.update && componentDirtyList.push(componentView);
            } else {
              componentDirtyList.push(componentView);
            }
          }
        });
        var seriesDirtyMap = createHashMap();
        ecModel.eachSeries(function (seriesModel) {
          var chartView = _this._chartsMap[seriesModel.__viewId];

          if (chartView.updateTransform) {
            var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
            result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
          } else {
            seriesDirtyMap.set(seriesModel.uid, 1);
          }
        });
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
        // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);

        this._scheduler.performVisualTasks(ecModel, payload, {
          setDirty: true,
          dirtyMap: seriesDirtyMap
        }); // Currently, not call render of components. Geo render cost a lot.
        // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);


        renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
        lifecycle.trigger('afterupdate', ecModel, api);
      },
      updateView: function (payload) {
        var ecModel = this._model; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload);
        ChartView.markUpdateMethod(payload, 'updateView');
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

        this._scheduler.performVisualTasks(ecModel, payload, {
          setDirty: true
        });

        render(this, ecModel, this._api, payload, {});
        lifecycle.trigger('afterupdate', ecModel, this._api);
      },
      updateVisual: function (payload) {
        // updateMethods.update.call(this, payload);
        var _this = this;

        var ecModel = this._model; // update before setOption

        if (!ecModel) {
          return;
        }

        ecModel.setUpdatePayload(payload); // clear all visual

        ecModel.eachSeries(function (seriesModel) {
          seriesModel.getData().clearAllVisual();
        }); // Perform visual

        ChartView.markUpdateMethod(payload, 'updateVisual');
        clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.

        this._scheduler.performVisualTasks(ecModel, payload, {
          visualType: 'visual',
          setDirty: true
        });

        ecModel.eachComponent(function (componentType, componentModel) {
          if (componentType !== 'series') {
            var componentView = _this.getViewOfComponentModel(componentModel);

            componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
          }
        });
        ecModel.eachSeries(function (seriesModel) {
          var chartView = _this._chartsMap[seriesModel.__viewId];
          chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
        });
        lifecycle.trigger('afterupdate', ecModel, this._api);
      },
      updateLayout: function (payload) {
        updateMethods.update.call(this, payload);
      }
    };

    doConvertPixel = function (ecIns, methodName, finder, value) {
      if (ecIns._disposed) {
        disposedWarning(ecIns.id);
        return;
      }

      var ecModel = ecIns._model;

      var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();

      var result;
      var parsedFinder = parseFinder(ecModel, finder);

      for (var i = 0; i < coordSysList.length; i++) {
        var coordSys = coordSysList[i];

        if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) {
          return result;
        }
      }

      if (process.env.NODE_ENV !== 'production') {
        warn('No coordinate system that supports ' + methodName + ' found by the given finder.');
      }
    };

    updateStreamModes = function (ecIns, ecModel) {
      var chartsMap = ecIns._chartsMap;
      var scheduler = ecIns._scheduler;
      ecModel.eachSeries(function (seriesModel) {
        scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
      });
    };

    doDispatchAction = function (payload, silent) {
      var _this = this;

      var ecModel = this.getModel();
      var payloadType = payload.type;
      var escapeConnect = payload.escapeConnect;
      var actionWrap = actions[payloadType];
      var actionInfo = actionWrap.actionInfo;
      var cptTypeTmp = (actionInfo.update || 'update').split(':');
      var updateMethod = cptTypeTmp.pop();
      var cptType = cptTypeTmp[0] != null && parseClassType(cptTypeTmp[0]);
      this[IN_MAIN_PROCESS_KEY] = true;
      var payloads = [payload];
      var batched = false; // Batch action

      if (payload.batch) {
        batched = true;
        payloads = map(payload.batch, function (item) {
          item = defaults(extend({}, item), payload);
          item.batch = null;
          return item;
        });
      }

      var eventObjBatch = [];
      var eventObj;
      var isSelectChange = isSelectChangePayload(payload);
      var isHighDown = isHighDownPayload(payload); // Only leave blur once if there are multiple batches.

      if (isHighDown) {
        allLeaveBlur(this._api);
      }

      each(payloads, function (batchItem) {
        // Action can specify the event by return it.
        eventObj = actionWrap.action(batchItem, _this._model, _this._api); // Emit event outside

        eventObj = eventObj || extend({}, batchItem); // Convert type to eventType

        eventObj.type = actionInfo.event || eventObj.type;
        eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.

        if (isHighDown) {
          var _a = preParseFinder(payload),
              queryOptionMap = _a.queryOptionMap,
              mainTypeSpecified = _a.mainTypeSpecified;

          var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
          updateDirectly(_this, updateMethod, batchItem, componentMainType);
          markStatusToUpdate(_this);
        } else if (isSelectChange) {
          // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
          // geo still use 'geoselect'.
          updateDirectly(_this, updateMethod, batchItem, 'series');
          markStatusToUpdate(_this);
        } else if (cptType) {
          updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
        }
      });

      if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) {
        try {
          // Still dirty
          if (this[PENDING_UPDATE]) {
            prepare$1(this);
            updateMethods.update.call(this, payload);
            this[PENDING_UPDATE] = null;
          } else {
            updateMethods[updateMethod].call(this, payload);
          }
        } catch (e) {
          this[IN_MAIN_PROCESS_KEY] = false;
          throw e;
        }
      } // Follow the rule of action batch


      if (batched) {
        eventObj = {
          type: actionInfo.event || payloadType,
          escapeConnect: escapeConnect,
          batch: eventObjBatch
        };
      } else {
        eventObj = eventObjBatch[0];
      }

      this[IN_MAIN_PROCESS_KEY] = false;

      if (!silent) {
        var messageCenter = this._messageCenter;
        messageCenter.trigger(eventObj.type, eventObj); // Extra triggered 'selectchanged' event

        if (isSelectChange) {
          var newObj = {
            type: 'selectchanged',
            escapeConnect: escapeConnect,
            selected: getAllSelectedIndices(ecModel),
            isFromClick: payload.isFromClick || false,
            fromAction: payload.type,
            fromActionPayload: payload
          };
          messageCenter.trigger(newObj.type, newObj);
        }
      }
    };

    flushPendingActions = function (silent) {
      var pendingActions = this._pendingActions;

      while (pendingActions.length) {
        var payload = pendingActions.shift();
        doDispatchAction.call(this, payload, silent);
      }
    };

    triggerUpdatedEvent = function (silent) {
      !silent && this.trigger('updated');
    };
    /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */


    bindRenderedEvent = function (zr, ecIns) {
      zr.on('rendered', function (params) {
        ecIns.trigger('rendered', params); // The `finished` event should not be triggered repeatedly,
        // so it should only be triggered when rendering indeed happens
        // in zrender. (Consider the case that dipatchAction is keep
        // triggering when mouse move).

        if ( // Although zr is dirty if initial animation is not finished
        // and this checking is called on frame, we also check
        // animation finished for robustness.
        zr.animation.isFinished() && !ecIns[PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
          ecIns.trigger('finished');
        }
      });
    };

    bindMouseEvent = function (zr, ecIns) {
      zr.on('mouseover', function (e) {
        var el = e.target;
        var dispatcher = findEventDispatcher(el, isHighDownDispatcher);

        if (dispatcher) {
          handleGlobalMouseOverForHighDown(dispatcher, e, ecIns._api);
          markStatusToUpdate(ecIns);
        }
      }).on('mouseout', function (e) {
        var el = e.target;
        var dispatcher = findEventDispatcher(el, isHighDownDispatcher);

        if (dispatcher) {
          handleGlobalMouseOutForHighDown(dispatcher, e, ecIns._api);
          markStatusToUpdate(ecIns);
        }
      }).on('click', function (e) {
        var el = e.target;
        var dispatcher = findEventDispatcher(el, function (target) {
          return getECData(target).dataIndex != null;
        }, true);

        if (dispatcher) {
          var actionType = dispatcher.selected ? 'unselect' : 'select';
          var ecData = getECData(dispatcher);

          ecIns._api.dispatchAction({
            type: actionType,
            dataType: ecData.dataType,
            dataIndexInside: ecData.dataIndex,
            seriesIndex: ecData.seriesIndex,
            isFromClick: true
          });
        }
      });
    };

    function clearColorPalette(ecModel) {
      ecModel.clearColorPalette();
      ecModel.eachSeries(function (seriesModel) {
        seriesModel.clearColorPalette();
      });
    }

    function allocateZlevels(ecModel) {
      var componentZLevels = [];
      var seriesZLevels = [];
      var hasSeperateZLevel = false;
      ecModel.eachComponent(function (componentType, componentModel) {
        var zlevel = componentModel.get('zlevel') || 0;
        var z = componentModel.get('z') || 0;
        var zlevelKey = componentModel.getZLevelKey();
        hasSeperateZLevel = hasSeperateZLevel || !!zlevelKey;
        (componentType === 'series' ? seriesZLevels : componentZLevels).push({
          zlevel: zlevel,
          z: z,
          idx: componentModel.componentIndex,
          type: componentType,
          key: zlevelKey
        });
      });

      if (hasSeperateZLevel) {
        // Series after component
        var zLevels = componentZLevels.concat(seriesZLevels);
        var lastSeriesZLevel_1;
        var lastSeriesKey_1;
        sort(zLevels, function (a, b) {
          if (a.zlevel === b.zlevel) {
            return a.z - b.z;
          }

          return a.zlevel - b.zlevel;
        });
        each(zLevels, function (item) {
          var componentModel = ecModel.getComponent(item.type, item.idx);
          var zlevel = item.zlevel;
          var key = item.key;

          if (lastSeriesZLevel_1 != null) {
            zlevel = Math.max(lastSeriesZLevel_1, zlevel);
          }

          if (key) {
            if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) {
              zlevel++;
            }

            lastSeriesKey_1 = key;
          } else if (lastSeriesKey_1) {
            if (zlevel === lastSeriesZLevel_1) {
              zlevel++;
            }

            lastSeriesKey_1 = '';
          }

          lastSeriesZLevel_1 = zlevel;
          componentModel.setZLevel(zlevel);
        });
      }
    }

    render = function (ecIns, ecModel, api, payload, updateParams) {
      allocateZlevels(ecModel);
      renderComponents(ecIns, ecModel, api, payload, updateParams);
      each(ecIns._chartsViews, function (chart) {
        chart.__alive = false;
      });
      renderSeries(ecIns, ecModel, api, payload, updateParams); // Remove groups of unrendered charts

      each(ecIns._chartsViews, function (chart) {
        if (!chart.__alive) {
          chart.remove(ecModel, api);
        }
      });
    };

    renderComponents = function (ecIns, ecModel, api, payload, updateParams, dirtyList) {
      each(dirtyList || ecIns._componentsViews, function (componentView) {
        var componentModel = componentView.__model;
        clearStates(componentModel, componentView);
        componentView.render(componentModel, ecModel, api, payload);
        updateZ(componentModel, componentView);
        updateStates(componentModel, componentView);
      });
    };
    /**
     * Render each chart and component
     */


    renderSeries = function (ecIns, ecModel, api, payload, updateParams, dirtyMap) {
      // Render all charts
      var scheduler = ecIns._scheduler;
      updateParams = extend(updateParams || {}, {
        updatedSeries: ecModel.getSeries()
      }); // TODO progressive?

      lifecycle.trigger('series:beforeupdate', ecModel, api, updateParams);
      var unfinished = false;
      ecModel.eachSeries(function (seriesModel) {
        var chartView = ecIns._chartsMap[seriesModel.__viewId];
        chartView.__alive = true;
        var renderTask = chartView.renderTask;
        scheduler.updatePayload(renderTask, payload); // TODO states on marker.

        clearStates(seriesModel, chartView);

        if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
          renderTask.dirty();
        }

        if (renderTask.perform(scheduler.getPerformArgs(renderTask))) {
          unfinished = true;
        }

        chartView.group.silent = !!seriesModel.get('silent'); // Should not call markRedraw on group, because it will disable zrender
        // incremental render (always render from the __startIndex each frame)
        // chartView.group.markRedraw();

        updateBlend(seriesModel, chartView);
        updateSeriesElementSelection(seriesModel);
      });
      scheduler.unfinished = unfinished || scheduler.unfinished;
      lifecycle.trigger('series:layoutlabels', ecModel, api, updateParams); // transition after label is layouted.

      lifecycle.trigger('series:transition', ecModel, api, updateParams);
      ecModel.eachSeries(function (seriesModel) {
        var chartView = ecIns._chartsMap[seriesModel.__viewId]; // Update Z after labels updated. Before applying states.

        updateZ(seriesModel, chartView); // NOTE: Update states after label is updated.
        // label should be in normal status when layouting.

        updateStates(seriesModel, chartView);
      }); // If use hover layer

      updateHoverLayerStatus(ecIns, ecModel);
      lifecycle.trigger('series:afterupdate', ecModel, api, updateParams);
    };

    markStatusToUpdate = function (ecIns) {
      ecIns[STATUS_NEEDS_UPDATE_KEY] = true; // Wake up zrender if it's sleep. Let it update states in the next frame.

      ecIns.getZr().wakeUp();
    };

    applyChangedStates = function (ecIns) {
      if (!ecIns[STATUS_NEEDS_UPDATE_KEY]) {
        return;
      }

      ecIns.getZr().storage.traverse(function (el) {
        // Not applied on removed elements, it may still in fading.
        if (isElementRemoved(el)) {
          return;
        }

        applyElementStates(el);
      });
      ecIns[STATUS_NEEDS_UPDATE_KEY] = false;
    };

    function applyElementStates(el) {
      var newStates = [];
      var oldStates = el.currentStates; // Keep other states.

      for (var i = 0; i < oldStates.length; i++) {
        var stateName = oldStates[i];

        if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) {
          newStates.push(stateName);
        }
      } // Only use states when it's exists.


      if (el.selected && el.states.select) {
        newStates.push('select');
      }

      if (el.hoverState === HOVER_STATE_EMPHASIS && el.states.emphasis) {
        newStates.push('emphasis');
      } else if (el.hoverState === HOVER_STATE_BLUR && el.states.blur) {
        newStates.push('blur');
      }

      el.useStates(newStates);
    }

    function updateHoverLayerStatus(ecIns, ecModel) {
      var zr = ecIns._zr;
      var storage = zr.storage;
      var elCount = 0;
      storage.traverse(function (el) {
        if (!el.isGroup) {
          elCount++;
        }
      });

      if (elCount > ecModel.get('hoverLayerThreshold') && !env.node && !env.worker) {
        ecModel.eachSeries(function (seriesModel) {
          if (seriesModel.preventUsingHoverLayer) {
            return;
          }

          var chartView = ecIns._chartsMap[seriesModel.__viewId];

          if (chartView.__alive) {
            chartView.eachRendered(function (el) {
              if (el.states.emphasis) {
                el.states.emphasis.hoverLayer = true;
              }
            });
          }
        });
      }
    }
    /**
     * Update chart and blend.
     */

    function updateBlend(seriesModel, chartView) {
      var blendMode = seriesModel.get('blendMode') || null;
      chartView.eachRendered(function (el) {
        // FIXME marker and other components
        if (!el.isGroup) {
          // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
          el.style.blend = blendMode;
        }
      });
    }

    function updateZ(model, view) {
      if (model.preventAutoZ) {
        return;
      }

      var z = model.get('z') || 0;
      var zlevel = model.get('zlevel') || 0; // Set z and zlevel

      view.eachRendered(function (el) {
        doUpdateZ(el, z, zlevel, -Infinity); // Don't traverse the children because it has been traversed in _updateZ.

        return true;
      });
    }

    function doUpdateZ(el, z, zlevel, maxZ2) {
      // Group may also have textContent
      var label = el.getTextContent();
      var labelLine = el.getTextGuideLine();
      var isGroup = el.isGroup;

      if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();

        for (var i = 0; i < children.length; i++) {
          maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
        }
      } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = Math.max(el.z2, maxZ2);
      } // always set z and zlevel if label/labelLine exists


      if (label) {
        label.z = z;
        label.zlevel = zlevel; // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.

        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
      }

      if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
      }

      return maxZ2;
    } // Clear states without animation.
    // TODO States on component.


    function clearStates(model, view) {
      view.eachRendered(function (el) {
        // Not applied on removed elements, it may still in fading.
        if (isElementRemoved(el)) {
          return;
        }

        var textContent = el.getTextContent();
        var textGuide = el.getTextGuideLine();

        if (el.stateTransition) {
          el.stateTransition = null;
        }

        if (textContent && textContent.stateTransition) {
          textContent.stateTransition = null;
        }

        if (textGuide && textGuide.stateTransition) {
          textGuide.stateTransition = null;
        } // TODO If el is incremental.


        if (el.hasState()) {
          el.prevStates = el.currentStates;
          el.clearStates();
        } else if (el.prevStates) {
          el.prevStates = null;
        }
      });
    }

    function updateStates(model, view) {
      var stateAnimationModel = model.getModel('stateAnimation');
      var enableAnimation = model.isAnimationEnabled();
      var duration = stateAnimationModel.get('duration');
      var stateTransition = duration > 0 ? {
        duration: duration,
        delay: stateAnimationModel.get('delay'),
        easing: stateAnimationModel.get('easing') // additive: stateAnimationModel.get('additive')

      } : null;
      view.eachRendered(function (el) {
        if (el.states && el.states.emphasis) {
          // Not applied on removed elements, it may still in fading.
          if (isElementRemoved(el)) {
            return;
          }

          if (el instanceof Path) {
            savePathStates(el);
          } // Only updated on changed element. In case element is incremental and don't want to rerender.
          // TODO, a more proper way?


          if (el.__dirty) {
            var prevStates = el.prevStates; // Restore states without animation

            if (prevStates) {
              el.useStates(prevStates);
            }
          } // Update state transition and enable animation again.


          if (enableAnimation) {
            el.stateTransition = stateTransition;
            var textContent = el.getTextContent();
            var textGuide = el.getTextGuideLine(); // TODO Is it necessary to animate label?

            if (textContent) {
              textContent.stateTransition = stateTransition;
            }

            if (textGuide) {
              textGuide.stateTransition = stateTransition;
            }
          } // Use highlighted and selected flag to toggle states.


          if (el.__dirty) {
            applyElementStates(el);
          }
        }
      });
    }

    createExtensionAPI = function (ecIns) {
      return new (
      /** @class */
      function (_super) {
        __extends$1(class_1, _super);

        function class_1() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        class_1.prototype.getCoordinateSystems = function () {
          return ecIns._coordSysMgr.getCoordinateSystems();
        };

        class_1.prototype.getComponentByElement = function (el) {
          while (el) {
            var modelInfo = el.__ecComponentInfo;

            if (modelInfo != null) {
              return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
            }

            el = el.parent;
          }
        };

        class_1.prototype.enterEmphasis = function (el, highlightDigit) {
          enterEmphasis(el, highlightDigit);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveEmphasis = function (el, highlightDigit) {
          leaveEmphasis(el, highlightDigit);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.enterBlur = function (el) {
          enterBlur(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveBlur = function (el) {
          leaveBlur(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.enterSelect = function (el) {
          enterSelect(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.leaveSelect = function (el) {
          leaveSelect(el);
          markStatusToUpdate(ecIns);
        };

        class_1.prototype.getModel = function () {
          return ecIns.getModel();
        };

        class_1.prototype.getViewOfComponentModel = function (componentModel) {
          return ecIns.getViewOfComponentModel(componentModel);
        };

        class_1.prototype.getViewOfSeriesModel = function (seriesModel) {
          return ecIns.getViewOfSeriesModel(seriesModel);
        };

        return class_1;
      }(ExtensionAPI))(ecIns);
    };

    enableConnect = function (chart) {
      function updateConnectedChartsStatus(charts, status) {
        for (var i = 0; i < charts.length; i++) {
          var otherChart = charts[i];
          otherChart[CONNECT_STATUS_KEY] = status;
        }
      }

      each(eventActionMap, function (actionType, eventType) {
        chart._messageCenter.on(eventType, function (event) {
          if (connectedGroups[chart.group] && chart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_PENDING) {
            if (event && event.escapeConnect) {
              return;
            }

            var action_1 = chart.makeActionFromEvent(event);
            var otherCharts_1 = [];
            each(instances$1, function (otherChart) {
              if (otherChart !== chart && otherChart.group === chart.group) {
                otherCharts_1.push(otherChart);
              }
            });
            updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_PENDING);
            each(otherCharts_1, function (otherChart) {
              if (otherChart[CONNECT_STATUS_KEY] !== CONNECT_STATUS_UPDATING) {
                otherChart.dispatchAction(action_1);
              }
            });
            updateConnectedChartsStatus(otherCharts_1, CONNECT_STATUS_UPDATED);
          }
        });
      });
    };
  }();

  return ECharts;
}(Eventful);

var echartsProto = ECharts.prototype;
echartsProto.on = createRegisterEventWithLowercaseECharts('on');
echartsProto.off = createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */
// @ts-ignore

echartsProto.one = function (eventName, cb, ctx) {
  var self = this;
  deprecateLog('ECharts#one is deprecated.');

  function wrapped() {
    var args2 = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args2[_i] = arguments[_i];
    }

    cb && cb.apply && cb.apply(this, args2); // @ts-ignore

    self.off(eventName, wrapped);
  }

  this.on.call(this, eventName, wrapped, ctx);
};

var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];

function disposedWarning(id) {
  if (process.env.NODE_ENV !== 'production') {
    warn('Instance ' + id + ' has been disposed');
  }
}

var actions = {};
/**
 * Map eventType to actionType
 */

var eventActionMap = {};
var dataProcessorFuncs = [];
var optionPreprocessorFuncs = [];
var visualFuncs = [];
var themeStorage = {};
var loadingEffects = {};
var instances$1 = {};
var connectedGroups = {};
var idBase = +new Date() - 0;
var groupIdBase = +new Date() - 0;
var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
/**
 * @param opts.devicePixelRatio Use window.devicePixelRatio by default
 * @param opts.renderer Can choose 'canvas' or 'svg' to render the chart.
 * @param opts.width Use clientWidth of the input `dom` by default.
 *        Can be 'auto' (the same as null/undefined)
 * @param opts.height Use clientHeight of the input `dom` by default.
 *        Can be 'auto' (the same as null/undefined)
 * @param opts.locale Specify the locale.
 * @param opts.useDirtyRect Enable dirty rectangle rendering or not.
 */

function init$1(dom, theme, opts) {
  var isClient = !(opts && opts.ssr);

  if (isClient) {
    if (process.env.NODE_ENV !== 'production') {
      if (!dom) {
        throw new Error('Initialize failed: invalid dom.');
      }
    }

    var existInstance = getInstanceByDom(dom);

    if (existInstance) {
      if (process.env.NODE_ENV !== 'production') {
        warn('There is a chart instance already initialized on the dom.');
      }

      return existInstance;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (isDom(dom) && dom.nodeName.toUpperCase() !== 'CANVAS' && (!dom.clientWidth && (!opts || opts.width == null) || !dom.clientHeight && (!opts || opts.height == null))) {
        warn('Can\'t get DOM width or height. Please check ' + 'dom.clientWidth and dom.clientHeight. They should not be 0.' + 'For example, you may need to call this in the callback ' + 'of window.onload.');
      }
    }
  }

  var chart = new ECharts(dom, theme, opts);
  chart.id = 'ec_' + idBase++;
  instances$1[chart.id] = chart;
  isClient && setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
  enableConnect(chart);
  lifecycle.trigger('afterinit', chart);
  return chart;
}
/**
 * @usage
 * (A)
 * ```js
 * let chart1 = echarts.init(dom1);
 * let chart2 = echarts.init(dom2);
 * chart1.group = 'xxx';
 * chart2.group = 'xxx';
 * echarts.connect('xxx');
 * ```
 * (B)
 * ```js
 * let chart1 = echarts.init(dom1);
 * let chart2 = echarts.init(dom2);
 * echarts.connect('xxx', [chart1, chart2]);
 * ```
 */

function connect(groupId) {
  // Is array of charts
  if (isArray$1(groupId)) {
    var charts = groupId;
    groupId = null; // If any chart has group

    each(charts, function (chart) {
      if (chart.group != null) {
        groupId = chart.group;
      }
    });
    groupId = groupId || 'g_' + groupIdBase++;
    each(charts, function (chart) {
      chart.group = groupId;
    });
  }

  connectedGroups[groupId] = true;
  return groupId;
}
/**
 * @deprecated
 */

function disConnect(groupId) {
  connectedGroups[groupId] = false;
}
/**
 * Alias and backward compatibility
 */

var disconnect = disConnect;
/**
 * Dispose a chart instance
 */

function dispose$1(chart) {
  if (isString(chart)) {
    chart = instances$1[chart];
  } else if (!(chart instanceof ECharts)) {
    // Try to treat as dom
    chart = getInstanceByDom(chart);
  }

  if (chart instanceof ECharts && !chart.isDisposed()) {
    chart.dispose();
  }
}
function getInstanceByDom(dom) {
  return instances$1[getAttribute(dom, DOM_ATTRIBUTE_KEY)];
}
function getInstanceById(key) {
  return instances$1[key];
}
/**
 * Register theme
 */

function registerTheme(name, theme) {
  themeStorage[name] = theme;
}
/**
 * Register option preprocessor
 */

function registerPreprocessor(preprocessorFunc) {
  if (indexOf(optionPreprocessorFuncs, preprocessorFunc) < 0) {
    optionPreprocessorFuncs.push(preprocessorFunc);
  }
}
function registerProcessor(priority, processor) {
  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_DEFAULT);
}
/**
 * Register postIniter
 * @param {Function} postInitFunc
 */

function registerPostInit(postInitFunc) {
  registerUpdateLifecycle('afterinit', postInitFunc);
}
/**
 * Register postUpdater
 * @param {Function} postUpdateFunc
 */

function registerPostUpdate(postUpdateFunc) {
  registerUpdateLifecycle('afterupdate', postUpdateFunc);
}
function registerUpdateLifecycle(name, cb) {
  lifecycle.on(name, cb);
}
function registerAction(actionInfo, eventName, action) {
  if (isFunction$3(eventName)) {
    action = eventName;
    eventName = '';
  }

  var actionType = isObject$2(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
    event: eventName
  }][0]; // Event name is all lowercase

  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
  eventName = actionInfo.event;

  if (eventActionMap[eventName]) {
    // Already registered.
    return;
  } // Validate action type and event name.


  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));

  if (!actions[actionType]) {
    actions[actionType] = {
      action: action,
      actionInfo: actionInfo
    };
  }

  eventActionMap[eventName] = actionType;
}
function registerCoordinateSystem(type, coordSysCreator) {
  CoordinateSystemManager.register(type, coordSysCreator);
}
/**
 * Get dimensions of specified coordinate system.
 * @param {string} type
 * @return {Array.<string|Object>}
 */

function getCoordinateSystemDimensions(type) {
  var coordSysCreator = CoordinateSystemManager.get(type);

  if (coordSysCreator) {
    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
  }
}

function registerLayout(priority, layoutTask) {
  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
}

function registerVisual(priority, visualTask) {
  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
}
var registeredTasks = [];

function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
  if (isFunction$3(priority) || isObject$2(priority)) {
    fn = priority;
    priority = defaultPriority;
  }

  if (process.env.NODE_ENV !== 'production') {
    if (isNaN(priority) || priority == null) {
      throw new Error('Illegal priority');
    } // Check duplicate


    each(targetList, function (wrap) {
      assert(wrap.__raw !== fn);
    });
  } // Already registered


  if (indexOf(registeredTasks, fn) >= 0) {
    return;
  }

  registeredTasks.push(fn);
  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
  stageHandler.__prio = priority;
  stageHandler.__raw = fn;
  targetList.push(stageHandler);
}

function registerLoading(name, loadingFx) {
  loadingEffects[name] = loadingFx;
}
/**
 * ZRender need a canvas context to do measureText.
 * But in node environment canvas may be created by node-canvas.
 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
 *
 *
 * @deprecated use setPlatformAPI({ createCanvas }) instead.
 *
 * @example
 *     let Canvas = require('canvas');
 *     let echarts = require('echarts');
 *     echarts.setCanvasCreator(function () {
 *         // Small size is enough.
 *         return new Canvas(32, 32);
 *     });
 */

function setCanvasCreator(creator) {
  if (process.env.NODE_ENV !== 'production') {
    deprecateLog('setCanvasCreator is deprecated. Use setPlatformAPI({ createCanvas }) instead.');
  }

  setPlatformAPI({
    createCanvas: creator
  });
}
/**
 * The parameters and usage: see `geoSourceManager.registerMap`.
 * Compatible with previous `echarts.registerMap`.
 */

function registerMap(mapName, geoJson, specialAreas) {
  var registerMap = getImpl('registerMap');
  registerMap && registerMap(mapName, geoJson, specialAreas);
}
function getMap(mapName) {
  var getMap = getImpl('getMap');
  return getMap && getMap(mapName);
}
var registerTransform = registerExternalTransform;
/**
 * Globa dispatchAction to a specified chart instance.
 */
// export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual

registerVisual(PRIORITY_VISUAL_GLOBAL, seriesStyleTask);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataStyleTask);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataColorPaletteTask);
registerVisual(PRIORITY_VISUAL_GLOBAL, seriesSymbolTask);
registerVisual(PRIORITY_VISUAL_CHART_DATA_CUSTOM, dataSymbolTask);
registerVisual(PRIORITY_VISUAL_DECAL, decalVisual);
registerPreprocessor(globalBackwardCompat);
registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
registerLoading('default', defaultLoading); // Default actions

registerAction({
  type: HIGHLIGHT_ACTION_TYPE,
  event: HIGHLIGHT_ACTION_TYPE,
  update: HIGHLIGHT_ACTION_TYPE
}, noop$2);
registerAction({
  type: DOWNPLAY_ACTION_TYPE,
  event: DOWNPLAY_ACTION_TYPE,
  update: DOWNPLAY_ACTION_TYPE
}, noop$2);
registerAction({
  type: SELECT_ACTION_TYPE,
  event: SELECT_ACTION_TYPE,
  update: SELECT_ACTION_TYPE
}, noop$2);
registerAction({
  type: UNSELECT_ACTION_TYPE,
  event: UNSELECT_ACTION_TYPE,
  update: UNSELECT_ACTION_TYPE
}, noop$2);
registerAction({
  type: TOGGLE_SELECT_ACTION_TYPE,
  event: TOGGLE_SELECT_ACTION_TYPE,
  update: TOGGLE_SELECT_ACTION_TYPE
}, noop$2); // Default theme

registerTheme('light', lightTheme);
registerTheme('dark', theme$1); // For backward compatibility, where the namespace `dataTool` will
// be mounted on `echarts` is the extension `dataTool` is imported.

var dataTool = {};

var extensions = [];
var extensionRegisters = {
  registerPreprocessor: registerPreprocessor,
  registerProcessor: registerProcessor,
  registerPostInit: registerPostInit,
  registerPostUpdate: registerPostUpdate,
  registerUpdateLifecycle: registerUpdateLifecycle,
  registerAction: registerAction,
  registerCoordinateSystem: registerCoordinateSystem,
  registerLayout: registerLayout,
  registerVisual: registerVisual,
  registerTransform: registerTransform,
  registerLoading: registerLoading,
  registerMap: registerMap,
  registerImpl: registerImpl,
  PRIORITY: PRIORITY,
  ComponentModel: ComponentModel,
  ComponentView: ComponentView,
  SeriesModel: SeriesModel,
  ChartView: ChartView,
  // TODO Use ComponentModel and SeriesModel instead of Constructor
  registerComponentModel: function (ComponentModelClass) {
    ComponentModel.registerClass(ComponentModelClass);
  },
  registerComponentView: function (ComponentViewClass) {
    ComponentView.registerClass(ComponentViewClass);
  },
  registerSeriesModel: function (SeriesModelClass) {
    SeriesModel.registerClass(SeriesModelClass);
  },
  registerChartView: function (ChartViewClass) {
    ChartView.registerClass(ChartViewClass);
  },
  registerSubTypeDefaulter: function (componentType, defaulter) {
    ComponentModel.registerSubTypeDefaulter(componentType, defaulter);
  },
  registerPainter: function (painterType, PainterCtor) {
    registerPainter(painterType, PainterCtor);
  }
};
function use(ext) {
  if (isArray$1(ext)) {
    // use([ChartLine, ChartBar]);
    each(ext, function (singleExt) {
      use(singleExt);
    });
    return;
  }

  if (indexOf(extensions, ext) >= 0) {
    return;
  }

  extensions.push(ext);

  if (isFunction$3(ext)) {
    ext = {
      install: ext
    };
  }

  ext.install(extensionRegisters);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
  return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}

function defaultKeyGetter(item) {
  return item;
}

var DataDiffer =
/** @class */
function () {
  /**
   * @param context Can be visited by this.context in callback.
   */
  function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
  diffMode) {
    this._old = oldArr;
    this._new = newArr;
    this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
    this._newKeyGetter = newKeyGetter || defaultKeyGetter; // Visible in callback via `this.context`;

    this.context = context;
    this._diffModeMultiple = diffMode === 'multiple';
  }
  /**
   * Callback function when add a data
   */


  DataDiffer.prototype.add = function (func) {
    this._add = func;
    return this;
  };
  /**
   * Callback function when update a data
   */


  DataDiffer.prototype.update = function (func) {
    this._update = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateManyToOne = function (func) {
    this._updateManyToOne = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateOneToMany = function (func) {
    this._updateOneToMany = func;
    return this;
  };
  /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */


  DataDiffer.prototype.updateManyToMany = function (func) {
    this._updateManyToMany = func;
    return this;
  };
  /**
   * Callback function when remove a data
   */


  DataDiffer.prototype.remove = function (func) {
    this._remove = func;
    return this;
  };

  DataDiffer.prototype.execute = function () {
    this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
  };

  DataDiffer.prototype._executeOneToOne = function () {
    var oldArr = this._old;
    var newArr = this._new;
    var newDataIndexMap = {};
    var oldDataKeyArr = new Array(oldArr.length);
    var newDataKeyArr = new Array(newArr.length);

    this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');

    this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');

    for (var i = 0; i < oldArr.length; i++) {
      var oldKey = oldDataKeyArr[i];
      var newIdxMapVal = newDataIndexMap[oldKey];
      var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal); // idx can never be empty array here. see 'set null' logic below.

      if (newIdxMapValLen > 1) {
        // Consider there is duplicate key (for example, use dataItem.name as key).
        // We should make sure every item in newArr and oldArr can be visited.
        var newIdx = newIdxMapVal.shift();

        if (newIdxMapVal.length === 1) {
          newDataIndexMap[oldKey] = newIdxMapVal[0];
        }

        this._update && this._update(newIdx, i);
      } else if (newIdxMapValLen === 1) {
        newDataIndexMap[oldKey] = null;
        this._update && this._update(newIdxMapVal, i);
      } else {
        this._remove && this._remove(i);
      }
    }

    this._performRestAdd(newDataKeyArr, newDataIndexMap);
  };
  /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */


  DataDiffer.prototype._executeMultiple = function () {
    var oldArr = this._old;
    var newArr = this._new;
    var oldDataIndexMap = {};
    var newDataIndexMap = {};
    var oldDataKeyArr = [];
    var newDataKeyArr = [];

    this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');

    this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');

    for (var i = 0; i < oldDataKeyArr.length; i++) {
      var oldKey = oldDataKeyArr[i];
      var oldIdxMapVal = oldDataIndexMap[oldKey];
      var newIdxMapVal = newDataIndexMap[oldKey];
      var oldIdxMapValLen = dataIndexMapValueLength(oldIdxMapVal);
      var newIdxMapValLen = dataIndexMapValueLength(newIdxMapVal);

      if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
        this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
        this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
        this._update && this._update(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
        this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
        newDataIndexMap[oldKey] = null;
      } else if (oldIdxMapValLen > 1) {
        for (var i_1 = 0; i_1 < oldIdxMapValLen; i_1++) {
          this._remove && this._remove(oldIdxMapVal[i_1]);
        }
      } else {
        this._remove && this._remove(oldIdxMapVal);
      }
    }

    this._performRestAdd(newDataKeyArr, newDataIndexMap);
  };

  DataDiffer.prototype._performRestAdd = function (newDataKeyArr, newDataIndexMap) {
    for (var i = 0; i < newDataKeyArr.length; i++) {
      var newKey = newDataKeyArr[i];
      var newIdxMapVal = newDataIndexMap[newKey];
      var idxMapValLen = dataIndexMapValueLength(newIdxMapVal);

      if (idxMapValLen > 1) {
        for (var j = 0; j < idxMapValLen; j++) {
          this._add && this._add(newIdxMapVal[j]);
        }
      } else if (idxMapValLen === 1) {
        this._add && this._add(newIdxMapVal);
      } // Support both `newDataKeyArr` are duplication removed or not removed.


      newDataIndexMap[newKey] = null;
    }
  };

  DataDiffer.prototype._initIndexMap = function (arr, // Can be null.
  map, // In 'byKey', the output `keyArr` is duplication removed.
  // In 'byIndex', the output `keyArr` is not duplication removed and
  //     its indices are accurately corresponding to `arr`.
  keyArr, keyGetterName) {
    var cbModeMultiple = this._diffModeMultiple;

    for (var i = 0; i < arr.length; i++) {
      // Add prefix to avoid conflict with Object.prototype.
      var key = '_ec_' + this[keyGetterName](arr[i], i);

      if (!cbModeMultiple) {
        keyArr[i] = key;
      }

      if (!map) {
        continue;
      }

      var idxMapVal = map[key];
      var idxMapValLen = dataIndexMapValueLength(idxMapVal);

      if (idxMapValLen === 0) {
        // Simple optimize: in most cases, one index has one key,
        // do not need array.
        map[key] = i;

        if (cbModeMultiple) {
          keyArr.push(key);
        }
      } else if (idxMapValLen === 1) {
        map[key] = [idxMapVal, i];
      } else {
        idxMapVal.push(i);
      }
    }
  };

  return DataDiffer;
}();

var DimensionUserOuput =
/** @class */
function () {
  function DimensionUserOuput(encode, dimRequest) {
    this._encode = encode;
    this._schema = dimRequest;
  }

  DimensionUserOuput.prototype.get = function () {
    return {
      // Do not generate full dimension name until fist used.
      fullDimensions: this._getFullDimensionNames(),
      encode: this._encode
    };
  };
  /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */


  DimensionUserOuput.prototype._getFullDimensionNames = function () {
    if (!this._cachedDimNames) {
      this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
    }

    return this._cachedDimNames;
  };

  return DimensionUserOuput;
}();
function summarizeDimensions(data, schema) {
  var summary = {};
  var encode = summary.encode = {};
  var notExtraCoordDimMap = createHashMap();
  var defaultedLabel = [];
  var defaultedTooltip = [];
  var userOutputEncode = {};
  each(data.dimensions, function (dimName) {
    var dimItem = data.getDimensionInfo(dimName);
    var coordDim = dimItem.coordDim;

    if (coordDim) {
      if (process.env.NODE_ENV !== 'production') {
        assert(VISUAL_DIMENSIONS.get(coordDim) == null);
      }

      var coordDimIndex = dimItem.coordDimIndex;
      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;

      if (!dimItem.isExtraCoord) {
        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
        // because when dataset is used, it is hard to guess which dimension
        // can be value dimension. If both show x, y on label is not look good,
        // and conventionally y axis is focused more.

        if (mayLabelDimType(dimItem.type)) {
          defaultedLabel[0] = dimName;
        } // User output encode do not contain generated coords.
        // And it only has index. User can use index to retrieve value from the raw item array.


        getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
      }

      if (dimItem.defaultTooltip) {
        defaultedTooltip.push(dimName);
      }
    }

    VISUAL_DIMENSIONS.each(function (v, otherDim) {
      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
      var dimIndex = dimItem.otherDims[otherDim];

      if (dimIndex != null && dimIndex !== false) {
        encodeArr[dimIndex] = dimItem.name;
      }
    });
  });
  var dataDimsOnCoord = [];
  var encodeFirstDimNotExtra = {};
  notExtraCoordDimMap.each(function (v, coordDim) {
    var dimArr = encode[coordDim];
    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
    // dim canot on more than one coordDim.

    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
  });
  summary.dataDimsOnCoord = dataDimsOnCoord;
  summary.dataDimIndicesOnCoord = map(dataDimsOnCoord, function (dimName) {
    return data.getDimensionInfo(dimName).storeDimIndex;
  });
  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
  var encodeLabel = encode.label; // FIXME `encode.label` is not recommended, because formatter cannot be set
  // in this way. Use label.formatter instead. Maybe remove this approach someday.

  if (encodeLabel && encodeLabel.length) {
    defaultedLabel = encodeLabel.slice();
  }

  var encodeTooltip = encode.tooltip;

  if (encodeTooltip && encodeTooltip.length) {
    defaultedTooltip = encodeTooltip.slice();
  } else if (!defaultedTooltip.length) {
    defaultedTooltip = defaultedLabel.slice();
  }

  encode.defaultedLabel = defaultedLabel;
  encode.defaultedTooltip = defaultedTooltip;
  summary.userOutput = new DimensionUserOuput(userOutputEncode, schema);
  return summary;
}

function getOrCreateEncodeArr(encode, dim) {
  if (!encode.hasOwnProperty(dim)) {
    encode[dim] = [];
  }

  return encode[dim];
} // FIXME:TS should be type `AxisType`


function getDimensionTypeByAxis(axisType) {
  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}

function mayLabelDimType(dimType) {
  // In most cases, ordinal and time do not suitable for label.
  // Ordinal info can be displayed on axis. Time is too long.
  return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
//     // Get last value dim
//     let dimensions = data.dimensions.slice();
//     let valueType;
//     let valueDim;
//     while (dimensions.length && (
//         valueDim = dimensions.pop(),
//         valueType = data.getDimensionInfo(valueDim).type,
//         valueType === 'ordinal' || valueType === 'time'
//     )) {} // jshint ignore:line
//     return valueDim;
// }

var SeriesDimensionDefine =
/** @class */
function () {
  /**
   * @param opt All of the fields will be shallow copied.
   */
  function SeriesDimensionDefine(opt) {
    /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */
    this.otherDims = {};

    if (opt != null) {
      extend(this, opt);
    }
  }

  return SeriesDimensionDefine;
}();

var inner$5 = makeInner();
var dimTypeShort = {
  float: 'f',
  int: 'i',
  ordinal: 'o',
  number: 'n',
  time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */

var SeriesDataSchema =
/** @class */
function () {
  function SeriesDataSchema(opt) {
    this.dimensions = opt.dimensions;
    this._dimOmitted = opt.dimensionOmitted;
    this.source = opt.source;
    this._fullDimCount = opt.fullDimensionCount;

    this._updateDimOmitted(opt.dimensionOmitted);
  }

  SeriesDataSchema.prototype.isDimensionOmitted = function () {
    return this._dimOmitted;
  };

  SeriesDataSchema.prototype._updateDimOmitted = function (dimensionOmitted) {
    this._dimOmitted = dimensionOmitted;

    if (!dimensionOmitted) {
      return;
    }

    if (!this._dimNameMap) {
      this._dimNameMap = ensureSourceDimNameMap(this.source);
    }
  };
  /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */


  SeriesDataSchema.prototype.getSourceDimensionIndex = function (dimName) {
    return retrieve2(this._dimNameMap.get(dimName), -1);
  };
  /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */


  SeriesDataSchema.prototype.getSourceDimension = function (dimIndex) {
    var dimensionsDefine = this.source.dimensionsDefine;

    if (dimensionsDefine) {
      return dimensionsDefine[dimIndex];
    }
  };

  SeriesDataSchema.prototype.makeStoreSchema = function () {
    var dimCount = this._fullDimCount;
    var willRetrieveDataByName = shouldRetrieveDataByName(this.source);
    var makeHashStrict = !shouldOmitUnusedDimensions(dimCount); // If source don't have dimensions or series don't omit unsed dimensions.
    // Generate from seriesDimList directly

    var dimHash = '';
    var dims = [];

    for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++) {
      var property = void 0;
      var type = void 0;
      var ordinalMeta = void 0;
      var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.

      if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
        property = willRetrieveDataByName ? seriesDimDef.name : null;
        type = seriesDimDef.type;
        ordinalMeta = seriesDimDef.ordinalMeta;
        seriesDimIdx++;
      } else {
        var sourceDimDef = this.getSourceDimension(fullDimIdx);

        if (sourceDimDef) {
          property = willRetrieveDataByName ? sourceDimDef.name : null;
          type = sourceDimDef.type;
        }
      }

      dims.push({
        property: property,
        type: type,
        ordinalMeta: ordinalMeta
      }); // If retrieving data by index,
      //   use <index, type, ordinalMeta> to determine whether data can be shared.
      //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
      //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
      // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
      //   use <property, type, ordinalMeta> in hash.

      if (willRetrieveDataByName && property != null // For data stack, we have make sure each series has its own dim on this store.
      // So we do not add property to hash to make sure they can share this store.
      && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) {
        dimHash += makeHashStrict // Use escape character '`' in case that property name contains '$'.
        ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') // For better performance, when there are large dimensions, tolerant this defects that hardly meet.
        : property;
      }

      dimHash += '$';
      dimHash += dimTypeShort[type] || 'f';

      if (ordinalMeta) {
        dimHash += ordinalMeta.uid;
      }

      dimHash += '$';
    } // Source from endpoint(usually series) will be read differently
    // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
    // So we use this three props as key.


    var source = this.source;
    var hash = [source.seriesLayoutBy, source.startIndex, dimHash].join('$$');
    return {
      dimensions: dims,
      hash: hash
    };
  };

  SeriesDataSchema.prototype.makeOutputDimensionNames = function () {
    var result = [];

    for (var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++) {
      var name_1 = void 0;
      var seriesDimDef = this.dimensions[seriesDimIdx]; // The list has been sorted by `storeDimIndex` asc.

      if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
        if (!seriesDimDef.isCalculationCoord) {
          name_1 = seriesDimDef.name;
        }

        seriesDimIdx++;
      } else {
        var sourceDimDef = this.getSourceDimension(fullDimIdx);

        if (sourceDimDef) {
          name_1 = sourceDimDef.name;
        }
      }

      result.push(name_1);
    }

    return result;
  };

  SeriesDataSchema.prototype.appendCalculationDimension = function (dimDef) {
    this.dimensions.push(dimDef);
    dimDef.isCalculationCoord = true;
    this._fullDimCount++; // If append dimension on a data store, consider the store
    // might be shared by different series, series dimensions not
    // really map to store dimensions.

    this._updateDimOmitted(true);
  };

  return SeriesDataSchema;
}();
function isSeriesDataSchema(schema) {
  return schema instanceof SeriesDataSchema;
}
function createDimNameMap(dimsDef) {
  var dataDimNameMap = createHashMap();

  for (var i = 0; i < (dimsDef || []).length; i++) {
    var dimDefItemRaw = dimsDef[i];
    var userDimName = isObject$2(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;

    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
      dataDimNameMap.set(userDimName, i);
    }
  }

  return dataDimNameMap;
}
function ensureSourceDimNameMap(source) {
  var innerSource = inner$5(source);
  return innerSource.dimNameMap || (innerSource.dimNameMap = createDimNameMap(source.dimensionsDefine));
}
function shouldOmitUnusedDimensions(dimCount) {
  return dimCount > 30;
}

var isObject$4 = isObject$2;
var map$1 = map;
var CtorInt32Array$1 = typeof Int32Array === 'undefined' ? Array : Int32Array; // Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.

var ID_PREFIX = 'e\0\0';
var INDEX_NOT_FOUND = -1; // type SeriesDimensionIndex = DimensionIndex;

var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_dimSummary', 'userOutput', '_rawData', '_dimValueGetter', '_nameDimIdx', '_idDimIdx', '_nameRepeatCount'];
var CLONE_PROPERTIES = ['_approximateExtent']; // -----------------------------
// Internal method declarations:
// -----------------------------

var prepareInvertedIndex;
var getId;
var getIdNameFromStore;
var normalizeDimensions;
var transferProperties;
var cloneListForMapAndSample;
var makeIdFromName;

var SeriesData =
/** @class */
function () {
  /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */
  function SeriesData(dimensionsInput, hostModel) {
    this.type = 'list';
    this._dimOmitted = false;
    this._nameList = [];
    this._idList = []; // Models of data option is stored sparse for optimizing memory cost
    // Never used yet (not used yet).
    // private _optionModels: Model[] = [];
    // Global visual properties after visual coding

    this._visual = {}; // Global layout properties.

    this._layout = {}; // Item visual properties after visual coding

    this._itemVisuals = []; // Item layout properties after layout

    this._itemLayouts = []; // Graphic elements

    this._graphicEls = []; // key: dim, value: extent

    this._approximateExtent = {};
    this._calculationInfo = {}; // Having detected that there is data item is non primitive type
    // (in type `OptionDataItemObject`).
    // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
    // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.

    this.hasItemOption = false; // Methods that create a new list based on this list should be listed here.
    // Notice that those method should `RETURN` the new list.

    this.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'lttbDownSample', 'map']; // Methods that change indices of this list should be listed here.

    this.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
    this.DOWNSAMPLE_METHODS = ['downSample', 'lttbDownSample'];
    var dimensions;
    var assignStoreDimIdx = false;

    if (isSeriesDataSchema(dimensionsInput)) {
      dimensions = dimensionsInput.dimensions;
      this._dimOmitted = dimensionsInput.isDimensionOmitted();
      this._schema = dimensionsInput;
    } else {
      assignStoreDimIdx = true;
      dimensions = dimensionsInput;
    }

    dimensions = dimensions || ['x', 'y'];
    var dimensionInfos = {};
    var dimensionNames = [];
    var invertedIndicesMap = {};
    var needsHasOwn = false;
    var emptyObj = {};

    for (var i = 0; i < dimensions.length; i++) {
      // Use the original dimensions[i], where other flag props may exists.
      var dimInfoInput = dimensions[i];
      var dimensionInfo = isString(dimInfoInput) ? new SeriesDimensionDefine({
        name: dimInfoInput
      }) : !(dimInfoInput instanceof SeriesDimensionDefine) ? new SeriesDimensionDefine(dimInfoInput) : dimInfoInput;
      var dimensionName = dimensionInfo.name;
      dimensionInfo.type = dimensionInfo.type || 'float';

      if (!dimensionInfo.coordDim) {
        dimensionInfo.coordDim = dimensionName;
        dimensionInfo.coordDimIndex = 0;
      }

      var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
      dimensionNames.push(dimensionName);
      dimensionInfos[dimensionName] = dimensionInfo;

      if (emptyObj[dimensionName] != null) {
        needsHasOwn = true;
      }

      if (dimensionInfo.createInvertedIndices) {
        invertedIndicesMap[dimensionName] = [];
      }

      if (otherDims.itemName === 0) {
        this._nameDimIdx = i;
      }

      if (otherDims.itemId === 0) {
        this._idDimIdx = i;
      }

      if (process.env.NODE_ENV !== 'production') {
        assert(assignStoreDimIdx || dimensionInfo.storeDimIndex >= 0);
      }

      if (assignStoreDimIdx) {
        dimensionInfo.storeDimIndex = i;
      }
    }

    this.dimensions = dimensionNames;
    this._dimInfos = dimensionInfos;

    this._initGetDimensionInfo(needsHasOwn);

    this.hostModel = hostModel;
    this._invertedIndicesMap = invertedIndicesMap;

    if (this._dimOmitted) {
      var dimIdxToName_1 = this._dimIdxToName = createHashMap();
      each(dimensionNames, function (dimName) {
        dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
      });
    }
  }
  /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */


  SeriesData.prototype.getDimension = function (dim) {
    var dimIdx = this._recognizeDimIndex(dim);

    if (dimIdx == null) {
      return dim;
    }

    dimIdx = dim;

    if (!this._dimOmitted) {
      return this.dimensions[dimIdx];
    } // Retrieve from series dimension definition because it probably contains
    // generated dimension name (like 'x', 'y').


    var dimName = this._dimIdxToName.get(dimIdx);

    if (dimName != null) {
      return dimName;
    }

    var sourceDimDef = this._schema.getSourceDimension(dimIdx);

    if (sourceDimDef) {
      return sourceDimDef.name;
    }
  };
  /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */


  SeriesData.prototype.getDimensionIndex = function (dim) {
    var dimIdx = this._recognizeDimIndex(dim);

    if (dimIdx != null) {
      return dimIdx;
    }

    if (dim == null) {
      return -1;
    }

    var dimInfo = this._getDimInfo(dim);

    return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
  };
  /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */


  SeriesData.prototype._recognizeDimIndex = function (dim) {
    if (isNumber$1(dim) // If being a number-like string but not being defined as a dimension name.
    || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) {
      return +dim;
    }
  };

  SeriesData.prototype._getStoreDimIndex = function (dim) {
    var dimIdx = this.getDimensionIndex(dim);

    if (process.env.NODE_ENV !== 'production') {
      if (dimIdx == null) {
        throw new Error('Unknown dimension ' + dim);
      }
    }

    return dimIdx;
  };
  /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */


  SeriesData.prototype.getDimensionInfo = function (dim) {
    // Do not clone, because there may be categories in dimInfo.
    return this._getDimInfo(this.getDimension(dim));
  };

  SeriesData.prototype._initGetDimensionInfo = function (needsHasOwn) {
    var dimensionInfos = this._dimInfos;
    this._getDimInfo = needsHasOwn ? function (dimName) {
      return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
    } : function (dimName) {
      return dimensionInfos[dimName];
    };
  };
  /**
   * concrete dimension name list on coord.
   */


  SeriesData.prototype.getDimensionsOnCoord = function () {
    return this._dimSummary.dataDimsOnCoord.slice();
  };

  SeriesData.prototype.mapDimension = function (coordDim, idx) {
    var dimensionsSummary = this._dimSummary;

    if (idx == null) {
      return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
    }

    var dims = dimensionsSummary.encode[coordDim];
    return dims ? dims[idx] : null;
  };

  SeriesData.prototype.mapDimensionsAll = function (coordDim) {
    var dimensionsSummary = this._dimSummary;
    var dims = dimensionsSummary.encode[coordDim];
    return (dims || []).slice();
  };

  SeriesData.prototype.getStore = function () {
    return this._store;
  };
  /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */


  SeriesData.prototype.initData = function (data, nameList, dimValueGetter) {
    var _this = this;

    var store;

    if (data instanceof DataStore) {
      store = data;
    }

    if (!store) {
      var dimensions = this.dimensions;
      var provider = isSourceInstance(data) || isArrayLike$1(data) ? new DefaultDataProvider(data, dimensions.length) : data;
      store = new DataStore();
      var dimensionInfos = map$1(dimensions, function (dimName) {
        return {
          type: _this._dimInfos[dimName].type,
          property: dimName
        };
      });
      store.initData(provider, dimensionInfos, dimValueGetter);
    }

    this._store = store; // Reset

    this._nameList = (nameList || []).slice();
    this._idList = [];
    this._nameRepeatCount = {};

    this._doInit(0, store.count()); // Cache summary info for fast visit. See "dimensionHelper".
    // Needs to be initialized after store is prepared.


    this._dimSummary = summarizeDimensions(this, this._schema);
    this.userOutput = this._dimSummary.userOutput;
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */


  SeriesData.prototype.appendData = function (data) {
    var range = this._store.appendData(data);

    this._doInit(range[0], range[1]);
  };
  /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */


  SeriesData.prototype.appendValues = function (values, names) {
    var _a = this._store.appendValues(values, names.length),
        start = _a.start,
        end = _a.end;

    var shouldMakeIdFromName = this._shouldMakeIdFromName();

    this._updateOrdinalMeta();

    if (names) {
      for (var idx = start; idx < end; idx++) {
        var sourceIdx = idx - start;
        this._nameList[idx] = names[sourceIdx];

        if (shouldMakeIdFromName) {
          makeIdFromName(this, idx);
        }
      }
    }
  };

  SeriesData.prototype._updateOrdinalMeta = function () {
    var store = this._store;
    var dimensions = this.dimensions;

    for (var i = 0; i < dimensions.length; i++) {
      var dimInfo = this._dimInfos[dimensions[i]];

      if (dimInfo.ordinalMeta) {
        store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
      }
    }
  };

  SeriesData.prototype._shouldMakeIdFromName = function () {
    var provider = this._store.getProvider();

    return this._idDimIdx == null && provider.getSource().sourceFormat !== SOURCE_FORMAT_TYPED_ARRAY && !provider.fillStorage;
  };

  SeriesData.prototype._doInit = function (start, end) {
    if (start >= end) {
      return;
    }

    var store = this._store;
    var provider = store.getProvider();

    this._updateOrdinalMeta();

    var nameList = this._nameList;
    var idList = this._idList;
    var sourceFormat = provider.getSource().sourceFormat;
    var isFormatOriginal = sourceFormat === SOURCE_FORMAT_ORIGINAL; // Each data item is value
    // [1, 2]
    // 2
    // Bar chart, line chart which uses category axis
    // only gives the 'y' value. 'x' value is the indices of category
    // Use a tempValue to normalize the value to be a (x, y) value
    // If dataItem is {name: ...} or {id: ...}, it has highest priority.
    // This kind of ids and names are always stored `_nameList` and `_idList`.

    if (isFormatOriginal && !provider.pure) {
      var sharedDataItem = [];

      for (var idx = start; idx < end; idx++) {
        // NOTICE: Try not to write things into dataItem
        var dataItem = provider.getItem(idx, sharedDataItem);

        if (!this.hasItemOption && isDataItemOption(dataItem)) {
          this.hasItemOption = true;
        }

        if (dataItem) {
          var itemName = dataItem.name;

          if (nameList[idx] == null && itemName != null) {
            nameList[idx] = convertOptionIdName(itemName, null);
          }

          var itemId = dataItem.id;

          if (idList[idx] == null && itemId != null) {
            idList[idx] = convertOptionIdName(itemId, null);
          }
        }
      }
    }

    if (this._shouldMakeIdFromName()) {
      for (var idx = start; idx < end; idx++) {
        makeIdFromName(this, idx);
      }
    }

    prepareInvertedIndex(this);
  };
  /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */


  SeriesData.prototype.getApproximateExtent = function (dim) {
    return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
  };
  /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */


  SeriesData.prototype.setApproximateExtent = function (extent, dim) {
    dim = this.getDimension(dim);
    this._approximateExtent[dim] = extent.slice();
  };

  SeriesData.prototype.getCalculationInfo = function (key) {
    return this._calculationInfo[key];
  };

  SeriesData.prototype.setCalculationInfo = function (key, value) {
    isObject$4(key) ? extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
  };
  /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */


  SeriesData.prototype.getName = function (idx) {
    var rawIndex = this.getRawIndex(idx);
    var name = this._nameList[rawIndex];

    if (name == null && this._nameDimIdx != null) {
      name = getIdNameFromStore(this, this._nameDimIdx, rawIndex);
    }

    if (name == null) {
      name = '';
    }

    return name;
  };

  SeriesData.prototype._getCategory = function (dimIdx, idx) {
    var ordinal = this._store.get(dimIdx, idx);

    var ordinalMeta = this._store.getOrdinalMeta(dimIdx);

    if (ordinalMeta) {
      return ordinalMeta.categories[ordinal];
    }

    return ordinal;
  };
  /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */


  SeriesData.prototype.getId = function (idx) {
    return getId(this, this.getRawIndex(idx));
  };

  SeriesData.prototype.count = function () {
    return this._store.count();
  };
  /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */


  SeriesData.prototype.get = function (dim, idx) {
    var store = this._store;
    var dimInfo = this._dimInfos[dim];

    if (dimInfo) {
      return store.get(dimInfo.storeDimIndex, idx);
    }
  };
  /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */


  SeriesData.prototype.getByRawIndex = function (dim, rawIdx) {
    var store = this._store;
    var dimInfo = this._dimInfos[dim];

    if (dimInfo) {
      return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    }
  };

  SeriesData.prototype.getIndices = function () {
    return this._store.getIndices();
  };

  SeriesData.prototype.getDataExtent = function (dim) {
    return this._store.getDataExtent(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getSum = function (dim) {
    return this._store.getSum(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getMedian = function (dim) {
    return this._store.getMedian(this._getStoreDimIndex(dim));
  };

  SeriesData.prototype.getValues = function (dimensions, idx) {
    var _this = this;

    var store = this._store;
    return isArray$1(dimensions) ? store.getValues(map$1(dimensions, function (dim) {
      return _this._getStoreDimIndex(dim);
    }), idx) : store.getValues(dimensions);
  };
  /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */


  SeriesData.prototype.hasValue = function (idx) {
    var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;

    for (var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++) {
      // Ordinal type originally can be string or number.
      // But when an ordinal type is used on coord, it can
      // not be string but only number. So we can also use isNaN.
      if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) {
        return false;
      }
    }

    return true;
  };
  /**
   * Retrieve the index with given name
   */


  SeriesData.prototype.indexOfName = function (name) {
    for (var i = 0, len = this._store.count(); i < len; i++) {
      if (this.getName(i) === name) {
        return i;
      }
    }

    return -1;
  };

  SeriesData.prototype.getRawIndex = function (idx) {
    return this._store.getRawIndex(idx);
  };

  SeriesData.prototype.indexOfRawIndex = function (rawIndex) {
    return this._store.indexOfRawIndex(rawIndex);
  };
  /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */


  SeriesData.prototype.rawIndexOf = function (dim, value) {
    var invertedIndices = dim && this._invertedIndicesMap[dim];

    if (process.env.NODE_ENV !== 'production') {
      if (!invertedIndices) {
        throw new Error('Do not supported yet');
      }
    }

    var rawIndex = invertedIndices[value];

    if (rawIndex == null || isNaN(rawIndex)) {
      return INDEX_NOT_FOUND;
    }

    return rawIndex;
  };
  /**
   * Retrieve the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */


  SeriesData.prototype.indicesOfNearest = function (dim, value, maxDistance) {
    return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
  };

  SeriesData.prototype.each = function (dims, cb, ctx) {

    if (isFunction$3(dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    var fCtx = ctx || this;
    var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);

    this._store.each(dimIndices, fCtx ? bind(cb, fCtx) : cb);
  };

  SeriesData.prototype.filterSelf = function (dims, cb, ctx) {

    if (isFunction$3(dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    var fCtx = ctx || this;
    var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);
    this._store = this._store.filter(dimIndices, fCtx ? bind(cb, fCtx) : cb);
    return this;
  };
  /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */


  SeriesData.prototype.selectRange = function (range) {

    var _this = this;

    var innerRange = {};
    var dims = keys$2(range);
    each(dims, function (dim) {
      var dimIdx = _this._getStoreDimIndex(dim);

      innerRange[dimIdx] = range[dim];
    });
    this._store = this._store.selectRange(innerRange);
    return this;
  };
  /* eslint-enable max-len */


  SeriesData.prototype.mapArray = function (dims, cb, ctx) {

    if (isFunction$3(dims)) {
      ctx = cb;
      cb = dims;
      dims = [];
    } // ctxCompat just for compat echarts3


    ctx = ctx || this;
    var result = [];
    this.each(dims, function () {
      result.push(cb && cb.apply(this, arguments));
    }, ctx);
    return result;
  };

  SeriesData.prototype.map = function (dims, cb, ctx, ctxCompat) {

    var fCtx = ctx || ctxCompat || this;
    var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this);
    var list = cloneListForMapAndSample(this);
    list._store = this._store.map(dimIndices, fCtx ? bind(cb, fCtx) : cb);
    return list;
  };

  SeriesData.prototype.modify = function (dims, cb, ctx, ctxCompat) {
    var _this = this; // ctxCompat just for compat echarts3


    var fCtx = ctx || ctxCompat || this;

    if (process.env.NODE_ENV !== 'production') {
      each(normalizeDimensions(dims), function (dim) {
        var dimInfo = _this.getDimensionInfo(dim);

        if (!dimInfo.isCalculationCoord) {
          console.error('Danger: only stack dimension can be modified');
        }
      });
    }

    var dimIndices = map$1(normalizeDimensions(dims), this._getStoreDimIndex, this); // If do shallow clone here, if there are too many stacked series,
    // it still cost lots of memory, because `_store.dimensions` are not shared.
    // We should consider there probably be shallow clone happen in each series
    // in consequent filter/map.

    this._store.modify(dimIndices, fCtx ? bind(cb, fCtx) : cb);
  };
  /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */


  SeriesData.prototype.downSample = function (dimension, rate, sampleValue, sampleIndex) {
    var list = cloneListForMapAndSample(this);
    list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
    return list;
  };
  /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */


  SeriesData.prototype.lttbDownSample = function (valueDimension, rate) {
    var list = cloneListForMapAndSample(this);
    list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
    return list;
  };

  SeriesData.prototype.getRawDataItem = function (idx) {
    return this._store.getRawDataItem(idx);
  };
  /**
   * Get model of one data item.
   */
  // TODO: Type of data item


  SeriesData.prototype.getItemModel = function (idx) {
    var hostModel = this.hostModel;
    var dataItem = this.getRawDataItem(idx);
    return new Model(dataItem, hostModel, hostModel && hostModel.ecModel);
  };
  /**
   * Create a data differ
   */


  SeriesData.prototype.diff = function (otherList) {
    var thisList = this;
    return new DataDiffer(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function (idx) {
      return getId(otherList, idx);
    }, function (idx) {
      return getId(thisList, idx);
    });
  };
  /**
   * Get visual property.
   */


  SeriesData.prototype.getVisual = function (key) {
    var visual = this._visual;
    return visual && visual[key];
  };

  SeriesData.prototype.setVisual = function (kvObj, val) {
    this._visual = this._visual || {};

    if (isObject$4(kvObj)) {
      extend(this._visual, kvObj);
    } else {
      this._visual[kvObj] = val;
    }
  };
  /**
   * Get visual property of single data item
   */
  // eslint-disable-next-line


  SeriesData.prototype.getItemVisual = function (idx, key) {
    var itemVisual = this._itemVisuals[idx];
    var val = itemVisual && itemVisual[key];

    if (val == null) {
      // Use global visual property
      return this.getVisual(key);
    }

    return val;
  };
  /**
   * If exists visual property of single data item
   */


  SeriesData.prototype.hasItemVisual = function () {
    return this._itemVisuals.length > 0;
  };
  /**
   * Make sure itemVisual property is unique
   */
  // TODO: use key to save visual to reduce memory.


  SeriesData.prototype.ensureUniqueItemVisual = function (idx, key) {
    var itemVisuals = this._itemVisuals;
    var itemVisual = itemVisuals[idx];

    if (!itemVisual) {
      itemVisual = itemVisuals[idx] = {};
    }

    var val = itemVisual[key];

    if (val == null) {
      val = this.getVisual(key); // TODO Performance?

      if (isArray$1(val)) {
        val = val.slice();
      } else if (isObject$4(val)) {
        val = extend({}, val);
      }

      itemVisual[key] = val;
    }

    return val;
  }; // eslint-disable-next-line


  SeriesData.prototype.setItemVisual = function (idx, key, value) {
    var itemVisual = this._itemVisuals[idx] || {};
    this._itemVisuals[idx] = itemVisual;

    if (isObject$4(key)) {
      extend(itemVisual, key);
    } else {
      itemVisual[key] = value;
    }
  };
  /**
   * Clear itemVisuals and list visual.
   */


  SeriesData.prototype.clearAllVisual = function () {
    this._visual = {};
    this._itemVisuals = [];
  };

  SeriesData.prototype.setLayout = function (key, val) {
    isObject$4(key) ? extend(this._layout, key) : this._layout[key] = val;
  };
  /**
   * Get layout property.
   */


  SeriesData.prototype.getLayout = function (key) {
    return this._layout[key];
  };
  /**
   * Get layout of single data item
   */


  SeriesData.prototype.getItemLayout = function (idx) {
    return this._itemLayouts[idx];
  };
  /**
   * Set layout of single data item
   */


  SeriesData.prototype.setItemLayout = function (idx, layout, merge) {
    this._itemLayouts[idx] = merge ? extend(this._itemLayouts[idx] || {}, layout) : layout;
  };
  /**
   * Clear all layout of single data item
   */


  SeriesData.prototype.clearItemLayouts = function () {
    this._itemLayouts.length = 0;
  };
  /**
   * Set graphic element relative to data. It can be set as null
   */


  SeriesData.prototype.setItemGraphicEl = function (idx, el) {
    var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
    setCommonECData(seriesIndex, this.dataType, idx, el);
    this._graphicEls[idx] = el;
  };

  SeriesData.prototype.getItemGraphicEl = function (idx) {
    return this._graphicEls[idx];
  };

  SeriesData.prototype.eachItemGraphicEl = function (cb, context) {
    each(this._graphicEls, function (el, idx) {
      if (el) {
        cb && cb.call(context, el, idx);
      }
    });
  };
  /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */


  SeriesData.prototype.cloneShallow = function (list) {
    if (!list) {
      list = new SeriesData(this._schema ? this._schema : map$1(this.dimensions, this._getDimInfo, this), this.hostModel);
    }

    transferProperties(list, this);
    list._store = this._store;
    return list;
  };
  /**
   * Wrap some method to add more feature
   */


  SeriesData.prototype.wrapMethod = function (methodName, injectFunction) {
    var originalMethod = this[methodName];

    if (!isFunction$3(originalMethod)) {
      return;
    }

    this.__wrappedMethods = this.__wrappedMethods || [];

    this.__wrappedMethods.push(methodName);

    this[methodName] = function () {
      var res = originalMethod.apply(this, arguments);
      return injectFunction.apply(this, [res].concat(slice(arguments)));
    };
  }; // ----------------------------------------------------------
  // A work around for internal method visiting private member.
  // ----------------------------------------------------------


  SeriesData.internalField = function () {
    prepareInvertedIndex = function (data) {
      var invertedIndicesMap = data._invertedIndicesMap;
      each(invertedIndicesMap, function (invertedIndices, dim) {
        var dimInfo = data._dimInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.

        var ordinalMeta = dimInfo.ordinalMeta;
        var store = data._store;

        if (ordinalMeta) {
          invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array$1(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
          // mapping to 0, we should set it as INDEX_NOT_FOUND.

          for (var i = 0; i < invertedIndices.length; i++) {
            invertedIndices[i] = INDEX_NOT_FOUND;
          }

          for (var i = 0; i < store.count(); i++) {
            // Only support the case that all values are distinct.
            invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
          }
        }
      });
    };

    getIdNameFromStore = function (data, dimIdx, idx) {
      return convertOptionIdName(data._getCategory(dimIdx, idx), null);
    };
    /**
     * @see the comment of `List['getId']`.
     */


    getId = function (data, rawIndex) {
      var id = data._idList[rawIndex];

      if (id == null && data._idDimIdx != null) {
        id = getIdNameFromStore(data, data._idDimIdx, rawIndex);
      }

      if (id == null) {
        id = ID_PREFIX + rawIndex;
      }

      return id;
    };

    normalizeDimensions = function (dimensions) {
      if (!isArray$1(dimensions)) {
        dimensions = dimensions != null ? [dimensions] : [];
      }

      return dimensions;
    };
    /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */


    cloneListForMapAndSample = function (original) {
      var list = new SeriesData(original._schema ? original._schema : map$1(original.dimensions, original._getDimInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked

      transferProperties(list, original);
      return list;
    };

    transferProperties = function (target, source) {
      each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
        if (source.hasOwnProperty(propName)) {
          target[propName] = source[propName];
        }
      });
      target.__wrappedMethods = source.__wrappedMethods;
      each(CLONE_PROPERTIES, function (propName) {
        target[propName] = clone(source[propName]);
      });
      target._calculationInfo = extend({}, source._calculationInfo);
    };

    makeIdFromName = function (data, idx) {
      var nameList = data._nameList;
      var idList = data._idList;
      var nameDimIdx = data._nameDimIdx;
      var idDimIdx = data._idDimIdx;
      var name = nameList[idx];
      var id = idList[idx];

      if (name == null && nameDimIdx != null) {
        nameList[idx] = name = getIdNameFromStore(data, nameDimIdx, idx);
      }

      if (id == null && idDimIdx != null) {
        idList[idx] = id = getIdNameFromStore(data, idDimIdx, idx);
      }

      if (id == null && name != null) {
        var nameRepeatCount = data._nameRepeatCount;
        var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
        id = name;

        if (nmCnt > 1) {
          id += '__ec__' + nmCnt;
        }

        idList[idx] = id;
      }
    };
  }();

  return SeriesData;
}();

/**
 * For outside usage compat (like echarts-gl are using it).
 */

function createDimensions(source, opt) {
  return prepareSeriesDataSchema(source, opt).dimensions;
}
/**
 * This method builds the relationship between:
 * + "what the coord sys or series requires (see `coordDimensions`)",
 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimensionsDefine` and `opt.encodeDefine`)"
 * + "what the data source provids (see `source`)".
 *
 * Some guess strategy will be adapted if user does not define something.
 * If no 'value' dimension specified, the first no-named dimension will be
 * named as 'value'.
 *
 * @return The results are always sorted by `storeDimIndex` asc.
 */

function prepareSeriesDataSchema( // TODO: TYPE completeDimensions type
source, opt) {
  if (!isSourceInstance(source)) {
    source = createSourceFromSeriesDataOption(source);
  }

  opt = opt || {};
  var sysDims = opt.coordDimensions || [];
  var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
  var coordDimNameMap = createHashMap();
  var resultList = [];
  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimensionsCount); // Try to ignore unused dimensions if sharing a high dimension datastore
  // 30 is an experience value.

  var omitUnusedDimensions = opt.canOmitUnusedDimensions && shouldOmitUnusedDimensions(dimCount);
  var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
  var dataDimNameMap = isUsingSourceDimensionsDef ? ensureSourceDimNameMap(source) : createDimNameMap(dimsDef);
  var encodeDef = opt.encodeDefine;

  if (!encodeDef && opt.encodeDefaulter) {
    encodeDef = opt.encodeDefaulter(source, dimCount);
  }

  var encodeDefMap = createHashMap(encodeDef);
  var indicesMap = new CtorInt32Array(dimCount);

  for (var i = 0; i < indicesMap.length; i++) {
    indicesMap[i] = -1;
  }

  function getResultItem(dimIdx) {
    var idx = indicesMap[dimIdx];

    if (idx < 0) {
      var dimDefItemRaw = dimsDef[dimIdx];
      var dimDefItem = isObject$2(dimDefItemRaw) ? dimDefItemRaw : {
        name: dimDefItemRaw
      };
      var resultItem = new SeriesDimensionDefine();
      var userDimName = dimDefItem.name;

      if (userDimName != null && dataDimNameMap.get(userDimName) != null) {
        // Only if `series.dimensions` is defined in option
        // displayName, will be set, and dimension will be displayed vertically in
        // tooltip by default.
        resultItem.name = resultItem.displayName = userDimName;
      }

      dimDefItem.type != null && (resultItem.type = dimDefItem.type);
      dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
      var newIdx = resultList.length;
      indicesMap[dimIdx] = newIdx;
      resultItem.storeDimIndex = dimIdx;
      resultList.push(resultItem);
      return resultItem;
    }

    return resultList[idx];
  }

  if (!omitUnusedDimensions) {
    for (var i = 0; i < dimCount; i++) {
      getResultItem(i);
    }
  } // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.


  encodeDefMap.each(function (dataDimsRaw, coordDim) {
    var dataDims = normalizeToArray(dataDimsRaw).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
    // this case.

    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
      encodeDefMap.set(coordDim, false);
      return;
    }

    var validDataDims = encodeDefMap.set(coordDim, []);
    each(dataDims, function (resultDimIdxOrName, idx) {
      // The input resultDimIdx can be dim name or index.
      var resultDimIdx = isString(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;

      if (resultDimIdx != null && resultDimIdx < dimCount) {
        validDataDims[idx] = resultDimIdx;
        applyDim(getResultItem(resultDimIdx), coordDim, idx);
      }
    });
  }); // Apply templates and default order from `sysDims`.

  var availDimIdx = 0;
  each(sysDims, function (sysDimItemRaw) {
    var coordDim;
    var sysDimItemDimsDef;
    var sysDimItemOtherDims;
    var sysDimItem;

    if (isString(sysDimItemRaw)) {
      coordDim = sysDimItemRaw;
      sysDimItem = {};
    } else {
      sysDimItem = sysDimItemRaw;
      coordDim = sysDimItem.name;
      var ordinalMeta = sysDimItem.ordinalMeta;
      sysDimItem.ordinalMeta = null;
      sysDimItem = extend({}, sysDimItem);
      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.

      sysDimItemDimsDef = sysDimItem.dimsDef;
      sysDimItemOtherDims = sysDimItem.otherDims;
      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
    }

    var dataDims = encodeDefMap.get(coordDim); // negative resultDimIdx means no need to mapping.

    if (dataDims === false) {
      return;
    }

    dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.

    if (!dataDims.length) {
      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
        while (availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null) {
          availDimIdx++;
        }

        availDimIdx < dimCount && dataDims.push(availDimIdx++);
      }
    } // Apply templates.


    each(dataDims, function (resultDimIdx, coordDimIndex) {
      var resultItem = getResultItem(resultDimIdx); // Coordinate system has a higher priority on dim type than source.

      if (isUsingSourceDimensionsDef && sysDimItem.type != null) {
        resultItem.type = sysDimItem.type;
      }

      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);

      if (resultItem.name == null && sysDimItemDimsDef) {
        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
        !isObject$2(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
          name: sysDimItemDimsDefItem
        });
        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}


      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
    });
  });

  function applyDim(resultItem, coordDim, coordDimIndex) {
    if (VISUAL_DIMENSIONS.get(coordDim) != null) {
      resultItem.otherDims[coordDim] = coordDimIndex;
    } else {
      resultItem.coordDim = coordDim;
      resultItem.coordDimIndex = coordDimIndex;
      coordDimNameMap.set(coordDim, true);
    }
  } // Make sure the first extra dim is 'value'.


  var generateCoord = opt.generateCoord;
  var generateCoordCount = opt.generateCoordCount;
  var fromZero = generateCoordCount != null;
  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
  var extra = generateCoord || 'value';

  function ifNoNameFillWithCoordName(resultItem) {
    if (resultItem.name == null) {
      // Duplication will be removed in the next step.
      resultItem.name = resultItem.coordDim;
    }
  } // Set dim `name` and other `coordDim` and other props.


  if (!omitUnusedDimensions) {
    for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
      var resultItem = getResultItem(resultDimIdx);
      var coordDim = resultItem.coordDim;

      if (coordDim == null) {
        // TODO no need to generate coordDim for isExtraCoord?
        resultItem.coordDim = genCoordDimName(extra, coordDimNameMap, fromZero);
        resultItem.coordDimIndex = 0; // Series specified generateCoord is using out.

        if (!generateCoord || generateCoordCount <= 0) {
          resultItem.isExtraCoord = true;
        }

        generateCoordCount--;
      }

      ifNoNameFillWithCoordName(resultItem);

      if (resultItem.type == null && (guessOrdinal(source, resultDimIdx) === BE_ORDINAL.Must // Consider the case:
      // {
      //    dataset: {source: [
      //        ['2001', 123],
      //        ['2002', 456],
      //        ...
      //        ['The others', 987],
      //    ]},
      //    series: {type: 'pie'}
      // }
      // The first column should better be treated as a "ordinal" although it
      // might not be detected as an "ordinal" by `guessOrdinal`.
      || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
        resultItem.type = 'ordinal';
      }
    }
  } else {
    each(resultList, function (resultItem) {
      // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
      ifNoNameFillWithCoordName(resultItem);
    }); // Sort dimensions: there are some rule that use the last dim as label,
    // and for some latter travel process easier.

    resultList.sort(function (item0, item1) {
      return item0.storeDimIndex - item1.storeDimIndex;
    });
  }

  removeDuplication(resultList);
  return new SeriesDataSchema({
    source: source,
    dimensions: resultList,
    fullDimensionCount: dimCount,
    dimensionOmitted: omitUnusedDimensions
  });
}

function removeDuplication(result) {
  var duplicationMap = createHashMap();

  for (var i = 0; i < result.length; i++) {
    var dim = result[i];
    var dimOriginalName = dim.name;
    var count = duplicationMap.get(dimOriginalName) || 0;

    if (count > 0) {
      // Starts from 0.
      dim.name = dimOriginalName + (count - 1);
    }

    count++;
    duplicationMap.set(dimOriginalName, count);
  }
} // ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?


function getDimCount(source, sysDims, dimsDef, optDimCount) {
  // Note that the result dimCount should not small than columns count
  // of data, otherwise `dataDimNameMap` checking will be incorrect.
  var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
  each(sysDims, function (sysDimItem) {
    var sysDimItemDimsDef;

    if (isObject$2(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) {
      dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    }
  });
  return dimCount;
}

function genCoordDimName(name, map, fromZero) {
  if (fromZero || map.hasKey(name)) {
    var i = 0;

    while (map.hasKey(name + i)) {
      i++;
    }

    name += i;
  }

  map.set(name, true);
  return name;
}

/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */

var CoordSysInfo =
/** @class */
function () {
  function CoordSysInfo(coordSysName) {
    this.coordSysDims = [];
    this.axisMap = createHashMap();
    this.categoryAxisMap = createHashMap();
    this.coordSysName = coordSysName;
  }

  return CoordSysInfo;
}();

function getCoordSysInfoBySeries(seriesModel) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var result = new CoordSysInfo(coordSysName);
  var fetch = fetchers[coordSysName];

  if (fetch) {
    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
    return result;
  }
}
var fetchers = {
  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
    var xAxisModel = seriesModel.getReferringComponents('xAxis', SINGLE_REFERRING).models[0];
    var yAxisModel = seriesModel.getReferringComponents('yAxis', SINGLE_REFERRING).models[0];

    if (process.env.NODE_ENV !== 'production') {
      if (!xAxisModel) {
        throw new Error('xAxis "' + retrieve(seriesModel.get('xAxisIndex'), seriesModel.get('xAxisId'), 0) + '" not found');
      }

      if (!yAxisModel) {
        throw new Error('yAxis "' + retrieve(seriesModel.get('xAxisIndex'), seriesModel.get('yAxisId'), 0) + '" not found');
      }
    }

    result.coordSysDims = ['x', 'y'];
    axisMap.set('x', xAxisModel);
    axisMap.set('y', yAxisModel);

    if (isCategory(xAxisModel)) {
      categoryAxisMap.set('x', xAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(yAxisModel)) {
      categoryAxisMap.set('y', yAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
    var singleAxisModel = seriesModel.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];

    if (process.env.NODE_ENV !== 'production') {
      if (!singleAxisModel) {
        throw new Error('singleAxis should be specified.');
      }
    }

    result.coordSysDims = ['single'];
    axisMap.set('single', singleAxisModel);

    if (isCategory(singleAxisModel)) {
      categoryAxisMap.set('single', singleAxisModel);
      result.firstCategoryDimIndex = 0;
    }
  },
  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
    var polarModel = seriesModel.getReferringComponents('polar', SINGLE_REFERRING).models[0];
    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
    var angleAxisModel = polarModel.findAxisModel('angleAxis');

    if (process.env.NODE_ENV !== 'production') {
      if (!angleAxisModel) {
        throw new Error('angleAxis option not found');
      }

      if (!radiusAxisModel) {
        throw new Error('radiusAxis option not found');
      }
    }

    result.coordSysDims = ['radius', 'angle'];
    axisMap.set('radius', radiusAxisModel);
    axisMap.set('angle', angleAxisModel);

    if (isCategory(radiusAxisModel)) {
      categoryAxisMap.set('radius', radiusAxisModel);
      result.firstCategoryDimIndex = 0;
    }

    if (isCategory(angleAxisModel)) {
      categoryAxisMap.set('angle', angleAxisModel);
      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
    }
  },
  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
    result.coordSysDims = ['lng', 'lat'];
  },
  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
    var ecModel = seriesModel.ecModel;
    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
      var axisDim = coordSysDims[index];
      axisMap.set(axisDim, axisModel);

      if (isCategory(axisModel)) {
        categoryAxisMap.set(axisDim, axisModel);

        if (result.firstCategoryDimIndex == null) {
          result.firstCategoryDimIndex = index;
        }
      }
    });
  }
};

function isCategory(axisModel) {
  return axisModel.get('type') === 'category';
}

/**
 * Note that it is too complicated to support 3d stack by value
 * (have to create two-dimension inverted index), so in 3d case
 * we just support that stacked by index.
 *
 * @param seriesModel
 * @param dimensionsInput The same as the input of <module:echarts/data/SeriesData>.
 *        The input will be modified.
 * @param opt
 * @param opt.stackedCoordDimension Specify a coord dimension if needed.
 * @param opt.byIndex=false
 * @return calculationInfo
 * {
 *     stackedDimension: string
 *     stackedByDimension: string
 *     isStackedByIndex: boolean
 *     stackedOverDimension: string
 *     stackResultDimension: string
 * }
 */

function enableDataStack(seriesModel, dimensionsInput, opt) {
  opt = opt || {};
  var byIndex = opt.byIndex;
  var stackedCoordDimension = opt.stackedCoordDimension;
  var dimensionDefineList;
  var schema;
  var store;

  if (isLegacyDimensionsInput(dimensionsInput)) {
    dimensionDefineList = dimensionsInput;
  } else {
    schema = dimensionsInput.schema;
    dimensionDefineList = schema.dimensions;
    store = dimensionsInput.store;
  } // Compatibal: when `stack` is set as '', do not stack.


  var mayStack = !!(seriesModel && seriesModel.get('stack'));
  var stackedByDimInfo;
  var stackedDimInfo;
  var stackResultDimension;
  var stackedOverDimension;
  each(dimensionDefineList, function (dimensionInfo, index) {
    if (isString(dimensionInfo)) {
      dimensionDefineList[index] = dimensionInfo = {
        name: dimensionInfo
      };
    }

    if (mayStack && !dimensionInfo.isExtraCoord) {
      // Find the first ordinal dimension as the stackedByDimInfo.
      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
        stackedByDimInfo = dimensionInfo;
      } // Find the first stackable dimension as the stackedDimInfo.


      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
        stackedDimInfo = dimensionInfo;
      }
    }
  });

  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
    // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
  // That put stack logic in List is for using conveniently in echarts extensions, but it
  // might not be a good way.


  if (stackedDimInfo) {
    // Use a weird name that not duplicated with other names.
    // Also need to use seriesModel.id as postfix because different
    // series may share same data store. The stack dimension needs to be distinguished.
    stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
    stackedOverDimension = '__\0ecstackedover_' + seriesModel.id; // Create inverted index to fast query index by value.

    if (stackedByDimInfo) {
      stackedByDimInfo.createInvertedIndices = true;
    }

    var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
    var stackedDimType = stackedDimInfo.type;
    var stackedDimCoordIndex_1 = 0;
    each(dimensionDefineList, function (dimensionInfo) {
      if (dimensionInfo.coordDim === stackedDimCoordDim_1) {
        stackedDimCoordIndex_1++;
      }
    });
    var stackedOverDimensionDefine = {
      name: stackResultDimension,
      coordDim: stackedDimCoordDim_1,
      coordDimIndex: stackedDimCoordIndex_1,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true,
      storeDimIndex: dimensionDefineList.length
    };
    var stackResultDimensionDefine = {
      name: stackedOverDimension,
      // This dimension contains stack base (generally, 0), so do not set it as
      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
      coordDim: stackedOverDimension,
      coordDimIndex: stackedDimCoordIndex_1 + 1,
      type: stackedDimType,
      isExtraCoord: true,
      isCalculationCoord: true,
      storeDimIndex: dimensionDefineList.length + 1
    };

    if (schema) {
      if (store) {
        stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
        stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
      }

      schema.appendCalculationDimension(stackedOverDimensionDefine);
      schema.appendCalculationDimension(stackResultDimensionDefine);
    } else {
      dimensionDefineList.push(stackedOverDimensionDefine);
      dimensionDefineList.push(stackResultDimensionDefine);
    }
  }

  return {
    stackedDimension: stackedDimInfo && stackedDimInfo.name,
    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
    isStackedByIndex: byIndex,
    stackedOverDimension: stackedOverDimension,
    stackResultDimension: stackResultDimension
  };
}

function isLegacyDimensionsInput(dimensionsInput) {
  return !isSeriesDataSchema(dimensionsInput.schema);
}

function isDimensionStacked(data, stackedDim) {
  // Each single series only maps to one pair of axis. So we do not need to
  // check stackByDim, whatever stacked by a dimension or stacked by index.
  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function getStackedDimension(data, targetDim) {
  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}

function getCoordSysDimDefs(seriesModel, coordSysInfo) {
  var coordSysName = seriesModel.get('coordinateSystem');
  var registeredCoordSys = CoordinateSystemManager.get(coordSysName);
  var coordSysDimDefs;

  if (coordSysInfo && coordSysInfo.coordSysDims) {
    coordSysDimDefs = map(coordSysInfo.coordSysDims, function (dim) {
      var dimInfo = {
        name: dim
      };
      var axisModel = coordSysInfo.axisMap.get(dim);

      if (axisModel) {
        var axisType = axisModel.get('type');
        dimInfo.type = getDimensionTypeByAxis(axisType);
      }

      return dimInfo;
    });
  }

  if (!coordSysDimDefs) {
    // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
  }

  return coordSysDimDefs;
}

function injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
  var firstCategoryDimIndex;
  var hasNameEncode;
  coordSysInfo && each(dimInfoList, function (dimInfo, dimIndex) {
    var coordDim = dimInfo.coordDim;
    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);

    if (categoryAxisModel) {
      if (firstCategoryDimIndex == null) {
        firstCategoryDimIndex = dimIndex;
      }

      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();

      if (createInvertedIndices) {
        dimInfo.createInvertedIndices = true;
      }
    }

    if (dimInfo.otherDims.itemName != null) {
      hasNameEncode = true;
    }
  });

  if (!hasNameEncode && firstCategoryDimIndex != null) {
    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
  }

  return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */


function createSeriesData(sourceRaw, seriesModel, opt) {
  opt = opt || {};
  var sourceManager = seriesModel.getSourceManager();
  var source;
  var isOriginalSource = false;

  if (sourceRaw) {
    isOriginalSource = true;
    source = createSourceFromSeriesDataOption(sourceRaw);
  } else {
    source = sourceManager.getSource(); // Is series.data. not dataset.

    isOriginalSource = source.sourceFormat === SOURCE_FORMAT_ORIGINAL;
  }

  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
  var coordSysDimDefs = getCoordSysDimDefs(seriesModel, coordSysInfo);
  var useEncodeDefaulter = opt.useEncodeDefaulter;
  var encodeDefaulter = isFunction$3(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null;
  var createDimensionOptions = {
    coordDimensions: coordSysDimDefs,
    generateCoord: opt.generateCoord,
    encodeDefine: seriesModel.getEncode(),
    encodeDefaulter: encodeDefaulter,
    canOmitUnusedDimensions: !isOriginalSource
  };
  var schema = prepareSeriesDataSchema(source, createDimensionOptions);
  var firstCategoryDimIndex = injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
  var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
  var stackCalculationInfo = enableDataStack(seriesModel, {
    schema: schema,
    store: store
  });
  var data = new SeriesData(schema, seriesModel);
  data.setCalculationInfo(stackCalculationInfo);
  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
    // Use dataIndex as ordinal value in categoryAxis
    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
  } : null;
  data.hasItemOption = false;
  data.initData( // Try to reuse the data store in sourceManager if using dataset.
  isOriginalSource ? source : store, null, dimValueGetter);
  return data;
}

function isNeedCompleteOrdinalData(source) {
  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
    var sampleItem = firstDataNotNull(source.data || []);
    return !isArray$1(getDataItemValue(sampleItem));
  }
}

function firstDataNotNull(arr) {
  var i = 0;

  while (i < arr.length && arr[i] == null) {
    i++;
  }

  return arr[i];
}

var Scale =
/** @class */
function () {
  function Scale(setting) {
    this._setting = setting || {};
    this._extent = [Infinity, -Infinity];
  }

  Scale.prototype.getSetting = function (name) {
    return this._setting[name];
  };
  /**
   * Set extent from data
   */


  Scale.prototype.unionExtent = function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
  };
  /**
   * Set extent from data
   */


  Scale.prototype.unionExtentFromData = function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * Get extent
   *
   * Extent is always in increase order.
   */


  Scale.prototype.getExtent = function () {
    return this._extent.slice();
  };
  /**
   * Set extent
   */


  Scale.prototype.setExtent = function (start, end) {
    var thisExtent = this._extent;

    if (!isNaN(start)) {
      thisExtent[0] = start;
    }

    if (!isNaN(end)) {
      thisExtent[1] = end;
    }
  };
  /**
   * If value is in extent range
   */


  Scale.prototype.isInExtentRange = function (value) {
    return this._extent[0] <= value && this._extent[1] >= value;
  };
  /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */


  Scale.prototype.isBlank = function () {
    return this._isBlank;
  };
  /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */


  Scale.prototype.setBlank = function (isBlank) {
    this._isBlank = isBlank;
  };

  return Scale;
}();

enableClassManagement(Scale);

var uidBase = 0;

var OrdinalMeta =
/** @class */
function () {
  function OrdinalMeta(opt) {
    this.categories = opt.categories || [];
    this._needCollect = opt.needCollect;
    this._deduplication = opt.deduplication;
    this.uid = ++uidBase;
  }

  OrdinalMeta.createByAxisModel = function (axisModel) {
    var option = axisModel.option;
    var data = option.data;
    var categories = data && map(data, getName);
    return new OrdinalMeta({
      categories: categories,
      needCollect: !categories,
      // deduplication is default in axis.
      deduplication: option.dedplication !== false
    });
  };

  OrdinalMeta.prototype.getOrdinal = function (category) {
    // @ts-ignore
    return this._getOrCreateMap().get(category);
  };
  /**
   * @return The ordinal. If not found, return NaN.
   */


  OrdinalMeta.prototype.parseAndCollect = function (category) {
    var index;
    var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
    // This feature is only supported when !needCollect, because we should
    // consider a common case: a value is 2017, which is a number but is
    // expected to be tread as a category. This case usually happen in dataset,
    // where it happent to be no need of the index feature.

    if (!isString(category) && !needCollect) {
      return category;
    } // Optimize for the scenario:
    // category is ['2012-01-01', '2012-01-02', ...], where the input
    // data has been ensured not duplicate and is large data.
    // Notice, if a dataset dimension provide categroies, usually echarts
    // should remove duplication except user tell echarts dont do that
    // (set axis.deduplication = false), because echarts do not know whether
    // the values in the category dimension has duplication (consider the
    // parallel-aqi example)


    if (needCollect && !this._deduplication) {
      index = this.categories.length;
      this.categories[index] = category;
      return index;
    }

    var map = this._getOrCreateMap(); // @ts-ignore


    index = map.get(category);

    if (index == null) {
      if (needCollect) {
        index = this.categories.length;
        this.categories[index] = category; // @ts-ignore

        map.set(category, index);
      } else {
        index = NaN;
      }
    }

    return index;
  }; // Consider big data, do not create map until needed.


  OrdinalMeta.prototype._getOrCreateMap = function () {
    return this._map || (this._map = createHashMap(this.categories));
  };

  return OrdinalMeta;
}();

function getName(obj) {
  if (isObject$2(obj) && obj.value != null) {
    return obj.value;
  } else {
    return obj + '';
  }
}

function isValueNice(val) {
  var exp10 = Math.pow(10, quantityExponent(Math.abs(val)));
  var f = Math.abs(val / exp10);
  return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function isIntervalOrLogScale(scale) {
  return scale.type === 'interval' || scale.type === 'log';
}
/**
 * @param extent Both extent[0] and extent[1] should be valid number.
 *               Should be extent[0] < extent[1].
 * @param splitNumber splitNumber should be >= 1.
 */

function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
  var result = {};
  var span = extent[1] - extent[0];
  var interval = result.interval = nice(span / splitNumber, true);

  if (minInterval != null && interval < minInterval) {
    interval = result.interval = minInterval;
  }

  if (maxInterval != null && interval > maxInterval) {
    interval = result.interval = maxInterval;
  } // Tow more digital for tick.


  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent

  var niceTickExtent = result.niceTickExtent = [round$3(Math.ceil(extent[0] / interval) * interval, precision), round$3(Math.floor(extent[1] / interval) * interval, precision)];
  fixExtent(niceTickExtent, extent);
  return result;
}
function increaseInterval(interval) {
  var exp10 = Math.pow(10, quantityExponent(interval)); // Increase interval

  var f = interval / exp10;

  if (!f) {
    f = 1;
  } else if (f === 2) {
    f = 3;
  } else if (f === 3) {
    f = 5;
  } else {
    // f is 1 or 5
    f *= 2;
  }

  return round$3(f * exp10);
}
/**
 * @return interval precision
 */

function getIntervalPrecision(interval) {
  // Tow more digital for tick.
  return getPrecision(interval) + 2;
}

function clamp$2(niceTickExtent, idx, extent) {
  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.


function fixExtent(niceTickExtent, extent) {
  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
  clamp$2(niceTickExtent, 0, extent);
  clamp$2(niceTickExtent, 1, extent);

  if (niceTickExtent[0] > niceTickExtent[1]) {
    niceTickExtent[0] = niceTickExtent[1];
  }
}
function contain$1(val, extent) {
  return val >= extent[0] && val <= extent[1];
}
function normalize$1(val, extent) {
  if (extent[1] === extent[0]) {
    return 0.5;
  }

  return (val - extent[0]) / (extent[1] - extent[0]);
}
function scale$2(val, extent) {
  return val * (extent[1] - extent[0]) + extent[0];
}

var OrdinalScale =
/** @class */
function (_super) {
  __extends$1(OrdinalScale, _super);

  function OrdinalScale(setting) {
    var _this = _super.call(this, setting) || this;

    _this.type = 'ordinal';

    var ordinalMeta = _this.getSetting('ordinalMeta'); // Caution: Should not use instanceof, consider ec-extensions using
    // import approach to get OrdinalMeta class.


    if (!ordinalMeta) {
      ordinalMeta = new OrdinalMeta({});
    }

    if (isArray$1(ordinalMeta)) {
      ordinalMeta = new OrdinalMeta({
        categories: map(ordinalMeta, function (item) {
          return isObject$2(item) ? item.value : item;
        })
      });
    }

    _this._ordinalMeta = ordinalMeta;
    _this._extent = _this.getSetting('extent') || [0, ordinalMeta.categories.length - 1];
    return _this;
  }

  OrdinalScale.prototype.parse = function (val) {
    // Caution: Math.round(null) will return `0` rather than `NaN`
    if (val == null) {
      return NaN;
    }

    return isString(val) ? this._ordinalMeta.getOrdinal(val) // val might be float.
    : Math.round(val);
  };

  OrdinalScale.prototype.contain = function (rank) {
    rank = this.parse(rank);
    return contain$1(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
  };
  /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */


  OrdinalScale.prototype.normalize = function (val) {
    val = this._getTickNumber(this.parse(val));
    return normalize$1(val, this._extent);
  };
  /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */


  OrdinalScale.prototype.scale = function (val) {
    val = Math.round(scale$2(val, this._extent));
    return this.getRawOrdinalNumber(val);
  };

  OrdinalScale.prototype.getTicks = function () {
    var ticks = [];
    var extent = this._extent;
    var rank = extent[0];

    while (rank <= extent[1]) {
      ticks.push({
        value: rank
      });
      rank++;
    }

    return ticks;
  };

  OrdinalScale.prototype.getMinorTicks = function (splitNumber) {
    // Not support.
    return;
  };
  /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */


  OrdinalScale.prototype.setSortInfo = function (info) {
    if (info == null) {
      this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
      return;
    }

    var infoOrdinalNumbers = info.ordinalNumbers;
    var ordinalsByTick = this._ordinalNumbersByTick = [];
    var ticksByOrdinal = this._ticksByOrdinalNumber = []; // Unnecessary support negative tick in `realtimeSort`.

    var tickNum = 0;
    var allCategoryLen = this._ordinalMeta.categories.length;

    for (var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum) {
      var ordinalNumber = infoOrdinalNumbers[tickNum];
      ordinalsByTick[tickNum] = ordinalNumber;
      ticksByOrdinal[ordinalNumber] = tickNum;
    } // Handle that `series.data` only covers part of the `axis.category.data`.


    var unusedOrdinal = 0;

    for (; tickNum < allCategoryLen; ++tickNum) {
      while (ticksByOrdinal[unusedOrdinal] != null) {
        unusedOrdinal++;
      }
      ordinalsByTick.push(unusedOrdinal);
      ticksByOrdinal[unusedOrdinal] = tickNum;
    }
  };

  OrdinalScale.prototype._getTickNumber = function (ordinal) {
    var ticksByOrdinalNumber = this._ticksByOrdinalNumber; // also support ordinal out of range of `ordinalMeta.categories.length`,
    // where ordinal numbers are used as tick value directly.

    return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
  };
  /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */


  OrdinalScale.prototype.getRawOrdinalNumber = function (tickNumber) {
    var ordinalNumbersByTick = this._ordinalNumbersByTick; // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
    // where ordinal numbers are used as tick value directly.

    return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
  };
  /**
   * Get item on tick
   */


  OrdinalScale.prototype.getLabel = function (tick) {
    if (!this.isBlank()) {
      var ordinalNumber = this.getRawOrdinalNumber(tick.value);
      var cateogry = this._ordinalMeta.categories[ordinalNumber]; // Note that if no data, ordinalMeta.categories is an empty array.
      // Return empty if it's not exist.

      return cateogry == null ? '' : cateogry + '';
    }
  };

  OrdinalScale.prototype.count = function () {
    return this._extent[1] - this._extent[0] + 1;
  };

  OrdinalScale.prototype.unionExtentFromData = function (data, dim) {
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * @override
   * If value is in extent range
   */


  OrdinalScale.prototype.isInExtentRange = function (value) {
    value = this._getTickNumber(value);
    return this._extent[0] <= value && this._extent[1] >= value;
  };

  OrdinalScale.prototype.getOrdinalMeta = function () {
    return this._ordinalMeta;
  };

  OrdinalScale.prototype.calcNiceTicks = function () {};

  OrdinalScale.prototype.calcNiceExtent = function () {};

  OrdinalScale.type = 'ordinal';
  return OrdinalScale;
}(Scale);

Scale.registerClass(OrdinalScale);

var roundNumber = round$3;

var IntervalScale =
/** @class */
function (_super) {
  __extends$1(IntervalScale, _super);

  function IntervalScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'interval'; // Step is calculated in adjustExtent.

    _this._interval = 0;
    _this._intervalPrecision = 2;
    return _this;
  }

  IntervalScale.prototype.parse = function (val) {
    return val;
  };

  IntervalScale.prototype.contain = function (val) {
    return contain$1(val, this._extent);
  };

  IntervalScale.prototype.normalize = function (val) {
    return normalize$1(val, this._extent);
  };

  IntervalScale.prototype.scale = function (val) {
    return scale$2(val, this._extent);
  };

  IntervalScale.prototype.setExtent = function (start, end) {
    var thisExtent = this._extent; // start,end may be a Number like '25',so...

    if (!isNaN(start)) {
      thisExtent[0] = parseFloat(start);
    }

    if (!isNaN(end)) {
      thisExtent[1] = parseFloat(end);
    }
  };

  IntervalScale.prototype.unionExtent = function (other) {
    var extent = this._extent;
    other[0] < extent[0] && (extent[0] = other[0]);
    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes

    this.setExtent(extent[0], extent[1]);
  };

  IntervalScale.prototype.getInterval = function () {
    return this._interval;
  };

  IntervalScale.prototype.setInterval = function (interval) {
    this._interval = interval; // Dropped auto calculated niceExtent and use user-set extent.
    // We assume user wants to set both interval, min, max to get a better result.

    this._niceExtent = this._extent.slice();
    this._intervalPrecision = getIntervalPrecision(interval);
  };
  /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */


  IntervalScale.prototype.getTicks = function (expandToNicedExtent) {
    var interval = this._interval;
    var extent = this._extent;
    var niceTickExtent = this._niceExtent;
    var intervalPrecision = this._intervalPrecision;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    } // Consider this case: using dataZoom toolbox, zoom and zoom.


    var safeLimit = 10000;

    if (extent[0] < niceTickExtent[0]) {
      if (expandToNicedExtent) {
        ticks.push({
          value: roundNumber(niceTickExtent[0] - interval, intervalPrecision)
        });
      } else {
        ticks.push({
          value: extent[0]
        });
      }
    }

    var tick = niceTickExtent[0];

    while (tick <= niceTickExtent[1]) {
      ticks.push({
        value: tick
      }); // Avoid rounding error

      tick = roundNumber(tick + interval, intervalPrecision);

      if (tick === ticks[ticks.length - 1].value) {
        // Consider out of safe float point, e.g.,
        // -3711126.9907707 + 2e-10 === -3711126.9907707
        break;
      }

      if (ticks.length > safeLimit) {
        return [];
      }
    } // Consider this case: the last item of ticks is smaller
    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].


    var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];

    if (extent[1] > lastNiceTick) {
      if (expandToNicedExtent) {
        ticks.push({
          value: roundNumber(lastNiceTick + interval, intervalPrecision)
        });
      } else {
        ticks.push({
          value: extent[1]
        });
      }
    }

    return ticks;
  };

  IntervalScale.prototype.getMinorTicks = function (splitNumber) {
    var ticks = this.getTicks(true);
    var minorTicks = [];
    var extent = this.getExtent();

    for (var i = 1; i < ticks.length; i++) {
      var nextTick = ticks[i];
      var prevTick = ticks[i - 1];
      var count = 0;
      var minorTicksGroup = [];
      var interval = nextTick.value - prevTick.value;
      var minorInterval = interval / splitNumber;

      while (count < splitNumber - 1) {
        var minorTick = roundNumber(prevTick.value + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.

        if (minorTick > extent[0] && minorTick < extent[1]) {
          minorTicksGroup.push(minorTick);
        }

        count++;
      }

      minorTicks.push(minorTicksGroup);
    }

    return minorTicks;
  };
  /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */


  IntervalScale.prototype.getLabel = function (data, opt) {
    if (data == null) {
      return '';
    }

    var precision = opt && opt.precision;

    if (precision == null) {
      precision = getPrecision(data.value) || 0;
    } else if (precision === 'auto') {
      // Should be more precise then tick.
      precision = this._intervalPrecision;
    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.


    var dataNum = roundNumber(data.value, precision, true);
    return addCommas(dataNum);
  };
  /**
   * @param splitNumber By default `5`.
   */


  IntervalScale.prototype.calcNiceTicks = function (splitNumber, minInterval, maxInterval) {
    splitNumber = splitNumber || 5;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (!isFinite(span)) {
      return;
    } // User may set axis min 0 and data are all negative
    // FIXME If it needs to reverse ?


    if (span < 0) {
      span = -span;
      extent.reverse();
    }

    var result = intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
    this._intervalPrecision = result.intervalPrecision;
    this._interval = result.interval;
    this._niceExtent = result.niceTickExtent;
  };

  IntervalScale.prototype.calcNiceExtent = function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      if (extent[0] !== 0) {
        // Expand extent
        // Note that extents can be both negative. See #13154
        var expandSize = Math.abs(extent[0]); // In the fowllowing case
        //      Axis has been fixed max 100
        //      Plus data are all 100 and axis extent are [100, 100].
        // Extend to the both side will cause expanded max is larger than fixed max.
        // So only expand to the smaller side.

        if (!opt.fixMax) {
          extent[1] += expandSize / 2;
          extent[0] -= expandSize / 2;
        } else {
          extent[0] -= expandSize / 2;
        }
      } else {
        extent[1] = 1;
      }
    }

    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]

    if (!isFinite(span)) {
      extent[0] = 0;
      extent[1] = 1;
    }

    this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // let extent = this._extent;

    var interval = this._interval;

    if (!opt.fixMin) {
      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
    }

    if (!opt.fixMax) {
      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
    }
  };

  IntervalScale.prototype.setNiceExtent = function (min, max) {
    this._niceExtent = [min, max];
  };

  IntervalScale.type = 'interval';
  return IntervalScale;
}(Scale);

Scale.registerClass(IntervalScale);

/* global Float32Array */

var supportFloat32Array = typeof Float32Array !== 'undefined';
var Float32ArrayCtor = !supportFloat32Array ? Array : Float32Array;
function createFloat32Array(arg) {
  if (isArray$1(arg)) {
    // Return self directly if don't support TypedArray.
    return supportFloat32Array ? new Float32Array(arg) : arg;
  } // Else is number


  return new Float32ArrayCtor(arg);
}

var STACK_PREFIX = '__ec_stack_';

function getSeriesStackId(seriesModel) {
  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
}

function getAxisKey(axis) {
  return axis.dim + axis.index;
}
/**
 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
 */


function getLayoutOnAxis(opt) {
  var params = [];
  var baseAxis = opt.axis;
  var axisKey = 'axis0';

  if (baseAxis.type !== 'category') {
    return;
  }

  var bandWidth = baseAxis.getBandWidth();

  for (var i = 0; i < opt.count || 0; i++) {
    params.push(defaults({
      bandWidth: bandWidth,
      axisKey: axisKey,
      stackId: STACK_PREFIX + i
    }, opt));
  }

  var widthAndOffsets = doCalBarWidthAndOffset(params);
  var result = [];

  for (var i = 0; i < opt.count; i++) {
    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
    item.offsetCenter = item.offset + item.width / 2;
    result.push(item);
  }

  return result;
}
function prepareLayoutBarSeries(seriesType, ecModel) {
  var seriesModels = [];
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for cartesian2d only
    if (isOnCartesian(seriesModel)) {
      seriesModels.push(seriesModel);
    }
  });
  return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */

function getValueAxesMinGaps(barSeries) {
  /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */
  var axisValues = {};
  each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();

    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
      return;
    }

    var data = seriesModel.getData();
    var key = baseAxis.dim + '_' + baseAxis.index;
    var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
    var store = data.getStore();

    for (var i = 0, cnt = store.count(); i < cnt; ++i) {
      var value = store.get(dimIdx, i);

      if (!axisValues[key]) {
        // No previous data for the axis
        axisValues[key] = [value];
      } else {
        // No value in previous series
        axisValues[key].push(value);
      } // Ignore duplicated time values in the same axis

    }
  });
  var axisMinGaps = {};

  for (var key in axisValues) {
    if (axisValues.hasOwnProperty(key)) {
      var valuesInAxis = axisValues[key];

      if (valuesInAxis) {
        // Sort axis values into ascending order to calculate gaps
        valuesInAxis.sort(function (a, b) {
          return a - b;
        });
        var min = null;

        for (var j = 1; j < valuesInAxis.length; ++j) {
          var delta = valuesInAxis[j] - valuesInAxis[j - 1];

          if (delta > 0) {
            // Ignore 0 delta because they are of the same axis value
            min = min === null ? delta : Math.min(min, delta);
          }
        } // Set to null if only have one data


        axisMinGaps[key] = min;
      }
    }
  }

  return axisMinGaps;
}

function makeColumnLayout(barSeries) {
  var axisMinGaps = getValueAxesMinGaps(barSeries);
  var seriesInfoList = [];
  each(barSeries, function (seriesModel) {
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var axisExtent = baseAxis.getExtent();
    var bandWidth;

    if (baseAxis.type === 'category') {
      bandWidth = baseAxis.getBandWidth();
    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
      var key = baseAxis.dim + '_' + baseAxis.index;
      var minGap = axisMinGaps[key];
      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
      var scale = baseAxis.scale.getExtent();
      var scaleSpan = Math.abs(scale[1] - scale[0]);
      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
    } else {
      var data = seriesModel.getData();
      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    }

    var barWidth = parsePercent$1(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent$1(seriesModel.get('barMaxWidth'), bandWidth);
    var barMinWidth = parsePercent$1( // barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
    // the auto-calculated bar width might be less than 0.5 / 1.
    seriesModel.get('barMinWidth') || (isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');
    seriesInfoList.push({
      bandWidth: bandWidth,
      barWidth: barWidth,
      barMaxWidth: barMaxWidth,
      barMinWidth: barMinWidth,
      barGap: barGap,
      barCategoryGap: barCategoryGap,
      axisKey: getAxisKey(baseAxis),
      stackId: getSeriesStackId(seriesModel)
    });
  });
  return doCalBarWidthAndOffset(seriesInfoList);
}

function doCalBarWidthAndOffset(seriesInfoList) {
  // Columns info on each category axis. Key is cartesian name
  var columnsMap = {};
  each(seriesInfoList, function (seriesInfo, idx) {
    var axisKey = seriesInfo.axisKey;
    var bandWidth = seriesInfo.bandWidth;
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: null,
      gap: '20%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = seriesInfo.stackId;

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    }; // Caution: In a single coordinate system, these barGrid attributes
    // will be shared by series. Consider that they have default values,
    // only the attributes set on the last series will work.
    // Do not change this fact unless there will be a break change.

    var barWidth = seriesInfo.barWidth;

    if (barWidth && !stacks[stackId].width) {
      // See #6312, do not restrict width.
      stacks[stackId].width = barWidth;
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      columnsOnAxis.remainedWidth -= barWidth;
    }

    var barMaxWidth = seriesInfo.barMaxWidth;
    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    var barMinWidth = seriesInfo.barMinWidth;
    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
    var barGap = seriesInfo.barGap;
    barGap != null && (columnsOnAxis.gap = barGap);
    var barCategoryGap = seriesInfo.barCategoryGap;
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGapPercent = columnsOnAxis.categoryGap;

    if (categoryGapPercent == null) {
      var columnCount = keys$2(stacks).length; // More columns in one group
      // the spaces between group is smaller. Or the column will be too thin.

      categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
    }

    var categoryGap = parsePercent$1(categoryGapPercent, bandWidth);
    var barGapPercent = parsePercent$1(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    each(stacks, function (column) {
      var maxWidth = column.maxWidth;
      var minWidth = column.minWidth;

      if (!column.width) {
        var finalWidth = autoWidth;

        if (maxWidth && maxWidth < finalWidth) {
          finalWidth = Math.min(maxWidth, remainedWidth);
        } // `minWidth` has higher priority. `minWidth` decide that whether the
        // bar is able to be visible. So `minWidth` should not be restricted
        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
        // the extreme cases for `value` axis, bars are allowed to overlap
        // with each other if `minWidth` specified.


        if (minWidth && minWidth > finalWidth) {
          finalWidth = minWidth;
        }

        if (finalWidth !== autoWidth) {
          column.width = finalWidth;
          remainedWidth -= finalWidth + barGapPercent * finalWidth;
          autoWidthCount--;
        }
      } else {
        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
        // CSS does. Because barWidth can be a percent value, where
        // `barMaxWidth` can be used to restrict the final width.
        var finalWidth = column.width;

        if (maxWidth) {
          finalWidth = Math.min(finalWidth, maxWidth);
        } // `minWidth` has higher priority, as described above


        if (minWidth) {
          finalWidth = Math.max(finalWidth, minWidth);
        }

        column.width = finalWidth;
        remainedWidth -= finalWidth + barGapPercent * finalWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        bandWidth: bandWidth,
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
  if (barWidthAndOffset && axis) {
    var result = barWidthAndOffset[getAxisKey(axis)];

    if (result != null && seriesModel != null) {
      return result[getSeriesStackId(seriesModel)];
    }

    return result;
  }
}
function layout(seriesType, ecModel) {
  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
  var barWidthAndOffset = makeColumnLayout(seriesModels);
  each(seriesModels, function (seriesModel) {
    var data = seriesModel.getData();
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var stackId = getSeriesStackId(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    data.setLayout({
      bandWidth: columnLayoutInfo.bandWidth,
      offset: columnOffset,
      size: columnWidth
    });
  });
} // TODO: Do not support stack in large mode yet.

function createProgressiveLayout(seriesType) {
  return {
    seriesType: seriesType,
    plan: createRenderPlanner(),
    reset: function (seriesModel) {
      if (!isOnCartesian(seriesModel)) {
        return;
      }

      var data = seriesModel.getData();
      var cartesian = seriesModel.coordinateSystem;
      var baseAxis = cartesian.getBaseAxis();
      var valueAxis = cartesian.getOtherAxis(baseAxis);
      var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
      var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
      var drawBackground = seriesModel.get('showBackground', true);
      var valueDim = data.mapDimension(valueAxis.dim);
      var stackResultDim = data.getCalculationInfo('stackResultDimension');
      var stacked = isDimensionStacked(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
      var isValueAxisH = valueAxis.isHorizontal();
      var valueAxisStart = getValueAxisStart(baseAxis, valueAxis);
      var isLarge = isInLargeMode(seriesModel);
      var barMinHeight = seriesModel.get('barMinHeight') || 0;
      var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim); // Layout info.

      var columnWidth = data.getLayout('size');
      var columnOffset = data.getLayout('offset');
      return {
        progress: function (params, data) {
          var count = params.count;
          var largePoints = isLarge && createFloat32Array(count * 3);
          var largeBackgroundPoints = isLarge && drawBackground && createFloat32Array(count * 3);
          var largeDataIndices = isLarge && createFloat32Array(count);
          var coordLayout = cartesian.master.getRect();
          var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
          var dataIndex;
          var store = data.getStore();
          var idxOffset = 0;

          while ((dataIndex = params.next()) != null) {
            var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
            var baseValue = store.get(baseDimIdx, dataIndex);
            var baseCoord = valueAxisStart;
            var startValue = void 0; // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.

            if (stacked) {
              startValue = +value - store.get(valueDimIdx, dataIndex);
            }

            var x = void 0;
            var y = void 0;
            var width = void 0;
            var height = void 0;

            if (isValueAxisH) {
              var coord = cartesian.dataToPoint([value, baseValue]);

              if (stacked) {
                var startCoord = cartesian.dataToPoint([startValue, baseValue]);
                baseCoord = startCoord[0];
              }

              x = baseCoord;
              y = coord[1] + columnOffset;
              width = coord[0] - baseCoord;
              height = columnWidth;

              if (Math.abs(width) < barMinHeight) {
                width = (width < 0 ? -1 : 1) * barMinHeight;
              }
            } else {
              var coord = cartesian.dataToPoint([baseValue, value]);

              if (stacked) {
                var startCoord = cartesian.dataToPoint([baseValue, startValue]);
                baseCoord = startCoord[1];
              }

              x = coord[0] + columnOffset;
              y = baseCoord;
              width = columnWidth;
              height = coord[1] - baseCoord;

              if (Math.abs(height) < barMinHeight) {
                // Include zero to has a positive bar
                height = (height <= 0 ? -1 : 1) * barMinHeight;
              }
            }

            if (!isLarge) {
              data.setItemLayout(dataIndex, {
                x: x,
                y: y,
                width: width,
                height: height
              });
            } else {
              largePoints[idxOffset] = x;
              largePoints[idxOffset + 1] = y;
              largePoints[idxOffset + 2] = isValueAxisH ? width : height;

              if (largeBackgroundPoints) {
                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                largeBackgroundPoints[idxOffset + 2] = bgSize;
              }

              largeDataIndices[dataIndex] = dataIndex;
            }

            idxOffset += 3;
          }

          if (isLarge) {
            data.setLayout({
              largePoints: largePoints,
              largeDataIndices: largeDataIndices,
              largeBackgroundPoints: largeBackgroundPoints,
              valueAxisHorizontal: isValueAxisH
            });
          }
        }
      };
    }
  };
}

function isOnCartesian(seriesModel) {
  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}

function isInLargeMode(seriesModel) {
  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
} // See cases in `test/bar-start.html` and `#7412`, `#8747`.


function getValueAxisStart(baseAxis, valueAxis) {
  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
}

var bisect = function (a, x, lo, hi) {
  while (lo < hi) {
    var mid = lo + hi >>> 1;

    if (a[mid][1] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }

  return lo;
};

var TimeScale =
/** @class */
function (_super) {
  __extends$1(TimeScale, _super);

  function TimeScale(settings) {
    var _this = _super.call(this, settings) || this;

    _this.type = 'time';
    return _this;
  }
  /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */


  TimeScale.prototype.getLabel = function (tick) {
    var useUTC = this.getSetting('useUTC');
    return format$1(tick.value, fullLeveledFormatter[getDefaultFormatPrecisionOfInterval(getPrimaryTimeUnit(this._minLevelUnit))] || fullLeveledFormatter.second, useUTC, this.getSetting('locale'));
  };

  TimeScale.prototype.getFormattedLabel = function (tick, idx, labelFormatter) {
    var isUTC = this.getSetting('useUTC');
    var lang = this.getSetting('locale');
    return leveledFormat(tick, idx, labelFormatter, lang, isUTC);
  };
  /**
   * @override
   */


  TimeScale.prototype.getTicks = function () {
    var interval = this._interval;
    var extent = this._extent;
    var ticks = []; // If interval is 0, return [];

    if (!interval) {
      return ticks;
    }

    ticks.push({
      value: extent[0],
      level: 0
    });
    var useUTC = this.getSetting('useUTC');
    var innerTicks = getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
    ticks = ticks.concat(innerTicks);
    ticks.push({
      value: extent[1],
      level: 0
    });
    return ticks;
  };

  TimeScale.prototype.calcNiceExtent = function (opt) {
    var extent = this._extent; // If extent start and end are same, expand them

    if (extent[0] === extent[1]) {
      // Expand extent
      extent[0] -= ONE_DAY;
      extent[1] += ONE_DAY;
    } // If there are no data and extent are [Infinity, -Infinity]


    if (extent[1] === -Infinity && extent[0] === Infinity) {
      var d = new Date();
      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
      extent[0] = extent[1] - ONE_DAY;
    }

    this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
  };

  TimeScale.prototype.calcNiceTicks = function (approxTickNum, minInterval, maxInterval) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];
    this._approxInterval = span / approxTickNum;

    if (minInterval != null && this._approxInterval < minInterval) {
      this._approxInterval = minInterval;
    }

    if (maxInterval != null && this._approxInterval > maxInterval) {
      this._approxInterval = maxInterval;
    }

    var scaleIntervalsLen = scaleIntervals.length;
    var idx = Math.min(bisect(scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1); // Interval that can be used to calculate ticks

    this._interval = scaleIntervals[idx][1]; // Min level used when picking ticks from top down.
    // We check one more level to avoid the ticks are to sparse in some case.

    this._minLevelUnit = scaleIntervals[Math.max(idx - 1, 0)][0];
  };

  TimeScale.prototype.parse = function (val) {
    // val might be float.
    return isNumber$1(val) ? val : +parseDate(val);
  };

  TimeScale.prototype.contain = function (val) {
    return contain$1(this.parse(val), this._extent);
  };

  TimeScale.prototype.normalize = function (val) {
    return normalize$1(this.parse(val), this._extent);
  };

  TimeScale.prototype.scale = function (val) {
    return scale$2(val, this._extent);
  };

  TimeScale.type = 'time';
  return TimeScale;
}(IntervalScale);
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */


var scaleIntervals = [// Format                           interval
['second', ONE_SECOND], ['minute', ONE_MINUTE], ['hour', ONE_HOUR], ['quarter-day', ONE_HOUR * 6], ['half-day', ONE_HOUR * 12], ['day', ONE_DAY * 1.2], ['half-week', ONE_DAY * 3.5], ['week', ONE_DAY * 7], ['month', ONE_DAY * 31], ['quarter', ONE_DAY * 95], ['half-year', ONE_YEAR / 2], ['year', ONE_YEAR] // 1Y
];

function isUnitValueSame(unit, valueA, valueB, isUTC) {
  var dateA = parseDate(valueA);
  var dateB = parseDate(valueB);

  var isSame = function (unit) {
    return getUnitValue(dateA, unit, isUTC) === getUnitValue(dateB, unit, isUTC);
  };

  var isSameYear = function () {
    return isSame('year');
  }; // const isSameHalfYear = () => isSameYear() && isSame('half-year');
  // const isSameQuater = () => isSameYear() && isSame('quarter');


  var isSameMonth = function () {
    return isSameYear() && isSame('month');
  };

  var isSameDay = function () {
    return isSameMonth() && isSame('day');
  }; // const isSameHalfDay = () => isSameDay() && isSame('half-day');


  var isSameHour = function () {
    return isSameDay() && isSame('hour');
  };

  var isSameMinute = function () {
    return isSameHour() && isSame('minute');
  };

  var isSameSecond = function () {
    return isSameMinute() && isSame('second');
  };

  var isSameMilliSecond = function () {
    return isSameSecond() && isSame('millisecond');
  };

  switch (unit) {
    case 'year':
      return isSameYear();

    case 'month':
      return isSameMonth();

    case 'day':
      return isSameDay();

    case 'hour':
      return isSameHour();

    case 'minute':
      return isSameMinute();

    case 'second':
      return isSameSecond();

    case 'millisecond':
      return isSameMilliSecond();
  }
} // const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];


function getDateInterval(approxInterval, daysInMonth) {
  approxInterval /= ONE_DAY;
  return approxInterval > 16 ? 16 // Math.floor(daysInMonth / 2) + 1  // In this case we only want one tick between two months.
  : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
  : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}

function getMonthInterval(approxInterval) {
  var APPROX_ONE_MONTH = 30 * ONE_DAY;
  approxInterval /= APPROX_ONE_MONTH;
  return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}

function getHourInterval(approxInterval) {
  approxInterval /= ONE_HOUR;
  return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}

function getMinutesAndSecondsInterval(approxInterval, isMinutes) {
  approxInterval /= isMinutes ? ONE_MINUTE : ONE_SECOND;
  return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}

function getMillisecondsInterval(approxInterval) {
  return nice(approxInterval, true);
}

function getFirstTimestampOfUnit(date, unitName, isUTC) {
  var outDate = new Date(date);

  switch (getPrimaryTimeUnit(unitName)) {
    case 'year':
    case 'month':
      outDate[monthSetterName(isUTC)](0);

    case 'day':
      outDate[dateSetterName(isUTC)](1);

    case 'hour':
      outDate[hoursSetterName(isUTC)](0);

    case 'minute':
      outDate[minutesSetterName(isUTC)](0);

    case 'second':
      outDate[secondsSetterName(isUTC)](0);
      outDate[millisecondsSetterName(isUTC)](0);
  }

  return outDate.getTime();
}

function getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
  var safeLimit = 10000;
  var unitNames = timeUnits;
  var iter = 0;

  function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
    var date = new Date(minTimestamp);
    var dateTime = minTimestamp;
    var d = date[getMethodName](); // if (isDate) {
    //     d -= 1; // Starts with 0;   PENDING
    // }

    while (dateTime < maxTimestamp && dateTime <= extent[1]) {
      out.push({
        value: dateTime
      });
      d += interval;
      date[setMethodName](d);
      dateTime = date.getTime();
    } // This extra tick is for calcuating ticks of next level. Will not been added to the final result


    out.push({
      value: dateTime,
      notAdd: true
    });
  }

  function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
    var newAddedTicks = [];
    var isFirstLevel = !lastLevelTicks.length;

    if (isUnitValueSame(getPrimaryTimeUnit(unitName), extent[0], extent[1], isUTC)) {
      return;
    }

    if (isFirstLevel) {
      lastLevelTicks = [{
        // TODO Optimize. Not include so may ticks.
        value: getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
      }, {
        value: extent[1]
      }];
    }

    for (var i = 0; i < lastLevelTicks.length - 1; i++) {
      var startTick = lastLevelTicks[i].value;
      var endTick = lastLevelTicks[i + 1].value;

      if (startTick === endTick) {
        continue;
      }

      var interval = void 0;
      var getterName = void 0;
      var setterName = void 0;
      var isDate = false;

      switch (unitName) {
        case 'year':
          interval = Math.max(1, Math.round(approxInterval / ONE_DAY / 365));
          getterName = fullYearGetterName(isUTC);
          setterName = fullYearSetterName(isUTC);
          break;

        case 'half-year':
        case 'quarter':
        case 'month':
          interval = getMonthInterval(approxInterval);
          getterName = monthGetterName(isUTC);
          setterName = monthSetterName(isUTC);
          break;

        case 'week': // PENDING If week is added. Ignore day.

        case 'half-week':
        case 'day':
          interval = getDateInterval(approxInterval); // Use 32 days and let interval been 16

          getterName = dateGetterName(isUTC);
          setterName = dateSetterName(isUTC);
          isDate = true;
          break;

        case 'half-day':
        case 'quarter-day':
        case 'hour':
          interval = getHourInterval(approxInterval);
          getterName = hoursGetterName(isUTC);
          setterName = hoursSetterName(isUTC);
          break;

        case 'minute':
          interval = getMinutesAndSecondsInterval(approxInterval, true);
          getterName = minutesGetterName(isUTC);
          setterName = minutesSetterName(isUTC);
          break;

        case 'second':
          interval = getMinutesAndSecondsInterval(approxInterval, false);
          getterName = secondsGetterName(isUTC);
          setterName = secondsSetterName(isUTC);
          break;

        case 'millisecond':
          interval = getMillisecondsInterval(approxInterval);
          getterName = millisecondsGetterName(isUTC);
          setterName = millisecondsSetterName(isUTC);
          break;
      }

      addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);

      if (unitName === 'year' && levelTicks.length > 1 && i === 0) {
        // Add nearest years to the left extent.
        levelTicks.unshift({
          value: levelTicks[0].value - interval
        });
      }
    }

    for (var i = 0; i < newAddedTicks.length; i++) {
      levelTicks.push(newAddedTicks[i]);
    } // newAddedTicks.length && console.log(unitName, newAddedTicks);


    return newAddedTicks;
  }

  var levelsTicks = [];
  var currentLevelTicks = [];
  var tickCount = 0;
  var lastLevelTickCount = 0;

  for (var i = 0; i < unitNames.length && iter++ < safeLimit; ++i) {
    var primaryTimeUnit = getPrimaryTimeUnit(unitNames[i]);

    if (!isPrimaryTimeUnit(unitNames[i])) {
      // TODO
      continue;
    }

    addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
    var nextPrimaryTimeUnit = unitNames[i + 1] ? getPrimaryTimeUnit(unitNames[i + 1]) : null;

    if (primaryTimeUnit !== nextPrimaryTimeUnit) {
      if (currentLevelTicks.length) {
        lastLevelTickCount = tickCount; // Remove the duplicate so the tick count can be precisely.

        currentLevelTicks.sort(function (a, b) {
          return a.value - b.value;
        });
        var levelTicksRemoveDuplicated = [];

        for (var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1) {
          var tickValue = currentLevelTicks[i_1].value;

          if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
            levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);

            if (tickValue >= extent[0] && tickValue <= extent[1]) {
              tickCount++;
            }
          }
        }

        var targetTickNum = (extent[1] - extent[0]) / approxInterval; // Added too much in this level and not too less in last level

        if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) {
          break;
        } // Only treat primary time unit as one level.


        levelsTicks.push(levelTicksRemoveDuplicated);

        if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) {
          break;
        }
      } // Reset if next unitName is primary


      currentLevelTicks = [];
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (iter >= safeLimit) {
      warn('Exceed safe limit.');
    }
  }

  var levelsTicksInExtent = filter(map(levelsTicks, function (levelTicks) {
    return filter(levelTicks, function (tick) {
      return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
    });
  }), function (levelTicks) {
    return levelTicks.length > 0;
  });
  var ticks = [];
  var maxLevel = levelsTicksInExtent.length - 1;

  for (var i = 0; i < levelsTicksInExtent.length; ++i) {
    var levelTicks = levelsTicksInExtent[i];

    for (var k = 0; k < levelTicks.length; ++k) {
      ticks.push({
        value: levelTicks[k].value,
        level: maxLevel - i
      });
    }
  }

  ticks.sort(function (a, b) {
    return a.value - b.value;
  }); // Remove duplicates

  var result = [];

  for (var i = 0; i < ticks.length; ++i) {
    if (i === 0 || ticks[i].value !== ticks[i - 1].value) {
      result.push(ticks[i]);
    }
  }

  return result;
}

Scale.registerClass(TimeScale);

var scaleProto = Scale.prototype; // FIXME:TS refactor: not good to call it directly with `this`?

var intervalScaleProto = IntervalScale.prototype;
var roundingErrorFix = round$3;
var mathFloor = Math.floor;
var mathCeil = Math.ceil;
var mathPow$1 = Math.pow;
var mathLog = Math.log;

var LogScale =
/** @class */
function (_super) {
  __extends$1(LogScale, _super);

  function LogScale() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'log';
    _this.base = 10;
    _this._originalScale = new IntervalScale(); // FIXME:TS actually used by `IntervalScale`

    _this._interval = 0;
    return _this;
  }
  /**
   * @param Whether expand the ticks to niced extent.
   */


  LogScale.prototype.getTicks = function (expandToNicedExtent) {
    var originalScale = this._originalScale;
    var extent = this._extent;
    var originalExtent = originalScale.getExtent();
    var ticks = intervalScaleProto.getTicks.call(this, expandToNicedExtent);
    return map(ticks, function (tick) {
      var val = tick.value;
      var powVal = round$3(mathPow$1(this.base, val)); // Fix #4158

      powVal = val === extent[0] && this._fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
      powVal = val === extent[1] && this._fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
      return {
        value: powVal
      };
    }, this);
  };

  LogScale.prototype.setExtent = function (start, end) {
    var base = mathLog(this.base); // log(-Infinity) is NaN, so safe guard here

    start = mathLog(Math.max(0, start)) / base;
    end = mathLog(Math.max(0, end)) / base;
    intervalScaleProto.setExtent.call(this, start, end);
  };
  /**
   * @return {number} end
   */


  LogScale.prototype.getExtent = function () {
    var base = this.base;
    var extent = scaleProto.getExtent.call(this);
    extent[0] = mathPow$1(base, extent[0]);
    extent[1] = mathPow$1(base, extent[1]); // Fix #4158

    var originalScale = this._originalScale;
    var originalExtent = originalScale.getExtent();
    this._fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
    this._fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
    return extent;
  };

  LogScale.prototype.unionExtent = function (extent) {
    this._originalScale.unionExtent(extent);

    var base = this.base;
    extent[0] = mathLog(extent[0]) / mathLog(base);
    extent[1] = mathLog(extent[1]) / mathLog(base);
    scaleProto.unionExtent.call(this, extent);
  };

  LogScale.prototype.unionExtentFromData = function (data, dim) {
    // TODO
    // filter value that <= 0
    this.unionExtent(data.getApproximateExtent(dim));
  };
  /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */


  LogScale.prototype.calcNiceTicks = function (approxTickNum) {
    approxTickNum = approxTickNum || 10;
    var extent = this._extent;
    var span = extent[1] - extent[0];

    if (span === Infinity || span <= 0) {
      return;
    }

    var interval = quantity(span);
    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.

    if (err <= 0.5) {
      interval *= 10;
    } // Interval should be integer


    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
      interval *= 10;
    }

    var niceExtent = [round$3(mathCeil(extent[0] / interval) * interval), round$3(mathFloor(extent[1] / interval) * interval)];
    this._interval = interval;
    this._niceExtent = niceExtent;
  };

  LogScale.prototype.calcNiceExtent = function (opt) {
    intervalScaleProto.calcNiceExtent.call(this, opt);
    this._fixMin = opt.fixMin;
    this._fixMax = opt.fixMax;
  };

  LogScale.prototype.parse = function (val) {
    return val;
  };

  LogScale.prototype.contain = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return contain$1(val, this._extent);
  };

  LogScale.prototype.normalize = function (val) {
    val = mathLog(val) / mathLog(this.base);
    return normalize$1(val, this._extent);
  };

  LogScale.prototype.scale = function (val) {
    val = scale$2(val, this._extent);
    return mathPow$1(this.base, val);
  };

  LogScale.type = 'log';
  return LogScale;
}(Scale);

var proto = LogScale.prototype;
proto.getMinorTicks = intervalScaleProto.getMinorTicks;
proto.getLabel = intervalScaleProto.getLabel;

function fixRoundingError(val, originalVal) {
  return roundingErrorFix(val, getPrecision(originalVal));
}

Scale.registerClass(LogScale);

var ScaleRawExtentInfo =
/** @class */
function () {
  function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
  originalExtent) {
    this._prepareParams(scale, model, originalExtent);
  }
  /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */


  ScaleRawExtentInfo.prototype._prepareParams = function (scale, model, // Usually: data extent from all series on this axis.
  dataExtent) {
    if (dataExtent[1] < dataExtent[0]) {
      dataExtent = [NaN, NaN];
    }

    this._dataMin = dataExtent[0];
    this._dataMax = dataExtent[1];
    var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
    this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
    var modelMinRaw = this._modelMinRaw = model.get('min', true);

    if (isFunction$3(modelMinRaw)) {
      // This callback always provides users the full data extent (before data is filtered).
      this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw({
        min: dataExtent[0],
        max: dataExtent[1]
      }));
    } else if (modelMinRaw !== 'dataMin') {
      this._modelMinNum = parseAxisModelMinMax(scale, modelMinRaw);
    }

    var modelMaxRaw = this._modelMaxRaw = model.get('max', true);

    if (isFunction$3(modelMaxRaw)) {
      // This callback always provides users the full data extent (before data is filtered).
      this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw({
        min: dataExtent[0],
        max: dataExtent[1]
      }));
    } else if (modelMaxRaw !== 'dataMax') {
      this._modelMaxNum = parseAxisModelMinMax(scale, modelMaxRaw);
    }

    if (isOrdinal) {
      // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
      // and progressive rendering is using, here the category result might just only contain
      // the processed chunk rather than the entire result.
      this._axisDataLen = model.getCategories().length;
    } else {
      var boundaryGap = model.get('boundaryGap');
      var boundaryGapArr = isArray$1(boundaryGap) ? boundaryGap : [boundaryGap || 0, boundaryGap || 0];

      if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Boolean type for boundaryGap is only ' + 'allowed for ordinal axis. Please use string in ' + 'percentage instead, e.g., "20%". Currently, ' + 'boundaryGap is set to be 0.');
        }

        this._boundaryGapInner = [0, 0];
      } else {
        this._boundaryGapInner = [parsePercent(boundaryGapArr[0], 1), parsePercent(boundaryGapArr[1], 1)];
      }
    }
  };
  /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */


  ScaleRawExtentInfo.prototype.calculate = function () {
    // Notice: When min/max is not set (that is, when there are null/undefined,
    // which is the most common case), these cases should be ensured:
    // (1) For 'ordinal', show all axis.data.
    // (2) For others:
    //      + `boundaryGap` is applied (if min/max set, boundaryGap is
    //      disabled).
    //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
    //      be the result that originalExtent enlarged by boundaryGap.
    // (3) If no data, it should be ensured that `scale.setBlank` is set.
    var isOrdinal = this._isOrdinal;
    var dataMin = this._dataMin;
    var dataMax = this._dataMax;
    var axisDataLen = this._axisDataLen;
    var boundaryGapInner = this._boundaryGapInner;
    var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null; // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
    // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.

    var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
    var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum; // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.

    var minFixed = min != null;
    var maxFixed = max != null;

    if (min == null) {
      min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
    }

    if (max == null) {
      max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
    }

    (min == null || !isFinite(min)) && (min = NaN);
    (max == null || !isFinite(max)) && (max = NaN);
    var isBlank = eqNaN(min) || eqNaN(max) || isOrdinal && !axisDataLen; // If data extent modified, need to recalculated to ensure cross zero.

    if (this._needCrossZero) {
      // Axis is over zero and min is not set
      if (min > 0 && max > 0 && !minFixed) {
        min = 0; // minFixed = true;
      } // Axis is under zero and max is not set


      if (min < 0 && max < 0 && !maxFixed) {
        max = 0; // maxFixed = true;
      } // PENDING:
      // When `needCrossZero` and all data is positive/negative, should it be ensured
      // that the results processed by boundaryGap are positive/negative?
      // If so, here `minFixed`/`maxFixed` need to be set.

    }

    var determinedMin = this._determinedMin;
    var determinedMax = this._determinedMax;

    if (determinedMin != null) {
      min = determinedMin;
      minFixed = true;
    }

    if (determinedMax != null) {
      max = determinedMax;
      maxFixed = true;
    } // Ensure min/max be finite number or NaN here. (not to be null/undefined)
    // `NaN` means min/max axis is blank.


    return {
      min: min,
      max: max,
      minFixed: minFixed,
      maxFixed: maxFixed,
      isBlank: isBlank
    };
  };

  ScaleRawExtentInfo.prototype.modifyDataMinMax = function (minMaxName, val) {
    if (process.env.NODE_ENV !== 'production') {
      assert(!this.frozen);
    }

    this[DATA_MIN_MAX_ATTR[minMaxName]] = val;
  };

  ScaleRawExtentInfo.prototype.setDeterminedMinMax = function (minMaxName, val) {
    var attr = DETERMINED_MIN_MAX_ATTR[minMaxName];

    if (process.env.NODE_ENV !== 'production') {
      assert(!this.frozen // Earse them usually means logic flaw.
      && this[attr] == null);
    }

    this[attr] = val;
  };

  ScaleRawExtentInfo.prototype.freeze = function () {
    // @ts-ignore
    this.frozen = true;
  };

  return ScaleRawExtentInfo;
}();
var DETERMINED_MIN_MAX_ATTR = {
  min: '_determinedMin',
  max: '_determinedMax'
};
var DATA_MIN_MAX_ATTR = {
  min: '_dataMin',
  max: '_dataMax'
};
/**
 * Get scale min max and related info only depends on model settings.
 * This method can be called after coordinate system created.
 * For example, in data processing stage.
 *
 * Scale extent info probably be required multiple times during a workflow.
 * For example:
 * (1) `dataZoom` depends it to get the axis extent in "100%" state.
 * (2) `processor/extentCalculator` depends it to make sure whether axis extent is specified.
 * (3) `coordSys.update` use it to finally decide the scale extent.
 * But the callback of `min`/`max` should not be called multiple times.
 * The code below should not be implemented repeatedly either.
 * So we cache the result in the scale instance, which will be recreated at the beginning
 * of the workflow (because `scale` instance will be recreated each round of the workflow).
 */

function ensureScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
  // Do not permit to recreate.
  var rawExtentInfo = scale.rawExtentInfo;

  if (rawExtentInfo) {
    return rawExtentInfo;
  }

  rawExtentInfo = new ScaleRawExtentInfo(scale, model, originalExtent); // @ts-ignore

  scale.rawExtentInfo = rawExtentInfo;
  return rawExtentInfo;
}
function parseAxisModelMinMax(scale, minMax) {
  return minMax == null ? null : eqNaN(minMax) ? NaN : scale.parse(minMax);
}

/**
 * Get axis scale extent before niced.
 * Item of returned array can only be number (including Infinity and NaN).
 *
 * Caution:
 * Precondition of calling this method:
 * The scale extent has been initialized using series data extent via
 * `scale.setExtent` or `scale.unionExtentFromData`;
 */

function getScaleExtent(scale, model) {
  var scaleType = scale.type;
  var rawExtentResult = ensureScaleRawExtentInfo(scale, model, scale.getExtent()).calculate();
  scale.setBlank(rawExtentResult.isBlank);
  var min = rawExtentResult.min;
  var max = rawExtentResult.max; // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
  // is base axis
  // FIXME
  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
  //     Should not depend on series type `bar`?
  // (3) Fix that might overlap when using dataZoom.
  // (4) Consider other chart types using `barGrid`?
  // See #6728, #4862, `test/bar-overflow-time-plot.html`

  var ecModel = model.ecModel;

  if (ecModel && scaleType === 'time'
  /* || scaleType === 'interval' */
  ) {
    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
    var isBaseAxisAndHasBarSeries_1 = false;
    each(barSeriesModels, function (seriesModel) {
      isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
    });

    if (isBaseAxisAndHasBarSeries_1) {
      // Calculate placement of bars on axis. TODO should be decoupled
      // with barLayout
      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow

      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
      min = adjustedScale.min;
      max = adjustedScale.max;
    }
  }

  return {
    extent: [min, max],
    // "fix" means "fixed", the value should not be
    // changed in the subsequent steps.
    fixMin: rawExtentResult.minFixed,
    fixMax: rawExtentResult.maxFixed
  };
}

function adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
  // Get Axis Length
  var axisExtent = model.axis.getExtent();
  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow

  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);

  if (barsOnCurrentAxis === undefined) {
    return {
      min: min,
      max: max
    };
  }

  var minOverflow = Infinity;
  each(barsOnCurrentAxis, function (item) {
    minOverflow = Math.min(item.offset, minOverflow);
  });
  var maxOverflow = -Infinity;
  each(barsOnCurrentAxis, function (item) {
    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
  });
  minOverflow = Math.abs(minOverflow);
  maxOverflow = Math.abs(maxOverflow);
  var totalOverFlow = minOverflow + maxOverflow; // Calculate required buffer based on old range and overflow

  var oldRange = max - min;
  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
  max += overflowBuffer * (maxOverflow / totalOverFlow);
  min -= overflowBuffer * (minOverflow / totalOverFlow);
  return {
    min: min,
    max: max
  };
} // Precondition of calling this method:
// The scale extent has been initialized using series data extent via
// `scale.setExtent` or `scale.unionExtentFromData`;


function niceScaleExtent(scale, inModel) {
  var model = inModel;
  var extentInfo = getScaleExtent(scale, model);
  var extent = extentInfo.extent;
  var splitNumber = model.get('splitNumber');

  if (scale instanceof LogScale) {
    scale.base = model.get('logBase');
  }

  var scaleType = scale.type;
  var interval = model.get('interval');
  var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
  scale.setExtent(extent[0], extent[1]);
  scale.calcNiceExtent({
    splitNumber: splitNumber,
    fixMin: extentInfo.fixMin,
    fixMax: extentInfo.fixMax,
    minInterval: isIntervalOrTime ? model.get('minInterval') : null,
    maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
  }); // If some one specified the min, max. And the default calculated interval
  // is not good enough. He can specify the interval. It is often appeared
  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
  // to be 60.
  // FIXME

  if (interval != null) {
    scale.setInterval && scale.setInterval(interval);
  }
}
/**
 * @param axisType Default retrieve from model.type
 */

function createScaleByModel(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale({
          ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
          extent: [Infinity, -Infinity]
        });

      case 'time':
        return new TimeScale({
          locale: model.ecModel.getLocaleModel(),
          useUTC: model.ecModel.get('useUTC')
        });

      default:
        // case 'value'/'interval', 'log', or others.
        return new (Scale.getClass(axisType) || IntervalScale)();
    }
  }
}
/**
 * Check if the axis cross 0
 */

function ifAxisCrossZero(axis) {
  var dataExtent = axis.scale.getExtent();
  var min = dataExtent[0];
  var max = dataExtent[1];
  return !(min > 0 && max > 0 || min < 0 && max < 0);
}
/**
 * @param axis
 * @return Label formatter function.
 *         param: {number} tickValue,
 *         param: {number} idx, the index in all ticks.
 *                         If category axis, this param is not required.
 *         return: {string} label string.
 */

function makeLabelFormatter(axis) {
  var labelFormatter = axis.getLabelModel().get('formatter');
  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;

  if (axis.scale.type === 'time') {
    return function (tpl) {
      return function (tick, idx) {
        return axis.scale.getFormattedLabel(tick, idx, tpl);
      };
    }(labelFormatter);
  } else if (isString(labelFormatter)) {
    return function (tpl) {
      return function (tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = tpl.replace('{value}', label != null ? label : '');
        return text;
      };
    }(labelFormatter);
  } else if (isFunction$3(labelFormatter)) {
    return function (cb) {
      return function (tick, idx) {
        // The original intention of `idx` is "the index of the tick in all ticks".
        // But the previous implementation of category axis do not consider the
        // `axisLabel.interval`, which cause that, for example, the `interval` is
        // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
        // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
        // the definition here for back compatibility.
        if (categoryTickStart != null) {
          idx = tick.value - categoryTickStart;
        }

        return cb(getAxisRawValue(axis, tick), idx, tick.level != null ? {
          level: tick.level
        } : null);
      };
    }(labelFormatter);
  } else {
    return function (tick) {
      return axis.scale.getLabel(tick);
    };
  }
}
function getAxisRawValue(axis, tick) {
  // In category axis with data zoom, tick is not the original
  // index of axis.data. So tick should not be exposed to user
  // in category axis.
  return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
/**
 * @param axis
 * @return Be null/undefined if no labels.
 */

function estimateLabelUnionRect(axis) {
  var axisModel = axis.model;
  var scale = axis.scale;

  if (!axisModel.get(['axisLabel', 'show']) || scale.isBlank()) {
    return;
  }

  var realNumberScaleTicks;
  var tickCount;
  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.

  if (scale instanceof OrdinalScale) {
    tickCount = scale.count();
  } else {
    realNumberScaleTicks = scale.getTicks();
    tickCount = realNumberScaleTicks.length;
  }

  var axisLabelModel = axis.getLabelModel();
  var labelFormatter = makeLabelFormatter(axis);
  var rect;
  var step = 1; // Simple optimization for large amount of labels

  if (tickCount > 40) {
    step = Math.ceil(tickCount / 40);
  }

  for (var i = 0; i < tickCount; i += step) {
    var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
      value: categoryScaleExtent[0] + i
    };
    var label = labelFormatter(tick, i);
    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
    rect ? rect.union(singleRect) : rect = singleRect;
  }

  return rect;
}

function rotateTextRect(textRect, rotate) {
  var rotateRadians = rotate * Math.PI / 180;
  var beforeWidth = textRect.width;
  var beforeHeight = textRect.height;
  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
  var rotatedRect = new BoundingRect(textRect.x, textRect.y, afterWidth, afterHeight);
  return rotatedRect;
}
/**
 * @param model axisLabelModel or axisTickModel
 * @return {number|String} Can be null|'auto'|number|function
 */


function getOptionCategoryInterval(model) {
  var interval = model.get('interval');
  return interval == null ? 'auto' : interval;
}
/**
 * Set `categoryInterval` as 0 implicitly indicates that
 * show all labels regardless of overlap.
 * @param {Object} axis axisModel.axis
 */

function shouldShowAllLabels(axis) {
  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
}
function getDataDimensionsOnAxis(data, axisDim) {
  // Remove duplicated dat dimensions caused by `getStackedDimension`.
  var dataDimMap = {}; // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
  // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
  // there has been stacked result dim?

  each(data.mapDimensionsAll(axisDim), function (dataDim) {
    // For example, the extent of the original dimension
    // is [0.1, 0.5], the extent of the `stackResultDimension`
    // is [7, 9], the final extent should NOT include [0.1, 0.5],
    // because there is no graphic corresponding to [0.1, 0.5].
    // See the case in `test/area-stack.html` `main1`, where area line
    // stack needs `yAxis` not start from 0.
    dataDimMap[getStackedDimension(data, dataDim)] = true;
  });
  return keys$2(dataDimMap);
}
function unionAxisExtentFromData(dataExtent, data, axisDim) {
  if (data) {
    each(getDataDimensionsOnAxis(data, axisDim), function (dim) {
      var seriesExtent = data.getApproximateExtent(dim);
      seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
      seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
  }
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var AxisModelCommonMixin =
/** @class */
function () {
  function AxisModelCommonMixin() {}

  AxisModelCommonMixin.prototype.getNeedCrossZero = function () {
    var option = this.option;
    return !option.scale;
  };
  /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */


  AxisModelCommonMixin.prototype.getCoordSysModel = function () {
    return;
  };

  return AxisModelCommonMixin;
}();

/**
 * Create a multi dimension List structure from seriesModel.
 */

function createList(seriesModel) {
  return createSeriesData(null, seriesModel);
} // export function createGraph(seriesModel) {
var dataStack$1 = {
  isDimensionStacked: isDimensionStacked,
  enableDataStack: enableDataStack,
  getStackedDimension: getStackedDimension
};
/**
 * Create scale
 * @param {Array.<number>} dataExtent
 * @param {Object|module:echarts/Model} option If `optoin.type`
 *        is secified, it can only be `'value'` currently.
 */

function createScale(dataExtent, option) {
  var axisModel = option;

  if (!(option instanceof Model)) {
    axisModel = new Model(option); // FIXME
    // Currently AxisModelCommonMixin has nothing to do with the
    // the requirements of `axisHelper.createScaleByModel`. For
    // example the methods `getCategories` and `getOrdinalMeta`
    // are required for `'category'` axis, and ecModel is required
    // for `'time'` axis. But occasionally echarts-gl happened
    // to only use `'value'` axis.
    // zrUtil.mixin(axisModel, AxisModelCommonMixin);
  }

  var scale = createScaleByModel(axisModel);
  scale.setExtent(dataExtent[0], dataExtent[1]);
  niceScaleExtent(scale, axisModel);
  return scale;
}
/**
 * Mixin common methods to axis model,
 *
 * Include methods
 * `getFormattedLabels() => Array.<string>`
 * `getCategories() => Array.<string>`
 * `getMin(origin: boolean) => number`
 * `getMax(origin: boolean) => number`
 * `getNeedCrossZero() => boolean`
 */

function mixinAxisModelCommonMethods(Model) {
  mixin(Model, AxisModelCommonMixin);
}
function createTextStyle$1(textStyleModel, opts) {
  opts = opts || {};
  return createTextStyle(textStyleModel, null, null, opts.state !== 'normal');
}

var helper = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createList: createList,
	getLayoutRect: getLayoutRect$1,
	dataStack: dataStack$1,
	createScale: createScale,
	mixinAxisModelCommonMethods: mixinAxisModelCommonMethods,
	getECData: getECData,
	createTextStyle: createTextStyle$1,
	createDimensions: createDimensions,
	createSymbol: createSymbol,
	enableHoverEmphasis: enableHoverEmphasis
});

var EPSILON$4 = 1e-8;
function isAroundEqual$1(a, b) {
    return Math.abs(a - b) < EPSILON$4;
}
function contain$2(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) {
        return false;
    }
    for (var i = 1; i < points.length; i++) {
        var p2 = points[i];
        w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!isAroundEqual$1(p[0], p0[0]) || !isAroundEqual$1(p[1], p0[1])) {
        w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
    }
    return w !== 0;
}

var TMP_TRANSFORM = [];

function transformPoints(points, transform) {
  for (var p = 0; p < points.length; p++) {
    applyTransform(points[p], points[p], transform);
  }
}

function updateBBoxFromPoints(points, min, max, projection) {
  for (var i = 0; i < points.length; i++) {
    var p = points[i];

    if (projection) {
      // projection may return null point.
      p = projection.project(p);
    }

    if (p && isFinite(p[0]) && isFinite(p[1])) {
      min$1(min, min, p);
      max$1(max, max, p);
    }
  }
}

function centroid(points) {
  var signedArea = 0;
  var cx = 0;
  var cy = 0;
  var len = points.length;
  var x0 = points[len - 1][0];
  var y0 = points[len - 1][1]; // Polygon should been closed.

  for (var i = 0; i < len; i++) {
    var x1 = points[i][0];
    var y1 = points[i][1];
    var a = x0 * y1 - x1 * y0;
    signedArea += a;
    cx += (x0 + x1) * a;
    cy += (y0 + y1) * a;
    x0 = x1;
    y0 = y1;
  }

  return signedArea ? [cx / signedArea / 3, cy / signedArea / 3, signedArea] : [points[0][0] || 0, points[0][1] || 0];
}

var Region =
/** @class */
function () {
  function Region(name) {
    this.name = name;
  }

  Region.prototype.setCenter = function (center) {
    this._center = center;
  };
  /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */


  Region.prototype.getCenter = function () {
    var center = this._center;

    if (!center) {
      // In most cases there are no need to calculate this center.
      // So calculate only when called.
      center = this._center = this.calcCenter();
    }

    return center;
  };

  return Region;
}();

var GeoJSONPolygonGeometry =
/** @class */
function () {
  function GeoJSONPolygonGeometry(exterior, interiors) {
    this.type = 'polygon';
    this.exterior = exterior;
    this.interiors = interiors;
  }

  return GeoJSONPolygonGeometry;
}();

var GeoJSONLineStringGeometry =
/** @class */
function () {
  function GeoJSONLineStringGeometry(points) {
    this.type = 'linestring';
    this.points = points;
  }

  return GeoJSONLineStringGeometry;
}();

var GeoJSONRegion =
/** @class */
function (_super) {
  __extends$1(GeoJSONRegion, _super);

  function GeoJSONRegion(name, geometries, cp) {
    var _this = _super.call(this, name) || this;

    _this.type = 'geoJSON';
    _this.geometries = geometries;
    _this._center = cp && [cp[0], cp[1]];
    return _this;
  }

  GeoJSONRegion.prototype.calcCenter = function () {
    var geometries = this.geometries;
    var largestGeo;
    var largestGeoSize = 0;

    for (var i = 0; i < geometries.length; i++) {
      var geo = geometries[i];
      var exterior = geo.exterior; // Simple trick to use points count instead of polygon area as region size.
      // Ignore linestring

      var size = exterior && exterior.length;

      if (size > largestGeoSize) {
        largestGeo = geo;
        largestGeoSize = size;
      }
    }

    if (largestGeo) {
      return centroid(largestGeo.exterior);
    } // from bounding rect by default.


    var rect = this.getBoundingRect();
    return [rect.x + rect.width / 2, rect.y + rect.height / 2];
  };

  GeoJSONRegion.prototype.getBoundingRect = function (projection) {
    var rect = this._rect; // Always recalculate if using projection.

    if (rect && !projection) {
      return rect;
    }

    var min = [Infinity, Infinity];
    var max = [-Infinity, -Infinity];
    var geometries = this.geometries;
    each(geometries, function (geo) {
      if (geo.type === 'polygon') {
        // Doesn't consider hole
        updateBBoxFromPoints(geo.exterior, min, max, projection);
      } else {
        each(geo.points, function (points) {
          updateBBoxFromPoints(points, min, max, projection);
        });
      }
    }); // Normalie invalid bounding.

    if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) {
      min[0] = min[1] = max[0] = max[1] = 0;
    }

    rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);

    if (!projection) {
      this._rect = rect;
    }

    return rect;
  };

  GeoJSONRegion.prototype.contain = function (coord) {
    var rect = this.getBoundingRect();
    var geometries = this.geometries;

    if (!rect.contain(coord[0], coord[1])) {
      return false;
    }

    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
      var geo = geometries[i]; // Only support polygon.

      if (geo.type !== 'polygon') {
        continue;
      }

      var exterior = geo.exterior;
      var interiors = geo.interiors;

      if (contain$2(exterior, coord[0], coord[1])) {
        // Not in the region if point is in the hole.
        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
          if (contain$2(interiors[k], coord[0], coord[1])) {
            continue loopGeo;
          }
        }

        return true;
      }
    }

    return false;
  };
  /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */


  GeoJSONRegion.prototype.transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var aspect = rect.width / rect.height;

    if (!width) {
      width = aspect * height;
    } else if (!height) {
      height = width / aspect;
    }

    var target = new BoundingRect(x, y, width, height);
    var transform = rect.calculateTransform(target);
    var geometries = this.geometries;

    for (var i = 0; i < geometries.length; i++) {
      var geo = geometries[i];

      if (geo.type === 'polygon') {
        transformPoints(geo.exterior, transform);
        each(geo.interiors, function (interior) {
          transformPoints(interior, transform);
        });
      } else {
        each(geo.points, function (points) {
          transformPoints(points, transform);
        });
      }
    }

    rect = this._rect;
    rect.copy(target); // Update center

    this._center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  };

  GeoJSONRegion.prototype.cloneShallow = function (name) {
    name == null && (name = this.name);
    var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
    newRegion._rect = this._rect;
    newRegion.transformTo = null; // Simply avoid to be called.

    return newRegion;
  };

  return GeoJSONRegion;
}(Region);

var GeoSVGRegion =
/** @class */
function (_super) {
  __extends$1(GeoSVGRegion, _super);

  function GeoSVGRegion(name, elOnlyForCalculate) {
    var _this = _super.call(this, name) || this;

    _this.type = 'geoSVG';
    _this._elOnlyForCalculate = elOnlyForCalculate;
    return _this;
  }

  GeoSVGRegion.prototype.calcCenter = function () {
    var el = this._elOnlyForCalculate;
    var rect = el.getBoundingRect();
    var center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
    var mat = identity$1(TMP_TRANSFORM);
    var target = el;

    while (target && !target.isGeoSVGGraphicRoot) {
      mul$1(mat, target.getLocalTransform(), mat);
      target = target.parent;
    }

    invert(mat, mat);
    applyTransform(center, center, mat);
    return center;
  };

  return GeoSVGRegion;
}(Region);

function decode(json) {
  if (!json.UTF8Encoding) {
    return json;
  }

  var jsonCompressed = json;
  var encodeScale = jsonCompressed.UTF8Scale;

  if (encodeScale == null) {
    encodeScale = 1024;
  }

  var features = jsonCompressed.features;
  each(features, function (feature) {
    var geometry = feature.geometry;
    var encodeOffsets = geometry.encodeOffsets;
    var coordinates = geometry.coordinates; // Geometry may be appeded manually in the script after json loaded.
    // In this case this geometry is usually not encoded.

    if (!encodeOffsets) {
      return;
    }

    switch (geometry.type) {
      case 'LineString':
        geometry.coordinates = decodeRing(coordinates, encodeOffsets, encodeScale);
        break;

      case 'Polygon':
        decodeRings(coordinates, encodeOffsets, encodeScale);
        break;

      case 'MultiLineString':
        decodeRings(coordinates, encodeOffsets, encodeScale);
        break;

      case 'MultiPolygon':
        each(coordinates, function (rings, idx) {
          return decodeRings(rings, encodeOffsets[idx], encodeScale);
        });
    }
  }); // Has been decoded

  jsonCompressed.UTF8Encoding = false;
  return jsonCompressed;
}

function decodeRings(rings, encodeOffsets, encodeScale) {
  for (var c = 0; c < rings.length; c++) {
    rings[c] = decodeRing(rings[c], encodeOffsets[c], encodeScale);
  }
}

function decodeRing(coordinate, encodeOffsets, encodeScale) {
  var result = [];
  var prevX = encodeOffsets[0];
  var prevY = encodeOffsets[1];

  for (var i = 0; i < coordinate.length; i += 2) {
    var x = coordinate.charCodeAt(i) - 64;
    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding

    x = x >> 1 ^ -(x & 1);
    y = y >> 1 ^ -(y & 1); // Delta deocding

    x += prevX;
    y += prevY;
    prevX = x;
    prevY = y; // Dequantize

    result.push([x / encodeScale, y / encodeScale]);
  }

  return result;
}

function parseGeoJSON(geoJson, nameProperty) {
  geoJson = decode(geoJson);
  return map(filter(geoJson.features, function (featureObj) {
    // Output of mapshaper may have geometry null
    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
  }), function (featureObj) {
    var properties = featureObj.properties;
    var geo = featureObj.geometry;
    var geometries = [];

    switch (geo.type) {
      case 'Polygon':
        var coordinates = geo.coordinates; // According to the GeoJSON specification.
        // First must be exterior, and the rest are all interior(holes).

        geometries.push(new GeoJSONPolygonGeometry(coordinates[0], coordinates.slice(1)));
        break;

      case 'MultiPolygon':
        each(geo.coordinates, function (item) {
          if (item[0]) {
            geometries.push(new GeoJSONPolygonGeometry(item[0], item.slice(1)));
          }
        });
        break;

      case 'LineString':
        geometries.push(new GeoJSONLineStringGeometry([geo.coordinates]));
        break;

      case 'MultiLineString':
        geometries.push(new GeoJSONLineStringGeometry(geo.coordinates));
    }

    var region = new GeoJSONRegion(properties[nameProperty || 'name'], geometries, properties.cp);
    region.properties = properties;
    return region;
  });
}

var number = /*#__PURE__*/Object.freeze({
	__proto__: null,
	linearMap: linearMap,
	round: round$3,
	asc: asc,
	getPrecision: getPrecision,
	getPrecisionSafe: getPrecisionSafe,
	getPixelPrecision: getPixelPrecision,
	getPercentWithPrecision: getPercentWithPrecision,
	MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$2,
	remRadian: remRadian,
	isRadianAroundZero: isRadianAroundZero,
	parseDate: parseDate,
	quantity: quantity,
	quantityExponent: quantityExponent,
	nice: nice,
	quantile: quantile,
	reformIntervals: reformIntervals,
	isNumeric: isNumeric$1,
	numericToNumber: numericToNumber
});

var time = /*#__PURE__*/Object.freeze({
	__proto__: null,
	parse: parseDate,
	format: format$1
});

var graphic$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	extendShape: extendShape,
	extendPath: extendPath,
	makePath: makePath,
	makeImage: makeImage,
	mergePath: mergePath$1,
	resizePath: resizePath,
	createIcon: createIcon,
	updateProps: updateProps,
	initProps: initProps,
	getTransform: getTransform,
	clipPointsByRect: clipPointsByRect,
	clipRectByRect: clipRectByRect,
	registerShape: registerShape,
	getShapeClass: getShapeClass,
	Group: Group$1,
	Image: ZRImage,
	Text: ZRText,
	Circle: Circle$1,
	Ellipse: Ellipse,
	Sector: Sector,
	Ring: Ring,
	Polygon: Polygon,
	Polyline: Polyline,
	Rect: Rect,
	Line: Line,
	BezierCurve: BezierCurve,
	Arc: Arc,
	IncrementalDisplayable: IncrementalDisplayable,
	CompoundPath: CompoundPath,
	LinearGradient: LinearGradient,
	RadialGradient: RadialGradient,
	BoundingRect: BoundingRect
});

var format$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	addCommas: addCommas,
	toCamelCase: toCamelCase,
	normalizeCssArray: normalizeCssArray$1,
	encodeHTML: encodeHTML,
	formatTpl: formatTpl,
	getTooltipMarker: getTooltipMarker,
	formatTime: formatTime,
	capitalFirst: capitalFirst,
	truncateText: truncateText,
	getTextRect: getTextRect
});

var util$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	map: map,
	each: each,
	indexOf: indexOf,
	inherits: inherits,
	reduce: reduce$6,
	filter: filter,
	bind: bind,
	curry: curry,
	isArray: isArray$1,
	isString: isString,
	isObject: isObject$2,
	isFunction: isFunction$3,
	extend: extend,
	defaults: defaults,
	clone: clone,
	merge: merge$1
});

var inner$6 = makeInner();
function createAxisLabels(axis) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
}
/**
 * @param {module:echats/coord/Axis} axis
 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
 * @return {Object} {
 *     ticks: Array.<number>
 *     tickCategoryInterval: number
 * }
 */

function createAxisTicks(axis, tickModel) {
  // Only ordinal scale support tick interval
  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
    ticks: map(axis.scale.getTicks(), function (tick) {
      return tick.value;
    })
  };
}

function makeCategoryLabels(axis) {
  var labelModel = axis.getLabelModel();
  var result = makeCategoryLabelsActually(axis, labelModel);
  return !labelModel.get('show') || axis.scale.isBlank() ? {
    labels: [],
    labelCategoryInterval: result.labelCategoryInterval
  } : result;
}

function makeCategoryLabelsActually(axis, labelModel) {
  var labelsCache = getListCache(axis, 'labels');
  var optionLabelInterval = getOptionCategoryInterval(labelModel);
  var result = listCacheGet$1(labelsCache, optionLabelInterval);

  if (result) {
    return result;
  }

  var labels;
  var numericLabelInterval;

  if (isFunction$3(optionLabelInterval)) {
    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
  } else {
    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
  } // Cache to avoid calling interval function repeatedly.


  return listCacheSet$1(labelsCache, optionLabelInterval, {
    labels: labels,
    labelCategoryInterval: numericLabelInterval
  });
}

function makeCategoryTicks(axis, tickModel) {
  var ticksCache = getListCache(axis, 'ticks');
  var optionTickInterval = getOptionCategoryInterval(tickModel);
  var result = listCacheGet$1(ticksCache, optionTickInterval);

  if (result) {
    return result;
  }

  var ticks;
  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
  // we should not return all ticks.

  if (!tickModel.get('show') || axis.scale.isBlank()) {
    ticks = [];
  }

  if (isFunction$3(optionTickInterval)) {
    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
  } // Always use label interval by default despite label show. Consider this
  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
  // labels. `splitLine` and `axisTick` should be consistent in this case.
  else if (optionTickInterval === 'auto') {
      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
      tickCategoryInterval = labelsResult.labelCategoryInterval;
      ticks = map(labelsResult.labels, function (labelItem) {
        return labelItem.tickValue;
      });
    } else {
      tickCategoryInterval = optionTickInterval;
      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    } // Cache to avoid calling interval function repeatedly.


  return listCacheSet$1(ticksCache, optionTickInterval, {
    ticks: ticks,
    tickCategoryInterval: tickCategoryInterval
  });
}

function makeRealNumberLabels(axis) {
  var ticks = axis.scale.getTicks();
  var labelFormatter = makeLabelFormatter(axis);
  return {
    labels: map(ticks, function (tick, idx) {
      return {
        level: tick.level,
        formattedLabel: labelFormatter(tick, idx),
        rawLabel: axis.scale.getLabel(tick),
        tickValue: tick.value
      };
    })
  };
}

function getListCache(axis, prop) {
  // Because key can be a function, and cache size always is small, we use array cache.
  return inner$6(axis)[prop] || (inner$6(axis)[prop] = []);
}

function listCacheGet$1(cache, key) {
  for (var i = 0; i < cache.length; i++) {
    if (cache[i].key === key) {
      return cache[i].value;
    }
  }
}

function listCacheSet$1(cache, key, value) {
  cache.push({
    key: key,
    value: value
  });
  return value;
}

function makeAutoCategoryInterval(axis) {
  var result = inner$6(axis).autoInterval;
  return result != null ? result : inner$6(axis).autoInterval = axis.calculateCategoryInterval();
}
/**
 * Calculate interval for category axis ticks and labels.
 * To get precise result, at least one of `getRotate` and `isHorizontal`
 * should be implemented in axis.
 */


function calculateCategoryInterval(axis) {
  var params = fetchAutoCategoryIntervalCalculationParams(axis);
  var labelFormatter = makeLabelFormatter(axis);
  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
  // avoid generating a long array by `getTicks`
  // in large category data case.

  var tickCount = ordinalScale.count();

  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
    return 0;
  }

  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.

  if (tickCount > 40) {
    step = Math.max(1, Math.floor(tickCount / 40));
  }

  var tickValue = ordinalExtent[0];
  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
  var unitW = Math.abs(unitSpan * Math.cos(rotation));
  var unitH = Math.abs(unitSpan * Math.sin(rotation));
  var maxW = 0;
  var maxH = 0; // Caution: Performance sensitive for large category data.
  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    var width = 0;
    var height = 0; // Not precise, do not consider align and vertical align
    // and each distance from axis line yet.

    var rect = getBoundingRect(labelFormatter({
      value: tickValue
    }), params.font, 'center', 'top'); // Magic number

    width = rect.width * 1.3;
    height = rect.height * 1.3; // Min size, void long loop.

    maxW = Math.max(maxW, width, 7);
    maxH = Math.max(maxH, height, 7);
  }

  var dw = maxW / unitW;
  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

  isNaN(dw) && (dw = Infinity);
  isNaN(dh) && (dh = Infinity);
  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
  var cache = inner$6(axis.model);
  var axisExtent = axis.getExtent();
  var lastAutoInterval = cache.lastAutoInterval;
  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
  // otherwise the calculated interval might jitter when the zoom
  // window size is close to the interval-changing size.
  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
  // The jitter will cause that sometimes the displayed labels are
  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).

  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
  // point is not the same when zooming in or zooming out.
  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
  // be used. Otherwise some hidden labels might not be shown again.
  && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) {
    interval = lastAutoInterval;
  } // Only update cache if cache not used, otherwise the
  // changing of interval is too insensitive.
  else {
      cache.lastTickCount = tickCount;
      cache.lastAutoInterval = interval;
      cache.axisExtent0 = axisExtent[0];
      cache.axisExtent1 = axisExtent[1];
    }

  return interval;
}

function fetchAutoCategoryIntervalCalculationParams(axis) {
  var labelModel = axis.getLabelModel();
  return {
    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
    labelRotate: labelModel.get('rotate') || 0,
    font: labelModel.getFont()
  };
}

function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
  var labelFormatter = makeLabelFormatter(axis);
  var ordinalScale = axis.scale;
  var ordinalExtent = ordinalScale.getExtent();
  var labelModel = axis.getLabelModel();
  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...

  var step = Math.max((categoryInterval || 0) + 1, 1);
  var startTick = ordinalExtent[0];
  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
  // while zooming and moving while interval > 0. Otherwise the selection
  // of displayable ticks and symbols probably keep changing.
  // 3 is empirical value.

  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
    startTick = Math.round(Math.ceil(startTick / step) * step);
  } // (1) Only add min max label here but leave overlap checking
  // to render stage, which also ensure the returned list
  // suitable for splitLine and splitArea rendering.
  // (2) Scales except category always contain min max label so
  // do not need to perform this process.


  var showAllLabel = shouldShowAllLabels(axis);
  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;

  if (includeMinLabel && startTick !== ordinalExtent[0]) {
    addItem(ordinalExtent[0]);
  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.


  var tickValue = startTick;

  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
    addItem(tickValue);
  }

  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
    addItem(ordinalExtent[1]);
  }

  function addItem(tickValue) {
    var tickObj = {
      value: tickValue
    };
    result.push(onlyTick ? tickValue : {
      formattedLabel: labelFormatter(tickObj),
      rawLabel: ordinalScale.getLabel(tickObj),
      tickValue: tickValue
    });
  }

  return result;
}

function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
  var ordinalScale = axis.scale;
  var labelFormatter = makeLabelFormatter(axis);
  var result = [];
  each(ordinalScale.getTicks(), function (tick) {
    var rawLabel = ordinalScale.getLabel(tick);
    var tickValue = tick.value;

    if (categoryInterval(tick.value, rawLabel)) {
      result.push(onlyTick ? tickValue : {
        formattedLabel: labelFormatter(tick),
        rawLabel: rawLabel,
        tickValue: tickValue
      });
    }
  });
  return result;
}

var NORMALIZED_EXTENT = [0, 1];
/**
 * Base class of Axis.
 */

var Axis =
/** @class */
function () {
  function Axis(dim, scale, extent) {
    this.onBand = false;
    this.inverse = false;
    this.dim = dim;
    this.scale = scale;
    this._extent = extent || [0, 0];
  }
  /**
   * If axis extent contain given coord
   */


  Axis.prototype.contain = function (coord) {
    var extent = this._extent;
    var min = Math.min(extent[0], extent[1]);
    var max = Math.max(extent[0], extent[1]);
    return coord >= min && coord <= max;
  };
  /**
   * If axis extent contain given data
   */


  Axis.prototype.containData = function (data) {
    return this.scale.contain(data);
  };
  /**
   * Get coord extent.
   */


  Axis.prototype.getExtent = function () {
    return this._extent.slice();
  };
  /**
   * Get precision used for formatting
   */


  Axis.prototype.getPixelPrecision = function (dataExtent) {
    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
  };
  /**
   * Set coord extent
   */


  Axis.prototype.setExtent = function (start, end) {
    var extent = this._extent;
    extent[0] = start;
    extent[1] = end;
  };
  /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */


  Axis.prototype.dataToCoord = function (data, clamp) {
    var extent = this._extent;
    var scale = this.scale;
    data = scale.normalize(data);

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
  };
  /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */


  Axis.prototype.coordToData = function (coord, clamp) {
    var extent = this._extent;
    var scale = this.scale;

    if (this.onBand && scale.type === 'ordinal') {
      extent = extent.slice();
      fixExtentWithBands(extent, scale.count());
    }

    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
    return this.scale.scale(t);
  };
  /**
   * Convert pixel point to data in axis
   */


  Axis.prototype.pointToData = function (point, clamp) {
    // Should be implemented in derived class if necessary.
    return;
  };
  /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */


  Axis.prototype.getTicksCoords = function (opt) {
    opt = opt || {};
    var tickModel = opt.tickModel || this.getTickModel();
    var result = createAxisTicks(this, tickModel);
    var ticks = result.ticks;
    var ticksCoords = map(ticks, function (tickVal) {
      return {
        coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
        tickValue: tickVal
      };
    }, this);
    var alignWithLabel = tickModel.get('alignWithLabel');
    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
    return ticksCoords;
  };

  Axis.prototype.getMinorTicksCoords = function () {
    if (this.scale.type === 'ordinal') {
      // Category axis doesn't support minor ticks
      return [];
    }

    var minorTickModel = this.model.getModel('minorTick');
    var splitNumber = minorTickModel.get('splitNumber'); // Protection.

    if (!(splitNumber > 0 && splitNumber < 100)) {
      splitNumber = 5;
    }

    var minorTicks = this.scale.getMinorTicks(splitNumber);
    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
      return map(minorTicksGroup, function (minorTick) {
        return {
          coord: this.dataToCoord(minorTick),
          tickValue: minorTick
        };
      }, this);
    }, this);
    return minorTicksCoords;
  };

  Axis.prototype.getViewLabels = function () {
    return createAxisLabels(this).labels;
  };

  Axis.prototype.getLabelModel = function () {
    return this.model.getModel('axisLabel');
  };
  /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */


  Axis.prototype.getTickModel = function () {
    return this.model.getModel('axisTick');
  };
  /**
   * Get width of band
   */


  Axis.prototype.getBandWidth = function () {
    var axisExtent = this._extent;
    var dataExtent = this.scale.getExtent();
    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.

    len === 0 && (len = 1);
    var size = Math.abs(axisExtent[1] - axisExtent[0]);
    return Math.abs(size) / len;
  };
  /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */


  Axis.prototype.calculateCategoryInterval = function () {
    return calculateCategoryInterval(this);
  };

  return Axis;
}();

function fixExtentWithBands(extent, nTick) {
  var size = extent[1] - extent[0];
  var len = nTick;
  var margin = size / len / 2;
  extent[0] += margin;
  extent[1] -= margin;
} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).


function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
  var ticksLen = ticksCoords.length;

  if (!axis.onBand || alignWithLabel || !ticksLen) {
    return;
  }

  var axisExtent = axis.getExtent();
  var last;
  var diffSize;

  if (ticksLen === 1) {
    ticksCoords[0].coord = axisExtent[0];
    last = ticksCoords[1] = {
      coord: axisExtent[0]
    };
  } else {
    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
    var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
    each(ticksCoords, function (ticksItem) {
      ticksItem.coord -= shift_1 / 2;
    });
    var dataExtent = axis.scale.getExtent();
    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
    last = {
      coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
    };
    ticksCoords.push(last);
  }

  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.

  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
  }

  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
    ticksCoords.unshift({
      coord: axisExtent[0]
    });
  }

  if (littleThan(axisExtent[1], last.coord)) {
    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
  }

  if (clamp && littleThan(last.coord, axisExtent[1])) {
    ticksCoords.push({
      coord: axisExtent[1]
    });
  }

  function littleThan(a, b) {
    // Avoid rounding error cause calculated tick coord different with extent.
    // It may cause an extra unnecessary tick added.
    a = round$3(a);
    b = round$3(b);
    return inverse ? a > b : a < b;
  }
}

// Should use `ComponentModel.extend` or `class XXXX extend ComponentModel` to create class.
// Then use `registerComponentModel` in `install` parameter when `use` this extension. For example:
// class Bar3DModel extends ComponentModel {}
// export function install(registers) { registers.registerComponentModel(Bar3DModel); }
// echarts.use(install);

function extendComponentModel(proto) {
  var Model = ComponentModel.extend(proto);
  ComponentModel.registerClass(Model);
  return Model;
}
function extendComponentView(proto) {
  var View = ComponentView.extend(proto);
  ComponentView.registerClass(View);
  return View;
}
function extendSeriesModel(proto) {
  var Model = SeriesModel.extend(proto);
  SeriesModel.registerClass(Model);
  return Model;
}
function extendChartView(proto) {
  var View = ChartView.extend(proto);
  ChartView.registerClass(View);
  return View;
}

var PI2$6 = Math.PI * 2;
var CMD$3 = PathProxy.CMD;
var DEFAULT_SEARCH_SPACE = ['top', 'right', 'bottom', 'left'];

function getCandidateAnchor(pos, distance, rect, outPt, outDir) {
  var width = rect.width;
  var height = rect.height;

  switch (pos) {
    case 'top':
      outPt.set(rect.x + width / 2, rect.y - distance);
      outDir.set(0, -1);
      break;

    case 'bottom':
      outPt.set(rect.x + width / 2, rect.y + height + distance);
      outDir.set(0, 1);
      break;

    case 'left':
      outPt.set(rect.x - distance, rect.y + height / 2);
      outDir.set(-1, 0);
      break;

    case 'right':
      outPt.set(rect.x + width + distance, rect.y + height / 2);
      outDir.set(1, 0);
      break;
  }
}

function projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
  x -= cx;
  y -= cy;
  var d = Math.sqrt(x * x + y * y);
  x /= d;
  y /= d; // Intersect point.

  var ox = x * r + cx;
  var oy = y * r + cy;

  if (Math.abs(startAngle - endAngle) % PI2$6 < 1e-4) {
    // Is a circle
    out[0] = ox;
    out[1] = oy;
    return d - r;
  }

  if (anticlockwise) {
    var tmp = startAngle;
    startAngle = normalizeRadian(endAngle);
    endAngle = normalizeRadian(tmp);
  } else {
    startAngle = normalizeRadian(startAngle);
    endAngle = normalizeRadian(endAngle);
  }

  if (startAngle > endAngle) {
    endAngle += PI2$6;
  }

  var angle = Math.atan2(y, x);

  if (angle < 0) {
    angle += PI2$6;
  }

  if (angle >= startAngle && angle <= endAngle || angle + PI2$6 >= startAngle && angle + PI2$6 <= endAngle) {
    // Project point is on the arc.
    out[0] = ox;
    out[1] = oy;
    return d - r;
  }

  var x1 = r * Math.cos(startAngle) + cx;
  var y1 = r * Math.sin(startAngle) + cy;
  var x2 = r * Math.cos(endAngle) + cx;
  var y2 = r * Math.sin(endAngle) + cy;
  var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
  var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);

  if (d1 < d2) {
    out[0] = x1;
    out[1] = y1;
    return Math.sqrt(d1);
  } else {
    out[0] = x2;
    out[1] = y2;
    return Math.sqrt(d2);
  }
}

function projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
  var dx = x - x1;
  var dy = y - y1;
  var dx1 = x2 - x1;
  var dy1 = y2 - y1;
  var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  dx1 /= lineLen;
  dy1 /= lineLen; // dot product

  var projectedLen = dx * dx1 + dy * dy1;
  var t = projectedLen / lineLen;

  if (limitToEnds) {
    t = Math.min(Math.max(t, 0), 1);
  }

  t *= lineLen;
  var ox = out[0] = x1 + t * dx1;
  var oy = out[1] = y1 + t * dy1;
  return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}

function projectPointToRect(x1, y1, width, height, x, y, out) {
  if (width < 0) {
    x1 = x1 + width;
    width = -width;
  }

  if (height < 0) {
    y1 = y1 + height;
    height = -height;
  }

  var x2 = x1 + width;
  var y2 = y1 + height;
  var ox = out[0] = Math.min(Math.max(x, x1), x2);
  var oy = out[1] = Math.min(Math.max(y, y1), y2);
  return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}

var tmpPt = [];

function nearestPointOnRect(pt, rect, out) {
  var dist = projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, tmpPt);
  out.set(tmpPt[0], tmpPt[1]);
  return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */


function nearestPointOnPath(pt, path, out) {
  var xi = 0;
  var yi = 0;
  var x0 = 0;
  var y0 = 0;
  var x1;
  var y1;
  var minDist = Infinity;
  var data = path.data;
  var x = pt.x;
  var y = pt.y;

  for (var i = 0; i < data.length;) {
    var cmd = data[i++];

    if (i === 1) {
      xi = data[i];
      yi = data[i + 1];
      x0 = xi;
      y0 = yi;
    }

    var d = minDist;

    switch (cmd) {
      case CMD$3.M:
        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
        // 在 closePath 的时候使用
        x0 = data[i++];
        y0 = data[i++];
        xi = x0;
        yi = y0;
        break;

      case CMD$3.L:
        d = projectPointToLine(xi, yi, data[i], data[i + 1], x, y, tmpPt, true);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD$3.C:
        d = cubicProjectPoint(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD$3.Q:
        d = quadraticProjectPoint(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, tmpPt);
        xi = data[i++];
        yi = data[i++];
        break;

      case CMD$3.A:
        // TODO Arc 判断的开销比较大
        var cx = data[i++];
        var cy = data[i++];
        var rx = data[i++];
        var ry = data[i++];
        var theta = data[i++];
        var dTheta = data[i++]; // TODO Arc 旋转

        i += 1;
        var anticlockwise = !!(1 - data[i++]);
        x1 = Math.cos(theta) * rx + cx;
        y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令

        if (i <= 1) {
          // 第一个命令起点还未定义
          x0 = x1;
          y0 = y1;
        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放


        var _x = (x - cx) * ry / rx + cx;

        d = projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, tmpPt);
        xi = Math.cos(theta + dTheta) * rx + cx;
        yi = Math.sin(theta + dTheta) * ry + cy;
        break;

      case CMD$3.R:
        x0 = xi = data[i++];
        y0 = yi = data[i++];
        var width = data[i++];
        var height = data[i++];
        d = projectPointToRect(x0, y0, width, height, x, y, tmpPt);
        break;

      case CMD$3.Z:
        d = projectPointToLine(xi, yi, x0, y0, x, y, tmpPt, true);
        xi = x0;
        yi = y0;
        break;
    }

    if (d < minDist) {
      minDist = d;
      out.set(tmpPt[0], tmpPt[1]);
    }
  }

  return minDist;
} // Temporal variable for intermediate usage.


var pt0 = new Point();
var pt1 = new Point();
var pt2 = new Point();
var dir = new Point();
var dir2 = new Point();
/**
 * Calculate a proper guide line based on the label position and graphic element definition
 * @param label
 * @param labelRect
 * @param target
 * @param targetRect
 */

function updateLabelLinePoints(target, labelLineModel) {
  if (!target) {
    return;
  }

  var labelLine = target.getTextGuideLine();
  var label = target.getTextContent(); // Needs to create text guide in each charts.

  if (!(label && labelLine)) {
    return;
  }

  var labelGuideConfig = target.textGuideLineConfig || {};
  var points = [[0, 0], [0, 0], [0, 0]];
  var searchSpace = labelGuideConfig.candidates || DEFAULT_SEARCH_SPACE;
  var labelRect = label.getBoundingRect().clone();
  labelRect.applyTransform(label.getComputedTransform());
  var minDist = Infinity;
  var anchorPoint = labelGuideConfig.anchor;
  var targetTransform = target.getComputedTransform();
  var targetInversedTransform = targetTransform && invert([], targetTransform);
  var len = labelLineModel.get('length2') || 0;

  if (anchorPoint) {
    pt2.copy(anchorPoint);
  }

  for (var i = 0; i < searchSpace.length; i++) {
    var candidate = searchSpace[i];
    getCandidateAnchor(candidate, 0, labelRect, pt0, dir);
    Point.scaleAndAdd(pt1, pt0, dir, len); // Transform to target coord space.

    pt1.transform(targetInversedTransform); // Note: getBoundingRect will ensure the `path` being created.

    var boundingRect = target.getBoundingRect();
    var dist = anchorPoint ? anchorPoint.distance(pt1) : target instanceof Path ? nearestPointOnPath(pt1, target.path, pt2) : nearestPointOnRect(pt1, boundingRect, pt2); // TODO pt2 is in the path

    if (dist < minDist) {
      minDist = dist; // Transform back to global space.

      pt1.transform(targetTransform);
      pt2.transform(targetTransform);
      pt2.toArray(points[0]);
      pt1.toArray(points[1]);
      pt0.toArray(points[2]);
    }
  }

  limitTurnAngle(points, labelLineModel.get('minTurnAngle'));
  labelLine.setShape({
    points: points
  });
} // Temporal variable for the limitTurnAngle function

var tmpArr = [];
var tmpProjPoint = new Point();
/**
 * Reduce the line segment attached to the label to limit the turn angle between two segments.
 * @param linePoints
 * @param minTurnAngle Radian of minimum turn angle. 0 - 180
 */

function limitTurnAngle(linePoints, minTurnAngle) {
  if (!(minTurnAngle <= 180 && minTurnAngle > 0)) {
    return;
  }

  minTurnAngle = minTurnAngle / 180 * Math.PI; // The line points can be
  //      /pt1----pt2 (label)
  //     /
  // pt0/

  pt0.fromArray(linePoints[0]);
  pt1.fromArray(linePoints[1]);
  pt2.fromArray(linePoints[2]);
  Point.sub(dir, pt0, pt1);
  Point.sub(dir2, pt2, pt1);
  var len1 = dir.len();
  var len2 = dir2.len();

  if (len1 < 1e-3 || len2 < 1e-3) {
    return;
  }

  dir.scale(1 / len1);
  dir2.scale(1 / len2);
  var angleCos = dir.dot(dir2);
  var minTurnAngleCos = Math.cos(minTurnAngle);

  if (minTurnAngleCos < angleCos) {
    // Smaller than minTurnAngle
    // Calculate project point of pt0 on pt1-pt2
    var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
    tmpProjPoint.fromArray(tmpArr); // Calculate new projected length with limited minTurnAngle and get the new connect point

    tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI - minTurnAngle)); // Limit the new calculated connect point between pt1 and pt2.

    var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);

    if (isNaN(t)) {
      return;
    }

    if (t < 0) {
      Point.copy(tmpProjPoint, pt1);
    } else if (t > 1) {
      Point.copy(tmpProjPoint, pt2);
    }

    tmpProjPoint.toArray(linePoints[1]);
  }
}
/**
 * Limit the angle of line and the surface
 * @param maxSurfaceAngle Radian of minimum turn angle. 0 - 180. 0 is same direction to normal. 180 is opposite
 */

function limitSurfaceAngle(linePoints, surfaceNormal, maxSurfaceAngle) {
  if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) {
    return;
  }

  maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
  pt0.fromArray(linePoints[0]);
  pt1.fromArray(linePoints[1]);
  pt2.fromArray(linePoints[2]);
  Point.sub(dir, pt1, pt0);
  Point.sub(dir2, pt2, pt1);
  var len1 = dir.len();
  var len2 = dir2.len();

  if (len1 < 1e-3 || len2 < 1e-3) {
    return;
  }

  dir.scale(1 / len1);
  dir2.scale(1 / len2);
  var angleCos = dir.dot(surfaceNormal);
  var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);

  if (angleCos < maxSurfaceAngleCos) {
    // Calculate project point of pt0 on pt1-pt2
    var d = projectPointToLine(pt1.x, pt1.y, pt2.x, pt2.y, pt0.x, pt0.y, tmpArr, false);
    tmpProjPoint.fromArray(tmpArr);
    var HALF_PI = Math.PI / 2;
    var angle2 = Math.acos(dir2.dot(surfaceNormal));
    var newAngle = HALF_PI + angle2 - maxSurfaceAngle;

    if (newAngle >= HALF_PI) {
      // parallel
      Point.copy(tmpProjPoint, pt2);
    } else {
      // Calculate new projected length with limited minTurnAngle and get the new connect point
      tmpProjPoint.scaleAndAdd(dir2, d / Math.tan(Math.PI / 2 - newAngle)); // Limit the new calculated connect point between pt1 and pt2.

      var t = pt2.x !== pt1.x ? (tmpProjPoint.x - pt1.x) / (pt2.x - pt1.x) : (tmpProjPoint.y - pt1.y) / (pt2.y - pt1.y);

      if (isNaN(t)) {
        return;
      }

      if (t < 0) {
        Point.copy(tmpProjPoint, pt1);
      } else if (t > 1) {
        Point.copy(tmpProjPoint, pt2);
      }
    }

    tmpProjPoint.toArray(linePoints[1]);
  }
}

function setLabelLineState(labelLine, ignore, stateName, stateModel) {
  var isNormal = stateName === 'normal';
  var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName); // Make sure display.

  stateObj.ignore = ignore; // Set smooth

  var smooth = stateModel.get('smooth');

  if (smooth && smooth === true) {
    smooth = 0.3;
  }

  stateObj.shape = stateObj.shape || {};

  if (smooth > 0) {
    stateObj.shape.smooth = smooth;
  }

  var styleObj = stateModel.getModel('lineStyle').getLineStyle();
  isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}

function buildLabelLinePath(path, shape) {
  var smooth = shape.smooth;
  var points = shape.points;

  if (!points) {
    return;
  }

  path.moveTo(points[0][0], points[0][1]);

  if (smooth > 0 && points.length >= 3) {
    var len1 = dist(points[0], points[1]);
    var len2 = dist(points[1], points[2]);

    if (!len1 || !len2) {
      path.lineTo(points[1][0], points[1][1]);
      path.lineTo(points[2][0], points[2][1]);
      return;
    }

    var moveLen = Math.min(len1, len2) * smooth;
    var midPoint0 = lerp([], points[1], points[0], moveLen / len1);
    var midPoint2 = lerp([], points[1], points[2], moveLen / len2);
    var midPoint1 = lerp([], midPoint0, midPoint2, 0.5);
    path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
    path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
  } else {
    for (var i = 1; i < points.length; i++) {
      path.lineTo(points[i][0], points[i][1]);
    }
  }
}
/**
 * Create a label line if necessary and set it's style.
 */


function setLabelLineStyle(targetEl, statesModels, defaultStyle) {
  var labelLine = targetEl.getTextGuideLine();
  var label = targetEl.getTextContent();

  if (!label) {
    // Not show label line if there is no label.
    if (labelLine) {
      targetEl.removeTextGuideLine();
    }

    return;
  }

  var normalModel = statesModels.normal;
  var showNormal = normalModel.get('show');
  var labelIgnoreNormal = label.ignore;

  for (var i = 0; i < DISPLAY_STATES.length; i++) {
    var stateName = DISPLAY_STATES[i];
    var stateModel = statesModels[stateName];
    var isNormal = stateName === 'normal';

    if (stateModel) {
      var stateShow = stateModel.get('show');
      var isLabelIgnored = isNormal ? labelIgnoreNormal : retrieve2(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);

      if (isLabelIgnored // Not show when label is not shown in this state.
      || !retrieve2(stateShow, showNormal) // Use normal state by default if not set.
      ) {
          var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];

          if (stateObj) {
            stateObj.ignore = true;
          }

          continue;
        } // Create labelLine if not exists


      if (!labelLine) {
        labelLine = new Polyline();
        targetEl.setTextGuideLine(labelLine); // Reset state of normal because it's new created.
        // NOTE: NORMAL should always been the first!

        if (!isNormal && (labelIgnoreNormal || !showNormal)) {
          setLabelLineState(labelLine, true, 'normal', statesModels.normal);
        } // Use same state proxy.


        if (targetEl.stateProxy) {
          labelLine.stateProxy = targetEl.stateProxy;
        }
      }

      setLabelLineState(labelLine, false, stateName, stateModel);
    }
  }

  if (labelLine) {
    defaults(labelLine.style, defaultStyle); // Not fill.

    labelLine.style.fill = null;
    var showAbove = normalModel.get('showAbove');
    var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
    labelLineConfig.showAbove = showAbove || false; // Custom the buildPath.

    labelLine.buildPath = buildLabelLinePath;
  }
}
function getLabelLineStatesModels(itemModel, labelLineName) {
  labelLineName = labelLineName || 'labelLine';
  var statesModels = {
    normal: itemModel.getModel(labelLineName)
  };

  for (var i = 0; i < SPECIAL_STATES.length; i++) {
    var stateName = SPECIAL_STATES[i];
    statesModels[stateName] = itemModel.getModel([stateName, labelLineName]);
  }

  return statesModels;
}

function prepareLayoutList(input) {
  var list = [];

  for (var i = 0; i < input.length; i++) {
    var rawItem = input[i];

    if (rawItem.defaultAttr.ignore) {
      continue;
    }

    var label = rawItem.label;
    var transform = label.getComputedTransform(); // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.

    var localRect = label.getBoundingRect();
    var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
    var minMargin = label.style.margin || 0;
    var globalRect = localRect.clone();
    globalRect.applyTransform(transform);
    globalRect.x -= minMargin / 2;
    globalRect.y -= minMargin / 2;
    globalRect.width += minMargin;
    globalRect.height += minMargin;
    var obb = isAxisAligned ? new OrientedBoundingRect(localRect, transform) : null;
    list.push({
      label: label,
      labelLine: rawItem.labelLine,
      rect: globalRect,
      localRect: localRect,
      obb: obb,
      priority: rawItem.priority,
      defaultAttr: rawItem.defaultAttr,
      layoutOption: rawItem.computedLayoutOption,
      axisAligned: isAxisAligned,
      transform: transform
    });
  }

  return list;
}

function shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
  var len = list.length;

  if (len < 2) {
    return;
  }

  list.sort(function (a, b) {
    return a.rect[xyDim] - b.rect[xyDim];
  });
  var lastPos = 0;
  var delta;
  var adjusted = false;
  var totalShifts = 0;

  for (var i = 0; i < len; i++) {
    var item = list[i];
    var rect = item.rect;
    delta = rect[xyDim] - lastPos;

    if (delta < 0) {
      // shiftForward(i, len, -delta);
      rect[xyDim] -= delta;
      item.label[xyDim] -= delta;
      adjusted = true;
    }

    var shift = Math.max(-delta, 0);
    totalShifts += shift;
    lastPos = rect[xyDim] + rect[sizeDim];
  }

  if (totalShifts > 0 && balanceShift) {
    // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
  } // TODO bleedMargin?


  var first = list[0];
  var last = list[len - 1];
  var minGap;
  var maxGap;
  updateMinMaxGap(); // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.

  minGap < 0 && squeezeGaps(-minGap, 0.8);
  maxGap < 0 && squeezeGaps(maxGap, 0.8);
  updateMinMaxGap();
  takeBoundsGap(minGap, maxGap, 1);
  takeBoundsGap(maxGap, minGap, -1); // Handle bailout when there is not enough space.

  updateMinMaxGap();

  if (minGap < 0) {
    squeezeWhenBailout(-minGap);
  }

  if (maxGap < 0) {
    squeezeWhenBailout(maxGap);
  }

  function updateMinMaxGap() {
    minGap = first.rect[xyDim] - minBound;
    maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
  }

  function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
    if (gapThisBound < 0) {
      // Move from other gap if can.
      var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);

      if (moveFromMaxGap > 0) {
        shiftList(moveFromMaxGap * moveDir, 0, len);
        var remained = moveFromMaxGap + gapThisBound;

        if (remained < 0) {
          squeezeGaps(-remained * moveDir, 1);
        }
      } else {
        squeezeGaps(-gapThisBound * moveDir, 1);
      }
    }
  }

  function shiftList(delta, start, end) {
    if (delta !== 0) {
      adjusted = true;
    }

    for (var i = start; i < end; i++) {
      var item = list[i];
      var rect = item.rect;
      rect[xyDim] += delta;
      item.label[xyDim] += delta;
    }
  } // Squeeze gaps if the labels exceed margin.


  function squeezeGaps(delta, maxSqeezePercent) {
    var gaps = [];
    var totalGaps = 0;

    for (var i = 1; i < len; i++) {
      var prevItemRect = list[i - 1].rect;
      var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
      gaps.push(gap);
      totalGaps += gap;
    }

    if (!totalGaps) {
      return;
    }

    var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);

    if (delta > 0) {
      for (var i = 0; i < len - 1; i++) {
        // Distribute the shift delta to all gaps.
        var movement = gaps[i] * squeezePercent; // Forward

        shiftList(movement, 0, i + 1);
      }
    } else {
      // Backward
      for (var i = len - 1; i > 0; i--) {
        // Distribute the shift delta to all gaps.
        var movement = gaps[i - 1] * squeezePercent;
        shiftList(-movement, i, len);
      }
    }
  }
  /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */


  function squeezeWhenBailout(delta) {
    var dir = delta < 0 ? -1 : 1;
    delta = Math.abs(delta);
    var moveForEachLabel = Math.ceil(delta / (len - 1));

    for (var i = 0; i < len - 1; i++) {
      if (dir > 0) {
        // Forward
        shiftList(moveForEachLabel, 0, i + 1);
      } else {
        // Backward
        shiftList(-moveForEachLabel, len - i - 1, len);
      }

      delta -= moveForEachLabel;

      if (delta <= 0) {
        return;
      }
    }
  }

  return adjusted;
}
/**
 * Adjust labels on x direction to avoid overlap.
 */


function shiftLayoutOnX(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
  return shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
/**
 * Adjust labels on y direction to avoid overlap.
 */

function shiftLayoutOnY(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
  return shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function hideOverlap(labelList) {
  var displayedLabels = []; // TODO, render overflow visible first, put in the displayedLabels.

  labelList.sort(function (a, b) {
    return b.priority - a.priority;
  });
  var globalRect = new BoundingRect(0, 0, 0, 0);

  function hideEl(el) {
    if (!el.ignore) {
      // Show on emphasis.
      var emphasisState = el.ensureState('emphasis');

      if (emphasisState.ignore == null) {
        emphasisState.ignore = false;
      }
    }

    el.ignore = true;
  }

  for (var i = 0; i < labelList.length; i++) {
    var labelItem = labelList[i];
    var isAxisAligned = labelItem.axisAligned;
    var localRect = labelItem.localRect;
    var transform = labelItem.transform;
    var label = labelItem.label;
    var labelLine = labelItem.labelLine;
    globalRect.copy(labelItem.rect); // Add a threshold because layout may be aligned precisely.

    globalRect.width -= 0.1;
    globalRect.height -= 0.1;
    globalRect.x += 0.05;
    globalRect.y += 0.05;
    var obb = labelItem.obb;
    var overlapped = false;

    for (var j = 0; j < displayedLabels.length; j++) {
      var existsTextCfg = displayedLabels[j]; // Fast rejection.

      if (!globalRect.intersect(existsTextCfg.rect)) {
        continue;
      }

      if (isAxisAligned && existsTextCfg.axisAligned) {
        // Is overlapped
        overlapped = true;
        break;
      }

      if (!existsTextCfg.obb) {
        // If self is not axis aligned. But other is.
        existsTextCfg.obb = new OrientedBoundingRect(existsTextCfg.localRect, existsTextCfg.transform);
      }

      if (!obb) {
        // If self is axis aligned. But other is not.
        obb = new OrientedBoundingRect(localRect, transform);
      }

      if (obb.intersect(existsTextCfg.obb)) {
        overlapped = true;
        break;
      }
    } // TODO Callback to determine if this overlap should be handled?


    if (overlapped) {
      hideEl(label);
      labelLine && hideEl(labelLine);
    } else {
      label.attr('ignore', labelItem.defaultAttr.ignore);
      labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
      displayedLabels.push(labelItem);
    }
  }
}

function cloneArr(points) {
  if (points) {
    var newPoints = [];

    for (var i = 0; i < points.length; i++) {
      newPoints.push(points[i].slice());
    }

    return newPoints;
  }
}

function prepareLayoutCallbackParams(labelItem, hostEl) {
  var label = labelItem.label;
  var labelLine = hostEl && hostEl.getTextGuideLine();
  return {
    dataIndex: labelItem.dataIndex,
    dataType: labelItem.dataType,
    seriesIndex: labelItem.seriesModel.seriesIndex,
    text: labelItem.label.style.text,
    rect: labelItem.hostRect,
    labelRect: labelItem.rect,
    // x: labelAttr.x,
    // y: labelAttr.y,
    align: label.style.align,
    verticalAlign: label.style.verticalAlign,
    labelLinePoints: cloneArr(labelLine && labelLine.shape.points)
  };
}

var LABEL_OPTION_TO_STYLE_KEYS = ['align', 'verticalAlign', 'width', 'height', 'fontSize'];
var dummyTransformable = new Transformable();
var labelLayoutInnerStore = makeInner();
var labelLineAnimationStore = makeInner();

function extendWithKeys(target, source, keys) {
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (source[key] != null) {
      target[key] = source[key];
    }
  }
}

var LABEL_LAYOUT_PROPS = ['x', 'y', 'rotation'];

var LabelManager =
/** @class */
function () {
  function LabelManager() {
    this._labelList = [];
    this._chartViewList = [];
  }

  LabelManager.prototype.clearLabels = function () {
    this._labelList = [];
    this._chartViewList = [];
  };
  /**
   * Add label to manager
   */


  LabelManager.prototype._addLabel = function (dataIndex, dataType, seriesModel, label, layoutOption) {
    var labelStyle = label.style;
    var hostEl = label.__hostTarget;
    var textConfig = hostEl.textConfig || {}; // TODO: If label is in other state.

    var labelTransform = label.getComputedTransform();
    var labelRect = label.getBoundingRect().plain();
    BoundingRect.applyTransform(labelRect, labelRect, labelTransform);

    if (labelTransform) {
      dummyTransformable.setLocalTransform(labelTransform);
    } else {
      // Identity transform.
      dummyTransformable.x = dummyTransformable.y = dummyTransformable.rotation = dummyTransformable.originX = dummyTransformable.originY = 0;
      dummyTransformable.scaleX = dummyTransformable.scaleY = 1;
    }

    var host = label.__hostTarget;
    var hostRect;

    if (host) {
      hostRect = host.getBoundingRect().plain();
      var transform = host.getComputedTransform();
      BoundingRect.applyTransform(hostRect, hostRect, transform);
    }

    var labelGuide = hostRect && host.getTextGuideLine();

    this._labelList.push({
      label: label,
      labelLine: labelGuide,
      seriesModel: seriesModel,
      dataIndex: dataIndex,
      dataType: dataType,
      layoutOption: layoutOption,
      computedLayoutOption: null,
      rect: labelRect,
      hostRect: hostRect,
      // Label with lower priority will be hidden when overlapped
      // Use rect size as default priority
      priority: hostRect ? hostRect.width * hostRect.height : 0,
      // Save default label attributes.
      // For restore if developers want get back to default value in callback.
      defaultAttr: {
        ignore: label.ignore,
        labelGuideIgnore: labelGuide && labelGuide.ignore,
        x: dummyTransformable.x,
        y: dummyTransformable.y,
        scaleX: dummyTransformable.scaleX,
        scaleY: dummyTransformable.scaleY,
        rotation: dummyTransformable.rotation,
        style: {
          x: labelStyle.x,
          y: labelStyle.y,
          align: labelStyle.align,
          verticalAlign: labelStyle.verticalAlign,
          width: labelStyle.width,
          height: labelStyle.height,
          fontSize: labelStyle.fontSize
        },
        cursor: label.cursor,
        attachedPos: textConfig.position,
        attachedRot: textConfig.rotation
      }
    });
  };

  LabelManager.prototype.addLabelsOfSeries = function (chartView) {
    var _this = this;

    this._chartViewList.push(chartView);

    var seriesModel = chartView.__model;
    var layoutOption = seriesModel.get('labelLayout');
    /**
     * Ignore layouting if it's not specified anything.
     */

    if (!(isFunction$3(layoutOption) || keys$2(layoutOption).length)) {
      return;
    }

    chartView.group.traverse(function (child) {
      if (child.ignore) {
        return true; // Stop traverse descendants.
      } // Only support label being hosted on graphic elements.


      var textEl = child.getTextContent();
      var ecData = getECData(child); // Can only attach the text on the element with dataIndex

      if (textEl && !textEl.disableLabelLayout) {
        _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
      }
    });
  };

  LabelManager.prototype.updateLayoutConfig = function (api) {
    var width = api.getWidth();
    var height = api.getHeight();

    function createDragHandler(el, labelLineModel) {
      return function () {
        updateLabelLinePoints(el, labelLineModel);
      };
    }

    for (var i = 0; i < this._labelList.length; i++) {
      var labelItem = this._labelList[i];
      var label = labelItem.label;
      var hostEl = label.__hostTarget;
      var defaultLabelAttr = labelItem.defaultAttr;
      var layoutOption = void 0; // TODO A global layout option?

      if (isFunction$3(labelItem.layoutOption)) {
        layoutOption = labelItem.layoutOption(prepareLayoutCallbackParams(labelItem, hostEl));
      } else {
        layoutOption = labelItem.layoutOption;
      }

      layoutOption = layoutOption || {};
      labelItem.computedLayoutOption = layoutOption;
      var degreeToRadian = Math.PI / 180; // TODO hostEl should always exists.
      // Or label should not have parent because the x, y is all in global space.

      if (hostEl) {
        hostEl.setTextConfig({
          // Force to set local false.
          local: false,
          // Ignore position and rotation config on the host el if x or y is changed.
          position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
          // Ignore rotation config on the host el if rotation is changed.
          rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
          offset: [layoutOption.dx || 0, layoutOption.dy || 0]
        });
      }

      var needsUpdateLabelLine = false;

      if (layoutOption.x != null) {
        // TODO width of chart view.
        label.x = parsePercent$1(layoutOption.x, width);
        label.setStyle('x', 0); // Ignore movement in style. TODO: origin.

        needsUpdateLabelLine = true;
      } else {
        label.x = defaultLabelAttr.x;
        label.setStyle('x', defaultLabelAttr.style.x);
      }

      if (layoutOption.y != null) {
        // TODO height of chart view.
        label.y = parsePercent$1(layoutOption.y, height);
        label.setStyle('y', 0); // Ignore movement in style.

        needsUpdateLabelLine = true;
      } else {
        label.y = defaultLabelAttr.y;
        label.setStyle('y', defaultLabelAttr.style.y);
      }

      if (layoutOption.labelLinePoints) {
        var guideLine = hostEl.getTextGuideLine();

        if (guideLine) {
          guideLine.setShape({
            points: layoutOption.labelLinePoints
          }); // Not update

          needsUpdateLabelLine = false;
        }
      }

      var labelLayoutStore = labelLayoutInnerStore(label);
      labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
      label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
      label.scaleX = defaultLabelAttr.scaleX;
      label.scaleY = defaultLabelAttr.scaleY;

      for (var k = 0; k < LABEL_OPTION_TO_STYLE_KEYS.length; k++) {
        var key = LABEL_OPTION_TO_STYLE_KEYS[k];
        label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
      }

      if (layoutOption.draggable) {
        label.draggable = true;
        label.cursor = 'move';

        if (hostEl) {
          var hostModel = labelItem.seriesModel;

          if (labelItem.dataIndex != null) {
            var data = labelItem.seriesModel.getData(labelItem.dataType);
            hostModel = data.getItemModel(labelItem.dataIndex);
          }

          label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
        }
      } else {
        // TODO Other drag functions?
        label.off('drag');
        label.cursor = defaultLabelAttr.cursor;
      }
    }
  };

  LabelManager.prototype.layout = function (api) {
    var width = api.getWidth();
    var height = api.getHeight();
    var labelList = prepareLayoutList(this._labelList);
    var labelsNeedsAdjustOnX = filter(labelList, function (item) {
      return item.layoutOption.moveOverlap === 'shiftX';
    });
    var labelsNeedsAdjustOnY = filter(labelList, function (item) {
      return item.layoutOption.moveOverlap === 'shiftY';
    });
    shiftLayoutOnX(labelsNeedsAdjustOnX, 0, width);
    shiftLayoutOnY(labelsNeedsAdjustOnY, 0, height);
    var labelsNeedsHideOverlap = filter(labelList, function (item) {
      return item.layoutOption.hideOverlap;
    });
    hideOverlap(labelsNeedsHideOverlap);
  };
  /**
   * Process all labels. Not only labels with layoutOption.
   */


  LabelManager.prototype.processLabelsOverall = function () {
    var _this = this;

    each(this._chartViewList, function (chartView) {
      var seriesModel = chartView.__model;
      var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
      var animationEnabled = seriesModel.isAnimationEnabled();
      chartView.group.traverse(function (child) {
        if (child.ignore && !child.forceLabelAnimation) {
          return true; // Stop traverse descendants.
        }

        var needsUpdateLabelLine = !ignoreLabelLineUpdate;
        var label = child.getTextContent();

        if (!needsUpdateLabelLine && label) {
          needsUpdateLabelLine = labelLayoutInnerStore(label).needsUpdateLabelLine;
        }

        if (needsUpdateLabelLine) {
          _this._updateLabelLine(child, seriesModel);
        }

        if (animationEnabled) {
          _this._animateLabels(child, seriesModel);
        }
      });
    });
  };

  LabelManager.prototype._updateLabelLine = function (el, seriesModel) {
    // Only support label being hosted on graphic elements.
    var textEl = el.getTextContent(); // Update label line style.

    var ecData = getECData(el);
    var dataIndex = ecData.dataIndex; // Only support labelLine on the labels represent data.

    if (textEl && dataIndex != null) {
      var data = seriesModel.getData(ecData.dataType);
      var itemModel = data.getItemModel(dataIndex);
      var defaultStyle = {};
      var visualStyle = data.getItemVisual(dataIndex, 'style');
      var visualType = data.getVisual('drawType'); // Default to be same with main color

      defaultStyle.stroke = visualStyle[visualType];
      var labelLineModel = itemModel.getModel('labelLine');
      setLabelLineStyle(el, getLabelLineStatesModels(itemModel), defaultStyle);
      updateLabelLinePoints(el, labelLineModel);
    }
  };

  LabelManager.prototype._animateLabels = function (el, seriesModel) {
    var textEl = el.getTextContent();
    var guideLine = el.getTextGuideLine(); // Animate

    if (textEl // `forceLabelAnimation` has the highest priority
    && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !isElementRemoved(el))) {
      var layoutStore = labelLayoutInnerStore(textEl);
      var oldLayout = layoutStore.oldLayout;
      var ecData = getECData(el);
      var dataIndex = ecData.dataIndex;
      var newProps = {
        x: textEl.x,
        y: textEl.y,
        rotation: textEl.rotation
      };
      var data = seriesModel.getData(ecData.dataType);

      if (!oldLayout) {
        textEl.attr(newProps); // Disable fade in animation if value animation is enabled.

        if (!labelInner(textEl).valueAnimation) {
          var oldOpacity = retrieve2(textEl.style.opacity, 1); // Fade in animation

          textEl.style.opacity = 0;
          initProps(textEl, {
            style: {
              opacity: oldOpacity
            }
          }, seriesModel, dataIndex);
        }
      } else {
        textEl.attr(oldLayout); // Make sure the animation from is in the right status.

        var prevStates = el.prevStates;

        if (prevStates) {
          if (indexOf(prevStates, 'select') >= 0) {
            textEl.attr(layoutStore.oldLayoutSelect);
          }

          if (indexOf(prevStates, 'emphasis') >= 0) {
            textEl.attr(layoutStore.oldLayoutEmphasis);
          }
        }

        updateProps(textEl, newProps, seriesModel, dataIndex);
      }

      layoutStore.oldLayout = newProps;

      if (textEl.states.select) {
        var layoutSelect = layoutStore.oldLayoutSelect = {};
        extendWithKeys(layoutSelect, newProps, LABEL_LAYOUT_PROPS);
        extendWithKeys(layoutSelect, textEl.states.select, LABEL_LAYOUT_PROPS);
      }

      if (textEl.states.emphasis) {
        var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
        extendWithKeys(layoutEmphasis, newProps, LABEL_LAYOUT_PROPS);
        extendWithKeys(layoutEmphasis, textEl.states.emphasis, LABEL_LAYOUT_PROPS);
      }

      animateLabelValue(textEl, dataIndex, data, seriesModel, seriesModel);
    }

    if (guideLine && !guideLine.ignore && !guideLine.invisible) {
      var layoutStore = labelLineAnimationStore(guideLine);
      var oldLayout = layoutStore.oldLayout;
      var newLayout = {
        points: guideLine.shape.points
      };

      if (!oldLayout) {
        guideLine.setShape(newLayout);
        guideLine.style.strokePercent = 0;
        initProps(guideLine, {
          style: {
            strokePercent: 1
          }
        }, seriesModel);
      } else {
        guideLine.attr({
          shape: oldLayout
        });
        updateProps(guideLine, {
          shape: newLayout
        }, seriesModel);
      }

      layoutStore.oldLayout = newLayout;
    }
  };

  return LabelManager;
}();

var getLabelManager = makeInner();
function installLabelLayout(registers) {
  registers.registerUpdateLifecycle('series:beforeupdate', function (ecModel, api, params) {
    // TODO api provide an namespace that can save stuff per instance
    var labelManager = getLabelManager(api).labelManager;

    if (!labelManager) {
      labelManager = getLabelManager(api).labelManager = new LabelManager();
    }

    labelManager.clearLabels();
  });
  registers.registerUpdateLifecycle('series:layoutlabels', function (ecModel, api, params) {
    var labelManager = getLabelManager(api).labelManager;
    params.updatedSeries.forEach(function (series) {
      labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
    });
    labelManager.updateLayoutConfig(api);
    labelManager.layout(api);
    labelManager.processLabelsOverall();
  });
}

var mathSin$4 = Math.sin;
var mathCos$4 = Math.cos;
var PI$4 = Math.PI;
var PI2$7 = Math.PI * 2;
var degree = 180 / PI$4;
var SVGPathRebuilder = (function () {
    function SVGPathRebuilder() {
    }
    SVGPathRebuilder.prototype.reset = function (precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function (x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function (x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function (x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function (x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function (cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function (cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = isAroundZero$1(dThetaPositive - PI2$7)
            || (clockwise ? dTheta >= PI2$7 : -dTheta >= PI2$7);
        var unifiedTheta = dTheta > 0 ? dTheta % PI2$7 : (dTheta % PI2$7 + PI2$7);
        var large = false;
        if (isCircle) {
            large = true;
        }
        else if (isAroundZero$1(dThetaPositive)) {
            large = false;
        }
        else {
            large = (unifiedTheta >= PI$4) === !!clockwise;
        }
        var x0 = cx + rx * mathCos$4(startAngle);
        var y0 = cy + ry * mathSin$4(startAngle);
        if (this._start) {
            this._add('M', x0, y0);
        }
        var xRot = Math.round(psi * degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * (PI2$7 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * mathCos$4(startAngle + dTheta_1), cy + ry * mathSin$4(startAngle + dTheta_1));
            if (p > 1e-2) {
                this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
            }
        }
        else {
            var x = cx + rx * mathCos$4(endAngle);
            var y = cy + ry * mathSin$4(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function (x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function () {
        if (this._d.length > 0) {
            this._add('Z');
        }
    };
    SVGPathRebuilder.prototype._add = function (cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for (var i = 1; i < arguments.length; i++) {
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function () {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function () {
        return this._str;
    };
    return SVGPathRebuilder;
}());

var NONE$1 = 'none';
var mathRound$1 = Math.round;
function pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== NONE$1;
}
function pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== NONE$1;
}
var strokeProps = ['lineCap', 'miterLimit', 'lineJoin'];
var svgStrokeProps = map(strokeProps, function (prop) { return "stroke-" + prop.toLowerCase(); });
function mapStyleToAttrs(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof ZRImage) {
        updateAttr('opacity', opacity);
        return;
    }
    if (pathHasFill(style)) {
        var fill = normalizeColor(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null
            ? style.fillOpacity * fill.opacity * opacity
            : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) {
            updateAttr('fill-opacity', fillOpacity);
        }
    }
    else {
        updateAttr('fill', NONE$1);
    }
    if (pathHasStroke(style)) {
        var stroke = normalizeColor(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale
            ? el.getLineScale()
            : 1;
        var strokeWidth = (strokeScale ? (style.lineWidth || 0) / strokeScale : 0);
        var strokeOpacity = style.strokeOpacity != null
            ? style.strokeOpacity * stroke.opacity * opacity
            : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) {
            updateAttr('stroke-width', strokeWidth);
        }
        if (forceUpdate || strokeFirst) {
            updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        }
        if (forceUpdate || strokeOpacity < 1) {
            updateAttr('stroke-opacity', strokeOpacity);
        }
        if (style.lineDash) {
            var _a = getLineDash(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = mathRound$1(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) {
                    updateAttr('stroke-dashoffset', lineDashOffset);
                }
            }
        }
        else if (forceUpdate) {
            updateAttr('stroke-dasharray', NONE$1);
        }
        for (var i = 0; i < strokeProps.length; i++) {
            var propName = strokeProps[i];
            if (forceUpdate || style[propName] !== DEFAULT_PATH_STYLE[propName]) {
                var val = style[propName] || DEFAULT_PATH_STYLE[propName];
                val && updateAttr(svgStrokeProps[i], val);
            }
        }
    }
    else if (forceUpdate) {
        updateAttr('stroke', NONE$1);
    }
}

var SVGNS = 'http://www.w3.org/2000/svg';
var XLINKNS = 'http://www.w3.org/1999/xlink';
var XMLNS = 'http://www.w3.org/2000/xmlns/';
var XML_NAMESPACE = 'http://www.w3.org/XML/1998/namespace';
function createElement(name) {
    return document.createElementNS(SVGNS, name);
}
function createVNode(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) {
        for (var key in attrs) {
            var val = attrs[key];
            var part = key;
            if (val === false) {
                continue;
            }
            else if (val !== true && val != null) {
                part += "=\"" + val + "\"";
            }
            attrsStr.push(part);
        }
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function createElementClose(name) {
    return "</" + name + ">";
}
function vNodeToString(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs;
        return createElementOpen(tag, attrs)
            + encodeHTML(el.text)
            + (children ? "" + S + map(children, function (child) { return convertElToString(child); }).join(S) + S : '')
            + createElementClose(tag);
    }
    return convertElToString(el);
}
function getCssString(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = map(keys$2(selectorNodes), function (className) {
        return className + bracketBegin + map(keys$2(selectorNodes[className]), function (attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = map(keys$2(animationNodes), function (animationName) {
        return "@keyframes " + animationName + bracketBegin + map(keys$2(animationNodes[animationName]), function (percent) {
            return percent + bracketBegin + map(keys$2(animationNodes[animationName][percent]), function (attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') {
                    val = "path(\"" + val + "\")";
                }
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) {
        return '';
    }
    return ['<![CDATA[', selectors, animations, ']]>'].join(S);
}
function createBrushScope(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssClassIdx: 0,
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function createSVGVNode(width, height, children, useViewBox) {
    return createVNode('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': SVGNS,
        'xmlns:xlink': XLINKNS,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}

var EASING_MAP = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var transformOriginKey = 'transform-origin';
function buildPathString(el, kfShape, path) {
    var shape = extend({}, el.shape);
    extend(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new SVGPathRebuilder();
    svgPathBuilder.reset(getPathPrecision(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) {
        target[transformOriginKey] = originX + "px " + originY + "px";
    }
}
var ANIMATE_STYLE_MAP = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    each(paths, function (path) {
        var subScope = createBrushScope(scope.zrId);
        subScope.animation = true;
        createCSSAnimation(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = keys$2(cssAnims);
        var len = animNames.length;
        if (!len) {
            return;
        }
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for (var percent in lastAnim) {
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || { d: '' };
            composedAnim[percent].d += kf.d || '';
        }
        for (var className in cssNodes) {
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) {
                cssAnimationCfg = val;
            }
        }
    });
    if (!cssAnimationCfg) {
        return;
    }
    attrs.d = false;
    var animationName = addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function getEasingFunc(easing) {
    return isString(easing)
        ? EASING_MAP[easing]
            ? "cubic-bezier(" + EASING_MAP[easing] + ")"
            : createCubicEasingFunc(easing) ? easing : ''
        : '';
}
function createCSSAnimation(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof CompoundPath) {
        var animationCfg = createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) {
            cssAnimations.push(animationCfg);
        }
        else if (!len) {
            return;
        }
    }
    else if (!len) {
        return;
    }
    var groupAnimators = {};
    for (var i = 0; i < len; i++) {
        var animator = animators[i];
        var cfgArr = [animator.getMaxTime() / 1000 + 's'];
        var easing = getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) {
            cfgArr.push(easing);
        }
        else {
            cfgArr.push('linear');
        }
        if (delay) {
            cfgArr.push(delay / 1000 + 's');
        }
        if (animator.getLoop()) {
            cfgArr.push('infinite');
        }
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [cfg, []];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for (var k = 0; k < tracks.length; k++) {
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) {
                        for (var i = 0; i < kfs.length; i++) {
                            var kf = kfs[i];
                            var percent = Math.round(kf.time / maxTime * 100) + '%';
                            var kfEasing = getEasingFunc(kf.easing);
                            var rawValue = kf.rawValue;
                            if (isString(rawValue) || isNumber$1(rawValue)) {
                                cssKfs[percent] = cssKfs[percent] || {};
                                cssKfs[percent][attrName] = kf.rawValue;
                                if (kfEasing) {
                                    cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                                }
                            }
                        }
                    }
                }
            }
        }
        for (var i = 0; i < len; i++) {
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) {
                !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            }
            else if (targetProp === 'shape') {
                saveAnimatorTrackToCssKfs(animator, shapeKfs);
            }
        }
        for (var percent in transformKfs) {
            var transform = {};
            copyTransform(transform, el);
            extend(transform, transformKfs[percent]);
            var str = getSRTTransformString(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) {
                finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
            }
        }
        var path;
        var canAnimateShape = true;
        for (var percent in shapeKfs) {
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) {
                path = new PathProxy();
            }
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) {
                finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
            }
        }
        if (!canAnimateShape) {
            for (var percent in finalKfs) {
                delete finalKfs[percent].d;
            }
        }
        if (!onlyShape) {
            for (var i = 0; i < len; i++) {
                var animator = animators[i];
                var targetProp = animator.targetName;
                if (targetProp === 'style') {
                    saveAnimatorTrackToCssKfs(animator, finalKfs, function (propName) { return ANIMATE_STYLE_MAP[propName]; });
                }
            }
        }
        var percents = keys$2(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for (var i = 1; i < percents.length; i++) {
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][transformOriginKey] !== finalKfs[p1][transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for (var percent in finalKfs) {
                if (finalKfs[percent][transformOriginKey]) {
                    delete finalKfs[percent][transformOriginKey];
                }
            }
            attrs[transformOriginKey] = transformOrigin;
        }
        if (filter(percents, function (percent) { return keys$2(finalKfs[percent]).length > 0; }).length) {
            var animationName = addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for (var key in groupAnimators) {
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) {
            cssAnimations.push(animationCfg);
        }
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + scope.cssClassIdx++;
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}

var round$5 = Math.round;
function isImageLike$1(val) {
    return val && isString(val.src);
}
function isCanvasLike(val) {
    return val && isFunction$3(val.toDataURL);
}
function setStyleAttrs(attrs, style, el, scope) {
    mapStyleToAttrs(function (key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && isGradient(val)) {
            setGradient(style, attrs, key, scope);
        }
        else if (isFillStroke && isPattern(val)) {
            setPattern(el, attrs, key, scope);
        }
        else {
            attrs[key] = val;
        }
    }, style, el, false);
    setShadow(el, attrs, scope);
}
function noRotateScale(m) {
    return isAroundZero$1(m[0] - 1)
        && isAroundZero$1(m[1])
        && isAroundZero$1(m[2])
        && isAroundZero$1(m[3] - 1);
}
function noTranslate(m) {
    return isAroundZero$1(m[4]) && isAroundZero$1(m[5]);
}
function setTransform(attrs, m, compress) {
    if (m && !(noTranslate(m) && noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = noRotateScale(m)
            ? "translate(" + round$5(m[4] * mul) / mul + " " + round$5(m[5] * mul) / mul + ")" : getMatrixStr(m);
    }
}
function convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for (var i = 0; i < points.length; i++) {
        strArr.push(round$5(points[i][0] * mul) / mul);
        strArr.push(round$5(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function validatePolyShape(shape) {
    return !shape.smooth;
}
function createAttrsConvert(desc) {
    var normalizedDesc = map(desc, function (item) {
        return (typeof item === 'string' ? [item, item] : item);
    });
    return function (shape, attrs, mul) {
        for (var i = 0; i < normalizedDesc.length; i++) {
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) {
                attrs[item[1]] = round$5(val * mul) / mul;
            }
        }
    };
}
var builtinShapesDef = {
    circle: [createAttrsConvert(['cx', 'cy', 'r'])],
    polyline: [convertPolyShape, validatePolyShape],
    polygon: [convertPolyShape, validatePolyShape]
};
function hasShapeAnimation(el) {
    var animators = el.animators;
    for (var i = 0; i < animators.length; i++) {
        if (animators[i].targetName === 'shape') {
            return true;
        }
    }
    return false;
}
function brushSVGPath(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = (scope.compress && getPathPrecision(el)) || 4;
    if (builtinShpDef
        && !scope.willUpdate
        && !(builtinShpDef[1] && !builtinShpDef[1](shape))
        && !(needsAnimate && hasShapeAnimation(el))
        && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    }
    else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) {
            el.createPathProxy();
        }
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion
            || !svgPathBuilder
            || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) {
                svgPathBuilder = elExt.__svgPathBuilder = new SVGPathRebuilder();
            }
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && createCSSAnimation(el, attrs, scope);
    return createVNode(svgElType, el.id + '', attrs);
}
function brushSVGImage(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !isString(image)) {
        if (isImageLike$1(image)) {
            image = image.src;
        }
        else if (isCanvasLike(image)) {
            image = image.toDataURL();
        }
    }
    if (!image) {
        return;
    }
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) {
        attrs.x = x;
    }
    if (y) {
        attrs.y = y;
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && createCSSAnimation(el, attrs, scope);
    return createVNode('image', el.id + '', attrs);
}
function brushSVGTSpan(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) {
        return;
    }
    var font = style.font || DEFAULT_FONT;
    var x = style.x || 0;
    var y = adjustTextY(style.y || 0, getLineHeight(font), style.textBaseline);
    var textAlign = TEXT_ALIGN_TO_ANCHOR[style.textAlign]
        || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if (hasSeparateFont(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = parseFontSize(style.fontSize);
        if (!parseFloat(fontSize)) {
            return;
        }
        var fontFamily = style.fontFamily || DEFAULT_FONT_FAMILY;
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') {
            separatedFontStr += "font-style:" + fontStyle + ";";
        }
        if (fontWeight && fontWeight !== 'normal') {
            separatedFontStr += "font-weight:" + fontWeight + ";";
        }
        attrs.style = separatedFontStr;
    }
    else {
        attrs.style = "font: " + font;
    }
    if (text.match(/\s/)) {
        attrs['xml:space'] = 'preserve';
    }
    if (x) {
        attrs.x = x;
    }
    if (y) {
        attrs.y = y;
    }
    setTransform(attrs, el.transform);
    setStyleAttrs(attrs, style, el, scope);
    scope.animation && createCSSAnimation(el, attrs, scope);
    return createVNode('text', el.id + '', attrs, undefined, text);
}
function brush$1(el, scope) {
    if (el instanceof Path) {
        return brushSVGPath(el, scope);
    }
    else if (el instanceof ZRImage) {
        return brushSVGImage(el, scope);
    }
    else if (el instanceof TSpan) {
        return brushSVGTSpan(el, scope);
    }
}
function setShadow(el, attrs, scope) {
    var style = el.style;
    if (hasShadow(style)) {
        var shadowKey = getShadowKey(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) {
                return;
            }
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = normalizeColor(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = createVNode('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                createVNode('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = getIdURL(shadowId);
    }
}
function setGradient(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global
            ? 'userSpaceOnUse'
            : 'objectBoundingBox'
    };
    if (isLinearGradient(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    }
    else if (isRadialGradient(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = retrieve2(val.x, 0.5);
        gradientAttrs.cy = retrieve2(val.y, 0.5);
        gradientAttrs.r = retrieve2(val.r, 0.5);
    }
    else {
        if (process.env.NODE_ENV !== 'production') {
            logError('Illegal gradient type.');
        }
        return;
    }
    var colors = val.colorStops;
    var colorStops = [];
    for (var i = 0, len = colors.length; i < len; ++i) {
        var offset = round4(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = normalizeColor(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) {
            stopsAttrs['stop-opacity'] = opacity;
        }
        colorStops.push(createVNode('stop', i + '', stopsAttrs));
    }
    var gradientVNode = createVNode(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = vNodeToString(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = createVNode(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = getIdURL(gradientId);
}
function setPattern(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if (isImagePattern(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if (isString(patternImage)) {
            imageSrc = patternImage;
        }
        else if (isImageLike$1(patternImage)) {
            imageSrc = patternImage.src;
        }
        else if (isCanvasLike(patternImage)) {
            imageSrc = patternImage.toDataURL();
        }
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            assert(imageWidth_1, errMsg);
            assert(imageHeight_1, errMsg);
        }
        else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function (vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        }
                        else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = createOrUpdateImage(imageSrc, null, el, function (img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = createVNode('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    }
    else if (val.svgElement) {
        child = clone(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) {
        return;
    }
    var patternWidth;
    var patternHeight;
    if (noRepeat) {
        patternWidth = patternHeight = 1;
    }
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    }
    else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    }
    else {
        patternAttrs.patternUnits = 'userSpaceOnUse';
    }
    if (patternWidth != null && !isNaN(patternWidth)) {
        patternAttrs.width = patternWidth;
    }
    if (patternHeight != null && !isNaN(patternHeight)) {
        patternAttrs.height = patternHeight;
    }
    var patternTransform = getSRTTransformString(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = createVNode('pattern', '', patternAttrs, [child]);
    var patternKey = vNodeToString(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = createVNode('pattern', patternId, patternAttrs, [child]);
    }
    attrs[target] = getIdURL(patternId);
}
function setClipPath(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = createVNode('clipPath', clipPathId, clipPathAttrs, [brushSVGPath(clipPath, scope)]);
    }
    attrs['clip-path'] = getIdURL(clipPathId);
}

function createTextNode(text) {
    return document.createTextNode(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function setTextContent(node, text) {
    node.textContent = text;
}

var colonChar = 58;
var xChar = 120;
var emptyNode = createVNode('', '');
function isUndef(s) {
    return s === undefined;
}
function isDef(s) {
    return s !== undefined;
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for (var i = beginIdx; i <= endIdx; ++i) {
        var key = children[i].key;
        if (key !== undefined) {
            if (process.env.NODE_ENV !== 'production') {
                if (map[key] != null) {
                    console.error("Duplicate key " + key);
                }
            }
            map[key] = i;
        }
    }
    return map;
}
function sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
        var elm = (vnode.elm = createElement(tag));
        updateAttrs(emptyNode, vnode);
        if (isArray$1(children)) {
            for (i = 0; i < children.length; ++i) {
                var ch = children[i];
                if (ch != null) {
                    appendChild(elm, createElm(ch));
                }
            }
        }
        else if (isDef(vnode.text) && !isObject$2(vnode.text)) {
            appendChild(elm, createTextNode(vnode.text));
        }
    }
    else {
        vnode.elm = createTextNode(vnode.text);
    }
    return vnode.elm;
}
function addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (ch != null) {
            insertBefore(parentElm, createElm(ch), before);
        }
    }
}
function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
        var ch = vnodes[startIdx];
        if (ch != null) {
            if (isDef(ch.tag)) {
                var parent_1 = parentNode(ch.elm);
                removeChild(parent_1, ch.elm);
            }
            else {
                removeChild(parentElm, ch.elm);
            }
        }
    }
}
function updateAttrs(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) {
        return;
    }
    for (key in attrs) {
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) {
                elm.setAttribute(key, '');
            }
            else if (cur === false) {
                elm.removeAttribute(key);
            }
            else {
                if (key.charCodeAt(0) !== xChar) {
                    elm.setAttribute(key, cur);
                }
                else if (key === 'xmlns:xlink' || key === 'xmlns') {
                    elm.setAttributeNS(XMLNS, key, cur);
                }
                else if (key.charCodeAt(3) === colonChar) {
                    elm.setAttributeNS(XML_NAMESPACE, key, cur);
                }
                else if (key.charCodeAt(5) === colonChar) {
                    elm.setAttributeNS(XLINKNS, key, cur);
                }
                else {
                    elm.setAttribute(key, cur);
                }
            }
        }
    }
    for (key in oldAttrs) {
        if (!(key in attrs)) {
            elm.removeAttribute(key);
        }
    }
}
function updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
        if (oldStartVnode == null) {
            oldStartVnode = oldCh[++oldStartIdx];
        }
        else if (oldEndVnode == null) {
            oldEndVnode = oldCh[--oldEndIdx];
        }
        else if (newStartVnode == null) {
            newStartVnode = newCh[++newStartIdx];
        }
        else if (newEndVnode == null) {
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartVnode, newStartVnode)) {
            patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else if (sameVnode(oldEndVnode, newEndVnode)) {
            patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldStartVnode, newEndVnode)) {
            patchVnode(oldStartVnode, newEndVnode);
            insertBefore(parentElm, oldStartVnode.elm, nextSibling(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        }
        else if (sameVnode(oldEndVnode, newStartVnode)) {
            patchVnode(oldEndVnode, newStartVnode);
            insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        }
        else {
            if (isUndef(oldKeyToIdx)) {
                oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            }
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if (isUndef(idxInOld)) {
                insertBefore(parentElm, createElm(newStartVnode), oldStartVnode.elm);
            }
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) {
                    insertBefore(parentElm, createElm(newStartVnode), oldStartVnode.elm);
                }
                else {
                    patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        }
        else {
            removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
        }
    }
}
function patchVnode(oldVnode, vnode) {
    var elm = (vnode.elm = oldVnode.elm);
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) {
        return;
    }
    updateAttrs(oldVnode, vnode);
    if (isUndef(vnode.text)) {
        if (isDef(oldCh) && isDef(ch)) {
            if (oldCh !== ch) {
                updateChildren(elm, oldCh, ch);
            }
        }
        else if (isDef(ch)) {
            if (isDef(oldVnode.text)) {
                setTextContent(elm, '');
            }
            addVnodes(elm, null, ch, 0, ch.length - 1);
        }
        else if (isDef(oldCh)) {
            removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        }
        else if (isDef(oldVnode.text)) {
            setTextContent(elm, '');
        }
    }
    else if (oldVnode.text !== vnode.text) {
        if (isDef(oldCh)) {
            removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        }
        setTextContent(elm, vnode.text);
    }
}
function patch(oldVnode, vnode) {
    if (sameVnode(oldVnode, vnode)) {
        patchVnode(oldVnode, vnode);
    }
    else {
        var elm = oldVnode.elm;
        var parent_2 = parentNode(elm);
        createElm(vnode);
        if (parent_2 !== null) {
            insertBefore(parent_2, vnode.elm, nextSibling(elm));
            removeVnodes(parent_2, [oldVnode], 0, 0);
        }
    }
    return vnode;
}

var svgId = 0;
var SVGPainter = (function () {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = createMethodNotSupport('refreshHover');
        this.configLayer = createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = extend({}, opts);
        this.root = root;
        this._id = 'zr' + svgId++;
        this._oldVNode = createSVGVNode(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = createElement('svg');
            updateAttrs(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function () {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function () {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function () {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) {
            return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        }
    };
    SVGPainter.prototype.getSvgDom = function () {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function () {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            patch(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function (el) {
        return brush$1(el, createBrushScope(this._id));
    };
    SVGPainter.prototype.renderToVNode = function (opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = createBrushScope(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        var children = [];
        var bgVNode = this._bgVNode = createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress
            ? (this._mainVNode = createVNode('g', 'main', {}, [])) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = map(keys$2(scope.defs), function (id) { return scope.defs[id]; });
        if (defs.length) {
            children.push(createVNode('defs', 'defs', {}, defs));
        }
        if (opts.animation) {
            var animationCssStr = getCssString(scope.cssNodes, scope.cssAnims, { newline: true });
            if (animationCssStr) {
                var styleNode = createVNode('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return createSVGVNode(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function (opts) {
        opts = opts || {};
        return vNodeToString(this.renderToVNode({
            animation: retrieve2(opts.cssAnimation, true),
            willUpdate: false,
            compress: true,
            useViewBox: retrieve2(opts.useViewBox, true)
        }), { newline: true });
    };
    SVGPainter.prototype.setBackgroundColor = function (backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function () {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function (list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for (var i = 0; i < listLen; i++) {
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for (lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--) {
                    if (clipPaths && prevClipPaths
                        && clipPaths[lca] === prevClipPaths[lca]) {
                        break;
                    }
                }
                for (var i_1 = prevLen - 1; i_1 > lca; i_1--) {
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for (var i_2 = lca + 1; i_2 < len; i_2++) {
                    var groupAttrs = {};
                    setClipPath(clipPaths[i_2], groupAttrs, scope);
                    var g = createVNode('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = brush$1(displayable, scope);
                if (ret) {
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
                }
            }
        }
    };
    SVGPainter.prototype.resize = function (width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = getSize$2(root, 0, opts);
            height = getSize$2(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!isPattern(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            }
            else {
                this.refresh();
            }
        }
    };
    SVGPainter.prototype.getWidth = function () {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function () {
        return this._height;
    };
    SVGPainter.prototype.dispose = function () {
        if (this.root) {
            this.root.innerHTML = '';
        }
        this._svgDom =
            this._viewport =
                this.storage =
                    this._oldVNode =
                        this._bgVNode =
                            this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function () {
        if (this._svgDom) {
            this._svgDom.innerHTML = null;
        }
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function (base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = encodeBase64(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}());
function createMethodNotSupport(method) {
    return function () {
        if (process.env.NODE_ENV !== 'production') {
            logError('In SVG mode painter not support method "' + method + '"');
        }
    };
}
function createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = createVNode('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0',
            id: '0'
        });
        if (isGradient(backgroundColor)) {
            setGradient({ fill: backgroundColor }, bgVNode.attrs, 'fill', scope);
        }
        else if (isPattern(backgroundColor)) {
            setPattern({
                style: {
                    fill: backgroundColor
                },
                dirty: noop$2,
                getBoundingRect: function () { return ({ width: width, height: height }); }
            }, bgVNode.attrs, 'fill', scope);
        }
        else {
            var _a = normalizeColor(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}

function install(registers) {
  registers.registerPainter('svg', SVGPainter);
}

function createDom(id, painter, dpr) {
    var newDom = platformApi.createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var Layer = (function (_super) {
    __extends$1(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || devicePixelRatio;
        if (typeof id === 'string') {
            dom = createDom(id, painter, dpr);
        }
        else if (isObject$2(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            disableUserSelect(dom);
            dom.onselectstart = function () { return false; };
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function () {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function () {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function () {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function () {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function () {
        var dpr = this.dpr;
        this.domBack = createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) {
            this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.createRepaintRects = function (displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new BoundingRect(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) {
                return;
            }
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new BoundingRect(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            }
            else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for (var i = 0; i < mergedRepaintRects.length; ++i) {
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new BoundingRect(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    }
                    else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new BoundingRect(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) {
                    full = mergedRepaintRects.length >= maxRepaintRectCount;
                }
            }
        }
        for (var i = this.__startIndex; i < this.__endIndex; ++i) {
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && ((el.__dirty & REDRAW_BIT) || !shouldPaint)
                    ? el.getPrevPaintRect()
                    : null;
                if (prevRect) {
                    addRectToMergePool(prevRect);
                }
                var curRect = shouldPaint && ((el.__dirty & REDRAW_BIT) || !el.__isRendered)
                    ? el.getPaintRect()
                    : null;
                if (curRect) {
                    addRectToMergePool(curRect);
                }
            }
        }
        for (var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i) {
            var el = prevList[i];
            var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) {
                    addRectToMergePool(prevRect);
                }
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for (var i = 0; i < mergedRepaintRects.length;) {
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for (var j = i + 1; j < mergedRepaintRects.length;) {
                    if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                        hasIntersections = true;
                        mergedRepaintRects[i].union(mergedRepaintRects[j]);
                        mergedRepaintRects.splice(j, 1);
                    }
                    else {
                        j++;
                    }
                }
                i++;
            }
        } while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function () {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function (width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) {
                this.ctxBack.scale(dpr, dpr);
            }
        }
    };
    Layer.prototype.clear = function (clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) {
                this.createBackBuffer();
            }
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if (isGradientObject(clearColor)) {
                    var shouldCache = clearColor.global || (clearColor.__width === width
                        && clearColor.__height === height);
                    clearColorGradientOrPattern = shouldCache
                        && clearColor.__canvasGradient
                        || getCanvasGradient(ctx, clearColor, {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                }
                else if (isImagePatternObject(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = createCanvasPattern(ctx, clearColor, {
                        dirty: function () {
                            self.setUnpainted();
                            self.__painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) {
            doClear(0, 0, width, height);
        }
        else if (repaintRects.length) {
            each(repaintRects, function (rect) {
                doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
            });
        }
    };
    return Layer;
}(Eventful));

var HOVER_LAYER_ZLEVEL = 1e5;
var CANVAS_ZLEVEL = 314159;
var EL_AFTER_INCREMENTAL_INC = 0.01;
var INCREMENTAL_INC = 0.001;
function isLayerValid(layer) {
    if (!layer) {
        return false;
    }
    if (layer.__builtin__) {
        return true;
    }
    if (typeof (layer.resize) !== 'function'
        || typeof (layer.refresh) !== 'function') {
        return false;
    }
    return true;
}
function createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var CanvasPainter = (function () {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName
            || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = extend({}, opts || {});
        this.dpr = opts.devicePixelRatio || devicePixelRatio;
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            disableUserSelect(root);
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = getSize$2(root, 0, opts);
            this._height = getSize$2(root, 1, opts);
            var domRoot = this._domRoot = createRoot(this._width, this._height);
            root.appendChild(domRoot);
        }
        else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) {
                width = opts.width;
            }
            if (opts.height != null) {
                height = opts.height;
            }
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new Layer(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = CANVAS_ZLEVEL;
            zlevelList.push(CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function () {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function () {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function () {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function () {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) {
            return {
                offsetLeft: viewportRoot.offsetLeft || 0,
                offsetTop: viewportRoot.offsetTop || 0
            };
        }
    };
    CanvasPainter.prototype.refresh = function (paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) {
            this._prevDisplayList = list.slice();
        }
        return this;
    };
    CanvasPainter.prototype.refreshHover = function () {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function (list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) {
            return;
        }
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for (var i = 0; i < len; i++) {
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) {
                    hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
                }
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                brush(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) {
            ctx.restore();
        }
    };
    CanvasPainter.prototype.getHoverLayer = function () {
        return this.getLayer(HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function (ctx, el) {
        brushSingle(ctx, el);
    };
    CanvasPainter.prototype._paintList = function (list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) {
            return;
        }
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) {
            this._compositeManually();
        }
        if (needsRefreshHover) {
            this._paintHoverList(list);
        }
        if (!finished) {
            var self_1 = this;
            requestAnimationFrame$2(function () {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        }
        else {
            this.eachLayer(function (layer) {
                layer.afterBrush && layer.afterBrush();
            });
        }
    };
    CanvasPainter.prototype._compositeManually = function () {
        var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function (layer) {
            if (layer.virtual) {
                ctx.drawImage(layer.dom, 0, 0, width, height);
            }
        });
    };
    CanvasPainter.prototype._doPaintList = function (list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for (var zi = 0; zi < this._zlevelList.length; zi++) {
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__
                && layer !== this._hoverlayer
                && (layer.__dirty || paintAll)) {
                layerList.push(layer);
            }
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function (k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect
                && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0]
                ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) {
                layer.clear(false, clearColor, repaintRects);
            }
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) {
                    layer.clear(false, clearColor, repaintRects);
                }
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function (repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for (i = start; i < layer.__endIndex; i++) {
                    var el = list[i];
                    if (el.__inHover) {
                        needsRefreshHover = true;
                    }
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) {
                            break;
                        }
                    }
                }
                if (scope.prevElClipPaths) {
                    ctx.restore();
                }
            };
            if (repaintRects) {
                if (repaintRects.length === 0) {
                    i = layer.__endIndex;
                }
                else {
                    var dpr = this_1.dpr;
                    for (var r = 0; r < repaintRects.length; ++r) {
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            }
            else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) {
                finished = false;
            }
        };
        var this_1 = this;
        for (var k = 0; k < layerList.length; k++) {
            _loop_1(k);
        }
        if (env.wxa) {
            each(this._layers, function (layer) {
                if (layer && layer.ctx && layer.ctx.draw) {
                    layer.ctx.draw();
                }
            });
        }
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function (el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                brush(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        }
        else {
            brush(ctx, el, scope, isLast);
        }
    };
    CanvasPainter.prototype.getLayer = function (zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) {
            zlevel = CANVAS_ZLEVEL;
        }
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new Layer('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) {
                merge$1(layer, this._layerConfig[zlevel], true);
            }
            else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
                merge$1(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
            }
            if (virtual) {
                layer.virtual = virtual;
            }
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function (zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) {
            if (process.env.NODE_ENV !== 'production') {
                logError('ZLevel ' + zlevel + ' has been used already');
            }
            return;
        }
        if (!isLayerValid(layer)) {
            if (process.env.NODE_ENV !== 'production') {
                logError('Layer of zlevel ' + zlevel + ' is not valid');
            }
            return;
        }
        if (len > 0 && zlevel > zlevelList[0]) {
            for (i = 0; i < len - 1; i++) {
                if (zlevelList[i] < zlevel
                    && zlevelList[i + 1] > zlevel) {
                    break;
                }
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) {
                    domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                }
                else {
                    domRoot.appendChild(layer.dom);
                }
            }
            else {
                if (domRoot.firstChild) {
                    domRoot.insertBefore(layer.dom, domRoot.firstChild);
                }
                else {
                    domRoot.appendChild(layer.dom);
                }
            }
        }
        layer.__painter = this;
    };
    CanvasPainter.prototype.eachLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) {
                cb.call(context, layer, z);
            }
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function (cb, context) {
        var zlevelList = this._zlevelList;
        for (var i = 0; i < zlevelList.length; i++) {
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) {
                cb.call(context, layer, z);
            }
        }
    };
    CanvasPainter.prototype.getLayers = function () {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function (list) {
        this.eachBuiltinLayer(function (layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) {
                    prevLayer.__dirty = true;
                }
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) {
            for (var i_1 = 1; i_1 < list.length; i_1++) {
                var el = list[i_1];
                if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                    this._needsManuallyCompositing = true;
                    break;
                }
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for (i = 0; i < list.length; i++) {
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            }
            else {
                layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            }
            if (!layer.__builtin__) {
                logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            }
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) {
                    layer.__dirty = true;
                }
                layer.__startIndex = i;
                if (!layer.incremental) {
                    layer.__drawIndex = i;
                }
                else {
                    layer.__drawIndex = -1;
                }
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if ((el.__dirty & REDRAW_BIT) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) {
                    layer.__drawIndex = i;
                }
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function (layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) {
                layer.__drawIndex = layer.__startIndex;
            }
        });
    };
    CanvasPainter.prototype.clear = function () {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function (layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function (backgroundColor) {
        this._backgroundColor = backgroundColor;
        each(this._layers, function (layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function (zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) {
                layerConfig[zlevel] = config;
            }
            else {
                merge$1(layerConfig[zlevel], config, true);
            }
            for (var i = 0; i < this._zlevelList.length; i++) {
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    merge$1(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function (zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) {
            return;
        }
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice(indexOf(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function (width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) {
                return;
            }
            this._width = width;
            this._height = height;
            this.getLayer(CANVAS_ZLEVEL).resize(width, height);
        }
        else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = getSize$2(root, 0, opts);
            height = getSize$2(root, 1, opts);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for (var id in this._layers) {
                    if (this._layers.hasOwnProperty(id)) {
                        this._layers[id].resize(width, height);
                    }
                }
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function (zlevel) {
        var layer = this._layers[zlevel];
        if (layer) {
            layer.clear();
        }
    };
    CanvasPainter.prototype.dispose = function () {
        this.root.innerHTML = '';
        this.root =
            this.storage =
                this._domRoot =
                    this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function (opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) {
            return this._layers[CANVAS_ZLEVEL].dom;
        }
        var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function (layer) {
                if (layer.__builtin__) {
                    ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                }
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        }
        else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for (var i = 0, len = displayList.length; i < len; i++) {
                var el = displayList[i];
                brush(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function () {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function () {
        return this._height;
    };
    return CanvasPainter;
}());

function install$1(registers) {
  registers.registerPainter('canvas', CanvasPainter);
}

var LineSeriesModel =
/** @class */
function (_super) {
  __extends$1(LineSeriesModel, _super);

  function LineSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LineSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  LineSeriesModel.prototype.getInitialData = function (option) {
    if (process.env.NODE_ENV !== 'production') {
      var coordSys = option.coordinateSystem;

      if (coordSys !== 'polar' && coordSys !== 'cartesian2d') {
        throw new Error('Line not support coordinateSystem besides cartesian and polar');
      }
    }

    return createSeriesData(null, this, {
      useEncodeDefaulter: true
    });
  };

  LineSeriesModel.prototype.getLegendIcon = function (opt) {
    var group = new Group$1();
    var line = createSymbol('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
    group.add(line);
    line.setStyle(opt.lineStyle);
    var visualType = this.getData().getVisual('symbol');
    var visualRotate = this.getData().getVisual('symbolRotate');
    var symbolType = visualType === 'none' ? 'circle' : visualType; // Symbol size is 80% when there is a line

    var size = opt.itemHeight * 0.8;
    var symbol = createSymbol(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
    group.add(symbol);
    symbol.setStyle(opt.itemStyle);
    var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
    symbol.rotation = symbolRotate * Math.PI / 180;
    symbol.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);

    if (symbolType.indexOf('empty') > -1) {
      symbol.style.stroke = symbol.style.fill;
      symbol.style.fill = '#fff';
      symbol.style.lineWidth = 2;
    }

    return group;
  };

  LineSeriesModel.type = 'series.line';
  LineSeriesModel.dependencies = ['grid', 'polar'];
  LineSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 3,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    clip: true,
    label: {
      position: 'top'
    },
    // itemStyle: {
    // },
    endLabel: {
      show: false,
      valueAnimation: true,
      distance: 8
    },
    lineStyle: {
      width: 2,
      type: 'solid'
    },
    emphasis: {
      scale: true
    },
    // areaStyle: {
    // origin of areaStyle. Valid values:
    // `'auto'/null/undefined`: from axisLine to data
    // `'start'`: from min to data
    // `'end'`: from data to max
    // origin: 'auto'
    // },
    // false, 'start', 'end', 'middle'
    step: false,
    // Disabled if step is true
    smooth: false,
    smoothMonotone: null,
    symbol: 'emptyCircle',
    symbolSize: 4,
    symbolRotate: null,
    showSymbol: true,
    // `false`: follow the label interval strategy.
    // `true`: show all symbols.
    // `'auto'`: If possible, show all symbols, otherwise
    //           follow the label interval strategy.
    showAllSymbol: 'auto',
    // Whether to connect break point.
    connectNulls: false,
    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
    sampling: 'none',
    animationEasing: 'linear',
    // Disable progressive
    progressive: 0,
    hoverLayerThreshold: Infinity,
    universalTransition: {
      divideShape: 'clone'
    },
    triggerLineEvent: false
  };
  return LineSeriesModel;
}(SeriesModel);

/**
 * @return label string. Not null/undefined
 */

function getDefaultLabel(data, dataIndex) {
  var labelDims = data.mapDimensionsAll('defaultedLabel');
  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)

  if (len === 1) {
    var rawVal = retrieveRawValue(data, dataIndex, labelDims[0]);
    return rawVal != null ? rawVal + '' : null;
  } else if (len) {
    var vals = [];

    for (var i = 0; i < labelDims.length; i++) {
      vals.push(retrieveRawValue(data, dataIndex, labelDims[i]));
    }

    return vals.join(' ');
  }
}
function getDefaultInterpolatedLabel(data, interpolatedValue) {
  var labelDims = data.mapDimensionsAll('defaultedLabel');

  if (!isArray$1(interpolatedValue)) {
    return interpolatedValue + '';
  }

  var vals = [];

  for (var i = 0; i < labelDims.length; i++) {
    var dimIndex = data.getDimensionIndex(labelDims[i]);

    if (dimIndex >= 0) {
      vals.push(interpolatedValue[dimIndex]);
    }
  }

  return vals.join(' ');
}

var Symbol$2 =
/** @class */
function (_super) {
  __extends$1(Symbol, _super);

  function Symbol(data, idx, seriesScope, opts) {
    var _this = _super.call(this) || this;

    _this.updateData(data, idx, seriesScope, opts);

    return _this;
  }

  Symbol.prototype._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
    // Remove paths created before
    this.removeAll(); // let symbolPath = createSymbol(
    //     symbolType, -0.5, -0.5, 1, 1, color
    // );
    // If width/height are set too small (e.g., set to 1) on ios10
    // and macOS Sierra, a circle stroke become a rect, no matter what
    // the scale is set. So we set width/height as 2. See #4150.

    var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, null, keepAspect);
    symbolPath.attr({
      z2: 100,
      culling: true,
      scaleX: symbolSize[0] / 2,
      scaleY: symbolSize[1] / 2
    }); // Rewrite drift method

    symbolPath.drift = driftSymbol;
    this._symbolType = symbolType;
    this.add(symbolPath);
  };
  /**
   * Stop animation
   * @param {boolean} toLastFrame
   */


  Symbol.prototype.stopSymbolAnimation = function (toLastFrame) {
    this.childAt(0).stopAnimation(null, toLastFrame);
  };

  Symbol.prototype.getSymbolType = function () {
    return this._symbolType;
  };
  /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */


  Symbol.prototype.getSymbolPath = function () {
    return this.childAt(0);
  };
  /**
   * Highlight symbol
   */


  Symbol.prototype.highlight = function () {
    enterEmphasis(this.childAt(0));
  };
  /**
   * Downplay symbol
   */


  Symbol.prototype.downplay = function () {
    leaveEmphasis(this.childAt(0));
  };
  /**
   * @param {number} zlevel
   * @param {number} z
   */


  Symbol.prototype.setZ = function (zlevel, z) {
    var symbolPath = this.childAt(0);
    symbolPath.zlevel = zlevel;
    symbolPath.z = z;
  };

  Symbol.prototype.setDraggable = function (draggable, hasCursorOption) {
    var symbolPath = this.childAt(0);
    symbolPath.draggable = draggable;
    symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
  };
  /**
   * Update symbol properties
   */


  Symbol.prototype.updateData = function (data, idx, seriesScope, opts) {
    this.silent = false;
    var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
    var seriesModel = data.hostModel;
    var symbolSize = Symbol.getSymbolSize(data, idx);
    var isInit = symbolType !== this._symbolType;
    var disableAnimation = opts && opts.disableAnimation;

    if (isInit) {
      var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');

      this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
    } else {
      var symbolPath = this.childAt(0);
      symbolPath.silent = false;
      var target = {
        scaleX: symbolSize[0] / 2,
        scaleY: symbolSize[1] / 2
      };
      disableAnimation ? symbolPath.attr(target) : updateProps(symbolPath, target, seriesModel, idx);
      saveOldStyle(symbolPath);
    }

    this._updateCommon(data, idx, symbolSize, seriesScope, opts);

    if (isInit) {
      var symbolPath = this.childAt(0);

      if (!disableAnimation) {
        var target = {
          scaleX: this._sizeX,
          scaleY: this._sizeY,
          style: {
            // Always fadeIn. Because it has fadeOut animation when symbol is removed..
            opacity: symbolPath.style.opacity
          }
        };
        symbolPath.scaleX = symbolPath.scaleY = 0;
        symbolPath.style.opacity = 0;
        initProps(symbolPath, target, seriesModel, idx);
      }
    }

    if (disableAnimation) {
      // Must stop leave transition manually if don't call initProps or updateProps.
      this.childAt(0).stopAnimation('leave');
    }
  };

  Symbol.prototype._updateCommon = function (data, idx, symbolSize, seriesScope, opts) {
    var symbolPath = this.childAt(0);
    var seriesModel = data.hostModel;
    var emphasisItemStyle;
    var blurItemStyle;
    var selectItemStyle;
    var focus;
    var blurScope;
    var emphasisDisabled;
    var labelStatesModels;
    var hoverScale;
    var cursorStyle;

    if (seriesScope) {
      emphasisItemStyle = seriesScope.emphasisItemStyle;
      blurItemStyle = seriesScope.blurItemStyle;
      selectItemStyle = seriesScope.selectItemStyle;
      focus = seriesScope.focus;
      blurScope = seriesScope.blurScope;
      labelStatesModels = seriesScope.labelStatesModels;
      hoverScale = seriesScope.hoverScale;
      cursorStyle = seriesScope.cursorStyle;
      emphasisDisabled = seriesScope.emphasisDisabled;
    }

    if (!seriesScope || data.hasItemOption) {
      var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
      selectItemStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
      blurItemStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
      emphasisDisabled = emphasisModel.get('disabled');
      labelStatesModels = getLabelStatesModels(itemModel);
      hoverScale = emphasisModel.getShallow('scale');
      cursorStyle = itemModel.getShallow('cursor');
    }

    var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
    symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
    var symbolOffset = normalizeSymbolOffset(data.getItemVisual(idx, 'symbolOffset'), symbolSize);

    if (symbolOffset) {
      symbolPath.x = symbolOffset[0];
      symbolPath.y = symbolOffset[1];
    }

    cursorStyle && symbolPath.attr('cursor', cursorStyle);
    var symbolStyle = data.getItemVisual(idx, 'style');
    var visualColor = symbolStyle.fill;

    if (symbolPath instanceof ZRImage) {
      var pathStyle = symbolPath.style;
      symbolPath.useStyle(extend({
        // TODO other properties like x, y ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, symbolStyle));
    } else {
      if (symbolPath.__isEmptyBrush) {
        // fill and stroke will be swapped if it's empty.
        // So we cloned a new style to avoid it affecting the original style in visual storage.
        // TODO Better implementation. No empty logic!
        symbolPath.useStyle(extend({}, symbolStyle));
      } else {
        symbolPath.useStyle(symbolStyle);
      } // Disable decal because symbol scale will been applied on the decal.


      symbolPath.style.decal = null;
      symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
      symbolPath.style.strokeNoScale = true;
    }

    var liftZ = data.getItemVisual(idx, 'liftZ');
    var z2Origin = this._z2;

    if (liftZ != null) {
      if (z2Origin == null) {
        this._z2 = symbolPath.z2;
        symbolPath.z2 += liftZ;
      }
    } else if (z2Origin != null) {
      symbolPath.z2 = z2Origin;
      this._z2 = null;
    }

    var useNameLabel = opts && opts.useNameLabel;
    setLabelStyle(symbolPath, labelStatesModels, {
      labelFetcher: seriesModel,
      labelDataIndex: idx,
      defaultText: getLabelDefaultText,
      inheritColor: visualColor,
      defaultOpacity: symbolStyle.opacity
    }); // Do not execute util needed.

    function getLabelDefaultText(idx) {
      return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
    }

    this._sizeX = symbolSize[0] / 2;
    this._sizeY = symbolSize[1] / 2;
    var emphasisState = symbolPath.ensureState('emphasis');
    emphasisState.style = emphasisItemStyle;
    symbolPath.ensureState('select').style = selectItemStyle;
    symbolPath.ensureState('blur').style = blurItemStyle; // null / undefined / true means to use default strategy.
    // 0 / false / negative number / NaN / Infinity means no scale.

    var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) // PENDING: restrict hoverScale > 1? It seems unreasonable to scale down
    : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1; // always set scale to allow resetting

    emphasisState.scaleX = this._sizeX * scaleRatio;
    emphasisState.scaleY = this._sizeY * scaleRatio;
    this.setSymbolScale(1);
    toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
  };

  Symbol.prototype.setSymbolScale = function (scale) {
    this.scaleX = this.scaleY = scale;
  };

  Symbol.prototype.fadeOut = function (cb, seriesModel, opt) {
    var symbolPath = this.childAt(0);
    var dataIndex = getECData(this).dataIndex;
    var animationOpt = opt && opt.animation; // Avoid mistaken hover when fading out

    this.silent = symbolPath.silent = true; // Not show text when animating

    if (opt && opt.fadeLabel) {
      var textContent = symbolPath.getTextContent();

      if (textContent) {
        removeElement(textContent, {
          style: {
            opacity: 0
          }
        }, seriesModel, {
          dataIndex: dataIndex,
          removeOpt: animationOpt,
          cb: function () {
            symbolPath.removeTextContent();
          }
        });
      }
    } else {
      symbolPath.removeTextContent();
    }

    removeElement(symbolPath, {
      style: {
        opacity: 0
      },
      scaleX: 0,
      scaleY: 0
    }, seriesModel, {
      dataIndex: dataIndex,
      cb: cb,
      removeOpt: animationOpt
    });
  };

  Symbol.getSymbolSize = function (data, idx) {
    return normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
  };

  return Symbol;
}(Group$1);

function driftSymbol(dx, dy) {
  this.parent.drift(dx, dy);
}

function symbolNeedsDraw(data, point, idx, opt) {
  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
  // the symbol element shape. We use the same clip shape here as
  // the line clip.
  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}

function normalizeUpdateOpt(opt) {
  if (opt != null && !isObject$2(opt)) {
    opt = {
      isIgnore: opt
    };
  }

  return opt || {};
}

function makeSeriesScope(data) {
  var seriesModel = data.hostModel;
  var emphasisModel = seriesModel.getModel('emphasis');
  return {
    emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
    blurItemStyle: seriesModel.getModel(['blur', 'itemStyle']).getItemStyle(),
    selectItemStyle: seriesModel.getModel(['select', 'itemStyle']).getItemStyle(),
    focus: emphasisModel.get('focus'),
    blurScope: emphasisModel.get('blurScope'),
    emphasisDisabled: emphasisModel.get('disabled'),
    hoverScale: emphasisModel.get('scale'),
    labelStatesModels: getLabelStatesModels(seriesModel),
    cursorStyle: seriesModel.get('cursor')
  };
}

var SymbolDraw =
/** @class */
function () {
  function SymbolDraw(SymbolCtor) {
    this.group = new Group$1();
    this._SymbolCtor = SymbolCtor || Symbol$2;
  }
  /**
   * Update symbols draw by new data
   */


  SymbolDraw.prototype.updateData = function (data, opt) {
    // Remove progressive els.
    this._progressiveEls = null;
    opt = normalizeUpdateOpt(opt);
    var group = this.group;
    var seriesModel = data.hostModel;
    var oldData = this._data;
    var SymbolCtor = this._SymbolCtor;
    var disableAnimation = opt.disableAnimation;
    var seriesScope = makeSeriesScope(data);
    var symbolUpdateOpt = {
      disableAnimation: disableAnimation
    };

    var getSymbolPoint = opt.getSymbolPoint || function (idx) {
      return data.getItemLayout(idx);
    }; // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.


    if (!oldData) {
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      var point = getSymbolPoint(newIdx);

      if (symbolNeedsDraw(data, point, newIdx, opt)) {
        var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
        symbolEl.setPosition(point);
        data.setItemGraphicEl(newIdx, symbolEl);
        group.add(symbolEl);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);
      var point = getSymbolPoint(newIdx);

      if (!symbolNeedsDraw(data, point, newIdx, opt)) {
        group.remove(symbolEl);
        return;
      }

      var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
      var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();

      if (!symbolEl // Create a new if symbol type changed.
      || oldSymbolType && oldSymbolType !== newSymbolType) {
        group.remove(symbolEl);
        symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
        symbolEl.setPosition(point);
      } else {
        symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
        var target = {
          x: point[0],
          y: point[1]
        };
        disableAnimation ? symbolEl.attr(target) : updateProps(symbolEl, target, seriesModel);
      } // Add back


      group.add(symbolEl);
      data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && el.fadeOut(function () {
        group.remove(el);
      }, seriesModel);
    }).execute();
    this._getSymbolPoint = getSymbolPoint;
    this._data = data;
  };

  SymbolDraw.prototype.updateLayout = function () {
    var _this = this;

    var data = this._data;

    if (data) {
      // Not use animation
      data.eachItemGraphicEl(function (el, idx) {
        var point = _this._getSymbolPoint(idx);

        el.setPosition(point);
        el.markRedraw();
      });
    }
  };

  SymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
    this._seriesScope = makeSeriesScope(data);
    this._data = null;
    this.group.removeAll();
  };
  /**
   * Update symbols draw by new data
   */

  SymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
    // Clear
    this._progressiveEls = [];
    opt = normalizeUpdateOpt(opt);

    function updateIncrementalAndHover(el) {
      if (!el.isGroup) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = taskParams.start; idx < taskParams.end; idx++) {
      var point = data.getItemLayout(idx);

      if (symbolNeedsDraw(data, point, idx, opt)) {
        var el = new this._SymbolCtor(data, idx, this._seriesScope);
        el.traverse(updateIncrementalAndHover);
        el.setPosition(point);
        this.group.add(el);
        data.setItemGraphicEl(idx, el);

        this._progressiveEls.push(el);
      }
    }
  };

  SymbolDraw.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  SymbolDraw.prototype.remove = function (enableAnimation) {
    var group = this.group;
    var data = this._data; // Incremental model do not have this._data.

    if (data && enableAnimation) {
      data.eachItemGraphicEl(function (el) {
        el.fadeOut(function () {
          group.remove(el);
        }, data.hostModel);
      });
    } else {
      group.removeAll();
    }
  };
  return SymbolDraw;
}();

function prepareDataCoordInfo(coordSys, data, valueOrigin) {
  var baseAxis = coordSys.getBaseAxis();
  var valueAxis = coordSys.getOtherAxis(baseAxis);
  var valueStart = getValueStart(valueAxis, valueOrigin);
  var baseAxisDim = baseAxis.dim;
  var valueAxisDim = valueAxis.dim;
  var valueDim = data.mapDimension(valueAxisDim);
  var baseDim = data.mapDimension(baseAxisDim);
  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
  var dims = map(coordSys.dimensions, function (coordDim) {
    return data.mapDimension(coordDim);
  });
  var stacked = false;
  var stackResultDim = data.getCalculationInfo('stackResultDimension');

  if (isDimensionStacked(data, dims[0]
  /* , dims[1] */
  )) {
    // jshint ignore:line
    stacked = true;
    dims[0] = stackResultDim;
  }

  if (isDimensionStacked(data, dims[1]
  /* , dims[0] */
  )) {
    // jshint ignore:line
    stacked = true;
    dims[1] = stackResultDim;
  }

  return {
    dataDimsForPoint: dims,
    valueStart: valueStart,
    valueAxisDim: valueAxisDim,
    baseAxisDim: baseAxisDim,
    stacked: !!stacked,
    valueDim: valueDim,
    baseDim: baseDim,
    baseDataOffset: baseDataOffset,
    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
  };
}

function getValueStart(valueAxis, valueOrigin) {
  var valueStart = 0;
  var extent = valueAxis.scale.getExtent();

  if (valueOrigin === 'start') {
    valueStart = extent[0];
  } else if (valueOrigin === 'end') {
    valueStart = extent[1];
  } // If origin is specified as a number, use it as
  // valueStart directly
  else if (isNumber$1(valueOrigin) && !isNaN(valueOrigin)) {
      valueStart = valueOrigin;
    } // auto
    else {
        // Both positive
        if (extent[0] > 0) {
          valueStart = extent[0];
        } // Both negative
        else if (extent[1] < 0) {
            valueStart = extent[1];
          } // If is one positive, and one negative, onZero shall be true

      }

  return valueStart;
}

function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
  var value = NaN;

  if (dataCoordInfo.stacked) {
    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
  }

  if (isNaN(value)) {
    value = dataCoordInfo.valueStart;
  }

  var baseDataOffset = dataCoordInfo.baseDataOffset;
  var stackedData = [];
  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
  stackedData[1 - baseDataOffset] = value;
  return coordSys.dataToPoint(stackedData);
}

function diffData(oldData, newData) {
  var diffResult = [];
  newData.diff(oldData).add(function (idx) {
    diffResult.push({
      cmd: '+',
      idx: idx
    });
  }).update(function (newIdx, oldIdx) {
    diffResult.push({
      cmd: '=',
      idx: oldIdx,
      idx1: newIdx
    });
  }).remove(function (idx) {
    diffResult.push({
      cmd: '-',
      idx: idx
    });
  }).execute();
  return diffResult;
}

function lineAnimationDiff(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
  var diff = diffData(oldData, newData); // let newIdList = newData.mapArray(newData.getId);
  // let oldIdList = oldData.mapArray(oldData.getId);
  // convertToIntId(newIdList, oldIdList);
  // // FIXME One data ?
  // diff = arrayDiff(oldIdList, newIdList);

  var currPoints = [];
  var nextPoints = []; // Points for stacking base line

  var currStackedPoints = [];
  var nextStackedPoints = [];
  var status = [];
  var sortedIndices = [];
  var rawIndices = [];
  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin); // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);

  var oldPoints = oldData.getLayout('points') || [];
  var newPoints = newData.getLayout('points') || [];

  for (var i = 0; i < diff.length; i++) {
    var diffItem = diff[i];
    var pointAdded = true;
    var oldIdx2 = void 0;
    var newIdx2 = void 0; // FIXME, animation is not so perfect when dataZoom window moves fast
    // Which is in case remvoing or add more than one data in the tail or head

    switch (diffItem.cmd) {
      case '=':
        oldIdx2 = diffItem.idx * 2;
        newIdx2 = diffItem.idx1 * 2;
        var currentX = oldPoints[oldIdx2];
        var currentY = oldPoints[oldIdx2 + 1];
        var nextX = newPoints[newIdx2];
        var nextY = newPoints[newIdx2 + 1]; // If previous data is NaN, use next point directly

        if (isNaN(currentX) || isNaN(currentY)) {
          currentX = nextX;
          currentY = nextY;
        }

        currPoints.push(currentX, currentY);
        nextPoints.push(nextX, nextY);
        currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
        nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
        rawIndices.push(newData.getRawIndex(diffItem.idx1));
        break;

      case '+':
        var newIdx = diffItem.idx;
        var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
        var oldPt = oldCoordSys.dataToPoint([newData.get(newDataDimsForPoint[0], newIdx), newData.get(newDataDimsForPoint[1], newIdx)]);
        newIdx2 = newIdx * 2;
        currPoints.push(oldPt[0], oldPt[1]);
        nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
        var stackedOnPoint = getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
        currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
        nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
        rawIndices.push(newData.getRawIndex(newIdx));
        break;

      case '-':
        pointAdded = false;
    } // Original indices


    if (pointAdded) {
      status.push(diffItem);
      sortedIndices.push(sortedIndices.length);
    }
  } // Diff result may be crossed if all items are changed
  // Sort by data index


  sortedIndices.sort(function (a, b) {
    return rawIndices[a] - rawIndices[b];
  });
  var len = currPoints.length;
  var sortedCurrPoints = createFloat32Array(len);
  var sortedNextPoints = createFloat32Array(len);
  var sortedCurrStackedPoints = createFloat32Array(len);
  var sortedNextStackedPoints = createFloat32Array(len);
  var sortedStatus = [];

  for (var i = 0; i < sortedIndices.length; i++) {
    var idx = sortedIndices[i];
    var i2 = i * 2;
    var idx2 = idx * 2;
    sortedCurrPoints[i2] = currPoints[idx2];
    sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
    sortedNextPoints[i2] = nextPoints[idx2];
    sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
    sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
    sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
    sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
    sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
    sortedStatus[i] = status[idx];
  }

  return {
    current: sortedCurrPoints,
    next: sortedNextPoints,
    stackedOnCurrent: sortedCurrStackedPoints,
    stackedOnNext: sortedNextStackedPoints,
    status: sortedStatus
  };
}

var mathMin$5 = Math.min;
var mathMax$5 = Math.max;

function isPointNull(x, y) {
  return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */


function drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
  var prevX;
  var prevY;
  var cpx0;
  var cpy0;
  var cpx1;
  var cpy1;
  var idx = start;
  var k = 0;

  for (; k < segLen; k++) {
    var x = points[idx * 2];
    var y = points[idx * 2 + 1];

    if (idx >= allLen || idx < 0) {
      break;
    }

    if (isPointNull(x, y)) {
      if (connectNulls) {
        idx += dir;
        continue;
      }

      break;
    }

    if (idx === start) {
      ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
      cpx0 = x;
      cpy0 = y;
    } else {
      var dx = x - prevX;
      var dy = y - prevY; // Ignore tiny segment.

      if (dx * dx + dy * dy < 0.5) {
        idx += dir;
        continue;
      }

      if (smooth > 0) {
        var nextIdx = idx + dir;
        var nextX = points[nextIdx * 2];
        var nextY = points[nextIdx * 2 + 1]; // Ignore duplicate point

        while (nextX === x && nextY === y && k < segLen) {
          k++;
          nextIdx += dir;
          idx += dir;
          nextX = points[nextIdx * 2];
          nextY = points[nextIdx * 2 + 1];
          x = points[idx * 2];
          y = points[idx * 2 + 1];
          dx = x - prevX;
          dy = y - prevY;
        }

        var tmpK = k + 1;

        if (connectNulls) {
          // Find next point not null
          while (isPointNull(nextX, nextY) && tmpK < segLen) {
            tmpK++;
            nextIdx += dir;
            nextX = points[nextIdx * 2];
            nextY = points[nextIdx * 2 + 1];
          }
        }

        var ratioNextSeg = 0.5;
        var vx = 0;
        var vy = 0;
        var nextCpx0 = void 0;
        var nextCpy0 = void 0; // Is last point

        if (tmpK >= segLen || isPointNull(nextX, nextY)) {
          cpx1 = x;
          cpy1 = y;
        } else {
          vx = nextX - prevX;
          vy = nextY - prevY;
          var dx0 = x - prevX;
          var dx1 = nextX - x;
          var dy0 = y - prevY;
          var dy1 = nextY - y;
          var lenPrevSeg = void 0;
          var lenNextSeg = void 0;

          if (smoothMonotone === 'x') {
            lenPrevSeg = Math.abs(dx0);
            lenNextSeg = Math.abs(dx1);
            var dir_1 = vx > 0 ? 1 : -1;
            cpx1 = x - dir_1 * lenPrevSeg * smooth;
            cpy1 = y;
            nextCpx0 = x + dir_1 * lenNextSeg * smooth;
            nextCpy0 = y;
          } else if (smoothMonotone === 'y') {
            lenPrevSeg = Math.abs(dy0);
            lenNextSeg = Math.abs(dy1);
            var dir_2 = vy > 0 ? 1 : -1;
            cpx1 = x;
            cpy1 = y - dir_2 * lenPrevSeg * smooth;
            nextCpx0 = x;
            nextCpy0 = y + dir_2 * lenNextSeg * smooth;
          } else {
            lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
            lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1); // Use ratio of seg length

            ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
            cpx1 = x - vx * smooth * (1 - ratioNextSeg);
            cpy1 = y - vy * smooth * (1 - ratioNextSeg); // cp0 of next segment

            nextCpx0 = x + vx * smooth * ratioNextSeg;
            nextCpy0 = y + vy * smooth * ratioNextSeg; // Smooth constraint between point and next point.
            // Avoid exceeding extreme after smoothing.

            nextCpx0 = mathMin$5(nextCpx0, mathMax$5(nextX, x));
            nextCpy0 = mathMin$5(nextCpy0, mathMax$5(nextY, y));
            nextCpx0 = mathMax$5(nextCpx0, mathMin$5(nextX, x));
            nextCpy0 = mathMax$5(nextCpy0, mathMin$5(nextY, y)); // Reclaculate cp1 based on the adjusted cp0 of next seg.

            vx = nextCpx0 - x;
            vy = nextCpy0 - y;
            cpx1 = x - vx * lenPrevSeg / lenNextSeg;
            cpy1 = y - vy * lenPrevSeg / lenNextSeg; // Smooth constraint between point and prev point.
            // Avoid exceeding extreme after smoothing.

            cpx1 = mathMin$5(cpx1, mathMax$5(prevX, x));
            cpy1 = mathMin$5(cpy1, mathMax$5(prevY, y));
            cpx1 = mathMax$5(cpx1, mathMin$5(prevX, x));
            cpy1 = mathMax$5(cpy1, mathMin$5(prevY, y)); // Adjust next cp0 again.

            vx = x - cpx1;
            vy = y - cpy1;
            nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
            nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
          }
        }

        ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
        cpx0 = nextCpx0;
        cpy0 = nextCpy0;
      } else {
        ctx.lineTo(x, y);
      }
    }

    prevX = x;
    prevY = y;
    idx += dir;
  }

  return k;
}

var ECPolylineShape =
/** @class */
function () {
  function ECPolylineShape() {
    this.smooth = 0;
    this.smoothConstraint = true;
  }

  return ECPolylineShape;
}();

var ECPolyline =
/** @class */
function (_super) {
  __extends$1(ECPolyline, _super);

  function ECPolyline(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-polyline';
    return _this;
  }

  ECPolyline.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  ECPolyline.prototype.getDefaultShape = function () {
    return new ECPolylineShape();
  };

  ECPolyline.prototype.buildPath = function (ctx, shape) {
    var points = shape.points;
    var i = 0;
    var len = points.length / 2; // const result = getBoundingBox(points, shape.smoothConstraint);

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
          break;
        }
      }
    }

    while (i < len) {
      i += drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    }
  };

  ECPolyline.prototype.getPointOn = function (xOrY, dim) {
    if (!this.path) {
      this.createPathProxy();
      this.buildPath(this.path, this.shape);
    }

    var path = this.path;
    var data = path.data;
    var CMD = PathProxy.CMD;
    var x0;
    var y0;
    var isDimX = dim === 'x';
    var roots = [];

    for (var i = 0; i < data.length;) {
      var cmd = data[i++];
      var x = void 0;
      var y = void 0;
      var x2 = void 0;
      var y2 = void 0;
      var x3 = void 0;
      var y3 = void 0;
      var t = void 0;

      switch (cmd) {
        case CMD.M:
          x0 = data[i++];
          y0 = data[i++];
          break;

        case CMD.L:
          x = data[i++];
          y = data[i++];
          t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);

          if (t <= 1 && t >= 0) {
            var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
            return isDimX ? [xOrY, val] : [val, xOrY];
          }

          x0 = x;
          y0 = y;
          break;

        case CMD.C:
          x = data[i++];
          y = data[i++];
          x2 = data[i++];
          y2 = data[i++];
          x3 = data[i++];
          y3 = data[i++];
          var nRoot = isDimX ? cubicRootAt(x0, x, x2, x3, xOrY, roots) : cubicRootAt(y0, y, y2, y3, xOrY, roots);

          if (nRoot > 0) {
            for (var i_1 = 0; i_1 < nRoot; i_1++) {
              var t_1 = roots[i_1];

              if (t_1 <= 1 && t_1 >= 0) {
                var val = isDimX ? cubicAt(y0, y, y2, y3, t_1) : cubicAt(x0, x, x2, x3, t_1);
                return isDimX ? [xOrY, val] : [val, xOrY];
              }
            }
          }

          x0 = x3;
          y0 = y3;
          break;
      }
    }
  };

  return ECPolyline;
}(Path);

var ECPolygonShape =
/** @class */
function (_super) {
  __extends$1(ECPolygonShape, _super);

  function ECPolygonShape() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ECPolygonShape;
}(ECPolylineShape);

var ECPolygon =
/** @class */
function (_super) {
  __extends$1(ECPolygon, _super);

  function ECPolygon(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-polygon';
    return _this;
  }

  ECPolygon.prototype.getDefaultShape = function () {
    return new ECPolygonShape();
  };

  ECPolygon.prototype.buildPath = function (ctx, shape) {
    var points = shape.points;
    var stackedOnPoints = shape.stackedOnPoints;
    var i = 0;
    var len = points.length / 2;
    var smoothMonotone = shape.smoothMonotone;

    if (shape.connectNulls) {
      // Must remove first and last null values avoid draw error in polygon
      for (; len > 0; len--) {
        if (!isPointNull(points[len * 2 - 2], points[len * 2 - 1])) {
          break;
        }
      }

      for (; i < len; i++) {
        if (!isPointNull(points[i * 2], points[i * 2 + 1])) {
          break;
        }
      }
    }

    while (i < len) {
      var k = drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
      i += k + 1;
      ctx.closePath();
    }
  };

  return ECPolygon;
}(Path);

function createGridClipPath(cartesian, hasAnimation, seriesModel, done, during) {
  var rect = cartesian.getArea();
  var x = rect.x;
  var y = rect.y;
  var width = rect.width;
  var height = rect.height;
  var lineWidth = seriesModel.get(['lineStyle', 'width']) || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner

  x -= lineWidth / 2;
  y -= lineWidth / 2;
  width += lineWidth;
  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369

  x = Math.floor(x);
  width = Math.round(width);
  var clipPath = new Rect({
    shape: {
      x: x,
      y: y,
      width: width,
      height: height
    }
  });

  if (hasAnimation) {
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isAxisInversed = baseAxis.inverse;

    if (isHorizontal) {
      if (isAxisInversed) {
        clipPath.shape.x += width;
      }

      clipPath.shape.width = 0;
    } else {
      if (!isAxisInversed) {
        clipPath.shape.y += height;
      }

      clipPath.shape.height = 0;
    }

    var duringCb = isFunction$3(during) ? function (percent) {
      during(percent, clipPath);
    } : null;
    initProps(clipPath, {
      shape: {
        width: width,
        height: height,
        x: x,
        y: y
      }
    }, seriesModel, null, done, duringCb);
  }

  return clipPath;
}

function createPolarClipPath(polar, hasAnimation, seriesModel) {
  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.

  var r0 = round$3(sectorArea.r0, 1);
  var r = round$3(sectorArea.r, 1);
  var clipPath = new Sector({
    shape: {
      cx: round$3(polar.cx, 1),
      cy: round$3(polar.cy, 1),
      r0: r0,
      r: r,
      startAngle: sectorArea.startAngle,
      endAngle: sectorArea.endAngle,
      clockwise: sectorArea.clockwise
    }
  });

  if (hasAnimation) {
    var isRadial = polar.getBaseAxis().dim === 'angle';

    if (isRadial) {
      clipPath.shape.endAngle = sectorArea.startAngle;
    } else {
      clipPath.shape.r = r0;
    }

    initProps(clipPath, {
      shape: {
        endAngle: sectorArea.endAngle,
        r: r
      }
    }, seriesModel);
  }

  return clipPath;
}

function createClipPath(coordSys, hasAnimation, seriesModel, done, during) {
  if (!coordSys) {
    return null;
  } else if (coordSys.type === 'polar') {
    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  } else if (coordSys.type === 'cartesian2d') {
    return createGridClipPath(coordSys, hasAnimation, seriesModel, done, during);
  }

  return null;
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function isCoordinateSystemType(coordSys, type) {
  return coordSys.type === type;
}

function isPointsSame(points1, points2) {
  if (points1.length !== points2.length) {
    return;
  }

  for (var i = 0; i < points1.length; i++) {
    if (points1[i] !== points2[i]) {
      return;
    }
  }

  return true;
}

function bboxFromPoints(points) {
  var minX = Infinity;
  var minY = Infinity;
  var maxX = -Infinity;
  var maxY = -Infinity;

  for (var i = 0; i < points.length;) {
    var x = points[i++];
    var y = points[i++];

    if (!isNaN(x)) {
      minX = Math.min(x, minX);
      maxX = Math.max(x, maxX);
    }

    if (!isNaN(y)) {
      minY = Math.min(y, minY);
      maxY = Math.max(y, maxY);
    }
  }

  return [[minX, minY], [maxX, maxY]];
}

function getBoundingDiff(points1, points2) {
  var _a = bboxFromPoints(points1),
      min1 = _a[0],
      max1 = _a[1];

  var _b = bboxFromPoints(points2),
      min2 = _b[0],
      max2 = _b[1]; // Get a max value from each corner of two boundings.


  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}

function getSmooth(smooth) {
  return isNumber$1(smooth) ? smooth : smooth ? 0.5 : 0;
}

function getStackedOnPoints(coordSys, data, dataCoordInfo) {
  if (!dataCoordInfo.valueDim) {
    return [];
  }

  var len = data.count();
  var points = createFloat32Array(len * 2);

  for (var idx = 0; idx < len; idx++) {
    var pt = getStackedOnPoint(dataCoordInfo, coordSys, data, idx);
    points[idx * 2] = pt[0];
    points[idx * 2 + 1] = pt[1];
  }

  return points;
}

function turnPointsIntoStep(points, coordSys, stepTurnAt, connectNulls) {
  var baseAxis = coordSys.getBaseAxis();
  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
  var stepPoints = [];
  var i = 0;
  var stepPt = [];
  var pt = [];
  var nextPt = [];
  var filteredPoints = [];

  if (connectNulls) {
    for (i = 0; i < points.length; i += 2) {
      if (!isNaN(points[i]) && !isNaN(points[i + 1])) {
        filteredPoints.push(points[i], points[i + 1]);
      }
    }

    points = filteredPoints;
  }

  for (i = 0; i < points.length - 2; i += 2) {
    nextPt[0] = points[i + 2];
    nextPt[1] = points[i + 3];
    pt[0] = points[i];
    pt[1] = points[i + 1];
    stepPoints.push(pt[0], pt[1]);

    switch (stepTurnAt) {
      case 'end':
        stepPt[baseIndex] = nextPt[baseIndex];
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
        break;

      case 'middle':
        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
        var stepPt2 = [];
        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
        stepPt[1 - baseIndex] = pt[1 - baseIndex];
        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
        stepPoints.push(stepPt2[0], stepPt2[1]);
        break;

      default:
        // default is start
        stepPt[baseIndex] = pt[baseIndex];
        stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
        stepPoints.push(stepPt[0], stepPt[1]);
    }
  } // Last points


  stepPoints.push(points[i++], points[i++]);
  return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */


function clipColorStops(colorStops, maxSize) {
  var newColorStops = [];
  var len = colorStops.length; // coord will always < 0 in prevOutOfRangeColorStop.

  var prevOutOfRangeColorStop;
  var prevInRangeColorStop;

  function lerpStop(stop0, stop1, clippedCoord) {
    var coord0 = stop0.coord;
    var p = (clippedCoord - coord0) / (stop1.coord - coord0);
    var color = lerp$1(p, [stop0.color, stop1.color]);
    return {
      coord: clippedCoord,
      color: color
    };
  }

  for (var i = 0; i < len; i++) {
    var stop_1 = colorStops[i];
    var coord = stop_1.coord;

    if (coord < 0) {
      prevOutOfRangeColorStop = stop_1;
    } else if (coord > maxSize) {
      if (prevInRangeColorStop) {
        newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
      } else if (prevOutOfRangeColorStop) {
        // If there are two stops and coord range is between these two stops
        newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
      } // All following stop will be out of range. So just ignore them.


      break;
    } else {
      if (prevOutOfRangeColorStop) {
        newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0)); // Reset

        prevOutOfRangeColorStop = null;
      }

      newColorStops.push(stop_1);
      prevInRangeColorStop = stop_1;
    }
  }

  return newColorStops;
}

function getVisualGradient(data, coordSys, api) {
  var visualMetaList = data.getVisual('visualMeta');

  if (!visualMetaList || !visualMetaList.length || !data.count()) {
    // When data.count() is 0, gradient range can not be calculated.
    return;
  }

  if (coordSys.type !== 'cartesian2d') {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Visual map on line style is only supported on cartesian2d.');
    }

    return;
  }

  var coordDim;
  var visualMeta;

  for (var i = visualMetaList.length - 1; i >= 0; i--) {
    var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y

    if (coordDim === 'x' || coordDim === 'y') {
      visualMeta = visualMetaList[i];
      break;
    }
  }

  if (!visualMeta) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Visual map on line style only support x or y dimension.');
    }

    return;
  } // If the area to be rendered is bigger than area defined by LinearGradient,
  // the canvas spec prescribes that the color of the first stop and the last
  // stop should be used. But if two stops are added at offset 0, in effect
  // browsers use the color of the second stop to render area outside
  // LinearGradient. So we can only infinitesimally extend area defined in
  // LinearGradient to render `outerColors`.


  var axis = coordSys.getAxis(coordDim); // dataToCoord mapping may not be linear, but must be monotonic.

  var colorStops = map(visualMeta.stops, function (stop) {
    // offset will be calculated later.
    return {
      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
      color: stop.color
    };
  });
  var stopLen = colorStops.length;
  var outerColors = visualMeta.outerColors.slice();

  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
    colorStops.reverse();
    outerColors.reverse();
  }

  var colorStopsInRange = clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
  var inRangeStopLen = colorStopsInRange.length;

  if (!inRangeStopLen && stopLen) {
    // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
  }

  var tinyExtent = 10; // Arbitrary value: 10px

  var minCoord = colorStopsInRange[0].coord - tinyExtent;
  var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
  var coordSpan = maxCoord - minCoord;

  if (coordSpan < 1e-3) {
    return 'transparent';
  }

  each(colorStopsInRange, function (stop) {
    stop.offset = (stop.coord - minCoord) / coordSpan;
  });
  colorStopsInRange.push({
    // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
    offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
    color: outerColors[1] || 'transparent'
  });
  colorStopsInRange.unshift({
    offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
    color: outerColors[0] || 'transparent'
  });
  var gradient = new LinearGradient(0, 0, 0, 0, colorStopsInRange, true);
  gradient[coordDim] = minCoord;
  gradient[coordDim + '2'] = maxCoord;
  return gradient;
}

function getIsIgnoreFunc(seriesModel, data, coordSys) {
  var showAllSymbol = seriesModel.get('showAllSymbol');
  var isAuto = showAllSymbol === 'auto';

  if (showAllSymbol && !isAuto) {
    return;
  }

  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

  if (!categoryAxis) {
    return;
  } // Note that category label interval strategy might bring some weird effect
  // in some scenario: users may wonder why some of the symbols are not
  // displayed. So we show all symbols as possible as we can.


  if (isAuto // Simplify the logic, do not determine label overlap here.
  && canShowAllSymbolForCategory(categoryAxis, data)) {
    return;
  } // Otherwise follow the label interval strategy on category axis.


  var categoryDataDim = data.mapDimension(categoryAxis.dim);
  var labelMap = {};
  each(categoryAxis.getViewLabels(), function (labelItem) {
    var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
    labelMap[ordinalNumber] = 1;
  });
  return function (dataIndex) {
    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
  };
}

function canShowAllSymbolForCategory(categoryAxis, data) {
  // In most cases, line is monotonous on category axis, and the label size
  // is close with each other. So we check the symbol size and some of the
  // label size alone with the category axis to estimate whether all symbol
  // can be shown without overlap.
  var axisExtent = categoryAxis.getExtent();
  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
  // Sampling some points, max 5.

  var dataLen = data.count();
  var step = Math.max(1, Math.round(dataLen / 5));

  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
    if (Symbol$2.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
    * 1.5 > availSize) {
      return false;
    }
  }

  return true;
}

function isPointNull$1(x, y) {
  return isNaN(x) || isNaN(y);
}

function getLastIndexNotNull(points) {
  var len = points.length / 2;

  for (; len > 0; len--) {
    if (!isPointNull$1(points[len * 2 - 2], points[len * 2 - 1])) {
      break;
    }
  }

  return len - 1;
}

function getPointAtIndex(points, idx) {
  return [points[idx * 2], points[idx * 2 + 1]];
}

function getIndexRange(points, xOrY, dim) {
  var len = points.length / 2;
  var dimIdx = dim === 'x' ? 0 : 1;
  var a;
  var b;
  var prevIndex = 0;
  var nextIndex = -1;

  for (var i = 0; i < len; i++) {
    b = points[i * 2 + dimIdx];

    if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) {
      continue;
    }

    if (i === 0) {
      a = b;
      continue;
    }

    if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
      nextIndex = i;
      break;
    }

    prevIndex = i;
    a = b;
  }

  return {
    range: [prevIndex, nextIndex],
    t: (xOrY - a) / (b - a)
  };
}

function anyStateShowEndLabel(seriesModel) {
  if (seriesModel.get(['endLabel', 'show'])) {
    return true;
  }

  for (var i = 0; i < SPECIAL_STATES.length; i++) {
    if (seriesModel.get([SPECIAL_STATES[i], 'endLabel', 'show'])) {
      return true;
    }
  }

  return false;
}

function createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
  if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
    var endLabelModel_1 = seriesModel.getModel('endLabel');
    var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
    var data_1 = seriesModel.getData();
    var labelAnimationRecord_1 = {
      lastFrameIndex: 0
    };
    var during = anyStateShowEndLabel(seriesModel) ? function (percent, clipRect) {
      lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
    } : null;
    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel, function () {
      var endLabel = lineView._endLabel;

      if (endLabel && hasAnimation) {
        if (labelAnimationRecord_1.originalX != null) {
          endLabel.attr({
            x: labelAnimationRecord_1.originalX,
            y: labelAnimationRecord_1.originalY
          });
        }
      }
    }, during); // Expand clip shape to avoid clipping when line value exceeds axis

    if (!seriesModel.get('clip', true)) {
      var rectShape = clipPath.shape;
      var expandSize = Math.max(rectShape.width, rectShape.height);

      if (isHorizontal) {
        rectShape.y -= expandSize;
        rectShape.height += expandSize * 2;
      } else {
        rectShape.x -= expandSize;
        rectShape.width += expandSize * 2;
      }
    } // Set to the final frame. To make sure label layout is right.


    if (during) {
      during(1, clipPath);
    }

    return clipPath;
  } else {
    if (process.env.NODE_ENV !== 'production') {
      if (seriesModel.get(['endLabel', 'show'])) {
        console.warn('endLabel is not supported for lines in polar systems.');
      }
    }

    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
  }
}

function getEndLabelStateSpecified(endLabelModel, coordSys) {
  var baseAxis = coordSys.getBaseAxis();
  var isHorizontal = baseAxis.isHorizontal();
  var isBaseInversed = baseAxis.inverse;
  var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
  var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
  return {
    normal: {
      align: endLabelModel.get('align') || align,
      verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
    }
  };
}

var LineView =
/** @class */
function (_super) {
  __extends$1(LineView, _super);

  function LineView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LineView.prototype.init = function () {
    var lineGroup = new Group$1();
    var symbolDraw = new SymbolDraw();
    this.group.add(symbolDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineGroup = lineGroup;
  };

  LineView.prototype.render = function (seriesModel, ecModel, api) {
    var _this = this;

    var coordSys = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var lineStyleModel = seriesModel.getModel('lineStyle');
    var areaStyleModel = seriesModel.getModel('areaStyle');
    var points = data.getLayout('points') || [];
    var isCoordSysPolar = coordSys.type === 'polar';
    var prevCoordSys = this._coordSys;
    var symbolDraw = this._symbolDraw;
    var polyline = this._polyline;
    var polygon = this._polygon;
    var lineGroup = this._lineGroup;
    var hasAnimation = seriesModel.get('animation');
    var isAreaChart = !areaStyleModel.isEmpty();
    var valueOrigin = areaStyleModel.get('origin');
    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
    var stackedOnPoints = isAreaChart && getStackedOnPoints(coordSys, data, dataCoordInfo);
    var showSymbol = seriesModel.get('showSymbol');
    var connectNulls = seriesModel.get('connectNulls');
    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols

    var oldData = this._data;
    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    }); // Remove previous created symbols if showSymbol changed to false

    if (!showSymbol) {
      symbolDraw.remove();
    }

    group.add(lineGroup); // FIXME step not support polar

    var step = !isCoordSysPolar ? seriesModel.get('step') : false;
    var clipShapeForSymbol;

    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
      // See #7913 and `test/dataZoom-clip.html`.

      if (clipShapeForSymbol.width != null) {
        clipShapeForSymbol.x -= 0.1;
        clipShapeForSymbol.y -= 0.1;
        clipShapeForSymbol.width += 0.2;
        clipShapeForSymbol.height += 0.2;
      } else if (clipShapeForSymbol.r0) {
        clipShapeForSymbol.r0 -= 0.5;
        clipShapeForSymbol.r += 0.5;
      }
    }

    this._clipShapeForSymbol = clipShapeForSymbol;
    var visualColor = getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')]; // Initialization animation or coordinate system changed

    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol,
        disableAnimation: true,
        getSymbolPoint: function (idx) {
          return [points[idx * 2], points[idx * 2 + 1]];
        }
      });
      hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);

      if (step) {
        // TODO If stacked series is not step
        points = turnPointsIntoStep(points, coordSys, step, connectNulls);

        if (stackedOnPoints) {
          stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
        }
      }

      polyline = this._newPolyline(points);

      if (isAreaChart) {
        polygon = this._newPolygon(points, stackedOnPoints);
      } // If areaStyle is removed
      else if (polygon) {
          lineGroup.remove(polygon);
          polygon = this._polygon = null;
        } // NOTE: Must update _endLabel before setClipPath.


      if (!isCoordSysPolar) {
        this._initOrUpdateEndLabel(seriesModel, coordSys, convertToColorString(visualColor));
      }

      lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
    } else {
      if (isAreaChart && !polygon) {
        // If areaStyle is added
        polygon = this._newPolygon(points, stackedOnPoints);
      } else if (polygon && !isAreaChart) {
        // If areaStyle is removed
        lineGroup.remove(polygon);
        polygon = this._polygon = null;
      } // NOTE: Must update _endLabel before setClipPath.


      if (!isCoordSysPolar) {
        this._initOrUpdateEndLabel(seriesModel, coordSys, convertToColorString(visualColor));
      } // Update clipPath


      var oldClipPath = lineGroup.getClipPath();

      if (oldClipPath) {
        var newClipPath = createLineClipPath(this, coordSys, false, seriesModel);
        initProps(oldClipPath, {
          shape: newClipPath.shape
        }, seriesModel);
      } else {
        lineGroup.setClipPath(createLineClipPath(this, coordSys, true, seriesModel));
      } // Always update, or it is wrong in the case turning on legend
      // because points are not changed.


      showSymbol && symbolDraw.updateData(data, {
        isIgnore: isIgnoreFunc,
        clipShape: clipShapeForSymbol,
        disableAnimation: true,
        getSymbolPoint: function (idx) {
          return [points[idx * 2], points[idx * 2 + 1]];
        }
      }); // In the case data zoom triggered refreshing frequently
      // Data may not change if line has a category axis. So it should animate nothing.

      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
        if (hasAnimation) {
          this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
        } else {
          // Not do it in update with animation
          if (step) {
            // TODO If stacked series is not step
            points = turnPointsIntoStep(points, coordSys, step, connectNulls);

            if (stackedOnPoints) {
              stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
            }
          }

          polyline.setShape({
            points: points
          });
          polygon && polygon.setShape({
            points: points,
            stackedOnPoints: stackedOnPoints
          });
        }
      }
    }

    var emphasisModel = seriesModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var emphasisDisabled = emphasisModel.get('disabled');
    polyline.useStyle(defaults( // Use color in lineStyle first
    lineStyleModel.getLineStyle(), {
      fill: 'none',
      stroke: visualColor,
      lineJoin: 'bevel'
    }));
    setStatesStylesFromModel(polyline, seriesModel, 'lineStyle');

    if (polyline.style.lineWidth > 0 && seriesModel.get(['emphasis', 'lineStyle', 'width']) === 'bolder') {
      var emphasisLineStyle = polyline.getState('emphasis').style;
      emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
    } // Needs seriesIndex for focus


    getECData(polyline).seriesIndex = seriesModel.seriesIndex;
    toggleHoverEmphasis(polyline, focus, blurScope, emphasisDisabled);
    var smooth = getSmooth(seriesModel.get('smooth'));
    var smoothMonotone = seriesModel.get('smoothMonotone');
    polyline.setShape({
      smooth: smooth,
      smoothMonotone: smoothMonotone,
      connectNulls: connectNulls
    });

    if (polygon) {
      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
      var stackedOnSmooth = 0;
      polygon.useStyle(defaults(areaStyleModel.getAreaStyle(), {
        fill: visualColor,
        opacity: 0.7,
        lineJoin: 'bevel',
        decal: data.getVisual('style').decal
      }));

      if (stackedOnSeries) {
        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
      }

      polygon.setShape({
        smooth: smooth,
        stackedOnSmooth: stackedOnSmooth,
        smoothMonotone: smoothMonotone,
        connectNulls: connectNulls
      });
      setStatesStylesFromModel(polygon, seriesModel, 'areaStyle'); // Needs seriesIndex for focus

      getECData(polygon).seriesIndex = seriesModel.seriesIndex;
      toggleHoverEmphasis(polygon, focus, blurScope, emphasisDisabled);
    }

    var changePolyState = function (toState) {
      _this._changePolyState(toState);
    };

    data.eachItemGraphicEl(function (el) {
      // Switch polyline / polygon state if element changed its state.
      el && (el.onHoverStateChange = changePolyState);
    });
    this._polyline.onHoverStateChange = changePolyState;
    this._data = data; // Save the coordinate system for transition animation when data changed

    this._coordSys = coordSys;
    this._stackedOnPoints = stackedOnPoints;
    this._points = points;
    this._step = step;
    this._valueOrigin = valueOrigin;

    if (seriesModel.get('triggerLineEvent')) {
      this.packEventData(seriesModel, polyline);
      polygon && this.packEventData(seriesModel, polygon);
    }
  };

  LineView.prototype.packEventData = function (seriesModel, el) {
    getECData(el).eventData = {
      componentType: 'series',
      componentSubType: 'line',
      componentIndex: seriesModel.componentIndex,
      seriesIndex: seriesModel.seriesIndex,
      seriesName: seriesModel.name,
      seriesType: 'line'
    };
  };

  LineView.prototype.highlight = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = queryDataIndex(data, payload);

    this._changePolyState('emphasis');

    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
      var points = data.getLayout('points');
      var symbol = data.getItemGraphicEl(dataIndex);

      if (!symbol) {
        // Create a temporary symbol if it is not exists
        var x = points[dataIndex * 2];
        var y = points[dataIndex * 2 + 1];

        if (isNaN(x) || isNaN(y)) {
          // Null data
          return;
        } // fix #11360: shouldn't draw symbol outside clipShapeForSymbol


        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) {
          return;
        }

        var zlevel = seriesModel.get('zlevel') || 0;
        var z = seriesModel.get('z') || 0;
        symbol = new Symbol$2(data, dataIndex);
        symbol.x = x;
        symbol.y = y;
        symbol.setZ(zlevel, z); // ensure label text of the temporary symbol is in front of line and area polygon

        var symbolLabel = symbol.getSymbolPath().getTextContent();

        if (symbolLabel) {
          symbolLabel.zlevel = zlevel;
          symbolLabel.z = z;
          symbolLabel.z2 = this._polyline.z2 + 1;
        }

        symbol.__temp = true;
        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation

        symbol.stopSymbolAnimation(true);
        this.group.add(symbol);
      }

      symbol.highlight();
    } else {
      // Highlight whole series
      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    }
  };

  LineView.prototype.downplay = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var dataIndex = queryDataIndex(data, payload);

    this._changePolyState('normal');

    if (dataIndex != null && dataIndex >= 0) {
      var symbol = data.getItemGraphicEl(dataIndex);

      if (symbol) {
        if (symbol.__temp) {
          data.setItemGraphicEl(dataIndex, null);
          this.group.remove(symbol);
        } else {
          symbol.downplay();
        }
      }
    } else {
      // FIXME
      // can not downplay completely.
      // Downplay whole series
      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    }
  };

  LineView.prototype._changePolyState = function (toState) {
    var polygon = this._polygon;
    setStatesFlag(this._polyline, toState);
    polygon && setStatesFlag(polygon, toState);
  };

  LineView.prototype._newPolyline = function (points) {
    var polyline = this._polyline; // Remove previous created polyline

    if (polyline) {
      this._lineGroup.remove(polyline);
    }

    polyline = new ECPolyline({
      shape: {
        points: points
      },
      segmentIgnoreThreshold: 2,
      z2: 10
    });

    this._lineGroup.add(polyline);

    this._polyline = polyline;
    return polyline;
  };

  LineView.prototype._newPolygon = function (points, stackedOnPoints) {
    var polygon = this._polygon; // Remove previous created polygon

    if (polygon) {
      this._lineGroup.remove(polygon);
    }

    polygon = new ECPolygon({
      shape: {
        points: points,
        stackedOnPoints: stackedOnPoints
      },
      segmentIgnoreThreshold: 2
    });

    this._lineGroup.add(polygon);

    this._polygon = polygon;
    return polygon;
  };

  LineView.prototype._initSymbolLabelAnimation = function (data, coordSys, clipShape) {
    var isHorizontalOrRadial;
    var isCoordSysPolar;
    var baseAxis = coordSys.getBaseAxis();
    var isAxisInverse = baseAxis.inverse;

    if (coordSys.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
      isCoordSysPolar = false;
    } else if (coordSys.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
      isCoordSysPolar = true;
    }

    var seriesModel = data.hostModel;
    var seriesDuration = seriesModel.get('animationDuration');

    if (isFunction$3(seriesDuration)) {
      seriesDuration = seriesDuration(null);
    }

    var seriesDalay = seriesModel.get('animationDelay') || 0;
    var seriesDalayValue = isFunction$3(seriesDalay) ? seriesDalay(null) : seriesDalay;
    data.eachItemGraphicEl(function (symbol, idx) {
      var el = symbol;

      if (el) {
        var point = [symbol.x, symbol.y];
        var start = void 0;
        var end = void 0;
        var current = void 0;

        if (clipShape) {
          if (isCoordSysPolar) {
            var polarClip = clipShape;
            var coord = coordSys.pointToCoord(point);

            if (isHorizontalOrRadial) {
              start = polarClip.startAngle;
              end = polarClip.endAngle;
              current = -coord[1] / 180 * Math.PI;
            } else {
              start = polarClip.r0;
              end = polarClip.r;
              current = coord[0];
            }
          } else {
            var gridClip = clipShape;

            if (isHorizontalOrRadial) {
              start = gridClip.x;
              end = gridClip.x + gridClip.width;
              current = symbol.x;
            } else {
              start = gridClip.y + gridClip.height;
              end = gridClip.y;
              current = symbol.y;
            }
          }
        }

        var ratio = end === start ? 0 : (current - start) / (end - start);

        if (isAxisInverse) {
          ratio = 1 - ratio;
        }

        var delay = isFunction$3(seriesDalay) ? seriesDalay(idx) : seriesDuration * ratio + seriesDalayValue;
        var symbolPath = el.getSymbolPath();
        var text = symbolPath.getTextContent();
        el.attr({
          scaleX: 0,
          scaleY: 0
        });
        el.animateTo({
          scaleX: 1,
          scaleY: 1
        }, {
          duration: 200,
          setToFinal: true,
          delay: delay
        });

        if (text) {
          text.animateFrom({
            style: {
              opacity: 0
            }
          }, {
            duration: 300,
            delay: delay
          });
        }

        symbolPath.disableLabelAnimation = true;
      }
    });
  };

  LineView.prototype._initOrUpdateEndLabel = function (seriesModel, coordSys, inheritColor) {
    var endLabelModel = seriesModel.getModel('endLabel');

    if (anyStateShowEndLabel(seriesModel)) {
      var data_2 = seriesModel.getData();
      var polyline = this._polyline; // series may be filtered.

      var points = data_2.getLayout('points');

      if (!points) {
        polyline.removeTextContent();
        this._endLabel = null;
        return;
      }

      var endLabel = this._endLabel;

      if (!endLabel) {
        endLabel = this._endLabel = new ZRText({
          z2: 200 // should be higher than item symbol

        });
        endLabel.ignoreClip = true;
        polyline.setTextContent(this._endLabel);
        polyline.disableLabelAnimation = true;
      } // Find last non-NaN data to display data


      var dataIndex = getLastIndexNotNull(points);

      if (dataIndex >= 0) {
        setLabelStyle(polyline, getLabelStatesModels(seriesModel, 'endLabel'), {
          inheritColor: inheritColor,
          labelFetcher: seriesModel,
          labelDataIndex: dataIndex,
          defaultText: function (dataIndex, opt, interpolatedValue) {
            return interpolatedValue != null ? getDefaultInterpolatedLabel(data_2, interpolatedValue) : getDefaultLabel(data_2, dataIndex);
          },
          enableTextSetter: true
        }, getEndLabelStateSpecified(endLabelModel, coordSys));
        polyline.textConfig.position = null;
      }
    } else if (this._endLabel) {
      this._polyline.removeTextContent();

      this._endLabel = null;
    }
  };

  LineView.prototype._endLabelOnDuring = function (percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
    var endLabel = this._endLabel;
    var polyline = this._polyline;

    if (endLabel) {
      // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
      // The label is not prepared at this time.
      if (percent < 1 && animationRecord.originalX == null) {
        animationRecord.originalX = endLabel.x;
        animationRecord.originalY = endLabel.y;
      }

      var points = data.getLayout('points');
      var seriesModel = data.hostModel;
      var connectNulls = seriesModel.get('connectNulls');
      var precision = endLabelModel.get('precision');
      var distance = endLabelModel.get('distance') || 0;
      var baseAxis = coordSys.getBaseAxis();
      var isHorizontal = baseAxis.isHorizontal();
      var isBaseInversed = baseAxis.inverse;
      var clipShape = clipRect.shape;
      var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
      var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
      var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
      var dim = isHorizontal ? 'x' : 'y';
      var dataIndexRange = getIndexRange(points, xOrY, dim);
      var indices = dataIndexRange.range;
      var diff = indices[1] - indices[0];
      var value = void 0;

      if (diff >= 1) {
        // diff > 1 && connectNulls, which is on the null data.
        if (diff > 1 && !connectNulls) {
          var pt = getPointAtIndex(points, indices[0]);
          endLabel.attr({
            x: pt[0] + distanceX,
            y: pt[1] + distanceY
          });
          valueAnimation && (value = seriesModel.getRawValue(indices[0]));
        } else {
          var pt = polyline.getPointOn(xOrY, dim);
          pt && endLabel.attr({
            x: pt[0] + distanceX,
            y: pt[1] + distanceY
          });
          var startValue = seriesModel.getRawValue(indices[0]);
          var endValue = seriesModel.getRawValue(indices[1]);
          valueAnimation && (value = interpolateRawValues(data, precision, startValue, endValue, dataIndexRange.t));
        }

        animationRecord.lastFrameIndex = indices[0];
      } else {
        // If diff <= 0, which is the range is not found(Include NaN)
        // Choose the first point or last point.
        var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
        var pt = getPointAtIndex(points, idx);
        valueAnimation && (value = seriesModel.getRawValue(idx));
        endLabel.attr({
          x: pt[0] + distanceX,
          y: pt[1] + distanceY
        });
      }

      if (valueAnimation) {
        labelInner(endLabel).setLabelText(value);
      }
    }
  };
  /**
   * @private
   */
  // FIXME Two value axis


  LineView.prototype._doUpdateAnimation = function (data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
    var polyline = this._polyline;
    var polygon = this._polygon;
    var seriesModel = data.hostModel;
    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin);
    var current = diff.current;
    var stackedOnCurrent = diff.stackedOnCurrent;
    var next = diff.next;
    var stackedOnNext = diff.stackedOnNext;

    if (step) {
      // TODO If stacked series is not step
      current = turnPointsIntoStep(diff.current, coordSys, step, connectNulls);
      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step, connectNulls);
      next = turnPointsIntoStep(diff.next, coordSys, step, connectNulls);
      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step, connectNulls);
    } // Don't apply animation if diff is large.
    // For better result and avoid memory explosion problems like
    // https://github.com/apache/incubator-echarts/issues/12229


    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
      polyline.stopAnimation();
      polyline.setShape({
        points: next
      });

      if (polygon) {
        polygon.stopAnimation();
        polygon.setShape({
          points: next,
          stackedOnPoints: stackedOnNext
        });
      }

      return;
    }

    polyline.shape.__points = diff.current;
    polyline.shape.points = current;
    var target = {
      shape: {
        points: next
      }
    }; // Also animate the original points.
    // If points reference is changed when turning into step line.

    if (diff.current !== current) {
      target.shape.__points = diff.next;
    } // Stop previous animation.


    polyline.stopAnimation();
    updateProps(polyline, target, seriesModel);

    if (polygon) {
      polygon.setShape({
        // Reuse the points with polyline.
        points: current,
        stackedOnPoints: stackedOnCurrent
      });
      polygon.stopAnimation();
      updateProps(polygon, {
        shape: {
          stackedOnPoints: stackedOnNext
        }
      }, seriesModel); // If use attr directly in updateProps.

      if (polyline.shape.points !== polygon.shape.points) {
        polygon.shape.points = polyline.shape.points;
      }
    }

    var updatedDataInfo = [];
    var diffStatus = diff.status;

    for (var i = 0; i < diffStatus.length; i++) {
      var cmd = diffStatus[i].cmd;

      if (cmd === '=') {
        var el = data.getItemGraphicEl(diffStatus[i].idx1);

        if (el) {
          updatedDataInfo.push({
            el: el,
            ptIdx: i // Index of points

          });
        }
      }
    }

    if (polyline.animators && polyline.animators.length) {
      polyline.animators[0].during(function () {
        polygon && polygon.dirtyShape();
        var points = polyline.shape.__points;

        for (var i = 0; i < updatedDataInfo.length; i++) {
          var el = updatedDataInfo[i].el;
          var offset = updatedDataInfo[i].ptIdx * 2;
          el.x = points[offset];
          el.y = points[offset + 1];
          el.markRedraw();
        }
      });
    }
  };

  LineView.prototype.remove = function (ecModel) {
    var group = this.group;
    var oldData = this._data;

    this._lineGroup.removeAll();

    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting


    oldData && oldData.eachItemGraphicEl(function (el, idx) {
      if (el.__temp) {
        group.remove(el);
        oldData.setItemGraphicEl(idx, null);
      }
    });
    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
  };

  LineView.type = 'line';
  return LineView;
}(ChartView);

function pointsLayout(seriesType, forceStoreInTypedArray) {
  return {
    seriesType: seriesType,
    plan: createRenderPlanner(),
    reset: function (seriesModel) {
      var data = seriesModel.getData();
      var coordSys = seriesModel.coordinateSystem;
      var pipelineContext = seriesModel.pipelineContext;
      var useTypedArray = forceStoreInTypedArray || pipelineContext.large;

      if (!coordSys) {
        return;
      }

      var dims = map(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }).slice(0, 2);
      var dimLen = dims.length;
      var stackResultDim = data.getCalculationInfo('stackResultDimension');

      if (isDimensionStacked(data, dims[0])) {
        dims[0] = stackResultDim;
      }

      if (isDimensionStacked(data, dims[1])) {
        dims[1] = stackResultDim;
      }

      var store = data.getStore();
      var dimIdx0 = data.getDimensionIndex(dims[0]);
      var dimIdx1 = data.getDimensionIndex(dims[1]);
      return dimLen && {
        progress: function (params, data) {
          var segCount = params.end - params.start;
          var points = useTypedArray && createFloat32Array(segCount * dimLen);
          var tmpIn = [];
          var tmpOut = [];

          for (var i = params.start, offset = 0; i < params.end; i++) {
            var point = void 0;

            if (dimLen === 1) {
              var x = store.get(dimIdx0, i); // NOTE: Make sure the second parameter is null to use default strategy.

              point = coordSys.dataToPoint(x, null, tmpOut);
            } else {
              tmpIn[0] = store.get(dimIdx0, i);
              tmpIn[1] = store.get(dimIdx1, i); // Let coordinate system to handle the NaN data.

              point = coordSys.dataToPoint(tmpIn, null, tmpOut);
            }

            if (useTypedArray) {
              points[offset++] = point[0];
              points[offset++] = point[1];
            } else {
              data.setItemLayout(i, point.slice());
            }
          }

          useTypedArray && data.setLayout('points', points);
        }
      };
    }
  };
}

var samplers = {
  average: function (frame) {
    var sum = 0;
    var count = 0;

    for (var i = 0; i < frame.length; i++) {
      if (!isNaN(frame[i])) {
        sum += frame[i];
        count++;
      }
    } // Return NaN if count is 0


    return count === 0 ? NaN : sum / count;
  },
  sum: function (frame) {
    var sum = 0;

    for (var i = 0; i < frame.length; i++) {
      // Ignore NaN
      sum += frame[i] || 0;
    }

    return sum;
  },
  max: function (frame) {
    var max = -Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] > max && (max = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(max) ? max : NaN;
  },
  min: function (frame) {
    var min = Infinity;

    for (var i = 0; i < frame.length; i++) {
      frame[i] < min && (min = frame[i]);
    } // NaN will cause illegal axis extent.


    return isFinite(min) ? min : NaN;
  },
  // TODO
  // Median
  nearest: function (frame) {
    return frame[0];
  }
};

var indexSampler = function (frame) {
  return Math.round(frame.length / 2);
};

function dataSample(seriesType) {
  return {
    seriesType: seriesType,
    // FIXME:TS never used, so comment it
    // modifyOutputEnd: true,
    reset: function (seriesModel, ecModel, api) {
      var data = seriesModel.getData();
      var sampling = seriesModel.get('sampling');
      var coordSys = seriesModel.coordinateSystem;
      var count = data.count(); // Only cartesian2d support down sampling. Disable it when there is few data.

      if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
        var baseAxis = coordSys.getBaseAxis();
        var valueAxis = coordSys.getOtherAxis(baseAxis);
        var extent = baseAxis.getExtent();
        var dpr = api.getDevicePixelRatio(); // Coordinste system has been resized

        var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
        var rate = Math.round(count / size);

        if (isFinite(rate) && rate > 1) {
          if (sampling === 'lttb') {
            seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
          }

          var sampler = void 0;

          if (isString(sampling)) {
            sampler = samplers[sampling];
          } else if (isFunction$3(sampling)) {
            sampler = sampling;
          }

          if (sampler) {
            // Only support sample the first dim mapped from value axis.
            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
          }
        }
      }
    }
  };
}

function install$2(registers) {
  registers.registerChartView(LineView);
  registers.registerSeriesModel(LineSeriesModel);
  registers.registerLayout(pointsLayout('line', true));
  registers.registerVisual({
    seriesType: 'line',
    reset: function (seriesModel) {
      var data = seriesModel.getData(); // Visual coding for legend

      var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();

      if (lineStyle && !lineStyle.stroke) {
        // Fill in visual should be palette color if
        // has color callback
        lineStyle.stroke = data.getVisual('style').fill;
      }

      data.setVisual('legendLineStyle', lineStyle);
    }
  }); // Down sample after filter

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));
}

var BaseBarSeriesModel =
/** @class */
function (_super) {
  __extends$1(BaseBarSeriesModel, _super);

  function BaseBarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BaseBarSeriesModel.type;
    return _this;
  }

  BaseBarSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this, {
      useEncodeDefaulter: true
    });
  };

  BaseBarSeriesModel.prototype.getMarkerPosition = function (value, dims, startingAtTick) {
    var coordSys = this.coordinateSystem;

    if (coordSys && coordSys.clampData) {
      // PENDING if clamp ?
      var pt_1 = coordSys.dataToPoint(coordSys.clampData(value));

      if (startingAtTick) {
        each(coordSys.getAxes(), function (axis, idx) {
          // If axis type is category, use tick coords instead
          if (axis.type === 'category') {
            var tickCoords = axis.getTicksCoords();
            var tickIdx = coordSys.clampData(value)[idx]; // The index of rightmost tick of markArea is 1 larger than x1/y1 index

            if (dims && (dims[idx] === 'x1' || dims[idx] === 'y1')) {
              tickIdx += 1;
            }

            tickIdx > tickCoords.length - 1 && (tickIdx = tickCoords.length - 1);
            tickIdx < 0 && (tickIdx = 0);
            tickCoords[tickIdx] && (pt_1[idx] = axis.toGlobalCoord(tickCoords[tickIdx].coord));
          }
        });
      } else {
        var data = this.getData();
        var offset = data.getLayout('offset');
        var size = data.getLayout('size');
        var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
        pt_1[offsetIndex] += offset + size / 2;
      }

      return pt_1;
    }

    return [NaN, NaN];
  };

  BaseBarSeriesModel.type = 'series.__base_bar__';
  BaseBarSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // stack: null
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    barMinHeight: 0,
    barMinAngle: 0,
    // cursor: null,
    large: false,
    largeThreshold: 400,
    progressive: 3e3,
    progressiveChunkMode: 'mod'
  };
  return BaseBarSeriesModel;
}(SeriesModel);

SeriesModel.registerClass(BaseBarSeriesModel);

var BarSeriesModel =
/** @class */
function (_super) {
  __extends$1(BarSeriesModel, _super);

  function BarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BarSeriesModel.type;
    return _this;
  }

  BarSeriesModel.prototype.getInitialData = function () {
    return createSeriesData(null, this, {
      useEncodeDefaulter: true,
      createInvertedIndices: !!this.get('realtimeSort', true) || null
    });
  };
  /**
   * @override
   */


  BarSeriesModel.prototype.getProgressive = function () {
    // Do not support progressive in normal mode.
    return this.get('large') ? this.get('progressive') : false;
  };
  /**
   * @override
   */


  BarSeriesModel.prototype.getProgressiveThreshold = function () {
    // Do not support progressive in normal mode.
    var progressiveThreshold = this.get('progressiveThreshold');
    var largeThreshold = this.get('largeThreshold');

    if (largeThreshold > progressiveThreshold) {
      progressiveThreshold = largeThreshold;
    }

    return progressiveThreshold;
  };

  BarSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.rect(data.getItemLayout(dataIndex));
  };

  BarSeriesModel.type = 'series.bar';
  BarSeriesModel.dependencies = ['grid', 'polar'];
  BarSeriesModel.defaultOption = inheritDefaultOption(BaseBarSeriesModel.defaultOption, {
    // If clipped
    // Only available on cartesian2d
    clip: true,
    roundCap: false,
    showBackground: false,
    backgroundStyle: {
      color: 'rgba(180, 180, 180, 0.2)',
      borderColor: null,
      borderWidth: 0,
      borderType: 'solid',
      borderRadius: 0,
      shadowBlur: 0,
      shadowColor: null,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    realtimeSort: false
  });
  return BarSeriesModel;
}(BaseBarSeriesModel);

/**
 * Sausage: similar to sector, but have half circle on both sides
 */

var SausageShape =
/** @class */
function () {
  function SausageShape() {
    this.cx = 0;
    this.cy = 0;
    this.r0 = 0;
    this.r = 0;
    this.startAngle = 0;
    this.endAngle = Math.PI * 2;
    this.clockwise = true;
  }

  return SausageShape;
}();

var SausagePath =
/** @class */
function (_super) {
  __extends$1(SausagePath, _super);

  function SausagePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'sausage';
    return _this;
  }

  SausagePath.prototype.getDefaultShape = function () {
    return new SausageShape();
  };

  SausagePath.prototype.buildPath = function (ctx, shape) {
    var cx = shape.cx;
    var cy = shape.cy;
    var r0 = Math.max(shape.r0 || 0, 0);
    var r = Math.max(shape.r, 0);
    var dr = (r - r0) * 0.5;
    var rCenter = r0 + dr;
    var startAngle = shape.startAngle;
    var endAngle = shape.endAngle;
    var clockwise = shape.clockwise;
    var PI2 = Math.PI * 2;
    var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;

    if (!lessThanCircle) {
      // Normalize angles
      startAngle = endAngle - (clockwise ? PI2 : -PI2);
    }

    var unitStartX = Math.cos(startAngle);
    var unitStartY = Math.sin(startAngle);
    var unitEndX = Math.cos(endAngle);
    var unitEndY = Math.sin(endAngle);

    if (lessThanCircle) {
      ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
      ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
    } else {
      ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
    }

    ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
    ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);

    if (r0 !== 0) {
      ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    } // ctx.closePath();

  };

  return SausagePath;
}(Path);

function createSectorCalculateTextPosition(positionMapping, opts) {
  opts = opts || {};
  var isRoundCap = opts.isRoundCap;
  return function (out, opts, boundingRect) {
    var textPosition = opts.position;

    if (!textPosition || textPosition instanceof Array) {
      return calculateTextPosition(out, opts, boundingRect);
    }

    var mappedSectorPosition = positionMapping(textPosition);
    var distance = opts.distance != null ? opts.distance : 5;
    var sector = this.shape;
    var cx = sector.cx;
    var cy = sector.cy;
    var r = sector.r;
    var r0 = sector.r0;
    var middleR = (r + r0) / 2;
    var startAngle = sector.startAngle;
    var endAngle = sector.endAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
    var mathCos = Math.cos;
    var mathSin = Math.sin; // base position: top-left

    var x = cx + r * mathCos(startAngle);
    var y = cy + r * mathSin(startAngle);
    var textAlign = 'left';
    var textVerticalAlign = 'top';

    switch (mappedSectorPosition) {
      case 'startArc':
        x = cx + (r0 - distance) * mathCos(middleAngle);
        y = cy + (r0 - distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'top';
        break;

      case 'insideStartArc':
        x = cx + (r0 + distance) * mathCos(middleAngle);
        y = cy + (r0 + distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'bottom';
        break;

      case 'startAngle':
        x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, distance + extraDist, false);
        y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, distance + extraDist, false);
        textAlign = 'right';
        textVerticalAlign = 'middle';
        break;

      case 'insideStartAngle':
        x = cx + middleR * mathCos(startAngle) + adjustAngleDistanceX(startAngle, -distance + extraDist, false);
        y = cy + middleR * mathSin(startAngle) + adjustAngleDistanceY(startAngle, -distance + extraDist, false);
        textAlign = 'left';
        textVerticalAlign = 'middle';
        break;

      case 'middle':
        x = cx + middleR * mathCos(middleAngle);
        y = cy + middleR * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'middle';
        break;

      case 'endArc':
        x = cx + (r + distance) * mathCos(middleAngle);
        y = cy + (r + distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'bottom';
        break;

      case 'insideEndArc':
        x = cx + (r - distance) * mathCos(middleAngle);
        y = cy + (r - distance) * mathSin(middleAngle);
        textAlign = 'center';
        textVerticalAlign = 'top';
        break;

      case 'endAngle':
        x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, distance + extraDist, true);
        y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, distance + extraDist, true);
        textAlign = 'left';
        textVerticalAlign = 'middle';
        break;

      case 'insideEndAngle':
        x = cx + middleR * mathCos(endAngle) + adjustAngleDistanceX(endAngle, -distance + extraDist, true);
        y = cy + middleR * mathSin(endAngle) + adjustAngleDistanceY(endAngle, -distance + extraDist, true);
        textAlign = 'right';
        textVerticalAlign = 'middle';
        break;

      default:
        return calculateTextPosition(out, opts, boundingRect);
    }

    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
  };
}
function setSectorTextRotation(sector, textPosition, positionMapping, rotateType) {
  if (isNumber$1(rotateType)) {
    // user-set rotation
    sector.setTextConfig({
      rotation: rotateType
    });
    return;
  } else if (isArray$1(textPosition)) {
    // user-set position, use 0 as auto rotation
    sector.setTextConfig({
      rotation: 0
    });
    return;
  }

  var shape = sector.shape;
  var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
  var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
  var middleAngle = (startAngle + endAngle) / 2;
  var anchorAngle;
  var mappedSectorPosition = positionMapping(textPosition);

  switch (mappedSectorPosition) {
    case 'startArc':
    case 'insideStartArc':
    case 'middle':
    case 'insideEndArc':
    case 'endArc':
      anchorAngle = middleAngle;
      break;

    case 'startAngle':
    case 'insideStartAngle':
      anchorAngle = startAngle;
      break;

    case 'endAngle':
    case 'insideEndAngle':
      anchorAngle = endAngle;
      break;

    default:
      sector.setTextConfig({
        rotation: 0
      });
      return;
  }

  var rotate = Math.PI * 1.5 - anchorAngle;
  /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */

  if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) {
    rotate -= Math.PI;
  }

  sector.setTextConfig({
    rotation: rotate
  });
}

function adjustAngleDistanceX(angle, distance, isEnd) {
  return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}

function adjustAngleDistanceY(angle, distance, isEnd) {
  return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}

var mathMax$6 = Math.max;
var mathMin$6 = Math.min;

function getClipArea(coord, data) {
  var coordSysClipArea = coord.getArea && coord.getArea();

  if (isCoordinateSystemType(coord, 'cartesian2d')) {
    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
    // We should not clip this part.
    // See test/bar2.html

    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
      var expandWidth = data.getLayout('bandWidth');

      if (baseAxis.isHorizontal()) {
        coordSysClipArea.x -= expandWidth;
        coordSysClipArea.width += expandWidth * 2;
      } else {
        coordSysClipArea.y -= expandWidth;
        coordSysClipArea.height += expandWidth * 2;
      }
    }
  }

  return coordSysClipArea;
}

var BarView =
/** @class */
function (_super) {
  __extends$1(BarView, _super);

  function BarView() {
    var _this = _super.call(this) || this;

    _this.type = BarView.type;
    _this._isFirstFrame = true;
    return _this;
  }

  BarView.prototype.render = function (seriesModel, ecModel, api, payload) {
    this._model = seriesModel;

    this._removeOnRenderedListener(api);

    this._updateDrawMode(seriesModel);

    var coordinateSystemType = seriesModel.get('coordinateSystem');

    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
      // Clear previously rendered progressive elements.
      this._progressiveEls = null;
      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
    } else if (process.env.NODE_ENV !== 'production') {
      warn('Only cartesian2d and polar supported for bar.');
    }
  };

  BarView.prototype.incrementalPrepareRender = function (seriesModel) {
    this._clear();

    this._updateDrawMode(seriesModel); // incremental also need to clip, otherwise might be overlow.
    // But must not set clip in each frame, otherwise all of the children will be marked redraw.


    this._updateLargeClip(seriesModel);
  };

  BarView.prototype.incrementalRender = function (params, seriesModel) {
    // Reset
    this._progressiveEls = []; // Do not support progressive in normal mode.

    this._incrementalRenderLarge(params, seriesModel);
  };

  BarView.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  BarView.prototype._updateDrawMode = function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  };

  BarView.prototype._renderNormal = function (seriesModel, ecModel, api, payload) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coord = seriesModel.coordinateSystem;
    var baseAxis = coord.getBaseAxis();
    var isHorizontalOrRadial;

    if (coord.type === 'cartesian2d') {
      isHorizontalOrRadial = baseAxis.isHorizontal();
    } else if (coord.type === 'polar') {
      isHorizontalOrRadial = baseAxis.dim === 'angle';
    }

    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
    var realtimeSortCfg = shouldRealtimeSort(seriesModel, coord);

    if (realtimeSortCfg) {
      this._enableRealtimeSort(realtimeSortCfg, data, api);
    }

    var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.

    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
    // And don't want the label are clipped.

    var roundCap = seriesModel.get('roundCap', true);
    var drawBackground = seriesModel.get('showBackground', true);
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var barBorderRadius = backgroundModel.get('borderRadius') || 0;
    var bgEls = [];
    var oldBgEls = this._backgroundEls;
    var isInitSort = payload && payload.isInitSort;
    var isChangeOrder = payload && payload.type === 'changeAxisOrder';

    function createBackground(dataIndex) {
      var bgLayout = getLayout[coord.type](data, dataIndex);
      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
      bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.

      if (coord.type === 'cartesian2d') {
        bgEl.setShape('r', barBorderRadius);
      }

      bgEls[dataIndex] = bgEl;
      return bgEl;
    }
    data.diff(oldData).add(function (dataIndex) {
      var itemModel = data.getItemModel(dataIndex);
      var layout = getLayout[coord.type](data, dataIndex, itemModel);

      if (drawBackground) {
        createBackground(dataIndex);
      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".


      if (!data.hasValue(dataIndex) || !isValidLayout[coord.type](layout)) {
        return;
      }

      var isClipped = false;

      if (needsClip) {
        // Clip will modify the layout params.
        // And return a boolean to determine if the shape are fully clipped.
        isClipped = clip[coord.type](coordSysClipArea, layout);
      }

      var el = elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);

      if (realtimeSortCfg) {
        /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */
        el.forceLabelAnimation = true;
      }

      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');

      if (isInitSort) {
        el.attr({
          shape: layout
        });
      } else if (realtimeSortCfg) {
        updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
      } else {
        initProps(el, {
          shape: layout
        }, seriesModel, dataIndex);
      }

      data.setItemGraphicEl(dataIndex, el);
      group.add(el);
      el.ignore = isClipped;
    }).update(function (newIndex, oldIndex) {
      var itemModel = data.getItemModel(newIndex);
      var layout = getLayout[coord.type](data, newIndex, itemModel);

      if (drawBackground) {
        var bgEl = void 0;

        if (oldBgEls.length === 0) {
          bgEl = createBackground(oldIndex);
        } else {
          bgEl = oldBgEls[oldIndex];
          bgEl.useStyle(backgroundModel.getItemStyle()); // Only cartesian2d support borderRadius.

          if (coord.type === 'cartesian2d') {
            bgEl.setShape('r', barBorderRadius);
          }

          bgEls[newIndex] = bgEl;
        }

        var bgLayout = getLayout[coord.type](data, newIndex);
        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
        updateProps(bgEl, {
          shape: shape
        }, animationModel, newIndex);
      }

      var el = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex) || !isValidLayout[coord.type](layout)) {
        group.remove(el);
        return;
      }

      var isClipped = false;

      if (needsClip) {
        isClipped = clip[coord.type](coordSysClipArea, layout);

        if (isClipped) {
          group.remove(el);
        }
      }

      if (!el) {
        el = elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
      } else {
        saveOldStyle(el);
      }

      if (realtimeSortCfg) {
        el.forceLabelAnimation = true;
      }

      if (isChangeOrder) {
        var textEl = el.getTextContent();

        if (textEl) {
          var labelInnerStore = labelInner(textEl);

          if (labelInnerStore.prevValue != null) {
            /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */
            labelInnerStore.prevValue = labelInnerStore.value;
          }
        }
      } // Not change anything if only order changed.
      // Especially not change label.
      else {
          updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
        }

      if (isInitSort) {
        el.attr({
          shape: layout
        });
      } else if (realtimeSortCfg) {
        updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
      } else {
        updateProps(el, {
          shape: layout
        }, seriesModel, newIndex, null);
      }

      data.setItemGraphicEl(newIndex, el);
      el.ignore = isClipped;
      group.add(el);
    }).remove(function (dataIndex) {
      var el = oldData.getItemGraphicEl(dataIndex);
      el && removeElementWithFadeOut(el, seriesModel, dataIndex);
    }).execute();
    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group$1());
    bgGroup.removeAll();

    for (var i = 0; i < bgEls.length; ++i) {
      bgGroup.add(bgEls[i]);
    }

    group.add(bgGroup);
    this._backgroundEls = bgEls;
    this._data = data;
  };

  BarView.prototype._renderLarge = function (seriesModel, ecModel, api) {
    this._clear();

    createLarge(seriesModel, this.group);

    this._updateLargeClip(seriesModel);
  };

  BarView.prototype._incrementalRenderLarge = function (params, seriesModel) {
    this._removeBackground();

    createLarge(seriesModel, this.group, this._progressiveEls, true);
  };

  BarView.prototype._updateLargeClip = function (seriesModel) {
    // Use clipPath in large mode.
    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
    var group = this.group;

    if (clipPath) {
      group.setClipPath(clipPath);
    } else {
      group.removeClipPath();
    }
  };

  BarView.prototype._enableRealtimeSort = function (realtimeSortCfg, data, api) {
    var _this = this; // If no data in the first frame, wait for data to initSort


    if (!data.count()) {
      return;
    }

    var baseAxis = realtimeSortCfg.baseAxis;

    if (this._isFirstFrame) {
      this._dispatchInitSort(data, realtimeSortCfg, api);

      this._isFirstFrame = false;
    } else {
      var orderMapping_1 = function (idx) {
        var el = data.getItemGraphicEl(idx);
        var shape = el && el.shape;
        return shape && // The result should be consistent with the initial sort by data value.
        // Do not support the case that both positive and negative exist.
        Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) // If data is NaN, shape.xxx may be NaN, so use || 0 here in case
        || 0;
      };

      this._onRendered = function () {
        _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
      };

      api.getZr().on('rendered', this._onRendered);
    }
  };

  BarView.prototype._dataSort = function (data, baseAxis, orderMapping) {
    var info = [];
    data.each(data.mapDimension(baseAxis.dim), function (ordinalNumber, dataIdx) {
      var mappedValue = orderMapping(dataIdx);
      mappedValue = mappedValue == null ? NaN : mappedValue;
      info.push({
        dataIndex: dataIdx,
        mappedValue: mappedValue,
        ordinalNumber: ordinalNumber
      });
    });
    info.sort(function (a, b) {
      // If NaN, it will be treated as min val.
      return b.mappedValue - a.mappedValue;
    });
    return {
      ordinalNumbers: map(info, function (item) {
        return item.ordinalNumber;
      })
    };
  };

  BarView.prototype._isOrderChangedWithinSameData = function (data, orderMapping, baseAxis) {
    var scale = baseAxis.scale;
    var ordinalDataDim = data.mapDimension(baseAxis.dim);
    var lastValue = Number.MAX_VALUE;

    for (var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum) {
      var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
      var value = rawIdx < 0 // If some tick have no bar, the tick will be treated as min.
      ? Number.MIN_VALUE // PENDING: if dataZoom on baseAxis exits, is it a performance issue?
      : orderMapping(data.indexOfRawIndex(rawIdx));

      if (value > lastValue) {
        return true;
      }

      lastValue = value;
    }

    return false;
  };
  /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */


  BarView.prototype._isOrderDifferentInView = function (orderInfo, baseAxis) {
    var scale = baseAxis.scale;
    var extent = scale.getExtent();
    var tickNum = Math.max(0, extent[0]);
    var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);

    for (; tickNum <= tickMax; ++tickNum) {
      if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) {
        return true;
      }
    }
  };

  BarView.prototype._updateSortWithinSameData = function (data, orderMapping, baseAxis, api) {
    if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) {
      return;
    }

    var sortInfo = this._dataSort(data, baseAxis, orderMapping);

    if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
      this._removeOnRenderedListener(api);

      api.dispatchAction({
        type: 'changeAxisOrder',
        componentType: baseAxis.dim + 'Axis',
        axisId: baseAxis.index,
        sortInfo: sortInfo
      });
    }
  };

  BarView.prototype._dispatchInitSort = function (data, realtimeSortCfg, api) {
    var baseAxis = realtimeSortCfg.baseAxis;

    var sortResult = this._dataSort(data, baseAxis, function (dataIdx) {
      return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
    });

    api.dispatchAction({
      type: 'changeAxisOrder',
      componentType: baseAxis.dim + 'Axis',
      isInitSort: true,
      axisId: baseAxis.index,
      sortInfo: sortResult
    });
  };

  BarView.prototype.remove = function (ecModel, api) {
    this._clear(this._model);

    this._removeOnRenderedListener(api);
  };

  BarView.prototype.dispose = function (ecModel, api) {
    this._removeOnRenderedListener(api);
  };

  BarView.prototype._removeOnRenderedListener = function (api) {
    if (this._onRendered) {
      api.getZr().off('rendered', this._onRendered);
      this._onRendered = null;
    }
  };

  BarView.prototype._clear = function (model) {
    var group = this.group;
    var data = this._data;

    if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
      this._removeBackground();

      this._backgroundEls = [];
      data.eachItemGraphicEl(function (el) {
        removeElementWithFadeOut(el, model, getECData(el).dataIndex);
      });
    } else {
      group.removeAll();
    }

    this._data = null;
    this._isFirstFrame = true;
  };

  BarView.prototype._removeBackground = function () {
    this.group.remove(this._backgroundGroup);
    this._backgroundGroup = null;
  };

  BarView.type = 'bar';
  return BarView;
}(ChartView);

var clip = {
  cartesian2d: function (coordSysBoundingRect, layout) {
    var signWidth = layout.width < 0 ? -1 : 1;
    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
    var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
    var x = mathMax$6(layout.x, coordSysBoundingRect.x);
    var x2 = mathMin$6(layout.x + layout.width, coordSysX2);
    var y = mathMax$6(layout.y, coordSysBoundingRect.y);
    var y2 = mathMin$6(layout.y + layout.height, coordSysY2);
    var xClipped = x2 < x;
    var yClipped = y2 < y; // When xClipped or yClipped, the element will be marked as `ignore`.
    // But we should also place the element at the edge of the coord sys bounding rect.
    // Because if data changed and the bar shows again, its transition animation
    // will begin at this place.

    layout.x = xClipped && x > coordSysX2 ? x2 : x;
    layout.y = yClipped && y > coordSysY2 ? y2 : y;
    layout.width = xClipped ? 0 : x2 - x;
    layout.height = yClipped ? 0 : y2 - y; // Reverse back

    if (signWidth < 0) {
      layout.x += layout.width;
      layout.width = -layout.width;
    }

    if (signHeight < 0) {
      layout.y += layout.height;
      layout.height = -layout.height;
    }

    return xClipped || yClipped;
  },
  polar: function (coordSysClipArea, layout) {
    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0

    if (signR < 0) {
      var tmp = layout.r;
      layout.r = layout.r0;
      layout.r0 = tmp;
    }

    var r = mathMin$6(layout.r, coordSysClipArea.r);
    var r0 = mathMax$6(layout.r0, coordSysClipArea.r0);
    layout.r = r;
    layout.r0 = r0;
    var clipped = r - r0 < 0; // Reverse back

    if (signR < 0) {
      var tmp = layout.r;
      layout.r = layout.r0;
      layout.r0 = tmp;
    }

    return clipped;
  }
};
var elementCreator = {
  cartesian2d: function (seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
    var rect = new Rect({
      shape: extend({}, layout),
      z2: 1
    });
    rect.__dataIndex = newIndex;
    rect.name = 'item';

    if (animationModel) {
      var rectShape = rect.shape;
      var animateProperty = isHorizontal ? 'height' : 'width';
      rectShape[animateProperty] = 0;
    }

    return rect;
  },
  polar: function (seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
    var ShapeClass = !isRadial && roundCap ? SausagePath : Sector;
    var sector = new ShapeClass({
      shape: layout,
      z2: 1
    });
    sector.name = 'item';
    var positionMap = createPolarPositionMapping(isRadial);
    sector.calculateTextPosition = createSectorCalculateTextPosition(positionMap, {
      isRoundCap: ShapeClass === SausagePath
    }); // Animation

    if (animationModel) {
      var sectorShape = sector.shape;
      var animateProperty = isRadial ? 'r' : 'endAngle';
      var animateTarget = {};
      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
      animateTarget[animateProperty] = layout[animateProperty];
      (isUpdate ? updateProps : initProps)(sector, {
        shape: animateTarget // __value: typeof dataValue === 'string' ? parseInt(dataValue, 10) : dataValue

      }, animationModel);
    }

    return sector;
  }
};

function shouldRealtimeSort(seriesModel, coordSys) {
  var realtimeSortOption = seriesModel.get('realtimeSort', true);
  var baseAxis = coordSys.getBaseAxis();

  if (process.env.NODE_ENV !== 'production') {
    if (realtimeSortOption) {
      if (baseAxis.type !== 'category') {
        warn('`realtimeSort` will not work because this bar series is not based on a category axis.');
      }

      if (coordSys.type !== 'cartesian2d') {
        warn('`realtimeSort` will not work because this bar series is not on cartesian2d.');
      }
    }
  }

  if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') {
    return {
      baseAxis: baseAxis,
      otherAxis: coordSys.getOtherAxis(baseAxis)
    };
  }
}

function updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
  var seriesTarget;
  var axisTarget;

  if (isHorizontal) {
    axisTarget = {
      x: layout.x,
      width: layout.width
    };
    seriesTarget = {
      y: layout.y,
      height: layout.height
    };
  } else {
    axisTarget = {
      y: layout.y,
      height: layout.height
    };
    seriesTarget = {
      x: layout.x,
      width: layout.width
    };
  }

  if (!isChangeOrder) {
    // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? updateProps : initProps)(el, {
      shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
  }

  var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
  (isUpdate ? updateProps : initProps)(el, {
    shape: axisTarget
  }, axisAnimationModel, newIndex);
}

function checkPropertiesNotValid(obj, props) {
  for (var i = 0; i < props.length; i++) {
    if (!isFinite(obj[props[i]])) {
      return true;
    }
  }

  return false;
}

var rectPropties = ['x', 'y', 'width', 'height'];
var polarPropties = ['cx', 'cy', 'r', 'startAngle', 'endAngle'];
var isValidLayout = {
  cartesian2d: function (layout) {
    return !checkPropertiesNotValid(layout, rectPropties);
  },
  polar: function (layout) {
    return !checkPropertiesNotValid(layout, polarPropties);
  }
};
var getLayout = {
  // itemModel is only used to get borderWidth, which is not needed
  // when calculating bar background layout.
  cartesian2d: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth

    var signX = layout.width > 0 ? 1 : -1;
    var signY = layout.height > 0 ? 1 : -1;
    return {
      x: layout.x + signX * fixedLineWidth / 2,
      y: layout.y + signY * fixedLineWidth / 2,
      width: layout.width - signX * fixedLineWidth,
      height: layout.height - signY * fixedLineWidth
    };
  },
  polar: function (data, dataIndex, itemModel) {
    var layout = data.getItemLayout(dataIndex);
    return {
      cx: layout.cx,
      cy: layout.cy,
      r0: layout.r0,
      r: layout.r,
      startAngle: layout.startAngle,
      endAngle: layout.endAngle,
      clockwise: layout.clockwise
    };
  }
};

function isZeroOnPolar(layout) {
  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}

function createPolarPositionMapping(isRadial) {
  return function (isRadial) {
    var arcOrAngle = isRadial ? 'Arc' : 'Angle';
    return function (position) {
      switch (position) {
        case 'start':
        case 'insideStart':
        case 'end':
        case 'insideEnd':
          return position + arcOrAngle;

        default:
          return position;
      }
    };
  }(isRadial);
}

function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
  var style = data.getItemVisual(dataIndex, 'style');

  if (!isPolar) {
    el.setShape('r', itemModel.get(['itemStyle', 'borderRadius']) || 0);
  }

  el.useStyle(style);
  var cursorStyle = itemModel.getShallow('cursor');
  cursorStyle && el.attr('cursor', cursorStyle);
  var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
  var labelStatesModels = getLabelStatesModels(itemModel);
  setLabelStyle(el, labelStatesModels, {
    labelFetcher: seriesModel,
    labelDataIndex: dataIndex,
    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
    inheritColor: style.fill,
    defaultOpacity: style.opacity,
    defaultOutsidePosition: labelPositionOutside
  });
  var label = el.getTextContent();

  if (isPolar && label) {
    var position = itemModel.get(['label', 'position']);
    el.textConfig.inside = position === 'middle' ? true : null;
    setSectorTextRotation(el, position === 'outside' ? labelPositionOutside : position, createPolarPositionMapping(isHorizontalOrRadial), itemModel.get(['label', 'rotate']));
  }

  setLabelValueAnimation(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function (value) {
    return getDefaultInterpolatedLabel(data, value);
  });
  var emphasisModel = itemModel.getModel(['emphasis']);
  toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  setStatesStylesFromModel(el, itemModel);

  if (isZeroOnPolar(layout)) {
    el.style.fill = 'none';
    el.style.stroke = 'none';
    each(el.states, function (state) {
      if (state.style) {
        state.style.fill = state.style.stroke = 'none';
      }
    });
  }
} // In case width or height are too small.


function getLineWidth(itemModel, rawLayout) {
  // Has no border.
  var borderColor = itemModel.get(['itemStyle', 'borderColor']);

  if (!borderColor || borderColor === 'none') {
    return 0;
  }

  var lineWidth = itemModel.get(['itemStyle', 'borderWidth']) || 0; // width or height may be NaN for empty data

  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
  return Math.min(lineWidth, width, height);
}

var LagePathShape =
/** @class */
function () {
  function LagePathShape() {}

  return LagePathShape;
}();

var LargePath =
/** @class */
function (_super) {
  __extends$1(LargePath, _super);

  function LargePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'largeBar';
    return _this;
  }

  LargePath.prototype.getDefaultShape = function () {
    return new LagePathShape();
  };

  LargePath.prototype.buildPath = function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;
    var baseDimIdx = this.baseDimIdx;
    var valueDimIdx = 1 - this.baseDimIdx;
    var startPoint = [];
    var size = [];
    var barWidth = this.barWidth;

    for (var i = 0; i < points.length; i += 3) {
      size[baseDimIdx] = barWidth;
      size[valueDimIdx] = points[i + 2];
      startPoint[baseDimIdx] = points[i + baseDimIdx];
      startPoint[valueDimIdx] = points[i + valueDimIdx];
      ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
    }
  };

  return LargePath;
}(Path);

function createLarge(seriesModel, group, progressiveEls, incremental) {
  // TODO support polar
  var data = seriesModel.getData();
  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
  var largeDataIndices = data.getLayout('largeDataIndices');
  var barWidth = data.getLayout('size');
  var backgroundModel = seriesModel.getModel('backgroundStyle');
  var bgPoints = data.getLayout('largeBackgroundPoints');

  if (bgPoints) {
    var bgEl = new LargePath({
      shape: {
        points: bgPoints
      },
      incremental: !!incremental,
      silent: true,
      z2: 0
    });
    bgEl.baseDimIdx = baseDimIdx;
    bgEl.largeDataIndices = largeDataIndices;
    bgEl.barWidth = barWidth;
    bgEl.useStyle(backgroundModel.getItemStyle());
    group.add(bgEl);
    progressiveEls && progressiveEls.push(bgEl);
  }

  var el = new LargePath({
    shape: {
      points: data.getLayout('largePoints')
    },
    incremental: !!incremental,
    ignoreCoarsePointer: true,
    z2: 1
  });
  el.baseDimIdx = baseDimIdx;
  el.largeDataIndices = largeDataIndices;
  el.barWidth = barWidth;
  group.add(el);
  el.useStyle(data.getVisual('style')); // Enable tooltip and user mouse/touch event handlers.

  getECData(el).seriesIndex = seriesModel.seriesIndex;

  if (!seriesModel.get('silent')) {
    el.on('mousedown', largePathUpdateDataIndex);
    el.on('mousemove', largePathUpdateDataIndex);
  }

  progressiveEls && progressiveEls.push(el);
} // Use throttle to avoid frequently traverse to find dataIndex.


var largePathUpdateDataIndex = throttle$1(function (event) {
  var largePath = this;
  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
  getECData(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);

function largePathFindDataIndex(largePath, x, y) {
  var baseDimIdx = largePath.baseDimIdx;
  var valueDimIdx = 1 - baseDimIdx;
  var points = largePath.shape.points;
  var largeDataIndices = largePath.largeDataIndices;
  var startPoint = [];
  var size = [];
  var barWidth = largePath.barWidth;

  for (var i = 0, len = points.length / 3; i < len; i++) {
    var ii = i * 3;
    size[baseDimIdx] = barWidth;
    size[valueDimIdx] = points[ii + 2];
    startPoint[baseDimIdx] = points[ii + baseDimIdx];
    startPoint[valueDimIdx] = points[ii + valueDimIdx];

    if (size[valueDimIdx] < 0) {
      startPoint[valueDimIdx] += size[valueDimIdx];
      size[valueDimIdx] = -size[valueDimIdx];
    }

    if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) {
      return largeDataIndices[i];
    }
  }

  return -1;
}

function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
  if (isCoordinateSystemType(coord, 'cartesian2d')) {
    var rectShape = layout;
    var coordLayout = coord.getArea();
    return {
      x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
      y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
      width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
      height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
    };
  } else {
    var coordLayout = coord.getArea();
    var sectorShape = layout;
    return {
      cx: coordLayout.cx,
      cy: coordLayout.cy,
      r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
      r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
      startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
      endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
    };
  }
}

function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
  var ElementClz = coord.type === 'polar' ? Sector : Rect;
  return new ElementClz({
    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
    silent: true,
    z2: 0
  });
}

function install$3(registers) {
  registers.registerChartView(BarView);
  registers.registerSeriesModel(BarSeriesModel);
  registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, curry(layout, 'bar')); // Do layout after other overall layout, which can prepare some information.

  registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, createProgressiveLayout('bar')); // Down sample after filter

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, dataSample('bar'));
  /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */

  registers.registerAction({
    type: 'changeAxisOrder',
    event: 'changeAxisOrder',
    update: 'update'
  }, function (payload, ecModel) {
    var componentType = payload.componentType || 'series';
    ecModel.eachComponent({
      mainType: componentType,
      query: payload
    }, function (componentModel) {
      if (payload.sortInfo) {
        componentModel.axis.setCategorySortInfo(payload.sortInfo);
      }
    });
  });
}

var PI2$8 = Math.PI * 2;
var RADIAN = Math.PI / 180;

function getViewRect(seriesModel, api) {
  return getLayoutRect$1(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getBasicPieLayout(seriesModel, api) {
  var viewRect = getViewRect(seriesModel, api); // center can be string or number when coordinateSystem is specified

  var center = seriesModel.get('center');
  var radius = seriesModel.get('radius');

  if (!isArray$1(radius)) {
    radius = [0, radius];
  }

  var width = parsePercent$1(viewRect.width, api.getWidth());
  var height = parsePercent$1(viewRect.height, api.getHeight());
  var size = Math.min(width, height);
  var r0 = parsePercent$1(radius[0], size / 2);
  var r = parsePercent$1(radius[1], size / 2);
  var cx;
  var cy;
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys) {
    // percentage is not allowed when coordinate system is specified
    var point = coordSys.dataToPoint(center);
    cx = point[0] || 0;
    cy = point[1] || 0;
  } else {
    if (!isArray$1(center)) {
      center = [center, center];
    }

    cx = parsePercent$1(center[0], width) + viewRect.x;
    cy = parsePercent$1(center[1], height) + viewRect.y;
  }

  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r
  };
}
function pieLayout(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var viewRect = getViewRect(seriesModel, api);

    var _a = getBasicPieLayout(seriesModel, api),
        cx = _a.cx,
        cy = _a.cy,
        r = _a.r,
        r0 = _a.r0;

    var startAngle = -seriesModel.get('startAngle') * RADIAN;
    var minAngle = seriesModel.get('minAngle') * RADIAN;
    var validDataCount = 0;
    data.each(valueDim, function (value) {
      !isNaN(value) && validDataCount++;
    });
    var sum = data.getSum(valueDim); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var clockwise = seriesModel.get('clockwise');
    var roseType = seriesModel.get('roseType');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]

    var extent = data.getDataExtent(valueDim);
    extent[0] = 0; // In the case some sector angle is smaller than minAngle

    var restAngle = PI2$8;
    var valueSumLargerThanMinAngle = 0;
    var currentAngle = startAngle;
    var dir = clockwise ? 1 : -1;
    data.setLayout({
      viewRect: viewRect,
      r: r
    });
    data.each(valueDim, function (value, idx) {
      var angle;

      if (isNaN(value)) {
        data.setItemLayout(idx, {
          angle: NaN,
          startAngle: NaN,
          endAngle: NaN,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: r0,
          r: roseType ? NaN : r
        });
        return;
      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？


      if (roseType !== 'area') {
        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
      } else {
        angle = PI2$8 / validDataCount;
      }

      if (angle < minAngle) {
        angle = minAngle;
        restAngle -= minAngle;
      } else {
        valueSumLargerThanMinAngle += value;
      }

      var endAngle = currentAngle + dir * angle;
      data.setItemLayout(idx, {
        angle: angle,
        startAngle: currentAngle,
        endAngle: endAngle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: r0,
        r: roseType ? linearMap(value, extent, [r0, r]) : r
      });
      currentAngle = endAngle;
    }); // Some sector is constrained by minAngle
    // Rest sectors needs recalculate angle

    if (restAngle < PI2$8 && validDataCount) {
      // Average the angle if rest angle is not enough after all angles is
      // Constrained by minAngle
      if (restAngle <= 1e-3) {
        var angle_1 = PI2$8 / validDataCount;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout_1 = data.getItemLayout(idx);
            layout_1.angle = angle_1;
            layout_1.startAngle = startAngle + dir * idx * angle_1;
            layout_1.endAngle = startAngle + dir * (idx + 1) * angle_1;
          }
        });
      } else {
        unitRadian = restAngle / valueSumLargerThanMinAngle;
        currentAngle = startAngle;
        data.each(valueDim, function (value, idx) {
          if (!isNaN(value)) {
            var layout_2 = data.getItemLayout(idx);
            var angle = layout_2.angle === minAngle ? minAngle : value * unitRadian;
            layout_2.startAngle = currentAngle;
            layout_2.endAngle = currentAngle + dir * angle;
            currentAngle += dir * angle;
          }
        });
      }
    }
  });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function dataFilter(seriesType) {
  return {
    seriesType: seriesType,
    reset: function (seriesModel, ecModel) {
      var legendModels = ecModel.findComponents({
        mainType: 'legend'
      });

      if (!legendModels || !legendModels.length) {
        return;
      }

      var data = seriesModel.getData();
      data.filterSelf(function (idx) {
        var name = data.getName(idx); // If in any legend component the status is not selected.

        for (var i = 0; i < legendModels.length; i++) {
          // @ts-ignore FIXME: LegendModel
          if (!legendModels[i].isSelected(name)) {
            return false;
          }
        }

        return true;
      });
    }
  };
}

var RADIAN$1 = Math.PI / 180;

function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
  if (list.length < 2) {
    return;
  }

  function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
    var rB = semi.rB;
    var rB2 = rB * rB;

    for (var i = 0; i < semi.list.length; i++) {
      var item = semi.list[i];
      var dy = Math.abs(item.label.y - cy); // horizontal r is always same with original r because x is not changed.

      var rA = r + item.len;
      var rA2 = rA * rA; // Use ellipse implicit function to calculate x

      var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
      var newX = cx + (dx + item.len2) * dir;
      var deltaX = newX - item.label.x;
      var newTargetWidth = item.targetTextWidth - deltaX * dir; // text x is changed, so need to recalculate width.

      constrainTextWidth(item, newTargetWidth, true);
      item.label.x = newX;
    }
  } // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.


  function recalculateX(items) {
    // Extremes of
    var topSemi = {
      list: [],
      maxY: 0
    };
    var bottomSemi = {
      list: [],
      maxY: 0
    };

    for (var i = 0; i < items.length; i++) {
      if (items[i].labelAlignTo !== 'none') {
        continue;
      }

      var item = items[i];
      var semi = item.label.y > cy ? bottomSemi : topSemi;
      var dy = Math.abs(item.label.y - cy);

      if (dy >= semi.maxY) {
        var dx = item.label.x - cx - item.len2 * dir; // horizontal r is always same with original r because x is not changed.

        var rA = r + item.len; // Canculate rB based on the topest / bottemest label.

        var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
        semi.rB = rB;
        semi.maxY = dy;
      }

      semi.list.push(item);
    }

    recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
    recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
  }

  var len = list.length;

  for (var i = 0; i < len; i++) {
    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
      var dx = list[i].label.x - farthestX;
      list[i].linePoints[1][0] += dx;
      list[i].label.x = farthestX;
    }
  }

  if (shiftLayoutOnY(list, viewTop, viewTop + viewHeight)) {
    recalculateX(list);
  }
}

function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
  var leftList = [];
  var rightList = [];
  var leftmostX = Number.MAX_VALUE;
  var rightmostX = -Number.MAX_VALUE;

  for (var i = 0; i < labelLayoutList.length; i++) {
    var label = labelLayoutList[i].label;

    if (isPositionCenter(labelLayoutList[i])) {
      continue;
    }

    if (label.x < cx) {
      leftmostX = Math.min(leftmostX, label.x);
      leftList.push(labelLayoutList[i]);
    } else {
      rightmostX = Math.max(rightmostX, label.x);
      rightList.push(labelLayoutList[i]);
    }
  }

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];

    if (!isPositionCenter(layout) && layout.linePoints) {
      if (layout.labelStyleWidth != null) {
        continue;
      }

      var label = layout.label;
      var linePoints = layout.linePoints;
      var targetTextWidth = void 0;

      if (layout.labelAlignTo === 'edge') {
        if (label.x < cx) {
          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
        } else {
          targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
        }
      } else if (layout.labelAlignTo === 'labelLine') {
        if (label.x < cx) {
          targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
        }
      } else {
        if (label.x < cx) {
          targetTextWidth = label.x - viewLeft - layout.bleedMargin;
        } else {
          targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
        }
      }

      layout.targetTextWidth = targetTextWidth;
      constrainTextWidth(layout, targetTextWidth);
    }
  }

  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];

    if (!isPositionCenter(layout) && layout.linePoints) {
      var label = layout.label;
      var linePoints = layout.linePoints;
      var isAlignToEdge = layout.labelAlignTo === 'edge';
      var padding = label.style.padding;
      var paddingH = padding ? padding[1] + padding[3] : 0; // textRect.width already contains paddingH if bgColor is set

      var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
      var realTextWidth = layout.rect.width + extraPaddingH;
      var dist = linePoints[1][0] - linePoints[2][0];

      if (isAlignToEdge) {
        if (label.x < cx) {
          linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
        } else {
          linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
        }
      } else {
        if (label.x < cx) {
          linePoints[2][0] = label.x + layout.labelDistance;
        } else {
          linePoints[2][0] = label.x - layout.labelDistance;
        }

        linePoints[1][0] = linePoints[2][0] + dist;
      }

      linePoints[1][1] = linePoints[2][1] = label.y;
    }
  }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */


function constrainTextWidth(layout, availableWidth, forceRecalculate) {
  if (forceRecalculate === void 0) {
    forceRecalculate = false;
  }

  if (layout.labelStyleWidth != null) {
    // User-defined style.width has the highest priority.
    return;
  }

  var label = layout.label;
  var style = label.style;
  var textRect = layout.rect;
  var bgColor = style.backgroundColor;
  var padding = style.padding;
  var paddingH = padding ? padding[1] + padding[3] : 0;
  var overflow = style.overflow; // textRect.width already contains paddingH if bgColor is set

  var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);

  if (availableWidth < oldOuterWidth || forceRecalculate) {
    var oldHeight = textRect.height;

    if (overflow && overflow.match('break')) {
      // Temporarily set background to be null to calculate
      // the bounding box without background.
      label.setStyle('backgroundColor', null); // Set constraining width

      label.setStyle('width', availableWidth - paddingH); // This is the real bounding box of the text without padding.

      var innerRect = label.getBoundingRect();
      label.setStyle('width', Math.ceil(innerRect.width));
      label.setStyle('backgroundColor', bgColor);
    } else {
      var availableInnerWidth = availableWidth - paddingH;
      var newWidth = availableWidth < oldOuterWidth // Current text is too wide, use `availableWidth` as max width.
      ? availableInnerWidth : // Current available width is enough, but the text may have
      // already been wrapped with a smaller available width.
      forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth // Current available is larger than text width,
      // so don't constrain width (otherwise it may have
      // empty space in the background).
      ? null // Current available is smaller than text width, so
      // use the current available width as constraining
      // width.
      : availableInnerWidth : // Current available width is enough, so no need to
      // constrain.
      null;
      label.setStyle('width', newWidth);
    }

    var newRect = label.getBoundingRect();
    textRect.width = newRect.width;
    var margin = (label.style.margin || 0) + 2.1;
    textRect.height = newRect.height + margin;
    textRect.y -= (textRect.height - oldHeight) / 2;
  }
}

function isPositionCenter(sectorShape) {
  // Not change x for center label
  return sectorShape.position === 'center';
}

function pieLabelLayout(seriesModel) {
  var data = seriesModel.getData();
  var labelLayoutList = [];
  var cx;
  var cy;
  var hasLabelRotate = false;
  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN$1;
  var viewRect = data.getLayout('viewRect');
  var r = data.getLayout('r');
  var viewWidth = viewRect.width;
  var viewLeft = viewRect.x;
  var viewTop = viewRect.y;
  var viewHeight = viewRect.height;

  function setNotShow(el) {
    el.ignore = true;
  }

  function isLabelShown(label) {
    if (!label.ignore) {
      return true;
    }

    for (var key in label.states) {
      if (label.states[key].ignore === false) {
        return true;
      }
    }

    return false;
  }

  data.each(function (idx) {
    var sector = data.getItemGraphicEl(idx);
    var sectorShape = sector.shape;
    var label = sector.getTextContent();
    var labelLine = sector.getTextGuideLine();
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis

    var labelPosition = labelModel.get('position') || itemModel.get(['emphasis', 'label', 'position']);
    var labelDistance = labelModel.get('distanceToLabelLine');
    var labelAlignTo = labelModel.get('alignTo');
    var edgeDistance = parsePercent$1(labelModel.get('edgeDistance'), viewWidth);
    var bleedMargin = labelModel.get('bleedMargin');
    var labelLineModel = itemModel.getModel('labelLine');
    var labelLineLen = labelLineModel.get('length');
    labelLineLen = parsePercent$1(labelLineLen, viewWidth);
    var labelLineLen2 = labelLineModel.get('length2');
    labelLineLen2 = parsePercent$1(labelLineLen2, viewWidth);

    if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
      each(label.states, setNotShow);
      label.ignore = true;

      if (labelLine) {
        each(labelLine.states, setNotShow);
        labelLine.ignore = true;
      }

      return;
    }

    if (!isLabelShown(label)) {
      return;
    }

    var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
    var nx = Math.cos(midAngle);
    var ny = Math.sin(midAngle);
    var textX;
    var textY;
    var linePoints;
    var textAlign;
    cx = sectorShape.cx;
    cy = sectorShape.cy;
    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';

    if (labelPosition === 'center') {
      textX = sectorShape.cx;
      textY = sectorShape.cy;
      textAlign = 'center';
    } else {
      var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
      var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
      textX = x1 + nx * 3;
      textY = y1 + ny * 3;

      if (!isLabelInside) {
        // For roseType
        var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
        var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
        var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
        var y3 = y2;

        if (labelAlignTo === 'edge') {
          // Adjust textX because text align of edge is opposite
          textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
        } else {
          textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
        }

        textY = y3;
        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
      }

      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
    }

    var PI = Math.PI;
    var labelRotate = 0;
    var rotate = labelModel.get('rotate');

    if (isNumber$1(rotate)) {
      labelRotate = rotate * (PI / 180);
    } else if (labelPosition === 'center') {
      labelRotate = 0;
    } else if (rotate === 'radial' || rotate === true) {
      var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
      labelRotate = radialAngle;
    } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
      var rad = Math.atan2(nx, ny);

      if (rad < 0) {
        rad = PI * 2 + rad;
      }

      var isDown = ny > 0;

      if (isDown) {
        rad = PI + rad;
      }

      labelRotate = rad - PI;
    }

    hasLabelRotate = !!labelRotate;
    label.x = textX;
    label.y = textY;
    label.rotation = labelRotate;
    label.setStyle({
      verticalAlign: 'middle'
    }); // Not sectorShape the inside label

    if (!isLabelInside) {
      var textRect = label.getBoundingRect().clone();
      textRect.applyTransform(label.getComputedTransform()); // Text has a default 1px stroke. Exclude this.

      var margin = (label.style.margin || 0) + 2.1;
      textRect.y -= margin / 2;
      textRect.height += margin;
      labelLayoutList.push({
        label: label,
        labelLine: labelLine,
        position: labelPosition,
        len: labelLineLen,
        len2: labelLineLen2,
        minTurnAngle: labelLineModel.get('minTurnAngle'),
        maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
        surfaceNormal: new Point(nx, ny),
        linePoints: linePoints,
        textAlign: textAlign,
        labelDistance: labelDistance,
        labelAlignTo: labelAlignTo,
        edgeDistance: edgeDistance,
        bleedMargin: bleedMargin,
        rect: textRect,
        unconstrainedWidth: textRect.width,
        labelStyleWidth: label.style.width
      });
    } else {
      label.setStyle({
        align: textAlign
      });
      var selectState = label.states.select;

      if (selectState) {
        selectState.x += label.x;
        selectState.y += label.y;
      }
    }

    sector.setTextConfig({
      inside: isLabelInside
    });
  });

  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
  }

  for (var i = 0; i < labelLayoutList.length; i++) {
    var layout = labelLayoutList[i];
    var label = layout.label;
    var labelLine = layout.labelLine;
    var notShowLabel = isNaN(label.x) || isNaN(label.y);

    if (label) {
      label.setStyle({
        align: layout.textAlign
      });

      if (notShowLabel) {
        each(label.states, setNotShow);
        label.ignore = true;
      }

      var selectState = label.states.select;

      if (selectState) {
        selectState.x += label.x;
        selectState.y += label.y;
      }
    }

    if (labelLine) {
      var linePoints = layout.linePoints;

      if (notShowLabel || !linePoints) {
        each(labelLine.states, setNotShow);
        labelLine.ignore = true;
      } else {
        limitTurnAngle(linePoints, layout.minTurnAngle);
        limitSurfaceAngle(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
        labelLine.setShape({
          points: linePoints
        }); // Set the anchor to the midpoint of sector

        label.__hostTarget.textGuideLineConfig = {
          anchor: new Point(linePoints[0][0], linePoints[0][1])
        };
      }
    }
  }
}

function getSectorCornerRadius(model, shape, zeroIfNull) {
  var cornerRadius = model.get('borderRadius');

  if (cornerRadius == null) {
    return zeroIfNull ? {
      cornerRadius: 0
    } : null;
  }

  if (!isArray$1(cornerRadius)) {
    cornerRadius = [cornerRadius, cornerRadius, cornerRadius, cornerRadius];
  }

  var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
  return {
    cornerRadius: map(cornerRadius, function (cr) {
      return parsePercent(cr, dr);
    })
  };
}

/**
 * Piece of pie including Sector, Label, LabelLine
 */

var PiePiece =
/** @class */
function (_super) {
  __extends$1(PiePiece, _super);

  function PiePiece(data, idx, startAngle) {
    var _this = _super.call(this) || this;

    _this.z2 = 2;
    var text = new ZRText();

    _this.setTextContent(text);

    _this.updateData(data, idx, startAngle, true);

    return _this;
  }

  PiePiece.prototype.updateData = function (data, idx, startAngle, firstCreate) {
    var sector = this;
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var emphasisModel = itemModel.getModel('emphasis');
    var layout = data.getItemLayout(idx); // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
    // see `setItemLayout` in `pieLayout.ts`.

    var sectorShape = extend(getSectorCornerRadius(itemModel.getModel('itemStyle'), layout, true), layout); // Ignore NaN data.

    if (isNaN(sectorShape.startAngle)) {
      // Use NaN shape to avoid drawing shape.
      sector.setShape(sectorShape);
      return;
    }

    if (firstCreate) {
      sector.setShape(sectorShape);
      var animationType = seriesModel.getShallow('animationType');

      if (seriesModel.ecModel.ssr) {
        // Use scale animation in SSR mode(opacity?)
        // Because CSS SVG animation doesn't support very customized shape animation.
        initProps(sector, {
          scaleX: 0,
          scaleY: 0
        }, seriesModel, {
          dataIndex: idx,
          isFrom: true
        });
        sector.originX = sectorShape.cx;
        sector.originY = sectorShape.cy;
      } else if (animationType === 'scale') {
        sector.shape.r = layout.r0;
        initProps(sector, {
          shape: {
            r: layout.r
          }
        }, seriesModel, idx);
      } // Expansion
      else {
          if (startAngle != null) {
            sector.setShape({
              startAngle: startAngle,
              endAngle: startAngle
            });
            initProps(sector, {
              shape: {
                startAngle: layout.startAngle,
                endAngle: layout.endAngle
              }
            }, seriesModel, idx);
          } else {
            sector.shape.endAngle = layout.startAngle;
            updateProps(sector, {
              shape: {
                endAngle: layout.endAngle
              }
            }, seriesModel, idx);
          }
        }
    } else {
      saveOldStyle(sector); // Transition animation from the old shape

      updateProps(sector, {
        shape: sectorShape
      }, seriesModel, idx);
    }

    sector.useStyle(data.getItemVisual(idx, 'style'));
    setStatesStylesFromModel(sector, itemModel);
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var offset = seriesModel.get('selectedOffset');
    var dx = Math.cos(midAngle) * offset;
    var dy = Math.sin(midAngle) * offset;
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && sector.attr('cursor', cursorStyle);

    this._updateLabel(seriesModel, data, idx);

    sector.ensureState('emphasis').shape = extend({
      r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
    }, getSectorCornerRadius(emphasisModel.getModel('itemStyle'), layout));
    extend(sector.ensureState('select'), {
      x: dx,
      y: dy,
      shape: getSectorCornerRadius(itemModel.getModel(['select', 'itemStyle']), layout)
    });
    extend(sector.ensureState('blur'), {
      shape: getSectorCornerRadius(itemModel.getModel(['blur', 'itemStyle']), layout)
    });
    var labelLine = sector.getTextGuideLine();
    var labelText = sector.getTextContent();
    labelLine && extend(labelLine.ensureState('select'), {
      x: dx,
      y: dy
    }); // TODO: needs dx, dy in zrender?

    extend(labelText.ensureState('select'), {
      x: dx,
      y: dy
    });
    toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  PiePiece.prototype._updateLabel = function (seriesModel, data, idx) {
    var sector = this;
    var itemModel = data.getItemModel(idx);
    var labelLineModel = itemModel.getModel('labelLine');
    var style = data.getItemVisual(idx, 'style');
    var visualColor = style && style.fill;
    var visualOpacity = style && style.opacity;
    setLabelStyle(sector, getLabelStatesModels(itemModel), {
      labelFetcher: data.hostModel,
      labelDataIndex: idx,
      inheritColor: visualColor,
      defaultOpacity: visualOpacity,
      defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
    });
    var labelText = sector.getTextContent(); // Set textConfig on sector.

    sector.setTextConfig({
      // reset position, rotation
      position: null,
      rotation: null
    }); // Make sure update style on labelText after setLabelStyle.
    // Because setLabelStyle will replace a new style on it.

    labelText.attr({
      z2: 10
    });
    var labelPosition = seriesModel.get(['label', 'position']);

    if (labelPosition !== 'outside' && labelPosition !== 'outer') {
      sector.removeTextGuideLine();
    } else {
      var polyline = this.getTextGuideLine();

      if (!polyline) {
        polyline = new Polyline();
        this.setTextGuideLine(polyline);
      } // Default use item visual color


      setLabelLineStyle(this, getLabelLineStatesModels(itemModel), {
        stroke: visualColor,
        opacity: retrieve3(labelLineModel.get(['lineStyle', 'opacity']), visualOpacity, 1)
      });
    }
  };

  return PiePiece;
}(Sector); // Pie view


var PieView =
/** @class */
function (_super) {
  __extends$1(PieView, _super);

  function PieView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ignoreLabelLineUpdate = true;
    return _this;
  }

  PieView.prototype.render = function (seriesModel, ecModel, api, payload) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var startAngle; // First render

    if (!oldData && data.count() > 0) {
      var shape = data.getItemLayout(0);

      for (var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s) {
        shape = data.getItemLayout(s);
      }

      if (shape) {
        startAngle = shape.startAngle;
      }
    } // remove empty-circle if it exists


    if (this._emptyCircleSector) {
      group.remove(this._emptyCircleSector);
    } // when all data are filtered, show lightgray empty circle


    if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
      var sector = new Sector({
        shape: getBasicPieLayout(seriesModel, api)
      });
      sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
      this._emptyCircleSector = sector;
      group.add(sector);
    }

    data.diff(oldData).add(function (idx) {
      var piePiece = new PiePiece(data, idx, startAngle);
      data.setItemGraphicEl(idx, piePiece);
      group.add(piePiece);
    }).update(function (newIdx, oldIdx) {
      var piePiece = oldData.getItemGraphicEl(oldIdx);
      piePiece.updateData(data, newIdx, startAngle);
      piePiece.off('click');
      group.add(piePiece);
      data.setItemGraphicEl(newIdx, piePiece);
    }).remove(function (idx) {
      var piePiece = oldData.getItemGraphicEl(idx);
      removeElementWithFadeOut(piePiece, seriesModel, idx);
    }).execute();
    pieLabelLayout(seriesModel); // Always use initial animation.

    if (seriesModel.get('animationTypeUpdate') !== 'expansion') {
      this._data = data;
    }
  };

  PieView.prototype.dispose = function () {};

  PieView.prototype.containPoint = function (point, seriesModel) {
    var data = seriesModel.getData();
    var itemLayout = data.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  };

  PieView.type = 'pie';
  return PieView;
}(ChartView);

/**
 * [Usage]:
 * (1)
 * createListSimply(seriesModel, ['value']);
 * (2)
 * createListSimply(seriesModel, {
 *     coordDimensions: ['value'],
 *     dimensionsCount: 5
 * });
 */

function createSeriesDataSimply(seriesModel, opt, nameList) {
  opt = isArray$1(opt) && {
    coordDimensions: opt
  } || extend({
    encodeDefine: seriesModel.getEncode()
  }, opt);
  var source = seriesModel.getSource();
  var dimensions = prepareSeriesDataSchema(source, opt).dimensions;
  var list = new SeriesData(dimensions, seriesModel);
  list.initData(source, nameList);
  return list;
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */
var LegendVisualProvider =
/** @class */
function () {
  function LegendVisualProvider( // Function to get data after filtered. It stores all the encoding info
  getDataWithEncodedVisual, // Function to get raw data before filtered.
  getRawData) {
    this._getDataWithEncodedVisual = getDataWithEncodedVisual;
    this._getRawData = getRawData;
  }

  LegendVisualProvider.prototype.getAllNames = function () {
    var rawData = this._getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.


    return rawData.mapArray(rawData.getName);
  };

  LegendVisualProvider.prototype.containName = function (name) {
    var rawData = this._getRawData();

    return rawData.indexOfName(name) >= 0;
  };

  LegendVisualProvider.prototype.indexOfName = function (name) {
    // Only get data when necessary.
    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
    // Invoking Series#getData immediately will throw an error.
    var dataWithEncodedVisual = this._getDataWithEncodedVisual();

    return dataWithEncodedVisual.indexOfName(name);
  };

  LegendVisualProvider.prototype.getItemVisual = function (dataIndex, key) {
    // Get encoded visual properties from final filtered data.
    var dataWithEncodedVisual = this._getDataWithEncodedVisual();

    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
  };

  return LegendVisualProvider;
}();

var innerData = makeInner();

var PieSeriesModel =
/** @class */
function (_super) {
  __extends$1(PieSeriesModel, _super);

  function PieSeriesModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));

    this._defaultLabelLine(option);
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.mergeOption = function () {
    _super.prototype.mergeOption.apply(this, arguments);
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.getInitialData = function () {
    return createSeriesDataSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
    });
  };
  /**
   * @overwrite
   */


  PieSeriesModel.prototype.getDataParams = function (dataIndex) {
    var data = this.getData(); // update seats when data is changed

    var dataInner = innerData(data);
    var seats = dataInner.seats;

    if (!seats) {
      var valueList_1 = [];
      data.each(data.mapDimension('value'), function (value) {
        valueList_1.push(value);
      });
      seats = dataInner.seats = getPercentSeats(valueList_1, data.hostModel.get('percentPrecision'));
    }

    var params = _super.prototype.getDataParams.call(this, dataIndex); // seats may be empty when sum is 0


    params.percent = seats[dataIndex] || 0;
    params.$vars.push('percent');
    return params;
  };

  PieSeriesModel.prototype._defaultLabelLine = function (option) {
    // Extend labelLine emphasis
    defaultEmphasis(option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  };

  PieSeriesModel.type = 'series.pie';
  PieSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    colorBy: 'data',
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // If the angle of a sector less than `minShowLabelAngle`,
    // the label will not be displayed.
    minShowLabelAngle: 0,
    // 选中时扇区偏移量
    selectedOffset: 10,
    // 选择模式，默认关闭，可选single，multiple
    // selectedMode: false,
    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
    // roseType: null,
    percentPrecision: 2,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // cursor: null,
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: null,
    height: null,
    label: {
      // color: 'inherit',
      // If rotate around circle
      rotate: 0,
      show: true,
      overflow: 'truncate',
      // 'outer', 'inside', 'center'
      position: 'outer',
      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
      alignTo: 'none',
      // Closest distance between label and chart edge.
      // Works only position is 'outer' and alignTo is 'edge'.
      edgeDistance: '25%',
      // Works only position is 'outer' and alignTo is not 'edge'.
      bleedMargin: 10,
      // Distance between text and label line.
      distanceToLabelLine: 5 // formatter: 标签文本格式器，同 tooltip.formatter，不支持异步回调
      // 默认使用全局文本样式，详见 textStyle
      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数

    },
    // Enabled when label.normal.position is 'outer'
    labelLine: {
      show: true,
      // 引导线两段中的第一段长度
      length: 15,
      // 引导线两段中的第二段长度
      length2: 15,
      smooth: false,
      minTurnAngle: 90,
      maxSurfaceAngle: 90,
      lineStyle: {
        // color: 各异,
        width: 1,
        type: 'solid'
      }
    },
    itemStyle: {
      borderWidth: 1,
      borderJoin: 'round'
    },
    showEmptyCircle: true,
    emptyCircleStyle: {
      color: 'lightgray',
      opacity: 1
    },
    labelLayout: {
      // Hide the overlapped label.
      hideOverlap: true
    },
    emphasis: {
      scale: true,
      scaleSize: 5
    },
    // If use strategy to avoid label overlapping
    avoidLabelOverlap: true,
    // Animation type. Valid values: expansion, scale
    animationType: 'expansion',
    animationDuration: 1000,
    // Animation type when update. Valid values: transition, expansion
    animationTypeUpdate: 'transition',
    animationEasingUpdate: 'cubicInOut',
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut'
  };
  return PieSeriesModel;
}(SeriesModel);

function negativeDataFilter(seriesType) {
  return {
    seriesType: seriesType,
    reset: function (seriesModel, ecModel) {
      var data = seriesModel.getData();
      data.filterSelf(function (idx) {
        // handle negative value condition
        var valueDim = data.mapDimension('value');
        var curValue = data.get(valueDim, idx);

        if (isNumber$1(curValue) && !isNaN(curValue) && curValue < 0) {
          return false;
        }

        return true;
      });
    }
  };
}

function install$4(registers) {
  registers.registerChartView(PieView);
  registers.registerSeriesModel(PieSeriesModel);
  createLegacyDataSelectAction('pie', registers.registerAction);
  registers.registerLayout(curry(pieLayout, 'pie'));
  registers.registerProcessor(dataFilter('pie'));
  registers.registerProcessor(negativeDataFilter('pie'));
}

var ScatterSeriesModel =
/** @class */
function (_super) {
  __extends$1(ScatterSeriesModel, _super);

  function ScatterSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScatterSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  ScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this, {
      useEncodeDefaulter: true
    });
  };

  ScatterSeriesModel.prototype.getProgressive = function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      // PENDING
      return this.option.large ? 5e3 : this.get('progressive');
    }

    return progressive;
  };

  ScatterSeriesModel.prototype.getProgressiveThreshold = function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      // PENDING
      return this.option.large ? 1e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  };

  ScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.point(data.getItemLayout(dataIndex));
  };

  ScatterSeriesModel.prototype.getZLevelKey = function () {
    // Each progressive series has individual key.
    return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
  };

  ScatterSeriesModel.type = 'series.scatter';
  ScatterSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  ScatterSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    symbolSize: 10,
    // symbolRotate: null,  // 图形旋转控制
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    // cursor: null,
    itemStyle: {
      opacity: 0.8 // color: 各异

    },
    emphasis: {
      scale: true
    },
    // If clip the overflow graphics
    // Works on cartesian / polar series
    clip: true,
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    universalTransition: {
      divideShape: 'clone'
    } // progressive: null

  };
  return ScatterSeriesModel;
}(SeriesModel);

var BOOST_SIZE_THRESHOLD = 4;

var LargeSymbolPathShape =
/** @class */
function () {
  function LargeSymbolPathShape() {}

  return LargeSymbolPathShape;
}();

var LargeSymbolPath =
/** @class */
function (_super) {
  __extends$1(LargeSymbolPath, _super);

  function LargeSymbolPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this._off = 0;
    _this.hoverDataIdx = -1;
    return _this;
  }

  LargeSymbolPath.prototype.getDefaultShape = function () {
    return new LargeSymbolPathShape();
  };

  LargeSymbolPath.prototype.reset = function () {
    this.notClear = false;
    this._off = 0;
  };

  LargeSymbolPath.prototype.buildPath = function (path, shape) {
    var points = shape.points;
    var size = shape.size;
    var symbolProxy = this.symbolProxy;
    var symbolProxyShape = symbolProxy.shape;
    var ctx = path.getContext ? path.getContext() : path;
    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD;
    var softClipShape = this.softClipShape;
    var i; // Do draw in afterBrush.

    if (canBoost) {
      this._ctx = ctx;
      return;
    }

    this._ctx = null;

    for (i = this._off; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (softClipShape && !softClipShape.contain(x, y)) {
        continue;
      }

      symbolProxyShape.x = x - size[0] / 2;
      symbolProxyShape.y = y - size[1] / 2;
      symbolProxyShape.width = size[0];
      symbolProxyShape.height = size[1];
      symbolProxy.buildPath(path, symbolProxyShape, true);
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeSymbolPath.prototype.afterBrush = function () {
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var ctx = this._ctx;
    var softClipShape = this.softClipShape;
    var i;

    if (!ctx) {
      return;
    } // PENDING If style or other canvas status changed?


    for (i = this._off; i < points.length;) {
      var x = points[i++];
      var y = points[i++];

      if (isNaN(x) || isNaN(y)) {
        continue;
      }

      if (softClipShape && !softClipShape.contain(x, y)) {
        continue;
      } // fillRect is faster than building a rect path and draw.
      // And it support light globalCompositeOperation.


      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeSymbolPath.prototype.findDataIndex = function (x, y) {
    // TODO ???
    // Consider transform
    var shape = this.shape;
    var points = shape.points;
    var size = shape.size;
    var w = Math.max(size[0], 4);
    var h = Math.max(size[1], 4); // Not consider transform
    // Treat each element as a rect
    // top down traverse

    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
      var i = idx * 2;
      var x0 = points[i] - w / 2;
      var y0 = points[i + 1] - h / 2;

      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
        return idx;
      }
    }

    return -1;
  };

  LargeSymbolPath.prototype.contain = function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      // Cache found data index.
      var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
      return dataIdx >= 0;
    }

    this.hoverDataIdx = -1;
    return false;
  };

  LargeSymbolPath.prototype.getBoundingRect = function () {
    // Ignore stroke for large symbol draw.
    var rect = this._rect;

    if (!rect) {
      var shape = this.shape;
      var points = shape.points;
      var size = shape.size;
      var w = size[0];
      var h = size[1];
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;

      for (var i = 0; i < points.length;) {
        var x = points[i++];
        var y = points[i++];
        minX = Math.min(x, minX);
        maxX = Math.max(x, maxX);
        minY = Math.min(y, minY);
        maxY = Math.max(y, maxY);
      }

      rect = this._rect = new BoundingRect(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
    }

    return rect;
  };

  return LargeSymbolPath;
}(Path);

var LargeSymbolDraw =
/** @class */
function () {
  function LargeSymbolDraw() {
    this.group = new Group$1();
  }
  /**
   * Update symbols draw by new data
   */


  LargeSymbolDraw.prototype.updateData = function (data, opt) {
    this._clear();

    var symbolEl = this._create();

    symbolEl.setShape({
      points: data.getLayout('points')
    });

    this._setCommon(symbolEl, data, opt);
  };

  LargeSymbolDraw.prototype.updateLayout = function (data) {
    var points = data.getLayout('points');
    this.group.eachChild(function (child) {
      if (child.startIndex != null) {
        var len = (child.endIndex - child.startIndex) * 2;
        var byteOffset = child.startIndex * 4 * 2;
        points = new Float32Array(points.buffer, byteOffset, len);
      }

      child.setShape('points', points); // Reset draw cursor.

      child.reset();
    });
  };

  LargeSymbolDraw.prototype.incrementalPrepareUpdate = function (data) {
    this._clear();
  };

  LargeSymbolDraw.prototype.incrementalUpdate = function (taskParams, data, opt) {
    var lastAdded = this._newAdded[0];
    var points = data.getLayout('points');
    var oldPoints = lastAdded && lastAdded.shape.points; // Merging the exists. Each element has 1e4 points.
    // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)

    if (oldPoints && oldPoints.length < 2e4) {
      var oldLen = oldPoints.length;
      var newPoints = new Float32Array(oldLen + points.length); // Concat two array

      newPoints.set(oldPoints);
      newPoints.set(points, oldLen); // Update endIndex

      lastAdded.endIndex = taskParams.end;
      lastAdded.setShape({
        points: newPoints
      });
    } else {
      // Clear
      this._newAdded = [];

      var symbolEl = this._create();

      symbolEl.startIndex = taskParams.start;
      symbolEl.endIndex = taskParams.end;
      symbolEl.incremental = true;
      symbolEl.setShape({
        points: points
      });

      this._setCommon(symbolEl, data, opt);
    }
  };

  LargeSymbolDraw.prototype.eachRendered = function (cb) {
    this._newAdded[0] && cb(this._newAdded[0]);
  };

  LargeSymbolDraw.prototype._create = function () {
    var symbolEl = new LargeSymbolPath({
      cursor: 'default'
    });
    symbolEl.ignoreCoarsePointer = true;
    this.group.add(symbolEl);

    this._newAdded.push(symbolEl);

    return symbolEl;
  };

  LargeSymbolDraw.prototype._setCommon = function (symbolEl, data, opt) {
    var hostModel = data.hostModel;
    opt = opt || {};
    var size = data.getVisual('symbolSize');
    symbolEl.setShape('size', size instanceof Array ? size : [size, size]);
    symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data

    symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method

    symbolEl.setColor = symbolEl.symbolProxy.setColor;
    var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
    symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
    hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
    var globalStyle = data.getVisual('style');
    var visualColor = globalStyle && globalStyle.fill;

    if (visualColor) {
      symbolEl.setColor(visualColor);
    }

    var ecData = getECData(symbolEl); // Enable tooltip
    // PENDING May have performance issue when path is extremely large

    ecData.seriesIndex = hostModel.seriesIndex;
    symbolEl.on('mousemove', function (e) {
      ecData.dataIndex = null;
      var dataIndex = symbolEl.hoverDataIdx;

      if (dataIndex >= 0) {
        // Provide dataIndex for tooltip
        ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
      }
    });
  };

  LargeSymbolDraw.prototype.remove = function () {
    this._clear();
  };

  LargeSymbolDraw.prototype._clear = function () {
    this._newAdded = [];
    this.group.removeAll();
  };

  return LargeSymbolDraw;
}();

var ScatterView =
/** @class */
function (_super) {
  __extends$1(ScatterView, _super);

  function ScatterView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScatterView.type;
    return _this;
  }

  ScatterView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.updateData(data, {
      // TODO
      // If this parameter should be a shape or a bounding volume
      // shape will be more general.
      // But bounding volume like bounding rect will be much faster in the contain calculation
      clipShape: this._getClipShape(seriesModel)
    });
    this._finished = true;
  };

  ScatterView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var symbolDraw = this._updateSymbolDraw(data, seriesModel);

    symbolDraw.incrementalPrepareUpdate(data);
    this._finished = false;
  };

  ScatterView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
      clipShape: this._getClipShape(seriesModel)
    });

    this._finished = taskParams.end === seriesModel.getData().count();
  };

  ScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
    // PENDING

    this.group.dirty();

    if (!this._finished || data.count() > 1e4) {
      return {
        update: true
      };
    } else {
      var res = pointsLayout('').reset(seriesModel, ecModel, api);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count(),
          count: data.count()
        }, data);
      }

      this._symbolDraw.updateLayout(data);
    }
  };

  ScatterView.prototype.eachRendered = function (cb) {
    this._symbolDraw && this._symbolDraw.eachRendered(cb);
  };

  ScatterView.prototype._getClipShape = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
    return seriesModel.get('clip', true) ? clipArea : null;
  };

  ScatterView.prototype._updateSymbolDraw = function (data, seriesModel) {
    var symbolDraw = this._symbolDraw;
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
      symbolDraw && symbolDraw.remove();
      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
      this._isLargeDraw = isLargeDraw;
      this.group.removeAll();
    }

    this.group.add(symbolDraw.group);
    return symbolDraw;
  };

  ScatterView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(true);
    this._symbolDraw = null;
  };

  ScatterView.prototype.dispose = function () {};

  ScatterView.type = 'scatter';
  return ScatterView;
}(ChartView);

var GridModel =
/** @class */
function (_super) {
  __extends$1(GridModel, _super);

  function GridModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GridModel.type = 'grid';
  GridModel.dependencies = ['xAxis', 'yAxis'];
  GridModel.layoutMode = 'box';
  GridModel.defaultOption = {
    show: false,
    // zlevel: 0,
    z: 0,
    left: '10%',
    top: 60,
    right: '10%',
    bottom: 70,
    // If grid size contain label
    containLabel: false,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    backgroundColor: 'rgba(0,0,0,0)',
    borderWidth: 1,
    borderColor: '#ccc'
  };
  return GridModel;
}(ComponentModel);

var CartesianAxisModel =
/** @class */
function (_super) {
  __extends$1(CartesianAxisModel, _super);

  function CartesianAxisModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  CartesianAxisModel.prototype.getCoordSysModel = function () {
    return this.getReferringComponents('grid', SINGLE_REFERRING).models[0];
  };

  CartesianAxisModel.type = 'cartesian2dAxis';
  return CartesianAxisModel;
}(ComponentModel);
mixin(CartesianAxisModel, AxisModelCommonMixin);

var defaultOption = {
  show: true,
  // zlevel: 0,
  z: 0,
  // Inverse the axis.
  inverse: false,
  // Axis name displayed.
  name: '',
  // 'start' | 'middle' | 'end'
  nameLocation: 'end',
  // By degree. By default auto rotate by nameLocation.
  nameRotate: null,
  nameTruncate: {
    maxWidth: null,
    ellipsis: '...',
    placeholder: '.'
  },
  // Use global text style by default.
  nameTextStyle: {},
  // The gap between axisName and axisLine.
  nameGap: 15,
  // Default `false` to support tooltip.
  silent: false,
  // Default `false` to avoid legacy user event listener fail.
  triggerEvent: false,
  tooltip: {
    show: false
  },
  axisPointer: {},
  axisLine: {
    show: true,
    onZero: true,
    onZeroAxisIndex: null,
    lineStyle: {
      color: '#6E7079',
      width: 1,
      type: 'solid'
    },
    // The arrow at both ends the the axis.
    symbol: ['none', 'none'],
    symbolSize: [10, 15]
  },
  axisTick: {
    show: true,
    // Whether axisTick is inside the grid or outside the grid.
    inside: false,
    // The length of axisTick.
    length: 5,
    lineStyle: {
      width: 1
    }
  },
  axisLabel: {
    show: true,
    // Whether axisLabel is inside the grid or outside the grid.
    inside: false,
    rotate: 0,
    // true | false | null/undefined (auto)
    showMinLabel: null,
    // true | false | null/undefined (auto)
    showMaxLabel: null,
    margin: 8,
    // formatter: null,
    fontSize: 12
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: ['#E0E6F1'],
      width: 1,
      type: 'solid'
    }
  },
  splitArea: {
    show: false,
    areaStyle: {
      color: ['rgba(250,250,250,0.2)', 'rgba(210,219,238,0.2)']
    }
  }
};
var categoryAxis = merge$1({
  // The gap at both ends of the axis. For categoryAxis, boolean.
  boundaryGap: true,
  // Set false to faster category collection.
  deduplication: null,
  // splitArea: {
  // show: false
  // },
  splitLine: {
    show: false
  },
  axisTick: {
    // If tick is align with label when boundaryGap is true
    alignWithLabel: false,
    interval: 'auto'
  },
  axisLabel: {
    interval: 'auto'
  }
}, defaultOption);
var valueAxis = merge$1({
  boundaryGap: [0, 0],
  axisLine: {
    // Not shown when other axis is categoryAxis in cartesian
    show: 'auto'
  },
  axisTick: {
    // Not shown when other axis is categoryAxis in cartesian
    show: 'auto'
  },
  // TODO
  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
  splitNumber: 5,
  minorTick: {
    // Minor tick, not available for cateogry axis.
    show: false,
    // Split number of minor ticks. The value should be in range of (0, 100)
    splitNumber: 5,
    // Length of minor tick
    length: 3,
    // Line style
    lineStyle: {// Default to be same with axisTick
    }
  },
  minorSplitLine: {
    show: false,
    lineStyle: {
      color: '#F4F7FD',
      width: 1
    }
  }
}, defaultOption);
var timeAxis = merge$1({
  splitNumber: 6,
  axisLabel: {
    // To eliminate labels that are not nice
    showMinLabel: false,
    showMaxLabel: false,
    rich: {
      primary: {
        fontWeight: 'bold'
      }
    }
  },
  splitLine: {
    show: false
  }
}, valueAxis);
var logAxis = defaults({
  logBase: 10
}, valueAxis);
var axisDefault = {
  category: categoryAxis,
  value: valueAxis,
  time: timeAxis,
  log: logAxis
};

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var AXIS_TYPES = {
  value: 1,
  category: 1,
  time: 1,
  log: 1
};

/**
 * Generate sub axis model class
 * @param axisName 'x' 'y' 'radius' 'angle' 'parallel' ...
 */

function axisModelCreator(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
  each(AXIS_TYPES, function (v, axisType) {
    var defaultOption = merge$1(merge$1({}, axisDefault[axisType], true), extraDefaultOption, true);

    var AxisModel =
    /** @class */
    function (_super) {
      __extends$1(AxisModel, _super);

      function AxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.type = axisName + 'Axis.' + axisType;
        return _this;
      }

      AxisModel.prototype.mergeDefaultAndTheme = function (option, ecModel) {
        var layoutMode = fetchLayoutMode(this);
        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
        var themeModel = ecModel.getTheme();
        merge$1(option, themeModel.get(axisType + 'Axis'));
        merge$1(option, this.getDefaultOption());
        option.type = getAxisType(option);

        if (layoutMode) {
          mergeLayoutParam(option, inputPositionParams, layoutMode);
        }
      };

      AxisModel.prototype.optionUpdated = function () {
        var thisOption = this.option;

        if (thisOption.type === 'category') {
          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
        }
      };
      /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */


      AxisModel.prototype.getCategories = function (rawData) {
        var option = this.option; // FIXME
        // warning if called before all of 'getInitailData' finished.

        if (option.type === 'category') {
          if (rawData) {
            return option.data;
          }

          return this.__ordinalMeta.categories;
        }
      };

      AxisModel.prototype.getOrdinalMeta = function () {
        return this.__ordinalMeta;
      };

      AxisModel.type = axisName + 'Axis.' + axisType;
      AxisModel.defaultOption = defaultOption;
      return AxisModel;
    }(BaseAxisModelClass);

    registers.registerComponentModel(AxisModel);
  });
  registers.registerSubTypeDefaulter(axisName + 'Axis', getAxisType);
}

function getAxisType(option) {
  // Default axis with data is category axis
  return option.type || (option.data ? 'category' : 'value');
}

var Cartesian =
/** @class */
function () {
  function Cartesian(name) {
    this.type = 'cartesian';
    this._dimList = [];
    this._axes = {};
    this.name = name || '';
  }

  Cartesian.prototype.getAxis = function (dim) {
    return this._axes[dim];
  };

  Cartesian.prototype.getAxes = function () {
    return map(this._dimList, function (dim) {
      return this._axes[dim];
    }, this);
  };

  Cartesian.prototype.getAxesByScale = function (scaleType) {
    scaleType = scaleType.toLowerCase();
    return filter(this.getAxes(), function (axis) {
      return axis.scale.type === scaleType;
    });
  };

  Cartesian.prototype.addAxis = function (axis) {
    var dim = axis.dim;
    this._axes[dim] = axis;

    this._dimList.push(dim);
  };

  return Cartesian;
}();

var cartesian2DDimensions = ['x', 'y'];

function canCalculateAffineTransform(scale) {
  return scale.type === 'interval' || scale.type === 'time';
}

var Cartesian2D =
/** @class */
function (_super) {
  __extends$1(Cartesian2D, _super);

  function Cartesian2D() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'cartesian2d';
    _this.dimensions = cartesian2DDimensions;
    return _this;
  }
  /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */


  Cartesian2D.prototype.calcAffineTransform = function () {
    this._transform = this._invTransform = null;
    var xAxisScale = this.getAxis('x').scale;
    var yAxisScale = this.getAxis('y').scale;

    if (!canCalculateAffineTransform(xAxisScale) || !canCalculateAffineTransform(yAxisScale)) {
      return;
    }

    var xScaleExtent = xAxisScale.getExtent();
    var yScaleExtent = yAxisScale.getExtent();
    var start = this.dataToPoint([xScaleExtent[0], yScaleExtent[0]]);
    var end = this.dataToPoint([xScaleExtent[1], yScaleExtent[1]]);
    var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
    var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];

    if (!xScaleSpan || !yScaleSpan) {
      return;
    } // Accelerate data to point calculation on the special large time series data.


    var scaleX = (end[0] - start[0]) / xScaleSpan;
    var scaleY = (end[1] - start[1]) / yScaleSpan;
    var translateX = start[0] - xScaleExtent[0] * scaleX;
    var translateY = start[1] - yScaleExtent[0] * scaleY;
    var m = this._transform = [scaleX, 0, 0, scaleY, translateX, translateY];
    this._invTransform = invert([], m);
  };
  /**
   * Base axis will be used on stacking.
   */


  Cartesian2D.prototype.getBaseAxis = function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
  };

  Cartesian2D.prototype.containPoint = function (point) {
    var axisX = this.getAxis('x');
    var axisY = this.getAxis('y');
    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
  };

  Cartesian2D.prototype.containData = function (data) {
    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
  };

  Cartesian2D.prototype.containZone = function (data1, data2) {
    var zoneDiag1 = this.dataToPoint(data1);
    var zoneDiag2 = this.dataToPoint(data2);
    var area = this.getArea();
    var zone = new BoundingRect(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
    return area.intersect(zone);
  };

  Cartesian2D.prototype.dataToPoint = function (data, clamp, out) {
    out = out || [];
    var xVal = data[0];
    var yVal = data[1]; // Fast path

    if (this._transform // It's supported that if data is like `[Inifity, 123]`, where only Y pixel calculated.
    && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) {
      return applyTransform(out, data, this._transform);
    }

    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
    return out;
  };

  Cartesian2D.prototype.clampData = function (data, out) {
    var xScale = this.getAxis('x').scale;
    var yScale = this.getAxis('y').scale;
    var xAxisExtent = xScale.getExtent();
    var yAxisExtent = yScale.getExtent();
    var x = xScale.parse(data[0]);
    var y = yScale.parse(data[1]);
    out = out || [];
    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
    return out;
  };

  Cartesian2D.prototype.pointToData = function (point, clamp) {
    var out = [];

    if (this._invTransform) {
      return applyTransform(out, point, this._invTransform);
    }

    var xAxis = this.getAxis('x');
    var yAxis = this.getAxis('y');
    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
    return out;
  };

  Cartesian2D.prototype.getOtherAxis = function (axis) {
    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
  };
  /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */


  Cartesian2D.prototype.getArea = function () {
    var xExtent = this.getAxis('x').getGlobalExtent();
    var yExtent = this.getAxis('y').getGlobalExtent();
    var x = Math.min(xExtent[0], xExtent[1]);
    var y = Math.min(yExtent[0], yExtent[1]);
    var width = Math.max(xExtent[0], xExtent[1]) - x;
    var height = Math.max(yExtent[0], yExtent[1]) - y;
    return new BoundingRect(x, y, width, height);
  };

  return Cartesian2D;
}(Cartesian);

var Axis2D =
/** @class */
function (_super) {
  __extends$1(Axis2D, _super);

  function Axis2D(dim, scale, coordExtent, axisType, position) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;
    /**
     * Index of axis, can be used as key
     * Injected outside.
     */


    _this.index = 0;
    _this.type = axisType || 'value';
    _this.position = position || 'bottom';
    return _this;
  }

  Axis2D.prototype.isHorizontal = function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  };
  /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */


  Axis2D.prototype.getGlobalExtent = function (asc) {
    var ret = this.getExtent();
    ret[0] = this.toGlobalCoord(ret[0]);
    ret[1] = this.toGlobalCoord(ret[1]);
    asc && ret[0] > ret[1] && ret.reverse();
    return ret;
  };

  Axis2D.prototype.pointToData = function (point, clamp) {
    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
  };
  /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */


  Axis2D.prototype.setCategorySortInfo = function (info) {
    if (this.type !== 'category') {
      return false;
    }

    this.model.option.categorySortInfo = info;
    this.scale.setSortInfo(info);
  };

  return Axis2D;
}(Axis);

/**
 * Can only be called after coordinate system creation stage.
 * (Can be called before coordinate system update stage).
 */

function layout$1(gridModel, axisModel, opt) {
  opt = opt || {};
  var grid = gridModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
  var rawAxisPosition = axis.position;
  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
  var axisDim = axis.dim;
  var rect = grid.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var idx = {
    left: 0,
    right: 1,
    top: 0,
    bottom: 1,
    onZero: 2
  };
  var axisOffset = axisModel.get('offset') || 0;
  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];

  if (otherAxisOnZeroOf) {
    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
  } // Axis position


  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation

  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim

  var dirMap = {
    top: -1,
    bottom: 1,
    left: -1,
    right: 1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;

  if (axisModel.get(['axisTick', 'inside'])) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (retrieve(opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
    layout.labelDirection = -layout.labelDirection;
  } // Special label rotation


  var labelRotate = axisModel.get(['axisLabel', 'rotate']);
  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea

  layout.z2 = 1;
  return layout;
}
function isCartesian2DSeries(seriesModel) {
  return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function findAxisModels(seriesModel) {
  var axisModelMap = {
    xAxisModel: null,
    yAxisModel: null
  };
  each(axisModelMap, function (v, key) {
    var axisType = key.replace(/Model$/, '');
    var axisModel = seriesModel.getReferringComponents(axisType, SINGLE_REFERRING).models[0];

    if (process.env.NODE_ENV !== 'production') {
      if (!axisModel) {
        throw new Error(axisType + ' "' + retrieve3(seriesModel.get(axisType + 'Index'), seriesModel.get(axisType + 'Id'), 0) + '" not found');
      }
    }

    axisModelMap[key] = axisModel;
  });
  return axisModelMap;
}

var mathLog$1 = Math.log;
function alignScaleTicks(scale, axisModel, alignToScale) {
  var intervalScaleProto = IntervalScale.prototype; // NOTE: There is a precondition for log scale  here:
  // In log scale we store _interval and _extent of exponent value.
  // So if we use the method of InternalScale to set/get these data.
  // It process the exponent value, which is linear and what we want here.

  var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
  var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
  var alignToSplitNumber = alignToTicks.length - 1;
  var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
  var scaleExtent = getScaleExtent(scale, axisModel);
  var rawExtent = scaleExtent.extent;
  var isMinFixed = scaleExtent.fixMin;
  var isMaxFixed = scaleExtent.fixMax;

  if (scale.type === 'log') {
    var logBase = mathLog$1(scale.base);
    rawExtent = [mathLog$1(rawExtent[0]) / logBase, mathLog$1(rawExtent[1]) / logBase];
  }

  scale.setExtent(rawExtent[0], rawExtent[1]);
  scale.calcNiceExtent({
    splitNumber: alignToSplitNumber,
    fixMin: isMinFixed,
    fixMax: isMaxFixed
  });
  var extent = intervalScaleProto.getExtent.call(scale); // Need to update the rawExtent.
  // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'

  if (isMinFixed) {
    rawExtent[0] = extent[0];
  }

  if (isMaxFixed) {
    rawExtent[1] = extent[1];
  }

  var interval = intervalScaleProto.getInterval.call(scale);
  var min = rawExtent[0];
  var max = rawExtent[1];

  if (isMinFixed && isMaxFixed) {
    // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
  } else if (isMinFixed) {
    max = rawExtent[0] + interval * alignToSplitNumber; // User set min, expand extent on the other side

    while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])) {
      interval = increaseInterval(interval);
      max = rawExtent[0] + interval * alignToSplitNumber;
    }
  } else if (isMaxFixed) {
    // User set max, expand extent on the other side
    min = rawExtent[1] - interval * alignToSplitNumber;

    while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])) {
      interval = increaseInterval(interval);
      min = rawExtent[1] - interval * alignToSplitNumber;
    }
  } else {
    var nicedSplitNumber = scale.getTicks().length - 1;

    if (nicedSplitNumber > alignToSplitNumber) {
      interval = increaseInterval(interval);
    }

    var range = interval * alignToSplitNumber;
    max = Math.ceil(rawExtent[1] / interval) * interval;
    min = round$3(max - range); // Not change the result that crossing zero.

    if (min < 0 && rawExtent[0] >= 0) {
      min = 0;
      max = round$3(range);
    } else if (max > 0 && rawExtent[1] <= 0) {
      max = 0;
      min = -round$3(range);
    }
  } // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale


  var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
  var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval; // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.

  intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
  intervalScaleProto.setInterval.call(scale, interval);

  if (t0 || t1) {
    intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
  }

  if (process.env.NODE_ENV !== 'production') {
    var ticks = intervalScaleProto.getTicks.call(scale);

    if (ticks[1] && (!isValueNice(interval) || getPrecisionSafe(ticks[1].value) > getPrecisionSafe(interval))) {
      warn( // eslint-disable-next-line
      "The ticks may be not readable when set min: " + axisModel.get('min') + ", max: " + axisModel.get('max') + " and alignTicks: true");
    }
  }
}

var Grid =
/** @class */
function () {
  function Grid(gridModel, ecModel, api) {
    // FIXME:TS where used (different from registered type 'cartesian2d')?
    this.type = 'grid';
    this._coordsMap = {};
    this._coordsList = [];
    this._axesMap = {};
    this._axesList = [];
    this.axisPointerEnabled = true;
    this.dimensions = cartesian2DDimensions;

    this._initCartesian(gridModel, ecModel, api);

    this.model = gridModel;
  }

  Grid.prototype.getRect = function () {
    return this._rect;
  };

  Grid.prototype.update = function (ecModel, api) {
    var axesMap = this._axesMap;

    this._updateScale(ecModel, this.model);

    function updateAxisTicks(axes) {
      var alignTo; // Axis is added in order of axisIndex.

      var axesIndices = keys$2(axes);
      var len = axesIndices.length;

      if (!len) {
        return;
      }

      var axisNeedsAlign = []; // Process once and calculate the ticks for those don't use alignTicks.

      for (var i = len - 1; i >= 0; i--) {
        var idx = +axesIndices[i]; // Convert to number.

        var axis = axes[idx];
        var model = axis.model;
        var scale = axis.scale;

        if ( // Only value and log axis without interval support alignTicks.
        isIntervalOrLogScale(scale) && model.get('alignTicks') && model.get('interval') == null) {
          axisNeedsAlign.push(axis);
        } else {
          niceScaleExtent(scale, model);

          if (isIntervalOrLogScale(scale)) {
            // Can only align to interval or log axis.
            alignTo = axis;
          }
        }
      }
      // PENDING. Should we find the axis that both set interval, min, max and align to this one?

      if (axisNeedsAlign.length) {
        if (!alignTo) {
          alignTo = axisNeedsAlign.pop();
          niceScaleExtent(alignTo.scale, alignTo.model);
        }

        each(axisNeedsAlign, function (axis) {
          alignScaleTicks(axis.scale, axis.model, alignTo.scale);
        });
      }
    }

    updateAxisTicks(axesMap.x);
    updateAxisTicks(axesMap.y); // Key: axisDim_axisIndex, value: boolean, whether onZero target.

    var onZeroRecords = {};
    each(axesMap.x, function (xAxis) {
      fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
    });
    each(axesMap.y, function (yAxis) {
      fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
    }); // Resize again if containLabel is enabled
    // FIXME It may cause getting wrong grid size in data processing stage

    this.resize(this.model, api);
  };
  /**
   * Resize the grid
   */


  Grid.prototype.resize = function (gridModel, api, ignoreContainLabel) {
    var boxLayoutParams = gridModel.getBoxLayoutParams();
    var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
    var gridRect = getLayoutRect$1(boxLayoutParams, {
      width: api.getWidth(),
      height: api.getHeight()
    });
    this._rect = gridRect;
    var axesList = this._axesList;
    adjustAxes(); // Minus label size

    if (isContainLabel) {
      each(axesList, function (axis) {
        if (!axis.model.get(['axisLabel', 'inside'])) {
          var labelUnionRect = estimateLabelUnionRect(axis);

          if (labelUnionRect) {
            var dim = axis.isHorizontal() ? 'height' : 'width';
            var margin = axis.model.get(['axisLabel', 'margin']);
            gridRect[dim] -= labelUnionRect[dim] + margin;

            if (axis.position === 'top') {
              gridRect.y += labelUnionRect.height + margin;
            } else if (axis.position === 'left') {
              gridRect.x += labelUnionRect.width + margin;
            }
          }
        }
      });
      adjustAxes();
    }

    each(this._coordsList, function (coord) {
      // Calculate affine matrix to accelerate the data to point transform.
      // If all the axes scales are time or value.
      coord.calcAffineTransform();
    });

    function adjustAxes() {
      each(axesList, function (axis) {
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
      });
    }
  };

  Grid.prototype.getAxis = function (dim, axisIndex) {
    var axesMapOnDim = this._axesMap[dim];

    if (axesMapOnDim != null) {
      return axesMapOnDim[axisIndex || 0];
    }
  };

  Grid.prototype.getAxes = function () {
    return this._axesList.slice();
  };

  Grid.prototype.getCartesian = function (xAxisIndex, yAxisIndex) {
    if (xAxisIndex != null && yAxisIndex != null) {
      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
      return this._coordsMap[key];
    }

    if (isObject$2(xAxisIndex)) {
      yAxisIndex = xAxisIndex.yAxisIndex;
      xAxisIndex = xAxisIndex.xAxisIndex;
    }

    for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
      if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
        return coordList[i];
      }
    }
  };

  Grid.prototype.getCartesians = function () {
    return this._coordsList.slice();
  };
  /**
   * @implements
   */


  Grid.prototype.convertToPixel = function (ecModel, finder, value) {
    var target = this._findConvertTarget(finder);

    return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
  };
  /**
   * @implements
   */


  Grid.prototype.convertFromPixel = function (ecModel, finder, value) {
    var target = this._findConvertTarget(finder);

    return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
  };

  Grid.prototype._findConvertTarget = function (finder) {
    var seriesModel = finder.seriesModel;
    var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', SINGLE_REFERRING).models[0];
    var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', SINGLE_REFERRING).models[0];
    var gridModel = finder.gridModel;
    var coordsList = this._coordsList;
    var cartesian;
    var axis;

    if (seriesModel) {
      cartesian = seriesModel.coordinateSystem;
      indexOf(coordsList, cartesian) < 0 && (cartesian = null);
    } else if (xAxisModel && yAxisModel) {
      cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    } else if (xAxisModel) {
      axis = this.getAxis('x', xAxisModel.componentIndex);
    } else if (yAxisModel) {
      axis = this.getAxis('y', yAxisModel.componentIndex);
    } // Lowest priority.
    else if (gridModel) {
        var grid = gridModel.coordinateSystem;

        if (grid === this) {
          cartesian = this._coordsList[0];
        }
      }

    return {
      cartesian: cartesian,
      axis: axis
    };
  };
  /**
   * @implements
   */


  Grid.prototype.containPoint = function (point) {
    var coord = this._coordsList[0];

    if (coord) {
      return coord.containPoint(point);
    }
  };
  /**
   * Initialize cartesian coordinate systems
   */


  Grid.prototype._initCartesian = function (gridModel, ecModel, api) {
    var _this = this;

    var grid = this;
    var axisPositionUsed = {
      left: false,
      right: false,
      top: false,
      bottom: false
    };
    var axesMap = {
      x: {},
      y: {}
    };
    var axesCount = {
      x: 0,
      y: 0
    }; // Create axis

    ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
    ecModel.eachComponent('yAxis', createAxisCreator('y'), this);

    if (!axesCount.x || !axesCount.y) {
      // Roll back when there no either x or y axis
      this._axesMap = {};
      this._axesList = [];
      return;
    }

    this._axesMap = axesMap; // Create cartesian2d

    each(axesMap.x, function (xAxis, xAxisIndex) {
      each(axesMap.y, function (yAxis, yAxisIndex) {
        var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
        var cartesian = new Cartesian2D(key);
        cartesian.master = _this;
        cartesian.model = gridModel;
        _this._coordsMap[key] = cartesian;

        _this._coordsList.push(cartesian);

        cartesian.addAxis(xAxis);
        cartesian.addAxis(yAxis);
      });
    });

    function createAxisCreator(dimName) {
      return function (axisModel, idx) {
        if (!isAxisUsedInTheGrid(axisModel, gridModel)) {
          return;
        }

        var axisPosition = axisModel.get('position');

        if (dimName === 'x') {
          // Fix position
          if (axisPosition !== 'top' && axisPosition !== 'bottom') {
            // Default bottom of X
            axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
          }
        } else {
          // Fix position
          if (axisPosition !== 'left' && axisPosition !== 'right') {
            // Default left of Y
            axisPosition = axisPositionUsed.left ? 'right' : 'left';
          }
        }

        axisPositionUsed[axisPosition] = true;
        var axis = new Axis2D(dimName, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
        var isCategory = axis.type === 'category';
        axis.onBand = isCategory && axisModel.get('boundaryGap');
        axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel

        axisModel.axis = axis; // Inject axisModel into axis

        axis.model = axisModel; // Inject grid info axis

        axis.grid = grid; // Index of axis, can be used as key

        axis.index = idx;

        grid._axesList.push(axis);

        axesMap[dimName][idx] = axis;
        axesCount[dimName]++;
      };
    }
  };
  /**
   * Update cartesian properties from series.
   */


  Grid.prototype._updateScale = function (ecModel, gridModel) {
    // Reset scale
    each(this._axesList, function (axis) {
      axis.scale.setExtent(Infinity, -Infinity);

      if (axis.type === 'category') {
        var categorySortInfo = axis.model.get('categorySortInfo');
        axis.scale.setSortInfo(categorySortInfo);
      }
    });
    ecModel.eachSeries(function (seriesModel) {
      if (isCartesian2DSeries(seriesModel)) {
        var axesModelMap = findAxisModels(seriesModel);
        var xAxisModel = axesModelMap.xAxisModel;
        var yAxisModel = axesModelMap.yAxisModel;

        if (!isAxisUsedInTheGrid(xAxisModel, gridModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel)) {
          return;
        }

        var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        var data = seriesModel.getData();
        var xAxis = cartesian.getAxis('x');
        var yAxis = cartesian.getAxis('y');
        unionExtent(data, xAxis);
        unionExtent(data, yAxis);
      }
    }, this);

    function unionExtent(data, axis) {
      each(getDataDimensionsOnAxis(data, axis.dim), function (dim) {
        axis.scale.unionExtentFromData(data, dim);
      });
    }
  };
  /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */


  Grid.prototype.getTooltipAxes = function (dim) {
    var baseAxes = [];
    var otherAxes = [];
    each(this.getCartesians(), function (cartesian) {
      var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
      var otherAxis = cartesian.getOtherAxis(baseAxis);
      indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
      indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
    });
    return {
      baseAxes: baseAxes,
      otherAxes: otherAxes
    };
  };

  Grid.create = function (ecModel, api) {
    var grids = [];
    ecModel.eachComponent('grid', function (gridModel, idx) {
      var grid = new Grid(gridModel, ecModel, api);
      grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
      // should be performed in create stage.

      grid.resize(gridModel, api, true);
      gridModel.coordinateSystem = grid;
      grids.push(grid);
    }); // Inject the coordinateSystems into seriesModel

    ecModel.eachSeries(function (seriesModel) {
      if (!isCartesian2DSeries(seriesModel)) {
        return;
      }

      var axesModelMap = findAxisModels(seriesModel);
      var xAxisModel = axesModelMap.xAxisModel;
      var yAxisModel = axesModelMap.yAxisModel;
      var gridModel = xAxisModel.getCoordSysModel();

      if (process.env.NODE_ENV !== 'production') {
        if (!gridModel) {
          throw new Error('Grid "' + retrieve3(xAxisModel.get('gridIndex'), xAxisModel.get('gridId'), 0) + '" not found');
        }

        if (xAxisModel.getCoordSysModel() !== yAxisModel.getCoordSysModel()) {
          throw new Error('xAxis and yAxis must use the same grid');
        }
      }

      var grid = gridModel.coordinateSystem;
      seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
    });
    return grids;
  }; // For deciding which dimensions to use when creating list data


  Grid.dimensions = cartesian2DDimensions;
  return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */


function isAxisUsedInTheGrid(axisModel, gridModel) {
  return axisModel.getCoordSysModel() === gridModel;
}

function fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
  axis.getAxesOnZeroOf = function () {
    // TODO: onZero of multiple axes.
    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
  }; // onZero can not be enabled in these two situations:
  // 1. When any other axis is a category axis.
  // 2. When no axis is cross 0 point.


  var otherAxes = axesMap[otherAxisDim];
  var otherAxisOnZeroOf;
  var axisModel = axis.model;
  var onZero = axisModel.get(['axisLine', 'onZero']);
  var onZeroAxisIndex = axisModel.get(['axisLine', 'onZeroAxisIndex']);

  if (!onZero) {
    return;
  } // If target axis is specified.


  if (onZeroAxisIndex != null) {
    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    }
  } else {
    // Find the first available other axis.
    for (var idx in otherAxes) {
      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
      // if both onZero, the two Y axes overlap.
      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
        otherAxisOnZeroOf = otherAxes[idx];
        break;
      }
    }
  }

  if (otherAxisOnZeroOf) {
    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
  }

  function getOnZeroRecordKey(axis) {
    return axis.dim + '_' + axis.index;
  }
}

function canOnZeroToAxis(axis) {
  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
}

function updateAxisTransform(axis, coordBase) {
  var axisExtent = axis.getExtent();
  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform

  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
    return coord + coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
    return coord - coordBase;
  } : function (coord) {
    return axisExtentSum - coord + coordBase;
  };
}

var PI$5 = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */

var AxisBuilder =
/** @class */
function () {
  function AxisBuilder(axisModel, opt) {
    this.group = new Group$1();
    this.opt = opt;
    this.axisModel = axisModel; // Default value

    defaults(opt, {
      labelOffset: 0,
      nameDirection: 1,
      tickDirection: 1,
      labelDirection: 1,
      silent: true,
      handleAutoShown: function () {
        return true;
      }
    }); // FIXME Not use a seperate text group?

    var transformGroup = new Group$1({
      x: opt.position[0],
      y: opt.position[1],
      rotation: opt.rotation
    }); // this.group.add(transformGroup);
    // this._transformGroup = transformGroup;

    transformGroup.updateTransform();
    this._transformGroup = transformGroup;
  }

  AxisBuilder.prototype.hasBuilder = function (name) {
    return !!builders[name];
  };

  AxisBuilder.prototype.add = function (name) {
    builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
  };

  AxisBuilder.prototype.getGroup = function () {
    return this.group;
  };

  AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
    var rotationDiff = remRadian(textRotation - axisRotation);
    var textAlign;
    var textVerticalAlign;

    if (isRadianAroundZero(rotationDiff)) {
      // Label is parallel with axis line.
      textVerticalAlign = direction > 0 ? 'top' : 'bottom';
      textAlign = 'center';
    } else if (isRadianAroundZero(rotationDiff - PI$5)) {
      // Label is inverse parallel with axis line.
      textVerticalAlign = direction > 0 ? 'bottom' : 'top';
      textAlign = 'center';
    } else {
      textVerticalAlign = 'middle';

      if (rotationDiff > 0 && rotationDiff < PI$5) {
        textAlign = direction > 0 ? 'right' : 'left';
      } else {
        textAlign = direction > 0 ? 'left' : 'right';
      }
    }

    return {
      rotation: rotationDiff,
      textAlign: textAlign,
      textVerticalAlign: textVerticalAlign
    };
  };

  AxisBuilder.makeAxisEventDataBase = function (axisModel) {
    var eventData = {
      componentType: axisModel.mainType,
      componentIndex: axisModel.componentIndex
    };
    eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
    return eventData;
  };

  AxisBuilder.isLabelSilent = function (axisModel) {
    var tooltipOpt = axisModel.get('tooltip');
    return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
    || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
  };

  return AxisBuilder;
}();
var builders = {
  axisLine: function (opt, axisModel, group, transformGroup) {
    var shown = axisModel.get(['axisLine', 'show']);

    if (shown === 'auto' && opt.handleAutoShown) {
      shown = opt.handleAutoShown('axisLine');
    }

    if (!shown) {
      return;
    }

    var extent = axisModel.axis.getExtent();
    var matrix = transformGroup.transform;
    var pt1 = [extent[0], 0];
    var pt2 = [extent[1], 0];
    var inverse = pt1[0] > pt2[0];

    if (matrix) {
      applyTransform(pt1, pt1, matrix);
      applyTransform(pt2, pt2, matrix);
    }

    var lineStyle = extend({
      lineCap: 'round'
    }, axisModel.getModel(['axisLine', 'lineStyle']).getLineStyle());
    var line = new Line({
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: lineStyle,
      strokeContainThreshold: opt.strokeContainThreshold || 5,
      silent: true,
      z2: 1
    });
    subPixelOptimizeLine$1(line.shape, line.style.lineWidth);
    line.anid = 'line';
    group.add(line);
    var arrows = axisModel.get(['axisLine', 'symbol']);

    if (arrows != null) {
      var arrowSize = axisModel.get(['axisLine', 'symbolSize']);

      if (isString(arrows)) {
        // Use the same arrow for start and end point
        arrows = [arrows, arrows];
      }

      if (isString(arrowSize) || isNumber$1(arrowSize)) {
        // Use the same size for width and height
        arrowSize = [arrowSize, arrowSize];
      }

      var arrowOffset = normalizeSymbolOffset(axisModel.get(['axisLine', 'symbolOffset']) || 0, arrowSize);
      var symbolWidth_1 = arrowSize[0];
      var symbolHeight_1 = arrowSize[1];
      each([{
        rotate: opt.rotation + Math.PI / 2,
        offset: arrowOffset[0],
        r: 0
      }, {
        rotate: opt.rotation - Math.PI / 2,
        offset: arrowOffset[1],
        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
      }], function (point, index) {
        if (arrows[index] !== 'none' && arrows[index] != null) {
          var symbol = createSymbol(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true); // Calculate arrow position with offset

          var r = point.r + point.offset;
          var pt = inverse ? pt2 : pt1;
          symbol.attr({
            rotation: point.rotate,
            x: pt[0] + r * Math.cos(opt.rotation),
            y: pt[1] - r * Math.sin(opt.rotation),
            silent: true,
            z2: 11
          });
          group.add(symbol);
        }
      });
    }
  },
  axisTickLabel: function (opt, axisModel, group, transformGroup) {
    var ticksEls = buildAxisMajorTicks(group, transformGroup, axisModel, opt);
    var labelEls = buildAxisLabel(group, transformGroup, axisModel, opt);
    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
    buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection); // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.

    if (axisModel.get(['axisLabel', 'hideOverlap'])) {
      var labelList = prepareLayoutList(map(labelEls, function (label) {
        return {
          label: label,
          priority: label.z2,
          defaultAttr: {
            ignore: label.ignore
          }
        };
      }));
      hideOverlap(labelList);
    }
  },
  axisName: function (opt, axisModel, group, transformGroup) {
    var name = retrieve(opt.axisName, axisModel.get('name'));

    if (!name) {
      return;
    }

    var nameLocation = axisModel.get('nameLocation');
    var nameDirection = opt.nameDirection;
    var textStyleModel = axisModel.getModel('nameTextStyle');
    var gap = axisModel.get('nameGap') || 0;
    var extent = axisModel.axis.getExtent();
    var gapSignal = extent[0] > extent[1] ? -1 : 1;
    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // Reuse labelOffset.
    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
    var labelLayout;
    var nameRotation = axisModel.get('nameRotate');

    if (nameRotation != null) {
      nameRotation = nameRotation * PI$5 / 180; // To radian.
    }

    var axisNameAvailableWidth;

    if (isNameLocationCenter(nameLocation)) {
      labelLayout = AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
      nameDirection);
    } else {
      labelLayout = endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
      axisNameAvailableWidth = opt.axisNameAvailableWidth;

      if (axisNameAvailableWidth != null) {
        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
      }
    }

    var textFont = textStyleModel.getFont();
    var truncateOpt = axisModel.get('nameTruncate', true) || {};
    var ellipsis = truncateOpt.ellipsis;
    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
    var textEl = new ZRText({
      x: pos[0],
      y: pos[1],
      rotation: labelLayout.rotation,
      silent: AxisBuilder.isLabelSilent(axisModel),
      style: createTextStyle(textStyleModel, {
        text: name,
        font: textFont,
        overflow: 'truncate',
        width: maxWidth,
        ellipsis: ellipsis,
        fill: textStyleModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']),
        align: textStyleModel.get('align') || labelLayout.textAlign,
        verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
      }),
      z2: 1
    });
    setTooltipConfig({
      el: textEl,
      componentModel: axisModel,
      itemName: name
    });
    textEl.__fullText = name; // Id for animation

    textEl.anid = 'name';

    if (axisModel.get('triggerEvent')) {
      var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
      eventData.targetType = 'axisName';
      eventData.name = name;
      getECData(textEl).eventData = eventData;
    } // FIXME


    transformGroup.add(textEl);
    textEl.updateTransform();
    group.add(textEl);
    textEl.decomposeTransform();
  }
};

function endTextLayout(rotation, textPosition, textRotate, extent) {
  var rotationDiff = remRadian(textRotate - rotation);
  var textAlign;
  var textVerticalAlign;
  var inverse = extent[0] > extent[1];
  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;

  if (isRadianAroundZero(rotationDiff - PI$5 / 2)) {
    textVerticalAlign = onLeft ? 'bottom' : 'top';
    textAlign = 'center';
  } else if (isRadianAroundZero(rotationDiff - PI$5 * 1.5)) {
    textVerticalAlign = onLeft ? 'top' : 'bottom';
    textAlign = 'center';
  } else {
    textVerticalAlign = 'middle';

    if (rotationDiff < PI$5 * 1.5 && rotationDiff > PI$5 / 2) {
      textAlign = onLeft ? 'left' : 'right';
    } else {
      textAlign = onLeft ? 'right' : 'left';
    }
  }

  return {
    rotation: rotationDiff,
    textAlign: textAlign,
    textVerticalAlign: textVerticalAlign
  };
}

function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
  if (shouldShowAllLabels(axisModel.axis)) {
    return;
  } // If min or max are user set, we need to check
  // If the tick on min(max) are overlap on their neighbour tick
  // If they are overlapped, we need to hide the min(max) tick label


  var showMinLabel = axisModel.get(['axisLabel', 'showMinLabel']);
  var showMaxLabel = axisModel.get(['axisLabel', 'showMaxLabel']); // FIXME
  // Have not consider onBand yet, where tick els is more than label els.

  labelEls = labelEls || [];
  tickEls = tickEls || [];
  var firstLabel = labelEls[0];
  var nextLabel = labelEls[1];
  var lastLabel = labelEls[labelEls.length - 1];
  var prevLabel = labelEls[labelEls.length - 2];
  var firstTick = tickEls[0];
  var nextTick = tickEls[1];
  var lastTick = tickEls[tickEls.length - 1];
  var prevTick = tickEls[tickEls.length - 2];

  if (showMinLabel === false) {
    ignoreEl(firstLabel);
    ignoreEl(firstTick);
  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
    if (showMinLabel) {
      ignoreEl(nextLabel);
      ignoreEl(nextTick);
    } else {
      ignoreEl(firstLabel);
      ignoreEl(firstTick);
    }
  }

  if (showMaxLabel === false) {
    ignoreEl(lastLabel);
    ignoreEl(lastTick);
  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
    if (showMaxLabel) {
      ignoreEl(prevLabel);
      ignoreEl(prevTick);
    } else {
      ignoreEl(lastLabel);
      ignoreEl(lastTick);
    }
  }
}

function ignoreEl(el) {
  el && (el.ignore = true);
}

function isTwoLabelOverlapped(current, next) {
  // current and next has the same rotation.
  var firstRect = current && current.getBoundingRect().clone();
  var nextRect = next && next.getBoundingRect().clone();

  if (!firstRect || !nextRect) {
    return;
  } // When checking intersect of two rotated labels, we use mRotationBack
  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.


  var mRotationBack = identity$1([]);
  rotate(mRotationBack, mRotationBack, -current.rotation);
  firstRect.applyTransform(mul$1([], mRotationBack, current.getLocalTransform()));
  nextRect.applyTransform(mul$1([], mRotationBack, next.getLocalTransform()));
  return firstRect.intersect(nextRect);
}

function isNameLocationCenter(nameLocation) {
  return nameLocation === 'middle' || nameLocation === 'center';
}

function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
  var tickEls = [];
  var pt1 = [];
  var pt2 = [];

  for (var i = 0; i < ticksCoords.length; i++) {
    var tickCoord = ticksCoords[i].coord;
    pt1[0] = tickCoord;
    pt1[1] = 0;
    pt2[0] = tickCoord;
    pt2[1] = tickEndCoord;

    if (tickTransform) {
      applyTransform(pt1, pt1, tickTransform);
      applyTransform(pt2, pt2, tickTransform);
    } // Tick line, Not use group transform to have better line draw


    var tickEl = new Line({
      shape: {
        x1: pt1[0],
        y1: pt1[1],
        x2: pt2[0],
        y2: pt2[1]
      },
      style: tickLineStyle,
      z2: 2,
      autoBatch: true,
      silent: true
    });
    subPixelOptimizeLine$1(tickEl.shape, tickEl.style.lineWidth);
    tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
    tickEls.push(tickEl);
  }

  return tickEls;
}

function buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
  var axis = axisModel.axis;
  var tickModel = axisModel.getModel('axisTick');
  var shown = tickModel.get('show');

  if (shown === 'auto' && opt.handleAutoShown) {
    shown = opt.handleAutoShown('axisTick');
  }

  if (!shown || axis.scale.isBlank()) {
    return;
  }

  var lineStyleModel = tickModel.getModel('lineStyle');
  var tickEndCoord = opt.tickDirection * tickModel.get('length');
  var ticksCoords = axis.getTicksCoords();
  var ticksEls = createTicks(ticksCoords, transformGroup.transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
    stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
  }), 'ticks');

  for (var i = 0; i < ticksEls.length; i++) {
    group.add(ticksEls[i]);
  }

  return ticksEls;
}

function buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
  var axis = axisModel.axis;
  var minorTickModel = axisModel.getModel('minorTick');

  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
    return;
  }

  var minorTicksCoords = axis.getMinorTicksCoords();

  if (!minorTicksCoords.length) {
    return;
  }

  var lineStyleModel = minorTickModel.getModel('lineStyle');
  var tickEndCoord = tickDirection * minorTickModel.get('length');
  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
    stroke: axisModel.get(['axisLine', 'lineStyle', 'color'])
  }));

  for (var i = 0; i < minorTicksCoords.length; i++) {
    var minorTicksEls = createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);

    for (var k = 0; k < minorTicksEls.length; k++) {
      group.add(minorTicksEls[k]);
    }
  }
}

function buildAxisLabel(group, transformGroup, axisModel, opt) {
  var axis = axisModel.axis;
  var show = retrieve(opt.axisLabelShow, axisModel.get(['axisLabel', 'show']));

  if (!show || axis.scale.isBlank()) {
    return;
  }

  var labelModel = axisModel.getModel('axisLabel');
  var labelMargin = labelModel.get('margin');
  var labels = axis.getViewLabels(); // Special label rotate.

  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI$5 / 180;
  var labelLayout = AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
  var labelEls = [];
  var silent = AxisBuilder.isLabelSilent(axisModel);
  var triggerEvent = axisModel.get('triggerEvent');
  each(labels, function (labelItem, index) {
    var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
    var formattedLabel = labelItem.formattedLabel;
    var rawLabel = labelItem.rawLabel;
    var itemLabelModel = labelModel;

    if (rawCategoryData && rawCategoryData[tickValue]) {
      var rawCategoryItem = rawCategoryData[tickValue];

      if (isObject$2(rawCategoryItem) && rawCategoryItem.textStyle) {
        itemLabelModel = new Model(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
      }
    }

    var textColor = itemLabelModel.getTextColor() || axisModel.get(['axisLine', 'lineStyle', 'color']);
    var tickCoord = axis.dataToCoord(tickValue);
    var textEl = new ZRText({
      x: tickCoord,
      y: opt.labelOffset + opt.labelDirection * labelMargin,
      rotation: labelLayout.rotation,
      silent: silent,
      z2: 10 + (labelItem.level || 0),
      style: createTextStyle(itemLabelModel, {
        text: formattedLabel,
        align: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
        verticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
        fill: isFunction$3(textColor) ? textColor( // (1) In category axis with data zoom, tick is not the original
        // index of axis.data. So tick should not be exposed to user
        // in category axis.
        // (2) Compatible with previous version, which always use formatted label as
        // input. But in interval scale the formatted label is like '223,445', which
        // maked user repalce ','. So we modify it to return original val but remain
        // it as 'string' to avoid error in replacing.
        axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
      })
    });
    textEl.anid = 'label_' + tickValue; // Pack data for mouse event

    if (triggerEvent) {
      var eventData = AxisBuilder.makeAxisEventDataBase(axisModel);
      eventData.targetType = 'axisLabel';
      eventData.value = rawLabel;
      eventData.tickIndex = index;

      if (axis.type === 'category') {
        eventData.dataIndex = tickValue;
      }

      getECData(textEl).eventData = eventData;
    } // FIXME


    transformGroup.add(textEl);
    textEl.updateTransform();
    labelEls.push(textEl);
    group.add(textEl);
    textEl.decomposeTransform();
  });
  return labelEls;
}

// allAxesInfo should be updated when setOption performed.

function collect(ecModel, api) {
  var result = {
    /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */
    axesInfo: {},
    seriesInvolved: false,

    /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */
    coordSysAxesInfo: {},
    coordSysMap: {}
  };
  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.

  result.seriesInvolved && collectSeriesInfo(result, ecModel);
  return result;
}

function collectAxesInfo(result, ecModel, api) {
  var globalTooltipModel = ecModel.getComponent('tooltip');
  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.

  var linksOption = globalAxisPointerModel.get('link', true) || [];
  var linkGroups = []; // Collect axes info.

  each(api.getCoordinateSystems(), function (coordSys) {
    // Some coordinate system do not support axes, like geo.
    if (!coordSys.axisPointerEnabled) {
      return;
    }

    var coordSysKey = makeKey(coordSys.model);
    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
    // for user. So we enable seting tooltip on coordSys model.

    var coordSysModel = coordSys.model;
    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
    // Notice this case: coordSys is `grid` but not `cartesian2D` here.

    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
    // show but axisPointer will show as normal.
    && baseTooltipModel.get('show')) {
      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
      var cross = baseTooltipModel.get(['axisPointer', 'type']) === 'cross';
      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get(['axisPointer', 'axis']));

      if (triggerAxis || cross) {
        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
      }

      if (cross) {
        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
      }
    } // fromTooltip: true | false | 'cross'
    // triggerTooltip: true | false | null


    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
      var axisPointerShow = axisPointerModel.get('show');

      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
        return;
      }

      if (triggerTooltip == null) {
        triggerTooltip = axisPointerModel.get('triggerTooltip');
      }

      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
      var snap = axisPointerModel.get('snap');
      var axisKey = makeKey(axis.model);
      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).

      var axisInfo = result.axesInfo[axisKey] = {
        key: axisKey,
        axis: axis,
        coordSys: coordSys,
        axisPointerModel: axisPointerModel,
        triggerTooltip: triggerTooltip,
        involveSeries: involveSeries,
        snap: snap,
        useHandle: isHandleTrigger(axisPointerModel),
        seriesModels: [],
        linkGroup: null
      };
      axesInfoInCoordSys[axisKey] = axisInfo;
      result.seriesInvolved = result.seriesInvolved || involveSeries;
      var groupIndex = getLinkGroupIndex(linksOption, axis);

      if (groupIndex != null) {
        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
          axesInfo: {}
        });
        linkGroup.axesInfo[axisKey] = axisInfo;
        linkGroup.mapper = linksOption[groupIndex].mapper;
        axisInfo.linkGroup = linkGroup;
      }
    }
  });
}

function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
  var fields = ['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'];
  var volatileOption = {};
  each(fields, function (field) {
    volatileOption[field] = clone(tooltipAxisPointerModel.get(field));
  }); // category axis do not auto snap, otherwise some tick that do not
  // has value can not be hovered. value/time/log axis default snap if
  // triggered from tooltip and trigger tooltip.

  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
  // Only these properties can be overrided from tooltip to axisPointer.

  if (tooltipAxisPointerModel.get('type') === 'cross') {
    volatileOption.type = 'line';
  }

  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.

  labelOption.show == null && (labelOption.show = false);

  if (fromTooltip === 'cross') {
    // When 'cross', both axes show labels.
    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get(['label', 'show']);
    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
    // (cross style is dashed by default)

    if (!triggerTooltip) {
      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
      crossStyle && defaults(labelOption, crossStyle.textStyle);
    }
  }

  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
}

function collectSeriesInfo(result, ecModel) {
  // Prepare data for axis trigger
  ecModel.eachSeries(function (seriesModel) {
    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
    var coordSys = seriesModel.coordinateSystem;
    var seriesTooltipTrigger = seriesModel.get(['tooltip', 'trigger'], true);
    var seriesTooltipShow = seriesModel.get(['tooltip', 'show'], true);

    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get(['axisPointer', 'show'], true) === false) {
      return;
    }

    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
      var axis = axisInfo.axis;

      if (coordSys.getAxis(axis.dim) === axis) {
        axisInfo.seriesModels.push(seriesModel);
        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
        axisInfo.seriesDataCount += seriesModel.getData().count();
      }
    });
  });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */


function getLinkGroupIndex(linksOption, axis) {
  var axisModel = axis.model;
  var dim = axis.dim;

  for (var i = 0; i < linksOption.length; i++) {
    var linkOption = linksOption[i] || {};

    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
      return i;
    }
  }
}

function checkPropInLink(linkPropValue, axisPropValue) {
  return linkPropValue === 'all' || isArray$1(linkPropValue) && indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}

function fixValue(axisModel) {
  var axisInfo = getAxisInfo(axisModel);

  if (!axisInfo) {
    return;
  }

  var axisPointerModel = axisInfo.axisPointerModel;
  var scale = axisInfo.axis.scale;
  var option = axisPointerModel.option;
  var status = axisPointerModel.get('status');
  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.

  if (value != null) {
    value = scale.parse(value);
  }

  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
  // and status should be initialized.

  if (status == null) {
    option.status = useHandle ? 'show' : 'hide';
  }

  var extent = scale.getExtent().slice();
  extent[0] > extent[1] && extent.reverse();

  if ( // Pick a value on axis when initializing.
  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
  // where we should re-pick a value to keep `handle` displaying normally.
  || value > extent[1]) {
    // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
  }

  if (value < extent[0]) {
    value = extent[0];
  }

  option.value = value;

  if (useHandle) {
    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
  }
}
function getAxisInfo(axisModel) {
  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
}
function getAxisPointerModel(axisModel) {
  var axisInfo = getAxisInfo(axisModel);
  return axisInfo && axisInfo.axisPointerModel;
}

function isHandleTrigger(axisPointerModel) {
  return !!axisPointerModel.get(['handle', 'show']);
}
/**
 * @param {module:echarts/model/Model} model
 * @return {string} unique key
 */


function makeKey(model) {
  return model.type + '||' + model.id;
}

var axisPointerClazz = {};
/**
 * Base class of AxisView.
 */

var AxisView =
/** @class */
function (_super) {
  __extends$1(AxisView, _super);

  function AxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisView.type;
    return _this;
  }
  /**
   * @override
   */


  AxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    // FIXME
    // This process should proformed after coordinate systems updated
    // (axis scale updated), and should be performed each time update.
    // So put it here temporarily, although it is not appropriate to
    // put a model-writing procedure in `view`.
    this.axisPointerClass && fixValue(axisModel);

    _super.prototype.render.apply(this, arguments);

    this._doUpdateAxisPointerClass(axisModel, api, true);
  };
  /**
   * Action handler.
   */


  AxisView.prototype.updateAxisPointer = function (axisModel, ecModel, api, payload) {
    this._doUpdateAxisPointerClass(axisModel, api, false);
  };
  /**
   * @override
   */


  AxisView.prototype.remove = function (ecModel, api) {
    var axisPointer = this._axisPointer;
    axisPointer && axisPointer.remove(api);
  };
  /**
   * @override
   */


  AxisView.prototype.dispose = function (ecModel, api) {
    this._disposeAxisPointer(api);

    _super.prototype.dispose.apply(this, arguments);
  };

  AxisView.prototype._doUpdateAxisPointerClass = function (axisModel, api, forceRender) {
    var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);

    if (!Clazz) {
      return;
    }

    var axisPointerModel = getAxisPointerModel(axisModel);
    axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
  };

  AxisView.prototype._disposeAxisPointer = function (api) {
    this._axisPointer && this._axisPointer.dispose(api);
    this._axisPointer = null;
  };

  AxisView.registerAxisPointerClass = function (type, clazz) {
    if (process.env.NODE_ENV !== 'production') {
      if (axisPointerClazz[type]) {
        throw new Error('axisPointer ' + type + ' exists');
      }
    }

    axisPointerClazz[type] = clazz;
  };

  AxisView.getAxisPointerClass = function (type) {
    return type && axisPointerClazz[type];
  };
  AxisView.type = 'axis';
  return AxisView;
}(ComponentView);

var inner$7 = makeInner();
function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
  var axis = axisModel.axis;

  if (axis.scale.isBlank()) {
    return;
  } // TODO: TYPE


  var splitAreaModel = axisModel.getModel('splitArea');
  var areaStyleModel = splitAreaModel.getModel('areaStyle');
  var areaColors = areaStyleModel.get('color');
  var gridRect = gridModel.coordinateSystem.getRect();
  var ticksCoords = axis.getTicksCoords({
    tickModel: splitAreaModel,
    clamp: true
  });

  if (!ticksCoords.length) {
    return;
  } // For Making appropriate splitArea animation, the color and anid
  // should be corresponding to previous one if possible.


  var areaColorsLen = areaColors.length;
  var lastSplitAreaColors = inner$7(axisView).splitAreaColors;
  var newSplitAreaColors = createHashMap();
  var colorIndex = 0;

  if (lastSplitAreaColors) {
    for (var i = 0; i < ticksCoords.length; i++) {
      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);

      if (cIndex != null) {
        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
        break;
      }
    }
  }

  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
  var areaStyle = areaStyleModel.getAreaStyle();
  areaColors = isArray$1(areaColors) ? areaColors : [areaColors];

  for (var i = 1; i < ticksCoords.length; i++) {
    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
    var x = void 0;
    var y = void 0;
    var width = void 0;
    var height = void 0;

    if (axis.isHorizontal()) {
      x = prev;
      y = gridRect.y;
      width = tickCoord - x;
      height = gridRect.height;
      prev = x + width;
    } else {
      x = gridRect.x;
      y = prev;
      width = gridRect.width;
      height = tickCoord - y;
      prev = y + height;
    }

    var tickValue = ticksCoords[i - 1].tickValue;
    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
    axisGroup.add(new Rect({
      anid: tickValue != null ? 'area_' + tickValue : null,
      shape: {
        x: x,
        y: y,
        width: width,
        height: height
      },
      style: defaults({
        fill: areaColors[colorIndex]
      }, areaStyle),
      autoBatch: true,
      silent: true
    }));
    colorIndex = (colorIndex + 1) % areaColorsLen;
  }

  inner$7(axisView).splitAreaColors = newSplitAreaColors;
}
function rectCoordAxisHandleRemove(axisView) {
  inner$7(axisView).splitAreaColors = null;
}

var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];

var CartesianAxisView =
/** @class */
function (_super) {
  __extends$1(CartesianAxisView, _super);

  function CartesianAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianAxisView.type;
    _this.axisPointerClass = 'CartesianAxisPointer';
    return _this;
  }
  /**
   * @override
   */


  CartesianAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new Group$1();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var gridModel = axisModel.getCoordSysModel();
    var layout = layout$1(gridModel, axisModel);
    var axisBuilder = new AxisBuilder(axisModel, extend({
      handleAutoShown: function (elementType) {
        var cartesians = gridModel.coordinateSystem.getCartesians();

        for (var i = 0; i < cartesians.length; i++) {
          if (isIntervalOrLogScale(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
            // Still show axis tick or axisLine if other axis is value / log
            return true;
          }
        } // Not show axisTick or axisLine if other axis is category / time


        return false;
      }
    }, layout));
    each(axisBuilderAttrs, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    each(selfBuilderAttrs, function (name) {
      if (axisModel.get([name, 'show'])) {
        axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
      }
    }, this); // THIS is a special case for bar racing chart.
    // Update the axis label from the natural initial layout to
    // sorted layout should has no animation.

    var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;

    if (!isInitialSortFromBarRacing) {
      groupTransition(oldAxisGroup, this._axisGroup, axisModel);
    }

    _super.prototype.render.call(this, axisModel, ecModel, api, payload);
  };

  CartesianAxisView.prototype.remove = function () {
    rectCoordAxisHandleRemove(this);
  };

  CartesianAxisView.type = 'cartesianAxis';
  return CartesianAxisView;
}(AxisView);

var axisElementBuilders = {
  splitLine: function (axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = isArray$1(lineColors) ? lineColors : [lineColors];
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < ticksCoords.length; i++) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var colorIndex = lineCount++ % lineColors.length;
      var tickValue = ticksCoords[i].tickValue;
      var line = new Line({
        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
        autoBatch: true,
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        style: defaults({
          stroke: lineColors[colorIndex]
        }, lineStyle),
        silent: true
      });
      subPixelOptimizeLine$1(line.shape, lineStyle.lineWidth);
      axisGroup.add(line);
    }
  },
  minorSplitLine: function (axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var gridRect = gridModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var minorTicksCoords = axis.getMinorTicksCoords();

    if (!minorTicksCoords.length) {
      return;
    }

    var p1 = [];
    var p2 = [];
    var lineStyle = lineStyleModel.getLineStyle();

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);

        if (isHorizontal) {
          p1[0] = tickCoord;
          p1[1] = gridRect.y;
          p2[0] = tickCoord;
          p2[1] = gridRect.y + gridRect.height;
        } else {
          p1[0] = gridRect.x;
          p1[1] = tickCoord;
          p2[0] = gridRect.x + gridRect.width;
          p2[1] = tickCoord;
        }

        var line = new Line({
          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
          autoBatch: true,
          shape: {
            x1: p1[0],
            y1: p1[1],
            x2: p2[0],
            y2: p2[1]
          },
          style: lineStyle,
          silent: true
        });
        subPixelOptimizeLine$1(line.shape, lineStyle.lineWidth);
        axisGroup.add(line);
      }
    }
  },
  splitArea: function (axisView, axisGroup, axisModel, gridModel) {
    rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel);
  }
};

var CartesianXAxisView =
/** @class */
function (_super) {
  __extends$1(CartesianXAxisView, _super);

  function CartesianXAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianXAxisView.type;
    return _this;
  }

  CartesianXAxisView.type = 'xAxis';
  return CartesianXAxisView;
}(CartesianAxisView);

var CartesianYAxisView =
/** @class */
function (_super) {
  __extends$1(CartesianYAxisView, _super);

  function CartesianYAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CartesianXAxisView.type;
    return _this;
  }

  CartesianYAxisView.type = 'yAxis';
  return CartesianYAxisView;
}(CartesianAxisView);

var GridView =
/** @class */
function (_super) {
  __extends$1(GridView, _super);

  function GridView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'grid';
    return _this;
  }

  GridView.prototype.render = function (gridModel, ecModel) {
    this.group.removeAll();

    if (gridModel.get('show')) {
      this.group.add(new Rect({
        shape: gridModel.coordinateSystem.getRect(),
        style: defaults({
          fill: gridModel.get('backgroundColor')
        }, gridModel.getItemStyle()),
        silent: true,
        z2: -1
      }));
    }
  };

  GridView.type = 'grid';
  return GridView;
}(ComponentView);

var extraOption = {
  // gridIndex: 0,
  // gridId: '',
  offset: 0
};
function install$5(registers) {
  registers.registerComponentView(GridView);
  registers.registerComponentModel(GridModel);
  registers.registerCoordinateSystem('cartesian2d', Grid);
  axisModelCreator(registers, 'x', CartesianAxisModel, extraOption);
  axisModelCreator(registers, 'y', CartesianAxisModel, extraOption);
  registers.registerComponentView(CartesianXAxisView);
  registers.registerComponentView(CartesianYAxisView);
  registers.registerPreprocessor(function (option) {
    // Only create grid when need
    if (option.xAxis && option.yAxis && !option.grid) {
      option.grid = {};
    }
  });
}

function install$6(registers) {
  // In case developer forget to include grid component
  use(install$5);
  registers.registerSeriesModel(ScatterSeriesModel);
  registers.registerChartView(ScatterView);
  registers.registerLayout(pointsLayout('scatter'));
}

function radarLayout(ecModel) {
  ecModel.eachSeriesByType('radar', function (seriesModel) {
    var data = seriesModel.getData();
    var points = [];
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      return;
    }

    var axes = coordSys.getIndicatorAxes();
    each(axes, function (axis, axisIndex) {
      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
        points[dataIndex] = points[dataIndex] || [];
        var point = coordSys.dataToPoint(val, axisIndex);
        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
      });
    }); // Close polygon

    data.each(function (idx) {
      // TODO
      // Is it appropriate to connect to the next data when some data is missing?
      // Or, should trade it like `connectNull` in line chart?
      var firstPoint = find$1(points[idx], function (point) {
        return isValidPoint(point);
      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array

      points[idx].push(firstPoint.slice());
      data.setItemLayout(idx, points[idx]);
    });
  });
}

function isValidPoint(point) {
  return !isNaN(point[0]) && !isNaN(point[1]);
}

function getValueMissingPoint(coordSys) {
  // It is error-prone to input [NaN, NaN] into polygon, polygon.
  // (probably cause problem when refreshing or animating)
  return [coordSys.cx, coordSys.cy];
}

function radarBackwardCompat(option) {
  var polarOptArr = option.polar;

  if (polarOptArr) {
    if (!isArray$1(polarOptArr)) {
      polarOptArr = [polarOptArr];
    }

    var polarNotRadar_1 = [];
    each(polarOptArr, function (polarOpt, idx) {
      if (polarOpt.indicator) {
        if (polarOpt.type && !polarOpt.shape) {
          polarOpt.shape = polarOpt.type;
        }

        option.radar = option.radar || [];

        if (!isArray$1(option.radar)) {
          option.radar = [option.radar];
        }

        option.radar.push(polarOpt);
      } else {
        polarNotRadar_1.push(polarOpt);
      }
    });
    option.polar = polarNotRadar_1;
  }

  each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
      seriesOpt.radarIndex = seriesOpt.polarIndex;
    }
  });
}

var RadarView =
/** @class */
function (_super) {
  __extends$1(RadarView, _super);

  function RadarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarView.type;
    return _this;
  }

  RadarView.prototype.render = function (seriesModel, ecModel, api) {
    var polar = seriesModel.coordinateSystem;
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;

    function createSymbol$1(data, idx) {
      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';

      if (symbolType === 'none') {
        return;
      }

      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
      var symbolPath = createSymbol(symbolType, -1, -1, 2, 2);
      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
      symbolPath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 100,
        scaleX: symbolSize[0] / 2,
        scaleY: symbolSize[1] / 2,
        rotation: symbolRotate * Math.PI / 180 || 0
      });
      return symbolPath;
    }

    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
      // Simply rerender all
      symbolGroup.removeAll();

      for (var i = 0; i < newPoints.length - 1; i++) {
        var symbolPath = createSymbol$1(data, idx);

        if (symbolPath) {
          symbolPath.__dimIdx = i;

          if (oldPoints[i]) {
            symbolPath.setPosition(oldPoints[i]);
            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
              x: newPoints[i][0],
              y: newPoints[i][1]
            }, seriesModel, idx);
          } else {
            symbolPath.setPosition(newPoints[i]);
          }

          symbolGroup.add(symbolPath);
        }
      }
    }

    function getInitialPoints(points) {
      return map(points, function (pt) {
        return [polar.cx, polar.cy];
      });
    }

    data.diff(oldData).add(function (idx) {
      var points = data.getItemLayout(idx);

      if (!points) {
        return;
      }

      var polygon = new Polygon();
      var polyline = new Polyline();
      var target = {
        shape: {
          points: points
        }
      };
      polygon.shape.points = getInitialPoints(points);
      polyline.shape.points = getInitialPoints(points);
      initProps(polygon, target, seriesModel, idx);
      initProps(polyline, target, seriesModel, idx);
      var itemGroup = new Group$1();
      var symbolGroup = new Group$1();
      itemGroup.add(polyline);
      itemGroup.add(polygon);
      itemGroup.add(symbolGroup);
      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
      data.setItemGraphicEl(idx, itemGroup);
    }).update(function (newIdx, oldIdx) {
      var itemGroup = oldData.getItemGraphicEl(oldIdx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2);
      var target = {
        shape: {
          points: data.getItemLayout(newIdx)
        }
      };

      if (!target.shape.points) {
        return;
      }

      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
      saveOldStyle(polygon);
      saveOldStyle(polyline);
      updateProps(polyline, target, seriesModel);
      updateProps(polygon, target, seriesModel);
      data.setItemGraphicEl(newIdx, itemGroup);
    }).remove(function (idx) {
      group.remove(oldData.getItemGraphicEl(idx));
    }).execute();
    data.eachItemGraphicEl(function (itemGroup, idx) {
      var itemModel = data.getItemModel(idx);
      var polyline = itemGroup.childAt(0);
      var polygon = itemGroup.childAt(1);
      var symbolGroup = itemGroup.childAt(2); // Radar uses the visual encoded from itemStyle.

      var itemStyle = data.getItemVisual(idx, 'style');
      var color = itemStyle.fill;
      group.add(itemGroup);
      polyline.useStyle(defaults(itemModel.getModel('lineStyle').getLineStyle(), {
        fill: 'none',
        stroke: color
      }));
      setStatesStylesFromModel(polyline, itemModel, 'lineStyle');
      setStatesStylesFromModel(polygon, itemModel, 'areaStyle');
      var areaStyleModel = itemModel.getModel('areaStyle');
      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
      polygon.ignore = polygonIgnore;
      each(['emphasis', 'select', 'blur'], function (stateName) {
        var stateModel = itemModel.getModel([stateName, 'areaStyle']);
        var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty(); // Won't be ignore if normal state is not ignore.

        polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
      });
      polygon.useStyle(defaults(areaStyleModel.getAreaStyle(), {
        fill: color,
        opacity: 0.7,
        decal: itemStyle.decal
      }));
      var emphasisModel = itemModel.getModel('emphasis');
      var itemHoverStyle = emphasisModel.getModel('itemStyle').getItemStyle();
      symbolGroup.eachChild(function (symbolPath) {
        if (symbolPath instanceof ZRImage) {
          var pathStyle = symbolPath.style;
          symbolPath.useStyle(extend({
            // TODO other properties like x, y ?
            image: pathStyle.image,
            x: pathStyle.x,
            y: pathStyle.y,
            width: pathStyle.width,
            height: pathStyle.height
          }, itemStyle));
        } else {
          symbolPath.useStyle(itemStyle);
          symbolPath.setColor(color);
          symbolPath.style.strokeNoScale = true;
        }

        var pathEmphasisState = symbolPath.ensureState('emphasis');
        pathEmphasisState.style = clone(itemHoverStyle);
        var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
        setLabelStyle(symbolPath, getLabelStatesModels(itemModel), {
          labelFetcher: data.hostModel,
          labelDataIndex: idx,
          labelDimIndex: symbolPath.__dimIdx,
          defaultText: defaultText,
          inheritColor: color,
          defaultOpacity: itemStyle.opacity
        });
      });
      toggleHoverEmphasis(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    });
    this._data = data;
  };

  RadarView.prototype.remove = function () {
    this.group.removeAll();
    this._data = null;
  };

  RadarView.type = 'radar';
  return RadarView;
}(ChartView);

var RadarSeriesModel =
/** @class */
function (_super) {
  __extends$1(RadarSeriesModel, _super);

  function RadarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  } // Overwrite


  RadarSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));
  };

  RadarSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesDataSimply(this, {
      generateCoord: 'indicator_',
      generateCoordCount: Infinity
    });
  };

  RadarSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var coordSys = this.coordinateSystem;
    var indicatorAxes = coordSys.getIndicatorAxes();
    var name = this.getData().getName(dataIndex);
    var nameToDisplay = name === '' ? this.name : name;
    var markerColor = retrieveVisualColorForTooltipMarker(this, dataIndex);
    return createTooltipMarkup('section', {
      header: nameToDisplay,
      sortBlocks: true,
      blocks: map(indicatorAxes, function (axis) {
        var val = data.get(data.mapDimension(axis.dim), dataIndex);
        return createTooltipMarkup('nameValue', {
          markerType: 'subItem',
          markerColor: markerColor,
          name: axis.name,
          value: val,
          sortParam: val
        });
      })
    });
  };

  RadarSeriesModel.prototype.getTooltipPosition = function (dataIndex) {
    if (dataIndex != null) {
      var data_1 = this.getData();
      var coordSys = this.coordinateSystem;
      var values = data_1.getValues(map(coordSys.dimensions, function (dim) {
        return data_1.mapDimension(dim);
      }), dataIndex);

      for (var i = 0, len = values.length; i < len; i++) {
        if (!isNaN(values[i])) {
          var indicatorAxes = coordSys.getIndicatorAxes();
          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
        }
      }
    }
  };

  RadarSeriesModel.type = 'series.radar';
  RadarSeriesModel.dependencies = ['radar'];
  RadarSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    coordinateSystem: 'radar',
    legendHoverLink: true,
    radarIndex: 0,
    lineStyle: {
      width: 2,
      type: 'solid',
      join: 'round'
    },
    label: {
      position: 'top'
    },
    // areaStyle: {
    // },
    // itemStyle: {}
    symbolSize: 8 // symbolRotate: null

  };
  return RadarSeriesModel;
}(SeriesModel);

var valueAxisDefault = axisDefault.value;

function defaultsShow(opt, show) {
  return defaults({
    show: show
  }, opt);
}

var RadarModel =
/** @class */
function (_super) {
  __extends$1(RadarModel, _super);

  function RadarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarModel.type;
    return _this;
  }

  RadarModel.prototype.optionUpdated = function () {
    var boundaryGap = this.get('boundaryGap');
    var splitNumber = this.get('splitNumber');
    var scale = this.get('scale');
    var axisLine = this.get('axisLine');
    var axisTick = this.get('axisTick'); // let axisType = this.get('axisType');

    var axisLabel = this.get('axisLabel');
    var nameTextStyle = this.get('axisName');
    var showName = this.get(['axisName', 'show']);
    var nameFormatter = this.get(['axisName', 'formatter']);
    var nameGap = this.get('axisNameGap');
    var triggerEvent = this.get('triggerEvent');
    var indicatorModels = map(this.get('indicator') || [], function (indicatorOpt) {
      // PENDING
      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
        indicatorOpt.min = 0;
      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
        indicatorOpt.max = 0;
      }

      var iNameTextStyle = nameTextStyle;

      if (indicatorOpt.color != null) {
        iNameTextStyle = defaults({
          color: indicatorOpt.color
        }, nameTextStyle);
      } // Use same configuration


      var innerIndicatorOpt = merge$1(clone(indicatorOpt), {
        boundaryGap: boundaryGap,
        splitNumber: splitNumber,
        scale: scale,
        axisLine: axisLine,
        axisTick: axisTick,
        // axisType: axisType,
        axisLabel: axisLabel,
        // Compatible with 2 and use text
        name: indicatorOpt.text,
        showName: showName,
        nameLocation: 'end',
        nameGap: nameGap,
        // min: 0,
        nameTextStyle: iNameTextStyle,
        triggerEvent: triggerEvent
      }, false);

      if (isString(nameFormatter)) {
        var indName = innerIndicatorOpt.name;
        innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
      } else if (isFunction$3(nameFormatter)) {
        innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
      }

      var model = new Model(innerIndicatorOpt, null, this.ecModel);
      mixin(model, AxisModelCommonMixin.prototype); // For triggerEvent.

      model.mainType = 'radar';
      model.componentIndex = this.componentIndex;
      return model;
    }, this);
    this._indicatorModels = indicatorModels;
  };

  RadarModel.prototype.getIndicatorModels = function () {
    return this._indicatorModels;
  };

  RadarModel.type = 'radar';
  RadarModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '75%',
    startAngle: 90,
    axisName: {
      show: true // formatter: null
      // textStyle: {}

    },
    boundaryGap: [0, 0],
    splitNumber: 5,
    axisNameGap: 15,
    scale: false,
    // Polygon or circle
    shape: 'polygon',
    axisLine: merge$1({
      lineStyle: {
        color: '#bbb'
      }
    }, valueAxisDefault.axisLine),
    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
    // axisType: 'value',
    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
    // {text, min, max}
    indicator: []
  };
  return RadarModel;
}(ComponentModel);

var axisBuilderAttrs$1 = ['axisLine', 'axisTickLabel', 'axisName'];

var RadarView$1 =
/** @class */
function (_super) {
  __extends$1(RadarView, _super);

  function RadarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadarView.type;
    return _this;
  }

  RadarView.prototype.render = function (radarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();

    this._buildAxes(radarModel);

    this._buildSplitLineAndArea(radarModel);
  };

  RadarView.prototype._buildAxes = function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();
    var axisBuilders = map(indicatorAxes, function (indicatorAxis) {
      var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name

      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
        axisName: axisName,
        position: [radar.cx, radar.cy],
        rotation: indicatorAxis.angle,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1
      });
      return axisBuilder;
    });
    each(axisBuilders, function (axisBuilder) {
      each(axisBuilderAttrs$1, axisBuilder.add, axisBuilder);
      this.group.add(axisBuilder.getGroup());
    }, this);
  };

  RadarView.prototype._buildSplitLineAndArea = function (radarModel) {
    var radar = radarModel.coordinateSystem;
    var indicatorAxes = radar.getIndicatorAxes();

    if (!indicatorAxes.length) {
      return;
    }

    var shape = radarModel.get('shape');
    var splitLineModel = radarModel.getModel('splitLine');
    var splitAreaModel = radarModel.getModel('splitArea');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var showSplitLine = splitLineModel.get('show');
    var showSplitArea = splitAreaModel.get('show');
    var splitLineColors = lineStyleModel.get('color');
    var splitAreaColors = areaStyleModel.get('color');
    var splitLineColorsArr = isArray$1(splitLineColors) ? splitLineColors : [splitLineColors];
    var splitAreaColorsArr = isArray$1(splitAreaColors) ? splitAreaColors : [splitAreaColors];
    var splitLines = [];
    var splitAreas = [];

    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
      var colorIndex = idx % areaOrLineColorList.length;
      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
      return colorIndex;
    }

    if (shape === 'circle') {
      var ticksRadius = indicatorAxes[0].getTicksCoords();
      var cx = radar.cx;
      var cy = radar.cy;

      for (var i = 0; i < ticksRadius.length; i++) {
        if (showSplitLine) {
          var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
          splitLines[colorIndex].push(new Circle$1({
            shape: {
              cx: cx,
              cy: cy,
              r: ticksRadius[i].coord
            }
          }));
        }

        if (showSplitArea && i < ticksRadius.length - 1) {
          var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
          splitAreas[colorIndex].push(new Ring({
            shape: {
              cx: cx,
              cy: cy,
              r0: ticksRadius[i].coord,
              r: ticksRadius[i + 1].coord
            }
          }));
        }
      }
    } // Polyyon
    else {
        var realSplitNumber_1;
        var axesTicksPoints = map(indicatorAxes, function (indicatorAxis, idx) {
          var ticksCoords = indicatorAxis.getTicksCoords();
          realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
          return map(ticksCoords, function (tickCoord) {
            return radar.coordToPoint(tickCoord.coord, idx);
          });
        });
        var prevPoints = [];

        for (var i = 0; i <= realSplitNumber_1; i++) {
          var points = [];

          for (var j = 0; j < indicatorAxes.length; j++) {
            points.push(axesTicksPoints[j][i]);
          } // Close


          if (points[0]) {
            points.push(points[0].slice());
          } else {
            if (process.env.NODE_ENV !== 'production') {
              console.error('Can\'t draw value axis ' + i);
            }
          }

          if (showSplitLine) {
            var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
            splitLines[colorIndex].push(new Polyline({
              shape: {
                points: points
              }
            }));
          }

          if (showSplitArea && prevPoints) {
            var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
            splitAreas[colorIndex].push(new Polygon({
              shape: {
                points: points.concat(prevPoints)
              }
            }));
          }

          prevPoints = points.slice().reverse();
        }
      }

    var lineStyle = lineStyleModel.getLineStyle();
    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine

    each(splitAreas, function (splitAreas, idx) {
      this.group.add(mergePath$1(splitAreas, {
        style: defaults({
          stroke: 'none',
          fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
        }, areaStyle),
        silent: true
      }));
    }, this);
    each(splitLines, function (splitLines, idx) {
      this.group.add(mergePath$1(splitLines, {
        style: defaults({
          fill: 'none',
          stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
        }, lineStyle),
        silent: true
      }));
    }, this);
  };

  RadarView.type = 'radar';
  return RadarView;
}(ComponentView);

var IndicatorAxis =
/** @class */
function (_super) {
  __extends$1(IndicatorAxis, _super);

  function IndicatorAxis(dim, scale, radiusExtent) {
    var _this = _super.call(this, dim, scale, radiusExtent) || this;

    _this.type = 'value';
    _this.angle = 0;
    _this.name = '';
    return _this;
  }

  return IndicatorAxis;
}(Axis);

var Radar =
/** @class */
function () {
  function Radar(radarModel, ecModel, api) {
    /**
     *
     * Radar dimensions
     */
    this.dimensions = [];
    this._model = radarModel;
    this._indicatorAxes = map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
      var dim = 'indicator_' + idx;
      var indicatorAxis = new IndicatorAxis(dim, new IntervalScale() // (indicatorModel.get('axisType') === 'log') ? new LogScale() : new IntervalScale()
      );
      indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis

      indicatorAxis.model = indicatorModel;
      indicatorModel.axis = indicatorAxis;
      this.dimensions.push(dim);
      return indicatorAxis;
    }, this);
    this.resize(radarModel, api);
  }

  Radar.prototype.getIndicatorAxes = function () {
    return this._indicatorAxes;
  };

  Radar.prototype.dataToPoint = function (value, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
  }; // TODO: API should be coordToPoint([coord, indicatorIndex])


  Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
    var indicatorAxis = this._indicatorAxes[indicatorIndex];
    var angle = indicatorAxis.angle;
    var x = this.cx + coord * Math.cos(angle);
    var y = this.cy - coord * Math.sin(angle);
    return [x, y];
  };

  Radar.prototype.pointToData = function (pt) {
    var dx = pt[0] - this.cx;
    var dy = pt[1] - this.cy;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx); // Find the closest angle
    // FIXME index can calculated directly

    var minRadianDiff = Infinity;
    var closestAxis;
    var closestAxisIdx = -1;

    for (var i = 0; i < this._indicatorAxes.length; i++) {
      var indicatorAxis = this._indicatorAxes[i];
      var diff = Math.abs(radian - indicatorAxis.angle);

      if (diff < minRadianDiff) {
        closestAxis = indicatorAxis;
        closestAxisIdx = i;
        minRadianDiff = diff;
      }
    }

    return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
  };

  Radar.prototype.resize = function (radarModel, api) {
    var center = radarModel.get('center');
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var viewSize = Math.min(viewWidth, viewHeight) / 2;
    this.cx = parsePercent$1(center[0], viewWidth);
    this.cy = parsePercent$1(center[1], viewHeight);
    this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`

    var radius = radarModel.get('radius');

    if (isString(radius) || isNumber$1(radius)) {
      radius = [0, radius];
    }

    this.r0 = parsePercent$1(radius[0], viewSize);
    this.r = parsePercent$1(radius[1], viewSize);
    each(this._indicatorAxes, function (indicatorAxis, idx) {
      indicatorAxis.setExtent(this.r0, this.r);
      var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]

      angle = Math.atan2(Math.sin(angle), Math.cos(angle));
      indicatorAxis.angle = angle;
    }, this);
  };

  Radar.prototype.update = function (ecModel, api) {
    var indicatorAxes = this._indicatorAxes;
    var radarModel = this._model;
    each(indicatorAxes, function (indicatorAxis) {
      indicatorAxis.scale.setExtent(Infinity, -Infinity);
    });
    ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
      if (radarSeries.get('coordinateSystem') !== 'radar' // @ts-ignore
      || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
        return;
      }

      var data = radarSeries.getData();
      each(indicatorAxes, function (indicatorAxis) {
        indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
      });
    }, this);
    var splitNumber = radarModel.get('splitNumber');
    var dummyScale = new IntervalScale();
    dummyScale.setExtent(0, splitNumber);
    dummyScale.setInterval(1); // Force all the axis fixing the maxSplitNumber.

    each(indicatorAxes, function (indicatorAxis, idx) {
      alignScaleTicks(indicatorAxis.scale, indicatorAxis.model, dummyScale);
    });
  };

  Radar.prototype.convertToPixel = function (ecModel, finder, value) {
    console.warn('Not implemented.');
    return null;
  };

  Radar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    console.warn('Not implemented.');
    return null;
  };

  Radar.prototype.containPoint = function (point) {
    console.warn('Not implemented.');
    return false;
  };

  Radar.create = function (ecModel, api) {
    var radarList = [];
    ecModel.eachComponent('radar', function (radarModel) {
      var radar = new Radar(radarModel, ecModel, api);
      radarList.push(radar);
      radarModel.coordinateSystem = radar;
    });
    ecModel.eachSeriesByType('radar', function (radarSeries) {
      if (radarSeries.get('coordinateSystem') === 'radar') {
        // Inject coordinate system
        // @ts-ignore
        radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
      }
    });
    return radarList;
  };
  /**
   * Radar dimensions is based on the data
   */


  Radar.dimensions = [];
  return Radar;
}();

function install$7(registers) {
  registers.registerCoordinateSystem('radar', Radar);
  registers.registerComponentModel(RadarModel);
  registers.registerComponentView(RadarView$1);
  registers.registerVisual({
    seriesType: 'radar',
    reset: function (seriesModel) {
      var data = seriesModel.getData(); // itemVisual symbol is for selected data

      data.each(function (idx) {
        data.setItemVisual(idx, 'legendIcon', 'roundRect');
      }); // visual is for unselected data

      data.setVisual('legendIcon', 'roundRect');
    }
  });
}

function install$8(registers) {
  use(install$7);
  registers.registerChartView(RadarView);
  registers.registerSeriesModel(RadarSeriesModel);
  registers.registerLayout(radarLayout);
  registers.registerProcessor(dataFilter('radar'));
  registers.registerPreprocessor(radarBackwardCompat);
}

var ATTR = '\0_ec_interaction_mutex';
function take(zr, resourceKey, userKey) {
  var store = getStore(zr);
  store[resourceKey] = userKey;
}
function release(zr, resourceKey, userKey) {
  var store = getStore(zr);
  var uKey = store[resourceKey];

  if (uKey === userKey) {
    store[resourceKey] = null;
  }
}
function isTaken(zr, resourceKey) {
  return !!getStore(zr)[resourceKey];
}

function getStore(zr) {
  return zr[ATTR] || (zr[ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */
// TODO: SELF REGISTERED.


registerAction({
  type: 'takeGlobalCursor',
  event: 'globalCursorTaken',
  update: 'update'
}, noop$2);

var RoamController =
/** @class */
function (_super) {
  __extends$1(RoamController, _super);

  function RoamController(zr) {
    var _this = _super.call(this) || this;

    _this._zr = zr; // Avoid two roamController bind the same handler

    var mousedownHandler = bind(_this._mousedownHandler, _this);
    var mousemoveHandler = bind(_this._mousemoveHandler, _this);
    var mouseupHandler = bind(_this._mouseupHandler, _this);
    var mousewheelHandler = bind(_this._mousewheelHandler, _this);
    var pinchHandler = bind(_this._pinchHandler, _this);
    /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */

    _this.enable = function (controlType, opt) {
      // Disable previous first
      this.disable();
      this._opt = defaults(clone(opt) || {}, {
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        // By default, wheel do not trigger move.
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
      });

      if (controlType == null) {
        controlType = true;
      }

      if (controlType === true || controlType === 'move' || controlType === 'pan') {
        zr.on('mousedown', mousedownHandler);
        zr.on('mousemove', mousemoveHandler);
        zr.on('mouseup', mouseupHandler);
      }

      if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
        zr.on('mousewheel', mousewheelHandler);
        zr.on('pinch', pinchHandler);
      }
    };

    _this.disable = function () {
      zr.off('mousedown', mousedownHandler);
      zr.off('mousemove', mousemoveHandler);
      zr.off('mouseup', mouseupHandler);
      zr.off('mousewheel', mousewheelHandler);
      zr.off('pinch', pinchHandler);
    };

    return _this;
  }

  RoamController.prototype.isDragging = function () {
    return this._dragging;
  };

  RoamController.prototype.isPinching = function () {
    return this._pinching;
  };

  RoamController.prototype.setPointerChecker = function (pointerChecker) {
    this.pointerChecker = pointerChecker;
  };

  RoamController.prototype.dispose = function () {
    this.disable();
  };

  RoamController.prototype._mousedownHandler = function (e) {
    if (isMiddleOrRightButtonOnMouseUpDown(e)) {
      return;
    }

    var el = e.target;

    while (el) {
      if (el.draggable) {
        return;
      } // check if host is draggable


      el = el.__hostTarget || el.parent;
    }

    var x = e.offsetX;
    var y = e.offsetY; // Only check on mosedown, but not mousemove.
    // Mouse can be out of target when mouse moving.

    if (this.pointerChecker && this.pointerChecker(e, x, y)) {
      this._x = x;
      this._y = y;
      this._dragging = true;
    }
  };

  RoamController.prototype._mousemoveHandler = function (e) {
    if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || isTaken(this._zr, 'globalPan')) {
      return;
    }

    var x = e.offsetX;
    var y = e.offsetY;
    var oldX = this._x;
    var oldY = this._y;
    var dx = x - oldX;
    var dy = y - oldY;
    this._x = x;
    this._y = y;
    this._opt.preventDefaultMouseMove && stop(e.event);
    trigger(this, 'pan', 'moveOnMouseMove', e, {
      dx: dx,
      dy: dy,
      oldX: oldX,
      oldY: oldY,
      newX: x,
      newY: y,
      isAvailableBehavior: null
    });
  };

  RoamController.prototype._mouseupHandler = function (e) {
    if (!isMiddleOrRightButtonOnMouseUpDown(e)) {
      this._dragging = false;
    }
  };

  RoamController.prototype._mousewheelHandler = function (e) {
    var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
    var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
    var wheelDelta = e.wheelDelta;
    var absWheelDeltaDelta = Math.abs(wheelDelta);
    var originX = e.offsetX;
    var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.

    if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
      return;
    } // If both `shouldZoom` and `shouldMove` is true, trigger
    // their event both, and the final behavior is determined
    // by event listener themselves.


    if (shouldZoom) {
      // Convenience:
      // Mac and VM Windows on Mac: scroll up: zoom out.
      // Windows: scroll up: zoom in.
      // FIXME: Should do more test in different environment.
      // wheelDelta is too complicated in difference nvironment
      // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
      // although it has been normallized by zrender.
      // wheelDelta of mouse wheel is bigger than touch pad.
      var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
      var scale = wheelDelta > 0 ? factor : 1 / factor;
      checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
        scale: scale,
        originX: originX,
        originY: originY,
        isAvailableBehavior: null
      });
    }

    if (shouldMove) {
      // FIXME: Should do more test in different environment.
      var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.

      var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
      checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
        scrollDelta: scrollDelta,
        originX: originX,
        originY: originY,
        isAvailableBehavior: null
      });
    }
  };

  RoamController.prototype._pinchHandler = function (e) {
    if (isTaken(this._zr, 'globalPan')) {
      return;
    }

    var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
    checkPointerAndTrigger(this, 'zoom', null, e, {
      scale: scale,
      originX: e.pinchX,
      originY: e.pinchY,
      isAvailableBehavior: null
    });
  };

  return RoamController;
}(Eventful);

function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
    // When mouse is out of roamController rect,
    // default befavoius should not be be disabled, otherwise
    // page sliding is disabled, contrary to expectation.
    stop(e.event);
    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
  }
}

function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
  // Also provide behavior checker for event listener, for some case that
  // multiple components share one listener.
  contollerEvent.isAvailableBehavior = bind(isAvailableBehavior, null, behaviorToCheck, e); // TODO should not have type issue.

  controller.trigger(eventName, contollerEvent);
} // settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.


function isAvailableBehavior(behaviorToCheck, e, settings) {
  var setting = settings[behaviorToCheck];
  return !behaviorToCheck || setting && (!isString(setting) || e.event[setting + 'Key']);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * For geo and graph.
 */
function updateViewOnPan(controllerHost, dx, dy) {
  var target = controllerHost.target;
  target.x += dx;
  target.y += dy;
  target.dirty();
}
/**
 * For geo and graph.
 */

function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
  var target = controllerHost.target;
  var zoomLimit = controllerHost.zoomLimit;
  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
  newZoom *= zoomDelta;

  if (zoomLimit) {
    var zoomMin = zoomLimit.min || 0;
    var zoomMax = zoomLimit.max || Infinity;
    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
  }

  var zoomScale = newZoom / controllerHost.zoom;
  controllerHost.zoom = newZoom; // Keep the mouse center when scaling

  target.x -= (zoomX - target.x) * (zoomScale - 1);
  target.y -= (zoomY - target.y) * (zoomScale - 1);
  target.scaleX *= zoomScale;
  target.scaleY *= zoomScale;
  target.dirty();
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var IRRELEVANT_EXCLUDES = {
  'axisPointer': 1,
  'tooltip': 1,
  'brush': 1
};
/**
 * Avoid that: mouse click on a elements that is over geo or graph,
 * but roam is triggered.
 */

function onIrrelevantElement(e, api, targetCoordSysModel) {
  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.

  var coordSys = model && model.coordinateSystem;
  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}

function parseXML(svg) {
    if (isString(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) {
        svgNode = svgNode.firstChild;
    }
    while (svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1) {
        svgNode = svgNode.nextSibling;
    }
    return svgNode;
}

var nodeParsers;
var INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = keys$2(INHERITABLE_STYLE_ATTRIBUTES_MAP);
var SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var SELF_STYLE_ATTRIBUTES_MAP_KEYS = keys$2(SELF_STYLE_ATTRIBUTES_MAP);
var SVGParser = (function () {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function (xml, opt) {
        opt = opt || {};
        var svg = parseXML(xml);
        if (process.env.NODE_ENV !== 'production') {
            if (!svg) {
                throw new Error('Illegal svg');
            }
        }
        this._defsUsePending = [];
        var root = new Group$1();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat((svg.getAttribute('width') || opt.width));
        var height = parseFloat((svg.getAttribute('height') || opt.height));
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while (child) {
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) {
                viewBoxRect = {
                    x: parseFloat((viewBoxArr[0] || 0)),
                    y: parseFloat((viewBoxArr[1] || 0)),
                    width: parseFloat(viewBoxArr[2]),
                    height: parseFloat(viewBoxArr[3])
                };
            }
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = makeViewBoxTransform(viewBoxRect, { x: 0, y: 0, width: width, height: height });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new Group$1();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) {
            root.setClipPath(new Rect({
                shape: { x: 0, y: 0, width: width, height: height }
            }));
        }
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function (xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') {
            isInDefs = true;
        }
        if (nodeName === 'text') {
            isInText = true;
        }
        if (nodeName === 'defs' || nodeName === 'switch') {
            el = parentGroup;
        }
        else {
            if (!isInDefs) {
                var parser_1 = nodeParsers[nodeName];
                if (parser_1 && hasOwn(nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') {
                            namedFromForSub = newNamed;
                        }
                    }
                    else if (namedFrom) {
                        named.push({
                            name: namedFrom.name,
                            namedFrom: namedFrom,
                            svgNodeTagLower: nodeName,
                            el: el
                        });
                    }
                    parentGroup.add(el);
                }
            }
            var parser = paintServerParsers[nodeName];
            if (parser && hasOwn(paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) {
                    this._defs[id] = def;
                }
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while (child) {
                if (child.nodeType === 1) {
                    this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                }
                else if (child.nodeType === 3 && isInText) {
                    this._parseText(child, el);
                }
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
        var text = new TSpan({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        inheritStyle(parentGroup, text);
        parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = (function () {
        nodeParsers = {
            'g': function (xmlNode, parentGroup) {
                var g = new Group$1();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function (xmlNode, parentGroup) {
                var rect = new Rect();
                inheritStyle(parentGroup, rect);
                parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function (xmlNode, parentGroup) {
                var circle = new Circle$1();
                inheritStyle(parentGroup, circle);
                parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function (xmlNode, parentGroup) {
                var line = new Line();
                inheritStyle(parentGroup, line);
                parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function (xmlNode, parentGroup) {
                var ellipse = new Ellipse();
                inheritStyle(parentGroup, ellipse);
                parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function (xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) {
                    pointsArr = parsePoints(pointsStr);
                }
                var polygon = new Polygon({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                inheritStyle(parentGroup, polygon);
                parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function (xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) {
                    pointsArr = parsePoints(pointsStr);
                }
                var polyline = new Polyline({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                inheritStyle(parentGroup, polyline);
                parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function (xmlNode, parentGroup) {
                var img = new ZRImage();
                inheritStyle(parentGroup, img);
                parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function (xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new Group$1();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function (xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) {
                    this._textX = parseFloat(x);
                }
                if (y != null) {
                    this._textY = parseFloat(y);
                }
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new Group$1();
                inheritStyle(parentGroup, g);
                parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function (xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = createFromString(d);
                inheritStyle(parentGroup, path);
                parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    })();
    return SVGParser;
}());
var paintServerParsers = {
    'lineargradient': function (xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new LinearGradient(x1, y1, x2, y2);
        parsePaintServerUnit(xmlNode, gradient);
        parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function (xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new RadialGradient(cx, cy, r);
        parsePaintServerUnit(xmlNode, gradient);
        parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') {
        gradient.global = true;
    }
}
function parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while (stop) {
        if (stop.nodeType === 1
            && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) {
                offset = parseInt(offsetStr, 10) / 100;
            }
            else if (offsetStr) {
                offset = parseFloat(offsetStr);
            }
            else {
                offset = 0;
            }
            var styleVals = {};
            parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor
                || stop.getAttribute('stop-color')
                || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) {
            child.__inheritedStyle = {};
        }
        defaults(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function parsePoints(pointsString) {
    var list = splitNumberSequence(pointsString);
    var points = [];
    for (var i = 0; i < list.length; i += 2) {
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([x, y]);
    }
    return points;
}
function parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        parseTransformAttribute(xmlNode, el);
        parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) {
            parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
        }
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) {
        disp.style.fill = getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    }
    if (inheritedStyle.stroke != null) {
        disp.style.stroke = getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    }
    each([
        'lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'
    ], function (propName) {
        if (inheritedStyle[propName] != null) {
            disp.style[propName] = parseFloat(inheritedStyle[propName]);
        }
    });
    each([
        'lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign'
    ], function (propName) {
        if (inheritedStyle[propName] != null) {
            disp.style[propName] = inheritedStyle[propName];
        }
    });
    if (isTextGroup) {
        disp.__selfStyle = selfStyle;
    }
    if (inheritedStyle.lineDash) {
        disp.style.lineDash = map(splitNumberSequence(inheritedStyle.lineDash), function (str) {
            return parseFloat(str);
        });
    }
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') {
        disp.invisible = true;
    }
    if (inheritedStyle.display === 'none') {
        disp.ignore = true;
    }
}
function applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') {
            zrTextBaseline = 'alphabetic';
        }
        else if (textBaseline === 'baseline') {
            zrTextBaseline = 'alphabetic';
        }
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') {
            zrTextBaseline = 'top';
        }
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') {
            zrTextBaseline = 'bottom';
        }
        else if (textBaseline === 'central' || textBaseline === 'mathematical') {
            zrTextBaseline = 'middle';
        }
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') {
                zrTextAlign = 'center';
            }
            text.style.textAlign = zrTextAlign;
        }
    }
}
var urlRegex = /^url\(\s*#(.*?)\)/;
function getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match(urlRegex);
    if (urlMatch) {
        var url = trim(urlMatch[1]);
        defsUsePending.push([el, method, url]);
        return;
    }
    if (str === 'none') {
        str = null;
    }
    return str;
}
function applyDefs(defs, defsUsePending) {
    for (var i = 0; i < defsUsePending.length; i++) {
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var numberReg$1 = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function splitNumberSequence(rawStr) {
    return rawStr.match(numberReg$1) || [];
}
var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var DEGREE_TO_ANGLE = Math.PI / 180;
function parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace(transformRegex, function (str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for (var i = transformOps_1.length - 1; i > 0; i -= 2) {
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = splitNumberSequence(value);
            mt = mt || create$1();
            switch (type) {
                case 'translate':
                    translate(mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || '0')]);
                    break;
                case 'scale':
                    scale$1(mt, mt, [parseFloat(valueArr[0]), parseFloat(valueArr[1] || valueArr[0])]);
                    break;
                case 'rotate':
                    rotate(mt, mt, -parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    mul$1(mt, [1, 0, sx, 1, 0, 0], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * DEGREE_TO_ANGLE);
                    mul$1(mt, [1, sy, 0, 1, 0, 0], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) {
        return;
    }
    styleRegex.lastIndex = 0;
    var styleRegResult;
    while ((styleRegResult = styleRegex.exec(style)) != null) {
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = hasOwn(INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr)
            ? INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr]
            : null;
        if (zrInheritableStlAttr) {
            inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        }
        var zrSelfStlAttr = hasOwn(SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr)
            ? SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr]
            : null;
        if (zrSelfStlAttr) {
            selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
        }
    }
}
function parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for (var i = 0; i < INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
        var svgAttrName = INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) {
            inheritableStyleResult[INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
    for (var i = 0; i < SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++) {
        var svgAttrName = SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) {
            selfStyleResult[SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
        }
    }
}
function makeViewBoxTransform(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function parseSVG(xml, opt) {
    var parser = new SVGParser();
    return parser.parse(xml, opt);
}

/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */

var REGION_AVAILABLE_SVG_TAG_MAP = createHashMap(['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path', // <text> <tspan> are also enabled because some SVG might paint text itself,
// but still need to trigger events or tooltip.
'text', 'tspan', // <g> is also enabled because this case: if multiple tags share one name
// and need label displayed, every tags will display the name, which is not
// expected. So we can put them into a <g name="xxx">. Thereby only one label
// displayed and located based on the bounding rect of the <g>.
'g']);

var GeoSVGResource =
/** @class */
function () {
  function GeoSVGResource(mapName, svg) {
    this.type = 'geoSVG'; // All used graphics. key: hostKey, value: root

    this._usedGraphicMap = createHashMap(); // All unused graphics.

    this._freedGraphics = [];
    this._mapName = mapName; // Only perform parse to XML object here, which might be time
    // consiming for large SVG.
    // Although convert XML to zrender element is also time consiming,
    // if we do it here, the clone of zrender elements has to be
    // required. So we do it once for each geo instance, util real
    // performance issues call for optimizing it.

    this._parsedXML = parseXML(svg);
  }

  GeoSVGResource.prototype.load = function ()
  /* nameMap: NameMap */
  {
    // In the "load" stage, graphic need to be built to
    // get boundingRect for geo coordinate system.
    var firstGraphic = this._firstGraphic; // Create the return data structure only when first graphic created.
    // Because they will be used in geo coordinate system update stage,
    // and `regions` will be mounted at `geo` coordinate system,
    // in which there is no "view" info, so that it should better not to
    // make references to graphic elements.

    if (!firstGraphic) {
      firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);

      this._freedGraphics.push(firstGraphic);

      this._boundingRect = this._firstGraphic.boundingRect.clone(); // PENDING: `nameMap` will not be supported until some real requirement come.
      // if (nameMap) {
      //     named = applyNameMap(named, nameMap);
      // }

      var _a = createRegions(firstGraphic.named),
          regions = _a.regions,
          regionsMap = _a.regionsMap;

      this._regions = regions;
      this._regionsMap = regionsMap;
    }

    return {
      boundingRect: this._boundingRect,
      regions: this._regions,
      regionsMap: this._regionsMap
    };
  };

  GeoSVGResource.prototype._buildGraphic = function (svgXML) {
    var result;
    var rootFromParse;

    try {
      result = svgXML && parseSVG(svgXML, {
        ignoreViewBox: true,
        ignoreRootClip: true
      }) || {};
      rootFromParse = result.root;
      assert(rootFromParse != null);
    } catch (e) {
      throw new Error('Invalid svg format\n' + e.message);
    } // Note: we keep the covenant that the root has no transform. So always add an extra root.


    var root = new Group$1();
    root.add(rootFromParse);
    root.isGeoSVGGraphicRoot = true; // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
    //
    // Consider: `<svg width="..." height="..." viewBox="...">`
    // - the `width/height` we call it `svgWidth/svgHeight` for short.
    // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
    //   "viewport boundingRect", or `boundingRect` for short.
    // - `viewBox` defines the transform from the real content ot the viewport.
    //   `viewBox` has the same unit as the content of SVG.
    //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
    //   different from the content of SVG. Otherwise, they are the same.
    //
    // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
    // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
    // 1. Make a transform from `viewBox` to `boundingRect`.
    //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
    //    the aspect ratio.
    // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
    //    (`Geo`/`View` will do this job).
    //    Note: this transform might not preserve aspect radio, which depending on how users specify
    //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
    //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
    //
    // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
    // layout look good.
    //
    // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
    // of the SVG content and use them to make SVG layout look good.

    var svgWidth = result.width;
    var svgHeight = result.height;
    var viewBoxRect = result.viewBoxRect;
    var boundingRect = this._boundingRect;

    if (!boundingRect) {
      var bRectX = void 0;
      var bRectY = void 0;
      var bRectWidth = void 0;
      var bRectHeight = void 0;

      if (svgWidth != null) {
        bRectX = 0;
        bRectWidth = svgWidth;
      } else if (viewBoxRect) {
        bRectX = viewBoxRect.x;
        bRectWidth = viewBoxRect.width;
      }

      if (svgHeight != null) {
        bRectY = 0;
        bRectHeight = svgHeight;
      } else if (viewBoxRect) {
        bRectY = viewBoxRect.y;
        bRectHeight = viewBoxRect.height;
      } // If both viewBox and svgWidth/svgHeight not specified,
      // we have to determine how to layout those element to make them look good.


      if (bRectX == null || bRectY == null) {
        var calculatedBoundingRect = rootFromParse.getBoundingRect();

        if (bRectX == null) {
          bRectX = calculatedBoundingRect.x;
          bRectWidth = calculatedBoundingRect.width;
        }

        if (bRectY == null) {
          bRectY = calculatedBoundingRect.y;
          bRectHeight = calculatedBoundingRect.height;
        }
      }

      boundingRect = this._boundingRect = new BoundingRect(bRectX, bRectY, bRectWidth, bRectHeight);
    }

    if (viewBoxRect) {
      var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect); // Only support `preserveAspectRatio 'xMidYMid'`

      rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
      rootFromParse.x = viewBoxTransform.x;
      rootFromParse.y = viewBoxTransform.y;
    } // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
    // They do not strictly confine all of the content inside a display rect, but deliberately
    // use a `viewBox` to define a displayable rect.
    // PENDING:
    // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
    // edge might also be clipped, because region labels are put as `textContent` of the SVG path.


    root.setClipPath(new Rect({
      shape: boundingRect.plain()
    }));
    var named = [];
    each(result.named, function (namedItem) {
      if (REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
        named.push(namedItem);
        setSilent(namedItem.el);
      }
    });
    return {
      root: root,
      boundingRect: boundingRect,
      named: named
    };
  };
  /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */


  GeoSVGResource.prototype.useGraphic = function (hostKey
  /* , nameMap: NameMap */
  ) {
    var usedRootMap = this._usedGraphicMap;
    var svgGraphic = usedRootMap.get(hostKey);

    if (svgGraphic) {
      return svgGraphic;
    }

    svgGraphic = this._freedGraphics.pop() // use the first boundingRect to avoid duplicated boundingRect calculation.
    || this._buildGraphic(this._parsedXML);
    usedRootMap.set(hostKey, svgGraphic); // PENDING: `nameMap` will not be supported until some real requirement come.
    // `nameMap` can only be obtained from echarts option.
    // The original `named` must not be modified.
    // if (nameMap) {
    //     svgGraphic = extend({}, svgGraphic);
    //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
    // }

    return svgGraphic;
  };

  GeoSVGResource.prototype.freeGraphic = function (hostKey) {
    var usedRootMap = this._usedGraphicMap;
    var svgGraphic = usedRootMap.get(hostKey);

    if (svgGraphic) {
      usedRootMap.removeKey(hostKey);

      this._freedGraphics.push(svgGraphic);
    }
  };

  return GeoSVGResource;
}();

function setSilent(el) {
  // Only named element has silent: false, other elements should
  // act as background and has no user interaction.
  el.silent = false; // text|tspan will be converted to group.

  if (el.isGroup) {
    el.traverse(function (child) {
      child.silent = false;
    });
  }
}

function createRegions(named) {
  var regions = [];
  var regionsMap = createHashMap(); // Create resions only for the first graphic.

  each(named, function (namedItem) {
    // Region has feature to calculate center for tooltip or other features.
    // If there is a <g name="xxx">, the center should be the center of the
    // bounding rect of the g.
    if (namedItem.namedFrom != null) {
      return;
    }

    var region = new GeoSVGRegion(namedItem.name, namedItem.el); // PENDING: if `nameMap` supported, this region can not be mounted on
    // `this`, but can only be created each time `load()` called.

    regions.push(region); // PENDING: if multiple tag named with the same name, only one will be
    // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
    // by name. We use `region.getCenter()` as the coordinate.

    regionsMap.set(namedItem.name, region);
  });
  return {
    regions: regions,
    regionsMap: regionsMap
  };
} // PENDING: `nameMap` will not be supported until some real requirement come.
// /**
//  * Use the alias in geoNameMap.
//  * The input `named` must not be modified.
//  */
// function applyNameMap(
//     named: GeoSVGGraphicRecord['named'],
//     nameMap: NameMap
// ): GeoSVGGraphicRecord['named'] {
//     const result = [] as GeoSVGGraphicRecord['named'];
//     for (let i = 0; i < named.length; i++) {
//         let regionGraphic = named[i];
//         const name = regionGraphic.name;
//         if (nameMap && nameMap.hasOwnProperty(name)) {
//             regionGraphic = extend({}, regionGraphic);
//             regionGraphic.name = name;
//         }
//         result.push(regionGraphic);
//     }
//     return result;
// }

var geoCoord = [126, 25];
var nanhaiName = '南海诸岛';
var points$1 = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];

for (var i = 0; i < points$1.length; i++) {
  for (var k$2 = 0; k$2 < points$1[i].length; k$2++) {
    points$1[i][k$2][0] /= 10.5;
    points$1[i][k$2][1] /= -10.5 / 0.75;
    points$1[i][k$2][0] += geoCoord[0];
    points$1[i][k$2][1] += geoCoord[1];
  }
}

function fixNanhai(mapType, regions) {
  if (mapType === 'china') {
    for (var i = 0; i < regions.length; i++) {
      // Already exists.
      if (regions[i].name === nanhaiName) {
        return;
      }
    }

    regions.push(new GeoJSONRegion(nanhaiName, map(points$1, function (exterior) {
      return {
        type: 'polygon',
        exterior: exterior
      };
    }), geoCoord));
  }
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var coordsOffsetMap = {
  '南海诸岛': [32, 80],
  // 全国
  '广东': [0, -10],
  '香港': [10, 5],
  '澳门': [-10, 10],
  // '北京': [-10, 0],
  '天津': [5, 5]
};
function fixTextCoords(mapType, region) {
  if (mapType === 'china') {
    var coordFix = coordsOffsetMap[region.name];

    if (coordFix) {
      var cp = region.getCenter();
      cp[0] += coordFix[0] / 10.5;
      cp[1] += -coordFix[1] / (10.5 / 0.75);
      region.setCenter(cp);
    }
  }
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
// Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var points$2 = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
function fixDiaoyuIsland(mapType, region) {
  if (mapType === 'china' && region.name === '台湾') {
    region.geometries.push({
      type: 'polygon',
      exterior: points$2[0]
    });
  }
}

var DEFAULT_NAME_PROPERTY = 'name';

var GeoJSONResource =
/** @class */
function () {
  function GeoJSONResource(mapName, geoJSON, specialAreas) {
    this.type = 'geoJSON';
    this._parsedMap = createHashMap();
    this._mapName = mapName;
    this._specialAreas = specialAreas; // PENDING: delay the parse to the first usage to rapid up the FMP?

    this._geoJSON = parseInput(geoJSON);
  }
  /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */


  GeoJSONResource.prototype.load = function (nameMap, nameProperty) {
    nameProperty = nameProperty || DEFAULT_NAME_PROPERTY;

    var parsed = this._parsedMap.get(nameProperty);

    if (!parsed) {
      var rawRegions = this._parseToRegions(nameProperty);

      parsed = this._parsedMap.set(nameProperty, {
        regions: rawRegions,
        boundingRect: calculateBoundingRect(rawRegions)
      });
    }

    var regionsMap = createHashMap();
    var finalRegions = [];
    each(parsed.regions, function (region) {
      var regionName = region.name; // Try use the alias in geoNameMap

      if (nameMap && hasOwn(nameMap, regionName)) {
        region = region.cloneShallow(regionName = nameMap[regionName]);
      }

      finalRegions.push(region);
      regionsMap.set(regionName, region);
    });
    return {
      regions: finalRegions,
      boundingRect: parsed.boundingRect || new BoundingRect(0, 0, 0, 0),
      regionsMap: regionsMap
    };
  };

  GeoJSONResource.prototype._parseToRegions = function (nameProperty) {
    var mapName = this._mapName;
    var geoJSON = this._geoJSON;
    var rawRegions; // https://jsperf.com/try-catch-performance-overhead

    try {
      rawRegions = geoJSON ? parseGeoJSON(geoJSON, nameProperty) : [];
    } catch (e) {
      throw new Error('Invalid geoJson format\n' + e.message);
    }

    fixNanhai(mapName, rawRegions);
    each(rawRegions, function (region) {
      var regionName = region.name;
      fixTextCoords(mapName, region);
      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
      // to look better

      var specialArea = this._specialAreas && this._specialAreas[regionName];

      if (specialArea) {
        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
      }
    }, this);
    return rawRegions;
  };
  /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */


  GeoJSONResource.prototype.getMapForUser = function () {
    return {
      // For backward compatibility, use geoJson
      // PENDING: it has been returning them without clone.
      // do we need to avoid outsite modification?
      geoJson: this._geoJSON,
      geoJSON: this._geoJSON,
      specialAreas: this._specialAreas
    };
  };

  return GeoJSONResource;
}();

function calculateBoundingRect(regions) {
  var rect;

  for (var i = 0; i < regions.length; i++) {
    var regionRect = regions[i].getBoundingRect();
    rect = rect || regionRect.clone();
    rect.union(regionRect);
  }

  return rect;
}

function parseInput(source) {
  return !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}

var storage = createHashMap();
var geoSourceManager = {
  /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */
  registerMap: function (mapName, rawDef, rawSpecialAreas) {
    if (rawDef.svg) {
      var resource = new GeoSVGResource(mapName, rawDef.svg);
      storage.set(mapName, resource);
    } else {
      // Recommend:
      //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
      // Backward compatibility:
      //     echarts.registerMap('eu', geoJSON, specialAreas);
      //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
      var geoJSON = rawDef.geoJson || rawDef.geoJSON;

      if (geoJSON && !rawDef.features) {
        rawSpecialAreas = rawDef.specialAreas;
      } else {
        geoJSON = rawDef;
      }

      var resource = new GeoJSONResource(mapName, geoJSON, rawSpecialAreas);
      storage.set(mapName, resource);
    }
  },
  getGeoResource: function (mapName) {
    return storage.get(mapName);
  },

  /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */
  getMapForUser: function (mapName) {
    var resource = storage.get(mapName); // Do not support return SVG until some real requirement come.

    return resource && resource.type === 'geoJSON' && resource.getMapForUser();
  },
  load: function (mapName, nameMap, nameProperty) {
    var resource = storage.get(mapName);

    if (!resource) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Map ' + mapName + ' not exists. The GeoJSON of the map must be provided.');
      }

      return;
    }

    return resource.load(nameMap, nameProperty);
  }
};

/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */

var OPTION_STYLE_ENABLED_TAGS = ['rect', 'circle', 'line', 'ellipse', 'polygon', 'polyline', 'path'];
var OPTION_STYLE_ENABLED_TAG_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS);
var STATE_TRIGGER_TAG_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS.concat(['g']));
var LABEL_HOST_MAP = createHashMap(OPTION_STYLE_ENABLED_TAGS.concat(['g']));
var mapLabelRaw = makeInner();

function getFixedItemStyle(model) {
  var itemStyle = model.getItemStyle();
  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
  // they should both set areaColor and color to be null.

  if (areaColor != null) {
    itemStyle.fill = areaColor;
  }

  return itemStyle;
} // Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?


function fixLineStyle(styleHost) {
  var style = styleHost.style;

  if (style) {
    style.stroke = style.stroke || style.fill;
    style.fill = null;
  }
}

var MapDraw =
/** @class */
function () {
  function MapDraw(api) {
    var group = new Group$1();
    this.uid = getUID('ec_map_draw');
    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: group
    };
    this.group = group;
    group.add(this._regionsGroup = new Group$1());
    group.add(this._svgGroup = new Group$1());
  }

  MapDraw.prototype.draw = function (mapOrGeoModel, ecModel, api, fromView, payload) {
    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
    // will be assigned with map data. Other GEO model has no data.

    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
    isGeo && ecModel.eachComponent({
      mainType: 'series',
      subType: 'map'
    }, function (mapSeries) {
      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
        data = mapSeries.getData();
      }
    });
    var geo = mapOrGeoModel.coordinateSystem;
    var regionsGroup = this._regionsGroup;
    var group = this.group;
    var transformInfo = geo.getTransformInfo();
    var transformInfoRaw = transformInfo.raw;
    var transformInfoRoam = transformInfo.roam; // No animation when first draw or in action

    var isFirstDraw = !regionsGroup.childAt(0) || payload;

    if (isFirstDraw) {
      group.x = transformInfoRoam.x;
      group.y = transformInfoRoam.y;
      group.scaleX = transformInfoRoam.scaleX;
      group.scaleY = transformInfoRoam.scaleY;
      group.dirty();
    } else {
      updateProps(group, transformInfoRoam, mapOrGeoModel);
    }

    var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
    var viewBuildCtx = {
      api: api,
      geo: geo,
      mapOrGeoModel: mapOrGeoModel,
      data: data,
      isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
      isGeo: isGeo,
      transformInfoRaw: transformInfoRaw
    };

    if (geo.resourceType === 'geoJSON') {
      this._buildGeoJSON(viewBuildCtx);
    } else if (geo.resourceType === 'geoSVG') {
      this._buildSVG(viewBuildCtx);
    }

    this._updateController(mapOrGeoModel, ecModel, api);

    this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
  };

  MapDraw.prototype._buildGeoJSON = function (viewBuildCtx) {
    var regionsGroupByName = this._regionsGroupByName = createHashMap();
    var regionsInfoByName = createHashMap();
    var regionsGroup = this._regionsGroup;
    var transformInfoRaw = viewBuildCtx.transformInfoRaw;
    var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
    var data = viewBuildCtx.data;
    var projection = viewBuildCtx.geo.projection;
    var projectionStream = projection && projection.stream;

    function transformPoint(point, project) {
      if (project) {
        // projection may return null point.
        point = project(point);
      }

      return point && [point[0] * transformInfoRaw.scaleX + transformInfoRaw.x, point[1] * transformInfoRaw.scaleY + transformInfoRaw.y];
    }

    function transformPolygonPoints(inPoints) {
      var outPoints = []; // If projectionStream is provided. Use it instead of single point project.

      var project = !projectionStream && projection && projection.project;

      for (var i = 0; i < inPoints.length; ++i) {
        var newPt = transformPoint(inPoints[i], project);
        newPt && outPoints.push(newPt);
      }

      return outPoints;
    }

    function getPolyShape(points) {
      return {
        shape: {
          points: transformPolygonPoints(points)
        }
      };
    }

    regionsGroup.removeAll(); // Only when the resource is GeoJSON, there is `geo.regions`.

    each(viewBuildCtx.geo.regions, function (region) {
      var regionName = region.name; // Consider in GeoJson properties.name may be duplicated, for example,
      // there is multiple region named "United Kindom" or "France" (so many
      // colonies). And it is not appropriate to merge them in geo, which
      // will make them share the same label and bring trouble in label
      // location calculation.

      var regionGroup = regionsGroupByName.get(regionName);

      var _a = regionsInfoByName.get(regionName) || {},
          dataIdx = _a.dataIdx,
          regionModel = _a.regionModel;

      if (!regionGroup) {
        regionGroup = regionsGroupByName.set(regionName, new Group$1());
        regionsGroup.add(regionGroup);
        dataIdx = data ? data.indexOfName(regionName) : null;
        regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
        regionsInfoByName.set(regionName, {
          dataIdx: dataIdx,
          regionModel: regionModel
        });
      }

      var polygonSubpaths = [];
      var polylineSubpaths = [];
      each(region.geometries, function (geometry) {
        // Polygon and MultiPolygon
        if (geometry.type === 'polygon') {
          var polys = [geometry.exterior].concat(geometry.interiors || []);

          if (projectionStream) {
            polys = projectPolys(polys, projectionStream);
          }

          each(polys, function (poly) {
            polygonSubpaths.push(new Polygon(getPolyShape(poly)));
          });
        } // LineString and MultiLineString
        else {
            var points = geometry.points;

            if (projectionStream) {
              points = projectPolys(points, projectionStream, true);
            }

            each(points, function (points) {
              polylineSubpaths.push(new Polyline(getPolyShape(points)));
            });
          }
      });
      var centerPt = transformPoint(region.getCenter(), projection && projection.project);

      function createCompoundPath(subpaths, isLine) {
        if (!subpaths.length) {
          return;
        }

        var compoundPath = new CompoundPath({
          culling: true,
          segmentIgnoreThreshold: 1,
          shape: {
            paths: subpaths
          }
        });
        regionGroup.add(compoundPath);
        applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
        resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);

        if (isLine) {
          fixLineStyle(compoundPath);
          each(compoundPath.states, fixLineStyle);
        }
      }

      createCompoundPath(polygonSubpaths);
      createCompoundPath(polylineSubpaths, true);
    }); // Ensure children have been added to `regionGroup` before calling them.

    regionsGroupByName.each(function (regionGroup, regionName) {
      var _a = regionsInfoByName.get(regionName),
          dataIdx = _a.dataIdx,
          regionModel = _a.regionModel;

      resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
      resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
      resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
    }, this);
  };

  MapDraw.prototype._buildSVG = function (viewBuildCtx) {
    var mapName = viewBuildCtx.geo.map;
    var transformInfoRaw = viewBuildCtx.transformInfoRaw;
    this._svgGroup.x = transformInfoRaw.x;
    this._svgGroup.y = transformInfoRaw.y;
    this._svgGroup.scaleX = transformInfoRaw.scaleX;
    this._svgGroup.scaleY = transformInfoRaw.scaleY;

    if (this._svgResourceChanged(mapName)) {
      this._freeSVG();

      this._useSVG(mapName);
    }

    var svgDispatcherMap = this._svgDispatcherMap = createHashMap();
    var focusSelf = false;
    each(this._svgGraphicRecord.named, function (namedItem) {
      // Note that we also allow different elements have the same name.
      // For example, a glyph of a city and the label of the city have
      // the same name and their tooltip info can be defined in a single
      // region option.
      var regionName = namedItem.name;
      var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
      var data = viewBuildCtx.data;
      var svgNodeTagLower = namedItem.svgNodeTagLower;
      var el = namedItem.el;
      var dataIdx = data ? data.indexOfName(regionName) : null;
      var regionModel = mapOrGeoModel.getRegionModel(regionName);

      if (OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof Displayable) {
        applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
      }

      if (el instanceof Displayable) {
        el.culling = true;
      } // We do not know how the SVG like so we'd better not to change z2.
      // Otherwise it might bring some unexpected result. For example,
      // an area hovered that make some inner city can not be clicked.


      el.z2EmphasisLift = 0; // If self named:

      if (!namedItem.namedFrom) {
        // label should batter to be displayed based on the center of <g>
        // if it is named rather than displayed on each child.
        if (LABEL_HOST_MAP.get(svgNodeTagLower) != null) {
          resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
        }

        resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
        resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);

        if (STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
          var focus_1 = resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);

          if (focus_1 === 'self') {
            focusSelf = true;
          }

          var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
          els.push(el);
        }
      }
    }, this);

    this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
  };

  MapDraw.prototype._enableBlurEntireSVG = function (focusSelf, viewBuildCtx) {
    // It's a little complicated to support blurring the entire geoSVG in series-map.
    // So do not suport it until some requirements come.
    // At present, in series-map, only regions can be blurred.
    if (focusSelf && viewBuildCtx.isGeo) {
      var blurStyle = viewBuildCtx.mapOrGeoModel.getModel(['blur', 'itemStyle']).getItemStyle(); // Only suport `opacity` here. Because not sure that other props are suitable for
      // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).

      var opacity_1 = blurStyle.opacity;

      this._svgGraphicRecord.root.traverse(function (el) {
        if (!el.isGroup) {
          // PENDING: clear those settings to SVG elements when `_freeSVG`.
          // (Currently it happen not to be needed.)
          setDefaultStateProxy(el);
          var style = el.ensureState('blur').style || {}; // Do not overwrite the region style that already set from region option.

          if (style.opacity == null && opacity_1 != null) {
            style.opacity = opacity_1;
          } // If `ensureState('blur').style = {}`, there will be default opacity.
          // Enable `stateTransition` (animation).


          el.ensureState('emphasis');
        }
      });
    }
  };

  MapDraw.prototype.remove = function () {
    this._regionsGroup.removeAll();

    this._regionsGroupByName = null;

    this._svgGroup.removeAll();

    this._freeSVG();

    this._controller.dispose();

    this._controllerHost = null;
  };

  MapDraw.prototype.findHighDownDispatchers = function (name, geoModel) {
    if (name == null) {
      return [];
    }

    var geo = geoModel.coordinateSystem;

    if (geo.resourceType === 'geoJSON') {
      var regionsGroupByName = this._regionsGroupByName;

      if (regionsGroupByName) {
        var regionGroup = regionsGroupByName.get(name);
        return regionGroup ? [regionGroup] : [];
      }
    } else if (geo.resourceType === 'geoSVG') {
      return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    }
  };

  MapDraw.prototype._svgResourceChanged = function (mapName) {
    return this._svgMapName !== mapName;
  };

  MapDraw.prototype._useSVG = function (mapName) {
    var resource = geoSourceManager.getGeoResource(mapName);

    if (resource && resource.type === 'geoSVG') {
      var svgGraphic = resource.useGraphic(this.uid);

      this._svgGroup.add(svgGraphic.root);

      this._svgGraphicRecord = svgGraphic;
      this._svgMapName = mapName;
    }
  };

  MapDraw.prototype._freeSVG = function () {
    var mapName = this._svgMapName;

    if (mapName == null) {
      return;
    }

    var resource = geoSourceManager.getGeoResource(mapName);

    if (resource && resource.type === 'geoSVG') {
      resource.freeGraphic(this.uid);
    }

    this._svgGraphicRecord = null;
    this._svgDispatcherMap = null;

    this._svgGroup.removeAll();

    this._svgMapName = null;
  };

  MapDraw.prototype._updateController = function (mapOrGeoModel, ecModel, api) {
    var geo = mapOrGeoModel.coordinateSystem;
    var controller = this._controller;
    var controllerHost = this._controllerHost; // @ts-ignore FIXME:TS

    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
    // @ts-ignore FIXME:TS

    controller.enable(mapOrGeoModel.get('roam') || false);
    var mainType = mapOrGeoModel.mainType;

    function makeActionBase() {
      var action = {
        type: 'geoRoam',
        componentType: mainType
      };
      action[mainType + 'Id'] = mapOrGeoModel.id;
      return action;
    }

    controller.off('pan').on('pan', function (e) {
      this._mouseDownFlag = false;
      updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction(extend(makeActionBase(), {
        dx: e.dx,
        dy: e.dy,
        animation: {
          duration: 0
        }
      }));
    }, this);
    controller.off('zoom').on('zoom', function (e) {
      this._mouseDownFlag = false;
      updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction(extend(makeActionBase(), {
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY,
        animation: {
          duration: 0
        }
      }));
    }, this);
    controller.setPointerChecker(function (e, x, y) {
      return geo.containPoint([x, y]) && !onIrrelevantElement(e, api, mapOrGeoModel);
    });
  };
  /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */


  MapDraw.prototype.resetForLabelLayout = function () {
    this.group.traverse(function (el) {
      var label = el.getTextContent();

      if (label) {
        label.ignore = mapLabelRaw(label).ignore;
      }
    });
  };

  MapDraw.prototype._updateMapSelectHandler = function (mapOrGeoModel, regionsGroup, api, fromView) {
    var mapDraw = this;
    regionsGroup.off('mousedown');
    regionsGroup.off('click'); // @ts-ignore FIXME:TS resolve type conflict

    if (mapOrGeoModel.get('selectedMode')) {
      regionsGroup.on('mousedown', function () {
        mapDraw._mouseDownFlag = true;
      });
      regionsGroup.on('click', function (e) {
        if (!mapDraw._mouseDownFlag) {
          return;
        }

        mapDraw._mouseDownFlag = false;
      });
    }
  };

  return MapDraw;
}();

function applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
  // All of the path are using `itemStyle`, because
  // (1) Some SVG also use fill on polyline (The different between
  // polyline and polygon is "open" or "close" but not fill or not).
  // (2) For the common props like opacity, if some use itemStyle
  // and some use `lineStyle`, it might confuse users.
  // (3) Most SVG use <path>, where can not detect wether draw a "line"
  // or a filled shape, so use `itemStyle` for <path>.
  var normalStyleModel = regionModel.getModel('itemStyle');
  var emphasisStyleModel = regionModel.getModel(['emphasis', 'itemStyle']);
  var blurStyleModel = regionModel.getModel(['blur', 'itemStyle']);
  var selectStyleModel = regionModel.getModel(['select', 'itemStyle']); // NOTE: DONT use 'style' in visual when drawing map.
  // This component is used for drawing underlying map for both geo component and map series.

  var normalStyle = getFixedItemStyle(normalStyleModel);
  var emphasisStyle = getFixedItemStyle(emphasisStyleModel);
  var selectStyle = getFixedItemStyle(selectStyleModel);
  var blurStyle = getFixedItemStyle(blurStyleModel); // Update the itemStyle if has data visual

  var data = viewBuildCtx.data;

  if (data) {
    // Only visual color of each item will be used. It can be encoded by visualMap
    // But visual color of series is used in symbol drawing
    // Visual color for each series is for the symbol draw
    var style = data.getItemVisual(dataIndex, 'style');
    var decal = data.getItemVisual(dataIndex, 'decal');

    if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) {
      normalStyle.fill = style.fill;
    }

    if (decal) {
      normalStyle.decal = createOrUpdatePatternFromDecal(decal, viewBuildCtx.api);
    }
  } // SVG text, tspan and image can be named but not supporeted
  // to be styled by region option yet.


  el.setStyle(normalStyle);
  el.style.strokeNoScale = true;
  el.ensureState('emphasis').style = emphasisStyle;
  el.ensureState('select').style = selectStyle;
  el.ensureState('blur').style = blurStyle; // Enable blur

  setDefaultStateProxy(el);
}

function resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
  var data = viewBuildCtx.data;
  var isGeo = viewBuildCtx.isGeo;
  var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
  var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
  // 1. In map series and data value is NaN
  // 2. In geo component
  // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout

  if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
    var query = !isGeo ? dataIdx : regionName;
    var labelFetcher = void 0; // Consider dataIdx not found.

    if (!data || dataIdx >= 0) {
      labelFetcher = mapOrGeoModel;
    }

    var specifiedTextOpt = labelXY ? {
      normal: {
        align: 'center',
        verticalAlign: 'middle'
      }
    } : null; // Caveat: must be called after `setDefaultStateProxy(el);` called.
    // because textContent will be assign with `el.stateProxy` inside.

    setLabelStyle(el, getLabelStatesModels(regionModel), {
      labelFetcher: labelFetcher,
      labelDataIndex: query,
      defaultText: regionName
    }, specifiedTextOpt);
    var textEl = el.getTextContent();

    if (textEl) {
      mapLabelRaw(textEl).ignore = textEl.ignore;

      if (el.textConfig && labelXY) {
        // Compute a relative offset based on the el bounding rect.
        var rect = el.getBoundingRect().clone(); // Need to make sure the percent position base on the same rect in normal and
        // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
        // has borderWidth (even 0.5px), the text position will be changed obviously
        // if the position is very big like ['1234%', '1345%'].

        el.textConfig.layoutRect = rect;
        el.textConfig.position = [(labelXY[0] - rect.x) / rect.width * 100 + '%', (labelXY[1] - rect.y) / rect.height * 100 + '%'];
      }
    } // PENDING:
    // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
    // But el.dataIndex is also used to determine whether user event should be triggered,
    // where el.seriesIndex or el.dataModel must be specified. At present for a single el
    // there is not case that "only label layout enabled but user event disabled", so here
    // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.


    el.disableLabelAnimation = true;
  } else {
    el.removeTextContent();
    el.removeTextConfig();
    el.disableLabelAnimation = null;
  }
}

function resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
  // setItemGraphicEl, setHoverStyle after all polygons and labels
  // are added to the regionGroup
  if (viewBuildCtx.data) {
    // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
  } // series-map will not trigger "geoselectchange" no matter it is
  // based on a declared geo component. Because series-map will
  // trigger "selectchange". If it trigger both the two events,
  // If users call `chart.dispatchAction({type: 'toggleSelect'})`,
  // it not easy to also fire event "geoselectchanged".
  else {
      // Package custom mouse event for geo component
      getECData(eventTrigger).eventData = {
        componentType: 'geo',
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
      };
    }
}

function resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
  if (!viewBuildCtx.data) {
    setTooltipConfig({
      el: el,
      componentModel: mapOrGeoModel,
      itemName: regionName,
      // @ts-ignore FIXME:TS fix the "compatible with each other"?
      itemTooltipOption: regionModel.get('tooltip')
    });
  }
}

function resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
  // @ts-ignore FIXME:TS fix the "compatible with each other"?
  el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode'); // @ts-ignore FIXME:TS fix the "compatible with each other"?

  var emphasisModel = regionModel.getModel('emphasis');
  var focus = emphasisModel.get('focus');
  toggleHoverEmphasis(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));

  if (viewBuildCtx.isGeo) {
    enableComponentHighDownFeatures(el, mapOrGeoModel, regionName);
  }

  return focus;
}

function projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
  var polygons = [];
  var curPoly;

  function startPolygon() {
    curPoly = [];
  }

  function endPolygon() {
    if (curPoly.length) {
      polygons.push(curPoly);
      curPoly = [];
    }
  }

  var stream = createStream({
    polygonStart: startPolygon,
    polygonEnd: endPolygon,
    lineStart: startPolygon,
    lineEnd: endPolygon,
    point: function (x, y) {
      // May have NaN values from stream.
      if (isFinite(x) && isFinite(y)) {
        curPoly.push([x, y]);
      }
    },
    sphere: function () {}
  });
  !isLine && stream.polygonStart();
  each(rings, function (ring) {
    stream.lineStart();

    for (var i = 0; i < ring.length; i++) {
      stream.point(ring[i][0], ring[i][1]);
    }

    stream.lineEnd();
  });
  !isLine && stream.polygonEnd();
  return polygons;
}
 // @ts-ignore FIXME:TS fix the "compatible with each other"?

var MapView =
/** @class */
function (_super) {
  __extends$1(MapView, _super);

  function MapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MapView.type;
    return _this;
  }

  MapView.prototype.render = function (mapModel, ecModel, api, payload) {
    // Not render if it is an toggleSelect action from self
    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
      return;
    }

    var group = this.group;
    group.removeAll();

    if (mapModel.getHostGeoModel()) {
      return;
    }

    if (this._mapDraw && payload && payload.type === 'geoRoam') {
      this._mapDraw.resetForLabelLayout();
    } // Not update map if it is an roam action from self


    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
      if (mapModel.needsDrawMap) {
        var mapDraw = this._mapDraw || new MapDraw(api);
        group.add(mapDraw.group);
        mapDraw.draw(mapModel, ecModel, api, this, payload);
        this._mapDraw = mapDraw;
      } else {
        // Remove drawn map
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
      }
    } else {
      var mapDraw = this._mapDraw;
      mapDraw && group.add(mapDraw.group);
    }

    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
  };

  MapView.prototype.remove = function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
    this.group.removeAll();
  };

  MapView.prototype.dispose = function () {
    this._mapDraw && this._mapDraw.remove();
    this._mapDraw = null;
  };

  MapView.prototype._renderSymbols = function (mapModel, ecModel, api) {
    var originalData = mapModel.originalData;
    var group = this.group;
    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
      if (isNaN(value)) {
        return;
      }

      var layout = originalData.getItemLayout(originalDataIndex);

      if (!layout || !layout.point) {
        // Not exists in map
        return;
      }

      var point = layout.point;
      var offset = layout.offset;
      var circle = new Circle$1({
        style: {
          // Because the special of map draw.
          // Which needs statistic of multiple series and draw on one map.
          // And each series also need a symbol with legend color
          //
          // Layout and visual are put one the different data
          // TODO
          fill: mapModel.getData().getVisual('style').fill
        },
        shape: {
          cx: point[0] + offset * 9,
          cy: point[1],
          r: 3
        },
        silent: true,
        // Do not overlap the first series, on which labels are displayed.
        z2: 8 + (!offset ? Z2_EMPHASIS_LIFT + 1 : 0)
      }); // Only the series that has the first value on the same region is in charge of rendering the label.
      // But consider the case:
      // series: [
      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
      // ]
      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
      // For backward compatibility, we follow the rule that render label `A` by the
      // settings on series `X` but render label `C` by the settings on series `Y`.

      if (!offset) {
        var fullData = mapModel.mainSeries.getData();
        var name_1 = originalData.getName(originalDataIndex);
        var fullIndex_1 = fullData.indexOfName(name_1);
        var itemModel = originalData.getItemModel(originalDataIndex);
        var labelModel = itemModel.getModel('label');
        var regionGroup = fullData.getItemGraphicEl(fullIndex_1); // `getFormattedLabel` needs to use `getData` inside. Here
        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
        // FIXME
        // If this is not the `mainSeries`, the item model (like label formatter)
        // set on original data item will never get. But it has been working
        // like that from the beginning, and this scenario is rarely encountered.
        // So it won't be fixed until we have to.

        setLabelStyle(circle, getLabelStatesModels(itemModel), {
          labelFetcher: {
            getFormattedLabel: function (idx, state) {
              return mapModel.getFormattedLabel(fullIndex_1, state);
            }
          },
          defaultText: name_1
        });
        circle.disableLabelAnimation = true;

        if (!labelModel.get('position')) {
          circle.setTextConfig({
            position: 'bottom'
          });
        }

        regionGroup.onHoverStateChange = function (toState) {
          setStatesFlag(circle, toState);
        };
      }

      group.add(circle);
    });
  };

  MapView.type = 'map';
  return MapView;
}(ChartView);

var MapSeries =
/** @class */
function (_super) {
  __extends$1(MapSeries, _super);

  function MapSeries() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MapSeries.type; // Only first map series of same mapType will drawMap.

    _this.needsDrawMap = false; // Group of all map series with same mapType

    _this.seriesGroup = [];

    _this.getTooltipPosition = function (dataIndex) {
      if (dataIndex != null) {
        var name_1 = this.getData().getName(dataIndex);
        var geo = this.coordinateSystem;
        var region = geo.getRegion(name_1);
        return region && geo.dataToPoint(region.getCenter());
      }
    };

    return _this;
  }

  MapSeries.prototype.getInitialData = function (option) {
    var data = createSeriesDataSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
    });
    var dataNameMap = createHashMap();
    var toAppendNames = [];

    for (var i = 0, len = data.count(); i < len; i++) {
      var name_2 = data.getName(i);
      dataNameMap.set(name_2, true);
    }

    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
    each(geoSource.regions, function (region) {
      var name = region.name;

      if (!dataNameMap.get(name)) {
        toAppendNames.push(name);
      }
    }); // Complete data with missing regions. The consequent processes (like visual
    // map and render) can not be performed without a "full data". For example,
    // find `dataIndex` by name.

    data.appendValues([], toAppendNames);
    return data;
  };
  /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */


  MapSeries.prototype.getHostGeoModel = function () {
    var geoIndex = this.option.geoIndex;
    return geoIndex != null ? this.ecModel.getComponent('geo', geoIndex) : null;
  };

  MapSeries.prototype.getMapType = function () {
    return (this.getHostGeoModel() || this).option.map;
  }; // _fillOption(option, mapName) {
  // Shallow clone
  // option = zrUtil.extend({}, option);
  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
  // return option;
  // }


  MapSeries.prototype.getRawValue = function (dataIndex) {
    // Use value stored in data instead because it is calculated from multiple series
    // FIXME Provide all value of multiple series ?
    var data = this.getData();
    return data.get(data.mapDimension('value'), dataIndex);
  };
  /**
   * Get model of region
   */


  MapSeries.prototype.getRegionModel = function (regionName) {
    var data = this.getData();
    return data.getItemModel(data.indexOfName(regionName));
  };
  /**
   * Map tooltip formatter
   */


  MapSeries.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    // FIXME orignalData and data is a bit confusing
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var name = data.getName(dataIndex);
    var seriesGroup = this.seriesGroup;
    var seriesNames = [];

    for (var i = 0; i < seriesGroup.length; i++) {
      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
      var valueDim = data.mapDimension('value');

      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
        seriesNames.push(seriesGroup[i].name);
      }
    }

    return createTooltipMarkup('section', {
      header: seriesNames.join(', '),
      noHeader: !seriesNames.length,
      blocks: [createTooltipMarkup('nameValue', {
        name: name,
        value: value
      })]
    });
  };

  MapSeries.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  MapSeries.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  MapSeries.prototype.getLegendIcon = function (opt) {
    var iconType = opt.icon || 'roundRect';
    var icon = createSymbol(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
    icon.setStyle(opt.itemStyle); // Map do not use itemStyle.borderWidth as border width

    icon.style.stroke = 'none'; // No rotation because no series visual symbol for map

    if (iconType.indexOf('empty') > -1) {
      icon.style.stroke = icon.style.fill;
      icon.style.fill = '#fff';
      icon.style.lineWidth = 2;
    }

    return icon;
  };

  MapSeries.type = 'series.map';
  MapSeries.dependencies = ['geo'];
  MapSeries.layoutMode = 'box';
  MapSeries.defaultOption = {
    // 一级层叠
    // zlevel: 0,
    // 二级层叠
    z: 2,
    coordinateSystem: 'geo',
    // map should be explicitly specified since ec3.
    map: '',
    // If `geoIndex` is not specified, a exclusive geo will be
    // created. Otherwise use the specified geo component, and
    // `map` and `mapType` are ignored.
    // geoIndex: 0,
    // 'center' | 'left' | 'right' | 'x%' | {number}
    left: 'center',
    // 'center' | 'top' | 'bottom' | 'x%' | {number}
    top: 'center',
    // right
    // bottom
    // width:
    // height
    // Aspect is width / height. Inited to be geoJson bbox aspect
    // This parameter is used for scale this aspect
    // Default value:
    // for geoSVG source: 1,
    // for geoJSON source: 0.75.
    aspectScale: null,
    // Layout with center and size
    // If you want to put map in a fixed size box with right aspect ratio
    // This two properties may be more convenient.
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    showLegendSymbol: true,
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ],
    // higher priority than center and zoom
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    selectedMode: true,
    label: {
      show: false,
      color: '#000'
    },
    // scaleLimit: null,
    itemStyle: {
      borderWidth: 0.5,
      borderColor: '#444',
      areaColor: '#eee'
    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        areaColor: 'rgba(255,215,0,0.8)'
      }
    },
    select: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    nameProperty: 'name'
  };
  return MapSeries;
}(SeriesModel);

function dataStatistics(datas, statisticType) {
  var dataNameMap = {};
  each(datas, function (data) {
    data.each(data.mapDimension('value'), function (value, idx) {
      // Add prefix to avoid conflict with Object.prototype.
      var mapKey = 'ec-' + data.getName(idx);
      dataNameMap[mapKey] = dataNameMap[mapKey] || [];

      if (!isNaN(value)) {
        dataNameMap[mapKey].push(value);
      }
    });
  });
  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
    var mapKey = 'ec-' + datas[0].getName(idx);
    var sum = 0;
    var min = Infinity;
    var max = -Infinity;
    var len = dataNameMap[mapKey].length;

    for (var i = 0; i < len; i++) {
      min = Math.min(min, dataNameMap[mapKey][i]);
      max = Math.max(max, dataNameMap[mapKey][i]);
      sum += dataNameMap[mapKey][i];
    }

    var result;

    if (statisticType === 'min') {
      result = min;
    } else if (statisticType === 'max') {
      result = max;
    } else if (statisticType === 'average') {
      result = sum / len;
    } else {
      result = sum;
    }

    return len === 0 ? NaN : result;
  });
}

function mapDataStatistic(ecModel) {
  var seriesGroups = {};
  ecModel.eachSeriesByType('map', function (seriesModel) {
    var hostGeoModel = seriesModel.getHostGeoModel();
    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
  });
  each(seriesGroups, function (seriesList, key) {
    var data = dataStatistics(map(seriesList, function (seriesModel) {
      return seriesModel.getData();
    }), seriesList[0].get('mapValueCalculation'));

    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].originalData = seriesList[i].getData();
    } // FIXME Put where?


    for (var i = 0; i < seriesList.length; i++) {
      seriesList[i].seriesGroup = seriesList;
      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
      seriesList[i].setData(data.cloneShallow());
      seriesList[i].mainSeries = seriesList[0];
    }
  });
}

function mapSymbolLayout(ecModel) {
  var processedMapType = {};
  ecModel.eachSeriesByType('map', function (mapSeries) {
    var mapType = mapSeries.getMapType();

    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
      return;
    }

    var mapSymbolOffsets = {};
    each(mapSeries.seriesGroup, function (subMapSeries) {
      var geo = subMapSeries.coordinateSystem;
      var data = subMapSeries.originalData;

      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
        data.each(data.mapDimension('value'), function (value, idx) {
          var name = data.getName(idx);
          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
          // not be drawn. So here must validate if value is NaN.

          if (!region || isNaN(value)) {
            return;
          }

          var offset = mapSymbolOffsets[name] || 0;
          var point = geo.dataToPoint(region.getCenter());
          mapSymbolOffsets[name] = offset + 1;
          data.setItemLayout(idx, {
            point: point,
            offset: offset
          });
        });
      }
    }); // Show label of those region not has legendIcon (which is offset 0)

    var data = mapSeries.getData();
    data.each(function (idx) {
      var name = data.getName(idx);
      var layout = data.getItemLayout(idx) || {};
      layout.showLabel = !mapSymbolOffsets[name];
      data.setItemLayout(idx, layout);
    });
    processedMapType[mapType] = true;
  });
}

var v2ApplyTransform = applyTransform;

var View =
/** @class */
function (_super) {
  __extends$1(View, _super);

  function View(name) {
    var _this = _super.call(this) || this;

    _this.type = 'view';
    _this.dimensions = ['x', 'y'];
    /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */

    _this._roamTransformable = new Transformable();
    /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */

    _this._rawTransformable = new Transformable();
    _this.name = name;
    return _this;
  }

  View.prototype.setBoundingRect = function (x, y, width, height) {
    this._rect = new BoundingRect(x, y, width, height);
    return this._rect;
  };
  /**
   * @return {module:zrender/core/BoundingRect}
   */


  View.prototype.getBoundingRect = function () {
    return this._rect;
  };

  View.prototype.setViewRect = function (x, y, width, height) {
    this._transformTo(x, y, width, height);

    this._viewRect = new BoundingRect(x, y, width, height);
  };
  /**
   * Transformed to particular position and size
   */


  View.prototype._transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var rawTransform = this._rawTransformable;
    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    var rawParent = rawTransform.parent;
    rawTransform.parent = null;
    rawTransform.decomposeTransform();
    rawTransform.parent = rawParent;

    this._updateTransform();
  };
  /**
   * Set center of view
   */


  View.prototype.setCenter = function (centerCoord, api) {
    if (!centerCoord) {
      return;
    }

    this._center = [parsePercent$1(centerCoord[0], api.getWidth()), parsePercent$1(centerCoord[1], api.getHeight())];

    this._updateCenterAndZoom();
  };

  View.prototype.setZoom = function (zoom) {
    zoom = zoom || 1;
    var zoomLimit = this.zoomLimit;

    if (zoomLimit) {
      if (zoomLimit.max != null) {
        zoom = Math.min(zoomLimit.max, zoom);
      }

      if (zoomLimit.min != null) {
        zoom = Math.max(zoomLimit.min, zoom);
      }
    }

    this._zoom = zoom;

    this._updateCenterAndZoom();
  };
  /**
   * Get default center without roam
   */


  View.prototype.getDefaultCenter = function () {
    // Rect before any transform
    var rawRect = this.getBoundingRect();
    var cx = rawRect.x + rawRect.width / 2;
    var cy = rawRect.y + rawRect.height / 2;
    return [cx, cy];
  };

  View.prototype.getCenter = function () {
    return this._center || this.getDefaultCenter();
  };

  View.prototype.getZoom = function () {
    return this._zoom || 1;
  };

  View.prototype.getRoamTransform = function () {
    return this._roamTransformable.getLocalTransform();
  };
  /**
   * Remove roam
   */


  View.prototype._updateCenterAndZoom = function () {
    // Must update after view transform updated
    var rawTransformMatrix = this._rawTransformable.getLocalTransform();

    var roamTransform = this._roamTransformable;
    var defaultCenter = this.getDefaultCenter();
    var center = this.getCenter();
    var zoom = this.getZoom();
    center = applyTransform([], center, rawTransformMatrix);
    defaultCenter = applyTransform([], defaultCenter, rawTransformMatrix);
    roamTransform.originX = center[0];
    roamTransform.originY = center[1];
    roamTransform.x = defaultCenter[0] - center[0];
    roamTransform.y = defaultCenter[1] - center[1];
    roamTransform.scaleX = roamTransform.scaleY = zoom;

    this._updateTransform();
  };
  /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */


  View.prototype._updateTransform = function () {
    var roamTransformable = this._roamTransformable;
    var rawTransformable = this._rawTransformable;
    rawTransformable.parent = roamTransformable;
    roamTransformable.updateTransform();
    rawTransformable.updateTransform();
    copy$1(this.transform || (this.transform = []), rawTransformable.transform || create$1());
    this._rawTransform = rawTransformable.getLocalTransform();
    this.invTransform = this.invTransform || [];
    invert(this.invTransform, this.transform);
    this.decomposeTransform();
  };

  View.prototype.getTransformInfo = function () {
    var rawTransformable = this._rawTransformable;
    var roamTransformable = this._roamTransformable; // Because roamTransformabel has `originX/originY` modified,
    // but the caller of `getTransformInfo` can not handle `originX/originY`,
    // so need to recalculate them.

    var dummyTransformable = new Transformable();
    dummyTransformable.transform = roamTransformable.transform;
    dummyTransformable.decomposeTransform();
    return {
      roam: {
        x: dummyTransformable.x,
        y: dummyTransformable.y,
        scaleX: dummyTransformable.scaleX,
        scaleY: dummyTransformable.scaleY
      },
      raw: {
        x: rawTransformable.x,
        y: rawTransformable.y,
        scaleX: rawTransformable.scaleX,
        scaleY: rawTransformable.scaleY
      }
    };
  };

  View.prototype.getViewRect = function () {
    return this._viewRect;
  };
  /**
   * Get view rect after roam transform
   */


  View.prototype.getViewRectAfterRoam = function () {
    var rect = this.getBoundingRect().clone();
    rect.applyTransform(this.transform);
    return rect;
  };
  /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */


  View.prototype.dataToPoint = function (data, noRoam, out) {
    var transform = noRoam ? this._rawTransform : this.transform;
    out = out || [];
    return transform ? v2ApplyTransform(out, data, transform) : copy(out, data);
  };
  /**
   * Convert a (x, y) point to (lon, lat) data
   */


  View.prototype.pointToData = function (point) {
    var invTransform = this.invTransform;
    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
  };

  View.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  View.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };
  /**
   * @implements
   */


  View.prototype.containPoint = function (point) {
    return this.getViewRectAfterRoam().contain(point[0], point[1]);
  };

  View.dimensions = ['x', 'y'];
  return View;
}(Transformable);

function getCoordSys(finder) {
  var seriesModel = finder.seriesModel;
  return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}

var GEO_DEFAULT_PARAMS = {
  'geoJSON': {
    aspectScale: 0.75,
    invertLongitute: true
  },
  'geoSVG': {
    aspectScale: 1,
    invertLongitute: false
  }
};
var geo2DDimensions = ['lng', 'lat'];

var Geo =
/** @class */
function (_super) {
  __extends$1(Geo, _super);

  function Geo(name, map, opt) {
    var _this = _super.call(this, name) || this;

    _this.dimensions = geo2DDimensions;
    _this.type = 'geo'; // Only store specified name coord via `addGeoCoord`.

    _this._nameCoordMap = createHashMap();
    _this.map = map;
    var projection = opt.projection;
    var source = geoSourceManager.load(map, opt.nameMap, opt.nameProperty);
    var resource = geoSourceManager.getGeoResource(map);
    var resourceType = _this.resourceType = resource ? resource.type : null;
    var regions = _this.regions = source.regions;
    var defaultParams = GEO_DEFAULT_PARAMS[resource.type];
    _this._regionsMap = source.regionsMap;
    _this.regions = source.regions;

    if (process.env.NODE_ENV !== 'production' && projection) {
      // Do some check
      if (resourceType === 'geoSVG') {
        if (process.env.NODE_ENV !== 'production') {
          warn("Map " + map + " with SVG source can't use projection. Only GeoJSON source supports projection.");
        }

        projection = null;
      }

      if (!(projection.project && projection.unproject)) {
        if (process.env.NODE_ENV !== 'production') {
          warn('project and unproject must be both provided in the projeciton.');
        }

        projection = null;
      }
    }

    _this.projection = projection;
    var boundingRect;

    if (projection) {
      // Can't reuse the raw bounding rect
      for (var i = 0; i < regions.length; i++) {
        var regionRect = regions[i].getBoundingRect(projection);
        boundingRect = boundingRect || regionRect.clone();
        boundingRect.union(regionRect);
      }
    } else {
      boundingRect = source.boundingRect;
    }

    _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height); // aspectScale and invertLongitute actually is the parameters default raw projection.
    // So we ignore them if projection is given.
    // Ignore default aspect scale if projection exits.


    _this.aspectScale = projection ? 1 : retrieve2(opt.aspectScale, defaultParams.aspectScale); // Not invert longitude if projection exits.

    _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
    return _this;
  }

  Geo.prototype._transformTo = function (x, y, width, height) {
    var rect = this.getBoundingRect();
    var invertLongitute = this._invertLongitute;
    rect = rect.clone();

    if (invertLongitute) {
      // Longitude is inverted.
      rect.y = -rect.y - rect.height;
    }

    var rawTransformable = this._rawTransformable;
    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
    var rawParent = rawTransformable.parent;
    rawTransformable.parent = null;
    rawTransformable.decomposeTransform();
    rawTransformable.parent = rawParent;

    if (invertLongitute) {
      rawTransformable.scaleY = -rawTransformable.scaleY;
    }

    this._updateTransform();
  };

  Geo.prototype.getRegion = function (name) {
    return this._regionsMap.get(name);
  };

  Geo.prototype.getRegionByCoord = function (coord) {
    var regions = this.regions;

    for (var i = 0; i < regions.length; i++) {
      var region = regions[i];

      if (region.type === 'geoJSON' && region.contain(coord)) {
        return regions[i];
      }
    }
  };
  /**
   * Add geoCoord for indexing by name
   */


  Geo.prototype.addGeoCoord = function (name, geoCoord) {
    this._nameCoordMap.set(name, geoCoord);
  };
  /**
   * Get geoCoord by name
   */


  Geo.prototype.getGeoCoord = function (name) {
    var region = this._regionsMap.get(name); // Calculate center only on demand.


    return this._nameCoordMap.get(name) || region && region.getCenter();
  };

  Geo.prototype.dataToPoint = function (data, noRoam, out) {
    if (isString(data)) {
      // Map area name to geoCoord
      data = this.getGeoCoord(data);
    }

    if (data) {
      var projection = this.projection;

      if (projection) {
        // projection may return null point.
        data = projection.project(data);
      }

      return data && this.projectedToPoint(data, noRoam, out);
    }
  };

  Geo.prototype.pointToData = function (point) {
    var projection = this.projection;

    if (projection) {
      // projection may return null point.
      point = projection.unproject(point);
    }

    return point && this.pointToProjected(point);
  };
  /**
   * Point to projected data. Same with pointToData when projection is used.
   */


  Geo.prototype.pointToProjected = function (point) {
    return _super.prototype.pointToData.call(this, point);
  };

  Geo.prototype.projectedToPoint = function (projected, noRoam, out) {
    return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
  };

  Geo.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys$1(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  Geo.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys$1(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };

  return Geo;
}(View);
mixin(Geo, View);

function getCoordSys$1(finder) {
  var geoModel = finder.geoModel;
  var seriesModel = finder.seriesModel;
  return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
  || (seriesModel.getReferringComponents('geo', SINGLE_REFERRING).models[0] || {}).coordinateSystem : null;
}

/**
 * Resize method bound to the geo
 */

function resizeGeo(geoModel, api) {
  var boundingCoords = geoModel.get('boundingCoords');

  if (boundingCoords != null) {
    var leftTop_1 = boundingCoords[0];
    var rightBottom_1 = boundingCoords[1];

    if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Invalid boundingCoords');
      }
    } else {
      // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
      var projection_1 = this.projection;

      if (projection_1) {
        var xMin = leftTop_1[0];
        var yMin = leftTop_1[1];
        var xMax = rightBottom_1[0];
        var yMax = rightBottom_1[1];
        leftTop_1 = [Infinity, Infinity];
        rightBottom_1 = [-Infinity, -Infinity]; // TODO better way?

        var sampleLine = function (x0, y0, x1, y1) {
          var dx = x1 - x0;
          var dy = y1 - y0;

          for (var i = 0; i <= 100; i++) {
            var p = i / 100;
            var pt = projection_1.project([x0 + dx * p, y0 + dy * p]);
            min$1(leftTop_1, leftTop_1, pt);
            max$1(rightBottom_1, rightBottom_1, pt);
          }
        }; // Top


        sampleLine(xMin, yMin, xMax, yMin); // Right

        sampleLine(xMax, yMin, xMax, yMax); // Bottom

        sampleLine(xMax, yMax, xMin, yMax); // Left

        sampleLine(xMin, yMax, xMax, yMin);
      }

      this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
    }
  }

  var rect = this.getBoundingRect();
  var centerOption = geoModel.get('layoutCenter');
  var sizeOption = geoModel.get('layoutSize');
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  var aspect = rect.width / rect.height * this.aspectScale;
  var useCenterAndSize = false;
  var center;
  var size;

  if (centerOption && sizeOption) {
    center = [parsePercent$1(centerOption[0], viewWidth), parsePercent$1(centerOption[1], viewHeight)];
    size = parsePercent$1(sizeOption, Math.min(viewWidth, viewHeight));

    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
      useCenterAndSize = true;
    } else {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Given layoutCenter or layoutSize data are invalid. Use left/top/width/height instead.');
      }
    }
  }

  var viewRect;

  if (useCenterAndSize) {
    viewRect = {};

    if (aspect > 1) {
      // Width is same with size
      viewRect.width = size;
      viewRect.height = size / aspect;
    } else {
      viewRect.height = size;
      viewRect.width = size * aspect;
    }

    viewRect.y = center[1] - viewRect.height / 2;
    viewRect.x = center[0] - viewRect.width / 2;
  } else {
    // Use left/top/width/height
    var boxLayoutOption = geoModel.getBoxLayoutParams();
    boxLayoutOption.aspect = aspect;
    viewRect = getLayoutRect$1(boxLayoutOption, {
      width: viewWidth,
      height: viewHeight
    });
  }

  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
  this.setCenter(geoModel.get('center'), api);
  this.setZoom(geoModel.get('zoom'));
} // Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},


function setGeoCoords(geo, model) {
  each(model.get('geoCoord'), function (geoCoord, name) {
    geo.addGeoCoord(name, geoCoord);
  });
}

var GeoCreator =
/** @class */
function () {
  function GeoCreator() {
    // For deciding which dimensions to use when creating list data
    this.dimensions = geo2DDimensions;
  }

  GeoCreator.prototype.create = function (ecModel, api) {
    var geoList = [];

    function getCommonGeoProperties(model) {
      return {
        nameProperty: model.get('nameProperty'),
        aspectScale: model.get('aspectScale'),
        projection: model.get('projection')
      };
    } // FIXME Create each time may be slow


    ecModel.eachComponent('geo', function (geoModel, idx) {
      var mapName = geoModel.get('map');
      var geo = new Geo(mapName + idx, mapName, extend({
        nameMap: geoModel.get('nameMap')
      }, getCommonGeoProperties(geoModel)));
      geo.zoomLimit = geoModel.get('scaleLimit');
      geoList.push(geo); // setGeoCoords(geo, geoModel);

      geoModel.coordinateSystem = geo;
      geo.model = geoModel; // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(geoModel, api);
    });
    ecModel.eachSeries(function (seriesModel) {
      var coordSys = seriesModel.get('coordinateSystem');

      if (coordSys === 'geo') {
        var geoIndex = seriesModel.get('geoIndex') || 0;
        seriesModel.coordinateSystem = geoList[geoIndex];
      }
    }); // If has map series

    var mapModelGroupBySeries = {};
    ecModel.eachSeriesByType('map', function (seriesModel) {
      if (!seriesModel.getHostGeoModel()) {
        var mapType = seriesModel.getMapType();
        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
        mapModelGroupBySeries[mapType].push(seriesModel);
      }
    });
    each(mapModelGroupBySeries, function (mapSeries, mapType) {
      var nameMapList = map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('nameMap');
      });
      var geo = new Geo(mapType, mapType, extend({
        nameMap: mergeAll(nameMapList)
      }, getCommonGeoProperties(mapSeries[0])));
      geo.zoomLimit = retrieve.apply(null, map(mapSeries, function (singleMapSeries) {
        return singleMapSeries.get('scaleLimit');
      }));
      geoList.push(geo); // Inject resize method

      geo.resize = resizeGeo;
      geo.resize(mapSeries[0], api);
      each(mapSeries, function (singleMapSeries) {
        singleMapSeries.coordinateSystem = geo;
        setGeoCoords(geo, singleMapSeries);
      });
    });
    return geoList;
  };
  /**
   * Fill given regions array
   */


  GeoCreator.prototype.getFilledRegions = function (originRegionArr, mapName, nameMap, nameProperty) {
    // Not use the original
    var regionsArr = (originRegionArr || []).slice();
    var dataNameMap = createHashMap();

    for (var i = 0; i < regionsArr.length; i++) {
      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
    }

    var source = geoSourceManager.load(mapName, nameMap, nameProperty);
    each(source.regions, function (region) {
      var name = region.name;
      !dataNameMap.get(name) && regionsArr.push({
        name: name
      });
    });
    return regionsArr;
  };

  return GeoCreator;
}();

var geoCreator = new GeoCreator();

var GeoModel =
/** @class */
function (_super) {
  __extends$1(GeoModel, _super);

  function GeoModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GeoModel.type;
    return _this;
  }

  GeoModel.prototype.init = function (option, parentModel, ecModel) {
    var source = geoSourceManager.getGeoResource(option.map);

    if (source && source.type === 'geoJSON') {
      var itemStyle = option.itemStyle = option.itemStyle || {};

      if (!('color' in itemStyle)) {
        itemStyle.color = '#eee';
      }
    }

    this.mergeDefaultAndTheme(option, ecModel); // Default label emphasis `show`

    defaultEmphasis(option, 'label', ['show']);
  };

  GeoModel.prototype.optionUpdated = function () {
    var _this = this;

    var option = this.option;
    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
    var selectedMap = {};
    this._optionModelMap = reduce$6(option.regions || [], function (optionModelMap, regionOpt) {
      var regionName = regionOpt.name;

      if (regionName) {
        optionModelMap.set(regionName, new Model(regionOpt, _this, _this.ecModel));

        if (regionOpt.selected) {
          selectedMap[regionName] = true;
        }
      }

      return optionModelMap;
    }, createHashMap());

    if (!option.selectedMap) {
      option.selectedMap = selectedMap;
    }
  };
  /**
   * Get model of region.
   */


  GeoModel.prototype.getRegionModel = function (name) {
    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
  };
  /**
   * Format label
   * @param name Region name
   */


  GeoModel.prototype.getFormattedLabel = function (name, status) {
    var regionModel = this.getRegionModel(name);
    var formatter = status === 'normal' ? regionModel.get(['label', 'formatter']) : regionModel.get(['emphasis', 'label', 'formatter']);
    var params = {
      name: name
    };

    if (isFunction$3(formatter)) {
      params.status = status;
      return formatter(params);
    } else if (isString(formatter)) {
      return formatter.replace('{a}', name != null ? name : '');
    }
  };

  GeoModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  GeoModel.prototype.setCenter = function (center) {
    this.option.center = center;
  }; // PENGING If selectedMode is null ?


  GeoModel.prototype.select = function (name) {
    var option = this.option;
    var selectedMode = option.selectedMode;

    if (!selectedMode) {
      return;
    }

    if (selectedMode !== 'multiple') {
      option.selectedMap = null;
    }

    var selectedMap = option.selectedMap || (option.selectedMap = {});
    selectedMap[name] = true;
  };

  GeoModel.prototype.unSelect = function (name) {
    var selectedMap = this.option.selectedMap;

    if (selectedMap) {
      selectedMap[name] = false;
    }
  };

  GeoModel.prototype.toggleSelected = function (name) {
    this[this.isSelected(name) ? 'unSelect' : 'select'](name);
  };

  GeoModel.prototype.isSelected = function (name) {
    var selectedMap = this.option.selectedMap;
    return !!(selectedMap && selectedMap[name]);
  };

  GeoModel.type = 'geo';
  GeoModel.layoutMode = 'box';
  GeoModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    show: true,
    left: 'center',
    top: 'center',
    // Default value:
    // for geoSVG source: 1,
    // for geoJSON source: 0.75.
    aspectScale: null,
    // /// Layout with center and size
    // If you want to put map in a fixed size box with right aspect ratio
    // This two properties may be more convenient
    // layoutCenter: [50%, 50%]
    // layoutSize: 100
    silent: false,
    // Map type
    map: '',
    // Define left-top, right-bottom coords to control view
    // For example, [ [180, 90], [-180, -90] ]
    boundingCoords: null,
    // Default on center of map
    center: null,
    zoom: 1,
    scaleLimit: null,
    // selectedMode: false
    label: {
      show: false,
      color: '#000'
    },
    itemStyle: {
      borderWidth: 0.5,
      borderColor: '#444' // Default color:
      // + geoJSON: #eee
      // + geoSVG: null (use SVG original `fill`)
      // color: '#eee'

    },
    emphasis: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    select: {
      label: {
        show: true,
        color: 'rgb(100,0,0)'
      },
      itemStyle: {
        color: 'rgba(255,215,0,0.8)'
      }
    },
    regions: [] // tooltip: {
    //     show: false
    // }

  };
  return GeoModel;
}(ComponentModel);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getCenterCoord(view, point) {
  // Use projected coord as center because it's linear.
  return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}

function updateCenterAndZoom(view, payload, zoomLimit, api) {
  var previousZoom = view.getZoom();
  var center = view.getCenter();
  var zoom = payload.zoom;
  var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);

  if (payload.dx != null && payload.dy != null) {
    point[0] -= payload.dx;
    point[1] -= payload.dy;
    view.setCenter(getCenterCoord(view, point), api);
  }

  if (zoom != null) {
    if (zoomLimit) {
      var zoomMin = zoomLimit.min || 0;
      var zoomMax = zoomLimit.max || Infinity;
      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
    } // Zoom on given point(originX, originY)


    view.scaleX *= zoom;
    view.scaleY *= zoom;
    var fixX = (payload.originX - view.x) * (zoom - 1);
    var fixY = (payload.originY - view.y) * (zoom - 1);
    view.x -= fixX;
    view.y -= fixY;
    view.updateTransform(); // Get the new center

    view.setCenter(getCenterCoord(view, point), api);
    view.setZoom(zoom * previousZoom);
  }

  return {
    center: view.getCenter(),
    zoom: view.getZoom()
  };
}

var GeoView =
/** @class */
function (_super) {
  __extends$1(GeoView, _super);

  function GeoView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GeoView.type;
    _this.focusBlurEnabled = true;
    return _this;
  }

  GeoView.prototype.init = function (ecModel, api) {
    this._api = api;
  };

  GeoView.prototype.render = function (geoModel, ecModel, api, payload) {
    this._model = geoModel;

    if (!geoModel.get('show')) {
      this._mapDraw && this._mapDraw.remove();
      this._mapDraw = null;
      return;
    }

    if (!this._mapDraw) {
      this._mapDraw = new MapDraw(api);
    }

    var mapDraw = this._mapDraw;
    mapDraw.draw(geoModel, ecModel, api, this, payload);
    mapDraw.group.on('click', this._handleRegionClick, this);
    mapDraw.group.silent = geoModel.get('silent');
    this.group.add(mapDraw.group);
    this.updateSelectStatus(geoModel, ecModel, api);
  };

  GeoView.prototype._handleRegionClick = function (e) {
    var eventData;
    findEventDispatcher(e.target, function (current) {
      return (eventData = getECData(current).eventData) != null;
    }, true);

    if (eventData) {
      this._api.dispatchAction({
        type: 'geoToggleSelect',
        geoId: this._model.id,
        name: eventData.name
      });
    }
  };

  GeoView.prototype.updateSelectStatus = function (model, ecModel, api) {
    var _this = this;

    this._mapDraw.group.traverse(function (node) {
      var eventData = getECData(node).eventData;

      if (eventData) {
        _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node); // No need to traverse children.

        return true;
      }
    });
  };

  GeoView.prototype.findHighDownDispatchers = function (name) {
    return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
  };

  GeoView.prototype.dispose = function () {
    this._mapDraw && this._mapDraw.remove();
  };

  GeoView.type = 'geo';
  return GeoView;
}(ComponentView);

function registerMap$1(mapName, geoJson, specialAreas) {
  geoSourceManager.registerMap(mapName, geoJson, specialAreas);
}

function install$9(registers) {
  registers.registerCoordinateSystem('geo', geoCreator);
  registers.registerComponentModel(GeoModel);
  registers.registerComponentView(GeoView);
  registers.registerImpl('registerMap', registerMap$1);
  registers.registerImpl('getMap', function (mapName) {
    return geoSourceManager.getMapForUser(mapName);
  });

  function makeAction(method, actionInfo) {
    actionInfo.update = 'geo:updateSelectStatus';
    registers.registerAction(actionInfo, function (payload, ecModel) {
      var selected = {};
      var allSelected = [];
      ecModel.eachComponent({
        mainType: 'geo',
        query: payload
      }, function (geoModel) {
        geoModel[method](payload.name);
        var geo = geoModel.coordinateSystem;
        each(geo.regions, function (region) {
          selected[region.name] = geoModel.isSelected(region.name) || false;
        }); // Notice: there might be duplicated name in different regions.

        var names = [];
        each(selected, function (v, name) {
          selected[name] && names.push(name);
        });
        allSelected.push({
          geoIndex: geoModel.componentIndex,
          // Use singular, the same naming convention as the event `selectchanged`.
          name: names
        });
      });
      return {
        selected: selected,
        allSelected: allSelected,
        name: payload.name
      };
    });
  }

  makeAction('toggleSelected', {
    type: 'geoToggleSelect',
    event: 'geoselectchanged'
  });
  makeAction('select', {
    type: 'geoSelect',
    event: 'geoselected'
  });
  makeAction('unSelect', {
    type: 'geoUnSelect',
    event: 'geounselected'
  });
  /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */

  registers.registerAction({
    type: 'geoRoam',
    event: 'geoRoam',
    update: 'updateTransform'
  }, function (payload, ecModel, api) {
    var componentType = payload.componentType || 'series';
    ecModel.eachComponent({
      mainType: componentType,
      query: payload
    }, function (componentModel) {
      var geo = componentModel.coordinateSystem;

      if (geo.type !== 'geo') {
        return;
      }

      var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'), api);
      componentModel.setCenter && componentModel.setCenter(res.center);
      componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
      // So the center and zoom must be in sync. Include the series not selected by legend

      if (componentType === 'series') {
        each(componentModel.seriesGroup, function (seriesModel) {
          seriesModel.setCenter(res.center);
          seriesModel.setZoom(res.zoom);
        });
      }
    });
  });
}

function install$a(registers) {
  use(install$9);
  registers.registerChartView(MapView);
  registers.registerSeriesModel(MapSeries);
  registers.registerLayout(mapSymbolLayout);
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
  createLegacyDataSelectAction('map', registers.registerAction);
}

/**
 * Initialize all computational message for following algorithm.
 */

function init$2(inRoot) {
  var root = inRoot;
  root.hierNode = {
    defaultAncestor: null,
    ancestor: root,
    prelim: 0,
    modifier: 0,
    change: 0,
    shift: 0,
    i: 0,
    thread: null
  };
  var nodes = [root];
  var node;
  var children;

  while (node = nodes.pop()) {
    // jshint ignore:line
    children = node.children;

    if (node.isExpand && children.length) {
      var n = children.length;

      for (var i = n - 1; i >= 0; i--) {
        var child = children[i];
        child.hierNode = {
          defaultAncestor: null,
          ancestor: child,
          prelim: 0,
          modifier: 0,
          change: 0,
          shift: 0,
          i: i,
          thread: null
        };
        nodes.push(child);
      }
    }
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes a preliminary x coordinate for node. Before that, this function is
 * applied recursively to the children of node, as well as the function
 * apportion(). After spacing out the children by calling executeShifts(), the
 * node is placed to the midpoint of its outermost children.
 */

function firstWalk(node, separation) {
  var children = node.isExpand ? node.children : [];
  var siblings = node.parentNode.children;
  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;

  if (children.length) {
    executeShifts(node);
    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;

    if (subtreeW) {
      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
      node.hierNode.modifier = node.hierNode.prelim - midPoint;
    } else {
      node.hierNode.prelim = midPoint;
    }
  } else if (subtreeW) {
    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
  }

  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Computes all real x-coordinates by summing up the modifiers recursively.
 */

function secondWalk(node) {
  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
  node.setLayout({
    x: nodeX
  }, true);
  node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function separation(cb) {
  return arguments.length ? cb : defaultSeparation;
}
/**
 * Transform the common coordinate to radial coordinate.
 */

function radialCoordinate(rad, r) {
  rad -= Math.PI / 2;
  return {
    x: r * Math.cos(rad),
    y: r * Math.sin(rad)
  };
}
/**
 * Get the layout position of the whole view.
 */

function getViewRect$1(seriesModel, api) {
  return getLayoutRect$1(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */

function executeShifts(node) {
  var children = node.children;
  var n = children.length;
  var shift = 0;
  var change = 0;

  while (--n >= 0) {
    var child = children[n];
    child.hierNode.prelim += shift;
    child.hierNode.modifier += shift;
    change += child.hierNode.change;
    shift += child.hierNode.shift + change;
  }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */


function apportion(subtreeV, subtreeW, ancestor, separation) {
  if (subtreeW) {
    var nodeOutRight = subtreeV;
    var nodeInRight = subtreeV;
    var nodeOutLeft = nodeInRight.parentNode.children[0];
    var nodeInLeft = subtreeW;
    var sumOutRight = nodeOutRight.hierNode.modifier;
    var sumInRight = nodeInRight.hierNode.modifier;
    var sumOutLeft = nodeOutLeft.hierNode.modifier;
    var sumInLeft = nodeInLeft.hierNode.modifier;

    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
      nodeOutRight = nextRight(nodeOutRight);
      nodeOutLeft = nextLeft(nodeOutLeft);
      nodeOutRight.hierNode.ancestor = subtreeV;
      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);

      if (shift > 0) {
        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
        sumInRight += shift;
        sumOutRight += shift;
      }

      sumInLeft += nodeInLeft.hierNode.modifier;
      sumInRight += nodeInRight.hierNode.modifier;
      sumOutRight += nodeOutRight.hierNode.modifier;
      sumOutLeft += nodeOutLeft.hierNode.modifier;
    }

    if (nodeInLeft && !nextRight(nodeOutRight)) {
      nodeOutRight.hierNode.thread = nodeInLeft;
      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
    }

    if (nodeInRight && !nextLeft(nodeOutLeft)) {
      nodeOutLeft.hierNode.thread = nodeInRight;
      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
      ancestor = subtreeV;
    }
  }

  return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */


function nextRight(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */


function nextLeft(node) {
  var children = node.children;
  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */


function nextAncestor(nodeInLeft, node, ancestor) {
  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */


function moveSubtree(wl, wr, shift) {
  var change = shift / (wr.hierNode.i - wl.hierNode.i);
  wr.hierNode.change -= change;
  wr.hierNode.shift += shift;
  wr.hierNode.modifier += shift;
  wr.hierNode.prelim += shift;
  wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */


function defaultSeparation(node1, node2) {
  return node1.parentNode === node2.parentNode ? 1 : 2;
}

var TreeEdgeShape =
/** @class */
function () {
  function TreeEdgeShape() {
    this.parentPoint = [];
    this.childPoints = [];
  }

  return TreeEdgeShape;
}();

var TreePath =
/** @class */
function (_super) {
  __extends$1(TreePath, _super);

  function TreePath(opts) {
    return _super.call(this, opts) || this;
  }

  TreePath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  TreePath.prototype.getDefaultShape = function () {
    return new TreeEdgeShape();
  };

  TreePath.prototype.buildPath = function (ctx, shape) {
    var childPoints = shape.childPoints;
    var childLen = childPoints.length;
    var parentPoint = shape.parentPoint;
    var firstChildPos = childPoints[0];
    var lastChildPos = childPoints[childLen - 1];

    if (childLen === 1) {
      ctx.moveTo(parentPoint[0], parentPoint[1]);
      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
      return;
    }

    var orient = shape.orient;
    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
    var otherDim = 1 - forkDim;
    var forkPosition = parsePercent$1(shape.forkPosition, 1);
    var tmpPoint = [];
    tmpPoint[forkDim] = parentPoint[forkDim];
    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
    ctx.moveTo(parentPoint[0], parentPoint[1]);
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
    tmpPoint[forkDim] = firstChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    tmpPoint[forkDim] = lastChildPos[forkDim];
    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    ctx.lineTo(lastChildPos[0], lastChildPos[1]);

    for (var i = 1; i < childLen - 1; i++) {
      var point = childPoints[i];
      ctx.moveTo(point[0], point[1]);
      tmpPoint[forkDim] = point[forkDim];
      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
    }
  };

  return TreePath;
}(Path);

var TreeView =
/** @class */
function (_super) {
  __extends$1(TreeView, _super);

  function TreeView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreeView.type;
    _this._mainGroup = new Group$1();
    return _this;
  }

  TreeView.prototype.init = function (ecModel, api) {
    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: this.group
    };
    this.group.add(this._mainGroup);
  };

  TreeView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var layoutInfo = seriesModel.layoutInfo;
    var group = this._mainGroup;
    var layout = seriesModel.get('layout');

    if (layout === 'radial') {
      group.x = layoutInfo.x + layoutInfo.width / 2;
      group.y = layoutInfo.y + layoutInfo.height / 2;
    } else {
      group.x = layoutInfo.x;
      group.y = layoutInfo.y;
    }

    this._updateViewCoordSys(seriesModel, api);

    this._updateController(seriesModel, ecModel, api);

    var oldData = this._data;
    data.diff(oldData).add(function (newIdx) {
      if (symbolNeedsDraw$1(data, newIdx)) {
        // Create node and edge
        updateNode(data, newIdx, null, group, seriesModel);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx);

      if (!symbolNeedsDraw$1(data, newIdx)) {
        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        return;
      } // Update node and edge


      updateNode(data, newIdx, symbolEl, group, seriesModel);
    }).remove(function (oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
      // node haven't been initialized with a symbol element,
      // you can't found it's symbol element through index.
      // so if we want to remove the symbol element we should insure
      // that the symbol element is not null.

      if (symbolEl) {
        removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
      }
    }).execute();
    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');

    this._updateNodeAndLinkScale(seriesModel);

    if (seriesModel.get('expandAndCollapse') === true) {
      data.eachItemGraphicEl(function (el, dataIndex) {
        el.off('click').on('click', function () {
          api.dispatchAction({
            type: 'treeExpandAndCollapse',
            seriesId: seriesModel.id,
            dataIndex: dataIndex
          });
        });
      });
    }

    this._data = data;
  };

  TreeView.prototype._updateViewCoordSys = function (seriesModel, api) {
    var data = seriesModel.getData();
    var points = [];
    data.each(function (idx) {
      var layout = data.getItemLayout(idx);

      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
        points.push([+layout.x, +layout.y]);
      }
    });
    var min = [];
    var max = [];
    fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
    // the root node will disappear.

    var oldMin = this._min;
    var oldMax = this._max; // If width or height is 0

    if (max[0] - min[0] === 0) {
      min[0] = oldMin ? oldMin[0] : min[0] - 1;
      max[0] = oldMax ? oldMax[0] : max[0] + 1;
    }

    if (max[1] - min[1] === 0) {
      min[1] = oldMin ? oldMin[1] : min[1] - 1;
      max[1] = oldMax ? oldMax[1] : max[1] + 1;
    }

    var viewCoordSys = seriesModel.coordinateSystem = new View();
    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    viewCoordSys.setCenter(seriesModel.get('center'), api);
    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group

    this.group.attr({
      x: viewCoordSys.x,
      y: viewCoordSys.y,
      scaleX: viewCoordSys.scaleX,
      scaleY: viewCoordSys.scaleY
    });
    this._min = min;
    this._max = max;
  };

  TreeView.prototype._updateController = function (seriesModel, ecModel, api) {
    var _this = this;

    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
    });
    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        dx: e.dx,
        dy: e.dy
      });
    }).on('zoom', function (e) {
      updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'treeRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      _this._updateNodeAndLinkScale(seriesModel); // Only update label layout on zoom


      api.updateLabelLayout();
    });
  };

  TreeView.prototype._updateNodeAndLinkScale = function (seriesModel) {
    var data = seriesModel.getData();

    var nodeScale = this._getNodeGlobalScale(seriesModel);

    data.eachItemGraphicEl(function (el, idx) {
      el.setSymbolScale(nodeScale);
    });
  };

  TreeView.prototype._getNodeGlobalScale = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type !== 'view') {
      return 1;
    }

    var nodeScaleRatio = this._nodeScaleRatio;
    var groupZoom = coordSys.scaleX || 1; // Scale node when zoom changes

    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
  };

  TreeView.prototype.dispose = function () {
    this._controller && this._controller.dispose();
    this._controllerHost = null;
  };

  TreeView.prototype.remove = function () {
    this._mainGroup.removeAll();

    this._data = null;
  };

  TreeView.type = 'tree';
  return TreeView;
}(ChartView);

function symbolNeedsDraw$1(data, dataIndex) {
  var layout = data.getItemLayout(dataIndex);
  return layout && !isNaN(layout.x) && !isNaN(layout.y);
}

function updateNode(data, dataIndex, symbolEl, group, seriesModel) {
  var isInit = !symbolEl;
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var itemModel = node.getModel();
  var visualColor = node.getVisual('style').fill;
  var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : '#fff';
  var virtualRoot = data.tree.root;
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceLayout = source.getLayout();
  var sourceOldLayout = sourceSymbolEl ? {
    x: sourceSymbolEl.__oldX,
    y: sourceSymbolEl.__oldY,
    rawX: sourceSymbolEl.__radialOldRawX,
    rawY: sourceSymbolEl.__radialOldRawY
  } : sourceLayout;
  var targetLayout = node.getLayout();

  if (isInit) {
    symbolEl = new Symbol$2(data, dataIndex, null, {
      symbolInnerColor: symbolInnerColor,
      useNameLabel: true
    });
    symbolEl.x = sourceOldLayout.x;
    symbolEl.y = sourceOldLayout.y;
  } else {
    symbolEl.updateData(data, dataIndex, null, {
      symbolInnerColor: symbolInnerColor,
      useNameLabel: true
    });
  }

  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
  symbolEl.__radialRawX = targetLayout.rawX;
  symbolEl.__radialRawY = targetLayout.rawY;
  group.add(symbolEl);
  data.setItemGraphicEl(dataIndex, symbolEl);
  symbolEl.__oldX = symbolEl.x;
  symbolEl.__oldY = symbolEl.y;
  updateProps(symbolEl, {
    x: targetLayout.x,
    y: targetLayout.y
  }, seriesModel);
  var symbolPath = symbolEl.getSymbolPath();

  if (seriesModel.get('layout') === 'radial') {
    var realRoot = virtualRoot.children[0];
    var rootLayout = realRoot.getLayout();
    var length_1 = realRoot.children.length;
    var rad = void 0;
    var isLeft = void 0;

    if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
      var center = {
        x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
        y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
      };
      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      isLeft = center.x < rootLayout.x;

      if (isLeft) {
        rad = rad - Math.PI;
      }
    } else {
      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);

      if (rad < 0) {
        rad = Math.PI * 2 + rad;
      }

      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
        isLeft = targetLayout.x < rootLayout.x;

        if (isLeft) {
          rad = rad - Math.PI;
        }
      } else {
        isLeft = targetLayout.x > rootLayout.x;

        if (!isLeft) {
          rad = rad - Math.PI;
        }
      }
    }

    var textPosition = isLeft ? 'left' : 'right';
    var normalLabelModel = itemModel.getModel('label');
    var rotate = normalLabelModel.get('rotate');
    var labelRotateRadian = rotate * (Math.PI / 180);
    var textContent = symbolPath.getTextContent();

    if (textContent) {
      symbolPath.setTextConfig({
        position: normalLabelModel.get('position') || textPosition,
        rotation: rotate == null ? -rad : labelRotateRadian,
        origin: 'center'
      });
      textContent.setStyle('verticalAlign', 'middle');
    }
  } // Handle status


  var focus = itemModel.get(['emphasis', 'focus']);
  var focusDataIndices = focus === 'relative' ? concatArray(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;

  if (focusDataIndices) {
    // Modify the focus to data indices.
    getECData(symbolEl).focus = focusDataIndices;
  }

  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);

  if (symbolEl.__edge) {
    symbolEl.onHoverStateChange = function (toState) {
      if (toState !== 'blur') {
        // NOTE: Ensure the parent elements will been blurred firstly.
        // According to the return of getAncestorsIndices and getDescendantIndices
        // TODO: A bit tricky.
        var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);

        if (!(parentEl && parentEl.hoverState === HOVER_STATE_BLUR)) {
          setStatesFlag(symbolEl.__edge, toState);
        }
      }
    };
  }
}

function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
  var itemModel = node.getModel();
  var edgeShape = seriesModel.get('edgeShape');
  var layout = seriesModel.get('layout');
  var orient = seriesModel.getOrient();
  var curvature = seriesModel.get(['lineStyle', 'curveness']);
  var edgeForkPosition = seriesModel.get('edgeForkPosition');
  var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
  var edge = symbolEl.__edge; // curve edge from node -> parent
  // polyline edge from node -> children

  if (edgeShape === 'curve') {
    if (node.parentNode && node.parentNode !== virtualRoot) {
      if (!edge) {
        edge = symbolEl.__edge = new BezierCurve({
          shape: getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
        });
      }

      updateProps(edge, {
        shape: getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
      }, seriesModel);
    }
  } else if (edgeShape === 'polyline') {
    if (layout === 'orthogonal') {
      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
        var children = node.children;
        var childPoints = [];

        for (var i = 0; i < children.length; i++) {
          var childLayout = children[i].getLayout();
          childPoints.push([childLayout.x, childLayout.y]);
        }

        if (!edge) {
          edge = symbolEl.__edge = new TreePath({
            shape: {
              parentPoint: [targetLayout.x, targetLayout.y],
              childPoints: [[targetLayout.x, targetLayout.y]],
              orient: orient,
              forkPosition: edgeForkPosition
            }
          });
        }

        updateProps(edge, {
          shape: {
            parentPoint: [targetLayout.x, targetLayout.y],
            childPoints: childPoints
          }
        }, seriesModel);
      }
    } else {
      if (process.env.NODE_ENV !== 'production') {
        throw new Error('The polyline edgeShape can only be used in orthogonal layout');
      }
    }
  } // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'


  if (edge && !(edgeShape === 'polyline' && !node.isExpand)) {
    edge.useStyle(defaults({
      strokeNoScale: true,
      fill: null
    }, lineStyle));
    setStatesStylesFromModel(edge, itemModel, 'lineStyle');
    setDefaultStateProxy(edge);
    group.add(edge);
  }
}

function removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
  var virtualRoot = data.tree.root;

  var _a = getSourceNode(virtualRoot, node),
      source = _a.source,
      sourceLayout = _a.sourceLayout;

  var symbolEl = data.getItemGraphicEl(node.dataIndex);

  if (!symbolEl) {
    return;
  }

  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
  // the source at the same time. because the polyline edge shape is only owned by the source.
  // 2.when the node is the only children of the source, delete the node should delete the edge of
  // the source at the same time. the same reason as above.

  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
  var edgeShape = seriesModel.get('edgeShape');
  var layoutOpt = seriesModel.get('layout');
  var orient = seriesModel.get('orient');
  var curvature = seriesModel.get(['lineStyle', 'curveness']);

  if (edge) {
    if (edgeShape === 'curve') {
      removeElement(edge, {
        shape: getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
        style: {
          opacity: 0
        }
      }, seriesModel, {
        cb: function () {
          group.remove(edge);
        },
        removeOpt: removeAnimationOpt
      });
    } else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') {
      removeElement(edge, {
        shape: {
          parentPoint: [sourceLayout.x, sourceLayout.y],
          childPoints: [[sourceLayout.x, sourceLayout.y]]
        },
        style: {
          opacity: 0
        }
      }, seriesModel, {
        cb: function () {
          group.remove(edge);
        },
        removeOpt: removeAnimationOpt
      });
    }
  }
}

function getSourceNode(virtualRoot, node) {
  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
  var sourceLayout;

  while (sourceLayout = source.getLayout(), sourceLayout == null) {
    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
  }

  return {
    source: source,
    sourceLayout: sourceLayout
  };
}

function removeNode(data, dataIndex, symbolEl, group, seriesModel) {
  var node = data.tree.getNodeByDataIndex(dataIndex);
  var virtualRoot = data.tree.root;
  var sourceLayout = getSourceNode(virtualRoot, node).sourceLayout; // Use same duration and easing with update to have more consistent animation.

  var removeAnimationOpt = {
    duration: seriesModel.get('animationDurationUpdate'),
    easing: seriesModel.get('animationEasingUpdate')
  };
  removeElement(symbolEl, {
    x: sourceLayout.x + 1,
    y: sourceLayout.y + 1
  }, seriesModel, {
    cb: function () {
      group.remove(symbolEl);
      data.setItemGraphicEl(dataIndex, null);
    },
    removeOpt: removeAnimationOpt
  });
  symbolEl.fadeOut(null, data.hostModel, {
    fadeLabel: true,
    animation: removeAnimationOpt
  }); // remove edge as parent node

  node.children.forEach(function (childNode) {
    removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
  }); // remove edge as child node

  removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}

function getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
  var cpx1;
  var cpy1;
  var cpx2;
  var cpy2;
  var x1;
  var x2;
  var y1;
  var y2;

  if (layoutOpt === 'radial') {
    x1 = sourceLayout.rawX;
    y1 = sourceLayout.rawY;
    x2 = targetLayout.rawX;
    y2 = targetLayout.rawY;
    var radialCoor1 = radialCoordinate(x1, y1);
    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * curvature);
    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * curvature);
    var radialCoor4 = radialCoordinate(x2, y2);
    return {
      x1: radialCoor1.x || 0,
      y1: radialCoor1.y || 0,
      x2: radialCoor4.x || 0,
      y2: radialCoor4.y || 0,
      cpx1: radialCoor2.x || 0,
      cpy1: radialCoor2.y || 0,
      cpx2: radialCoor3.x || 0,
      cpy2: radialCoor3.y || 0
    };
  } else {
    x1 = sourceLayout.x;
    y1 = sourceLayout.y;
    x2 = targetLayout.x;
    y2 = targetLayout.y;

    if (orient === 'LR' || orient === 'RL') {
      cpx1 = x1 + (x2 - x1) * curvature;
      cpy1 = y1;
      cpx2 = x2 + (x1 - x2) * curvature;
      cpy2 = y2;
    }

    if (orient === 'TB' || orient === 'BT') {
      cpx1 = x1;
      cpy1 = y1 + (y2 - y1) * curvature;
      cpx2 = x2;
      cpy2 = y2 + (y1 - y2) * curvature;
    }
  }

  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2,
    cpx1: cpx1,
    cpy1: cpy1,
    cpx2: cpx2,
    cpy2: cpy2
  };
}

var inner$8 = makeInner();

function linkSeriesData(opt) {
  var mainData = opt.mainData;
  var datas = opt.datas;

  if (!datas) {
    datas = {
      main: mainData
    };
    opt.datasAttr = {
      main: 'data'
    };
  }

  opt.datas = opt.mainData = null;
  linkAll(mainData, datas, opt); // Porxy data original methods.

  each(datas, function (data) {
    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
      data.wrapMethod(methodName, curry(transferInjection, opt));
    });
  }); // Beyond transfer, additional features should be added to `cloneShallow`.

  mainData.wrapMethod('cloneShallow', curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
  // another changable methods, which may bring about dead lock.

  each(mainData.CHANGABLE_METHODS, function (methodName) {
    mainData.wrapMethod(methodName, curry(changeInjection, opt));
  }); // Make sure datas contains mainData.

  assert(datas[mainData.dataType] === mainData);
}

function transferInjection(opt, res) {
  if (isMainData(this)) {
    // Transfer datas to new main data.
    var datas = extend({}, inner$8(this).datas);
    datas[this.dataType] = res;
    linkAll(res, datas, opt);
  } else {
    // Modify the reference in main data to point newData.
    linkSingle(res, this.dataType, inner$8(this).mainData, opt);
  }

  return res;
}

function changeInjection(opt, res) {
  opt.struct && opt.struct.update();
  return res;
}

function cloneShallowInjection(opt, res) {
  // cloneShallow, which brings about some fragilities, may be inappropriate
  // to be exposed as an API. So for implementation simplicity we can make
  // the restriction that cloneShallow of not-mainData should not be invoked
  // outside, but only be invoked here.
  each(inner$8(res).datas, function (data, dataType) {
    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
  });
  return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */


function getLinkedData(dataType) {
  var mainData = inner$8(this).mainData;
  return dataType == null || mainData == null ? mainData : inner$8(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */


function getLinkedDataAll() {
  var mainData = inner$8(this).mainData;
  return mainData == null ? [{
    data: mainData
  }] : map(keys$2(inner$8(mainData).datas), function (type) {
    return {
      type: type,
      data: inner$8(mainData).datas[type]
    };
  });
}

function isMainData(data) {
  return inner$8(data).mainData === data;
}

function linkAll(mainData, datas, opt) {
  inner$8(mainData).datas = {};
  each(datas, function (data, dataType) {
    linkSingle(data, dataType, mainData, opt);
  });
}

function linkSingle(data, dataType, mainData, opt) {
  inner$8(mainData).datas[dataType] = data;
  inner$8(data).mainData = mainData;
  data.dataType = dataType;

  if (opt.struct) {
    data[opt.structAttr] = opt.struct;
    opt.struct[opt.datasAttr[dataType]] = data;
  } // Supplement method.


  data.getLinkedData = getLinkedData;
  data.getLinkedDataAll = getLinkedDataAll;
}

var TreeNode =
/** @class */
function () {
  function TreeNode(name, hostTree) {
    this.depth = 0;
    this.height = 0;
    /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */

    this.dataIndex = -1;
    this.children = [];
    this.viewChildren = [];
    this.isExpand = false;
    this.name = name || '';
    this.hostTree = hostTree;
  }
  /**
   * The node is removed.
   */


  TreeNode.prototype.isRemoved = function () {
    return this.dataIndex < 0;
  };

  TreeNode.prototype.eachNode = function (options, cb, context) {
    if (isFunction$3(options)) {
      context = cb;
      cb = options;
      options = null;
    }

    options = options || {};

    if (isString(options)) {
      options = {
        order: options
      };
    }

    var order = options.order || 'preorder';
    var children = this[options.attr || 'children'];
    var suppressVisitSub;
    order === 'preorder' && (suppressVisitSub = cb.call(context, this));

    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
      children[i].eachNode(options, cb, context);
    }

    order === 'postorder' && cb.call(context, this);
  };
  /**
   * Update depth and height of this subtree.
   */


  TreeNode.prototype.updateDepthAndHeight = function (depth) {
    var height = 0;
    this.depth = depth;

    for (var i = 0; i < this.children.length; i++) {
      var child = this.children[i];
      child.updateDepthAndHeight(depth + 1);

      if (child.height > height) {
        height = child.height;
      }
    }

    this.height = height + 1;
  };

  TreeNode.prototype.getNodeById = function (id) {
    if (this.getId() === id) {
      return this;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].getNodeById(id);

      if (res) {
        return res;
      }
    }
  };

  TreeNode.prototype.contains = function (node) {
    if (node === this) {
      return true;
    }

    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
      var res = children[i].contains(node);

      if (res) {
        return res;
      }
    }
  };
  /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */


  TreeNode.prototype.getAncestors = function (includeSelf) {
    var ancestors = [];
    var node = includeSelf ? this : this.parentNode;

    while (node) {
      ancestors.push(node);
      node = node.parentNode;
    }

    ancestors.reverse();
    return ancestors;
  };

  TreeNode.prototype.getAncestorsIndices = function () {
    var indices = [];
    var currNode = this;

    while (currNode) {
      indices.push(currNode.dataIndex);
      currNode = currNode.parentNode;
    }

    indices.reverse();
    return indices;
  };

  TreeNode.prototype.getDescendantIndices = function () {
    var indices = [];
    this.eachNode(function (childNode) {
      indices.push(childNode.dataIndex);
    });
    return indices;
  };

  TreeNode.prototype.getValue = function (dimension) {
    var data = this.hostTree.data;
    return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
  };

  TreeNode.prototype.setLayout = function (layout, merge) {
    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
  };
  /**
   * @return {Object} layout
   */


  TreeNode.prototype.getLayout = function () {
    return this.hostTree.data.getItemLayout(this.dataIndex);
  }; // @depcrecated
  // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars


  TreeNode.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var hostTree = this.hostTree;
    var itemModel = hostTree.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  }; // TODO: TYPE More specific model


  TreeNode.prototype.getLevelModel = function () {
    return (this.hostTree.levelModels || [])[this.depth];
  };

  TreeNode.prototype.setVisual = function (key, value) {
    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
  };
  /**
   * Get item visual
   * FIXME: make return type better
   */


  TreeNode.prototype.getVisual = function (key) {
    return this.hostTree.data.getItemVisual(this.dataIndex, key);
  };

  TreeNode.prototype.getRawIndex = function () {
    return this.hostTree.data.getRawIndex(this.dataIndex);
  };

  TreeNode.prototype.getId = function () {
    return this.hostTree.data.getId(this.dataIndex);
  };
  /**
   * index in parent's children
   */


  TreeNode.prototype.getChildIndex = function () {
    if (this.parentNode) {
      var children = this.parentNode.children;

      for (var i = 0; i < children.length; ++i) {
        if (children[i] === this) {
          return i;
        }
      }

      return -1;
    }

    return -1;
  };
  /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */


  TreeNode.prototype.isAncestorOf = function (node) {
    var parent = node.parentNode;

    while (parent) {
      if (parent === this) {
        return true;
      }

      parent = parent.parentNode;
    }

    return false;
  };
  /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */


  TreeNode.prototype.isDescendantOf = function (node) {
    return node !== this && node.isAncestorOf(this);
  };

  return TreeNode;
}();

var Tree =
/** @class */
function () {
  function Tree(hostModel) {
    this.type = 'tree';
    this._nodes = [];
    this.hostModel = hostModel;
  }

  Tree.prototype.eachNode = function (options, cb, context) {
    this.root.eachNode(options, cb, context);
  };

  Tree.prototype.getNodeByDataIndex = function (dataIndex) {
    var rawIndex = this.data.getRawIndex(dataIndex);
    return this._nodes[rawIndex];
  };

  Tree.prototype.getNodeById = function (name) {
    return this.root.getNodeById(name);
  };
  /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */


  Tree.prototype.update = function () {
    var data = this.data;
    var nodes = this._nodes;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }
  };
  /**
   * Clear all layouts
   */


  Tree.prototype.clearLayouts = function () {
    this.data.clearItemLayouts();
  };
  /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */


  Tree.createTree = function (dataRoot, hostModel, beforeLink) {
    var tree = new Tree(hostModel);
    var listData = [];
    var dimMax = 1;
    buildHierarchy(dataRoot);

    function buildHierarchy(dataNode, parentNode) {
      var value = dataNode.value;
      dimMax = Math.max(dimMax, isArray$1(value) ? value.length : 1);
      listData.push(dataNode);
      var node = new TreeNode(convertOptionIdName(dataNode.name, ''), tree);
      parentNode ? addChild(node, parentNode) : tree.root = node;

      tree._nodes.push(node);

      var children = dataNode.children;

      if (children) {
        for (var i = 0; i < children.length; i++) {
          buildHierarchy(children[i], node);
        }
      }
    }

    tree.root.updateDepthAndHeight(0);
    var dimensions = prepareSeriesDataSchema(listData, {
      coordDimensions: ['value'],
      dimensionsCount: dimMax
    }).dimensions;
    var list = new SeriesData(dimensions, hostModel);
    list.initData(listData);
    beforeLink && beforeLink(list);
    linkSeriesData({
      mainData: list,
      struct: tree,
      structAttr: 'tree'
    });
    tree.update();
    return tree;
  };

  return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */


function addChild(child, node) {
  var children = node.children;

  if (child.parentNode === node) {
    return;
  }

  children.push(child);
  child.parentNode = node;
}

function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
  if (payload && indexOf(validPayloadTypes, payload.type) >= 0) {
    var root = seriesModel.getData().tree.root;
    var targetNode = payload.targetNode;

    if (isString(targetNode)) {
      targetNode = root.getNodeById(targetNode);
    }

    if (targetNode && root.contains(targetNode)) {
      return {
        node: targetNode
      };
    }

    var targetNodeId = payload.targetNodeId;

    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
      return {
        node: targetNode
      };
    }
  }
} // Not includes the given node at the last item.

function getPathToRoot(node) {
  var path = [];

  while (node) {
    node = node.parentNode;
    node && path.push(node);
  }

  return path.reverse();
}
function aboveViewRoot(viewRoot, node) {
  var viewPath = getPathToRoot(viewRoot);
  return indexOf(viewPath, node) >= 0;
} // From root to the input node (the input node will be included).

function wrapTreePathInfo(node, seriesModel) {
  var treePathInfo = [];

  while (node) {
    var nodeDataIndex = node.dataIndex;
    treePathInfo.push({
      name: node.name,
      dataIndex: nodeDataIndex,
      value: seriesModel.getRawValue(nodeDataIndex)
    });
    node = node.parentNode;
  }

  treePathInfo.reverse();
  return treePathInfo;
}

var TreeSeriesModel =
/** @class */
function (_super) {
  __extends$1(TreeSeriesModel, _super);

  function TreeSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.hasSymbolVisual = true; // Do it self.

    _this.ignoreStyleOnData = true;
    return _this;
  }
  /**
   * Init a tree data structure from data in option series
   */


  TreeSeriesModel.prototype.getInitialData = function (option) {
    // create a virtual root
    var root = {
      name: option.name,
      children: option.data
    };
    var leaves = option.leaves || {};
    var leavesModel = new Model(leaves, this, this.ecModel);
    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);

        if (!(node && node.children.length && node.isExpand)) {
          model.parentModel = leavesModel;
        }

        return model;
      });
    }

    var treeDepth = 0;
    tree.eachNode('preorder', function (node) {
      if (node.depth > treeDepth) {
        treeDepth = node.depth;
      }
    });
    var expandAndCollapse = option.expandAndCollapse;
    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
    tree.root.eachNode('preorder', function (node) {
      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.

      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
    });
    return tree.data;
  };
  /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */


  TreeSeriesModel.prototype.getOrient = function () {
    var orient = this.get('orient');

    if (orient === 'horizontal') {
      orient = 'LR';
    } else if (orient === 'vertical') {
      orient = 'TB';
    }

    return orient;
  };

  TreeSeriesModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  TreeSeriesModel.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  TreeSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var tree = this.getData().tree;
    var realRoot = tree.root.children[0];
    var node = tree.getNodeByDataIndex(dataIndex);
    var value = node.getValue();
    var name = node.name;

    while (node && node !== realRoot) {
      name = node.parentNode.name + '.' + name;
      node = node.parentNode;
    }

    return createTooltipMarkup('nameValue', {
      name: name,
      value: value,
      noValue: isNaN(value) || value == null
    });
  }; // Add tree path to tooltip param


  TreeSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treeAncestors = wrapTreePathInfo(node, this);
    params.collapsed = !node.isExpand;
    return params;
  };

  TreeSeriesModel.type = 'series.tree'; // can support the position parameters 'left', 'top','right','bottom', 'width',
  // 'height' in the setOption() with 'merge' mode normal.

  TreeSeriesModel.layoutMode = 'box';
  TreeSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // the position of the whole view
    left: '12%',
    top: '12%',
    right: '12%',
    bottom: '12%',
    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
    layout: 'orthogonal',
    // value can be 'polyline'
    edgeShape: 'curve',
    edgeForkPosition: '50%',
    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
    roam: false,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.4,
    // Default on center of graph
    center: null,
    zoom: 1,
    orient: 'LR',
    symbol: 'emptyCircle',
    symbolSize: 7,
    expandAndCollapse: true,
    initialTreeDepth: 2,
    lineStyle: {
      color: '#ccc',
      width: 1.5,
      curveness: 0.5
    },
    itemStyle: {
      color: 'lightsteelblue',
      // borderColor: '#c23531',
      borderWidth: 1.5
    },
    label: {
      show: true
    },
    animationEasing: 'linear',
    animationDuration: 700,
    animationDurationUpdate: 500
  };
  return TreeSeriesModel;
}(SeriesModel);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Traverse the tree from bottom to top and do something
 */
function eachAfter(root, callback, separation) {
  var nodes = [root];
  var next = [];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    next.push(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = 0; i < children.length; i++) {
          nodes.push(children[i]);
        }
      }
    }
  }

  while (node = next.pop()) {
    // jshint ignore:line
    callback(node, separation);
  }
}
/**
 * Traverse the tree from top to bottom and do something
 */


function eachBefore(root, callback) {
  var nodes = [root];
  var node;

  while (node = nodes.pop()) {
    // jshint ignore:line
    callback(node);

    if (node.isExpand) {
      var children = node.children;

      if (children.length) {
        for (var i = children.length - 1; i >= 0; i--) {
          nodes.push(children[i]);
        }
      }
    }
  }
}

function treeLayout(ecModel, api) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    commonLayout(seriesModel, api);
  });
}

function commonLayout(seriesModel, api) {
  var layoutInfo = getViewRect$1(seriesModel, api);
  seriesModel.layoutInfo = layoutInfo;
  var layout = seriesModel.get('layout');
  var width = 0;
  var height = 0;
  var separation$1 = null;

  if (layout === 'radial') {
    width = 2 * Math.PI;
    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
    separation$1 = separation(function (node1, node2) {
      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
    });
  } else {
    width = layoutInfo.width;
    height = layoutInfo.height;
    separation$1 = separation();
  }

  var virtualRoot = seriesModel.getData().tree.root;
  var realRoot = virtualRoot.children[0];

  if (realRoot) {
    init$2(virtualRoot);
    eachAfter(realRoot, firstWalk, separation$1);
    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
    eachBefore(realRoot, secondWalk);
    var left_1 = realRoot;
    var right_1 = realRoot;
    var bottom_1 = realRoot;
    eachBefore(realRoot, function (node) {
      var x = node.getLayout().x;

      if (x < left_1.getLayout().x) {
        left_1 = node;
      }

      if (x > right_1.getLayout().x) {
        right_1 = node;
      }

      if (node.depth > bottom_1.depth) {
        bottom_1 = node;
      }
    });
    var delta = left_1 === right_1 ? 1 : separation$1(left_1, right_1) / 2;
    var tx_1 = delta - left_1.getLayout().x;
    var kx_1 = 0;
    var ky_1 = 0;
    var coorX_1 = 0;
    var coorY_1 = 0;

    if (layout === 'radial') {
      kx_1 = width / (right_1.getLayout().x + delta + tx_1); // here we use (node.depth - 1), bucause the real root's depth is 1

      ky_1 = height / (bottom_1.depth - 1 || 1);
      eachBefore(realRoot, function (node) {
        coorX_1 = (node.getLayout().x + tx_1) * kx_1;
        coorY_1 = (node.depth - 1) * ky_1;
        var finalCoor = radialCoordinate(coorX_1, coorY_1);
        node.setLayout({
          x: finalCoor.x,
          y: finalCoor.y,
          rawX: coorX_1,
          rawY: coorY_1
        }, true);
      });
    } else {
      var orient_1 = seriesModel.getOrient();

      if (orient_1 === 'RL' || orient_1 === 'LR') {
        ky_1 = height / (right_1.getLayout().x + delta + tx_1);
        kx_1 = width / (bottom_1.depth - 1 || 1);
        eachBefore(realRoot, function (node) {
          coorY_1 = (node.getLayout().x + tx_1) * ky_1;
          coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
          node.setLayout({
            x: coorX_1,
            y: coorY_1
          }, true);
        });
      } else if (orient_1 === 'TB' || orient_1 === 'BT') {
        kx_1 = width / (right_1.getLayout().x + delta + tx_1);
        ky_1 = height / (bottom_1.depth - 1 || 1);
        eachBefore(realRoot, function (node) {
          coorX_1 = (node.getLayout().x + tx_1) * kx_1;
          coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
          node.setLayout({
            x: coorX_1,
            y: coorY_1
          }, true);
        });
      }
    }
  }
}

function treeVisual(ecModel) {
  ecModel.eachSeriesByType('tree', function (seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    tree.eachNode(function (node) {
      var model = node.getModel(); // TODO Optimize

      var style = model.getModel('itemStyle').getItemStyle();
      var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
      extend(existsStyle, style);
    });
  });
}

function installTreeAction(registers) {
  registers.registerAction({
    type: 'treeExpandAndCollapse',
    event: 'treeExpandAndCollapse',
    update: 'update'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'tree',
      query: payload
    }, function (seriesModel) {
      var dataIndex = payload.dataIndex;
      var tree = seriesModel.getData().tree;
      var node = tree.getNodeByDataIndex(dataIndex);
      node.isExpand = !node.isExpand;
    });
  });
  registers.registerAction({
    type: 'treeRoam',
    event: 'treeRoam',
    // Here we set 'none' instead of 'update', because roam action
    // just need to update the transform matrix without having to recalculate
    // the layout. So don't need to go through the whole update process, such
    // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
    update: 'none'
  }, function (payload, ecModel, api) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'tree',
      query: payload
    }, function (seriesModel) {
      var coordSys = seriesModel.coordinateSystem;
      var res = updateCenterAndZoom(coordSys, payload, undefined, api);
      seriesModel.setCenter && seriesModel.setCenter(res.center);
      seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
  });
}

function install$b(registers) {
  registers.registerChartView(TreeView);
  registers.registerSeriesModel(TreeSeriesModel);
  registers.registerLayout(treeLayout);
  registers.registerVisual(treeVisual);
  installTreeAction(registers);
}

var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
function installTreemapAction(registers) {
  for (var i = 0; i < actionTypes.length; i++) {
    registers.registerAction({
      type: actionTypes[i],
      update: 'updateView'
    }, noop$2);
  }

  registers.registerAction({
    type: 'treemapRootToNode',
    update: 'updateView'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    }, handleRootToNode);

    function handleRootToNode(model, index) {
      var types = ['treemapZoomToNode', 'treemapRootToNode'];
      var targetInfo = retrieveTargetInfo(payload, types, model);

      if (targetInfo) {
        var originViewRoot = model.getViewRoot();

        if (originViewRoot) {
          payload.direction = aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
        }

        model.resetViewRoot(targetInfo.node);
      }
    }
  });
}

function enableAriaDecalForTree(seriesModel) {
  var data = seriesModel.getData();
  var tree = data.tree;
  var decalPaletteScope = {};
  tree.eachNode(function (node) {
    // Use decal of level 1 node
    var current = node;

    while (current && current.depth > 1) {
      current = current.parentNode;
    }

    var decal = getDecalFromPalette(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
    node.setVisual('decal', decal);
  });
}

var TreemapSeriesModel =
/** @class */
function (_super) {
  __extends$1(TreemapSeriesModel, _super);

  function TreemapSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreemapSeriesModel.type;
    _this.preventUsingHoverLayer = true;
    return _this;
  }
  /**
   * @override
   */


  TreemapSeriesModel.prototype.getInitialData = function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue(root);
    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
    // This way is a little tricky, must satisfy the precondition:
    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
    //   2. The `Model.prototype.getModel()` will not use any clone-like way.

    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
    var designatedVisualModel = new Model({
      itemStyle: designatedVisualItemStyle
    }, this, ecModel);
    levels = option.levels = setDefault(levels, ecModel);
    var levelModels = map(levels || [], function (levelDefine) {
      return new Model(levelDefine, designatedVisualModel, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = node ? levelModels[node.depth] : null; // If no levelModel, we also need `designatedVisualModel`.

        model.parentModel = levelModel || designatedVisualModel;
        return model;
      });
    }

    return tree.data;
  };

  TreemapSeriesModel.prototype.optionUpdated = function () {
    this.resetViewRoot();
  };
  /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */


  TreemapSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var name = data.getName(dataIndex);
    return createTooltipMarkup('nameValue', {
      name: name,
      value: value
    });
  };
  /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */


  TreemapSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treeAncestors = wrapTreePathInfo(node, this); // compatitable the previous code.

    params.treePathInfo = params.treeAncestors;
    return params;
  };
  /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */


  TreemapSeriesModel.prototype.setLayoutInfo = function (layoutInfo) {
    /**
     * @readOnly
     * @type {Object}
     */
    this.layoutInfo = this.layoutInfo || {};
    extend(this.layoutInfo, layoutInfo);
  };
  /**
   * @param  {string} id
   * @return {number} index
   */


  TreemapSeriesModel.prototype.mapIdToIndex = function (id) {
    // A feature is implemented:
    // index is monotone increasing with the sequence of
    // input id at the first time.
    // This feature can make sure that each data item and its
    // mapped color have the same index between data list and
    // color list at the beginning, which is useful for user
    // to adjust data-color mapping.

    /**
     * @private
     * @type {Object}
     */
    var idIndexMap = this._idIndexMap;

    if (!idIndexMap) {
      idIndexMap = this._idIndexMap = createHashMap();
      /**
       * @private
       * @type {number}
       */

      this._idIndexMapCount = 0;
    }

    var index = idIndexMap.get(id);

    if (index == null) {
      idIndexMap.set(id, index = this._idIndexMapCount++);
    }

    return index;
  };

  TreemapSeriesModel.prototype.getViewRoot = function () {
    return this._viewRoot;
  };

  TreemapSeriesModel.prototype.resetViewRoot = function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  };

  TreemapSeriesModel.prototype.enableAriaDecal = function () {
    enableAriaDecalForTree(this);
  };

  TreemapSeriesModel.type = 'series.treemap';
  TreemapSeriesModel.layoutMode = 'box';
  TreemapSeriesModel.defaultOption = {
    // Disable progressive rendering
    progressive: 0,
    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
    left: 'center',
    top: 'middle',
    width: '80%',
    height: '80%',
    sort: true,
    clipWindow: 'origin',
    squareRatio: 0.5 * (1 + Math.sqrt(5)),
    leafDepth: null,
    drillDownIcon: '▶',
    // to align specialized icon. ▷▶❒❐▼✚
    zoomToNodeRatio: 0.32 * 0.32,
    roam: true,
    nodeClick: 'zoomToNode',
    animation: true,
    animationDurationUpdate: 900,
    animationEasing: 'quinticInOut',
    breadcrumb: {
      show: true,
      height: 22,
      left: 'center',
      top: 'bottom',
      // right
      // bottom
      emptyItemWidth: 25,
      itemStyle: {
        color: 'rgba(0,0,0,0.7)',
        textStyle: {
          color: '#fff'
        }
      },
      emphasis: {
        itemStyle: {
          color: 'rgba(0,0,0,0.9)' // '#5793f3',

        }
      }
    },
    label: {
      show: true,
      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
      distance: 0,
      padding: 5,
      position: 'inside',
      // formatter: null,
      color: '#fff',
      overflow: 'truncate' // align
      // verticalAlign

    },
    upperLabel: {
      show: false,
      position: [0, '50%'],
      height: 20,
      // formatter: null,
      // color: '#fff',
      overflow: 'truncate',
      // align: null,
      verticalAlign: 'middle'
    },
    itemStyle: {
      color: null,
      colorAlpha: null,
      colorSaturation: null,
      borderWidth: 0,
      gapWidth: 0,
      borderColor: '#fff',
      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
      // border color is evaluated by color of current node and
      // borderColorSaturation.

    },
    emphasis: {
      upperLabel: {
        show: true,
        position: [0, '50%'],
        overflow: 'truncate',
        verticalAlign: 'middle'
      }
    },
    visualDimension: 0,
    visualMin: null,
    visualMax: null,
    color: [],
    // level[n].color (if necessary).
    // + Specify color list of each level. level[0].color would be global
    // color list if not specified. (see method `setDefault`).
    // + But set as a empty array to forbid fetch color from global palette
    // when using nodeModel.get('color'), otherwise nodes on deep level
    // will always has color palette set and are not able to inherit color
    // from parent node.
    // + TreemapSeries.color can not be set as 'none', otherwise effect
    // legend color fetching (see seriesColor.js).
    colorAlpha: null,
    colorSaturation: null,
    colorMappingBy: 'index',
    visibleMin: 10,
    // be rendered. Only works when sort is 'asc' or 'desc'.
    childrenVisibleMin: null,
    // grandchildren will not show.
    // Why grandchildren? If not grandchildren but children,
    // some siblings show children and some not,
    // the appearance may be mess and not consistent,
    levels: [] // Each item: {
    //     visibleMin, itemStyle, visualDimension, label
    // }

  };
  return TreemapSeriesModel;
}(SeriesModel);
/**
 * @param {Object} dataNode
 */


function completeTreeValue(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  each(dataNode.children, function (child) {
    completeTreeValue(child);
    var childValue = child.value;
    isArray$1(childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (isArray$1(thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  isArray$1(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */


function setDefault(levels, ecModel) {
  var globalColorList = normalizeToArray(ecModel.get('color'));
  var globalDecalList = normalizeToArray(ecModel.get(['aria', 'decal', 'decals']));

  if (!globalColorList) {
    return;
  }

  levels = levels || [];
  var hasColorDefine;
  var hasDecalDefine;
  each(levels, function (levelDefine) {
    var model = new Model(levelDefine);
    var modelColor = model.get('color');
    var modelDecal = model.get('decal');

    if (model.get(['itemStyle', 'color']) || modelColor && modelColor !== 'none') {
      hasColorDefine = true;
    }

    if (model.get(['itemStyle', 'decal']) || modelDecal && modelDecal !== 'none') {
      hasDecalDefine = true;
    }
  });
  var level0 = levels[0] || (levels[0] = {});

  if (!hasColorDefine) {
    level0.color = globalColorList.slice();
  }

  if (!hasDecalDefine && globalDecalList) {
    level0.decal = globalDecalList.slice();
  }

  return levels;
}

var TEXT_PADDING = 8;
var ITEM_GAP = 8;
var ARRAY_LENGTH = 5;

var Breadcrumb =
/** @class */
function () {
  function Breadcrumb(containerGroup) {
    this.group = new Group$1();
    containerGroup.add(this.group);
  }

  Breadcrumb.prototype.render = function (seriesModel, api, targetNode, onSelect) {
    var model = seriesModel.getModel('breadcrumb');
    var thisGroup = this.group;
    thisGroup.removeAll();

    if (!model.get('show') || !targetNode) {
      return;
    }

    var normalStyleModel = model.getModel('itemStyle');
    var emphasisModel = model.getModel('emphasis');
    var textStyleModel = normalStyleModel.getModel('textStyle');
    var emphasisTextStyleModel = emphasisModel.getModel(['itemStyle', 'textStyle']);
    var layoutParam = {
      pos: {
        left: model.get('left'),
        right: model.get('right'),
        top: model.get('top'),
        bottom: model.get('bottom')
      },
      box: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      emptyItemWidth: model.get('emptyItemWidth'),
      totalWidth: 0,
      renderList: []
    };

    this._prepare(targetNode, layoutParam, textStyleModel);

    this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);

    positionElement(thisGroup, layoutParam.pos, layoutParam.box);
  };
  /**
   * Prepare render list and total width
   * @private
   */


  Breadcrumb.prototype._prepare = function (targetNode, layoutParam, textStyleModel) {
    for (var node = targetNode; node; node = node.parentNode) {
      var text = convertOptionIdName(node.getModel().get('name'), '');
      var textRect = textStyleModel.getTextRect(text);
      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
      layoutParam.totalWidth += itemWidth + ITEM_GAP;
      layoutParam.renderList.push({
        node: node,
        text: text,
        width: itemWidth
      });
    }
  };
  /**
   * @private
   */


  Breadcrumb.prototype._renderContent = function (seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
    // Start rendering.
    var lastX = 0;
    var emptyItemWidth = layoutParam.emptyItemWidth;
    var height = seriesModel.get(['breadcrumb', 'height']);
    var availableSize = getAvailableSize(layoutParam.pos, layoutParam.box);
    var totalWidth = layoutParam.totalWidth;
    var renderList = layoutParam.renderList;
    var emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();

    for (var i = renderList.length - 1; i >= 0; i--) {
      var item = renderList[i];
      var itemNode = item.node;
      var itemWidth = item.width;
      var text = item.text; // Hdie text and shorten width if necessary.

      if (totalWidth > availableSize.width) {
        totalWidth -= itemWidth - emptyItemWidth;
        itemWidth = emptyItemWidth;
        text = null;
      }

      var el = new Polygon({
        shape: {
          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
        },
        style: defaults(normalStyleModel.getItemStyle(), {
          lineJoin: 'bevel'
        }),
        textContent: new ZRText({
          style: createTextStyle(textStyleModel, {
            text: text
          })
        }),
        textConfig: {
          position: 'inside'
        },
        z2: Z2_EMPHASIS_LIFT * 1e4,
        onclick: curry(onSelect, itemNode)
      });
      el.disableLabelAnimation = true;
      el.getTextContent().ensureState('emphasis').style = createTextStyle(emphasisTextStyleModel, {
        text: text
      });
      el.ensureState('emphasis').style = emphasisItemStyle;
      toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
      this.group.add(el);
      packEventData(el, seriesModel, itemNode);
      lastX += itemWidth + ITEM_GAP;
    }
  };

  Breadcrumb.prototype.remove = function () {
    this.group.removeAll();
  };

  return Breadcrumb;
}();

function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
  !head && points.push([x, y + itemHeight / 2]);
  return points;
} // Package custom mouse event.


function packEventData(el, seriesModel, itemNode) {
  getECData(el).eventData = {
    componentType: 'series',
    componentSubType: 'treemap',
    componentIndex: seriesModel.componentIndex,
    seriesIndex: seriesModel.seriesIndex,
    seriesName: seriesModel.name,
    seriesType: 'treemap',
    selfType: 'breadcrumb',
    nodeData: {
      dataIndex: itemNode && itemNode.dataIndex,
      name: itemNode && itemNode.name
    },
    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
  };
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */
var AnimationWrap =
/** @class */
function () {
  function AnimationWrap() {
    this._storage = [];
    this._elExistsMap = {};
  }
  /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */


  AnimationWrap.prototype.add = function (el, target, duration, delay, easing) {
    if (this._elExistsMap[el.id]) {
      return false;
    }

    this._elExistsMap[el.id] = true;

    this._storage.push({
      el: el,
      target: target,
      duration: duration,
      delay: delay,
      easing: easing
    });

    return true;
  };
  /**
   * Only execute when animation done/aborted.
   */


  AnimationWrap.prototype.finished = function (callback) {
    this._finishedCallback = callback;
    return this;
  };
  /**
   * Will stop exist animation firstly.
   */


  AnimationWrap.prototype.start = function () {
    var _this = this;

    var count = this._storage.length;

    var checkTerminate = function () {
      count--;

      if (count <= 0) {
        // Guard.
        _this._storage.length = 0;
        _this._elExistsMap = {};
        _this._finishedCallback && _this._finishedCallback();
      }
    };

    for (var i = 0, len = this._storage.length; i < len; i++) {
      var item = this._storage[i];
      item.el.animateTo(item.target, {
        duration: item.duration,
        delay: item.delay,
        easing: item.easing,
        setToFinal: true,
        done: checkTerminate,
        aborted: checkTerminate
      });
    }

    return this;
  };

  return AnimationWrap;
}();

function createWrap() {
  return new AnimationWrap();
}

var Group$2 = Group$1;
var Rect$1 = Rect;
var DRAG_THRESHOLD = 3;
var PATH_LABEL_NOAMAL = 'label';
var PATH_UPPERLABEL_NORMAL = 'upperLabel'; // Should larger than emphasis states lift z

var Z2_BASE = Z2_EMPHASIS_LIFT * 10; // Should bigger than every z2.

var Z2_BG = Z2_EMPHASIS_LIFT * 2;
var Z2_CONTENT = Z2_EMPHASIS_LIFT * 3;
var getStateItemStyle = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
// so use `stroke` to indicate the stroke of the rect.
['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
// So do not transfer decal directly.
]);

var getItemStyleNormal = function (model) {
  // Normal style props should include emphasis style props.
  var itemStyle = getStateItemStyle(model); // Clear styles set by emphasis.

  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
  return itemStyle;
};

var inner$9 = makeInner();

var TreemapView =
/** @class */
function (_super) {
  __extends$1(TreemapView, _super);

  function TreemapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TreemapView.type;
    _this._state = 'ready';
    _this._storage = createStorage();
    return _this;
  }
  /**
   * @override
   */


  TreemapView.prototype.render = function (seriesModel, ecModel, api, payload) {
    var models = ecModel.findComponents({
      mainType: 'series',
      subType: 'treemap',
      query: payload
    });

    if (indexOf(models, seriesModel) < 0) {
      return;
    }

    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = retrieveTargetInfo(payload, types, seriesModel);
    var payloadType = payload && payload.type;
    var layoutInfo = seriesModel.layoutInfo;
    var isInit = !this._oldTree;
    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.

    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
      direction: payload.direction
    } : null;

    var containerGroup = this._giveContainerGroup(layoutInfo);

    var hasAnimation = seriesModel.get('animation');

    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);

    hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();

    this._resetController(api);

    this._renderBreadcrumb(seriesModel, api, targetInfo);
  };

  TreemapView.prototype._giveContainerGroup = function (layoutInfo) {
    var containerGroup = this._containerGroup;

    if (!containerGroup) {
      // FIXME
      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
      containerGroup = this._containerGroup = new Group$2();

      this._initEvents(containerGroup);

      this.group.add(containerGroup);
    }

    containerGroup.x = layoutInfo.x;
    containerGroup.y = layoutInfo.y;
    return containerGroup;
  };

  TreemapView.prototype._doRender = function (containerGroup, seriesModel, reRoot) {
    var thisTree = seriesModel.getData().tree;
    var oldTree = this._oldTree; // Clear last shape records.

    var lastsForAnimation = createStorage();
    var thisStorage = createStorage();
    var oldStorage = this._storage;
    var willInvisibleEls = [];

    function doRenderNode(thisNode, oldNode, parentGroup, depth) {
      return renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
    } // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
    // the oldTree is actually losted, so we cannot find all of the old graphic
    // elements from tree. So we use this strategy: make element storage, move
    // from old storage to new storage, clear old storage.


    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.

    var willDeleteEls = clearStorage(oldStorage);
    this._oldTree = thisTree;
    this._storage = thisStorage;
    return {
      lastsForAnimation: lastsForAnimation,
      willDeleteEls: willDeleteEls,
      renderFinally: renderFinally
    };

    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
      // When 'render' is triggered by action,
      // 'this' and 'old' may be the same tree,
      // we use rawIndex in that case.
      if (sameTree) {
        oldViewChildren = thisViewChildren;
        each(thisViewChildren, function (child, index) {
          !child.isRemoved() && processNode(index, index);
        });
      } // Diff hierarchically (diff only in each subtree, but not whole).
      // because, consistency of view is important.
      else {
          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(curry(processNode, null)).execute();
        }

      function getKey(node) {
        // Identify by name or raw index.
        return node.getId();
      }

      function processNode(newIndex, oldIndex) {
        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
      }
    }

    function clearStorage(storage) {
      var willDeleteEls = createStorage();
      storage && each(storage, function (store, storageName) {
        var delEls = willDeleteEls[storageName];
        each(store, function (el) {
          el && (delEls.push(el), inner$9(el).willDelete = true);
        });
      });
      return willDeleteEls;
    }

    function renderFinally() {
      each(willDeleteEls, function (els) {
        each(els, function (el) {
          el.parent && el.parent.remove(el);
        });
      });
      each(willInvisibleEls, function (el) {
        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
        // just mark as invisible.

        el.dirty();
      });
    }
  };

  TreemapView.prototype._doAnimation = function (containerGroup, renderResult, seriesModel, reRoot) {
    var durationOption = seriesModel.get('animationDurationUpdate');
    var easingOption = seriesModel.get('animationEasing'); // TODO: do not support function until necessary.

    var duration = (isFunction$3(durationOption) ? 0 : durationOption) || 0;
    var easing = (isFunction$3(easingOption) ? null : easingOption) || 'cubicOut';
    var animationWrap = createWrap(); // Make delete animations.

    each(renderResult.willDeleteEls, function (store, storageName) {
      each(store, function (el, rawIndex) {
        if (el.invisible) {
          return;
        }

        var parent = el.parent; // Always has parent, and parent is nodeGroup.

        var target;
        var innerStore = inner$9(parent);

        if (reRoot && reRoot.direction === 'drillDown') {
          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
          // Only `content` will enter this branch, because
          // `background` and `nodeGroup` will not be deleted.
          ? {
            shape: {
              x: 0,
              y: 0,
              width: innerStore.nodeWidth,
              height: innerStore.nodeHeight
            },
            style: {
              opacity: 0
            }
          } // Others.
          : {
            style: {
              opacity: 0
            }
          };
        } else {
          var targetX = 0;
          var targetY = 0;

          if (!innerStore.willDelete) {
            // Let node animate to right-bottom corner, cooperating with fadeout,
            // which is appropriate for user understanding.
            // Divided by 2 for reRoot rolling up effect.
            targetX = innerStore.nodeWidth / 2;
            targetY = innerStore.nodeHeight / 2;
          }

          target = storageName === 'nodeGroup' ? {
            x: targetX,
            y: targetY,
            style: {
              opacity: 0
            }
          } : {
            shape: {
              x: targetX,
              y: targetY,
              width: 0,
              height: 0
            },
            style: {
              opacity: 0
            }
          };
        } // TODO: do not support delay until necessary.


        target && animationWrap.add(el, target, duration, 0, easing);
      });
    }); // Make other animations

    each(this._storage, function (store, storageName) {
      each(store, function (el, rawIndex) {
        var last = renderResult.lastsForAnimation[storageName][rawIndex];
        var target = {};

        if (!last) {
          return;
        }

        if (el instanceof Group$1) {
          if (last.oldX != null) {
            target.x = el.x;
            target.y = el.y;
            el.x = last.oldX;
            el.y = last.oldY;
          }
        } else {
          if (last.oldShape) {
            target.shape = extend({}, el.shape);
            el.setShape(last.oldShape);
          }

          if (last.fadein) {
            el.setStyle('opacity', 0);
            target.style = {
              opacity: 1
            };
          } // When animation is stopped for succedent animation starting,
          // el.style.opacity might not be 1
          else if (el.style.opacity !== 1) {
              target.style = {
                opacity: 1
              };
            }
        }

        animationWrap.add(el, target, duration, 0, easing);
      });
    }, this);
    this._state = 'animating';
    animationWrap.finished(bind(function () {
      this._state = 'ready';
      renderResult.renderFinally();
    }, this)).start();
  };

  TreemapView.prototype._resetController = function (api) {
    var controller = this._controller; // Init controller.

    if (!controller) {
      controller = this._controller = new RoamController(api.getZr());
      controller.enable(this.seriesModel.get('roam'));
      controller.on('pan', bind(this._onPan, this));
      controller.on('zoom', bind(this._onZoom, this));
    }

    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
    controller.setPointerChecker(function (e, x, y) {
      return rect.contain(x, y);
    });
  };

  TreemapView.prototype._clearController = function () {
    var controller = this._controller;

    if (controller) {
      controller.dispose();
      controller = null;
    }
  };

  TreemapView.prototype._onPan = function (e) {
    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      this.api.dispatchAction({
        type: 'treemapMove',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rootLayout.x + e.dx,
          y: rootLayout.y + e.dy,
          width: rootLayout.width,
          height: rootLayout.height
        }
      });
    }
  };

  TreemapView.prototype._onZoom = function (e) {
    var mouseX = e.originX;
    var mouseY = e.originY;

    if (this._state !== 'animating') {
      // These param must not be cached.
      var root = this.seriesModel.getData().tree.root;

      if (!root) {
        return;
      }

      var rootLayout = root.getLayout();

      if (!rootLayout) {
        return;
      }

      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.

      mouseX -= layoutInfo.x;
      mouseY -= layoutInfo.y; // Scale root bounding rect.

      var m = create$1();
      translate(m, m, [-mouseX, -mouseY]);
      scale$1(m, m, [e.scale, e.scale]);
      translate(m, m, [mouseX, mouseY]);
      rect.applyTransform(m);
      this.api.dispatchAction({
        type: 'treemapRender',
        from: this.uid,
        seriesId: this.seriesModel.id,
        rootRect: {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        }
      });
    }
  };

  TreemapView.prototype._initEvents = function (containerGroup) {
    var _this = this;

    containerGroup.on('click', function (e) {
      if (_this._state !== 'ready') {
        return;
      }

      var nodeClick = _this.seriesModel.get('nodeClick', true);

      if (!nodeClick) {
        return;
      }

      var targetInfo = _this.findTarget(e.offsetX, e.offsetY);

      if (!targetInfo) {
        return;
      }

      var node = targetInfo.node;

      if (node.getLayout().isLeafRoot) {
        _this._rootToNode(targetInfo);
      } else {
        if (nodeClick === 'zoomToNode') {
          _this._zoomToNode(targetInfo);
        } else if (nodeClick === 'link') {
          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
          var link = itemModel.get('link', true);
          var linkTarget = itemModel.get('target', true) || 'blank';
          link && windowOpen(link, linkTarget);
        }
      }
    }, this);
  };

  TreemapView.prototype._renderBreadcrumb = function (seriesModel, api, targetInfo) {
    var _this = this;

    if (!targetInfo) {
      targetInfo = seriesModel.get('leafDepth', true) != null ? {
        node: seriesModel.getViewRoot()
      } // FIXME
      // better way?
      // Find breadcrumb tail on center of containerGroup.
      : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);

      if (!targetInfo) {
        targetInfo = {
          node: seriesModel.getData().tree.root
        };
      }
    }

    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, function (node) {
      if (_this._state !== 'animating') {
        aboveViewRoot(seriesModel.getViewRoot(), node) ? _this._rootToNode({
          node: node
        }) : _this._zoomToNode({
          node: node
        });
      }
    });
  };
  /**
   * @override
   */


  TreemapView.prototype.remove = function () {
    this._clearController();

    this._containerGroup && this._containerGroup.removeAll();
    this._storage = createStorage();
    this._state = 'ready';
    this._breadcrumb && this._breadcrumb.remove();
  };

  TreemapView.prototype.dispose = function () {
    this._clearController();
  };

  TreemapView.prototype._zoomToNode = function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapZoomToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  };

  TreemapView.prototype._rootToNode = function (targetInfo) {
    this.api.dispatchAction({
      type: 'treemapRootToNode',
      from: this.uid,
      seriesId: this.seriesModel.id,
      targetNode: targetInfo.node
    });
  };
  /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */


  TreemapView.prototype.findTarget = function (x, y) {
    var targetInfo;
    var viewRoot = this.seriesModel.getViewRoot();
    viewRoot.eachNode({
      attr: 'viewChildren',
      order: 'preorder'
    }, function (node) {
      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.


      if (bgEl) {
        var point = bgEl.transformCoordToLocal(x, y);
        var shape = bgEl.shape; // For performance consideration, don't use 'getBoundingRect'.

        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
          targetInfo = {
            node: node,
            offsetX: point[0],
            offsetY: point[1]
          };
        } else {
          return false; // Suppress visit subtree.
        }
      }
    }, this);
    return targetInfo;
  };

  TreemapView.type = 'treemap';
  return TreemapView;
}(ChartView);
/**
 * @inner
 */


function createStorage() {
  return {
    nodeGroup: [],
    background: [],
    content: []
  };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */


function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
  // Whether under viewRoot.
  if (!thisNode) {
    // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
  } // -------------------------------------------------------------------
  // Start of closure variables available in "Procedures in renderNode".


  var thisLayout = thisNode.getLayout();
  var data = seriesModel.getData();
  var nodeModel = thisNode.getModel(); // Only for enabling highlight/downplay. Clear firstly.
  // Because some node will not be rendered.

  data.setItemGraphicEl(thisNode.dataIndex, null);

  if (!thisLayout || !thisLayout.isInView) {
    return;
  }

  var thisWidth = thisLayout.width;
  var thisHeight = thisLayout.height;
  var borderWidth = thisLayout.borderWidth;
  var thisInvisible = thisLayout.invisible;
  var thisRawIndex = thisNode.getRawIndex();
  var oldRawIndex = oldNode && oldNode.getRawIndex();
  var thisViewChildren = thisNode.viewChildren;
  var upperHeight = thisLayout.upperHeight;
  var isParent = thisViewChildren && thisViewChildren.length;
  var itemStyleNormalModel = nodeModel.getModel('itemStyle');
  var itemStyleEmphasisModel = nodeModel.getModel(['emphasis', 'itemStyle']);
  var itemStyleBlurModel = nodeModel.getModel(['blur', 'itemStyle']);
  var itemStyleSelectModel = nodeModel.getModel(['select', 'itemStyle']);
  var borderRadius = itemStyleNormalModel.get('borderRadius') || 0; // End of closure ariables available in "Procedures in renderNode".
  // -----------------------------------------------------------------
  // Node group

  var group = giveGraphic('nodeGroup', Group$2);

  if (!group) {
    return;
  }

  parentGroup.add(group); // x,y are not set when el is above view root.

  group.x = thisLayout.x || 0;
  group.y = thisLayout.y || 0;
  group.markRedraw();
  inner$9(group).nodeWidth = thisWidth;
  inner$9(group).nodeHeight = thisHeight;

  if (thisLayout.isAboveViewRoot) {
    return group;
  } // Background


  var bg = giveGraphic('background', Rect$1, depth, Z2_BG);
  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
  var emphasisModel = nodeModel.getModel('emphasis');
  var focus = emphasisModel.get('focus');
  var blurScope = emphasisModel.get('blurScope');
  var isDisabled = emphasisModel.get('disabled');
  var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus; // No children, render content.

  if (isParent) {
    // Because of the implementation about "traverse" in graphic hover style, we
    // can not set hover listener on the "group" of non-leaf node. Otherwise the
    // hover event from the descendents will be listenered.
    if (isHighDownDispatcher(group)) {
      setAsHighDownDispatcher(group, false);
    }

    if (bg) {
      setAsHighDownDispatcher(bg, !isDisabled); // Only for enabling highlight/downplay.

      data.setItemGraphicEl(thisNode.dataIndex, bg);
      enableHoverFocus(bg, focusOrIndices, blurScope);
    }
  } else {
    var content = giveGraphic('content', Rect$1, depth, Z2_CONTENT);
    content && renderContent(group, content);
    bg.disableMorphing = true;

    if (bg && isHighDownDispatcher(bg)) {
      setAsHighDownDispatcher(bg, false);
    }

    setAsHighDownDispatcher(group, !isDisabled); // Only for enabling highlight/downplay.

    data.setItemGraphicEl(thisNode.dataIndex, group);
    enableHoverFocus(group, focusOrIndices, blurScope);
  }

  return group; // ----------------------------
  // | Procedures in renderNode |
  // ----------------------------

  function renderBackground(group, bg, useUpperLabel) {
    var ecData = getECData(bg); // For tooltip.

    ecData.dataIndex = thisNode.dataIndex;
    ecData.seriesIndex = seriesModel.seriesIndex;
    bg.setShape({
      x: 0,
      y: 0,
      width: thisWidth,
      height: thisHeight,
      r: borderRadius
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(bg);
    } else {
      bg.invisible = false;
      var style = thisNode.getVisual('style');
      var visualBorderColor = style.stroke;
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualBorderColor;
      var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
      emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
      var blurStyle = getStateItemStyle(itemStyleBlurModel);
      blurStyle.fill = itemStyleBlurModel.get('borderColor');
      var selectStyle = getStateItemStyle(itemStyleSelectModel);
      selectStyle.fill = itemStyleSelectModel.get('borderColor');

      if (useUpperLabel) {
        var upperLabelWidth = thisWidth - 2 * borderWidth;
        prepareText( // PENDING: convert ZRColor to ColorString for text.
        bg, visualBorderColor, style.opacity, {
          x: borderWidth,
          y: 0,
          width: upperLabelWidth,
          height: upperHeight
        });
      } // For old bg.
      else {
          bg.removeTextContent();
        }

      bg.setStyle(normalStyle);
      bg.ensureState('emphasis').style = emphasisStyle;
      bg.ensureState('blur').style = blurStyle;
      bg.ensureState('select').style = selectStyle;
      setDefaultStateProxy(bg);
    }

    group.add(bg);
  }

  function renderContent(group, content) {
    var ecData = getECData(content); // For tooltip.

    ecData.dataIndex = thisNode.dataIndex;
    ecData.seriesIndex = seriesModel.seriesIndex;
    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
    content.culling = true;
    content.setShape({
      x: borderWidth,
      y: borderWidth,
      width: contentWidth,
      height: contentHeight,
      r: borderRadius
    });

    if (thisInvisible) {
      // If invisible, do not set visual, otherwise the element will
      // change immediately before animation. We think it is OK to
      // remain its origin color when moving out of the view window.
      processInvisible(content);
    } else {
      content.invisible = false;
      var nodeStyle = thisNode.getVisual('style');
      var visualColor = nodeStyle.fill;
      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
      normalStyle.fill = visualColor;
      normalStyle.decal = nodeStyle.decal;
      var emphasisStyle = getStateItemStyle(itemStyleEmphasisModel);
      var blurStyle = getStateItemStyle(itemStyleBlurModel);
      var selectStyle = getStateItemStyle(itemStyleSelectModel); // PENDING: convert ZRColor to ColorString for text.

      prepareText(content, visualColor, nodeStyle.opacity, null);
      content.setStyle(normalStyle);
      content.ensureState('emphasis').style = emphasisStyle;
      content.ensureState('blur').style = blurStyle;
      content.ensureState('select').style = selectStyle;
      setDefaultStateProxy(content);
    }

    group.add(content);
  }

  function processInvisible(element) {
    // Delay invisible setting utill animation finished,
    // avoid element vanish suddenly before animation.
    !element.invisible && willInvisibleEls.push(element);
  }

  function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
  upperLabelRect) {
    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
    var defaultText = convertOptionIdName(nodeModel.get('name'), null);
    var isShow = normalLabelModel.getShallow('show');
    setLabelStyle(rectEl, getLabelStatesModels(nodeModel, upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL), {
      defaultText: isShow ? defaultText : null,
      inheritColor: visualColor,
      defaultOpacity: visualOpacity,
      labelFetcher: seriesModel,
      labelDataIndex: thisNode.dataIndex
    });
    var textEl = rectEl.getTextContent();

    if (!textEl) {
      return;
    }

    var textStyle = textEl.style;
    var textPadding = normalizeCssArray(textStyle.padding || 0);

    if (upperLabelRect) {
      rectEl.setTextConfig({
        layoutRect: upperLabelRect
      });
      textEl.disableLabelLayout = true;
    }

    textEl.beforeUpdate = function () {
      var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
      var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);

      if (textStyle.width !== width || textStyle.height !== height) {
        textEl.setStyle({
          width: width,
          height: height
        });
      }
    };

    textStyle.truncateMinChar = 2;
    textStyle.lineOverflow = 'truncate';
    addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
    var textEmphasisState = textEl.getState('emphasis');
    addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
  }

  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
    var text = style ? style.text : null;

    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
      var iconChar = seriesModel.get('drillDownIcon', true);
      style.text = iconChar ? iconChar + ' ' + text : text;
    }
  }

  function giveGraphic(storageName, Ctor, depth, z) {
    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
    var lasts = lastsForAnimation[storageName];

    if (element) {
      // Remove from oldStorage
      oldStorage[storageName][oldRawIndex] = null;
      prepareAnimationWhenHasOld(lasts, element);
    } // If invisible and no old element, do not create new element (for optimizing).
    else if (!thisInvisible) {
        element = new Ctor();

        if (element instanceof Displayable) {
          element.z2 = calculateZ2(depth, z);
        }

        prepareAnimationWhenNoOld(lasts, element);
      } // Set to thisStorage


    return thisStorage[storageName][thisRawIndex] = element;
  }

  function prepareAnimationWhenHasOld(lasts, element) {
    var lastCfg = lasts[thisRawIndex] = {};

    if (element instanceof Group$2) {
      lastCfg.oldX = element.x;
      lastCfg.oldY = element.y;
    } else {
      lastCfg.oldShape = extend({}, element.shape);
    }
  } // If a element is new, we need to find the animation start point carefully,
  // otherwise it will looks strange when 'zoomToNode'.


  function prepareAnimationWhenNoOld(lasts, element) {
    var lastCfg = lasts[thisRawIndex] = {};
    var parentNode = thisNode.parentNode;
    var isGroup = element instanceof Group$1;

    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
      var parentOldX = 0;
      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
      // For convenience, get old bounding rect from background.

      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];

      if (!reRoot && parentOldBg && parentOldBg.oldShape) {
        parentOldX = parentOldBg.oldShape.width;
        parentOldY = parentOldBg.oldShape.height;
      } // When no parent old shape found, its parent is new too,
      // so we can just use {x:0, y:0}.


      if (isGroup) {
        lastCfg.oldX = 0;
        lastCfg.oldY = parentOldY;
      } else {
        lastCfg.oldShape = {
          x: parentOldX,
          y: parentOldY,
          width: 0,
          height: 0
        };
      }
    } // Fade in, user can be aware that these nodes are new.


    lastCfg.fadein = !isGroup;
  }
} // We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.


function calculateZ2(depth, z2InLevel) {
  return depth * Z2_BASE + z2InLevel;
}

var each$3 = each;
var isObject$5 = isObject$2;
var CATEGORY_DEFAULT_VISUAL_INDEX = -1;

var VisualMapping =
/** @class */
function () {
  function VisualMapping(option) {
    var mappingMethod = option.mappingMethod;
    var visualType = option.type;
    var thisOption = this.option = clone(option);
    this.type = visualType;
    this.mappingMethod = mappingMethod;
    this._normalizeData = normalizers[mappingMethod];
    var visualHandler = VisualMapping.visualHandlers[visualType];
    this.applyVisual = visualHandler.applyVisual;
    this.getColorMapper = visualHandler.getColorMapper;
    this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];

    if (mappingMethod === 'piecewise') {
      normalizeVisualRange(thisOption);
      preprocessForPiecewise(thisOption);
    } else if (mappingMethod === 'category') {
      thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
      // which need no more preprocess except normalize visual.
      : normalizeVisualRange(thisOption, true);
    } else {
      // mappingMethod === 'linear' or 'fixed'
      assert(mappingMethod !== 'linear' || thisOption.dataExtent);
      normalizeVisualRange(thisOption);
    }
  }

  VisualMapping.prototype.mapValueToVisual = function (value) {
    var normalized = this._normalizeData(value);

    return this._normalizedToVisual(normalized, value);
  };

  VisualMapping.prototype.getNormalizer = function () {
    return bind(this._normalizeData, this);
  };
  /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */


  VisualMapping.listVisualTypes = function () {
    return keys$2(VisualMapping.visualHandlers);
  }; // /**
  //  * @public
  //  */
  // static addVisualHandler(name, handler) {
  //     visualHandlers[name] = handler;
  // }

  /**
   * @public
   */


  VisualMapping.isValidType = function (visualType) {
    return VisualMapping.visualHandlers.hasOwnProperty(visualType);
  };
  /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */


  VisualMapping.eachVisual = function (visual, callback, context) {
    if (isObject$2(visual)) {
      each(visual, callback, context);
    } else {
      callback.call(context, visual);
    }
  };

  VisualMapping.mapVisual = function (visual, callback, context) {
    var isPrimary;
    var newVisual = isArray$1(visual) ? [] : isObject$2(visual) ? {} : (isPrimary = true, null);
    VisualMapping.eachVisual(visual, function (v, key) {
      var newVal = callback.call(context, v, key);
      isPrimary ? newVisual = newVal : newVisual[key] = newVal;
    });
    return newVisual;
  };
  /**
   * Retrieve visual properties from given object.
   */


  VisualMapping.retrieveVisuals = function (obj) {
    var ret = {};
    var hasVisual;
    obj && each$3(VisualMapping.visualHandlers, function (h, visualType) {
      if (obj.hasOwnProperty(visualType)) {
        ret[visualType] = obj[visualType];
        hasVisual = true;
      }
    });
    return hasVisual ? ret : null;
  };
  /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */


  VisualMapping.prepareVisualTypes = function (visualTypes) {
    if (isArray$1(visualTypes)) {
      visualTypes = visualTypes.slice();
    } else if (isObject$5(visualTypes)) {
      var types_1 = [];
      each$3(visualTypes, function (item, type) {
        types_1.push(type);
      });
      visualTypes = types_1;
    } else {
      return [];
    }

    visualTypes.sort(function (type1, type2) {
      // color should be front of colorSaturation, colorAlpha, ...
      // symbol and symbolSize do not matter.
      return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
    });
    return visualTypes;
  };
  /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */


  VisualMapping.dependsOn = function (visualType1, visualType2) {
    return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
  };
  /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */


  VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
    var possibleI;
    var abs = Infinity; // value has the higher priority.

    for (var i = 0, len = pieceList.length; i < len; i++) {
      var pieceValue = pieceList[i].value;

      if (pieceValue != null) {
        if (pieceValue === value // FIXME
        // It is supposed to compare value according to value type of dimension,
        // but currently value type can exactly be string or number.
        // Compromise for numeric-like string (like '12'), especially
        // in the case that visualMap.categories is ['22', '33'].
        || isString(pieceValue) && pieceValue === value + '') {
          return i;
        }

        findClosestWhenOutside && updatePossible(pieceValue, i);
      }
    }

    for (var i = 0, len = pieceList.length; i < len; i++) {
      var piece = pieceList[i];
      var interval = piece.interval;
      var close_1 = piece.close;

      if (interval) {
        if (interval[0] === -Infinity) {
          if (littleThan(close_1[1], value, interval[1])) {
            return i;
          }
        } else if (interval[1] === Infinity) {
          if (littleThan(close_1[0], interval[0], value)) {
            return i;
          }
        } else if (littleThan(close_1[0], interval[0], value) && littleThan(close_1[1], value, interval[1])) {
          return i;
        }

        findClosestWhenOutside && updatePossible(interval[0], i);
        findClosestWhenOutside && updatePossible(interval[1], i);
      }
    }

    if (findClosestWhenOutside) {
      return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
    }

    function updatePossible(val, index) {
      var newAbs = Math.abs(val - value);

      if (newAbs < abs) {
        abs = newAbs;
        possibleI = index;
      }
    }
  };

  VisualMapping.visualHandlers = {
    color: {
      applyVisual: makeApplyVisual('color'),
      getColorMapper: function () {
        var thisOption = this.option;
        return bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
          !isNormalized && (value = this._normalizeData(value));
          return doMapCategory.call(this, value);
        } : function (value, isNormalized, out) {
          // If output rgb array
          // which will be much faster and useful in pixel manipulation
          var returnRGBArray = !!out;
          !isNormalized && (value = this._normalizeData(value));
          out = fastLerp(value, thisOption.parsedVisual, out);
          return returnRGBArray ? out : stringify(out, 'rgba');
        }, this);
      },
      _normalizedToVisual: {
        linear: function (normalized) {
          return stringify(fastLerp(normalized, this.option.parsedVisual), 'rgba');
        },
        category: doMapCategory,
        piecewise: function (normalized, value) {
          var result = getSpecifiedVisual.call(this, value);

          if (result == null) {
            result = stringify(fastLerp(normalized, this.option.parsedVisual), 'rgba');
          }

          return result;
        },
        fixed: doMapFixed
      }
    },
    colorHue: makePartialColorVisualHandler(function (color$1, value) {
      return modifyHSL(color$1, value);
    }),
    colorSaturation: makePartialColorVisualHandler(function (color$1, value) {
      return modifyHSL(color$1, null, value);
    }),
    colorLightness: makePartialColorVisualHandler(function (color$1, value) {
      return modifyHSL(color$1, null, null, value);
    }),
    colorAlpha: makePartialColorVisualHandler(function (color$1, value) {
      return modifyAlpha(color$1, value);
    }),
    decal: {
      applyVisual: makeApplyVisual('decal'),
      _normalizedToVisual: {
        linear: null,
        category: doMapCategory,
        piecewise: null,
        fixed: null
      }
    },
    opacity: {
      applyVisual: makeApplyVisual('opacity'),
      _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
    },
    liftZ: {
      applyVisual: makeApplyVisual('liftZ'),
      _normalizedToVisual: {
        linear: doMapFixed,
        category: doMapFixed,
        piecewise: doMapFixed,
        fixed: doMapFixed
      }
    },
    symbol: {
      applyVisual: function (value, getter, setter) {
        var symbolCfg = this.mapValueToVisual(value);
        setter('symbol', symbolCfg);
      },
      _normalizedToVisual: {
        linear: doMapToArray,
        category: doMapCategory,
        piecewise: function (normalized, value) {
          var result = getSpecifiedVisual.call(this, value);

          if (result == null) {
            result = doMapToArray.call(this, normalized);
          }

          return result;
        },
        fixed: doMapFixed
      }
    },
    symbolSize: {
      applyVisual: makeApplyVisual('symbolSize'),
      _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
    }
  };
  return VisualMapping;
}();

function preprocessForPiecewise(thisOption) {
  var pieceList = thisOption.pieceList;
  thisOption.hasSpecialVisual = false;
  each(pieceList, function (piece, index) {
    piece.originIndex = index; // piece.visual is "result visual value" but not
    // a visual range, so it does not need to be normalized.

    if (piece.visual != null) {
      thisOption.hasSpecialVisual = true;
    }
  });
}

function preprocessForSpecifiedCategory(thisOption) {
  // Hash categories.
  var categories = thisOption.categories;
  var categoryMap = thisOption.categoryMap = {};
  var visual = thisOption.visual;
  each$3(categories, function (cate, index) {
    categoryMap[cate] = index;
  }); // Process visual map input.

  if (!isArray$1(visual)) {
    var visualArr_1 = [];

    if (isObject$2(visual)) {
      each$3(visual, function (v, cate) {
        var index = categoryMap[cate];
        visualArr_1[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
      });
    } else {
      // Is primary type, represents default visual.
      visualArr_1[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
    }

    visual = setVisualToOption(thisOption, visualArr_1);
  } // Remove categories that has no visual,
  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.


  for (var i = categories.length - 1; i >= 0; i--) {
    if (visual[i] == null) {
      delete categoryMap[categories[i]];
      categories.pop();
    }
  }
}

function normalizeVisualRange(thisOption, isCategory) {
  var visual = thisOption.visual;
  var visualArr = [];

  if (isObject$2(visual)) {
    each$3(visual, function (v) {
      visualArr.push(v);
    });
  } else if (visual != null) {
    visualArr.push(visual);
  }

  var doNotNeedPair = {
    color: 1,
    symbol: 1
  };

  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
    // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
  }

  setVisualToOption(thisOption, visualArr);
}

function makePartialColorVisualHandler(applyValue) {
  return {
    applyVisual: function (value, getter, setter) {
      // Only used in HSL
      var colorChannel = this.mapValueToVisual(value); // Must not be array value

      setter('color', applyValue(getter('color'), colorChannel));
    },
    _normalizedToVisual: createNormalizedToNumericVisual([0, 1])
  };
}

function doMapToArray(normalized) {
  var visual = this.option.visual;
  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {}; // TODO {}?
}

function makeApplyVisual(visualType) {
  return function (value, getter, setter) {
    setter(visualType, this.mapValueToVisual(value));
  };
}

function doMapCategory(normalized) {
  var visual = this.option.visual;
  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}

function doMapFixed() {
  // visual will be convert to array.
  return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */


function createNormalizedToNumericVisual(sourceExtent) {
  return {
    linear: function (normalized) {
      return linearMap(normalized, sourceExtent, this.option.visual, true);
    },
    category: doMapCategory,
    piecewise: function (normalized, value) {
      var result = getSpecifiedVisual.call(this, value);

      if (result == null) {
        result = linearMap(normalized, sourceExtent, this.option.visual, true);
      }

      return result;
    },
    fixed: doMapFixed
  };
}

function getSpecifiedVisual(value) {
  var thisOption = this.option;
  var pieceList = thisOption.pieceList;

  if (thisOption.hasSpecialVisual) {
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
    var piece = pieceList[pieceIndex];

    if (piece && piece.visual) {
      return piece.visual[this.type];
    }
  }
}

function setVisualToOption(thisOption, visualArr) {
  thisOption.visual = visualArr;

  if (thisOption.type === 'color') {
    thisOption.parsedVisual = map(visualArr, function (item) {
      var color$1 = parse(item);

      if (!color$1 && process.env.NODE_ENV !== 'production') {
        warn("'" + item + "' is an illegal color, fallback to '#000000'", true);
      }

      return color$1 || [0, 0, 0, 1];
    });
  }

  return visualArr;
}
/**
 * Normalizers by mapping methods.
 */


var normalizers = {
  linear: function (value) {
    return linearMap(value, this.option.dataExtent, [0, 1], true);
  },
  piecewise: function (value) {
    var pieceList = this.option.pieceList;
    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);

    if (pieceIndex != null) {
      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
    }
  },
  category: function (value) {
    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value

    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
  },
  fixed: noop$2
};

function littleThan(close, a, b) {
  return close ? a <= b : a < b;
}

var ITEM_STYLE_NORMAL = 'itemStyle';
var inner$a = makeInner();
var treemapVisual = {
  seriesType: 'treemap',
  reset: function (seriesModel) {
    var tree = seriesModel.getData().tree;
    var root = tree.root;

    if (root.isRemoved()) {
      return;
    }

    travelTree(root, // Visual should calculate from tree root but not view root.
    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
  }
};

function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
  var nodeModel = node.getModel();
  var nodeLayout = node.getLayout();
  var data = node.hostTree.data; // Optimize

  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
    return;
  }

  var nodeItemStyleModel = nodeModel.getModel(ITEM_STYLE_NORMAL);
  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
  var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style'); // calculate border color

  var borderColor = nodeItemStyleModel.get('borderColor');
  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
  var thisNodeColor;

  if (borderColorSaturation != null) {
    // For performance, do not always execute 'calculateColor'.
    thisNodeColor = calculateColor(visuals);
    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
  }

  existsStyle.stroke = borderColor;
  var viewChildren = node.viewChildren;

  if (!viewChildren || !viewChildren.length) {
    thisNodeColor = calculateColor(visuals); // Apply visual to this node.

    existsStyle.fill = thisNodeColor;
  } else {
    var mapping_1 = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.

    each(viewChildren, function (child, index) {
      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
        travelTree(child, childVisual, viewRootAncestors, seriesModel);
      }
    });
  }
}

function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
  var visuals = extend({}, designatedVisual);
  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
  each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
    var val = nodeItemStyleModel.get(visualName);
    designatedVisualItemStyle[visualName] = null;
    val != null && (visuals[visualName] = val);
  });
  return visuals;
}

function calculateColor(visuals) {
  var color = getValueVisualDefine(visuals, 'color');

  if (color) {
    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');

    if (colorSaturation) {
      color = modifyHSL(color, null, null, colorSaturation);
    }

    if (colorAlpha) {
      color = modifyAlpha(color, colorAlpha);
    }

    return color;
  }
}

function calculateBorderColor(borderColorSaturation, thisNodeColor) {
  return thisNodeColor != null // Can only be string
  ? modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
}

function getValueVisualDefine(visuals, name) {
  var value = visuals[name];

  if (value != null && value !== 'none') {
    return value;
  }
}

function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
  if (!viewChildren || !viewChildren.length) {
    return;
  }

  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));

  if (!rangeVisual) {
    return;
  }

  var visualMin = nodeModel.get('visualMin');
  var visualMax = nodeModel.get('visualMax');
  var dataExtent = nodeLayout.dataExtent.slice();
  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
  var colorMappingBy = nodeModel.get('colorMappingBy');
  var opt = {
    type: rangeVisual.name,
    dataExtent: dataExtent,
    visual: rangeVisual.range
  };

  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
    opt.mappingMethod = 'category';
    opt.loop = true; // categories is ordinal, so do not set opt.categories.
  } else {
    opt.mappingMethod = 'linear';
  }

  var mapping = new VisualMapping(opt);
  inner$a(mapping).drColorMappingBy = colorMappingBy;
  return mapping;
} // Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.


function getRangeVisual(nodeModel, name) {
  // 'colorRange', 'colorARange', 'colorSRange'.
  // If not exists on this node, fetch from levels and series.
  var range = nodeModel.get(name);
  return isArray$1(range) && range.length ? {
    name: name,
    range: range
  } : null;
}

function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
  var childVisuals = extend({}, visuals);

  if (mapping) {
    // Only support color, colorAlpha, colorSaturation.
    var mappingType = mapping.type;
    var colorMappingBy = mappingType === 'color' && inner$a(mapping).drColorMappingBy;
    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
    childVisuals[mappingType] = mapping.mapValueToVisual(value);
  }

  return childVisuals;
}

var mathMax$7 = Math.max;
var mathMin$7 = Math.min;
var retrieveValue = retrieve;
var each$4 = each;
var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
/**
 * @public
 */

var treemapLayout = {
  seriesType: 'treemap',
  reset: function (seriesModel, ecModel, api, payload) {
    // Layout result in each node:
    // {x, y, width, height, area, borderWidth}
    var ecWidth = api.getWidth();
    var ecHeight = api.getHeight();
    var seriesOption = seriesModel.option;
    var layoutInfo = getLayoutRect$1(seriesModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
    var size = seriesOption.size || []; // Compatible with ec2.

    var containerWidth = parsePercent$1(retrieveValue(layoutInfo.width, size[0]), ecWidth);
    var containerHeight = parsePercent$1(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.

    var payloadType = payload && payload.type;
    var types = ['treemapZoomToNode', 'treemapRootToNode'];
    var targetInfo = retrieveTargetInfo(payload, types, seriesModel);
    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
    var viewRoot = seriesModel.getViewRoot();
    var viewAbovePath = getPathToRoot(viewRoot);

    if (payloadType !== 'treemapMove') {
      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
      var sort_1 = seriesOption.sort;

      if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') {
        // Default to be desc order.
        sort_1 = 'desc';
      }

      var options = {
        squareRatio: seriesOption.squareRatio,
        sort: sort_1,
        leafDepth: seriesOption.leafDepth
      }; // layout should be cleared because using updateView but not update.

      viewRoot.hostTree.clearLayouts(); // TODO
      // optimize: if out of view clip, do not layout.
      // But take care that if do not render node out of view clip,
      // how to calculate start po

      var viewRootLayout_1 = {
        x: 0,
        y: 0,
        width: rootSize[0],
        height: rootSize[1],
        area: rootSize[0] * rootSize[1]
      };
      viewRoot.setLayout(viewRootLayout_1);
      squarify(viewRoot, options, false, 0); // Supplement layout.

      viewRootLayout_1 = viewRoot.getLayout();
      each$4(viewAbovePath, function (node, index) {
        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
        node.setLayout(extend({
          dataExtent: [childValue, childValue],
          borderWidth: 0,
          upperHeight: 0
        }, viewRootLayout_1));
      });
    }

    var treeRoot = seriesModel.getData().tree.root;
    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
    seriesModel.setLayoutInfo(layoutInfo); // FIXME
    // 现在没有clip功能，暂时取ec高宽。

    prunning(treeRoot, // Transform to base element coordinate system.
    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
  }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */

function squarify(node, options, hideChildren, depth) {
  var width;
  var height;

  if (node.isRemoved()) {
    return;
  }

  var thisLayout = node.getLayout();
  width = thisLayout.width;
  height = thisLayout.height; // Considering border and gap

  var nodeModel = node.getModel();
  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
  var upperLabelHeight = getUpperLabelHeight(nodeModel);
  var upperHeight = Math.max(borderWidth, upperLabelHeight);
  var layoutOffset = borderWidth - halfGapWidth;
  var layoutOffsetUpper = upperHeight - halfGapWidth;
  node.setLayout({
    borderWidth: borderWidth,
    upperHeight: upperHeight,
    upperLabelHeight: upperLabelHeight
  }, true);
  width = mathMax$7(width - 2 * layoutOffset, 0);
  height = mathMax$7(height - layoutOffset - layoutOffsetUpper, 0);
  var totalArea = width * height;
  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);

  if (!viewChildren.length) {
    return;
  }

  var rect = {
    x: layoutOffset,
    y: layoutOffsetUpper,
    width: width,
    height: height
  };
  var rowFixedLength = mathMin$7(width, height);
  var best = Infinity; // the best row score so far

  var row = [];
  row.area = 0;

  for (var i = 0, len = viewChildren.length; i < len;) {
    var child = viewChildren[i];
    row.push(child);
    row.area += child.getLayout().area;
    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation

    if (score <= best) {
      i++;
      best = score;
    } // abort, and try a different orientation
    else {
        row.area -= row.pop().getLayout().area;
        position(row, rowFixedLength, rect, halfGapWidth, false);
        rowFixedLength = mathMin$7(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
  }

  if (row.length) {
    position(row, rowFixedLength, rect, halfGapWidth, true);
  }

  if (!hideChildren) {
    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');

    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
      hideChildren = true;
    }
  }

  for (var i = 0, len = viewChildren.length; i < len; i++) {
    squarify(viewChildren[i], options, hideChildren, depth + 1);
  }
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */


function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
  var viewChildren = node.children || [];
  var orderBy = options.sort;
  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.

  if (hideChildren && !overLeafDepth) {
    return node.viewChildren = [];
  } // Sort children, order by desc.


  viewChildren = filter(viewChildren, function (child) {
    return !child.isRemoved();
  });
  sort$1(viewChildren, orderBy);
  var info = statistic(nodeModel, viewChildren, orderBy);

  if (info.sum === 0) {
    return node.viewChildren = [];
  }

  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);

  if (info.sum === 0) {
    return node.viewChildren = [];
  } // Set area to each child.


  for (var i = 0, len = viewChildren.length; i < len; i++) {
    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.

    viewChildren[i].setLayout({
      area: area
    });
  }

  if (overLeafDepth) {
    viewChildren.length && node.setLayout({
      isLeafRoot: true
    }, true);
    viewChildren.length = 0;
  }

  node.viewChildren = viewChildren;
  node.setLayout({
    dataExtent: info.dataExtent
  }, true);
  return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */


function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
  // visibleMin is not supported yet when no option.sort.
  if (!orderBy) {
    return sum;
  }

  var visibleMin = nodeModel.get('visibleMin');
  var len = orderedChildren.length;
  var deletePoint = len; // Always travel from little value to big value.

  for (var i = len - 1; i >= 0; i--) {
    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();

    if (value / sum * totalArea < visibleMin) {
      deletePoint = i;
      sum -= value;
    }
  }

  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
  return sum;
}
/**
 * Sort
 */


function sort$1(viewChildren, orderBy) {
  if (orderBy) {
    viewChildren.sort(function (a, b) {
      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
  }

  return viewChildren;
}
/**
 * Statistic
 */


function statistic(nodeModel, children, orderBy) {
  // Calculate sum.
  var sum = 0;

  for (var i = 0, len = children.length; i < len; i++) {
    sum += children[i].getValue();
  } // Statistic data extent for latter visual coding.
  // Notice: data extent should be calculate based on raw children
  // but not filtered view children, otherwise visual mapping will not
  // be stable when zoom (where children is filtered by visibleMin).


  var dimension = nodeModel.get('visualDimension');
  var dataExtent; // The same as area dimension.

  if (!children || !children.length) {
    dataExtent = [NaN, NaN];
  } else if (dimension === 'value' && orderBy) {
    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
    orderBy === 'asc' && dataExtent.reverse();
  } // Other dimension.
  else {
      dataExtent = [Infinity, -Infinity];
      each$4(children, function (child) {
        var value = child.getValue(dimension);
        value < dataExtent[0] && (dataExtent[0] = value);
        value > dataExtent[1] && (dataExtent[1] = value);
      });
    }

  return {
    sum: sum,
    dataExtent: dataExtent
  };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */


function worst(row, rowFixedLength, ratio) {
  var areaMax = 0;
  var areaMin = Infinity;

  for (var i = 0, area = void 0, len = row.length; i < len; i++) {
    area = row[i].getLayout().area;

    if (area) {
      area < areaMin && (areaMin = area);
      area > areaMax && (areaMax = area);
    }
  }

  var squareArea = row.area * row.area;
  var f = rowFixedLength * rowFixedLength * ratio;
  return squareArea ? mathMax$7(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */


function position(row, rowFixedLength, rect, halfGapWidth, flush) {
  // When rowFixedLength === rect.width,
  // it is horizontal subdivision,
  // rowFixedLength is the width of the subdivision,
  // rowOtherLength is the height of the subdivision,
  // and nodes will be positioned from left to right.
  // wh[idx0WhenH] means: when horizontal,
  //      wh[idx0WhenH] => wh[0] => 'width'.
  //      xy[idx1WhenH] => xy[1] => 'y'.
  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
  var idx1WhenH = 1 - idx0WhenH;
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  var last = rect[xy[idx0WhenH]];
  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;

  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
  }

  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
    var node = row[i];
    var nodeLayout = {};
    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax$7(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.

    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
    var modWH = i === rowLen - 1 || remain < step ? remain : step;
    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax$7(modWH - 2 * halfGapWidth, 0);
    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin$7(halfGapWidth, wh1 / 2);
    nodeLayout[xy[idx0WhenH]] = last + mathMin$7(halfGapWidth, wh0 / 2);
    last += modWH;
    node.setLayout(nodeLayout, true);
  }

  rect[xy[idx1WhenH]] += rowOtherLength;
  rect[wh[idx1WhenH]] -= rowOtherLength;
} // Return [containerWidth, containerHeight] as default.


function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
  // If targetInfo.node exists, we zoom to the node,
  // so estimate whole width and height by target node.
  var currNode = (targetInfo || {}).node;
  var defaultSize = [containerWidth, containerHeight];

  if (!currNode || currNode === viewRoot) {
    return defaultSize;
  }

  var parent;
  var viewArea = containerWidth * containerHeight;
  var area = viewArea * seriesModel.option.zoomToNodeRatio;

  while (parent = currNode.parentNode) {
    // jshint ignore:line
    var sum = 0;
    var siblings = parent.children;

    for (var i = 0, len = siblings.length; i < len; i++) {
      sum += siblings[i].getValue();
    }

    var currNodeValue = currNode.getValue();

    if (currNodeValue === 0) {
      return defaultSize;
    }

    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.

    var parentModel = parent.getModel();
    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel));
    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
    area > MAX_SAFE_INTEGER$2 && (area = MAX_SAFE_INTEGER$2);
    currNode = parent;
  }

  area < viewArea && (area = viewArea);
  var scale = Math.pow(area / viewArea, 0.5);
  return [containerWidth * scale, containerHeight * scale];
} // Root position based on coord of containerGroup


function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
  if (rootRect) {
    return {
      x: rootRect.x,
      y: rootRect.y
    };
  }

  var defaultPosition = {
    x: 0,
    y: 0
  };

  if (!targetInfo) {
    return defaultPosition;
  } // If targetInfo is fetched by 'retrieveTargetInfo',
  // old tree and new tree are the same tree,
  // so the node still exists and we can visit it.


  var targetNode = targetInfo.node;
  var layout = targetNode.getLayout();

  if (!layout) {
    return defaultPosition;
  } // Transform coord from local to container.


  var targetCenter = [layout.width / 2, layout.height / 2];
  var node = targetNode;

  while (node) {
    var nodeLayout = node.getLayout();
    targetCenter[0] += nodeLayout.x;
    targetCenter[1] += nodeLayout.y;
    node = node.parentNode;
  }

  return {
    x: layoutInfo.width / 2 - targetCenter[0],
    y: layoutInfo.height / 2 - targetCenter[1]
  };
} // Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.


function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
  var nodeLayout = node.getLayout();
  var nodeInViewAbovePath = viewAbovePath[depth];
  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;

  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
    return;
  }

  node.setLayout({
    // isInView means: viewRoot sub tree + viewAbovePath
    isInView: true,
    // invisible only means: outside view clip so that the node can not
    // see but still layout for animation preparation but not render.
    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
    isAboveViewRoot: isAboveViewRoot
  }, true); // Transform to child coordinate.

  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
  each$4(node.viewChildren || [], function (child) {
    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
  });
}

function getUpperLabelHeight(model) {
  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
}

function install$c(registers) {
  registers.registerSeriesModel(TreemapSeriesModel);
  registers.registerChartView(TreemapView);
  registers.registerVisual(treemapVisual);
  registers.registerLayout(treemapLayout);
  installTreemapAction(registers);
}

function categoryFilter(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (!legendModels || !legendModels.length) {
    return;
  }

  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var categoriesData = graphSeries.getCategoriesData();
    var graph = graphSeries.getGraph();
    var data = graph.data;
    var categoryNames = categoriesData.mapArray(categoriesData.getName);
    data.filterSelf(function (idx) {
      var model = data.getItemModel(idx);
      var category = model.getShallow('category');

      if (category != null) {
        if (isNumber$1(category)) {
          category = categoryNames[category];
        } // If in any legend component the status is not selected.


        for (var i = 0; i < legendModels.length; i++) {
          if (!legendModels[i].isSelected(category)) {
            return false;
          }
        }
      }

      return true;
    });
  });
}

function categoryVisual(ecModel) {
  var paletteScope = {};
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var categoriesData = seriesModel.getCategoriesData();
    var data = seriesModel.getData();
    var categoryNameIdxMap = {};
    categoriesData.each(function (idx) {
      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.

      categoryNameIdxMap['ec-' + name] = idx;
      var itemModel = categoriesData.getItemModel(idx);
      var style = itemModel.getModel('itemStyle').getItemStyle();

      if (!style.fill) {
        // Get color from palette.
        style.fill = seriesModel.getColorFromPalette(name, paletteScope);
      }

      categoriesData.setItemVisual(idx, 'style', style);
      var symbolVisualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];

      for (var i = 0; i < symbolVisualList.length; i++) {
        var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);

        if (symbolVisual != null) {
          categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
        }
      }
    }); // Assign category color to visual

    if (categoriesData.count()) {
      data.each(function (idx) {
        var model = data.getItemModel(idx);
        var categoryIdx = model.getShallow('category');

        if (categoryIdx != null) {
          if (isString(categoryIdx)) {
            categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
          }

          var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
          var style = data.ensureUniqueItemVisual(idx, 'style');
          extend(style, categoryStyle);
          var visualList = ['symbol', 'symbolSize', 'symbolKeepAspect'];

          for (var i = 0; i < visualList.length; i++) {
            data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
          }
        }
      });
    }
  });
}

function normalize$2(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

function graphEdgeVisual(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var edgeData = seriesModel.getEdgeData();
    var symbolType = normalize$2(seriesModel.get('edgeSymbol'));
    var symbolSize = normalize$2(seriesModel.get('edgeSymbolSize')); // const colorQuery = ['lineStyle', 'color'] as const;
    // const opacityQuery = ['lineStyle', 'opacity'] as const;

    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
    edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
    edgeData.each(function (idx) {
      var itemModel = edgeData.getItemModel(idx);
      var edge = graph.getEdgeByIndex(idx);
      var symbolType = normalize$2(itemModel.getShallow('symbol', true));
      var symbolSize = normalize$2(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual

      var style = itemModel.getModel('lineStyle').getLineStyle();
      var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
      extend(existsStyle, style);

      switch (existsStyle.stroke) {
        case 'source':
          {
            var nodeStyle = edge.node1.getVisual('style');
            existsStyle.stroke = nodeStyle && nodeStyle.fill;
            break;
          }

        case 'target':
          {
            var nodeStyle = edge.node2.getVisual('style');
            existsStyle.stroke = nodeStyle && nodeStyle.fill;
            break;
          }
      }

      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
    });
  });
}

var KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */

var getAutoCurvenessParams = function (seriesModel) {
  return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */


var createCurveness = function (seriesModel, appendLength) {
  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
  var length = 20;
  var curvenessList = []; // handler the function set

  if (isNumber$1(autoCurvenessParmas)) {
    length = autoCurvenessParmas;
  } else if (isArray$1(autoCurvenessParmas)) {
    seriesModel.__curvenessList = autoCurvenessParmas;
    return;
  } // append length


  if (appendLength > length) {
    length = appendLength;
  } // make sure the length is even


  var len = length % 2 ? length + 2 : length + 3;
  curvenessList = [];

  for (var i = 0; i < len; i++) {
    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
  }

  seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */


var getKeyOfEdges = function (n1, n2, seriesModel) {
  var source = [n1.id, n1.dataIndex].join('.');
  var target = [n2.id, n2.dataIndex].join('.');
  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */


var getOppositeKey = function (key) {
  var keys = key.split(KEY_DELIMITER);
  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


var getEdgeFromMap = function (edge, seriesModel) {
  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */


var getTotalLengthBetweenNodes = function (edge, seriesModel) {
  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
  return len + lenV;
};
/**
 *
 * @param key
 */


var getEdgeMapLengthWithKey = function (key, seriesModel) {
  var edgeMap = seriesModel.__edgeMap;
  return edgeMap[key] ? edgeMap[key].length : 0;
};
/**
 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
 * @see /graph/GraphSeries.js@getInitialData
 * @param {module:echarts/model/SeriesModel} seriesModel
 */


function initCurvenessList(seriesModel) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  seriesModel.__curvenessList = [];
  seriesModel.__edgeMap = {}; // calc the array of curveness List

  createCurveness(seriesModel);
}
/**
 * set edgeMap with key
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} index
 */

function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
  if (!getAutoCurvenessParams(seriesModel)) {
    return;
  }

  var key = getKeyOfEdges(n1, n2, seriesModel);
  var edgeMap = seriesModel.__edgeMap;
  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction

  if (edgeMap[key] && !oppositeEdges) {
    edgeMap[key].isForward = true;
  } else if (oppositeEdges && edgeMap[key]) {
    oppositeEdges.isForward = true;
    edgeMap[key].isForward = false;
  }

  edgeMap[key] = edgeMap[key] || [];
  edgeMap[key].push(index);
}
/**
 * get curvature for edge
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param index
 */

function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
  var isArrayParam = isArray$1(autoCurvenessParams);

  if (!autoCurvenessParams) {
    return null;
  }

  var edgeArray = getEdgeFromMap(edge, seriesModel);

  if (!edgeArray) {
    return null;
  }

  var edgeIndex = -1;

  for (var i = 0; i < edgeArray.length; i++) {
    if (edgeArray[i] === index) {
      edgeIndex = i;
      break;
    }
  } // if totalLen is Longer createCurveness


  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
  createCurveness(seriesModel, totalLen);
  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number

  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity

  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;

  if (!edgeArray.isForward) {
    // the opposite edge show outside
    var oppositeKey = getOppositeKey(curKey);
    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite

    if (needReverse) {
      // set as array may make the parity handle with the len of opposite
      if (isArrayParam) {
        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
          return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else {
          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
        }
      } else {
        return (len + parityCorrection) % 2 ? resValue : -resValue;
      }
    } else {
      return curvenessList[edgeIndex + len + parityCorrection];
    }
  } else {
    return curvenessList[parityCorrection + edgeIndex];
  }
}

function simpleLayout(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var graph = seriesModel.getGraph();
  graph.eachNode(function (node) {
    var model = node.getModel();
    node.setLayout([+model.get('x'), +model.get('y')]);
  });
  simpleLayoutEdge(graph, seriesModel);
}
function simpleLayoutEdge(graph, seriesModel) {
  graph.eachEdge(function (edge, index) {
    var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
    var p1 = clone$1(edge.node1.getLayout());
    var p2 = clone$1(edge.node2.getLayout());
    var points = [p1, p2];

    if (+curveness) {
      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
    }

    edge.setLayout(points);
  });
}

function graphSimpleLayout(ecModel, api) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var layout = seriesModel.get('layout');
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      var data_1 = seriesModel.getData();
      var dimensions_1 = [];
      each(coordSys.dimensions, function (coordDim) {
        dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
      });

      for (var dataIndex = 0; dataIndex < data_1.count(); dataIndex++) {
        var value = [];
        var hasValue = false;

        for (var i = 0; i < dimensions_1.length; i++) {
          var val = data_1.get(dimensions_1[i], dataIndex);

          if (!isNaN(val)) {
            hasValue = true;
          }

          value.push(val);
        }

        if (hasValue) {
          data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
        } else {
          // Also {Array.<number>}, not undefined to avoid if...else... statement
          data_1.setItemLayout(dataIndex, [NaN, NaN]);
        }
      }

      simpleLayoutEdge(data_1.graph, seriesModel);
    } else if (!layout || layout === 'none') {
      simpleLayout(seriesModel);
    }
  });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function getNodeGlobalScale(seriesModel) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys.type !== 'view') {
    return 1;
  }

  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
  var groupZoom = coordSys.scaleX; // Scale node when zoom changes

  var roamZoom = coordSys.getZoom();
  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
  return nodeScale / groupZoom;
}
function getSymbolSize(node) {
  var symbolSize = node.getVisual('symbolSize');

  if (symbolSize instanceof Array) {
    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
  }

  return +symbolSize;
}

var PI$6 = Math.PI;
var _symbolRadiansHalf = [];
/**
 * `basedOn` can be:
 * 'value':
 *     This layout is not accurate and have same bad case. For example,
 *     if the min value is very smaller than the max value, the nodes
 *     with the min value probably overlap even though there is enough
 *     space to layout them. So we only use this approach in the as the
 *     init layout of the force layout.
 *     FIXME
 *     Probably we do not need this method any more but use
 *     `basedOn: 'symbolSize'` in force layout if
 *     delay its init operations to GraphView.
 * 'symbolSize':
 *     This approach work only if all of the symbol size calculated.
 *     That is, the progressive rendering is not applied to graph.
 *     FIXME
 *     If progressive rendering is applied to graph some day,
 *     probably we have to use `basedOn: 'value'`.
 */

function circularLayout(seriesModel, basedOn, draggingNode, pointer) {
  var coordSys = seriesModel.coordinateSystem;

  if (coordSys && coordSys.type !== 'view') {
    return;
  }

  var rect = coordSys.getBoundingRect();
  var nodeData = seriesModel.getData();
  var graph = nodeData.graph;
  var cx = rect.width / 2 + rect.x;
  var cy = rect.height / 2 + rect.y;
  var r = Math.min(rect.width, rect.height) / 2;
  var count = nodeData.count();
  nodeData.setLayout({
    cx: cx,
    cy: cy
  });

  if (!count) {
    return;
  }

  if (draggingNode) {
    var _a = coordSys.pointToData(pointer),
        tempX = _a[0],
        tempY = _a[1];

    var v = [tempX - cx, tempY - cy];
    normalize(v, v);
    scale(v, v, r);
    draggingNode.setLayout([cx + v[0], cy + v[1]], true);
    var circularRotateLabel = seriesModel.get(['circular', 'rotateLabel']);
    rotateNodeLabel(draggingNode, circularRotateLabel, cx, cy);
  }

  _layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);

  graph.eachEdge(function (edge, index) {
    var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), getCurvenessForEdge(edge, seriesModel, index), 0);
    var p1 = clone$1(edge.node1.getLayout());
    var p2 = clone$1(edge.node2.getLayout());
    var cp1;
    var x12 = (p1[0] + p2[0]) / 2;
    var y12 = (p1[1] + p2[1]) / 2;

    if (+curveness) {
      curveness *= 3;
      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
    }

    edge.setLayout([p1, p2, cp1]);
  });
}
var _layoutNodesBasedOn = {
  value: function (seriesModel, graph, nodeData, r, cx, cy, count) {
    var angle = 0;
    var sum = nodeData.getSum('value');
    var unitAngle = Math.PI * 2 / (sum || count);
    graph.eachNode(function (node) {
      var value = node.getValue('value');
      var radianHalf = unitAngle * (sum ? value : 1) / 2;
      angle += radianHalf;
      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  },
  symbolSize: function (seriesModel, graph, nodeData, r, cx, cy, count) {
    var sumRadian = 0;
    _symbolRadiansHalf.length = count;
    var nodeScale = getNodeGlobalScale(seriesModel);
    graph.eachNode(function (node) {
      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
      // some the defensive code (2px is an arbitrary value).

      isNaN(symbolSize) && (symbolSize = 2);
      symbolSize < 0 && (symbolSize = 0);
      symbolSize *= nodeScale;
      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.

      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI$6 / 2);
      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
      sumRadian += symbolRadianHalf * 2;
    });
    var halfRemainRadian = (2 * PI$6 - sumRadian) / count / 2;
    var angle = 0;
    graph.eachNode(function (node) {
      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
      angle += radianHalf; // init circular layout for
      // 1. layout undefined node
      // 2. not fixed node

      (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
      angle += radianHalf;
    });
  }
};
function rotateNodeLabel(node, circularRotateLabel, cx, cy) {
  var el = node.getGraphicEl(); // need to check if el exists. '-' value may not create node element.

  if (!el) {
    return;
  }

  var nodeModel = node.getModel();
  var labelRotate = nodeModel.get(['label', 'rotate']) || 0;
  var symbolPath = el.getSymbolPath();

  if (circularRotateLabel) {
    var pos = node.getLayout();
    var rad = Math.atan2(pos[1] - cy, pos[0] - cx);

    if (rad < 0) {
      rad = Math.PI * 2 + rad;
    }

    var isLeft = pos[0] < cx;

    if (isLeft) {
      rad = rad - Math.PI;
    }

    var textPosition = isLeft ? 'left' : 'right';
    symbolPath.setTextConfig({
      rotation: -rad,
      position: textPosition,
      origin: 'center'
    });
    var emphasisState = symbolPath.ensureState('emphasis');
    extend(emphasisState.textConfig || (emphasisState.textConfig = {}), {
      position: textPosition
    });
  } else {
    symbolPath.setTextConfig({
      rotation: labelRotate *= Math.PI / 180
    });
  }
}

function graphCircularLayout(ecModel) {
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    if (seriesModel.get('layout') === 'circular') {
      circularLayout(seriesModel, 'symbolSize');
    }
  });
}

var scaleAndAdd$1 = scaleAndAdd; // function adjacentNode(n, e) {
//     return e.n1 === n ? e.n2 : e.n1;
// }

function forceLayout(inNodes, inEdges, opts) {
  var nodes = inNodes;
  var edges = inEdges;
  var rect = opts.rect;
  var width = rect.width;
  var height = rect.height;
  var center = [rect.x + width / 2, rect.y + height / 2]; // let scale = opts.scale || 1;

  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (let i = 0; i < edges.length; i++) {
  //     let e = edges[i];
  //     let n1 = e.n1;
  //     let n2 = e.n2;
  //     n1.edges = n1.edges || [];
  //     n2.edges = n2.edges || [];
  //     n1.edges.push(e);
  //     n2.edges.push(e);
  // }
  // Init position

  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];

    if (!n.p) {
      n.p = create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
    }

    n.pp = clone$1(n.p);
    n.edges = null;
  } // Formula in 'Graph Drawing by Force-directed Placement'
  // let k = scale * Math.sqrt(width * height / nodes.length);
  // let k2 = k * k;


  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
  var friction = initialFriction;
  var beforeStepCallback;
  var afterStepCallback;
  return {
    warmUp: function () {
      friction = initialFriction * 0.8;
    },
    setFixed: function (idx) {
      nodes[idx].fixed = true;
    },
    setUnfixed: function (idx) {
      nodes[idx].fixed = false;
    },

    /**
     * Before step hook
     */
    beforeStep: function (cb) {
      beforeStepCallback = cb;
    },

    /**
     * After step hook
     */
    afterStep: function (cb) {
      afterStepCallback = cb;
    },

    /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */
    step: function (cb) {
      beforeStepCallback && beforeStepCallback(nodes, edges);
      var v12 = [];
      var nLen = nodes.length;

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];

        if (e.ignoreForceLayout) {
          continue;
        }

        var n1 = e.n1;
        var n2 = e.n2;
        sub(v12, n2.p, n1.p);
        var d = len(v12) - e.d;
        var w = n2.w / (n1.w + n2.w);

        if (isNaN(w)) {
          w = 0;
        }

        normalize(v12, v12);
        !n1.fixed && scaleAndAdd$1(n1.p, n1.p, v12, w * d * friction);
        !n2.fixed && scaleAndAdd$1(n2.p, n2.p, v12, -(1 - w) * d * friction);
      } // Gravity


      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          sub(v12, center, n.p); // let d = vec2.len(v12);
          // vec2.scale(v12, v12, 1 / d);
          // let gravityFactor = gravity;

          scaleAndAdd$1(n.p, n.p, v12, gravity * friction);
        }
      } // Repulsive
      // PENDING


      for (var i = 0; i < nLen; i++) {
        var n1 = nodes[i];

        for (var j = i + 1; j < nLen; j++) {
          var n2 = nodes[j];
          sub(v12, n2.p, n1.p);
          var d = len(v12);

          if (d === 0) {
            // Random repulse
            set(v12, Math.random() - 0.5, Math.random() - 0.5);
            d = 1;
          }

          var repFact = (n1.rep + n2.rep) / d / d;
          !n1.fixed && scaleAndAdd$1(n1.pp, n1.pp, v12, repFact);
          !n2.fixed && scaleAndAdd$1(n2.pp, n2.pp, v12, -repFact);
        }
      }

      var v = [];

      for (var i = 0; i < nLen; i++) {
        var n = nodes[i];

        if (!n.fixed) {
          sub(v, n.p, n.pp);
          scaleAndAdd$1(n.p, n.p, v, friction);
          copy(n.pp, n.p);
        }
      }

      friction = friction * 0.992;
      var finished = friction < 0.01;
      afterStepCallback && afterStepCallback(nodes, edges, finished);
      cb && cb(finished);
    }
  };
}

function graphForceLayout(ecModel) {
  ecModel.eachSeriesByType('graph', function (graphSeries) {
    var coordSys = graphSeries.coordinateSystem;

    if (coordSys && coordSys.type !== 'view') {
      return;
    }

    if (graphSeries.get('layout') === 'force') {
      var preservedPoints_1 = graphSeries.preservedPoints || {};
      var graph_1 = graphSeries.getGraph();
      var nodeData_1 = graph_1.data;
      var edgeData = graph_1.edgeData;
      var forceModel = graphSeries.getModel('force');
      var initLayout = forceModel.get('initLayout');

      if (graphSeries.preservedPoints) {
        nodeData_1.each(function (idx) {
          var id = nodeData_1.getId(idx);
          nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [NaN, NaN]);
        });
      } else if (!initLayout || initLayout === 'none') {
        simpleLayout(graphSeries);
      } else if (initLayout === 'circular') {
        circularLayout(graphSeries, 'value');
      }

      var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
      var edgeDataExtent_1 = edgeData.getDataExtent('value'); // let edgeDataExtent = edgeData.getDataExtent('value');

      var repulsion = forceModel.get('repulsion');
      var edgeLength = forceModel.get('edgeLength');
      var repulsionArr_1 = isArray$1(repulsion) ? repulsion : [repulsion, repulsion];
      var edgeLengthArr_1 = isArray$1(edgeLength) ? edgeLength : [edgeLength, edgeLength]; // Larger value has smaller length

      edgeLengthArr_1 = [edgeLengthArr_1[1], edgeLengthArr_1[0]];
      var nodes_1 = nodeData_1.mapArray('value', function (value, idx) {
        var point = nodeData_1.getItemLayout(idx);
        var rep = linearMap(value, nodeDataExtent_1, repulsionArr_1);

        if (isNaN(rep)) {
          rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
        }

        return {
          w: rep,
          rep: rep,
          fixed: nodeData_1.getItemModel(idx).get('fixed'),
          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
        };
      });
      var edges = edgeData.mapArray('value', function (value, idx) {
        var edge = graph_1.getEdgeByIndex(idx);
        var d = linearMap(value, edgeDataExtent_1, edgeLengthArr_1);

        if (isNaN(d)) {
          d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
        }

        var edgeModel = edge.getModel();
        var curveness = retrieve3(edge.getModel().get(['lineStyle', 'curveness']), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
        return {
          n1: nodes_1[edge.node1.dataIndex],
          n2: nodes_1[edge.node2.dataIndex],
          d: d,
          curveness: curveness,
          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
        };
      }); // let coordSys = graphSeries.coordinateSystem;

      var rect = coordSys.getBoundingRect();
      var forceInstance = forceLayout(nodes_1, edges, {
        rect: rect,
        gravity: forceModel.get('gravity'),
        friction: forceModel.get('friction')
      });
      forceInstance.beforeStep(function (nodes, edges) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (nodes[i].fixed) {
            // Write back to layout instance
            copy(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
          }
        }
      });
      forceInstance.afterStep(function (nodes, edges, stopped) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          if (!nodes[i].fixed) {
            graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
          }

          preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
        }

        for (var i = 0, l = edges.length; i < l; i++) {
          var e = edges[i];
          var edge = graph_1.getEdgeByIndex(i);
          var p1 = e.n1.p;
          var p2 = e.n2.p;
          var points = edge.getLayout();
          points = points ? points.slice() : [];
          points[0] = points[0] || [];
          points[1] = points[1] || [];
          copy(points[0], p1);
          copy(points[1], p2);

          if (+e.curveness) {
            points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
          }

          edge.setLayout(points);
        }
      });
      graphSeries.forceLayout = forceInstance;
      graphSeries.preservedPoints = preservedPoints_1; // Step to get the layout

      forceInstance.step();
    } else {
      // Remove prev injected forceLayout instance
      graphSeries.forceLayout = null;
    }
  });
}

function getViewRect$2(seriesModel, api, aspect) {
  var option = extend(seriesModel.getBoxLayoutParams(), {
    aspect: aspect
  });
  return getLayoutRect$1(option, {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function createViewCoordSys(ecModel, api) {
  var viewList = [];
  ecModel.eachSeriesByType('graph', function (seriesModel) {
    var coordSysType = seriesModel.get('coordinateSystem');

    if (!coordSysType || coordSysType === 'view') {
      var data_1 = seriesModel.getData();
      var positions = data_1.mapArray(function (idx) {
        var itemModel = data_1.getItemModel(idx);
        return [+itemModel.get('x'), +itemModel.get('y')];
      });
      var min = [];
      var max = [];
      fromPoints(positions, min, max); // If width or height is 0

      if (max[0] - min[0] === 0) {
        max[0] += 1;
        min[0] -= 1;
      }

      if (max[1] - min[1] === 0) {
        max[1] += 1;
        min[1] -= 1;
      }

      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?

      var viewRect = getViewRect$2(seriesModel, api, aspect); // Position may be NaN, use view rect instead

      if (isNaN(aspect)) {
        min = [viewRect.x, viewRect.y];
        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
      }

      var bbWidth = max[0] - min[0];
      var bbHeight = max[1] - min[1];
      var viewWidth = viewRect.width;
      var viewHeight = viewRect.height;
      var viewCoordSys = seriesModel.coordinateSystem = new View();
      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info

      viewCoordSys.setCenter(seriesModel.get('center'), api);
      viewCoordSys.setZoom(seriesModel.get('zoom'));
      viewList.push(viewCoordSys);
    }
  });
  return viewList;
}

var straightLineProto = Line.prototype;
var bezierCurveProto = BezierCurve.prototype;

var StraightLineShape =
/** @class */
function () {
  function StraightLineShape() {
    // Start point
    this.x1 = 0;
    this.y1 = 0; // End point

    this.x2 = 0;
    this.y2 = 0;
    this.percent = 1;
  }

  return StraightLineShape;
}();

var CurveShape =
/** @class */
function (_super) {
  __extends$1(CurveShape, _super);

  function CurveShape() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return CurveShape;
}(StraightLineShape);

function isStraightLine(shape) {
  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}

var ECLinePath =
/** @class */
function (_super) {
  __extends$1(ECLinePath, _super);

  function ECLinePath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'ec-line';
    return _this;
  }

  ECLinePath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  ECLinePath.prototype.getDefaultShape = function () {
    return new StraightLineShape();
  };

  ECLinePath.prototype.buildPath = function (ctx, shape) {
    if (isStraightLine(shape)) {
      straightLineProto.buildPath.call(this, ctx, shape);
    } else {
      bezierCurveProto.buildPath.call(this, ctx, shape);
    }
  };

  ECLinePath.prototype.pointAt = function (t) {
    if (isStraightLine(this.shape)) {
      return straightLineProto.pointAt.call(this, t);
    } else {
      return bezierCurveProto.pointAt.call(this, t);
    }
  };

  ECLinePath.prototype.tangentAt = function (t) {
    var shape = this.shape;
    var p = isStraightLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : bezierCurveProto.tangentAt.call(this, t);
    return normalize(p, p);
  };

  return ECLinePath;
}(Path);

var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];

function makeSymbolTypeKey(symbolCategory) {
  return '_' + symbolCategory + 'Type';
}
/**
 * @inner
 */


function createSymbol$1(name, lineData, idx) {
  var symbolType = lineData.getItemVisual(idx, name);

  if (!symbolType || symbolType === 'none') {
    return;
  }

  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
  var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
  var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
  var symbolSizeArr = normalizeSymbolSize(symbolSize);
  var symbolOffsetArr = normalizeSymbolOffset(symbolOffset || 0, symbolSizeArr);
  var symbolPath = createSymbol(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
  symbolPath.name = name;
  return symbolPath;
}

function createLine(points) {
  var line = new ECLinePath({
    name: 'line',
    subPixelOptimize: true
  });
  setLinePoints(line.shape, points);
  return line;
}

function setLinePoints(targetShape, points) {
  targetShape.x1 = points[0][0];
  targetShape.y1 = points[0][1];
  targetShape.x2 = points[1][0];
  targetShape.y2 = points[1][1];
  targetShape.percent = 1;
  var cp1 = points[2];

  if (cp1) {
    targetShape.cpx1 = cp1[0];
    targetShape.cpy1 = cp1[1];
  } else {
    targetShape.cpx1 = NaN;
    targetShape.cpy1 = NaN;
  }
}

var Line$1 =
/** @class */
function (_super) {
  __extends$1(Line, _super);

  function Line(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this._createLine(lineData, idx, seriesScope);

    return _this;
  }

  Line.prototype._createLine = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var linePoints = lineData.getItemLayout(idx);
    var line = createLine(linePoints);
    line.shape.percent = 0;
    initProps(line, {
      shape: {
        percent: 1
      }
    }, seriesModel, idx);
    this.add(line);
    each(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbol = createSymbol$1(symbolCategory, lineData, idx); // symbols must added after line to make sure
      // it will be updated after line#update.
      // Or symbol position and rotation update in line#beforeUpdate will be one frame slow

      this.add(symbol);
      this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
    }, this);

    this._updateCommonStl(lineData, idx, seriesScope);
  }; // TODO More strict on the List type in parameters?


  Line.prototype.updateData = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName('line');
    var linePoints = lineData.getItemLayout(idx);
    var target = {
      shape: {}
    };
    setLinePoints(target.shape, linePoints);
    updateProps(line, target, seriesModel, idx);
    each(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbolType = lineData.getItemVisual(idx, symbolCategory);
      var key = makeSymbolTypeKey(symbolCategory); // Symbol changed

      if (this[key] !== symbolType) {
        this.remove(this.childOfName(symbolCategory));
        var symbol = createSymbol$1(symbolCategory, lineData, idx);
        this.add(symbol);
      }

      this[key] = symbolType;
    }, this);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  Line.prototype.getLinePath = function () {
    return this.childAt(0);
  };

  Line.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childOfName('line');
    var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
    var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
    var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
    var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
    var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
    var focus = seriesScope && seriesScope.focus;
    var blurScope = seriesScope && seriesScope.blurScope; // Optimization for large dataset

    if (!seriesScope || lineData.hasItemOption) {
      var itemModel = lineData.getItemModel(idx);
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
      blurLineStyle = itemModel.getModel(['blur', 'lineStyle']).getLineStyle();
      selectLineStyle = itemModel.getModel(['select', 'lineStyle']).getLineStyle();
      emphasisDisabled = emphasisModel.get('disabled');
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
      labelStatesModels = getLabelStatesModels(itemModel);
    }

    var lineStyle = lineData.getItemVisual(idx, 'style');
    var visualColor = lineStyle.stroke;
    line.useStyle(lineStyle);
    line.style.fill = null;
    line.style.strokeNoScale = true;
    line.ensureState('emphasis').style = emphasisLineStyle;
    line.ensureState('blur').style = blurLineStyle;
    line.ensureState('select').style = selectLineStyle; // Update symbol

    each(SYMBOL_CATEGORIES, function (symbolCategory) {
      var symbol = this.childOfName(symbolCategory);

      if (symbol) {
        // Share opacity and color with line.
        symbol.setColor(visualColor);
        symbol.style.opacity = lineStyle.opacity;

        for (var i = 0; i < SPECIAL_STATES.length; i++) {
          var stateName = SPECIAL_STATES[i];
          var lineState = line.getState(stateName);

          if (lineState) {
            var lineStateStyle = lineState.style || {};
            var state = symbol.ensureState(stateName);
            var stateStyle = state.style || (state.style = {});

            if (lineStateStyle.stroke != null) {
              stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
            }

            if (lineStateStyle.opacity != null) {
              stateStyle.opacity = lineStateStyle.opacity;
            }
          }
        }

        symbol.markRedraw();
      }
    }, this);
    var rawVal = seriesModel.getRawValue(idx);
    setLabelStyle(this, labelStatesModels, {
      labelDataIndex: idx,
      labelFetcher: {
        getFormattedLabel: function (dataIndex, stateName) {
          return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
        }
      },
      inheritColor: visualColor || '#000',
      defaultOpacity: lineStyle.opacity,
      defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round$3(rawVal) : rawVal) + ''
    });
    var label = this.getTextContent(); // Always set `textStyle` even if `normalStyle.text` is null, because default
    // values have to be set on `normalStyle`.

    if (label) {
      var labelNormalModel = labelStatesModels.normal;
      label.__align = label.style.align;
      label.__verticalAlign = label.style.verticalAlign; // 'start', 'middle', 'end'

      label.__position = labelNormalModel.get('position') || 'middle';
      var distance = labelNormalModel.get('distance');

      if (!isArray$1(distance)) {
        distance = [distance, distance];
      }

      label.__labelDistance = distance;
    }

    this.setTextConfig({
      position: null,
      local: true,
      inside: false // Can't be inside for stroke element.

    });
    toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
  };

  Line.prototype.highlight = function () {
    enterEmphasis(this);
  };

  Line.prototype.downplay = function () {
    leaveEmphasis(this);
  };

  Line.prototype.updateLayout = function (lineData, idx) {
    this.setLinePoints(lineData.getItemLayout(idx));
  };

  Line.prototype.setLinePoints = function (points) {
    var linePath = this.childOfName('line');
    setLinePoints(linePath.shape, points);
    linePath.dirty();
  };

  Line.prototype.beforeUpdate = function () {
    var lineGroup = this;
    var symbolFrom = lineGroup.childOfName('fromSymbol');
    var symbolTo = lineGroup.childOfName('toSymbol');
    var label = lineGroup.getTextContent(); // Quick reject

    if (!symbolFrom && !symbolTo && (!label || label.ignore)) {
      return;
    }

    var invScale = 1;
    var parentNode = this.parent;

    while (parentNode) {
      if (parentNode.scaleX) {
        invScale /= parentNode.scaleX;
      }

      parentNode = parentNode.parent;
    }

    var line = lineGroup.childOfName('line'); // If line not changed
    // FIXME Parent scale changed

    if (!this.__dirty && !line.__dirty) {
      return;
    }

    var percent = line.shape.percent;
    var fromPos = line.pointAt(0);
    var toPos = line.pointAt(percent);
    var d = sub([], toPos, fromPos);
    normalize(d, d);

    function setSymbolRotation(symbol, percent) {
      // Fix #12388
      // when symbol is set to be 'arrow' in markLine,
      // symbolRotate value will be ignored, and compulsively use tangent angle.
      // rotate by default if symbol rotation is not specified
      var specifiedRotation = symbol.__specifiedRotation;

      if (specifiedRotation == null) {
        var tangent = line.tangentAt(percent);
        symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
      } else {
        symbol.attr('rotation', specifiedRotation);
      }
    }

    if (symbolFrom) {
      symbolFrom.setPosition(fromPos);
      setSymbolRotation(symbolFrom, 0);
      symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
      symbolFrom.markRedraw();
    }

    if (symbolTo) {
      symbolTo.setPosition(toPos);
      setSymbolRotation(symbolTo, 1);
      symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
      symbolTo.markRedraw();
    }

    if (label && !label.ignore) {
      label.x = label.y = 0;
      label.originX = label.originY = 0;
      var textAlign = void 0;
      var textVerticalAlign = void 0;
      var distance = label.__labelDistance;
      var distanceX = distance[0] * invScale;
      var distanceY = distance[1] * invScale;
      var halfPercent = percent / 2;
      var tangent = line.tangentAt(halfPercent);
      var n = [tangent[1], -tangent[0]];
      var cp = line.pointAt(halfPercent);

      if (n[1] > 0) {
        n[0] = -n[0];
        n[1] = -n[1];
      }

      var dir = tangent[0] < 0 ? -1 : 1;

      if (label.__position !== 'start' && label.__position !== 'end') {
        var rotation = -Math.atan2(tangent[1], tangent[0]);

        if (toPos[0] < fromPos[0]) {
          rotation = Math.PI + rotation;
        }

        label.rotation = rotation;
      }

      var dy = void 0;

      switch (label.__position) {
        case 'insideStartTop':
        case 'insideMiddleTop':
        case 'insideEndTop':
        case 'middle':
          dy = -distanceY;
          textVerticalAlign = 'bottom';
          break;

        case 'insideStartBottom':
        case 'insideMiddleBottom':
        case 'insideEndBottom':
          dy = distanceY;
          textVerticalAlign = 'top';
          break;

        default:
          dy = 0;
          textVerticalAlign = 'middle';
      }

      switch (label.__position) {
        case 'end':
          label.x = d[0] * distanceX + toPos[0];
          label.y = d[1] * distanceY + toPos[1];
          textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
          textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
          break;

        case 'start':
          label.x = -d[0] * distanceX + fromPos[0];
          label.y = -d[1] * distanceY + fromPos[1];
          textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
          textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
          break;

        case 'insideStartTop':
        case 'insideStart':
        case 'insideStartBottom':
          label.x = distanceX * dir + fromPos[0];
          label.y = fromPos[1] + dy;
          textAlign = tangent[0] < 0 ? 'right' : 'left';
          label.originX = -distanceX * dir;
          label.originY = -dy;
          break;

        case 'insideMiddleTop':
        case 'insideMiddle':
        case 'insideMiddleBottom':
        case 'middle':
          label.x = cp[0];
          label.y = cp[1] + dy;
          textAlign = 'center';
          label.originY = -dy;
          break;

        case 'insideEndTop':
        case 'insideEnd':
        case 'insideEndBottom':
          label.x = -distanceX * dir + toPos[0];
          label.y = toPos[1] + dy;
          textAlign = tangent[0] >= 0 ? 'right' : 'left';
          label.originX = distanceX * dir;
          label.originY = -dy;
          break;
      }

      label.scaleX = label.scaleY = invScale;
      label.setStyle({
        // Use the user specified text align and baseline first
        verticalAlign: label.__verticalAlign || textVerticalAlign,
        align: label.__align || textAlign
      });
    }
  };

  return Line;
}(Group$1);

var LineDraw =
/** @class */
function () {
  function LineDraw(LineCtor) {
    this.group = new Group$1();
    this._LineCtor = LineCtor || Line$1;
  }

  LineDraw.prototype.updateData = function (lineData) {
    var _this = this; // Remove progressive els.


    this._progressiveEls = null;
    var lineDraw = this;
    var group = lineDraw.group;
    var oldLineData = lineDraw._lineData;
    lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!oldLineData) {
      group.removeAll();
    }

    var seriesScope = makeSeriesScope$1(lineData);
    lineData.diff(oldLineData).add(function (idx) {
      _this._doAdd(lineData, idx, seriesScope);
    }).update(function (newIdx, oldIdx) {
      _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
    }).remove(function (idx) {
      group.remove(oldLineData.getItemGraphicEl(idx));
    }).execute();
  };

  LineDraw.prototype.updateLayout = function () {
    var lineData = this._lineData; // Do not support update layout in incremental mode.

    if (!lineData) {
      return;
    }

    lineData.eachItemGraphicEl(function (el, idx) {
      el.updateLayout(lineData, idx);
    }, this);
  };

  LineDraw.prototype.incrementalPrepareUpdate = function (lineData) {
    this._seriesScope = makeSeriesScope$1(lineData);
    this._lineData = null;
    this.group.removeAll();
  };

  LineDraw.prototype.incrementalUpdate = function (taskParams, lineData) {
    this._progressiveEls = [];

    function updateIncrementalAndHover(el) {
      if (!el.isGroup && !isEffectObject(el)) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = taskParams.start; idx < taskParams.end; idx++) {
      var itemLayout = lineData.getItemLayout(idx);

      if (lineNeedsDraw(itemLayout)) {
        var el = new this._LineCtor(lineData, idx, this._seriesScope);
        el.traverse(updateIncrementalAndHover);
        this.group.add(el);
        lineData.setItemGraphicEl(idx, el);

        this._progressiveEls.push(el);
      }
    }
  };

  LineDraw.prototype.remove = function () {
    this.group.removeAll();
  };

  LineDraw.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  LineDraw.prototype._doAdd = function (lineData, idx, seriesScope) {
    var itemLayout = lineData.getItemLayout(idx);

    if (!lineNeedsDraw(itemLayout)) {
      return;
    }

    var el = new this._LineCtor(lineData, idx, seriesScope);
    lineData.setItemGraphicEl(idx, el);
    this.group.add(el);
  };

  LineDraw.prototype._doUpdate = function (oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
    var itemEl = oldLineData.getItemGraphicEl(oldIdx);

    if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
      this.group.remove(itemEl);
      return;
    }

    if (!itemEl) {
      itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
    } else {
      itemEl.updateData(newLineData, newIdx, seriesScope);
    }

    newLineData.setItemGraphicEl(newIdx, itemEl);
    this.group.add(itemEl);
  };

  return LineDraw;
}();

function isEffectObject(el) {
  return el.animators && el.animators.length > 0;
}

function makeSeriesScope$1(lineData) {
  var hostModel = lineData.hostModel;
  var emphasisModel = hostModel.getModel('emphasis');
  return {
    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
    emphasisLineStyle: emphasisModel.getModel(['lineStyle']).getLineStyle(),
    blurLineStyle: hostModel.getModel(['blur', 'lineStyle']).getLineStyle(),
    selectLineStyle: hostModel.getModel(['select', 'lineStyle']).getLineStyle(),
    emphasisDisabled: emphasisModel.get('disabled'),
    blurScope: emphasisModel.get('blurScope'),
    focus: emphasisModel.get('focus'),
    labelStatesModels: getLabelStatesModels(hostModel)
  };
}

function isPointNaN(pt) {
  return isNaN(pt[0]) || isNaN(pt[1]);
}

function lineNeedsDraw(pts) {
  return pts && !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
}

var v1 = [];
var v2 = [];
var v3 = [];
var quadraticAt$1 = quadraticAt;
var v2DistSquare = distSquare;
var mathAbs$2 = Math.abs;

function intersectCurveCircle(curvePoints, center, radius) {
  var p0 = curvePoints[0];
  var p1 = curvePoints[1];
  var p2 = curvePoints[2];
  var d = Infinity;
  var t;
  var radiusSquare = radius * radius;
  var interval = 0.1;

  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
    v1[0] = quadraticAt$1(p0[0], p1[0], p2[0], _t);
    v1[1] = quadraticAt$1(p0[1], p1[1], p2[1], _t);
    var diff = mathAbs$2(v2DistSquare(v1, center) - radiusSquare);

    if (diff < d) {
      d = diff;
      t = _t;
    }
  } // Assume the segment is monotone，Find root through Bisection method
  // At most 32 iteration


  for (var i = 0; i < 32; i++) {
    // let prev = t - interval;
    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);

    v2[0] = quadraticAt$1(p0[0], p1[0], p2[0], t);
    v2[1] = quadraticAt$1(p0[1], p1[1], p2[1], t);
    v3[0] = quadraticAt$1(p0[0], p1[0], p2[0], next);
    v3[1] = quadraticAt$1(p0[1], p1[1], p2[1], next);
    var diff = v2DistSquare(v2, center) - radiusSquare;

    if (mathAbs$2(diff) < 1e-2) {
      break;
    } // let prevDiff = v2DistSquare(v1, center) - radiusSquare;


    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
    interval /= 2;

    if (diff < 0) {
      if (nextDiff >= 0) {
        t = t + interval;
      } else {
        t = t - interval;
      }
    } else {
      if (nextDiff >= 0) {
        t = t - interval;
      } else {
        t = t + interval;
      }
    }
  }

  return t;
} // Adjust edge to avoid


function adjustEdge(graph, scale) {
  var tmp0 = [];
  var quadraticSubdivide$1 = quadraticSubdivide;
  var pts = [[], [], []];
  var pts2 = [[], []];
  var v = [];
  scale /= 2;
  graph.eachEdge(function (edge, idx) {
    var linePoints = edge.getLayout();
    var fromSymbol = edge.getVisual('fromSymbol');
    var toSymbol = edge.getVisual('toSymbol');

    if (!linePoints.__original) {
      linePoints.__original = [clone$1(linePoints[0]), clone$1(linePoints[1])];

      if (linePoints[2]) {
        linePoints.__original.push(clone$1(linePoints[2]));
      }
    }

    var originalPoints = linePoints.__original; // Quadratic curve

    if (linePoints[2] != null) {
      copy(pts[0], originalPoints[0]);
      copy(pts[1], originalPoints[2]);
      copy(pts[2], originalPoints[1]);

      if (fromSymbol && fromSymbol !== 'none') {
        var symbolSize = getSymbolSize(edge.node1);
        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second

        quadraticSubdivide$1(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[0][0] = tmp0[3];
        pts[1][0] = tmp0[4];
        quadraticSubdivide$1(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[0][1] = tmp0[3];
        pts[1][1] = tmp0[4];
      }

      if (toSymbol && toSymbol !== 'none') {
        var symbolSize = getSymbolSize(edge.node2);
        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first

        quadraticSubdivide$1(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
        pts[1][0] = tmp0[1];
        pts[2][0] = tmp0[2];
        quadraticSubdivide$1(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
        pts[1][1] = tmp0[1];
        pts[2][1] = tmp0[2];
      } // Copy back to layout


      copy(linePoints[0], pts[0]);
      copy(linePoints[1], pts[2]);
      copy(linePoints[2], pts[1]);
    } // Line
    else {
        copy(pts2[0], originalPoints[0]);
        copy(pts2[1], originalPoints[1]);
        sub(v, pts2[1], pts2[0]);
        normalize(v, v);

        if (fromSymbol && fromSymbol !== 'none') {
          var symbolSize = getSymbolSize(edge.node1);
          scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
        }

        if (toSymbol && toSymbol !== 'none') {
          var symbolSize = getSymbolSize(edge.node2);
          scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
        }

        copy(linePoints[0], pts2[0]);
        copy(linePoints[1], pts2[1]);
      }
  });
}

function isViewCoordSys(coordSys) {
  return coordSys.type === 'view';
}

var GraphView =
/** @class */
function (_super) {
  __extends$1(GraphView, _super);

  function GraphView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphView.type;
    return _this;
  }

  GraphView.prototype.init = function (ecModel, api) {
    var symbolDraw = new SymbolDraw();
    var lineDraw = new LineDraw();
    var group = this.group;
    this._controller = new RoamController(api.getZr());
    this._controllerHost = {
      target: group
    };
    group.add(symbolDraw.group);
    group.add(lineDraw.group);
    this._symbolDraw = symbolDraw;
    this._lineDraw = lineDraw;
    this._firstRender = true;
  };

  GraphView.prototype.render = function (seriesModel, ecModel, api) {
    var _this = this;

    var coordSys = seriesModel.coordinateSystem;
    this._model = seriesModel;
    var symbolDraw = this._symbolDraw;
    var lineDraw = this._lineDraw;
    var group = this.group;

    if (isViewCoordSys(coordSys)) {
      var groupNewProp = {
        x: coordSys.x,
        y: coordSys.y,
        scaleX: coordSys.scaleX,
        scaleY: coordSys.scaleY
      };

      if (this._firstRender) {
        group.attr(groupNewProp);
      } else {
        updateProps(group, groupNewProp, seriesModel);
      }
    } // Fix edge contact point with node


    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
    var data = seriesModel.getData();
    symbolDraw.updateData(data);
    var edgeData = seriesModel.getEdgeData(); // TODO: TYPE

    lineDraw.updateData(edgeData);

    this._updateNodeAndLinkScale();

    this._updateController(seriesModel, ecModel, api);

    clearTimeout(this._layoutTimeout);
    var forceLayout = seriesModel.forceLayout;
    var layoutAnimation = seriesModel.get(['force', 'layoutAnimation']);

    if (forceLayout) {
      this._startForceLayoutIteration(forceLayout, layoutAnimation);
    }

    var layout = seriesModel.get('layout');
    data.graph.eachNode(function (node) {
      var idx = node.dataIndex;
      var el = node.getGraphicEl();
      var itemModel = node.getModel();

      if (!el) {
        return;
      } // Update draggable


      el.off('drag').off('dragend');
      var draggable = itemModel.get('draggable');

      if (draggable) {
        el.on('drag', function (e) {
          switch (layout) {
            case 'force':
              forceLayout.warmUp();
              !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
              forceLayout.setFixed(idx); // Write position back to layout

              data.setItemLayout(idx, [el.x, el.y]);
              break;

            case 'circular':
              data.setItemLayout(idx, [el.x, el.y]); // mark node fixed

              node.setLayout({
                fixed: true
              }, true); // recalculate circular layout

              circularLayout(seriesModel, 'symbolSize', node, [e.offsetX, e.offsetY]);

              _this.updateLayout(seriesModel);

              break;

            case 'none':
            default:
              data.setItemLayout(idx, [el.x, el.y]); // update edge

              simpleLayoutEdge(seriesModel.getGraph(), seriesModel);

              _this.updateLayout(seriesModel);

              break;
          }
        }).on('dragend', function () {
          if (forceLayout) {
            forceLayout.setUnfixed(idx);
          }
        });
      }

      el.setDraggable(draggable, !!itemModel.get('cursor'));
      var focus = itemModel.get(['emphasis', 'focus']);

      if (focus === 'adjacency') {
        getECData(el).focus = node.getAdjacentDataIndices();
      }
    });
    data.graph.eachEdge(function (edge) {
      var el = edge.getGraphicEl();
      var focus = edge.getModel().get(['emphasis', 'focus']);

      if (!el) {
        return;
      }

      if (focus === 'adjacency') {
        getECData(el).focus = {
          edge: [edge.dataIndex],
          node: [edge.node1.dataIndex, edge.node2.dataIndex]
        };
      }
    });
    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get(['circular', 'rotateLabel']);
    var cx = data.getLayout('cx');
    var cy = data.getLayout('cy');
    data.graph.eachNode(function (node) {
      rotateNodeLabel(node, circularRotateLabel, cx, cy);
    });
    this._firstRender = false;
  };

  GraphView.prototype.dispose = function () {
    this._controller && this._controller.dispose();
    this._controllerHost = null;
  };

  GraphView.prototype._startForceLayoutIteration = function (forceLayout, layoutAnimation) {
    var self = this;

    (function step() {
      forceLayout.step(function (stopped) {
        self.updateLayout(self._model);
        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
      });
    })();
  };

  GraphView.prototype._updateController = function (seriesModel, ecModel, api) {
    var _this = this;

    var controller = this._controller;
    var controllerHost = this._controllerHost;
    var group = this.group;
    controller.setPointerChecker(function (e, x, y) {
      var rect = group.getBoundingRect();
      rect.applyTransform(group.transform);
      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
    });

    if (!isViewCoordSys(seriesModel.coordinateSystem)) {
      controller.disable();
      return;
    }

    controller.enable(seriesModel.get('roam'));
    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
    controller.off('pan').off('zoom').on('pan', function (e) {
      updateViewOnPan(controllerHost, e.dx, e.dy);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        dx: e.dx,
        dy: e.dy
      });
    }).on('zoom', function (e) {
      updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
      api.dispatchAction({
        seriesId: seriesModel.id,
        type: 'graphRoam',
        zoom: e.scale,
        originX: e.originX,
        originY: e.originY
      });

      _this._updateNodeAndLinkScale();

      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));

      _this._lineDraw.updateLayout(); // Only update label layout on zoom


      api.updateLabelLayout();
    });
  };

  GraphView.prototype._updateNodeAndLinkScale = function () {
    var seriesModel = this._model;
    var data = seriesModel.getData();
    var nodeScale = getNodeGlobalScale(seriesModel);
    data.eachItemGraphicEl(function (el, idx) {
      el && el.setSymbolScale(nodeScale);
    });
  };

  GraphView.prototype.updateLayout = function (seriesModel) {
    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));

    this._symbolDraw.updateLayout();

    this._lineDraw.updateLayout();
  };

  GraphView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove();
    this._lineDraw && this._lineDraw.remove();
  };

  GraphView.type = 'graph';
  return GraphView;
}(ChartView);

function generateNodeKey(id) {
  return '_EC_' + id;
}

var Graph$1 =
/** @class */
function () {
  function Graph(directed) {
    this.type = 'graph';
    this.nodes = [];
    this.edges = [];
    this._nodesMap = {};
    /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */

    this._edgesMap = {};
    this._directed = directed || false;
  }
  /**
   * If is directed graph
   */


  Graph.prototype.isDirected = function () {
    return this._directed;
  };
  /**
   * Add a new node
   */

  Graph.prototype.addNode = function (id, dataIndex) {
    id = id == null ? '' + dataIndex : '' + id;
    var nodesMap = this._nodesMap;

    if (nodesMap[generateNodeKey(id)]) {
      if (process.env.NODE_ENV !== 'production') {
        console.error('Graph nodes have duplicate name or id');
      }

      return;
    }

    var node = new GraphNode(id, dataIndex);
    node.hostGraph = this;
    this.nodes.push(node);
    nodesMap[generateNodeKey(id)] = node;
    return node;
  };
  /**
   * Get node by data index
   */

  Graph.prototype.getNodeByIndex = function (dataIndex) {
    var rawIdx = this.data.getRawIndex(dataIndex);
    return this.nodes[rawIdx];
  };
  /**
   * Get node by id
   */

  Graph.prototype.getNodeById = function (id) {
    return this._nodesMap[generateNodeKey(id)];
  };
  /**
   * Add a new edge
   */

  Graph.prototype.addEdge = function (n1, n2, dataIndex) {
    var nodesMap = this._nodesMap;
    var edgesMap = this._edgesMap; // PNEDING

    if (isNumber$1(n1)) {
      n1 = this.nodes[n1];
    }

    if (isNumber$1(n2)) {
      n2 = this.nodes[n2];
    }

    if (!(n1 instanceof GraphNode)) {
      n1 = nodesMap[generateNodeKey(n1)];
    }

    if (!(n2 instanceof GraphNode)) {
      n2 = nodesMap[generateNodeKey(n2)];
    }

    if (!n1 || !n2) {
      return;
    }

    var key = n1.id + '-' + n2.id;
    var edge = new GraphEdge(n1, n2, dataIndex);
    edge.hostGraph = this;

    if (this._directed) {
      n1.outEdges.push(edge);
      n2.inEdges.push(edge);
    }

    n1.edges.push(edge);

    if (n1 !== n2) {
      n2.edges.push(edge);
    }

    this.edges.push(edge);
    edgesMap[key] = edge;
    return edge;
  };
  /**
   * Get edge by data index
   */

  Graph.prototype.getEdgeByIndex = function (dataIndex) {
    var rawIdx = this.edgeData.getRawIndex(dataIndex);
    return this.edges[rawIdx];
  };
  /**
   * Get edge by two linked nodes
   */

  Graph.prototype.getEdge = function (n1, n2) {
    if (n1 instanceof GraphNode) {
      n1 = n1.id;
    }

    if (n2 instanceof GraphNode) {
      n2 = n2.id;
    }

    var edgesMap = this._edgesMap;

    if (this._directed) {
      return edgesMap[n1 + '-' + n2];
    } else {
      return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
    }
  };
  /**
   * Iterate all nodes
   */

  Graph.prototype.eachNode = function (cb, context) {
    var nodes = this.nodes;
    var len = nodes.length;

    for (var i = 0; i < len; i++) {
      if (nodes[i].dataIndex >= 0) {
        cb.call(context, nodes[i], i);
      }
    }
  };
  /**
   * Iterate all edges
   */

  Graph.prototype.eachEdge = function (cb, context) {
    var edges = this.edges;
    var len = edges.length;

    for (var i = 0; i < len; i++) {
      if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
        cb.call(context, edges[i], i);
      }
    }
  };
  /**
   * Breadth first traverse
   * Return true to stop traversing
   */

  Graph.prototype.breadthFirstTraverse = function (cb, startNode, direction, context) {
    if (!(startNode instanceof GraphNode)) {
      startNode = this._nodesMap[generateNodeKey(startNode)];
    }

    if (!startNode) {
      return;
    }

    var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';

    for (var i = 0; i < this.nodes.length; i++) {
      this.nodes[i].__visited = false;
    }

    if (cb.call(context, startNode, null)) {
      return;
    }

    var queue = [startNode];

    while (queue.length) {
      var currentNode = queue.shift();
      var edges = currentNode[edgeType];

      for (var i = 0; i < edges.length; i++) {
        var e = edges[i];
        var otherNode = e.node1 === currentNode ? e.node2 : e.node1;

        if (!otherNode.__visited) {
          if (cb.call(context, otherNode, currentNode)) {
            // Stop traversing
            return;
          }

          queue.push(otherNode);
          otherNode.__visited = true;
        }
      }
    }
  };
  // depthFirstTraverse(
  //     cb, startNode, direction, context
  // ) {
  // };
  // Filter update

  Graph.prototype.update = function () {
    var data = this.data;
    var edgeData = this.edgeData;
    var nodes = this.nodes;
    var edges = this.edges;

    for (var i = 0, len = nodes.length; i < len; i++) {
      nodes[i].dataIndex = -1;
    }

    for (var i = 0, len = data.count(); i < len; i++) {
      nodes[data.getRawIndex(i)].dataIndex = i;
    }

    edgeData.filterSelf(function (idx) {
      var edge = edges[edgeData.getRawIndex(idx)];
      return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
    }); // Update edge

    for (var i = 0, len = edges.length; i < len; i++) {
      edges[i].dataIndex = -1;
    }

    for (var i = 0, len = edgeData.count(); i < len; i++) {
      edges[edgeData.getRawIndex(i)].dataIndex = i;
    }
  };
  /**
   * @return {module:echarts/data/Graph}
   */

  Graph.prototype.clone = function () {
    var graph = new Graph(this._directed);
    var nodes = this.nodes;
    var edges = this.edges;

    for (var i = 0; i < nodes.length; i++) {
      graph.addNode(nodes[i].id, nodes[i].dataIndex);
    }

    for (var i = 0; i < edges.length; i++) {
      var e = edges[i];
      graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
    }

    return graph;
  };
  return Graph;
}();

var GraphNode =
/** @class */
function () {
  function GraphNode(id, dataIndex) {
    this.inEdges = [];
    this.outEdges = [];
    this.edges = [];
    this.dataIndex = -1;
    this.id = id == null ? '' : id;
    this.dataIndex = dataIndex == null ? -1 : dataIndex;
  }
  /**
   * @return {number}
   */


  GraphNode.prototype.degree = function () {
    return this.edges.length;
  };
  /**
   * @return {number}
   */


  GraphNode.prototype.inDegree = function () {
    return this.inEdges.length;
  };
  /**
  * @return {number}
  */


  GraphNode.prototype.outDegree = function () {
    return this.outEdges.length;
  };

  GraphNode.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.data.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  };

  GraphNode.prototype.getAdjacentDataIndices = function () {
    var dataIndices = {
      edge: [],
      node: []
    };

    for (var i = 0; i < this.edges.length; i++) {
      var adjacentEdge = this.edges[i];

      if (adjacentEdge.dataIndex < 0) {
        continue;
      }

      dataIndices.edge.push(adjacentEdge.dataIndex);
      dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
    }

    return dataIndices;
  };

  return GraphNode;
}();

var GraphEdge =
/** @class */
function () {
  function GraphEdge(n1, n2, dataIndex) {
    this.dataIndex = -1;
    this.node1 = n1;
    this.node2 = n2;
    this.dataIndex = dataIndex == null ? -1 : dataIndex;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  GraphEdge.prototype.getModel = function (path) {
    if (this.dataIndex < 0) {
      return;
    }

    var graph = this.hostGraph;
    var itemModel = graph.edgeData.getItemModel(this.dataIndex);
    return itemModel.getModel(path);
  };

  GraphEdge.prototype.getAdjacentDataIndices = function () {
    return {
      edge: [this.dataIndex],
      node: [this.node1.dataIndex, this.node2.dataIndex]
    };
  };

  return GraphEdge;
}();

function createGraphDataProxyMixin(hostName, dataName) {
  return {
    /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */
    getValue: function (dimension) {
      var data = this[hostName][dataName];
      return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
    },
    // TODO: TYPE stricter type.
    setVisual: function (key, value) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
    },
    getVisual: function (key) {
      return this[hostName][dataName].getItemVisual(this.dataIndex, key);
    },
    setLayout: function (layout, merge) {
      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
    },
    getLayout: function () {
      return this[hostName][dataName].getItemLayout(this.dataIndex);
    },
    getGraphicEl: function () {
      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
    },
    getRawIndex: function () {
      return this[hostName][dataName].getRawIndex(this.dataIndex);
    }
  };
}
mixin(GraphNode, createGraphDataProxyMixin('hostGraph', 'data'));
mixin(GraphEdge, createGraphDataProxyMixin('hostGraph', 'edgeData'));

function createGraphFromNodeEdge(nodes, edges, seriesModel, directed, beforeLink) {
  // ??? TODO
  // support dataset?
  var graph = new Graph$1(directed);

  for (var i = 0; i < nodes.length; i++) {
    graph.addNode(retrieve( // Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
  }

  var linkNameList = [];
  var validEdges = [];
  var linkCount = 0;

  for (var i = 0; i < edges.length; i++) {
    var link = edges[i];
    var source = link.source;
    var target = link.target; // addEdge may fail when source or target not exists

    if (graph.addEdge(source, target, linkCount)) {
      validEdges.push(link);
      linkNameList.push(retrieve(convertOptionIdName(link.id, null), source + ' > ' + target));
      linkCount++;
    }
  }

  var coordSys = seriesModel.get('coordinateSystem');
  var nodeData;

  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
    nodeData = createSeriesData(nodes, seriesModel);
  } else {
    var coordSysCtor = CoordinateSystemManager.get(coordSys);
    var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
    // `value` dimension, but graph need `value` dimension. It's better to
    // uniform this behavior.

    if (indexOf(coordDimensions, 'value') < 0) {
      coordDimensions.concat(['value']);
    }

    var dimensions = prepareSeriesDataSchema(nodes, {
      coordDimensions: coordDimensions,
      encodeDefine: seriesModel.getEncode()
    }).dimensions;
    nodeData = new SeriesData(dimensions, seriesModel);
    nodeData.initData(nodes);
  }

  var edgeData = new SeriesData(['value'], seriesModel);
  edgeData.initData(validEdges, linkNameList);
  beforeLink && beforeLink(nodeData, edgeData);
  linkSeriesData({
    mainData: nodeData,
    struct: graph,
    structAttr: 'graph',
    datas: {
      node: nodeData,
      edge: edgeData
    },
    datasAttr: {
      node: 'data',
      edge: 'edgeData'
    }
  }); // Update dataIndex of nodes and edges because invalid edge may be removed

  graph.update();
  return graph;
}

var GraphSeriesModel =
/** @class */
function (_super) {
  __extends$1(GraphSeriesModel, _super);

  function GraphSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  GraphSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments);

    var self = this;

    function getCategoriesData() {
      return self._categoriesData;
    } // Provide data for legend select


    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  };

  GraphSeriesModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    this.fillDataTextStyle(option.edges || option.links);

    this._updateCategoriesData();
  };

  GraphSeriesModel.prototype.mergeDefaultAndTheme = function (option) {
    _super.prototype.mergeDefaultAndTheme.apply(this, arguments);

    defaultEmphasis(option, 'edgeLabel', ['show']);
  };

  GraphSeriesModel.prototype.getInitialData = function (option, ecModel) {
    var edges = option.edges || option.links || [];
    var nodes = option.data || option.nodes || [];
    var self = this;

    if (nodes && edges) {
      // auto curveness
      initCurvenessList(this);
      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
      each(graph.edges, function (edge) {
        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
      }, this);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      // Overwrite nodeData.getItemModel to
      nodeData.wrapMethod('getItemModel', function (model) {
        var categoriesModels = self._categoriesModels;
        var categoryIdx = model.getShallow('category');
        var categoryModel = categoriesModels[categoryIdx];

        if (categoryModel) {
          categoryModel.parentModel = model.parentModel;
          model.parentModel = categoryModel;
        }

        return model;
      }); // TODO Inherit resolveParentPath by default in Model#getModel?

      var oldGetModel = Model.prototype.getModel;

      function newGetModel(path, parentModel) {
        var model = oldGetModel.call(this, path, parentModel);
        model.resolveParentPath = resolveParentPath;
        return model;
      }

      edgeData.wrapMethod('getItemModel', function (model) {
        model.resolveParentPath = resolveParentPath;
        model.getModel = newGetModel;
        return model;
      });

      function resolveParentPath(pathArr) {
        if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
          var newPathArr = pathArr.slice();

          if (pathArr[0] === 'label') {
            newPathArr[0] = 'edgeLabel';
          } else if (pathArr[1] === 'label') {
            newPathArr[1] = 'edgeLabel';
          }

          return newPathArr;
        }

        return pathArr;
      }
    }
  };

  GraphSeriesModel.prototype.getGraph = function () {
    return this.getData().graph;
  };

  GraphSeriesModel.prototype.getEdgeData = function () {
    return this.getGraph().edgeData;
  };

  GraphSeriesModel.prototype.getCategoriesData = function () {
    return this._categoriesData;
  };

  GraphSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    if (dataType === 'edge') {
      var nodeData = this.getData();
      var params = this.getDataParams(dataIndex, dataType);
      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
      var sourceName = nodeData.getName(edge.node1.dataIndex);
      var targetName = nodeData.getName(edge.node2.dataIndex);
      var nameArr = [];
      sourceName != null && nameArr.push(sourceName);
      targetName != null && nameArr.push(targetName);
      return createTooltipMarkup('nameValue', {
        name: nameArr.join(' > '),
        value: params.value,
        noValue: params.value == null
      });
    } // dataType === 'node' or empty


    var nodeMarkup = defaultSeriesFormatTooltip({
      series: this,
      dataIndex: dataIndex,
      multipleSeries: multipleSeries
    });
    return nodeMarkup;
  };

  GraphSeriesModel.prototype._updateCategoriesData = function () {
    var categories = map(this.option.categories || [], function (category) {
      // Data must has value
      return category.value != null ? category : extend({
        value: 0
      }, category);
    });
    var categoriesData = new SeriesData(['value'], this);
    categoriesData.initData(categories);
    this._categoriesData = categoriesData;
    this._categoriesModels = categoriesData.mapArray(function (idx) {
      return categoriesData.getItemModel(idx);
    });
  };

  GraphSeriesModel.prototype.setZoom = function (zoom) {
    this.option.zoom = zoom;
  };

  GraphSeriesModel.prototype.setCenter = function (center) {
    this.option.center = center;
  };

  GraphSeriesModel.prototype.isAnimationEnabled = function () {
    return _super.prototype.isAnimationEnabled.call(this) // Not enable animation when do force layout
    && !(this.get('layout') === 'force' && this.get(['force', 'layoutAnimation']));
  };

  GraphSeriesModel.type = 'series.graph';
  GraphSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  GraphSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    // Default option for all coordinate systems
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // polarIndex: 0,
    // geoIndex: 0,
    legendHoverLink: true,
    layout: null,
    // Configuration of circular layout
    circular: {
      rotateLabel: false
    },
    // Configuration of force directed layout
    force: {
      initLayout: null,
      // Node repulsion. Can be an array to represent range.
      repulsion: [0, 50],
      gravity: 0.1,
      // Initial friction
      friction: 0.6,
      // Edge length. Can be an array to represent range.
      edgeLength: 30,
      layoutAnimation: true
    },
    left: 'center',
    top: 'center',
    // right: null,
    // bottom: null,
    // width: '80%',
    // height: '80%',
    symbol: 'circle',
    symbolSize: 10,
    edgeSymbol: ['none', 'none'],
    edgeSymbolSize: 10,
    edgeLabel: {
      position: 'middle',
      distance: 5
    },
    draggable: false,
    roam: false,
    // Default on center of graph
    center: null,
    zoom: 1,
    // Symbol size scale ratio in roam
    nodeScaleRatio: 0.6,
    // cursor: null,
    // categories: [],
    // data: []
    // Or
    // nodes: []
    //
    // links: []
    // Or
    // edges: []
    label: {
      show: false,
      formatter: '{b}'
    },
    itemStyle: {},
    lineStyle: {
      color: '#aaa',
      width: 1,
      opacity: 0.5
    },
    emphasis: {
      scale: true,
      label: {
        show: true
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return GraphSeriesModel;
}(SeriesModel);

var actionInfo = {
  type: 'graphRoam',
  event: 'graphRoam',
  update: 'none'
};
function install$d(registers) {
  registers.registerChartView(GraphView);
  registers.registerSeriesModel(GraphSeriesModel);
  registers.registerProcessor(categoryFilter);
  registers.registerVisual(categoryVisual);
  registers.registerVisual(graphEdgeVisual);
  registers.registerLayout(graphSimpleLayout);
  registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, graphCircularLayout);
  registers.registerLayout(graphForceLayout);
  registers.registerCoordinateSystem('graphView', {
    dimensions: View.dimensions,
    create: createViewCoordSys
  }); // Register legacy focus actions

  registers.registerAction({
    type: 'focusNodeAdjacency',
    event: 'focusNodeAdjacency',
    update: 'series:focusNodeAdjacency'
  }, noop$2);
  registers.registerAction({
    type: 'unfocusNodeAdjacency',
    event: 'unfocusNodeAdjacency',
    update: 'series:unfocusNodeAdjacency'
  }, noop$2); // Register roam action.

  registers.registerAction(actionInfo, function (payload, ecModel, api) {
    ecModel.eachComponent({
      mainType: 'series',
      query: payload
    }, function (seriesModel) {
      var coordSys = seriesModel.coordinateSystem;
      var res = updateCenterAndZoom(coordSys, payload, undefined, api);
      seriesModel.setCenter && seriesModel.setCenter(res.center);
      seriesModel.setZoom && seriesModel.setZoom(res.zoom);
    });
  });
}

var PointerShape =
/** @class */
function () {
  function PointerShape() {
    this.angle = 0;
    this.width = 10;
    this.r = 10;
    this.x = 0;
    this.y = 0;
  }

  return PointerShape;
}();

var PointerPath =
/** @class */
function (_super) {
  __extends$1(PointerPath, _super);

  function PointerPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'pointer';
    return _this;
  }

  PointerPath.prototype.getDefaultShape = function () {
    return new PointerShape();
  };

  PointerPath.prototype.buildPath = function (ctx, shape) {
    var mathCos = Math.cos;
    var mathSin = Math.sin;
    var r = shape.r;
    var width = shape.width;
    var angle = shape.angle;
    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
    angle = shape.angle - Math.PI / 2;
    ctx.moveTo(x, y);
    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
    ctx.lineTo(x, y);
  };

  return PointerPath;
}(Path);

function parsePosition(seriesModel, api) {
  var center = seriesModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  var size = Math.min(width, height);
  var cx = parsePercent$1(center[0], api.getWidth());
  var cy = parsePercent$1(center[1], api.getHeight());
  var r = parsePercent$1(seriesModel.get('radius'), size / 2);
  return {
    cx: cx,
    cy: cy,
    r: r
  };
}

function formatLabel(value, labelFormatter) {
  var label = value == null ? '' : value + '';

  if (labelFormatter) {
    if (isString(labelFormatter)) {
      label = labelFormatter.replace('{value}', label);
    } else if (isFunction$3(labelFormatter)) {
      label = labelFormatter(value);
    }
  }

  return label;
}

var GaugeView =
/** @class */
function (_super) {
  __extends$1(GaugeView, _super);

  function GaugeView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GaugeView.type;
    return _this;
  }

  GaugeView.prototype.render = function (seriesModel, ecModel, api) {
    this.group.removeAll();
    var colorList = seriesModel.get(['axisLine', 'lineStyle', 'color']);
    var posInfo = parsePosition(seriesModel, api);

    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);

    this._data = seriesModel.getData();
  };

  GaugeView.prototype.dispose = function () {};

  GaugeView.prototype._renderMain = function (seriesModel, ecModel, api, colorList, posInfo) {
    var group = this.group;
    var clockwise = seriesModel.get('clockwise');
    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
    var axisLineModel = seriesModel.getModel('axisLine');
    var roundCap = axisLineModel.get('roundCap');
    var MainPath = roundCap ? SausagePath : Sector;
    var showAxis = axisLineModel.get('show');
    var lineStyleModel = axisLineModel.getModel('lineStyle');
    var axisLineWidth = lineStyleModel.get('width');
    var angles = [startAngle, endAngle];
    normalizeArcAngles(angles, !clockwise);
    startAngle = angles[0];
    endAngle = angles[1];
    var angleRangeSpan = endAngle - startAngle;
    var prevEndAngle = startAngle;
    var sectors = [];

    for (var i = 0; showAxis && i < colorList.length; i++) {
      // Clamp
      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
      endAngle = startAngle + angleRangeSpan * percent;
      var sector = new MainPath({
        shape: {
          startAngle: prevEndAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: posInfo.r - axisLineWidth,
          r: posInfo.r
        },
        silent: true
      });
      sector.setStyle({
        fill: colorList[i][1]
      });
      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
      // so the properties for stroking are useless
      ['color', 'width']));
      sectors.push(sector);
      prevEndAngle = endAngle;
    }

    sectors.reverse();
    each(sectors, function (sector) {
      return group.add(sector);
    });

    var getColor = function (percent) {
      // Less than 0
      if (percent <= 0) {
        return colorList[0][1];
      }

      var i;

      for (i = 0; i < colorList.length; i++) {
        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
          return colorList[i][1];
        }
      } // More than 1


      return colorList[i - 1][1];
    };

    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);

    this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);

    this._renderAnchor(seriesModel, posInfo);

    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
  };

  GaugeView.prototype._renderTicks = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
    var group = this.group;
    var cx = posInfo.cx;
    var cy = posInfo.cy;
    var r = posInfo.r;
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var splitLineModel = seriesModel.getModel('splitLine');
    var tickModel = seriesModel.getModel('axisTick');
    var labelModel = seriesModel.getModel('axisLabel');
    var splitNumber = seriesModel.get('splitNumber');
    var subSplitNumber = tickModel.get('splitNumber');
    var splitLineLen = parsePercent$1(splitLineModel.get('length'), r);
    var tickLen = parsePercent$1(tickModel.get('length'), r);
    var angle = startAngle;
    var step = (endAngle - startAngle) / splitNumber;
    var subStep = step / subSplitNumber;
    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
    var splitLineDistance = splitLineModel.get('distance');
    var unitX;
    var unitY;

    for (var i = 0; i <= splitNumber; i++) {
      unitX = Math.cos(angle);
      unitY = Math.sin(angle); // Split line

      if (splitLineModel.get('show')) {
        var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
        var splitLine = new Line({
          shape: {
            x1: unitX * (r - distance) + cx,
            y1: unitY * (r - distance) + cy,
            x2: unitX * (r - splitLineLen - distance) + cx,
            y2: unitY * (r - splitLineLen - distance) + cy
          },
          style: splitLineStyle,
          silent: true
        });

        if (splitLineStyle.stroke === 'auto') {
          splitLine.setStyle({
            stroke: getColor(i / splitNumber)
          });
        }

        group.add(splitLine);
      } // Label


      if (labelModel.get('show')) {
        var distance = labelModel.get('distance') + splitLineDistance;
        var label = formatLabel(round$3(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
        var autoColor = getColor(i / splitNumber);
        var textStyleX = unitX * (r - splitLineLen - distance) + cx;
        var textStyleY = unitY * (r - splitLineLen - distance) + cy;
        var rotateType = labelModel.get('rotate');
        var rotate = 0;

        if (rotateType === 'radial') {
          rotate = -angle + 2 * Math.PI;

          if (rotate > Math.PI / 2) {
            rotate += Math.PI;
          }
        } else if (rotateType === 'tangential') {
          rotate = -angle - Math.PI / 2;
        } else if (isNumber$1(rotateType)) {
          rotate = rotateType * Math.PI / 180;
        }

        if (rotate === 0) {
          group.add(new ZRText({
            style: createTextStyle(labelModel, {
              text: label,
              x: textStyleX,
              y: textStyleY,
              verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
              align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
            }, {
              inheritColor: autoColor
            }),
            silent: true
          }));
        } else {
          group.add(new ZRText({
            style: createTextStyle(labelModel, {
              text: label,
              x: textStyleX,
              y: textStyleY,
              verticalAlign: 'middle',
              align: 'center'
            }, {
              inheritColor: autoColor
            }),
            silent: true,
            originX: textStyleX,
            originY: textStyleY,
            rotation: rotate
          }));
        }
      } // Axis tick


      if (tickModel.get('show') && i !== splitNumber) {
        var distance = tickModel.get('distance');
        distance = distance ? distance + axisLineWidth : axisLineWidth;

        for (var j = 0; j <= subSplitNumber; j++) {
          unitX = Math.cos(angle);
          unitY = Math.sin(angle);
          var tickLine = new Line({
            shape: {
              x1: unitX * (r - distance) + cx,
              y1: unitY * (r - distance) + cy,
              x2: unitX * (r - tickLen - distance) + cx,
              y2: unitY * (r - tickLen - distance) + cy
            },
            silent: true,
            style: tickLineStyle
          });

          if (tickLineStyle.stroke === 'auto') {
            tickLine.setStyle({
              stroke: getColor((i + j / subSplitNumber) / splitNumber)
            });
          }

          group.add(tickLine);
          angle += subStep;
        }

        angle -= subStep;
      } else {
        angle += step;
      }
    }
  };

  GaugeView.prototype._renderPointer = function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
    var group = this.group;
    var oldData = this._data;
    var oldProgressData = this._progressEls;
    var progressList = [];
    var showPointer = seriesModel.get(['pointer', 'show']);
    var progressModel = seriesModel.getModel('progress');
    var showProgress = progressModel.get('show');
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var valueExtent = [minVal, maxVal];
    var angleExtent = [startAngle, endAngle];

    function createPointer(idx, angle) {
      var itemModel = data.getItemModel(idx);
      var pointerModel = itemModel.getModel('pointer');
      var pointerWidth = parsePercent$1(pointerModel.get('width'), posInfo.r);
      var pointerLength = parsePercent$1(pointerModel.get('length'), posInfo.r);
      var pointerStr = seriesModel.get(['pointer', 'icon']);
      var pointerOffset = pointerModel.get('offsetCenter');
      var pointerOffsetX = parsePercent$1(pointerOffset[0], posInfo.r);
      var pointerOffsetY = parsePercent$1(pointerOffset[1], posInfo.r);
      var pointerKeepAspect = pointerModel.get('keepAspect');
      var pointer; // not exist icon type will be set 'rect'

      if (pointerStr) {
        pointer = createSymbol(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
      } else {
        pointer = new PointerPath({
          shape: {
            angle: -Math.PI / 2,
            width: pointerWidth,
            r: pointerLength,
            x: pointerOffsetX,
            y: pointerOffsetY
          }
        });
      }

      pointer.rotation = -(angle + Math.PI / 2);
      pointer.x = posInfo.cx;
      pointer.y = posInfo.cy;
      return pointer;
    }

    function createProgress(idx, endAngle) {
      var roundCap = progressModel.get('roundCap');
      var ProgressPath = roundCap ? SausagePath : Sector;
      var isOverlap = progressModel.get('overlap');
      var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
      var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
      var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
      var progress = new ProgressPath({
        shape: {
          startAngle: startAngle,
          endAngle: endAngle,
          cx: posInfo.cx,
          cy: posInfo.cy,
          clockwise: clockwise,
          r0: r0,
          r: r
        }
      });
      isOverlap && (progress.z2 = maxVal - data.get(valueDim, idx) % maxVal);
      return progress;
    }

    if (showProgress || showPointer) {
      data.diff(oldData).add(function (idx) {
        var val = data.get(valueDim, idx);

        if (showPointer) {
          var pointer = createPointer(idx, startAngle); // TODO hide pointer on NaN value?

          initProps(pointer, {
            rotation: -((isNaN(+val) ? angleExtent[0] : linearMap(val, valueExtent, angleExtent, true)) + Math.PI / 2)
          }, seriesModel);
          group.add(pointer);
          data.setItemGraphicEl(idx, pointer);
        }

        if (showProgress) {
          var progress = createProgress(idx, startAngle);
          var isClip = progressModel.get('clip');
          initProps(progress, {
            shape: {
              endAngle: linearMap(val, valueExtent, angleExtent, isClip)
            }
          }, seriesModel);
          group.add(progress); // Add data index and series index for indexing the data by element
          // Useful in tooltip

          setCommonECData(seriesModel.seriesIndex, data.dataType, idx, progress);
          progressList[idx] = progress;
        }
      }).update(function (newIdx, oldIdx) {
        var val = data.get(valueDim, newIdx);

        if (showPointer) {
          var previousPointer = oldData.getItemGraphicEl(oldIdx);
          var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
          var pointer = createPointer(newIdx, previousRotate);
          pointer.rotation = previousRotate;
          updateProps(pointer, {
            rotation: -((isNaN(+val) ? angleExtent[0] : linearMap(val, valueExtent, angleExtent, true)) + Math.PI / 2)
          }, seriesModel);
          group.add(pointer);
          data.setItemGraphicEl(newIdx, pointer);
        }

        if (showProgress) {
          var previousProgress = oldProgressData[oldIdx];
          var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
          var progress = createProgress(newIdx, previousEndAngle);
          var isClip = progressModel.get('clip');
          updateProps(progress, {
            shape: {
              endAngle: linearMap(val, valueExtent, angleExtent, isClip)
            }
          }, seriesModel);
          group.add(progress); // Add data index and series index for indexing the data by element
          // Useful in tooltip

          setCommonECData(seriesModel.seriesIndex, data.dataType, newIdx, progress);
          progressList[newIdx] = progress;
        }
      }).execute();
      data.each(function (idx) {
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');

        if (showPointer) {
          var pointer = data.getItemGraphicEl(idx);
          var symbolStyle = data.getItemVisual(idx, 'style');
          var visualColor = symbolStyle.fill;

          if (pointer instanceof ZRImage) {
            var pathStyle = pointer.style;
            pointer.useStyle(extend({
              image: pathStyle.image,
              x: pathStyle.x,
              y: pathStyle.y,
              width: pathStyle.width,
              height: pathStyle.height
            }, symbolStyle));
          } else {
            pointer.useStyle(symbolStyle);
            pointer.type !== 'pointer' && pointer.setColor(visualColor);
          }

          pointer.setStyle(itemModel.getModel(['pointer', 'itemStyle']).getItemStyle());

          if (pointer.style.fill === 'auto') {
            pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
          }

          pointer.z2EmphasisLift = 0;
          setStatesStylesFromModel(pointer, itemModel);
          toggleHoverEmphasis(pointer, focus, blurScope, emphasisDisabled);
        }

        if (showProgress) {
          var progress = progressList[idx];
          progress.useStyle(data.getItemVisual(idx, 'style'));
          progress.setStyle(itemModel.getModel(['progress', 'itemStyle']).getItemStyle());
          progress.z2EmphasisLift = 0;
          setStatesStylesFromModel(progress, itemModel);
          toggleHoverEmphasis(progress, focus, blurScope, emphasisDisabled);
        }
      });
      this._progressEls = progressList;
    }
  };

  GaugeView.prototype._renderAnchor = function (seriesModel, posInfo) {
    var anchorModel = seriesModel.getModel('anchor');
    var showAnchor = anchorModel.get('show');

    if (showAnchor) {
      var anchorSize = anchorModel.get('size');
      var anchorType = anchorModel.get('icon');
      var offsetCenter = anchorModel.get('offsetCenter');
      var anchorKeepAspect = anchorModel.get('keepAspect');
      var anchor = createSymbol(anchorType, posInfo.cx - anchorSize / 2 + parsePercent$1(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + parsePercent$1(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
      anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
      anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
      this.group.add(anchor);
    }
  };

  GaugeView.prototype._renderTitleAndDetail = function (seriesModel, ecModel, api, getColor, posInfo) {
    var _this = this;

    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var minVal = +seriesModel.get('min');
    var maxVal = +seriesModel.get('max');
    var contentGroup = new Group$1();
    var newTitleEls = [];
    var newDetailEls = [];
    var hasAnimation = seriesModel.isAnimationEnabled();
    var showPointerAbove = seriesModel.get(['pointer', 'showAbove']);
    data.diff(this._data).add(function (idx) {
      newTitleEls[idx] = new ZRText({
        silent: true
      });
      newDetailEls[idx] = new ZRText({
        silent: true
      });
    }).update(function (idx, oldIdx) {
      newTitleEls[idx] = _this._titleEls[oldIdx];
      newDetailEls[idx] = _this._detailEls[oldIdx];
    }).execute();
    data.each(function (idx) {
      var itemModel = data.getItemModel(idx);
      var value = data.get(valueDim, idx);
      var itemGroup = new Group$1();
      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
      var itemTitleModel = itemModel.getModel('title');

      if (itemTitleModel.get('show')) {
        var titleOffsetCenter = itemTitleModel.get('offsetCenter');
        var titleX = posInfo.cx + parsePercent$1(titleOffsetCenter[0], posInfo.r);
        var titleY = posInfo.cy + parsePercent$1(titleOffsetCenter[1], posInfo.r);
        var labelEl = newTitleEls[idx];
        labelEl.attr({
          z2: showPointerAbove ? 0 : 2,
          style: createTextStyle(itemTitleModel, {
            x: titleX,
            y: titleY,
            text: data.getName(idx),
            align: 'center',
            verticalAlign: 'middle'
          }, {
            inheritColor: autoColor
          })
        });
        itemGroup.add(labelEl);
      }

      var itemDetailModel = itemModel.getModel('detail');

      if (itemDetailModel.get('show')) {
        var detailOffsetCenter = itemDetailModel.get('offsetCenter');
        var detailX = posInfo.cx + parsePercent$1(detailOffsetCenter[0], posInfo.r);
        var detailY = posInfo.cy + parsePercent$1(detailOffsetCenter[1], posInfo.r);
        var width = parsePercent$1(itemDetailModel.get('width'), posInfo.r);
        var height = parsePercent$1(itemDetailModel.get('height'), posInfo.r);
        var detailColor = seriesModel.get(['progress', 'show']) ? data.getItemVisual(idx, 'style').fill : autoColor;
        var labelEl = newDetailEls[idx];
        var formatter_1 = itemDetailModel.get('formatter');
        labelEl.attr({
          z2: showPointerAbove ? 0 : 2,
          style: createTextStyle(itemDetailModel, {
            x: detailX,
            y: detailY,
            text: formatLabel(value, formatter_1),
            width: isNaN(width) ? null : width,
            height: isNaN(height) ? null : height,
            align: 'center',
            verticalAlign: 'middle'
          }, {
            inheritColor: detailColor
          })
        });
        setLabelValueAnimation(labelEl, {
          normal: itemDetailModel
        }, value, function (value) {
          return formatLabel(value, formatter_1);
        });
        hasAnimation && animateLabelValue(labelEl, idx, data, seriesModel, {
          getFormattedLabel: function (labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
            return formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
          }
        });
        itemGroup.add(labelEl);
      }

      contentGroup.add(itemGroup);
    });
    this.group.add(contentGroup);
    this._titleEls = newTitleEls;
    this._detailEls = newDetailEls;
  };

  GaugeView.type = 'gauge';
  return GaugeView;
}(ChartView);

var GaugeSeriesModel =
/** @class */
function (_super) {
  __extends$1(GaugeSeriesModel, _super);

  function GaugeSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GaugeSeriesModel.type;
    _this.visualStyleAccessPath = 'itemStyle';
    return _this;
  }

  GaugeSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesDataSimply(this, ['value']);
  };

  GaugeSeriesModel.type = 'series.gauge';
  GaugeSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    // 默认全局居中
    center: ['50%', '50%'],
    legendHoverLink: true,
    radius: '75%',
    startAngle: 225,
    endAngle: -45,
    clockwise: true,
    // 最小值
    min: 0,
    // 最大值
    max: 100,
    // 分割段数，默认为10
    splitNumber: 10,
    // 坐标轴线
    axisLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      roundCap: false,
      lineStyle: {
        color: [[1, '#E6EBF8']],
        width: 10
      }
    },
    // 坐标轴线
    progress: {
      // 默认显示，属性show控制显示与否
      show: false,
      overlap: true,
      width: 10,
      roundCap: false,
      clip: true
    },
    // 分隔线
    splitLine: {
      // 默认显示，属性show控制显示与否
      show: true,
      // 属性length控制线长
      length: 10,
      distance: 10,
      // 属性lineStyle（详见lineStyle）控制线条样式
      lineStyle: {
        color: '#63677A',
        width: 3,
        type: 'solid'
      }
    },
    // 坐标轴小标记
    axisTick: {
      // 属性show控制显示与否，默认不显示
      show: true,
      // 每份split细分多少段
      splitNumber: 5,
      // 属性length控制线长
      length: 6,
      distance: 10,
      // 属性lineStyle控制线条样式
      lineStyle: {
        color: '#63677A',
        width: 1,
        type: 'solid'
      }
    },
    axisLabel: {
      show: true,
      distance: 15,
      // formatter: null,
      color: '#464646',
      fontSize: 12,
      rotate: 0
    },
    pointer: {
      icon: null,
      offsetCenter: [0, 0],
      show: true,
      showAbove: true,
      length: '60%',
      width: 6,
      keepAspect: false
    },
    anchor: {
      show: false,
      showAbove: false,
      size: 6,
      icon: 'circle',
      offsetCenter: [0, 0],
      keepAspect: false,
      itemStyle: {
        color: '#fff',
        borderWidth: 0,
        borderColor: '#5470c6'
      }
    },
    title: {
      show: true,
      // x, y，单位px
      offsetCenter: [0, '20%'],
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#464646',
      fontSize: 16,
      valueAnimation: false
    },
    detail: {
      show: true,
      backgroundColor: 'rgba(0,0,0,0)',
      borderWidth: 0,
      borderColor: '#ccc',
      width: 100,
      height: null,
      padding: [5, 10],
      // x, y，单位px
      offsetCenter: [0, '40%'],
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#464646',
      fontSize: 30,
      fontWeight: 'bold',
      lineHeight: 30,
      valueAnimation: false
    }
  };
  return GaugeSeriesModel;
}(SeriesModel);

function install$e(registers) {
  registers.registerChartView(GaugeView);
  registers.registerSeriesModel(GaugeSeriesModel);
}

var opacityAccessPath = ['itemStyle', 'opacity'];
/**
 * Piece of pie including Sector, Label, LabelLine
 */

var FunnelPiece =
/** @class */
function (_super) {
  __extends$1(FunnelPiece, _super);

  function FunnelPiece(data, idx) {
    var _this = _super.call(this) || this;

    var polygon = _this;
    var labelLine = new Polyline();
    var text = new ZRText();
    polygon.setTextContent(text);

    _this.setTextGuideLine(labelLine);

    _this.updateData(data, idx, true);

    return _this;
  }

  FunnelPiece.prototype.updateData = function (data, idx, firstCreate) {
    var polygon = this;
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var emphasisModel = itemModel.getModel('emphasis');
    var opacity = itemModel.get(opacityAccessPath);
    opacity = opacity == null ? 1 : opacity;

    if (!firstCreate) {
      saveOldStyle(polygon);
    } // Update common style


    polygon.useStyle(data.getItemVisual(idx, 'style'));
    polygon.style.lineJoin = 'round';

    if (firstCreate) {
      polygon.setShape({
        points: layout.points
      });
      polygon.style.opacity = 0;
      initProps(polygon, {
        style: {
          opacity: opacity
        }
      }, seriesModel, idx);
    } else {
      updateProps(polygon, {
        style: {
          opacity: opacity
        },
        shape: {
          points: layout.points
        }
      }, seriesModel, idx);
    }

    setStatesStylesFromModel(polygon, itemModel);

    this._updateLabel(data, idx);

    toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  FunnelPiece.prototype._updateLabel = function (data, idx) {
    var polygon = this;
    var labelLine = this.getTextGuideLine();
    var labelText = polygon.getTextContent();
    var seriesModel = data.hostModel;
    var itemModel = data.getItemModel(idx);
    var layout = data.getItemLayout(idx);
    var labelLayout = layout.label;
    var style = data.getItemVisual(idx, 'style');
    var visualColor = style.fill;
    setLabelStyle( // position will not be used in setLabelStyle
    labelText, getLabelStatesModels(itemModel), {
      labelFetcher: data.hostModel,
      labelDataIndex: idx,
      defaultOpacity: style.opacity,
      defaultText: data.getName(idx)
    }, {
      normal: {
        align: labelLayout.textAlign,
        verticalAlign: labelLayout.verticalAlign
      }
    });
    polygon.setTextConfig({
      local: true,
      inside: !!labelLayout.inside,
      insideStroke: visualColor,
      // insideFill: 'auto',
      outsideFill: visualColor
    });
    var linePoints = labelLayout.linePoints;
    labelLine.setShape({
      points: linePoints
    });
    polygon.textGuideLineConfig = {
      anchor: linePoints ? new Point(linePoints[0][0], linePoints[0][1]) : null
    }; // Make sure update style on labelText after setLabelStyle.
    // Because setLabelStyle will replace a new style on it.

    updateProps(labelText, {
      style: {
        x: labelLayout.x,
        y: labelLayout.y
      }
    }, seriesModel, idx);
    labelText.attr({
      rotation: labelLayout.rotation,
      originX: labelLayout.x,
      originY: labelLayout.y,
      z2: 10
    });
    setLabelLineStyle(polygon, getLabelLineStatesModels(itemModel), {
      // Default use item visual color
      stroke: visualColor
    });
  };

  return FunnelPiece;
}(Polygon);

var FunnelView =
/** @class */
function (_super) {
  __extends$1(FunnelView, _super);

  function FunnelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = FunnelView.type;
    _this.ignoreLabelLineUpdate = true;
    return _this;
  }

  FunnelView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    data.diff(oldData).add(function (idx) {
      var funnelPiece = new FunnelPiece(data, idx);
      data.setItemGraphicEl(idx, funnelPiece);
      group.add(funnelPiece);
    }).update(function (newIdx, oldIdx) {
      var piece = oldData.getItemGraphicEl(oldIdx);
      piece.updateData(data, newIdx);
      group.add(piece);
      data.setItemGraphicEl(newIdx, piece);
    }).remove(function (idx) {
      var piece = oldData.getItemGraphicEl(idx);
      removeElementWithFadeOut(piece, seriesModel, idx);
    }).execute();
    this._data = data;
  };

  FunnelView.prototype.remove = function () {
    this.group.removeAll();
    this._data = null;
  };

  FunnelView.prototype.dispose = function () {};

  FunnelView.type = 'funnel';
  return FunnelView;
}(ChartView);

var FunnelSeriesModel =
/** @class */
function (_super) {
  __extends$1(FunnelSeriesModel, _super);

  function FunnelSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = FunnelSeriesModel.type;
    return _this;
  }

  FunnelSeriesModel.prototype.init = function (option) {
    _super.prototype.init.apply(this, arguments); // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this)); // Extend labelLine emphasis

    this._defaultLabelLine(option);
  };

  FunnelSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesDataSimply(this, {
      coordDimensions: ['value'],
      encodeDefaulter: curry(makeSeriesEncodeForNameBased, this)
    });
  };

  FunnelSeriesModel.prototype._defaultLabelLine = function (option) {
    // Extend labelLine emphasis
    defaultEmphasis(option, 'labelLine', ['show']);
    var labelLineNormalOpt = option.labelLine;
    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`

    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
  }; // Overwrite


  FunnelSeriesModel.prototype.getDataParams = function (dataIndex) {
    var data = this.getData();

    var params = _super.prototype.getDataParams.call(this, dataIndex);

    var valueDim = data.mapDimension('value');
    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0

    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
    params.$vars.push('percent');
    return params;
  };

  FunnelSeriesModel.type = 'series.funnel';
  FunnelSeriesModel.defaultOption = {
    // zlevel: 0,                  // 一级层叠
    z: 2,
    legendHoverLink: true,
    colorBy: 'data',
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    // 默认取数据最小最大值
    // min: 0,
    // max: 100,
    minSize: '0%',
    maxSize: '100%',
    sort: 'descending',
    orient: 'vertical',
    gap: 0,
    funnelAlign: 'center',
    label: {
      show: true,
      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    labelLine: {
      show: true,
      length: 20,
      lineStyle: {
        // color: 各异,
        width: 1
      }
    },
    itemStyle: {
      // color: 各异,
      borderColor: '#fff',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return FunnelSeriesModel;
}(SeriesModel);

function getViewRect$3(seriesModel, api) {
  return getLayoutRect$1(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function getSortedIndices(data, sort) {
  var valueDim = data.mapDimension('value');
  var valueArr = data.mapArray(valueDim, function (val) {
    return val;
  });
  var indices = [];
  var isAscending = sort === 'ascending';

  for (var i = 0, len = data.count(); i < len; i++) {
    indices[i] = i;
  } // Add custom sortable function & none sortable opetion by "options.sort"


  if (isFunction$3(sort)) {
    indices.sort(sort);
  } else if (sort !== 'none') {
    indices.sort(function (a, b) {
      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
  }

  return indices;
}

function labelLayout(data) {
  var seriesModel = data.hostModel;
  var orient = seriesModel.get('orient');
  data.each(function (idx) {
    var itemModel = data.getItemModel(idx);
    var labelModel = itemModel.getModel('label');
    var labelPosition = labelModel.get('position');
    var labelLineModel = itemModel.getModel('labelLine');
    var layout = data.getItemLayout(idx);
    var points = layout.points;
    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
    var textAlign;
    var textX;
    var textY;
    var linePoints;

    if (isLabelInside) {
      if (labelPosition === 'insideLeft') {
        textX = (points[0][0] + points[3][0]) / 2 + 5;
        textY = (points[0][1] + points[3][1]) / 2;
        textAlign = 'left';
      } else if (labelPosition === 'insideRight') {
        textX = (points[1][0] + points[2][0]) / 2 - 5;
        textY = (points[1][1] + points[2][1]) / 2;
        textAlign = 'right';
      } else {
        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
        textAlign = 'center';
      }

      linePoints = [[textX, textY], [textX, textY]];
    } else {
      var x1 = void 0;
      var y1 = void 0;
      var x2 = void 0;
      var y2 = void 0;
      var labelLineLen = labelLineModel.get('length');

      if (process.env.NODE_ENV !== 'production') {
        if (orient === 'vertical' && ['top', 'bottom'].indexOf(labelPosition) > -1) {
          labelPosition = 'left';
          console.warn('Position error: Funnel chart on vertical orient dose not support top and bottom.');
        }

        if (orient === 'horizontal' && ['left', 'right'].indexOf(labelPosition) > -1) {
          labelPosition = 'bottom';
          console.warn('Position error: Funnel chart on horizontal orient dose not support left and right.');
        }
      }

      if (labelPosition === 'left') {
        // Left side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        x2 = x1 - labelLineLen;
        textX = x2 - 5;
        textAlign = 'right';
      } else if (labelPosition === 'right') {
        // Right side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        x2 = x1 + labelLineLen;
        textX = x2 + 5;
        textAlign = 'left';
      } else if (labelPosition === 'top') {
        // Top side
        x1 = (points[3][0] + points[0][0]) / 2;
        y1 = (points[3][1] + points[0][1]) / 2;
        y2 = y1 - labelLineLen;
        textY = y2 - 5;
        textAlign = 'center';
      } else if (labelPosition === 'bottom') {
        // Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;
        y2 = y1 + labelLineLen;
        textY = y2 + 5;
        textAlign = 'center';
      } else if (labelPosition === 'rightTop') {
        // RightTop side
        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'top';
        }
      } else if (labelPosition === 'rightBottom') {
        // RightBottom side
        x1 = points[2][0];
        y1 = points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'bottom';
        }
      } else if (labelPosition === 'leftTop') {
        // LeftTop side
        x1 = points[0][0];
        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];

        if (orient === 'horizontal') {
          y2 = y1 - labelLineLen;
          textY = y2 - 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else if (labelPosition === 'leftBottom') {
        // LeftBottom side
        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 - labelLineLen;
          textX = x2 - 5;
          textAlign = 'right';
        }
      } else {
        // Right side or Bottom side
        x1 = (points[1][0] + points[2][0]) / 2;
        y1 = (points[1][1] + points[2][1]) / 2;

        if (orient === 'horizontal') {
          y2 = y1 + labelLineLen;
          textY = y2 + 5;
          textAlign = 'center';
        } else {
          x2 = x1 + labelLineLen;
          textX = x2 + 5;
          textAlign = 'left';
        }
      }

      if (orient === 'horizontal') {
        x2 = x1;
        textX = x2;
      } else {
        y2 = y1;
        textY = y2;
      }

      linePoints = [[x1, y1], [x2, y2]];
    }

    layout.label = {
      linePoints: linePoints,
      x: textX,
      y: textY,
      verticalAlign: 'middle',
      textAlign: textAlign,
      inside: isLabelInside
    };
  });
}

function funnelLayout(ecModel, api) {
  ecModel.eachSeriesByType('funnel', function (seriesModel) {
    var data = seriesModel.getData();
    var valueDim = data.mapDimension('value');
    var sort = seriesModel.get('sort');
    var viewRect = getViewRect$3(seriesModel, api);
    var orient = seriesModel.get('orient');
    var viewWidth = viewRect.width;
    var viewHeight = viewRect.height;
    var indices = getSortedIndices(data, sort);
    var x = viewRect.x;
    var y = viewRect.y;
    var sizeExtent = orient === 'horizontal' ? [parsePercent$1(seriesModel.get('minSize'), viewHeight), parsePercent$1(seriesModel.get('maxSize'), viewHeight)] : [parsePercent$1(seriesModel.get('minSize'), viewWidth), parsePercent$1(seriesModel.get('maxSize'), viewWidth)];
    var dataExtent = data.getDataExtent(valueDim);
    var min = seriesModel.get('min');
    var max = seriesModel.get('max');

    if (min == null) {
      min = Math.min(dataExtent[0], 0);
    }

    if (max == null) {
      max = dataExtent[1];
    }

    var funnelAlign = seriesModel.get('funnelAlign');
    var gap = seriesModel.get('gap');
    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();

    var getLinePoints = function (idx, offset) {
      // End point index is data.count() and we assign it 0
      if (orient === 'horizontal') {
        var val_1 = data.get(valueDim, idx) || 0;
        var itemHeight = linearMap(val_1, [min, max], sizeExtent, true);
        var y0 = void 0;

        switch (funnelAlign) {
          case 'top':
            y0 = y;
            break;

          case 'center':
            y0 = y + (viewHeight - itemHeight) / 2;
            break;

          case 'bottom':
            y0 = y + (viewHeight - itemHeight);
            break;
        }

        return [[offset, y0], [offset, y0 + itemHeight]];
      }

      var val = data.get(valueDim, idx) || 0;
      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
      var x0;

      switch (funnelAlign) {
        case 'left':
          x0 = x;
          break;

        case 'center':
          x0 = x + (viewWidth - itemWidth) / 2;
          break;

        case 'right':
          x0 = x + viewWidth - itemWidth;
          break;
      }

      return [[x0, offset], [x0 + itemWidth, offset]];
    };

    if (sort === 'ascending') {
      // From bottom to top
      itemSize = -itemSize;
      gap = -gap;

      if (orient === 'horizontal') {
        x += viewWidth;
      } else {
        y += viewHeight;
      }

      indices = indices.reverse();
    }

    for (var i = 0; i < indices.length; i++) {
      var idx = indices[i];
      var nextIdx = indices[i + 1];
      var itemModel = data.getItemModel(idx);

      if (orient === 'horizontal') {
        var width = itemModel.get(['itemStyle', 'width']);

        if (width == null) {
          width = itemSize;
        } else {
          width = parsePercent$1(width, viewWidth);

          if (sort === 'ascending') {
            width = -width;
          }
        }

        var start = getLinePoints(idx, x);
        var end = getLinePoints(nextIdx, x + width);
        x += width + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      } else {
        var height = itemModel.get(['itemStyle', 'height']);

        if (height == null) {
          height = itemSize;
        } else {
          height = parsePercent$1(height, viewHeight);

          if (sort === 'ascending') {
            height = -height;
          }
        }

        var start = getLinePoints(idx, y);
        var end = getLinePoints(nextIdx, y + height);
        y += height + gap;
        data.setItemLayout(idx, {
          points: start.concat(end.slice().reverse())
        });
      }
    }

    labelLayout(data);
  });
}

function install$f(registers) {
  registers.registerChartView(FunnelView);
  registers.registerSeriesModel(FunnelSeriesModel);
  registers.registerLayout(funnelLayout);
  registers.registerProcessor(dataFilter('funnel'));
}

var DEFAULT_SMOOTH = 0.3;

var ParallelView =
/** @class */
function (_super) {
  __extends$1(ParallelView, _super);

  function ParallelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelView.type;
    _this._dataGroup = new Group$1();
    _this._initialized = false;
    return _this;
  }

  ParallelView.prototype.init = function () {
    this.group.add(this._dataGroup);
  };
  /**
   * @override
   */


  ParallelView.prototype.render = function (seriesModel, ecModel, api, payload) {
    // Clear previously rendered progressive elements.
    this._progressiveEls = null;
    var dataGroup = this._dataGroup;
    var data = seriesModel.getData();
    var oldData = this._data;
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope$2(seriesModel);
    data.diff(oldData).add(add).update(update).remove(remove).execute();

    function add(newDataIndex) {
      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function update(newDataIndex, oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
      data.setItemGraphicEl(newDataIndex, line);
      updateProps(line, {
        shape: {
          points: points
        }
      }, seriesModel, newDataIndex);
      saveOldStyle(line);
      updateElCommon(line, data, newDataIndex, seriesScope);
    }

    function remove(oldDataIndex) {
      var line = oldData.getItemGraphicEl(oldDataIndex);
      dataGroup.remove(line);
    } // First create


    if (!this._initialized) {
      this._initialized = true;
      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
        // Callback will be invoked immediately if there is no animation
        setTimeout(function () {
          dataGroup.removeClipPath();
        });
      });
      dataGroup.setClipPath(clipPath);
    }

    this._data = data;
  };

  ParallelView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this._initialized = true;
    this._data = null;

    this._dataGroup.removeAll();
  };

  ParallelView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dimensions = coordSys.dimensions;
    var seriesScope = makeSeriesScope$2(seriesModel);
    var progressiveEls = this._progressiveEls = [];

    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
      line.incremental = true;
      updateElCommon(line, data, dataIndex, seriesScope);
      progressiveEls.push(line);
    }
  };

  ParallelView.prototype.remove = function () {
    this._dataGroup && this._dataGroup.removeAll();
    this._data = null;
  };

  ParallelView.type = 'parallel';
  return ParallelView;
}(ChartView);

function createGridClipShape(coordSys, seriesModel, cb) {
  var parallelModel = coordSys.model;
  var rect = coordSys.getRect();
  var rectEl = new Rect({
    shape: {
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    }
  });
  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
  rectEl.setShape(dim, 0);
  initProps(rectEl, {
    shape: {
      width: rect.width,
      height: rect.height
    }
  }, seriesModel, cb);
  return rectEl;
}

function createLinePoints(data, dataIndex, dimensions, coordSys) {
  var points = [];

  for (var i = 0; i < dimensions.length; i++) {
    var dimName = dimensions[i];
    var value = data.get(data.mapDimension(dimName), dataIndex);

    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
      points.push(coordSys.dataToPoint(value, dimName));
    }
  }

  return points;
}

function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
  var line = new Polyline({
    shape: {
      points: points
    },
    // silent: true,
    z2: 10
  });
  dataGroup.add(line);
  data.setItemGraphicEl(dataIndex, line);
  return line;
}

function makeSeriesScope$2(seriesModel) {
  var smooth = seriesModel.get('smooth', true);
  smooth === true && (smooth = DEFAULT_SMOOTH);
  smooth = numericToNumber(smooth);
  eqNaN(smooth) && (smooth = 0);
  return {
    smooth: smooth
  };
}

function updateElCommon(el, data, dataIndex, seriesScope) {
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.fill = null;
  el.setShape('smooth', seriesScope.smooth);
  var itemModel = data.getItemModel(dataIndex);
  var emphasisModel = itemModel.getModel('emphasis');
  setStatesStylesFromModel(el, itemModel, 'lineStyle');
  toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
} // function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?


function isEmptyValue(val, axisType) {
  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}

var ParallelSeriesModel =
/** @class */
function (_super) {
  __extends$1(ParallelSeriesModel, _super);

  function ParallelSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelSeriesModel.type;
    _this.visualStyleAccessPath = 'lineStyle';
    _this.visualDrawType = 'stroke';
    return _this;
  }

  ParallelSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this, {
      useEncodeDefaulter: bind(makeDefaultEncode, null, this)
    });
  };
  /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */


  ParallelSeriesModel.prototype.getRawIndicesByActiveState = function (activeState) {
    var coordSys = this.coordinateSystem;
    var data = this.getData();
    var indices = [];
    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
      if (activeState === theActiveState) {
        indices.push(data.getRawIndex(dataIndex));
      }
    });
    return indices;
  };

  ParallelSeriesModel.type = 'series.parallel';
  ParallelSeriesModel.dependencies = ['parallel'];
  ParallelSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'parallel',
    parallelIndex: 0,
    label: {
      show: false
    },
    inactiveOpacity: 0.05,
    activeOpacity: 1,
    lineStyle: {
      width: 1,
      opacity: 0.45,
      type: 'solid'
    },
    emphasis: {
      label: {
        show: false
      }
    },
    progressive: 500,
    smooth: false,
    animationEasing: 'linear'
  };
  return ParallelSeriesModel;
}(SeriesModel);

function makeDefaultEncode(seriesModel) {
  // The mapping of parallelAxis dimension to data dimension can
  // be specified in parallelAxis.option.dim. For example, if
  // parallelAxis.option.dim is 'dim3', it mapping to the third
  // dimension of data. But `data.encode` has higher priority.
  // Moreover, parallelModel.dimension should not be regarded as data
  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));

  if (!parallelModel) {
    return;
  }

  var encodeDefine = {};
  each(parallelModel.dimensions, function (axisDim) {
    var dataDimIndex = convertDimNameToNumber(axisDim);
    encodeDefine[axisDim] = dataDimIndex;
  });
  return encodeDefine;
}

function convertDimNameToNumber(dimName) {
  return +dimName.replace('dim', '');
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var opacityAccessPath$1 = ['lineStyle', 'opacity'];
var parallelVisual = {
  seriesType: 'parallel',
  reset: function (seriesModel, ecModel) {
    var coordSys = seriesModel.coordinateSystem;
    var opacityMap = {
      normal: seriesModel.get(['lineStyle', 'opacity']),
      active: seriesModel.get('activeOpacity'),
      inactive: seriesModel.get('inactiveOpacity')
    };
    return {
      progress: function (params, data) {
        coordSys.eachActiveState(data, function (activeState, dataIndex) {
          var opacity = opacityMap[activeState];

          if (activeState === 'normal' && data.hasItemOption) {
            var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath$1, true);
            itemOpacity != null && (opacity = itemOpacity);
          }

          var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
          existsStyle.opacity = opacity;
        }, params.start, params.end);
      }
    };
  }
};

function parallelPreprocessor(option) {
  createParallelIfNeeded(option);
  mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */

function createParallelIfNeeded(option) {
  if (option.parallel) {
    return;
  }

  var hasParallelSeries = false;
  each(option.series, function (seriesOpt) {
    if (seriesOpt && seriesOpt.type === 'parallel') {
      hasParallelSeries = true;
    }
  });

  if (hasParallelSeries) {
    option.parallel = [{}];
  }
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */


function mergeAxisOptionFromParallel(option) {
  var axes = normalizeToArray(option.parallelAxis);
  each(axes, function (axisOption) {
    if (!isObject$2(axisOption)) {
      return;
    }

    var parallelIndex = axisOption.parallelIndex || 0;
    var parallelOption = normalizeToArray(option.parallel)[parallelIndex];

    if (parallelOption && parallelOption.parallelAxisDefault) {
      merge$1(axisOption, parallelOption.parallelAxisDefault, false);
    }
  });
}

var CLICK_THRESHOLD = 5; // > 4

var ParallelView$1 =
/** @class */
function (_super) {
  __extends$1(ParallelView, _super);

  function ParallelView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelView.type;
    return _this;
  }

  ParallelView.prototype.render = function (parallelModel, ecModel, api) {
    this._model = parallelModel;
    this._api = api;

    if (!this._handlers) {
      this._handlers = {};
      each(handlers, function (handler, eventName) {
        api.getZr().on(eventName, this._handlers[eventName] = bind(handler, this));
      }, this);
    }

    createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
  };

  ParallelView.prototype.dispose = function (ecModel, api) {
    clear(this, '_throttledDispatchExpand');
    each(this._handlers, function (handler, eventName) {
      api.getZr().off(eventName, handler);
    });
    this._handlers = null;
  };
  /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */


  ParallelView.prototype._throttledDispatchExpand = function (opt) {
    this._dispatchExpand(opt);
  };
  /**
   * @internal
   */


  ParallelView.prototype._dispatchExpand = function (opt) {
    opt && this._api.dispatchAction(extend({
      type: 'parallelAxisExpand'
    }, opt));
  };

  ParallelView.type = 'parallel';
  return ParallelView;
}(ComponentView);

var handlers = {
  mousedown: function (e) {
    if (checkTrigger(this, 'click')) {
      this._mouseDownPoint = [e.offsetX, e.offsetY];
    }
  },
  mouseup: function (e) {
    var mouseDownPoint = this._mouseDownPoint;

    if (checkTrigger(this, 'click') && mouseDownPoint) {
      var point = [e.offsetX, e.offsetY];
      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);

      if (dist > CLICK_THRESHOLD) {
        return;
      }

      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);

      result.behavior !== 'none' && this._dispatchExpand({
        axisExpandWindow: result.axisExpandWindow
      });
    }

    this._mouseDownPoint = null;
  },
  mousemove: function (e) {
    // Should do nothing when brushing.
    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
      return;
    }

    var model = this._model;
    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
    var behavior = result.behavior;
    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));

    this._throttledDispatchExpand(behavior === 'none' ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
    : {
      axisExpandWindow: result.axisExpandWindow,
      // Jumping uses animation, and sliding suppresses animation.
      animation: behavior === 'jump' ? null : {
        duration: 0 // Disable animation.

      }
    });
  }
};

function checkTrigger(view, triggerOn) {
  var model = view._model;
  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}

var ParallelModel =
/** @class */
function (_super) {
  __extends$1(ParallelModel, _super);

  function ParallelModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelModel.type;
    return _this;
  }

  ParallelModel.prototype.init = function () {
    _super.prototype.init.apply(this, arguments);

    this.mergeOption({});
  };

  ParallelModel.prototype.mergeOption = function (newOption) {
    var thisOption = this.option;
    newOption && merge$1(thisOption, newOption, true);

    this._initDimensions();
  };
  /**
   * Whether series or axis is in this coordinate system.
   */


  ParallelModel.prototype.contains = function (model, ecModel) {
    var parallelIndex = model.get('parallelIndex');
    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
  };

  ParallelModel.prototype.setAxisExpand = function (opt) {
    each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
      if (opt.hasOwnProperty(name)) {
        // @ts-ignore FIXME: why "never" inferred in this.option[name]?
        this.option[name] = opt[name];
      }
    }, this);
  };

  ParallelModel.prototype._initDimensions = function () {
    var dimensions = this.dimensions = [];
    var parallelAxisIndex = this.parallelAxisIndex = [];
    var axisModels = filter(this.ecModel.queryComponents({
      mainType: 'parallelAxis'
    }), function (axisModel) {
      // Can not use this.contains here, because
      // initialization has not been completed yet.
      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
    }, this);
    each(axisModels, function (axisModel) {
      dimensions.push('dim' + axisModel.get('dim'));
      parallelAxisIndex.push(axisModel.componentIndex);
    });
  };

  ParallelModel.type = 'parallel';
  ParallelModel.dependencies = ['parallelAxis'];
  ParallelModel.layoutMode = 'box';
  ParallelModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    left: 80,
    top: 60,
    right: 80,
    bottom: 60,
    // width: {totalWidth} - left - right,
    // height: {totalHeight} - top - bottom,
    layout: 'horizontal',
    // FIXME
    // naming?
    axisExpandable: false,
    axisExpandCenter: null,
    axisExpandCount: 0,
    axisExpandWidth: 50,
    axisExpandRate: 17,
    axisExpandDebounce: 50,
    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
    // Do not doc to user until necessary.
    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
    axisExpandTriggerOn: 'click',
    parallelAxisDefault: null
  };
  return ParallelModel;
}(ComponentModel);

var ParallelAxis =
/** @class */
function (_super) {
  __extends$1(ParallelAxis, _super);

  function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    _this.axisIndex = axisIndex;
    return _this;
  }

  ParallelAxis.prototype.isHorizontal = function () {
    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
  };

  return ParallelAxis;
}(Axis);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/

/**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */
function sliderMove(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
  delta = delta || 0;
  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.

  if (minSpan != null) {
    minSpan = restrict(minSpan, [0, extentSpan]);
  }

  if (maxSpan != null) {
    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
  }

  if (handleIndex === 'all') {
    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
    handleSpan = restrict(handleSpan, [0, extentSpan]);
    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
    handleIndex = 0;
  }

  handleEnds[0] = restrict(handleEnds[0], extent);
  handleEnds[1] = restrict(handleEnds[1], extent);
  var originalDistSign = getSpanSign(handleEnds, handleIndex);
  handleEnds[handleIndex] += delta; // Restrict in extent.

  var extentMinSpan = minSpan || 0;
  var realExtent = extent.slice();
  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.

  var currDistSign;
  currDistSign = getSpanSign(handleEnds, handleIndex);

  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
    // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
  } // Shrink span.


  currDistSign = getSpanSign(handleEnds, handleIndex);

  if (maxSpan != null && currDistSign.span > maxSpan) {
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
  }

  return handleEnds;
}

function getSpanSign(handleEnds, handleIndex) {
  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
  // is at left of handleEnds[1] for non-cross case.

  return {
    span: Math.abs(dist),
    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
  };
}

function restrict(value, extend) {
  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}

var each$5 = each;
var mathMin$8 = Math.min;
var mathMax$8 = Math.max;
var mathFloor$1 = Math.floor;
var mathCeil$1 = Math.ceil;
var round$6 = round$3;
var PI$7 = Math.PI;

var Parallel =
/** @class */
function () {
  function Parallel(parallelModel, ecModel, api) {
    this.type = 'parallel';
    /**
     * key: dimension
     */

    this._axesMap = createHashMap();
    /**
     * key: dimension
     * value: {position: [], rotation, }
     */

    this._axesLayout = {};
    this.dimensions = parallelModel.dimensions;
    this._model = parallelModel;

    this._init(parallelModel, ecModel, api);
  }

  Parallel.prototype._init = function (parallelModel, ecModel, api) {
    var dimensions = parallelModel.dimensions;
    var parallelAxisIndex = parallelModel.parallelAxisIndex;
    each$5(dimensions, function (dim, idx) {
      var axisIndex = parallelAxisIndex[idx];
      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);

      var axis = this._axesMap.set(dim, new ParallelAxis(dim, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));

      var isCategory = axis.type === 'category';
      axis.onBand = isCategory && axisModel.get('boundaryGap');
      axis.inverse = axisModel.get('inverse'); // Injection

      axisModel.axis = axis;
      axis.model = axisModel;
      axis.coordinateSystem = axisModel.coordinateSystem = this;
    }, this);
  };
  /**
   * Update axis scale after data processed
   */


  Parallel.prototype.update = function (ecModel, api) {
    this._updateAxesFromSeries(this._model, ecModel);
  };

  Parallel.prototype.containPoint = function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var axisBase = layoutInfo.axisBase;
    var layoutBase = layoutInfo.layoutBase;
    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var pAxis = point[1 - pixelDimIndex];
    var pLayout = point[pixelDimIndex];
    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
  };

  Parallel.prototype.getModel = function () {
    return this._model;
  };
  /**
   * Update properties from series
   */


  Parallel.prototype._updateAxesFromSeries = function (parallelModel, ecModel) {
    ecModel.eachSeries(function (seriesModel) {
      if (!parallelModel.contains(seriesModel, ecModel)) {
        return;
      }

      var data = seriesModel.getData();
      each$5(this.dimensions, function (dim) {
        var axis = this._axesMap.get(dim);

        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
        niceScaleExtent(axis.scale, axis.model);
      }, this);
    }, this);
  };
  /**
   * Resize the parallel coordinate system.
   */


  Parallel.prototype.resize = function (parallelModel, api) {
    this._rect = getLayoutRect$1(parallelModel.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._layoutAxes();
  };

  Parallel.prototype.getRect = function () {
    return this._rect;
  };

  Parallel.prototype._makeLayoutInfo = function () {
    var parallelModel = this._model;
    var rect = this._rect;
    var xy = ['x', 'y'];
    var wh = ['width', 'height'];
    var layout = parallelModel.get('layout');
    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
    var layoutLength = rect[wh[pixelDimIndex]];
    var layoutExtent = [0, layoutLength];
    var axisCount = this.dimensions.length;
    var axisExpandWidth = restrict$1(parallelModel.get('axisExpandWidth'), layoutExtent);
    var axisExpandCount = restrict$1(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
    // where collapsed axes should be overlapped.

    var axisExpandWindow = parallelModel.get('axisExpandWindow');
    var winSize;

    if (!axisExpandWindow) {
      winSize = restrict$1(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor$1(axisCount / 2);
      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    } else {
      winSize = restrict$1(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
    }

    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.

    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].

    var winInnerIndices = [mathFloor$1(round$6(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil$1(round$6(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.

    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
    return {
      layout: layout,
      pixelDimIndex: pixelDimIndex,
      layoutBase: rect[xy[pixelDimIndex]],
      layoutLength: layoutLength,
      axisBase: rect[xy[1 - pixelDimIndex]],
      axisLength: rect[wh[1 - pixelDimIndex]],
      axisExpandable: axisExpandable,
      axisExpandWidth: axisExpandWidth,
      axisCollapseWidth: axisCollapseWidth,
      axisExpandWindow: axisExpandWindow,
      axisCount: axisCount,
      winInnerIndices: winInnerIndices,
      axisExpandWindow0Pos: axisExpandWindow0Pos
    };
  };

  Parallel.prototype._layoutAxes = function () {
    var rect = this._rect;
    var axes = this._axesMap;
    var dimensions = this.dimensions;

    var layoutInfo = this._makeLayoutInfo();

    var layout = layoutInfo.layout;
    axes.each(function (axis) {
      var axisExtent = [0, layoutInfo.axisLength];
      var idx = axis.inverse ? 1 : 0;
      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
    });
    each$5(dimensions, function (dim, idx) {
      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
      var positionTable = {
        horizontal: {
          x: posInfo.position,
          y: layoutInfo.axisLength
        },
        vertical: {
          x: 0,
          y: posInfo.position
        }
      };
      var rotationTable = {
        horizontal: PI$7 / 2,
        vertical: 0
      };
      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
      var rotation = rotationTable[layout];
      var transform = create$1();
      rotate(transform, transform, rotation);
      translate(transform, transform, position); // TODO
      // tick layout info
      // TODO
      // update dimensions info based on axis order.

      this._axesLayout[dim] = {
        position: position,
        rotation: rotation,
        transform: transform,
        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
        axisLabelShow: posInfo.axisLabelShow,
        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
        tickDirection: 1,
        labelDirection: 1
      };
    }, this);
  };
  /**
   * Get axis by dim.
   */


  Parallel.prototype.getAxis = function (dim) {
    return this._axesMap.get(dim);
  };
  /**
   * Convert a dim value of a single item of series data to Point.
   */


  Parallel.prototype.dataToPoint = function (value, dim) {
    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
  };
  /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */


  Parallel.prototype.eachActiveState = function (data, callback, start, end) {
    start == null && (start = 0);
    end == null && (end = data.count());
    var axesMap = this._axesMap;
    var dimensions = this.dimensions;
    var dataDimensions = [];
    var axisModels = [];
    each(dimensions, function (axisDim) {
      dataDimensions.push(data.mapDimension(axisDim));
      axisModels.push(axesMap.get(axisDim).model);
    });
    var hasActiveSet = this.hasAxisBrushed();

    for (var dataIndex = start; dataIndex < end; dataIndex++) {
      var activeState = void 0;

      if (!hasActiveSet) {
        activeState = 'normal';
      } else {
        activeState = 'active';
        var values = data.getValues(dataDimensions, dataIndex);

        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
          var state = axisModels[j].getActiveState(values[j]);

          if (state === 'inactive') {
            activeState = 'inactive';
            break;
          }
        }
      }

      callback(activeState, dataIndex);
    }
  };
  /**
   * Whether has any activeSet.
   */


  Parallel.prototype.hasAxisBrushed = function () {
    var dimensions = this.dimensions;
    var axesMap = this._axesMap;
    var hasActiveSet = false;

    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
        hasActiveSet = true;
      }
    }

    return hasActiveSet;
  };
  /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */


  Parallel.prototype.axisCoordToPoint = function (coord, dim) {
    var axisLayout = this._axesLayout[dim];
    return applyTransform$1([coord, 0], axisLayout.transform);
  };
  /**
   * Get axis layout.
   */


  Parallel.prototype.getAxisLayout = function (dim) {
    return clone(this._axesLayout[dim]);
  };
  /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */


  Parallel.prototype.getSlidedAxisExpandWindow = function (point) {
    var layoutInfo = this._makeLayoutInfo();

    var pixelDimIndex = layoutInfo.pixelDimIndex;
    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.

    if (!this.containPoint(point)) {
      return {
        behavior: 'none',
        axisExpandWindow: axisExpandWindow
      };
    } // Convert the point from global to expand coordinates.


    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
    // slided when mouse is the center area of the window.

    var delta;
    var behavior = 'slide';
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;

    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.


    var useJump = triggerArea[0] != null;

    if (axisCollapseWidth) {
      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
        behavior = 'jump';
        delta = pointCoord - winSize * triggerArea[2];
      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
        behavior = 'jump';
        delta = pointCoord - winSize * (1 - triggerArea[2]);
      } else {
        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
      }

      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
      : behavior = 'none';
    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
    else {
        var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
        var pos = extent[1] * pointCoord / winSize2;
        axisExpandWindow = [mathMax$8(0, pos - winSize2 / 2)];
        axisExpandWindow[1] = mathMin$8(extent[1], axisExpandWindow[0] + winSize2);
        axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
      }

    return {
      axisExpandWindow: axisExpandWindow,
      behavior: behavior
    };
  };

  return Parallel;
}();

function restrict$1(len, extent) {
  return mathMin$8(mathMax$8(len, extent[0]), extent[1]);
}

function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
  return {
    position: step * axisIndex,
    axisNameAvailableWidth: step,
    axisLabelShow: true
  };
}

function layoutAxisWithExpand(axisIndex, layoutInfo) {
  var layoutLength = layoutInfo.layoutLength;
  var axisExpandWidth = layoutInfo.axisExpandWidth;
  var axisCount = layoutInfo.axisCount;
  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
  var winInnerIndices = layoutInfo.winInnerIndices;
  var position;
  var axisNameAvailableWidth = axisCollapseWidth;
  var axisLabelShow = false;
  var nameTruncateMaxWidth;

  if (axisIndex < winInnerIndices[0]) {
    position = axisIndex * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  } else if (axisIndex <= winInnerIndices[1]) {
    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
    axisNameAvailableWidth = axisExpandWidth;
    axisLabelShow = true;
  } else {
    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
    nameTruncateMaxWidth = axisCollapseWidth;
  }

  return {
    position: position,
    axisNameAvailableWidth: axisNameAvailableWidth,
    axisLabelShow: axisLabelShow,
    nameTruncateMaxWidth: nameTruncateMaxWidth
  };
}

function createParallelCoordSys(ecModel, api) {
  var coordSysList = [];
  ecModel.eachComponent('parallel', function (parallelModel, idx) {
    var coordSys = new Parallel(parallelModel, ecModel, api);
    coordSys.name = 'parallel_' + idx;
    coordSys.resize(parallelModel, api);
    parallelModel.coordinateSystem = coordSys;
    coordSys.model = parallelModel;
    coordSysList.push(coordSys);
  }); // Inject the coordinateSystems into seriesModel

  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'parallel') {
      var parallelModel = seriesModel.getReferringComponents('parallel', SINGLE_REFERRING).models[0];
      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
    }
  });
  return coordSysList;
}

var parallelCoordSysCreator = {
  create: createParallelCoordSys
};

var ParallelAxisModel =
/** @class */
function (_super) {
  __extends$1(ParallelAxisModel, _super);

  function ParallelAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelAxisModel.type;
    /**
     * @readOnly
     */

    _this.activeIntervals = [];
    return _this;
  }

  ParallelAxisModel.prototype.getAreaSelectStyle = function () {
    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity'] // Option decal is in `DecalObject` but style.decal is in `PatternObject`.
    // So do not transfer decal directly.
    ])(this.getModel('areaSelectStyle'));
  };
  /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */


  ParallelAxisModel.prototype.setActiveIntervals = function (intervals) {
    var activeIntervals = this.activeIntervals = clone(intervals); // Normalize

    if (activeIntervals) {
      for (var i = activeIntervals.length - 1; i >= 0; i--) {
        asc(activeIntervals[i]);
      }
    }
  };
  /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */


  ParallelAxisModel.prototype.getActiveState = function (value) {
    var activeIntervals = this.activeIntervals;

    if (!activeIntervals.length) {
      return 'normal';
    }

    if (value == null || isNaN(+value)) {
      return 'inactive';
    } // Simple optimization


    if (activeIntervals.length === 1) {
      var interval = activeIntervals[0];

      if (interval[0] <= value && value <= interval[1]) {
        return 'active';
      }
    } else {
      for (var i = 0, len = activeIntervals.length; i < len; i++) {
        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
          return 'active';
        }
      }
    }

    return 'inactive';
  };

  return ParallelAxisModel;
}(ComponentModel);

mixin(ParallelAxisModel, AxisModelCommonMixin);

var BRUSH_PANEL_GLOBAL = true;
var mathMin$9 = Math.min;
var mathMax$9 = Math.max;
var mathPow$2 = Math.pow;
var COVER_Z = 10000;
var UNSELECT_THRESHOLD = 6;
var MIN_RESIZE_LINE_WIDTH = 6;
var MUTEX_RESOURCE_KEY = 'globalPan';
var DIRECTION_MAP = {
  w: [0, 0],
  e: [0, 1],
  n: [1, 0],
  s: [1, 1]
};
var CURSOR_MAP = {
  w: 'ew',
  e: 'ew',
  n: 'ns',
  s: 'ns',
  ne: 'nesw',
  sw: 'nesw',
  nw: 'nwse',
  se: 'nwse'
};
var DEFAULT_BRUSH_OPT = {
  brushStyle: {
    lineWidth: 2,
    stroke: 'rgba(210,219,238,0.3)',
    fill: '#D2DBEE'
  },
  transformable: true,
  brushMode: 'single',
  removeOnClick: false
};
var baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */

var BrushController =
/** @class */
function (_super) {
  __extends$1(BrushController, _super);

  function BrushController(zr) {
    var _this = _super.call(this) || this;
    /**
     * @internal
     */


    _this._track = [];
    /**
     * @internal
     */

    _this._covers = [];
    _this._handlers = {};

    if (process.env.NODE_ENV !== 'production') {
      assert(zr);
    }

    _this._zr = zr;
    _this.group = new Group$1();
    _this._uid = 'brushController_' + baseUID++;
    each(pointerHandlers, function (handler, eventName) {
      this._handlers[eventName] = bind(handler, this);
    }, _this);
    return _this;
  }
  /**
   * If set to `false`, select disabled.
   */


  BrushController.prototype.enableBrush = function (brushOption) {
    if (process.env.NODE_ENV !== 'production') {
      assert(this._mounted);
    }

    this._brushType && this._doDisableBrush();
    brushOption.brushType && this._doEnableBrush(brushOption);
    return this;
  };

  BrushController.prototype._doEnableBrush = function (brushOption) {
    var zr = this._zr; // Consider roam, which takes globalPan too.

    if (!this._enableGlobalPan) {
      take(zr, MUTEX_RESOURCE_KEY, this._uid);
    }

    each(this._handlers, function (handler, eventName) {
      zr.on(eventName, handler);
    });
    this._brushType = brushOption.brushType;
    this._brushOption = merge$1(clone(DEFAULT_BRUSH_OPT), brushOption, true);
  };

  BrushController.prototype._doDisableBrush = function () {
    var zr = this._zr;
    release(zr, MUTEX_RESOURCE_KEY, this._uid);
    each(this._handlers, function (handler, eventName) {
      zr.off(eventName, handler);
    });
    this._brushType = this._brushOption = null;
  };
  /**
   * @param panelOpts If not pass, it is global brush.
   */


  BrushController.prototype.setPanels = function (panelOpts) {
    if (panelOpts && panelOpts.length) {
      var panels_1 = this._panels = {};
      each(panelOpts, function (panelOpts) {
        panels_1[panelOpts.panelId] = clone(panelOpts);
      });
    } else {
      this._panels = null;
    }

    return this;
  };

  BrushController.prototype.mount = function (opt) {
    opt = opt || {};

    if (process.env.NODE_ENV !== 'production') {
      this._mounted = true; // should be at first.
    }

    this._enableGlobalPan = opt.enableGlobalPan;
    var thisGroup = this.group;

    this._zr.add(thisGroup);

    thisGroup.attr({
      x: opt.x || 0,
      y: opt.y || 0,
      rotation: opt.rotation || 0,
      scaleX: opt.scaleX || 1,
      scaleY: opt.scaleY || 1
    });
    this._transform = thisGroup.getLocalTransform();
    return this;
  }; // eachCover(cb, context): void {
  //     each(this._covers, cb, context);
  // }

  /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */


  BrushController.prototype.updateCovers = function (coverConfigList) {
    if (process.env.NODE_ENV !== 'production') {
      assert(this._mounted);
    }

    coverConfigList = map(coverConfigList, function (coverConfig) {
      return merge$1(clone(DEFAULT_BRUSH_OPT), coverConfig, true);
    });
    var tmpIdPrefix = '\0-brush-index-';
    var oldCovers = this._covers;
    var newCovers = this._covers = [];
    var controller = this;
    var creatingCover = this._creatingCover;
    new DataDiffer(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
    return this;

    function getKey(brushOption, index) {
      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
    }

    function oldGetKey(cover, index) {
      return getKey(cover.__brushOption, index);
    }

    function addOrUpdate(newIndex, oldIndex) {
      var newBrushInternal = coverConfigList[newIndex]; // Consider setOption in event listener of brushSelect,
      // where updating cover when creating should be forbiden.

      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
        newCovers[newIndex] = oldCovers[oldIndex];
      } else {
        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushInternal));
        updateCoverAfterCreation(controller, cover);
      }
    }

    function remove(oldIndex) {
      if (oldCovers[oldIndex] !== creatingCover) {
        controller.group.remove(oldCovers[oldIndex]);
      }
    }
  };

  BrushController.prototype.unmount = function () {
    if (process.env.NODE_ENV !== 'production') {
      if (!this._mounted) {
        return;
      }
    }

    this.enableBrush(false); // container may 'removeAll' outside.

    clearCovers(this);

    this._zr.remove(this.group);

    if (process.env.NODE_ENV !== 'production') {
      this._mounted = false; // should be at last.
    }

    return this;
  };

  BrushController.prototype.dispose = function () {
    this.unmount();
    this.off();
  };

  return BrushController;
}(Eventful);

function createCover(controller, brushOption) {
  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
  cover.__brushOption = brushOption;
  updateZ(cover, brushOption);
  controller.group.add(cover);
  return cover;
}

function endCreating(controller, creatingCover) {
  var coverRenderer = getCoverRenderer(creatingCover);

  if (coverRenderer.endCreating) {
    coverRenderer.endCreating(controller, creatingCover);
    updateZ(creatingCover, creatingCover.__brushOption);
  }

  return creatingCover;
}

function updateCoverShape(controller, cover) {
  var brushOption = cover.__brushOption;
  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}

function updateZ(cover, brushOption) {
  var z = brushOption.z;
  z == null && (z = COVER_Z);
  cover.traverse(function (el) {
    el.z = z;
    el.z2 = z; // Consider in given container.
  });
}

function updateCoverAfterCreation(controller, cover) {
  getCoverRenderer(cover).updateCommon(controller, cover);
  updateCoverShape(controller, cover);
}

function getCoverRenderer(cover) {
  return coverRenderers[cover.__brushOption.brushType];
} // return target panel or `true` (means global panel)


function getPanelByPoint(controller, e, localCursorPoint) {
  var panels = controller._panels;

  if (!panels) {
    return BRUSH_PANEL_GLOBAL; // Global panel
  }

  var panel;
  var transform = controller._transform;
  each(panels, function (pn) {
    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
  });
  return panel;
} // Return a panel or true


function getPanelByCover(controller, cover) {
  var panels = controller._panels;

  if (!panels) {
    return BRUSH_PANEL_GLOBAL; // Global panel
  }

  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
  // which is then treated as global panel.

  return panelId != null ? panels[panelId] : BRUSH_PANEL_GLOBAL;
}

function clearCovers(controller) {
  var covers = controller._covers;
  var originalLength = covers.length;
  each(covers, function (cover) {
    controller.group.remove(cover);
  }, controller);
  covers.length = 0;
  return !!originalLength;
}

function trigger$1(controller, opt) {
  var areas = map(controller._covers, function (cover) {
    var brushOption = cover.__brushOption;
    var range = clone(brushOption.range);
    return {
      brushType: brushOption.brushType,
      panelId: brushOption.panelId,
      range: range
    };
  });
  controller.trigger('brush', {
    areas: areas,
    isEnd: !!opt.isEnd,
    removeOnClick: !!opt.removeOnClick
  });
}

function shouldShowCover(controller) {
  var track = controller._track;

  if (!track.length) {
    return false;
  }

  var p2 = track[track.length - 1];
  var p1 = track[0];
  var dx = p2[0] - p1[0];
  var dy = p2[1] - p1[1];
  var dist = mathPow$2(dx * dx + dy * dy, 0.5);
  return dist > UNSELECT_THRESHOLD;
}

function getTrackEnds(track) {
  var tail = track.length - 1;
  tail < 0 && (tail = 0);
  return [track[0], track[tail]];
}

function createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
  var cover = new Group$1();
  cover.add(new Rect({
    name: 'main',
    style: makeStyle(brushOption),
    silent: true,
    draggable: true,
    cursor: 'move',
    drift: curry(driftRect, rectRangeConverter, controller, cover, ['n', 's', 'w', 'e']),
    ondragend: curry(trigger$1, controller, {
      isEnd: true
    })
  }));
  each(edgeNameSequences, function (nameSequence) {
    cover.add(new Rect({
      name: nameSequence.join(''),
      style: {
        opacity: 0
      },
      draggable: true,
      silent: true,
      invisible: true,
      drift: curry(driftRect, rectRangeConverter, controller, cover, nameSequence),
      ondragend: curry(trigger$1, controller, {
        isEnd: true
      })
    }));
  });
  return cover;
}

function updateBaseRect(controller, cover, localRange, brushOption) {
  var lineWidth = brushOption.brushStyle.lineWidth || 0;
  var handleSize = mathMax$9(lineWidth, MIN_RESIZE_LINE_WIDTH);
  var x = localRange[0][0];
  var y = localRange[1][0];
  var xa = x - lineWidth / 2;
  var ya = y - lineWidth / 2;
  var x2 = localRange[0][1];
  var y2 = localRange[1][1];
  var x2a = x2 - handleSize + lineWidth / 2;
  var y2a = y2 - handleSize + lineWidth / 2;
  var width = x2 - x;
  var height = y2 - y;
  var widtha = width + lineWidth;
  var heighta = height + lineWidth;
  updateRectShape(controller, cover, 'main', x, y, width, height);

  if (brushOption.transformable) {
    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
  }
}

function updateCommon(controller, cover) {
  var brushOption = cover.__brushOption;
  var transformable = brushOption.transformable;
  var mainEl = cover.childAt(0);
  mainEl.useStyle(makeStyle(brushOption));
  mainEl.attr({
    silent: !transformable,
    cursor: transformable ? 'move' : 'default'
  });
  each([['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']], function (nameSequence) {
    var el = cover.childOfName(nameSequence.join(''));
    var globalDir = nameSequence.length === 1 ? getGlobalDirection1(controller, nameSequence[0]) : getGlobalDirection2(controller, nameSequence);
    el && el.attr({
      silent: !transformable,
      invisible: !transformable,
      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
    });
  });
}

function updateRectShape(controller, cover, name, x, y, w, h) {
  var el = cover.childOfName(name);
  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
}

function makeStyle(brushOption) {
  return defaults({
    strokeNoScale: true
  }, brushOption.brushStyle);
}

function formatRectRange(x, y, x2, y2) {
  var min = [mathMin$9(x, x2), mathMin$9(y, y2)];
  var max = [mathMax$9(x, x2), mathMax$9(y, y2)];
  return [[min[0], max[0]], [min[1], max[1]] // y range
  ];
}

function getTransform$1(controller) {
  return getTransform(controller.group);
}

function getGlobalDirection1(controller, localDirName) {
  var map = {
    w: 'left',
    e: 'right',
    n: 'top',
    s: 'bottom'
  };
  var inverseMap = {
    left: 'w',
    right: 'e',
    top: 'n',
    bottom: 's'
  };
  var dir = transformDirection(map[localDirName], getTransform$1(controller));
  return inverseMap[dir];
}

function getGlobalDirection2(controller, localDirNameSeq) {
  var globalDir = [getGlobalDirection1(controller, localDirNameSeq[0]), getGlobalDirection1(controller, localDirNameSeq[1])];
  (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
  return globalDir.join('');
}

function driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
  var brushOption = cover.__brushOption;
  var rectRange = rectRangeConverter.toRectRange(brushOption.range);
  var localDelta = toLocalDelta(controller, dx, dy);
  each(dirNameSequence, function (dirName) {
    var ind = DIRECTION_MAP[dirName];
    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
  });
  brushOption.range = rectRangeConverter.fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
  updateCoverAfterCreation(controller, cover);
  trigger$1(controller, {
    isEnd: false
  });
}

function driftPolygon(controller, cover, dx, dy) {
  var range = cover.__brushOption.range;
  var localDelta = toLocalDelta(controller, dx, dy);
  each(range, function (point) {
    point[0] += localDelta[0];
    point[1] += localDelta[1];
  });
  updateCoverAfterCreation(controller, cover);
  trigger$1(controller, {
    isEnd: false
  });
}

function toLocalDelta(controller, dx, dy) {
  var thisGroup = controller.group;
  var localD = thisGroup.transformCoordToLocal(dx, dy);
  var localZero = thisGroup.transformCoordToLocal(0, 0);
  return [localD[0] - localZero[0], localD[1] - localZero[1]];
}

function clipByPanel(controller, cover, data) {
  var panel = getPanelByCover(controller, cover);
  return panel && panel !== BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : clone(data);
}

function pointsToRect(points) {
  var xmin = mathMin$9(points[0][0], points[1][0]);
  var ymin = mathMin$9(points[0][1], points[1][1]);
  var xmax = mathMax$9(points[0][0], points[1][0]);
  var ymax = mathMax$9(points[0][1], points[1][1]);
  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin
  };
}

function resetCursor(controller, e, localCursorPoint) {
  if ( // Check active
  !controller._brushType // resetCursor should be always called when mouse is in zr area,
  // but not called when mouse is out of zr area to avoid bad influence
  // if `mousemove`, `mouseup` are triggered from `document` event.
  || isOutsideZrArea(controller, e.offsetX, e.offsetY)) {
    return;
  }

  var zr = controller._zr;
  var covers = controller._covers;
  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.

  if (!controller._dragging) {
    for (var i = 0; i < covers.length; i++) {
      var brushOption = covers[i].__brushOption;

      if (currPanel && (currPanel === BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
        // Use cursor style set on cover.
        return;
      }
    }
  }

  currPanel && zr.setCursorStyle('crosshair');
}

function preventDefault(e) {
  var rawE = e.event;
  rawE.preventDefault && rawE.preventDefault();
}

function mainShapeContain(cover, x, y) {
  return cover.childOfName('main').contain(x, y);
}

function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
  var creatingCover = controller._creatingCover;
  var panel = controller._creatingPanel;
  var thisBrushOption = controller._brushOption;
  var eventParams;

  controller._track.push(localCursorPoint.slice());

  if (shouldShowCover(controller) || creatingCover) {
    if (panel && !creatingCover) {
      thisBrushOption.brushMode === 'single' && clearCovers(controller);
      var brushOption = clone(thisBrushOption);
      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
      brushOption.panelId = panel === BRUSH_PANEL_GLOBAL ? null : panel.panelId;
      creatingCover = controller._creatingCover = createCover(controller, brushOption);

      controller._covers.push(creatingCover);
    }

    if (creatingCover) {
      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
      var coverBrushOption = creatingCover.__brushOption;
      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));

      if (isEnd) {
        endCreating(controller, creatingCover);
        coverRenderer.updateCommon(controller, creatingCover);
      }

      updateCoverShape(controller, creatingCover);
      eventParams = {
        isEnd: isEnd
      };
    }
  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
      eventParams = {
        isEnd: isEnd,
        removeOnClick: true
      };
    }
  }

  return eventParams;
}

function determineBrushType(brushType, panel) {
  if (brushType === 'auto') {
    if (process.env.NODE_ENV !== 'production') {
      assert(panel && panel.defaultBrushType, 'MUST have defaultBrushType when brushType is "atuo"');
    }

    return panel.defaultBrushType;
  }

  return brushType;
}

var pointerHandlers = {
  mousedown: function (e) {
    if (this._dragging) {
      // In case some browser do not support globalOut,
      // and release mouse out side the browser.
      handleDragEnd(this, e);
    } else if (!e.target || !e.target.draggable) {
      preventDefault(e);
      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
      this._creatingCover = null;
      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);

      if (panel) {
        this._dragging = true;
        this._track = [localCursorPoint.slice()];
      }
    }
  },
  mousemove: function (e) {
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = this.group.transformCoordToLocal(x, y);
    resetCursor(this, e, localCursorPoint);

    if (this._dragging) {
      preventDefault(e);
      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
      eventParams && trigger$1(this, eventParams);
    }
  },
  mouseup: function (e) {
    handleDragEnd(this, e);
  }
};

function handleDragEnd(controller, e) {
  if (controller._dragging) {
    preventDefault(e);
    var x = e.offsetX;
    var y = e.offsetY;
    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
    controller._dragging = false;
    controller._track = [];
    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.

    eventParams && trigger$1(controller, eventParams);
  }
}

function isOutsideZrArea(controller, x, y) {
  var zr = controller._zr;
  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */


var coverRenderers = {
  lineX: getLineRenderer(0),
  lineY: getLineRenderer(1),
  rect: {
    createCover: function (controller, brushOption) {
      function returnInput(range) {
        return range;
      }

      return createBaseRectCover({
        toRectRange: returnInput,
        fromRectRange: returnInput
      }, controller, brushOption, [['w'], ['e'], ['n'], ['s'], ['s', 'e'], ['s', 'w'], ['n', 'e'], ['n', 'w']]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      updateBaseRect(controller, cover, localRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  },
  polygon: {
    createCover: function (controller, brushOption) {
      var cover = new Group$1(); // Do not use graphic.Polygon because graphic.Polyline do not close the
      // border of the shape when drawing, which is a better experience for user.

      cover.add(new Polyline({
        name: 'main',
        style: makeStyle(brushOption),
        silent: true
      }));
      return cover;
    },
    getCreatingRange: function (localTrack) {
      return localTrack;
    },
    endCreating: function (controller, cover) {
      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.

      cover.add(new Polygon({
        name: 'main',
        draggable: true,
        drift: curry(driftPolygon, controller, cover),
        ondragend: curry(trigger$1, controller, {
          isEnd: true
        })
      }));
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      cover.childAt(0).setShape({
        points: clipByPanel(controller, cover, localRange)
      });
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  }
};

function getLineRenderer(xyIndex) {
  return {
    createCover: function (controller, brushOption) {
      return createBaseRectCover({
        toRectRange: function (range) {
          var rectRange = [range, [0, 100]];
          xyIndex && rectRange.reverse();
          return rectRange;
        },
        fromRectRange: function (rectRange) {
          return rectRange[xyIndex];
        }
      }, controller, brushOption, [[['w'], ['e']], [['n'], ['s']]][xyIndex]);
    },
    getCreatingRange: function (localTrack) {
      var ends = getTrackEnds(localTrack);
      var min = mathMin$9(ends[0][xyIndex], ends[1][xyIndex]);
      var max = mathMax$9(ends[0][xyIndex], ends[1][xyIndex]);
      return [min, max];
    },
    updateCoverShape: function (controller, cover, localRange, brushOption) {
      var otherExtent; // If brushWidth not specified, fit the panel.

      var panel = getPanelByCover(controller, cover);

      if (panel !== BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) {
        otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
      } else {
        var zr = controller._zr;
        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
      }

      var rectRange = [localRange, otherExtent];
      xyIndex && rectRange.reverse();
      updateBaseRect(controller, cover, rectRange, brushOption);
    },
    updateCommon: updateCommon,
    contain: mainShapeContain
  };
}

function makeRectPanelClipPath(rect) {
  rect = normalizeRect(rect);
  return function (localPoints) {
    return clipPointsByRect(localPoints, rect);
  };
}
function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
  rect = normalizeRect(rect);
  return function (xyIndex) {
    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
    var brushWidth = idx ? rect.width : rect.height;
    var base = idx ? rect.x : rect.y;
    return [base, base + (brushWidth || 0)];
  };
}
function makeRectIsTargetByCursor(rect, api, targetModel) {
  var boundingRect = normalizeRect(rect);
  return function (e, localCursorPoint) {
    return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
  };
} // Consider width/height is negative.

function normalizeRect(rect) {
  return BoundingRect.create(rect);
}

var elementList = ['axisLine', 'axisTickLabel', 'axisName'];

var ParallelAxisView =
/** @class */
function (_super) {
  __extends$1(ParallelAxisView, _super);

  function ParallelAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ParallelAxisView.type;
    return _this;
  }

  ParallelAxisView.prototype.init = function (ecModel, api) {
    _super.prototype.init.apply(this, arguments);

    (this._brushController = new BrushController(api.getZr())).on('brush', bind(this._onBrush, this));
  };

  ParallelAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
      return;
    }

    this.axisModel = axisModel;
    this.api = api;
    this.group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new Group$1();
    this.group.add(this._axisGroup);

    if (!axisModel.get('show')) {
      return;
    }

    var coordSysModel = getCoordSysModel(axisModel, ecModel);
    var coordSys = coordSysModel.coordinateSystem;
    var areaSelectStyle = axisModel.getAreaSelectStyle();
    var areaWidth = areaSelectStyle.width;
    var dim = axisModel.axis.dim;
    var axisLayout = coordSys.getAxisLayout(dim);
    var builderOpt = extend({
      strokeContainThreshold: areaWidth
    }, axisLayout);
    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
    each(elementList, axisBuilder.add, axisBuilder);

    this._axisGroup.add(axisBuilder.getGroup());

    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);

    groupTransition(oldAxisGroup, this._axisGroup, axisModel);
  }; // /**
  //  * @override
  //  */
  // updateVisual(axisModel, ecModel, api, payload) {
  //     this._brushController && this._brushController
  //         .updateCovers(getCoverInfoList(axisModel));
  // }


  ParallelAxisView.prototype._refreshBrushController = function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
    // After filtering, axis may change, select area needs to be update.
    var extent = axisModel.axis.getExtent();
    var extentLen = extent[1] - extent[0];
    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
    // width/height might be negative, which will be
    // normalized in BoundingRect.

    var rect = BoundingRect.create({
      x: extent[0],
      y: -areaWidth / 2,
      width: extentLen,
      height: areaWidth
    });
    rect.x -= extra;
    rect.width += 2 * extra;

    this._brushController.mount({
      enableGlobalPan: true,
      rotation: builderOpt.rotation,
      x: builderOpt.position[0],
      y: builderOpt.position[1]
    }).setPanels([{
      panelId: 'pl',
      clipPath: makeRectPanelClipPath(rect),
      isTargetByCursor: makeRectIsTargetByCursor(rect, api, coordSysModel),
      getLinearBrushOtherExtent: makeLinearBrushOtherExtent(rect, 0)
    }]).enableBrush({
      brushType: 'lineX',
      brushStyle: areaSelectStyle,
      removeOnClick: true
    }).updateCovers(getCoverInfoList(axisModel));
  };

  ParallelAxisView.prototype._onBrush = function (eventParam) {
    var coverInfoList = eventParam.areas; // Do not cache these object, because the mey be changed.

    var axisModel = this.axisModel;
    var axis = axisModel.axis;
    var intervals = map(coverInfoList, function (coverInfo) {
      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
    }); // If realtime is true, action is not dispatched on drag end, because
    // the drag end emits the same params with the last drag move event,
    // and may have some delay when using touch pad.

    if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'axisAreaSelect',
        parallelAxisId: axisModel.id,
        intervals: intervals
      });
    }
  };

  ParallelAxisView.prototype.dispose = function () {
    this._brushController.dispose();
  };

  ParallelAxisView.type = 'parallelAxis';
  return ParallelAxisView;
}(ComponentView);

function fromAxisAreaSelect(axisModel, ecModel, payload) {
  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
    mainType: 'parallelAxis',
    query: payload
  })[0] === axisModel;
}

function getCoverInfoList(axisModel) {
  var axis = axisModel.axis;
  return map(axisModel.activeIntervals, function (interval) {
    return {
      brushType: 'lineX',
      panelId: 'pl',
      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
    };
  });
}

function getCoordSysModel(axisModel, ecModel) {
  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var actionInfo$1 = {
  type: 'axisAreaSelect',
  event: 'axisAreaSelected' // update: 'updateVisual'

};
function installParallelActions(registers) {
  registers.registerAction(actionInfo$1, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'parallelAxis',
      query: payload
    }, function (parallelAxisModel) {
      parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
    });
  });
  /**
   * @payload
   */

  registers.registerAction('parallelAxisExpand', function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'parallel',
      query: payload
    }, function (parallelModel) {
      parallelModel.setAxisExpand(payload);
    });
  });
}

var defaultAxisOption = {
  type: 'value',
  areaSelectStyle: {
    width: 20,
    borderWidth: 1,
    borderColor: 'rgba(160,197,232)',
    color: 'rgba(160,197,232)',
    opacity: 0.3
  },
  realtime: true,
  z: 10
};
function install$g(registers) {
  registers.registerComponentView(ParallelView$1);
  registers.registerComponentModel(ParallelModel);
  registers.registerCoordinateSystem('parallel', parallelCoordSysCreator);
  registers.registerPreprocessor(parallelPreprocessor);
  registers.registerComponentModel(ParallelAxisModel);
  registers.registerComponentView(ParallelAxisView);
  axisModelCreator(registers, 'parallel', ParallelAxisModel, defaultAxisOption);
  installParallelActions(registers);
}

function install$h(registers) {
  use(install$g);
  registers.registerChartView(ParallelView);
  registers.registerSeriesModel(ParallelSeriesModel);
  registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, parallelVisual);
}

var SankeyPathShape =
/** @class */
function () {
  function SankeyPathShape() {
    this.x1 = 0;
    this.y1 = 0;
    this.x2 = 0;
    this.y2 = 0;
    this.cpx1 = 0;
    this.cpy1 = 0;
    this.cpx2 = 0;
    this.cpy2 = 0;
    this.extent = 0;
  }

  return SankeyPathShape;
}();

var SankeyPath =
/** @class */
function (_super) {
  __extends$1(SankeyPath, _super);

  function SankeyPath(opts) {
    return _super.call(this, opts) || this;
  }

  SankeyPath.prototype.getDefaultShape = function () {
    return new SankeyPathShape();
  };

  SankeyPath.prototype.buildPath = function (ctx, shape) {
    var extent = shape.extent;
    ctx.moveTo(shape.x1, shape.y1);
    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);

    if (shape.orient === 'vertical') {
      ctx.lineTo(shape.x2 + extent, shape.y2);
      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
    } else {
      ctx.lineTo(shape.x2, shape.y2 + extent);
      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
    }

    ctx.closePath();
  };

  SankeyPath.prototype.highlight = function () {
    enterEmphasis(this);
  };

  SankeyPath.prototype.downplay = function () {
    leaveEmphasis(this);
  };

  return SankeyPath;
}(Path);

var SankeyView =
/** @class */
function (_super) {
  __extends$1(SankeyView, _super);

  function SankeyView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SankeyView.type;
    _this._focusAdjacencyDisabled = false;
    return _this;
  }

  SankeyView.prototype.render = function (seriesModel, ecModel, api) {
    var sankeyView = this;
    var graph = seriesModel.getGraph();
    var group = this.group;
    var layoutInfo = seriesModel.layoutInfo; // view width

    var width = layoutInfo.width; // view height

    var height = layoutInfo.height;
    var nodeData = seriesModel.getData();
    var edgeData = seriesModel.getData('edge');
    var orient = seriesModel.get('orient');
    this._model = seriesModel;
    group.removeAll();
    group.x = layoutInfo.x;
    group.y = layoutInfo.y; // generate a bezire Curve for each edge

    graph.eachEdge(function (edge) {
      var curve = new SankeyPath();
      var ecData = getECData(curve);
      ecData.dataIndex = edge.dataIndex;
      ecData.seriesIndex = seriesModel.seriesIndex;
      ecData.dataType = 'edge';
      var edgeModel = edge.getModel();
      var lineStyleModel = edgeModel.getModel('lineStyle');
      var curvature = lineStyleModel.get('curveness');
      var n1Layout = edge.node1.getLayout();
      var node1Model = edge.node1.getModel();
      var dragX1 = node1Model.get('localX');
      var dragY1 = node1Model.get('localY');
      var n2Layout = edge.node2.getLayout();
      var node2Model = edge.node2.getModel();
      var dragX2 = node2Model.get('localX');
      var dragY2 = node2Model.get('localY');
      var edgeLayout = edge.getLayout();
      var x1;
      var y1;
      var x2;
      var y2;
      var cpx1;
      var cpy1;
      var cpx2;
      var cpy2;
      curve.shape.extent = Math.max(1, edgeLayout.dy);
      curve.shape.orient = orient;

      if (orient === 'vertical') {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
        cpx1 = x1;
        cpy1 = y1 * (1 - curvature) + y2 * curvature;
        cpx2 = x2;
        cpy2 = y1 * curvature + y2 * (1 - curvature);
      } else {
        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
        cpx1 = x1 * (1 - curvature) + x2 * curvature;
        cpy1 = y1;
        cpx2 = x1 * curvature + x2 * (1 - curvature);
        cpy2 = y2;
      }

      curve.setShape({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
      });
      curve.useStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color

      switch (curve.style.fill) {
        case 'source':
          curve.style.fill = edge.node1.getVisual('color');
          curve.style.decal = edge.node1.getVisual('style').decal;
          break;

        case 'target':
          curve.style.fill = edge.node2.getVisual('color');
          curve.style.decal = edge.node2.getVisual('style').decal;
          break;

        case 'gradient':
          var sourceColor = edge.node1.getVisual('color');
          var targetColor = edge.node2.getVisual('color');

          if (isString(sourceColor) && isString(targetColor)) {
            curve.style.fill = new LinearGradient(0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [{
              color: sourceColor,
              offset: 0
            }, {
              color: targetColor,
              offset: 1
            }]);
          }

      }

      setLabelStyle(curve, getLabelStatesModels(edgeModel, 'edgeLabel'), {
        labelFetcher: seriesModel,
        labelDataIndex: edge.dataIndex,
        defaultText: "" + edgeModel.get('value')
      });
      curve.setTextConfig({
        position: 'inside'
      });
      var emphasisModel = edgeModel.getModel('emphasis');
      setStatesStylesFromModel(curve, edgeModel, 'lineStyle', function (model) {
        return model.getItemStyle();
      });
      group.add(curve);
      edgeData.setItemGraphicEl(edge.dataIndex, curve);
      var focus = emphasisModel.get('focus');
      toggleHoverEmphasis(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
      getECData(curve).dataType = 'edge';
    }); // Generate a rect for each node

    graph.eachNode(function (node) {
      var layout = node.getLayout();
      var itemModel = node.getModel();
      var dragX = itemModel.get('localX');
      var dragY = itemModel.get('localY');
      var emphasisModel = itemModel.getModel('emphasis');
      var rect = new Rect({
        shape: {
          x: dragX != null ? dragX * width : layout.x,
          y: dragY != null ? dragY * height : layout.y,
          width: layout.dx,
          height: layout.dy
        },
        style: itemModel.getModel('itemStyle').getItemStyle(),
        z2: 10
      });
      setLabelStyle(rect, getLabelStatesModels(itemModel), {
        labelFetcher: seriesModel,
        labelDataIndex: node.dataIndex,
        defaultText: node.id
      });
      rect.disableLabelAnimation = true;
      rect.setStyle('fill', node.getVisual('color'));
      rect.setStyle('decal', node.getVisual('style').decal);
      setStatesStylesFromModel(rect, itemModel);
      group.add(rect);
      nodeData.setItemGraphicEl(node.dataIndex, rect);
      getECData(rect).dataType = 'node';
      var focus = emphasisModel.get('focus');
      toggleHoverEmphasis(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    });
    nodeData.eachItemGraphicEl(function (el, dataIndex) {
      var itemModel = nodeData.getItemModel(dataIndex);

      if (itemModel.get('draggable')) {
        el.drift = function (dx, dy) {
          sankeyView._focusAdjacencyDisabled = true;
          this.shape.x += dx;
          this.shape.y += dy;
          this.dirty();
          api.dispatchAction({
            type: 'dragNode',
            seriesId: seriesModel.id,
            dataIndex: nodeData.getRawIndex(dataIndex),
            localX: this.shape.x / width,
            localY: this.shape.y / height
          });
        };

        el.ondragend = function () {
          sankeyView._focusAdjacencyDisabled = false;
        };

        el.draggable = true;
        el.cursor = 'move';
      }
    });

    if (!this._data && seriesModel.isAnimationEnabled()) {
      group.setClipPath(createGridClipShape$1(group.getBoundingRect(), seriesModel, function () {
        group.removeClipPath();
      }));
    }

    this._data = seriesModel.getData();
  };

  SankeyView.prototype.dispose = function () {};

  SankeyView.type = 'sankey';
  return SankeyView;
}(ChartView); // Add animation to the view


function createGridClipShape$1(rect, seriesModel, cb) {
  var rectEl = new Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  initProps(rectEl, {
    shape: {
      width: rect.width + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

var SankeySeriesModel =
/** @class */
function (_super) {
  __extends$1(SankeySeriesModel, _super);

  function SankeySeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SankeySeriesModel.type;
    return _this;
  }
  /**
   * Init a graph data structure from data in option series
   */


  SankeySeriesModel.prototype.getInitialData = function (option, ecModel) {
    var links = option.edges || option.links;
    var nodes = option.data || option.nodes;
    var levels = option.levels;
    this.levelModels = [];
    var levelModels = this.levelModels;

    for (var i = 0; i < levels.length; i++) {
      if (levels[i].depth != null && levels[i].depth >= 0) {
        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          throw new Error('levels[i].depth is mandatory and should be natural number');
        }
      }
    }

    if (nodes && links) {
      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
      return graph.data;
    }

    function beforeLink(nodeData, edgeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var seriesModel = model.parentModel;
        var layout = seriesModel.getData().getItemLayout(idx);

        if (layout) {
          var nodeDepth = layout.depth;
          var levelModel = seriesModel.levelModels[nodeDepth];

          if (levelModel) {
            model.parentModel = levelModel;
          }
        }

        return model;
      });
      edgeData.wrapMethod('getItemModel', function (model, idx) {
        var seriesModel = model.parentModel;
        var edge = seriesModel.getGraph().getEdgeByIndex(idx);
        var layout = edge.node1.getLayout();

        if (layout) {
          var depth = layout.depth;
          var levelModel = seriesModel.levelModels[depth];

          if (levelModel) {
            model.parentModel = levelModel;
          }
        }

        return model;
      });
    }
  };

  SankeySeriesModel.prototype.setNodePosition = function (dataIndex, localPosition) {
    var nodes = this.option.data || this.option.nodes;
    var dataItem = nodes[dataIndex];
    dataItem.localX = localPosition[0];
    dataItem.localY = localPosition[1];
  };
  /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */


  SankeySeriesModel.prototype.getGraph = function () {
    return this.getData().graph;
  };
  /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */


  SankeySeriesModel.prototype.getEdgeData = function () {
    return this.getGraph().edgeData;
  };

  SankeySeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    function noValue(val) {
      return isNaN(val) || val == null;
    } // dataType === 'node' or empty do not show tooltip by default


    if (dataType === 'edge') {
      var params = this.getDataParams(dataIndex, dataType);
      var rawDataOpt = params.data;
      var edgeValue = params.value;
      var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
      return createTooltipMarkup('nameValue', {
        name: edgeName,
        value: edgeValue,
        noValue: noValue(edgeValue)
      });
    } // dataType === 'node'
    else {
        var node = this.getGraph().getNodeByIndex(dataIndex);
        var value = node.getLayout().value;
        var name_1 = this.getDataParams(dataIndex, dataType).data.name;
        return createTooltipMarkup('nameValue', {
          name: name_1 != null ? name_1 + '' : null,
          value: value,
          noValue: noValue(value)
        });
      }
  };

  SankeySeriesModel.prototype.optionUpdated = function () {}; // Override Series.getDataParams()


  SankeySeriesModel.prototype.getDataParams = function (dataIndex, dataType) {
    var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);

    if (params.value == null && dataType === 'node') {
      var node = this.getGraph().getNodeByIndex(dataIndex);
      var nodeValue = node.getLayout().value;
      params.value = nodeValue;
    }

    return params;
  };

  SankeySeriesModel.type = 'series.sankey';
  SankeySeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'view',
    left: '5%',
    top: '5%',
    right: '20%',
    bottom: '5%',
    orient: 'horizontal',
    nodeWidth: 20,
    nodeGap: 8,
    draggable: true,
    layoutIterations: 32,
    label: {
      show: true,
      position: 'right',
      fontSize: 12
    },
    edgeLabel: {
      show: false,
      fontSize: 12
    },
    levels: [],
    nodeAlign: 'justify',
    lineStyle: {
      color: '#314656',
      opacity: 0.2,
      curveness: 0.5
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        opacity: 0.5
      }
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    },
    animationEasing: 'linear',
    animationDuration: 1000
  };
  return SankeySeriesModel;
}(SeriesModel);

function sankeyLayout(ecModel, api) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var nodeWidth = seriesModel.get('nodeWidth');
    var nodeGap = seriesModel.get('nodeGap');
    var layoutInfo = getViewRect$4(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var width = layoutInfo.width;
    var height = layoutInfo.height;
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    var edges = graph.edges;
    computeNodeValues(nodes);
    var filteredNodes = filter(nodes, function (node) {
      return node.getLayout().value === 0;
    });
    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
    var orient = seriesModel.get('orient');
    var nodeAlign = seriesModel.get('nodeAlign');
    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
  });
}
/**
 * Get the layout position of the whole view
 */

function getViewRect$4(seriesModel, api) {
  return getLayoutRect$1(seriesModel.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  });
}

function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
  computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */


function computeNodeValues(nodes) {
  each(nodes, function (node) {
    var value1 = sum(node.outEdges, getEdgeValue);
    var value2 = sum(node.inEdges, getEdgeValue);
    var nodeRawValue = node.getValue() || 0;
    var value = Math.max(value1, value2, nodeRawValue);
    node.setLayout({
      value: value
    }, true);
  });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */


function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
  // Used to mark whether the edge is deleted. if it is deleted,
  // the value is 0, otherwise it is 1.
  var remainEdges = []; // Storage each node's indegree.

  var indegreeArr = []; // Used to storage the node with indegree is equal to 0.

  var zeroIndegrees = [];
  var nextTargetNode = [];
  var x = 0; // let kx = 0;

  for (var i = 0; i < edges.length; i++) {
    remainEdges[i] = 1;
  }

  for (var i = 0; i < nodes.length; i++) {
    indegreeArr[i] = nodes[i].inEdges.length;

    if (indegreeArr[i] === 0) {
      zeroIndegrees.push(nodes[i]);
    }
  }

  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
  // position of the nodes.

  while (zeroIndegrees.length) {
    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
      var node = zeroIndegrees[idx];
      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
      var isItemDepth = item.depth != null && item.depth >= 0;

      if (isItemDepth && item.depth > maxNodeDepth) {
        maxNodeDepth = item.depth;
      }

      node.setLayout({
        depth: isItemDepth ? item.depth : x
      }, true);
      orient === 'vertical' ? node.setLayout({
        dy: nodeWidth
      }, true) : node.setLayout({
        dx: nodeWidth
      }, true);

      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
        var edge = node.outEdges[edgeIdx];
        var indexEdge = edges.indexOf(edge);
        remainEdges[indexEdge] = 0;
        var targetNode = edge.node2;
        var nodeIndex = nodes.indexOf(targetNode);

        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
          nextTargetNode.push(targetNode);
        }
      }
    }

    ++x;
    zeroIndegrees = nextTargetNode;
    nextTargetNode = [];
  }

  for (var i = 0; i < remainEdges.length; i++) {
    if (remainEdges[i] === 1) {
      throw new Error('Sankey is a DAG, the original data has cycle!');
    }
  }

  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;

  if (nodeAlign && nodeAlign !== 'left') {
    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
  }

  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
  scaleNodeBreadths(nodes, kx, orient);
}

function isNodeDepth(node) {
  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
  return item.depth != null && item.depth >= 0;
}

function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
  if (nodeAlign === 'right') {
    var nextSourceNode = [];
    var remainNodes = nodes;
    var nodeHeight = 0;

    while (remainNodes.length) {
      for (var i = 0; i < remainNodes.length; i++) {
        var node = remainNodes[i];
        node.setLayout({
          skNodeHeight: nodeHeight
        }, true);

        for (var j = 0; j < node.inEdges.length; j++) {
          var edge = node.inEdges[j];

          if (nextSourceNode.indexOf(edge.node1) < 0) {
            nextSourceNode.push(edge.node1);
          }
        }
      }

      remainNodes = nextSourceNode;
      nextSourceNode = [];
      ++nodeHeight;
    }

    each(nodes, function (node) {
      if (!isNodeDepth(node)) {
        node.setLayout({
          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
        }, true);
      }
    });
  } else if (nodeAlign === 'justify') {
    moveSinksRight(nodes, maxDepth);
  }
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */


function moveSinksRight(nodes, maxDepth) {
  each(nodes, function (node) {
    if (!isNodeDepth(node) && !node.outEdges.length) {
      node.setLayout({
        depth: maxDepth
      }, true);
    }
  });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */


function scaleNodeBreadths(nodes, kx, orient) {
  each(nodes, function (node) {
    var nodeDepth = node.getLayout().depth * kx;
    orient === 'vertical' ? node.setLayout({
      y: nodeDepth
    }, true) : node.setLayout({
      x: nodeDepth
    }, true);
  });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */


function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);

  for (var alpha = 1; iterations > 0; iterations--) {
    // 0.99 is a experience parameter, ensure that each iterations of
    // changes as small as possible.
    alpha *= 0.99;
    relaxRightToLeft(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    relaxLeftToRight(nodesByBreadth, alpha, orient);
    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
  }
}

function prepareNodesByBreadth(nodes, orient) {
  var nodesByBreadth = [];
  var keyAttr = orient === 'vertical' ? 'y' : 'x';
  var groupResult = groupData(nodes, function (node) {
    return node.getLayout()[keyAttr];
  });
  groupResult.keys.sort(function (a, b) {
    return a - b;
  });
  each(groupResult.keys, function (key) {
    nodesByBreadth.push(groupResult.buckets.get(key));
  });
  return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */


function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
  var minKy = Infinity;
  each(nodesByBreadth, function (nodes) {
    var n = nodes.length;
    var sum = 0;
    each(nodes, function (node) {
      sum += node.getLayout().value;
    });
    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;

    if (ky < minKy) {
      minKy = ky;
    }
  });
  each(nodesByBreadth, function (nodes) {
    each(nodes, function (node, i) {
      var nodeDy = node.getLayout().value * minKy;

      if (orient === 'vertical') {
        node.setLayout({
          x: i
        }, true);
        node.setLayout({
          dx: nodeDy
        }, true);
      } else {
        node.setLayout({
          y: i
        }, true);
        node.setLayout({
          dy: nodeDy
        }, true);
      }
    });
  });
  each(edges, function (edge) {
    var edgeDy = +edge.getValue() * minKy;
    edge.setLayout({
      dy: edgeDy
    }, true);
  });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */


function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  each(nodesByBreadth, function (nodes) {
    nodes.sort(function (a, b) {
      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
    });
    var nodeX;
    var node;
    var dy;
    var y0 = 0;
    var n = nodes.length;
    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';

    for (var i = 0; i < n; i++) {
      node = nodes[i];
      dy = y0 - node.getLayout()[keyAttr];

      if (dy > 0) {
        nodeX = node.getLayout()[keyAttr] + dy;
        orient === 'vertical' ? node.setLayout({
          x: nodeX
        }, true) : node.setLayout({
          y: nodeX
        }, true);
      }

      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
    }

    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up

    dy = y0 - nodeGap - viewWidth;

    if (dy > 0) {
      nodeX = node.getLayout()[keyAttr] - dy;
      orient === 'vertical' ? node.setLayout({
        x: nodeX
      }, true) : node.setLayout({
        y: nodeX
      }, true);
      y0 = nodeX;

      for (var i = n - 2; i >= 0; --i) {
        node = nodes[i];
        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;

        if (dy > 0) {
          nodeX = node.getLayout()[keyAttr] - dy;
          orient === 'vertical' ? node.setLayout({
            x: nodeX
          }, true) : node.setLayout({
            y: nodeX
          }, true);
        }

        y0 = node.getLayout()[keyAttr];
      }
    }
  });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */


function relaxRightToLeft(nodesByBreadth, alpha, orient) {
  each(nodesByBreadth.slice().reverse(), function (nodes) {
    each(nodes, function (node) {
      if (node.outEdges.length) {
        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue);

        if (isNaN(y)) {
          var len = node.outEdges.length;
          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center$1(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center$1(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}

function weightedTarget(edge, orient) {
  return center$1(edge.node2, orient) * edge.getValue();
}

function centerTarget(edge, orient) {
  return center$1(edge.node2, orient);
}

function weightedSource(edge, orient) {
  return center$1(edge.node1, orient) * edge.getValue();
}

function centerSource(edge, orient) {
  return center$1(edge.node1, orient);
}

function center$1(node, orient) {
  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}

function getEdgeValue(edge) {
  return edge.getValue();
}

function sum(array, cb, orient) {
  var sum = 0;
  var len = array.length;
  var i = -1;

  while (++i < len) {
    var value = +cb(array[i], orient);

    if (!isNaN(value)) {
      sum += value;
    }
  }

  return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */


function relaxLeftToRight(nodesByBreadth, alpha, orient) {
  each(nodesByBreadth, function (nodes) {
    each(nodes, function (node) {
      if (node.inEdges.length) {
        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue);

        if (isNaN(y)) {
          var len = node.inEdges.length;
          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
        }

        if (orient === 'vertical') {
          var nodeX = node.getLayout().x + (y - center$1(node, orient)) * alpha;
          node.setLayout({
            x: nodeX
          }, true);
        } else {
          var nodeY = node.getLayout().y + (y - center$1(node, orient)) * alpha;
          node.setLayout({
            y: nodeY
          }, true);
        }
      }
    });
  });
}
/**
 * Compute the depth(y-position) of each edge
 */


function computeEdgeDepths(nodes, orient) {
  var keyAttr = orient === 'vertical' ? 'x' : 'y';
  each(nodes, function (node) {
    node.outEdges.sort(function (a, b) {
      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
    });
    node.inEdges.sort(function (a, b) {
      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
    });
  });
  each(nodes, function (node) {
    var sy = 0;
    var ty = 0;
    each(node.outEdges, function (edge) {
      edge.setLayout({
        sy: sy
      }, true);
      sy += edge.getLayout().dy;
    });
    each(node.inEdges, function (edge) {
      edge.setLayout({
        ty: ty
      }, true);
      ty += edge.getLayout().dy;
    });
  });
}

function sankeyVisual(ecModel) {
  ecModel.eachSeriesByType('sankey', function (seriesModel) {
    var graph = seriesModel.getGraph();
    var nodes = graph.nodes;
    var edges = graph.edges;

    if (nodes.length) {
      var minValue_1 = Infinity;
      var maxValue_1 = -Infinity;
      each(nodes, function (node) {
        var nodeValue = node.getLayout().value;

        if (nodeValue < minValue_1) {
          minValue_1 = nodeValue;
        }

        if (nodeValue > maxValue_1) {
          maxValue_1 = nodeValue;
        }
      });
      each(nodes, function (node) {
        var mapping = new VisualMapping({
          type: 'color',
          mappingMethod: 'linear',
          dataExtent: [minValue_1, maxValue_1],
          visual: seriesModel.get('color')
        });
        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
        var customColor = node.getModel().get(['itemStyle', 'color']);

        if (customColor != null) {
          node.setVisual('color', customColor);
          node.setVisual('style', {
            fill: customColor
          });
        } else {
          node.setVisual('color', mapValueToColor);
          node.setVisual('style', {
            fill: mapValueToColor
          });
        }
      });
    }

    if (edges.length) {
      each(edges, function (edge) {
        var edgeStyle = edge.getModel().get('lineStyle');
        edge.setVisual('style', edgeStyle);
      });
    }
  });
}

function install$i(registers) {
  registers.registerChartView(SankeyView);
  registers.registerSeriesModel(SankeySeriesModel);
  registers.registerLayout(sankeyLayout);
  registers.registerVisual(sankeyVisual);
  registers.registerAction({
    type: 'dragNode',
    event: 'dragnode',
    // here can only use 'update' now, other value is not support in echarts.
    update: 'update'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sankey',
      query: payload
    }, function (seriesModel) {
      seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
    });
  });
}

var WhiskerBoxCommonMixin =
/** @class */
function () {
  function WhiskerBoxCommonMixin() {}
  /**
   * @override
   */


  WhiskerBoxCommonMixin.prototype.getInitialData = function (option, ecModel) {
    // When both types of xAxis and yAxis are 'value', layout is
    // needed to be specified by user. Otherwise, layout can be
    // judged by which axis is category.
    var ordinalMeta;
    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
    var xAxisType = xAxisModel.get('type');
    var yAxisType = yAxisModel.get('type');
    var addOrdinal; // FIXME
    // Consider time axis.

    if (xAxisType === 'category') {
      option.layout = 'horizontal';
      ordinalMeta = xAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else if (yAxisType === 'category') {
      option.layout = 'vertical';
      ordinalMeta = yAxisModel.getOrdinalMeta();
      addOrdinal = true;
    } else {
      option.layout = option.layout || 'horizontal';
    }

    var coordDims = ['x', 'y'];
    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
    var axisModels = [xAxisModel, yAxisModel];
    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
    var data = option.data; // Clone a new data for next setOption({}) usage.
    // Avoid modifying current data will affect further update.

    if (data && addOrdinal) {
      var newOptionData_1 = [];
      each(data, function (item, index) {
        var newItem;

        if (isArray$1(item)) {
          newItem = item.slice(); // Modify current using data.

          item.unshift(index);
        } else if (isArray$1(item.value)) {
          newItem = extend({}, item);
          newItem.value = newItem.value.slice(); // Modify current using data.

          item.value.unshift(index);
        } else {
          newItem = item;
        }

        newOptionData_1.push(newItem);
      });
      option.data = newOptionData_1;
    }

    var defaultValueDimensions = this.defaultValueDimensions;
    var coordDimensions = [{
      name: baseAxisDim,
      type: getDimensionTypeByAxis(baseAxisType),
      ordinalMeta: ordinalMeta,
      otherDims: {
        tooltip: false,
        itemName: 0
      },
      dimsDef: ['base']
    }, {
      name: otherAxisDim,
      type: getDimensionTypeByAxis(otherAxisType),
      dimsDef: defaultValueDimensions.slice()
    }];
    return createSeriesDataSimply(this, {
      coordDimensions: coordDimensions,
      dimensionsCount: defaultValueDimensions.length + 1,
      encodeDefaulter: curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
    });
  };
  /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */


  WhiskerBoxCommonMixin.prototype.getBaseAxis = function () {
    var dim = this._baseAxisDim;
    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
  };

  return WhiskerBoxCommonMixin;
}();

var BoxplotSeriesModel =
/** @class */
function (_super) {
  __extends$1(BoxplotSeriesModel, _super);

  function BoxplotSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BoxplotSeriesModel.type; // TODO
    // box width represents group size, so dimension should have 'size'.

    /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */

    _this.defaultValueDimensions = [{
      name: 'min',
      defaultTooltip: true
    }, {
      name: 'Q1',
      defaultTooltip: true
    }, {
      name: 'median',
      defaultTooltip: true
    }, {
      name: 'Q3',
      defaultTooltip: true
    }, {
      name: 'max',
      defaultTooltip: true
    }];
    _this.visualDrawType = 'stroke';
    return _this;
  }

  BoxplotSeriesModel.type = 'series.boxplot';
  BoxplotSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
  BoxplotSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    layout: null,
    boxWidth: [7, 50],
    itemStyle: {
      color: '#fff',
      borderWidth: 1
    },
    emphasis: {
      scale: true,
      itemStyle: {
        borderWidth: 2,
        shadowBlur: 5,
        shadowOffsetX: 1,
        shadowOffsetY: 1,
        shadowColor: 'rgba(0,0,0,0.2)'
      }
    },
    animationDuration: 800
  };
  return BoxplotSeriesModel;
}(SeriesModel);

mixin(BoxplotSeriesModel, WhiskerBoxCommonMixin, true);

var BoxplotView =
/** @class */
function (_super) {
  __extends$1(BoxplotView, _super);

  function BoxplotView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BoxplotView.type;
    return _this;
  }

  BoxplotView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var group = this.group;
    var oldData = this._data; // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var itemLayout = data.getItemLayout(newIdx);
        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
        data.setItemGraphicEl(newIdx, symbolEl);
        group.add(symbolEl);
      }
    }).update(function (newIdx, oldIdx) {
      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(symbolEl);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (!symbolEl) {
        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
      } else {
        saveOldStyle(symbolEl);
        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
      }

      group.add(symbolEl);
      data.setItemGraphicEl(newIdx, symbolEl);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  };

  BoxplotView.prototype.remove = function (ecModel) {
    var group = this.group;
    var data = this._data;
    this._data = null;
    data && data.eachItemGraphicEl(function (el) {
      el && group.remove(el);
    });
  };

  BoxplotView.type = 'boxplot';
  return BoxplotView;
}(ChartView);

var BoxPathShape =
/** @class */
function () {
  function BoxPathShape() {}

  return BoxPathShape;
}();

var BoxPath =
/** @class */
function (_super) {
  __extends$1(BoxPath, _super);

  function BoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'boxplotBoxPath';
    return _this;
  }

  BoxPath.prototype.getDefaultShape = function () {
    return new BoxPathShape();
  };

  BoxPath.prototype.buildPath = function (ctx, shape) {
    var ends = shape.points;
    var i = 0;
    ctx.moveTo(ends[i][0], ends[i][1]);
    i++;

    for (; i < 4; i++) {
      ctx.lineTo(ends[i][0], ends[i][1]);
    }

    ctx.closePath();

    for (; i < ends.length; i++) {
      ctx.moveTo(ends[i][0], ends[i][1]);
      i++;
      ctx.lineTo(ends[i][0], ends[i][1]);
    }
  };

  return BoxPath;
}(Path);

function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
  var ends = itemLayout.ends;
  var el = new BoxPath({
    shape: {
      points: isInit ? transInit(ends, constDim, itemLayout) : ends
    }
  });
  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
  return el;
}

function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
  var seriesModel = data.hostModel;
  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
  updateMethod(el, {
    shape: {
      points: itemLayout.ends
    }
  }, seriesModel, dataIndex);
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.strokeNoScale = true;
  el.z2 = 100;
  var itemModel = data.getItemModel(dataIndex);
  var emphasisModel = itemModel.getModel('emphasis');
  setStatesStylesFromModel(el, itemModel);
  toggleHoverEmphasis(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}

function transInit(points, dim, itemLayout) {
  return map(points, function (point) {
    point = point.slice();
    point[dim] = itemLayout.initBaseline;
    return point;
  });
}

var each$6 = each;
function boxplotLayout(ecModel) {
  var groupResult = groupSeriesByAxis(ecModel);
  each$6(groupResult, function (groupItem) {
    var seriesModels = groupItem.seriesModels;

    if (!seriesModels.length) {
      return;
    }

    calculateBase(groupItem);
    each$6(seriesModels, function (seriesModel, idx) {
      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
    });
  });
}
/**
 * Group series by axis.
 */

function groupSeriesByAxis(ecModel) {
  var result = [];
  var axisList = [];
  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
    var baseAxis = seriesModel.getBaseAxis();
    var idx = indexOf(axisList, baseAxis);

    if (idx < 0) {
      idx = axisList.length;
      axisList[idx] = baseAxis;
      result[idx] = {
        axis: baseAxis,
        seriesModels: []
      };
    }

    result[idx].seriesModels.push(seriesModel);
  });
  return result;
}
/**
 * Calculate offset and box width for each series.
 */


function calculateBase(groupItem) {
  var baseAxis = groupItem.axis;
  var seriesModels = groupItem.seriesModels;
  var seriesCount = seriesModels.length;
  var boxWidthList = groupItem.boxWidthList = [];
  var boxOffsetList = groupItem.boxOffsetList = [];
  var boundList = [];
  var bandWidth;

  if (baseAxis.type === 'category') {
    bandWidth = baseAxis.getBandWidth();
  } else {
    var maxDataCount_1 = 0;
    each$6(seriesModels, function (seriesModel) {
      maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
    });
    var extent = baseAxis.getExtent();
    bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
  }

  each$6(seriesModels, function (seriesModel) {
    var boxWidthBound = seriesModel.get('boxWidth');

    if (!isArray$1(boxWidthBound)) {
      boxWidthBound = [boxWidthBound, boxWidthBound];
    }

    boundList.push([parsePercent$1(boxWidthBound[0], bandWidth) || 0, parsePercent$1(boxWidthBound[1], bandWidth) || 0]);
  });
  var availableWidth = bandWidth * 0.8 - 2;
  var boxGap = availableWidth / seriesCount * 0.3;
  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
  var base = boxWidth / 2 - availableWidth / 2;
  each$6(seriesModels, function (seriesModel, idx) {
    boxOffsetList.push(base);
    base += boxGap + boxWidth;
    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
  });
}
/**
 * Calculate points location for each series.
 */


function layoutSingleSeries(seriesModel, offset, boxWidth) {
  var coordSys = seriesModel.coordinateSystem;
  var data = seriesModel.getData();
  var halfWidth = boxWidth / 2;
  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
  var vDimIdx = 1 - cDimIdx;
  var coordDims = ['x', 'y'];
  var cDim = data.mapDimension(coordDims[cDimIdx]);
  var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);

  if (cDim == null || vDims.length < 5) {
    return;
  }

  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
    var axisDimVal = data.get(cDim, dataIndex);
    var median = getPoint(axisDimVal, vDims[2], dataIndex);
    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
    var ends = [];
    addBodyEnd(ends, end2, false);
    addBodyEnd(ends, end4, true);
    ends.push(end1, end2, end5, end4);
    layEndLine(ends, end1);
    layEndLine(ends, end5);
    layEndLine(ends, median);
    data.setItemLayout(dataIndex, {
      initBaseline: median[vDimIdx],
      ends: ends
    });
  }

  function getPoint(axisDimVal, dim, dataIndex) {
    var val = data.get(dim, dataIndex);
    var p = [];
    p[cDimIdx] = axisDimVal;
    p[vDimIdx] = val;
    var point;

    if (isNaN(axisDimVal) || isNaN(val)) {
      point = [NaN, NaN];
    } else {
      point = coordSys.dataToPoint(p);
      point[cDimIdx] += offset;
    }

    return point;
  }

  function addBodyEnd(ends, point, start) {
    var point1 = point.slice();
    var point2 = point.slice();
    point1[cDimIdx] += halfWidth;
    point2[cDimIdx] -= halfWidth;
    start ? ends.push(point1, point2) : ends.push(point2, point1);
  }

  function layEndLine(ends, endCenter) {
    var from = endCenter.slice();
    var to = endCenter.slice();
    from[cDimIdx] -= halfWidth;
    to[cDimIdx] += halfWidth;
    ends.push(from, to);
  }
}

/**
 * See:
 *  <https://en.wikipedia.org/wiki/Box_plot#cite_note-frigge_hoaglin_iglewicz-2>
 *  <http://stat.ethz.ch/R-manual/R-devel/library/grDevices/html/boxplot.stats.html>
 *
 * Helper method for preparing data.
 *
 * @param rawData like
 *        [
 *            [12,232,443], (raw data set for the first box)
 *            [3843,5545,1232], (raw data set for the second box)
 *            ...
 *        ]
 * @param opt.boundIQR=1.5 Data less than min bound is outlier.
 *      default 1.5, means Q1 - 1.5 * (Q3 - Q1).
 *      If 'none'/0 passed, min bound will not be used.
 */

function prepareBoxplotData(rawData, opt) {
  opt = opt || {};
  var boxData = [];
  var outliers = [];
  var boundIQR = opt.boundIQR;
  var useExtreme = boundIQR === 'none' || boundIQR === 0;

  for (var i = 0; i < rawData.length; i++) {
    var ascList = asc(rawData[i].slice());
    var Q1 = quantile(ascList, 0.25);
    var Q2 = quantile(ascList, 0.5);
    var Q3 = quantile(ascList, 0.75);
    var min = ascList[0];
    var max = ascList[ascList.length - 1];
    var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
    var low = useExtreme ? min : Math.max(min, Q1 - bound);
    var high = useExtreme ? max : Math.min(max, Q3 + bound);
    var itemNameFormatter = opt.itemNameFormatter;
    var itemName = isFunction$3(itemNameFormatter) ? itemNameFormatter({
      value: i
    }) : isString(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
    boxData.push([itemName, low, Q1, Q2, Q3, high]);

    for (var j = 0; j < ascList.length; j++) {
      var dataItem = ascList[j];

      if (dataItem < low || dataItem > high) {
        var outlier = [itemName, dataItem];
        outliers.push(outlier);
      }
    }
  }

  return {
    boxData: boxData,
    outliers: outliers
  };
}

var boxplotTransform = {
  type: 'echarts:boxplot',
  transform: function transform(params) {
    var upstream = params.upstream;

    if (upstream.sourceFormat !== SOURCE_FORMAT_ARRAY_ROWS) {
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        errMsg = makePrintable('source data is not applicable for this boxplot transform. Expect number[][].');
      }

      throwError(errMsg);
    }

    var result = prepareBoxplotData(upstream.getRawData(), params.config);
    return [{
      dimensions: ['ItemName', 'Low', 'Q1', 'Q2', 'Q3', 'High'],
      data: result.boxData
    }, {
      data: result.outliers
    }];
  }
};

function install$j(registers) {
  registers.registerSeriesModel(BoxplotSeriesModel);
  registers.registerChartView(BoxplotView);
  registers.registerLayout(boxplotLayout);
  registers.registerTransform(boxplotTransform);
}

var SKIP_PROPS = ['color', 'borderColor'];

var CandlestickView =
/** @class */
function (_super) {
  __extends$1(CandlestickView, _super);

  function CandlestickView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CandlestickView.type;
    return _this;
  }

  CandlestickView.prototype.render = function (seriesModel, ecModel, api) {
    // If there is clipPath created in large mode. Remove it.
    this.group.removeClipPath(); // Clear previously rendered progressive elements.

    this._progressiveEls = null;

    this._updateDrawMode(seriesModel);

    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
  };

  CandlestickView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this._clear();

    this._updateDrawMode(seriesModel);
  };

  CandlestickView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
    this._progressiveEls = [];
    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
  };

  CandlestickView.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  CandlestickView.prototype._updateDrawMode = function (seriesModel) {
    var isLargeDraw = seriesModel.pipelineContext.large;

    if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
      this._isLargeDraw = isLargeDraw;

      this._clear();
    }
  };

  CandlestickView.prototype._renderNormal = function (seriesModel) {
    var data = seriesModel.getData();
    var oldData = this._data;
    var group = this.group;
    var isSimpleBox = data.getLayout('isSimpleBox');
    var needsClip = seriesModel.get('clip', true);
    var coord = seriesModel.coordinateSystem;
    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
    // stream mode to normal mode, where previous elements should be removed.

    if (!this._data) {
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      if (data.hasValue(newIdx)) {
        var itemLayout = data.getItemLayout(newIdx);

        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
          return;
        }

        var el = createNormalBox$1(itemLayout, newIdx, true);
        initProps(el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
        setBoxCommon(el, data, newIdx, isSimpleBox);
        group.add(el);
        data.setItemGraphicEl(newIdx, el);
      }
    }).update(function (newIdx, oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx); // Empty data

      if (!data.hasValue(newIdx)) {
        group.remove(el);
        return;
      }

      var itemLayout = data.getItemLayout(newIdx);

      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
        group.remove(el);
        return;
      }

      if (!el) {
        el = createNormalBox$1(itemLayout);
      } else {
        updateProps(el, {
          shape: {
            points: itemLayout.ends
          }
        }, seriesModel, newIdx);
        saveOldStyle(el);
      }

      setBoxCommon(el, data, newIdx, isSimpleBox);
      group.add(el);
      data.setItemGraphicEl(newIdx, el);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && group.remove(el);
    }).execute();
    this._data = data;
  };

  CandlestickView.prototype._renderLarge = function (seriesModel) {
    this._clear();

    createLarge$1(seriesModel, this.group);
    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }
  };

  CandlestickView.prototype._incrementalRenderNormal = function (params, seriesModel) {
    var data = seriesModel.getData();
    var isSimpleBox = data.getLayout('isSimpleBox');
    var dataIndex;

    while ((dataIndex = params.next()) != null) {
      var itemLayout = data.getItemLayout(dataIndex);
      var el = createNormalBox$1(itemLayout);
      setBoxCommon(el, data, dataIndex, isSimpleBox);
      el.incremental = true;
      this.group.add(el);

      this._progressiveEls.push(el);
    }
  };

  CandlestickView.prototype._incrementalRenderLarge = function (params, seriesModel) {
    createLarge$1(seriesModel, this.group, this._progressiveEls, true);
  };

  CandlestickView.prototype.remove = function (ecModel) {
    this._clear();
  };

  CandlestickView.prototype._clear = function () {
    this.group.removeAll();
    this._data = null;
  };

  CandlestickView.type = 'candlestick';
  return CandlestickView;
}(ChartView);

var NormalBoxPathShape =
/** @class */
function () {
  function NormalBoxPathShape() {}

  return NormalBoxPathShape;
}();

var NormalBoxPath =
/** @class */
function (_super) {
  __extends$1(NormalBoxPath, _super);

  function NormalBoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'normalCandlestickBox';
    return _this;
  }

  NormalBoxPath.prototype.getDefaultShape = function () {
    return new NormalBoxPathShape();
  };

  NormalBoxPath.prototype.buildPath = function (ctx, shape) {
    var ends = shape.points;

    if (this.__simpleBox) {
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[6][0], ends[6][1]);
    } else {
      ctx.moveTo(ends[0][0], ends[0][1]);
      ctx.lineTo(ends[1][0], ends[1][1]);
      ctx.lineTo(ends[2][0], ends[2][1]);
      ctx.lineTo(ends[3][0], ends[3][1]);
      ctx.closePath();
      ctx.moveTo(ends[4][0], ends[4][1]);
      ctx.lineTo(ends[5][0], ends[5][1]);
      ctx.moveTo(ends[6][0], ends[6][1]);
      ctx.lineTo(ends[7][0], ends[7][1]);
    }
  };

  return NormalBoxPath;
}(Path);

function createNormalBox$1(itemLayout, dataIndex, isInit) {
  var ends = itemLayout.ends;
  return new NormalBoxPath({
    shape: {
      points: isInit ? transInit$1(ends, itemLayout) : ends
    },
    z2: 100
  });
}

function isNormalBoxClipped(clipArea, itemLayout) {
  var clipped = true;

  for (var i = 0; i < itemLayout.ends.length; i++) {
    // If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
      clipped = false;
      break;
    }
  }

  return clipped;
}

function setBoxCommon(el, data, dataIndex, isSimpleBox) {
  var itemModel = data.getItemModel(dataIndex);
  el.useStyle(data.getItemVisual(dataIndex, 'style'));
  el.style.strokeNoScale = true;
  el.__simpleBox = isSimpleBox;
  setStatesStylesFromModel(el, itemModel);
}

function transInit$1(points, itemLayout) {
  return map(points, function (point) {
    point = point.slice();
    point[1] = itemLayout.initBaseline;
    return point;
  });
}

var LargeBoxPathShape =
/** @class */
function () {
  function LargeBoxPathShape() {}

  return LargeBoxPathShape;
}();

var LargeBoxPath =
/** @class */
function (_super) {
  __extends$1(LargeBoxPath, _super);

  function LargeBoxPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this.type = 'largeCandlestickBox';
    return _this;
  }

  LargeBoxPath.prototype.getDefaultShape = function () {
    return new LargeBoxPathShape();
  };

  LargeBoxPath.prototype.buildPath = function (ctx, shape) {
    // Drawing lines is more efficient than drawing
    // a whole line or drawing rects.
    var points = shape.points;

    for (var i = 0; i < points.length;) {
      if (this.__sign === points[i++]) {
        var x = points[i++];
        ctx.moveTo(x, points[i++]);
        ctx.lineTo(x, points[i++]);
      } else {
        i += 3;
      }
    }
  };

  return LargeBoxPath;
}(Path);

function createLarge$1(seriesModel, group, progressiveEls, incremental) {
  var data = seriesModel.getData();
  var largePoints = data.getLayout('largePoints');
  var elP = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: 1,
    ignoreCoarsePointer: true
  });
  group.add(elP);
  var elN = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: -1,
    ignoreCoarsePointer: true
  });
  group.add(elN);
  var elDoji = new LargeBoxPath({
    shape: {
      points: largePoints
    },
    __sign: 0,
    ignoreCoarsePointer: true
  });
  group.add(elDoji);
  setLargeStyle(1, elP, seriesModel);
  setLargeStyle(-1, elN, seriesModel);
  setLargeStyle(0, elDoji, seriesModel);

  if (incremental) {
    elP.incremental = true;
    elN.incremental = true;
  }

  if (progressiveEls) {
    progressiveEls.push(elP, elN);
  }
}

function setLargeStyle(sign, el, seriesModel, data) {
  // TODO put in visual?
  var borderColor = seriesModel.get(['itemStyle', sign > 0 ? 'borderColor' : 'borderColor0']) // Use color for border color by default.
  || seriesModel.get(['itemStyle', sign > 0 ? 'color' : 'color0']);

  if (sign === 0) {
    borderColor = seriesModel.get(['itemStyle', 'borderColorDoji']);
  } // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke


  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(SKIP_PROPS);
  el.useStyle(itemStyle);
  el.style.fill = null;
  el.style.stroke = borderColor;
}

var CandlestickSeriesModel =
/** @class */
function (_super) {
  __extends$1(CandlestickSeriesModel, _super);

  function CandlestickSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CandlestickSeriesModel.type;
    _this.defaultValueDimensions = [{
      name: 'open',
      defaultTooltip: true
    }, {
      name: 'close',
      defaultTooltip: true
    }, {
      name: 'lowest',
      defaultTooltip: true
    }, {
      name: 'highest',
      defaultTooltip: true
    }];
    return _this;
  }
  /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */


  CandlestickSeriesModel.prototype.getShadowDim = function () {
    return 'open';
  };

  CandlestickSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    var itemLayout = data.getItemLayout(dataIndex);
    return itemLayout && selectors.rect(itemLayout.brushRect);
  };

  CandlestickSeriesModel.type = 'series.candlestick';
  CandlestickSeriesModel.dependencies = ['xAxis', 'yAxis', 'grid'];
  CandlestickSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    coordinateSystem: 'cartesian2d',
    legendHoverLink: true,
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    layout: null,
    clip: true,
    itemStyle: {
      color: '#eb5454',
      color0: '#47b262',
      borderColor: '#eb5454',
      borderColor0: '#47b262',
      borderColorDoji: null,
      // borderColor: '#d24040',
      // borderColor0: '#398f4f',
      borderWidth: 1
    },
    emphasis: {
      scale: true,
      itemStyle: {
        borderWidth: 2
      }
    },
    barMaxWidth: null,
    barMinWidth: null,
    barWidth: null,
    large: true,
    largeThreshold: 600,
    progressive: 3e3,
    progressiveThreshold: 1e4,
    progressiveChunkMode: 'mod',
    animationEasing: 'linear',
    animationDuration: 300
  };
  return CandlestickSeriesModel;
}(SeriesModel);

mixin(CandlestickSeriesModel, WhiskerBoxCommonMixin, true);

function candlestickPreprocessor(option) {
  if (!option || !isArray$1(option.series)) {
    return;
  } // Translate 'k' to 'candlestick'.


  each(option.series, function (seriesItem) {
    if (isObject$2(seriesItem) && seriesItem.type === 'k') {
      seriesItem.type = 'candlestick';
    }
  });
}

var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
var dojiBorderColorQuery = ['itemStyle', 'borderColorDoji'];
var positiveColorQuery = ['itemStyle', 'color'];
var negativeColorQuery = ['itemStyle', 'color0'];
var candlestickVisual = {
  seriesType: 'candlestick',
  plan: createRenderPlanner(),
  // For legend.
  performRawSeries: true,
  reset: function (seriesModel, ecModel) {
    function getColor(sign, model) {
      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
    }

    function getBorderColor(sign, model) {
      return model.get(sign === 0 ? dojiBorderColorQuery : sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
    } // Only visible series has each data be visual encoded


    if (ecModel.isSeriesFiltered(seriesModel)) {
      return;
    }

    var isLargeRender = seriesModel.pipelineContext.large;
    return !isLargeRender && {
      progress: function (params, data) {
        var dataIndex;

        while ((dataIndex = params.next()) != null) {
          var itemModel = data.getItemModel(dataIndex);
          var sign = data.getItemLayout(dataIndex).sign;
          var style = itemModel.getItemStyle();
          style.fill = getColor(sign, itemModel);
          style.stroke = getBorderColor(sign, itemModel) || style.fill;
          var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
          extend(existsStyle, style);
        }
      }
    };
  }
};

var candlestickLayout = {
  seriesType: 'candlestick',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var candleWidth = calculateCandleWidth(seriesModel, data);
    var cDimIdx = 0;
    var vDimIdx = 1;
    var coordDims = ['x', 'y'];
    var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
    var vDimsI = map(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
    var openDimI = vDimsI[0];
    var closeDimI = vDimsI[1];
    var lowestDimI = vDimsI[2];
    var highestDimI = vDimsI[3];
    data.setLayout({
      candleWidth: candleWidth,
      // The value is experimented visually.
      isSimpleBox: candleWidth <= 1.3
    });

    if (cDimI < 0 || vDimsI.length < 4) {
      return;
    }

    return {
      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
    };

    function normalProgress(params, data) {
      var dataIndex;
      var store = data.getStore();

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = store.get(cDimI, dataIndex);
        var openVal = store.get(openDimI, dataIndex);
        var closeVal = store.get(closeDimI, dataIndex);
        var lowestVal = store.get(lowestDimI, dataIndex);
        var highestVal = store.get(highestDimI, dataIndex);
        var ocLow = Math.min(openVal, closeVal);
        var ocHigh = Math.max(openVal, closeVal);
        var ocLowPoint = getPoint(ocLow, axisDimVal);
        var ocHighPoint = getPoint(ocHigh, axisDimVal);
        var lowestPoint = getPoint(lowestVal, axisDimVal);
        var highestPoint = getPoint(highestVal, axisDimVal);
        var ends = [];
        addBodyEnd(ends, ocHighPoint, 0);
        addBodyEnd(ends, ocLowPoint, 1);
        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
        var itemModel = data.getItemModel(dataIndex);
        var hasDojiColor = !!itemModel.get(['itemStyle', 'borderColorDoji']);
        data.setItemLayout(dataIndex, {
          sign: getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
          ends: ends,
          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
        });
      }

      function getPoint(val, axisDimVal) {
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
      }

      function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] = subPixelOptimize$1(point1[cDimIdx] + candleWidth / 2, 1, false);
        point2[cDimIdx] = subPixelOptimize$1(point2[cDimIdx] - candleWidth / 2, 1, true);
        start ? ends.push(point1, point2) : ends.push(point2, point1);
      }

      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
        var pmin = getPoint(lowestVal, axisDimVal);
        var pmax = getPoint(highestVal, axisDimVal);
        pmin[cDimIdx] -= candleWidth / 2;
        pmax[cDimIdx] -= candleWidth / 2;
        return {
          x: pmin[0],
          y: pmin[1],
          width:  candleWidth ,
          height:  pmax[1] - pmin[1] 
        };
      }

      function subPixelOptimizePoint(point) {
        point[cDimIdx] = subPixelOptimize$1(point[cDimIdx], 1);
        return point;
      }
    }

    function largeProgress(params, data) {
      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
      var points = createFloat32Array(params.count * 4);
      var offset = 0;
      var point;
      var tmpIn = [];
      var tmpOut = [];
      var dataIndex;
      var store = data.getStore();
      var hasDojiColor = !!seriesModel.get(['itemStyle', 'borderColorDoji']);

      while ((dataIndex = params.next()) != null) {
        var axisDimVal = store.get(cDimI, dataIndex);
        var openVal = store.get(openDimI, dataIndex);
        var closeVal = store.get(closeDimI, dataIndex);
        var lowestVal = store.get(lowestDimI, dataIndex);
        var highestVal = store.get(highestDimI, dataIndex);

        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
          points[offset++] = NaN;
          offset += 3;
          continue;
        }

        points[offset++] = getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
        tmpIn[cDimIdx] = axisDimVal;
        tmpIn[vDimIdx] = lowestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[0] : NaN;
        points[offset++] = point ? point[1] : NaN;
        tmpIn[vDimIdx] = highestVal;
        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
        points[offset++] = point ? point[1] : NaN;
      }

      data.setLayout('largePoints', points);
    }
  }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */

function getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
  var sign;

  if (openVal > closeVal) {
    sign = -1;
  } else if (openVal < closeVal) {
    sign = 1;
  } else {
    sign = hasDojiColor // When doji color is set, use it instead of color/color0.
    ? 0 : dataIndex > 0 // If close === open, compare with close of last record
    ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
    1;
  }

  return sign;
}

function calculateCandleWidth(seriesModel, data) {
  var baseAxis = seriesModel.getBaseAxis();
  var extent;
  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
  var barMaxWidth = parsePercent$1(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
  var barMinWidth = parsePercent$1(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
  var barWidth = seriesModel.get('barWidth');
  return barWidth != null ? parsePercent$1(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}

function install$k(registers) {
  registers.registerChartView(CandlestickView);
  registers.registerSeriesModel(CandlestickSeriesModel);
  registers.registerPreprocessor(candlestickPreprocessor);
  registers.registerVisual(candlestickVisual);
  registers.registerLayout(candlestickLayout);
}

function updateRipplePath(rippleGroup, effectCfg) {
  var color = effectCfg.rippleEffectColor || effectCfg.color;
  rippleGroup.eachChild(function (ripplePath) {
    ripplePath.attr({
      z: effectCfg.z,
      zlevel: effectCfg.zlevel,
      style: {
        stroke: effectCfg.brushType === 'stroke' ? color : null,
        fill: effectCfg.brushType === 'fill' ? color : null
      }
    });
  });
}

var EffectSymbol =
/** @class */
function (_super) {
  __extends$1(EffectSymbol, _super);

  function EffectSymbol(data, idx) {
    var _this = _super.call(this) || this;

    var symbol = new Symbol$2(data, idx);
    var rippleGroup = new Group$1();

    _this.add(symbol);

    _this.add(rippleGroup);

    _this.updateData(data, idx);

    return _this;
  }

  EffectSymbol.prototype.stopEffectAnimation = function () {
    this.childAt(1).removeAll();
  };

  EffectSymbol.prototype.startEffectAnimation = function (effectCfg) {
    var symbolType = effectCfg.symbolType;
    var color = effectCfg.color;
    var rippleNumber = effectCfg.rippleNumber;
    var rippleGroup = this.childAt(1);

    for (var i = 0; i < rippleNumber; i++) {
      // If width/height are set too small (e.g., set to 1) on ios10
      // and macOS Sierra, a circle stroke become a rect, no matter what
      // the scale is set. So we set width/height as 2. See #4136.
      var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
      ripplePath.attr({
        style: {
          strokeNoScale: true
        },
        z2: 99,
        silent: true,
        scaleX: 0.5,
        scaleY: 0.5
      });
      var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
      ripplePath.animate('', true).when(effectCfg.period, {
        scaleX: effectCfg.rippleScale / 2,
        scaleY: effectCfg.rippleScale / 2
      }).delay(delay).start();
      ripplePath.animateStyle(true).when(effectCfg.period, {
        opacity: 0
      }).delay(delay).start();
      rippleGroup.add(ripplePath);
    }

    updateRipplePath(rippleGroup, effectCfg);
  };
  /**
   * Update effect symbol
   */


  EffectSymbol.prototype.updateEffectAnimation = function (effectCfg) {
    var oldEffectCfg = this._effectCfg;
    var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed

    var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale', 'rippleNumber'];

    for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
      var propName = DIFFICULT_PROPS[i];

      if (oldEffectCfg[propName] !== effectCfg[propName]) {
        this.stopEffectAnimation();
        this.startEffectAnimation(effectCfg);
        return;
      }
    }

    updateRipplePath(rippleGroup, effectCfg);
  };
  /**
   * Highlight symbol
   */


  EffectSymbol.prototype.highlight = function () {
    enterEmphasis(this);
  };
  /**
   * Downplay symbol
   */


  EffectSymbol.prototype.downplay = function () {
    leaveEmphasis(this);
  };

  EffectSymbol.prototype.getSymbolType = function () {
    var symbol = this.childAt(0);
    return symbol && symbol.getSymbolType();
  };
  /**
   * Update symbol properties
   */


  EffectSymbol.prototype.updateData = function (data, idx) {
    var _this = this;

    var seriesModel = data.hostModel;
    this.childAt(0).updateData(data, idx);
    var rippleGroup = this.childAt(1);
    var itemModel = data.getItemModel(idx);
    var symbolType = data.getItemVisual(idx, 'symbol');
    var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
    var symbolStyle = data.getItemVisual(idx, 'style');
    var color = symbolStyle && symbolStyle.fill;
    var emphasisModel = itemModel.getModel('emphasis');
    rippleGroup.setScale(symbolSize);
    rippleGroup.traverse(function (ripplePath) {
      ripplePath.setStyle('fill', color);
    });
    var symbolOffset = normalizeSymbolOffset(data.getItemVisual(idx, 'symbolOffset'), symbolSize);

    if (symbolOffset) {
      rippleGroup.x = symbolOffset[0];
      rippleGroup.y = symbolOffset[1];
    }

    var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
    rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var effectCfg = {};
    effectCfg.showEffectOn = seriesModel.get('showEffectOn');
    effectCfg.rippleScale = itemModel.get(['rippleEffect', 'scale']);
    effectCfg.brushType = itemModel.get(['rippleEffect', 'brushType']);
    effectCfg.period = itemModel.get(['rippleEffect', 'period']) * 1000;
    effectCfg.effectOffset = idx / data.count();
    effectCfg.z = seriesModel.getShallow('z') || 0;
    effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
    effectCfg.symbolType = symbolType;
    effectCfg.color = color;
    effectCfg.rippleEffectColor = itemModel.get(['rippleEffect', 'color']);
    effectCfg.rippleNumber = itemModel.get(['rippleEffect', 'number']);

    if (effectCfg.showEffectOn === 'render') {
      this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
      this._effectCfg = effectCfg;
    } else {
      // Not keep old effect config
      this._effectCfg = null;
      this.stopEffectAnimation();

      this.onHoverStateChange = function (toState) {
        if (toState === 'emphasis') {
          if (effectCfg.showEffectOn !== 'render') {
            _this.startEffectAnimation(effectCfg);
          }
        } else if (toState === 'normal') {
          if (effectCfg.showEffectOn !== 'render') {
            _this.stopEffectAnimation();
          }
        }
      };
    }

    this._effectCfg = effectCfg;
    toggleHoverEmphasis(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  EffectSymbol.prototype.fadeOut = function (cb) {
    cb && cb();
  };
  return EffectSymbol;
}(Group$1);

var EffectScatterView =
/** @class */
function (_super) {
  __extends$1(EffectScatterView, _super);

  function EffectScatterView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = EffectScatterView.type;
    return _this;
  }

  EffectScatterView.prototype.init = function () {
    this._symbolDraw = new SymbolDraw(EffectSymbol);
  };

  EffectScatterView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var effectSymbolDraw = this._symbolDraw;
    effectSymbolDraw.updateData(data, {
      clipShape: this._getClipShape(seriesModel)
    });
    this.group.add(effectSymbolDraw.group);
  };

  EffectScatterView.prototype._getClipShape = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
    return seriesModel.get('clip', true) ? clipArea : null;
  };

  EffectScatterView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    this.group.dirty();
    var res = pointsLayout('').reset(seriesModel, ecModel, api);

    if (res.progress) {
      res.progress({
        start: 0,
        end: data.count(),
        count: data.count()
      }, data);
    }

    this._symbolDraw.updateLayout();
  };

  EffectScatterView.prototype._updateGroupTransform = function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && coordSys.getRoamTransform) {
      this.group.transform = clone$2(coordSys.getRoamTransform());
      this.group.decomposeTransform();
    }
  };

  EffectScatterView.prototype.remove = function (ecModel, api) {
    this._symbolDraw && this._symbolDraw.remove(true);
  };

  EffectScatterView.type = 'effectScatter';
  return EffectScatterView;
}(ChartView);

var EffectScatterSeriesModel =
/** @class */
function (_super) {
  __extends$1(EffectScatterSeriesModel, _super);

  function EffectScatterSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = EffectScatterSeriesModel.type;
    _this.hasSymbolVisual = true;
    return _this;
  }

  EffectScatterSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this, {
      useEncodeDefaulter: true
    });
  };

  EffectScatterSeriesModel.prototype.brushSelector = function (dataIndex, data, selectors) {
    return selectors.point(data.getItemLayout(dataIndex));
  };

  EffectScatterSeriesModel.type = 'series.effectScatter';
  EffectScatterSeriesModel.dependencies = ['grid', 'polar'];
  EffectScatterSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    effectType: 'ripple',
    progressive: 0,
    // When to show the effect, option: 'render'|'emphasis'
    showEffectOn: 'render',
    clip: true,
    // Ripple effect config
    rippleEffect: {
      period: 4,
      // Scale of ripple
      scale: 2.5,
      // Brush type can be fill or stroke
      brushType: 'fill',
      // Ripple number
      number: 3
    },
    universalTransition: {
      divideShape: 'clone'
    },
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,
    // symbol: null,        // 图形类型
    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    // symbolRotate: null,  // 图形旋转控制
    // itemStyle: {
    //     opacity: 1
    // }

  };
  return EffectScatterSeriesModel;
}(SeriesModel);

function install$l(registers) {
  registers.registerChartView(EffectScatterView);
  registers.registerSeriesModel(EffectScatterSeriesModel);
  registers.registerLayout(pointsLayout('effectScatter'));
}

var EffectLine =
/** @class */
function (_super) {
  __extends$1(EffectLine, _super);

  function EffectLine(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this.add(_this.createLine(lineData, idx, seriesScope));

    _this._updateEffectSymbol(lineData, idx);

    return _this;
  }

  EffectLine.prototype.createLine = function (lineData, idx, seriesScope) {
    return new Line$1(lineData, idx, seriesScope);
  };

  EffectLine.prototype._updateEffectSymbol = function (lineData, idx) {
    var itemModel = lineData.getItemModel(idx);
    var effectModel = itemModel.getModel('effect');
    var size = effectModel.get('symbolSize');
    var symbolType = effectModel.get('symbol');

    if (!isArray$1(size)) {
      size = [size, size];
    }

    var lineStyle = lineData.getItemVisual(idx, 'style');
    var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
    var symbol = this.childAt(1);

    if (this._symbolType !== symbolType) {
      // Remove previous
      this.remove(symbol);
      symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
      symbol.z2 = 100;
      symbol.culling = true;
      this.add(symbol);
    } // Symbol may be removed if loop is false


    if (!symbol) {
      return;
    } // Shadow color is same with color in default


    symbol.setStyle('shadowColor', color);
    symbol.setStyle(effectModel.getItemStyle(['color']));
    symbol.scaleX = size[0];
    symbol.scaleY = size[1];
    symbol.setColor(color);
    this._symbolType = symbolType;
    this._symbolScale = size;

    this._updateEffectAnimation(lineData, effectModel, idx);
  };

  EffectLine.prototype._updateEffectAnimation = function (lineData, effectModel, idx) {
    var symbol = this.childAt(1);

    if (!symbol) {
      return;
    }

    var points = lineData.getItemLayout(idx);
    var period = effectModel.get('period') * 1000;
    var loop = effectModel.get('loop');
    var roundTrip = effectModel.get('roundTrip');
    var constantSpeed = effectModel.get('constantSpeed');
    var delayExpr = retrieve(effectModel.get('delay'), function (idx) {
      return idx / lineData.count() * period / 3;
    }); // Ignore when updating

    symbol.ignore = true;

    this._updateAnimationPoints(symbol, points);

    if (constantSpeed > 0) {
      period = this._getLineLength(symbol) / constantSpeed * 1000;
    }

    if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
      symbol.stopAnimation();
      var delayNum = void 0;

      if (isFunction$3(delayExpr)) {
        delayNum = delayExpr(idx);
      } else {
        delayNum = delayExpr;
      }

      if (symbol.__t > 0) {
        delayNum = -period * symbol.__t;
      }

      this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
    }

    this._period = period;
    this._loop = loop;
    this._roundTrip = roundTrip;
  };

  EffectLine.prototype._animateSymbol = function (symbol, period, delayNum, loop, roundTrip) {
    if (period > 0) {
      symbol.__t = 0;
      var self_1 = this;
      var animator = symbol.animate('', loop).when(roundTrip ? period * 2 : period, {
        __t: roundTrip ? 2 : 1
      }).delay(delayNum).during(function () {
        self_1._updateSymbolPosition(symbol);
      });

      if (!loop) {
        animator.done(function () {
          self_1.remove(symbol);
        });
      }

      animator.start();
    }
  };

  EffectLine.prototype._getLineLength = function (symbol) {
    // Not so accurate
    return dist(symbol.__p1, symbol.__cp1) + dist(symbol.__cp1, symbol.__p2);
  };

  EffectLine.prototype._updateAnimationPoints = function (symbol, points) {
    symbol.__p1 = points[0];
    symbol.__p2 = points[1];
    symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
  };

  EffectLine.prototype.updateData = function (lineData, idx, seriesScope) {
    this.childAt(0).updateData(lineData, idx, seriesScope);

    this._updateEffectSymbol(lineData, idx);
  };

  EffectLine.prototype._updateSymbolPosition = function (symbol) {
    var p1 = symbol.__p1;
    var p2 = symbol.__p2;
    var cp1 = symbol.__cp1;
    var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
    var pos = [symbol.x, symbol.y];
    var lastPos = pos.slice();
    var quadraticAt$1 = quadraticAt;
    var quadraticDerivativeAt$1 = quadraticDerivativeAt;
    pos[0] = quadraticAt$1(p1[0], cp1[0], p2[0], t);
    pos[1] = quadraticAt$1(p1[1], cp1[1], p2[1], t); // Tangent

    var tx = symbol.__t < 1 ? quadraticDerivativeAt$1(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt$1(p2[0], cp1[0], p1[0], 1 - t);
    var ty = symbol.__t < 1 ? quadraticDerivativeAt$1(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt$1(p2[1], cp1[1], p1[1], 1 - t);
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType

    if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
      if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
        symbol.scaleY = dist(lastPos, pos) * 1.05; // make sure the last segment render within endPoint

        if (t === 1) {
          pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
          pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
        }
      } else if (symbol.__lastT === 1) {
        // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
        symbol.scaleY = 2 * dist(p1, pos);
      } else {
        symbol.scaleY = this._symbolScale[1];
      }
    }

    symbol.__lastT = symbol.__t;
    symbol.ignore = false;
    symbol.x = pos[0];
    symbol.y = pos[1];
  };

  EffectLine.prototype.updateLayout = function (lineData, idx) {
    this.childAt(0).updateLayout(lineData, idx);
    var effectModel = lineData.getItemModel(idx).getModel('effect');

    this._updateEffectAnimation(lineData, effectModel, idx);
  };

  return EffectLine;
}(Group$1);

var Polyline$1 =
/** @class */
function (_super) {
  __extends$1(Polyline$1, _super);

  function Polyline$1(lineData, idx, seriesScope) {
    var _this = _super.call(this) || this;

    _this._createPolyline(lineData, idx, seriesScope);

    return _this;
  }

  Polyline$1.prototype._createPolyline = function (lineData, idx, seriesScope) {
    // let seriesModel = lineData.hostModel;
    var points = lineData.getItemLayout(idx);
    var line = new Polyline({
      shape: {
        points: points
      }
    });
    this.add(line);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  Polyline$1.prototype.updateData = function (lineData, idx, seriesScope) {
    var seriesModel = lineData.hostModel;
    var line = this.childAt(0);
    var target = {
      shape: {
        points: lineData.getItemLayout(idx)
      }
    };
    updateProps(line, target, seriesModel, idx);

    this._updateCommonStl(lineData, idx, seriesScope);
  };

  Polyline$1.prototype._updateCommonStl = function (lineData, idx, seriesScope) {
    var line = this.childAt(0);
    var itemModel = lineData.getItemModel(idx);
    var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
    var focus = seriesScope && seriesScope.focus;
    var blurScope = seriesScope && seriesScope.blurScope;
    var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;

    if (!seriesScope || lineData.hasItemOption) {
      var emphasisModel = itemModel.getModel('emphasis');
      emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
      emphasisDisabled = emphasisModel.get('disabled');
      focus = emphasisModel.get('focus');
      blurScope = emphasisModel.get('blurScope');
    }

    line.useStyle(lineData.getItemVisual(idx, 'style'));
    line.style.fill = null;
    line.style.strokeNoScale = true;
    var lineEmphasisState = line.ensureState('emphasis');
    lineEmphasisState.style = emphasisLineStyle;
    toggleHoverEmphasis(this, focus, blurScope, emphasisDisabled);
  };

  Polyline$1.prototype.updateLayout = function (lineData, idx) {
    var polyline = this.childAt(0);
    polyline.setShape('points', lineData.getItemLayout(idx));
  };
  return Polyline$1;
}(Group$1);

var EffectPolyline =
/** @class */
function (_super) {
  __extends$1(EffectPolyline, _super);

  function EffectPolyline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._lastFrame = 0;
    _this._lastFramePercent = 0;
    return _this;
  } // Override


  EffectPolyline.prototype.createLine = function (lineData, idx, seriesScope) {
    return new Polyline$1(lineData, idx, seriesScope);
  };

  EffectPolyline.prototype._updateAnimationPoints = function (symbol, points) {
    this._points = points;
    var accLenArr = [0];
    var len = 0;

    for (var i = 1; i < points.length; i++) {
      var p1 = points[i - 1];
      var p2 = points[i];
      len += dist(p1, p2);
      accLenArr.push(len);
    }

    if (len === 0) {
      this._length = 0;
      return;
    }

    for (var i = 0; i < accLenArr.length; i++) {
      accLenArr[i] /= len;
    }

    this._offsets = accLenArr;
    this._length = len;
  };

  EffectPolyline.prototype._getLineLength = function () {
    return this._length;
  };

  EffectPolyline.prototype._updateSymbolPosition = function (symbol) {
    var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
    var points = this._points;
    var offsets = this._offsets;
    var len = points.length;

    if (!offsets) {
      // Has length 0
      return;
    }

    var lastFrame = this._lastFrame;
    var frame;

    if (t < this._lastFramePercent) {
      // Start from the next frame
      // PENDING start from lastFrame ?
      var start = Math.min(lastFrame + 1, len - 1);

      for (frame = start; frame >= 0; frame--) {
        if (offsets[frame] <= t) {
          break;
        }
      } // PENDING really need to do this ?


      frame = Math.min(frame, len - 2);
    } else {
      for (frame = lastFrame; frame < len; frame++) {
        if (offsets[frame] > t) {
          break;
        }
      }

      frame = Math.min(frame - 1, len - 2);
    }

    var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
    var p0 = points[frame];
    var p1 = points[frame + 1];
    symbol.x = p0[0] * (1 - p) + p * p1[0];
    symbol.y = p0[1] * (1 - p) + p * p1[1];
    var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
    var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
    symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
    this._lastFrame = frame;
    this._lastFramePercent = t;
    symbol.ignore = false;
  };
  return EffectPolyline;
}(EffectLine);

var LargeLinesPathShape =
/** @class */
function () {
  function LargeLinesPathShape() {
    this.polyline = false;
    this.curveness = 0;
    this.segs = [];
  }

  return LargeLinesPathShape;
}();

var LargeLinesPath =
/** @class */
function (_super) {
  __extends$1(LargeLinesPath, _super);

  function LargeLinesPath(opts) {
    var _this = _super.call(this, opts) || this;

    _this._off = 0;
    _this.hoverDataIdx = -1;
    return _this;
  }

  LargeLinesPath.prototype.reset = function () {
    this.notClear = false;
    this._off = 0;
  };

  LargeLinesPath.prototype.getDefaultStyle = function () {
    return {
      stroke: '#000',
      fill: null
    };
  };

  LargeLinesPath.prototype.getDefaultShape = function () {
    return new LargeLinesPathShape();
  };

  LargeLinesPath.prototype.buildPath = function (ctx, shape) {
    var segs = shape.segs;
    var curveness = shape.curveness;
    var i;

    if (shape.polyline) {
      for (i = this._off; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          ctx.moveTo(segs[i++], segs[i++]);

          for (var k = 1; k < count; k++) {
            ctx.lineTo(segs[i++], segs[i++]);
          }
        }
      }
    } else {
      for (i = this._off; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];
        ctx.moveTo(x0, y0);

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
          ctx.quadraticCurveTo(x2, y2, x1, y1);
        } else {
          ctx.lineTo(x1, y1);
        }
      }
    }

    if (this.incremental) {
      this._off = i;
      this.notClear = true;
    }
  };

  LargeLinesPath.prototype.findDataIndex = function (x, y) {
    var shape = this.shape;
    var segs = shape.segs;
    var curveness = shape.curveness;
    var lineWidth = this.style.lineWidth;

    if (shape.polyline) {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var count = segs[i++];

        if (count > 0) {
          var x0 = segs[i++];
          var y0 = segs[i++];

          for (var k = 1; k < count; k++) {
            var x1 = segs[i++];
            var y1 = segs[i++];

            if (containStroke(x0, y0, x1, y1, lineWidth, x, y)) {
              return dataIndex;
            }
          }
        }

        dataIndex++;
      }
    } else {
      var dataIndex = 0;

      for (var i = 0; i < segs.length;) {
        var x0 = segs[i++];
        var y0 = segs[i++];
        var x1 = segs[i++];
        var y1 = segs[i++];

        if (curveness > 0) {
          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;

          if (containStroke$2(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) {
            return dataIndex;
          }
        } else {
          if (containStroke(x0, y0, x1, y1, lineWidth, x, y)) {
            return dataIndex;
          }
        }

        dataIndex++;
      }
    }

    return -1;
  };

  LargeLinesPath.prototype.contain = function (x, y) {
    var localPos = this.transformCoordToLocal(x, y);
    var rect = this.getBoundingRect();
    x = localPos[0];
    y = localPos[1];

    if (rect.contain(x, y)) {
      // Cache found data index.
      var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
      return dataIdx >= 0;
    }

    this.hoverDataIdx = -1;
    return false;
  };

  LargeLinesPath.prototype.getBoundingRect = function () {
    // Ignore stroke for large symbol draw.
    var rect = this._rect;

    if (!rect) {
      var shape = this.shape;
      var points = shape.segs;
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;

      for (var i = 0; i < points.length;) {
        var x = points[i++];
        var y = points[i++];
        minX = Math.min(x, minX);
        maxX = Math.max(x, maxX);
        minY = Math.min(y, minY);
        maxY = Math.max(y, maxY);
      }

      rect = this._rect = new BoundingRect(minX, minY, maxX, maxY);
    }

    return rect;
  };

  return LargeLinesPath;
}(Path);

var LargeLineDraw =
/** @class */
function () {
  function LargeLineDraw() {
    this.group = new Group$1();
  }
  /**
   * Update symbols draw by new data
   */


  LargeLineDraw.prototype.updateData = function (data) {
    this._clear();

    var lineEl = this._create();

    lineEl.setShape({
      segs: data.getLayout('linesPoints')
    });

    this._setCommon(lineEl, data);
  };
  /**
   * @override
   */

  LargeLineDraw.prototype.incrementalPrepareUpdate = function (data) {
    this.group.removeAll();

    this._clear();
  };
  /**
   * @override
   */

  LargeLineDraw.prototype.incrementalUpdate = function (taskParams, data) {
    var lastAdded = this._newAdded[0];
    var linePoints = data.getLayout('linesPoints');
    var oldSegs = lastAdded && lastAdded.shape.segs; // Merging the exists. Each element has 1e4 points.
    // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)

    if (oldSegs && oldSegs.length < 2e4) {
      var oldLen = oldSegs.length;
      var newSegs = new Float32Array(oldLen + linePoints.length); // Concat two array

      newSegs.set(oldSegs);
      newSegs.set(linePoints, oldLen);
      lastAdded.setShape({
        segs: newSegs
      });
    } else {
      // Clear
      this._newAdded = [];

      var lineEl = this._create();

      lineEl.incremental = true;
      lineEl.setShape({
        segs: linePoints
      });

      this._setCommon(lineEl, data);

      lineEl.__startIndex = taskParams.start;
    }
  };
  /**
   * @override
   */


  LargeLineDraw.prototype.remove = function () {
    this._clear();
  };

  LargeLineDraw.prototype.eachRendered = function (cb) {
    this._newAdded[0] && cb(this._newAdded[0]);
  };

  LargeLineDraw.prototype._create = function () {
    var lineEl = new LargeLinesPath({
      cursor: 'default',
      ignoreCoarsePointer: true
    });

    this._newAdded.push(lineEl);

    this.group.add(lineEl);
    return lineEl;
  };

  LargeLineDraw.prototype._setCommon = function (lineEl, data, isIncremental) {
    var hostModel = data.hostModel;
    lineEl.setShape({
      polyline: hostModel.get('polyline'),
      curveness: hostModel.get(['lineStyle', 'curveness'])
    });
    lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
    lineEl.style.strokeNoScale = true;
    var style = data.getVisual('style');

    if (style && style.stroke) {
      lineEl.setStyle('stroke', style.stroke);
    }

    lineEl.setStyle('fill', null);
    var ecData = getECData(lineEl); // Enable tooltip
    // PENDING May have performance issue when path is extremely large

    ecData.seriesIndex = hostModel.seriesIndex;
    lineEl.on('mousemove', function (e) {
      ecData.dataIndex = null;
      var dataIndex = lineEl.hoverDataIdx;

      if (dataIndex > 0) {
        // Provide dataIndex for tooltip
        ecData.dataIndex = dataIndex + lineEl.__startIndex;
      }
    });
  };

  LargeLineDraw.prototype._clear = function () {
    this._newAdded = [];
    this.group.removeAll();
  };
  return LargeLineDraw;
}();

var linesLayout = {
  seriesType: 'lines',
  plan: createRenderPlanner(),
  reset: function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (!coordSys) {
      if (process.env.NODE_ENV !== 'production') {
        error('The lines series must have a coordinate system.');
      }

      return;
    }

    var isPolyline = seriesModel.get('polyline');
    var isLarge = seriesModel.pipelineContext.large;
    return {
      progress: function (params, lineData) {
        var lineCoords = [];

        if (isLarge) {
          var points = void 0;
          var segCount = params.end - params.start;

          if (isPolyline) {
            var totalCoordsCount = 0;

            for (var i = params.start; i < params.end; i++) {
              totalCoordsCount += seriesModel.getLineCoordsCount(i);
            }

            points = new Float32Array(segCount + totalCoordsCount * 2);
          } else {
            points = new Float32Array(segCount * 4);
          }

          var offset = 0;
          var pt = [];

          for (var i = params.start; i < params.end; i++) {
            var len = seriesModel.getLineCoords(i, lineCoords);

            if (isPolyline) {
              points[offset++] = len;
            }

            for (var k = 0; k < len; k++) {
              pt = coordSys.dataToPoint(lineCoords[k], false, pt);
              points[offset++] = pt[0];
              points[offset++] = pt[1];
            }
          }

          lineData.setLayout('linesPoints', points);
        } else {
          for (var i = params.start; i < params.end; i++) {
            var itemModel = lineData.getItemModel(i);
            var len = seriesModel.getLineCoords(i, lineCoords);
            var pts = [];

            if (isPolyline) {
              for (var j = 0; j < len; j++) {
                pts.push(coordSys.dataToPoint(lineCoords[j]));
              }
            } else {
              pts[0] = coordSys.dataToPoint(lineCoords[0]);
              pts[1] = coordSys.dataToPoint(lineCoords[1]);
              var curveness = itemModel.get(['lineStyle', 'curveness']);

              if (+curveness) {
                pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
              }
            }

            lineData.setItemLayout(i, pts);
          }
        }
      }
    };
  }
};

var LinesView =
/** @class */
function (_super) {
  __extends$1(LinesView, _super);

  function LinesView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LinesView.type;
    return _this;
  }

  LinesView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    var zlevel = seriesModel.get('zlevel');
    var trailLength = seriesModel.get(['effect', 'trailLength']);
    var zr = api.getZr(); // Avoid the drag cause ghost shadow
    // FIXME Better way ?
    // SVG doesn't support

    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg) {
      zr.painter.getLayer(zlevel).clear(true);
    } // Config layer with motion blur


    if (this._lastZlevel != null && !isSvg) {
      zr.configLayer(this._lastZlevel, {
        motionBlur: false
      });
    }

    if (this._showEffect(seriesModel) && trailLength > 0) {
      if (!isSvg) {
        zr.configLayer(zlevel, {
          motionBlur: true,
          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
        });
      } else if (process.env.NODE_ENV !== 'production') {
        console.warn('SVG render mode doesn\'t support lines with trail effect');
      }
    }

    lineDraw.updateData(data);
    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);

    if (clipPath) {
      this.group.setClipPath(clipPath);
    } else {
      this.group.removeClipPath();
    }

    this._lastZlevel = zlevel;
    this._finished = true;
  };

  LinesView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();

    var lineDraw = this._updateLineDraw(data, seriesModel);

    lineDraw.incrementalPrepareUpdate(data);

    this._clearLayer(api);

    this._finished = false;
  };

  LinesView.prototype.incrementalRender = function (taskParams, seriesModel, ecModel) {
    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());

    this._finished = taskParams.end === seriesModel.getData().count();
  };

  LinesView.prototype.eachRendered = function (cb) {
    this._lineDraw && this._lineDraw.eachRendered(cb);
  };

  LinesView.prototype.updateTransform = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var pipelineContext = seriesModel.pipelineContext;

    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
      return {
        update: true
      };
    } else {
      // TODO Use same logic with ScatterView.
      // Manually update layout
      var res = linesLayout.reset(seriesModel, ecModel, api);

      if (res.progress) {
        res.progress({
          start: 0,
          end: data.count(),
          count: data.count()
        }, data);
      } // Not in large mode


      this._lineDraw.updateLayout();

      this._clearLayer(api);
    }
  };

  LinesView.prototype._updateLineDraw = function (data, seriesModel) {
    var lineDraw = this._lineDraw;

    var hasEffect = this._showEffect(seriesModel);

    var isPolyline = !!seriesModel.get('polyline');
    var pipelineContext = seriesModel.pipelineContext;
    var isLargeDraw = pipelineContext.large;

    if (process.env.NODE_ENV !== 'production') {
      if (hasEffect && isLargeDraw) {
        console.warn('Large lines not support effect');
      }
    }

    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
      if (lineDraw) {
        lineDraw.remove();
      }

      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline$1 : hasEffect ? EffectLine : Line$1);
      this._hasEffet = hasEffect;
      this._isPolyline = isPolyline;
      this._isLargeDraw = isLargeDraw;
    }

    this.group.add(lineDraw.group);
    return lineDraw;
  };

  LinesView.prototype._showEffect = function (seriesModel) {
    return !!seriesModel.get(['effect', 'show']);
  };

  LinesView.prototype._clearLayer = function (api) {
    // Not use motion when dragging or zooming
    var zr = api.getZr();
    var isSvg = zr.painter.getType() === 'svg';

    if (!isSvg && this._lastZlevel != null) {
      zr.painter.getLayer(this._lastZlevel).clear(true);
    }
  };

  LinesView.prototype.remove = function (ecModel, api) {
    this._lineDraw && this._lineDraw.remove();
    this._lineDraw = null; // Clear motion when lineDraw is removed

    this._clearLayer(api);
  };

  LinesView.prototype.dispose = function (ecModel, api) {
    this.remove(ecModel, api);
  };

  LinesView.type = 'lines';
  return LinesView;
}(ChartView);

var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;

function compatEc2(seriesOpt) {
  var data = seriesOpt.data;

  if (data && data[0] && data[0][0] && data[0][0].coord) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Lines data configuration has been changed to' + ' { coords:[[1,2],[2,3]] }');
    }

    seriesOpt.data = map(data, function (itemOpt) {
      var coords = [itemOpt[0].coord, itemOpt[1].coord];
      var target = {
        coords: coords
      };

      if (itemOpt[0].name) {
        target.fromName = itemOpt[0].name;
      }

      if (itemOpt[1].name) {
        target.toName = itemOpt[1].name;
      }

      return mergeAll([target, itemOpt[0], itemOpt[1]]);
    });
  }
}

var LinesSeriesModel =
/** @class */
function (_super) {
  __extends$1(LinesSeriesModel, _super);

  function LinesSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LinesSeriesModel.type;
    _this.visualStyleAccessPath = 'lineStyle';
    _this.visualDrawType = 'stroke';
    return _this;
  }

  LinesSeriesModel.prototype.init = function (option) {
    // The input data may be null/undefined.
    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type

    compatEc2(option);

    var result = this._processFlatCoordsArray(option.data);

    this._flatCoords = result.flatCoords;
    this._flatCoordsOffset = result.flatCoordsOffset;

    if (result.flatCoords) {
      option.data = new Float32Array(result.count);
    }

    _super.prototype.init.apply(this, arguments);
  };

  LinesSeriesModel.prototype.mergeOption = function (option) {
    compatEc2(option);

    if (option.data) {
      // Only update when have option data to merge.
      var result = this._processFlatCoordsArray(option.data);

      this._flatCoords = result.flatCoords;
      this._flatCoordsOffset = result.flatCoordsOffset;

      if (result.flatCoords) {
        option.data = new Float32Array(result.count);
      }
    }

    _super.prototype.mergeOption.apply(this, arguments);
  };

  LinesSeriesModel.prototype.appendData = function (params) {
    var result = this._processFlatCoordsArray(params.data);

    if (result.flatCoords) {
      if (!this._flatCoords) {
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
      } else {
        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
      }

      params.data = new Float32Array(result.count);
    }

    this.getRawData().appendData(params.data);
  };

  LinesSeriesModel.prototype._getCoordsFromItemModel = function (idx) {
    var itemModel = this.getData().getItemModel(idx);
    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');

    if (process.env.NODE_ENV !== 'production') {
      if (!(coords instanceof Array && coords.length > 0 && coords[0] instanceof Array)) {
        throw new Error('Invalid coords ' + JSON.stringify(coords) + '. Lines must have 2d coords array in data item.');
      }
    }

    return coords;
  };

  LinesSeriesModel.prototype.getLineCoordsCount = function (idx) {
    if (this._flatCoordsOffset) {
      return this._flatCoordsOffset[idx * 2 + 1];
    } else {
      return this._getCoordsFromItemModel(idx).length;
    }
  };

  LinesSeriesModel.prototype.getLineCoords = function (idx, out) {
    if (this._flatCoordsOffset) {
      var offset = this._flatCoordsOffset[idx * 2];
      var len = this._flatCoordsOffset[idx * 2 + 1];

      for (var i = 0; i < len; i++) {
        out[i] = out[i] || [];
        out[i][0] = this._flatCoords[offset + i * 2];
        out[i][1] = this._flatCoords[offset + i * 2 + 1];
      }

      return len;
    } else {
      var coords = this._getCoordsFromItemModel(idx);

      for (var i = 0; i < coords.length; i++) {
        out[i] = out[i] || [];
        out[i][0] = coords[i][0];
        out[i][1] = coords[i][1];
      }

      return coords.length;
    }
  };

  LinesSeriesModel.prototype._processFlatCoordsArray = function (data) {
    var startOffset = 0;

    if (this._flatCoords) {
      startOffset = this._flatCoords.length;
    } // Stored as a typed array. In format
    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |


    if (isNumber$1(data[0])) {
      var len = data.length; // Store offset and len of each segment

      var coordsOffsetAndLenStorage = new Uint32Arr(len);
      var coordsStorage = new Float64Arr(len);
      var coordsCursor = 0;
      var offsetCursor = 0;
      var dataCount = 0;

      for (var i = 0; i < len;) {
        dataCount++;
        var count = data[i++]; // Offset

        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len

        coordsOffsetAndLenStorage[offsetCursor++] = count;

        for (var k = 0; k < count; k++) {
          var x = data[i++];
          var y = data[i++];
          coordsStorage[coordsCursor++] = x;
          coordsStorage[coordsCursor++] = y;

          if (i > len) {
            if (process.env.NODE_ENV !== 'production') {
              throw new Error('Invalid data format.');
            }
          }
        }
      }

      return {
        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
        flatCoords: coordsStorage,
        count: dataCount
      };
    }

    return {
      flatCoordsOffset: null,
      flatCoords: null,
      count: data.length
    };
  };

  LinesSeriesModel.prototype.getInitialData = function (option, ecModel) {
    if (process.env.NODE_ENV !== 'production') {
      var CoordSys = CoordinateSystemManager.get(option.coordinateSystem);

      if (!CoordSys) {
        throw new Error('Unknown coordinate system ' + option.coordinateSystem);
      }
    }

    var lineData = new SeriesData(['value'], this);
    lineData.hasItemOption = false;
    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
      // dataItem is simply coords
      if (dataItem instanceof Array) {
        return NaN;
      } else {
        lineData.hasItemOption = true;
        var value = dataItem.value;

        if (value != null) {
          return value instanceof Array ? value[dimIndex] : value;
        }
      }
    });
    return lineData;
  };

  LinesSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var itemModel = data.getItemModel(dataIndex);
    var name = itemModel.get('name');

    if (name) {
      return name;
    }

    var fromName = itemModel.get('fromName');
    var toName = itemModel.get('toName');
    var nameArr = [];
    fromName != null && nameArr.push(fromName);
    toName != null && nameArr.push(toName);
    return createTooltipMarkup('nameValue', {
      name: nameArr.join(' > ')
    });
  };

  LinesSeriesModel.prototype.preventIncremental = function () {
    return !!this.get(['effect', 'show']);
  };

  LinesSeriesModel.prototype.getProgressive = function () {
    var progressive = this.option.progressive;

    if (progressive == null) {
      return this.option.large ? 1e4 : this.get('progressive');
    }

    return progressive;
  };

  LinesSeriesModel.prototype.getProgressiveThreshold = function () {
    var progressiveThreshold = this.option.progressiveThreshold;

    if (progressiveThreshold == null) {
      return this.option.large ? 2e4 : this.get('progressiveThreshold');
    }

    return progressiveThreshold;
  };

  LinesSeriesModel.prototype.getZLevelKey = function () {
    var effectModel = this.getModel('effect');
    var trailLength = effectModel.get('trailLength');
    return this.getData().count() > this.getProgressiveThreshold() // Each progressive series has individual key.
    ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
  };

  LinesSeriesModel.type = 'series.lines';
  LinesSeriesModel.dependencies = ['grid', 'polar', 'geo', 'calendar'];
  LinesSeriesModel.defaultOption = {
    coordinateSystem: 'geo',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    // Cartesian coordinate system
    xAxisIndex: 0,
    yAxisIndex: 0,
    symbol: ['none', 'none'],
    symbolSize: [10, 10],
    // Geo coordinate system
    geoIndex: 0,
    effect: {
      show: false,
      period: 4,
      constantSpeed: 0,
      symbol: 'circle',
      symbolSize: 3,
      loop: true,
      trailLength: 0.2
    },
    large: false,
    // Available when large is true
    largeThreshold: 2000,
    polyline: false,
    clip: true,
    label: {
      show: false,
      position: 'end' // distance: 5,
      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调

    },
    lineStyle: {
      opacity: 0.5
    }
  };
  return LinesSeriesModel;
}(SeriesModel);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function normalize$3(a) {
  if (!(a instanceof Array)) {
    a = [a, a];
  }

  return a;
}

var linesVisual = {
  seriesType: 'lines',
  reset: function (seriesModel) {
    var symbolType = normalize$3(seriesModel.get('symbol'));
    var symbolSize = normalize$3(seriesModel.get('symbolSize'));
    var data = seriesModel.getData();
    data.setVisual('fromSymbol', symbolType && symbolType[0]);
    data.setVisual('toSymbol', symbolType && symbolType[1]);
    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);

    function dataEach(data, idx) {
      var itemModel = data.getItemModel(idx);
      var symbolType = normalize$3(itemModel.getShallow('symbol', true));
      var symbolSize = normalize$3(itemModel.getShallow('symbolSize', true));
      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
    }

    return {
      dataEach: data.hasItemOption ? dataEach : null
    };
  }
};

function install$m(registers) {
  registers.registerChartView(LinesView);
  registers.registerSeriesModel(LinesSeriesModel);
  registers.registerLayout(linesLayout);
  registers.registerVisual(linesVisual);
}

var GRADIENT_LEVELS = 256;

var HeatmapLayer =
/** @class */
function () {
  function HeatmapLayer() {
    this.blurSize = 30;
    this.pointSize = 20;
    this.maxOpacity = 1;
    this.minOpacity = 0;
    this._gradientPixels = {
      inRange: null,
      outOfRange: null
    };
    var canvas = platformApi.createCanvas();
    this.canvas = canvas;
  }
  /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */


  HeatmapLayer.prototype.update = function (data, width, height, normalize, colorFunc, isInRange) {
    var brush = this._getBrush();

    var gradientInRange = this._getGradient(colorFunc, 'inRange');

    var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');

    var r = this.pointSize + this.blurSize;
    var canvas = this.canvas;
    var ctx = canvas.getContext('2d');
    var len = data.length;
    canvas.width = width;
    canvas.height = height;

    for (var i = 0; i < len; ++i) {
      var p = data[i];
      var x = p[0];
      var y = p[1];
      var value = p[2]; // calculate alpha using value

      var alpha = normalize(value); // draw with the circle brush with alpha

      ctx.globalAlpha = alpha;
      ctx.drawImage(brush, x - r, y - r);
    }

    if (!canvas.width || !canvas.height) {
      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
      // 'CanvasRenderingContext2D': The source height is 0."
      return canvas;
    } // colorize the canvas using alpha value and set with gradient


    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imageData.data;
    var offset = 0;
    var pixelLen = pixels.length;
    var minOpacity = this.minOpacity;
    var maxOpacity = this.maxOpacity;
    var diffOpacity = maxOpacity - minOpacity;

    while (offset < pixelLen) {
      var alpha = pixels[offset + 3] / 256;
      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data

      if (alpha > 0) {
        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]

        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
        pixels[offset++] = gradient[gradientOffset];
        pixels[offset++] = gradient[gradientOffset + 1];
        pixels[offset++] = gradient[gradientOffset + 2];
        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
      } else {
        offset += 4;
      }
    }

    ctx.putImageData(imageData, 0, 0);
    return canvas;
  };
  /**
   * get canvas of a black circle brush used for canvas to draw later
   */


  HeatmapLayer.prototype._getBrush = function () {
    var brushCanvas = this._brushCanvas || (this._brushCanvas = platformApi.createCanvas()); // set brush size

    var r = this.pointSize + this.blurSize;
    var d = r * 2;
    brushCanvas.width = d;
    brushCanvas.height = d;
    var ctx = brushCanvas.getContext('2d');
    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
    // draw the distinct circle in an invisible place,
    // and use shadowOffset to draw shadow in the center of the canvas

    ctx.shadowOffsetX = d;
    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
    // color in color map

    ctx.shadowColor = '#000'; // draw circle in the left to the canvas

    ctx.beginPath();
    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
    return brushCanvas;
  };
  /**
   * get gradient color map
   * @private
   */


  HeatmapLayer.prototype._getGradient = function (colorFunc, state) {
    var gradientPixels = this._gradientPixels;
    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
    var color = [0, 0, 0, 0];
    var off = 0;

    for (var i = 0; i < 256; i++) {
      colorFunc[state](i / 255, true, color);
      pixelsSingleState[off++] = color[0];
      pixelsSingleState[off++] = color[1];
      pixelsSingleState[off++] = color[2];
      pixelsSingleState[off++] = color[3];
    }

    return pixelsSingleState;
  };

  return HeatmapLayer;
}();

function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  pieceList = map(pieceList, function (piece) {
    return {
      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
    };
  });
  var len = pieceList.length;
  var lastIndex = 0;
  return function (val) {
    var i; // Try to find in the location of the last found

    for (i = lastIndex; i < len; i++) {
      var interval = pieceList[i].interval;

      if (interval[0] <= val && val <= interval[1]) {
        lastIndex = i;
        break;
      }
    }

    if (i === len) {
      // Not found, back interation
      for (i = lastIndex - 1; i >= 0; i--) {
        var interval = pieceList[i].interval;

        if (interval[0] <= val && val <= interval[1]) {
          lastIndex = i;
          break;
        }
      }
    }

    return i >= 0 && i < len && selected[i];
  };
}

function getIsInContinuousRange(dataExtent, range) {
  var dataSpan = dataExtent[1] - dataExtent[0];
  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
  return function (val) {
    return val >= range[0] && val <= range[1];
  };
}

function isGeoCoordSys(coordSys) {
  var dimensions = coordSys.dimensions; // Not use coordSys.type === 'geo' because coordSys maybe extended

  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}

var HeatmapView =
/** @class */
function (_super) {
  __extends$1(HeatmapView, _super);

  function HeatmapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = HeatmapView.type;
    return _this;
  }

  HeatmapView.prototype.render = function (seriesModel, ecModel, api) {
    var visualMapOfThisSeries;
    ecModel.eachComponent('visualMap', function (visualMap) {
      visualMap.eachTargetSeries(function (targetSeries) {
        if (targetSeries === seriesModel) {
          visualMapOfThisSeries = visualMap;
        }
      });
    });

    if (process.env.NODE_ENV !== 'production') {
      if (!visualMapOfThisSeries) {
        throw new Error('Heatmap must use with visualMap');
      }
    } // Clear previously rendered progressive elements.


    this._progressiveEls = null;
    this.group.removeAll();
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
    } else if (isGeoCoordSys(coordSys)) {
      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    }
  };

  HeatmapView.prototype.incrementalPrepareRender = function (seriesModel, ecModel, api) {
    this.group.removeAll();
  };

  HeatmapView.prototype.incrementalRender = function (params, seriesModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys) {
      // geo does not support incremental rendering?
      if (isGeoCoordSys(coordSys)) {
        this.render(seriesModel, ecModel, api);
      } else {
        this._progressiveEls = [];

        this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
      }
    }
  };

  HeatmapView.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  HeatmapView.prototype._renderOnCartesianAndCalendar = function (seriesModel, api, start, end, incremental) {
    var coordSys = seriesModel.coordinateSystem;
    var isCartesian2d = isCoordinateSystemType(coordSys, 'cartesian2d');
    var width;
    var height;
    var xAxisExtent;
    var yAxisExtent;

    if (isCartesian2d) {
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');

      if (process.env.NODE_ENV !== 'production') {
        if (!(xAxis.type === 'category' && yAxis.type === 'category')) {
          throw new Error('Heatmap on cartesian must have two category axes');
        }

        if (!(xAxis.onBand && yAxis.onBand)) {
          throw new Error('Heatmap on cartesian must have two axes with boundaryGap true');
        }
      } // add 0.5px to avoid the gaps


      width = xAxis.getBandWidth() + .5;
      height = yAxis.getBandWidth() + .5;
      xAxisExtent = xAxis.scale.getExtent();
      yAxisExtent = yAxis.scale.getExtent();
    }

    var group = this.group;
    var data = seriesModel.getData();
    var emphasisStyle = seriesModel.getModel(['emphasis', 'itemStyle']).getItemStyle();
    var blurStyle = seriesModel.getModel(['blur', 'itemStyle']).getItemStyle();
    var selectStyle = seriesModel.getModel(['select', 'itemStyle']).getItemStyle();
    var borderRadius = seriesModel.get(['itemStyle', 'borderRadius']);
    var labelStatesModels = getLabelStatesModels(seriesModel);
    var emphasisModel = seriesModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var emphasisDisabled = emphasisModel.get('disabled');
    var dataDims = isCartesian2d ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];

    for (var idx = start; idx < end; idx++) {
      var rect = void 0;
      var style = data.getItemVisual(idx, 'style');

      if (isCartesian2d) {
        var dataDimX = data.get(dataDims[0], idx);
        var dataDimY = data.get(dataDims[1], idx); // Ignore empty data and out of extent data

        if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) {
          continue;
        }

        var point = coordSys.dataToPoint([dataDimX, dataDimY]);
        rect = new Rect({
          shape: {
            x: point[0] - width / 2,
            y: point[1] - height / 2,
            width: width,
            height: height
          },
          style: style
        });
      } else {
        // Ignore empty data
        if (isNaN(data.get(dataDims[1], idx))) {
          continue;
        }

        rect = new Rect({
          z2: 1,
          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
          style: style
        });
      } // Optimization for large dataset


      if (data.hasItemOption) {
        var itemModel = data.getItemModel(idx);
        var emphasisModel_1 = itemModel.getModel('emphasis');
        emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
        blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
        selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle(); // Each item value struct in the data would be firstly
        // {
        //     itemStyle: { borderRadius: [30, 30] },
        //     value: [2022, 02, 22]
        // }

        borderRadius = itemModel.get(['itemStyle', 'borderRadius']);
        focus = emphasisModel_1.get('focus');
        blurScope = emphasisModel_1.get('blurScope');
        emphasisDisabled = emphasisModel_1.get('disabled');
        labelStatesModels = getLabelStatesModels(itemModel);
      }

      rect.shape.r = borderRadius;
      var rawValue = seriesModel.getRawValue(idx);
      var defaultText = '-';

      if (rawValue && rawValue[2] != null) {
        defaultText = rawValue[2] + '';
      }

      setLabelStyle(rect, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: idx,
        defaultOpacity: style.opacity,
        defaultText: defaultText
      });
      rect.ensureState('emphasis').style = emphasisStyle;
      rect.ensureState('blur').style = blurStyle;
      rect.ensureState('select').style = selectStyle;
      toggleHoverEmphasis(rect, focus, blurScope, emphasisDisabled);
      rect.incremental = incremental; // PENDING

      if (incremental) {
        // Rect must use hover layer if it's incremental.
        rect.states.emphasis.hoverLayer = true;
      }

      group.add(rect);
      data.setItemGraphicEl(idx, rect);

      if (this._progressiveEls) {
        this._progressiveEls.push(rect);
      }
    }
  };

  HeatmapView.prototype._renderOnGeo = function (geo, seriesModel, visualMapModel, api) {
    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
    //     throw new Error('Data range must have color visuals');
    // }

    var data = seriesModel.getData();
    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
    hmLayer.blurSize = seriesModel.get('blurSize');
    hmLayer.pointSize = seriesModel.get('pointSize');
    hmLayer.minOpacity = seriesModel.get('minOpacity');
    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
    var rect = geo.getViewRect().clone();
    var roamTransform = geo.getRoamTransform();
    rect.applyTransform(roamTransform); // Clamp on viewport

    var x = Math.max(rect.x, 0);
    var y = Math.max(rect.y, 0);
    var x2 = Math.min(rect.width + rect.x, api.getWidth());
    var y2 = Math.min(rect.height + rect.y, api.getHeight());
    var width = x2 - x;
    var height = y2 - y;
    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
    var points = data.mapArray(dims, function (lng, lat, value) {
      var pt = geo.dataToPoint([lng, lat]);
      pt[0] -= x;
      pt[1] -= y;
      pt.push(value);
      return pt;
    });
    var dataExtent = visualMapModel.getExtent();
    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
      inRange: inRangeVisuals.color.getColorMapper(),
      outOfRange: outOfRangeVisuals.color.getColorMapper()
    }, isInRange);
    var img = new ZRImage({
      style: {
        width: width,
        height: height,
        x: x,
        y: y,
        image: hmLayer.canvas
      },
      silent: true
    });
    this.group.add(img);
  };

  HeatmapView.type = 'heatmap';
  return HeatmapView;
}(ChartView);

var HeatmapSeriesModel =
/** @class */
function (_super) {
  __extends$1(HeatmapSeriesModel, _super);

  function HeatmapSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = HeatmapSeriesModel.type;
    return _this;
  }

  HeatmapSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this, {
      generateCoord: 'value'
    });
  };

  HeatmapSeriesModel.prototype.preventIncremental = function () {
    var coordSysCreator = CoordinateSystemManager.get(this.get('coordinateSystem'));

    if (coordSysCreator && coordSysCreator.dimensions) {
      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    }
  };

  HeatmapSeriesModel.type = 'series.heatmap';
  HeatmapSeriesModel.dependencies = ['grid', 'geo', 'calendar'];
  HeatmapSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Geo coordinate system
    geoIndex: 0,
    blurSize: 30,
    pointSize: 20,
    maxOpacity: 1,
    minOpacity: 0,
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  };
  return HeatmapSeriesModel;
}(SeriesModel);

function install$n(registers) {
  registers.registerChartView(HeatmapView);
  registers.registerSeriesModel(HeatmapSeriesModel);
}

var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal

var LAYOUT_ATTRS = [{
  xy: 'x',
  wh: 'width',
  index: 0,
  posDesc: ['left', 'right']
}, {
  xy: 'y',
  wh: 'height',
  index: 1,
  posDesc: ['top', 'bottom']
}];
var pathForLineWidth = new Circle$1();

var PictorialBarView =
/** @class */
function (_super) {
  __extends$1(PictorialBarView, _super);

  function PictorialBarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PictorialBarView.type;
    return _this;
  }

  PictorialBarView.prototype.render = function (seriesModel, ecModel, api) {
    var group = this.group;
    var data = seriesModel.getData();
    var oldData = this._data;
    var cartesian = seriesModel.coordinateSystem;
    var baseAxis = cartesian.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var coordSysRect = cartesian.master.getRect();
    var opt = {
      ecSize: {
        width: api.getWidth(),
        height: api.getHeight()
      },
      seriesModel: seriesModel,
      coordSys: cartesian,
      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
      isHorizontal: isHorizontal,
      valueDim: LAYOUT_ATTRS[+isHorizontal],
      categoryDim: LAYOUT_ATTRS[1 - +isHorizontal]
    };
    data.diff(oldData).add(function (dataIndex) {
      if (!data.hasValue(dataIndex)) {
        return;
      }

      var itemModel = getItemModel(data, dataIndex);
      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
      var bar = createBar(data, opt, symbolMeta);
      data.setItemGraphicEl(dataIndex, bar);
      group.add(bar);
      updateCommon$1(bar, opt, symbolMeta);
    }).update(function (newIndex, oldIndex) {
      var bar = oldData.getItemGraphicEl(oldIndex);

      if (!data.hasValue(newIndex)) {
        group.remove(bar);
        return;
      }

      var itemModel = getItemModel(data, newIndex);
      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
      var pictorialShapeStr = getShapeStr(data, symbolMeta);

      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
        group.remove(bar);
        data.setItemGraphicEl(newIndex, null);
        bar = null;
      }

      if (bar) {
        updateBar(bar, opt, symbolMeta);
      } else {
        bar = createBar(data, opt, symbolMeta, true);
      }

      data.setItemGraphicEl(newIndex, bar);
      bar.__pictorialSymbolMeta = symbolMeta; // Add back

      group.add(bar);
      updateCommon$1(bar, opt, symbolMeta);
    }).remove(function (dataIndex) {
      var bar = oldData.getItemGraphicEl(dataIndex);
      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
    }).execute();
    this._data = data;
    return this.group;
  };

  PictorialBarView.prototype.remove = function (ecModel, api) {
    var group = this.group;
    var data = this._data;

    if (ecModel.get('animation')) {
      if (data) {
        data.eachItemGraphicEl(function (bar) {
          removeBar(data, getECData(bar).dataIndex, ecModel, bar);
        });
      }
    } else {
      group.removeAll();
    }
  };

  PictorialBarView.type = 'pictorialBar';
  return PictorialBarView;
}(ChartView); // Set or calculate default value about symbol, and calculate layout info.


function getSymbolMeta(data, dataIndex, itemModel, opt) {
  var layout = data.getItemLayout(dataIndex);
  var symbolRepeat = itemModel.get('symbolRepeat');
  var symbolClip = itemModel.get('symbolClip');
  var symbolPosition = itemModel.get('symbolPosition') || 'start';
  var symbolRotate = itemModel.get('symbolRotate');
  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
  var isAnimationEnabled = itemModel.isAnimationEnabled();
  var symbolMeta = {
    dataIndex: dataIndex,
    layout: layout,
    itemModel: itemModel,
    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
    style: data.getItemVisual(dataIndex, 'style'),
    symbolClip: symbolClip,
    symbolRepeat: symbolRepeat,
    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
    symbolPatternSize: symbolPatternSize,
    rotation: rotation,
    animationModel: isAnimationEnabled ? itemModel : null,
    hoverScale: isAnimationEnabled && itemModel.get(['emphasis', 'scale']),
    z2: itemModel.getShallow('z', true) || 0
  };
  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
  var symbolSize = symbolMeta.symbolSize;
  var symbolOffset = normalizeSymbolOffset(itemModel.get('symbolOffset'), symbolSize);
  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
  return symbolMeta;
} // bar length can be negative.


function prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
  var valueDim = opt.valueDim;
  var symbolBoundingData = itemModel.get('symbolBoundingData');
  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
  var boundingLength;

  if (isArray$1(symbolBoundingData)) {
    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
    boundingLength = symbolBoundingExtent[pxSignIdx];
  } else if (symbolBoundingData != null) {
    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
  } else if (symbolRepeat) {
    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
  } else {
    boundingLength = layout[valueDim.wh];
  }

  outputSymbolMeta.boundingLength = boundingLength;

  if (symbolRepeat) {
    outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
  } // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
  // and when borderWidth be settled, the actual linewidth will be NaN


  outputSymbolMeta.pxSign = boundingLength > 0 ? 1 : -1;
}

function convertToCoordOnAxis(axis, value) {
  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
} // Support ['100%', '100%']


function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
  var valueDim = opt.valueDim;
  var categoryDim = opt.categoryDim;
  var categorySize = Math.abs(layout[categoryDim.wh]);
  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
  var parsedSymbolSize;

  if (isArray$1(symbolSize)) {
    parsedSymbolSize = symbolSize.slice();
  } else {
    if (symbolSize == null) {
      // will parse to number below
      parsedSymbolSize = ['100%', '100%'];
    } else {
      parsedSymbolSize = [symbolSize, symbolSize];
    }
  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
  // to complicated to calculate real percent value if considering scaled lineWidth.
  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
  // which can be tolerated in pictorial chart.


  parsedSymbolSize[categoryDim.index] = parsePercent$1(parsedSymbolSize[categoryDim.index], categorySize);
  parsedSymbolSize[valueDim.index] = parsePercent$1(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
  outputSymbolMeta.symbolSize = parsedSymbolSize; // If x or y is less than zero, show reversed shape.

  var symbolScale = outputSymbolMeta.symbolScale = [parsedSymbolSize[0] / symbolPatternSize, parsedSymbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.

  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}

function prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
  // In symbols are drawn with scale, so do not need to care about the case that width
  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
  // be calculated.
  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;

  if (valueLineWidth) {
    pathForLineWidth.attr({
      scaleX: symbolScale[0],
      scaleY: symbolScale[1],
      rotation: rotation
    });
    pathForLineWidth.updateTransform();
    valueLineWidth /= pathForLineWidth.getLineScale();
    valueLineWidth *= symbolScale[opt.valueDim.index];
  }

  outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}

function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
  var categoryDim = opt.categoryDim;
  var valueDim = opt.valueDim;
  var pxSign = outputSymbolMeta.pxSign;
  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
  // want symbols to rotate on its center, which should not be translated
  // when rotating.

  if (symbolRepeat) {
    var absBoundingLength = Math.abs(boundingLength);
    var symbolMargin = retrieve(itemModel.get('symbolMargin'), '15%') + '';
    var hasEndGap = false;

    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
      hasEndGap = true;
      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
    }

    var symbolMarginNumeric = parsePercent$1(symbolMargin, symbolSize[valueDim.index]);
    var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
    // to ensure that all of the symbols will not be overflow the given area.

    var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Both final repeatTimes and final symbolMarginNumeric area calculated based on
    // boundingLength.

    var repeatSpecified = isNumeric$1(symbolRepeat);
    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
    // entirely in the given layout area.

    var mDiff = absBoundingLength - repeatTimes * unitLength;
    symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
    uLenWithMargin = unitLength + symbolMarginNumeric * 2;
    endFix = hasEndGap ? 0 : symbolMarginNumeric * 2; // Update repeatTimes when not all symbol will be shown.

    if (!repeatSpecified && symbolRepeat !== 'fixed') {
      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
    }

    pathLen = repeatTimes * uLenWithMargin - endFix;
    outputSymbolMeta.repeatTimes = repeatTimes;
    outputSymbolMeta.symbolMargin = symbolMarginNumeric;
  }

  var sizeFix = pxSign * (pathLen / 2);
  var pathPosition = outputSymbolMeta.pathPosition = [];
  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'

  if (symbolOffset) {
    pathPosition[0] += symbolOffset[0];
    pathPosition[1] += symbolOffset[1];
  }

  var bundlePosition = outputSymbolMeta.bundlePosition = [];
  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
  bundlePosition[valueDim.index] = layout[valueDim.xy];
  var barRectShape = outputSymbolMeta.barRectShape = extend({}, layout);
  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
  var clipShape = outputSymbolMeta.clipShape = {}; // Consider that symbol may be overflow layout rect.

  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
  clipShape[valueDim.xy] = 0;
  clipShape[valueDim.wh] = layout[valueDim.wh];
}

function createPath(symbolMeta) {
  var symbolPatternSize = symbolMeta.symbolPatternSize;
  var path = createSymbol( // Consider texture img, make a big size.
  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
  path.attr({
    culling: true
  });
  path.type !== 'image' && path.setStyle({
    strokeNoScale: true
  });
  return path;
}

function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var symbolSize = symbolMeta.symbolSize;
  var valueLineWidth = symbolMeta.valueLineWidth;
  var pathPosition = symbolMeta.pathPosition;
  var valueDim = opt.valueDim;
  var repeatTimes = symbolMeta.repeatTimes || 0;
  var index = 0;
  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
  eachPath(bar, function (path) {
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;

    if (index < repeatTimes) {
      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
    } else {
      updateAttr(path, null, {
        scaleX: 0,
        scaleY: 0
      }, symbolMeta, isUpdate, function () {
        bundle.remove(path);
      });
    } // updateHoverAnimation(path, symbolMeta);


    index++;
  });

  for (; index < repeatTimes; index++) {
    var path = createPath(symbolMeta);
    path.__pictorialAnimationIndex = index;
    path.__pictorialRepeatTimes = repeatTimes;
    bundle.add(path);
    var target = makeTarget(index);
    updateAttr(path, {
      x: target.x,
      y: target.y,
      scaleX: 0,
      scaleY: 0
    }, {
      scaleX: target.scaleX,
      scaleY: target.scaleY,
      rotation: target.rotation
    }, symbolMeta, isUpdate);
  }

  function makeTarget(index) {
    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
    // Otherwise: i = index;

    var pxSign = symbolMeta.pxSign;
    var i = index;

    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
      i = repeatTimes - 1 - index;
    }

    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
    return {
      x: position[0],
      y: position[1],
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1],
      rotation: symbolMeta.rotation
    };
  }
}

function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
  var bundle = bar.__pictorialBundle;
  var mainPath = bar.__pictorialMainPath;

  if (!mainPath) {
    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
    bundle.add(mainPath);
    updateAttr(mainPath, {
      x: symbolMeta.pathPosition[0],
      y: symbolMeta.pathPosition[1],
      scaleX: 0,
      scaleY: 0,
      rotation: symbolMeta.rotation
    }, {
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1]
    }, symbolMeta, isUpdate);
  } else {
    updateAttr(mainPath, null, {
      x: symbolMeta.pathPosition[0],
      y: symbolMeta.pathPosition[1],
      scaleX: symbolMeta.symbolScale[0],
      scaleY: symbolMeta.symbolScale[1],
      rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
  }
} // bar rect is used for label.


function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
  var rectShape = extend({}, symbolMeta.barRectShape);
  var barRect = bar.__pictorialBarRect;

  if (!barRect) {
    barRect = bar.__pictorialBarRect = new Rect({
      z2: 2,
      shape: rectShape,
      silent: true,
      style: {
        stroke: 'transparent',
        fill: 'transparent',
        lineWidth: 0
      }
    });
    barRect.disableMorphing = true;
    bar.add(barRect);
  } else {
    updateAttr(barRect, null, {
      shape: rectShape
    }, symbolMeta, isUpdate);
  }
}

function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
  // If not clip, symbol will be remove and rebuilt.
  if (symbolMeta.symbolClip) {
    var clipPath = bar.__pictorialClipPath;
    var clipShape = extend({}, symbolMeta.clipShape);
    var valueDim = opt.valueDim;
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;

    if (clipPath) {
      updateProps(clipPath, {
        shape: clipShape
      }, animationModel, dataIndex);
    } else {
      clipShape[valueDim.wh] = 0;
      clipPath = new Rect({
        shape: clipShape
      });

      bar.__pictorialBundle.setClipPath(clipPath);

      bar.__pictorialClipPath = clipPath;
      var target = {};
      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
        shape: target
      }, animationModel, dataIndex);
    }
  }
}

function getItemModel(data, dataIndex) {
  var itemModel = data.getItemModel(dataIndex);
  itemModel.getAnimationDelayParams = getAnimationDelayParams;
  itemModel.isAnimationEnabled = isAnimationEnabled;
  return itemModel;
}

function getAnimationDelayParams(path) {
  // The order is the same as the z-order, see `symbolRepeatDiretion`.
  return {
    index: path.__pictorialAnimationIndex,
    count: path.__pictorialRepeatTimes
  };
}

function isAnimationEnabled() {
  // `animation` prop can be set on itemModel in pictorial bar chart.
  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}

function createBar(data, opt, symbolMeta, isUpdate) {
  // bar is the main element for each data.
  var bar = new Group$1(); // bundle is used for location and clip.

  var bundle = new Group$1();
  bar.add(bundle);
  bar.__pictorialBundle = bundle;
  bundle.x = symbolMeta.bundlePosition[0];
  bundle.y = symbolMeta.bundlePosition[1];

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
  }

  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
  bar.__pictorialSymbolMeta = symbolMeta;
  return bar;
}

function updateBar(bar, opt, symbolMeta) {
  var animationModel = symbolMeta.animationModel;
  var dataIndex = symbolMeta.dataIndex;
  var bundle = bar.__pictorialBundle;
  updateProps(bundle, {
    x: symbolMeta.bundlePosition[0],
    y: symbolMeta.bundlePosition[1]
  }, animationModel, dataIndex);

  if (symbolMeta.symbolRepeat) {
    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
  } else {
    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
  }

  createOrUpdateBarRect(bar, symbolMeta, true);
  createOrUpdateClip(bar, opt, symbolMeta, true);
}

function removeBar(data, dataIndex, animationModel, bar) {
  // Not show text when animating
  var labelRect = bar.__pictorialBarRect;
  labelRect && labelRect.removeTextContent();
  var paths = [];
  eachPath(bar, function (path) {
    paths.push(path);
  });
  bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.

  bar.__pictorialClipPath && (animationModel = null);
  each(paths, function (path) {
    removeElement(path, {
      scaleX: 0,
      scaleY: 0
    }, animationModel, dataIndex, function () {
      bar.parent && bar.parent.remove(bar);
    });
  });
  data.setItemGraphicEl(dataIndex, null);
}

function getShapeStr(data, symbolMeta) {
  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
}

function eachPath(bar, cb, context) {
  // Do not use Group#eachChild, because it do not support remove.
  each(bar.__pictorialBundle.children(), function (el) {
    el !== bar.__pictorialBarRect && cb.call(context, el);
  });
}

function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.

  if (symbolMeta.symbolClip && !isUpdate) {
    animationAttrs && el.attr(animationAttrs);
  } else {
    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
  }
}

function updateCommon$1(bar, opt, symbolMeta) {
  var dataIndex = symbolMeta.dataIndex;
  var itemModel = symbolMeta.itemModel; // Color must be excluded.
  // Because symbol provide setColor individually to set fill and stroke

  var emphasisModel = itemModel.getModel('emphasis');
  var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
  var blurStyle = itemModel.getModel(['blur', 'itemStyle']).getItemStyle();
  var selectStyle = itemModel.getModel(['select', 'itemStyle']).getItemStyle();
  var cursorStyle = itemModel.getShallow('cursor');
  var focus = emphasisModel.get('focus');
  var blurScope = emphasisModel.get('blurScope');
  var hoverScale = emphasisModel.get('scale');
  eachPath(bar, function (path) {
    if (path instanceof ZRImage) {
      var pathStyle = path.style;
      path.useStyle(extend({
        // TODO other properties like dx, dy ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, symbolMeta.style));
    } else {
      path.useStyle(symbolMeta.style);
    }

    var emphasisState = path.ensureState('emphasis');
    emphasisState.style = emphasisStyle;

    if (hoverScale) {
      // NOTE: Must after scale is set after updateAttr
      emphasisState.scaleX = path.scaleX * 1.1;
      emphasisState.scaleY = path.scaleY * 1.1;
    }

    path.ensureState('blur').style = blurStyle;
    path.ensureState('select').style = selectStyle;
    cursorStyle && (path.cursor = cursorStyle);
    path.z2 = symbolMeta.z2;
  });
  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
  var barRect = bar.__pictorialBarRect;
  setLabelStyle(barRect, getLabelStatesModels(itemModel), {
    labelFetcher: opt.seriesModel,
    labelDataIndex: dataIndex,
    defaultText: getDefaultLabel(opt.seriesModel.getData(), dataIndex),
    inheritColor: symbolMeta.style.fill,
    defaultOpacity: symbolMeta.style.opacity,
    defaultOutsidePosition: barPositionOutside
  });
  toggleHoverEmphasis(bar, focus, blurScope, emphasisModel.get('disabled'));
}

function toIntTimes(times) {
  var roundedTimes = Math.round(times); // Escapse accurate error

  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}

var PictorialBarSeriesModel =
/** @class */
function (_super) {
  __extends$1(PictorialBarSeriesModel, _super);

  function PictorialBarSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PictorialBarSeriesModel.type;
    _this.hasSymbolVisual = true;
    _this.defaultSymbol = 'roundRect';
    return _this;
  }

  PictorialBarSeriesModel.prototype.getInitialData = function (option) {
    // Disable stack.
    option.stack = null;
    return _super.prototype.getInitialData.apply(this, arguments);
  };

  PictorialBarSeriesModel.type = 'series.pictorialBar';
  PictorialBarSeriesModel.dependencies = ['grid'];
  PictorialBarSeriesModel.defaultOption = inheritDefaultOption(BaseBarSeriesModel.defaultOption, {
    symbol: 'circle',
    symbolSize: null,
    symbolRotate: null,
    symbolPosition: null,
    symbolOffset: null,
    symbolMargin: null,
    symbolRepeat: false,
    symbolRepeatDirection: 'end',
    symbolClip: false,
    symbolBoundingData: null,
    symbolPatternSize: 400,
    barGap: '-100%',
    // z can be set in data item, which is z2 actually.
    // Disable progressive
    progressive: 0,
    emphasis: {
      // By default pictorialBar do not hover scale. Hover scale is not suitable
      // for the case that both has foreground and background.
      scale: false
    },
    select: {
      itemStyle: {
        borderColor: '#212121'
      }
    }
  });
  return PictorialBarSeriesModel;
}(BaseBarSeriesModel);

function install$o(registers) {
  registers.registerChartView(PictorialBarView);
  registers.registerSeriesModel(PictorialBarSeriesModel);
  registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, curry(layout, 'pictorialBar')); // Do layout after other overall layout, which can prepare some information.

  registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, createProgressiveLayout('pictorialBar'));
}

var ThemeRiverView =
/** @class */
function (_super) {
  __extends$1(ThemeRiverView, _super);

  function ThemeRiverView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ThemeRiverView.type;
    _this._layers = [];
    return _this;
  }

  ThemeRiverView.prototype.render = function (seriesModel, ecModel, api) {
    var data = seriesModel.getData();
    var self = this;
    var group = this.group;
    var layersSeries = seriesModel.getLayerSeries();
    var layoutInfo = data.getLayout('layoutInfo');
    var rect = layoutInfo.rect;
    var boundaryGap = layoutInfo.boundaryGap;
    group.x = 0;
    group.y = rect.y + boundaryGap[0];

    function keyGetter(item) {
      return item.name;
    }

    var dataDiffer = new DataDiffer(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
    var newLayersGroups = [];
    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();

    function process(status, idx, oldIdx) {
      var oldLayersGroups = self._layers;

      if (status === 'remove') {
        group.remove(oldLayersGroups[idx]);
        return;
      }

      var points0 = [];
      var points1 = [];
      var style;
      var indices = layersSeries[idx].indices;
      var j = 0;

      for (; j < indices.length; j++) {
        var layout = data.getItemLayout(indices[j]);
        var x = layout.x;
        var y0 = layout.y0;
        var y = layout.y;
        points0.push(x, y0);
        points1.push(x, y0 + y);
        style = data.getItemVisual(indices[j], 'style');
      }

      var polygon;
      var textLayout = data.getItemLayout(indices[0]);
      var labelModel = seriesModel.getModel('label');
      var margin = labelModel.get('margin');
      var emphasisModel = seriesModel.getModel('emphasis');

      if (status === 'add') {
        var layerGroup = newLayersGroups[idx] = new Group$1();
        polygon = new ECPolygon({
          shape: {
            points: points0,
            stackedOnPoints: points1,
            smooth: 0.4,
            stackedOnSmooth: 0.4,
            smoothConstraint: false
          },
          z2: 0
        });
        layerGroup.add(polygon);
        group.add(layerGroup);

        if (seriesModel.isAnimationEnabled()) {
          polygon.setClipPath(createGridClipShape$2(polygon.getBoundingRect(), seriesModel, function () {
            polygon.removeClipPath();
          }));
        }
      } else {
        var layerGroup = oldLayersGroups[oldIdx];
        polygon = layerGroup.childAt(0);
        group.add(layerGroup);
        newLayersGroups[idx] = layerGroup;
        updateProps(polygon, {
          shape: {
            points: points0,
            stackedOnPoints: points1
          }
        }, seriesModel);
        saveOldStyle(polygon);
      }

      setLabelStyle(polygon, getLabelStatesModels(seriesModel), {
        labelDataIndex: indices[j - 1],
        defaultText: data.getName(indices[j - 1]),
        inheritColor: style.fill
      }, {
        normal: {
          verticalAlign: 'middle' // align: 'right'

        }
      });
      polygon.setTextConfig({
        position: null,
        local: true
      });
      var labelEl = polygon.getTextContent(); // TODO More label position options.

      if (labelEl) {
        labelEl.x = textLayout.x - margin;
        labelEl.y = textLayout.y0 + textLayout.y / 2;
      }

      polygon.useStyle(style);
      data.setItemGraphicEl(idx, polygon);
      setStatesStylesFromModel(polygon, seriesModel);
      toggleHoverEmphasis(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    }

    this._layersSeries = layersSeries;
    this._layers = newLayersGroups;
  };

  ThemeRiverView.type = 'themeRiver';
  return ThemeRiverView;
}(ChartView);

function createGridClipShape$2(rect, seriesModel, cb) {
  var rectEl = new Rect({
    shape: {
      x: rect.x - 10,
      y: rect.y - 10,
      width: 0,
      height: rect.height + 20
    }
  });
  initProps(rectEl, {
    shape: {
      x: rect.x - 50,
      width: rect.width + 100,
      height: rect.height + 20
    }
  }, seriesModel, cb);
  return rectEl;
}

var DATA_NAME_INDEX = 2;

var ThemeRiverSeriesModel =
/** @class */
function (_super) {
  __extends$1(ThemeRiverSeriesModel, _super);

  function ThemeRiverSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ThemeRiverSeriesModel.type;
    return _this;
  }
  /**
   * @override
   */


  ThemeRiverSeriesModel.prototype.init = function (option) {
    // eslint-disable-next-line
    _super.prototype.init.apply(this, arguments); // Put this function here is for the sake of consistency of code style.
    // Enable legend selection for each data item
    // Use a function instead of direct access because data reference may changed


    this.legendVisualProvider = new LegendVisualProvider(bind(this.getData, this), bind(this.getRawData, this));
  };
  /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */


  ThemeRiverSeriesModel.prototype.fixData = function (data) {
    var rawDataLength = data.length;
    /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */

    var timeValueKeys = {}; // grouped data by name

    var groupResult = groupData(data, function (item) {
      if (!timeValueKeys.hasOwnProperty(item[0] + '')) {
        timeValueKeys[item[0] + ''] = -1;
      }

      return item[2];
    });
    var layerData = [];
    groupResult.buckets.each(function (items, key) {
      layerData.push({
        name: key,
        dataList: items
      });
    });
    var layerNum = layerData.length;

    for (var k = 0; k < layerNum; ++k) {
      var name_1 = layerData[k].name;

      for (var j = 0; j < layerData[k].dataList.length; ++j) {
        var timeValue = layerData[k].dataList[j][0] + '';
        timeValueKeys[timeValue] = k;
      }

      for (var timeValue in timeValueKeys) {
        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
          timeValueKeys[timeValue] = k;
          data[rawDataLength] = [timeValue, 0, name_1];
          rawDataLength++;
        }
      }
    }

    return data;
  };
  /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */


  ThemeRiverSeriesModel.prototype.getInitialData = function (option, ecModel) {
    var singleAxisModel = this.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];
    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined

    var filterData = filter(option.data, function (dataItem) {
      return dataItem[2] !== undefined;
    }); // ??? TODO design a stage to transfer data for themeRiver and lines?

    var data = this.fixData(filterData || []);
    var nameList = [];
    var nameMap = this.nameMap = createHashMap();
    var count = 0;

    for (var i = 0; i < data.length; ++i) {
      nameList.push(data[i][DATA_NAME_INDEX]);

      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
        nameMap.set(data[i][DATA_NAME_INDEX], count);
        count++;
      }
    }

    var dimensions = prepareSeriesDataSchema(data, {
      coordDimensions: ['single'],
      dimensionsDefine: [{
        name: 'time',
        type: getDimensionTypeByAxis(axisType)
      }, {
        name: 'value',
        type: 'float'
      }, {
        name: 'name',
        type: 'ordinal'
      }],
      encodeDefine: {
        single: 0,
        value: 1,
        itemName: 2
      }
    }).dimensions;
    var list = new SeriesData(dimensions, this);
    list.initData(data);
    return list;
  };
  /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */


  ThemeRiverSeriesModel.prototype.getLayerSeries = function () {
    var data = this.getData();
    var lenCount = data.count();
    var indexArr = [];

    for (var i = 0; i < lenCount; ++i) {
      indexArr[i] = i;
    }

    var timeDim = data.mapDimension('single'); // data group by name

    var groupResult = groupData(indexArr, function (index) {
      return data.get('name', index);
    });
    var layerSeries = [];
    groupResult.buckets.each(function (items, key) {
      items.sort(function (index1, index2) {
        return data.get(timeDim, index1) - data.get(timeDim, index2);
      });
      layerSeries.push({
        name: key,
        indices: items
      });
    });
    return layerSeries;
  };
  /**
   * Get data indices for show tooltip content
   */


  ThemeRiverSeriesModel.prototype.getAxisTooltipData = function (dim, value, baseAxis) {
    if (!isArray$1(dim)) {
      dim = dim ? [dim] : [];
    }

    var data = this.getData();
    var layerSeries = this.getLayerSeries();
    var indices = [];
    var layerNum = layerSeries.length;
    var nestestValue;

    for (var i = 0; i < layerNum; ++i) {
      var minDist = Number.MAX_VALUE;
      var nearestIdx = -1;
      var pointNum = layerSeries[i].indices.length;

      for (var j = 0; j < pointNum; ++j) {
        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
        var dist = Math.abs(theValue - value);

        if (dist <= minDist) {
          nestestValue = theValue;
          minDist = dist;
          nearestIdx = layerSeries[i].indices[j];
        }
      }

      indices.push(nearestIdx);
    }

    return {
      dataIndices: indices,
      nestestValue: nestestValue
    };
  };

  ThemeRiverSeriesModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var name = data.getName(dataIndex);
    var value = data.get(data.mapDimension('value'), dataIndex);
    return createTooltipMarkup('nameValue', {
      name: name,
      value: value
    });
  };

  ThemeRiverSeriesModel.type = 'series.themeRiver';
  ThemeRiverSeriesModel.dependencies = ['singleAxis'];
  ThemeRiverSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    colorBy: 'data',
    coordinateSystem: 'singleAxis',
    // gap in axis's orthogonal orientation
    boundaryGap: ['10%', '10%'],
    // legendHoverLink: true,
    singleAxisIndex: 0,
    animationEasing: 'linear',
    label: {
      margin: 4,
      show: true,
      position: 'left',
      fontSize: 11
    },
    emphasis: {
      label: {
        show: true
      }
    }
  };
  return ThemeRiverSeriesModel;
}(SeriesModel);

function themeRiverLayout(ecModel, api) {
  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
    var data = seriesModel.getData();
    var single = seriesModel.coordinateSystem;
    var layoutInfo = {}; // use the axis boundingRect for view

    var rect = single.getRect();
    layoutInfo.rect = rect;
    var boundaryGap = seriesModel.get('boundaryGap');
    var axis = single.getAxis();
    layoutInfo.boundaryGap = boundaryGap;

    if (axis.orient === 'horizontal') {
      boundaryGap[0] = parsePercent$1(boundaryGap[0], rect.height);
      boundaryGap[1] = parsePercent$1(boundaryGap[1], rect.height);
      var height = rect.height - boundaryGap[0] - boundaryGap[1];
      doThemeRiverLayout(data, seriesModel, height);
    } else {
      boundaryGap[0] = parsePercent$1(boundaryGap[0], rect.width);
      boundaryGap[1] = parsePercent$1(boundaryGap[1], rect.width);
      var width = rect.width - boundaryGap[0] - boundaryGap[1];
      doThemeRiverLayout(data, seriesModel, width);
    }

    data.setLayout('layoutInfo', layoutInfo);
  });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */

function doThemeRiverLayout(data, seriesModel, height) {
  if (!data.count()) {
    return;
  }

  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.

  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.

  var timeDim = data.mapDimension('single');
  var valueDim = data.mapDimension('value');
  var layerPoints = map(layerSeries, function (singleLayer) {
    return map(singleLayer.indices, function (idx) {
      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
      pt[1] = data.get(valueDim, idx);
      return pt;
    });
  });
  var base = computeBaseline(layerPoints);
  var baseLine = base.y0;
  var ky = height / base.max; // set layout information for each item.

  var n = layerSeries.length;
  var m = layerSeries[0].indices.length;
  var baseY0;

  for (var j = 0; j < m; ++j) {
    baseY0 = baseLine[j] * ky;
    data.setItemLayout(layerSeries[0].indices[j], {
      layerIndex: 0,
      x: layerPoints[0][j][0],
      y0: baseY0,
      y: layerPoints[0][j][1] * ky
    });

    for (var i = 1; i < n; ++i) {
      baseY0 += layerPoints[i - 1][j][1] * ky;
      data.setItemLayout(layerSeries[i].indices[j], {
        layerIndex: i,
        x: layerPoints[i][j][0],
        y0: baseY0,
        y: layerPoints[i][j][1] * ky
      });
    }
  }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */


function computeBaseline(data) {
  var layerNum = data.length;
  var pointNum = data[0].length;
  var sums = [];
  var y0 = [];
  var max = 0;

  for (var i = 0; i < pointNum; ++i) {
    var temp = 0;

    for (var j = 0; j < layerNum; ++j) {
      temp += data[j][i][1];
    }

    if (temp > max) {
      max = temp;
    }

    sums.push(temp);
  }

  for (var k = 0; k < pointNum; ++k) {
    y0[k] = (max - sums[k]) / 2;
  }

  max = 0;

  for (var l = 0; l < pointNum; ++l) {
    var sum = sums[l] + y0[l];

    if (sum > max) {
      max = sum;
    }
  }

  return {
    y0: y0,
    max: max
  };
}

function install$p(registers) {
  registers.registerChartView(ThemeRiverView);
  registers.registerSeriesModel(ThemeRiverSeriesModel);
  registers.registerLayout(themeRiverLayout);
  registers.registerProcessor(dataFilter('themeRiver'));
}

var DEFAULT_SECTOR_Z = 2;
var DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */

var SunburstPiece =
/** @class */
function (_super) {
  __extends$1(SunburstPiece, _super);

  function SunburstPiece(node, seriesModel, ecModel, api) {
    var _this = _super.call(this) || this;

    _this.z2 = DEFAULT_SECTOR_Z;
    _this.textConfig = {
      inside: true
    };
    getECData(_this).seriesIndex = seriesModel.seriesIndex;
    var text = new ZRText({
      z2: DEFAULT_TEXT_Z,
      silent: node.getModel().get(['label', 'silent'])
    });

    _this.setTextContent(text);

    _this.updateData(true, node, seriesModel, ecModel, api);

    return _this;
  }

  SunburstPiece.prototype.updateData = function (firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
  seriesModel, ecModel, api) {
    this.node = node;
    node.piece = this;
    seriesModel = seriesModel || this._seriesModel;
    ecModel = ecModel || this._ecModel;
    var sector = this;
    getECData(sector).dataIndex = node.dataIndex;
    var itemModel = node.getModel();
    var emphasisModel = itemModel.getModel('emphasis');
    var layout = node.getLayout();
    var sectorShape = extend({}, layout);
    sectorShape.label = null;
    var normalStyle = node.getVisual('style');
    normalStyle.lineJoin = 'bevel';
    var decal = node.getVisual('decal');

    if (decal) {
      normalStyle.decal = createOrUpdatePatternFromDecal(decal, api);
    }

    var cornerRadius = getSectorCornerRadius(itemModel.getModel('itemStyle'), sectorShape, true);
    extend(sectorShape, cornerRadius);
    each(SPECIAL_STATES, function (stateName) {
      var state = sector.ensureState(stateName);
      var itemStyleModel = itemModel.getModel([stateName, 'itemStyle']);
      state.style = itemStyleModel.getItemStyle(); // border radius

      var cornerRadius = getSectorCornerRadius(itemStyleModel, sectorShape);

      if (cornerRadius) {
        state.shape = cornerRadius;
      }
    });

    if (firstCreate) {
      sector.setShape(sectorShape);
      sector.shape.r = layout.r0;
      updateProps(sector, {
        shape: {
          r: layout.r
        }
      }, seriesModel, node.dataIndex);
    } else {
      // Disable animation for gradient since no interpolation method
      // is supported for gradient
      updateProps(sector, {
        shape: sectorShape
      }, seriesModel);
      saveOldStyle(sector);
    }

    sector.useStyle(normalStyle);

    this._updateLabel(seriesModel);

    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && sector.attr('cursor', cursorStyle);
    this._seriesModel = seriesModel || this._seriesModel;
    this._ecModel = ecModel || this._ecModel;
    var focus = emphasisModel.get('focus');
    var focusOrIndices = focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
    toggleHoverEmphasis(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
  };

  SunburstPiece.prototype._updateLabel = function (seriesModel) {
    var _this = this;

    var itemModel = this.node.getModel();
    var normalLabelModel = itemModel.getModel('label');
    var layout = this.node.getLayout();
    var angle = layout.endAngle - layout.startAngle;
    var midAngle = (layout.startAngle + layout.endAngle) / 2;
    var dx = Math.cos(midAngle);
    var dy = Math.sin(midAngle);
    var sector = this;
    var label = sector.getTextContent();
    var dataIndex = this.node.dataIndex;
    var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
    var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
    label.ignore = !isNormalShown; // TODO use setLabelStyle

    each(DISPLAY_STATES, function (stateName) {
      var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([stateName, 'label']);
      var isNormal = stateName === 'normal';
      var state = isNormal ? label : label.ensureState(stateName);
      var text = seriesModel.getFormattedLabel(dataIndex, stateName);

      if (isNormal) {
        text = text || _this.node.name;
      }

      state.style = createTextStyle(labelStateModel, {}, null, stateName !== 'normal', true);

      if (text) {
        state.style.text = text;
      } // Not displaying text when angle is too small


      var isShown = labelStateModel.get('show');

      if (isShown != null && !isNormal) {
        state.ignore = !isShown;
      }

      var labelPosition = getLabelAttr(labelStateModel, 'position');
      var sectorState = isNormal ? sector : sector.states[stateName];
      var labelColor = sectorState.style.fill;
      sectorState.textConfig = {
        outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
        inside: labelPosition !== 'outside'
      };
      var r;
      var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
      var textAlign = getLabelAttr(labelStateModel, 'align');

      if (labelPosition === 'outside') {
        r = layout.r + labelPadding;
        textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
      } else {
        if (!textAlign || textAlign === 'center') {
          // Put label in the center if it's a circle
          if (angle === 2 * Math.PI && layout.r0 === 0) {
            r = 0;
          } else {
            r = (layout.r + layout.r0) / 2;
          }

          textAlign = 'center';
        } else if (textAlign === 'left') {
          r = layout.r0 + labelPadding;

          if (midAngle > Math.PI / 2) {
            textAlign = 'right';
          }
        } else if (textAlign === 'right') {
          r = layout.r - labelPadding;

          if (midAngle > Math.PI / 2) {
            textAlign = 'left';
          }
        }
      }

      state.style.align = textAlign;
      state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
      state.x = r * dx + layout.cx;
      state.y = r * dy + layout.cy;
      var rotateType = getLabelAttr(labelStateModel, 'rotate');
      var rotate = 0;

      if (rotateType === 'radial') {
        rotate = -midAngle;

        if (rotate < -Math.PI / 2) {
          rotate += Math.PI;
        }
      } else if (rotateType === 'tangential') {
        rotate = Math.PI / 2 - midAngle;

        if (rotate > Math.PI / 2) {
          rotate -= Math.PI;
        } else if (rotate < -Math.PI / 2) {
          rotate += Math.PI;
        }
      } else if (isNumber$1(rotateType)) {
        rotate = rotateType * Math.PI / 180;
      }

      state.rotation = rotate;
    });

    function getLabelAttr(model, name) {
      var stateAttr = model.get(name);

      if (stateAttr == null) {
        return normalLabelModel.get(name);
      }

      return stateAttr;
    }

    label.dirtyStyle();
  };

  return SunburstPiece;
}(Sector);

var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
var HIGHLIGHT_ACTION = 'sunburstHighlight';
var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
function installSunburstAction(registers) {
  registers.registerAction({
    type: ROOT_TO_NODE_ACTION,
    update: 'updateView'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sunburst',
      query: payload
    }, handleRootToNode);

    function handleRootToNode(model, index) {
      var targetInfo = retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);

      if (targetInfo) {
        var originViewRoot = model.getViewRoot();

        if (originViewRoot) {
          payload.direction = aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
        }

        model.resetViewRoot(targetInfo.node);
      }
    }
  });
  registers.registerAction({
    type: HIGHLIGHT_ACTION,
    update: 'none'
  }, function (payload, ecModel, api) {
    // Clone
    payload = extend({}, payload);
    ecModel.eachComponent({
      mainType: 'series',
      subType: 'sunburst',
      query: payload
    }, handleHighlight);

    function handleHighlight(model) {
      var targetInfo = retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);

      if (targetInfo) {
        payload.dataIndex = targetInfo.node.dataIndex;
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      deprecateReplaceLog('sunburstHighlight', 'highlight');
    } // Fast forward action


    api.dispatchAction(extend(payload, {
      type: 'highlight'
    }));
  });
  registers.registerAction({
    type: UNHIGHLIGHT_ACTION,
    update: 'updateView'
  }, function (payload, ecModel, api) {
    payload = extend({}, payload);

    if (process.env.NODE_ENV !== 'production') {
      deprecateReplaceLog('sunburstUnhighlight', 'downplay');
    }

    api.dispatchAction(extend(payload, {
      type: 'downplay'
    }));
  });
}

var SunburstView =
/** @class */
function (_super) {
  __extends$1(SunburstView, _super);

  function SunburstView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SunburstView.type;
    return _this;
  }

  SunburstView.prototype.render = function (seriesModel, ecModel, api, // @ts-ignore
  payload) {
    var self = this;
    this.seriesModel = seriesModel;
    this.api = api;
    this.ecModel = ecModel;
    var data = seriesModel.getData();
    var virtualRoot = data.tree.root;
    var newRoot = seriesModel.getViewRoot();
    var group = this.group;
    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
    var newChildren = [];
    newRoot.eachNode(function (node) {
      newChildren.push(node);
    });
    var oldChildren = this._oldChildren || [];
    dualTravel(newChildren, oldChildren);
    renderRollUp(virtualRoot, newRoot);

    this._initEvents();

    this._oldChildren = newChildren;

    function dualTravel(newChildren, oldChildren) {
      if (newChildren.length === 0 && oldChildren.length === 0) {
        return;
      }

      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(curry(processNode, null)).execute();

      function getKey(node) {
        return node.getId();
      }

      function processNode(newIdx, oldIdx) {
        var newNode = newIdx == null ? null : newChildren[newIdx];
        var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
        doRenderNode(newNode, oldNode);
      }
    }

    function doRenderNode(newNode, oldNode) {
      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
        // Not render data with value 0
        newNode = null;
      }

      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
        if (oldNode && oldNode.piece) {
          if (newNode) {
            // Update
            oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api); // For tooltip

            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
          } else {
            // Remove
            removeNode(oldNode);
          }
        } else if (newNode) {
          // Add
          var piece = new SunburstPiece(newNode, seriesModel, ecModel, api);
          group.add(piece); // For tooltip

          data.setItemGraphicEl(newNode.dataIndex, piece);
        }
      }
    }

    function removeNode(node) {
      if (!node) {
        return;
      }

      if (node.piece) {
        group.remove(node.piece);
        node.piece = null;
      }
    }

    function renderRollUp(virtualRoot, viewRoot) {
      if (viewRoot.depth > 0) {
        // Render
        if (self.virtualPiece) {
          // Update
          self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
        } else {
          // Add
          self.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel, api);
          group.add(self.virtualPiece);
        } // TODO event scope


        viewRoot.piece.off('click');
        self.virtualPiece.on('click', function (e) {
          self._rootToNode(viewRoot.parentNode);
        });
      } else if (self.virtualPiece) {
        // Remove
        group.remove(self.virtualPiece);
        self.virtualPiece = null;
      }
    }
  };
  /**
   * @private
   */


  SunburstView.prototype._initEvents = function () {
    var _this = this;

    this.group.off('click');
    this.group.on('click', function (e) {
      var targetFound = false;

      var viewRoot = _this.seriesModel.getViewRoot();

      viewRoot.eachNode(function (node) {
        if (!targetFound && node.piece && node.piece === e.target) {
          var nodeClick = node.getModel().get('nodeClick');

          if (nodeClick === 'rootToNode') {
            _this._rootToNode(node);
          } else if (nodeClick === 'link') {
            var itemModel = node.getModel();
            var link = itemModel.get('link');

            if (link) {
              var linkTarget = itemModel.get('target', true) || '_blank';
              windowOpen(link, linkTarget);
            }
          }

          targetFound = true;
        }
      });
    });
  };
  /**
   * @private
   */


  SunburstView.prototype._rootToNode = function (node) {
    if (node !== this.seriesModel.getViewRoot()) {
      this.api.dispatchAction({
        type: ROOT_TO_NODE_ACTION,
        from: this.uid,
        seriesId: this.seriesModel.id,
        targetNode: node
      });
    }
  };
  /**
   * @implement
   */


  SunburstView.prototype.containPoint = function (point, seriesModel) {
    var treeRoot = seriesModel.getData();
    var itemLayout = treeRoot.getItemLayout(0);

    if (itemLayout) {
      var dx = point[0] - itemLayout.cx;
      var dy = point[1] - itemLayout.cy;
      var radius = Math.sqrt(dx * dx + dy * dy);
      return radius <= itemLayout.r && radius >= itemLayout.r0;
    }
  };

  SunburstView.type = 'sunburst';
  return SunburstView;
}(ChartView);

var SunburstSeriesModel =
/** @class */
function (_super) {
  __extends$1(SunburstSeriesModel, _super);

  function SunburstSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SunburstSeriesModel.type;
    _this.ignoreStyleOnData = true;
    return _this;
  }

  SunburstSeriesModel.prototype.getInitialData = function (option, ecModel) {
    // Create a virtual root.
    var root = {
      name: option.name,
      children: option.data
    };
    completeTreeValue$1(root);
    var levelModels = this._levelModels = map(option.levels || [], function (levelDefine) {
      return new Model(levelDefine, this, ecModel);
    }, this); // Make sure always a new tree is created when setOption,
    // in TreemapView, we check whether oldTree === newTree
    // to choose mappings approach among old shapes and new shapes.

    var tree = Tree.createTree(root, this, beforeLink);

    function beforeLink(nodeData) {
      nodeData.wrapMethod('getItemModel', function (model, idx) {
        var node = tree.getNodeByDataIndex(idx);
        var levelModel = levelModels[node.depth];
        levelModel && (model.parentModel = levelModel);
        return model;
      });
    }

    return tree.data;
  };

  SunburstSeriesModel.prototype.optionUpdated = function () {
    this.resetViewRoot();
  };
  /*
   * @override
   */


  SunburstSeriesModel.prototype.getDataParams = function (dataIndex) {
    var params = _super.prototype.getDataParams.apply(this, arguments);

    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
    params.treePathInfo = wrapTreePathInfo(node, this);
    return params;
  };

  SunburstSeriesModel.prototype.getLevelModel = function (node) {
    return this._levelModels && this._levelModels[node.depth];
  };

  SunburstSeriesModel.prototype.getViewRoot = function () {
    return this._viewRoot;
  };

  SunburstSeriesModel.prototype.resetViewRoot = function (viewRoot) {
    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
    var root = this.getRawData().tree.root;

    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
      this._viewRoot = root;
    }
  };

  SunburstSeriesModel.prototype.enableAriaDecal = function () {
    enableAriaDecalForTree(this);
  };

  SunburstSeriesModel.type = 'series.sunburst';
  SunburstSeriesModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    // 默认全局居中
    center: ['50%', '50%'],
    radius: [0, '75%'],
    // 默认顺时针
    clockwise: true,
    startAngle: 90,
    // 最小角度改为0
    minAngle: 0,
    // If still show when all data zero.
    stillShowZeroSum: true,
    // 'rootToNode', 'link', or false
    nodeClick: 'rootToNode',
    renderLabelForZeroData: false,
    label: {
      // could be: 'radial', 'tangential', or 'none'
      rotate: 'radial',
      show: true,
      opacity: 1,
      // 'left' is for inner side of inside, and 'right' is for outer
      // side for inside
      align: 'center',
      position: 'inside',
      distance: 5,
      silent: true
    },
    itemStyle: {
      borderWidth: 1,
      borderColor: 'white',
      borderType: 'solid',
      shadowBlur: 0,
      shadowColor: 'rgba(0, 0, 0, 0.2)',
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      opacity: 1
    },
    emphasis: {
      focus: 'descendant'
    },
    blur: {
      itemStyle: {
        opacity: 0.2
      },
      label: {
        opacity: 0.1
      }
    },
    // Animation type can be expansion, scale.
    animationType: 'expansion',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    data: [],

    /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */
    sort: 'desc'
  };
  return SunburstSeriesModel;
}(SeriesModel);

function completeTreeValue$1(dataNode) {
  // Postorder travel tree.
  // If value of none-leaf node is not set,
  // calculate it by suming up the value of all children.
  var sum = 0;
  each(dataNode.children, function (child) {
    completeTreeValue$1(child);
    var childValue = child.value; // TODO First value of array must be a number

    isArray$1(childValue) && (childValue = childValue[0]);
    sum += childValue;
  });
  var thisValue = dataNode.value;

  if (isArray$1(thisValue)) {
    thisValue = thisValue[0];
  }

  if (thisValue == null || isNaN(thisValue)) {
    thisValue = sum;
  } // Value should not less than 0.


  if (thisValue < 0) {
    thisValue = 0;
  }

  isArray$1(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}

var RADIAN$2 = Math.PI / 180;
function sunburstLayout(seriesType, ecModel, api) {
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');

    if (!isArray$1(radius)) {
      radius = [0, radius];
    }

    if (!isArray$1(center)) {
      center = [center, center];
    }

    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = parsePercent$1(center[0], width);
    var cy = parsePercent$1(center[1], height);
    var r0 = parsePercent$1(radius[0], size / 2);
    var r = parsePercent$1(radius[1], size / 2);
    var startAngle = -seriesModel.get('startAngle') * RADIAN$2;
    var minAngle = seriesModel.get('minAngle') * RADIAN$2;
    var virtualRoot = seriesModel.getData().tree.root;
    var treeRoot = seriesModel.getViewRoot();
    var rootDepth = treeRoot.depth;
    var sort = seriesModel.get('sort');

    if (sort != null) {
      initChildren$1(treeRoot, sort);
    }

    var validDataCount = 0;
    each(treeRoot.children, function (child) {
      !isNaN(child.getValue()) && validDataCount++;
    });
    var sum = treeRoot.getValue(); // Sum may be 0

    var unitRadian = Math.PI / (sum || validDataCount) * 2;
    var renderRollupNode = treeRoot.depth > 0;
    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
    var rPerLevel = (r - r0) / (levels || 1);
    var clockwise = seriesModel.get('clockwise');
    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
    // let restAngle = PI2;
    // let valueSumLargerThanMinAngle = 0;

    var dir = clockwise ? 1 : -1;
    /**
     * Render a tree
     * @return increased angle
     */

    var renderNode = function (node, startAngle) {
      if (!node) {
        return;
      }

      var endAngle = startAngle; // Render self

      if (node !== virtualRoot) {
        // Tree node is virtual, so it doesn't need to be drawn
        var value = node.getValue();
        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;

        if (angle < minAngle) {
          angle = minAngle; // restAngle -= minAngle;
        } // else {
        //     valueSumLargerThanMinAngle += value;
        // }


        endAngle = startAngle + dir * angle;
        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
        var rStart = r0 + rPerLevel * depth;
        var rEnd = r0 + rPerLevel * (depth + 1);
        var levelModel = seriesModel.getLevelModel(node);

        if (levelModel) {
          var r0_1 = levelModel.get('r0', true);
          var r_1 = levelModel.get('r', true);
          var radius_1 = levelModel.get('radius', true);

          if (radius_1 != null) {
            r0_1 = radius_1[0];
            r_1 = radius_1[1];
          }

          r0_1 != null && (rStart = parsePercent$1(r0_1, size / 2));
          r_1 != null && (rEnd = parsePercent$1(r_1, size / 2));
        }

        node.setLayout({
          angle: angle,
          startAngle: startAngle,
          endAngle: endAngle,
          clockwise: clockwise,
          cx: cx,
          cy: cy,
          r0: rStart,
          r: rEnd
        });
      } // Render children


      if (node.children && node.children.length) {
        // currentAngle = startAngle;
        var siblingAngle_1 = 0;
        each(node.children, function (node) {
          siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
        });
      }

      return endAngle - startAngle;
    }; // Virtual root node for roll up


    if (renderRollupNode) {
      var rStart = r0;
      var rEnd = r0 + rPerLevel;
      var angle = Math.PI * 2;
      virtualRoot.setLayout({
        angle: angle,
        startAngle: startAngle,
        endAngle: startAngle + angle,
        clockwise: clockwise,
        cx: cx,
        cy: cy,
        r0: rStart,
        r: rEnd
      });
    }

    renderNode(treeRoot, startAngle);
  });
}
/**
 * Init node children by order and update visual
 */

function initChildren$1(node, sortOrder) {
  var children = node.children || [];
  node.children = sort$2(children, sortOrder); // Init children recursively

  if (children.length) {
    each(node.children, function (child) {
      initChildren$1(child, sortOrder);
    });
  }
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */


function sort$2(children, sortOrder) {
  if (isFunction$3(sortOrder)) {
    var sortTargets = map(children, function (child, idx) {
      var value = child.getValue();
      return {
        params: {
          depth: child.depth,
          height: child.height,
          dataIndex: child.dataIndex,
          getValue: function () {
            return value;
          }
        },
        index: idx
      };
    });
    sortTargets.sort(function (a, b) {
      return sortOrder(a.params, b.params);
    });
    return map(sortTargets, function (target) {
      return children[target.index];
    });
  } else {
    var isAsc_1 = sortOrder === 'asc';
    return children.sort(function (a, b) {
      var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
    });
  }
}

function sunburstVisual(ecModel) {
  var paletteScope = {}; // Default color strategy

  function pickColor(node, seriesModel, treeHeight) {
    // Choose color from palette based on the first level.
    var current = node;

    while (current && current.depth > 1) {
      current = current.parentNode;
    }

    var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);

    if (node.depth > 1 && isString(color)) {
      // Lighter on the deeper level.
      color = lift(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
    }

    return color;
  }

  ecModel.eachSeriesByType('sunburst', function (seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    tree.eachNode(function (node) {
      var model = node.getModel();
      var style = model.getModel('itemStyle').getItemStyle();

      if (!style.fill) {
        style.fill = pickColor(node, seriesModel, tree.root.height);
      }

      var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
      extend(existsStyle, style);
    });
  });
}

function install$q(registers) {
  registers.registerChartView(SunburstView);
  registers.registerSeriesModel(SunburstSeriesModel);
  registers.registerLayout(curry(sunburstLayout, 'sunburst'));
  registers.registerProcessor(curry(dataFilter, 'sunburst'));
  registers.registerVisual(sunburstVisual);
  installSunburstAction(registers);
}

// `visual('color') visual('borderColor')` is supported.

var STYLE_VISUAL_TYPE = {
  color: 'fill',
  borderColor: 'stroke'
};
var NON_STYLE_VISUAL_PROPS = {
  symbol: 1,
  symbolSize: 1,
  symbolKeepAspect: 1,
  legendIcon: 1,
  visualMeta: 1,
  liftZ: 1,
  decal: 1
};
var customInnerStore = makeInner();

var CustomSeriesModel =
/** @class */
function (_super) {
  __extends$1(CustomSeriesModel, _super);

  function CustomSeriesModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CustomSeriesModel.type;
    return _this;
  }

  CustomSeriesModel.prototype.optionUpdated = function () {
    this.currentZLevel = this.get('zlevel', true);
    this.currentZ = this.get('z', true);
  };

  CustomSeriesModel.prototype.getInitialData = function (option, ecModel) {
    return createSeriesData(null, this);
  };

  CustomSeriesModel.prototype.getDataParams = function (dataIndex, dataType, el) {
    var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);

    el && (params.info = customInnerStore(el).info);
    return params;
  };

  CustomSeriesModel.type = 'series.custom';
  CustomSeriesModel.dependencies = ['grid', 'polar', 'geo', 'singleAxis', 'calendar'];
  CustomSeriesModel.defaultOption = {
    coordinateSystem: 'cartesian2d',
    // zlevel: 0,
    z: 2,
    legendHoverLink: true,
    // Custom series will not clip by default.
    // Some case will use custom series to draw label
    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
    clip: false // Cartesian coordinate system
    // xAxisIndex: 0,
    // yAxisIndex: 0,
    // Polar coordinate system
    // polarIndex: 0,
    // Geo coordinate system
    // geoIndex: 0,

  };
  return CustomSeriesModel;
}(SeriesModel);

function dataToCoordSize(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return map(['x', 'y'], function (dim, dimIdx) {
    var axis = this.getAxis(dim);
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
  }, this);
}

function cartesianPrepareCustom(coordSys) {
  var rect = coordSys.master.getRect();
  return {
    coordSys: {
      // The name exposed to user is always 'cartesian2d' but not 'grid'.
      type: 'cartesian2d',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (data) {
        // do not provide "out" param
        return coordSys.dataToPoint(data);
      },
      size: bind(dataToCoordSize, coordSys)
    }
  };
}

function dataToCoordSize$1(dataSize, dataItem) {
  dataItem = dataItem || [0, 0];
  return map([0, 1], function (dimIdx) {
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var p1 = [];
    var p2 = [];
    p1[dimIdx] = val - halfSize;
    p2[dimIdx] = val + halfSize;
    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
  }, this);
}

function geoPrepareCustom(coordSys) {
  var rect = coordSys.getBoundingRect();
  return {
    coordSys: {
      type: 'geo',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      zoom: coordSys.getZoom()
    },
    api: {
      coord: function (data) {
        // do not provide "out" and noRoam param,
        // Compatible with this usage:
        // echarts.util.map(item.points, api.coord)
        return coordSys.dataToPoint(data);
      },
      size: bind(dataToCoordSize$1, coordSys)
    }
  };
}

function dataToCoordSize$2(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  var axis = this.getAxis();
  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}

function singlePrepareCustom(coordSys) {
  var rect = coordSys.getRect();
  return {
    coordSys: {
      type: 'singleAxis',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height
    },
    api: {
      coord: function (val) {
        // do not provide "out" param
        return coordSys.dataToPoint(val);
      },
      size: bind(dataToCoordSize$2, coordSys)
    }
  };
}

function dataToCoordSize$3(dataSize, dataItem) {
  // dataItem is necessary in log axis.
  dataItem = dataItem || [0, 0];
  return map(['Radius', 'Angle'], function (dim, dimIdx) {
    var getterName = 'get' + dim + 'Axis'; // TODO: TYPE Check Angle Axis

    var axis = this[getterName]();
    var val = dataItem[dimIdx];
    var halfSize = dataSize[dimIdx] / 2;
    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));

    if (dim === 'Angle') {
      result = result * Math.PI / 180;
    }

    return result;
  }, this);
}

function polarPrepareCustom(coordSys) {
  var radiusAxis = coordSys.getRadiusAxis();
  var angleAxis = coordSys.getAngleAxis();
  var radius = radiusAxis.getExtent();
  radius[0] > radius[1] && radius.reverse();
  return {
    coordSys: {
      type: 'polar',
      cx: coordSys.cx,
      cy: coordSys.cy,
      r: radius[1],
      r0: radius[0]
    },
    api: {
      coord: function (data) {
        var radius = radiusAxis.dataToRadius(data[0]);
        var angle = angleAxis.dataToAngle(data[1]);
        var coord = coordSys.coordToPoint([radius, angle]);
        coord.push(radius, angle * Math.PI / 180);
        return coord;
      },
      size: bind(dataToCoordSize$3, coordSys)
    }
  };
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function calendarPrepareCustom(coordSys) {
  var rect = coordSys.getRect();
  var rangeInfo = coordSys.getRangeInfo();
  return {
    coordSys: {
      type: 'calendar',
      x: rect.x,
      y: rect.y,
      width: rect.width,
      height: rect.height,
      cellWidth: coordSys.getCellWidth(),
      cellHeight: coordSys.getCellHeight(),
      rangeInfo: {
        start: rangeInfo.start,
        end: rangeInfo.end,
        weeks: rangeInfo.weeks,
        dayCount: rangeInfo.allDay
      }
    },
    api: {
      coord: function (data, clamp) {
        return coordSys.dataToPoint(data, clamp);
      }
    }
  };
}

var deprecatedLogs = {};
/**
 * Whether need to call `convertEC4CompatibleStyle`.
 */

function isEC4CompatibleStyle(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
  // Since echarts5, `RectText` is separated from its host element and style.text
  // does not exist any more. The compat work brings some extra burden on performance.
  // So we provide:
  // `legacy: true` force make compat.
  // `legacy: false`, force do not compat.
  // `legacy` not set: auto detect whether legacy.
  //     But in this case we do not compat (difficult to detect and rare case):
  //     Becuse custom series and graphic component support "merge", users may firstly
  //     only set `textStrokeWidth` style or secondly only set `text`.
  return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' // Difficult to detect whether legacy for a "text" el.
  && (elType === 'text' || hasOwn(style, 'text')));
}
/**
 * `EC4CompatibleStyle` is style that might be in echarts4 format or echarts5 format.
 * @param hostStyle The properties might be modified.
 * @return If be text el, `textContentStyle` and `textConfig` will not be returned.
 *         Otherwise a `textContentStyle` and `textConfig` will be created, whose props area
 *         retried from the `hostStyle`.
 */

function convertFromEC4CompatibleStyle(hostStyle, elType, isNormal) {
  var srcStyle = hostStyle;
  var textConfig;
  var textContent;
  var textContentStyle;

  if (elType === 'text') {
    textContentStyle = srcStyle;
  } else {
    textContentStyle = {};
    hasOwn(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
    hasOwn(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
    hasOwn(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
    hasOwn(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
    hasOwn(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
    hasOwn(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
    hasOwn(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
    hasOwn(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
    textContent = {
      type: 'text',
      style: textContentStyle,
      // ec4 does not support rectText trigger.
      // And when text position is different in normal and emphasis
      // => hover text trigger emphasis;
      // => text position changed, leave mouse pointer immediately;
      // That might cause incorrect state.
      silent: true
    };
    textConfig = {};
    var hasOwnPos = hasOwn(srcStyle, 'textPosition');

    if (isNormal) {
      textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
    } else {
      hasOwnPos && (textConfig.position = srcStyle.textPosition);
    }

    hasOwn(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
    hasOwn(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
    hasOwn(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
    hasOwn(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
  }

  convertEC4CompatibleRichItem(textContentStyle, hostStyle);
  each(textContentStyle.rich, function (richItem) {
    convertEC4CompatibleRichItem(richItem, richItem);
  });
  return {
    textConfig: textConfig,
    textContent: textContent
  };
}
/**
 * The result will be set to `out`.
 */

function convertEC4CompatibleRichItem(out, richItem) {
  if (!richItem) {
    return;
  } // (1) For simplicity, make textXXX properties (deprecated since ec5) has
  // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
  // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
  // richText in ec5.
  // (2) `out === richItem` if and only if `out` is text el or rich item.
  // So we can overwrite existing props in `out` since textXXX has higher priority.


  richItem.font = richItem.textFont || richItem.font;
  hasOwn(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
  hasOwn(richItem, 'textAlign') && (out.align = richItem.textAlign);
  hasOwn(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
  hasOwn(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
  hasOwn(richItem, 'textWidth') && (out.width = richItem.textWidth);
  hasOwn(richItem, 'textHeight') && (out.height = richItem.textHeight);
  hasOwn(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
  hasOwn(richItem, 'textPadding') && (out.padding = richItem.textPadding);
  hasOwn(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
  hasOwn(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
  hasOwn(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
  hasOwn(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
  hasOwn(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
  hasOwn(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
  hasOwn(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
/**
 * Convert to pure echarts4 format style.
 * `itemStyle` will be modified, added with ec4 style properties from
 * `textStyle` and `textConfig`.
 *
 * [Caveat]: For simplicity, `insideRollback` in ec4 does not compat, where
 * `styleEmphasis: {textFill: 'red'}` will remove the normal auto added stroke.
 */


function convertToEC4StyleForCustomSerise(itemStl, txStl, txCfg) {
  var out = itemStl; // See `custom.ts`, a trick to set extra `textPosition` firstly.

  out.textPosition = out.textPosition || txCfg.position || 'inside';
  txCfg.offset != null && (out.textOffset = txCfg.offset);
  txCfg.rotation != null && (out.textRotation = txCfg.rotation);
  txCfg.distance != null && (out.textDistance = txCfg.distance);
  var isInside = out.textPosition.indexOf('inside') >= 0;
  var hostFill = itemStl.fill || '#000';
  convertToEC4RichItem(out, txStl);
  var textFillNotSet = out.textFill == null;

  if (isInside) {
    if (textFillNotSet) {
      out.textFill = txCfg.insideFill || '#fff';
      !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
      !out.textStroke && (out.textStroke = hostFill);
      out.textStrokeWidth == null && (out.textStrokeWidth = 2);
    }
  } else {
    if (textFillNotSet) {
      out.textFill = itemStl.fill || txCfg.outsideFill || '#000';
    }

    !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
  }

  out.text = txStl.text;
  out.rich = txStl.rich;
  each(txStl.rich, function (richItem) {
    convertToEC4RichItem(richItem, richItem);
  });
  return out;
}

function convertToEC4RichItem(out, richItem) {
  if (!richItem) {
    return;
  }

  hasOwn(richItem, 'fill') && (out.textFill = richItem.fill);
  hasOwn(richItem, 'stroke') && (out.textStroke = richItem.fill);
  hasOwn(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
  hasOwn(richItem, 'font') && (out.font = richItem.font);
  hasOwn(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
  hasOwn(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
  hasOwn(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
  hasOwn(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
  hasOwn(richItem, 'align') && (out.textAlign = richItem.align);
  hasOwn(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
  hasOwn(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
  hasOwn(richItem, 'width') && (out.textWidth = richItem.width);
  hasOwn(richItem, 'height') && (out.textHeight = richItem.height);
  hasOwn(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
  hasOwn(richItem, 'padding') && (out.textPadding = richItem.padding);
  hasOwn(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
  hasOwn(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
  hasOwn(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
  hasOwn(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
  hasOwn(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
  hasOwn(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
  hasOwn(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
  hasOwn(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
  hasOwn(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
  hasOwn(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
  hasOwn(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}

function warnDeprecated(deprecated, insteadApproach) {
  if (process.env.NODE_ENV !== 'production') {
    var key = deprecated + '^_^' + insteadApproach;

    if (!deprecatedLogs[key]) {
      console.warn("[ECharts] DEPRECATED: \"" + deprecated + "\" has been deprecated. " + insteadApproach);
      deprecatedLogs[key] = true;
    }
  }
}

var LEGACY_TRANSFORM_PROPS_MAP = {
  position: ['x', 'y'],
  scale: ['scaleX', 'scaleY'],
  origin: ['originX', 'originY']
};
var LEGACY_TRANSFORM_PROPS = keys$2(LEGACY_TRANSFORM_PROPS_MAP);
var TRANSFORM_PROPS_MAP = reduce$6(TRANSFORMABLE_PROPS, function (obj, key) {
  obj[key] = 1;
  return obj;
}, {});
var transformPropNamesStr = TRANSFORMABLE_PROPS.join(', '); // '' means root

var ELEMENT_ANIMATABLE_PROPS = ['', 'style', 'shape', 'extra'];
var transitionInnerStore = makeInner();

function getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
  var animationProp = animationType + "Animation";
  var config = getAnimationConfig(animationType, parentModel, dataIndex) || {};
  var userDuring = transitionInnerStore(el).userDuring; // Only set when duration is > 0 and it's need to be animated.

  if (config.duration > 0) {
    // For simplicity, if during not specified, the previous during will not work any more.
    config.during = userDuring ? bind(duringCall, {
      el: el,
      userDuring: userDuring
    }) : null;
    config.setToFinal = true;
    config.scope = animationType;
  }

  extend(config, elOption[animationProp]);
  return config;
}

function applyUpdateTransition(el, elOption, animatableModel, opts) {
  opts = opts || {};
  var dataIndex = opts.dataIndex,
      isInit = opts.isInit,
      clearStyle = opts.clearStyle;
  var hasAnimation = animatableModel.isAnimationEnabled(); // Save the meta info for further morphing. Like apply on the sub morphing elements.

  var store = transitionInnerStore(el);
  var styleOpt = elOption.style;
  store.userDuring = elOption.during;
  var transFromProps = {};
  var propsToSet = {};
  prepareTransformAllPropsFinal(el, elOption, propsToSet);
  prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
  prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);

  if (!isInit && hasAnimation) {
    prepareTransformTransitionFrom(el, elOption, transFromProps);
    prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
    prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
    prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
  }

  propsToSet.style = styleOpt;
  applyPropsDirectly(el, propsToSet, clearStyle);
  applyMiscProps(el, elOption);

  if (hasAnimation) {
    if (isInit) {
      var enterFromProps_1 = {};
      each(ELEMENT_ANIMATABLE_PROPS, function (propName) {
        var prop = propName ? elOption[propName] : elOption;

        if (prop && prop.enterFrom) {
          if (propName) {
            enterFromProps_1[propName] = enterFromProps_1[propName] || {};
          }

          extend(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
        }
      });
      var config = getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);

      if (config.duration > 0) {
        el.animateFrom(enterFromProps_1, config);
      }
    } else {
      applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
  } // Store leave to be used in leave transition.


  updateLeaveTo(el, elOption);
  styleOpt ? el.dirty() : el.markRedraw();
}
function updateLeaveTo(el, elOption) {
  // Try merge to previous set leaveTo
  var leaveToProps = transitionInnerStore(el).leaveToProps;

  for (var i = 0; i < ELEMENT_ANIMATABLE_PROPS.length; i++) {
    var propName = ELEMENT_ANIMATABLE_PROPS[i];
    var prop = propName ? elOption[propName] : elOption;

    if (prop && prop.leaveTo) {
      if (!leaveToProps) {
        leaveToProps = transitionInnerStore(el).leaveToProps = {};
      }

      if (propName) {
        leaveToProps[propName] = leaveToProps[propName] || {};
      }

      extend(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
    }
  }
}
function applyLeaveTransition(el, elOption, animatableModel, onRemove) {
  if (el) {
    var parent_1 = el.parent;
    var leaveToProps = transitionInnerStore(el).leaveToProps;

    if (leaveToProps) {
      // TODO TODO use leave after leaveAnimation in series is introduced
      // TODO Data index?
      var config = getElementAnimationConfig('update', el, elOption, animatableModel, 0);

      config.done = function () {
        parent_1.remove(el);
        onRemove && onRemove();
      };

      el.animateTo(leaveToProps, config);
    } else {
      parent_1.remove(el);
      onRemove && onRemove();
    }
  }
}
function isTransitionAll(transition) {
  return transition === 'all';
}

function applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
  var styleOpt = allPropsFinal.style;

  if (!el.isGroup && styleOpt) {
    if (clearStyle) {
      el.useStyle({}); // When style object changed, how to trade the existing animation?
      // It is probably complicated and not needed to cover all the cases.
      // But still need consider the case:
      // (1) When using init animation on `style.opacity`, and before the animation
      //     ended users triggers an update by mousewhel. At that time the init
      //     animation should better be continued rather than terminated.
      //     So after `useStyle` called, we should change the animation target manually
      //     to continue the effect of the init animation.
      // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
      //     to update the value to `val2` and no animation declared, should be terminate
      //     the previous animation or just modify the target of the animation?
      //     Therotically That will happen not only on `style` but also on `shape` and
      //     `transfrom` props. But we haven't handle this case at present yet.
      // (3) PENDING: Is it proper to visit `animators` and `targetName`?

      var animators = el.animators;

      for (var i = 0; i < animators.length; i++) {
        var animator = animators[i]; // targetName is the "topKey".

        if (animator.targetName === 'style') {
          animator.changeTarget(el.style);
        }
      }
    }

    el.setStyle(styleOpt);
  }

  if (allPropsFinal) {
    // Not set style here.
    allPropsFinal.style = null; // Set el to the final state firstly.

    allPropsFinal && el.attr(allPropsFinal);
    allPropsFinal.style = styleOpt;
  }
}

function applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
  if (transFromProps) {
    var config = getElementAnimationConfig('update', el, elOption, model, dataIndex);

    if (config.duration > 0) {
      el.animateFrom(transFromProps, config);
    }
  }
}

function applyMiscProps(el, elOption) {
  // Merge by default.
  hasOwn(elOption, 'silent') && (el.silent = elOption.silent);
  hasOwn(elOption, 'ignore') && (el.ignore = elOption.ignore);

  if (el instanceof Displayable) {
    hasOwn(elOption, 'invisible') && (el.invisible = elOption.invisible);
  }

  if (el instanceof Path) {
    hasOwn(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
  }
} // Use it to avoid it be exposed to user.


var tmpDuringScope = {};
var transitionDuringAPI = {
  // Usually other props do not need to be changed in animation during.
  setTransform: function (key, val) {
    if (process.env.NODE_ENV !== 'production') {
      assert(hasOwn(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `setTransform`.');
    }

    tmpDuringScope.el[key] = val;
    return this;
  },
  getTransform: function (key) {
    if (process.env.NODE_ENV !== 'production') {
      assert(hasOwn(TRANSFORM_PROPS_MAP, key), 'Only ' + transformPropNamesStr + ' available in `getTransform`.');
    }

    return tmpDuringScope.el[key];
  },
  setShape: function (key, val) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var el = tmpDuringScope.el;
    var shape = el.shape || (el.shape = {});
    shape[key] = val;
    el.dirtyShape && el.dirtyShape();
    return this;
  },
  getShape: function (key) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var shape = tmpDuringScope.el.shape;

    if (shape) {
      return shape[key];
    }
  },
  setStyle: function (key, val) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var el = tmpDuringScope.el;
    var style = el.style;

    if (style) {
      if (process.env.NODE_ENV !== 'production') {
        if (eqNaN(val)) {
          warn('style.' + key + ' must not be assigned with NaN.');
        }
      }

      style[key] = val;
      el.dirtyStyle && el.dirtyStyle();
    }

    return this;
  },
  getStyle: function (key) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var style = tmpDuringScope.el.style;

    if (style) {
      return style[key];
    }
  },
  setExtra: function (key, val) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var extra = tmpDuringScope.el.extra || (tmpDuringScope.el.extra = {});
    extra[key] = val;
    return this;
  },
  getExtra: function (key) {
    if (process.env.NODE_ENV !== 'production') {
      assertNotReserved(key);
    }

    var extra = tmpDuringScope.el.extra;

    if (extra) {
      return extra[key];
    }
  }
};

function assertNotReserved(key) {
  if (process.env.NODE_ENV !== 'production') {
    if (key === 'transition' || key === 'enterFrom' || key === 'leaveTo') {
      throw new Error('key must not be "' + key + '"');
    }
  }
}

function duringCall() {
  // Do not provide "percent" until some requirements come.
  // Because consider thies case:
  // enterFrom: {x: 100, y: 30}, transition: 'x'.
  // And enter duration is different from update duration.
  // Thus it might be confused about the meaning of "percent" in during callback.
  var scope = this;
  var el = scope.el;

  if (!el) {
    return;
  } // If el is remove from zr by reason like legend, during still need to called,
  // because el will be added back to zr and the prop value should not be incorrect.


  var latestUserDuring = transitionInnerStore(el).userDuring;
  var scopeUserDuring = scope.userDuring; // Ensured a during is only called once in each animation frame.
  // If a during is called multiple times in one frame, maybe some users' calculation logic
  // might be wrong (not sure whether this usage exists).
  // The case of a during might be called twice can be: by default there is a animator for
  // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
  // another animators for 'style'/'shape'/'extra'.

  if (latestUserDuring !== scopeUserDuring) {
    // release
    scope.el = scope.userDuring = null;
    return;
  }

  tmpDuringScope.el = el; // Give no `this` to user in "during" calling.

  scopeUserDuring(transitionDuringAPI); // FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
  // consider the issue that the prop might be incorrect when return to "normal" state.
}

function prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
  var attrOpt = elOption[mainAttr];

  if (!attrOpt) {
    return;
  }

  var elPropsInAttr = fromEl[mainAttr];
  var transFromPropsInAttr;

  if (elPropsInAttr) {
    var transition = elOption.transition;
    var attrTransition = attrOpt.transition;

    if (attrTransition) {
      !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});

      if (isTransitionAll(attrTransition)) {
        extend(transFromPropsInAttr, elPropsInAttr);
      } else {
        var transitionKeys = normalizeToArray(attrTransition);

        for (var i = 0; i < transitionKeys.length; i++) {
          var key = transitionKeys[i];
          var elVal = elPropsInAttr[key];
          transFromPropsInAttr[key] = elVal;
        }
      }
    } else if (isTransitionAll(transition) || indexOf(transition, mainAttr) >= 0) {
      !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
      var elPropsInAttrKeys = keys$2(elPropsInAttr);

      for (var i = 0; i < elPropsInAttrKeys.length; i++) {
        var key = elPropsInAttrKeys[i];
        var elVal = elPropsInAttr[key];

        if (isNonStyleTransitionEnabled(attrOpt[key], elVal)) {
          transFromPropsInAttr[key] = elVal;
        }
      }
    }
  }
}

function prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
  var attrOpt = elOption[mainAttr];

  if (!attrOpt) {
    return;
  }

  var allPropsInAttr = allProps[mainAttr] = {};
  var keysInAttr = keys$2(attrOpt);

  for (var i = 0; i < keysInAttr.length; i++) {
    var key = keysInAttr[i]; // To avoid share one object with different element, and
    // to avoid user modify the object inexpectedly, have to clone.

    allPropsInAttr[key] = cloneValue(attrOpt[key]);
  }
}

function prepareTransformTransitionFrom(el, elOption, transFromProps) {
  var transition = elOption.transition;
  var transitionKeys = isTransitionAll(transition) ? TRANSFORMABLE_PROPS : normalizeToArray(transition || []);

  for (var i = 0; i < transitionKeys.length; i++) {
    var key = transitionKeys[i];

    if (key === 'style' || key === 'shape' || key === 'extra') {
      continue;
    }

    var elVal = el[key];

    if (process.env.NODE_ENV !== 'production') {
      checkTransformPropRefer(key, 'el.transition');
    } // Do not clone, animator will perform that clone.


    transFromProps[key] = elVal;
  }
}

function prepareTransformAllPropsFinal(el, elOption, allProps) {
  for (var i = 0; i < LEGACY_TRANSFORM_PROPS.length; i++) {
    var legacyName = LEGACY_TRANSFORM_PROPS[i];
    var xyName = LEGACY_TRANSFORM_PROPS_MAP[legacyName];
    var legacyArr = elOption[legacyName];

    if (legacyArr) {
      allProps[xyName[0]] = legacyArr[0];
      allProps[xyName[1]] = legacyArr[1];
    }
  }

  for (var i = 0; i < TRANSFORMABLE_PROPS.length; i++) {
    var key = TRANSFORMABLE_PROPS[i];

    if (elOption[key] != null) {
      allProps[key] = elOption[key];
    }
  }
}

function prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
  if (!styleOpt) {
    return;
  }

  var fromElStyle = fromEl.style;
  var transFromStyleProps;

  if (fromElStyle) {
    var styleTransition = styleOpt.transition;
    var elTransition = elOption.transition;

    if (styleTransition && !isTransitionAll(styleTransition)) {
      var transitionKeys = normalizeToArray(styleTransition);
      !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});

      for (var i = 0; i < transitionKeys.length; i++) {
        var key = transitionKeys[i];
        var elVal = fromElStyle[key]; // Do not clone, see `checkNonStyleTansitionRefer`.

        transFromStyleProps[key] = elVal;
      }
    } else if (fromEl.getAnimationStyleProps && (isTransitionAll(elTransition) || isTransitionAll(styleTransition) || indexOf(elTransition, 'style') >= 0)) {
      var animationProps = fromEl.getAnimationStyleProps();
      var animationStyleProps = animationProps ? animationProps.style : null;

      if (animationStyleProps) {
        !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
        var styleKeys = keys$2(styleOpt);

        for (var i = 0; i < styleKeys.length; i++) {
          var key = styleKeys[i];

          if (animationStyleProps[key]) {
            var elVal = fromElStyle[key];
            transFromStyleProps[key] = elVal;
          }
        }
      }
    }
  }
}

function isNonStyleTransitionEnabled(optVal, elVal) {
  // The same as `checkNonStyleTansitionRefer`.
  return !isArrayLike$1(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}

var checkTransformPropRefer;

if (process.env.NODE_ENV !== 'production') {
  checkTransformPropRefer = function (key, usedIn) {
    if (!hasOwn(TRANSFORM_PROPS_MAP, key)) {
      warn('Prop `' + key + '` is not a permitted in `' + usedIn + '`. ' + 'Only `' + keys$2(TRANSFORM_PROPS_MAP).join('`, `') + '` are permitted.');
    }
  };
}

var getStateToRestore = makeInner();
var KEYFRAME_EXCLUDE_KEYS = ['percent', 'easing', 'shape', 'style', 'extra'];
/**
 * Stop previous keyframe animation and restore the attributes.
 * Avoid new keyframe animation starts with wrong internal state when the percent: 0 is not set.
 */

function stopPreviousKeyframeAnimationAndRestore(el) {
  // Stop previous keyframe animation.
  el.stopAnimation('keyframe'); // Restore

  el.attr(getStateToRestore(el));
}
function applyKeyframeAnimation(el, animationOpts, animatableModel) {
  if (!animatableModel.isAnimationEnabled() || !animationOpts) {
    return;
  }

  if (isArray$1(animationOpts)) {
    each(animationOpts, function (singleAnimationOpts) {
      applyKeyframeAnimation(el, singleAnimationOpts, animatableModel);
    });
    return;
  }

  var keyframes = animationOpts.keyframes;
  var duration = animationOpts.duration;

  if (animatableModel && duration == null) {
    // Default to use duration of config.
    // NOTE: animation config from payload will be ignored because they are mainly for transitions.
    var config = getAnimationConfig('enter', animatableModel, 0);
    duration = config && config.duration;
  }

  if (!keyframes || !duration) {
    return;
  }

  var stateToRestore = getStateToRestore(el);
  each(ELEMENT_ANIMATABLE_PROPS, function (targetPropName) {
    if (targetPropName && !el[targetPropName]) {
      return;
    }

    var animator;
    var endFrameIsSet = false; // Sort keyframes by percent.

    keyframes.sort(function (a, b) {
      return a.percent - b.percent;
    });
    each(keyframes, function (kf) {
      // Stop current animation.
      var animators = el.animators;
      var kfValues = targetPropName ? kf[targetPropName] : kf;

      if (process.env.NODE_ENV !== 'production') {
        if (kf.percent >= 1) {
          endFrameIsSet = true;
        }
      }

      if (!kfValues) {
        return;
      }

      var propKeys = keys$2(kfValues);

      if (!targetPropName) {
        // PENDING performance?
        propKeys = filter(propKeys, function (key) {
          return indexOf(KEYFRAME_EXCLUDE_KEYS, key) < 0;
        });
      }

      if (!propKeys.length) {
        return;
      }

      if (!animator) {
        animator = el.animate(targetPropName, animationOpts.loop, true);
        animator.scope = 'keyframe';
      }

      for (var i = 0; i < animators.length; i++) {
        // Stop all other animation that is not keyframe.
        if (animators[i] !== animator && animators[i].targetName === animator.targetName) {
          animators[i].stopTracks(propKeys);
        }
      }

      targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
      var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
      each(propKeys, function (key) {
        // Save original value.
        savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
      });
      animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
    });

    if (!animator) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!endFrameIsSet) {
        warn('End frame with percent: 1 is missing in the keyframeAnimation.', true);
      }
    }

    animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
  });
}

var EMPHASIS = 'emphasis';
var NORMAL = 'normal';
var BLUR = 'blur';
var SELECT = 'select';
var STATES = [NORMAL, EMPHASIS, BLUR, SELECT];
var PATH_ITEM_STYLE = {
  normal: ['itemStyle'],
  emphasis: [EMPHASIS, 'itemStyle'],
  blur: [BLUR, 'itemStyle'],
  select: [SELECT, 'itemStyle']
};
var PATH_LABEL = {
  normal: ['label'],
  emphasis: [EMPHASIS, 'label'],
  blur: [BLUR, 'label'],
  select: [SELECT, 'label']
};
var DEFAULT_TRANSITION = ['x', 'y']; // Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.

var GROUP_DIFF_PREFIX = 'e\0\0';
var attachedTxInfoTmp = {
  normal: {},
  emphasis: {},
  blur: {},
  select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */

var prepareCustoms = {
  cartesian2d: cartesianPrepareCustom,
  geo: geoPrepareCustom,
  single: singlePrepareCustom,
  polar: polarPrepareCustom,
  calendar: calendarPrepareCustom
};

function isPath$1(el) {
  return el instanceof Path;
}

function isDisplayable(el) {
  return el instanceof Displayable;
}

function copyElement(sourceEl, targetEl) {
  targetEl.copyTransform(sourceEl);

  if (isDisplayable(targetEl) && isDisplayable(sourceEl)) {
    targetEl.setStyle(sourceEl.style);
    targetEl.z = sourceEl.z;
    targetEl.z2 = sourceEl.z2;
    targetEl.zlevel = sourceEl.zlevel;
    targetEl.invisible = sourceEl.invisible;
    targetEl.ignore = sourceEl.ignore;

    if (isPath$1(targetEl) && isPath$1(sourceEl)) {
      targetEl.setShape(sourceEl.shape);
    }
  }
}

var CustomChartView =
/** @class */
function (_super) {
  __extends$1(CustomChartView, _super);

  function CustomChartView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CustomChartView.type;
    return _this;
  }

  CustomChartView.prototype.render = function (customSeries, ecModel, api, payload) {
    // Clear previously rendered progressive elements.
    this._progressiveEls = null;
    var oldData = this._data;
    var data = customSeries.getData();
    var group = this.group;
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);

    if (!oldData) {
      // Previous render is incremental render or first render.
      // Needs remove the incremental rendered elements.
      group.removeAll();
    }

    data.diff(oldData).add(function (newIdx) {
      createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).remove(function (oldIdx) {
      var el = oldData.getItemGraphicEl(oldIdx);
      el && applyLeaveTransition(el, customInnerStore(el).option, customSeries);
    }).update(function (newIdx, oldIdx) {
      var oldEl = oldData.getItemGraphicEl(oldIdx);
      createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
    }).execute(); // Do clipping

    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;

    if (clipPath) {
      group.setClipPath(clipPath);
    } else {
      group.removeClipPath();
    }

    this._data = data;
  };

  CustomChartView.prototype.incrementalPrepareRender = function (customSeries, ecModel, api) {
    this.group.removeAll();
    this._data = null;
  };

  CustomChartView.prototype.incrementalRender = function (params, customSeries, ecModel, api, payload) {
    var data = customSeries.getData();
    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
    var progressiveEls = this._progressiveEls = [];

    function setIncrementalAndHoverLayer(el) {
      if (!el.isGroup) {
        el.incremental = true;
        el.ensureState('emphasis').hoverLayer = true;
      }
    }

    for (var idx = params.start; idx < params.end; idx++) {
      var el = createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);

      if (el) {
        el.traverse(setIncrementalAndHoverLayer);
        progressiveEls.push(el);
      }
    }
  };

  CustomChartView.prototype.eachRendered = function (cb) {
    traverseElements(this._progressiveEls || this.group, cb);
  };

  CustomChartView.prototype.filterForExposedEvent = function (eventType, query, targetEl, packedEvent) {
    var elementName = query.element;

    if (elementName == null || targetEl.name === elementName) {
      return true;
    } // Enable to give a name on a group made by `renderItem`, and listen
    // events that are triggered by its descendents.


    while ((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group) {
      if (targetEl.name === elementName) {
        return true;
      }
    }

    return false;
  };

  CustomChartView.type = 'custom';
  return CustomChartView;
}(ChartView);

function createEl(elOption) {
  var graphicType = elOption.type;
  var el; // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.

  if (graphicType === 'path') {
    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.

    var pathRect = shape.width != null && shape.height != null ? {
      x: shape.x || 0,
      y: shape.y || 0,
      width: shape.width,
      height: shape.height
    } : null;
    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.

    el = makePath(pathData, null, pathRect, shape.layout || 'center');
    customInnerStore(el).customPathData = pathData;
  } else if (graphicType === 'image') {
    el = new ZRImage({});
    customInnerStore(el).customImagePath = elOption.style.image;
  } else if (graphicType === 'text') {
    el = new ZRText({}); // customInnerStore(el).customText = (elOption.style as TextStyleProps).text;
  } else if (graphicType === 'group') {
    el = new Group$1();
  } else if (graphicType === 'compoundPath') {
    throw new Error('"compoundPath" is not supported yet.');
  } else {
    var Clz = getShapeClass(graphicType);

    if (!Clz) {
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'graphic type "' + graphicType + '" can not be found.';
      }

      throwError(errMsg);
    }

    el = new Clz();
  }

  customInnerStore(el).customGraphicType = graphicType;
  el.name = elOption.name; // Compat ec4: the default z2 lift is 1. If changing the number,
  // some cases probably be broken: hierarchy layout along z, like circle packing,
  // where emphasis only intending to modify color/border rather than lift z2.

  el.z2EmphasisLift = 1;
  el.z2SelectLift = 1;
  return el;
}

function updateElNormal( // Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
  // Stop and restore before update any other attributes.
  stopPreviousKeyframeAnimationAndRestore(el);
  var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;

  if (txCfgOpt) {
    // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
  } // Default transition ['x', 'y']


  if (elOption && elOption.transition == null) {
    elOption.transition = DEFAULT_TRANSITION;
  } // Do some normalization on style.


  var styleOpt = elOption && elOption.style;

  if (styleOpt) {
    if (el.type === 'text') {
      var textOptionStyle = styleOpt; // Compatible with ec4: if `textFill` or `textStroke` exists use them.

      hasOwn(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
      hasOwn(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
    }

    var decalPattern = void 0;
    var decalObj = isPath$1(el) ? styleOpt.decal : null;

    if (api && decalObj) {
      decalObj.dirty = true;
      decalPattern = createOrUpdatePatternFromDecal(decalObj, api);
    } // Always overwrite in case user specify this prop.


    styleOpt.__decalPattern = decalPattern;
  }

  if (isDisplayable(el)) {
    if (styleOpt) {
      var decalPattern = styleOpt.__decalPattern;

      if (decalPattern) {
        styleOpt.decal = decalPattern;
      }
    }
  }

  applyUpdateTransition(el, elOption, seriesModel, {
    dataIndex: dataIndex,
    isInit: isInit,
    clearStyle: true
  });
  applyKeyframeAnimation(el, elOption.keyframeAnimation, seriesModel);
}

function updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
  var elDisplayable = el.isGroup ? null : el;
  var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg; // PENDING:5.0 support customize scale change and transition animation?

  if (elDisplayable) {
    // By default support auto lift color when hover whether `emphasis` specified.
    var stateObj = elDisplayable.ensureState(state);

    if (styleOpt === false) {
      var existingEmphasisState = elDisplayable.getState(state);

      if (existingEmphasisState) {
        existingEmphasisState.style = null;
      }
    } else {
      // style is needed to enable default emphasis.
      stateObj.style = styleOpt || null;
    } // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
    // remove hover style.
    // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
    // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.


    if (txCfgOpt) {
      stateObj.textConfig = txCfgOpt;
    }

    setDefaultStateProxy(elDisplayable);
  }
}

function updateZ$1(el, elOption, seriesModel) {
  // Group not support textContent and not support z yet.
  if (el.isGroup) {
    return;
  }

  var elDisplayable = el;
  var currentZ = seriesModel.currentZ;
  var currentZLevel = seriesModel.currentZLevel; // Always erase.

  elDisplayable.z = currentZ;
  elDisplayable.zlevel = currentZLevel; // z2 must not be null/undefined, otherwise sort error may occur.

  var optZ2 = elOption.z2;
  optZ2 != null && (elDisplayable.z2 = optZ2 || 0);

  for (var i = 0; i < STATES.length; i++) {
    updateZForEachState(elDisplayable, elOption, STATES[i]);
  }
}

function updateZForEachState(elDisplayable, elOption, state) {
  var isNormal = state === NORMAL;
  var elStateOpt = isNormal ? elOption : retrieveStateOption(elOption, state);
  var optZ2 = elStateOpt ? elStateOpt.z2 : null;
  var stateObj;

  if (optZ2 != null) {
    // Do not `ensureState` until required.
    stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
    stateObj.z2 = optZ2 || 0;
  }
}

function makeRenderItem(customSeries, data, ecModel, api) {
  var renderItem = customSeries.get('renderItem');
  var coordSys = customSeries.coordinateSystem;
  var prepareResult = {};

  if (coordSys) {
    if (process.env.NODE_ENV !== 'production') {
      assert(renderItem, 'series.render is required.');
      assert(coordSys.prepareCustoms || prepareCustoms[coordSys.type], 'This coordSys does not support custom series.');
    } // `coordSys.prepareCustoms` is used for external coord sys like bmap.


    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : prepareCustoms[coordSys.type](coordSys);
  }

  var userAPI = defaults({
    getWidth: api.getWidth,
    getHeight: api.getHeight,
    getZr: api.getZr,
    getDevicePixelRatio: api.getDevicePixelRatio,
    value: value,
    style: style,
    ordinalRawValue: ordinalRawValue,
    styleEmphasis: styleEmphasis,
    visual: visual,
    barLayout: barLayout,
    currentSeriesIndices: currentSeriesIndices,
    font: font
  }, prepareResult.api || {});
  var userParams = {
    // The life cycle of context: current round of rendering.
    // The global life cycle is probably not necessary, because
    // user can store global status by themselves.
    context: {},
    seriesId: customSeries.id,
    seriesName: customSeries.name,
    seriesIndex: customSeries.seriesIndex,
    coordSys: prepareResult.coordSys,
    dataInsideLength: data.count(),
    encode: wrapEncodeDef(customSeries.getData())
  }; // If someday intending to refactor them to a class, should consider do not
  // break change: currently these attribute member are encapsulated in a closure
  // so that do not need to force user to call these method with a scope.
  // Do not support call `api` asynchronously without dataIndexInside input.

  var currDataIndexInside;
  var currItemModel;
  var currItemStyleModels = {};
  var currLabelModels = {};
  var seriesItemStyleModels = {};
  var seriesLabelModels = {};

  for (var i = 0; i < STATES.length; i++) {
    var stateName = STATES[i];
    seriesItemStyleModels[stateName] = customSeries.getModel(PATH_ITEM_STYLE[stateName]);
    seriesLabelModels[stateName] = customSeries.getModel(PATH_LABEL[stateName]);
  }

  function getItemModel(dataIndexInside) {
    return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
  }

  function getItemStyleModel(dataIndexInside, state) {
    return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel(PATH_ITEM_STYLE[state]);
  }

  function getLabelModel(dataIndexInside, state) {
    return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel(PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel(PATH_LABEL[state]);
  }

  return function (dataIndexInside, payload) {
    currDataIndexInside = dataIndexInside;
    currItemModel = null;
    currItemStyleModels = {};
    currLabelModels = {};
    return renderItem && renderItem(defaults({
      dataIndexInside: dataIndexInside,
      dataIndex: data.getRawIndex(dataIndexInside),
      // Can be used for optimization when zoom or roam.
      actionType: payload ? payload.type : null
    }, userParams), userAPI);
  };
  /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */

  function value(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
  }
  /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function ordinalRawValue(dim, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    dim = dim || 0;
    var dimInfo = data.getDimensionInfo(dim);

    if (!dimInfo) {
      var dimIndex = data.getDimensionIndex(dim);
      return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
    }

    var val = data.get(dimInfo.name, dataIndexInside);
    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
    return ordinalMeta ? ordinalMeta.categories[val] : val;
  }
  /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function style(userProps, dataIndexInside) {
    if (process.env.NODE_ENV !== 'production') {
      warnDeprecated('api.style', 'Please write literal style directly instead.');
    }

    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    var style = data.getItemVisual(dataIndexInside, 'style');
    var visualColor = style && style.fill;
    var opacity = style && style.opacity;
    var itemStyle = getItemStyleModel(dataIndexInside, NORMAL).getItemStyle();
    visualColor != null && (itemStyle.fill = visualColor);
    opacity != null && (itemStyle.opacity = opacity);
    var opt = {
      inheritColor: isString(visualColor) ? visualColor : '#000'
    };
    var labelModel = getLabelModel(dataIndexInside, NORMAL); // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
    // since ec5, we should set `isAttached` as `false` here and make compat in
    // `convertToEC4StyleForCustomSerise`.

    var textStyle = createTextStyle(labelModel, null, opt, false, true);
    textStyle.text = labelModel.getShallow('show') ? retrieve2(customSeries.getFormattedLabel(dataIndexInside, NORMAL), getDefaultLabel(data, dataIndexInside)) : null;
    var textConfig = createTextConfig(labelModel, opt, false);
    preFetchFromExtra(userProps, itemStyle);
    itemStyle = convertToEC4StyleForCustomSerise(itemStyle, textStyle, textConfig);
    userProps && applyUserPropsAfter(itemStyle, userProps);
    itemStyle.legacy = true;
    return itemStyle;
  }
  /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function styleEmphasis(userProps, dataIndexInside) {
    if (process.env.NODE_ENV !== 'production') {
      warnDeprecated('api.styleEmphasis', 'Please write literal style directly instead.');
    }

    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
    var itemStyle = getItemStyleModel(dataIndexInside, EMPHASIS).getItemStyle();
    var labelModel = getLabelModel(dataIndexInside, EMPHASIS);
    var textStyle = createTextStyle(labelModel, null, null, true, true);
    textStyle.text = labelModel.getShallow('show') ? retrieve3(customSeries.getFormattedLabel(dataIndexInside, EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, NORMAL), getDefaultLabel(data, dataIndexInside)) : null;
    var textConfig = createTextConfig(labelModel, null, true);
    preFetchFromExtra(userProps, itemStyle);
    itemStyle = convertToEC4StyleForCustomSerise(itemStyle, textStyle, textConfig);
    userProps && applyUserPropsAfter(itemStyle, userProps);
    itemStyle.legacy = true;
    return itemStyle;
  }

  function applyUserPropsAfter(itemStyle, extra) {
    for (var key in extra) {
      if (hasOwn(extra, key)) {
        itemStyle[key] = extra[key];
      }
    }
  }

  function preFetchFromExtra(extra, itemStyle) {
    // A trick to retrieve those props firstly, which are used to
    // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
    // (It's not reasonable but only for a degree of compat)
    if (extra) {
      extra.textFill && (itemStyle.textFill = extra.textFill);
      extra.textPosition && (itemStyle.textPosition = extra.textPosition);
    }
  }
  /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */


  function visual(visualType, dataIndexInside) {
    dataIndexInside == null && (dataIndexInside = currDataIndexInside);

    if (hasOwn(STYLE_VISUAL_TYPE, visualType)) {
      var style_1 = data.getItemVisual(dataIndexInside, 'style');
      return style_1 ? style_1[STYLE_VISUAL_TYPE[visualType]] : null;
    } // Only support these visuals. Other visual might be inner tricky
    // for performance (like `style`), do not expose to users.


    if (hasOwn(NON_STYLE_VISUAL_PROPS, visualType)) {
      return data.getItemVisual(dataIndexInside, visualType);
    }
  }
  /**
   * @public
   * @return If not support, return undefined.
   */


  function barLayout(opt) {
    if (coordSys.type === 'cartesian2d') {
      var baseAxis = coordSys.getBaseAxis();
      return getLayoutOnAxis(defaults({
        axis: baseAxis
      }, opt));
    }
  }
  /**
   * @public
   */


  function currentSeriesIndices() {
    return ecModel.getCurrentSeriesIndices();
  }
  /**
   * @public
   * @return font string
   */


  function font(opt) {
    return getFont(opt, ecModel);
  }
}

function wrapEncodeDef(data) {
  var encodeDef = {};
  each(data.dimensions, function (dimName) {
    var dimInfo = data.getDimensionInfo(dimName);

    if (!dimInfo.isExtraCoord) {
      var coordDim = dimInfo.coordDim;
      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
      dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
    }
  });
  return encodeDef;
}

function createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
  // [Rule]
  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
  //     (It seems that violate the "merge" principle, but most of users probably intuitively
  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
  //     most cases.)
  // The rule or "merge" see [STRATEGY_MERGE].
  // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
  if (!elOption) {
    group.remove(existsEl);
    return;
  }

  var el = doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
  el && data.setItemGraphicEl(dataIndex, el);
  el && toggleHoverEmphasis(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
  return el;
}

function doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
  if (process.env.NODE_ENV !== 'production') {
    assert(elOption, 'should not have an null/undefined element setting');
  }

  var toBeReplacedIdx = -1;
  var oldEl = existsEl;

  if (existsEl && doesElNeedRecreate(existsEl, elOption, seriesModel) // || (
  //     // PENDING: even in one-to-one mapping case, if el is marked as morph,
  //     // do not sure whether the el will be mapped to another el with different
  //     // hierarchy in Group tree. So always recreate el rather than reuse the el.
  //     morphHelper && morphHelper.isOneToOneFrom(el)
  // )
  ) {
    // Should keep at the original index, otherwise "merge by index" will be incorrect.
    toBeReplacedIdx = indexOf(group.childrenRef(), existsEl);
    existsEl = null;
  }

  var isInit = !existsEl;
  var el = existsEl;

  if (!el) {
    el = createEl(elOption);

    if (oldEl) {
      copyElement(oldEl, el);
    }
  } else {
    // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
  } // Need to set morph: false explictly to disable automatically morphing.


  if (elOption.morph === false) {
    el.disableMorphing = true;
  } else if (el.disableMorphing) {
    el.disableMorphing = false;
  }

  attachedTxInfoTmp.normal.cfg = attachedTxInfoTmp.normal.conOpt = attachedTxInfoTmp.emphasis.cfg = attachedTxInfoTmp.emphasis.conOpt = attachedTxInfoTmp.blur.cfg = attachedTxInfoTmp.blur.conOpt = attachedTxInfoTmp.select.cfg = attachedTxInfoTmp.select.conOpt = null;
  attachedTxInfoTmp.isLegacy = false;
  doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfoTmp);
  doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
  updateElNormal(api, el, dataIndex, elOption, attachedTxInfoTmp, seriesModel, isInit); // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.
  // Update them only when user specified, otherwise, remain.

  hasOwn(elOption, 'info') && (customInnerStore(el).info = elOption.info);

  for (var i = 0; i < STATES.length; i++) {
    var stateName = STATES[i];

    if (stateName !== NORMAL) {
      var otherStateOpt = retrieveStateOption(elOption, stateName);
      var otherStyleOpt = retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
      updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, attachedTxInfoTmp);
    }
  }

  updateZ$1(el, elOption, seriesModel);

  if (elOption.type === 'group') {
    mergeChildren(api, el, dataIndex, elOption, seriesModel);
  }

  if (toBeReplacedIdx >= 0) {
    group.replaceAt(el, toBeReplacedIdx);
  } else {
    group.add(el);
  }

  return el;
} // `el` must not be null/undefined.


function doesElNeedRecreate(el, elOption, seriesModel) {
  var elInner = customInnerStore(el);
  var elOptionType = elOption.type;
  var elOptionShape = elOption.shape;
  var elOptionStyle = elOption.style;
  return (// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() // If `elOptionType` is `null`, follow the merge principle.
    || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath // // FIXME test and remove this restriction?
    // || (elOptionType === 'text'
    //     && hasOwn(elOptionStyle, 'text')
    //     && (elOptionStyle as TextStyleProps).text !== elInner.customText
    // )

  );
}

function doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
  // Based on the "merge" principle, if no clipPath provided,
  // do nothing. The exists clip will be totally removed only if
  // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
  var clipPathOpt = elOption.clipPath;

  if (clipPathOpt === false) {
    if (el && el.getClipPath()) {
      el.removeClipPath();
    }
  } else if (clipPathOpt) {
    var clipPath = el.getClipPath();

    if (clipPath && doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) {
      clipPath = null;
    }

    if (!clipPath) {
      clipPath = createEl(clipPathOpt);

      if (process.env.NODE_ENV !== 'production') {
        assert(isPath$1(clipPath), 'Only any type of `path` can be used in `clipPath`, rather than ' + clipPath.type + '.');
      }

      el.setClipPath(clipPath);
    }

    updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
  } // If not define `clipPath` in option, do nothing unnecessary.

}

function doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
  // Group does not support textContent temporarily until necessary.
  if (el.isGroup) {
    return;
  } // Normal must be called before emphasis, for `isLegacy` detection.


  processTxInfo(elOption, null, attachedTxInfo);
  processTxInfo(elOption, EMPHASIS, attachedTxInfo); // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
  // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
  // trade them as set to null to el.
  // Especially:
  // `elOption.textContent: false` means remove textContent.
  // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.

  var txConOptNormal = attachedTxInfo.normal.conOpt;
  var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
  var txConOptBlur = attachedTxInfo.blur.conOpt;
  var txConOptSelect = attachedTxInfo.select.conOpt;

  if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
    var textContent = el.getTextContent();

    if (txConOptNormal === false) {
      textContent && el.removeTextContent();
    } else {
      txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
        type: 'text'
      };

      if (!textContent) {
        textContent = createEl(txConOptNormal);
        el.setTextContent(textContent);
      } else {
        // If in some case the performance issue arised, consider
        // do not clearState but update cached normal state directly.
        textContent.clearStates();
      }

      updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
      var txConStlOptNormal = txConOptNormal && txConOptNormal.style;

      for (var i = 0; i < STATES.length; i++) {
        var stateName = STATES[i];

        if (stateName !== NORMAL) {
          var txConOptOtherState = attachedTxInfo[stateName].conOpt;
          updateElOnState(stateName, textContent, txConOptOtherState, retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
        }
      }

      txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
    }
  }
}

function processTxInfo(elOption, state, attachedTxInfo) {
  var stateOpt = !state ? elOption : retrieveStateOption(elOption, state);
  var styleOpt = !state ? elOption.style : retrieveStyleOptionOnState(elOption, stateOpt, EMPHASIS);
  var elType = elOption.type;
  var txCfg = stateOpt ? stateOpt.textConfig : null;
  var txConOptNormal = elOption.textContent;
  var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : retrieveStateOption(txConOptNormal, state);

  if (styleOpt && ( // Because emphasis style has little info to detect legacy,
  // if normal is legacy, emphasis is trade as legacy.
  attachedTxInfo.isLegacy || isEC4CompatibleStyle(styleOpt, elType, !!txCfg, !!txConOpt))) {
    attachedTxInfo.isLegacy = true;
    var convertResult = convertFromEC4CompatibleStyle(styleOpt, elType, !state); // Explicitly specified `textConfig` and `textContent` has higher priority than
    // the ones generated by legacy style. Otherwise if users use them and `api.style`
    // at the same time, they not both work and hardly to known why.

    if (!txCfg && convertResult.textConfig) {
      txCfg = convertResult.textConfig;
    }

    if (!txConOpt && convertResult.textContent) {
      txConOpt = convertResult.textContent;
    }
  }

  if (!state && txConOpt) {
    var txConOptNormal_1 = txConOpt; // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.

    !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');

    if (process.env.NODE_ENV !== 'production') {
      // Do not tolerate incorrcet type for forward compat.
      assert(txConOptNormal_1.type === 'text', 'textContent.type must be "text"');
    }
  }

  var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
  info.cfg = txCfg;
  info.conOpt = txConOpt;
}

function retrieveStateOption(elOption, state) {
  return !state ? elOption : elOption ? elOption[state] : null;
}

function retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
  var style = stateOption && stateOption.style;

  if (style == null && state === EMPHASIS && stateOptionNormal) {
    style = stateOptionNormal.styleEmphasis;
  }

  return style;
} // Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.


function mergeChildren(api, el, dataIndex, elOption, seriesModel) {
  var newChildren = elOption.children;
  var newLen = newChildren ? newChildren.length : 0;
  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.

  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.

  if (!newLen && !byName && !notMerge) {
    return;
  }

  if (byName) {
    diffGroupChildren({
      api: api,
      oldChildren: el.children() || [],
      newChildren: newChildren || [],
      dataIndex: dataIndex,
      seriesModel: seriesModel,
      group: el
    });
    return;
  }

  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
  // might be better performance.

  var index = 0;

  for (; index < newLen; index++) {
    var newChild = newChildren[index];
    var oldChild = el.childAt(index);

    if (newChild) {
      if (newChild.ignore == null) {
        // The old child is set to be ignored if null (see comments
        // below). So we need to set ignore to be false back.
        newChild.ignore = false;
      }

      doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
    } else {
      if (process.env.NODE_ENV !== 'production') {
        assert(oldChild, 'renderItem should not return a group containing elements' + ' as null/undefined/{} if they do not exist before.');
      } // If the new element option is null, it means to remove the old
      // element. But we cannot really remove the element from the group
      // directly, because the element order may not be stable when this
      // element is added back. So we set the element to be ignored.


      oldChild.ignore = true;
    }
  }

  for (var i = el.childCount() - 1; i >= index; i--) {
    var child = el.childAt(i);
    removeChildFromGroup(el, child, seriesModel);
  }
}

function removeChildFromGroup(group, child, seriesModel) {
  // Do not support leave elements that are not mentioned in the latest
  // `renderItem` return. Otherwise users may not have a clear and simple
  // concept that how to control all of the elements.
  child && applyLeaveTransition(child, customInnerStore(group).option, seriesModel);
}

function diffGroupChildren(context) {
  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
}

function getKey(item, idx) {
  var name = item && item.name;
  return name != null ? name : GROUP_DIFF_PREFIX + idx;
}

function processAddUpdate(newIndex, oldIndex) {
  var context = this.context;
  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
  doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}

function processRemove(oldIndex) {
  var context = this.context;
  var child = context.oldChildren[oldIndex];
  child && applyLeaveTransition(child, customInnerStore(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */


function getPathData(shape) {
  // "d" follows the SVG convention.
  return shape && (shape.pathData || shape.d);
}

function hasOwnPathData(shape) {
  return shape && (hasOwn(shape, 'pathData') || hasOwn(shape, 'd'));
}

function install$r(registers) {
  registers.registerChartView(CustomChartView);
  registers.registerSeriesModel(CustomSeriesModel);
}

var inner$b = makeInner();
var clone$3 = clone;
var bind$1 = bind;
/**
 * Base axis pointer class in 2D.
 */

var BaseAxisPointer =
/** @class */
function () {
  function BaseAxisPointer() {
    this._dragging = false;
    /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */

    this.animationThreshold = 15;
  }
  /**
   * @implement
   */


  BaseAxisPointer.prototype.render = function (axisModel, axisPointerModel, api, forceRender) {
    var value = axisPointerModel.get('value');
    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
    // be replaced when user calling setOption in not merge mode.

    this._axisModel = axisModel;
    this._axisPointerModel = axisPointerModel;
    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
    // So it is power consuming if performing `render` each time,
    // especially on mobile device.

    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
      return;
    }

    this._lastValue = value;
    this._lastStatus = status;
    var group = this._group;
    var handle = this._handle;

    if (!status || status === 'hide') {
      // Do not clear here, for animation better.
      group && group.hide();
      handle && handle.hide();
      return;
    }

    group && group.show();
    handle && handle.show(); // Otherwise status is 'show'

    var elOption = {};
    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.

    var graphicKey = elOption.graphicKey;

    if (graphicKey !== this._lastGraphicKey) {
      this.clear(api);
    }

    this._lastGraphicKey = graphicKey;
    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);

    if (!group) {
      group = this._group = new Group$1();
      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
      api.getZr().add(group);
    } else {
      var doUpdateProps = curry(updateProps$1, axisPointerModel, moveAnimation);
      this.updatePointerEl(group, elOption, doUpdateProps);
      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
    }

    updateMandatoryProps(group, axisPointerModel, true);

    this._renderHandle(value);
  };
  /**
   * @implement
   */


  BaseAxisPointer.prototype.remove = function (api) {
    this.clear(api);
  };
  /**
   * @implement
   */


  BaseAxisPointer.prototype.dispose = function (api) {
    this.clear(api);
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.determineAnimation = function (axisModel, axisPointerModel) {
    var animation = axisPointerModel.get('animation');
    var axis = axisModel.axis;
    var isCategoryAxis = axis.type === 'category';
    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.

    if (!useSnap && !isCategoryAxis) {
      return false;
    }

    if (animation === 'auto' || animation == null) {
      var animationThreshold = this.animationThreshold;

      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
        return true;
      } // It is important to auto animation when snap used. Consider if there is
      // a dataZoom, animation will be disabled when too many points exist, while
      // it will be enabled for better visual effect when little points exist.


      if (useSnap) {
        var seriesDataCount = getAxisInfo(axisModel).seriesDataCount;
        var axisExtent = axis.getExtent(); // Approximate band width

        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
      }

      return false;
    }

    return animation === true;
  };
  /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */


  BaseAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.createPointerEl = function (group, elOption, axisModel, axisPointerModel) {
    var pointerOption = elOption.pointer;

    if (pointerOption) {
      var pointerEl = inner$b(group).pointerEl = new graphic[pointerOption.type](clone$3(elOption.pointer));
      group.add(pointerEl);
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.createLabelEl = function (group, elOption, axisModel, axisPointerModel) {
    if (elOption.label) {
      var labelEl = inner$b(group).labelEl = new ZRText(clone$3(elOption.label));
      group.add(labelEl);
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.updatePointerEl = function (group, elOption, updateProps) {
    var pointerEl = inner$b(group).pointerEl;

    if (pointerEl && elOption.pointer) {
      pointerEl.setStyle(elOption.pointer.style);
      updateProps(pointerEl, {
        shape: elOption.pointer.shape
      });
    }
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.updateLabelEl = function (group, elOption, updateProps, axisPointerModel) {
    var labelEl = inner$b(group).labelEl;

    if (labelEl) {
      labelEl.setStyle(elOption.label.style);
      updateProps(labelEl, {
        // Consider text length change in vertical axis, animation should
        // be used on shape, otherwise the effect will be weird.
        // TODOTODO
        // shape: elOption.label.shape,
        x: elOption.label.x,
        y: elOption.label.y
      });
      updateLabelShowHide(labelEl, axisPointerModel);
    }
  };
  /**
   * @private
   */


  BaseAxisPointer.prototype._renderHandle = function (value) {
    if (this._dragging || !this.updateHandleTransform) {
      return;
    }

    var axisPointerModel = this._axisPointerModel;

    var zr = this._api.getZr();

    var handle = this._handle;
    var handleModel = axisPointerModel.getModel('handle');
    var status = axisPointerModel.get('status');

    if (!handleModel.get('show') || !status || status === 'hide') {
      handle && zr.remove(handle);
      this._handle = null;
      return;
    }

    var isInit;

    if (!this._handle) {
      isInit = true;
      handle = this._handle = createIcon(handleModel.get('icon'), {
        cursor: 'move',
        draggable: true,
        onmousemove: function (e) {
          // Fot mobile devicem, prevent screen slider on the button.
          stop(e.event);
        },
        onmousedown: bind$1(this._onHandleDragMove, this, 0, 0),
        drift: bind$1(this._onHandleDragMove, this),
        ondragend: bind$1(this._onHandleDragEnd, this)
      });
      zr.add(handle);
    }

    updateMandatoryProps(handle, axisPointerModel, false); // update style

    handle.setStyle(handleModel.getItemStyle(null, ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'])); // update position

    var handleSize = handleModel.get('size');

    if (!isArray$1(handleSize)) {
      handleSize = [handleSize, handleSize];
    }

    handle.scaleX = handleSize[0] / 2;
    handle.scaleY = handleSize[1] / 2;
    createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');

    this._moveHandleToValue(value, isInit);
  };

  BaseAxisPointer.prototype._moveHandleToValue = function (value, isInit) {
    updateProps$1(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
  };

  BaseAxisPointer.prototype._onHandleDragMove = function (dx, dy) {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    this._dragging = true; // Persistent for throttle.

    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
    this._payloadInfo = trans;
    handle.stopAnimation();
    handle.attr(getHandleTransProps(trans));
    inner$b(handle).lastProp = null;

    this._doDispatchAxisPointer();
  };
  /**
   * Throttled method.
   */


  BaseAxisPointer.prototype._doDispatchAxisPointer = function () {
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var payloadInfo = this._payloadInfo;
    var axisModel = this._axisModel;

    this._api.dispatchAction({
      type: 'updateAxisPointer',
      x: payloadInfo.cursorPoint[0],
      y: payloadInfo.cursorPoint[1],
      tooltipOption: payloadInfo.tooltipOption,
      axesInfo: [{
        axisDim: axisModel.axis.dim,
        axisIndex: axisModel.componentIndex
      }]
    });
  };

  BaseAxisPointer.prototype._onHandleDragEnd = function () {
    this._dragging = false;
    var handle = this._handle;

    if (!handle) {
      return;
    }

    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
    // axisPointer. So move handle to align the exact value position when
    // drag ended.


    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
    // button, and will be hidden after finger left handle button.


    this._api.dispatchAction({
      type: 'hideTip'
    });
  };
  /**
   * @private
   */


  BaseAxisPointer.prototype.clear = function (api) {
    this._lastValue = null;
    this._lastStatus = null;
    var zr = api.getZr();
    var group = this._group;
    var handle = this._handle;

    if (zr && group) {
      this._lastGraphicKey = null;
      group && zr.remove(group);
      handle && zr.remove(handle);
      this._group = null;
      this._handle = null;
      this._payloadInfo = null;
    }

    clear(this, '_doDispatchAxisPointer');
  };
  /**
   * @protected
   */


  BaseAxisPointer.prototype.doClear = function () {// Implemented by sub-class if necessary.
  };

  BaseAxisPointer.prototype.buildLabel = function (xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
      x: xy[xDimIndex],
      y: xy[1 - xDimIndex],
      width: wh[xDimIndex],
      height: wh[1 - xDimIndex]
    };
  };

  return BaseAxisPointer;
}();

function updateProps$1(animationModel, moveAnimation, el, props) {
  // Animation optimize.
  if (!propsEqual(inner$b(el).lastProp, props)) {
    inner$b(el).lastProp = props;
    moveAnimation ? updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
  }
}

function propsEqual(lastProps, newProps) {
  if (isObject$2(lastProps) && isObject$2(newProps)) {
    var equals_1 = true;
    each(newProps, function (item, key) {
      equals_1 = equals_1 && propsEqual(lastProps[key], item);
    });
    return !!equals_1;
  } else {
    return lastProps === newProps;
  }
}

function updateLabelShowHide(labelEl, axisPointerModel) {
  labelEl[axisPointerModel.get(['label', 'show']) ? 'show' : 'hide']();
}

function getHandleTransProps(trans) {
  return {
    x: trans.x || 0,
    y: trans.y || 0,
    rotation: trans.rotation || 0
  };
}

function updateMandatoryProps(group, axisPointerModel, silent) {
  var z = axisPointerModel.get('z');
  var zlevel = axisPointerModel.get('zlevel');
  group && group.traverse(function (el) {
    if (el.type !== 'group') {
      z != null && (el.z = z);
      zlevel != null && (el.zlevel = zlevel);
      el.silent = silent;
    }
  });
}

function buildElStyle(axisPointerModel) {
  var axisPointerType = axisPointerModel.get('type');
  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
  var style;

  if (axisPointerType === 'line') {
    style = styleModel.getLineStyle();
    style.fill = null;
  } else if (axisPointerType === 'shadow') {
    style = styleModel.getAreaStyle();
    style.stroke = null;
  }

  return style;
}
/**
 * @param {Function} labelPos {align, verticalAlign, position}
 */

function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
  var value = axisPointerModel.get('value');
  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
    precision: axisPointerModel.get(['label', 'precision']),
    formatter: axisPointerModel.get(['label', 'formatter'])
  });
  var labelModel = axisPointerModel.getModel('label');
  var paddings = normalizeCssArray$1(labelModel.get('padding') || 0);
  var font = labelModel.getFont();
  var textRect = getBoundingRect(text, font);
  var position = labelPos.position;
  var width = textRect.width + paddings[1] + paddings[3];
  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.

  var align = labelPos.align;
  align === 'right' && (position[0] -= width);
  align === 'center' && (position[0] -= width / 2);
  var verticalAlign = labelPos.verticalAlign;
  verticalAlign === 'bottom' && (position[1] -= height);
  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container

  confineInContainer(position, width, height, api);
  var bgColor = labelModel.get('backgroundColor');

  if (!bgColor || bgColor === 'auto') {
    bgColor = axisModel.get(['axisLine', 'lineStyle', 'color']);
  }

  elOption.label = {
    // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
    x: position[0],
    y: position[1],
    style: createTextStyle(labelModel, {
      text: text,
      font: font,
      fill: labelModel.getTextColor(),
      padding: paddings,
      backgroundColor: bgColor
    }),
    // Lable should be over axisPointer.
    z2: 10
  };
} // Do not overflow ec container

function confineInContainer(position, width, height, api) {
  var viewWidth = api.getWidth();
  var viewHeight = api.getHeight();
  position[0] = Math.min(position[0] + width, viewWidth) - width;
  position[1] = Math.min(position[1] + height, viewHeight) - height;
  position[0] = Math.max(position[0], 0);
  position[1] = Math.max(position[1], 0);
}

function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
  value = axis.scale.parse(value);
  var text = axis.scale.getLabel({
    value: value
  }, {
    // If `precision` is set, width can be fixed (like '12.00500'), which
    // helps to debounce when when moving label.
    precision: opt.precision
  });
  var formatter = opt.formatter;

  if (formatter) {
    var params_1 = {
      value: getAxisRawValue(axis, {
        value: value
      }),
      axisDimension: axis.dim,
      axisIndex: axis.index,
      seriesData: []
    };
    each(seriesDataIndices, function (idxItem) {
      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
      var dataIndex = idxItem.dataIndexInside;
      var dataParams = series && series.getDataParams(dataIndex);
      dataParams && params_1.seriesData.push(dataParams);
    });

    if (isString(formatter)) {
      text = formatter.replace('{value}', text);
    } else if (isFunction$3(formatter)) {
      text = formatter(params_1);
    }
  }

  return text;
}
function getTransformedPosition(axis, value, layoutInfo) {
  var transform = create$1();
  rotate(transform, transform, layoutInfo.rotation);
  translate(transform, transform, layoutInfo.position);
  return applyTransform$1([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
}
function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
  // @ts-ignore
  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
  layoutInfo.labelMargin = axisPointerModel.get(['label', 'margin']);
  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
    align: textLayout.textAlign,
    verticalAlign: textLayout.textVerticalAlign
  });
}
function makeLineShape(p1, p2, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x1: p1[xDimIndex],
    y1: p1[1 - xDimIndex],
    x2: p2[xDimIndex],
    y2: p2[1 - xDimIndex]
  };
}
function makeRectShape(xy, wh, xDimIndex) {
  xDimIndex = xDimIndex || 0;
  return {
    x: xy[xDimIndex],
    y: xy[1 - xDimIndex],
    width: wh[xDimIndex],
    height: wh[1 - xDimIndex]
  };
}
function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
  return {
    cx: cx,
    cy: cy,
    r0: r0,
    r: r,
    startAngle: startAngle,
    endAngle: endAngle,
    clockwise: true
  };
}

var CartesianAxisPointer =
/** @class */
function (_super) {
  __extends$1(CartesianAxisPointer, _super);

  function CartesianAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  CartesianAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisPointerType = axisPointerModel.get('type');
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = layout$1(grid.model, axisModel);
    buildCartesianSingleLabelElOption( // @ts-ignore
    value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  };
  /**
   * @override
   */


  CartesianAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
    var layoutInfo = layout$1(axisModel.axis.grid.model, axisModel, {
      labelInside: false
    }); // @ts-ignore

    layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
    var pos = getTransformedPosition(axisModel.axis, value, layoutInfo);
    return {
      x: pos[0],
      y: pos[1],
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  };
  /**
   * @override
   */


  CartesianAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var grid = axis.grid;
    var axisExtent = axis.getGlobalExtent(true);
    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
    var dimIndex = axis.dim === 'x' ? 0 : 1;
    var currPosition = [transform.x, transform.y];
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.

    var tooltipOptions = [{
      verticalAlign: 'middle'
    }, {
      align: 'center'
    }];
    return {
      x: currPosition[0],
      y: currPosition[1],
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: tooltipOptions[dimIndex]
    };
  };

  return CartesianAxisPointer;
}(BaseAxisPointer);

function getCartesian(grid, axis) {
  var opt = {};
  opt[axis.dim + 'AxisIndex'] = axis.index;
  return grid.getCartesian(opt);
}

var pointerShapeBuilder = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
    };
  }
};

function getAxisDimIndex(axis) {
  return axis.dim === 'x' ? 0 : 1;
}

var AxisPointerModel =
/** @class */
function (_super) {
  __extends$1(AxisPointerModel, _super);

  function AxisPointerModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisPointerModel.type;
    return _this;
  }

  AxisPointerModel.type = 'axisPointer';
  AxisPointerModel.defaultOption = {
    // 'auto' means that show when triggered by tooltip or handle.
    show: 'auto',
    // zlevel: 0,
    z: 50,
    type: 'line',
    // axispointer triggered by tootip determine snap automatically,
    // see `modelHelper`.
    snap: false,
    triggerTooltip: true,
    value: null,
    status: null,
    link: [],
    // Do not set 'auto' here, otherwise global animation: false
    // will not effect at this axispointer.
    animation: null,
    animationDurationUpdate: 200,
    lineStyle: {
      color: '#B9BEC9',
      width: 1,
      type: 'dashed'
    },
    shadowStyle: {
      color: 'rgba(210,219,238,0.2)'
    },
    label: {
      show: true,
      formatter: null,
      precision: 'auto',
      margin: 3,
      color: '#fff',
      padding: [5, 7, 5, 7],
      backgroundColor: 'auto',
      borderColor: null,
      borderWidth: 0,
      borderRadius: 3
    },
    handle: {
      show: false,
      // eslint-disable-next-line
      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
      size: 45,
      // handle margin is from symbol center to axis, which is stable when circular move.
      margin: 50,
      // color: '#1b8bbd'
      // color: '#2f4554'
      color: '#333',
      shadowBlur: 3,
      shadowColor: '#aaa',
      shadowOffsetX: 0,
      shadowOffsetY: 2,
      // For mobile performance
      throttle: 40
    }
  };
  return AxisPointerModel;
}(ComponentModel);

var inner$c = makeInner();
var each$7 = each;
/**
 * @param {string} key
 * @param {module:echarts/ExtensionAPI} api
 * @param {Function} handler
 *      param: {string} currTrigger
 *      param: {Array.<number>} point
 */

function register(key, api, handler) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  inner$c(zr).records || (inner$c(zr).records = {});
  initGlobalListeners(zr, api);
  var record = inner$c(zr).records[key] || (inner$c(zr).records[key] = {});
  record.handler = handler;
}

function initGlobalListeners(zr, api) {
  if (inner$c(zr).initialized) {
    return;
  }

  inner$c(zr).initialized = true;
  useHandler('click', curry(doEnter, 'click'));
  useHandler('mousemove', curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);

  useHandler('globalout', onLeave);

  function useHandler(eventType, cb) {
    zr.on(eventType, function (e) {
      var dis = makeDispatchAction(api);
      each$7(inner$c(zr).records, function (record) {
        record && cb(record, e, dis.dispatchAction);
      });
      dispatchTooltipFinally(dis.pendings, api);
    });
  }
}

function dispatchTooltipFinally(pendings, api) {
  var showLen = pendings.showTip.length;
  var hideLen = pendings.hideTip.length;
  var actuallyPayload;

  if (showLen) {
    actuallyPayload = pendings.showTip[showLen - 1];
  } else if (hideLen) {
    actuallyPayload = pendings.hideTip[hideLen - 1];
  }

  if (actuallyPayload) {
    actuallyPayload.dispatchAction = null;
    api.dispatchAction(actuallyPayload);
  }
}

function onLeave(record, e, dispatchAction) {
  record.handler('leave', null, dispatchAction);
}

function doEnter(currTrigger, record, e, dispatchAction) {
  record.handler(currTrigger, e, dispatchAction);
}

function makeDispatchAction(api) {
  var pendings = {
    showTip: [],
    hideTip: []
  }; // FIXME
  // better approach?
  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
  // So we have to add "final stage" to merge those dispatched actions.

  var dispatchAction = function (payload) {
    var pendingList = pendings[payload.type];

    if (pendingList) {
      pendingList.push(payload);
    } else {
      payload.dispatchAction = dispatchAction;
      api.dispatchAction(payload);
    }
  };

  return {
    dispatchAction: dispatchAction,
    pendings: pendings
  };
}

function unregister(key, api) {
  if (env.node) {
    return;
  }

  var zr = api.getZr();
  var record = (inner$c(zr).records || {})[key];

  if (record) {
    inner$c(zr).records[key] = null;
  }
}

var AxisPointerView =
/** @class */
function (_super) {
  __extends$1(AxisPointerView, _super);

  function AxisPointerView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AxisPointerView.type;
    return _this;
  }

  AxisPointerView.prototype.render = function (globalAxisPointerModel, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
    // AxisPointerView to be independent to Tooltip.

    register('axisPointer', api, function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
        dispatchAction({
          type: 'updateAxisPointer',
          currTrigger: currTrigger,
          x: e && e.offsetX,
          y: e && e.offsetY
        });
      }
    });
  };

  AxisPointerView.prototype.remove = function (ecModel, api) {
    unregister('axisPointer', api);
  };

  AxisPointerView.prototype.dispose = function (ecModel, api) {
    unregister('axisPointer', api);
  };

  AxisPointerView.type = 'axisPointer';
  return AxisPointerView;
}(ComponentView);

/**
 * @param finder contains {seriesIndex, dataIndex, dataIndexInside}
 * @param ecModel
 * @return  {point: [x, y], el: ...} point Will not be null.
 */

function findPointFromSeries(finder, ecModel) {
  var point = [];
  var seriesIndex = finder.seriesIndex;
  var seriesModel;

  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
    return {
      point: []
    };
  }

  var data = seriesModel.getData();
  var dataIndex = queryDataIndex(data, finder);

  if (dataIndex == null || dataIndex < 0 || isArray$1(dataIndex)) {
    return {
      point: []
    };
  }

  var el = data.getItemGraphicEl(dataIndex);
  var coordSys = seriesModel.coordinateSystem;

  if (seriesModel.getTooltipPosition) {
    point = seriesModel.getTooltipPosition(dataIndex) || [];
  } else if (coordSys && coordSys.dataToPoint) {
    if (finder.isStacked) {
      var baseAxis = coordSys.getBaseAxis();
      var valueAxis = coordSys.getOtherAxis(baseAxis);
      var valueAxisDim = valueAxis.dim;
      var baseAxisDim = baseAxis.dim;
      var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
      var baseDim = data.mapDimension(baseAxisDim);
      var stackedData = [];
      stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
      stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
      point = coordSys.dataToPoint(stackedData) || [];
    } else {
      point = coordSys.dataToPoint(data.getValues(map(coordSys.dimensions, function (dim) {
        return data.mapDimension(dim);
      }), dataIndex)) || [];
    }
  } else if (el) {
    // Use graphic bounding rect
    var rect = el.getBoundingRect().clone();
    rect.applyTransform(el.transform);
    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
  }

  return {
    point: point,
    el: el
  };
}

var inner$d = makeInner();
/**
 * Basic logic: check all axis, if they do not demand show/highlight,
 * then hide/downplay them.
 *
 * @return content of event obj for echarts.connect.
 */

function axisTrigger(payload, ecModel, api) {
  var currTrigger = payload.currTrigger;
  var point = [payload.x, payload.y];
  var finder = payload;
  var dispatchAction = payload.dispatchAction || bind(api.dispatchAction, api);
  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
  // See #6121. But we are not able to reproduce it yet.

  if (!coordSysAxesInfo) {
    return;
  }

  if (illegalPoint(point)) {
    // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = findPointFromSeries({
      seriesIndex: finder.seriesIndex,
      // Do not use dataIndexInside from other ec instance.
      // FIXME: auto detect it?
      dataIndex: finder.dataIndex
    }, ecModel).point;
  }

  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
  // and dataIndex.

  var inputAxesInfo = finder.axesInfo;
  var axesInfo = coordSysAxesInfo.axesInfo;
  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
  var outputPayload = {};
  var showValueMap = {};
  var dataByCoordSys = {
    list: [],
    map: {}
  };
  var updaters = {
    showPointer: curry(showPointer, showValueMap),
    showTooltip: curry(showTooltip, dataByCoordSys)
  }; // Process for triggered axes.

  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
    // If a point given, it must be contained by the coordinate system.
    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
      var axis = axisInfo.axis;
      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.

      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
        var val = inputAxisInfo && inputAxisInfo.value;

        if (val == null && !isIllegalPoint) {
          val = axis.pointToData(point);
        }

        val != null && processOnAxis(axisInfo, val, updaters, false, outputPayload);
      }
    });
  }); // Process for linked axes.

  var linkTriggers = {};
  each(axesInfo, function (tarAxisInfo, tarKey) {
    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.

    if (linkGroup && !showValueMap[tarKey]) {
      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.

        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
          var val = srcValItem.value;
          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
          linkTriggers[tarAxisInfo.key] = val;
        }
      });
    }
  });
  each(linkTriggers, function (val, tarKey) {
    processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
  });
  updateModelActually(showValueMap, axesInfo, outputPayload);
  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
  dispatchHighDownActually(axesInfo, dispatchAction, api);
  return outputPayload;
}

function processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
  var axis = axisInfo.axis;

  if (axis.scale.isBlank() || !axis.containData(newValue)) {
    return;
  }

  if (!axisInfo.involveSeries) {
    updaters.showPointer(axisInfo, newValue);
    return;
  } // Heavy calculation. So put it after axis.containData checking.


  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
  var payloadBatch = payloadInfo.payloadBatch;
  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
  // By default use the first involved series data as a sample to connect.

  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
    extend(outputFinder, payloadBatch[0]);
  } // If no linkSource input, this process is for collecting link
  // target, where snap should not be accepted.


  if (!noSnap && axisInfo.snap) {
    if (axis.containData(snapToValue) && snapToValue != null) {
      newValue = snapToValue;
    }
  }

  updaters.showPointer(axisInfo, newValue, payloadBatch); // Tooltip should always be snapToValue, otherwise there will be
  // incorrect "axis value ~ series value" mapping displayed in tooltip.

  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}

function buildPayloadsBySeries(value, axisInfo) {
  var axis = axisInfo.axis;
  var dim = axis.dim;
  var snapToValue = value;
  var payloadBatch = [];
  var minDist = Number.MAX_VALUE;
  var minDiff = -1;
  each(axisInfo.seriesModels, function (series, idx) {
    var dataDim = series.getData().mapDimensionsAll(dim);
    var seriesNestestValue;
    var dataIndices;

    if (series.getAxisTooltipData) {
      var result = series.getAxisTooltipData(dataDim, value, axis);
      dataIndices = result.dataIndices;
      seriesNestestValue = result.nestestValue;
    } else {
      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
      // when data length is not same.
      // false,
      axis.type === 'category' ? 0.5 : null);

      if (!dataIndices.length) {
        return;
      }

      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
    }

    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
      return;
    }

    var diff = value - seriesNestestValue;
    var dist = Math.abs(diff); // Consider category case

    if (dist <= minDist) {
      if (dist < minDist || diff >= 0 && minDiff < 0) {
        minDist = dist;
        minDiff = diff;
        snapToValue = seriesNestestValue;
        payloadBatch.length = 0;
      }

      each(dataIndices, function (dataIndex) {
        payloadBatch.push({
          seriesIndex: series.seriesIndex,
          dataIndexInside: dataIndex,
          dataIndex: series.getData().getRawIndex(dataIndex)
        });
      });
    }
  });
  return {
    payloadBatch: payloadBatch,
    snapToValue: snapToValue
  };
}

function showPointer(showValueMap, axisInfo, value, payloadBatch) {
  showValueMap[axisInfo.key] = {
    value: value,
    payloadBatch: payloadBatch
  };
}

function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
  var payloadBatch = payloadInfo.payloadBatch;
  var axis = axisInfo.axis;
  var axisModel = axis.model;
  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
  // whose length will be used to judge whether dispatch action.

  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
    return;
  }

  var coordSysModel = axisInfo.coordSys.model;
  var coordSysKey = makeKey(coordSysModel);
  var coordSysItem = dataByCoordSys.map[coordSysKey];

  if (!coordSysItem) {
    coordSysItem = dataByCoordSys.map[coordSysKey] = {
      coordSysId: coordSysModel.id,
      coordSysIndex: coordSysModel.componentIndex,
      coordSysType: coordSysModel.type,
      coordSysMainType: coordSysModel.mainType,
      dataByAxis: []
    };
    dataByCoordSys.list.push(coordSysItem);
  }

  coordSysItem.dataByAxis.push({
    axisDim: axis.dim,
    axisIndex: axisModel.componentIndex,
    axisType: axisModel.type,
    axisId: axisModel.id,
    value: value,
    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
    // depends that all models have been updated. So it should not be performed
    // here. Considering axisPointerModel used here is volatile, which is hard
    // to be retrieve in TooltipView, we prepare parameters here.
    valueLabelOpt: {
      precision: axisPointerModel.get(['label', 'precision']),
      formatter: axisPointerModel.get(['label', 'formatter'])
    },
    seriesDataIndices: payloadBatch.slice()
  });
}

function updateModelActually(showValueMap, axesInfo, outputPayload) {
  var outputAxesInfo = outputPayload.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    var valItem = showValueMap[key];

    if (valItem) {
      !axisInfo.useHandle && (option.status = 'show');
      option.value = valItem.value; // For label formatter param and highlight.

      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
    } // When always show (e.g., handle used), remain
    // original value and status.
    else {
        // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
      } // If status is 'hide', should be no info in payload.


    option.status === 'show' && outputAxesInfo.push({
      axisDim: axisInfo.axis.dim,
      axisIndex: axisInfo.axis.model.componentIndex,
      value: option.value
    });
  });
}

function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
  // Basic logic: If no showTip required, hideTip will be dispatched.
  if (illegalPoint(point) || !dataByCoordSys.list.length) {
    dispatchAction({
      type: 'hideTip'
    });
    return;
  } // In most case only one axis (or event one series is used). It is
  // convinient to fetch payload.seriesIndex and payload.dataIndex
  // dirtectly. So put the first seriesIndex and dataIndex of the first
  // axis on the payload.


  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
  dispatchAction({
    type: 'showTip',
    escapeConnect: true,
    x: point[0],
    y: point[1],
    tooltipOption: payload.tooltipOption,
    position: payload.position,
    dataIndexInside: sampleItem.dataIndexInside,
    dataIndex: sampleItem.dataIndex,
    seriesIndex: sampleItem.seriesIndex,
    dataByCoordSys: dataByCoordSys.list
  });
}

function dispatchHighDownActually(axesInfo, dispatchAction, api) {
  // FIXME
  // highlight status modification shoule be a stage of main process?
  // (Consider confilct (e.g., legend and axisPointer) and setOption)
  var zr = api.getZr();
  var highDownKey = 'axisPointerLastHighlights';
  var lastHighlights = inner$d(zr)[highDownKey] || {};
  var newHighlights = inner$d(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
  // Build hash map and remove duplicate incidentally.

  each(axesInfo, function (axisInfo, key) {
    var option = axisInfo.axisPointerModel.option;
    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
      newHighlights[key] = batchItem;
    });
  }); // Diff.

  var toHighlight = [];
  var toDownplay = [];
  each(lastHighlights, function (batchItem, key) {
    !newHighlights[key] && toDownplay.push(batchItem);
  });
  each(newHighlights, function (batchItem, key) {
    !lastHighlights[key] && toHighlight.push(batchItem);
  });
  toDownplay.length && api.dispatchAction({
    type: 'downplay',
    escapeConnect: true,
    // Not blur others when highlight in axisPointer.
    notBlur: true,
    batch: toDownplay
  });
  toHighlight.length && api.dispatchAction({
    type: 'highlight',
    escapeConnect: true,
    // Not blur others when highlight in axisPointer.
    notBlur: true,
    batch: toHighlight
  });
}

function findInputAxisInfo(inputAxesInfo, axisInfo) {
  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
    var inputAxisInfo = inputAxesInfo[i];

    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
      return inputAxisInfo;
    }
  }
}

function makeMapperParam(axisInfo) {
  var axisModel = axisInfo.axis.model;
  var item = {};
  var dim = item.axisDim = axisInfo.axis.dim;
  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
  item.axisName = item[dim + 'AxisName'] = axisModel.name;
  item.axisId = item[dim + 'AxisId'] = axisModel.id;
  return item;
}

function illegalPoint(point) {
  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}

function install$s(registers) {
  // CartesianAxisPointer is not supposed to be required here. But consider
  // echarts.simple.js and online build tooltip, which only require gridSimple,
  // CartesianAxisPointer should be able to required somewhere.
  AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
  registers.registerComponentModel(AxisPointerModel);
  registers.registerComponentView(AxisPointerView);
  registers.registerPreprocessor(function (option) {
    // Always has a global axisPointerModel for default setting.
    if (option) {
      (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
      var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
      // is not set, remain null/undefined, otherwise it will
      // override existent link setting.

      if (link && !isArray$1(link)) {
        option.axisPointer.link = [link];
      }
    }
  }); // This process should proformed after coordinate systems created
  // and series data processed. So put it on statistic processing stage.

  registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
    // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
    // allAxesInfo should be updated when setOption performed.
    ecModel.getComponent('axisPointer').coordSysAxesInfo = collect(ecModel, api);
  }); // Broadcast to all views.

  registers.registerAction({
    type: 'updateAxisPointer',
    event: 'updateAxisPointer',
    update: ':updateAxisPointer'
  }, axisTrigger);
}

function install$t(registers) {
  use(install$5);
  use(install$s);
}

var PolarAxisPointer =
/** @class */
function (_super) {
  __extends$1(PolarAxisPointer, _super);

  function PolarAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  PolarAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;

    if (axis.dim === 'angle') {
      this.animationThreshold = Math.PI / 18;
    }

    var polar = axis.polar;
    var otherAxis = polar.getOtherAxis(axis);
    var otherExtent = otherAxis.getExtent();
    var coordValue = axis.dataToCoord(value);
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder$1[axisPointerType](axis, polar, coordValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var labelMargin = axisPointerModel.get(['label', 'margin']);
    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
    buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
  };

  return PolarAxisPointer;
}(BaseAxisPointer);

function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
  var axis = axisModel.axis;
  var coord = axis.dataToCoord(value);
  var axisAngle = polar.getAngleAxis().getExtent()[0];
  axisAngle = axisAngle / 180 * Math.PI;
  var radiusExtent = polar.getRadiusAxis().getExtent();
  var position;
  var align;
  var verticalAlign;

  if (axis.dim === 'radius') {
    var transform = create$1();
    rotate(transform, transform, axisAngle);
    translate(transform, transform, [polar.cx, polar.cy]);
    position = applyTransform$1([coord, -labelMargin], transform);
    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0; // @ts-ignore

    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
    align = labelLayout.textAlign;
    verticalAlign = labelLayout.textVerticalAlign;
  } else {
    // angle axis
    var r = radiusExtent[1];
    position = polar.coordToPoint([r + labelMargin, coord]);
    var cx = polar.cx;
    var cy = polar.cy;
    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
  }

  return {
    position: position,
    align: align,
    verticalAlign: verticalAlign
  };
}

var pointerShapeBuilder$1 = {
  line: function (axis, polar, coordValue, otherExtent) {
    return axis.dim === 'angle' ? {
      type: 'Line',
      shape: makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
    } : {
      type: 'Circle',
      shape: {
        cx: polar.cx,
        cy: polar.cy,
        r: coordValue
      }
    };
  },
  shadow: function (axis, polar, coordValue, otherExtent) {
    var bandWidth = Math.max(1, axis.getBandWidth());
    var radian = Math.PI / 180;
    return axis.dim === 'angle' ? {
      type: 'Sector',
      shape: makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
    } : {
      type: 'Sector',
      shape: makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
    };
  }
};

var PolarModel =
/** @class */
function (_super) {
  __extends$1(PolarModel, _super);

  function PolarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PolarModel.type;
    return _this;
  }

  PolarModel.prototype.findAxisModel = function (axisType) {
    var foundAxisModel;
    var ecModel = this.ecModel;
    ecModel.eachComponent(axisType, function (axisModel) {
      if (axisModel.getCoordSysModel() === this) {
        foundAxisModel = axisModel;
      }
    }, this);
    return foundAxisModel;
  };

  PolarModel.type = 'polar';
  PolarModel.dependencies = ['radiusAxis', 'angleAxis'];
  PolarModel.defaultOption = {
    // zlevel: 0,
    z: 0,
    center: ['50%', '50%'],
    radius: '80%'
  };
  return PolarModel;
}(ComponentModel);

var PolarAxisModel =
/** @class */
function (_super) {
  __extends$1(PolarAxisModel, _super);

  function PolarAxisModel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PolarAxisModel.prototype.getCoordSysModel = function () {
    return this.getReferringComponents('polar', SINGLE_REFERRING).models[0];
  };

  PolarAxisModel.type = 'polarAxis';
  return PolarAxisModel;
}(ComponentModel);

mixin(PolarAxisModel, AxisModelCommonMixin);

var AngleAxisModel =
/** @class */
function (_super) {
  __extends$1(AngleAxisModel, _super);

  function AngleAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AngleAxisModel.type;
    return _this;
  }

  AngleAxisModel.type = 'angleAxis';
  return AngleAxisModel;
}(PolarAxisModel);

var RadiusAxisModel =
/** @class */
function (_super) {
  __extends$1(RadiusAxisModel, _super);

  function RadiusAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadiusAxisModel.type;
    return _this;
  }

  RadiusAxisModel.type = 'radiusAxis';
  return RadiusAxisModel;
}(PolarAxisModel);

var RadiusAxis =
/** @class */
function (_super) {
  __extends$1(RadiusAxis, _super);

  function RadiusAxis(scale, radiusExtent) {
    return _super.call(this, 'radius', scale, radiusExtent) || this;
  }

  RadiusAxis.prototype.pointToData = function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  };

  return RadiusAxis;
}(Axis);

RadiusAxis.prototype.dataToRadius = Axis.prototype.dataToCoord;
RadiusAxis.prototype.radiusToData = Axis.prototype.coordToData;

var inner$e = makeInner();

var AngleAxis =
/** @class */
function (_super) {
  __extends$1(AngleAxis, _super);

  function AngleAxis(scale, angleExtent) {
    return _super.call(this, 'angle', scale, angleExtent || [0, 360]) || this;
  }

  AngleAxis.prototype.pointToData = function (point, clamp) {
    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
  };
  /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */


  AngleAxis.prototype.calculateCategoryInterval = function () {
    var axis = this;
    var labelModel = axis.getLabelModel();
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.

    var tickCount = ordinalScale.count();

    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
      return 0;
    }

    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
    // and each distance from axis line yet.

    var rect = getBoundingRect(tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
    var maxH = Math.max(rect.height, 7);
    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.

    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(dh));
    var cache = inner$e(axis.model);
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.

    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
    // point is not the same when zooming in or zooming out.
    && lastAutoInterval > interval) {
      interval = lastAutoInterval;
    } // Only update cache if cache not used, otherwise the
    // changing of interval is too insensitive.
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
      }

    return interval;
  };

  return AngleAxis;
}(Axis);

AngleAxis.prototype.dataToAngle = Axis.prototype.dataToCoord;
AngleAxis.prototype.angleToData = Axis.prototype.coordToData;

var polarDimensions = ['radius', 'angle'];

var Polar =
/** @class */
function () {
  function Polar(name) {
    this.dimensions = polarDimensions;
    this.type = 'polar';
    /**
     * x of polar center
     */

    this.cx = 0;
    /**
     * y of polar center
     */

    this.cy = 0;
    this._radiusAxis = new RadiusAxis();
    this._angleAxis = new AngleAxis();
    this.axisPointerEnabled = true;
    this.name = name || '';
    this._radiusAxis.polar = this._angleAxis.polar = this;
  }
  /**
   * If contain coord
   */


  Polar.prototype.containPoint = function (point) {
    var coord = this.pointToCoord(point);
    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
  };
  /**
   * If contain data
   */


  Polar.prototype.containData = function (data) {
    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
  };

  Polar.prototype.getAxis = function (dim) {
    var key = '_' + dim + 'Axis';
    return this[key];
  };

  Polar.prototype.getAxes = function () {
    return [this._radiusAxis, this._angleAxis];
  };
  /**
   * Get axes by type of scale
   */


  Polar.prototype.getAxesByScale = function (scaleType) {
    var axes = [];
    var angleAxis = this._angleAxis;
    var radiusAxis = this._radiusAxis;
    angleAxis.scale.type === scaleType && axes.push(angleAxis);
    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
    return axes;
  };

  Polar.prototype.getAngleAxis = function () {
    return this._angleAxis;
  };

  Polar.prototype.getRadiusAxis = function () {
    return this._radiusAxis;
  };

  Polar.prototype.getOtherAxis = function (axis) {
    var angleAxis = this._angleAxis;
    return axis === angleAxis ? this._radiusAxis : angleAxis;
  };
  /**
   * Base axis will be used on stacking.
   *
   */


  Polar.prototype.getBaseAxis = function () {
    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
  };

  Polar.prototype.getTooltipAxes = function (dim) {
    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
    return {
      baseAxes: [baseAxis],
      otherAxes: [this.getOtherAxis(baseAxis)]
    };
  };
  /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */


  Polar.prototype.dataToPoint = function (data, clamp) {
    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
  };
  /**
   * Convert a (x, y) point to data
   */


  Polar.prototype.pointToData = function (point, clamp) {
    var coord = this.pointToCoord(point);
    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
  };
  /**
   * Convert a (x, y) point to (radius, angle) coord
   */


  Polar.prototype.pointToCoord = function (point) {
    var dx = point[0] - this.cx;
    var dy = point[1] - this.cy;
    var angleAxis = this.getAngleAxis();
    var extent = angleAxis.getExtent();
    var minAngle = Math.min(extent[0], extent[1]);
    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
    // FIXME

    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
    var radius = Math.sqrt(dx * dx + dy * dy);
    dx /= radius;
    dy /= radius;
    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent

    var dir = radian < minAngle ? 1 : -1;

    while (radian < minAngle || radian > maxAngle) {
      radian += dir * 360;
    }

    return [radius, radian];
  };
  /**
   * Convert a (radius, angle) coord to (x, y) point
   */


  Polar.prototype.coordToPoint = function (coord) {
    var radius = coord[0];
    var radian = coord[1] / 180 * Math.PI;
    var x = Math.cos(radian) * radius + this.cx; // Inverse the y

    var y = -Math.sin(radian) * radius + this.cy;
    return [x, y];
  };
  /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */


  Polar.prototype.getArea = function () {
    var angleAxis = this.getAngleAxis();
    var radiusAxis = this.getRadiusAxis();
    var radiusExtent = radiusAxis.getExtent().slice();
    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
    var angleExtent = angleAxis.getExtent();
    var RADIAN = Math.PI / 180;
    return {
      cx: this.cx,
      cy: this.cy,
      r0: radiusExtent[0],
      r: radiusExtent[1],
      startAngle: -angleExtent[0] * RADIAN,
      endAngle: -angleExtent[1] * RADIAN,
      clockwise: angleAxis.inverse,
      contain: function (x, y) {
        // It's a ring shape.
        // Start angle and end angle don't matter
        var dx = x - this.cx;
        var dy = y - this.cy; // minus a tiny value 1e-4 to avoid being clipped unexpectedly

        var d2 = dx * dx + dy * dy - 1e-4;
        var r = this.r;
        var r0 = this.r0;
        return d2 <= r * r && d2 >= r0 * r0;
      }
    };
  };

  Polar.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys$2(finder);
    return coordSys === this ? this.dataToPoint(value) : null;
  };

  Polar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys$2(finder);
    return coordSys === this ? this.pointToData(pixel) : null;
  };

  return Polar;
}();

function getCoordSys$2(finder) {
  var seriesModel = finder.seriesModel;
  var polarModel = finder.polarModel;
  return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}

/**
 * Resize method bound to the polar
 */

function resizePolar(polar, polarModel, api) {
  var center = polarModel.get('center');
  var width = api.getWidth();
  var height = api.getHeight();
  polar.cx = parsePercent$1(center[0], width);
  polar.cy = parsePercent$1(center[1], height);
  var radiusAxis = polar.getRadiusAxis();
  var size = Math.min(width, height) / 2;
  var radius = polarModel.get('radius');

  if (radius == null) {
    radius = [0, '100%'];
  } else if (!isArray$1(radius)) {
    // r0 = 0
    radius = [0, radius];
  }

  var parsedRadius = [parsePercent$1(radius[0], size), parsePercent$1(radius[1], size)];
  radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */


function updatePolarScale(ecModel, api) {
  var polar = this;
  var angleAxis = polar.getAngleAxis();
  var radiusAxis = polar.getRadiusAxis(); // Reset scale

  angleAxis.scale.setExtent(Infinity, -Infinity);
  radiusAxis.scale.setExtent(Infinity, -Infinity);
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.coordinateSystem === polar) {
      var data_1 = seriesModel.getData();
      each(getDataDimensionsOnAxis(data_1, 'radius'), function (dim) {
        radiusAxis.scale.unionExtentFromData(data_1, dim);
      });
      each(getDataDimensionsOnAxis(data_1, 'angle'), function (dim) {
        angleAxis.scale.unionExtentFromData(data_1, dim);
      });
    }
  });
  niceScaleExtent(angleAxis.scale, angleAxis.model);
  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis

  if (angleAxis.type === 'category' && !angleAxis.onBand) {
    var extent = angleAxis.getExtent();
    var diff = 360 / angleAxis.scale.count();
    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
    angleAxis.setExtent(extent[0], extent[1]);
  }
}

function isAngleAxisModel(axisModel) {
  return axisModel.mainType === 'angleAxis';
}
/**
 * Set common axis properties
 */


function setAxis(axis, axisModel) {
  axis.type = axisModel.get('type');
  axis.scale = createScaleByModel(axisModel);
  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
  axis.inverse = axisModel.get('inverse');

  if (isAngleAxisModel(axisModel)) {
    axis.inverse = axis.inverse !== axisModel.get('clockwise');
    var startAngle = axisModel.get('startAngle');
    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
  } // Inject axis instance


  axisModel.axis = axis;
  axis.model = axisModel;
}

var polarCreator = {
  dimensions: polarDimensions,
  create: function (ecModel, api) {
    var polarList = [];
    ecModel.eachComponent('polar', function (polarModel, idx) {
      var polar = new Polar(idx + ''); // Inject resize and update method

      polar.update = updatePolarScale;
      var radiusAxis = polar.getRadiusAxis();
      var angleAxis = polar.getAngleAxis();
      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
      var angleAxisModel = polarModel.findAxisModel('angleAxis');
      setAxis(radiusAxis, radiusAxisModel);
      setAxis(angleAxis, angleAxisModel);
      resizePolar(polar, polarModel, api);
      polarList.push(polar);
      polarModel.coordinateSystem = polar;
      polar.model = polarModel;
    }); // Inject coordinateSystem to series

    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.get('coordinateSystem') === 'polar') {
        var polarModel = seriesModel.getReferringComponents('polar', SINGLE_REFERRING).models[0];

        if (process.env.NODE_ENV !== 'production') {
          if (!polarModel) {
            throw new Error('Polar "' + retrieve(seriesModel.get('polarIndex'), seriesModel.get('polarId'), 0) + '" not found');
          }
        }

        seriesModel.coordinateSystem = polarModel.coordinateSystem;
      }
    });
    return polarList;
  }
};

var elementList$1 = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];

function getAxisLineShape(polar, rExtent, angle) {
  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
  var start = polar.coordToPoint([rExtent[0], angle]);
  var end = polar.coordToPoint([rExtent[1], angle]);
  return {
    x1: start[0],
    y1: start[1],
    x2: end[0],
    y2: end[1]
  };
}

function getRadiusIdx(polar) {
  var radiusAxis = polar.getRadiusAxis();
  return radiusAxis.inverse ? 0 : 1;
} // Remove the last tick which will overlap the first tick


function fixAngleOverlap(list) {
  var firstItem = list[0];
  var lastItem = list[list.length - 1];

  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
    list.pop();
  }
}

var AngleAxisView =
/** @class */
function (_super) {
  __extends$1(AngleAxisView, _super);

  function AngleAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = AngleAxisView.type;
    _this.axisPointerClass = 'PolarAxisPointer';
    return _this;
  }

  AngleAxisView.prototype.render = function (angleAxisModel, ecModel) {
    this.group.removeAll();

    if (!angleAxisModel.get('show')) {
      return;
    }

    var angleAxis = angleAxisModel.axis;
    var polar = angleAxis.polar;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var ticksAngles = angleAxis.getTicksCoords();
    var minorTickAngles = angleAxis.getMinorTicksCoords();
    var labels = map(angleAxis.getViewLabels(), function (labelItem) {
      labelItem = clone(labelItem);
      var scale = angleAxis.scale;
      var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
      labelItem.coord = angleAxis.dataToCoord(tickValue);
      return labelItem;
    });
    fixAngleOverlap(labels);
    fixAngleOverlap(ticksAngles);
    each(elementList$1, function (name) {
      if (angleAxisModel.get([name, 'show']) && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
        angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
      }
    }, this);
  };

  AngleAxisView.type = 'angleAxis';
  return AngleAxisView;
}(AxisView);

var angelAxisElementsBuilders = {
  axisLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var lineStyleModel = angleAxisModel.getModel(['axisLine', 'lineStyle']); // extent id of the axis radius (r0 and r)

    var rId = getRadiusIdx(polar);
    var r0Id = rId ? 0 : 1;
    var shape;

    if (radiusExtent[r0Id] === 0) {
      shape = new Circle$1({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    } else {
      shape = new Ring({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r: radiusExtent[rId],
          r0: radiusExtent[r0Id]
        },
        style: lineStyleModel.getLineStyle(),
        z2: 1,
        silent: true
      });
    }

    shape.style.fill = null;
    group.add(shape);
  },
  axisTick: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var tickModel = angleAxisModel.getModel('axisTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = map(ticksAngles, function (tickAngleItem) {
      return new Line({
        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
      });
    });
    group.add(mergePath$1(lines, {
      style: defaults(tickModel.getModel('lineStyle').getLineStyle(), {
        stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
      })
    }));
  },
  minorTick: function (group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var tickModel = angleAxisModel.getModel('axisTick');
    var minorTickModel = angleAxisModel.getModel('minorTick');
    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
    var radius = radiusExtent[getRadiusIdx(polar)];
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new Line({
          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
        }));
      }
    }

    group.add(mergePath$1(lines, {
      style: defaults(minorTickModel.getModel('lineStyle').getLineStyle(), defaults(tickModel.getLineStyle(), {
        stroke: angleAxisModel.get(['axisLine', 'lineStyle', 'color'])
      }))
    }));
  },
  axisLabel: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
    var rawCategoryData = angleAxisModel.getCategories(true);
    var commonLabelModel = angleAxisModel.getModel('axisLabel');
    var labelMargin = commonLabelModel.get('margin');
    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping

    each(labels, function (labelItem, idx) {
      var labelModel = commonLabelModel;
      var tickValue = labelItem.tickValue;
      var r = radiusExtent[getRadiusIdx(polar)];
      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
      var cx = polar.cx;
      var cy = polar.cy;
      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';

      if (rawCategoryData && rawCategoryData[tickValue]) {
        var rawCategoryItem = rawCategoryData[tickValue];

        if (isObject$2(rawCategoryItem) && rawCategoryItem.textStyle) {
          labelModel = new Model(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
        }
      }

      var textEl = new ZRText({
        silent: AxisBuilder.isLabelSilent(angleAxisModel),
        style: createTextStyle(labelModel, {
          x: p[0],
          y: p[1],
          fill: labelModel.getTextColor() || angleAxisModel.get(['axisLine', 'lineStyle', 'color']),
          text: labelItem.formattedLabel,
          align: labelTextAlign,
          verticalAlign: labelTextVerticalAlign
        })
      });
      group.add(textEl); // Pack data for mouse event

      if (triggerEvent) {
        var eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
        eventData.targetType = 'axisLabel';
        eventData.value = labelItem.rawLabel;
        getECData(textEl).eventData = eventData;
      }
    }, this);
  },
  splitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    var splitLineModel = angleAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksAngles.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new Line({
        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      group.add(mergePath$1(splitLines[i], {
        style: defaults({
          stroke: lineColors[i % lineColors.length]
        }, lineStyleModel.getLineStyle()),
        silent: true,
        z: angleAxisModel.get('z')
      }));
    }
  },
  minorSplitLine: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!minorTickAngles.length) {
      return;
    }

    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTickAngles.length; i++) {
      for (var k = 0; k < minorTickAngles[i].length; k++) {
        lines.push(new Line({
          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
      }
    }

    group.add(mergePath$1(lines, {
      style: lineStyleModel.getLineStyle(),
      silent: true,
      z: angleAxisModel.get('z')
    }));
  },
  splitArea: function (group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
    if (!ticksAngles.length) {
      return;
    }

    var splitAreaModel = angleAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var RADIAN = Math.PI / 180;
    var prevAngle = -ticksAngles[0].coord * RADIAN;
    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
    var clockwise = angleAxisModel.get('clockwise');

    for (var i = 1, len = ticksAngles.length; i <= len; i++) {
      var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: r0,
          r: r1,
          startAngle: prevAngle,
          endAngle: -coord * RADIAN,
          clockwise: clockwise
        },
        silent: true
      }));
      prevAngle = -coord * RADIAN;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      group.add(mergePath$1(splitAreas[i], {
        style: defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
};

var axisBuilderAttrs$2 = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs$1 = ['splitLine', 'splitArea', 'minorSplitLine'];

var RadiusAxisView =
/** @class */
function (_super) {
  __extends$1(RadiusAxisView, _super);

  function RadiusAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = RadiusAxisView.type;
    _this.axisPointerClass = 'PolarAxisPointer';
    return _this;
  }

  RadiusAxisView.prototype.render = function (radiusAxisModel, ecModel) {
    this.group.removeAll();

    if (!radiusAxisModel.get('show')) {
      return;
    }

    var oldAxisGroup = this._axisGroup;
    var newAxisGroup = this._axisGroup = new Group$1();
    this.group.add(newAxisGroup);
    var radiusAxis = radiusAxisModel.axis;
    var polar = radiusAxis.polar;
    var angleAxis = polar.getAngleAxis();
    var ticksCoords = radiusAxis.getTicksCoords();
    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
    var axisAngle = angleAxis.getExtent()[0];
    var radiusExtent = radiusAxis.getExtent();
    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
    each(axisBuilderAttrs$2, axisBuilder.add, axisBuilder);
    newAxisGroup.add(axisBuilder.getGroup());
    groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
    each(selfBuilderAttrs$1, function (name) {
      if (radiusAxisModel.get([name, 'show']) && !radiusAxis.scale.isBlank()) {
        axisElementBuilders$1[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
      }
    }, this);
  };

  RadiusAxisView.type = 'radiusAxis';
  return RadiusAxisView;
}(AxisView);

var axisElementBuilders$1 = {
  splitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    var splitLineModel = radiusAxisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    var lineCount = 0;
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var splitLines = [];

    for (var i = 0; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(new Circle$1({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          // ensure circle radius >= 0
          r: Math.max(ticksCoords[i].coord, 0)
        }
      }));
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitLines.length; i++) {
      group.add(mergePath$1(splitLines[i], {
        style: defaults({
          stroke: lineColors[i % lineColors.length],
          fill: null
        }, lineStyleModel.getLineStyle()),
        silent: true
      }));
    }
  },
  minorSplitLine: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
    if (!minorTicksCoords.length) {
      return;
    }

    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
    var lines = [];

    for (var i = 0; i < minorTicksCoords.length; i++) {
      for (var k = 0; k < minorTicksCoords[i].length; k++) {
        lines.push(new Circle$1({
          shape: {
            cx: polar.cx,
            cy: polar.cy,
            r: minorTicksCoords[i][k].coord
          }
        }));
      }
    }

    group.add(mergePath$1(lines, {
      style: defaults({
        fill: null
      }, lineStyleModel.getLineStyle()),
      silent: true
    }));
  },
  splitArea: function (group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
    if (!ticksCoords.length) {
      return;
    }

    var splitAreaModel = radiusAxisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var lineCount = 0;
    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
    var splitAreas = [];
    var prevRadius = ticksCoords[0].coord;

    for (var i = 1; i < ticksCoords.length; i++) {
      var colorIndex = lineCount++ % areaColors.length;
      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
      splitAreas[colorIndex].push(new Sector({
        shape: {
          cx: polar.cx,
          cy: polar.cy,
          r0: prevRadius,
          r: ticksCoords[i].coord,
          startAngle: 0,
          endAngle: Math.PI * 2
        },
        silent: true
      }));
      prevRadius = ticksCoords[i].coord;
    } // Simple optimization
    // Batching the lines if color are the same


    for (var i = 0; i < splitAreas.length; i++) {
      group.add(mergePath$1(splitAreas[i], {
        style: defaults({
          fill: areaColors[i % areaColors.length]
        }, areaStyleModel.getAreaStyle()),
        silent: true
      }));
    }
  }
};
/**
 * @inner
 */

function layoutAxis(polar, radiusAxisModel, axisAngle) {
  return {
    position: [polar.cx, polar.cy],
    rotation: axisAngle / 180 * Math.PI,
    labelDirection: -1,
    tickDirection: -1,
    nameDirection: 1,
    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
    // Over splitLine and splitArea
    z2: 1
  };
}

function getSeriesStackId$1(seriesModel) {
  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}

function getAxisKey$1(polar, axis) {
  return axis.dim + polar.model.componentIndex;
}

function barLayoutPolar(seriesType, ecModel, api) {
  var lastStackCoords = {};
  var barWidthAndOffset = calRadialBar(filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
  }));
  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
    // Check series coordinate, do layout for polar only
    if (seriesModel.coordinateSystem.type !== 'polar') {
      return;
    }

    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey$1(polar, baseAxis);
    var stackId = getSeriesStackId$1(seriesModel);
    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
    var columnOffset = columnLayoutInfo.offset;
    var columnWidth = columnLayoutInfo.width;
    var valueAxis = polar.getOtherAxis(baseAxis);
    var cx = seriesModel.coordinateSystem.cx;
    var cy = seriesModel.coordinateSystem.cy;
    var barMinHeight = seriesModel.get('barMinHeight') || 0;
    var barMinAngle = seriesModel.get('barMinAngle') || 0;
    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
    var valueDim = data.mapDimension(valueAxis.dim);
    var baseDim = data.mapDimension(baseAxis.dim);
    var stacked = isDimensionStacked(data, valueDim
    /* , baseDim */
    );
    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
    var valueAxisStart = valueAxis.dataToCoord(0);

    for (var idx = 0, len = data.count(); idx < len; idx++) {
      var value = data.get(valueDim, idx);
      var baseValue = data.get(baseDim, idx);
      var sign = value >= 0 ? 'p' : 'n';
      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
      // stackResultDimension directly.
      // Only ordinal axis can be stacked.

      if (stacked) {
        if (!lastStackCoords[stackId][baseValue]) {
          lastStackCoords[stackId][baseValue] = {
            p: valueAxisStart,
            n: valueAxisStart // Negative stack

          };
        } // Should also consider #4243


        baseCoord = lastStackCoords[stackId][baseValue][sign];
      }

      var r0 = void 0;
      var r = void 0;
      var startAngle = void 0;
      var endAngle = void 0; // radial sector

      if (valueAxis.dim === 'radius') {
        var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
        var angle = baseAxis.dataToCoord(baseValue);

        if (Math.abs(radiusSpan) < barMinHeight) {
          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
        }

        r0 = baseCoord;
        r = baseCoord + radiusSpan;
        startAngle = angle - columnOffset;
        endAngle = startAngle - columnWidth;
        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
      } // tangential sector
      else {
          var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
          var radius = baseAxis.dataToCoord(baseValue);

          if (Math.abs(angleSpan) < barMinAngle) {
            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
          }

          r0 = radius + columnOffset;
          r = r0 + columnWidth;
          startAngle = baseCoord;
          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
          // add a round to differentiate it from origin
          // let extent = angleAxis.getExtent();
          // let stackCoord = angle;
          // if (stackCoord === extent[0] && value > 0) {
          //     stackCoord = extent[1];
          // }
          // else if (stackCoord === extent[1] && value < 0) {
          //     stackCoord = extent[0];
          // }

          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
        }

      data.setItemLayout(idx, {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        // Consider that positive angle is anti-clockwise,
        // while positive radian of sector is clockwise
        startAngle: -startAngle * Math.PI / 180,
        endAngle: -endAngle * Math.PI / 180,

        /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */
        clockwise: startAngle >= endAngle
      });
    }
  });
}
/**
 * Calculate bar width and offset for radial bar charts
 */


function calRadialBar(barSeries) {
  // Columns info on each category axis. Key is polar name
  var columnsMap = {};
  each(barSeries, function (seriesModel, idx) {
    var data = seriesModel.getData();
    var polar = seriesModel.coordinateSystem;
    var baseAxis = polar.getBaseAxis();
    var axisKey = getAxisKey$1(polar, baseAxis);
    var axisExtent = baseAxis.getExtent();
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
    var columnsOnAxis = columnsMap[axisKey] || {
      bandWidth: bandWidth,
      remainedWidth: bandWidth,
      autoWidthCount: 0,
      categoryGap: '20%',
      gap: '30%',
      stacks: {}
    };
    var stacks = columnsOnAxis.stacks;
    columnsMap[axisKey] = columnsOnAxis;
    var stackId = getSeriesStackId$1(seriesModel);

    if (!stacks[stackId]) {
      columnsOnAxis.autoWidthCount++;
    }

    stacks[stackId] = stacks[stackId] || {
      width: 0,
      maxWidth: 0
    };
    var barWidth = parsePercent$1(seriesModel.get('barWidth'), bandWidth);
    var barMaxWidth = parsePercent$1(seriesModel.get('barMaxWidth'), bandWidth);
    var barGap = seriesModel.get('barGap');
    var barCategoryGap = seriesModel.get('barCategoryGap');

    if (barWidth && !stacks[stackId].width) {
      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
      stacks[stackId].width = barWidth;
      columnsOnAxis.remainedWidth -= barWidth;
    }

    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
    barGap != null && (columnsOnAxis.gap = barGap);
    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
  });
  var result = {};
  each(columnsMap, function (columnsOnAxis, coordSysName) {
    result[coordSysName] = {};
    var stacks = columnsOnAxis.stacks;
    var bandWidth = columnsOnAxis.bandWidth;
    var categoryGap = parsePercent$1(columnsOnAxis.categoryGap, bandWidth);
    var barGapPercent = parsePercent$1(columnsOnAxis.gap, 1);
    var remainedWidth = columnsOnAxis.remainedWidth;
    var autoWidthCount = columnsOnAxis.autoWidthCount;
    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth

    each(stacks, function (column, stack) {
      var maxWidth = column.maxWidth;

      if (maxWidth && maxWidth < autoWidth) {
        maxWidth = Math.min(maxWidth, remainedWidth);

        if (column.width) {
          maxWidth = Math.min(maxWidth, column.width);
        }

        remainedWidth -= maxWidth;
        column.width = maxWidth;
        autoWidthCount--;
      }
    }); // Recalculate width again

    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = Math.max(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    each(stacks, function (column, idx) {
      if (!column.width) {
        column.width = autoWidth;
      }

      lastColumn = column;
      widthSum += column.width * (1 + barGapPercent);
    });

    if (lastColumn) {
      widthSum -= lastColumn.width * barGapPercent;
    }

    var offset = -widthSum / 2;
    each(stacks, function (column, stackId) {
      result[coordSysName][stackId] = result[coordSysName][stackId] || {
        offset: offset,
        width: column.width
      };
      offset += column.width * (1 + barGapPercent);
    });
  });
  return result;
}

var angleAxisExtraOption = {
  startAngle: 90,
  clockwise: true,
  splitNumber: 12,
  axisLabel: {
    rotate: 0
  }
};
var radiusAxisExtraOption = {
  splitNumber: 5
};

var PolarView =
/** @class */
function (_super) {
  __extends$1(PolarView, _super);

  function PolarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PolarView.type;
    return _this;
  }

  PolarView.type = 'polar';
  return PolarView;
}(ComponentView);

function install$u(registers) {
  use(install$s);
  AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
  registers.registerCoordinateSystem('polar', polarCreator);
  registers.registerComponentModel(PolarModel);
  registers.registerComponentView(PolarView); // Model and view for angleAxis and radiusAxis

  axisModelCreator(registers, 'angle', AngleAxisModel, angleAxisExtraOption);
  axisModelCreator(registers, 'radius', RadiusAxisModel, radiusAxisExtraOption);
  registers.registerComponentView(AngleAxisView);
  registers.registerComponentView(RadiusAxisView);
  registers.registerLayout(curry(barLayoutPolar, 'bar'));
}

function layout$2(axisModel, opt) {
  opt = opt || {};
  var single = axisModel.coordinateSystem;
  var axis = axisModel.axis;
  var layout = {};
  var axisPosition = axis.position;
  var orient = axis.orient;
  var rect = single.getRect();
  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
  var positionMap = {
    horizontal: {
      top: rectBound[2],
      bottom: rectBound[3]
    },
    vertical: {
      left: rectBound[0],
      right: rectBound[1]
    }
  };
  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
  var r = {
    horizontal: 0,
    vertical: 1
  };
  layout.rotation = Math.PI / 2 * r[orient];
  var directionMap = {
    top: -1,
    bottom: 1,
    right: 1,
    left: -1
  };
  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];

  if (axisModel.get(['axisTick', 'inside'])) {
    layout.tickDirection = -layout.tickDirection;
  }

  if (retrieve(opt.labelInside, axisModel.get(['axisLabel', 'inside']))) {
    layout.labelDirection = -layout.labelDirection;
  }

  var labelRotation = opt.rotate;
  labelRotation == null && (labelRotation = axisModel.get(['axisLabel', 'rotate']));
  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
  layout.z2 = 1;
  return layout;
}

var axisBuilderAttrs$3 = ['axisLine', 'axisTickLabel', 'axisName'];
var selfBuilderAttrs$2 = ['splitArea', 'splitLine'];

var SingleAxisView =
/** @class */
function (_super) {
  __extends$1(SingleAxisView, _super);

  function SingleAxisView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleAxisView.type;
    _this.axisPointerClass = 'SingleAxisPointer';
    return _this;
  }

  SingleAxisView.prototype.render = function (axisModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();
    var oldAxisGroup = this._axisGroup;
    this._axisGroup = new Group$1();
    var layout = layout$2(axisModel);
    var axisBuilder = new AxisBuilder(axisModel, layout);
    each(axisBuilderAttrs$3, axisBuilder.add, axisBuilder);
    group.add(this._axisGroup);
    group.add(axisBuilder.getGroup());
    each(selfBuilderAttrs$2, function (name) {
      if (axisModel.get([name, 'show'])) {
        axisElementBuilders$2[name](this, this.group, this._axisGroup, axisModel);
      }
    }, this);
    groupTransition(oldAxisGroup, this._axisGroup, axisModel);

    _super.prototype.render.call(this, axisModel, ecModel, api, payload);
  };

  SingleAxisView.prototype.remove = function () {
    rectCoordAxisHandleRemove(this);
  };

  SingleAxisView.type = 'singleAxis';
  return SingleAxisView;
}(AxisView);

var axisElementBuilders$2 = {
  splitLine: function (axisView, group, axisGroup, axisModel) {
    var axis = axisModel.axis;

    if (axis.scale.isBlank()) {
      return;
    }

    var splitLineModel = axisModel.getModel('splitLine');
    var lineStyleModel = splitLineModel.getModel('lineStyle');
    var lineColors = lineStyleModel.get('color');
    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
    var lineWidth = lineStyleModel.get('width');
    var gridRect = axisModel.coordinateSystem.getRect();
    var isHorizontal = axis.isHorizontal();
    var splitLines = [];
    var lineCount = 0;
    var ticksCoords = axis.getTicksCoords({
      tickModel: splitLineModel
    });
    var p1 = [];
    var p2 = [];

    for (var i = 0; i < ticksCoords.length; ++i) {
      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);

      if (isHorizontal) {
        p1[0] = tickCoord;
        p1[1] = gridRect.y;
        p2[0] = tickCoord;
        p2[1] = gridRect.y + gridRect.height;
      } else {
        p1[0] = gridRect.x;
        p1[1] = tickCoord;
        p2[0] = gridRect.x + gridRect.width;
        p2[1] = tickCoord;
      }

      var line = new Line({
        shape: {
          x1: p1[0],
          y1: p1[1],
          x2: p2[0],
          y2: p2[1]
        },
        silent: true
      });
      subPixelOptimizeLine$1(line.shape, lineWidth);
      var colorIndex = lineCount++ % lineColors.length;
      splitLines[colorIndex] = splitLines[colorIndex] || [];
      splitLines[colorIndex].push(line);
    }

    var lineStyle = lineStyleModel.getLineStyle(['color']);

    for (var i = 0; i < splitLines.length; ++i) {
      group.add(mergePath$1(splitLines[i], {
        style: defaults({
          stroke: lineColors[i % lineColors.length]
        }, lineStyle),
        silent: true
      }));
    }
  },
  splitArea: function (axisView, group, axisGroup, axisModel) {
    rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, axisModel);
  }
};

var SingleAxisModel =
/** @class */
function (_super) {
  __extends$1(SingleAxisModel, _super);

  function SingleAxisModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleAxisModel.type;
    return _this;
  }

  SingleAxisModel.prototype.getCoordSysModel = function () {
    return this;
  };

  SingleAxisModel.type = 'singleAxis';
  SingleAxisModel.layoutMode = 'box';
  SingleAxisModel.defaultOption = {
    left: '5%',
    top: '5%',
    right: '5%',
    bottom: '5%',
    type: 'value',
    position: 'bottom',
    orient: 'horizontal',
    axisLine: {
      show: true,
      lineStyle: {
        width: 1,
        type: 'solid'
      }
    },
    // Single coordinate system and single axis is the,
    // which is used as the parent tooltip model.
    // same model, so we set default tooltip show as true.
    tooltip: {
      show: true
    },
    axisTick: {
      show: true,
      length: 6,
      lineStyle: {
        width: 1
      }
    },
    axisLabel: {
      show: true,
      interval: 'auto'
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed',
        opacity: 0.2
      }
    }
  };
  return SingleAxisModel;
}(ComponentModel);

mixin(SingleAxisModel, AxisModelCommonMixin.prototype);

var SingleAxis =
/** @class */
function (_super) {
  __extends$1(SingleAxis, _super);

  function SingleAxis(dim, scale, coordExtent, axisType, position) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    _this.position = position || 'bottom';
    return _this;
  }
  /**
   * Judge the orient of the axis.
   */


  SingleAxis.prototype.isHorizontal = function () {
    var position = this.position;
    return position === 'top' || position === 'bottom';
  };

  SingleAxis.prototype.pointToData = function (point, clamp) {
    return this.coordinateSystem.pointToData(point)[0];
  };

  return SingleAxis;
}(Axis);

var singleDimensions = ['single'];
/**
 * Create a single coordinates system.
 */

var Single =
/** @class */
function () {
  function Single(axisModel, ecModel, api) {
    this.type = 'single';
    this.dimension = 'single';
    /**
     * Add it just for draw tooltip.
     */

    this.dimensions = singleDimensions;
    this.axisPointerEnabled = true;
    this.model = axisModel;

    this._init(axisModel, ecModel, api);
  }
  /**
   * Initialize single coordinate system.
   */


  Single.prototype._init = function (axisModel, ecModel, api) {
    var dim = this.dimension;
    var axis = new SingleAxis(dim, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
    var isCategory = axis.type === 'category';
    axis.onBand = isCategory && axisModel.get('boundaryGap');
    axis.inverse = axisModel.get('inverse');
    axis.orient = axisModel.get('orient');
    axisModel.axis = axis;
    axis.model = axisModel;
    axis.coordinateSystem = this;
    this._axis = axis;
  };
  /**
   * Update axis scale after data processed
   */


  Single.prototype.update = function (ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      if (seriesModel.coordinateSystem === this) {
        var data_1 = seriesModel.getData();
        each(data_1.mapDimensionsAll(this.dimension), function (dim) {
          this._axis.scale.unionExtentFromData(data_1, dim);
        }, this);
        niceScaleExtent(this._axis.scale, this._axis.model);
      }
    }, this);
  };
  /**
   * Resize the single coordinate system.
   */


  Single.prototype.resize = function (axisModel, api) {
    this._rect = getLayoutRect$1({
      left: axisModel.get('left'),
      top: axisModel.get('top'),
      right: axisModel.get('right'),
      bottom: axisModel.get('bottom'),
      width: axisModel.get('width'),
      height: axisModel.get('height')
    }, {
      width: api.getWidth(),
      height: api.getHeight()
    });

    this._adjustAxis();
  };

  Single.prototype.getRect = function () {
    return this._rect;
  };

  Single.prototype._adjustAxis = function () {
    var rect = this._rect;
    var axis = this._axis;
    var isHorizontal = axis.isHorizontal();
    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);

    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
  };

  Single.prototype._updateAxisTransform = function (axis, coordBase) {
    var axisExtent = axis.getExtent();
    var extentSum = axisExtent[0] + axisExtent[1];
    var isHorizontal = axis.isHorizontal();
    axis.toGlobalCoord = isHorizontal ? function (coord) {
      return coord + coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
    axis.toLocalCoord = isHorizontal ? function (coord) {
      return coord - coordBase;
    } : function (coord) {
      return extentSum - coord + coordBase;
    };
  };
  /**
   * Get axis.
   */


  Single.prototype.getAxis = function () {
    return this._axis;
  };
  /**
   * Get axis, add it just for draw tooltip.
   */


  Single.prototype.getBaseAxis = function () {
    return this._axis;
  };

  Single.prototype.getAxes = function () {
    return [this._axis];
  };

  Single.prototype.getTooltipAxes = function () {
    return {
      baseAxes: [this.getAxis()],
      // Empty otherAxes
      otherAxes: []
    };
  };
  /**
   * If contain point.
   */


  Single.prototype.containPoint = function (point) {
    var rect = this.getRect();
    var axis = this.getAxis();
    var orient = axis.orient;

    if (orient === 'horizontal') {
      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
    } else {
      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    }
  };

  Single.prototype.pointToData = function (point) {
    var axis = this.getAxis();
    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
  };
  /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */


  Single.prototype.dataToPoint = function (val) {
    var axis = this.getAxis();
    var rect = this.getRect();
    var pt = [];
    var idx = axis.orient === 'horizontal' ? 0 : 1;

    if (val instanceof Array) {
      val = val[0];
    }

    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
    return pt;
  };

  Single.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys$3(finder);
    return coordSys === this ? this.dataToPoint(value) : null;
  };

  Single.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys$3(finder);
    return coordSys === this ? this.pointToData(pixel) : null;
  };

  return Single;
}();

function getCoordSys$3(finder) {
  var seriesModel = finder.seriesModel;
  var singleModel = finder.singleAxisModel;
  return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}

/**
 * Create single coordinate system and inject it into seriesModel.
 */

function create$2(ecModel, api) {
  var singles = [];
  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
    var single = new Single(axisModel, ecModel, api);
    single.name = 'single_' + idx;
    single.resize(axisModel, api);
    axisModel.coordinateSystem = single;
    singles.push(single);
  });
  ecModel.eachSeries(function (seriesModel) {
    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
      var singleAxisModel = seriesModel.getReferringComponents('singleAxis', SINGLE_REFERRING).models[0];
      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
    }
  });
  return singles;
}

var singleCreator = {
  create: create$2,
  dimensions: singleDimensions
};

var XY = ['x', 'y'];
var WH = ['width', 'height'];

var SingleAxisPointer =
/** @class */
function (_super) {
  __extends$1(SingleAxisPointer, _super);

  function SingleAxisPointer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @override
   */


  SingleAxisPointer.prototype.makeElOption = function (elOption, value, axisModel, axisPointerModel, api) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
    var pixelValue = coordSys.dataToPoint(value)[0];
    var axisPointerType = axisPointerModel.get('type');

    if (axisPointerType && axisPointerType !== 'none') {
      var elStyle = buildElStyle(axisPointerModel);
      var pointerOption = pointerShapeBuilder$2[axisPointerType](axis, pixelValue, otherExtent);
      pointerOption.style = elStyle;
      elOption.graphicKey = pointerOption.type;
      elOption.pointer = pointerOption;
    }

    var layoutInfo = layout$2(axisModel);
    buildCartesianSingleLabelElOption( // @ts-ignore
    value, elOption, layoutInfo, axisModel, axisPointerModel, api);
  };
  /**
   * @override
   */


  SingleAxisPointer.prototype.getHandleTransform = function (value, axisModel, axisPointerModel) {
    var layoutInfo = layout$2(axisModel, {
      labelInside: false
    }); // @ts-ignore

    layoutInfo.labelMargin = axisPointerModel.get(['handle', 'margin']);
    var position = getTransformedPosition(axisModel.axis, value, layoutInfo);
    return {
      x: position[0],
      y: position[1],
      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
    };
  };
  /**
   * @override
   */


  SingleAxisPointer.prototype.updateHandleTransform = function (transform, delta, axisModel, axisPointerModel) {
    var axis = axisModel.axis;
    var coordSys = axis.coordinateSystem;
    var dimIndex = getPointDimIndex(axis);
    var axisExtent = getGlobalExtent(coordSys, dimIndex);
    var currPosition = [transform.x, transform.y];
    currPosition[dimIndex] += delta[dimIndex];
    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
    var cursorPoint = [cursorOtherValue, cursorOtherValue];
    cursorPoint[dimIndex] = currPosition[dimIndex];
    return {
      x: currPosition[0],
      y: currPosition[1],
      rotation: transform.rotation,
      cursorPoint: cursorPoint,
      tooltipOption: {
        verticalAlign: 'middle'
      }
    };
  };

  return SingleAxisPointer;
}(BaseAxisPointer);

var pointerShapeBuilder$2 = {
  line: function (axis, pixelValue, otherExtent) {
    var targetShape = makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
    return {
      type: 'Line',
      subPixelOptimize: true,
      shape: targetShape
    };
  },
  shadow: function (axis, pixelValue, otherExtent) {
    var bandWidth = axis.getBandWidth();
    var span = otherExtent[1] - otherExtent[0];
    return {
      type: 'Rect',
      shape: makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
    };
  }
};

function getPointDimIndex(axis) {
  return axis.isHorizontal() ? 0 : 1;
}

function getGlobalExtent(coordSys, dimIndex) {
  var rect = coordSys.getRect();
  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
}

var SingleView =
/** @class */
function (_super) {
  __extends$1(SingleView, _super);

  function SingleView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SingleView.type;
    return _this;
  }

  SingleView.type = 'single';
  return SingleView;
}(ComponentView);

function install$v(registers) {
  use(install$s);
  AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
  registers.registerComponentView(SingleView); // Axis

  registers.registerComponentView(SingleAxisView);
  registers.registerComponentModel(SingleAxisModel);
  axisModelCreator(registers, 'single', SingleAxisModel, SingleAxisModel.defaultOption);
  registers.registerCoordinateSystem('single', singleCreator);
}

var CalendarModel =
/** @class */
function (_super) {
  __extends$1(CalendarModel, _super);

  function CalendarModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CalendarModel.type;
    return _this;
  }
  /**
   * @override
   */


  CalendarModel.prototype.init = function (option, parentModel, ecModel) {
    var inputPositionParams = getLayoutParams(option);

    _super.prototype.init.apply(this, arguments);

    mergeAndNormalizeLayoutParams(option, inputPositionParams);
  };
  /**
   * @override
   */


  CalendarModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    mergeAndNormalizeLayoutParams(this.option, option);
  };

  CalendarModel.prototype.getCellSize = function () {
    // Has been normalized
    return this.option.cellSize;
  };

  CalendarModel.type = 'calendar';
  CalendarModel.defaultOption = {
    // zlevel: 0,
    z: 2,
    left: 80,
    top: 60,
    cellSize: 20,
    // horizontal vertical
    orient: 'horizontal',
    // month separate line style
    splitLine: {
      show: true,
      lineStyle: {
        color: '#000',
        width: 1,
        type: 'solid'
      }
    },
    // rect style  temporarily unused emphasis
    itemStyle: {
      color: '#fff',
      borderWidth: 1,
      borderColor: '#ccc'
    },
    // week text style
    dayLabel: {
      show: true,
      firstDay: 0,
      // start end
      position: 'start',
      margin: '50%',
      color: '#000'
    },
    // month text style
    monthLabel: {
      show: true,
      // start end
      position: 'start',
      margin: 5,
      // center or left
      align: 'center',
      formatter: null,
      color: '#000'
    },
    // year text style
    yearLabel: {
      show: true,
      // top bottom left right
      position: null,
      margin: 30,
      formatter: null,
      color: '#ccc',
      fontFamily: 'sans-serif',
      fontWeight: 'bolder',
      fontSize: 20
    }
  };
  return CalendarModel;
}(ComponentModel);

function mergeAndNormalizeLayoutParams(target, raw) {
  // Normalize cellSize
  var cellSize = target.cellSize;
  var cellSizeArr;

  if (!isArray$1(cellSize)) {
    cellSizeArr = target.cellSize = [cellSize, cellSize];
  } else {
    cellSizeArr = cellSize;
  }

  if (cellSizeArr.length === 1) {
    cellSizeArr[1] = cellSizeArr[0];
  }

  var ignoreSize = map([0, 1], function (hvIdx) {
    // If user have set `width` or both `left` and `right`, cellSizeArr
    // will be automatically set to 'auto', otherwise the default
    // setting of cellSizeArr will make `width` setting not work.
    if (sizeCalculable(raw, hvIdx)) {
      cellSizeArr[hvIdx] = 'auto';
    }

    return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
  });
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: ignoreSize
  });
}

var CalendarView =
/** @class */
function (_super) {
  __extends$1(CalendarView, _super);

  function CalendarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = CalendarView.type;
    return _this;
  }

  CalendarView.prototype.render = function (calendarModel, ecModel, api) {
    var group = this.group;
    group.removeAll();
    var coordSys = calendarModel.coordinateSystem; // range info

    var rangeData = coordSys.getRangeInfo();
    var orient = coordSys.getOrient(); // locale

    var localeModel = ecModel.getLocaleModel();

    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function


    this._renderLines(calendarModel, rangeData, orient, group);

    this._renderYearText(calendarModel, rangeData, orient, group);

    this._renderMonthText(calendarModel, localeModel, orient, group);

    this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
  }; // render day rect


  CalendarView.prototype._renderDayRect = function (calendarModel, rangeData, group) {
    var coordSys = calendarModel.coordinateSystem;
    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
    var sw = coordSys.getCellWidth();
    var sh = coordSys.getCellHeight();

    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
      var point = coordSys.dataToRect([i], false).tl; // every rect

      var rect = new Rect({
        shape: {
          x: point[0],
          y: point[1],
          width: sw,
          height: sh
        },
        cursor: 'default',
        style: itemRectStyleModel
      });
      group.add(rect);
    }
  }; // render separate line


  CalendarView.prototype._renderLines = function (calendarModel, rangeData, orient, group) {
    var self = this;
    var coordSys = calendarModel.coordinateSystem;
    var lineStyleModel = calendarModel.getModel(['splitLine', 'lineStyle']).getLineStyle();
    var show = calendarModel.get(['splitLine', 'show']);
    var lineWidth = lineStyleModel.lineWidth;
    this._tlpoints = [];
    this._blpoints = [];
    this._firstDayOfMonth = [];
    this._firstDayPoints = [];
    var firstDay = rangeData.start;

    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
      addPoints(firstDay.formatedDate);

      if (i === 0) {
        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
      }

      var date = firstDay.date;
      date.setMonth(date.getMonth() + 1);
      firstDay = coordSys.getDateInfo(date);
    }

    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);

    function addPoints(date) {
      self._firstDayOfMonth.push(coordSys.getDateInfo(date));

      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);

      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);

      self._tlpoints.push(points[0]);

      self._blpoints.push(points[points.length - 1]);

      show && self._drawSplitline(points, lineStyleModel, group);
    } // render top/left line


    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line

    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
  }; // get points at both ends


  CalendarView.prototype._getEdgesPoints = function (points, lineWidth, orient) {
    var rs = [points[0].slice(), points[points.length - 1].slice()];
    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth

    rs[0][idx] = rs[0][idx] - lineWidth / 2;
    rs[1][idx] = rs[1][idx] + lineWidth / 2;
    return rs;
  }; // render split line


  CalendarView.prototype._drawSplitline = function (points, lineStyle, group) {
    var poyline = new Polyline({
      z2: 20,
      shape: {
        points: points
      },
      style: lineStyle
    });
    group.add(poyline);
  }; // render month line of one week points


  CalendarView.prototype._getLinePointsOfOneWeek = function (calendarModel, date, orient) {
    var coordSys = calendarModel.coordinateSystem;
    var parsedDate = coordSys.getDateInfo(date);
    var points = [];

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(parsedDate.time, i);
      var point = coordSys.dataToRect([tmpD.time], false);
      points[2 * tmpD.day] = point.tl;
      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
    }

    return points;
  };

  CalendarView.prototype._formatterLabel = function (formatter, params) {
    if (isString(formatter) && formatter) {
      return formatTplSimple(formatter, params);
    }

    if (isFunction$3(formatter)) {
      return formatter(params);
    }

    return params.nameMap;
  };

  CalendarView.prototype._yearTextPositionControl = function (textEl, point, orient, position, margin) {
    var x = point[0];
    var y = point[1];
    var aligns = ['center', 'bottom'];

    if (position === 'bottom') {
      y += margin;
      aligns = ['center', 'top'];
    } else if (position === 'left') {
      x -= margin;
    } else if (position === 'right') {
      x += margin;
      aligns = ['center', 'top'];
    } else {
      // top
      y -= margin;
    }

    var rotate = 0;

    if (position === 'left' || position === 'right') {
      rotate = Math.PI / 2;
    }

    return {
      rotation: rotate,
      x: x,
      y: y,
      style: {
        align: aligns[0],
        verticalAlign: aligns[1]
      }
    };
  }; // render year


  CalendarView.prototype._renderYearText = function (calendarModel, rangeData, orient, group) {
    var yearLabel = calendarModel.getModel('yearLabel');

    if (!yearLabel.get('show')) {
      return;
    }

    var margin = yearLabel.get('margin');
    var pos = yearLabel.get('position');

    if (!pos) {
      pos = orient !== 'horizontal' ? 'top' : 'left';
    }

    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
    var xc = (points[0][0] + points[1][0]) / 2;
    var yc = (points[0][1] + points[1][1]) / 2;
    var idx = orient === 'horizontal' ? 0 : 1;
    var posPoints = {
      top: [xc, points[idx][1]],
      bottom: [xc, points[1 - idx][1]],
      left: [points[1 - idx][0], yc],
      right: [points[idx][0], yc]
    };
    var name = rangeData.start.y;

    if (+rangeData.end.y > +rangeData.start.y) {
      name = name + '-' + rangeData.end.y;
    }

    var formatter = yearLabel.get('formatter');
    var params = {
      start: rangeData.start.y,
      end: rangeData.end.y,
      nameMap: name
    };

    var content = this._formatterLabel(formatter, params);

    var yearText = new ZRText({
      z2: 30,
      style: createTextStyle(yearLabel, {
        text: content
      })
    });
    yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
    group.add(yearText);
  };

  CalendarView.prototype._monthTextPositionControl = function (point, isCenter, orient, position, margin) {
    var align = 'left';
    var vAlign = 'top';
    var x = point[0];
    var y = point[1];

    if (orient === 'horizontal') {
      y = y + margin;

      if (isCenter) {
        align = 'center';
      }

      if (position === 'start') {
        vAlign = 'bottom';
      }
    } else {
      x = x + margin;

      if (isCenter) {
        vAlign = 'middle';
      }

      if (position === 'start') {
        align = 'right';
      }
    }

    return {
      x: x,
      y: y,
      align: align,
      verticalAlign: vAlign
    };
  }; // render month and year text


  CalendarView.prototype._renderMonthText = function (calendarModel, localeModel, orient, group) {
    var monthLabel = calendarModel.getModel('monthLabel');

    if (!monthLabel.get('show')) {
      return;
    }

    var nameMap = monthLabel.get('nameMap');
    var margin = monthLabel.get('margin');
    var pos = monthLabel.get('position');
    var align = monthLabel.get('align');
    var termPoints = [this._tlpoints, this._blpoints];

    if (!nameMap || isString(nameMap)) {
      if (nameMap) {
        // case-sensitive
        localeModel = getLocaleModel(nameMap) || localeModel;
      } // PENDING
      // for ZH locale, original form is `一月` but current form is `1月`


      nameMap = localeModel.get(['time', 'monthAbbr']) || [];
    }

    var idx = pos === 'start' ? 0 : 1;
    var axis = orient === 'horizontal' ? 0 : 1;
    margin = pos === 'start' ? -margin : margin;
    var isCenter = align === 'center';

    for (var i = 0; i < termPoints[idx].length - 1; i++) {
      var tmp = termPoints[idx][i].slice();
      var firstDay = this._firstDayOfMonth[i];

      if (isCenter) {
        var firstDayPoints = this._firstDayPoints[i];
        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
      }

      var formatter = monthLabel.get('formatter');
      var name_1 = nameMap[+firstDay.m - 1];
      var params = {
        yyyy: firstDay.y,
        yy: (firstDay.y + '').slice(2),
        MM: firstDay.m,
        M: +firstDay.m,
        nameMap: name_1
      };

      var content = this._formatterLabel(formatter, params);

      var monthText = new ZRText({
        z2: 30,
        style: extend(createTextStyle(monthLabel, {
          text: content
        }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin))
      });
      group.add(monthText);
    }
  };

  CalendarView.prototype._weekTextPositionControl = function (point, orient, position, margin, cellSize) {
    var align = 'center';
    var vAlign = 'middle';
    var x = point[0];
    var y = point[1];
    var isStart = position === 'start';

    if (orient === 'horizontal') {
      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
      align = isStart ? 'right' : 'left';
    } else {
      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
      vAlign = isStart ? 'bottom' : 'top';
    }

    return {
      x: x,
      y: y,
      align: align,
      verticalAlign: vAlign
    };
  }; // render weeks


  CalendarView.prototype._renderWeekText = function (calendarModel, localeModel, rangeData, orient, group) {
    var dayLabel = calendarModel.getModel('dayLabel');

    if (!dayLabel.get('show')) {
      return;
    }

    var coordSys = calendarModel.coordinateSystem;
    var pos = dayLabel.get('position');
    var nameMap = dayLabel.get('nameMap');
    var margin = dayLabel.get('margin');
    var firstDayOfWeek = coordSys.getFirstDayOfWeek();

    if (!nameMap || isString(nameMap)) {
      if (nameMap) {
        // case-sensitive
        localeModel = getLocaleModel(nameMap) || localeModel;
      } // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file


      var dayOfWeekShort = localeModel.get(['time', 'dayOfWeekShort']);
      nameMap = dayOfWeekShort || map(localeModel.get(['time', 'dayOfWeekAbbr']), function (val) {
        return val[0];
      });
    }

    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
    margin = parsePercent$1(margin, Math.min(cellSize[1], cellSize[0]));

    if (pos === 'start') {
      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
      margin = -margin;
    }

    for (var i = 0; i < 7; i++) {
      var tmpD = coordSys.getNextNDay(start, i);
      var point = coordSys.dataToRect([tmpD.time], false).center;
      var day = i;
      day = Math.abs((i + firstDayOfWeek) % 7);
      var weekText = new ZRText({
        z2: 30,
        style: extend(createTextStyle(dayLabel, {
          text: nameMap[day]
        }), this._weekTextPositionControl(point, orient, pos, margin, cellSize))
      });
      group.add(weekText);
    }
  };

  CalendarView.type = 'calendar';
  return CalendarView;
}(ComponentView);

var PROXIMATE_ONE_DAY = 86400000;

var Calendar$1 =
/** @class */
function () {
  function Calendar(calendarModel, ecModel, api) {
    this.type = 'calendar';
    this.dimensions = Calendar.dimensions; // Required in createListFromData

    this.getDimensionsInfo = Calendar.getDimensionsInfo;
    this._model = calendarModel;
  }

  Calendar.getDimensionsInfo = function () {
    return [{
      name: 'time',
      type: 'time'
    }, 'value'];
  };

  Calendar.prototype.getRangeInfo = function () {
    return this._rangeInfo;
  };

  Calendar.prototype.getModel = function () {
    return this._model;
  };

  Calendar.prototype.getRect = function () {
    return this._rect;
  };

  Calendar.prototype.getCellWidth = function () {
    return this._sw;
  };

  Calendar.prototype.getCellHeight = function () {
    return this._sh;
  };

  Calendar.prototype.getOrient = function () {
    return this._orient;
  };
  /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */


  Calendar.prototype.getFirstDayOfWeek = function () {
    return this._firstDayOfWeek;
  };
  /**
   * get date info
   * }
   */


  Calendar.prototype.getDateInfo = function (date) {
    date = parseDate(date);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var mStr = m < 10 ? '0' + m : '' + m;
    var d = date.getDate();
    var dStr = d < 10 ? '0' + d : '' + d;
    var day = date.getDay();
    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
    return {
      y: y + '',
      m: mStr,
      d: dStr,
      day: day,
      time: date.getTime(),
      formatedDate: y + '-' + mStr + '-' + dStr,
      date: date
    };
  };

  Calendar.prototype.getNextNDay = function (date, n) {
    n = n || 0;

    if (n === 0) {
      return this.getDateInfo(date);
    }

    date = new Date(this.getDateInfo(date).time);
    date.setDate(date.getDate() + n);
    return this.getDateInfo(date);
  };

  Calendar.prototype.update = function (ecModel, api) {
    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
    this._orient = this._model.get('orient');
    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
    var weeks = this._rangeInfo.weeks || 1;
    var whNames = ['width', 'height'];

    var cellSize = this._model.getCellSize().slice();

    var layoutParams = this._model.getBoxLayoutParams();

    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
    each([0, 1], function (idx) {
      if (cellSizeSpecified(cellSize, idx)) {
        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
      }
    });
    var whGlobal = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var calendarRect = this._rect = getLayoutRect$1(layoutParams, whGlobal);
    each([0, 1], function (idx) {
      if (!cellSizeSpecified(cellSize, idx)) {
        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
      }
    });

    function cellSizeSpecified(cellSize, idx) {
      return cellSize[idx] != null && cellSize[idx] !== 'auto';
    } // Has been calculated out number.


    this._sw = cellSize[0];
    this._sh = cellSize[1];
  };
  /**
   * Convert a time data(time, value) item to (x, y) point.
   */
  // TODO Clamp of calendar is not same with cartesian coordinate systems.
  // It will return NaN if data exceeds.


  Calendar.prototype.dataToPoint = function (data, clamp) {
    isArray$1(data) && (data = data[0]);
    clamp == null && (clamp = true);
    var dayInfo = this.getDateInfo(data);
    var range = this._rangeInfo;
    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]

    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
      return [NaN, NaN];
    }

    var week = dayInfo.day;

    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;

    if (this._orient === 'vertical') {
      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
    }

    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
  };
  /**
   * Convert a (x, y) point to time data
   */


  Calendar.prototype.pointToData = function (point) {
    var date = this.pointToDate(point);
    return date && date.time;
  };
  /**
   * Convert a time date item to (x, y) four point.
   */


  Calendar.prototype.dataToRect = function (data, clamp) {
    var point = this.dataToPoint(data, clamp);
    return {
      contentShape: {
        x: point[0] - (this._sw - this._lineWidth) / 2,
        y: point[1] - (this._sh - this._lineWidth) / 2,
        width: this._sw - this._lineWidth,
        height: this._sh - this._lineWidth
      },
      center: point,
      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
    };
  };
  /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */


  Calendar.prototype.pointToDate = function (point) {
    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
    var range = this._rangeInfo.range;

    if (this._orient === 'vertical') {
      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
    }

    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
  };

  Calendar.prototype.convertToPixel = function (ecModel, finder, value) {
    var coordSys = getCoordSys$4(finder);
    return coordSys === this ? coordSys.dataToPoint(value) : null;
  };

  Calendar.prototype.convertFromPixel = function (ecModel, finder, pixel) {
    var coordSys = getCoordSys$4(finder);
    return coordSys === this ? coordSys.pointToData(pixel) : null;
  };

  Calendar.prototype.containPoint = function (point) {
    console.warn('Not implemented.');
    return false;
  };
  /**
   * initRange
   * Normalize to an [start, end] array
   */


  Calendar.prototype._initRangeOption = function () {
    var range = this._model.get('range');

    var normalizedRange; // Convert [1990] to 1990

    if (isArray$1(range) && range.length === 1) {
      range = range[0];
    }

    if (!isArray$1(range)) {
      var rangeStr = range.toString(); // One year.

      if (/^\d{4}$/.test(rangeStr)) {
        normalizedRange = [rangeStr + '-01-01', rangeStr + '-12-31'];
      } // One month


      if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
        var start = this.getDateInfo(rangeStr);
        var firstDay = start.date;
        firstDay.setMonth(firstDay.getMonth() + 1);
        var end = this.getNextNDay(firstDay, -1);
        normalizedRange = [start.formatedDate, end.formatedDate];
      } // One day


      if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) {
        normalizedRange = [rangeStr, rangeStr];
      }
    } else {
      normalizedRange = range;
    }

    if (!normalizedRange) {
      if (process.env.NODE_ENV !== 'production') {
        logError('Invalid date range.');
      } // Not handling it.


      return range;
    }

    var tmp = this._getRangeInfo(normalizedRange);

    if (tmp.start.time > tmp.end.time) {
      normalizedRange.reverse();
    }

    return normalizedRange;
  };
  /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */


  Calendar.prototype._getRangeInfo = function (range) {
    var parsedRange = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
    var reversed;

    if (parsedRange[0].time > parsedRange[1].time) {
      reversed = true;
      parsedRange.reverse();
    }

    var allDay = Math.floor(parsedRange[1].time / PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
    // Consider case2:
    // Firstly set system timezone as "Time Zone: America/Toronto",
    // ```
    // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
    // let second = new Date(1478412000000);
    // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
    // ```
    // will get wrong result because of DST. So we should fix it.

    var date = new Date(parsedRange[0].time);
    var startDateNum = date.getDate();
    var endDateNum = parsedRange[1].date.getDate();
    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.

    var dateNum = date.getDate();

    if (dateNum !== endDateNum) {
      var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;

      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0) {
        allDay -= sign;
        date.setDate(dateNum - sign);
      }
    }

    var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
    reversed && parsedRange.reverse();
    return {
      range: [parsedRange[0].formatedDate, parsedRange[1].formatedDate],
      start: parsedRange[0],
      end: parsedRange[1],
      allDay: allDay,
      weeks: weeks,
      // From 0.
      nthWeek: nthWeek,
      fweek: parsedRange[0].day,
      lweek: parsedRange[1].day
    };
  };
  /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */


  Calendar.prototype._getDateByWeeksAndDay = function (nthWeek, day, range) {
    var rangeInfo = this._getRangeInfo(range);

    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
      return null;
    }

    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
    var date = new Date(rangeInfo.start.time);
    date.setDate(+rangeInfo.start.d + nthDay);
    return this.getDateInfo(date);
  };

  Calendar.create = function (ecModel, api) {
    var calendarList = [];
    ecModel.eachComponent('calendar', function (calendarModel) {
      var calendar = new Calendar(calendarModel, ecModel, api);
      calendarList.push(calendar);
      calendarModel.coordinateSystem = calendar;
    });
    ecModel.eachSeries(function (calendarSeries) {
      if (calendarSeries.get('coordinateSystem') === 'calendar') {
        // Inject coordinate system
        calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
      }
    });
    return calendarList;
  };

  Calendar.dimensions = ['time', 'value'];
  return Calendar;
}();

function getCoordSys$4(finder) {
  var calendarModel = finder.calendarModel;
  var seriesModel = finder.seriesModel;
  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
  return coordSys;
}

function install$w(registers) {
  registers.registerComponentModel(CalendarModel);
  registers.registerComponentView(CalendarView);
  registers.registerCoordinateSystem('calendar', Calendar$1);
}

function setKeyInfoToNewElOption(resultItem, newElOption) {
  var existElOption = resultItem.existing; // Set id and type after id assigned.

  newElOption.id = resultItem.keyInfo.id;
  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified

  if (newElOption.parentId == null) {
    var newElParentOption = newElOption.parentOption;

    if (newElParentOption) {
      newElOption.parentId = newElParentOption.id;
    } else if (existElOption) {
      newElOption.parentId = existElOption.parentId;
    }
  } // Clear


  newElOption.parentOption = null;
}

function isSetLoc(obj, props) {
  var isSet;
  each(props, function (prop) {
    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
  });
  return isSet;
}

function mergeNewElOptionToExist(existList, index, newElOption) {
  // Update existing options, for `getOption` feature.
  var newElOptCopy = extend({}, newElOption);
  var existElOption = existList[index];
  var $action = newElOption.$action || 'merge';

  if ($action === 'merge') {
    if (existElOption) {
      if (process.env.NODE_ENV !== 'production') {
        var newType = newElOption.type;
        assert(!newType || existElOption.type === newType, 'Please set $action: "replace" to change `type`');
      } // We can ensure that newElOptCopy and existElOption are not
      // the same object, so `merge` will not change newElOptCopy.


      merge$1(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.

      mergeLayoutParam(existElOption, newElOptCopy, {
        ignoreSize: true
      }); // Will be used in render.

      copyLayoutParams(newElOption, existElOption); // Copy transition info to new option so it can be used in the transition.
      // DO IT AFTER merge

      copyTransitionInfo(newElOption, existElOption);
      copyTransitionInfo(newElOption, existElOption, 'shape');
      copyTransitionInfo(newElOption, existElOption, 'style');
      copyTransitionInfo(newElOption, existElOption, 'extra'); // Copy clipPath

      newElOption.clipPath = existElOption.clipPath;
    } else {
      existList[index] = newElOptCopy;
    }
  } else if ($action === 'replace') {
    existList[index] = newElOptCopy;
  } else if ($action === 'remove') {
    // null will be cleaned later.
    existElOption && (existList[index] = null);
  }
}

var TRANSITION_PROPS_TO_COPY = ['transition', 'enterFrom', 'leaveTo'];
var ROOT_TRANSITION_PROPS_TO_COPY = TRANSITION_PROPS_TO_COPY.concat(['enterAnimation', 'updateAnimation', 'leaveAnimation']);

function copyTransitionInfo(target, source, targetProp) {
  if (targetProp) {
    if (!target[targetProp] && source[targetProp]) {
      // TODO avoid creating this empty object when there is no transition configuration.
      target[targetProp] = {};
    }

    target = target[targetProp];
    source = source[targetProp];
  }

  if (!target || !source) {
    return;
  }

  var props = targetProp ? TRANSITION_PROPS_TO_COPY : ROOT_TRANSITION_PROPS_TO_COPY;

  for (var i = 0; i < props.length; i++) {
    var prop = props[i];

    if (target[prop] == null && source[prop] != null) {
      target[prop] = source[prop];
    }
  }
}

function setLayoutInfoToExist(existItem, newElOption) {
  if (!existItem) {
    return;
  }

  existItem.hv = newElOption.hv = [// Rigid body, don't care about `width`.
  isSetLoc(newElOption, ['left', 'right']), // Rigid body, don't care about `height`.
  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.

  if (existItem.type === 'group') {
    var existingGroupOpt = existItem;
    var newGroupOpt = newElOption;
    existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
    existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
  }
}

var GraphicComponentModel =
/** @class */
function (_super) {
  __extends$1(GraphicComponentModel, _super);

  function GraphicComponentModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphicComponentModel.type;
    _this.preventAutoZ = true;
    return _this;
  }

  GraphicComponentModel.prototype.mergeOption = function (option, ecModel) {
    // Prevent default merge to elements
    var elements = this.option.elements;
    this.option.elements = null;

    _super.prototype.mergeOption.call(this, option, ecModel);

    this.option.elements = elements;
  };

  GraphicComponentModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    var newList = (isInit ? thisOption : newOption).elements;
    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
    var flattenedList = [];

    this._flatten(newList, flattenedList, null);

    var mappingResult = mappingToExists(existList, flattenedList, 'normalMerge'); // Clear elOptionsToUpdate

    var elOptionsToUpdate = this._elOptionsToUpdate = [];
    each(mappingResult, function (resultItem, index) {
      var newElOption = resultItem.newOption;

      if (process.env.NODE_ENV !== 'production') {
        assert(isObject$2(newElOption) || resultItem.existing, 'Empty graphic option definition');
      }

      if (!newElOption) {
        return;
      }

      elOptionsToUpdate.push(newElOption);
      setKeyInfoToNewElOption(resultItem, newElOption);
      mergeNewElOptionToExist(existList, index, newElOption);
      setLayoutInfoToExist(existList[index], newElOption);
    }, this); // Clean

    thisOption.elements = filter(existList, function (item) {
      // $action should be volatile, otherwise option gotten from
      // `getOption` will contain unexpected $action.
      item && delete item.$action;
      return item != null;
    });
  };
  /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */


  GraphicComponentModel.prototype._flatten = function (optionList, result, parentOption) {
    each(optionList, function (option) {
      if (!option) {
        return;
      }

      if (parentOption) {
        option.parentOption = parentOption;
      }

      result.push(option);
      var children = option.children; // here we don't judge if option.type is `group`
      // when new option doesn't provide `type`, it will cause that the children can't be updated.

      if (children && children.length) {
        this._flatten(children, result, option);
      } // Deleting for JSON output, and for not affecting group creation.


      delete option.children;
    }, this);
  }; // FIXME
  // Pass to view using payload? setOption has a payload?


  GraphicComponentModel.prototype.useElOptionsToUpdate = function () {
    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.

    this._elOptionsToUpdate = null;
    return els;
  };

  GraphicComponentModel.type = 'graphic';
  GraphicComponentModel.defaultOption = {
    elements: [] // parentId: null

  };
  return GraphicComponentModel;
}(ComponentModel);

var nonShapeGraphicElements = {
  // Reserved but not supported in graphic component.
  path: null,
  compoundPath: null,
  // Supported in graphic component.
  group: Group$1,
  image: ZRImage,
  text: ZRText
};
var inner$f = makeInner(); // ------------------------
// View
// ------------------------

var GraphicComponentView =
/** @class */
function (_super) {
  __extends$1(GraphicComponentView, _super);

  function GraphicComponentView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = GraphicComponentView.type;
    return _this;
  }

  GraphicComponentView.prototype.init = function () {
    this._elMap = createHashMap();
  };

  GraphicComponentView.prototype.render = function (graphicModel, ecModel, api) {
    // Having leveraged between use cases and algorithm complexity, a very
    // simple layout mechanism is used:
    // The size(width/height) can be determined by itself or its parent (not
    // implemented yet), but can not by its children. (Top-down travel)
    // The location(x/y) can be determined by the bounding rect of itself
    // (can including its descendants or not) and the size of its parent.
    // (Bottom-up travel)
    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
    // view will be reused.
    if (graphicModel !== this._lastGraphicModel) {
      this._clear();
    }

    this._lastGraphicModel = graphicModel;

    this._updateElements(graphicModel);

    this._relocate(graphicModel, api);
  };
  /**
   * Update graphic elements.
   */


  GraphicComponentView.prototype._updateElements = function (graphicModel) {
    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();

    if (!elOptionsToUpdate) {
      return;
    }

    var elMap = this._elMap;
    var rootGroup = this.group;
    var globalZ = graphicModel.get('z');
    var globalZLevel = graphicModel.get('zlevel'); // Top-down tranverse to assign graphic settings to each elements.

    each(elOptionsToUpdate, function (elOption) {
      var id = convertOptionIdName(elOption.id, null);
      var elExisting = id != null ? elMap.get(id) : null;
      var parentId = convertOptionIdName(elOption.parentId, null);
      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
      var elType = elOption.type;
      var elOptionStyle = elOption.style;

      if (elType === 'text' && elOptionStyle) {
        // In top/bottom mode, textVerticalAlign should not be used, which cause
        // inaccurately locating.
        if (elOption.hv && elOption.hv[1]) {
          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
        }
      }

      var textContentOption = elOption.textContent;
      var textConfig = elOption.textConfig;

      if (elOptionStyle && isEC4CompatibleStyle(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
        var convertResult = convertFromEC4CompatibleStyle(elOptionStyle, elType, true);

        if (!textConfig && convertResult.textConfig) {
          textConfig = elOption.textConfig = convertResult.textConfig;
        }

        if (!textContentOption && convertResult.textContent) {
          textContentOption = convertResult.textContent;
        }
      } // Remove unnecessary props to avoid potential problems.


      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.

      if (process.env.NODE_ENV !== 'production') {
        elExisting && assert(targetElParent === elExisting.parent, 'Changing parent is not supported.');
      }

      var $action = elOption.$action || 'merge';
      var isMerge = $action === 'merge';
      var isReplace = $action === 'replace';

      if (isMerge) {
        var isInit = !elExisting;
        var el_1 = elExisting;

        if (isInit) {
          el_1 = createEl$1(id, targetElParent, elOption.type, elMap);
        } else {
          el_1 && (inner$f(el_1).isNew = false); // Stop and restore before update any other attributes.

          stopPreviousKeyframeAnimationAndRestore(el_1);
        }

        if (el_1) {
          applyUpdateTransition(el_1, elOptionCleaned, graphicModel, {
            isInit: isInit
          });
          updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
        }
      } else if (isReplace) {
        removeEl(elExisting, elOption, elMap, graphicModel);
        var el_2 = createEl$1(id, targetElParent, elOption.type, elMap);

        if (el_2) {
          applyUpdateTransition(el_2, elOptionCleaned, graphicModel, {
            isInit: true
          });
          updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
        }
      } else if ($action === 'remove') {
        updateLeaveTo(elExisting, elOption);
        removeEl(elExisting, elOption, elMap, graphicModel);
      }

      var el = elMap.get(id);

      if (el && textContentOption) {
        if (isMerge) {
          var textContentExisting = el.getTextContent();
          textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new ZRText(textContentOption));
        } else if (isReplace) {
          el.setTextContent(new ZRText(textContentOption));
        }
      }

      if (el) {
        var clipPathOption = elOption.clipPath;

        if (clipPathOption) {
          var clipPathType = clipPathOption.type;
          var clipPath = void 0;
          var isInit = false;

          if (isMerge) {
            var oldClipPath = el.getClipPath();
            isInit = !oldClipPath || inner$f(oldClipPath).type !== clipPathType;
            clipPath = isInit ? newEl(clipPathType) : oldClipPath;
          } else if (isReplace) {
            isInit = true;
            clipPath = newEl(clipPathType);
          }

          el.setClipPath(clipPath);
          applyUpdateTransition(clipPath, clipPathOption, graphicModel, {
            isInit: isInit
          });
          applyKeyframeAnimation(clipPath, clipPathOption.keyframeAnimation, graphicModel);
        }

        var elInner = inner$f(el);
        el.setTextConfig(textConfig);
        elInner.option = elOption;
        setEventData(el, graphicModel, elOption);
        setTooltipConfig({
          el: el,
          componentModel: graphicModel,
          itemName: el.name,
          itemTooltipOption: elOption.tooltip
        });
        applyKeyframeAnimation(el, elOption.keyframeAnimation, graphicModel);
      }
    });
  };
  /**
   * Locate graphic elements.
   */


  GraphicComponentView.prototype._relocate = function (graphicModel, api) {
    var elOptions = graphicModel.option.elements;
    var rootGroup = this.group;
    var elMap = this._elMap;
    var apiWidth = api.getWidth();
    var apiHeight = api.getHeight();
    var xy = ['x', 'y']; // Top-down to calculate percentage width/height of group

    for (var i = 0; i < elOptions.length; i++) {
      var elOption = elOptions[i];
      var id = convertOptionIdName(elOption.id, null);
      var el = id != null ? elMap.get(id) : null;

      if (!el || !el.isGroup) {
        continue;
      }

      var parentEl = el.parent;
      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.

      var elInner = inner$f(el);
      var parentElInner = inner$f(parentEl);
      elInner.width = parsePercent$1(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
      elInner.height = parsePercent$1(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.


    for (var i = elOptions.length - 1; i >= 0; i--) {
      var elOption = elOptions[i];
      var id = convertOptionIdName(elOption.id, null);
      var el = id != null ? elMap.get(id) : null;

      if (!el) {
        continue;
      }

      var parentEl = el.parent;
      var parentElInner = inner$f(parentEl);
      var containerInfo = parentEl === rootGroup ? {
        width: apiWidth,
        height: apiHeight
      } : {
        width: parentElInner.width,
        height: parentElInner.height
      }; // PENDING
      // Currently, when `bounding: 'all'`, the union bounding rect of the group
      // does not include the rect of [0, 0, group.width, group.height], which
      // is probably weird for users. Should we make a break change for it?

      var layoutPos = {};
      var layouted = positionElement(el, elOption, containerInfo, null, {
        hv: elOption.hv,
        boundingMode: elOption.bounding
      }, layoutPos);

      if (!inner$f(el).isNew && layouted) {
        var transition = elOption.transition;
        var animatePos = {};

        for (var k = 0; k < xy.length; k++) {
          var key = xy[k];
          var val = layoutPos[key];

          if (transition && (isTransitionAll(transition) || indexOf(transition, key) >= 0)) {
            animatePos[key] = val;
          } else {
            el[key] = val;
          }
        }

        updateProps(el, animatePos, graphicModel, 0);
      } else {
        el.attr(layoutPos);
      }
    }
  };
  /**
   * Clear all elements.
   */


  GraphicComponentView.prototype._clear = function () {
    var _this = this;

    var elMap = this._elMap;
    elMap.each(function (el) {
      removeEl(el, inner$f(el).option, elMap, _this._lastGraphicModel);
    });
    this._elMap = createHashMap();
  };

  GraphicComponentView.prototype.dispose = function () {
    this._clear();
  };

  GraphicComponentView.type = 'graphic';
  return GraphicComponentView;
}(ComponentView);

function newEl(graphicType) {
  if (process.env.NODE_ENV !== 'production') {
    assert(graphicType, 'graphic type MUST be set');
  }

  var Clz = hasOwn(nonShapeGraphicElements, graphicType) // Those graphic elements are not shapes. They should not be
  // overwritten by users, so do them first.
  ? nonShapeGraphicElements[graphicType] : getShapeClass(graphicType);

  if (process.env.NODE_ENV !== 'production') {
    assert(Clz, "graphic type " + graphicType + " can not be found");
  }

  var el = new Clz({});
  inner$f(el).type = graphicType;
  return el;
}

function createEl$1(id, targetElParent, graphicType, elMap) {
  var el = newEl(graphicType);
  targetElParent.add(el);
  elMap.set(id, el);
  inner$f(el).id = id;
  inner$f(el).isNew = true;
  return el;
}

function removeEl(elExisting, elOption, elMap, graphicModel) {
  var existElParent = elExisting && elExisting.parent;

  if (existElParent) {
    elExisting.type === 'group' && elExisting.traverse(function (el) {
      removeEl(el, elOption, elMap, graphicModel);
    });
    applyLeaveTransition(elExisting, elOption, graphicModel);
    elMap.removeKey(inner$f(elExisting).id);
  }
}

function updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
  if (!el.isGroup) {
    each([['cursor', Displayable.prototype.cursor], // We should not support configure z and zlevel in the element level.
    // But seems we didn't limit it previously. So here still use it to avoid breaking.
    ['zlevel', defaultZlevel || 0], ['z', defaultZ || 0], // z2 must not be null/undefined, otherwise sort error may occur.
    ['z2', 0]], function (item) {
      var prop = item[0];

      if (hasOwn(elOption, prop)) {
        el[prop] = retrieve2(elOption[prop], item[1]);
      } else if (el[prop] == null) {
        el[prop] = item[1];
      }
    });
  }

  each(keys$2(elOption), function (key) {
    // Assign event handlers.
    // PENDING: should enumerate all event names or use pattern matching?
    if (key.indexOf('on') === 0) {
      var val = elOption[key];
      el[key] = isFunction$3(val) ? val : null;
    }
  });

  if (hasOwn(elOption, 'draggable')) {
    el.draggable = elOption.draggable;
  } // Other attributes


  elOption.name != null && (el.name = elOption.name);
  elOption.id != null && (el.id = elOption.id);
} // Remove unnecessary props to avoid potential problems.


function getCleanedElOption(elOption) {
  elOption = extend({}, elOption);
  each(['id', 'parentId', '$action', 'hv', 'bounding', 'textContent', 'clipPath'].concat(LOCATION_PARAMS), function (name) {
    delete elOption[name];
  });
  return elOption;
}

function setEventData(el, graphicModel, elOption) {
  var eventData = getECData(el).eventData; // Simple optimize for large amount of elements that no need event.

  if (!el.silent && !el.ignore && !eventData) {
    eventData = getECData(el).eventData = {
      componentType: 'graphic',
      componentIndex: graphicModel.componentIndex,
      name: el.name
    };
  } // `elOption.info` enables user to mount some info on
  // elements and use them in event handlers.


  if (eventData) {
    eventData.info = elOption.info;
  }
}

function install$x(registers) {
  registers.registerComponentModel(GraphicComponentModel);
  registers.registerComponentView(GraphicComponentView);
  registers.registerPreprocessor(function (option) {
    var graphicOption = option.graphic; // Convert
    // {graphic: [{left: 10, type: 'circle'}, ...]}
    // or
    // {graphic: {left: 10, type: 'circle'}}
    // to
    // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}

    if (isArray$1(graphicOption)) {
      if (!graphicOption[0] || !graphicOption[0].elements) {
        option.graphic = [{
          elements: graphicOption
        }];
      } else {
        // Only one graphic instance can be instantiated. (We don't
        // want that too many views are created in echarts._viewMap.)
        option.graphic = [option.graphic[0]];
      }
    } else if (graphicOption && !graphicOption.elements) {
      option.graphic = [{
        elements: [graphicOption]
      }];
    }
  });
}

var DATA_ZOOM_AXIS_DIMENSIONS = ['x', 'y', 'radius', 'angle', 'single']; // Supported coords.
// FIXME: polar has been broken (but rarely used).

var SERIES_COORDS = ['cartesian2d', 'polar', 'singleAxis'];
function isCoordSupported(seriesModel) {
  var coordType = seriesModel.get('coordinateSystem');
  return indexOf(SERIES_COORDS, coordType) >= 0;
}
function getAxisMainType(axisDim) {
  if (process.env.NODE_ENV !== 'production') {
    assert(axisDim);
  }

  return axisDim + 'Axis';
}
/**
 * If two dataZoomModels has the same axis controlled, we say that they are 'linked'.
 * This function finds all linked dataZoomModels start from the given payload.
 */

function findEffectedDataZooms(ecModel, payload) {
  // Key: `DataZoomAxisDimension`
  var axisRecords = createHashMap();
  var effectedModels = []; // Key: uid of dataZoomModel

  var effectedModelMap = createHashMap(); // Find the dataZooms specified by payload.

  ecModel.eachComponent({
    mainType: 'dataZoom',
    query: payload
  }, function (dataZoomModel) {
    if (!effectedModelMap.get(dataZoomModel.uid)) {
      addToEffected(dataZoomModel);
    }
  }); // Start from the given dataZoomModels, travel the graph to find
  // all of the linked dataZoom models.

  var foundNewLink;

  do {
    foundNewLink = false;
    ecModel.eachComponent('dataZoom', processSingle);
  } while (foundNewLink);

  function processSingle(dataZoomModel) {
    if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
      addToEffected(dataZoomModel);
      foundNewLink = true;
    }
  }

  function addToEffected(dataZoom) {
    effectedModelMap.set(dataZoom.uid, true);
    effectedModels.push(dataZoom);
    markAxisControlled(dataZoom);
  }

  function isLinked(dataZoomModel) {
    var isLink = false;
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      var axisIdxArr = axisRecords.get(axisDim);

      if (axisIdxArr && axisIdxArr[axisIndex]) {
        isLink = true;
      }
    });
    return isLink;
  }

  function markAxisControlled(dataZoomModel) {
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
    });
  }

  return effectedModels;
}
/**
 * Find the first target coordinate system.
 * Available after model built.
 *
 * @return Like {
 *                  grid: [
 *                      {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
 *                      {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
 *                      ...
 *                  ],  // cartesians must not be null/undefined.
 *                  polar: [
 *                      {model: coord0, axisModels: [axis4], coordIndex: 0},
 *                      ...
 *                  ],  // polars must not be null/undefined.
 *                  singleAxis: [
 *                      {model: coord0, axisModels: [], coordIndex: 0}
 *                  ]
 *              }
 */

function collectReferCoordSysModelInfo(dataZoomModel) {
  var ecModel = dataZoomModel.ecModel;
  var coordSysInfoWrap = {
    infoList: [],
    infoMap: createHashMap()
  };
  dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
    var axisModel = ecModel.getComponent(getAxisMainType(axisDim), axisIndex);

    if (!axisModel) {
      return;
    }

    var coordSysModel = axisModel.getCoordSysModel();

    if (!coordSysModel) {
      return;
    }

    var coordSysUid = coordSysModel.uid;
    var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);

    if (!coordSysInfo) {
      coordSysInfo = {
        model: coordSysModel,
        axisModels: []
      };
      coordSysInfoWrap.infoList.push(coordSysInfo);
      coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
    }

    coordSysInfo.axisModels.push(axisModel);
  });
  return coordSysInfoWrap;
}

var DataZoomAxisInfo =
/** @class */
function () {
  function DataZoomAxisInfo() {
    this.indexList = [];
    this.indexMap = [];
  }

  DataZoomAxisInfo.prototype.add = function (axisCmptIdx) {
    // Remove duplication.
    if (!this.indexMap[axisCmptIdx]) {
      this.indexList.push(axisCmptIdx);
      this.indexMap[axisCmptIdx] = true;
    }
  };

  return DataZoomAxisInfo;
}();

var DataZoomModel =
/** @class */
function (_super) {
  __extends$1(DataZoomModel, _super);

  function DataZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = DataZoomModel.type;
    _this._autoThrottle = true;
    _this._noTarget = true;
    /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */

    _this._rangePropMode = ['percent', 'percent'];
    return _this;
  }

  DataZoomModel.prototype.init = function (option, parentModel, ecModel) {
    var inputRawOption = retrieveRawOption(option);
    /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */

    this.settledOption = inputRawOption;
    this.mergeDefaultAndTheme(option, ecModel);

    this._doInit(inputRawOption);
  };

  DataZoomModel.prototype.mergeOption = function (newOption) {
    var inputRawOption = retrieveRawOption(newOption); // FIX #2591

    merge$1(this.option, newOption, true);
    merge$1(this.settledOption, inputRawOption, true);

    this._doInit(inputRawOption);
  };

  DataZoomModel.prototype._doInit = function (inputRawOption) {
    var thisOption = this.option;

    this._setDefaultThrottle(inputRawOption);

    this._updateRangeUse(inputRawOption);

    var settledOption = this.settledOption;
    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      // start/end has higher priority over startValue/endValue if they
      // both set, but we should make chart.setOption({endValue: 1000})
      // effective, rather than chart.setOption({endValue: 1000, end: null}).
      if (this._rangePropMode[index] === 'value') {
        thisOption[names[0]] = settledOption[names[0]] = null;
      } // Otherwise do nothing and use the merge result.

    }, this);

    this._resetTarget();
  };

  DataZoomModel.prototype._resetTarget = function () {
    var optionOrient = this.get('orient', true);
    var targetAxisIndexMap = this._targetAxisInfoMap = createHashMap();

    var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);

    if (hasAxisSpecified) {
      this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
    } else {
      this._orient = optionOrient || 'horizontal';

      this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
    }

    this._noTarget = true;
    targetAxisIndexMap.each(function (axisInfo) {
      if (axisInfo.indexList.length) {
        this._noTarget = false;
      }
    }, this);
  };

  DataZoomModel.prototype._fillSpecifiedTargetAxis = function (targetAxisIndexMap) {
    var hasAxisSpecified = false;
    each(DATA_ZOOM_AXIS_DIMENSIONS, function (axisDim) {
      var refering = this.getReferringComponents(getAxisMainType(axisDim), MULTIPLE_REFERRING); // When user set axisIndex as a empty array, we think that user specify axisIndex
      // but do not want use auto mode. Because empty array may be encountered when
      // some error occurred.

      if (!refering.specified) {
        return;
      }

      hasAxisSpecified = true;
      var axisInfo = new DataZoomAxisInfo();
      each(refering.models, function (axisModel) {
        axisInfo.add(axisModel.componentIndex);
      });
      targetAxisIndexMap.set(axisDim, axisInfo);
    }, this);
    return hasAxisSpecified;
  };

  DataZoomModel.prototype._fillAutoTargetAxisByOrient = function (targetAxisIndexMap, orient) {
    var ecModel = this.ecModel;
    var needAuto = true; // Find axis that parallel to dataZoom as default.

    if (needAuto) {
      var axisDim = orient === 'vertical' ? 'y' : 'x';
      var axisModels = ecModel.findComponents({
        mainType: axisDim + 'Axis'
      });
      setParallelAxis(axisModels, axisDim);
    } // Find axis that parallel to dataZoom as default.


    if (needAuto) {
      var axisModels = ecModel.findComponents({
        mainType: 'singleAxis',
        filter: function (axisModel) {
          return axisModel.get('orient', true) === orient;
        }
      });
      setParallelAxis(axisModels, 'single');
    }

    function setParallelAxis(axisModels, axisDim) {
      // At least use the first parallel axis as the target axis.
      var axisModel = axisModels[0];

      if (!axisModel) {
        return;
      }

      var axisInfo = new DataZoomAxisInfo();
      axisInfo.add(axisModel.componentIndex);
      targetAxisIndexMap.set(axisDim, axisInfo);
      needAuto = false; // Find parallel axes in the same grid.

      if (axisDim === 'x' || axisDim === 'y') {
        var gridModel_1 = axisModel.getReferringComponents('grid', SINGLE_REFERRING).models[0];
        gridModel_1 && each(axisModels, function (axModel) {
          if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', SINGLE_REFERRING).models[0]) {
            axisInfo.add(axModel.componentIndex);
          }
        });
      }
    }

    if (needAuto) {
      // If no parallel axis, find the first category axis as default. (Also consider polar).
      each(DATA_ZOOM_AXIS_DIMENSIONS, function (axisDim) {
        if (!needAuto) {
          return;
        }

        var axisModels = ecModel.findComponents({
          mainType: getAxisMainType(axisDim),
          filter: function (axisModel) {
            return axisModel.get('type', true) === 'category';
          }
        });

        if (axisModels[0]) {
          var axisInfo = new DataZoomAxisInfo();
          axisInfo.add(axisModels[0].componentIndex);
          targetAxisIndexMap.set(axisDim, axisInfo);
          needAuto = false;
        }
      }, this);
    }
  };

  DataZoomModel.prototype._makeAutoOrientByTargetAxis = function () {
    var dim; // Find the first axis

    this.eachTargetAxis(function (axisDim) {
      !dim && (dim = axisDim);
    }, this);
    return dim === 'y' ? 'vertical' : 'horizontal';
  };

  DataZoomModel.prototype._setDefaultThrottle = function (inputRawOption) {
    // When first time user set throttle, auto throttle ends.
    if (inputRawOption.hasOwnProperty('throttle')) {
      this._autoThrottle = false;
    }

    if (this._autoThrottle) {
      var globalOption = this.ecModel.option;
      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
    }
  };

  DataZoomModel.prototype._updateRangeUse = function (inputRawOption) {
    var rangePropMode = this._rangePropMode;
    var rangeModeInOption = this.get('rangeMode');
    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
      var percentSpecified = inputRawOption[names[0]] != null;
      var valueSpecified = inputRawOption[names[1]] != null;

      if (percentSpecified && !valueSpecified) {
        rangePropMode[index] = 'percent';
      } else if (!percentSpecified && valueSpecified) {
        rangePropMode[index] = 'value';
      } else if (rangeModeInOption) {
        rangePropMode[index] = rangeModeInOption[index];
      } else if (percentSpecified) {
        // percentSpecified && valueSpecified
        rangePropMode[index] = 'percent';
      } // else remain its original setting.

    });
  };

  DataZoomModel.prototype.noTarget = function () {
    return this._noTarget;
  };

  DataZoomModel.prototype.getFirstTargetAxisModel = function () {
    var firstAxisModel;
    this.eachTargetAxis(function (axisDim, axisIndex) {
      if (firstAxisModel == null) {
        firstAxisModel = this.ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
      }
    }, this);
    return firstAxisModel;
  };
  /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */


  DataZoomModel.prototype.eachTargetAxis = function (callback, context) {
    this._targetAxisInfoMap.each(function (axisInfo, axisDim) {
      each(axisInfo.indexList, function (axisIndex) {
        callback.call(context, axisDim, axisIndex);
      });
    });
  };
  /**
   * @return If not found, return null/undefined.
   */


  DataZoomModel.prototype.getAxisProxy = function (axisDim, axisIndex) {
    var axisModel = this.getAxisModel(axisDim, axisIndex);

    if (axisModel) {
      return axisModel.__dzAxisProxy;
    }
  };
  /**
   * @return If not found, return null/undefined.
   */


  DataZoomModel.prototype.getAxisModel = function (axisDim, axisIndex) {
    if (process.env.NODE_ENV !== 'production') {
      assert(axisDim && axisIndex != null);
    }

    var axisInfo = this._targetAxisInfoMap.get(axisDim);

    if (axisInfo && axisInfo.indexMap[axisIndex]) {
      return this.ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
    }
  };
  /**
   * If not specified, set to undefined.
   */


  DataZoomModel.prototype.setRawRange = function (opt) {
    var thisOption = this.option;
    var settledOption = this.settledOption;
    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
      // Consider the pair <start, startValue>:
      // If one has value and the other one is `null/undefined`, we both set them
      // to `settledOption`. This strategy enables the feature to clear the original
      // value in `settledOption` to `null/undefined`.
      // But if both of them are `null/undefined`, we do not set them to `settledOption`
      // and keep `settledOption` with the original value. This strategy enables users to
      // only set <end or endValue> but not set <start or startValue> when calling
      // `dispatchAction`.
      // The pair <end, endValue> is treated in the same way.
      if (opt[names[0]] != null || opt[names[1]] != null) {
        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
      }
    }, this);

    this._updateRangeUse(opt);
  };

  DataZoomModel.prototype.setCalculatedRange = function (opt) {
    var option = this.option;
    each(['start', 'startValue', 'end', 'endValue'], function (name) {
      option[name] = opt[name];
    });
  };

  DataZoomModel.prototype.getPercentRange = function () {
    var axisProxy = this.findRepresentativeAxisProxy();

    if (axisProxy) {
      return axisProxy.getDataPercentWindow();
    }
  };
  /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */


  DataZoomModel.prototype.getValueRange = function (axisDim, axisIndex) {
    if (axisDim == null && axisIndex == null) {
      var axisProxy = this.findRepresentativeAxisProxy();

      if (axisProxy) {
        return axisProxy.getDataValueWindow();
      }
    } else {
      return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    }
  };
  /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */


  DataZoomModel.prototype.findRepresentativeAxisProxy = function (axisModel) {
    if (axisModel) {
      return axisModel.__dzAxisProxy;
    } // Find the first hosted axisProxy


    var firstProxy;

    var axisDimList = this._targetAxisInfoMap.keys();

    for (var i = 0; i < axisDimList.length; i++) {
      var axisDim = axisDimList[i];

      var axisInfo = this._targetAxisInfoMap.get(axisDim);

      for (var j = 0; j < axisInfo.indexList.length; j++) {
        var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);

        if (proxy.hostedBy(this)) {
          return proxy;
        }

        if (!firstProxy) {
          firstProxy = proxy;
        }
      }
    } // If no hosted proxy found, still need to return a proxy.
    // This case always happens in toolbox dataZoom, where axes are all hosted by
    // other dataZooms.


    return firstProxy;
  };

  DataZoomModel.prototype.getRangePropMode = function () {
    return this._rangePropMode.slice();
  };

  DataZoomModel.prototype.getOrient = function () {
    if (process.env.NODE_ENV !== 'production') {
      // Should not be called before initialized.
      assert(this._orient);
    }

    return this._orient;
  };

  DataZoomModel.type = 'dataZoom';
  DataZoomModel.dependencies = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series', 'toolbox'];
  DataZoomModel.defaultOption = {
    // zlevel: 0,
    z: 4,
    filterMode: 'filter',
    start: 0,
    end: 100
  };
  return DataZoomModel;
}(ComponentModel);
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */


function retrieveRawOption(option) {
  var ret = {};
  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
    option.hasOwnProperty(name) && (ret[name] = option[name]);
  });
  return ret;
}

var SelectDataZoomModel =
/** @class */
function (_super) {
  __extends$1(SelectDataZoomModel, _super);

  function SelectDataZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SelectDataZoomModel.type;
    return _this;
  }

  SelectDataZoomModel.type = 'dataZoom.select';
  return SelectDataZoomModel;
}(DataZoomModel);

var DataZoomView =
/** @class */
function (_super) {
  __extends$1(DataZoomView, _super);

  function DataZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = DataZoomView.type;
    return _this;
  }

  DataZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
    this.dataZoomModel = dataZoomModel;
    this.ecModel = ecModel;
    this.api = api;
  };

  DataZoomView.type = 'dataZoom';
  return DataZoomView;
}(ComponentView);

var SelectDataZoomView =
/** @class */
function (_super) {
  __extends$1(SelectDataZoomView, _super);

  function SelectDataZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SelectDataZoomView.type;
    return _this;
  }

  SelectDataZoomView.type = 'dataZoom.select';
  return SelectDataZoomView;
}(DataZoomView);

var each$8 = each;
var asc$1 = asc;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */

var AxisProxy =
/** @class */
function () {
  function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
    this._dimName = dimName;
    this._axisIndex = axisIndex;
    this.ecModel = ecModel;
    this._dataZoomModel = dataZoomModel; // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
  }
  /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */


  AxisProxy.prototype.hostedBy = function (dataZoomModel) {
    return this._dataZoomModel === dataZoomModel;
  };
  /**
   * @return Value can only be NaN or finite value.
   */


  AxisProxy.prototype.getDataValueWindow = function () {
    return this._valueWindow.slice();
  };
  /**
   * @return {Array.<number>}
   */


  AxisProxy.prototype.getDataPercentWindow = function () {
    return this._percentWindow.slice();
  };

  AxisProxy.prototype.getTargetSeriesModels = function () {
    var seriesModels = [];
    this.ecModel.eachSeries(function (seriesModel) {
      if (isCoordSupported(seriesModel)) {
        var axisMainType = getAxisMainType(this._dimName);
        var axisModel = seriesModel.getReferringComponents(axisMainType, SINGLE_REFERRING).models[0];

        if (axisModel && this._axisIndex === axisModel.componentIndex) {
          seriesModels.push(seriesModel);
        }
      }
    }, this);
    return seriesModels;
  };

  AxisProxy.prototype.getAxisModel = function () {
    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
  };

  AxisProxy.prototype.getMinMaxSpan = function () {
    return clone(this._minMaxSpan);
  };
  /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */


  AxisProxy.prototype.calculateDataWindow = function (opt) {
    var dataExtent = this._dataExtent;
    var axisModel = this.getAxisModel();
    var scale = axisModel.axis.scale;

    var rangePropMode = this._dataZoomModel.getRangePropMode();

    var percentExtent = [0, 100];
    var percentWindow = [];
    var valueWindow = [];
    var hasPropModeValue;
    each$8(['start', 'end'], function (prop, idx) {
      var boundPercent = opt[prop];
      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
      // but not min/max of axis, which will be calculated by data window then).
      // The former one is suitable for cases that a dataZoom component controls multiple
      // axes with different unit or extent, and the latter one is suitable for accurate
      // zoom by pixel (e.g., in dataZoomSelect).
      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
      // only when setOption or dispatchAction, otherwise it remains its original value.
      // (Why not only record `percentProp` and always map to `valueProp`? Because
      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
      // data extent. All of values that are overflow the `dataExtent` will be calculated
      // to percent '100%').

      if (rangePropMode[idx] === 'percent') {
        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.

        boundValue = scale.parse(linearMap(boundPercent, percentExtent, dataExtent));
      } else {
        hasPropModeValue = true;
        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
        // This calculation can not be inversed, because all of values that
        // are overflow the `dataExtent` will be calculated to percent '100%'

        boundPercent = linearMap(boundValue, dataExtent, percentExtent);
      } // valueWindow[idx] = round(boundValue);
      // percentWindow[idx] = round(boundPercent);
      // fallback to extent start/end when parsed value or percent is invalid


      valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
      percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
    });
    asc$1(valueWindow);
    asc$1(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
    // where API is able to initialize/modify the window size even though `zoomLock`
    // specified.

    var spans = this._minMaxSpan;
    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);

    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
      var suffix = toValue ? 'Span' : 'ValueSpan';
      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);

      for (var i = 0; i < 2; i++) {
        toWindow[i] = linearMap(fromWindow[i], fromExtent, toExtent, true);
        toValue && (toWindow[i] = scale.parse(toWindow[i]));
      }
    }

    return {
      valueWindow: valueWindow,
      percentWindow: percentWindow
    };
  };
  /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */


  AxisProxy.prototype.reset = function (dataZoomModel) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.

    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // `calculateDataWindow` uses min/maxSpan.

    this._updateMinMaxSpan();

    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
    this._valueWindow = dataWindow.valueWindow;
    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.

    this._setAxisModel();
  };

  AxisProxy.prototype.filterData = function (dataZoomModel, api) {
    if (dataZoomModel !== this._dataZoomModel) {
      return;
    }

    var axisDim = this._dimName;
    var seriesModels = this.getTargetSeriesModels();
    var filterMode = dataZoomModel.get('filterMode');
    var valueWindow = this._valueWindow;

    if (filterMode === 'none') {
      return;
    } // FIXME
    // Toolbox may has dataZoom injected. And if there are stacked bar chart
    // with NaN data, NaN will be filtered and stack will be wrong.
    // So we need to force the mode to be set empty.
    // In fect, it is not a big deal that do not support filterMode-'filter'
    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
    // selection" some day, which might need "adapt to data extent on the
    // otherAxis", which is disabled by filterMode-'empty'.
    // But currently, stack has been fixed to based on value but not index,
    // so this is not an issue any more.
    // let otherAxisModel = this.getOtherAxisModel();
    // if (dataZoomModel.get('$fromToolbox')
    //     && otherAxisModel
    //     && otherAxisModel.hasSeriesStacked
    // ) {
    //     filterMode = 'empty';
    // }
    // TODO
    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.


    each$8(seriesModels, function (seriesModel) {
      var seriesData = seriesModel.getData();
      var dataDims = seriesData.mapDimensionsAll(axisDim);

      if (!dataDims.length) {
        return;
      }

      if (filterMode === 'weakFilter') {
        var store_1 = seriesData.getStore();
        var dataDimIndices_1 = map(dataDims, function (dim) {
          return seriesData.getDimensionIndex(dim);
        }, seriesData);
        seriesData.filterSelf(function (dataIndex) {
          var leftOut;
          var rightOut;
          var hasValue;

          for (var i = 0; i < dataDims.length; i++) {
            var value = store_1.get(dataDimIndices_1[i], dataIndex);
            var thisHasValue = !isNaN(value);
            var thisLeftOut = value < valueWindow[0];
            var thisRightOut = value > valueWindow[1];

            if (thisHasValue && !thisLeftOut && !thisRightOut) {
              return true;
            }

            thisHasValue && (hasValue = true);
            thisLeftOut && (leftOut = true);
            thisRightOut && (rightOut = true);
          } // If both left out and right out, do not filter.


          return hasValue && leftOut && rightOut;
        });
      } else {
        each$8(dataDims, function (dim) {
          if (filterMode === 'empty') {
            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
              return !isInWindow(value) ? NaN : value;
            }));
          } else {
            var range = {};
            range[dim] = valueWindow; // console.time('select');

            seriesData.selectRange(range); // console.timeEnd('select');
          }
        });
      }

      each$8(dataDims, function (dim) {
        seriesData.setApproximateExtent(valueWindow, dim);
      });
    });

    function isInWindow(value) {
      return value >= valueWindow[0] && value <= valueWindow[1];
    }
  };

  AxisProxy.prototype._updateMinMaxSpan = function () {
    var minMaxSpan = this._minMaxSpan = {};
    var dataZoomModel = this._dataZoomModel;
    var dataExtent = this._dataExtent;
    each$8(['min', 'max'], function (minMax) {
      var percentSpan = dataZoomModel.get(minMax + 'Span');
      var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
      valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan

      if (valueSpan != null) {
        percentSpan = linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
      } else if (percentSpan != null) {
        valueSpan = linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
      }

      minMaxSpan[minMax + 'Span'] = percentSpan;
      minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
    }, this);
  };

  AxisProxy.prototype._setAxisModel = function () {
    var axisModel = this.getAxisModel();
    var percentWindow = this._percentWindow;
    var valueWindow = this._valueWindow;

    if (!percentWindow) {
      return;
    } // [0, 500]: arbitrary value, guess axis extent.


    var precision = getPixelPrecision(valueWindow, [0, 500]);
    precision = Math.min(precision, 20); // For value axis, if min/max/scale are not set, we just use the extent obtained
    // by series data, which may be a little different from the extent calculated by
    // `axisHelper.getScaleExtent`. But the different just affects the experience a
    // little when zooming. So it will not be fixed until some users require it strongly.

    var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;

    if (percentWindow[0] !== 0) {
      rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
    }

    if (percentWindow[1] !== 100) {
      rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
    }

    rawExtentInfo.freeze();
  };

  return AxisProxy;
}();

function calculateDataExtent(axisProxy, axisDim, seriesModels) {
  var dataExtent = [Infinity, -Infinity];
  each$8(seriesModels, function (seriesModel) {
    unionAxisExtentFromData(dataExtent, seriesModel.getData(), axisDim);
  }); // It is important to get "consistent" extent when more then one axes is
  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
  // when zooming. But it is difficult to know what is "consistent", considering
  // axes have different type or even different meanings (For example, two
  // time axes are used to compare data of the same date in different years).
  // So basically dataZoom just obtains extent by series.data (in category axis
  // extent can be obtained from axis.data).
  // Nevertheless, user can set min/max/scale on axes to make extent of axes
  // consistent.

  var axisModel = axisProxy.getAxisModel();
  var rawExtentResult = ensureScaleRawExtentInfo(axisModel.axis.scale, axisModel, dataExtent).calculate();
  return [rawExtentResult.min, rawExtentResult.max];
}

var dataZoomProcessor = {
  // `dataZoomProcessor` will only be performed in needed series. Consider if
  // there is a line series and a pie series, it is better not to update the
  // line series if only pie series is needed to be updated.
  getTargetSeries: function (ecModel) {
    function eachAxisModel(cb) {
      ecModel.eachComponent('dataZoom', function (dataZoomModel) {
        dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
          var axisModel = ecModel.getComponent(getAxisMainType(axisDim), axisIndex);
          cb(axisDim, axisIndex, axisModel, dataZoomModel);
        });
      });
    } // FIXME: it brings side-effect to `getTargetSeries`.
    // Prepare axis proxies.


    eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
      // dispose all last axis proxy, in case that some axis are deleted.
      axisModel.__dzAxisProxy = null;
    });
    var proxyList = [];
    eachAxisModel(function (axisDim, axisIndex, axisModel, dataZoomModel) {
      // Different dataZooms may constrol the same axis. In that case,
      // an axisProxy serves both of them.
      if (!axisModel.__dzAxisProxy) {
        // Use the first dataZoomModel as the main model of axisProxy.
        axisModel.__dzAxisProxy = new AxisProxy(axisDim, axisIndex, dataZoomModel, ecModel);
        proxyList.push(axisModel.__dzAxisProxy);
      }
    });
    var seriesModelMap = createHashMap();
    each(proxyList, function (axisProxy) {
      each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
        seriesModelMap.set(seriesModel.uid, seriesModel);
      });
    });
    return seriesModelMap;
  },
  // Consider appendData, where filter should be performed. Because data process is
  // in block mode currently, it is not need to worry about that the overallProgress
  // execute every frame.
  overallReset: function (ecModel, api) {
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // We calculate window and reset axis here but not in model
      // init stage and not after action dispatch handler, because
      // reset should be called after seriesData.restoreData.
      dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
        dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
      }); // Caution: data zoom filtering is order sensitive when using
      // percent range and no min/max/scale set on axis.
      // For example, we have dataZoom definition:
      // [
      //      {xAxisIndex: 0, start: 30, end: 70},
      //      {yAxisIndex: 0, start: 20, end: 80}
      // ]
      // In this case, [20, 80] of y-dataZoom should be based on data
      // that have filtered by x-dataZoom using range of [30, 70],
      // but should not be based on full raw data. Thus sliding
      // x-dataZoom will change both ranges of xAxis and yAxis,
      // while sliding y-dataZoom will only change the range of yAxis.
      // So we should filter x-axis after reset x-axis immediately,
      // and then reset y-axis and filter y-axis.

      dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
        dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
      });
    });
    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
      // Fullfill all of the range props so that user
      // is able to get them from chart.getOption().
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var percentRange = axisProxy.getDataPercentWindow();
        var valueRange = axisProxy.getDataValueWindow();
        dataZoomModel.setCalculatedRange({
          start: percentRange[0],
          end: percentRange[1],
          startValue: valueRange[0],
          endValue: valueRange[1]
        });
      }
    });
  }
};

function installDataZoomAction(registers) {
  registers.registerAction('dataZoom', function (payload, ecModel) {
    var effectedModels = findEffectedDataZooms(ecModel, payload);
    each(effectedModels, function (dataZoomModel) {
      dataZoomModel.setRawRange({
        start: payload.start,
        end: payload.end,
        startValue: payload.startValue,
        endValue: payload.endValue
      });
    });
  });
}

var installed = false;
function installCommon(registers) {
  if (installed) {
    return;
  }

  installed = true;
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, dataZoomProcessor);
  installDataZoomAction(registers);
  registers.registerSubTypeDefaulter('dataZoom', function () {
    // Default 'slider' when no type specified.
    return 'slider';
  });
}

function install$y(registers) {
  registers.registerComponentModel(SelectDataZoomModel);
  registers.registerComponentView(SelectDataZoomView);
  installCommon(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

var ToolboxFeature =
/** @class */
function () {
  function ToolboxFeature() {}

  return ToolboxFeature;
}();
var features = {};
function registerFeature(name, ctor) {
  features[name] = ctor;
}
function getFeature(name) {
  return features[name];
}

var ToolboxModel =
/** @class */
function (_super) {
  __extends$1(ToolboxModel, _super);

  function ToolboxModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ToolboxModel.type;
    return _this;
  }

  ToolboxModel.prototype.optionUpdated = function () {
    _super.prototype.optionUpdated.apply(this, arguments);

    var ecModel = this.ecModel;
    each(this.option.feature, function (featureOpt, featureName) {
      var Feature = getFeature(featureName);

      if (Feature) {
        if (Feature.getDefaultOption) {
          Feature.defaultOption = Feature.getDefaultOption(ecModel);
        }

        merge$1(featureOpt, Feature.defaultOption);
      }
    });
  };

  ToolboxModel.type = 'toolbox';
  ToolboxModel.layoutMode = {
    type: 'box',
    ignoreSize: true
  };
  ToolboxModel.defaultOption = {
    show: true,
    z: 6,
    // zlevel: 0,
    orient: 'horizontal',
    left: 'right',
    top: 'top',
    // right
    // bottom
    backgroundColor: 'transparent',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemSize: 15,
    itemGap: 8,
    showTitle: true,
    iconStyle: {
      borderColor: '#666',
      color: 'none'
    },
    emphasis: {
      iconStyle: {
        borderColor: '#3E98C5'
      }
    },
    // textStyle: {},
    // feature
    tooltip: {
      show: false,
      position: 'bottom'
    }
  };
  return ToolboxModel;
}(ComponentModel);

/**
 * Layout list like component.
 * It will box layout each items in group of component and then position the whole group in the viewport
 * @param {module:zrender/group/Group} group
 * @param {module:echarts/model/Component} componentModel
 * @param {module:echarts/ExtensionAPI}
 */

function layout$3(group, componentModel, api) {
  var boxLayoutParams = componentModel.getBoxLayoutParams();
  var padding = componentModel.get('padding');
  var viewportSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var rect = getLayoutRect$1(boxLayoutParams, viewportSize, padding);
  box(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
  positionElement(group, boxLayoutParams, viewportSize, padding);
}
function makeBackground(rect, componentModel) {
  var padding = normalizeCssArray$1(componentModel.get('padding'));
  var style = componentModel.getItemStyle(['color', 'opacity']);
  style.fill = componentModel.get('backgroundColor');
  rect = new Rect({
    shape: {
      x: rect.x - padding[3],
      y: rect.y - padding[0],
      width: rect.width + padding[1] + padding[3],
      height: rect.height + padding[0] + padding[2],
      r: componentModel.get('borderRadius')
    },
    style: style,
    silent: true,
    z2: -1
  }); // FIXME
  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
  // and background rect when setting like `left: 0`, `top: 0`.
  // graphic.subPixelOptimizeRect(rect);

  return rect;
}

var ToolboxView =
/** @class */
function (_super) {
  __extends$1(ToolboxView, _super);

  function ToolboxView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ToolboxView.prototype.render = function (toolboxModel, ecModel, api, payload) {
    var group = this.group;
    group.removeAll();

    if (!toolboxModel.get('show')) {
      return;
    }

    var itemSize = +toolboxModel.get('itemSize');
    var isVertical = toolboxModel.get('orient') === 'vertical';
    var featureOpts = toolboxModel.get('feature') || {};
    var features = this._features || (this._features = {});
    var featureNames = [];
    each(featureOpts, function (opt, name) {
      featureNames.push(name);
    });
    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(curry(processFeature, null)).execute(); // Keep for diff.

    this._featureNames = featureNames;

    function processFeature(newIndex, oldIndex) {
      var featureName = featureNames[newIndex];
      var oldName = featureNames[oldIndex];
      var featureOpt = featureOpts[featureName];
      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?

      if (payload && payload.newTitle != null && payload.featureName === featureName) {
        featureOpt.title = payload.newTitle;
      }

      if (featureName && !oldName) {
        // Create
        if (isUserFeatureName(featureName)) {
          feature = {
            onclick: featureModel.option.onclick,
            featureName: featureName
          };
        } else {
          var Feature = getFeature(featureName);

          if (!Feature) {
            return;
          }

          feature = new Feature();
        }

        features[featureName] = feature;
      } else {
        feature = features[oldName]; // If feature does not exsit.

        if (!feature) {
          return;
        }
      }

      feature.uid = getUID('toolbox-feature');
      feature.model = featureModel;
      feature.ecModel = ecModel;
      feature.api = api;
      var isToolboxFeature = feature instanceof ToolboxFeature;

      if (!featureName && oldName) {
        isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
        return;
      }

      if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
        isToolboxFeature && feature.remove && feature.remove(ecModel, api);
        return;
      }

      createIconPaths(featureModel, feature, featureName);

      featureModel.setIconStatus = function (iconName, status) {
        var option = this.option;
        var iconPaths = this.iconPaths;
        option.iconStatus = option.iconStatus || {};
        option.iconStatus[iconName] = status;

        if (iconPaths[iconName]) {
          (status === 'emphasis' ? enterEmphasis : leaveEmphasis)(iconPaths[iconName]);
        }
      };

      if (feature instanceof ToolboxFeature) {
        if (feature.render) {
          feature.render(featureModel, ecModel, api, payload);
        }
      }
    }

    function createIconPaths(featureModel, feature, featureName) {
      var iconStyleModel = featureModel.getModel('iconStyle');
      var iconStyleEmphasisModel = featureModel.getModel(['emphasis', 'iconStyle']); // If one feature has mutiple icon. they are orginaized as
      // {
      //     icon: {
      //         foo: '',
      //         bar: ''
      //     },
      //     title: {
      //         foo: '',
      //         bar: ''
      //     }
      // }

      var icons = feature instanceof ToolboxFeature && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
      var titles = featureModel.get('title') || {};
      var iconsMap;
      var titlesMap;

      if (isString(icons)) {
        iconsMap = {};
        iconsMap[featureName] = icons;
      } else {
        iconsMap = icons;
      }

      if (isString(titles)) {
        titlesMap = {};
        titlesMap[featureName] = titles;
      } else {
        titlesMap = titles;
      }

      var iconPaths = featureModel.iconPaths = {};
      each(iconsMap, function (iconStr, iconName) {
        var path = createIcon(iconStr, {}, {
          x: -itemSize / 2,
          y: -itemSize / 2,
          width: itemSize,
          height: itemSize
        }); // TODO handling image

        path.setStyle(iconStyleModel.getItemStyle());
        var pathEmphasisState = path.ensureState('emphasis');
        pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle(); // Text position calculation

        var textContent = new ZRText({
          style: {
            text: titlesMap[iconName],
            align: iconStyleEmphasisModel.get('textAlign'),
            borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
            padding: iconStyleEmphasisModel.get('textPadding'),
            fill: null
          },
          ignore: true
        });
        path.setTextContent(textContent);
        setTooltipConfig({
          el: path,
          componentModel: toolboxModel,
          itemName: iconName,
          formatterParamsExtra: {
            title: titlesMap[iconName]
          }
        });
        path.__title = titlesMap[iconName];
        path.on('mouseover', function () {
          // Should not reuse above hoverStyle, which might be modified.
          var hoverStyle = iconStyleEmphasisModel.getItemStyle();
          var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
          textContent.setStyle({
            fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
            backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
          });
          path.setTextConfig({
            position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
          });
          textContent.ignore = !toolboxModel.get('showTitle'); // Use enterEmphasis and leaveEmphasis provide by ec.
          // There are flags managed by the echarts.

          api.enterEmphasis(this);
        }).on('mouseout', function () {
          if (featureModel.get(['iconStatus', iconName]) !== 'emphasis') {
            api.leaveEmphasis(this);
          }

          textContent.hide();
        });
        (featureModel.get(['iconStatus', iconName]) === 'emphasis' ? enterEmphasis : leaveEmphasis)(path);
        group.add(path);
        path.on('click', bind(feature.onclick, feature, ecModel, api, iconName));
        iconPaths[iconName] = path;
      });
    }

    layout$3(group, toolboxModel, api); // Render background after group is layout
    // FIXME

    group.add(makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen

    isVertical || group.eachChild(function (icon) {
      var titleText = icon.__title; // const hoverStyle = icon.hoverStyle;
      // TODO simplify code?

      var emphasisState = icon.ensureState('emphasis');
      var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
      var textContent = icon.getTextContent();
      var emphasisTextState = textContent && textContent.ensureState('emphasis'); // May be background element

      if (emphasisTextState && !isFunction$3(emphasisTextState) && titleText) {
        var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
        var rect = getBoundingRect(titleText, ZRText.makeFont(emphasisTextStyle));
        var offsetX = icon.x + group.x;
        var offsetY = icon.y + group.y + itemSize;
        var needPutOnTop = false;

        if (offsetY + rect.height > api.getHeight()) {
          emphasisTextConfig.position = 'top';
          needPutOnTop = true;
        }

        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;

        if (offsetX + rect.width / 2 > api.getWidth()) {
          emphasisTextConfig.position = ['100%', topOffset];
          emphasisTextStyle.align = 'right';
        } else if (offsetX - rect.width / 2 < 0) {
          emphasisTextConfig.position = [0, topOffset];
          emphasisTextStyle.align = 'left';
        }
      }
    });
  };

  ToolboxView.prototype.updateView = function (toolboxModel, ecModel, api, payload) {
    each(this._features, function (feature) {
      feature instanceof ToolboxFeature && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
    });
  }; // updateLayout(toolboxModel, ecModel, api, payload) {
  //     zrUtil.each(this._features, function (feature) {
  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
  //     });
  // },


  ToolboxView.prototype.remove = function (ecModel, api) {
    each(this._features, function (feature) {
      feature instanceof ToolboxFeature && feature.remove && feature.remove(ecModel, api);
    });
    this.group.removeAll();
  };

  ToolboxView.prototype.dispose = function (ecModel, api) {
    each(this._features, function (feature) {
      feature instanceof ToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
    });
  };

  ToolboxView.type = 'toolbox';
  return ToolboxView;
}(ComponentView);

function isUserFeatureName(featureName) {
  return featureName.indexOf('my') === 0;
}

/* global window, document */

var SaveAsImage =
/** @class */
function (_super) {
  __extends$1(SaveAsImage, _super);

  function SaveAsImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SaveAsImage.prototype.onclick = function (ecModel, api) {
    var model = this.model;
    var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
    var isSvg = api.getZr().painter.getType() === 'svg';
    var type = isSvg ? 'svg' : model.get('type', true) || 'png';
    var url = api.getConnectedDataURL({
      type: type,
      backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
      connectedBackgroundColor: model.get('connectedBackgroundColor'),
      excludeComponents: model.get('excludeComponents'),
      pixelRatio: model.get('pixelRatio')
    });
    var browser = env.browser; // Chrome, Firefox, New Edge

    if (isFunction$3(MouseEvent) && (browser.newEdge || !browser.ie && !browser.edge)) {
      var $a = document.createElement('a');
      $a.download = title + '.' + type;
      $a.target = '_blank';
      $a.href = url;
      var evt = new MouseEvent('click', {
        // some micro front-end framework， window maybe is a Proxy
        view: document.defaultView,
        bubbles: true,
        cancelable: false
      });
      $a.dispatchEvent(evt);
    } // IE or old Edge
    else {
        // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
          var parts = url.split(','); // data:[<mime type>][;charset=<charset>][;base64],<encoded data>

          var base64Encoded = parts[0].indexOf('base64') > -1;
          var bstr = isSvg // should decode the svg data uri first
          ? decodeURIComponent(parts[1]) : parts[1]; // only `atob` when the data uri is encoded with base64
          // otherwise, like `svg` data uri exported by zrender,
          // there will be an error, for it's not encoded with base64.
          // (just a url-encoded string through `encodeURIComponent`)

          base64Encoded && (bstr = window.atob(bstr));
          var filename = title + '.' + type; // @ts-ignore

          if (window.navigator.msSaveOrOpenBlob) {
            var n = bstr.length;
            var u8arr = new Uint8Array(n);

            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }

            var blob = new Blob([u8arr]); // @ts-ignore

            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var frame = document.createElement('iframe');
            document.body.appendChild(frame);
            var cw = frame.contentWindow;
            var doc = cw.document;
            doc.open('image/svg+xml', 'replace');
            doc.write(bstr);
            doc.close();
            cw.focus();
            doc.execCommand('SaveAs', true, filename);
            document.body.removeChild(frame);
          }
        } else {
          var lang = model.get('lang');
          var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
          var tab = window.open();
          tab.document.write(html);
          tab.document.title = title;
        }
      }
  };

  SaveAsImage.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
      title: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'title']),
      type: 'png',
      // Default use option.backgroundColor
      // backgroundColor: '#fff',
      connectedBackgroundColor: '#fff',
      name: '',
      excludeComponents: ['toolbox'],
      // use current pixel ratio of device by default
      // pixelRatio: 1,
      lang: ecModel.getLocaleModel().get(['toolbox', 'saveAsImage', 'lang'])
    };
    return defaultOption;
  };

  return SaveAsImage;
}(ToolboxFeature);

var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
var radioTypes = [['line', 'bar'], ['stack']];

var MagicType =
/** @class */
function (_super) {
  __extends$1(MagicType, _super);

  function MagicType() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MagicType.prototype.getIcons = function () {
    var model = this.model;
    var availableIcons = model.get('icon');
    var icons = {};
    each(model.get('type'), function (type) {
      if (availableIcons[type]) {
        icons[type] = availableIcons[type];
      }
    });
    return icons;
  };

  MagicType.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      type: [],
      // Icon group
      icon: {
        line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
        bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
        // eslint-disable-next-line
        stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line

      },
      // `line`, `bar`, `stack`, `tiled`
      title: ecModel.getLocaleModel().get(['toolbox', 'magicType', 'title']),
      option: {},
      seriesIndex: {}
    };
    return defaultOption;
  };

  MagicType.prototype.onclick = function (ecModel, api, type) {
    var model = this.model;
    var seriesIndex = model.get(['seriesIndex', type]); // Not supported magicType

    if (!seriesOptGenreator[type]) {
      return;
    }

    var newOption = {
      series: []
    };

    var generateNewSeriesTypes = function (seriesModel) {
      var seriesType = seriesModel.subType;
      var seriesId = seriesModel.id;
      var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);

      if (newSeriesOpt) {
        // PENDING If merge original option?
        defaults(newSeriesOpt, seriesModel.option);
        newOption.series.push(newSeriesOpt);
      } // Modify boundaryGap


      var coordSys = seriesModel.coordinateSystem;

      if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
        var categoryAxis = coordSys.getAxesByScale('ordinal')[0];

        if (categoryAxis) {
          var axisDim = categoryAxis.dim;
          var axisType = axisDim + 'Axis';
          var axisModel = seriesModel.getReferringComponents(axisType, SINGLE_REFERRING).models[0];
          var axisIndex = axisModel.componentIndex;
          newOption[axisType] = newOption[axisType] || [];

          for (var i = 0; i <= axisIndex; i++) {
            newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
          }

          newOption[axisType][axisIndex].boundaryGap = type === 'bar';
        }
      }
    };

    each(radioTypes, function (radio) {
      if (indexOf(radio, type) >= 0) {
        each(radio, function (item) {
          model.setIconStatus(item, 'normal');
        });
      }
    });
    model.setIconStatus(type, 'emphasis');
    ecModel.eachComponent({
      mainType: 'series',
      query: seriesIndex == null ? null : {
        seriesIndex: seriesIndex
      }
    }, generateNewSeriesTypes);
    var newTitle;
    var currentType = type; // Change title of stack

    if (type === 'stack') {
      // use titles in model instead of ecModel
      // as stack and tiled appears in pair, just flip them
      // no need of checking stack state
      newTitle = merge$1({
        stack: model.option.title.tiled,
        tiled: model.option.title.stack
      }, model.option.title);

      if (model.get(['iconStatus', type]) !== 'emphasis') {
        currentType = 'tiled';
      }
    }

    api.dispatchAction({
      type: 'changeMagicType',
      currentType: currentType,
      newOption: newOption,
      newTitle: newTitle,
      featureName: 'magicType'
    });
  };

  return MagicType;
}(ToolboxFeature);

var seriesOptGenreator = {
  'line': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'bar') {
      return merge$1({
        id: seriesId,
        type: 'line',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get(['option', 'line']) || {}, true);
    }
  },
  'bar': function (seriesType, seriesId, seriesModel, model) {
    if (seriesType === 'line') {
      return merge$1({
        id: seriesId,
        type: 'bar',
        // Preserve data related option
        data: seriesModel.get('data'),
        stack: seriesModel.get('stack'),
        markPoint: seriesModel.get('markPoint'),
        markLine: seriesModel.get('markLine')
      }, model.get(['option', 'bar']) || {}, true);
    }
  },
  'stack': function (seriesType, seriesId, seriesModel, model) {
    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;

    if (seriesType === 'line' || seriesType === 'bar') {
      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
      return merge$1({
        id: seriesId,
        stack: isStack ? '' : INNER_STACK_KEYWORD
      }, model.get(['option', 'stack']) || {}, true);
    }
  }
}; // TODO: SELF REGISTERED.

registerAction({
  type: 'changeMagicType',
  event: 'magicTypeChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.mergeOption(payload.newOption);
});

/* global document */

var BLOCK_SPLITER = new Array(60).join('-');
var ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */

function groupSeries(ecModel) {
  var seriesGroupByCategoryAxis = {};
  var otherSeries = [];
  var meta = [];
  ecModel.eachRawSeries(function (seriesModel) {
    var coordSys = seriesModel.coordinateSystem;

    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
      // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
      var baseAxis = coordSys.getBaseAxis();

      if (baseAxis.type === 'category') {
        var key = baseAxis.dim + '_' + baseAxis.index;

        if (!seriesGroupByCategoryAxis[key]) {
          seriesGroupByCategoryAxis[key] = {
            categoryAxis: baseAxis,
            valueAxis: coordSys.getOtherAxis(baseAxis),
            series: []
          };
          meta.push({
            axisDim: baseAxis.dim,
            axisIndex: baseAxis.index
          });
        }

        seriesGroupByCategoryAxis[key].series.push(seriesModel);
      } else {
        otherSeries.push(seriesModel);
      }
    } else {
      otherSeries.push(seriesModel);
    }
  });
  return {
    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
    other: otherSeries,
    meta: meta
  };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */


function assembleSeriesWithCategoryAxis(groups) {
  var tables = [];
  each(groups, function (group, key) {
    var categoryAxis = group.categoryAxis;
    var valueAxis = group.valueAxis;
    var valueAxisDim = valueAxis.dim;
    var headers = [' '].concat(map(group.series, function (series) {
      return series.name;
    })); // @ts-ignore TODO Polar

    var columns = [categoryAxis.model.getCategories()];
    each(group.series, function (series) {
      var rawData = series.getRawData();
      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
        return val;
      }));
    }); // Assemble table content

    var lines = [headers.join(ITEM_SPLITER)];

    for (var i = 0; i < columns[0].length; i++) {
      var items = [];

      for (var j = 0; j < columns.length; j++) {
        items.push(columns[j][i]);
      }

      lines.push(items.join(ITEM_SPLITER));
    }

    tables.push(lines.join('\n'));
  });
  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 */


function assembleOtherSeries(series) {
  return map(series, function (series) {
    var data = series.getRawData();
    var lines = [series.name];
    var vals = [];
    data.each(data.dimensions, function () {
      var argLen = arguments.length;
      var dataIndex = arguments[argLen - 1];
      var name = data.getName(dataIndex);

      for (var i = 0; i < argLen - 1; i++) {
        vals[i] = arguments[i];
      }

      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
    });
    return lines.join('\n');
  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
}

function getContentFromModel(ecModel) {
  var result = groupSeries(ecModel);
  return {
    value: filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
      return !!str.replace(/[\n\t\s]/g, '');
    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
    meta: result.meta
  };
}

function trim$1(str) {
  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */


function isTSVFormat(block) {
  // Simple method to find out if a block is tsv format
  var firstLine = block.slice(0, block.indexOf('\n'));

  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
    return true;
  }
}

var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */

function parseTSVContents(tsv) {
  var tsvLines = tsv.split(/\n+/g);
  var headers = trim$1(tsvLines.shift()).split(itemSplitRegex);
  var categories = [];
  var series = map(headers, function (header) {
    return {
      name: header,
      data: []
    };
  });

  for (var i = 0; i < tsvLines.length; i++) {
    var items = trim$1(tsvLines[i]).split(itemSplitRegex);
    categories.push(items.shift());

    for (var j = 0; j < items.length; j++) {
      series[j] && (series[j].data[i] = items[j]);
    }
  }

  return {
    series: series,
    categories: categories
  };
}

function parseListContents(str) {
  var lines = str.split(/\n+/g);
  var seriesName = trim$1(lines.shift());
  var data = [];

  for (var i = 0; i < lines.length; i++) {
    // if line is empty, ignore it.
    // there is a case that a user forgot to delete `\n`.
    var line = trim$1(lines[i]);

    if (!line) {
      continue;
    }

    var items = line.split(itemSplitRegex);
    var name_1 = '';
    var value = void 0;
    var hasName = false;

    if (isNaN(items[0])) {
      // First item is name
      hasName = true;
      name_1 = items[0];
      items = items.slice(1);
      data[i] = {
        name: name_1,
        value: []
      };
      value = data[i].value;
    } else {
      value = data[i] = [];
    }

    for (var j = 0; j < items.length; j++) {
      value.push(+items[j]);
    }

    if (value.length === 1) {
      hasName ? data[i].value = value[0] : data[i] = value[0];
    }
  }

  return {
    name: seriesName,
    data: data
  };
}

function parseContents(str, blockMetaList) {
  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
  var newOption = {
    series: []
  };
  each(blocks, function (block, idx) {
    if (isTSVFormat(block)) {
      var result = parseTSVContents(block);
      var blockMeta = blockMetaList[idx];
      var axisKey = blockMeta.axisDim + 'Axis';

      if (blockMeta) {
        newOption[axisKey] = newOption[axisKey] || [];
        newOption[axisKey][blockMeta.axisIndex] = {
          data: result.categories
        };
        newOption.series = newOption.series.concat(result.series);
      }
    } else {
      var result = parseListContents(block);
      newOption.series.push(result);
    }
  });
  return newOption;
}

var DataView$1 =
/** @class */
function (_super) {
  __extends$1(DataView, _super);

  function DataView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataView.prototype.onclick = function (ecModel, api) {
    // FIXME: better way?
    setTimeout(function () {
      api.dispatchAction({
        type: 'hideTip'
      });
    });
    var container = api.getDom();
    var model = this.model;

    if (this._dom) {
      container.removeChild(this._dom);
    }

    var root = document.createElement('div'); // use padding to avoid 5px whitespace

    root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
    root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements

    var header = document.createElement('h4');
    var lang = model.get('lang') || [];
    header.innerHTML = lang[0] || model.get('title');
    header.style.cssText = 'margin:10px 20px';
    header.style.color = model.get('textColor');
    var viewMain = document.createElement('div');
    var textarea = document.createElement('textarea');
    viewMain.style.cssText = 'overflow:auto';
    var optionToContent = model.get('optionToContent');
    var contentToOption = model.get('contentToOption');
    var result = getContentFromModel(ecModel);

    if (isFunction$3(optionToContent)) {
      var htmlOrDom = optionToContent(api.getOption());

      if (isString(htmlOrDom)) {
        viewMain.innerHTML = htmlOrDom;
      } else if (isDom(htmlOrDom)) {
        viewMain.appendChild(htmlOrDom);
      }
    } else {
      // Use default textarea
      textarea.readOnly = model.get('readOnly');
      var style = textarea.style; // eslint-disable-next-line max-len

      style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
      style.color = model.get('textColor');
      style.borderColor = model.get('textareaBorderColor');
      style.backgroundColor = model.get('textareaColor');
      textarea.value = result.value;
      viewMain.appendChild(textarea);
    }

    var blockMetaList = result.meta;
    var buttonContainer = document.createElement('div');
    buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0'; // eslint-disable-next-line max-len

    var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
    var closeButton = document.createElement('div');
    var refreshButton = document.createElement('div');
    buttonStyle += ';background-color:' + model.get('buttonColor');
    buttonStyle += ';color:' + model.get('buttonTextColor');
    var self = this;

    function close() {
      container.removeChild(root);
      self._dom = null;
    }

    addEventListener(closeButton, 'click', close);
    addEventListener(refreshButton, 'click', function () {
      if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line
          warn('It seems you have just provided one of `contentToOption` and `optionToContent` functions but missed the other one. Data change is ignored.');
        }

        close();
        return;
      }

      var newOption;

      try {
        if (isFunction$3(contentToOption)) {
          newOption = contentToOption(viewMain, api.getOption());
        } else {
          newOption = parseContents(textarea.value, blockMetaList);
        }
      } catch (e) {
        close();
        throw new Error('Data view format error ' + e);
      }

      if (newOption) {
        api.dispatchAction({
          type: 'changeDataView',
          newOption: newOption
        });
      }

      close();
    });
    closeButton.innerHTML = lang[1];
    refreshButton.innerHTML = lang[2];
    refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
    !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
    buttonContainer.appendChild(closeButton);
    root.appendChild(header);
    root.appendChild(viewMain);
    root.appendChild(buttonContainer);
    viewMain.style.height = container.clientHeight - 80 + 'px';
    container.appendChild(root);
    this._dom = root;
  };

  DataView.prototype.remove = function (ecModel, api) {
    this._dom && api.getDom().removeChild(this._dom);
  };

  DataView.prototype.dispose = function (ecModel, api) {
    this.remove(ecModel, api);
  };

  DataView.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      readOnly: false,
      optionToContent: null,
      contentToOption: null,
      // eslint-disable-next-line
      icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
      title: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'title']),
      lang: ecModel.getLocaleModel().get(['toolbox', 'dataView', 'lang']),
      backgroundColor: '#fff',
      textColor: '#000',
      textareaColor: '#fff',
      textareaBorderColor: '#333',
      buttonColor: '#c23531',
      buttonTextColor: '#fff'
    };
    return defaultOption;
  };

  return DataView;
}(ToolboxFeature);
/**
 * @inner
 */


function tryMergeDataOption(newData, originalData) {
  return map(newData, function (newVal, idx) {
    var original = originalData && originalData[idx];

    if (isObject$2(original) && !isArray$1(original)) {
      var newValIsObject = isObject$2(newVal) && !isArray$1(newVal);

      if (!newValIsObject) {
        newVal = {
          value: newVal
        };
      } // original data has name but new data has no name


      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option

      newVal = defaults(newVal, original);
      shouldDeleteName && delete newVal.name;
      return newVal;
    } else {
      return newVal;
    }
  });
} // TODO: SELF REGISTERED.


registerAction({
  type: 'changeDataView',
  event: 'dataViewChanged',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  var newSeriesOptList = [];
  each(payload.newOption.series, function (seriesOpt) {
    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];

    if (!seriesModel) {
      // New created series
      // Geuss the series type
      newSeriesOptList.push(extend({
        // Default is scatter
        type: 'scatter'
      }, seriesOpt));
    } else {
      var originalData = seriesModel.get('data');
      newSeriesOptList.push({
        name: seriesOpt.name,
        data: tryMergeDataOption(seriesOpt.data, originalData)
      });
    }
  });
  ecModel.mergeOption(defaults({
    series: newSeriesOptList
  }, payload.newOption));
});

var each$9 = each;
var inner$g = makeInner();
/**
 * @param ecModel
 * @param newSnapshot key is dataZoomId
 */

function push(ecModel, newSnapshot) {
  var storedSnapshots = getStoreSnapshots(ecModel); // If previous dataZoom can not be found,
  // complete an range with current range.

  each$9(newSnapshot, function (batchItem, dataZoomId) {
    var i = storedSnapshots.length - 1;

    for (; i >= 0; i--) {
      var snapshot = storedSnapshots[i];

      if (snapshot[dataZoomId]) {
        break;
      }
    }

    if (i < 0) {
      // No origin range set, create one by current range.
      var dataZoomModel = ecModel.queryComponents({
        mainType: 'dataZoom',
        subType: 'select',
        id: dataZoomId
      })[0];

      if (dataZoomModel) {
        var percentRange = dataZoomModel.getPercentRange();
        storedSnapshots[0][dataZoomId] = {
          dataZoomId: dataZoomId,
          start: percentRange[0],
          end: percentRange[1]
        };
      }
    }
  });
  storedSnapshots.push(newSnapshot);
}
function pop(ecModel) {
  var storedSnapshots = getStoreSnapshots(ecModel);
  var head = storedSnapshots[storedSnapshots.length - 1];
  storedSnapshots.length > 1 && storedSnapshots.pop(); // Find top for all dataZoom.

  var snapshot = {};
  each$9(head, function (batchItem, dataZoomId) {
    for (var i = storedSnapshots.length - 1; i >= 0; i--) {
      batchItem = storedSnapshots[i][dataZoomId];

      if (batchItem) {
        snapshot[dataZoomId] = batchItem;
        break;
      }
    }
  });
  return snapshot;
}
function clear$1(ecModel) {
  inner$g(ecModel).snapshots = null;
}
function count(ecModel) {
  return getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */

function getStoreSnapshots(ecModel) {
  var store = inner$g(ecModel);

  if (!store.snapshots) {
    store.snapshots = [{}];
  }

  return store.snapshots;
}

var RestoreOption =
/** @class */
function (_super) {
  __extends$1(RestoreOption, _super);

  function RestoreOption() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RestoreOption.prototype.onclick = function (ecModel, api) {
    clear$1(ecModel);
    api.dispatchAction({
      type: 'restore',
      from: this.uid
    });
  };

  RestoreOption.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      // eslint-disable-next-line
      icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
      title: ecModel.getLocaleModel().get(['toolbox', 'restore', 'title'])
    };
    return defaultOption;
  };

  return RestoreOption;
}(ToolboxFeature); // TODO: SELF REGISTERED.


registerAction({
  type: 'restore',
  event: 'restore',
  update: 'prepareAndUpdate'
}, function (payload, ecModel) {
  ecModel.resetOption('recreate');
});

// how to genarialize to more coordinate systems.

var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];

var BrushTargetManager =
/** @class */
function () {
  /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */
  function BrushTargetManager(finder, ecModel, opt) {
    var _this = this;

    this._targetInfoList = [];
    var foundCpts = parseFinder$1(ecModel, finder);
    each(targetInfoBuilders, function (builder, type) {
      if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
        builder(foundCpts, _this._targetInfoList);
      }
    });
  }

  BrushTargetManager.prototype.setOutputRanges = function (areas, ecModel) {
    this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
      (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges

      if (!area.coordRange) {
        area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
        // rebuild range by coordRange accrately, which may bring trouble when
        // brushing only one item. So we use __rangeOffset to rebuilding range
        // by coordRange. And this it only used in brush component so it is no
        // need to be adapted to coordRanges.

        var result = coordConvert[area.brushType](0, coordSys, coordRange);
        area.__rangeOffset = {
          offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
          xyMinMax: result.xyMinMax
        };
      }
    });
    return areas;
  };

  BrushTargetManager.prototype.matchOutputRanges = function (areas, ecModel, cb) {
    each(areas, function (area) {
      var targetInfo = this.findTargetInfo(area, ecModel);

      if (targetInfo && targetInfo !== true) {
        each(targetInfo.coordSyses, function (coordSys) {
          var result = coordConvert[area.brushType](1, coordSys, area.range, true);
          cb(area, result.values, coordSys, ecModel);
        });
      }
    }, this);
  };
  /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */


  BrushTargetManager.prototype.setInputRanges = function (areas, ecModel) {
    each(areas, function (area) {
      var targetInfo = this.findTargetInfo(area, ecModel);

      if (process.env.NODE_ENV !== 'production') {
        assert(!targetInfo || targetInfo === true || area.coordRange, 'coordRange must be specified when coord index specified.');
        assert(!targetInfo || targetInfo !== true || area.range, 'range must be specified in global brush.');
      }

      area.range = area.range || []; // convert coordRange to global range and set panelId.

      if (targetInfo && targetInfo !== true) {
        area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
        // not keep its original value, for the sake of the dataZoom scenario,
        // where area.coordRange remains unchanged but area.range may be changed.
        // (2) Only support converting one coordRange to pixel range in brush
        // component. So do not consider `coordRanges`.
        // (3) About __rangeOffset, see comment above.

        var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
        var rangeOffset = area.__rangeOffset;
        area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
      }
    }, this);
  };

  BrushTargetManager.prototype.makePanelOpts = function (api, getDefaultBrushType) {
    return map(this._targetInfoList, function (targetInfo) {
      var rect = targetInfo.getPanelRect();
      return {
        panelId: targetInfo.panelId,
        defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
        clipPath: makeRectPanelClipPath(rect),
        isTargetByCursor: makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
        getLinearBrushOtherExtent: makeLinearBrushOtherExtent(rect)
      };
    });
  };

  BrushTargetManager.prototype.controlSeries = function (area, seriesModel, ecModel) {
    // Check whether area is bound in coord, and series do not belong to that coord.
    // If do not do this check, some brush (like lineX) will controll all axes.
    var targetInfo = this.findTargetInfo(area, ecModel);
    return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
  };
  /**
   * If return Object, a coord found.
   * If reutrn true, global found.
   * Otherwise nothing found.
   */


  BrushTargetManager.prototype.findTargetInfo = function (area, ecModel) {
    var targetInfoList = this._targetInfoList;
    var foundCpts = parseFinder$1(ecModel, area);

    for (var i = 0; i < targetInfoList.length; i++) {
      var targetInfo = targetInfoList[i];
      var areaPanelId = area.panelId;

      if (areaPanelId) {
        if (targetInfo.panelId === areaPanelId) {
          return targetInfo;
        }
      } else {
        for (var j = 0; j < targetInfoMatchers.length; j++) {
          if (targetInfoMatchers[j](foundCpts, targetInfo)) {
            return targetInfo;
          }
        }
      }
    }

    return true;
  };

  return BrushTargetManager;
}();

function formatMinMax(minMax) {
  minMax[0] > minMax[1] && minMax.reverse();
  return minMax;
}

function parseFinder$1(ecModel, finder) {
  return parseFinder(ecModel, finder, {
    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
  });
}

var targetInfoBuilders = {
  grid: function (foundCpts, targetInfoList) {
    var xAxisModels = foundCpts.xAxisModels;
    var yAxisModels = foundCpts.yAxisModels;
    var gridModels = foundCpts.gridModels; // Remove duplicated.

    var gridModelMap = createHashMap();
    var xAxesHas = {};
    var yAxesHas = {};

    if (!xAxisModels && !yAxisModels && !gridModels) {
      return;
    }

    each(xAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
    });
    each(yAxisModels, function (axisModel) {
      var gridModel = axisModel.axis.grid.model;
      gridModelMap.set(gridModel.id, gridModel);
      yAxesHas[gridModel.id] = true;
    });
    each(gridModels, function (gridModel) {
      gridModelMap.set(gridModel.id, gridModel);
      xAxesHas[gridModel.id] = true;
      yAxesHas[gridModel.id] = true;
    });
    gridModelMap.each(function (gridModel) {
      var grid = gridModel.coordinateSystem;
      var cartesians = [];
      each(grid.getCartesians(), function (cartesian, index) {
        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
          cartesians.push(cartesian);
        }
      });
      targetInfoList.push({
        panelId: 'grid--' + gridModel.id,
        gridModel: gridModel,
        coordSysModel: gridModel,
        // Use the first one as the representitive coordSys.
        coordSys: cartesians[0],
        coordSyses: cartesians,
        getPanelRect: panelRectBuilders.grid,
        xAxisDeclared: xAxesHas[gridModel.id],
        yAxisDeclared: yAxesHas[gridModel.id]
      });
    });
  },
  geo: function (foundCpts, targetInfoList) {
    each(foundCpts.geoModels, function (geoModel) {
      var coordSys = geoModel.coordinateSystem;
      targetInfoList.push({
        panelId: 'geo--' + geoModel.id,
        geoModel: geoModel,
        coordSysModel: geoModel,
        coordSys: coordSys,
        coordSyses: [coordSys],
        getPanelRect: panelRectBuilders.geo
      });
    });
  }
};
var targetInfoMatchers = [// grid
function (foundCpts, targetInfo) {
  var xAxisModel = foundCpts.xAxisModel;
  var yAxisModel = foundCpts.yAxisModel;
  var gridModel = foundCpts.gridModel;
  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
  return gridModel && gridModel === targetInfo.gridModel;
}, // geo
function (foundCpts, targetInfo) {
  var geoModel = foundCpts.geoModel;
  return geoModel && geoModel === targetInfo.geoModel;
}];
var panelRectBuilders = {
  grid: function () {
    // grid is not Transformable.
    return this.coordSys.master.getRect().clone();
  },
  geo: function () {
    var coordSys = this.coordSys;
    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform

    rect.applyTransform(getTransform(coordSys));
    return rect;
  }
};
var coordConvert = {
  lineX: curry(axisConvert, 0),
  lineY: curry(axisConvert, 1),
  rect: function (to, coordSys, rangeOrCoordRange, clamp) {
    var xminymin = to ? coordSys.pointToData([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]], clamp);
    var xmaxymax = to ? coordSys.pointToData([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp) : coordSys.dataToPoint([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]], clamp);
    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
    return {
      values: values,
      xyMinMax: values
    };
  },
  polygon: function (to, coordSys, rangeOrCoordRange, clamp) {
    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
    var values = map(rangeOrCoordRange, function (item) {
      var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
      return p;
    });
    return {
      values: values,
      xyMinMax: xyMinMax
    };
  }
};

function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
  if (process.env.NODE_ENV !== 'production') {
    assert(coordSys.type === 'cartesian2d', 'lineX/lineY brush is available only in cartesian2d.');
  }

  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
  var values = formatMinMax(map([0, 1], function (i) {
    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
  }));
  var xyMinMax = [];
  xyMinMax[axisNameIndex] = values;
  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
  return {
    values: values,
    xyMinMax: xyMinMax
  };
}

var diffProcessor = {
  lineX: curry(axisDiffProcessor, 0),
  lineY: curry(axisDiffProcessor, 1),
  rect: function (values, refer, scales) {
    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
  },
  polygon: function (values, refer, scales) {
    return map(values, function (item, idx) {
      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
    });
  }
};

function axisDiffProcessor(axisNameIndex, values, refer, scales) {
  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
} // We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]


function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
  var sizeCurr = getSize$3(xyMinMaxCurr);
  var sizeOrigin = getSize$3(xyMinMaxOrigin);
  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
  isNaN(scales[0]) && (scales[0] = 1);
  isNaN(scales[1]) && (scales[1] = 1);
  return scales;
}

function getSize$3(xyMinMax) {
  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
}

var each$a = each;
var DATA_ZOOM_ID_BASE = makeInternalComponentId('toolbox-dataZoom_');

var DataZoomFeature =
/** @class */
function (_super) {
  __extends$1(DataZoomFeature, _super);

  function DataZoomFeature() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DataZoomFeature.prototype.render = function (featureModel, ecModel, api, payload) {
    if (!this._brushController) {
      this._brushController = new BrushController(api.getZr());

      this._brushController.on('brush', bind(this._onBrush, this)).mount();
    }

    updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
    updateBackBtnStatus(featureModel, ecModel);
  };

  DataZoomFeature.prototype.onclick = function (ecModel, api, type) {
    handlers$1[type].call(this);
  };

  DataZoomFeature.prototype.remove = function (ecModel, api) {
    this._brushController && this._brushController.unmount();
  };

  DataZoomFeature.prototype.dispose = function (ecModel, api) {
    this._brushController && this._brushController.dispose();
  };

  DataZoomFeature.prototype._onBrush = function (eventParam) {
    var areas = eventParam.areas;

    if (!eventParam.isEnd || !areas.length) {
      return;
    }

    var snapshot = {};
    var ecModel = this.ecModel;

    this._brushController.updateCovers([]); // remove cover


    var brushTargetManager = new BrushTargetManager(makeAxisFinder(this.model), ecModel, {
      include: ['grid']
    });
    brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
      if (coordSys.type !== 'cartesian2d') {
        return;
      }

      var brushType = area.brushType;

      if (brushType === 'rect') {
        setBatch('x', coordSys, coordRange[0]);
        setBatch('y', coordSys, coordRange[1]);
      } else {
        setBatch({
          lineX: 'x',
          lineY: 'y'
        }[brushType], coordSys, coordRange);
      }
    });
    push(ecModel, snapshot);

    this._dispatchZoomAction(snapshot);

    function setBatch(dimName, coordSys, minMax) {
      var axis = coordSys.getAxis(dimName);
      var axisModel = axis.model;
      var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.

      var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();

      if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
        minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
      }

      dataZoomModel && (snapshot[dataZoomModel.id] = {
        dataZoomId: dataZoomModel.id,
        startValue: minMax[0],
        endValue: minMax[1]
      });
    }

    function findDataZoom(dimName, axisModel, ecModel) {
      var found;
      ecModel.eachComponent({
        mainType: 'dataZoom',
        subType: 'select'
      }, function (dzModel) {
        var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
        has && (found = dzModel);
      });
      return found;
    }
  };

  DataZoomFeature.prototype._dispatchZoomAction = function (snapshot) {
    var batch = []; // Convert from hash map to array.

    each$a(snapshot, function (batchItem, dataZoomId) {
      batch.push(clone(batchItem));
    });
    batch.length && this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      batch: batch
    });
  };

  DataZoomFeature.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      filterMode: 'filter',
      // Icon group
      icon: {
        zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
        back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
      },
      // `zoom`, `back`
      title: ecModel.getLocaleModel().get(['toolbox', 'dataZoom', 'title']),
      brushStyle: {
        borderWidth: 0,
        color: 'rgba(210,219,238,0.2)'
      }
    };
    return defaultOption;
  };

  return DataZoomFeature;
}(ToolboxFeature);

var handlers$1 = {
  zoom: function () {
    var nextActive = !this._isZoomActive;
    this.api.dispatchAction({
      type: 'takeGlobalCursor',
      key: 'dataZoomSelect',
      dataZoomSelectActive: nextActive
    });
  },
  back: function () {
    this._dispatchZoomAction(pop(this.ecModel));
  }
};

function makeAxisFinder(dzFeatureModel) {
  var setting = {
    xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
    yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
    xAxisId: dzFeatureModel.get('xAxisId', true),
    yAxisId: dzFeatureModel.get('yAxisId', true)
  }; // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
  // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
  // Some old cases set like this below to close yAxis control but leave xAxis control:
  // `{ feature: { dataZoom: { yAxisIndex: false } }`.

  if (setting.xAxisIndex == null && setting.xAxisId == null) {
    setting.xAxisIndex = 'all';
  }

  if (setting.yAxisIndex == null && setting.yAxisId == null) {
    setting.yAxisIndex = 'all';
  }

  return setting;
}

function updateBackBtnStatus(featureModel, ecModel) {
  featureModel.setIconStatus('back', count(ecModel) > 1 ? 'emphasis' : 'normal');
}

function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
  var zoomActive = view._isZoomActive;

  if (payload && payload.type === 'takeGlobalCursor') {
    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
  }

  view._isZoomActive = zoomActive;
  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
  var brushTargetManager = new BrushTargetManager(makeAxisFinder(featureModel), ecModel, {
    include: ['grid']
  });
  var panels = brushTargetManager.makePanelOpts(api, function (targetInfo) {
    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
  });

  view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
    brushType: 'auto',
    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
  } : false);
}

registerInternalOptionCreator('dataZoom', function (ecModel) {
  var toolboxModel = ecModel.getComponent('toolbox', 0);
  var featureDataZoomPath = ['feature', 'dataZoom'];

  if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) {
    return;
  }

  var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
  var dzOptions = [];
  var finder = makeAxisFinder(dzFeatureModel);
  var finderResult = parseFinder(ecModel, finder);
  each$a(finderResult.xAxisModels, function (axisModel) {
    return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
  });
  each$a(finderResult.yAxisModels, function (axisModel) {
    return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
  });

  function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
    var axisIndex = axisModel.componentIndex;
    var newOpt = {
      type: 'select',
      $fromToolbox: true,
      // Default to be filter
      filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
      // Id for merge mapping.
      id: DATA_ZOOM_ID_BASE + axisMainType + axisIndex
    };
    newOpt[axisIndexPropName] = axisIndex;
    dzOptions.push(newOpt);
  }

  return dzOptions;
});

function install$z(registers) {
  registers.registerComponentModel(ToolboxModel);
  registers.registerComponentView(ToolboxView);
  registerFeature('saveAsImage', SaveAsImage);
  registerFeature('magicType', MagicType);
  registerFeature('dataView', DataView$1);
  registerFeature('dataZoom', DataZoomFeature);
  registerFeature('restore', RestoreOption);
  use(install$y);
}

var TooltipModel =
/** @class */
function (_super) {
  __extends$1(TooltipModel, _super);

  function TooltipModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TooltipModel.type;
    return _this;
  }

  TooltipModel.type = 'tooltip';
  TooltipModel.dependencies = ['axisPointer'];
  TooltipModel.defaultOption = {
    // zlevel: 0,
    z: 60,
    show: true,
    // tooltip main content
    showContent: true,
    // 'trigger' only works on coordinate system.
    // 'item' | 'axis' | 'none'
    trigger: 'item',
    // 'click' | 'mousemove' | 'none'
    triggerOn: 'mousemove|click',
    alwaysShowContent: false,
    displayMode: 'single',
    renderMode: 'auto',
    // whether restraint content inside viewRect.
    // If renderMode: 'richText', default true.
    // If renderMode: 'html', defaut false (for backward compat).
    confine: null,
    showDelay: 0,
    hideDelay: 100,
    // Animation transition time, unit is second
    transitionDuration: 0.4,
    enterable: false,
    backgroundColor: '#fff',
    // box shadow
    shadowBlur: 10,
    shadowColor: 'rgba(0, 0, 0, .2)',
    shadowOffsetX: 1,
    shadowOffsetY: 2,
    // tooltip border radius, unit is px, default is 4
    borderRadius: 4,
    // tooltip border width, unit is px, default is 0 (no border)
    borderWidth: 1,
    // Tooltip inside padding, default is 5 for all direction
    // Array is allowed to set up, right, bottom, left, same with css
    // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
    padding: null,
    // Extra css text
    extraCssText: '',
    // axis indicator, trigger by axis
    axisPointer: {
      // default is line
      // legal values: 'line' | 'shadow' | 'cross'
      type: 'line',
      // Valid when type is line, appoint tooltip line locate on which line. Optional
      // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
      // default is 'auto', chose the axis which type is category.
      // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
      axis: 'auto',
      animation: 'auto',
      animationDurationUpdate: 200,
      animationEasingUpdate: 'exponentialOut',
      crossStyle: {
        color: '#999',
        width: 1,
        type: 'dashed',
        // TODO formatter
        textStyle: {}
      } // lineStyle and shadowStyle should not be specified here,
      // otherwise it will always override those styles on option.axisPointer.

    },
    textStyle: {
      color: '#666',
      fontSize: 14
    }
  };
  return TooltipModel;
}(ComponentModel);

/* global document */

function shouldTooltipConfine(tooltipModel) {
  var confineOption = tooltipModel.get('confine');
  return confineOption != null ? !!confineOption // In richText mode, the outside part can not be visible.
  : tooltipModel.get('renderMode') === 'richText';
}

function testStyle(styleProps) {
  if (!env.domSupported) {
    return;
  }

  var style = document.documentElement.style;

  for (var i = 0, len = styleProps.length; i < len; i++) {
    if (styleProps[i] in style) {
      return styleProps[i];
    }
  }
}

var TRANSFORM_VENDOR = testStyle(['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
var TRANSITION_VENDOR = testStyle(['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
function toCSSVendorPrefix(styleVendor, styleProp) {
  if (!styleVendor) {
    return styleProp;
  }

  styleProp = toCamelCase(styleProp, true);
  var idx = styleVendor.indexOf(styleProp);
  styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
  return styleVendor.toLowerCase();
}
function getComputedStyle$2(el, style) {
  var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
  return stl ? style ? stl[style] : stl : null;
}

/* global document, window */

var CSS_TRANSITION_VENDOR = toCSSVendorPrefix(TRANSITION_VENDOR, 'transition');
var CSS_TRANSFORM_VENDOR = toCSSVendorPrefix(TRANSFORM_VENDOR, 'transform'); // eslint-disable-next-line

var gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + (env.transform3dSupported ? 'will-change:transform;' : '');

function mirrorPos(pos) {
  pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
  return pos;
}

function assembleArrow(tooltipModel, borderColor, arrowPosition) {
  if (!isString(arrowPosition) || arrowPosition === 'inside') {
    return '';
  }

  var backgroundColor = tooltipModel.get('backgroundColor');
  var borderWidth = tooltipModel.get('borderWidth');
  borderColor = convertToColorString(borderColor);
  var arrowPos = mirrorPos(arrowPosition);
  var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
  var positionStyle = '';
  var transformStyle = CSS_TRANSFORM_VENDOR + ':';
  var rotateDeg;

  if (indexOf(['left', 'right'], arrowPos) > -1) {
    positionStyle += 'top:50%';
    transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
  } else {
    positionStyle += 'left:50%';
    transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
  }

  var rotateRadian = rotateDeg * Math.PI / 180;
  var arrowWH = arrowSize + borderWidth;
  var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
  var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
  positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
  var borderStyle = borderColor + " solid " + borderWidth + "px;";
  var styleCss = ["position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;", positionStyle + ";" + transformStyle + ";", "border-bottom:" + borderStyle, "border-right:" + borderStyle, "background-color:" + backgroundColor + ";"];
  return "<div style=\"" + styleCss.join('') + "\"></div>";
}

function assembleTransition(duration, onlyFade) {
  var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
  var transitionOption = " " + duration / 2 + "s " + transitionCurve;
  var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;

  if (!onlyFade) {
    transitionOption = " " + duration + "s " + transitionCurve;
    transitionText += env.transformSupported ? "," + CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
  }

  return CSS_TRANSITION_VENDOR + ':' + transitionText;
}

function assembleTransform(x, y, toString) {
  // If using float on style, the final width of the dom might
  // keep changing slightly while mouse move. So `toFixed(0)` them.
  var x0 = x.toFixed(0) + 'px';
  var y0 = y.toFixed(0) + 'px'; // not support transform, use `left` and `top` instead.

  if (!env.transformSupported) {
    return toString ? "top:" + y0 + ";left:" + x0 + ";" : [['top', y0], ['left', x0]];
  } // support transform


  var is3d = env.transform3dSupported;
  var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
  return toString ? 'top:0;left:0;' + CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [['top', 0], ['left', 0], [TRANSFORM_VENDOR, translate]];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */


function assembleFont(textStyleModel) {
  var cssText = [];
  var fontSize = textStyleModel.get('fontSize');
  var color = textStyleModel.getTextColor();
  color && cssText.push('color:' + color);
  cssText.push('font:' + textStyleModel.getFont());
  fontSize // @ts-ignore, leave it to the tooltip refactor.
  && cssText.push('line-height:' + Math.round(fontSize * 3 / 2) + 'px');
  var shadowColor = textStyleModel.get('textShadowColor');
  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
  shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
  each(['decoration', 'align'], function (name) {
    var val = textStyleModel.get(name);
    val && cssText.push('text-' + name + ':' + val);
  });
  return cssText.join(';');
}

function assembleCssText(tooltipModel, enableTransition, onlyFade) {
  var cssText = [];
  var transitionDuration = tooltipModel.get('transitionDuration');
  var backgroundColor = tooltipModel.get('backgroundColor');
  var shadowBlur = tooltipModel.get('shadowBlur');
  var shadowColor = tooltipModel.get('shadowColor');
  var shadowOffsetX = tooltipModel.get('shadowOffsetX');
  var shadowOffsetY = tooltipModel.get('shadowOffsetY');
  var textStyleModel = tooltipModel.getModel('textStyle');
  var padding = getPaddingFromTooltipModel(tooltipModel, 'html');
  var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
  cssText.push('box-shadow:' + boxShadow); // Animation transition. Do not animate when transitionDuration is 0.

  enableTransition && transitionDuration && cssText.push(assembleTransition(transitionDuration, onlyFade));

  if (backgroundColor) {
    cssText.push('background-color:' + backgroundColor);
  } // Border style


  each(['width', 'color', 'radius'], function (name) {
    var borderName = 'border-' + name;
    var camelCase = toCamelCase(borderName);
    var val = tooltipModel.get(camelCase);
    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
  }); // Text style

  cssText.push(assembleFont(textStyleModel)); // Padding

  if (padding != null) {
    cssText.push('padding:' + normalizeCssArray$1(padding).join('px ') + 'px');
  }

  return cssText.join(';') + ';';
} // If not able to make, do not modify the input `out`.


function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
  var zrPainter = zr && zr.painter;

  if (appendToBody) {
    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();

    if (zrViewportRoot) {
      // Some APPs might use scale on body, so we support CSS transform here.
      transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
    }
  } else {
    out[0] = zrX;
    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
    // the sibling of canvas root. So padding of ec container
    // should be considered here.

    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();

    if (viewportRootOffset) {
      out[0] += viewportRootOffset.offsetLeft;
      out[1] += viewportRootOffset.offsetTop;
    }
  }

  out[2] = out[0] / zr.getWidth();
  out[3] = out[1] / zr.getHeight();
}

var TooltipHTMLContent =
/** @class */
function () {
  function TooltipHTMLContent(container, api, opt) {
    this._show = false;
    this._styleCoord = [0, 0, 0, 0];
    this._enterable = true;
    this._firstShow = true;
    this._longHide = true;

    if (env.wxa) {
      return null;
    }

    var el = document.createElement('div'); // TODO: TYPE

    el.domBelongToZr = true;
    this.el = el;
    var zr = this._zr = api.getZr();
    var appendToBody = this._appendToBody = opt && opt.appendToBody;
    makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);

    if (appendToBody) {
      document.body.appendChild(el);
    } else {
      container.appendChild(el);
    }

    this._container = container; // FIXME
    // Is it needed to trigger zr event manually if
    // the browser do not support `pointer-events: none`.

    var self = this;

    el.onmouseenter = function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    };

    el.onmousemove = function (e) {
      e = e || window.event;

      if (!self._enterable) {
        // `pointer-events: none` is set to tooltip content div
        // if `enterable` is set as `false`, and `el.onmousemove`
        // can not be triggered. But in browser that do not
        // support `pointer-events`, we need to do this:
        // Try trigger zrender event to avoid mouse
        // in and out shape too frequently
        var handler = zr.handler;
        var zrViewportRoot = zr.painter.getViewportRoot();
        normalizeEvent(zrViewportRoot, e, true);
        handler.dispatch('mousemove', e);
      }
    };

    el.onmouseleave = function () {
      // set `_inContent` to `false` before `hideLater`
      self._inContent = false;

      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }
    };
  }
  /**
   * Update when tooltip is rendered
   */


  TooltipHTMLContent.prototype.update = function (tooltipModel) {
    // FIXME
    // Move this logic to ec main?
    var container = this._container;
    var position = getComputedStyle$2(container, 'position');
    var domStyle = container.style;

    if (domStyle.position !== 'absolute' && position !== 'absolute') {
      domStyle.position = 'relative';
    } // move tooltip if chart resized


    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveIfResized(); // update className

    this.el.className = tooltipModel.get('className') || ''; // Hide the tooltip
    // PENDING
    // this.hide();
  };

  TooltipHTMLContent.prototype.show = function (tooltipModel, nearPointColor) {
    clearTimeout(this._hideTimeout);
    clearTimeout(this._longHideTimeout);
    var el = this.el;
    var style = el.style;
    var styleCoord = this._styleCoord;

    if (!el.innerHTML) {
      style.display = 'none';
    } else {
      style.cssText = gCssText + assembleCssText(tooltipModel, !this._firstShow, this._longHide) // initial transform
      + assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + convertToColorString(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') // If mouse occasionally move over the tooltip, a mouseout event will be
      // triggered by canvas, and cause some unexpectable result like dragging
      // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
      // it. Although it is not supported by IE8~IE10, fortunately it is a rare
      // scenario.
      + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
    }

    this._show = true;
    this._firstShow = false;
    this._longHide = false;
  };

  TooltipHTMLContent.prototype.setContent = function (content, markers, tooltipModel, borderColor, arrowPosition) {
    var el = this.el;

    if (content == null) {
      el.innerHTML = '';
      return;
    }

    var arrow = '';

    if (isString(arrowPosition) && tooltipModel.get('trigger') === 'item' && !shouldTooltipConfine(tooltipModel)) {
      arrow = assembleArrow(tooltipModel, borderColor, arrowPosition);
    }

    if (isString(content)) {
      el.innerHTML = content + arrow;
    } else if (content) {
      // Clear previous
      el.innerHTML = '';

      if (!isArray$1(content)) {
        content = [content];
      }

      for (var i = 0; i < content.length; i++) {
        if (isDom(content[i]) && content[i].parentNode !== el) {
          el.appendChild(content[i]);
        }
      } // no arrow if empty


      if (arrow && el.childNodes.length) {
        // no need to create a new parent element, but it's not supported by IE 10 and older.
        // const arrowEl = document.createRange().createContextualFragment(arrow);
        var arrowEl = document.createElement('div');
        arrowEl.innerHTML = arrow;
        el.appendChild(arrowEl);
      }
    }
  };

  TooltipHTMLContent.prototype.setEnterable = function (enterable) {
    this._enterable = enterable;
  };

  TooltipHTMLContent.prototype.getSize = function () {
    var el = this.el;
    return [el.offsetWidth, el.offsetHeight];
  };

  TooltipHTMLContent.prototype.moveTo = function (zrX, zrY) {
    var styleCoord = this._styleCoord;
    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);

    if (styleCoord[0] != null && styleCoord[1] != null) {
      var style_1 = this.el.style;
      var transforms = assembleTransform(styleCoord[0], styleCoord[1]);
      each(transforms, function (transform) {
        style_1[transform[0]] = transform[1];
      });
    }
  };
  /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */


  TooltipHTMLContent.prototype._moveIfResized = function () {
    // The ratio of left to width
    var ratioX = this._styleCoord[2]; // The ratio of top to height

    var ratioY = this._styleCoord[3];
    this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
  };

  TooltipHTMLContent.prototype.hide = function () {
    var _this = this;

    var style = this.el.style;
    style.visibility = 'hidden';
    style.opacity = '0';
    env.transform3dSupported && (style.willChange = '');
    this._show = false;
    this._longHideTimeout = setTimeout(function () {
      return _this._longHide = true;
    }, 500);
  };

  TooltipHTMLContent.prototype.hideLater = function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  };

  TooltipHTMLContent.prototype.isShow = function () {
    return this._show;
  };

  TooltipHTMLContent.prototype.dispose = function () {
    this.el.parentNode.removeChild(this.el);
  };

  return TooltipHTMLContent;
}();

var TooltipRichContent =
/** @class */
function () {
  function TooltipRichContent(api) {
    this._show = false;
    this._styleCoord = [0, 0, 0, 0];
    this._enterable = true;
    this._zr = api.getZr();
    makeStyleCoord$1(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
  }
  /**
   * Update when tooltip is rendered
   */


  TooltipRichContent.prototype.update = function (tooltipModel) {
    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
    alwaysShowContent && this._moveIfResized();
  };

  TooltipRichContent.prototype.show = function () {
    if (this._hideTimeout) {
      clearTimeout(this._hideTimeout);
    }

    this.el.show();
    this._show = true;
  };
  /**
   * Set tooltip content
   */


  TooltipRichContent.prototype.setContent = function (content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
    var _this = this;

    if (isObject$2(content)) {
      throwError(process.env.NODE_ENV !== 'production' ? 'Passing DOM nodes as content is not supported in richText tooltip!' : '');
    }

    if (this.el) {
      this._zr.remove(this.el);
    }

    var textStyleModel = tooltipModel.getModel('textStyle');
    this.el = new ZRText({
      style: {
        rich: markupStyleCreator.richTextStyles,
        text: content,
        lineHeight: 22,
        borderWidth: 1,
        borderColor: borderColor,
        textShadowColor: textStyleModel.get('textShadowColor'),
        fill: tooltipModel.get(['textStyle', 'color']),
        padding: getPaddingFromTooltipModel(tooltipModel, 'richText'),
        verticalAlign: 'top',
        align: 'left'
      },
      z: tooltipModel.get('z')
    });
    each(['backgroundColor', 'borderRadius', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'], function (propName) {
      _this.el.style[propName] = tooltipModel.get(propName);
    });
    each(['textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'], function (propName) {
      _this.el.style[propName] = textStyleModel.get(propName) || 0;
    });

    this._zr.add(this.el);

    var self = this;
    this.el.on('mouseover', function () {
      // clear the timeout in hideLater and keep showing tooltip
      if (self._enterable) {
        clearTimeout(self._hideTimeout);
        self._show = true;
      }

      self._inContent = true;
    });
    this.el.on('mouseout', function () {
      if (self._enterable) {
        if (self._show) {
          self.hideLater(self._hideDelay);
        }
      }

      self._inContent = false;
    });
  };

  TooltipRichContent.prototype.setEnterable = function (enterable) {
    this._enterable = enterable;
  };

  TooltipRichContent.prototype.getSize = function () {
    var el = this.el;
    var bounding = this.el.getBoundingRect(); // bounding rect does not include shadow. For renderMode richText,
    // if overflow, it will be cut. So calculate them accurately.

    var shadowOuterSize = calcShadowOuterSize(el.style);
    return [bounding.width + shadowOuterSize.left + shadowOuterSize.right, bounding.height + shadowOuterSize.top + shadowOuterSize.bottom];
  };

  TooltipRichContent.prototype.moveTo = function (x, y) {
    var el = this.el;

    if (el) {
      var styleCoord = this._styleCoord;
      makeStyleCoord$1(styleCoord, this._zr, x, y);
      x = styleCoord[0];
      y = styleCoord[1];
      var style = el.style;
      var borderWidth = mathMaxWith0(style.borderWidth || 0);
      var shadowOuterSize = calcShadowOuterSize(style); // rich text x, y do not include border.

      el.x = x + borderWidth + shadowOuterSize.left;
      el.y = y + borderWidth + shadowOuterSize.top;
      el.markRedraw();
    }
  };
  /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */


  TooltipRichContent.prototype._moveIfResized = function () {
    // The ratio of left to width
    var ratioX = this._styleCoord[2]; // The ratio of top to height

    var ratioY = this._styleCoord[3];
    this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
  };

  TooltipRichContent.prototype.hide = function () {
    if (this.el) {
      this.el.hide();
    }

    this._show = false;
  };

  TooltipRichContent.prototype.hideLater = function (time) {
    if (this._show && !(this._inContent && this._enterable)) {
      if (time) {
        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times

        this._show = false;
        this._hideTimeout = setTimeout(bind(this.hide, this), time);
      } else {
        this.hide();
      }
    }
  };

  TooltipRichContent.prototype.isShow = function () {
    return this._show;
  };

  TooltipRichContent.prototype.dispose = function () {
    this._zr.remove(this.el);
  };

  return TooltipRichContent;
}();

function mathMaxWith0(val) {
  return Math.max(0, val);
}

function calcShadowOuterSize(style) {
  var shadowBlur = mathMaxWith0(style.shadowBlur || 0);
  var shadowOffsetX = mathMaxWith0(style.shadowOffsetX || 0);
  var shadowOffsetY = mathMaxWith0(style.shadowOffsetY || 0);
  return {
    left: mathMaxWith0(shadowBlur - shadowOffsetX),
    right: mathMaxWith0(shadowBlur + shadowOffsetX),
    top: mathMaxWith0(shadowBlur - shadowOffsetY),
    bottom: mathMaxWith0(shadowBlur + shadowOffsetY)
  };
}

function makeStyleCoord$1(out, zr, zrX, zrY) {
  out[0] = zrX;
  out[1] = zrY;
  out[2] = out[0] / zr.getWidth();
  out[3] = out[1] / zr.getHeight();
}

var proxyRect = new Rect({
  shape: {
    x: -1,
    y: -1,
    width: 2,
    height: 2
  }
});

var TooltipView =
/** @class */
function (_super) {
  __extends$1(TooltipView, _super);

  function TooltipView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TooltipView.type;
    return _this;
  }

  TooltipView.prototype.init = function (ecModel, api) {
    if (env.node || !api.getDom()) {
      return;
    }

    var tooltipModel = ecModel.getComponent('tooltip');
    var renderMode = this._renderMode = getTooltipRenderMode(tooltipModel.get('renderMode'));
    this._tooltipContent = renderMode === 'richText' ? new TooltipRichContent(api) : new TooltipHTMLContent(api.getDom(), api, {
      appendToBody: tooltipModel.get('appendToBody', true)
    });
  };

  TooltipView.prototype.render = function (tooltipModel, ecModel, api) {
    if (env.node || !api.getDom()) {
      return;
    } // Reset


    this.group.removeAll();
    this._tooltipModel = tooltipModel;
    this._ecModel = ecModel;
    this._api = api;
    /**
     * @private
     * @type {boolean}
     */

    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
    var tooltipContent = this._tooltipContent;
    tooltipContent.update(tooltipModel);
    tooltipContent.setEnterable(tooltipModel.get('enterable'));

    this._initGlobalListener();

    this._keepShow(); // PENDING
    // `mousemove` event will be triggered very frequently when the mouse moves fast,
    // which causes that the `updatePosition` function was also called frequently.
    // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
    // To avoid frequent triggering,
    // consider throttling it in 50ms when transition is enabled


    if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) {
      createOrUpdate(this, '_updatePosition', 50, 'fixRate');
    } else {
      clear(this, '_updatePosition');
    }
  };

  TooltipView.prototype._initGlobalListener = function () {
    var tooltipModel = this._tooltipModel;
    var triggerOn = tooltipModel.get('triggerOn');
    register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
      // If 'none', it is not controlled by mouse totally.
      if (triggerOn !== 'none') {
        if (triggerOn.indexOf(currTrigger) >= 0) {
          this._tryShow(e, dispatchAction);
        } else if (currTrigger === 'leave') {
          this._hide(dispatchAction);
        }
      }
    }, this));
  };

  TooltipView.prototype._keepShow = function () {
    var tooltipModel = this._tooltipModel;
    var ecModel = this._ecModel;
    var api = this._api;
    var triggerOn = tooltipModel.get('triggerOn'); // Try to keep the tooltip show when refreshing

    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
    // self.manuallyShowTip({x, y}) might cause tooltip hide,
    // which is not expected.
    && triggerOn !== 'none' && triggerOn !== 'click') {
      var self_1 = this;
      clearTimeout(this._refreshUpdateTimeout);
      this._refreshUpdateTimeout = setTimeout(function () {
        // Show tip next tick after other charts are rendered
        // In case highlight action has wrong result
        // FIXME
        !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
          x: self_1._lastX,
          y: self_1._lastY,
          dataByCoordSys: self_1._lastDataByCoordSys
        });
      });
    }
  };
  /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */


  TooltipView.prototype.manuallyShowTip = function (tooltipModel, ecModel, api, payload) {
    if (payload.from === this.uid || env.node || !api.getDom()) {
      return;
    }

    var dispatchAction = makeDispatchAction$1(payload, api); // Reset ticket

    this._ticket = ''; // When triggered from axisPointer.

    var dataByCoordSys = payload.dataByCoordSys;
    var cmptRef = findComponentReference(payload, ecModel, api);

    if (cmptRef) {
      var rect = cmptRef.el.getBoundingRect().clone();
      rect.applyTransform(cmptRef.el.transform);

      this._tryShow({
        offsetX: rect.x + rect.width / 2,
        offsetY: rect.y + rect.height / 2,
        target: cmptRef.el,
        position: payload.position,
        // When manully trigger, the mouse is not on the el, so we'd better to
        // position tooltip on the bottom of the el and display arrow is possible.
        positionDefault: 'bottom'
      }, dispatchAction);
    } else if (payload.tooltip && payload.x != null && payload.y != null) {
      var el = proxyRect;
      el.x = payload.x;
      el.y = payload.y;
      el.update();
      getECData(el).tooltipConfig = {
        name: null,
        option: payload.tooltip
      }; // Manually show tooltip while view is not using zrender elements.

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        target: el
      }, dispatchAction);
    } else if (dataByCoordSys) {
      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        dataByCoordSys: dataByCoordSys,
        tooltipOption: payload.tooltipOption
      }, dispatchAction);
    } else if (payload.seriesIndex != null) {
      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
        return;
      }

      var pointInfo = findPointFromSeries(payload, ecModel);
      var cx = pointInfo.point[0];
      var cy = pointInfo.point[1];

      if (cx != null && cy != null) {
        this._tryShow({
          offsetX: cx,
          offsetY: cy,
          target: pointInfo.el,
          position: payload.position,
          // When manully trigger, the mouse is not on the el, so we'd better to
          // position tooltip on the bottom of the el and display arrow is possible.
          positionDefault: 'bottom'
        }, dispatchAction);
      }
    } else if (payload.x != null && payload.y != null) {
      // FIXME
      // should wrap dispatchAction like `axisPointer/globalListener` ?
      api.dispatchAction({
        type: 'updateAxisPointer',
        x: payload.x,
        y: payload.y
      });

      this._tryShow({
        offsetX: payload.x,
        offsetY: payload.y,
        position: payload.position,
        target: api.getZr().findHover(payload.x, payload.y).target
      }, dispatchAction);
    }
  };

  TooltipView.prototype.manuallyHideTip = function (tooltipModel, ecModel, api, payload) {
    var tooltipContent = this._tooltipContent;

    if (!this._alwaysShowContent && this._tooltipModel) {
      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
    }

    this._lastX = this._lastY = this._lastDataByCoordSys = null;

    if (payload.from !== this.uid) {
      this._hide(makeDispatchAction$1(payload, api));
    }
  }; // Be compatible with previous design, that is, when tooltip.type is 'axis' and
  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
  // and tooltip.


  TooltipView.prototype._manuallyAxisShowTip = function (tooltipModel, ecModel, api, payload) {
    var seriesIndex = payload.seriesIndex;
    var dataIndex = payload.dataIndex; // @ts-ignore

    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;

    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
      return;
    }

    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);

    if (!seriesModel) {
      return;
    }

    var data = seriesModel.getData();
    var tooltipCascadedModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model], this._tooltipModel);

    if (tooltipCascadedModel.get('trigger') !== 'axis') {
      return;
    }

    api.dispatchAction({
      type: 'updateAxisPointer',
      seriesIndex: seriesIndex,
      dataIndex: dataIndex,
      position: payload.position
    });
    return true;
  };

  TooltipView.prototype._tryShow = function (e, dispatchAction) {
    var el = e.target;
    var tooltipModel = this._tooltipModel;

    if (!tooltipModel) {
      return;
    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed


    this._lastX = e.offsetX;
    this._lastY = e.offsetY;
    var dataByCoordSys = e.dataByCoordSys;

    if (dataByCoordSys && dataByCoordSys.length) {
      this._showAxisTooltip(dataByCoordSys, e);
    } else if (el) {
      this._lastDataByCoordSys = null;
      var seriesDispatcher_1;
      var cmptDispatcher_1;
      findEventDispatcher(el, function (target) {
        // Always show item tooltip if mouse is on the element with dataIndex
        if (getECData(target).dataIndex != null) {
          seriesDispatcher_1 = target;
          return true;
        } // Tooltip provided directly. Like legend.


        if (getECData(target).tooltipConfig != null) {
          cmptDispatcher_1 = target;
          return true;
        }
      }, true);

      if (seriesDispatcher_1) {
        this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
      } else if (cmptDispatcher_1) {
        this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
      } else {
        this._hide(dispatchAction);
      }
    } else {
      this._lastDataByCoordSys = null;

      this._hide(dispatchAction);
    }
  };

  TooltipView.prototype._showOrMove = function (tooltipModel, cb) {
    // showDelay is used in this case: tooltip.enterable is set
    // as true. User intent to move mouse into tooltip and click
    // something. `showDelay` makes it easier to enter the content
    // but tooltip do not move immediately.
    var delay = tooltipModel.get('showDelay');
    cb = bind(cb, this);
    clearTimeout(this._showTimout);
    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
  };

  TooltipView.prototype._showAxisTooltip = function (dataByCoordSys, e) {
    var ecModel = this._ecModel;
    var globalTooltipModel = this._tooltipModel;
    var point = [e.offsetX, e.offsetY];
    var singleTooltipModel = buildTooltipModel([e.tooltipOption], globalTooltipModel);
    var renderMode = this._renderMode;
    var cbParamsList = [];
    var articleMarkup = createTooltipMarkup('section', {
      blocks: [],
      noHeader: true
    }); // Only for legacy: `Serise['formatTooltip']` returns a string.

    var markupTextArrLegacy = [];
    var markupStyleCreator = new TooltipMarkupStyleCreator();
    each(dataByCoordSys, function (itemCoordSys) {
      each(itemCoordSys.dataByAxis, function (axisItem) {
        var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
        var axisValue = axisItem.value;

        if (!axisModel || axisValue == null) {
          return;
        }

        var axisValueLabel = getValueLabel(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
        var axisSectionMarkup = createTooltipMarkup('section', {
          header: axisValueLabel,
          noHeader: !trim(axisValueLabel),
          sortBlocks: true,
          blocks: []
        });
        articleMarkup.blocks.push(axisSectionMarkup);
        each(axisItem.seriesDataIndices, function (idxItem) {
          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
          var dataIndex = idxItem.dataIndexInside;
          var cbParams = series.getDataParams(dataIndex); // Can't find data.

          if (cbParams.dataIndex < 0) {
            return;
          }

          cbParams.axisDim = axisItem.axisDim;
          cbParams.axisIndex = axisItem.axisIndex;
          cbParams.axisType = axisItem.axisType;
          cbParams.axisId = axisItem.axisId;
          cbParams.axisValue = getAxisRawValue(axisModel.axis, {
            value: axisValue
          });
          cbParams.axisValueLabel = axisValueLabel; // Pre-create marker style for makers. Users can assemble richText
          // text in `formatter` callback and use those markers style.

          cbParams.marker = markupStyleCreator.makeTooltipMarker('item', convertToColorString(cbParams.color), renderMode);
          var seriesTooltipResult = normalizeTooltipFormatResult(series.formatTooltip(dataIndex, true, null));
          var frag = seriesTooltipResult.frag;

          if (frag) {
            var valueFormatter = buildTooltipModel([series], globalTooltipModel).get('valueFormatter');
            axisSectionMarkup.blocks.push(valueFormatter ? extend({
              valueFormatter: valueFormatter
            }, frag) : frag);
          }

          if (seriesTooltipResult.text) {
            markupTextArrLegacy.push(seriesTooltipResult.text);
          }

          cbParamsList.push(cbParams);
        });
      });
    }); // In most cases, the second axis is displays upper on the first one.
    // So we reverse it to look better.

    articleMarkup.blocks.reverse();
    markupTextArrLegacy.reverse();
    var positionExpr = e.position;
    var orderMode = singleTooltipModel.get('order');
    var builtMarkupText = buildTooltipMarkup(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
    builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
    var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
    var allMarkupText = markupTextArrLegacy.join(blockBreak);

    this._showOrMove(singleTooltipModel, function () {
      if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) {
        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
      } else {
        this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
      }
    }); // Do not trigger events here, because this branch only be entered
    // from dispatchAction.

  };

  TooltipView.prototype._showSeriesItemTooltip = function (e, dispatcher, dispatchAction) {
    var ecModel = this._ecModel;
    var ecData = getECData(dispatcher); // Use dataModel in element if possible
    // Used when mouseover on a element like markPoint or edge
    // In which case, the data is not main data in series.

    var seriesIndex = ecData.seriesIndex;
    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.

    var dataModel = ecData.dataModel || seriesModel;
    var dataIndex = ecData.dataIndex;
    var dataType = ecData.dataType;
    var data = dataModel.getData(dataType);
    var renderMode = this._renderMode;
    var positionDefault = e.positionDefault;
    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model], this._tooltipModel, positionDefault ? {
      position: positionDefault
    } : null);
    var tooltipTrigger = tooltipModel.get('trigger');

    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
      return;
    }

    var params = dataModel.getDataParams(dataIndex, dataType);
    var markupStyleCreator = new TooltipMarkupStyleCreator(); // Pre-create marker style for makers. Users can assemble richText
    // text in `formatter` callback and use those markers style.

    params.marker = markupStyleCreator.makeTooltipMarker('item', convertToColorString(params.color), renderMode);
    var seriesTooltipResult = normalizeTooltipFormatResult(dataModel.formatTooltip(dataIndex, false, dataType));
    var orderMode = tooltipModel.get('order');
    var valueFormatter = tooltipModel.get('valueFormatter');
    var frag = seriesTooltipResult.frag;
    var markupText = frag ? buildTooltipMarkup(valueFormatter ? extend({
      valueFormatter: valueFormatter
    }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;

    this._showOrMove(tooltipModel, function () {
      this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
    }); // FIXME
    // duplicated showtip if manuallyShowTip is called from dispatchAction.


    dispatchAction({
      type: 'showTip',
      dataIndexInside: dataIndex,
      dataIndex: data.getRawIndex(dataIndex),
      seriesIndex: seriesIndex,
      from: this.uid
    });
  };

  TooltipView.prototype._showComponentItemTooltip = function (e, el, dispatchAction) {
    var ecData = getECData(el);
    var tooltipConfig = ecData.tooltipConfig;
    var tooltipOpt = tooltipConfig.option || {};

    if (isString(tooltipOpt)) {
      var content = tooltipOpt;
      tooltipOpt = {
        content: content,
        // Fixed formatter
        formatter: content
      };
    }

    var tooltipModelCascade = [tooltipOpt];

    var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);

    if (cmpt) {
      tooltipModelCascade.push(cmpt);
    } // In most cases, component tooltip formatter has different params with series tooltip formatter,
    // so that they can not share the same formatter. Since the global tooltip formatter is used for series
    // by convension, we do not use it as the default formatter for component.


    tooltipModelCascade.push({
      formatter: tooltipOpt.content
    });
    var positionDefault = e.positionDefault;
    var subTooltipModel = buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
      position: positionDefault
    } : null);
    var defaultHtml = subTooltipModel.get('content');
    var asyncTicket = Math.random() + ''; // PENDING: this case do not support richText style yet.

    var markupStyleCreator = new TooltipMarkupStyleCreator(); // Do not check whether `trigger` is 'none' here, because `trigger`
    // only works on coordinate system. In fact, we have not found case
    // that requires setting `trigger` nothing on component yet.

    this._showOrMove(subTooltipModel, function () {
      // Use formatterParams from element defined in component
      // Avoid users modify it.
      var formatterParams = clone(subTooltipModel.get('formatterParams') || {});

      this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
    }); // If not dispatch showTip, tip may be hide triggered by axis.


    dispatchAction({
      type: 'showTip',
      from: this.uid
    });
  };

  TooltipView.prototype._showTooltipContent = function ( // Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
  // Instead of top level tooltip.
  tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
    // Reset ticket
    this._ticket = '';

    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
      return;
    }

    var tooltipContent = this._tooltipContent;
    tooltipContent.setEnterable(tooltipModel.get('enterable'));
    var formatter = tooltipModel.get('formatter');
    positionExpr = positionExpr || tooltipModel.get('position');
    var html = defaultHtml;

    var nearPoint = this._getNearestPoint([x, y], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));

    var nearPointColor = nearPoint.color;

    if (formatter) {
      if (isString(formatter)) {
        var useUTC = tooltipModel.ecModel.get('useUTC');
        var params0 = isArray$1(params) ? params[0] : params;
        var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
        html = formatter;

        if (isTimeAxis) {
          html = format$1(params0.axisValue, html, useUTC);
        }

        html = formatTpl(html, params, true);
      } else if (isFunction$3(formatter)) {
        var callback = bind(function (cbTicket, html) {
          if (cbTicket === this._ticket) {
            tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);

            this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
          }
        }, this);
        this._ticket = asyncTicket;
        html = formatter(params, asyncTicket, callback);
      } else {
        html = formatter;
      }
    }

    tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
    tooltipContent.show(tooltipModel, nearPointColor);

    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
  };

  TooltipView.prototype._getNearestPoint = function (point, tooltipDataParams, trigger, borderColor) {
    if (trigger === 'axis' || isArray$1(tooltipDataParams)) {
      return {
        color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
      };
    }

    if (!isArray$1(tooltipDataParams)) {
      return {
        color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
      };
    }
  };

  TooltipView.prototype._updatePosition = function (tooltipModel, positionExpr, x, // Mouse x
  y, // Mouse y
  content, params, el) {
    var viewWidth = this._api.getWidth();

    var viewHeight = this._api.getHeight();

    positionExpr = positionExpr || tooltipModel.get('position');
    var contentSize = content.getSize();
    var align = tooltipModel.get('align');
    var vAlign = tooltipModel.get('verticalAlign');
    var rect = el && el.getBoundingRect().clone();
    el && rect.applyTransform(el.transform);

    if (isFunction$3(positionExpr)) {
      // Callback of position can be an array or a string specify the position
      positionExpr = positionExpr([x, y], params, content.el, rect, {
        viewSize: [viewWidth, viewHeight],
        contentSize: contentSize.slice()
      });
    }

    if (isArray$1(positionExpr)) {
      x = parsePercent$1(positionExpr[0], viewWidth);
      y = parsePercent$1(positionExpr[1], viewHeight);
    } else if (isObject$2(positionExpr)) {
      var boxLayoutPosition = positionExpr;
      boxLayoutPosition.width = contentSize[0];
      boxLayoutPosition.height = contentSize[1];
      var layoutRect = getLayoutRect$1(boxLayoutPosition, {
        width: viewWidth,
        height: viewHeight
      });
      x = layoutRect.x;
      y = layoutRect.y;
      align = null; // When positionExpr is left/top/right/bottom,
      // align and verticalAlign will not work.

      vAlign = null;
    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
    else if (isString(positionExpr) && el) {
        var pos = calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
        x = pos[0];
        y = pos[1];
      } else {
        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
        x = pos[0];
        y = pos[1];
      }

    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);

    if (shouldTooltipConfine(tooltipModel)) {
      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
      x = pos[0];
      y = pos[1];
    }

    content.moveTo(x, y);
  }; // FIXME
  // Should we remove this but leave this to user?


  TooltipView.prototype._updateContentNotChangedOnAxis = function (dataByCoordSys, cbParamsList) {
    var lastCoordSys = this._lastDataByCoordSys;
    var lastCbParamsList = this._cbParamsList;
    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
      var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
      contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
        var thisItem = thisDataByAxis[indexAxis] || {};
        var lastIndices = lastItem.seriesDataIndices || [];
        var newIndices = thisItem.seriesDataIndices || [];
        contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
          var newIdxItem = newIndices[j];
          contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
        }); // check is cbParams data value changed

        lastCbParamsList && each(lastItem.seriesDataIndices, function (idxItem) {
          var seriesIdx = idxItem.seriesIndex;
          var cbParams = cbParamsList[seriesIdx];
          var lastCbParams = lastCbParamsList[seriesIdx];

          if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) {
            contentNotChanged = false;
          }
        });
      });
    });
    this._lastDataByCoordSys = dataByCoordSys;
    this._cbParamsList = cbParamsList;
    return !!contentNotChanged;
  };

  TooltipView.prototype._hide = function (dispatchAction) {
    // Do not directly hideLater here, because this behavior may be prevented
    // in dispatchAction when showTip is dispatched.
    // FIXME
    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
    this._lastDataByCoordSys = null;
    dispatchAction({
      type: 'hideTip',
      from: this.uid
    });
  };

  TooltipView.prototype.dispose = function (ecModel, api) {
    if (env.node || !api.getDom()) {
      return;
    }

    clear(this, '_updatePosition');

    this._tooltipContent.dispose();

    unregister('itemTooltip', api);
  };

  TooltipView.type = 'tooltip';
  return TooltipView;
}(ComponentView);
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */


function buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
  // Last is always tooltip model.
  var ecModel = globalTooltipModel.ecModel;
  var resultModel;

  if (defaultTooltipOption) {
    resultModel = new Model(defaultTooltipOption, ecModel, ecModel);
    resultModel = new Model(globalTooltipModel.option, resultModel, ecModel);
  } else {
    resultModel = globalTooltipModel;
  }

  for (var i = modelCascade.length - 1; i >= 0; i--) {
    var tooltipOpt = modelCascade[i];

    if (tooltipOpt) {
      if (tooltipOpt instanceof Model) {
        tooltipOpt = tooltipOpt.get('tooltip', true);
      } // In each data item tooltip can be simply write:
      // {
      //  value: 10,
      //  tooltip: 'Something you need to know'
      // }


      if (isString(tooltipOpt)) {
        tooltipOpt = {
          formatter: tooltipOpt
        };
      }

      if (tooltipOpt) {
        resultModel = new Model(tooltipOpt, resultModel, ecModel);
      }
    }
  }

  return resultModel;
}

function makeDispatchAction$1(payload, api) {
  return payload.dispatchAction || bind(api.dispatchAction, api);
}

function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
  var size = content.getSize();
  var width = size[0];
  var height = size[1];

  if (gapH != null) {
    // Add extra 2 pixels for this case:
    // At present the "values" in defaut tooltip are using CSS `float: right`.
    // When the right edge of the tooltip box is on the right side of the
    // viewport, the `float` layout might push the "values" to the second line.
    if (x + width + gapH + 2 > viewWidth) {
      x -= width + gapH;
    } else {
      x += gapH;
    }
  }

  if (gapV != null) {
    if (y + height + gapV > viewHeight) {
      y -= height + gapV;
    } else {
      y += gapV;
    }
  }

  return [x, y];
}

function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
  var size = content.getSize();
  var width = size[0];
  var height = size[1];
  x = Math.min(x + width, viewWidth) - width;
  y = Math.min(y + height, viewHeight) - height;
  x = Math.max(x, 0);
  y = Math.max(y, 0);
  return [x, y];
}

function calcTooltipPosition(position, rect, contentSize, borderWidth) {
  var domWidth = contentSize[0];
  var domHeight = contentSize[1];
  var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
  var x = 0;
  var y = 0;
  var rectWidth = rect.width;
  var rectHeight = rect.height;

  switch (position) {
    case 'inside':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'top':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y - domHeight - offset;
      break;

    case 'bottom':
      x = rect.x + rectWidth / 2 - domWidth / 2;
      y = rect.y + rectHeight + offset;
      break;

    case 'left':
      x = rect.x - domWidth - offset;
      y = rect.y + rectHeight / 2 - domHeight / 2;
      break;

    case 'right':
      x = rect.x + rectWidth + offset;
      y = rect.y + rectHeight / 2 - domHeight / 2;
  }

  return [x, y];
}

function isCenterAlign(align) {
  return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */


function findComponentReference(payload, ecModel, api) {
  var queryOptionMap = preParseFinder(payload).queryOptionMap;
  var componentMainType = queryOptionMap.keys()[0];

  if (!componentMainType || componentMainType === 'series') {
    return;
  }

  var queryResult = queryReferringComponents(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
    useDefault: false,
    enableAll: false,
    enableNone: false
  });
  var model = queryResult.models[0];

  if (!model) {
    return;
  }

  var view = api.getViewOfComponentModel(model);
  var el;
  view.group.traverse(function (subEl) {
    var tooltipConfig = getECData(subEl).tooltipConfig;

    if (tooltipConfig && tooltipConfig.name === payload.name) {
      el = subEl;
      return true; // stop
    }
  });

  if (el) {
    return {
      componentMainType: componentMainType,
      componentIndex: model.componentIndex,
      el: el
    };
  }
}

function install$A(registers) {
  use(install$s);
  registers.registerComponentModel(TooltipModel);
  registers.registerComponentView(TooltipView);
  /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */

  registers.registerAction({
    type: 'showTip',
    event: 'showTip',
    update: 'tooltip:manuallyShowTip'
  }, noop$2);
  registers.registerAction({
    type: 'hideTip',
    event: 'hideTip',
    update: 'tooltip:manuallyHideTip'
  }, noop$2);
}

var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
function brushPreprocessor(option, isNew) {
  var brushComponents = normalizeToArray(option ? option.brush : []);

  if (!brushComponents.length) {
    return;
  }

  var brushComponentSpecifiedBtns = [];
  each(brushComponents, function (brushOpt) {
    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];

    if (tbs instanceof Array) {
      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    }
  });
  var toolbox = option && option.toolbox;

  if (isArray$1(toolbox)) {
    toolbox = toolbox[0];
  }

  if (!toolbox) {
    toolbox = {
      feature: {}
    };
    option.toolbox = [toolbox];
  }

  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
  removeDuplicate(brushTypes);

  if (isNew && !brushTypes.length) {
    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
  }
}

function removeDuplicate(arr) {
  var map = {};
  each(arr, function (val) {
    map[val] = 1;
  });
  arr.length = 0;
  each(map, function (flag, val) {
    arr.push(val);
  });
}

var each$b = each;

function hasKeys(obj) {
  if (obj) {
    for (var name_1 in obj) {
      if (obj.hasOwnProperty(name_1)) {
        return true;
      }
    }
  }
}

function createVisualMappings(option, stateList, supplementVisualOption) {
  var visualMappings = {};
  each$b(stateList, function (state) {
    var mappings = visualMappings[state] = createMappings();
    each$b(option[state], function (visualData, visualType) {
      if (!VisualMapping.isValidType(visualType)) {
        return;
      }

      var mappingOption = {
        type: visualType,
        visual: visualData
      };
      supplementVisualOption && supplementVisualOption(mappingOption, state);
      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
      // is not supported, such as rendering using gradient color.

      if (visualType === 'opacity') {
        mappingOption = clone(mappingOption);
        mappingOption.type = 'colorAlpha';
        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
      }
    });
  });
  return visualMappings;

  function createMappings() {
    var Creater = function () {}; // Make sure hidden fields will not be visited by
    // object iteration (with hasOwnProperty checking).


    Creater.prototype.__hidden = Creater.prototype;
    var obj = new Creater();
    return obj;
  }
}
function replaceVisualOption(thisOption, newOption, keys) {
  // Visual attributes merge is not supported, otherwise it
  // brings overcomplicated merge logic. See #2853. So if
  // newOption has anyone of these keys, all of these keys
  // will be reset. Otherwise, all keys remain.
  var has;
  each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      has = true;
    }
  });
  has && each(keys, function (key) {
    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
      thisOption[key] = clone(newOption[key]);
    } else {
      delete thisOption[key];
    }
  });
}
/**
 * @param stateList
 * @param visualMappings
 * @param list
 * @param getValueState param: valueOrIndex, return: state.
 * @param scope Scope for getValueState
 * @param dimension Concrete dimension, if used.
 */
// ???! handle brush?

function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
  var visualTypesMap = {};
  each(stateList, function (state) {
    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  var dataIndex;

  function getVisual(key) {
    return getItemVisualFromData(data, dataIndex, key);
  }

  function setVisual(key, value) {
    setItemVisualFromData(data, dataIndex, key, value);
  }

  if (dimension == null) {
    data.each(eachItem);
  } else {
    data.each([dimension], eachItem);
  }

  function eachItem(valueOrIndex, index) {
    dataIndex = dimension == null ? valueOrIndex // First argument is index
    : index;
    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
    // @ts-ignore

    if (rawDataItem && rawDataItem.visualMap === false) {
      return;
    }

    var valueState = getValueState.call(scope, valueOrIndex);
    var mappings = visualMappings[valueState];
    var visualTypes = visualTypesMap[valueState];

    for (var i = 0, len = visualTypes.length; i < len; i++) {
      var type = visualTypes[i];
      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
    }
  }
}
/**
 * @param data
 * @param stateList
 * @param visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
 * @param getValueState param: valueOrIndex, return: state.
 * @param dim dimension or dimension index.
 */

function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
  var visualTypesMap = {};
  each(stateList, function (state) {
    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
    visualTypesMap[state] = visualTypes;
  });
  return {
    progress: function progress(params, data) {
      var dimIndex;

      if (dim != null) {
        dimIndex = data.getDimensionIndex(dim);
      }

      function getVisual(key) {
        return getItemVisualFromData(data, dataIndex, key);
      }

      function setVisual(key, value) {
        setItemVisualFromData(data, dataIndex, key, value);
      }

      var dataIndex;
      var store = data.getStore();

      while ((dataIndex = params.next()) != null) {
        var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
        // @ts-ignore

        if (rawDataItem && rawDataItem.visualMap === false) {
          continue;
        }

        var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
        var valueState = getValueState(value);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];

        for (var i = 0, len = visualTypes.length; i < len; i++) {
          var type = visualTypes[i];
          mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
        }
      }
    }
  };
}

function makeBrushCommonSelectorForSeries(area) {
  var brushType = area.brushType; // Do not use function binding or curry for performance.

  var selectors = {
    point: function (itemLayout) {
      return selector[brushType].point(itemLayout, selectors, area);
    },
    rect: function (itemLayout) {
      return selector[brushType].rect(itemLayout, selectors, area);
    }
  };
  return selectors;
}
var selector = {
  lineX: getLineSelectors(0),
  lineY: getLineSelectors(1),
  rect: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.intersect(itemLayout);
    }
  },
  polygon: {
    point: function (itemLayout, selectors, area) {
      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && contain$2(area.range, itemLayout[0], itemLayout[1]);
    },
    rect: function (itemLayout, selectors, area) {
      var points = area.range;

      if (!itemLayout || points.length <= 1) {
        return false;
      }

      var x = itemLayout.x;
      var y = itemLayout.y;
      var width = itemLayout.width;
      var height = itemLayout.height;
      var p = points[0];

      if (contain$2(points, x, y) || contain$2(points, x + width, y) || contain$2(points, x, y + height) || contain$2(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
        return true;
      }
    }
  }
};

function getLineSelectors(xyIndex) {
  var xy = ['x', 'y'];
  var wh = ['width', 'height'];
  return {
    point: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var p = itemLayout[xyIndex];
        return inLineRange(p, range);
      }
    },
    rect: function (itemLayout, selectors, area) {
      if (itemLayout) {
        var range = area.range;
        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
      }
    }
  };
}

function inLineRange(p, range) {
  return range[0] <= p && p <= range[1];
}

var STATE_LIST = ['inBrush', 'outOfBrush'];
var DISPATCH_METHOD = '__ecBrushSelect';
var DISPATCH_FLAG = '__ecInBrushSelectEvent';
function layoutCovers(ecModel) {
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
  });
}
/**
 * Register the visual encoding if this modules required.
 */

function brushVisual(ecModel, api, payload) {
  var brushSelected = [];
  var throttleType;
  var throttleDelay;
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel) {
    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
      brushType: false
    });
  });
  layoutCovers(ecModel);
  ecModel.eachComponent({
    mainType: 'brush'
  }, function (brushModel, brushIndex) {
    var thisBrushSelected = {
      brushId: brushModel.id,
      brushIndex: brushIndex,
      brushName: brushModel.name,
      areas: clone(brushModel.areas),
      selected: []
    }; // Every brush component exists in event params, convenient
    // for user to find by index.

    brushSelected.push(thisBrushSelected);
    var brushOption = brushModel.option;
    var brushLink = brushOption.brushLink;
    var linkedSeriesMap = [];
    var selectedDataIndexForLink = [];
    var rangeInfoBySeries = [];
    var hasBrushExists = false;

    if (!brushIndex) {
      // Only the first throttle setting works.
      throttleType = brushOption.throttleType;
      throttleDelay = brushOption.throttleDelay;
    } // Add boundingRect and selectors to range.


    var areas = map(brushModel.areas, function (area) {
      var builder = boundingRectBuilders[area.brushType];
      var selectableArea = defaults({
        boundingRect: builder ? builder(area) : void 0
      }, area);
      selectableArea.selectors = makeBrushCommonSelectorForSeries(selectableArea);
      return selectableArea;
    });
    var visualMappings = createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
      mappingOption.mappingMethod = 'fixed';
    });
    isArray$1(brushLink) && each(brushLink, function (seriesIndex) {
      linkedSeriesMap[seriesIndex] = 1;
    });

    function linkOthers(seriesIndex) {
      return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
    } // If no supported brush or no brush on the series,
    // all visuals should be in original state.


    function brushed(rangeInfoList) {
      return !!rangeInfoList.length;
    }
    /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */
    // Step A


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
    });

    function stepAParallel(seriesModel, seriesIndex) {
      var coordSys = seriesModel.coordinateSystem;
      hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
      });
    }

    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
      if (!seriesModel.brushSelector || brushModelNotControll(brushModel, seriesIndex)) {
        return;
      }

      each(areas, function (area) {
        if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) {
          rangeInfoList.push(area);
        }

        hasBrushExists = hasBrushExists || brushed(rangeInfoList);
      });

      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
        var data_1 = seriesModel.getData();
        data_1.each(function (dataIndex) {
          if (checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) {
            selectedDataIndexForLink[dataIndex] = 1;
          }
        });
      }
    } // Step B


    ecModel.eachSeries(function (seriesModel, seriesIndex) {
      var seriesBrushSelected = {
        seriesId: seriesModel.id,
        seriesIndex: seriesIndex,
        seriesName: seriesModel.name,
        dataIndex: []
      }; // Every series exists in event params, convenient
      // for user to find series by seriesIndex.

      thisBrushSelected.selected.push(seriesBrushSelected);
      var rangeInfoList = rangeInfoBySeries[seriesIndex];
      var data = seriesModel.getData();
      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      } : function (dataIndex) {
        return checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
      }; // If no supported brush or no brush, all visuals are in original state.

      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && applyVisual(STATE_LIST, visualMappings, data, getValueState);
    });
  });
  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}

function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
  // This event will not be triggered when `setOpion`, otherwise dead lock may
  // triggered when do `setOption` in event listener, which we do not find
  // satisfactory way to solve yet. Some considered resolutions:
  // (a) Diff with prevoius selected data ant only trigger event when changed.
  // But store previous data and diff precisely (i.e., not only by dataIndex, but
  // also detect value changes in selected data) might bring complexity or fragility.
  // (b) Use spectial param like `silent` to suppress event triggering.
  // But such kind of volatile param may be weird in `setOption`.
  if (!payload) {
    return;
  }

  var zr = api.getZr();

  if (zr[DISPATCH_FLAG]) {
    return;
  }

  if (!zr[DISPATCH_METHOD]) {
    zr[DISPATCH_METHOD] = doDispatch;
  }

  var fn = createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
  fn(api, brushSelected);
}

function doDispatch(api, brushSelected) {
  if (!api.isDisposed()) {
    var zr = api.getZr();
    zr[DISPATCH_FLAG] = true;
    api.dispatchAction({
      type: 'brushSelect',
      batch: brushSelected
    });
    zr[DISPATCH_FLAG] = false;
  }
}

function checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
    var area = rangeInfoList[i];

    if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) {
      return true;
    }
  }
}

function brushModelNotControll(brushModel, seriesIndex) {
  var seriesIndices = brushModel.option.seriesIndex;
  return seriesIndices != null && seriesIndices !== 'all' && (isArray$1(seriesIndices) ? indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}

var boundingRectBuilders = {
  rect: function (area) {
    return getBoundingRectFromMinMax(area.range);
  },
  polygon: function (area) {
    var minMax;
    var range = area.range;

    for (var i = 0, len = range.length; i < len; i++) {
      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
      var rg = range[i];
      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
    }

    return minMax && getBoundingRectFromMinMax(minMax);
  }
};

function getBoundingRectFromMinMax(minMax) {
  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}

var BrushView =
/** @class */
function (_super) {
  __extends$1(BrushView, _super);

  function BrushView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BrushView.type;
    return _this;
  }

  BrushView.prototype.init = function (ecModel, api) {
    this.ecModel = ecModel;
    this.api = api;
    this.model;
    (this._brushController = new BrushController(api.getZr())).on('brush', bind(this._onBrush, this)).mount();
  };

  BrushView.prototype.render = function (brushModel, ecModel, api, payload) {
    this.model = brushModel;

    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateTransform = function (brushModel, ecModel, api, payload) {
    // PENDING: `updateTransform` is a little tricky, whose layout need
    // to be calculate mandatorily and other stages will not be performed.
    // Take care the correctness of the logic. See #11754 .
    layoutCovers(ecModel);

    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateVisual = function (brushModel, ecModel, api, payload) {
    this.updateTransform(brushModel, ecModel, api, payload);
  };

  BrushView.prototype.updateView = function (brushModel, ecModel, api, payload) {
    this._updateController(brushModel, ecModel, api, payload);
  };

  BrushView.prototype._updateController = function (brushModel, ecModel, api, payload) {
    // Do not update controller when drawing.
    (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
  }; // updateLayout: updateController,
  // updateVisual: updateController,


  BrushView.prototype.dispose = function () {
    this._brushController.dispose();
  };

  BrushView.prototype._onBrush = function (eventParam) {
    var modelId = this.model.id;
    var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
    // emits the same params with the last drag move event, and
    // may have some delay when using touch pad, which makes
    // animation not smooth (when using debounce).

    (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
      type: 'brush',
      brushId: modelId,
      areas: clone(areas),
      $from: modelId
    });
    eventParam.isEnd && this.api.dispatchAction({
      type: 'brushEnd',
      brushId: modelId,
      areas: clone(areas),
      $from: modelId
    });
  };

  BrushView.type = 'brush';
  return BrushView;
}(ComponentView);

var DEFAULT_OUT_OF_BRUSH_COLOR = '#ddd';

var BrushModel =
/** @class */
function (_super) {
  __extends$1(BrushModel, _super);

  function BrushModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = BrushModel.type;
    /**
     * @readOnly
     */

    _this.areas = [];
    /**
     * Current brush painting area settings.
     * @readOnly
     */

    _this.brushOption = {};
    return _this;
  }

  BrushModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.

    thisOption.outOfBrush = thisOption.outOfBrush || {
      color: DEFAULT_OUT_OF_BRUSH_COLOR
    };

    if (!inBrush.hasOwnProperty('liftZ')) {
      // Bigger than the highlight z lift, otherwise it will
      // be effected by the highlight z when brush.
      inBrush.liftZ = 5;
    }
  };
  /**
   * If `areas` is null/undefined, range state remain.
   */


  BrushModel.prototype.setAreas = function (areas) {
    if (process.env.NODE_ENV !== 'production') {
      assert(isArray$1(areas));
      each(areas, function (area) {
        assert(area.brushType, 'Illegal areas');
      });
    } // If areas is null/undefined, range state remain.
    // This helps user to dispatchAction({type: 'brush'}) with no areas
    // set but just want to get the current brush select info from a `brush` event.


    if (!areas) {
      return;
    }

    this.areas = map(areas, function (area) {
      return generateBrushOption(this.option, area);
    }, this);
  };
  /**
   * Set the current painting brush option.
   */


  BrushModel.prototype.setBrushOption = function (brushOption) {
    this.brushOption = generateBrushOption(this.option, brushOption);
    this.brushType = this.brushOption.brushType;
  };

  BrushModel.type = 'brush';
  BrushModel.dependencies = ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'];
  BrushModel.defaultOption = {
    seriesIndex: 'all',
    brushType: 'rect',
    brushMode: 'single',
    transformable: true,
    brushStyle: {
      borderWidth: 1,
      color: 'rgba(210,219,238,0.3)',
      borderColor: '#D2DBEE'
    },
    throttleType: 'fixRate',
    throttleDelay: 0,
    removeOnClick: true,
    z: 10000
  };
  return BrushModel;
}(ComponentModel);

function generateBrushOption(option, brushOption) {
  return merge$1({
    brushType: option.brushType,
    brushMode: option.brushMode,
    transformable: option.transformable,
    brushStyle: new Model(option.brushStyle).getItemStyle(),
    removeOnClick: option.removeOnClick,
    z: option.z
  }, brushOption, true);
}

var ICON_TYPES = ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'];

var BrushFeature =
/** @class */
function (_super) {
  __extends$1(BrushFeature, _super);

  function BrushFeature() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  BrushFeature.prototype.render = function (featureModel, ecModel, api) {
    var brushType;
    var brushMode;
    var isBrushed;
    ecModel.eachComponent({
      mainType: 'brush'
    }, function (brushModel) {
      brushType = brushModel.brushType;
      brushMode = brushModel.brushOption.brushMode || 'single';
      isBrushed = isBrushed || !!brushModel.areas.length;
    });
    this._brushType = brushType;
    this._brushMode = brushMode;
    each(featureModel.get('type', true), function (type) {
      featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
    });
  };

  BrushFeature.prototype.updateView = function (featureModel, ecModel, api) {
    this.render(featureModel, ecModel, api);
  };

  BrushFeature.prototype.getIcons = function () {
    var model = this.model;
    var availableIcons = model.get('icon', true);
    var icons = {};
    each(model.get('type', true), function (type) {
      if (availableIcons[type]) {
        icons[type] = availableIcons[type];
      }
    });
    return icons;
  };

  BrushFeature.prototype.onclick = function (ecModel, api, type) {
    var brushType = this._brushType;
    var brushMode = this._brushMode;

    if (type === 'clear') {
      // Trigger parallel action firstly
      api.dispatchAction({
        type: 'axisAreaSelect',
        intervals: []
      });
      api.dispatchAction({
        type: 'brush',
        command: 'clear',
        // Clear all areas of all brush components.
        areas: []
      });
    } else {
      api.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'brush',
        brushOption: {
          brushType: type === 'keep' ? brushType : brushType === type ? false : type,
          brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
        }
      });
    }
  };

  BrushFeature.getDefaultOption = function (ecModel) {
    var defaultOption = {
      show: true,
      type: ICON_TYPES.slice(),
      icon: {
        /* eslint-disable */
        rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
        polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
        lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
        lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
        keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
        clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line

        /* eslint-enable */

      },
      // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
      title: ecModel.getLocaleModel().get(['toolbox', 'brush', 'title'])
    };
    return defaultOption;
  };

  return BrushFeature;
}(ToolboxFeature);

function install$B(registers) {
  registers.registerComponentView(BrushView);
  registers.registerComponentModel(BrushModel);
  registers.registerPreprocessor(brushPreprocessor);
  registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, brushVisual);
  registers.registerAction({
    type: 'brush',
    event: 'brush',
    update: 'updateVisual'
  }, function (payload, ecModel) {
    ecModel.eachComponent({
      mainType: 'brush',
      query: payload
    }, function (brushModel) {
      brushModel.setAreas(payload.areas);
    });
  });
  /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */

  registers.registerAction({
    type: 'brushSelect',
    event: 'brushSelected',
    update: 'none'
  }, noop$2);
  registers.registerAction({
    type: 'brushEnd',
    event: 'brushEnd',
    update: 'none'
  }, noop$2);
  registerFeature('brush', BrushFeature);
}

var TitleModel =
/** @class */
function (_super) {
  __extends$1(TitleModel, _super);

  function TitleModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TitleModel.type;
    _this.layoutMode = {
      type: 'box',
      ignoreSize: true
    };
    return _this;
  }

  TitleModel.type = 'title';
  TitleModel.defaultOption = {
    // zlevel: 0,
    z: 6,
    show: true,
    text: '',
    target: 'blank',
    subtext: '',
    subtarget: 'blank',
    left: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderWidth: 0,
    padding: 5,
    itemGap: 10,
    textStyle: {
      fontSize: 18,
      fontWeight: 'bold',
      color: '#464646'
    },
    subtextStyle: {
      fontSize: 12,
      color: '#6E7079'
    }
  };
  return TitleModel;
}(ComponentModel); // View


var TitleView =
/** @class */
function (_super) {
  __extends$1(TitleView, _super);

  function TitleView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TitleView.type;
    return _this;
  }

  TitleView.prototype.render = function (titleModel, ecModel, api) {
    this.group.removeAll();

    if (!titleModel.get('show')) {
      return;
    }

    var group = this.group;
    var textStyleModel = titleModel.getModel('textStyle');
    var subtextStyleModel = titleModel.getModel('subtextStyle');
    var textAlign = titleModel.get('textAlign');
    var textVerticalAlign = retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
    var textEl = new ZRText({
      style: createTextStyle(textStyleModel, {
        text: titleModel.get('text'),
        fill: textStyleModel.getTextColor()
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var textRect = textEl.getBoundingRect();
    var subText = titleModel.get('subtext');
    var subTextEl = new ZRText({
      style: createTextStyle(subtextStyleModel, {
        text: subText,
        fill: subtextStyleModel.getTextColor(),
        y: textRect.height + titleModel.get('itemGap'),
        verticalAlign: 'top'
      }, {
        disableBox: true
      }),
      z2: 10
    });
    var link = titleModel.get('link');
    var sublink = titleModel.get('sublink');
    var triggerEvent = titleModel.get('triggerEvent', true);
    textEl.silent = !link && !triggerEvent;
    subTextEl.silent = !sublink && !triggerEvent;

    if (link) {
      textEl.on('click', function () {
        windowOpen(link, '_' + titleModel.get('target'));
      });
    }

    if (sublink) {
      subTextEl.on('click', function () {
        windowOpen(sublink, '_' + titleModel.get('subtarget'));
      });
    }

    getECData(textEl).eventData = getECData(subTextEl).eventData = triggerEvent ? {
      componentType: 'title',
      componentIndex: titleModel.componentIndex
    } : null;
    group.add(textEl);
    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.

    var groupRect = group.getBoundingRect();
    var layoutOption = titleModel.getBoxLayoutParams();
    layoutOption.width = groupRect.width;
    layoutOption.height = groupRect.height;
    var layoutRect = getLayoutRect$1(layoutOption, {
      width: api.getWidth(),
      height: api.getHeight()
    }, titleModel.get('padding')); // Adjust text align based on position

    if (!textAlign) {
      // Align left if title is on the left. center and right is same
      textAlign = titleModel.get('left') || titleModel.get('right'); // @ts-ignore

      if (textAlign === 'middle') {
        textAlign = 'center';
      } // Adjust layout by text align


      if (textAlign === 'right') {
        layoutRect.x += layoutRect.width;
      } else if (textAlign === 'center') {
        layoutRect.x += layoutRect.width / 2;
      }
    }

    if (!textVerticalAlign) {
      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom'); // @ts-ignore

      if (textVerticalAlign === 'center') {
        textVerticalAlign = 'middle';
      }

      if (textVerticalAlign === 'bottom') {
        layoutRect.y += layoutRect.height;
      } else if (textVerticalAlign === 'middle') {
        layoutRect.y += layoutRect.height / 2;
      }

      textVerticalAlign = textVerticalAlign || 'top';
    }

    group.x = layoutRect.x;
    group.y = layoutRect.y;
    group.markRedraw();
    var alignStyle = {
      align: textAlign,
      verticalAlign: textVerticalAlign
    };
    textEl.setStyle(alignStyle);
    subTextEl.setStyle(alignStyle); // Render background
    // Get groupRect again because textAlign has been changed

    groupRect = group.getBoundingRect();
    var padding = layoutRect.margin;
    var style = titleModel.getItemStyle(['color', 'opacity']);
    style.fill = titleModel.get('backgroundColor');
    var rect = new Rect({
      shape: {
        x: groupRect.x - padding[3],
        y: groupRect.y - padding[0],
        width: groupRect.width + padding[1] + padding[3],
        height: groupRect.height + padding[0] + padding[2],
        r: titleModel.get('borderRadius')
      },
      style: style,
      subPixelOptimize: true,
      silent: true
    });
    group.add(rect);
  };

  TitleView.type = 'title';
  return TitleView;
}(ComponentView);

function install$C(registers) {
  registers.registerComponentModel(TitleModel);
  registers.registerComponentView(TitleView);
}

var TimelineModel =
/** @class */
function (_super) {
  __extends$1(TimelineModel, _super);

  function TimelineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TimelineModel.type;
    _this.layoutMode = 'box';
    return _this;
  }
  /**
   * @override
   */


  TimelineModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);

    this._initData();
  };
  /**
   * @override
   */


  TimelineModel.prototype.mergeOption = function (option) {
    _super.prototype.mergeOption.apply(this, arguments);

    this._initData();
  };

  TimelineModel.prototype.setCurrentIndex = function (currentIndex) {
    if (currentIndex == null) {
      currentIndex = this.option.currentIndex;
    }

    var count = this._data.count();

    if (this.option.loop) {
      currentIndex = (currentIndex % count + count) % count;
    } else {
      currentIndex >= count && (currentIndex = count - 1);
      currentIndex < 0 && (currentIndex = 0);
    }

    this.option.currentIndex = currentIndex;
  };
  /**
   * @return {number} currentIndex
   */


  TimelineModel.prototype.getCurrentIndex = function () {
    return this.option.currentIndex;
  };
  /**
   * @return {boolean}
   */


  TimelineModel.prototype.isIndexMax = function () {
    return this.getCurrentIndex() >= this._data.count() - 1;
  };
  /**
   * @param {boolean} state true: play, false: stop
   */


  TimelineModel.prototype.setPlayState = function (state) {
    this.option.autoPlay = !!state;
  };
  /**
   * @return {boolean} true: play, false: stop
   */


  TimelineModel.prototype.getPlayState = function () {
    return !!this.option.autoPlay;
  };
  /**
   * @private
   */


  TimelineModel.prototype._initData = function () {
    var thisOption = this.option;
    var dataArr = thisOption.data || [];
    var axisType = thisOption.axisType;
    var names = this._names = [];
    var processedDataArr;

    if (axisType === 'category') {
      processedDataArr = [];
      each(dataArr, function (item, index) {
        var value = convertOptionIdName(getDataItemValue(item), '');
        var newItem;

        if (isObject$2(item)) {
          newItem = clone(item);
          newItem.value = index;
        } else {
          newItem = index;
        }

        processedDataArr.push(newItem);
        names.push(value);
      });
    } else {
      processedDataArr = dataArr;
    }

    var dimType = {
      category: 'ordinal',
      time: 'time',
      value: 'number'
    }[axisType] || 'number';
    var data = this._data = new SeriesData([{
      name: 'value',
      type: dimType
    }], this);
    data.initData(processedDataArr, names);
  };

  TimelineModel.prototype.getData = function () {
    return this._data;
  };
  /**
   * @public
   * @return {Array.<string>} categoreis
   */


  TimelineModel.prototype.getCategories = function () {
    if (this.get('axisType') === 'category') {
      return this._names.slice();
    }
  };

  TimelineModel.type = 'timeline';
  /**
   * @protected
   */

  TimelineModel.defaultOption = {
    // zlevel: 0,                  // 一级层叠
    z: 4,
    show: true,
    axisType: 'time',
    realtime: true,
    left: '20%',
    top: null,
    right: '20%',
    bottom: 0,
    width: null,
    height: 40,
    padding: 5,
    controlPosition: 'left',
    autoPlay: false,
    rewind: false,
    loop: true,
    playInterval: 2000,
    currentIndex: 0,
    itemStyle: {},
    label: {
      color: '#000'
    },
    data: []
  };
  return TimelineModel;
}(ComponentModel);

var SliderTimelineModel =
/** @class */
function (_super) {
  __extends$1(SliderTimelineModel, _super);

  function SliderTimelineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderTimelineModel.type;
    return _this;
  }

  SliderTimelineModel.type = 'timeline.slider';
  /**
   * @protected
   */

  SliderTimelineModel.defaultOption = inheritDefaultOption(TimelineModel.defaultOption, {
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderWidth: 0,
    orient: 'horizontal',
    inverse: false,
    tooltip: {
      trigger: 'item' // data item may also have tootip attr.

    },
    symbol: 'circle',
    symbolSize: 12,
    lineStyle: {
      show: true,
      width: 2,
      color: '#DAE1F5'
    },
    label: {
      position: 'auto',
      // When using number, label position is not
      // restricted by viewRect.
      // positive: right/bottom, negative: left/top
      show: true,
      interval: 'auto',
      rotate: 0,
      // formatter: null,
      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
      color: '#A4B1D7'
    },
    itemStyle: {
      color: '#A4B1D7',
      borderWidth: 1
    },
    checkpointStyle: {
      symbol: 'circle',
      symbolSize: 15,
      color: '#316bf3',
      borderColor: '#fff',
      borderWidth: 2,
      shadowBlur: 2,
      shadowOffsetX: 1,
      shadowOffsetY: 1,
      shadowColor: 'rgba(0, 0, 0, 0.3)',
      // borderColor: 'rgba(194,53,49, 0.5)',
      animation: true,
      animationDuration: 300,
      animationEasing: 'quinticInOut'
    },
    controlStyle: {
      show: true,
      showPlayBtn: true,
      showPrevBtn: true,
      showNextBtn: true,
      itemSize: 24,
      itemGap: 12,
      position: 'left',
      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
      // eslint-disable-next-line max-len
      nextIcon: 'M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z',
      // eslint-disable-next-line max-len
      prevIcon: 'M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z',
      prevBtnSize: 18,
      nextBtnSize: 18,
      color: '#A4B1D7',
      borderColor: '#A4B1D7',
      borderWidth: 1
    },
    emphasis: {
      label: {
        show: true,
        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
        color: '#6f778d'
      },
      itemStyle: {
        color: '#316BF3'
      },
      controlStyle: {
        color: '#316BF3',
        borderColor: '#316BF3',
        borderWidth: 2
      }
    },
    progress: {
      lineStyle: {
        color: '#316BF3'
      },
      itemStyle: {
        color: '#316BF3'
      },
      label: {
        color: '#6f778d'
      }
    },
    data: []
  });
  return SliderTimelineModel;
}(TimelineModel);

mixin(SliderTimelineModel, DataFormatMixin.prototype);

var TimelineView =
/** @class */
function (_super) {
  __extends$1(TimelineView, _super);

  function TimelineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = TimelineView.type;
    return _this;
  }

  TimelineView.type = 'timeline';
  return TimelineView;
}(ComponentView);

/**
 * Extend axis 2d
 */

var TimelineAxis =
/** @class */
function (_super) {
  __extends$1(TimelineAxis, _super);

  function TimelineAxis(dim, scale, coordExtent, axisType) {
    var _this = _super.call(this, dim, scale, coordExtent) || this;

    _this.type = axisType || 'value';
    return _this;
  }
  /**
   * @override
   */


  TimelineAxis.prototype.getLabelModel = function () {
    // Force override
    return this.model.getModel('label');
  };
  /**
   * @override
   */


  TimelineAxis.prototype.isHorizontal = function () {
    return this.model.get('orient') === 'horizontal';
  };

  return TimelineAxis;
}(Axis);

var PI$8 = Math.PI;
var labelDataIndexStore = makeInner();

var SliderTimelineView =
/** @class */
function (_super) {
  __extends$1(SliderTimelineView, _super);

  function SliderTimelineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderTimelineView.type;
    return _this;
  }

  SliderTimelineView.prototype.init = function (ecModel, api) {
    this.api = api;
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.render = function (timelineModel, ecModel, api) {
    this.model = timelineModel;
    this.api = api;
    this.ecModel = ecModel;
    this.group.removeAll();

    if (timelineModel.get('show', true)) {
      var layoutInfo_1 = this._layout(timelineModel, api);

      var mainGroup_1 = this._createGroup('_mainGroup');

      var labelGroup = this._createGroup('_labelGroup');

      var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);

      timelineModel.formatTooltip = function (dataIndex) {
        var name = axis_1.scale.getLabel({
          value: dataIndex
        });
        return createTooltipMarkup('nameValue', {
          noName: true,
          value: name
        });
      };

      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
        this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
      }, this);

      this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);

      this._position(layoutInfo_1, timelineModel);
    }

    this._doPlayStop();

    this._updateTicksStatus();
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.remove = function () {
    this._clearTimer();

    this.group.removeAll();
  };
  /**
   * @override
   */


  SliderTimelineView.prototype.dispose = function () {
    this._clearTimer();
  };

  SliderTimelineView.prototype._layout = function (timelineModel, api) {
    var labelPosOpt = timelineModel.get(['label', 'position']);
    var orient = timelineModel.get('orient');
    var viewRect = getViewRect$5(timelineModel, api);
    var parsedLabelPos; // Auto label offset.

    if (labelPosOpt == null || labelPosOpt === 'auto') {
      parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
    } else if (isString(labelPosOpt)) {
      parsedLabelPos = {
        horizontal: {
          top: '-',
          bottom: '+'
        },
        vertical: {
          left: '-',
          right: '+'
        }
      }[orient][labelPosOpt];
    } else {
      // is number
      parsedLabelPos = labelPosOpt;
    }

    var labelAlignMap = {
      horizontal: 'center',
      vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
    };
    var labelBaselineMap = {
      horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
      vertical: 'middle'
    };
    var rotationMap = {
      horizontal: 0,
      vertical: PI$8 / 2
    }; // Position

    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
    var controlModel = timelineModel.getModel('controlStyle');
    var showControl = controlModel.get('show', true);
    var controlSize = showControl ? controlModel.get('itemSize') : 0;
    var controlGap = showControl ? controlModel.get('itemGap') : 0;
    var sizePlusGap = controlSize + controlGap; // Special label rotate.

    var labelRotation = timelineModel.get(['label', 'rotate']) || 0;
    labelRotation = labelRotation * PI$8 / 180; // To radian.

    var playPosition;
    var prevBtnPosition;
    var nextBtnPosition;
    var controlPosition = controlModel.get('position', true);
    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
    var xLeft = 0;
    var xRight = mainLength; // position[0] means left, position[1] means middle.

    if (controlPosition === 'left' || controlPosition === 'bottom') {
      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    } else {
      // 'top' 'right'
      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
    }

    var axisExtent = [xLeft, xRight];

    if (timelineModel.get('inverse')) {
      axisExtent.reverse();
    }

    return {
      viewRect: viewRect,
      mainLength: mainLength,
      orient: orient,
      rotation: rotationMap[orient],
      labelRotation: labelRotation,
      labelPosOpt: parsedLabelPos,
      labelAlign: timelineModel.get(['label', 'align']) || labelAlignMap[orient],
      labelBaseline: timelineModel.get(['label', 'verticalAlign']) || timelineModel.get(['label', 'baseline']) || labelBaselineMap[orient],
      // Based on mainGroup.
      playPosition: playPosition,
      prevBtnPosition: prevBtnPosition,
      nextBtnPosition: nextBtnPosition,
      axisExtent: axisExtent,
      controlSize: controlSize,
      controlGap: controlGap
    };
  };

  SliderTimelineView.prototype._position = function (layoutInfo, timelineModel) {
    // Position is be called finally, because bounding rect is needed for
    // adapt content to fill viewRect (auto adapt offset).
    // Timeline may be not all in the viewRect when 'offset' is specified
    // as a number, because it is more appropriate that label aligns at
    // 'offset' but not the other edge defined by viewRect.
    var mainGroup = this._mainGroup;
    var labelGroup = this._labelGroup;
    var viewRect = layoutInfo.viewRect;

    if (layoutInfo.orient === 'vertical') {
      // transform to horizontal, inverse rotate by left-top point.
      var m = create$1();
      var rotateOriginX = viewRect.x;
      var rotateOriginY = viewRect.y + viewRect.height;
      translate(m, m, [-rotateOriginX, -rotateOriginY]);
      rotate(m, m, -PI$8 / 2);
      translate(m, m, [rotateOriginX, rotateOriginY]);
      viewRect = viewRect.clone();
      viewRect.applyTransform(m);
    }

    var viewBound = getBound(viewRect);
    var mainBound = getBound(mainGroup.getBoundingRect());
    var labelBound = getBound(labelGroup.getBoundingRect());
    var mainPosition = [mainGroup.x, mainGroup.y];
    var labelsPosition = [labelGroup.x, labelGroup.y];
    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
    var labelPosOpt = layoutInfo.labelPosOpt;

    if (labelPosOpt == null || isString(labelPosOpt)) {
      // '+' or '-'
      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
    } else {
      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
      labelsPosition[1] = mainPosition[1] + labelPosOpt;
    }

    mainGroup.setPosition(mainPosition);
    labelGroup.setPosition(labelsPosition);
    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
    setOrigin(mainGroup);
    setOrigin(labelGroup);

    function setOrigin(targetGroup) {
      targetGroup.originX = viewBound[0][0] - targetGroup.x;
      targetGroup.originY = viewBound[1][0] - targetGroup.y;
    }

    function getBound(rect) {
      // [[xmin, xmax], [ymin, ymax]]
      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
    }

    function toBound(fromPos, from, to, dimIdx, boundIdx) {
      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
    }
  };

  SliderTimelineView.prototype._createAxis = function (layoutInfo, timelineModel) {
    var data = timelineModel.getData();
    var axisType = timelineModel.get('axisType');
    var scale = createScaleByModel$1(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.

    scale.getTicks = function () {
      return data.mapArray(['value'], function (value) {
        return {
          value: value
        };
      });
    };

    var dataExtent = data.getDataExtent('value');
    scale.setExtent(dataExtent[0], dataExtent[1]);
    scale.calcNiceTicks();
    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
    axis.model = timelineModel;
    return axis;
  };

  SliderTimelineView.prototype._createGroup = function (key) {
    var newGroup = this[key] = new Group$1();
    this.group.add(newGroup);
    return newGroup;
  };

  SliderTimelineView.prototype._renderAxisLine = function (layoutInfo, group, axis, timelineModel) {
    var axisExtent = axis.getExtent();

    if (!timelineModel.get(['lineStyle', 'show'])) {
      return;
    }

    var line = new Line({
      shape: {
        x1: axisExtent[0],
        y1: 0,
        x2: axisExtent[1],
        y2: 0
      },
      style: extend({
        lineCap: 'round'
      }, timelineModel.getModel('lineStyle').getLineStyle()),
      silent: true,
      z2: 1
    });
    group.add(line);
    var progressLine = this._progressLine = new Line({
      shape: {
        x1: axisExtent[0],
        x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
        y1: 0,
        y2: 0
      },
      style: defaults({
        lineCap: 'round',
        lineWidth: line.style.lineWidth
      }, timelineModel.getModel(['progress', 'lineStyle']).getLineStyle()),
      silent: true,
      z2: 1
    });
    group.add(progressLine);
  };

  SliderTimelineView.prototype._renderAxisTick = function (layoutInfo, group, axis, timelineModel) {
    var _this = this;

    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.

    var ticks = axis.scale.getTicks();
    this._tickSymbols = []; // The value is dataIndex, see the customized scale.

    each(ticks, function (tick) {
      var tickCoord = axis.dataToCoord(tick.value);
      var itemModel = data.getItemModel(tick.value);
      var itemStyleModel = itemModel.getModel('itemStyle');
      var hoverStyleModel = itemModel.getModel(['emphasis', 'itemStyle']);
      var progressStyleModel = itemModel.getModel(['progress', 'itemStyle']);
      var symbolOpt = {
        x: tickCoord,
        y: 0,
        onclick: bind(_this._changeTimeline, _this, tick.value)
      };
      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
      el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
      el.ensureState('progress').style = progressStyleModel.getItemStyle();
      enableHoverEmphasis(el);
      var ecData = getECData(el);

      if (itemModel.get('tooltip')) {
        ecData.dataIndex = tick.value;
        ecData.dataModel = timelineModel;
      } else {
        ecData.dataIndex = ecData.dataModel = null;
      }

      _this._tickSymbols.push(el);
    });
  };

  SliderTimelineView.prototype._renderAxisLabel = function (layoutInfo, group, axis, timelineModel) {
    var _this = this;

    var labelModel = axis.getLabelModel();

    if (!labelModel.get('show')) {
      return;
    }

    var data = timelineModel.getData();
    var labels = axis.getViewLabels();
    this._tickLabels = [];
    each(labels, function (labelItem) {
      // The tickValue is dataIndex, see the customized scale.
      var dataIndex = labelItem.tickValue;
      var itemModel = data.getItemModel(dataIndex);
      var normalLabelModel = itemModel.getModel('label');
      var hoverLabelModel = itemModel.getModel(['emphasis', 'label']);
      var progressLabelModel = itemModel.getModel(['progress', 'label']);
      var tickCoord = axis.dataToCoord(labelItem.tickValue);
      var textEl = new ZRText({
        x: tickCoord,
        y: 0,
        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
        onclick: bind(_this._changeTimeline, _this, dataIndex),
        silent: false,
        style: createTextStyle(normalLabelModel, {
          text: labelItem.formattedLabel,
          align: layoutInfo.labelAlign,
          verticalAlign: layoutInfo.labelBaseline
        })
      });
      textEl.ensureState('emphasis').style = createTextStyle(hoverLabelModel);
      textEl.ensureState('progress').style = createTextStyle(progressLabelModel);
      group.add(textEl);
      enableHoverEmphasis(textEl);
      labelDataIndexStore(textEl).dataIndex = dataIndex;

      _this._tickLabels.push(textEl);
    });
  };

  SliderTimelineView.prototype._renderControl = function (layoutInfo, group, axis, timelineModel) {
    var controlSize = layoutInfo.controlSize;
    var rotation = layoutInfo.rotation;
    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
    var hoverStyle = timelineModel.getModel(['emphasis', 'controlStyle']).getItemStyle();
    var playState = timelineModel.getPlayState();
    var inverse = timelineModel.get('inverse', true);
    makeBtn(layoutInfo.nextBtnPosition, 'next', bind(this._changeTimeline, this, inverse ? '-' : '+'));
    makeBtn(layoutInfo.prevBtnPosition, 'prev', bind(this._changeTimeline, this, inverse ? '+' : '-'));
    makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', bind(this._handlePlayClick, this, !playState), true);

    function makeBtn(position, iconName, onclick, willRotate) {
      if (!position) {
        return;
      }

      var iconSize = parsePercent(retrieve2(timelineModel.get(['controlStyle', iconName + 'BtnSize']), controlSize), controlSize);
      var rect = [0, -iconSize / 2, iconSize, iconSize];
      var btn = makeControlIcon(timelineModel, iconName + 'Icon', rect, {
        x: position[0],
        y: position[1],
        originX: controlSize / 2,
        originY: 0,
        rotation: willRotate ? -rotation : 0,
        rectHover: true,
        style: itemStyle,
        onclick: onclick
      });
      btn.ensureState('emphasis').style = hoverStyle;
      group.add(btn);
      enableHoverEmphasis(btn);
    }
  };

  SliderTimelineView.prototype._renderCurrentPointer = function (layoutInfo, group, axis, timelineModel) {
    var data = timelineModel.getData();
    var currentIndex = timelineModel.getCurrentIndex();
    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
    var me = this;
    var callback = {
      onCreate: function (pointer) {
        pointer.draggable = true;
        pointer.drift = bind(me._handlePointerDrag, me);
        pointer.ondragend = bind(me._handlePointerDragend, me);
        pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
      },
      onUpdate: function (pointer) {
        pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
      }
    }; // Reuse when exists, for animation and drag.

    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
  };

  SliderTimelineView.prototype._handlePlayClick = function (nextState) {
    this._clearTimer();

    this.api.dispatchAction({
      type: 'timelinePlayChange',
      playState: nextState,
      from: this.uid
    });
  };

  SliderTimelineView.prototype._handlePointerDrag = function (dx, dy, e) {
    this._clearTimer();

    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
  };

  SliderTimelineView.prototype._handlePointerDragend = function (e) {
    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
  };

  SliderTimelineView.prototype._pointerChangeTimeline = function (mousePos, trigger) {
    var toCoord = this._toAxisCoord(mousePos)[0];

    var axis = this._axis;
    var axisExtent = asc(axis.getExtent().slice());
    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
    this._currentPointer.x = toCoord;

    this._currentPointer.markRedraw();

    var progressLine = this._progressLine;

    if (progressLine) {
      progressLine.shape.x2 = toCoord;
      progressLine.dirty();
    }

    var targetDataIndex = this._findNearestTick(toCoord);

    var timelineModel = this.model;

    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
      this._changeTimeline(targetDataIndex);
    }
  };

  SliderTimelineView.prototype._doPlayStop = function () {
    var _this = this;

    this._clearTimer();

    if (this.model.getPlayState()) {
      this._timer = setTimeout(function () {
        // Do not cache
        var timelineModel = _this.model;

        _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
      }, this.model.get('playInterval'));
    }
  };

  SliderTimelineView.prototype._toAxisCoord = function (vertex) {
    var trans = this._mainGroup.getLocalTransform();

    return applyTransform$1(vertex, trans, true);
  };

  SliderTimelineView.prototype._findNearestTick = function (axisCoord) {
    var data = this.model.getData();
    var dist = Infinity;
    var targetDataIndex;
    var axis = this._axis;
    data.each(['value'], function (value, dataIndex) {
      var coord = axis.dataToCoord(value);
      var d = Math.abs(coord - axisCoord);

      if (d < dist) {
        dist = d;
        targetDataIndex = dataIndex;
      }
    });
    return targetDataIndex;
  };

  SliderTimelineView.prototype._clearTimer = function () {
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  };

  SliderTimelineView.prototype._changeTimeline = function (nextIndex) {
    var currentIndex = this.model.getCurrentIndex();

    if (nextIndex === '+') {
      nextIndex = currentIndex + 1;
    } else if (nextIndex === '-') {
      nextIndex = currentIndex - 1;
    }

    this.api.dispatchAction({
      type: 'timelineChange',
      currentIndex: nextIndex,
      from: this.uid
    });
  };

  SliderTimelineView.prototype._updateTicksStatus = function () {
    var currentIndex = this.model.getCurrentIndex();
    var tickSymbols = this._tickSymbols;
    var tickLabels = this._tickLabels;

    if (tickSymbols) {
      for (var i = 0; i < tickSymbols.length; i++) {
        tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
      }
    }

    if (tickLabels) {
      for (var i = 0; i < tickLabels.length; i++) {
        tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
      }
    }
  };

  SliderTimelineView.type = 'timeline.slider';
  return SliderTimelineView;
}(TimelineView);

function createScaleByModel$1(model, axisType) {
  axisType = axisType || model.get('type');

  if (axisType) {
    switch (axisType) {
      // Buildin scale
      case 'category':
        return new OrdinalScale({
          ordinalMeta: model.getCategories(),
          extent: [Infinity, -Infinity]
        });

      case 'time':
        return new TimeScale({
          locale: model.ecModel.getLocaleModel(),
          useUTC: model.ecModel.get('useUTC')
        });

      default:
        // default to be value
        return new IntervalScale();
    }
  }
}

function getViewRect$5(model, api) {
  return getLayoutRect$1(model.getBoxLayoutParams(), {
    width: api.getWidth(),
    height: api.getHeight()
  }, model.get('padding'));
}

function makeControlIcon(timelineModel, objPath, rect, opts) {
  var style = opts.style;
  var icon = createIcon(timelineModel.get(['controlStyle', objPath]), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.

  if (style) {
    icon.setStyle(style);
  }

  return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */


function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
  var color = itemStyleModel.get('color');

  if (!symbol) {
    var symbolType = hostModel.get('symbol');
    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
    symbol.setStyle('strokeNoScale', true);
    group.add(symbol);
    callback && callback.onCreate(symbol);
  } else {
    symbol.setColor(color);
    group.add(symbol); // Group may be new, also need to add.

    callback && callback.onUpdate(symbol);
  } // Style


  var itemStyle = itemStyleModel.getItemStyle(['color']);
  symbol.setStyle(itemStyle); // Transform and events.

  opt = merge$1({
    rectHover: true,
    z2: 100
  }, opt, true);
  var symbolSize = normalizeSymbolSize(hostModel.get('symbolSize'));
  opt.scaleX = symbolSize[0] / 2;
  opt.scaleY = symbolSize[1] / 2;
  var symbolOffset = normalizeSymbolOffset(hostModel.get('symbolOffset'), symbolSize);

  if (symbolOffset) {
    opt.x = (opt.x || 0) + symbolOffset[0];
    opt.y = (opt.y || 0) + symbolOffset[1];
  }

  var symbolRotate = hostModel.get('symbolRotate');
  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
  symbol.attr(opt); // FIXME
  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
  // getBoundingRect will return wrong result.
  // (This is supposed to be resolved in zrender, but it is a little difficult to
  // leverage performance and auto updateTransform)
  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.

  symbol.updateTransform();
  return symbol;
}

function pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
  if (pointer.dragging) {
    return;
  }

  var pointerModel = timelineModel.getModel('checkpointStyle');
  var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));

  if (noAnimation || !pointerModel.get('animation', true)) {
    pointer.attr({
      x: toCoord,
      y: 0
    });
    progressLine && progressLine.attr({
      shape: {
        x2: toCoord
      }
    });
  } else {
    var animationCfg = {
      duration: pointerModel.get('animationDuration', true),
      easing: pointerModel.get('animationEasing', true)
    };
    pointer.stopAnimation(null, true);
    pointer.animateTo({
      x: toCoord,
      y: 0
    }, animationCfg);
    progressLine && progressLine.animateTo({
      shape: {
        x2: toCoord
      }
    }, animationCfg);
  }
}

function installTimelineAction(registers) {
  registers.registerAction({
    type: 'timelineChange',
    event: 'timelineChanged',
    update: 'prepareAndUpdate'
  }, function (payload, ecModel, api) {
    var timelineModel = ecModel.getComponent('timeline');

    if (timelineModel && payload.currentIndex != null) {
      timelineModel.setCurrentIndex(payload.currentIndex);

      if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
        timelineModel.setPlayState(false); // The timeline has played to the end, trigger event

        api.dispatchAction({
          type: 'timelinePlayChange',
          playState: false,
          from: payload.from
        });
      }
    } // Set normalized currentIndex to payload.


    ecModel.resetOption('timeline', {
      replaceMerge: timelineModel.get('replaceMerge', true)
    });
    return defaults({
      currentIndex: timelineModel.option.currentIndex
    }, payload);
  });
  registers.registerAction({
    type: 'timelinePlayChange',
    event: 'timelinePlayChanged',
    update: 'update'
  }, function (payload, ecModel) {
    var timelineModel = ecModel.getComponent('timeline');

    if (timelineModel && payload.playState != null) {
      timelineModel.setPlayState(payload.playState);
    }
  });
}

function timelinePreprocessor(option) {
  var timelineOpt = option && option.timeline;

  if (!isArray$1(timelineOpt)) {
    timelineOpt = timelineOpt ? [timelineOpt] : [];
  }

  each(timelineOpt, function (opt) {
    if (!opt) {
      return;
    }

    compatibleEC2(opt);
  });
}

function compatibleEC2(opt) {
  var type = opt.type;
  var ec2Types = {
    'number': 'value',
    'time': 'time'
  }; // Compatible with ec2

  if (ec2Types[type]) {
    opt.axisType = ec2Types[type];
    delete opt.type;
  }

  transferItem(opt);

  if (has$2(opt, 'controlPosition')) {
    var controlStyle = opt.controlStyle || (opt.controlStyle = {});

    if (!has$2(controlStyle, 'position')) {
      controlStyle.position = opt.controlPosition;
    }

    if (controlStyle.position === 'none' && !has$2(controlStyle, 'show')) {
      controlStyle.show = false;
      delete controlStyle.position;
    }

    delete opt.controlPosition;
  }

  each(opt.data || [], function (dataItem) {
    if (isObject$2(dataItem) && !isArray$1(dataItem)) {
      if (!has$2(dataItem, 'value') && has$2(dataItem, 'name')) {
        // In ec2, using name as value.
        dataItem.value = dataItem.name;
      }

      transferItem(dataItem);
    }
  });
}

function transferItem(opt) {
  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out

  var label = opt.label || opt.label || {};
  var labelNormal = label.normal || (label.normal = {});
  var excludeLabelAttr = {
    normal: 1,
    emphasis: 1
  };
  each(label, function (value, name) {
    if (!excludeLabelAttr[name] && !has$2(labelNormal, name)) {
      labelNormal[name] = value;
    }
  });

  if (itemStyleEmphasis.label && !has$2(label, 'emphasis')) {
    label.emphasis = itemStyleEmphasis.label;
    delete itemStyleEmphasis.label;
  }
}

function has$2(obj, attr) {
  return obj.hasOwnProperty(attr);
}

function install$D(registers) {
  registers.registerComponentModel(SliderTimelineModel);
  registers.registerComponentView(SliderTimelineView);
  registers.registerSubTypeDefaulter('timeline', function () {
    // Only slider now.
    return 'slider';
  });
  installTimelineAction(registers);
  registers.registerPreprocessor(timelinePreprocessor);
}

function checkMarkerInSeries(seriesOpts, markerType) {
  if (!seriesOpts) {
    return false;
  }

  var seriesOptArr = isArray$1(seriesOpts) ? seriesOpts : [seriesOpts];

  for (var idx = 0; idx < seriesOptArr.length; idx++) {
    if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) {
      return true;
    }
  }

  return false;
}

function fillLabel(opt) {
  defaultEmphasis(opt, 'label', ['show']);
} // { [componentType]: MarkerModel }


var inner$h = makeInner();

var MarkerModel =
/** @class */
function (_super) {
  __extends$1(MarkerModel, _super);

  function MarkerModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkerModel.type;
    /**
     * If marker model is created by self from series
     */

    _this.createdBySelf = false;
    return _this;
  }
  /**
   * @overrite
   */


  MarkerModel.prototype.init = function (option, parentModel, ecModel) {
    if (process.env.NODE_ENV !== 'production') {
      if (this.type === 'marker') {
        throw new Error('Marker component is abstract component. Use markLine, markPoint, markArea instead.');
      }
    }

    this.mergeDefaultAndTheme(option, ecModel);

    this._mergeOption(option, ecModel, false, true);
  };

  MarkerModel.prototype.isAnimationEnabled = function () {
    if (env.node) {
      return false;
    }

    var hostSeries = this.__hostSeries;
    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
  };
  /**
   * @overrite
   */


  MarkerModel.prototype.mergeOption = function (newOpt, ecModel) {
    this._mergeOption(newOpt, ecModel, false, false);
  };

  MarkerModel.prototype._mergeOption = function (newOpt, ecModel, createdBySelf, isInit) {
    var componentType = this.mainType;

    if (!createdBySelf) {
      ecModel.eachSeries(function (seriesModel) {
        // mainType can be markPoint, markLine, markArea
        var markerOpt = seriesModel.get(this.mainType, true);
        var markerModel = inner$h(seriesModel)[componentType];

        if (!markerOpt || !markerOpt.data) {
          inner$h(seriesModel)[componentType] = null;
          return;
        }

        if (!markerModel) {
          if (isInit) {
            // Default label emphasis `position` and `show`
            fillLabel(markerOpt);
          }

          each(markerOpt.data, function (item) {
            // FIXME Overwrite fillLabel method ?
            if (item instanceof Array) {
              fillLabel(item[0]);
              fillLabel(item[1]);
            } else {
              fillLabel(item);
            }
          });
          markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel); // markerModel = new ImplementedMarkerModel(
          //     markerOpt, this, ecModel
          // );

          extend(markerModel, {
            mainType: this.mainType,
            // Use the same series index and name
            seriesIndex: seriesModel.seriesIndex,
            name: seriesModel.name,
            createdBySelf: true
          });
          markerModel.__hostSeries = seriesModel;
        } else {
          markerModel._mergeOption(markerOpt, ecModel, true);
        }

        inner$h(seriesModel)[componentType] = markerModel;
      }, this);
    }
  };

  MarkerModel.prototype.formatTooltip = function (dataIndex, multipleSeries, dataType) {
    var data = this.getData();
    var value = this.getRawValue(dataIndex);
    var itemName = data.getName(dataIndex);
    return createTooltipMarkup('section', {
      header: this.name,
      blocks: [createTooltipMarkup('nameValue', {
        name: itemName,
        value: value,
        noName: !itemName,
        noValue: value == null
      })]
    });
  };

  MarkerModel.prototype.getData = function () {
    return this._data;
  };

  MarkerModel.prototype.setData = function (data) {
    this._data = data;
  };

  MarkerModel.getMarkerModelFromSeries = function (seriesModel, // Support three types of markers. Strict check.
  componentType) {
    return inner$h(seriesModel)[componentType];
  };

  MarkerModel.type = 'marker';
  MarkerModel.dependencies = ['series', 'grid', 'polar', 'geo'];
  return MarkerModel;
}(ComponentModel);

mixin(MarkerModel, DataFormatMixin.prototype);

var MarkPointModel =
/** @class */
function (_super) {
  __extends$1(MarkPointModel, _super);

  function MarkPointModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkPointModel.type;
    return _this;
  }

  MarkPointModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkPointModel.type = 'markPoint';
  MarkPointModel.defaultOption = {
    // zlevel: 0,
    z: 5,
    symbol: 'pin',
    symbolSize: 50,
    // symbolRotate: 0,
    // symbolOffset: [0, 0]
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'inside'
    },
    itemStyle: {
      borderWidth: 2
    },
    emphasis: {
      label: {
        show: true
      }
    }
  };
  return MarkPointModel;
}(MarkerModel);

function hasXOrY(item) {
  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}

function hasXAndY(item) {
  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}

function markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
  var coordArr = [];
  var stacked = isDimensionStacked(data, targetDataDim
  /* , otherDataDim */
  );
  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
  var value = numCalculate(data, calcDataDim, markerType);
  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.

  var precision = getPrecision(data.get(targetDataDim, dataIndex));
  precision = Math.min(precision, 20);

  if (precision >= 0) {
    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
  }

  return [coordArr, coordArrValue];
} // TODO Specified percent


var markerTypeCalculator = {
  min: curry(markerTypeCalculatorWithExtent, 'min'),
  max: curry(markerTypeCalculatorWithExtent, 'max'),
  average: curry(markerTypeCalculatorWithExtent, 'average'),
  median: curry(markerTypeCalculatorWithExtent, 'median')
};
/**
 * Transform markPoint data item to format used in List by do the following
 * 1. Calculate statistic like `max`, `min`, `average`
 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
 */

function dataTransform(seriesModel, item) {
  if (!item) {
    return;
  }

  var data = seriesModel.getData();
  var coordSys = seriesModel.coordinateSystem;
  var dims = coordSys.dimensions; // 1. If not specify the position with pixel directly
  // 2. If `coord` is not a data array. Which uses `xAxis`,
  // `yAxis` to specify the coord on each dimension
  // parseFloat first because item.x and item.y can be percent string like '20%'

  if (!hasXAndY(item) && !isArray$1(item.coord) && coordSys) {
    var axisInfo = getAxisInfo$1(item, data, coordSys, seriesModel); // Clone the option
    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value

    item = clone(item);

    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
      item.coord = coordInfo[0]; // Force to use the value of calculated value.
      // let item use the value without stack.

      item.value = coordInfo[1];
    } else {
      // FIXME Only has one of xAxis and yAxis.
      item.coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis];
    }
  } // x y is provided


  if (item.coord == null) {
    item.coord = [];
  } else {
    // Each coord support max, min, average
    var coord = item.coord;

    for (var i = 0; i < 2; i++) {
      if (markerTypeCalculator[coord[i]]) {
        coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
      }
    }
  }

  return item;
}
function getAxisInfo$1(item, data, coordSys, seriesModel) {
  var ret = {};

  if (item.valueIndex != null || item.valueDim != null) {
    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
  } else {
    ret.baseAxis = seriesModel.getBaseAxis();
    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
  }

  return ret;
}

function dataDimToCoordDim(seriesModel, dataDim) {
  var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
  return dimItem && dimItem.coordDim;
}
/**
 * Filter data which is out of coordinateSystem range
 * [dataFilter description]
 */


function dataFilter$1( // Currently only polar and cartesian has containData.
coordSys, item) {
  // Always return true if there is no coordSys
  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function zoneFilter( // Currently only polar and cartesian has containData.
coordSys, item1, item2) {
  // Always return true if there is no coordSys
  return coordSys && coordSys.containZone && item1.coord && item2.coord && !hasXOrY(item1) && !hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function createMarkerDimValueGetter(inCoordSys, dims) {
  return inCoordSys ? function (item, dimName, dataIndex, dimIndex) {
    var rawVal = dimIndex < 2 // x, y, radius, angle
    ? item.coord && item.coord[dimIndex] : item.value;
    return parseDataValue(rawVal, dims[dimIndex]);
  } : function (item, dimName, dataIndex, dimIndex) {
    return parseDataValue(item.value, dims[dimIndex]);
  };
}
function numCalculate(data, valueDataDim, type) {
  if (type === 'average') {
    var sum_1 = 0;
    var count_1 = 0;
    data.each(valueDataDim, function (val, idx) {
      if (!isNaN(val)) {
        sum_1 += val;
        count_1++;
      }
    });
    return sum_1 / count_1;
  } else if (type === 'median') {
    return data.getMedian(valueDataDim);
  } else {
    // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
  }
}

var inner$i = makeInner();

var MarkerView =
/** @class */
function (_super) {
  __extends$1(MarkerView, _super);

  function MarkerView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkerView.type;
    return _this;
  }

  MarkerView.prototype.init = function () {
    this.markerGroupMap = createHashMap();
  };

  MarkerView.prototype.render = function (markerModel, ecModel, api) {
    var _this = this;

    var markerGroupMap = this.markerGroupMap;
    markerGroupMap.each(function (item) {
      inner$i(item).keep = false;
    });
    ecModel.eachSeries(function (seriesModel) {
      var markerModel = MarkerModel.getMarkerModelFromSeries(seriesModel, _this.type);
      markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
    });
    markerGroupMap.each(function (item) {
      !inner$i(item).keep && _this.group.remove(item.group);
    });
  };

  MarkerView.prototype.markKeep = function (drawGroup) {
    inner$i(drawGroup).keep = true;
  };

  MarkerView.prototype.toggleBlurSeries = function (seriesModelList, isBlur) {
    var _this = this;

    each(seriesModelList, function (seriesModel) {
      var markerModel = MarkerModel.getMarkerModelFromSeries(seriesModel, _this.type);

      if (markerModel) {
        var data = markerModel.getData();
        data.eachItemGraphicEl(function (el) {
          if (el) {
            isBlur ? enterBlur(el) : leaveBlur(el);
          }
        });
      }
    });
  };

  MarkerView.type = 'marker';
  return MarkerView;
}(ComponentView);

function updateMarkerLayout(mpData, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  mpData.each(function (idx) {
    var itemModel = mpData.getItemModel(idx);
    var point;
    var xPx = parsePercent$1(itemModel.get('x'), api.getWidth());
    var yPx = parsePercent$1(itemModel.get('y'), api.getHeight());

    if (!isNaN(xPx) && !isNaN(yPx)) {
      point = [xPx, yPx];
    } // Chart like bar may have there own marker positioning logic
    else if (seriesModel.getMarkerPosition) {
        // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
      } else if (coordSys) {
        var x = mpData.get(coordSys.dimensions[0], idx);
        var y = mpData.get(coordSys.dimensions[1], idx);
        point = coordSys.dataToPoint([x, y]);
      } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }

    mpData.setItemLayout(idx, point);
  });
}

var MarkPointView =
/** @class */
function (_super) {
  __extends$1(MarkPointView, _super);

  function MarkPointView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkPointView.type;
    return _this;
  }

  MarkPointView.prototype.updateTransform = function (markPointModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mpModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markPoint');

      if (mpModel) {
        updateMarkerLayout(mpModel.getData(), seriesModel, api);
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  };

  MarkPointView.prototype.renderSeries = function (seriesModel, mpModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var symbolDrawMap = this.markerGroupMap;
    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
    var mpData = createData(coordSys, seriesModel, mpModel); // FIXME

    mpModel.setData(mpData);
    updateMarkerLayout(mpModel.getData(), seriesModel, api);
    mpData.each(function (idx) {
      var itemModel = mpData.getItemModel(idx);
      var symbol = itemModel.getShallow('symbol');
      var symbolSize = itemModel.getShallow('symbolSize');
      var symbolRotate = itemModel.getShallow('symbolRotate');
      var symbolOffset = itemModel.getShallow('symbolOffset');
      var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect'); // TODO: refactor needed: single data item should not support callback function

      if (isFunction$3(symbol) || isFunction$3(symbolSize) || isFunction$3(symbolRotate) || isFunction$3(symbolOffset)) {
        var rawIdx = mpModel.getRawValue(idx);
        var dataParams = mpModel.getDataParams(idx);

        if (isFunction$3(symbol)) {
          symbol = symbol(rawIdx, dataParams);
        }

        if (isFunction$3(symbolSize)) {
          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
          symbolSize = symbolSize(rawIdx, dataParams);
        }

        if (isFunction$3(symbolRotate)) {
          symbolRotate = symbolRotate(rawIdx, dataParams);
        }

        if (isFunction$3(symbolOffset)) {
          symbolOffset = symbolOffset(rawIdx, dataParams);
        }
      }

      var style = itemModel.getModel('itemStyle').getItemStyle();
      var color = getVisualFromData(seriesData, 'color');

      if (!style.fill) {
        style.fill = color;
      }

      mpData.setItemVisual(idx, {
        symbol: symbol,
        symbolSize: symbolSize,
        symbolRotate: symbolRotate,
        symbolOffset: symbolOffset,
        symbolKeepAspect: symbolKeepAspect,
        style: style
      });
    }); // TODO Text are wrong

    symbolDraw.updateData(mpData);
    this.group.add(symbolDraw.group); // Set host model for tooltip
    // FIXME

    mpData.eachItemGraphicEl(function (el) {
      el.traverse(function (child) {
        getECData(child).dataModel = mpModel;
      });
    });
    this.markKeep(symbolDraw);
    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
  };

  MarkPointView.type = 'markPoint';
  return MarkPointView;
}(MarkerView);

function createData(coordSys, seriesModel, mpModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return extend(extend({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var mpData = new SeriesData(coordDimsInfos, mpModel);
  var dataOpt = map(mpModel.get('data'), curry(dataTransform, seriesModel));

  if (coordSys) {
    dataOpt = filter(dataOpt, curry(dataFilter$1, coordSys));
  }

  var dimValueGetter = createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
  mpData.initData(dataOpt, null, dimValueGetter);
  return mpData;
}

function install$E(registers) {
  registers.registerComponentModel(MarkPointModel);
  registers.registerComponentView(MarkPointView);
  registers.registerPreprocessor(function (opt) {
    if (checkMarkerInSeries(opt.series, 'markPoint')) {
      // Make sure markPoint component is enabled
      opt.markPoint = opt.markPoint || {};
    }
  });
}

var MarkLineModel =
/** @class */
function (_super) {
  __extends$1(MarkLineModel, _super);

  function MarkLineModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkLineModel.type;
    return _this;
  }

  MarkLineModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkLineModel.type = 'markLine';
  MarkLineModel.defaultOption = {
    // zlevel: 0,
    z: 5,
    symbol: ['circle', 'arrow'],
    symbolSize: [8, 16],
    // symbolRotate: 0,
    symbolOffset: 0,
    precision: 2,
    tooltip: {
      trigger: 'item'
    },
    label: {
      show: true,
      position: 'end',
      distance: 5
    },
    lineStyle: {
      type: 'dashed'
    },
    emphasis: {
      label: {
        show: true
      },
      lineStyle: {
        width: 3
      }
    },
    animationEasing: 'linear'
  };
  return MarkLineModel;
}(MarkerModel);

var inner$j = makeInner();

var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
  var data = seriesModel.getData();
  var itemArray;

  if (!isArray$1(item)) {
    // Special type markLine like 'min', 'max', 'average', 'median'
    var mlType = item.type;

    if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
    // data: [{
    //   yAxis: 10
    // }]
    || item.xAxis != null || item.yAxis != null) {
      var valueAxis = void 0;
      var value = void 0;

      if (item.yAxis != null || item.xAxis != null) {
        valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
        value = retrieve(item.yAxis, item.xAxis);
      } else {
        var axisInfo = getAxisInfo$1(item, data, coordSys, seriesModel);
        valueAxis = axisInfo.valueAxis;
        var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
        value = numCalculate(data, valueDataDim, mlType);
      }

      var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
      var baseIndex = 1 - valueIndex; // Normized to 2d data with start and end point

      var mlFrom = clone(item);
      var mlTo = {
        coord: []
      };
      mlFrom.type = null;
      mlFrom.coord = [];
      mlFrom.coord[baseIndex] = -Infinity;
      mlTo.coord[baseIndex] = Infinity;
      var precision = mlModel.get('precision');

      if (precision >= 0 && isNumber$1(value)) {
        value = +value.toFixed(Math.min(precision, 20));
      }

      mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
      itemArray = [mlFrom, mlTo, {
        type: mlType,
        valueIndex: item.valueIndex,
        // Force to use the value of calculated value.
        value: value
      }];
    } else {
      // Invalid data
      if (process.env.NODE_ENV !== 'production') {
        logError('Invalid markLine data.');
      }

      itemArray = [];
    }
  } else {
    itemArray = item;
  }

  var normalizedItem = [dataTransform(seriesModel, itemArray[0]), dataTransform(seriesModel, itemArray[1]), extend({}, itemArray[2])]; // Avoid line data type is extended by from(to) data type

  normalizedItem[2].type = normalizedItem[2].type || null; // Merge from option and to option into line option

  merge$1(normalizedItem[2], normalizedItem[0]);
  merge$1(normalizedItem[2], normalizedItem[1]);
  return normalizedItem;
};

function isInfinity(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markLine has one dim


function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  var dimName = coordSys.dimensions[dimIndex];
  return isInfinity(fromCoord[otherDimIndex]) && isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}

function markLineFilter(coordSys, item) {
  if (coordSys.type === 'cartesian2d') {
    var fromCoord = item[0].coord;
    var toCoord = item[1].coord; // In case
    // {
    //  markLine: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }

    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
      return true;
    }
  }

  return dataFilter$1(coordSys, item[0]) && dataFilter$1(coordSys, item[1]);
}

function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = parsePercent$1(itemModel.get('x'), api.getWidth());
  var yPx = parsePercent$1(itemModel.get('y'), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Use the getMarkerPosition
      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
    } else {
      var dims = coordSys.dimensions;
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      point = coordSys.dataToPoint([x, y]);
    } // Expand line to the edge of grid if value on one axis is Inifnity
    // In case
    //  markLine: {
    //    data: [{
    //      yAxis: 2
    //      // or
    //      type: 'average'
    //    }]
    //  }


    if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
      // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var dims = coordSys.dimensions;

      if (isInfinity(data.get(dims[0], idx))) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
      } else if (isInfinity(data.get(dims[1], idx))) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  data.setItemLayout(idx, point);
}

var MarkLineView =
/** @class */
function (_super) {
  __extends$1(MarkLineView, _super);

  function MarkLineView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkLineView.type;
    return _this;
  }

  MarkLineView.prototype.updateTransform = function (markLineModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var mlModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markLine');

      if (mlModel) {
        var mlData_1 = mlModel.getData();
        var fromData_1 = inner$j(mlModel).from;
        var toData_1 = inner$j(mlModel).to; // Update visual and layout of from symbol and to symbol

        fromData_1.each(function (idx) {
          updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
          updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
        }); // Update layout of line

        mlData_1.each(function (idx) {
          mlData_1.setItemLayout(idx, [fromData_1.getItemLayout(idx), toData_1.getItemLayout(idx)]);
        });
        this.markerGroupMap.get(seriesModel.id).updateLayout();
      }
    }, this);
  };

  MarkLineView.prototype.renderSeries = function (seriesModel, mlModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var lineDrawMap = this.markerGroupMap;
    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
    this.group.add(lineDraw.group);
    var mlData = createList$1(coordSys, seriesModel, mlModel);
    var fromData = mlData.from;
    var toData = mlData.to;
    var lineData = mlData.line;
    inner$j(mlModel).from = fromData;
    inner$j(mlModel).to = toData; // Line data for tooltip and formatter

    mlModel.setData(lineData); // TODO
    // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
    // But the related logic and type definition are not finished yet.
    // Finish it if required

    var symbolType = mlModel.get('symbol');
    var symbolSize = mlModel.get('symbolSize');
    var symbolRotate = mlModel.get('symbolRotate');
    var symbolOffset = mlModel.get('symbolOffset'); // TODO: support callback function like markPoint

    if (!isArray$1(symbolType)) {
      symbolType = [symbolType, symbolType];
    }

    if (!isArray$1(symbolSize)) {
      symbolSize = [symbolSize, symbolSize];
    }

    if (!isArray$1(symbolRotate)) {
      symbolRotate = [symbolRotate, symbolRotate];
    }

    if (!isArray$1(symbolOffset)) {
      symbolOffset = [symbolOffset, symbolOffset];
    } // Update visual and layout of from symbol and to symbol


    mlData.from.each(function (idx) {
      updateDataVisualAndLayout(fromData, idx, true);
      updateDataVisualAndLayout(toData, idx, false);
    }); // Update visual and layout of line

    lineData.each(function (idx) {
      var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle(); // lineData.setItemVisual(idx, {
      //     color: lineColor || fromData.getItemVisual(idx, 'color')
      // });

      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);

      if (lineStyle.stroke == null) {
        lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
      }

      lineData.setItemVisual(idx, {
        fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
        fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
        fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
        fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
        fromSymbol: fromData.getItemVisual(idx, 'symbol'),
        toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
        toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
        toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
        toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
        toSymbol: toData.getItemVisual(idx, 'symbol'),
        style: lineStyle
      });
    });
    lineDraw.updateData(lineData); // Set host model for tooltip
    // FIXME

    mlData.line.eachItemGraphicEl(function (el) {
      getECData(el).dataModel = mlModel;
      el.traverse(function (child) {
        getECData(child).dataModel = mlModel;
      });
    });

    function updateDataVisualAndLayout(data, idx, isFrom) {
      var itemModel = data.getItemModel(idx);
      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
      var style = itemModel.getModel('itemStyle').getItemStyle();

      if (style.fill == null) {
        style.fill = getVisualFromData(seriesData, 'color');
      }

      data.setItemVisual(idx, {
        symbolKeepAspect: itemModel.get('symbolKeepAspect'),
        // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
        symbolOffset: retrieve2(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
        symbolRotate: retrieve2(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
        // TODO: when 2d array is supported, it should ignore parent
        symbolSize: retrieve2(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
        symbol: retrieve2(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
        style: style
      });
    }

    this.markKeep(lineDraw);
    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
  };

  MarkLineView.type = 'markLine';
  return MarkLineView;
}(MarkerView);

function createList$1(coordSys, seriesModel, mlModel) {
  var coordDimsInfos;

  if (coordSys) {
    coordDimsInfos = map(coordSys && coordSys.dimensions, function (coordDim) {
      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return extend(extend({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
  } else {
    coordDimsInfos = [{
      name: 'value',
      type: 'float'
    }];
  }

  var fromData = new SeriesData(coordDimsInfos, mlModel);
  var toData = new SeriesData(coordDimsInfos, mlModel); // No dimensions

  var lineData = new SeriesData([], mlModel);
  var optData = map(mlModel.get('data'), curry(markLineTransform, seriesModel, coordSys, mlModel));

  if (coordSys) {
    optData = filter(optData, curry(markLineFilter, coordSys));
  }

  var dimValueGetter = createMarkerDimValueGetter(!!coordSys, coordDimsInfos);
  fromData.initData(map(optData, function (item) {
    return item[0];
  }), null, dimValueGetter);
  toData.initData(map(optData, function (item) {
    return item[1];
  }), null, dimValueGetter);
  lineData.initData(map(optData, function (item) {
    return item[2];
  }));
  lineData.hasItemOption = true;
  return {
    from: fromData,
    to: toData,
    line: lineData
  };
}

function install$F(registers) {
  registers.registerComponentModel(MarkLineModel);
  registers.registerComponentView(MarkLineView);
  registers.registerPreprocessor(function (opt) {
    if (checkMarkerInSeries(opt.series, 'markLine')) {
      // Make sure markLine component is enabled
      opt.markLine = opt.markLine || {};
    }
  });
}

var MarkAreaModel =
/** @class */
function (_super) {
  __extends$1(MarkAreaModel, _super);

  function MarkAreaModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkAreaModel.type;
    return _this;
  }

  MarkAreaModel.prototype.createMarkerModelFromSeries = function (markerOpt, masterMarkerModel, ecModel) {
    return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
  };

  MarkAreaModel.type = 'markArea';
  MarkAreaModel.defaultOption = {
    // zlevel: 0,
    // PENDING
    z: 1,
    tooltip: {
      trigger: 'item'
    },
    // markArea should fixed on the coordinate system
    animation: false,
    label: {
      show: true,
      position: 'top'
    },
    itemStyle: {
      // color and borderColor default to use color from series
      // color: 'auto'
      // borderColor: 'auto'
      borderWidth: 0
    },
    emphasis: {
      label: {
        show: true,
        position: 'top'
      }
    }
  };
  return MarkAreaModel;
}(MarkerModel);

var inner$k = makeInner();

var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
  // item may be null
  var item0 = item[0];
  var item1 = item[1];

  if (!item0 || !item1) {
    return;
  }

  var lt = dataTransform(seriesModel, item0);
  var rb = dataTransform(seriesModel, item1); // FIXME make sure lt is less than rb

  var ltCoord = lt.coord;
  var rbCoord = rb.coord;
  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
  rbCoord[0] = retrieve(rbCoord[0], Infinity);
  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one

  var result = mergeAll([{}, lt, rb]);
  result.coord = [lt.coord, rb.coord];
  result.x0 = lt.x;
  result.y0 = lt.y;
  result.x1 = rb.x;
  result.y1 = rb.y;
  return result;
};

function isInfinity$1(val) {
  return !isNaN(val) && !isFinite(val);
} // If a markArea has one dim


function ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
  var otherDimIndex = 1 - dimIndex;
  return isInfinity$1(fromCoord[otherDimIndex]) && isInfinity$1(toCoord[otherDimIndex]);
}

function markAreaFilter(coordSys, item) {
  var fromCoord = item.coord[0];
  var toCoord = item.coord[1];
  var item0 = {
    coord: fromCoord,
    x: item.x0,
    y: item.y0
  };
  var item1 = {
    coord: toCoord,
    x: item.x1,
    y: item.y1
  };

  if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
    // In case
    // {
    //  markArea: {
    //    data: [{ yAxis: 2 }]
    //  }
    // }
    if (fromCoord && toCoord && (ifMarkAreaHasOnlyDim(1, fromCoord, toCoord) || ifMarkAreaHasOnlyDim(0, fromCoord, toCoord))) {
      return true;
    } // Directly returning true may also do the work,
    // because markArea will not be shown automatically
    // when it's not included in coordinate system.
    // But filtering ahead can avoid keeping rendering markArea
    // when there are too many of them.


    return zoneFilter(coordSys, item0, item1);
  }

  return dataFilter$1(coordSys, item0) || dataFilter$1(coordSys, item1);
} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']


function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
  var coordSys = seriesModel.coordinateSystem;
  var itemModel = data.getItemModel(idx);
  var point;
  var xPx = parsePercent$1(itemModel.get(dims[0]), api.getWidth());
  var yPx = parsePercent$1(itemModel.get(dims[1]), api.getHeight());

  if (!isNaN(xPx) && !isNaN(yPx)) {
    point = [xPx, yPx];
  } else {
    // Chart like bar may have there own marker positioning logic
    if (seriesModel.getMarkerPosition) {
      // Consider the case that user input the right-bottom point first
      // Pick the larger x and y as 'x1' and 'y1'
      var pointValue0 = data.getValues(['x0', 'y0'], idx);
      var pointValue1 = data.getValues(['x1', 'y1'], idx);
      var clampPointValue0 = coordSys.clampData(pointValue0);
      var clampPointValue1 = coordSys.clampData(pointValue1);
      var pointValue = [];

      if (dims[0] === 'x0') {
        pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
      } else {
        pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
      }

      if (dims[1] === 'y0') {
        pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
      } else {
        pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
      } // Use the getMarkerPosition


      point = seriesModel.getMarkerPosition(pointValue, dims, true);
    } else {
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);
      var pt = [x, y];
      coordSys.clampData && coordSys.clampData(pt, pt);
      point = coordSys.dataToPoint(pt, true);
    }

    if (isCoordinateSystemType(coordSys, 'cartesian2d')) {
      // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
      var xAxis = coordSys.getAxis('x');
      var yAxis = coordSys.getAxis('y');
      var x = data.get(dims[0], idx);
      var y = data.get(dims[1], idx);

      if (isInfinity$1(x)) {
        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
      } else if (isInfinity$1(y)) {
        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
      }
    } // Use x, y if has any


    if (!isNaN(xPx)) {
      point[0] = xPx;
    }

    if (!isNaN(yPx)) {
      point[1] = yPx;
    }
  }

  return point;
}

var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];

var MarkAreaView =
/** @class */
function (_super) {
  __extends$1(MarkAreaView, _super);

  function MarkAreaView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = MarkAreaView.type;
    return _this;
  }

  MarkAreaView.prototype.updateTransform = function (markAreaModel, ecModel, api) {
    ecModel.eachSeries(function (seriesModel) {
      var maModel = MarkerModel.getMarkerModelFromSeries(seriesModel, 'markArea');

      if (maModel) {
        var areaData_1 = maModel.getData();
        areaData_1.each(function (idx) {
          var points = map(dimPermutations, function (dim) {
            return getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
          }); // Layout

          areaData_1.setItemLayout(idx, points);
          var el = areaData_1.getItemGraphicEl(idx);
          el.setShape('points', points);
        });
      }
    }, this);
  };

  MarkAreaView.prototype.renderSeries = function (seriesModel, maModel, ecModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var seriesId = seriesModel.id;
    var seriesData = seriesModel.getData();
    var areaGroupMap = this.markerGroupMap;
    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
      group: new Group$1()
    });
    this.group.add(polygonGroup.group);
    this.markKeep(polygonGroup);
    var areaData = createList$2(coordSys, seriesModel, maModel); // Line data for tooltip and formatter

    maModel.setData(areaData); // Update visual and layout of line

    areaData.each(function (idx) {
      // Layout
      var points = map(dimPermutations, function (dim) {
        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
      });
      var xAxisScale = coordSys.getAxis('x').scale;
      var yAxisScale = coordSys.getAxis('y').scale;
      var xAxisExtent = xAxisScale.getExtent();
      var yAxisExtent = yAxisScale.getExtent();
      var xPointExtent = [xAxisScale.parse(areaData.get('x0', idx)), xAxisScale.parse(areaData.get('x1', idx))];
      var yPointExtent = [yAxisScale.parse(areaData.get('y0', idx)), yAxisScale.parse(areaData.get('y1', idx))];
      asc(xPointExtent);
      asc(yPointExtent);
      var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]); // If none of the area is inside coordSys, allClipped is set to be true
      // in layout so that label will not be displayed. See #12591

      var allClipped = !overlapped;
      areaData.setItemLayout(idx, {
        points: points,
        allClipped: allClipped
      });
      var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
      var color$1 = getVisualFromData(seriesData, 'color');

      if (!style.fill) {
        style.fill = color$1;

        if (isString(style.fill)) {
          style.fill = modifyAlpha(style.fill, 0.4);
        }
      }

      if (!style.stroke) {
        style.stroke = color$1;
      } // Visual


      areaData.setItemVisual(idx, 'style', style);
    });
    areaData.diff(inner$k(polygonGroup).data).add(function (idx) {
      var layout = areaData.getItemLayout(idx);

      if (!layout.allClipped) {
        var polygon = new Polygon({
          shape: {
            points: layout.points
          }
        });
        areaData.setItemGraphicEl(idx, polygon);
        polygonGroup.group.add(polygon);
      }
    }).update(function (newIdx, oldIdx) {
      var polygon = inner$k(polygonGroup).data.getItemGraphicEl(oldIdx);
      var layout = areaData.getItemLayout(newIdx);

      if (!layout.allClipped) {
        if (polygon) {
          updateProps(polygon, {
            shape: {
              points: layout.points
            }
          }, maModel, newIdx);
        } else {
          polygon = new Polygon({
            shape: {
              points: layout.points
            }
          });
        }

        areaData.setItemGraphicEl(newIdx, polygon);
        polygonGroup.group.add(polygon);
      } else if (polygon) {
        polygonGroup.group.remove(polygon);
      }
    }).remove(function (idx) {
      var polygon = inner$k(polygonGroup).data.getItemGraphicEl(idx);
      polygonGroup.group.remove(polygon);
    }).execute();
    areaData.eachItemGraphicEl(function (polygon, idx) {
      var itemModel = areaData.getItemModel(idx);
      var style = areaData.getItemVisual(idx, 'style');
      polygon.useStyle(areaData.getItemVisual(idx, 'style'));
      setLabelStyle(polygon, getLabelStatesModels(itemModel), {
        labelFetcher: maModel,
        labelDataIndex: idx,
        defaultText: areaData.getName(idx) || '',
        inheritColor: isString(style.fill) ? modifyAlpha(style.fill, 1) : '#000'
      });
      setStatesStylesFromModel(polygon, itemModel);
      toggleHoverEmphasis(polygon, null, null, itemModel.get(['emphasis', 'disabled']));
      getECData(polygon).dataModel = maModel;
    });
    inner$k(polygonGroup).data = areaData;
    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
  };

  MarkAreaView.type = 'markArea';
  return MarkAreaView;
}(MarkerView);

function createList$2(coordSys, seriesModel, maModel) {
  var areaData;
  var dataDims;
  var dims = ['x0', 'y0', 'x1', 'y1'];

  if (coordSys) {
    var coordDimsInfos_1 = map(coordSys && coordSys.dimensions, function (coordDim) {
      var data = seriesModel.getData();
      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys

      return extend(extend({}, info), {
        name: coordDim,
        // DON'T use ordinalMeta to parse and collect ordinal.
        ordinalMeta: null
      });
    });
    dataDims = map(dims, function (dim, idx) {
      return {
        name: dim,
        type: coordDimsInfos_1[idx % 2].type
      };
    });
    areaData = new SeriesData(dataDims, maModel);
  } else {
    dataDims = [{
      name: 'value',
      type: 'float'
    }];
    areaData = new SeriesData(dataDims, maModel);
  }

  var optData = map(maModel.get('data'), curry(markAreaTransform, seriesModel, coordSys, maModel));

  if (coordSys) {
    optData = filter(optData, curry(markAreaFilter, coordSys));
  }

  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
    // TODO should convert to ParsedValue?
    var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
    return parseDataValue(rawVal, dataDims[dimIndex]);
  } : function (item, dimName, dataIndex, dimIndex) {
    return parseDataValue(item.value, dataDims[dimIndex]);
  };
  areaData.initData(optData, null, dimValueGetter);
  areaData.hasItemOption = true;
  return areaData;
}

function install$G(registers) {
  registers.registerComponentModel(MarkAreaModel);
  registers.registerComponentView(MarkAreaView);
  registers.registerPreprocessor(function (opt) {
    if (checkMarkerInSeries(opt.series, 'markArea')) {
      // Make sure markArea component is enabled
      opt.markArea = opt.markArea || {};
    }
  });
}

var getDefaultSelectorOptions = function (ecModel, type) {
  if (type === 'all') {
    return {
      type: 'all',
      title: ecModel.getLocaleModel().get(['legend', 'selector', 'all'])
    };
  } else if (type === 'inverse') {
    return {
      type: 'inverse',
      title: ecModel.getLocaleModel().get(['legend', 'selector', 'inverse'])
    };
  }
};

var LegendModel =
/** @class */
function (_super) {
  __extends$1(LegendModel, _super);

  function LegendModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LegendModel.type;
    _this.layoutMode = {
      type: 'box',
      // legend.width/height are maxWidth/maxHeight actually,
      // whereas real width/height is calculated by its content.
      // (Setting {left: 10, right: 10} does not make sense).
      // So consider the case:
      // `setOption({legend: {left: 10});`
      // then `setOption({legend: {right: 10});`
      // The previous `left` should be cleared by setting `ignoreSize`.
      ignoreSize: true
    };
    return _this;
  }

  LegendModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
    option.selected = option.selected || {};

    this._updateSelector(option);
  };

  LegendModel.prototype.mergeOption = function (option, ecModel) {
    _super.prototype.mergeOption.call(this, option, ecModel);

    this._updateSelector(option);
  };

  LegendModel.prototype._updateSelector = function (option) {
    var selector = option.selector;
    var ecModel = this.ecModel;

    if (selector === true) {
      selector = option.selector = ['all', 'inverse'];
    }

    if (isArray$1(selector)) {
      each(selector, function (item, index) {
        isString(item) && (item = {
          type: item
        });
        selector[index] = merge$1(item, getDefaultSelectorOptions(ecModel, item.type));
      });
    }
  };

  LegendModel.prototype.optionUpdated = function () {
    this._updateData(this.ecModel);

    var legendData = this._data; // If selectedMode is single, try to select one

    if (legendData[0] && this.get('selectedMode') === 'single') {
      var hasSelected = false; // If has any selected in option.selected

      for (var i = 0; i < legendData.length; i++) {
        var name_1 = legendData[i].get('name');

        if (this.isSelected(name_1)) {
          // Force to unselect others
          this.select(name_1);
          hasSelected = true;
          break;
        }
      } // Try select the first if selectedMode is single


      !hasSelected && this.select(legendData[0].get('name'));
    }
  };

  LegendModel.prototype._updateData = function (ecModel) {
    var potentialData = [];
    var availableNames = [];
    ecModel.eachRawSeries(function (seriesModel) {
      var seriesName = seriesModel.name;
      availableNames.push(seriesName);
      var isPotential;

      if (seriesModel.legendVisualProvider) {
        var provider = seriesModel.legendVisualProvider;
        var names = provider.getAllNames();

        if (!ecModel.isSeriesFiltered(seriesModel)) {
          availableNames = availableNames.concat(names);
        }

        if (names.length) {
          potentialData = potentialData.concat(names);
        } else {
          isPotential = true;
        }
      } else {
        isPotential = true;
      }

      if (isPotential && isNameSpecified(seriesModel)) {
        potentialData.push(seriesModel.name);
      }
    });
    /**
     * @type {Array.<string>}
     * @private
     */

    this._availableNames = availableNames; // If legend.data is not specified in option, use availableNames as data,
    // which is convenient for user preparing option.

    var rawData = this.get('data') || potentialData;
    var legendNameMap = createHashMap();
    var legendData = map(rawData, function (dataItem) {
      // Can be string or number
      if (isString(dataItem) || isNumber$1(dataItem)) {
        dataItem = {
          name: dataItem
        };
      }

      if (legendNameMap.get(dataItem.name)) {
        // remove legend name duplicate
        return null;
      }

      legendNameMap.set(dataItem.name, true);
      return new Model(dataItem, this, this.ecModel);
    }, this);
    /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */

    this._data = filter(legendData, function (item) {
      return !!item;
    });
  };

  LegendModel.prototype.getData = function () {
    return this._data;
  };

  LegendModel.prototype.select = function (name) {
    var selected = this.option.selected;
    var selectedMode = this.get('selectedMode');

    if (selectedMode === 'single') {
      var data = this._data;
      each(data, function (dataItem) {
        selected[dataItem.get('name')] = false;
      });
    }

    selected[name] = true;
  };

  LegendModel.prototype.unSelect = function (name) {
    if (this.get('selectedMode') !== 'single') {
      this.option.selected[name] = false;
    }
  };

  LegendModel.prototype.toggleSelected = function (name) {
    var selected = this.option.selected; // Default is true

    if (!selected.hasOwnProperty(name)) {
      selected[name] = true;
    }

    this[selected[name] ? 'unSelect' : 'select'](name);
  };

  LegendModel.prototype.allSelect = function () {
    var data = this._data;
    var selected = this.option.selected;
    each(data, function (dataItem) {
      selected[dataItem.get('name', true)] = true;
    });
  };

  LegendModel.prototype.inverseSelect = function () {
    var data = this._data;
    var selected = this.option.selected;
    each(data, function (dataItem) {
      var name = dataItem.get('name', true); // Initially, default value is true

      if (!selected.hasOwnProperty(name)) {
        selected[name] = true;
      }

      selected[name] = !selected[name];
    });
  };

  LegendModel.prototype.isSelected = function (name) {
    var selected = this.option.selected;
    return !(selected.hasOwnProperty(name) && !selected[name]) && indexOf(this._availableNames, name) >= 0;
  };

  LegendModel.prototype.getOrient = function () {
    return this.get('orient') === 'vertical' ? {
      index: 1,
      name: 'vertical'
    } : {
      index: 0,
      name: 'horizontal'
    };
  };

  LegendModel.type = 'legend.plain';
  LegendModel.dependencies = ['series'];
  LegendModel.defaultOption = {
    // zlevel: 0,
    z: 4,
    show: true,
    orient: 'horizontal',
    left: 'center',
    // right: 'center',
    top: 0,
    // bottom: null,
    align: 'auto',
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    borderRadius: 0,
    borderWidth: 0,
    padding: 5,
    itemGap: 10,
    itemWidth: 25,
    itemHeight: 14,
    symbolRotate: 'inherit',
    symbolKeepAspect: true,
    inactiveColor: '#ccc',
    inactiveBorderColor: '#ccc',
    inactiveBorderWidth: 'auto',
    itemStyle: {
      color: 'inherit',
      opacity: 'inherit',
      borderColor: 'inherit',
      borderWidth: 'auto',
      borderCap: 'inherit',
      borderJoin: 'inherit',
      borderDashOffset: 'inherit',
      borderMiterLimit: 'inherit'
    },
    lineStyle: {
      width: 'auto',
      color: 'inherit',
      inactiveColor: '#ccc',
      inactiveWidth: 2,
      opacity: 'inherit',
      type: 'inherit',
      cap: 'inherit',
      join: 'inherit',
      dashOffset: 'inherit',
      miterLimit: 'inherit'
    },
    textStyle: {
      color: '#333'
    },
    selectedMode: true,
    selector: false,
    selectorLabel: {
      show: true,
      borderRadius: 10,
      padding: [3, 5, 3, 5],
      fontSize: 12,
      fontFamily: 'sans-serif',
      color: '#666',
      borderWidth: 1,
      borderColor: '#666'
    },
    emphasis: {
      selectorLabel: {
        show: true,
        color: '#eee',
        backgroundColor: '#666'
      }
    },
    selectorPosition: 'auto',
    selectorItemGap: 7,
    selectorButtonGap: 10,
    tooltip: {
      show: false
    }
  };
  return LegendModel;
}(ComponentModel);

var curry$1 = curry;
var each$c = each;
var Group$3 = Group$1;

var LegendView =
/** @class */
function (_super) {
  __extends$1(LegendView, _super);

  function LegendView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = LegendView.type;
    _this.newlineDisabled = false;
    return _this;
  }

  LegendView.prototype.init = function () {
    this.group.add(this._contentGroup = new Group$3());
    this.group.add(this._selectorGroup = new Group$3());
    this._isFirstRender = true;
  };
  /**
   * @protected
   */


  LegendView.prototype.getContentGroup = function () {
    return this._contentGroup;
  };
  /**
   * @protected
   */


  LegendView.prototype.getSelectorGroup = function () {
    return this._selectorGroup;
  };
  /**
   * @override
   */


  LegendView.prototype.render = function (legendModel, ecModel, api) {
    var isFirstRender = this._isFirstRender;
    this._isFirstRender = false;
    this.resetInner();

    if (!legendModel.get('show', true)) {
      return;
    }

    var itemAlign = legendModel.get('align');
    var orient = legendModel.get('orient');

    if (!itemAlign || itemAlign === 'auto') {
      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
    } // selector has been normalized to an array in model


    var selector = legendModel.get('selector', true);
    var selectorPosition = legendModel.get('selectorPosition', true);

    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
    }

    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.

    var positionInfo = legendModel.getBoxLayoutParams();
    var viewportSize = {
      width: api.getWidth(),
      height: api.getHeight()
    };
    var padding = legendModel.get('padding');
    var maxSize = getLayoutRect$1(positionInfo, viewportSize, padding);
    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.

    var layoutRect = getLayoutRect$1(defaults({
      width: mainRect.width,
      height: mainRect.height
    }, positionInfo), viewportSize, padding);
    this.group.x = layoutRect.x - mainRect.x;
    this.group.y = layoutRect.y - mainRect.y;
    this.group.markRedraw(); // Render background after group is layout.

    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
  };

  LegendView.prototype.resetInner = function () {
    this.getContentGroup().removeAll();
    this._backgroundEl && this.group.remove(this._backgroundEl);
    this.getSelectorGroup().removeAll();
  };

  LegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var legendDrawnMap = createHashMap();
    var selectMode = legendModel.get('selectedMode');
    var excludeSeriesId = [];
    ecModel.eachRawSeries(function (seriesModel) {
      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
    });
    each$c(legendModel.getData(), function (legendItemModel, dataIndex) {
      var name = legendItemModel.get('name'); // Use empty string or \n as a newline string

      if (!this.newlineDisabled && (name === '' || name === '\n')) {
        var g = new Group$3(); // @ts-ignore

        g.newline = true;
        contentGroup.add(g);
        return;
      } // Representitive series.


      var seriesModel = ecModel.getSeriesByName(name)[0];

      if (legendDrawnMap.get(name)) {
        // Have been drawn
        return;
      } // Legend to control series.


      if (seriesModel) {
        var data = seriesModel.getData();
        var lineVisualStyle = data.getVisual('legendLineStyle') || {};
        var legendIcon = data.getVisual('legendIcon');
        /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */

        var style = data.getVisual('style');

        var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);

        itemGroup.on('click', curry$1(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry$1(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry$1(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
        legendDrawnMap.set(name, true);
      } else {
        // Legend to control data. In pie and funnel.
        ecModel.eachRawSeries(function (seriesModel) {
          // In case multiple series has same data name
          if (legendDrawnMap.get(name)) {
            return;
          }

          if (seriesModel.legendVisualProvider) {
            var provider = seriesModel.legendVisualProvider;

            if (!provider.containName(name)) {
              return;
            }

            var idx = provider.indexOfName(name);
            var style = provider.getItemVisual(idx, 'style');
            var legendIcon = provider.getItemVisual(idx, 'legendIcon');
            var colorArr = parse(style.fill); // Color may be set to transparent in visualMap when data is out of range.
            // Do not show nothing.

            if (colorArr && colorArr[3] === 0) {
              colorArr[3] = 0.2; // TODO color is set to 0, 0, 0, 0. Should show correct RGBA

              style = extend(extend({}, style), {
                fill: stringify(colorArr, 'rgba')
              });
            }

            var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api); // FIXME: consider different series has items with the same name.


            itemGroup.on('click', curry$1(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
            // more than one pie series.
            .on('mouseover', curry$1(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry$1(dispatchDownplayAction, null, name, api, excludeSeriesId));
            legendDrawnMap.set(name, true);
          }
        }, this);
      }

      if (process.env.NODE_ENV !== 'production') {
        if (!legendDrawnMap.get(name)) {
          console.warn(name + ' series not exists. Legend data should be same with series name or data name.');
        }
      }
    }, this);

    if (selector) {
      this._createSelector(selector, legendModel, api, orient, selectorPosition);
    }
  };

  LegendView.prototype._createSelector = function (selector, legendModel, api, orient, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    each$c(selector, function createSelectorButton(selectorItem) {
      var type = selectorItem.type;
      var labelText = new ZRText({
        style: {
          x: 0,
          y: 0,
          align: 'center',
          verticalAlign: 'middle'
        },
        onclick: function () {
          api.dispatchAction({
            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
          });
        }
      });
      selectorGroup.add(labelText);
      var labelModel = legendModel.getModel('selectorLabel');
      var emphasisLabelModel = legendModel.getModel(['emphasis', 'selectorLabel']);
      setLabelStyle(labelText, {
        normal: labelModel,
        emphasis: emphasisLabelModel
      }, {
        defaultText: selectorItem.title
      });
      enableHoverEmphasis(labelText);
    });
  };

  LegendView.prototype._createItem = function (seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
    var drawType = seriesModel.visualDrawType;
    var itemWidth = legendModel.get('itemWidth');
    var itemHeight = legendModel.get('itemHeight');
    var isSelected = legendModel.isSelected(name);
    var iconRotate = legendItemModel.get('symbolRotate');
    var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
    var legendIconType = legendItemModel.get('icon');
    legendIcon = legendIconType || legendIcon || 'roundRect';
    var style = getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
    var itemGroup = new Group$3();
    var textStyleModel = legendItemModel.getModel('textStyle');

    if (isFunction$3(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) {
      // Series has specific way to define legend icon
      itemGroup.add(seriesModel.getLegendIcon({
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        icon: legendIcon,
        iconRotate: iconRotate,
        itemStyle: style.itemStyle,
        lineStyle: style.lineStyle,
        symbolKeepAspect: symbolKeepAspect
      }));
    } else {
      // Use default legend icon policy for most series
      var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon

      itemGroup.add(getDefaultLegendIcon({
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        icon: legendIcon,
        iconRotate: rotate,
        itemStyle: style.itemStyle,
        lineStyle: style.lineStyle,
        symbolKeepAspect: symbolKeepAspect
      }));
    }

    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
    var textAlign = itemAlign;
    var formatter = legendModel.get('formatter');
    var content = name;

    if (isString(formatter) && formatter) {
      content = formatter.replace('{name}', name != null ? name : '');
    } else if (isFunction$3(formatter)) {
      content = formatter(name);
    }

    var inactiveColor = legendItemModel.get('inactiveColor');
    itemGroup.add(new ZRText({
      style: createTextStyle(textStyleModel, {
        text: content,
        x: textX,
        y: itemHeight / 2,
        fill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
        align: textAlign,
        verticalAlign: 'middle'
      })
    })); // Add a invisible rect to increase the area of mouse hover

    var hitRect = new Rect({
      shape: itemGroup.getBoundingRect(),
      invisible: true
    });
    var tooltipModel = legendItemModel.getModel('tooltip');

    if (tooltipModel.get('show')) {
      setTooltipConfig({
        el: hitRect,
        componentModel: legendModel,
        itemName: name,
        itemTooltipOption: tooltipModel.option
      });
    }

    itemGroup.add(hitRect);
    itemGroup.eachChild(function (child) {
      child.silent = true;
    });
    hitRect.silent = !selectMode;
    this.getContentGroup().add(itemGroup);
    enableHoverEmphasis(itemGroup); // @ts-ignore

    itemGroup.__legendDataIndex = dataIndex;
    return itemGroup;
  };

  LegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var contentGroup = this.getContentGroup();
    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.

    box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
    var contentRect = contentGroup.getBoundingRect();
    var contentPos = [-contentRect.x, -contentRect.y];
    selectorGroup.markRedraw();
    contentGroup.markRedraw();

    if (selector) {
      // Place buttons in selectorGroup
      box( // Buttons in selectorGroup always layout horizontally
      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
      var selectorRect = selectorGroup.getBoundingRect();
      var selectorPos = [-selectorRect.x, -selectorRect.y];
      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
      var orientIdx = legendModel.getOrient().index;
      var wh = orientIdx === 0 ? 'width' : 'height';
      var hw = orientIdx === 0 ? 'height' : 'width';
      var yx = orientIdx === 0 ? 'y' : 'x';

      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
      } else {
        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
      } // Always align selector to content as 'middle'


      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
      selectorGroup.x = selectorPos[0];
      selectorGroup.y = selectorPos[1];
      contentGroup.x = contentPos[0];
      contentGroup.y = contentPos[1];
      var mainRect = {
        x: 0,
        y: 0
      };
      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
      return mainRect;
    } else {
      contentGroup.x = contentPos[0];
      contentGroup.y = contentPos[1];
      return this.group.getBoundingRect();
    }
  };
  /**
   * @protected
   */


  LegendView.prototype.remove = function () {
    this.getContentGroup().removeAll();
    this._isFirstRender = true;
  };

  LegendView.type = 'legend.plain';
  return LegendView;
}(ComponentView);

function getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
  /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */
  function handleCommonProps(style, visualStyle) {
    // If lineStyle.width is 'auto', it is set to be 2 if series has border
    if (style.lineWidth === 'auto') {
      style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
    }

    each$c(style, function (propVal, propName) {
      style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
    });
  } // itemStyle


  var itemStyleModel = legendItemModel.getModel('itemStyle');
  var itemStyle = itemStyleModel.getItemStyle();
  var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
  var decalStyle = itemStyleModel.getShallow('decal');
  itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : createOrUpdatePatternFromDecal(decalStyle, api);

  if (itemStyle.fill === 'inherit') {
    /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */
    itemStyle.fill = itemVisualStyle[drawType];
  }

  if (itemStyle.stroke === 'inherit') {
    /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */
    itemStyle.stroke = itemVisualStyle[iconBrushType];
  }

  if (itemStyle.opacity === 'inherit') {
    /**
     * Use lineStyle.opacity if drawType is stroke
     */
    itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
  }

  handleCommonProps(itemStyle, itemVisualStyle); // lineStyle

  var legendLineModel = legendItemModel.getModel('lineStyle');
  var lineStyle = legendLineModel.getLineStyle();
  handleCommonProps(lineStyle, lineVisualStyle); // Fix auto color to real color

  itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
  itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
  lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);

  if (!isSelected) {
    var borderWidth = legendItemModel.get('inactiveBorderWidth');
    /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */

    var visualHasBorder = itemStyle[iconBrushType];
    itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
    itemStyle.fill = legendItemModel.get('inactiveColor');
    itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
    lineStyle.stroke = legendLineModel.get('inactiveColor');
    lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
  }

  return {
    itemStyle: itemStyle,
    lineStyle: lineStyle
  };
}

function getDefaultLegendIcon(opt) {
  var symboType = opt.icon || 'roundRect';
  var icon = createSymbol(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
  icon.setStyle(opt.itemStyle);
  icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
  icon.setOrigin([opt.itemWidth / 2, opt.itemHeight / 2]);

  if (symboType.indexOf('empty') > -1) {
    icon.style.stroke = icon.style.fill;
    icon.style.fill = '#fff';
    icon.style.lineWidth = 2;
  }

  return icon;
}

function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
  // downplay before unselect
  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
  api.dispatchAction({
    type: 'legendToggleSelect',
    name: seriesName != null ? seriesName : dataName
  }); // highlight after select
  // TODO highlight immediately may cause animation loss.

  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}

function isUseHoverLayer(api) {
  var list = api.getZr().storage.getDisplayList();
  var emphasisState;
  var i = 0;
  var len = list.length;

  while (i < len && !(emphasisState = list[i].states.emphasis)) {
    i++;
  }

  return emphasisState && emphasisState.hoverLayer;
}

function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  if (!isUseHoverLayer(api)) {
    api.dispatchAction({
      type: 'highlight',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
  // If element hover will move to a hoverLayer.
  if (!isUseHoverLayer(api)) {
    api.dispatchAction({
      type: 'downplay',
      seriesName: seriesName,
      name: dataName,
      excludeSeriesId: excludeSeriesId
    });
  }
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function legendFilter(ecModel) {
  var legendModels = ecModel.findComponents({
    mainType: 'legend'
  });

  if (legendModels && legendModels.length) {
    ecModel.filterSeries(function (series) {
      // If in any legend component the status is not selected.
      // Because in legend series is assumed selected when it is not in the legend data.
      for (var i = 0; i < legendModels.length; i++) {
        if (!legendModels[i].isSelected(series.name)) {
          return false;
        }
      }

      return true;
    });
  }
}

function legendSelectActionHandler(methodName, payload, ecModel) {
  var selectedMap = {};
  var isToggleSelect = methodName === 'toggleSelected';
  var isSelected; // Update all legend components

  ecModel.eachComponent('legend', function (legendModel) {
    if (isToggleSelect && isSelected != null) {
      // Force other legend has same selected status
      // Or the first is toggled to true and other are toggled to false
      // In the case one legend has some item unSelected in option. And if other legend
      // doesn't has the item, they will assume it is selected.
      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
      legendModel[methodName]();
    } else {
      legendModel[methodName](payload.name);
      isSelected = legendModel.isSelected(payload.name);
    }

    var legendData = legendModel.getData();
    each(legendData, function (model) {
      var name = model.get('name'); // Wrap element

      if (name === '\n' || name === '') {
        return;
      }

      var isItemSelected = legendModel.isSelected(name);

      if (selectedMap.hasOwnProperty(name)) {
        // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
      } else {
        selectedMap[name] = isItemSelected;
      }
    });
  }); // Return the event explicitly

  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
    selected: selectedMap
  } : {
    name: payload.name,
    selected: selectedMap
  };
}

function installLegendAction(registers) {
  /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */
  registers.registerAction('legendToggleSelect', 'legendselectchanged', curry(legendSelectActionHandler, 'toggleSelected'));
  registers.registerAction('legendAllSelect', 'legendselectall', curry(legendSelectActionHandler, 'allSelect'));
  registers.registerAction('legendInverseSelect', 'legendinverseselect', curry(legendSelectActionHandler, 'inverseSelect'));
  /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */

  registers.registerAction('legendSelect', 'legendselected', curry(legendSelectActionHandler, 'select'));
  /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */

  registers.registerAction('legendUnSelect', 'legendunselected', curry(legendSelectActionHandler, 'unSelect'));
}

function install$H(registers) {
  registers.registerComponentModel(LegendModel);
  registers.registerComponentView(LegendView);
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
  registers.registerSubTypeDefaulter('legend', function () {
    return 'plain';
  });
  installLegendAction(registers);
}

var ScrollableLegendModel =
/** @class */
function (_super) {
  __extends$1(ScrollableLegendModel, _super);

  function ScrollableLegendModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScrollableLegendModel.type;
    return _this;
  }
  /**
   * @param {number} scrollDataIndex
   */


  ScrollableLegendModel.prototype.setScrollDataIndex = function (scrollDataIndex) {
    this.option.scrollDataIndex = scrollDataIndex;
  };

  ScrollableLegendModel.prototype.init = function (option, parentModel, ecModel) {
    var inputPositionParams = getLayoutParams(option);

    _super.prototype.init.call(this, option, parentModel, ecModel);

    mergeAndNormalizeLayoutParams$1(this, option, inputPositionParams);
  };
  /**
   * @override
   */


  ScrollableLegendModel.prototype.mergeOption = function (option, ecModel) {
    _super.prototype.mergeOption.call(this, option, ecModel);

    mergeAndNormalizeLayoutParams$1(this, this.option, option);
  };

  ScrollableLegendModel.type = 'legend.scroll';
  ScrollableLegendModel.defaultOption = inheritDefaultOption(LegendModel.defaultOption, {
    scrollDataIndex: 0,
    pageButtonItemGap: 5,
    pageButtonGap: null,
    pageButtonPosition: 'end',
    pageFormatter: '{current}/{total}',
    pageIcons: {
      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
    },
    pageIconColor: '#2f4554',
    pageIconInactiveColor: '#aaa',
    pageIconSize: 15,
    pageTextStyle: {
      color: '#333'
    },
    animationDurationUpdate: 800
  });
  return ScrollableLegendModel;
}(LegendModel);

function mergeAndNormalizeLayoutParams$1(legendModel, target, raw) {
  var orient = legendModel.getOrient();
  var ignoreSize = [1, 1];
  ignoreSize[orient.index] = 0;
  mergeLayoutParam(target, raw, {
    type: 'box',
    ignoreSize: !!ignoreSize
  });
}

var Group$4 = Group$1;
var WH$1 = ['width', 'height'];
var XY$1 = ['x', 'y'];

var ScrollableLegendView =
/** @class */
function (_super) {
  __extends$1(ScrollableLegendView, _super);

  function ScrollableLegendView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ScrollableLegendView.type;
    _this.newlineDisabled = true;
    _this._currentIndex = 0;
    return _this;
  }

  ScrollableLegendView.prototype.init = function () {
    _super.prototype.init.call(this);

    this.group.add(this._containerGroup = new Group$4());

    this._containerGroup.add(this.getContentGroup());

    this.group.add(this._controllerGroup = new Group$4());
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.resetInner = function () {
    _super.prototype.resetInner.call(this);

    this._controllerGroup.removeAll();

    this._containerGroup.removeClipPath();

    this._containerGroup.__rectSize = null;
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.renderInner = function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
    var self = this; // Render content items.

    _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);

    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
    // e.g., '3/12345' should not overlap with the control arrow button.

    var pageIconSize = legendModel.get('pageIconSize', true);
    var pageIconSizeArr = isArray$1(pageIconSize) ? pageIconSize : [pageIconSize, pageIconSize];
    createPageButton('pagePrev', 0);
    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
    controllerGroup.add(new ZRText({
      name: 'pageText',
      style: {
        // Placeholder to calculate a proper layout.
        text: 'xx/xx',
        fill: pageTextStyleModel.getTextColor(),
        font: pageTextStyleModel.getFont(),
        verticalAlign: 'middle',
        align: 'center'
      },
      silent: true
    }));
    createPageButton('pageNext', 1);

    function createPageButton(name, iconIdx) {
      var pageDataIndexName = name + 'DataIndex';
      var icon = createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
        // Buttons will be created in each render, so we do not need
        // to worry about avoiding using legendModel kept in scope.
        onclick: bind(self._pageGo, self, pageDataIndexName, legendModel, api)
      }, {
        x: -pageIconSizeArr[0] / 2,
        y: -pageIconSizeArr[1] / 2,
        width: pageIconSizeArr[0],
        height: pageIconSizeArr[1]
      });
      icon.name = name;
      controllerGroup.add(icon);
    }
  };
  /**
   * @override
   */


  ScrollableLegendView.prototype.layoutInner = function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
    var selectorGroup = this.getSelectorGroup();
    var orientIdx = legendModel.getOrient().index;
    var wh = WH$1[orientIdx];
    var xy = XY$1[orientIdx];
    var hw = WH$1[1 - orientIdx];
    var yx = XY$1[1 - orientIdx];
    selector && box( // Buttons in selectorGroup always layout horizontally
    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
    var selectorRect = selectorGroup.getBoundingRect();
    var selectorPos = [-selectorRect.x, -selectorRect.y];
    var processMaxSize = clone(maxSize);
    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);

    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);

    if (selector) {
      if (selectorPosition === 'end') {
        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
      } else {
        var offset = selectorRect[wh] + selectorButtonGap;
        selectorPos[orientIdx] -= offset;
        mainRect[xy] -= offset;
      }

      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
      selectorGroup.x = selectorPos[0];
      selectorGroup.y = selectorPos[1];
      selectorGroup.markRedraw();
    }

    return mainRect;
  };

  ScrollableLegendView.prototype._layoutContentAndController = function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
    var contentGroup = this.getContentGroup();
    var containerGroup = this._containerGroup;
    var controllerGroup = this._controllerGroup; // Place items in contentGroup.

    box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
    box( // Buttons in controller are layout always horizontally.
    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
    var contentRect = contentGroup.getBoundingRect();
    var controllerRect = controllerGroup.getBoundingRect();
    var showController = this._showController = contentRect[wh] > maxSize[wh]; // In case that the inner elements of contentGroup layout do not based on [0, 0]

    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
    // If first rendering, `contentGroup.position` is [0, 0], which
    // does not make sense and may cause unexepcted animation if adopted.

    if (!isFirstRender) {
      contentPos[orientIdx] = contentGroup[xy];
    } // Layout container group based on 0.


    var containerPos = [0, 0];
    var controllerPos = [-controllerRect.x, -controllerRect.y];
    var pageButtonGap = retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.

    if (showController) {
      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.

      if (pageButtonPosition === 'end') {
        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
      } // controller is on the left / top.
      else {
          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
    } // Always align controller to content as 'middle'.


    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
    contentGroup.setPosition(contentPos);
    containerGroup.setPosition(containerPos);
    controllerGroup.setPosition(controllerPos); // Calculate `mainRect` and set `clipPath`.
    // mainRect should not be calculated by `this.group.getBoundingRect()`
    // for sake of the overflow.

    var mainRect = {
      x: 0,
      y: 0
    }; // Consider content may be overflow (should be clipped).

    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.

    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
    containerGroup.__rectSize = maxSize[wh];

    if (showController) {
      var clipShape = {
        x: 0,
        y: 0
      };
      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
      clipShape[hw] = mainRect[hw];
      containerGroup.setClipPath(new Rect({
        shape: clipShape
      })); // Consider content may be larger than container, container rect
      // can not be obtained from `containerGroup.getBoundingRect()`.

      containerGroup.__rectSize = clipShape[wh];
    } else {
      // Do not remove or ignore controller. Keep them set as placeholders.
      controllerGroup.eachChild(function (child) {
        child.attr({
          invisible: true,
          silent: true
        });
      });
    } // Content translate animation.


    var pageInfo = this._getPageInfo(legendModel);

    pageInfo.pageIndex != null && updateProps(contentGroup, {
      x: pageInfo.contentPosition[0],
      y: pageInfo.contentPosition[1]
    }, // When switch from "show controller" to "not show controller", view should be
    // updated immediately without animation, otherwise causes weird effect.
    showController ? legendModel : null);

    this._updatePageInfoView(legendModel, pageInfo);

    return mainRect;
  };

  ScrollableLegendView.prototype._pageGo = function (to, legendModel, api) {
    var scrollDataIndex = this._getPageInfo(legendModel)[to];

    scrollDataIndex != null && api.dispatchAction({
      type: 'legendScroll',
      scrollDataIndex: scrollDataIndex,
      legendId: legendModel.id
    });
  };

  ScrollableLegendView.prototype._updatePageInfoView = function (legendModel, pageInfo) {
    var controllerGroup = this._controllerGroup;
    each(['pagePrev', 'pageNext'], function (name) {
      var key = name + 'DataIndex';
      var canJump = pageInfo[key] != null;
      var icon = controllerGroup.childOfName(name);

      if (icon) {
        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
        icon.cursor = canJump ? 'pointer' : 'default';
      }
    });
    var pageText = controllerGroup.childOfName('pageText');
    var pageFormatter = legendModel.get('pageFormatter');
    var pageIndex = pageInfo.pageIndex;
    var current = pageIndex != null ? pageIndex + 1 : 0;
    var total = pageInfo.pageCount;
    pageText && pageFormatter && pageText.setStyle('text', isString(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
      current: current,
      total: total
    }));
  };
  /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */


  ScrollableLegendView.prototype._getPageInfo = function (legendModel) {
    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
    var contentGroup = this.getContentGroup();
    var containerRectSize = this._containerGroup.__rectSize;
    var orientIdx = legendModel.getOrient().index;
    var wh = WH$1[orientIdx];
    var xy = XY$1[orientIdx];

    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);

    var children = contentGroup.children();
    var targetItem = children[targetItemIndex];
    var itemCount = children.length;
    var pCount = !itemCount ? 0 : 1;
    var result = {
      contentPosition: [contentGroup.x, contentGroup.y],
      pageCount: pCount,
      pageIndex: pCount - 1,
      pagePrevDataIndex: null,
      pageNextDataIndex: null
    };

    if (!targetItem) {
      return result;
    }

    var targetItemInfo = getItemInfo(targetItem);
    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
    // (1) Always align based on the left/top most item.
    // (2) It is user-friendly that the last item shown in the
    // current window is shown at the begining of next window.
    // Otherwise if half of the last item is cut by the window,
    // it will have no chance to display entirely.
    // (3) Consider that item size probably be different, we
    // have calculate pageIndex by size rather than item index,
    // and we can not get page index directly by division.
    // (4) The window is to narrow to contain more than
    // one item, we should make sure that the page can be fliped.

    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // Half of the last item is out of the window.
      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
      // can be started at the current item or the last item.
      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
        if (winEndItemInfo.i > winStartItemInfo.i) {
          winStartItemInfo = winEndItemInfo;
        } else {
          // e.g., when page size is smaller than item size.
          winStartItemInfo = currItemInfo;
        }

        if (winStartItemInfo) {
          if (result.pageNextDataIndex == null) {
            result.pageNextDataIndex = winStartItemInfo.i;
          }

          ++result.pageCount;
        }
      }

      winEndItemInfo = currItemInfo;
    }

    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
      currItemInfo = getItemInfo(children[i]);

      if ( // If the the end item does not intersect with the window started
      // from the current item, a page can be settled.
      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
      winStartItemInfo.i < winEndItemInfo.i) {
        winEndItemInfo = winStartItemInfo;

        if (result.pagePrevDataIndex == null) {
          result.pagePrevDataIndex = winStartItemInfo.i;
        }

        ++result.pageCount;
        ++result.pageIndex;
      }

      winStartItemInfo = currItemInfo;
    }

    return result;

    function getItemInfo(el) {
      if (el) {
        var itemRect = el.getBoundingRect();
        var start = itemRect[xy] + el[xy];
        return {
          s: start,
          e: start + itemRect[wh],
          i: el.__legendDataIndex
        };
      }
    }

    function intersect(itemInfo, winStart) {
      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
    }
  };

  ScrollableLegendView.prototype._findTargetItemIndex = function (targetDataIndex) {
    if (!this._showController) {
      return 0;
    }

    var index;
    var contentGroup = this.getContentGroup();
    var defaultIndex;
    contentGroup.eachChild(function (child, idx) {
      var legendDataIdx = child.__legendDataIndex; // FIXME
      // If the given targetDataIndex (from model) is illegal,
      // we use defaultIndex. But the index on the legend model and
      // action payload is still illegal. That case will not be
      // changed until some scenario requires.

      if (defaultIndex == null && legendDataIdx != null) {
        defaultIndex = idx;
      }

      if (legendDataIdx === targetDataIndex) {
        index = idx;
      }
    });
    return index != null ? index : defaultIndex;
  };

  ScrollableLegendView.type = 'legend.scroll';
  return ScrollableLegendView;
}(LegendView);

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
function installScrollableLegendAction(registers) {
  /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */
  registers.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
    var scrollDataIndex = payload.scrollDataIndex;
    scrollDataIndex != null && ecModel.eachComponent({
      mainType: 'legend',
      subType: 'scroll',
      query: payload
    }, function (legendModel) {
      legendModel.setScrollDataIndex(scrollDataIndex);
    });
  });
}

function install$I(registers) {
  use(install$H);
  registers.registerComponentModel(ScrollableLegendModel);
  registers.registerComponentView(ScrollableLegendView);
  installScrollableLegendAction(registers);
}

function install$J(registers) {
  use(install$H);
  use(install$I);
}

var InsideZoomModel =
/** @class */
function (_super) {
  __extends$1(InsideZoomModel, _super);

  function InsideZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = InsideZoomModel.type;
    return _this;
  }

  InsideZoomModel.type = 'dataZoom.inside';
  InsideZoomModel.defaultOption = inheritDefaultOption(DataZoomModel.defaultOption, {
    disabled: false,
    zoomLock: false,
    zoomOnMouseWheel: true,
    moveOnMouseMove: true,
    moveOnMouseWheel: false,
    preventDefaultMouseMove: true
  });
  return InsideZoomModel;
}(DataZoomModel);

var inner$l = makeInner();
function setViewInfoToCoordSysRecord(api, dataZoomModel, getRange) {
  inner$l(api).coordSysRecordMap.each(function (coordSysRecord) {
    var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);

    if (dzInfo) {
      dzInfo.getRange = getRange;
    }
  });
}
function disposeCoordSysRecordIfNeeded(api, dataZoomModel) {
  var coordSysRecordMap = inner$l(api).coordSysRecordMap;
  var coordSysKeyArr = coordSysRecordMap.keys();

  for (var i = 0; i < coordSysKeyArr.length; i++) {
    var coordSysKey = coordSysKeyArr[i];
    var coordSysRecord = coordSysRecordMap.get(coordSysKey);
    var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;

    if (dataZoomInfoMap) {
      var dzUid = dataZoomModel.uid;
      var dzInfo = dataZoomInfoMap.get(dzUid);

      if (dzInfo) {
        dataZoomInfoMap.removeKey(dzUid);

        if (!dataZoomInfoMap.keys().length) {
          disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
        }
      }
    }
  }
}

function disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
  if (coordSysRecord) {
    coordSysRecordMap.removeKey(coordSysRecord.model.uid);
    var controller = coordSysRecord.controller;
    controller && controller.dispose();
  }
}

function createCoordSysRecord(api, coordSysModel) {
  // These init props will never change after record created.
  var coordSysRecord = {
    model: coordSysModel,
    containsPoint: curry(containsPoint, coordSysModel),
    dispatchAction: curry(dispatchAction$1, api),
    dataZoomInfoMap: null,
    controller: null
  }; // Must not do anything depends on coordSysRecord outside the event handler here,
  // because coordSysRecord not completed yet.

  var controller = coordSysRecord.controller = new RoamController(api.getZr());
  each(['pan', 'zoom', 'scrollMove'], function (eventName) {
    controller.on(eventName, function (event) {
      var batch = [];
      coordSysRecord.dataZoomInfoMap.each(function (dzInfo) {
        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
        // moveOnMouseWheel, ...) enabled.
        if (!event.isAvailableBehavior(dzInfo.model.option)) {
          return;
        }

        var method = (dzInfo.getRange || {})[eventName];
        var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
        !dzInfo.model.get('disabled', true) && range && batch.push({
          dataZoomId: dzInfo.model.id,
          start: range[0],
          end: range[1]
        });
      });
      batch.length && coordSysRecord.dispatchAction(batch);
    });
  });
  return coordSysRecord;
}
/**
 * This action will be throttled.
 */


function dispatchAction$1(api, batch) {
  if (!api.isDisposed()) {
    api.dispatchAction({
      type: 'dataZoom',
      animation: {
        easing: 'cubicOut',
        duration: 100
      },
      batch: batch
    });
  }
}

function containsPoint(coordSysModel, e, x, y) {
  return coordSysModel.coordinateSystem.containPoint([x, y]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */


function mergeControllerParams(dataZoomInfoMap) {
  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
  // as string, it is probably revert to reserved word by compress tool. See #7411.

  var prefix = 'type_';
  var typePriority = {
    'type_true': 2,
    'type_move': 1,
    'type_false': 0,
    'type_undefined': -1
  };
  var preventDefaultMouseMove = true;
  dataZoomInfoMap.each(function (dataZoomInfo) {
    var dataZoomModel = dataZoomInfo.model;
    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;

    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
      controlType = oneType;
    } // Prevent default move event by default. If one false, do not prevent. Otherwise
    // users may be confused why it does not work when multiple insideZooms exist.


    preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
  });
  return {
    controlType: controlType,
    opt: {
      // RoamController will enable all of these functionalities,
      // and the final behavior is determined by its event listener
      // provided by each inside zoom.
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      moveOnMouseWheel: true,
      preventDefaultMouseMove: !!preventDefaultMouseMove
    }
  };
}

function installDataZoomRoamProcessor(registers) {
  registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function (ecModel, api) {
    var apiInner = inner$l(api);
    var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = createHashMap());
    coordSysRecordMap.each(function (coordSysRecord) {
      // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
      // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
      coordSysRecord.dataZoomInfoMap = null;
    });
    ecModel.eachComponent({
      mainType: 'dataZoom',
      subType: 'inside'
    }, function (dataZoomModel) {
      var dzReferCoordSysWrap = collectReferCoordSysModelInfo(dataZoomModel);
      each(dzReferCoordSysWrap.infoList, function (dzCoordSysInfo) {
        var coordSysUid = dzCoordSysInfo.model.uid;
        var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, createCoordSysRecord(api, dzCoordSysInfo.model));
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = createHashMap()); // Notice these props might be changed each time for a single dataZoomModel.

        dataZoomInfoMap.set(dataZoomModel.uid, {
          dzReferCoordSysInfo: dzCoordSysInfo,
          model: dataZoomModel,
          getRange: null
        });
      });
    }); // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
    // (2) Clear coord sys if not refered by any dataZoom.

    coordSysRecordMap.each(function (coordSysRecord) {
      var controller = coordSysRecord.controller;
      var firstDzInfo;
      var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;

      if (dataZoomInfoMap) {
        var firstDzKey = dataZoomInfoMap.keys()[0];

        if (firstDzKey != null) {
          firstDzInfo = dataZoomInfoMap.get(firstDzKey);
        }
      }

      if (!firstDzInfo) {
        disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
        return;
      }

      var controllerParams = mergeControllerParams(dataZoomInfoMap);
      controller.enable(controllerParams.controlType, controllerParams.opt);
      controller.setPointerChecker(coordSysRecord.containsPoint);
      createOrUpdate(coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
    });
  });
}

var InsideZoomView =
/** @class */
function (_super) {
  __extends$1(InsideZoomView, _super);

  function InsideZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataZoom.inside';
    return _this;
  }

  InsideZoomView.prototype.render = function (dataZoomModel, ecModel, api) {
    _super.prototype.render.apply(this, arguments);

    if (dataZoomModel.noTarget()) {
      this._clear();

      return;
    } // Hence the `throttle` util ensures to preserve command order,
    // here simply updating range all the time will not cause missing
    // any of the the roam change.


    this.range = dataZoomModel.getPercentRange(); // Reset controllers.

    setViewInfoToCoordSysRecord(api, dataZoomModel, {
      pan: bind(getRangeHandlers.pan, this),
      zoom: bind(getRangeHandlers.zoom, this),
      scrollMove: bind(getRangeHandlers.scrollMove, this)
    });
  };

  InsideZoomView.prototype.dispose = function () {
    this._clear();

    _super.prototype.dispose.apply(this, arguments);
  };

  InsideZoomView.prototype._clear = function () {
    disposeCoordSysRecordIfNeeded(this.api, this.dataZoomModel);
    this.range = null;
  };

  InsideZoomView.type = 'dataZoom.inside';
  return InsideZoomView;
}(DataZoomView);

var getRangeHandlers = {
  zoom: function (coordSysInfo, coordSysMainType, controller, e) {
    var lastRange = this.range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordSysInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var directionInfo = getDirectionInfo[coordSysMainType](null, [e.originX, e.originY], axisModel, controller, coordSysInfo);
    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
    var scale = Math.max(1 / e.scale, 0);
    range[0] = (range[0] - percentPoint) * scale + percentPoint;
    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.

    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
    this.range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  },
  pan: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
    var directionInfo = getDirectionInfo[coordSysMainType]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordSysInfo);
    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
  }),
  scrollMove: makeMover(function (range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
    var directionInfo = getDirectionInfo[coordSysMainType]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordSysInfo);
    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
  })
};

function makeMover(getPercentDelta) {
  return function (coordSysInfo, coordSysMainType, controller, e) {
    var lastRange = this.range;
    var range = lastRange.slice(); // Calculate transform by the first axis.

    var axisModel = coordSysInfo.axisModels[0];

    if (!axisModel) {
      return;
    }

    var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
    sliderMove(percentDelta, range, [0, 100], 'all');
    this.range = range;

    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
      return range;
    }
  };
}

var getDirectionInfo = {
  grid: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var rect = coordSysInfo.model.coordinateSystem.getRect();
    oldPoint = oldPoint || [0, 0];

    if (axis.dim === 'x') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // axis.dim === 'y'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  polar: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var ret = {};
    var polar = coordSysInfo.model.coordinateSystem;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var angleExtent = polar.getAngleAxis().getExtent();
    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
    newPoint = polar.pointToCoord(newPoint);

    if (axisModel.mainType === 'radiusAxis') {
      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);

      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
      ret.pixelStart = radiusExtent[0];
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'angleAxis'
      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);

      ret.pixelLength = angleExtent[1] - angleExtent[0];
      ret.pixelStart = angleExtent[0];
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  },
  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordSysInfo) {
    var axis = axisModel.axis;
    var rect = coordSysInfo.model.coordinateSystem.getRect();
    var ret = {};
    oldPoint = oldPoint || [0, 0];

    if (axis.orient === 'horizontal') {
      ret.pixel = newPoint[0] - oldPoint[0];
      ret.pixelLength = rect.width;
      ret.pixelStart = rect.x;
      ret.signal = axis.inverse ? 1 : -1;
    } else {
      // 'vertical'
      ret.pixel = newPoint[1] - oldPoint[1];
      ret.pixelLength = rect.height;
      ret.pixelStart = rect.y;
      ret.signal = axis.inverse ? -1 : 1;
    }

    return ret;
  }
};

function install$K(registers) {
  installCommon(registers);
  registers.registerComponentModel(InsideZoomModel);
  registers.registerComponentView(InsideZoomView);
  installDataZoomRoamProcessor(registers);
}

var SliderZoomModel =
/** @class */
function (_super) {
  __extends$1(SliderZoomModel, _super);

  function SliderZoomModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderZoomModel.type;
    return _this;
  }

  SliderZoomModel.type = 'dataZoom.slider';
  SliderZoomModel.layoutMode = 'box';
  SliderZoomModel.defaultOption = inheritDefaultOption(DataZoomModel.defaultOption, {
    show: true,
    // deault value can only be drived in view stage.
    right: 'ph',
    top: 'ph',
    width: 'ph',
    height: 'ph',
    left: null,
    bottom: null,
    borderColor: '#d2dbee',
    borderRadius: 3,
    backgroundColor: 'rgba(47,69,84,0)',
    // dataBackgroundColor: '#ddd',
    dataBackground: {
      lineStyle: {
        color: '#d2dbee',
        width: 0.5
      },
      areaStyle: {
        color: '#d2dbee',
        opacity: 0.2
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: '#8fb0f7',
        width: 0.5
      },
      areaStyle: {
        color: '#8fb0f7',
        opacity: 0.2
      }
    },
    // Color of selected window.
    fillerColor: 'rgba(135,175,274,0.2)',
    handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
    // Percent of the slider height
    handleSize: '100%',
    handleStyle: {
      color: '#fff',
      borderColor: '#ACB8D1'
    },
    moveHandleSize: 7,
    moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
    moveHandleStyle: {
      color: '#D2DBEE',
      opacity: 0.7
    },
    showDetail: true,
    showDataShadow: 'auto',
    realtime: true,
    zoomLock: false,
    textStyle: {
      color: '#6E7079'
    },
    brushSelect: true,
    brushStyle: {
      color: 'rgba(135,175,274,0.15)'
    },
    emphasis: {
      handleStyle: {
        borderColor: '#8FB0F7'
      },
      moveHandleStyle: {
        color: '#8FB0F7'
      }
    }
  });
  return SliderZoomModel;
}(DataZoomModel);

var Rect$2 = Rect; // Constants

var DEFAULT_LOCATION_EDGE_GAP = 7;
var DEFAULT_FRAME_BORDER_WIDTH = 1;
var DEFAULT_FILLER_SIZE = 30;
var DEFAULT_MOVE_HANDLE_SIZE = 7;
var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';
var LABEL_GAP = 5;
var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
var REALTIME_ANIMATION_CONFIG = {
  easing: 'cubicOut',
  duration: 100,
  delay: 0
};

var SliderZoomView =
/** @class */
function (_super) {
  __extends$1(SliderZoomView, _super);

  function SliderZoomView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = SliderZoomView.type;
    _this._displayables = {};
    return _this;
  }

  SliderZoomView.prototype.init = function (ecModel, api) {
    this.api = api; // A unique handler for each dataZoom component

    this._onBrush = bind(this._onBrush, this);
    this._onBrushEnd = bind(this._onBrushEnd, this);
  };

  SliderZoomView.prototype.render = function (dataZoomModel, ecModel, api, payload) {
    _super.prototype.render.apply(this, arguments);

    createOrUpdate(this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
    this._orient = dataZoomModel.getOrient();

    if (dataZoomModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    if (dataZoomModel.noTarget()) {
      this._clear();

      this.group.removeAll();
      return;
    } // Notice: this._resetInterval() should not be executed when payload.type
    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,


    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
      this._buildView();
    }

    this._updateView();
  };

  SliderZoomView.prototype.dispose = function () {
    this._clear();

    _super.prototype.dispose.apply(this, arguments);
  };

  SliderZoomView.prototype._clear = function () {
    clear(this, '_dispatchZoomAction');
    var zr = this.api.getZr();
    zr.off('mousemove', this._onBrush);
    zr.off('mouseup', this._onBrushEnd);
  };

  SliderZoomView.prototype._buildView = function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    this._brushing = false;
    this._displayables.brushRect = null;

    this._resetLocation();

    this._resetInterval();

    var barGroup = this._displayables.sliderGroup = new Group$1();

    this._renderBackground();

    this._renderHandle();

    this._renderDataShadow();

    thisGroup.add(barGroup);

    this._positionGroup();
  };

  SliderZoomView.prototype._resetLocation = function () {
    var dataZoomModel = this.dataZoomModel;
    var api = this.api;
    var showMoveHandle = dataZoomModel.get('brushSelect');
    var moveHandleSize = showMoveHandle ? DEFAULT_MOVE_HANDLE_SIZE : 0; // If some of x/y/width/height are not specified,
    // auto-adapt according to target grid.

    var coordRect = this._findCoordRect();

    var ecSize = {
      width: api.getWidth(),
      height: api.getHeight()
    }; // Default align by coordinate system rect.

    var positionInfo = this._orient === HORIZONTAL ? {
      // Why using 'right', because right should be used in vertical,
      // and it is better to be consistent for dealing with position param merge.
      right: ecSize.width - coordRect.x - coordRect.width,
      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
      width: coordRect.width,
      height: DEFAULT_FILLER_SIZE
    } : {
      right: DEFAULT_LOCATION_EDGE_GAP,
      top: coordRect.y,
      width: DEFAULT_FILLER_SIZE,
      height: coordRect.height
    }; // Do not write back to option and replace value 'ph', because
    // the 'ph' value should be recalculated when resize.

    var layoutParams = getLayoutParams(dataZoomModel.option); // Replace the placeholder value.

    each(['right', 'top', 'width', 'height'], function (name) {
      if (layoutParams[name] === 'ph') {
        layoutParams[name] = positionInfo[name];
      }
    });
    var layoutRect = getLayoutRect$1(layoutParams, ecSize);
    this._location = {
      x: layoutRect.x,
      y: layoutRect.y
    };
    this._size = [layoutRect.width, layoutRect.height];
    this._orient === VERTICAL && this._size.reverse();
  };

  SliderZoomView.prototype._positionGroup = function () {
    var thisGroup = this.group;
    var location = this._location;
    var orient = this._orient; // Just use the first axis to determine mapping.

    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
    var inverse = targetAxisModel && targetAxisModel.get('inverse');
    var sliderGroup = this._displayables.sliderGroup;
    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.

    sliderGroup.attr(orient === HORIZONTAL && !inverse ? {
      scaleY: otherAxisInverse ? 1 : -1,
      scaleX: 1
    } : orient === HORIZONTAL && inverse ? {
      scaleY: otherAxisInverse ? 1 : -1,
      scaleX: -1
    } : orient === VERTICAL && !inverse ? {
      scaleY: otherAxisInverse ? -1 : 1,
      scaleX: 1,
      rotation: Math.PI / 2
    } // Dont use Math.PI, considering shadow direction.
    : {
      scaleY: otherAxisInverse ? -1 : 1,
      scaleX: -1,
      rotation: Math.PI / 2
    }); // Position barGroup

    var rect = thisGroup.getBoundingRect([sliderGroup]);
    thisGroup.x = location.x - rect.x;
    thisGroup.y = location.y - rect.y;
    thisGroup.markRedraw();
  };

  SliderZoomView.prototype._getViewExtent = function () {
    return [0, this._size[0]];
  };

  SliderZoomView.prototype._renderBackground = function () {
    var dataZoomModel = this.dataZoomModel;
    var size = this._size;
    var barGroup = this._displayables.sliderGroup;
    var brushSelect = dataZoomModel.get('brushSelect');
    barGroup.add(new Rect$2({
      silent: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: dataZoomModel.get('backgroundColor')
      },
      z2: -40
    })); // Click panel, over shadow, below handles.

    var clickPanel = new Rect$2({
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1]
      },
      style: {
        fill: 'transparent'
      },
      z2: 0,
      onclick: bind(this._onClickPanel, this)
    });
    var zr = this.api.getZr();

    if (brushSelect) {
      clickPanel.on('mousedown', this._onBrushStart, this);
      clickPanel.cursor = 'crosshair';
      zr.on('mousemove', this._onBrush);
      zr.on('mouseup', this._onBrushEnd);
    } else {
      zr.off('mousemove', this._onBrush);
      zr.off('mouseup', this._onBrushEnd);
    }

    barGroup.add(clickPanel);
  };

  SliderZoomView.prototype._renderDataShadow = function () {
    var info = this._dataShadowInfo = this._prepareDataShadowInfo();

    this._displayables.dataShadowSegs = [];

    if (!info) {
      return;
    }

    var size = this._size;
    var oldSize = this._shadowSize || [];
    var seriesModel = info.series;
    var data = seriesModel.getRawData();
    var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
    var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
    : info.otherDim;

    if (otherDim == null) {
      return;
    }

    var polygonPts = this._shadowPolygonPts;
    var polylinePts = this._shadowPolylinePts; // Not re-render if data doesn't change.

    if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
      var otherDataExtent_1 = data.getDataExtent(otherDim); // Nice extent.

      var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
      otherDataExtent_1 = [otherDataExtent_1[0] - otherOffset, otherDataExtent_1[1] + otherOffset];
      var otherShadowExtent_1 = [0, size[1]];
      var thisShadowExtent = [0, size[0]];
      var areaPoints_1 = [[size[0], 0], [0, 0]];
      var linePoints_1 = [];
      var step_1 = thisShadowExtent[1] / (data.count() - 1);
      var thisCoord_1 = 0; // Optimize for large data shadow

      var stride_1 = Math.round(data.count() / size[0]);
      var lastIsEmpty_1;
      data.each([otherDim], function (value, index) {
        if (stride_1 > 0 && index % stride_1) {
          thisCoord_1 += step_1;
          return;
        } // FIXME
        // Should consider axis.min/axis.max when drawing dataShadow.
        // FIXME
        // 应该使用统一的空判断？还是在list里进行空判断？


        var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.

        var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent_1, otherShadowExtent_1, true); // Attempt to draw data shadow precisely when there are empty value.

        if (isEmpty && !lastIsEmpty_1 && index) {
          areaPoints_1.push([areaPoints_1[areaPoints_1.length - 1][0], 0]);
          linePoints_1.push([linePoints_1[linePoints_1.length - 1][0], 0]);
        } else if (!isEmpty && lastIsEmpty_1) {
          areaPoints_1.push([thisCoord_1, 0]);
          linePoints_1.push([thisCoord_1, 0]);
        }

        areaPoints_1.push([thisCoord_1, otherCoord]);
        linePoints_1.push([thisCoord_1, otherCoord]);
        thisCoord_1 += step_1;
        lastIsEmpty_1 = isEmpty;
      });
      polygonPts = this._shadowPolygonPts = areaPoints_1;
      polylinePts = this._shadowPolylinePts = linePoints_1;
    }

    this._shadowData = data;
    this._shadowDim = otherDim;
    this._shadowSize = [size[0], size[1]];
    var dataZoomModel = this.dataZoomModel;

    function createDataShadowGroup(isSelectedArea) {
      var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
      var group = new Group$1();
      var polygon = new Polygon({
        shape: {
          points: polygonPts
        },
        segmentIgnoreThreshold: 1,
        style: model.getModel('areaStyle').getAreaStyle(),
        silent: true,
        z2: -20
      });
      var polyline = new Polyline({
        shape: {
          points: polylinePts
        },
        segmentIgnoreThreshold: 1,
        style: model.getModel('lineStyle').getLineStyle(),
        silent: true,
        z2: -19
      });
      group.add(polygon);
      group.add(polyline);
      return group;
    } // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');


    for (var i = 0; i < 3; i++) {
      var group = createDataShadowGroup(i === 1);

      this._displayables.sliderGroup.add(group);

      this._displayables.dataShadowSegs.push(group);
    }
  };

  SliderZoomView.prototype._prepareDataShadowInfo = function () {
    var dataZoomModel = this.dataZoomModel;
    var showDataShadow = dataZoomModel.get('showDataShadow');

    if (showDataShadow === false) {
      return;
    } // Find a representative series.


    var result;
    var ecModel = this.ecModel;
    dataZoomModel.eachTargetAxis(function (axisDim, axisIndex) {
      var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
      each(seriesModels, function (seriesModel) {
        if (result) {
          return;
        }

        if (showDataShadow !== true && indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
          return;
        }

        var thisAxis = ecModel.getComponent(getAxisMainType(axisDim), axisIndex).axis;
        var otherDim = getOtherDim(axisDim);
        var otherAxisInverse;
        var coordSys = seriesModel.coordinateSystem;

        if (otherDim != null && coordSys.getOtherAxis) {
          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
        }

        otherDim = seriesModel.getData().mapDimension(otherDim);
        result = {
          thisAxis: thisAxis,
          series: seriesModel,
          thisDim: axisDim,
          otherDim: otherDim,
          otherAxisInverse: otherAxisInverse
        };
      }, this);
    }, this);
    return result;
  };

  SliderZoomView.prototype._renderHandle = function () {
    var thisGroup = this.group;
    var displayables = this._displayables;
    var handles = displayables.handles = [null, null];
    var handleLabels = displayables.handleLabels = [null, null];
    var sliderGroup = this._displayables.sliderGroup;
    var size = this._size;
    var dataZoomModel = this.dataZoomModel;
    var api = this.api;
    var borderRadius = dataZoomModel.get('borderRadius') || 0;
    var brushSelect = dataZoomModel.get('brushSelect');
    var filler = displayables.filler = new Rect$2({
      silent: brushSelect,
      style: {
        fill: dataZoomModel.get('fillerColor')
      },
      textConfig: {
        position: 'inside'
      }
    });
    sliderGroup.add(filler); // Frame border.

    sliderGroup.add(new Rect$2({
      silent: true,
      subPixelOptimize: true,
      shape: {
        x: 0,
        y: 0,
        width: size[0],
        height: size[1],
        r: borderRadius
      },
      style: {
        // deprecated option
        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
        fill: 'rgba(0,0,0,0)'
      }
    })); // Left and right handle to resize

    each([0, 1], function (handleIndex) {
      var iconStr = dataZoomModel.get('handleIcon');

      if (!symbolBuildProxies[iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) {
        // Compatitable with the old icon parsers. Which can use a path string without path://
        iconStr = 'path://' + iconStr;

        if (process.env.NODE_ENV !== 'production') {
          deprecateLog('handleIcon now needs \'path://\' prefix when using a path string');
        }
      }

      var path = createSymbol(iconStr, -1, 0, 2, 2, null, true);
      path.attr({
        cursor: getCursor(this._orient),
        draggable: true,
        drift: bind(this._onDragMove, this, handleIndex),
        ondragend: bind(this._onDragEnd, this),
        onmouseover: bind(this._showDataInfo, this, true),
        onmouseout: bind(this._showDataInfo, this, false),
        z2: 5
      });
      var bRect = path.getBoundingRect();
      var handleSize = dataZoomModel.get('handleSize');
      this._handleHeight = parsePercent$1(handleSize, this._size[1]);
      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
      path.style.strokeNoScale = true;
      path.rectHover = true;
      path.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
      enableHoverEmphasis(path);
      var handleColor = dataZoomModel.get('handleColor'); // deprecated option
      // Compatitable with previous version

      if (handleColor != null) {
        path.style.fill = handleColor;
      }

      sliderGroup.add(handles[handleIndex] = path);
      var textStyleModel = dataZoomModel.getModel('textStyle');
      thisGroup.add(handleLabels[handleIndex] = new ZRText({
        silent: true,
        invisible: true,
        style: createTextStyle(textStyleModel, {
          x: 0,
          y: 0,
          text: '',
          verticalAlign: 'middle',
          align: 'center',
          fill: textStyleModel.getTextColor(),
          font: textStyleModel.getFont()
        }),
        z2: 10
      }));
    }, this); // Handle to move. Only visible when brushSelect is set true.

    var actualMoveZone = filler;

    if (brushSelect) {
      var moveHandleHeight = parsePercent$1(dataZoomModel.get('moveHandleSize'), size[1]);
      var moveHandle_1 = displayables.moveHandle = new Rect({
        style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
        silent: true,
        shape: {
          r: [0, 0, 2, 2],
          y: size[1] - 0.5,
          height: moveHandleHeight
        }
      });
      var iconSize = moveHandleHeight * 0.8;
      var moveHandleIcon = displayables.moveHandleIcon = createSymbol(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, '#fff', true);
      moveHandleIcon.silent = true;
      moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
      moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel(['emphasis', 'moveHandleStyle']).getItemStyle();
      var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
      actualMoveZone = displayables.moveZone = new Rect({
        invisible: true,
        shape: {
          y: size[1] - moveZoneExpandSize,
          height: moveHandleHeight + moveZoneExpandSize
        }
      });
      actualMoveZone.on('mouseover', function () {
        api.enterEmphasis(moveHandle_1);
      }).on('mouseout', function () {
        api.leaveEmphasis(moveHandle_1);
      });
      sliderGroup.add(moveHandle_1);
      sliderGroup.add(moveHandleIcon);
      sliderGroup.add(actualMoveZone);
    }

    actualMoveZone.attr({
      draggable: true,
      cursor: getCursor(this._orient),
      drift: bind(this._onDragMove, this, 'all'),
      ondragstart: bind(this._showDataInfo, this, true),
      ondragend: bind(this._onDragEnd, this),
      onmouseover: bind(this._showDataInfo, this, true),
      onmouseout: bind(this._showDataInfo, this, false)
    });
  };

  SliderZoomView.prototype._resetInterval = function () {
    var range = this._range = this.dataZoomModel.getPercentRange();

    var viewExtent = this._getViewExtent();

    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
  };

  SliderZoomView.prototype._updateInterval = function (handleIndex, delta) {
    var dataZoomModel = this.dataZoomModel;
    var handleEnds = this._handleEnds;

    var viewExtend = this._getViewExtent();

    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
    var percentExtent = [0, 100];
    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
    var lastRange = this._range;
    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
  };

  SliderZoomView.prototype._updateView = function (nonRealtime) {
    var displaybles = this._displayables;
    var handleEnds = this._handleEnds;
    var handleInterval = asc(handleEnds.slice());
    var size = this._size;
    each([0, 1], function (handleIndex) {
      // Handles
      var handle = displaybles.handles[handleIndex];
      var handleHeight = this._handleHeight;
      handle.attr({
        scaleX: handleHeight / 2,
        scaleY: handleHeight / 2,
        // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
        // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
        x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
        y: size[1] / 2 - handleHeight / 2
      });
    }, this); // Filler

    displaybles.filler.setShape({
      x: handleInterval[0],
      y: 0,
      width: handleInterval[1] - handleInterval[0],
      height: size[1]
    });
    var viewExtent = {
      x: handleInterval[0],
      width: handleInterval[1] - handleInterval[0]
    }; // Move handle

    if (displaybles.moveHandle) {
      displaybles.moveHandle.setShape(viewExtent);
      displaybles.moveZone.setShape(viewExtent); // Force update path on the invisible object

      displaybles.moveZone.getBoundingRect();
      displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
    } // update clip path of shadow.


    var dataShadowSegs = displaybles.dataShadowSegs;
    var segIntervals = [0, handleInterval[0], handleInterval[1], size[0]];

    for (var i = 0; i < dataShadowSegs.length; i++) {
      var segGroup = dataShadowSegs[i];
      var clipPath = segGroup.getClipPath();

      if (!clipPath) {
        clipPath = new Rect();
        segGroup.setClipPath(clipPath);
      }

      clipPath.setShape({
        x: segIntervals[i],
        y: 0,
        width: segIntervals[i + 1] - segIntervals[i],
        height: size[1]
      });
    }

    this._updateDataInfo(nonRealtime);
  };

  SliderZoomView.prototype._updateDataInfo = function (nonRealtime) {
    var dataZoomModel = this.dataZoomModel;
    var displaybles = this._displayables;
    var handleLabels = displaybles.handleLabels;
    var orient = this._orient;
    var labelTexts = ['', '']; // FIXME
    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）

    if (dataZoomModel.get('showDetail')) {
      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();

      if (axisProxy) {
        var axis = axisProxy.getAxisModel().axis;
        var range = this._range;
        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
        ? axisProxy.calculateDataWindow({
          start: range[0],
          end: range[1]
        }).valueWindow : axisProxy.getDataValueWindow();
        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
      }
    }

    var orderedHandleEnds = asc(this._handleEnds.slice());
    setLabel.call(this, 0);
    setLabel.call(this, 1);

    function setLabel(handleIndex) {
      // Label
      // Text should not transform by barGroup.
      // Ignore handlers transform
      var barTransform = getTransform(displaybles.handles[handleIndex].parent, this.group);
      var direction = transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
      var offset = this._handleWidth / 2 + LABEL_GAP;
      var textPoint = applyTransform$1([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        verticalAlign: orient === HORIZONTAL ? 'middle' : direction,
        align: orient === HORIZONTAL ? direction : 'center',
        text: labelTexts[handleIndex]
      });
    }
  };

  SliderZoomView.prototype._formatLabel = function (value, axis) {
    var dataZoomModel = this.dataZoomModel;
    var labelFormatter = dataZoomModel.get('labelFormatter');
    var labelPrecision = dataZoomModel.get('labelPrecision');

    if (labelPrecision == null || labelPrecision === 'auto') {
      labelPrecision = axis.getPixelPrecision();
    }

    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
      value: Math.round(value)
    }) // param of toFixed should less then 20.
    : value.toFixed(Math.min(labelPrecision, 20));
    return isFunction$3(labelFormatter) ? labelFormatter(value, valueStr) : isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
  };
  /**
   * @param showOrHide true: show, false: hide
   */


  SliderZoomView.prototype._showDataInfo = function (showOrHide) {
    // Always show when drgging.
    showOrHide = this._dragging || showOrHide;
    var displayables = this._displayables;
    var handleLabels = displayables.handleLabels;
    handleLabels[0].attr('invisible', !showOrHide);
    handleLabels[1].attr('invisible', !showOrHide); // Highlight move handle

    displayables.moveHandle && this.api[showOrHide ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
  };

  SliderZoomView.prototype._onDragMove = function (handleIndex, dx, dy, event) {
    this._dragging = true; // For mobile device, prevent screen slider on the button.

    stop(event.event); // Transform dx, dy to bar coordination.

    var barTransform = this._displayables.sliderGroup.getLocalTransform();

    var vertex = applyTransform$1([dx, dy], barTransform, true);

    var changed = this._updateInterval(handleIndex, vertex[0]);

    var realtime = this.dataZoomModel.get('realtime');

    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
    // which cause bad visual effect when progressive enabled.


    changed && realtime && this._dispatchZoomAction(true);
  };

  SliderZoomView.prototype._onDragEnd = function () {
    this._dragging = false;

    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
    // drag end will cause the whole view rerender, which is unnecessary.


    var realtime = this.dataZoomModel.get('realtime');
    !realtime && this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onClickPanel = function (e) {
    var size = this._size;

    var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);

    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
      return;
    }

    var handleEnds = this._handleEnds;
    var center = (handleEnds[0] + handleEnds[1]) / 2;

    var changed = this._updateInterval('all', localPoint[0] - center);

    this._updateView();

    changed && this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onBrushStart = function (e) {
    var x = e.offsetX;
    var y = e.offsetY;
    this._brushStart = new Point(x, y);
    this._brushing = true;
    this._brushStartTime = +new Date(); // this._updateBrushRect(x, y);
  };

  SliderZoomView.prototype._onBrushEnd = function (e) {
    if (!this._brushing) {
      return;
    }

    var brushRect = this._displayables.brushRect;
    this._brushing = false;

    if (!brushRect) {
      return;
    }

    brushRect.attr('ignore', true);
    var brushShape = brushRect.shape;
    var brushEndTime = +new Date(); // console.log(brushEndTime - this._brushStartTime);

    if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) {
      // Will treat it as a click
      return;
    }

    var viewExtend = this._getViewExtent();

    var percentExtent = [0, 100];
    this._range = asc([linearMap(brushShape.x, viewExtend, percentExtent, true), linearMap(brushShape.x + brushShape.width, viewExtend, percentExtent, true)]);
    this._handleEnds = [brushShape.x, brushShape.x + brushShape.width];

    this._updateView();

    this._dispatchZoomAction(false);
  };

  SliderZoomView.prototype._onBrush = function (e) {
    if (this._brushing) {
      // For mobile device, prevent screen slider on the button.
      stop(e.event);

      this._updateBrushRect(e.offsetX, e.offsetY);
    }
  };

  SliderZoomView.prototype._updateBrushRect = function (mouseX, mouseY) {
    var displayables = this._displayables;
    var dataZoomModel = this.dataZoomModel;
    var brushRect = displayables.brushRect;

    if (!brushRect) {
      brushRect = displayables.brushRect = new Rect$2({
        silent: true,
        style: dataZoomModel.getModel('brushStyle').getItemStyle()
      });
      displayables.sliderGroup.add(brushRect);
    }

    brushRect.attr('ignore', false);
    var brushStart = this._brushStart;
    var sliderGroup = this._displayables.sliderGroup;
    var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
    var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
    var size = this._size;
    endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
    brushRect.setShape({
      x: startPoint[0],
      y: 0,
      width: endPoint[0] - startPoint[0],
      height: size[1]
    });
  };
  /**
   * This action will be throttled.
   */


  SliderZoomView.prototype._dispatchZoomAction = function (realtime) {
    var range = this._range;
    this.api.dispatchAction({
      type: 'dataZoom',
      from: this.uid,
      dataZoomId: this.dataZoomModel.id,
      animation: realtime ? REALTIME_ANIMATION_CONFIG : null,
      start: range[0],
      end: range[1]
    });
  };

  SliderZoomView.prototype._findCoordRect = function () {
    // Find the grid coresponding to the first axis referred by dataZoom.
    var rect;
    var coordSysInfoList = collectReferCoordSysModelInfo(this.dataZoomModel).infoList;

    if (!rect && coordSysInfoList.length) {
      var coordSys = coordSysInfoList[0].model.coordinateSystem;
      rect = coordSys.getRect && coordSys.getRect();
    }

    if (!rect) {
      var width = this.api.getWidth();
      var height = this.api.getHeight();
      rect = {
        x: width * 0.2,
        y: height * 0.2,
        width: width * 0.6,
        height: height * 0.6
      };
    }

    return rect;
  };

  SliderZoomView.type = 'dataZoom.slider';
  return SliderZoomView;
}(DataZoomView);

function getOtherDim(thisDim) {
  // FIXME
  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
  var map = {
    x: 'y',
    y: 'x',
    radius: 'angle',
    angle: 'radius'
  };
  return map[thisDim];
}

function getCursor(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

function install$L(registers) {
  registers.registerComponentModel(SliderZoomModel);
  registers.registerComponentView(SliderZoomView);
  installCommon(registers);
}

function install$M(registers) {
  use(install$K);
  use(install$L); // Do not install './dataZoomSelect',
  // since it only work for toolbox dataZoom.
}

var visualDefault = {
  /**
   * @public
   */
  get: function (visualType, key, isCategory) {
    var value = clone((defaultOption$1[visualType] || {})[key]);
    return isCategory ? isArray$1(value) ? value[value.length - 1] : value : value;
  }
};
var defaultOption$1 = {
  color: {
    active: ['#006edd', '#e0ffff'],
    inactive: ['rgba(0,0,0,0)']
  },
  colorHue: {
    active: [0, 360],
    inactive: [0, 0]
  },
  colorSaturation: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  colorLightness: {
    active: [0.9, 0.5],
    inactive: [0, 0]
  },
  colorAlpha: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  opacity: {
    active: [0.3, 1],
    inactive: [0, 0]
  },
  symbol: {
    active: ['circle', 'roundRect', 'diamond'],
    inactive: ['none']
  },
  symbolSize: {
    active: [10, 50],
    inactive: [0, 0]
  }
};

var mapVisual$1 = VisualMapping.mapVisual;
var eachVisual = VisualMapping.eachVisual;
var isArray$2 = isArray$1;
var each$d = each;
var asc$2 = asc;
var linearMap$1 = linearMap;

var VisualMapModel =
/** @class */
function (_super) {
  __extends$1(VisualMapModel, _super);

  function VisualMapModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = VisualMapModel.type;
    _this.stateList = ['inRange', 'outOfRange'];
    _this.replacableOptionKeys = ['inRange', 'outOfRange', 'target', 'controller', 'color'];
    _this.layoutMode = {
      type: 'box',
      ignoreSize: true
    };
    /**
     * [lowerBound, upperBound]
     */

    _this.dataBound = [-Infinity, Infinity];
    _this.targetVisuals = {};
    _this.controllerVisuals = {};
    return _this;
  }

  VisualMapModel.prototype.init = function (option, parentModel, ecModel) {
    this.mergeDefaultAndTheme(option, ecModel);
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.optionUpdated = function (newOption, isInit) {
    var thisOption = this.option;
    !isInit && replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
    this.textStyleModel = this.getModel('textStyle');
    this.resetItemSize();
    this.completeVisualOption();
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.resetVisual = function (supplementVisualOption) {
    var stateList = this.stateList;
    supplementVisualOption = bind(supplementVisualOption, this);
    this.controllerVisuals = createVisualMappings(this.option.controller, stateList, supplementVisualOption);
    this.targetVisuals = createVisualMappings(this.option.target, stateList, supplementVisualOption);
  };
  /**
   * @public
   */


  VisualMapModel.prototype.getItemSymbol = function () {
    return null;
  };
  /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */


  VisualMapModel.prototype.getTargetSeriesIndices = function () {
    var optionSeriesIndex = this.option.seriesIndex;
    var seriesIndices = [];

    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
      this.ecModel.eachSeries(function (seriesModel, index) {
        seriesIndices.push(index);
      });
    } else {
      seriesIndices = normalizeToArray(optionSeriesIndex);
    }

    return seriesIndices;
  };
  /**
   * @public
   */


  VisualMapModel.prototype.eachTargetSeries = function (callback, context) {
    each(this.getTargetSeriesIndices(), function (seriesIndex) {
      var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);

      if (seriesModel) {
        callback.call(context, seriesModel);
      }
    }, this);
  };
  /**
   * @pubilc
   */


  VisualMapModel.prototype.isTargetSeries = function (seriesModel) {
    var is = false;
    this.eachTargetSeries(function (model) {
      model === seriesModel && (is = true);
    });
    return is;
  };
  /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */


  VisualMapModel.prototype.formatValueText = function (value, isCategory, edgeSymbols) {
    var option = this.option;
    var precision = option.precision;
    var dataBound = this.dataBound;
    var formatter = option.formatter;
    var isMinMax;
    edgeSymbols = edgeSymbols || ['<', '>'];

    if (isArray$1(value)) {
      value = value.slice();
      isMinMax = true;
    }

    var textValue = isCategory ? value // Value is string when isCategory
    : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);

    if (isString(formatter)) {
      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
    } else if (isFunction$3(formatter)) {
      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
    }

    if (isMinMax) {
      if (value[0] === dataBound[0]) {
        return edgeSymbols[0] + ' ' + textValue[1];
      } else if (value[1] === dataBound[1]) {
        return edgeSymbols[1] + ' ' + textValue[0];
      } else {
        return textValue[0] + ' - ' + textValue[1];
      }
    } else {
      // Format single value (includes category case).
      return textValue;
    }

    function toFixed(val) {
      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
    }
  };
  /**
   * @protected
   */


  VisualMapModel.prototype.resetExtent = function () {
    var thisOption = this.option; // Can not calculate data extent by data here.
    // Because series and data may be modified in processing stage.
    // So we do not support the feature "auto min/max".

    var extent = asc$2([thisOption.min, thisOption.max]);
    this._dataExtent = extent;
  };
  /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimention. If return null/undefined, no dimension used.
   */
  // getDataDimension(data: SeriesData) {
  //     const optDim = this.option.dimension;
  //     if (optDim != null) {
  //         return data.getDimension(optDim);
  //     }
  //     const dimNames = data.dimensions;
  //     for (let i = dimNames.length - 1; i >= 0; i--) {
  //         const dimName = dimNames[i];
  //         const dimInfo = data.getDimensionInfo(dimName);
  //         if (!dimInfo.isCalculationCoord) {
  //             return dimName;
  //         }
  //     }
  // }


  VisualMapModel.prototype.getDataDimensionIndex = function (data) {
    var optDim = this.option.dimension;

    if (optDim != null) {
      return data.getDimensionIndex(optDim);
    }

    var dimNames = data.dimensions;

    for (var i = dimNames.length - 1; i >= 0; i--) {
      var dimName = dimNames[i];
      var dimInfo = data.getDimensionInfo(dimName);

      if (!dimInfo.isCalculationCoord) {
        return dimInfo.storeDimIndex;
      }
    }
  };

  VisualMapModel.prototype.getExtent = function () {
    return this._dataExtent.slice();
  };

  VisualMapModel.prototype.completeVisualOption = function () {
    var ecModel = this.ecModel;
    var thisOption = this.option;
    var base = {
      inRange: thisOption.inRange,
      outOfRange: thisOption.outOfRange
    };
    var target = thisOption.target || (thisOption.target = {});
    var controller = thisOption.controller || (thisOption.controller = {});
    merge$1(target, base); // Do not override

    merge$1(controller, base); // Do not override

    var isCategory = this.isCategory();
    completeSingle.call(this, target);
    completeSingle.call(this, controller);
    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');

    completeController.call(this, controller);

    function completeSingle(base) {
      // Compatible with ec2 dataRange.color.
      // The mapping order of dataRange.color is: [high value, ..., low value]
      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
      // Notice: ec2 has no inverse.
      if (isArray$2(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
      // So adding color only when no inRange defined.
      && !base.inRange) {
        base.inRange = {
          color: thisOption.color.slice().reverse()
        };
      } // Compatible with previous logic, always give a defautl color, otherwise
      // simple config with no inRange and outOfRange will not work.
      // Originally we use visualMap.color as the default color, but setOption at
      // the second time the default color will be erased. So we change to use
      // constant DEFAULT_COLOR.
      // If user do not want the default color, set inRange: {color: null}.


      base.inRange = base.inRange || {
        color: ecModel.get('gradientColor')
      };
    }

    function completeInactive(base, stateExist, stateAbsent) {
      var optExist = base[stateExist];
      var optAbsent = base[stateAbsent];

      if (optExist && !optAbsent) {
        optAbsent = base[stateAbsent] = {};
        each$d(optExist, function (visualData, visualType) {
          if (!VisualMapping.isValidType(visualType)) {
            return;
          }

          var defa = visualDefault.get(visualType, 'inactive', isCategory);

          if (defa != null) {
            optAbsent[visualType] = defa; // Compatibable with ec2:
            // Only inactive color to rgba(0,0,0,0) can not
            // make label transparent, so use opacity also.

            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
              optAbsent.opacity = [0, 0];
            }
          }
        });
      }
    }

    function completeController(controller) {
      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
      var inactiveColor = this.get('inactiveColor');
      var itemSymbol = this.getItemSymbol();
      var defaultSymbol = itemSymbol || 'roundRect';
      each$d(this.stateList, function (state) {
        var itemSize = this.itemSize;
        var visuals = controller[state]; // Set inactive color for controller if no other color
        // attr (like colorAlpha) specified.

        if (!visuals) {
          visuals = controller[state] = {
            color: isCategory ? inactiveColor : [inactiveColor]
          };
        } // Consistent symbol and symbolSize if not specified.


        if (visuals.symbol == null) {
          visuals.symbol = symbolExists && clone(symbolExists) || (isCategory ? defaultSymbol : [defaultSymbol]);
        }

        if (visuals.symbolSize == null) {
          visuals.symbolSize = symbolSizeExists && clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
        } // Filter none


        visuals.symbol = mapVisual$1(visuals.symbol, function (symbol) {
          return symbol === 'none' ? defaultSymbol : symbol;
        }); // Normalize symbolSize

        var symbolSize = visuals.symbolSize;

        if (symbolSize != null) {
          var max_1 = -Infinity; // symbolSize can be object when categories defined.

          eachVisual(symbolSize, function (value) {
            value > max_1 && (max_1 = value);
          });
          visuals.symbolSize = mapVisual$1(symbolSize, function (value) {
            return linearMap$1(value, [0, max_1], [0, itemSize[0]], true);
          });
        }
      }, this);
    }
  };

  VisualMapModel.prototype.resetItemSize = function () {
    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
  };

  VisualMapModel.prototype.isCategory = function () {
    return !!this.option.categories;
  };
  /**
   * @public
   * @abstract
   */


  VisualMapModel.prototype.setSelected = function (selected) {};

  VisualMapModel.prototype.getSelected = function () {
    return null;
  };
  /**
   * @public
   * @abstract
   */


  VisualMapModel.prototype.getValueState = function (value) {
    return null;
  };
  /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */


  VisualMapModel.prototype.getVisualMeta = function (getColorVisual) {
    return null;
  };

  VisualMapModel.type = 'visualMap';
  VisualMapModel.dependencies = ['series'];
  VisualMapModel.defaultOption = {
    show: true,
    // zlevel: 0,
    z: 4,
    seriesIndex: 'all',
    min: 0,
    max: 200,
    left: 0,
    right: null,
    top: null,
    bottom: 0,
    itemWidth: null,
    itemHeight: null,
    inverse: false,
    orient: 'vertical',
    backgroundColor: 'rgba(0,0,0,0)',
    borderColor: '#ccc',
    contentColor: '#5793f3',
    inactiveColor: '#aaa',
    borderWidth: 0,
    padding: 5,
    // 接受数组分别设定上右下左边距，同css
    textGap: 10,
    precision: 0,
    textStyle: {
      color: '#333' // 值域文字颜色

    }
  };
  return VisualMapModel;
}(ComponentModel);

var DEFAULT_BAR_BOUND = [20, 140];

var ContinuousModel =
/** @class */
function (_super) {
  __extends$1(ContinuousModel, _super);

  function ContinuousModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ContinuousModel.type;
    return _this;
  }
  /**
   * @override
   */


  ContinuousModel.prototype.optionUpdated = function (newOption, isInit) {
    _super.prototype.optionUpdated.apply(this, arguments);

    this.resetExtent();
    this.resetVisual(function (mappingOption) {
      mappingOption.mappingMethod = 'linear';
      mappingOption.dataExtent = this.getExtent();
    });

    this._resetRange();
  };
  /**
   * @protected
   * @override
   */


  ContinuousModel.prototype.resetItemSize = function () {
    _super.prototype.resetItemSize.apply(this, arguments);

    var itemSize = this.itemSize;
    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
  };
  /**
   * @private
   */


  ContinuousModel.prototype._resetRange = function () {
    var dataExtent = this.getExtent();
    var range = this.option.range;

    if (!range || range.auto) {
      // `range` should always be array (so we dont use other
      // value like 'auto') for user-friend. (consider getOption).
      dataExtent.auto = 1;
      this.option.range = dataExtent;
    } else if (isArray$1(range)) {
      if (range[0] > range[1]) {
        range.reverse();
      }

      range[0] = Math.max(range[0], dataExtent[0]);
      range[1] = Math.min(range[1], dataExtent[1]);
    }
  };
  /**
   * @protected
   * @override
   */


  ContinuousModel.prototype.completeVisualOption = function () {
    _super.prototype.completeVisualOption.apply(this, arguments);

    each(this.stateList, function (state) {
      var symbolSize = this.option.controller[state].symbolSize;

      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
        symbolSize[0] = symbolSize[1] / 3; // For good looking.
      }
    }, this);
  };
  /**
   * @override
   */


  ContinuousModel.prototype.setSelected = function (selected) {
    this.option.range = selected.slice();

    this._resetRange();
  };
  /**
   * @public
   */


  ContinuousModel.prototype.getSelected = function () {
    var dataExtent = this.getExtent();
    var dataInterval = asc((this.get('range') || []).slice()); // Clamp

    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
    return dataInterval;
  };
  /**
   * @override
   */


  ContinuousModel.prototype.getValueState = function (value) {
    var range = this.option.range;
    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
    // range[1] is processed likewise.

    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
  };

  ContinuousModel.prototype.findTargetDataIndices = function (range) {
    var result = [];
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  };
  /**
   * @implement
   */


  ContinuousModel.prototype.getVisualMeta = function (getColorVisual) {
    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
    var stops = [];

    function setStop(value, valueState) {
      stops.push({
        value: value,
        color: getColorVisual(value, valueState)
      });
    } // Format to: outOfRange -- inRange -- outOfRange.


    var iIdx = 0;
    var oIdx = 0;
    var iLen = iVals.length;
    var oLen = oVals.length;

    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
      if (oVals[oIdx] < iVals[iIdx]) {
        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
      // If range is full, value beyond min, max will be clamped.
      // make a singularity
      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
      setStop(iVals[iIdx], 'inRange');
    }

    for (var first = 1; oIdx < oLen; oIdx++) {
      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
        // make a singularity
        if (first) {
          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
          first = 0;
        }

        setStop(oVals[oIdx], 'outOfRange');
      }
    }

    var stopsLen = stops.length;
    return {
      stops: stops,
      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
    };
  };

  ContinuousModel.type = 'visualMap.continuous';
  ContinuousModel.defaultOption = inheritDefaultOption(VisualMapModel.defaultOption, {
    align: 'auto',
    calculable: false,
    hoverLink: true,
    realtime: true,
    handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
    handleSize: '120%',
    handleStyle: {
      borderColor: '#fff',
      borderWidth: 1
    },
    indicatorIcon: 'circle',
    indicatorSize: '50%',
    indicatorStyle: {
      borderColor: '#fff',
      borderWidth: 2,
      shadowBlur: 2,
      shadowOffsetX: 1,
      shadowOffsetY: 1,
      shadowColor: 'rgba(0,0,0,0.2)'
    } // emphasis: {
    //     handleStyle: {
    //         shadowBlur: 3,
    //         shadowOffsetX: 1,
    //         shadowOffsetY: 1,
    //         shadowColor: 'rgba(0,0,0,0.2)'
    //     }
    // }

  });
  return ContinuousModel;
}(VisualMapModel);

function getColorStopValues(visualMapModel, valueState, dataExtent) {
  if (dataExtent[0] === dataExtent[1]) {
    return dataExtent.slice();
  } // When using colorHue mapping, it is not linear color any more.
  // Moreover, canvas gradient seems not to be accurate linear.
  // FIXME
  // Should be arbitrary value 100? or based on pixel size?


  var count = 200;
  var step = (dataExtent[1] - dataExtent[0]) / count;
  var value = dataExtent[0];
  var stopValues = [];

  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
    stopValues.push(value);
    value += step;
  }

  stopValues.push(dataExtent[1]);
  return stopValues;
}

var VisualMapView =
/** @class */
function (_super) {
  __extends$1(VisualMapView, _super);

  function VisualMapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = VisualMapView.type;
    _this.autoPositionValues = {
      left: 1,
      right: 1,
      top: 1,
      bottom: 1
    };
    return _this;
  }

  VisualMapView.prototype.init = function (ecModel, api) {
    this.ecModel = ecModel;
    this.api = api;
  };
  /**
   * @protected
   */


  VisualMapView.prototype.render = function (visualMapModel, ecModel, api, payload // TODO: TYPE
  ) {
    this.visualMapModel = visualMapModel;

    if (visualMapModel.get('show') === false) {
      this.group.removeAll();
      return;
    }

    this.doRender(visualMapModel, ecModel, api, payload);
  };
  /**
   * @protected
   */


  VisualMapView.prototype.renderBackground = function (group) {
    var visualMapModel = this.visualMapModel;
    var padding = normalizeCssArray$1(visualMapModel.get('padding') || 0);
    var rect = group.getBoundingRect();
    group.add(new Rect({
      z2: -1,
      silent: true,
      shape: {
        x: rect.x - padding[3],
        y: rect.y - padding[0],
        width: rect.width + padding[3] + padding[1],
        height: rect.height + padding[0] + padding[2]
      },
      style: {
        fill: visualMapModel.get('backgroundColor'),
        stroke: visualMapModel.get('borderColor'),
        lineWidth: visualMapModel.get('borderWidth')
      }
    }));
  };
  /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */


  VisualMapView.prototype.getControllerVisual = function (targetValue, visualCluster, opts) {
    opts = opts || {};
    var forceState = opts.forceState;
    var visualMapModel = this.visualMapModel;
    var visualObj = {}; // Default values.

    if (visualCluster === 'color') {
      var defaultColor = visualMapModel.get('contentColor');
      visualObj.color = defaultColor;
    }

    function getter(key) {
      return visualObj[key];
    }

    function setter(key, value) {
      visualObj[key] = value;
    }

    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
    each(visualTypes, function (type) {
      var visualMapping = mappings[type];

      if (opts.convertOpacityToAlpha && type === 'opacity') {
        type = 'colorAlpha';
        visualMapping = mappings.__alphaForOpacity;
      }

      if (VisualMapping.dependsOn(type, visualCluster)) {
        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
      }
    });
    return visualObj[visualCluster];
  };

  VisualMapView.prototype.positionGroup = function (group) {
    var model = this.visualMapModel;
    var api = this.api;
    positionElement(group, model.getBoxLayoutParams(), {
      width: api.getWidth(),
      height: api.getHeight()
    });
  };

  VisualMapView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {};

  VisualMapView.type = 'visualMap';
  return VisualMapView;
}(ComponentView);

var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
/**
 * @param visualMapModel
 * @param api
 * @param itemSize always [short, long]
 * @return {string} 'left' or 'right' or 'top' or 'bottom'
 */

function getItemAlign(visualMapModel, api, itemSize) {
  var modelOption = visualMapModel.option;
  var itemAlign = modelOption.align;

  if (itemAlign != null && itemAlign !== 'auto') {
    return itemAlign;
  } // Auto decision align.


  var ecSize = {
    width: api.getWidth(),
    height: api.getHeight()
  };
  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
  var reals = paramsSet[realIndex];
  var fakeValue = [0, null, 10];
  var layoutInput = {};

  for (var i = 0; i < 3; i++) {
    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
  }

  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
  var rect = getLayoutRect$1(layoutInput, ecSize, modelOption.padding);
  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
/**
 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
 * dataIndexInside means filtered index.
 */
// TODO: TYPE more specified payload types.

function makeHighDownBatch(batch, visualMapModel) {
  each(batch || [], function (batchItem) {
    if (batchItem.dataIndex != null) {
      batchItem.dataIndexInside = batchItem.dataIndex;
      batchItem.dataIndex = null;
    }

    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
  });
  return batch;
}

var linearMap$2 = linearMap;
var each$e = each;
var mathMin$a = Math.min;
var mathMax$a = Math.max; // Arbitrary value

var HOVER_LINK_SIZE = 12;
var HOVER_LINK_OUT = 6; // Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.

var ContinuousView =
/** @class */
function (_super) {
  __extends$1(ContinuousView, _super);

  function ContinuousView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = ContinuousView.type;
    _this._shapes = {};
    _this._dataInterval = [];
    _this._handleEnds = [];
    _this._hoverLinkDataIndices = [];
    return _this;
  }

  ContinuousView.prototype.doRender = function (visualMapModel, ecModel, api, payload) {
    this._api = api;

    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
      this._buildView();
    }
  };

  ContinuousView.prototype._buildView = function () {
    this.group.removeAll();
    var visualMapModel = this.visualMapModel;
    var thisGroup = this.group;
    this._orient = visualMapModel.get('orient');
    this._useHandle = visualMapModel.get('calculable');

    this._resetInterval();

    this._renderBar(thisGroup);

    var dataRangeText = visualMapModel.get('text');

    this._renderEndsText(thisGroup, dataRangeText, 0);

    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.


    this._updateView(true); // After updating view, inner shapes is built completely,
    // and then background can be rendered.


    this.renderBackground(thisGroup); // Real update view

    this._updateView();

    this._enableHoverLinkToSeries();

    this._enableHoverLinkFromSeries();

    this.positionGroup(thisGroup);
  };

  ContinuousView.prototype._renderEndsText = function (group, dataRangeText, endsIndex) {
    if (!dataRangeText) {
      return;
    } // Compatible with ec2, text[0] map to high value, text[1] map low value.


    var text = dataRangeText[1 - endsIndex];
    text = text != null ? text + '' : '';
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var itemSize = visualMapModel.itemSize;
    var barGroup = this._shapes.mainGroup;

    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);

    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);

    var orient = this._orient;
    var textStyleModel = this.visualMapModel.textStyleModel;
    this.group.add(new ZRText({
      style: createTextStyle(textStyleModel, {
        x: position[0],
        y: position[1],
        verticalAlign: orient === 'horizontal' ? 'middle' : align,
        align: orient === 'horizontal' ? align : 'center',
        text: text
      })
    }));
  };

  ContinuousView.prototype._renderBar = function (targetGroup) {
    var visualMapModel = this.visualMapModel;
    var shapes = this._shapes;
    var itemSize = visualMapModel.itemSize;
    var orient = this._orient;
    var useHandle = this._useHandle;
    var itemAlign = getItemAlign(visualMapModel, this.api, itemSize);

    var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);

    var gradientBarGroup = new Group$1();
    mainGroup.add(gradientBarGroup); // Bar

    gradientBarGroup.add(shapes.outOfRange = createPolygon());
    gradientBarGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor$1(this._orient) : null, bind(this._dragHandle, this, 'all', false), bind(this._dragHandle, this, 'all', true))); // A border radius clip.

    gradientBarGroup.setClipPath(new Rect({
      shape: {
        x: 0,
        y: 0,
        width: itemSize[0],
        height: itemSize[1],
        r: 3
      }
    }));
    var textRect = visualMapModel.textStyleModel.getTextRect('国');
    var textSize = mathMax$a(textRect.width, textRect.height); // Handle

    if (useHandle) {
      shapes.handleThumbs = [];
      shapes.handleLabels = [];
      shapes.handleLabelPoints = [];

      this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);

      this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
    }

    this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);

    targetGroup.add(mainGroup);
  };

  ContinuousView.prototype._createHandle = function (visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
    var onDrift = bind(this._dragHandle, this, handleIndex, false);
    var onDragEnd = bind(this._dragHandle, this, handleIndex, true);
    var handleSize = parsePercent(visualMapModel.get('handleSize'), itemSize[0]);
    var handleThumb = createSymbol(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
    var cursor = getCursor$1(this._orient);
    handleThumb.attr({
      cursor: cursor,
      draggable: true,
      drift: onDrift,
      ondragend: onDragEnd,
      onmousemove: function (e) {
        stop(e.event);
      }
    });
    handleThumb.x = itemSize[0] / 2;
    handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
    handleThumb.setStyle({
      strokeNoScale: true,
      strokeFirst: true
    });
    handleThumb.style.lineWidth *= 2;
    handleThumb.ensureState('emphasis').style = visualMapModel.getModel(['emphasis', 'handleStyle']).getItemStyle();
    setAsHighDownDispatcher(handleThumb, true);
    mainGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
    // transform (orient/inverse). So label is built separately but not
    // use zrender/graphic/helper/RectText, and is located based on view
    // group (according to handleLabelPoint) but not barGroup.

    var textStyleModel = this.visualMapModel.textStyleModel;
    var handleLabel = new ZRText({
      cursor: cursor,
      draggable: true,
      drift: onDrift,
      onmousemove: function (e) {
        // Fot mobile devicem, prevent screen slider on the button.
        stop(e.event);
      },
      ondragend: onDragEnd,
      style: createTextStyle(textStyleModel, {
        x: 0,
        y: 0,
        text: ''
      })
    });
    handleLabel.ensureState('blur').style = {
      opacity: 0.1
    };
    handleLabel.stateTransition = {
      duration: 200
    };
    this.group.add(handleLabel);
    var handleLabelPoint = [handleSize, 0];
    var shapes = this._shapes;
    shapes.handleThumbs[handleIndex] = handleThumb;
    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
    shapes.handleLabels[handleIndex] = handleLabel;
  };

  ContinuousView.prototype._createIndicator = function (visualMapModel, mainGroup, itemSize, textSize, orient) {
    var scale = parsePercent(visualMapModel.get('indicatorSize'), itemSize[0]);
    var indicator = createSymbol(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
    indicator.attr({
      cursor: 'move',
      invisible: true,
      silent: true,
      x: itemSize[0] / 2
    });
    var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();

    if (indicator instanceof ZRImage) {
      var pathStyle = indicator.style;
      indicator.useStyle(extend({
        // TODO other properties like x, y ?
        image: pathStyle.image,
        x: pathStyle.x,
        y: pathStyle.y,
        width: pathStyle.width,
        height: pathStyle.height
      }, indicatorStyle));
    } else {
      indicator.useStyle(indicatorStyle);
    }

    mainGroup.add(indicator);
    var textStyleModel = this.visualMapModel.textStyleModel;
    var indicatorLabel = new ZRText({
      silent: true,
      invisible: true,
      style: createTextStyle(textStyleModel, {
        x: 0,
        y: 0,
        text: ''
      })
    });
    this.group.add(indicatorLabel);
    var indicatorLabelPoint = [(orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT) + itemSize[0] / 2, 0];
    var shapes = this._shapes;
    shapes.indicator = indicator;
    shapes.indicatorLabel = indicatorLabel;
    shapes.indicatorLabelPoint = indicatorLabelPoint;
    this._firstShowIndicator = true;
  };

  ContinuousView.prototype._dragHandle = function (handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
  dx, dy) {
    if (!this._useHandle) {
      return;
    }

    this._dragging = !isEnd;

    if (!isEnd) {
      // Transform dx, dy to bar coordination.
      var vertex = this._applyTransform([dx, dy], this._shapes.mainGroup, true);

      this._updateInterval(handleIndex, vertex[1]);

      this._hideIndicator(); // Considering realtime, update view should be executed
      // before dispatch action.


      this._updateView();
    } // dragEnd do not dispatch action when realtime.


    if (isEnd === !this.visualMapModel.get('realtime')) {
      // jshint ignore:line
      this.api.dispatchAction({
        type: 'selectDataRange',
        from: this.uid,
        visualMapId: this.visualMapModel.id,
        selected: this._dataInterval.slice()
      });
    }

    if (isEnd) {
      !this._hovering && this._clearHoverLinkToSeries();
    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    }
  };

  ContinuousView.prototype._resetInterval = function () {
    var visualMapModel = this.visualMapModel;
    var dataInterval = this._dataInterval = visualMapModel.getSelected();
    var dataExtent = visualMapModel.getExtent();
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    this._handleEnds = [linearMap$2(dataInterval[0], dataExtent, sizeExtent, true), linearMap$2(dataInterval[1], dataExtent, sizeExtent, true)];
  };
  /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */


  ContinuousView.prototype._updateInterval = function (handleIndex, delta) {
    delta = delta || 0;
    var visualMapModel = this.visualMapModel;
    var handleEnds = this._handleEnds;
    var sizeExtent = [0, visualMapModel.itemSize[1]];
    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
    0);
    var dataExtent = visualMapModel.getExtent(); // Update data interval.

    this._dataInterval = [linearMap$2(handleEnds[0], sizeExtent, dataExtent, true), linearMap$2(handleEnds[1], sizeExtent, dataExtent, true)];
  };

  ContinuousView.prototype._updateView = function (forSketch) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var shapes = this._shapes;
    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;

    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');

    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');

    shapes.inRange.setStyle({
      fill: visualInRange.barColor // opacity: visualInRange.opacity

    }).setShape('points', visualInRange.barPoints);
    shapes.outOfRange.setStyle({
      fill: visualOutOfRange.barColor // opacity: visualOutOfRange.opacity

    }).setShape('points', visualOutOfRange.barPoints);

    this._updateHandle(inRangeHandleEnds, visualInRange);
  };

  ContinuousView.prototype._createBarVisual = function (dataInterval, dataExtent, handleEnds, forceState) {
    var opts = {
      forceState: forceState,
      convertOpacityToAlpha: true
    };

    var colorStops = this._makeColorGradient(dataInterval, opts);

    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];

    var barPoints = this._createBarPoints(handleEnds, symbolSizes);

    return {
      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
      barPoints: barPoints,
      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
    };
  };

  ContinuousView.prototype._makeColorGradient = function (dataInterval, opts) {
    // Considering colorHue, which is not linear, so we have to sample
    // to calculate gradient color stops, but not only caculate head
    // and tail.
    var sampleNumber = 100; // Arbitrary value.

    var colorStops = [];
    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
    colorStops.push({
      color: this.getControllerVisual(dataInterval[0], 'color', opts),
      offset: 0
    });

    for (var i = 1; i < sampleNumber; i++) {
      var currValue = dataInterval[0] + step * i;

      if (currValue > dataInterval[1]) {
        break;
      }

      colorStops.push({
        color: this.getControllerVisual(currValue, 'color', opts),
        offset: i / sampleNumber
      });
    }

    colorStops.push({
      color: this.getControllerVisual(dataInterval[1], 'color', opts),
      offset: 1
    });
    return colorStops;
  };

  ContinuousView.prototype._createBarPoints = function (handleEnds, symbolSizes) {
    var itemSize = this.visualMapModel.itemSize;
    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
  };

  ContinuousView.prototype._createBarGroup = function (itemAlign) {
    var orient = this._orient;
    var inverse = this.visualMapModel.get('inverse');
    return new Group$1(orient === 'horizontal' && !inverse ? {
      scaleX: itemAlign === 'bottom' ? 1 : -1,
      rotation: Math.PI / 2
    } : orient === 'horizontal' && inverse ? {
      scaleX: itemAlign === 'bottom' ? -1 : 1,
      rotation: -Math.PI / 2
    } : orient === 'vertical' && !inverse ? {
      scaleX: itemAlign === 'left' ? 1 : -1,
      scaleY: -1
    } : {
      scaleX: itemAlign === 'left' ? 1 : -1
    });
  };

  ContinuousView.prototype._updateHandle = function (handleEnds, visualInRange) {
    if (!this._useHandle) {
      return;
    }

    var shapes = this._shapes;
    var visualMapModel = this.visualMapModel;
    var handleThumbs = shapes.handleThumbs;
    var handleLabels = shapes.handleLabels;
    var itemSize = visualMapModel.itemSize;
    var dataExtent = visualMapModel.getExtent();
    each$e([0, 1], function (handleIndex) {
      var handleThumb = handleThumbs[handleIndex];
      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
      handleThumb.y = handleEnds[handleIndex];
      var val = linearMap$2(handleEnds[handleIndex], [0, itemSize[1]], dataExtent, true);
      var symbolSize = this.getControllerVisual(val, 'symbolSize');
      handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
      handleThumb.x = itemSize[0] - symbolSize / 2; // Update handle label position.

      var textPoint = applyTransform$1(shapes.handleLabelPoints[handleIndex], getTransform(handleThumb, this.group));
      handleLabels[handleIndex].setStyle({
        x: textPoint[0],
        y: textPoint[1],
        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
        verticalAlign: 'middle',
        align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
      });
    }, this);
  };

  ContinuousView.prototype._showIndicator = function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
    var visualMapModel = this.visualMapModel;
    var dataExtent = visualMapModel.getExtent();
    var itemSize = visualMapModel.itemSize;
    var sizeExtent = [0, itemSize[1]];
    var shapes = this._shapes;
    var indicator = shapes.indicator;

    if (!indicator) {
      return;
    }

    indicator.attr('invisible', false);
    var opts = {
      convertOpacityToAlpha: true
    };
    var color = this.getControllerVisual(cursorValue, 'color', opts);
    var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
    var y = linearMap$2(cursorValue, dataExtent, sizeExtent, true);
    var x = itemSize[0] - symbolSize / 2;
    var oldIndicatorPos = {
      x: indicator.x,
      y: indicator.y
    }; // Update handle label position.

    indicator.y = y;
    indicator.x = x;
    var textPoint = applyTransform$1(shapes.indicatorLabelPoint, getTransform(indicator, this.group));
    var indicatorLabel = shapes.indicatorLabel;
    indicatorLabel.attr('invisible', false);

    var align = this._applyTransform('left', shapes.mainGroup);

    var orient = this._orient;
    var isHorizontal = orient === 'horizontal';
    indicatorLabel.setStyle({
      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
      verticalAlign: isHorizontal ? align : 'middle',
      align: isHorizontal ? 'center' : align
    });
    var indicatorNewProps = {
      x: x,
      y: y,
      style: {
        fill: color
      }
    };
    var labelNewProps = {
      style: {
        x: textPoint[0],
        y: textPoint[1]
      }
    };

    if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
      var animationCfg = {
        duration: 100,
        easing: 'cubicInOut',
        additive: true
      };
      indicator.x = oldIndicatorPos.x;
      indicator.y = oldIndicatorPos.y;
      indicator.animateTo(indicatorNewProps, animationCfg);
      indicatorLabel.animateTo(labelNewProps, animationCfg);
    } else {
      indicator.attr(indicatorNewProps);
      indicatorLabel.attr(labelNewProps);
    }

    this._firstShowIndicator = false;
    var handleLabels = this._shapes.handleLabels;

    if (handleLabels) {
      for (var i = 0; i < handleLabels.length; i++) {
        // Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this._api.enterBlur(handleLabels[i]);
      }
    }
  };

  ContinuousView.prototype._enableHoverLinkToSeries = function () {
    var self = this;

    this._shapes.mainGroup.on('mousemove', function (e) {
      self._hovering = true;

      if (!self._dragging) {
        var itemSize = self.visualMapModel.itemSize;

        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.mainGroup, true, true); // For hover link show when hover handle, which might be
        // below or upper than sizeExtent.


        pos[1] = mathMin$a(mathMax$a(0, pos[1]), itemSize[1]);

        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
      }
    }).on('mouseout', function () {
      // When mouse is out of handle, hoverLink still need
      // to be displayed when realtime is set as false.
      self._hovering = false;
      !self._dragging && self._clearHoverLinkToSeries();
    });
  };

  ContinuousView.prototype._enableHoverLinkFromSeries = function () {
    var zr = this.api.getZr();

    if (this.visualMapModel.option.hoverLink) {
      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
      zr.on('mouseout', this._hideIndicator, this);
    } else {
      this._clearHoverLinkFromSeries();
    }
  };

  ContinuousView.prototype._doHoverLinkToSeries = function (cursorPos, hoverOnBar) {
    var visualMapModel = this.visualMapModel;
    var itemSize = visualMapModel.itemSize;

    if (!visualMapModel.option.hoverLink) {
      return;
    }

    var sizeExtent = [0, itemSize[1]];
    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.

    cursorPos = mathMin$a(mathMax$a(sizeExtent[0], cursorPos), sizeExtent[1]);
    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
    var cursorValue = linearMap$2(cursorPos, sizeExtent, dataExtent, true);
    var valueRange = [linearMap$2(hoverRange[0], sizeExtent, dataExtent, true), linearMap$2(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
    // where china and india has very large population.

    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
    // otherwise labels overlap, especially when dragging.

    if (hoverOnBar) {
      if (valueRange[0] === -Infinity) {
        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
      } else if (valueRange[1] === Infinity) {
        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
      } else {
        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
      }
    } // When realtime is set as false, handles, which are in barGroup,
    // also trigger hoverLink, which help user to realize where they
    // focus on when dragging. (see test/heatmap-large.html)
    // When realtime is set as true, highlight will not show when hover
    // handle, because the label on handle, which displays a exact value
    // but not range, might mislead users.


    var oldBatch = this._hoverLinkDataIndices;
    var newBatch = [];

    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
    }

    var resultBatches = compressBatches(oldBatch, newBatch);

    this._dispatchHighDown('downplay', makeHighDownBatch(resultBatches[0], visualMapModel));

    this._dispatchHighDown('highlight', makeHighDownBatch(resultBatches[1], visualMapModel));
  };

  ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function (e) {
    var ecData;
    findEventDispatcher(e.target, function (target) {
      var currECData = getECData(target);

      if (currECData.dataIndex != null) {
        ecData = currECData;
        return true;
      }
    }, true);

    if (!ecData) {
      return;
    }

    var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
    var visualMapModel = this.visualMapModel;

    if (!visualMapModel.isTargetSeries(dataModel)) {
      return;
    }

    var data = dataModel.getData(ecData.dataType);
    var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);

    if (!isNaN(value)) {
      this._showIndicator(value, value);
    }
  };

  ContinuousView.prototype._hideIndicator = function () {
    var shapes = this._shapes;
    shapes.indicator && shapes.indicator.attr('invisible', true);
    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
    var handleLabels = this._shapes.handleLabels;

    if (handleLabels) {
      for (var i = 0; i < handleLabels.length; i++) {
        // Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this._api.leaveBlur(handleLabels[i]);
      }
    }
  };

  ContinuousView.prototype._clearHoverLinkToSeries = function () {
    this._hideIndicator();

    var indices = this._hoverLinkDataIndices;

    this._dispatchHighDown('downplay', makeHighDownBatch(indices, this.visualMapModel));

    indices.length = 0;
  };

  ContinuousView.prototype._clearHoverLinkFromSeries = function () {
    this._hideIndicator();

    var zr = this.api.getZr();
    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
    zr.off('mouseout', this._hideIndicator);
  };

  ContinuousView.prototype._applyTransform = function (vertex, element, inverse, global) {
    var transform = getTransform(element, global ? null : this.group);
    return isArray$1(vertex) ? applyTransform$1(vertex, transform, inverse) : transformDirection(vertex, transform, inverse);
  }; // TODO: TYPE more specified payload types.


  ContinuousView.prototype._dispatchHighDown = function (type, batch) {
    batch && batch.length && this.api.dispatchAction({
      type: type,
      batch: batch
    });
  };
  /**
   * @override
   */


  ContinuousView.prototype.dispose = function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  };
  /**
   * @override
   */


  ContinuousView.prototype.remove = function () {
    this._clearHoverLinkFromSeries();

    this._clearHoverLinkToSeries();
  };

  ContinuousView.type = 'visualMap.continuous';
  return ContinuousView;
}(VisualMapView);

function createPolygon(points, cursor, onDrift, onDragEnd) {
  return new Polygon({
    shape: {
      points: points
    },
    draggable: !!onDrift,
    cursor: cursor,
    drift: onDrift,
    onmousemove: function (e) {
      // Fot mobile devicem, prevent screen slider on the button.
      stop(e.event);
    },
    ondragend: onDragEnd
  });
}

function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');

  if (hoverLinkDataSize) {
    halfHoverLinkSize = linearMap$2(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
  }

  return halfHoverLinkSize;
}

function useHoverLinkOnHandle(visualMapModel) {
  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}

function getCursor$1(orient) {
  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
var visualMapActionInfo = {
  type: 'selectDataRange',
  event: 'dataRangeSelected',
  // FIXME use updateView appears wrong
  update: 'update'
};
var visualMapActionHander = function (payload, ecModel) {
  ecModel.eachComponent({
    mainType: 'visualMap',
    query: payload
  }, function (model) {
    model.setSelected(payload.selected);
  });
};

var visualMapEncodingHandlers = [{
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var resetDefines = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      var pipelineContext = seriesModel.pipelineContext;

      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
        return;
      }

      resetDefines.push(incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
    });
    return resetDefines;
  }
}, // Only support color.
{
  createOnAllSeries: true,
  reset: function (seriesModel, ecModel) {
    var data = seriesModel.getData();
    var visualMetaList = [];
    ecModel.eachComponent('visualMap', function (visualMapModel) {
      if (visualMapModel.isTargetSeries(seriesModel)) {
        var visualMeta = visualMapModel.getVisualMeta(bind(getColorVisual, null, seriesModel, visualMapModel)) || {
          stops: [],
          outerColors: []
        };
        var dimIdx = visualMapModel.getDataDimensionIndex(data);

        if (dimIdx >= 0) {
          // visualMeta.dimension should be dimension index, but not concrete dimension.
          visualMeta.dimension = dimIdx;
          visualMetaList.push(visualMeta);
        }
      }
    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));

    seriesModel.getData().setVisual('visualMeta', visualMetaList);
  }
}]; // FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity

function getColorVisual(seriesModel, visualMapModel, value, valueState) {
  var mappings = visualMapModel.targetVisuals[valueState];
  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
  var resultVisual = {
    color: getVisualFromData(seriesModel.getData(), 'color') // default color.

  };

  for (var i = 0, len = visualTypes.length; i < len; i++) {
    var type = visualTypes[i];
    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
    mapping && mapping.applyVisual(value, getVisual, setVisual);
  }

  return resultVisual.color;

  function getVisual(key) {
    return resultVisual[key];
  }

  function setVisual(key, value) {
    resultVisual[key] = value;
  }
}

var each$f = each;
function visualMapPreprocessor(option) {
  var visualMap = option && option.visualMap;

  if (!isArray$1(visualMap)) {
    visualMap = visualMap ? [visualMap] : [];
  }

  each$f(visualMap, function (opt) {
    if (!opt) {
      return;
    } // rename splitList to pieces


    if (has$3(opt, 'splitList') && !has$3(opt, 'pieces')) {
      opt.pieces = opt.splitList;
      delete opt.splitList;
    }

    var pieces = opt.pieces;

    if (pieces && isArray$1(pieces)) {
      each$f(pieces, function (piece) {
        if (isObject$2(piece)) {
          if (has$3(piece, 'start') && !has$3(piece, 'min')) {
            piece.min = piece.start;
          }

          if (has$3(piece, 'end') && !has$3(piece, 'max')) {
            piece.max = piece.end;
          }
        }
      });
    }
  });
}

function has$3(obj, name) {
  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}

var installed$1 = false;
function installCommon$1(registers) {
  if (installed$1) {
    return;
  }

  installed$1 = true;
  registers.registerSubTypeDefaulter('visualMap', function (option) {
    // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
    return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
  });
  registers.registerAction(visualMapActionInfo, visualMapActionHander);
  each(visualMapEncodingHandlers, function (handler) {
    registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
  });
  registers.registerPreprocessor(visualMapPreprocessor);
}

function install$N(registers) {
  registers.registerComponentModel(ContinuousModel);
  registers.registerComponentView(ContinuousView);
  installCommon$1(registers);
}

var PiecewiseModel =
/** @class */
function (_super) {
  __extends$1(PiecewiseModel, _super);

  function PiecewiseModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PiecewiseModel.type;
    /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */

    _this._pieceList = [];
    return _this;
  }

  PiecewiseModel.prototype.optionUpdated = function (newOption, isInit) {
    _super.prototype.optionUpdated.apply(this, arguments);

    this.resetExtent();

    var mode = this._mode = this._determineMode();

    this._pieceList = [];

    resetMethods[this._mode].call(this, this._pieceList);

    this._resetSelected(newOption, isInit);

    var categories = this.option.categories;
    this.resetVisual(function (mappingOption, state) {
      if (mode === 'categories') {
        mappingOption.mappingMethod = 'category';
        mappingOption.categories = clone(categories);
      } else {
        mappingOption.dataExtent = this.getExtent();
        mappingOption.mappingMethod = 'piecewise';
        mappingOption.pieceList = map(this._pieceList, function (piece) {
          piece = clone(piece);

          if (state !== 'inRange') {
            // FIXME
            // outOfRange do not support special visual in pieces.
            piece.visual = null;
          }

          return piece;
        });
      }
    });
  };
  /**
   * @protected
   * @override
   */


  PiecewiseModel.prototype.completeVisualOption = function () {
    // Consider this case:
    // visualMap: {
    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
    // }
    // where no inRange/outOfRange set but only pieces. So we should make
    // default inRange/outOfRange for this case, otherwise visuals that only
    // appear in `pieces` will not be taken into account in visual encoding.
    var option = this.option;
    var visualTypesInPieces = {};
    var visualTypes = VisualMapping.listVisualTypes();
    var isCategory = this.isCategory();
    each(option.pieces, function (piece) {
      each(visualTypes, function (visualType) {
        if (piece.hasOwnProperty(visualType)) {
          visualTypesInPieces[visualType] = 1;
        }
      });
    });
    each(visualTypesInPieces, function (v, visualType) {
      var exists = false;
      each(this.stateList, function (state) {
        exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
      }, this);
      !exists && each(this.stateList, function (state) {
        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
      });
    }, this);

    function has(obj, state, visualType) {
      return obj && obj[state] && obj[state].hasOwnProperty(visualType);
    }

    _super.prototype.completeVisualOption.apply(this, arguments);
  };

  PiecewiseModel.prototype._resetSelected = function (newOption, isInit) {
    var thisOption = this.option;
    var pieceList = this._pieceList; // Selected do not merge but all override.

    var selected = (isInit ? thisOption : newOption).selected || {};
    thisOption.selected = selected; // Consider 'not specified' means true.

    each(pieceList, function (piece, index) {
      var key = this.getSelectedMapKey(piece);

      if (!selected.hasOwnProperty(key)) {
        selected[key] = true;
      }
    }, this);

    if (thisOption.selectedMode === 'single') {
      // Ensure there is only one selected.
      var hasSel_1 = false;
      each(pieceList, function (piece, index) {
        var key = this.getSelectedMapKey(piece);

        if (selected[key]) {
          hasSel_1 ? selected[key] = false : hasSel_1 = true;
        }
      }, this);
    } // thisOption.selectedMode === 'multiple', default: all selected.

  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getItemSymbol = function () {
    return this.get('itemSymbol');
  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getSelectedMapKey = function (piece) {
    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
  };
  /**
   * @public
   */


  PiecewiseModel.prototype.getPieceList = function () {
    return this._pieceList;
  };
  /**
   * @return {string}
   */


  PiecewiseModel.prototype._determineMode = function () {
    var option = this.option;
    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
  };
  /**
   * @override
   */


  PiecewiseModel.prototype.setSelected = function (selected) {
    this.option.selected = clone(selected);
  };
  /**
   * @override
   */


  PiecewiseModel.prototype.getValueState = function (value) {
    var index = VisualMapping.findPieceIndex(value, this._pieceList);
    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
  };
  /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */


  PiecewiseModel.prototype.findTargetDataIndices = function (pieceIndex) {
    var result = [];
    var pieceList = this._pieceList;
    this.eachTargetSeries(function (seriesModel) {
      var dataIndices = [];
      var data = seriesModel.getData();
      data.each(this.getDataDimensionIndex(data), function (value, dataIndex) {
        // Should always base on model pieceList, because it is order sensitive.
        var pIdx = VisualMapping.findPieceIndex(value, pieceList);
        pIdx === pieceIndex && dataIndices.push(dataIndex);
      }, this);
      result.push({
        seriesId: seriesModel.id,
        dataIndex: dataIndices
      });
    }, this);
    return result;
  };
  /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */


  PiecewiseModel.prototype.getRepresentValue = function (piece) {
    var representValue;

    if (this.isCategory()) {
      representValue = piece.value;
    } else {
      if (piece.value != null) {
        representValue = piece.value;
      } else {
        var pieceInterval = piece.interval || [];
        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
      }
    }

    return representValue;
  };

  PiecewiseModel.prototype.getVisualMeta = function (getColorVisual) {
    // Do not support category. (category axis is ordinal, numerical)
    if (this.isCategory()) {
      return;
    }

    var stops = [];
    var outerColors = ['', ''];
    var visualMapModel = this;

    function setStop(interval, valueState) {
      var representValue = visualMapModel.getRepresentValue({
        interval: interval
      }); // Not category

      if (!valueState) {
        valueState = visualMapModel.getValueState(representValue);
      }

      var color = getColorVisual(representValue, valueState);

      if (interval[0] === -Infinity) {
        outerColors[0] = color;
      } else if (interval[1] === Infinity) {
        outerColors[1] = color;
      } else {
        stops.push({
          value: interval[0],
          color: color
        }, {
          value: interval[1],
          color: color
        });
      }
    } // Suplement


    var pieceList = this._pieceList.slice();

    if (!pieceList.length) {
      pieceList.push({
        interval: [-Infinity, Infinity]
      });
    } else {
      var edge = pieceList[0].interval[0];
      edge !== -Infinity && pieceList.unshift({
        interval: [-Infinity, edge]
      });
      edge = pieceList[pieceList.length - 1].interval[1];
      edge !== Infinity && pieceList.push({
        interval: [edge, Infinity]
      });
    }

    var curr = -Infinity;
    each(pieceList, function (piece) {
      var interval = piece.interval;

      if (interval) {
        // Fulfill gap.
        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
        setStop(interval.slice());
        curr = interval[1];
      }
    }, this);
    return {
      stops: stops,
      outerColors: outerColors
    };
  };

  PiecewiseModel.type = 'visualMap.piecewise';
  PiecewiseModel.defaultOption = inheritDefaultOption(VisualMapModel.defaultOption, {
    selected: null,
    minOpen: false,
    maxOpen: false,
    align: 'auto',
    itemWidth: 20,
    itemHeight: 14,
    itemSymbol: 'roundRect',
    pieces: null,
    categories: null,
    splitNumber: 5,
    selectedMode: 'multiple',
    itemGap: 10,
    hoverLink: true // Enable hover highlight.

  });
  return PiecewiseModel;
}(VisualMapModel);
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */

var resetMethods = {
  splitNumber: function (outPieceList) {
    var thisOption = this.option;
    var precision = Math.min(thisOption.precision, 20);
    var dataExtent = this.getExtent();
    var splitNumber = thisOption.splitNumber;
    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
    thisOption.splitNumber = splitNumber;
    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption

    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
      precision++;
    }

    thisOption.precision = precision;
    splitStep = +splitStep.toFixed(precision);

    if (thisOption.minOpen) {
      outPieceList.push({
        interval: [-Infinity, dataExtent[0]],
        close: [0, 0]
      });
    }

    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
      outPieceList.push({
        interval: [curr, max],
        close: [1, 1]
      });
    }

    if (thisOption.maxOpen) {
      outPieceList.push({
        interval: [dataExtent[1], Infinity],
        close: [0, 0]
      });
    }

    reformIntervals(outPieceList);
    each(outPieceList, function (piece, index) {
      piece.index = index;
      piece.text = this.formatValueText(piece.interval);
    }, this);
  },
  categories: function (outPieceList) {
    var thisOption = this.option;
    each(thisOption.categories, function (cate) {
      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
      // 是否改一致。
      outPieceList.push({
        text: this.formatValueText(cate, true),
        value: cate
      });
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, outPieceList);
  },
  pieces: function (outPieceList) {
    var thisOption = this.option;
    each(thisOption.pieces, function (pieceListItem, index) {
      if (!isObject$2(pieceListItem)) {
        pieceListItem = {
          value: pieceListItem
        };
      }

      var item = {
        text: '',
        index: index
      };

      if (pieceListItem.label != null) {
        item.text = pieceListItem.label;
      }

      if (pieceListItem.hasOwnProperty('value')) {
        var value = item.value = pieceListItem.value;
        item.interval = [value, value];
        item.close = [1, 1];
      } else {
        // `min` `max` is legacy option.
        // `lt` `gt` `lte` `gte` is recommanded.
        var interval = item.interval = [];
        var close_1 = item.close = [0, 0];
        var closeList = [1, 0, 1];
        var infinityList = [-Infinity, Infinity];
        var useMinMax = [];

        for (var lg = 0; lg < 2; lg++) {
          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];

          for (var i = 0; i < 3 && interval[lg] == null; i++) {
            interval[lg] = pieceListItem[names[i]];
            close_1[lg] = closeList[i];
            useMinMax[lg] = i === 2;
          }

          interval[lg] == null && (interval[lg] = infinityList[lg]);
        }

        useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
        useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);

        if (process.env.NODE_ENV !== 'production') {
          if (interval[0] > interval[1]) {
            console.warn('Piece ' + index + 'is illegal: ' + interval + ' lower bound should not greater then uppper bound.');
          }
        }

        if (interval[0] === interval[1] && close_1[0] && close_1[1]) {
          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
          // we use value to lift the priority when min === max
          item.value = interval[0];
        }
      }

      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
      outPieceList.push(item);
    }, this); // See "Order Rule".

    normalizeReverse(thisOption, outPieceList); // Only pieces

    reformIntervals(outPieceList);
    each(outPieceList, function (piece) {
      var close = piece.close;
      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
    }, this);
  }
};

function normalizeReverse(thisOption, pieceList) {
  var inverse = thisOption.inverse;

  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
    pieceList.reverse();
  }
}

var PiecewiseVisualMapView =
/** @class */
function (_super) {
  __extends$1(PiecewiseVisualMapView, _super);

  function PiecewiseVisualMapView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = PiecewiseVisualMapView.type;
    return _this;
  }

  PiecewiseVisualMapView.prototype.doRender = function () {
    var thisGroup = this.group;
    thisGroup.removeAll();
    var visualMapModel = this.visualMapModel;
    var textGap = visualMapModel.get('textGap');
    var textStyleModel = visualMapModel.textStyleModel;
    var textFont = textStyleModel.getFont();
    var textFill = textStyleModel.getTextColor();

    var itemAlign = this._getItemAlign();

    var itemSize = visualMapModel.itemSize;

    var viewData = this._getViewData();

    var endsText = viewData.endsText;
    var showLabel = retrieve(visualMapModel.get('showLabel', true), !endsText);
    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
    each(viewData.viewPieceList, function (item) {
      var piece = item.piece;
      var itemGroup = new Group$1();
      itemGroup.onclick = bind(this._onItemClick, this, piece);

      this._enableHoverLink(itemGroup, item.indexInModelPieceList); // TODO Category


      var representValue = visualMapModel.getRepresentValue(piece);

      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);

      if (showLabel) {
        var visualState = this.visualMapModel.getValueState(representValue);
        itemGroup.add(new ZRText({
          style: {
            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
            y: itemSize[1] / 2,
            text: piece.text,
            verticalAlign: 'middle',
            align: itemAlign,
            font: textFont,
            fill: textFill,
            opacity: visualState === 'outOfRange' ? 0.5 : 1
          }
        }));
      }

      thisGroup.add(itemGroup);
    }, this);
    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
    box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
    this.renderBackground(thisGroup);
    this.positionGroup(thisGroup);
  };

  PiecewiseVisualMapView.prototype._enableHoverLink = function (itemGroup, pieceIndex) {
    var _this = this;

    itemGroup.on('mouseover', function () {
      return onHoverLink('highlight');
    }).on('mouseout', function () {
      return onHoverLink('downplay');
    });

    var onHoverLink = function (method) {
      var visualMapModel = _this.visualMapModel; // TODO: TYPE More detailed action types

      visualMapModel.option.hoverLink && _this.api.dispatchAction({
        type: method,
        batch: makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
      });
    };
  };

  PiecewiseVisualMapView.prototype._getItemAlign = function () {
    var visualMapModel = this.visualMapModel;
    var modelOption = visualMapModel.option;

    if (modelOption.orient === 'vertical') {
      return getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
    } else {
      // horizontal, most case left unless specifying right.
      var align = modelOption.align;

      if (!align || align === 'auto') {
        align = 'left';
      }

      return align;
    }
  };

  PiecewiseVisualMapView.prototype._renderEndsText = function (group, text, itemSize, showLabel, itemAlign) {
    if (!text) {
      return;
    }

    var itemGroup = new Group$1();
    var textStyleModel = this.visualMapModel.textStyleModel;
    itemGroup.add(new ZRText({
      style: createTextStyle(textStyleModel, {
        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
        y: itemSize[1] / 2,
        verticalAlign: 'middle',
        align: showLabel ? itemAlign : 'center',
        text: text
      })
    }));
    group.add(itemGroup);
  };
  /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */


  PiecewiseVisualMapView.prototype._getViewData = function () {
    var visualMapModel = this.visualMapModel;
    var viewPieceList = map(visualMapModel.getPieceList(), function (piece, index) {
      return {
        piece: piece,
        indexInModelPieceList: index
      };
    });
    var endsText = visualMapModel.get('text'); // Consider orient and inverse.

    var orient = visualMapModel.get('orient');
    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]

    if (orient === 'horizontal' ? inverse : !inverse) {
      viewPieceList.reverse();
    } // Origin order of endsText is [high, low]
    else if (endsText) {
        endsText = endsText.slice().reverse();
      }

    return {
      viewPieceList: viewPieceList,
      endsText: endsText
    };
  };

  PiecewiseVisualMapView.prototype._createItemSymbol = function (group, representValue, shapeParam) {
    group.add(createSymbol( // symbol will be string
    this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
    this.getControllerVisual(representValue, 'color')));
  };

  PiecewiseVisualMapView.prototype._onItemClick = function (piece) {
    var visualMapModel = this.visualMapModel;
    var option = visualMapModel.option;
    var selectedMode = option.selectedMode;

    if (!selectedMode) {
      return;
    }

    var selected = clone(option.selected);
    var newKey = visualMapModel.getSelectedMapKey(piece);

    if (selectedMode === 'single' || selectedMode === true) {
      selected[newKey] = true;
      each(selected, function (o, key) {
        selected[key] = key === newKey;
      });
    } else {
      selected[newKey] = !selected[newKey];
    }

    this.api.dispatchAction({
      type: 'selectDataRange',
      from: this.uid,
      visualMapId: this.visualMapModel.id,
      selected: selected
    });
  };

  PiecewiseVisualMapView.type = 'visualMap.piecewise';
  return PiecewiseVisualMapView;
}(VisualMapView);

function install$O(registers) {
  registers.registerComponentModel(PiecewiseModel);
  registers.registerComponentView(PiecewiseVisualMapView);
  installCommon$1(registers);
}

function install$P(registers) {
  use(install$N);
  use(install$O); // Do not install './dataZoomSelect',
  // since it only work for toolbox dataZoom.
}

var DEFAULT_OPTION = {
  label: {
    enabled: true
  },
  decal: {
    show: false
  }
};
var inner$m = makeInner();
var decalPaletteScope = {};
function ariaVisual(ecModel, api) {
  var ariaModel = ecModel.getModel('aria'); // See "area enabled" detection code in `GlobalModel.ts`.

  if (!ariaModel.get('enabled')) {
    return;
  }

  var defaultOption = clone(DEFAULT_OPTION);
  merge$1(defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
  merge$1(ariaModel.option, defaultOption, false);
  setDecal();
  setLabel();

  function setDecal() {
    var decalModel = ariaModel.getModel('decal');
    var useDecal = decalModel.get('show');

    if (useDecal) {
      // Each type of series use one scope.
      // Pie and funnel are using different scopes.
      var paletteScopeGroupByType_1 = createHashMap();
      ecModel.eachSeries(function (seriesModel) {
        if (seriesModel.isColorBySeries()) {
          return;
        }

        var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);

        if (!decalScope) {
          decalScope = {};
          paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
        }

        inner$m(seriesModel).scope = decalScope;
      });
      ecModel.eachRawSeries(function (seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) {
          return;
        }

        if (isFunction$3(seriesModel.enableAriaDecal)) {
          // Let series define how to use decal palette on data
          seriesModel.enableAriaDecal();
          return;
        }

        var data = seriesModel.getData();

        if (!seriesModel.isColorBySeries()) {
          var dataAll_1 = seriesModel.getRawData();
          var idxMap_1 = {};
          var decalScope_1 = inner$m(seriesModel).scope;
          data.each(function (idx) {
            var rawIdx = data.getRawIndex(idx);
            idxMap_1[rawIdx] = idx;
          });
          var dataCount_1 = dataAll_1.count();
          dataAll_1.each(function (rawIdx) {
            var idx = idxMap_1[rawIdx];
            var name = dataAll_1.getName(rawIdx) || rawIdx + '';
            var paletteDecal = getDecalFromPalette(seriesModel.ecModel, name, decalScope_1, dataCount_1);
            var specifiedDecal = data.getItemVisual(idx, 'decal');
            data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
          });
        } else {
          var paletteDecal = getDecalFromPalette(seriesModel.ecModel, seriesModel.name, decalPaletteScope, ecModel.getSeriesCount());
          var specifiedDecal = data.getVisual('decal');
          data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
        }

        function mergeDecal(specifiedDecal, paletteDecal) {
          // Merge decal from palette to decal from itemStyle.
          // User do not need to specify all of the decal props.
          var resultDecal = specifiedDecal ? extend(extend({}, paletteDecal), specifiedDecal) : paletteDecal;
          resultDecal.dirty = true;
          return resultDecal;
        }
      });
    }
  }

  function setLabel() {
    var labelLocale = ecModel.getLocaleModel().get('aria');
    var labelModel = ariaModel.getModel('label');
    labelModel.option = defaults(labelModel.option, labelLocale);

    if (!labelModel.get('enabled')) {
      return;
    }

    var dom = api.getZr().dom;

    if (labelModel.get('description')) {
      dom.setAttribute('aria-label', labelModel.get('description'));
      return;
    }

    var seriesCnt = ecModel.getSeriesCount();
    var maxDataCnt = labelModel.get(['data', 'maxCount']) || 10;
    var maxSeriesCnt = labelModel.get(['series', 'maxCount']) || 10;
    var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
    var ariaLabel;

    if (seriesCnt < 1) {
      // No series, no aria label
      return;
    } else {
      var title = getTitle();

      if (title) {
        var withTitle = labelModel.get(['general', 'withTitle']);
        ariaLabel = replace(withTitle, {
          title: title
        });
      } else {
        ariaLabel = labelModel.get(['general', 'withoutTitle']);
      }

      var seriesLabels_1 = [];
      var prefix = seriesCnt > 1 ? labelModel.get(['series', 'multiple', 'prefix']) : labelModel.get(['series', 'single', 'prefix']);
      ariaLabel += replace(prefix, {
        seriesCount: seriesCnt
      });
      ecModel.eachSeries(function (seriesModel, idx) {
        if (idx < displaySeriesCnt) {
          var seriesLabel = void 0;
          var seriesName = seriesModel.get('name');
          var withName = seriesName ? 'withName' : 'withoutName';
          seriesLabel = seriesCnt > 1 ? labelModel.get(['series', 'multiple', withName]) : labelModel.get(['series', 'single', withName]);
          seriesLabel = replace(seriesLabel, {
            seriesId: seriesModel.seriesIndex,
            seriesName: seriesModel.get('name'),
            seriesType: getSeriesTypeName(seriesModel.subType)
          });
          var data = seriesModel.getData();

          if (data.count() > maxDataCnt) {
            // Show part of data
            var partialLabel = labelModel.get(['data', 'partialData']);
            seriesLabel += replace(partialLabel, {
              displayCnt: maxDataCnt
            });
          } else {
            seriesLabel += labelModel.get(['data', 'allData']);
          }

          var middleSeparator_1 = labelModel.get(['data', 'separator', 'middle']);
          var endSeparator_1 = labelModel.get(['data', 'separator', 'end']);
          var dataLabels = [];

          for (var i = 0; i < data.count(); i++) {
            if (i < maxDataCnt) {
              var name_1 = data.getName(i);
              var value = data.getValues(i);
              var dataLabel = labelModel.get(['data', name_1 ? 'withName' : 'withoutName']);
              dataLabels.push(replace(dataLabel, {
                name: name_1,
                value: value.join(middleSeparator_1)
              }));
            }
          }

          seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
          seriesLabels_1.push(seriesLabel);
        }
      });
      var separatorModel = labelModel.getModel(['series', 'multiple', 'separator']);
      var middleSeparator = separatorModel.get('middle');
      var endSeparator = separatorModel.get('end');
      ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
      dom.setAttribute('aria-label', ariaLabel);
    }
  }

  function replace(str, keyValues) {
    if (!isString(str)) {
      return str;
    }

    var result = str;
    each(keyValues, function (value, key) {
      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
    });
    return result;
  }

  function getTitle() {
    var title = ecModel.get('title');

    if (title && title.length) {
      title = title[0];
    }

    return title && title.text;
  }

  function getSeriesTypeName(type) {
    return ecModel.getLocaleModel().get(['series', 'typeNames'])[type] || '自定义图';
  }
}

function ariaPreprocessor(option) {
  if (!option || !option.aria) {
    return;
  }

  var aria = option.aria; // aria.show is deprecated and should use aria.enabled instead

  if (aria.show != null) {
    aria.enabled = aria.show;
  }

  aria.label = aria.label || {}; // move description, general, series, data to be under aria.label

  each(['description', 'general', 'series', 'data'], function (name) {
    if (aria[name] != null) {
      aria.label[name] = aria[name];
    }
  });
}

function install$Q(registers) {
  registers.registerPreprocessor(ariaPreprocessor);
  registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, ariaVisual);
}

var RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
  value: 'eq',
  // PENDING: not good for literal semantic?
  '<': 'lt',
  '<=': 'lte',
  '>': 'gt',
  '>=': 'gte',
  '=': 'eq',
  '!=': 'ne',
  '<>': 'ne' // Might be misleading for sake of the difference between '==' and '===',
  // so don't support them.
  // '==': 'eq',
  // '===': 'seq',
  // '!==': 'sne'
  // PENDING: Whether support some common alias "ge", "le", "neq"?
  // ge: 'gte',
  // le: 'lte',
  // neq: 'ne',

}; // type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;

var RegExpEvaluator =
/** @class */
function () {
  function RegExpEvaluator(rVal) {
    // Support condVal: RegExp | string
    var condValue = this._condVal = isString(rVal) ? new RegExp(rVal) : isRegExp(rVal) ? rVal : null;

    if (condValue == null) {
      var errMsg = '';

      if (process.env.NODE_ENV !== 'production') {
        errMsg = makePrintable('Illegal regexp', rVal, 'in');
      }

      throwError(errMsg);
    }
  }

  RegExpEvaluator.prototype.evaluate = function (lVal) {
    var type = typeof lVal;
    return isString(type) ? this._condVal.test(lVal) : isNumber$1(type) ? this._condVal.test(lVal + '') : false;
  };

  return RegExpEvaluator;
}();

var ConstConditionInternal =
/** @class */
function () {
  function ConstConditionInternal() {}

  ConstConditionInternal.prototype.evaluate = function () {
    return this.value;
  };

  return ConstConditionInternal;
}();

var AndConditionInternal =
/** @class */
function () {
  function AndConditionInternal() {}

  AndConditionInternal.prototype.evaluate = function () {
    var children = this.children;

    for (var i = 0; i < children.length; i++) {
      if (!children[i].evaluate()) {
        return false;
      }
    }

    return true;
  };

  return AndConditionInternal;
}();

var OrConditionInternal =
/** @class */
function () {
  function OrConditionInternal() {}

  OrConditionInternal.prototype.evaluate = function () {
    var children = this.children;

    for (var i = 0; i < children.length; i++) {
      if (children[i].evaluate()) {
        return true;
      }
    }

    return false;
  };

  return OrConditionInternal;
}();

var NotConditionInternal =
/** @class */
function () {
  function NotConditionInternal() {}

  NotConditionInternal.prototype.evaluate = function () {
    return !this.child.evaluate();
  };

  return NotConditionInternal;
}();

var RelationalConditionInternal =
/** @class */
function () {
  function RelationalConditionInternal() {}

  RelationalConditionInternal.prototype.evaluate = function () {
    var needParse = !!this.valueParser; // Call getValue with no `this`.

    var getValue = this.getValue;
    var tarValRaw = getValue(this.valueGetterParam);
    var tarValParsed = needParse ? this.valueParser(tarValRaw) : null; // Relational cond follow "and" logic internally.

    for (var i = 0; i < this.subCondList.length; i++) {
      if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) {
        return false;
      }
    }

    return true;
  };

  return RelationalConditionInternal;
}();

function parseOption(exprOption, getters) {
  if (exprOption === true || exprOption === false) {
    var cond = new ConstConditionInternal();
    cond.value = exprOption;
    return cond;
  }

  var errMsg = '';

  if (!isObjectNotArray(exprOption)) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = makePrintable('Illegal config. Expect a plain object but actually', exprOption);
    }

    throwError(errMsg);
  }

  if (exprOption.and) {
    return parseAndOrOption('and', exprOption, getters);
  } else if (exprOption.or) {
    return parseAndOrOption('or', exprOption, getters);
  } else if (exprOption.not) {
    return parseNotOption(exprOption, getters);
  }

  return parseRelationalOption(exprOption, getters);
}

function parseAndOrOption(op, exprOption, getters) {
  var subOptionArr = exprOption[op];
  var errMsg = '';

  if (process.env.NODE_ENV !== 'production') {
    errMsg = makePrintable('"and"/"or" condition should only be `' + op + ': [...]` and must not be empty array.', 'Illegal condition:', exprOption);
  }

  if (!isArray$1(subOptionArr)) {
    throwError(errMsg);
  }

  if (!subOptionArr.length) {
    throwError(errMsg);
  }

  var cond = op === 'and' ? new AndConditionInternal() : new OrConditionInternal();
  cond.children = map(subOptionArr, function (subOption) {
    return parseOption(subOption, getters);
  });

  if (!cond.children.length) {
    throwError(errMsg);
  }

  return cond;
}

function parseNotOption(exprOption, getters) {
  var subOption = exprOption.not;
  var errMsg = '';

  if (process.env.NODE_ENV !== 'production') {
    errMsg = makePrintable('"not" condition should only be `not: {}`.', 'Illegal condition:', exprOption);
  }

  if (!isObjectNotArray(subOption)) {
    throwError(errMsg);
  }

  var cond = new NotConditionInternal();
  cond.child = parseOption(subOption, getters);

  if (!cond.child) {
    throwError(errMsg);
  }

  return cond;
}

function parseRelationalOption(exprOption, getters) {
  var errMsg = '';
  var valueGetterParam = getters.prepareGetValue(exprOption);
  var subCondList = [];
  var exprKeys = keys$2(exprOption);
  var parserName = exprOption.parser;
  var valueParser = parserName ? getRawValueParser(parserName) : null;

  for (var i = 0; i < exprKeys.length; i++) {
    var keyRaw = exprKeys[i];

    if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) {
      continue;
    }

    var op = hasOwn(RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
    var condValueRaw = exprOption[keyRaw];
    var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
    var evaluator = createFilterComparator(op, condValueParsed) || op === 'reg' && new RegExpEvaluator(condValueParsed);

    if (!evaluator) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = makePrintable('Illegal relational operation: "' + keyRaw + '" in condition:', exprOption);
      }

      throwError(errMsg);
    }

    subCondList.push(evaluator);
  }

  if (!subCondList.length) {
    if (process.env.NODE_ENV !== 'production') {
      errMsg = makePrintable('Relational condition must have at least one operator.', 'Illegal condition:', exprOption);
    } // No relational operator always disabled in case of dangers result.


    throwError(errMsg);
  }

  var cond = new RelationalConditionInternal();
  cond.valueGetterParam = valueGetterParam;
  cond.valueParser = valueParser;
  cond.getValue = getters.getValue;
  cond.subCondList = subCondList;
  return cond;
}

function isObjectNotArray(val) {
  return isObject$2(val) && !isArrayLike$1(val);
}

var ConditionalExpressionParsed =
/** @class */
function () {
  function ConditionalExpressionParsed(exprOption, getters) {
    this._cond = parseOption(exprOption, getters);
  }

  ConditionalExpressionParsed.prototype.evaluate = function () {
    return this._cond.evaluate();
  };

  return ConditionalExpressionParsed;
}();
function parseConditionalExpression(exprOption, getters) {
  return new ConditionalExpressionParsed(exprOption, getters);
}

var filterTransform = {
  type: 'echarts:filter',
  // PEDING: enhance to filter by index rather than create new data
  transform: function (params) {
    // [Caveat] Fail-Fast:
    // Do not return the whole dataset unless user config indicate it explicitly.
    // For example, if no condition specified by mistake, return an empty result
    // is better than return the entire raw soruce for user to find the mistake.
    var upstream = params.upstream;
    var rawItem;
    var condition = parseConditionalExpression(params.config, {
      valueGetterAttrMap: createHashMap({
        dimension: true
      }),
      prepareGetValue: function (exprOption) {
        var errMsg = '';
        var dimLoose = exprOption.dimension;

        if (!hasOwn(exprOption, 'dimension')) {
          if (process.env.NODE_ENV !== 'production') {
            errMsg = makePrintable('Relation condition must has prop "dimension" specified.', 'Illegal condition:', exprOption);
          }

          throwError(errMsg);
        }

        var dimInfo = upstream.getDimensionInfo(dimLoose);

        if (!dimInfo) {
          if (process.env.NODE_ENV !== 'production') {
            errMsg = makePrintable('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal condition:', exprOption, '.\n');
          }

          throwError(errMsg);
        }

        return {
          dimIdx: dimInfo.index
        };
      },
      getValue: function (param) {
        return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
      }
    });
    var resultData = [];

    for (var i = 0, len = upstream.count(); i < len; i++) {
      rawItem = upstream.getRawDataItem(i);

      if (condition.evaluate()) {
        resultData.push(rawItem);
      }
    }

    return {
      data: resultData
    };
  }
};

var sampleLog = '';

if (process.env.NODE_ENV !== 'production') {
  sampleLog = ['Valid config is like:', '{ dimension: "age", order: "asc" }', 'or [{ dimension: "age", order: "asc"], { dimension: "date", order: "desc" }]'].join(' ');
}

var sortTransform = {
  type: 'echarts:sort',
  transform: function (params) {
    var upstream = params.upstream;
    var config = params.config;
    var errMsg = ''; // Normalize
    // const orderExprList: OrderExpression[] = isArray(config[0])
    //     ? config as OrderExpression[]
    //     : [config as OrderExpression];

    var orderExprList = normalizeToArray(config);

    if (!orderExprList.length) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'Empty `config` in sort transform.';
      }

      throwError(errMsg);
    }

    var orderDefList = [];
    each(orderExprList, function (orderExpr) {
      var dimLoose = orderExpr.dimension;
      var order = orderExpr.order;
      var parserName = orderExpr.parser;
      var incomparable = orderExpr.incomparable;

      if (dimLoose == null) {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = 'Sort transform config must has "dimension" specified.' + sampleLog;
        }

        throwError(errMsg);
      }

      if (order !== 'asc' && order !== 'desc') {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = 'Sort transform config must has "order" specified.' + sampleLog;
        }

        throwError(errMsg);
      }

      if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
        var errMsg_1 = '';

        if (process.env.NODE_ENV !== 'production') {
          errMsg_1 = 'incomparable must be "min" or "max" rather than "' + incomparable + '".';
        }

        throwError(errMsg_1);
      }

      if (order !== 'asc' && order !== 'desc') {
        var errMsg_2 = '';

        if (process.env.NODE_ENV !== 'production') {
          errMsg_2 = 'order must be "asc" or "desc" rather than "' + order + '".';
        }

        throwError(errMsg_2);
      }

      var dimInfo = upstream.getDimensionInfo(dimLoose);

      if (!dimInfo) {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = makePrintable('Can not find dimension info via: ' + dimLoose + '.\n', 'Existing dimensions: ', upstream.cloneAllDimensionInfo(), '.\n', 'Illegal config:', orderExpr, '.\n');
        }

        throwError(errMsg);
      }

      var parser = parserName ? getRawValueParser(parserName) : null;

      if (parserName && !parser) {
        if (process.env.NODE_ENV !== 'production') {
          errMsg = makePrintable('Invalid parser name ' + parserName + '.\n', 'Illegal config:', orderExpr, '.\n');
        }

        throwError(errMsg);
      }

      orderDefList.push({
        dimIdx: dimInfo.index,
        parser: parser,
        comparator: new SortOrderComparator(order, incomparable)
      });
    }); // TODO: support it?

    var sourceFormat = upstream.sourceFormat;

    if (sourceFormat !== SOURCE_FORMAT_ARRAY_ROWS && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
      if (process.env.NODE_ENV !== 'production') {
        errMsg = 'sourceFormat "' + sourceFormat + '" is not supported yet';
      }

      throwError(errMsg);
    } // Other upstream format are all array.


    var resultData = [];

    for (var i = 0, len = upstream.count(); i < len; i++) {
      resultData.push(upstream.getRawDataItem(i));
    }

    resultData.sort(function (item0, item1) {
      for (var i = 0; i < orderDefList.length; i++) {
        var orderDef = orderDefList[i];
        var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
        var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);

        if (orderDef.parser) {
          val0 = orderDef.parser(val0);
          val1 = orderDef.parser(val1);
        }

        var result = orderDef.comparator.evaluate(val0, val1);

        if (result !== 0) {
          return result;
        }
      }

      return 0;
    });
    return {
      data: resultData
    };
  }
};

function install$R(registers) {
  registers.registerTransform(filterTransform);
  registers.registerTransform(sortTransform);
}

var DatasetModel =
/** @class */
function (_super) {
  __extends$1(DatasetModel, _super);

  function DatasetModel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataset';
    return _this;
  }

  DatasetModel.prototype.init = function (option, parentModel, ecModel) {
    _super.prototype.init.call(this, option, parentModel, ecModel);

    this._sourceManager = new SourceManager(this);
    disableTransformOptionMerge(this);
  };

  DatasetModel.prototype.mergeOption = function (newOption, ecModel) {
    _super.prototype.mergeOption.call(this, newOption, ecModel);

    disableTransformOptionMerge(this);
  };

  DatasetModel.prototype.optionUpdated = function () {
    this._sourceManager.dirty();
  };

  DatasetModel.prototype.getSourceManager = function () {
    return this._sourceManager;
  };

  DatasetModel.type = 'dataset';
  DatasetModel.defaultOption = {
    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN
  };
  return DatasetModel;
}(ComponentModel);

var DatasetView =
/** @class */
function (_super) {
  __extends$1(DatasetView, _super);

  function DatasetView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'dataset';
    return _this;
  }

  DatasetView.type = 'dataset';
  return DatasetView;
}(ComponentView);

function install$S(registers) {
  registers.registerComponentModel(DatasetModel);
  registers.registerComponentView(DatasetView);
}

var CMD$4 = PathProxy.CMD;
function aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function pathToBezierCurves(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) {
            bezierArrayGroups.push(currentSubpath);
        }
        currentSubpath = [x, y];
    }
    function addLine(x0, y0, x1, y1) {
        if (!(aroundEqual(x0, x1) && aroundEqual(y0, y1))) {
            currentSubpath.push(x0, y0, x1, y1, x1, y1);
        }
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for (var i = 0; i < len;) {
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === CMD$4.L || cmd === CMD$4.C || cmd === CMD$4.Q) {
                currentSubpath = [x0, y0];
            }
        }
        switch (cmd) {
            case CMD$4.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case CMD$4.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case CMD$4.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case CMD$4.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case CMD$4.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                }
                else {
                    addLine(xi, yi, x1, y1);
                }
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for (var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step) {
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle)
                        : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case CMD$4.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case CMD$4.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) {
        bezierArrayGroups.push(currentSubpath);
    }
    return bezierArrayGroups;
}
function adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if (aroundEqual(x0, x1) && aroundEqual(y0, y1) && aroundEqual(x2, x3) && aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0
        && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    cubicSubdivide(x0, x1, x2, x3, 0.5, tmpSegX);
    cubicSubdivide(y0, y1, y2, y3, 0.5, tmpSegY);
    adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function pathToPolygons(path, scale) {
    var bezierArrayGroups = pathToBezierCurves(path);
    var polygons = [];
    scale = scale || 1;
    for (var i = 0; i < bezierArrayGroups.length; i++) {
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for (var k = 2; k < beziers.length;) {
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}

function getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for (var i = 0; i < rowCount; i++) {
        grids.push(columnCount);
    }
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) {
        for (var i = 0; i < remained; i++) {
            grids[i % rowCount] += 1;
        }
    }
    return grids;
}
function divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = getDividingGrids([arcLen, deltaR], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for (var row = 0; row < grids.length; row++) {
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for (var column = 0; column < grids[row]; column++) {
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            }
            else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = getDividingGrids([width, height], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? 'width' : 'height';
    var columnSizeDim = isHorizontalRow ? 'height' : 'width';
    var rowDim = isHorizontalRow ? 'x' : 'y';
    var columnDim = isHorizontalRow ? 'y' : 'x';
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for (var row = 0; row < grids.length; row++) {
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for (var column = 0; column < grids[row]; column++) {
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function crossProduct2d$1(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function lineLineIntersect$1(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = crossProduct2d$1(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) {
        return null;
    }
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = crossProduct2d$1(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) {
        return null;
    }
    return new Point(p * mx + a1x, p * my + a1y);
}
function projPtOnLine(pt, lineA, lineB) {
    var dir = new Point();
    Point.sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new Point();
    Point.sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) {
        return;
    }
    poly.push(pt);
}
function splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for (var i = 0; i < len; i++) {
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = lineLineIntersect$1(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) {
            intersections.push({
                projPt: projPtOnLine(intersectionPt, lineA, lineB),
                pt: intersectionPt,
                idx: i
            });
        }
    }
    if (intersections.length < 2) {
        return [{ points: points }, { points: points }];
    }
    intersections.sort(function (a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [splitPt0.pt.x, splitPt0.pt.y];
    var splitPt1Arr = [splitPt1.pt.x, splitPt1.pt.y];
    var newPolyA = [splitPt0Arr];
    var newPolyB = [splitPt1Arr];
    for (var i = splitPt0.idx + 1; i <= splitPt1.idx; i++) {
        addToPoly(newPolyA, points[i].slice());
    }
    addToPoly(newPolyA, splitPt1Arr);
    addToPoly(newPolyA, splitPt0Arr);
    for (var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++) {
        addToPoly(newPolyB, points[i % len].slice());
    }
    addToPoly(newPolyB, splitPt0Arr);
    addToPoly(newPolyB, splitPt1Arr);
    return [{
            points: newPolyA
        }, {
            points: newPolyB
        }];
}
function binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    fromPoints(points, min, max);
    var boundingRect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new Point();
    var pt1 = new Point();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    }
    else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return splitPolygonByLine(points, pt0, pt1);
}
function binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) {
        out.push(shape);
    }
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        binaryDivideRecursive(divider, sub[0], mid, out);
        binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function clone$4(path, count) {
    var paths = [];
    for (var i = 0; i < count; i++) {
        paths.push(clonePath(path));
    }
    return paths;
}
function copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function polygonConvert(points) {
    var out = [];
    for (var i = 0; i < points.length;) {
        out.push([points[i++], points[i++]]);
    }
    return out;
}
function split(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch (path.type) {
        case 'rect':
            divideRect(shape, count, outShapes);
            OutShapeCtor = Rect;
            break;
        case 'sector':
            divideSector(shape, count, outShapes);
            OutShapeCtor = Sector;
            break;
        case 'circle':
            divideSector({
                r0: 0, r: shape.r, startAngle: 0, endAngle: Math.PI * 2,
                cx: shape.cx, cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = Sector;
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = map(pathToPolygons(path.getUpdatedPathProxy(), scale), function (poly) { return polygonConvert(poly); });
            var polygonCount = polygons.length;
            if (polygonCount === 0) {
                binaryDivideRecursive(binaryDividePolygon, {
                    points: polygons[0]
                }, count, outShapes);
            }
            else if (polygonCount === count) {
                for (var i = 0; i < polygonCount; i++) {
                    outShapes.push({
                        points: polygons[i]
                    });
                }
            }
            else {
                var totalArea_1 = 0;
                var items = map(polygons, function (poly) {
                    var min = [];
                    var max = [];
                    fromPoints(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return { poly: poly, area: area };
                });
                items.sort(function (a, b) { return b.area - a.area; });
                var left = count;
                for (var i = 0; i < polygonCount; i++) {
                    var item = items[i];
                    if (left <= 0) {
                        break;
                    }
                    var selfCount = i === polygonCount - 1
                        ? left
                        : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) {
                        continue;
                    }
                    binaryDivideRecursive(binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = Polygon;
            break;
    }
    if (!OutShapeCtor) {
        return clone$4(path, count);
    }
    var out = [];
    for (var i = 0; i < outShapes.length; i++) {
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}

function alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) {
        return [subpath1, subpath2];
    }
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [shorterPath[0], shorterPath[1]];
    var remained = diff;
    for (var i = 2; i < shorterLen;) {
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for (var k = 1; k <= actualSubDivCount; k++) {
            var p = k / actualSubDivCount;
            cubicSubdivide(x0, x1, x2, x3, p, tmpSegX);
            cubicSubdivide(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [newSubpath, subpath2] : [subpath1, newSubpath];
}
function createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for (var i = 0; i < otherSubpath.length;) {
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function alignBezierCurves(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for (var i = 0; i < Math.max(array1.length, array2.length); i++) {
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        }
        else if (!subpath2) {
            newSubpath2 = createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        }
        else {
            _a = alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [newArray1, newArray2];
}
function centroid$1(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for (var i = 0, j = len - 2; i < len; j = i, i += 2) {
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) {
        return [array[0] || 0, array[1] || 0];
    }
    return [cx / signedArea / 3, cy / signedArea / 3, signedArea];
}
function findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for (var offset = 0; offset < bezierCount; offset++) {
        var cursorOffset = offset * 6;
        var score = 0;
        for (var k = 0; k < len; k += 2) {
            var idx = k === 0 ? cursorOffset : ((cursorOffset + k - 2) % len2 + 2);
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function reverse(array) {
    var newArr = [];
    var len = array.length;
    for (var i = 0; i < len; i += 2) {
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for (var i = 0; i < fromArr.length; i++) {
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = centroid$1(fromSubpathBezier);
        var toCp = centroid$1(toSubpathBezier);
        if (fromNeedsReverse == null) {
            fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        }
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) {
            fromSubpathBezier = reverse(fromSubpathBezier);
        }
        var offset = findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for (var k = 0; k < len2; k += 2) {
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for (var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step) {
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for (var k = 0; k < fromSubpathBezier.length; k += 2) {
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for (var m = 0; m < tmpArr.length; m++) {
                        newToSubpathBezier[m] = tmpArr[m];
                    }
                }
            }
        }
        else {
            for (var i_1 = 0; i_1 < len; i_1 += 2) {
                newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
                newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
            }
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function isCombineMorphing(path) {
    return path.__isCombineMorphing;
}
var SAVED_METHOD_PREFIX = '__mOriginal_';
function saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) {
        obj[savedMethodName] = obj[methodName];
    }
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function () {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) {
            res = replace.apply(this, args);
        }
        else {
            res = originalMethod.apply(this, args);
        }
        after && after.apply(this, args);
        return res;
    };
}
function restoreMethod(obj, methodName) {
    var savedMethodName = SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function applyTransformOnBeziers(bezierCurves, mm) {
    for (var i = 0; i < bezierCurves.length; i++) {
        var subBeziers = bezierCurves[i];
        for (var k = 0; k < subBeziers.length;) {
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = alignBezierCurves(pathToBezierCurves(fromPathProxy), pathToBezierCurves(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && applyTransformOnBeziers(toBezierCurves, toPathTransform);
    saveAndModifyMethod(toPath, 'updateTransform', { replace: updateIdentityTransform });
    toPath.transform = null;
    var morphingData = findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    saveAndModifyMethod(toPath, 'buildPath', { replace: function (path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for (var i = 0; i < morphingData.length; i++) {
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                lerp(newCp, fromCp, toCp, t);
                for (var m = 0; m < from.length; m += 2) {
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = (x * ca - y * sa) + newCp[0];
                    tmpArr[m + 1] = (x * sa + y * ca) + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for (var m = 2; m < from.length;) {
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) {
                        path.lineTo(x3, y3);
                    }
                    else {
                        path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    }
                    x0 = x3;
                    y0 = y3;
                }
            }
        } });
}
function morphPath(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) {
        return toPath;
    }
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        restoreMethod(toPath, 'buildPath');
        restoreMethod(toPath, 'updateTransform');
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, defaults({
        during: function (p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function () {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = (maxX === minX) ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = (maxY === minY) ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for (var s = (1 << bits) / 2; s > 0; s /= 2) {
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) {
            rx = 1;
        }
        if ((y & s) > 0) {
            ry = 1;
        }
        d += s * s * ((3 * rx) ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = map(pathList, function (path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [x, y];
    });
    var items = map(cps, function (cp, idx) {
        return {
            cp: cp,
            z: hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function (a, b) { return a.z - b.z; }).map(function (item) { return item.path; });
}
function defaultDividePath(param) {
    return split(param.path, param.count);
}
function createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function combineMorph(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for (var i = 0; i < fromList.length; i++) {
            var from = fromList[i];
            if (isCombineMorphing(from)) {
                addFromPath(from.childrenRef());
            }
            else if (from instanceof Path) {
                fromPathList.push(from);
            }
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) {
        return createEmptyReturn();
    }
    var dividePath = animationOpts.dividePath || defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath, count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error('Invalid morphing: unmatched splitted path');
        return createEmptyReturn();
    }
    fromPathList = sortPaths(fromPathList);
    toSubPathList = sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new Transformable();
    for (var i = 0; i < separateCount; i++) {
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) {
            prepareMorphPath(from, to);
        }
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function () {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for (var i = 0; i < toSubPathList.length; i++) {
            toSubPathList[i].addSelfToZr(zr);
        }
    }
    saveAndModifyMethod(toPath, 'addSelfToZr', {
        after: function (zr) {
            addToSubPathListToZr(zr);
        }
    });
    saveAndModifyMethod(toPath, 'removeSelfFromZr', {
        after: function (zr) {
            for (var i = 0; i < toSubPathList.length; i++) {
                toSubPathList[i].removeSelfFromZr(zr);
            }
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        restoreMethod(toPath, 'addSelfToZr');
        restoreMethod(toPath, 'removeSelfFromZr');
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function () {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for (var i = 0; i < toLen; i++) {
            var indivdualAnimationOpts = individualDelay ? defaults({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            morphPath(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    }
    else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, defaults({
            during: function (p) {
                for (var i = 0; i < toLen; i++) {
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function () {
                restoreToPath();
                for (var i = 0; i < fromList.length; i++) {
                    restoreMethod(fromList[i], 'updateTransform');
                }
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) {
        addToSubPathListToZr(toPath.__zr);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function separateMorph(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || defaultDividePath;
    function addFromPath(fromList) {
        for (var i = 0; i < fromList.length; i++) {
            var from = fromList[i];
            if (isCombineMorphing(from)) {
                addFromPath(from.childrenRef());
            }
            else if (from instanceof Path) {
                fromPathList.push(from);
            }
        }
    }
    if (isCombineMorphing(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for (var i = fromLen; i < toLen; i++) {
                fromPathList.push(clonePath(fromPathList[k++ % fromLen]));
            }
        }
        fromPathList.length = toLen;
    }
    else {
        fromPathList = dividePath({ path: fromPath, count: toLen });
        var fromPathTransform = fromPath.getComputedTransform();
        for (var i = 0; i < fromPathList.length; i++) {
            fromPathList[i].setLocalTransform(fromPathTransform);
        }
        if (fromPathList.length !== toLen) {
            console.error('Invalid morphing: unmatched splitted path');
            return createEmptyReturn();
        }
    }
    fromPathList = sortPaths(fromPathList);
    toPathList = sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for (var i = 0; i < toLen; i++) {
        var indivdualAnimationOpts = individualDelay ? defaults({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        morphPath(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}

function isMultiple(elements) {
  return isArray$1(elements[0]);
}

function prepareMorphBatches(one, many) {
  var batches = [];
  var batchCount = one.length;

  for (var i = 0; i < batchCount; i++) {
    batches.push({
      one: one[i],
      many: []
    });
  }

  for (var i = 0; i < many.length; i++) {
    var len = many[i].length;
    var k = void 0;

    for (k = 0; k < len; k++) {
      batches[k % batchCount].many.push(many[i][k]);
    }
  }

  var off = 0; // If one has more paths than each one of many. average them.

  for (var i = batchCount - 1; i >= 0; i--) {
    if (!batches[i].many.length) {
      var moveFrom = batches[off].many;

      if (moveFrom.length <= 1) {
        // Not enough
        // Start from the first one.
        if (off) {
          off = 0;
        } else {
          return batches;
        }
      }

      var len = moveFrom.length;
      var mid = Math.ceil(len / 2);
      batches[i].many = moveFrom.slice(mid, len);
      batches[off].many = moveFrom.slice(0, mid);
      off++;
    }
  }

  return batches;
}

var pathDividers = {
  clone: function (params) {
    var ret = []; // Fitting the alpha

    var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);

    for (var i = 0; i < params.count; i++) {
      var cloned = clonePath(params.path);
      cloned.setStyle('opacity', approxOpacity);
      ret.push(cloned);
    }

    return ret;
  },
  // Use the default divider
  split: null
};
function applyMorphAnimation(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
  if (!from.length || !to.length) {
    return;
  }

  var updateAnimationCfg = getAnimationConfig('update', seriesModel, dataIndex);

  if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) {
    return;
  }

  var animationDelay = seriesModel.getModel('universalTransition').get('delay');
  var animationCfg = Object.assign({
    // Need to setToFinal so the further calculation based on the style can be correct.
    // Like emphasis color.
    setToFinal: true
  }, updateAnimationCfg);
  var many;
  var one;

  if (isMultiple(from)) {
    // manyToOne
    many = from;
    one = to;
  }

  if (isMultiple(to)) {
    // oneToMany
    many = to;
    one = from;
  }

  function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
    var batchMany = batch.many;
    var batchOne = batch.one;

    if (batchMany.length === 1 && !forceManyOne) {
      // Is one to one
      var batchFrom = fromIsMany ? batchMany[0] : batchOne;
      var batchTo = fromIsMany ? batchOne : batchMany[0];

      if (isCombineMorphing(batchFrom)) {
        // Keep doing combine animation.
        morphOneBatch({
          many: [batchFrom],
          one: batchTo
        }, true, animateIndex, animateCount, true);
      } else {
        var individualAnimationCfg = animationDelay ? defaults({
          delay: animationDelay(animateIndex, animateCount)
        }, animationCfg) : animationCfg;
        morphPath(batchFrom, batchTo, individualAnimationCfg);
        animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
      }
    } else {
      var separateAnimationCfg = defaults({
        dividePath: pathDividers[divideShape],
        individualDelay: animationDelay && function (idx, count, fromPath, toPath) {
          return animationDelay(idx + animateIndex, animateCount);
        }
      }, animationCfg);

      var _a = fromIsMany ? combineMorph(batchMany, batchOne, separateAnimationCfg) : separateMorph(batchOne, batchMany, separateAnimationCfg),
          fromIndividuals = _a.fromIndividuals,
          toIndividuals = _a.toIndividuals;

      var count = fromIndividuals.length;

      for (var k = 0; k < count; k++) {
        var individualAnimationCfg = animationDelay ? defaults({
          delay: animationDelay(k, count)
        }, animationCfg) : animationCfg;
        animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
      }
    }
  }

  var fromIsMany = many ? many === from // Is one to one. If the path number not match. also needs do merge and separate morphing.
  : from.length > to.length;
  var morphBatches = many ? prepareMorphBatches(one, many) : prepareMorphBatches(fromIsMany ? to : from, [fromIsMany ? from : to]);
  var animateCount = 0;

  for (var i = 0; i < morphBatches.length; i++) {
    animateCount += morphBatches[i].many.length;
  }

  var animateIndex = 0;

  for (var i = 0; i < morphBatches.length; i++) {
    morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
    animateIndex += morphBatches[i].many.length;
  }
}
function getPathList(elements) {
  if (!elements) {
    return [];
  }

  if (isArray$1(elements)) {
    var pathList_1 = [];

    for (var i = 0; i < elements.length; i++) {
      pathList_1.push(getPathList(elements[i]));
    }

    return pathList_1;
  }

  var pathList = [];
  elements.traverse(function (el) {
    if (el instanceof Path && !el.disableMorphing && !el.invisible && !el.ignore) {
      pathList.push(el);
    }
  });
  return pathList;
}

var DATA_COUNT_THRESHOLD = 1e4;
var getUniversalTransitionGlobalStore = makeInner();

function getGroupIdDimension(data) {
  var dimensions = data.dimensions;

  for (var i = 0; i < dimensions.length; i++) {
    var dimInfo = data.getDimensionInfo(dimensions[i]);

    if (dimInfo && dimInfo.otherDims.itemGroupId === 0) {
      return dimensions[i];
    }
  }
}

function flattenDataDiffItems(list) {
  var items = [];
  each(list, function (seriesInfo) {
    var data = seriesInfo.data;

    if (data.count() > DATA_COUNT_THRESHOLD) {
      if (process.env.NODE_ENV !== 'production') {
        warn('Universal transition is disabled on large data > 10k.');
      }

      return;
    }

    var indices = data.getIndices();
    var groupDim = getGroupIdDimension(data);

    for (var dataIndex = 0; dataIndex < indices.length; dataIndex++) {
      items.push({
        dataGroupId: seriesInfo.dataGroupId,
        data: data,
        dim: seriesInfo.dim || groupDim,
        divide: seriesInfo.divide,
        dataIndex: dataIndex
      });
    }
  });
  return items;
}

function fadeInElement(newEl, newSeries, newIndex) {
  newEl.traverse(function (el) {
    if (el instanceof Path) {
      // TODO use fade in animation for target element.
      initProps(el, {
        style: {
          opacity: 0
        }
      }, newSeries, {
        dataIndex: newIndex,
        isFrom: true
      });
    }
  });
}

function removeEl$1(el) {
  if (el.parent) {
    // Bake parent transform to element.
    // So it can still have proper transform to transition after it's removed.
    var computedTransform = el.getComputedTransform();
    el.setLocalTransform(computedTransform);
    el.parent.remove(el);
  }
}

function stopAnimation(el) {
  el.stopAnimation();

  if (el.isGroup) {
    el.traverse(function (child) {
      child.stopAnimation();
    });
  }
}

function animateElementStyles(el, dataIndex, seriesModel) {
  var animationConfig = getAnimationConfig('update', seriesModel, dataIndex);
  animationConfig && el.traverse(function (child) {
    if (child instanceof Displayable) {
      var oldStyle = getOldStyle(child);

      if (oldStyle) {
        child.animateFrom({
          style: oldStyle
        }, animationConfig);
      }
    }
  });
}

function isAllIdSame(oldDiffItems, newDiffItems) {
  var len = oldDiffItems.length;

  if (len !== newDiffItems.length) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    var oldItem = oldDiffItems[i];
    var newItem = newDiffItems[i];

    if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) {
      return false;
    }
  }

  return true;
}

function transitionBetween(oldList, newList, api) {
  var oldDiffItems = flattenDataDiffItems(oldList);
  var newDiffItems = flattenDataDiffItems(newList);

  function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
    if (rawFrom || from) {
      to.animateFrom({
        style: rawFrom && rawFrom !== from ? // dividingMethod like clone may override the style(opacity)
        // So extend it to raw style.
        extend(extend({}, rawFrom.style), from.style) : from.style
      }, animationCfg);
    }
  }

  function findKeyDim(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].dim) {
        return items[i].dim;
      }
    }
  }

  var oldKeyDim = findKeyDim(oldDiffItems);
  var newKeyDim = findKeyDim(newDiffItems);
  var hasMorphAnimation = false;

  function createKeyGetter(isOld, onlyGetId) {
    return function (diffItem) {
      var data = diffItem.data;
      var dataIndex = diffItem.dataIndex; // TODO if specified dim

      if (onlyGetId) {
        return data.getId(dataIndex);
      } // Use group id as transition key by default.
      // So we can achieve multiple to multiple animation like drilldown / up naturally.
      // If group id not exits. Use id instead. If so, only one to one transition will be applied.


      var dataGroupId = diffItem.dataGroupId; // If specified key dimension(itemGroupId by default). Use this same dimension from other data.
      // PENDING: If only use key dimension of newData.

      var keyDim = isOld ? oldKeyDim || newKeyDim : newKeyDim || oldKeyDim;
      var dimInfo = keyDim && data.getDimensionInfo(keyDim);
      var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;

      if (dimInfo) {
        // Get from encode.itemGroupId.
        var key = data.get(dimInfo.name, dataIndex);

        if (dimOrdinalMeta) {
          return dimOrdinalMeta.categories[key] || key + '';
        }

        return key + '';
      } // Get groupId from raw item. { groupId: '' }


      var itemVal = data.getRawDataItem(dataIndex);

      if (itemVal && itemVal.groupId) {
        return itemVal.groupId + '';
      }

      return dataGroupId || data.getId(dataIndex);
    };
  } // Use id if it's very likely to be an one to one animation
  // It's more robust than groupId
  // TODO Check if key dimension is specified.


  var useId = isAllIdSame(oldDiffItems, newDiffItems);
  var isElementStillInChart = {};

  if (!useId) {
    // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for (var i = 0; i < newDiffItems.length; i++) {
      var newItem = newDiffItems[i];
      var el = newItem.data.getItemGraphicEl(newItem.dataIndex);

      if (el) {
        isElementStillInChart[el.id] = true;
      }
    }
  }

  function updateOneToOne(newIndex, oldIndex) {
    var oldItem = oldDiffItems[oldIndex];
    var newItem = newDiffItems[newIndex];
    var newSeries = newItem.data.hostModel; // TODO Mark this elements is morphed and don't morph them anymore

    var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
    var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex); // Can't handle same elements.

    if (oldEl === newEl) {
      newEl && animateElementStyles(newEl, newItem.dataIndex, newSeries);
      return;
    }

    if ( // We can't use the elements that already being morphed
    oldEl && isElementStillInChart[oldEl.id]) {
      return;
    }

    if (newEl) {
      // TODO: If keep animating the group in case
      // some of the elements don't want to be morphed.
      // TODO Label?
      stopAnimation(newEl);

      if (oldEl) {
        stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.

        removeEl$1(oldEl);
        hasMorphAnimation = true;
        applyMorphAnimation(getPathList(oldEl), getPathList(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
      } else {
        fadeInElement(newEl, newSeries, newIndex);
      }
    } // else keep oldEl leaving animation.

  }

  new DataDiffer(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function (newIndex, oldIndices) {
    var newItem = newDiffItems[newIndex];
    var newData = newItem.data;
    var newSeries = newData.hostModel;
    var newEl = newData.getItemGraphicEl(newItem.dataIndex);
    var oldElsList = filter(map(oldIndices, function (idx) {
      return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
    }), function (oldEl) {
      return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
    });

    if (newEl) {
      stopAnimation(newEl);

      if (oldElsList.length) {
        // If old element is doing leaving animation. stop it and remove it immediately.
        each(oldElsList, function (oldEl) {
          stopAnimation(oldEl);
          removeEl$1(oldEl);
        });
        hasMorphAnimation = true;
        applyMorphAnimation(getPathList(oldElsList), getPathList(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
      } else {
        fadeInElement(newEl, newSeries, newItem.dataIndex);
      }
    } // else keep oldEl leaving animation.

  }).updateOneToMany(function (newIndices, oldIndex) {
    var oldItem = oldDiffItems[oldIndex];
    var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex); // We can't use the elements that already being morphed

    if (oldEl && isElementStillInChart[oldEl.id]) {
      return;
    }

    var newElsList = filter(map(newIndices, function (idx) {
      return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
    }), function (el) {
      return el && el !== oldEl;
    });
    var newSeris = newDiffItems[newIndices[0]].data.hostModel;

    if (newElsList.length) {
      each(newElsList, function (newEl) {
        return stopAnimation(newEl);
      });

      if (oldEl) {
        stopAnimation(oldEl); // If old element is doing leaving animation. stop it and remove it immediately.

        removeEl$1(oldEl);
        hasMorphAnimation = true;
        applyMorphAnimation(getPathList(oldEl), getPathList(newElsList), oldItem.divide, // Use divide on old.
        newSeris, newIndices[0], updateMorphingPathProps);
      } else {
        each(newElsList, function (newEl) {
          return fadeInElement(newEl, newSeris, newIndices[0]);
        });
      }
    } // else keep oldEl leaving animation.

  }).updateManyToMany(function (newIndices, oldIndices) {
    // If two data are same and both have groupId.
    // Normally they should be diff by id.
    new DataDiffer(oldIndices, newIndices, function (rawIdx) {
      return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
    }, function (rawIdx) {
      return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
    }).update(function (newIndex, oldIndex) {
      // Use the original index
      updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
    }).execute();
  }).execute();

  if (hasMorphAnimation) {
    each(newList, function (_a) {
      var data = _a.data;
      var seriesModel = data.hostModel;
      var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
      var animationCfg = getAnimationConfig('update', seriesModel, 0); // use 0 index.

      if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) {
        view.group.traverse(function (el) {
          if (el instanceof Path && !el.animators.length) {
            // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
              style: {
                opacity: 0
              }
            }, animationCfg);
          }
        });
      }
    });
  }
}

function getSeriesTransitionKey(series) {
  var seriesKey = series.getModel('universalTransition').get('seriesKey');

  if (!seriesKey) {
    // Use series id by default.
    return series.id;
  }

  return seriesKey;
}

function convertArraySeriesKeyToString(seriesKey) {
  if (isArray$1(seriesKey)) {
    // Order independent.
    return seriesKey.sort().join(',');
  }

  return seriesKey;
}

function getDivideShapeFromData(data) {
  if (data.hostModel) {
    return data.hostModel.getModel('universalTransition').get('divideShape');
  }
}

function findTransitionSeriesBatches(globalStore, params) {
  var updateBatches = createHashMap();
  var oldDataMap = createHashMap(); // Map that only store key in array seriesKey.
  // Which is used to query the old data when transition from one to multiple series.

  var oldDataMapForSplit = createHashMap();
  each(globalStore.oldSeries, function (series, idx) {
    var oldDataGroupId = globalStore.oldDataGroupIds[idx];
    var oldData = globalStore.oldData[idx];
    var transitionKey = getSeriesTransitionKey(series);
    var transitionKeyStr = convertArraySeriesKeyToString(transitionKey);
    oldDataMap.set(transitionKeyStr, {
      dataGroupId: oldDataGroupId,
      data: oldData
    });

    if (isArray$1(transitionKey)) {
      // Same key can't in different array seriesKey.
      each(transitionKey, function (key) {
        oldDataMapForSplit.set(key, {
          key: transitionKeyStr,
          dataGroupId: oldDataGroupId,
          data: oldData
        });
      });
    }
  });

  function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
    if (updateBatches.get(transitionKeyStr)) {
      warn("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
  }

  each(params.updatedSeries, function (series) {
    if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
      var newDataGroupId = series.get('dataGroupId');
      var newData = series.getData();
      var transitionKey = getSeriesTransitionKey(series);
      var transitionKeyStr = convertArraySeriesKeyToString(transitionKey); // Only transition between series with same id.

      var oldData = oldDataMap.get(transitionKeyStr); // string transition key is the best match.

      if (oldData) {
        if (process.env.NODE_ENV !== 'production') {
          checkTransitionSeriesKeyDuplicated(transitionKeyStr);
        } // TODO check if data is same?


        updateBatches.set(transitionKeyStr, {
          oldSeries: [{
            dataGroupId: oldData.dataGroupId,
            divide: getDivideShapeFromData(oldData.data),
            data: oldData.data
          }],
          newSeries: [{
            dataGroupId: newDataGroupId,
            divide: getDivideShapeFromData(newData),
            data: newData
          }]
        });
      } else {
        // Transition from multiple series.
        if (isArray$1(transitionKey)) {
          if (process.env.NODE_ENV !== 'production') {
            checkTransitionSeriesKeyDuplicated(transitionKeyStr);
          }

          var oldSeries_1 = [];
          each(transitionKey, function (key) {
            var oldData = oldDataMap.get(key);

            if (oldData.data) {
              oldSeries_1.push({
                dataGroupId: oldData.dataGroupId,
                divide: getDivideShapeFromData(oldData.data),
                data: oldData.data
              });
            }
          });

          if (oldSeries_1.length) {
            updateBatches.set(transitionKeyStr, {
              oldSeries: oldSeries_1,
              newSeries: [{
                dataGroupId: newDataGroupId,
                data: newData,
                divide: getDivideShapeFromData(newData)
              }]
            });
          }
        } else {
          // Try transition to multiple series.
          var oldData_1 = oldDataMapForSplit.get(transitionKey);

          if (oldData_1) {
            var batch = updateBatches.get(oldData_1.key);

            if (!batch) {
              batch = {
                oldSeries: [{
                  dataGroupId: oldData_1.dataGroupId,
                  data: oldData_1.data,
                  divide: getDivideShapeFromData(oldData_1.data)
                }],
                newSeries: []
              };
              updateBatches.set(oldData_1.key, batch);
            }

            batch.newSeries.push({
              dataGroupId: newDataGroupId,
              data: newData,
              divide: getDivideShapeFromData(newData)
            });
          }
        }
      }
    }
  });
  return updateBatches;
}

function querySeries(series, finder) {
  for (var i = 0; i < series.length; i++) {
    var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;

    if (found) {
      return i;
    }
  }
}

function transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
  var from = [];
  var to = [];
  each(normalizeToArray(transitionOpt.from), function (finder) {
    var idx = querySeries(globalStore.oldSeries, finder);

    if (idx >= 0) {
      from.push({
        dataGroupId: globalStore.oldDataGroupIds[idx],
        data: globalStore.oldData[idx],
        // TODO can specify divideShape in transition.
        divide: getDivideShapeFromData(globalStore.oldData[idx]),
        dim: finder.dimension
      });
    }
  });
  each(normalizeToArray(transitionOpt.to), function (finder) {
    var idx = querySeries(params.updatedSeries, finder);

    if (idx >= 0) {
      var data = params.updatedSeries[idx].getData();
      to.push({
        dataGroupId: globalStore.oldDataGroupIds[idx],
        data: data,
        divide: getDivideShapeFromData(data),
        dim: finder.dimension
      });
    }
  });

  if (from.length > 0 && to.length > 0) {
    transitionBetween(from, to, api);
  }
}

function installUniversalTransition(registers) {
  registers.registerUpdateLifecycle('series:beforeupdate', function (ecMOdel, api, params) {
    each(normalizeToArray(params.seriesTransition), function (transOpt) {
      each(normalizeToArray(transOpt.to), function (finder) {
        var series = params.updatedSeries;

        for (var i = 0; i < series.length; i++) {
          if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) {
            series[i][SERIES_UNIVERSAL_TRANSITION_PROP] = true;
          }
        }
      });
    });
  });
  registers.registerUpdateLifecycle('series:transition', function (ecModel, api, params) {
    // TODO api provide an namespace that can save stuff per instance
    var globalStore = getUniversalTransitionGlobalStore(api); // TODO multiple to multiple series.

    if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
      // Use give transition config if its' give;
      var transitionOpt = params.seriesTransition;

      if (transitionOpt) {
        each(normalizeToArray(transitionOpt), function (opt) {
          transitionSeriesFromOpt(opt, globalStore, params, api);
        });
      } else {
        // Else guess from series based on transition series key.
        var updateBatches_1 = findTransitionSeriesBatches(globalStore, params);
        each(updateBatches_1.keys(), function (key) {
          var batch = updateBatches_1.get(key);
          transitionBetween(batch.oldSeries, batch.newSeries, api);
        });
      } // Reset


      each(params.updatedSeries, function (series) {
        // Reset;
        if (series[SERIES_UNIVERSAL_TRANSITION_PROP]) {
          series[SERIES_UNIVERSAL_TRANSITION_PROP] = false;
        }
      });
    } // Save all series of current update. Not only the updated one.


    var allSeries = ecModel.getSeries();
    var savedSeries = globalStore.oldSeries = [];
    var savedDataGroupIds = globalStore.oldDataGroupIds = [];
    var savedData = globalStore.oldData = [];

    for (var i = 0; i < allSeries.length; i++) {
      var data = allSeries[i].getData(); // Only save the data that can have transition.
      // Avoid large data costing too much extra memory

      if (data.count() < DATA_COUNT_THRESHOLD) {
        savedSeries.push(allSeries[i]);
        savedDataGroupIds.push(allSeries[i].get('dataGroupId'));
        savedData.push(data);
      }
    }
  });
}

// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })

use([install$1]); // Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })

use([install]); // ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });

use([install$2, install$3, install$4, install$6, install$8, install$a, install$b, install$c, install$d, install$e, install$f, install$h, install$i, install$j, install$k, install$l, install$m, install$n, install$o, install$p, install$q, install$r]); // -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });

use(install$t); // `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });

use(install$u); // `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });

use(install$9); // `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });

use(install$v); // `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });

use(install$g); // `calendar` coordinate system. for example,
// chart.setOptionp({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );

use(install$w); // ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });

use(install$x); // `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });

use(install$z); // `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });

use(install$A); // `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });

use(install$s); // `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })

use(install$B); // `title` component, for example:
// chart.setOption({
//     title: {...}
// });

use(install$C); // `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });

use(install$D); // `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });

use(install$E); // `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });

use(install$F); // `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });

use(install$G); // `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });

use(install$J); // `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.

use(install$M); // `dataZoom` component providing drag, pinch, wheel behaviors
// inside coodinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });

use(install$K); // `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });

use(install$L); // `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.

use(install$P); // `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });

use(install$N); // `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });

use(install$O); // `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });

use(install$Q); // dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });

use(install$R);
use(install$S); // universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })

use(installUniversalTransition); // label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })

use(installLabelLayout);

var index$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	registerLocale: registerLocale,
	version: version$1,
	dependencies: dependencies,
	PRIORITY: PRIORITY,
	init: init$1,
	connect: connect,
	disConnect: disConnect,
	disconnect: disconnect,
	dispose: dispose$1,
	getInstanceByDom: getInstanceByDom,
	getInstanceById: getInstanceById,
	registerTheme: registerTheme,
	registerPreprocessor: registerPreprocessor,
	registerProcessor: registerProcessor,
	registerPostInit: registerPostInit,
	registerPostUpdate: registerPostUpdate,
	registerUpdateLifecycle: registerUpdateLifecycle,
	registerAction: registerAction,
	registerCoordinateSystem: registerCoordinateSystem,
	getCoordinateSystemDimensions: getCoordinateSystemDimensions,
	registerLayout: registerLayout,
	registerVisual: registerVisual,
	registerLoading: registerLoading,
	setCanvasCreator: setCanvasCreator,
	registerMap: registerMap,
	getMap: getMap,
	registerTransform: registerTransform,
	dataTool: dataTool,
	throttle: throttle$1,
	use: use,
	setPlatformAPI: setPlatformAPI,
	parseGeoJSON: parseGeoJSON,
	parseGeoJson: parseGeoJSON,
	env: env,
	Model: Model,
	Axis: Axis,
	innerDrawElementOnCanvas: brushSingle,
	zrender: zrender,
	matrix: matrix,
	vector: vector,
	zrUtil: util,
	color: color,
	helper: helper,
	number: number,
	time: time,
	graphic: graphic$1,
	format: format$2,
	util: util$1,
	List: SeriesData,
	ComponentModel: ComponentModel,
	ComponentView: ComponentView,
	SeriesModel: SeriesModel,
	ChartView: ChartView,
	extendComponentModel: extendComponentModel,
	extendComponentView: extendComponentView,
	extendSeriesModel: extendSeriesModel,
	extendChartView: extendChartView
});

function ownKeys$s(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$s(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$s(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$s(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const EChart = /*#__PURE__*/forwardRef(({
  option,
  style,
  settings,
  loading,
  theme,
  className
}, parentRef) => {
  const chartRef = useRef(null);
  useEffect(() => {
    // Initialize chart
    let chart;
    if (chartRef.current !== null) {
      chart = init$1(chartRef.current, theme);
    }
    // Add chart resize listener
    // ResizeObserver is leading to a bit janky UX
    function resizeChart() {
      chart?.resize();
    }
    window.addEventListener('resize', resizeChart);
    // Return cleanup function
    return () => {
      chart?.dispose();
      window.removeEventListener('resize', resizeChart);
    };
  }, [theme]);
  useEffect(() => {
    // Update chart
    if (chartRef.current !== null) {
      const chart = getInstanceByDom(chartRef.current);
      chart?.setOption(option, settings);
    }
  }, [option, settings, theme]); // Whenever theme changes we need to add option and setting due to it being deleted in cleanup function
  useEffect(() => {
    // Update chart
    if (chartRef.current !== null) {
      const chart = getInstanceByDom(chartRef.current);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      loading === true ? chart?.showLoading() : chart?.hideLoading();
    }
  }, [loading, theme]);
  return /*#__PURE__*/React.createElement("div", {
    ref: mergeRefs$1([parentRef, chartRef]),
    className: className,
    style: _objectSpread$s({
      width: '100%',
      height: '100px'
    }, style)
  });
});
EChart.displayName = 'EChart';

const TileContext = /*#__PURE__*/createContext({
  checked: false
});
function useTileContext() {
  const context = React.useContext(TileContext);
  if (context === undefined) {
    throw new Error('TileContext must be used within a TileContext.Provider');
  }
  return context;
}

const ImageWrapper = styled(Flex).withConfig({
  displayName: "styles__ImageWrapper",
  componentId: "sc-22qyyo-0"
})(["overflow:hidden;border-radius:8px 8px 0 0;height:", ";background-color:", ";opacity:", ";filter:", ";img{min-width:100%;min-height:100%;}"], ({
  small
}) => small ? '72px' : '78px', ({
  theme
}) => theme.colors.tile.imageBackgroundColor, ({
  checked,
  disabled
}) => !checked && disabled ? 0.75 : 1, ({
  checked,
  disabled
}) => !checked && disabled ? 'grayscale(1)' : 'none');
const Divider$2 = styled.hr.withConfig({
  displayName: "styles__Divider",
  componentId: "sc-22qyyo-1"
})(["height:1px;border:none;margin:0 0 ", " 0;background-color:", ";"], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => theme.colors.tile.dividerColor);

const checkedCSS = css$1(["border-color:", ";background-color:", ";.beauTypography{color:", ";}", "{background-color:", ";}"], ({
  theme
}) => theme.colors.tile.hover.borderColor, ({
  theme
}) => theme.colors.tile.active.backgroundColor, ({
  theme
}) => theme.colors.tile.active.textColor, Divider$2, ({
  theme
}) => theme.colors.tile.hover.dividerColor);
const hoverCSS = css$1(["", ";cursor:pointer;background-color:", ";"], checkedCSS, ({
  theme
}) => theme.colors.tile.hover.backgroundColor);
const disabledCSS = css$1(["cursor:not-allowed;border-color:", ";background-color:", ";color:", ";"], ({
  theme
}) => theme.colors.tile.borderColor, ({
  theme
}) => theme.colors.tile.disabled.backgroundColor, ({
  theme
}) => theme.colors.tile.disabled.textColor);
const Wrapper$5 = styled.label.withConfig({
  displayName: "styles__Wrapper",
  componentId: "kn9ltb-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;padding:", ";border-radius:8px;border:", ";background-color:", ";overflow:hidden;min-height:", ";width:", ";&:hover{", ";}", " ", ""], ({
  theme
}) => theme.spacing(1), ({
  theme
}) => `1px solid ${theme.colors.tile.borderColor}`, ({
  theme
}) => theme.colors.tile.backgroundColor, ({
  small
}) => small ? '168px' : '180px', ({
  small
}) => small ? '208px' : '272px', ({
  disabled
}) => !disabled && hoverCSS, ({
  disabled
}) => disabled && disabledCSS, ({
  checked
}) => checked && checkedCSS);

const Title$7 = styled(Typography$2).withConfig({
  displayName: "styles__Title",
  componentId: "h2i8qr-0"
})(["&.beauTypography{", ";}"], ({
  $small
}) => $small && `margin-top: 3px`);

const Text$1 = ({
  name,
  description
}) => {
  const {
    small,
    'data-testid': dataTestId
  } = useTileContext();
  return /*#__PURE__*/React.createElement(Flex, {
    direction: "column"
  }, /*#__PURE__*/React.createElement(Title$7, {
    "$small": small,
    variant: small ? 'captionstrong' : 'paragraphstrong',
    "data-testid": `${dataTestId}-title`,
    component: "span"
  }, name), description && /*#__PURE__*/React.createElement(Typography$2, {
    color: colors.neutrals.darkGrey,
    variant: small ? 'tinyregular' : 'captionregular',
    "data-testid": `${dataTestId}-description`,
    component: "p"
  }, description));
};

const Checkbox$3 = ({
  name,
  description,
  'data-testid': dataTestId = 'beau-tile-checkbox'
}) => {
  const {
    checked,
    disabled,
    onClick
  } = useTileContext();
  return /*#__PURE__*/React.createElement(Checkbox$2, {
    name: name,
    checked: !!checked,
    disabled: disabled,
    "data-testid": dataTestId,
    onChange: e => onClick && onClick(e)
  }, /*#__PURE__*/React.createElement(Text$1, {
    name: name,
    description: description
  }));
};

const Radio$2 = ({
  name,
  description,
  'data-testid': dataTestId = 'beau-tile-radio'
}) => {
  const {
    checked,
    disabled,
    onClick
  } = useTileContext();
  return /*#__PURE__*/React.createElement(Radio$1, {
    name: name,
    checked: !!checked,
    disabled: disabled,
    "data-testid": dataTestId,
    onChange: e => onClick && onClick(e)
  }, /*#__PURE__*/React.createElement(Text$1, {
    name: name,
    description: description
  }));
};

const StyledIcon$2 = styled(Icon).withConfig({
  displayName: "styles__StyledIcon",
  componentId: "sc-107l2ni-0"
})(["svg{height:", ";width:", ";}"], ({
  small
}) => small ? '40px' : '60px', ({
  small
}) => small ? '40px' : '60px');

const Image$2 = ({
  children
}) => {
  const {
    small,
    checked,
    disabled
  } = useTileContext();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImageWrapper, {
    small: small,
    checked: !!checked,
    disabled: disabled,
    verticalAlign: "center",
    horizontalAlign: "center",
    "data-testid": "beau-tile-image-placeholder"
  }, children), /*#__PURE__*/React.createElement(Divider$2, null));
};

const Icon$4 = ({
  name
}) => {
  const {
    small,
    disabled
  } = useTileContext();
  return /*#__PURE__*/React.createElement(Image$2, null, /*#__PURE__*/React.createElement(StyledIcon$2, {
    small: small,
    disabled: disabled,
    name: name ?? 'Image',
    "data-testid": "beau-tile-icon",
    color: samsungColors.samsungBlue.light
  }));
};

const Tile = ({
  checked = false,
  disabled = false,
  small = false,
  onClick,
  children,
  'data-testid': dataTestId = 'beau-tile'
}) => {
  return /*#__PURE__*/React.createElement(Wrapper$5, {
    small: small,
    checked: checked,
    disabled: disabled,
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(TileContext.Provider, {
    value: {
      checked,
      disabled,
      small,
      onClick,
      'data-testid': dataTestId
    }
  }, children));
};
Tile.Icon = Icon$4;
Tile.Image = Image$2;
Tile.Checkbox = Checkbox$3;
Tile.Radio = Radio$2;
//Storybooks naming fix
Tile.Icon.displayName = 'Tile.Icon';
Tile.Image.displayName = 'Tile.Image';
Tile.Checkbox.displayName = 'Tile.Checkbox';
Tile.Radio.displayName = 'Tile.Radio';

const TitleWrapper$4 = styled.div.withConfig({
  displayName: "styles__TitleWrapper",
  componentId: "ip59w8-0"
})(["text-transform:capitalize;font-size:", ";line-height:", ";font-family:", ";font-weight:", ";"], ({
  theme
}) => theme.fonts.fontSize.heading4, ({
  theme
}) => theme.fonts.lineHeight.heading4, ({
  theme
}) => theme.fonts.samsungSharpSans.fontFamily, ({
  theme
}) => theme.fonts.samsungSharpSans.fontWeight.bold.fontWeight);

const Title$8 = ({
  children,
  className = '',
  'data-testid': dataTestId = 'beau-drawer-title'
}) => {
  return /*#__PURE__*/React.createElement(TitleWrapper$4, {
    "data-testid": dataTestId,
    className: className
  }, children);
};

const ContentWrapper$3 = styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "rcctp6-0"
})(["display:flex;overflow:auto;flex-direction:column;font-size:", ";line-height:", ";font-family:", ";", ";"], ({
  theme
}) => theme.fonts.fontSize.paragraph, ({
  theme
}) => theme.fonts.lineHeight.paragraph, ({
  theme
}) => theme.fonts.samsungOne.fontFamily, scrollbar$1);

const Content$1 = ({
  children,
  'data-testid': dataTestId = 'beau-drawer-content'
}) => {
  return /*#__PURE__*/React.createElement(ContentWrapper$3, {
    "data-testid": dataTestId
  }, children);
};

const BaseButtonGroupWrapper$1 = styled.div.withConfig({
  displayName: "styles__BaseButtonGroupWrapper",
  componentId: "sc-7vsn3f-0"
})(["padding:", ";position:absolute;right:0;bottom:0;"], ({
  theme
}) => `${theme.spacing(1)} ${theme.spacing(2)}`);

const BaseButtonGroup$1 = ({
  children,
  'data-testid': dataTestId = 'beau-drawer-buttongroup'
}) => {
  return /*#__PURE__*/React.createElement(BaseButtonGroupWrapper$1, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    "data-testid": dataTestId
  }, children));
};

const OverlayContainer = styled.div.withConfig({
  displayName: "styles__OverlayContainer",
  componentId: "cuf7lx-0"
})(["background-color:", ";top:0;bottom:0;left:0;right:0;position:fixed;z-index:", ";display:block;"], colors.overlay.backgroundColor, zIndex.overlay);
const DrawerContainer = styled.div.withConfig({
  displayName: "styles__DrawerContainer",
  componentId: "cuf7lx-1"
})(["position:fixed;height:100vh;box-sizing:border-box;right:0;background-color:", ";top:0;max-width:calc(100vw - 200px);box-shadow:0 0 4px 0px rgba(0,0,0,0.15);padding:", ";transition:all 0.3s ease-out;z-index:", ";animation-name:fadeInRight;@keyframes fadeInRight{from{opacity:0;transform:translate3d(100%,0,0);}to{opacity:1;transform:translate3d(0,0,0);}}animation-duration:0.5s;animation-fill-mode:both;"], colors.neutrals.white, ({
  theme
}) => `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(8)} ${theme.spacing(2)}`, zIndex.modal);
const DrawerContentWrapper = styled.div.withConfig({
  displayName: "styles__DrawerContentWrapper",
  componentId: "cuf7lx-2"
})(["height:100%;display:flex;flex-direction:column;gap:", ";"], ({
  theme
}) => theme.spacing(3));

const DrawerComponent = ({
  children,
  show = false,
  className = '',
  onHide,
  'data-testid': dataTestId = 'beau-drawer'
}) => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    show ? document.addEventListener('keydown', handleEscape, false) : document.removeEventListener('keydown', handleEscape, false);
    return () => document.removeEventListener('keydown', handleEscape, false);
  }, [show]);
  const handleEscape = e => {
    e.key === 'Escape' && onHide();
  };
  return show ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerContainer, {
    className: `${show ? className : ''}`,
    "data-testid": dataTestId,
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(DrawerContentWrapper, {
    "data-testid": "beau-drawer-container"
  }, children)), /*#__PURE__*/React.createElement(OverlayContainer, {
    onClick: () => show && onHide()
  })), document.body) : null;
};
DrawerComponent.displayName = 'Drawer';
const Drawer = DrawerComponent;
Drawer.Title = Title$8;
Drawer.Content = Content$1;
Drawer.ButtonGroup = BaseButtonGroup$1;
Drawer.Title.displayName = 'Drawer.Title';
Drawer.Content.displayName = 'Drawer.Content';
Drawer.ButtonGroup.displayName = 'Drawer.ButtonGroup';

export { Accordion$2 as Accordion, Alert$1 as Alert, Badge$2 as Badge, BeauIcon, Board, Button, Checkbox$2 as Checkbox, Col, Drawer, Dropdown$1 as Dropdown, EChart, Ellipsis, Flex, Footer, Header, ICONS_NAMES, Icon, Indicator, Input, List$4 as List, Menu$1 as Menu, Modal, NumberInput, Pill, Popover, Radio$1 as Radio, RadioGroup, Ribbon, Row, Select, Spinner, Switch$2 as Switch, Table$3 as Table, Tabs, TextArea, TextInput, Tile, Toggle, Tooltip$2 as Tooltip, Typography$2 as Typography, index$1 as echarts, legacy$1 as legacy, theme };
